webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jstimezonedetect = __webpack_require__(615);

var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);

var _momentTimezone = __webpack_require__(3020);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _store = __webpack_require__(487);

var _store2 = _interopRequireDefault(_store);

var _en = __webpack_require__(3353);

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__(3354);

var _fr2 = _interopRequireDefault(_fr);

__webpack_require__(432);

__webpack_require__(433);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var langConfig = __webpack_require__(686);

var appContextConfig = __webpack_require__(685);

var runtimeConfig = __webpack_require__(1305);
var locale = runtimeConfig.locale;
var runmode = runtimeConfig.runmode;
var ApplicationContext = runtimeConfig.appcontext;

var PusherKeyProduction = "08a356f17511d0fafcca";
var PusherKeyDevelopment = "8fe360eb7d9bddc31f19";
var RavenKey = "https://dadee211dac945449f35f678bccddf6d@sentry.io/1225412";
var RaygunKey = "do4e8Y+t9xZRj5Wz0AODnw==";
var GoogleUACode = "UA-104677630-1";

var Timezone = _jstimezonedetect2.default.determine().name();
_axios2.default.defaults.headers.common["Timezone"] = Timezone;
_axios2.default.defaults.headers.common["applicationContext"] = ApplicationContext;

var DevelopmentMode = runmode !== 'production';

if (false) {
  locale = "en-GB";
}

var language = void 0;

switch (locale) {
  case 'fr-CA':
    _momentTimezone2.default.locale('fr');
    language = "fr";
    _store2.default.commit('setLang', 'fr_ca');
    break;
  case 'en-CA':
    _momentTimezone2.default.locale('en');
    language = 'en';
    _store2.default.commit('setLang', 'en_ca');
    break;
  case 'en-GB':
    _momentTimezone2.default.locale('en');
    language = 'en';
    _store2.default.commit('setLang', 'en_gb');
    break;
  default:
    _momentTimezone2.default.locale('en');
    language = 'en';
    _store2.default.commit('setLang', 'en_gb');
    break;
}

var Configuration = {
  ApplicationContext: ApplicationContext,
  Application: ApplicationContext === 'lowcarbprogram' ? 'Low Carb Program' : 'Gro Health',
  RavenKey: RavenKey,
  RaygunKey: RaygunKey,
  GoogleCode: GoogleUACode,
  PusherKey: DevelopmentMode ? PusherKeyDevelopment : PusherKeyProduction,
  language: language,
  locale: locale,
  timezone: Timezone,
  apiUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/api/" : "https://www.lowcarbprogram.com/api/",
  siteUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/" : "https://www.lowcarbprogram.com/",
  appUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/app/" : "https://www.lowcarbprogram.com/app/",
  hcpCmsUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/lc-hcp-cms/wp-json" : "https://www.diabetes.co.uk/lc-hcp-cms/wp-json",
  validationDictionary: {
    EnglishMessages: _en2.default,
    FrenchMessages: _fr2.default
  },
  dateFormatting: {

    fromNow: function fromNow(date) {
      var utcDate = _momentTimezone2.default.utc(date);
      return utcDate.fromNow();
    },
    graphLabels: function graphLabels(date) {
      var offset = new Date();
      var utcDate = _momentTimezone2.default.utc(date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
      return utcDate.format('Do MMM h:mm a');
    },
    foodDiaryDate: function foodDiaryDate(date) {
      var utcDate = _momentTimezone2.default.utc(date);
      return utcDate.format('dddd Do MMMM, YYYY');
    }
  },
  captchaSiteKey: DevelopmentMode ? "6LdqxDMeAAAAAPt4y63oA4ORBPdKwpMvHQKgwz8s" : "6LdqxDMeAAAAAPt4y63oA4ORBPdKwpMvHQKgwz8s",
  stripePublishableKey: DevelopmentMode ? "pk_test_51L7zDVIGpQzdYFKYjU1YtGlgwjqDXvJYNMF0acPaY5E8XNOfEeDEGfXyhvoS8qgKPZWfzzolfu9NAYFQsAFIv2L800cQq0yf0M" : "pk_live_51L7zDVIGpQzdYFKYfR1WHrzio5aQhbh3dj6N5hKuvyMLtrceSoMhKRp1xl3c4qWzYLcaolOFbo89SCxuykUG2IX200iVLiYbn0"
};

exports.default = Configuration;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      scroller: null
    };
  },
  mounted: function mounted() {
    var self = this;
    self.scroller = document.getElementsByClassName('main-content')[0];
  },

  methods: {
    scrollTop: function scrollTop() {
      var self = this;
      self.scroller.scrollTo(0, 0);
    }
  }
};

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var dayAbbreviation = moment.weekdaysShort();
var dayList = moment.weekdaysShort();
for (var i = 0; i < dayList.length; i++) {
  dayList[i] = dayList[i].replace('.', '');
}
for (var _i = 0; _i < dayAbbreviation.length; _i++) {
  dayAbbreviation[_i] = dayAbbreviation[_i].charAt(0).toUpperCase().replace('.', '');
}
var monthList = moment.months();
var monthLongList = moment.months();
var dateFormat = {
  formatDisplay: function formatDisplay(date) {
    return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
  },
  formatMonth: function formatMonth(date) {
    return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
  },
  getWeekDayArray: function getWeekDayArray(firstDayOfWeek) {
    var beforeArray = [];
    var afterArray = [];
    for (var _i2 = 0; _i2 < dayAbbreviation.length; _i2++) {
      if (_i2 < firstDayOfWeek) {
        afterArray.push(dayAbbreviation[_i2]);
      } else {
        beforeArray.push(dayAbbreviation[_i2]);
      }
    }
    return beforeArray.concat(afterArray);
  }
};

exports.default = dateFormat;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    "route": function route() {
      var self = this;
      self.onMounted();
    }
  },
  data: function data() {
    return {
      hcp_pusher: null,
      welcome_accept: false
    };
  },

  methods: {
    onMounted: function onMounted() {
      var self = this;
      self.checkStatusOfHcpUser();
      self.initPusher();
    },
    checkStatusOfHcpUser: function checkStatusOfHcpUser() {
      var self = this;

      if (self.isHcpView) {
        _Hcp2.default.getHcpUser().then(function (response) {
          if (response.data.steps.complete === false) {
            self.$router.push({
              name: 'HcpGettingStarted'
            });
          }
          if (response.data.scope.welcome_accept === false) {
            self.welcome_accept = true;
          }
        });
      }
    },
    switchProgram: function switchProgram() {
      var self = this;
      if (self.isHcpVerified === true) {
        _Hcp2.default.switchProgram().then(function (response) {
          if (!response.data.error) {
            self.$toastr.success(response.data.message);
            self.$store.state.user.user_role.role_id = response.data.program;
            self.$EventBus.$emit('App::onProgramSwitch', response.data.program);
            self.$router.push({
              name: 'Dashboard'
            });
          }
        }).catch(function (error) {
          if (error.data.response) {
            self.$toastr.error(error.data.response.message);
          }
        });
      }
    },
    initPusher: function initPusher() {
      var self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        var userId = self.$store.state.user.scope.user_id;
        self.hcp_pusher = _PusherManager2.default.subscribe('hcp_' + userId);
        self.hcp_pusher.bind('verify', function (data) {
          if (data.verified === true) {
            self.$store.state.user.isHcpVerified = true;
            self.$toastr.success('Congratulations, your identity verification has been approved!');
          } else {
            self.$router.push({
              name: 'HcpGettingStarted'
            });
            self.$toastr.error('Sorry, but your identity verification has been rejected!');
            self.$store.state.user.isHcpVerified = false;
          }
        });
      }
    }
  },
  computed: {
    isHcpView: function isHcpView() {
      var self = this;
      if (_.has(self.$store.state.user.user_role, 'role_id')) {
        return self.$store.state.user.user_role.role_id === 3;
      }
    },
    isHcpUser: function isHcpUser() {
      var self = this;
      if (_.has(self.$store.state.user, 'isHcp')) {
        return self.$store.state.user.isHcp === true;
      }
    },
    isHcpVerified: function isHcpVerified() {
      var self = this;
      if (_.has(self.$store.state.user, 'isHcp')) {
        return self.$store.state.user.isHcpVerified === true;
      }
    },
    userId: function userId() {
      var self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.user.scope.user_id;
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    _PusherManager2.default.unsubscribe('hcp_' + self.userId);
    self.onMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postCache = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity,
  ttl: 60000
});

postCache.__addFilter(/user/);

var UserApi = {
  authCheck: function authCheck() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/authCheck');
  },
  getUser: function getUser() {
    return (0, _axios2.default)({ method: 'get', url: _config2.default.apiUrl + 'user/web/' });
  },
  getUserConditions: function getUserConditions() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/conditions/');
  },
  getUserGoals: function getUserGoals() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/goals/');
  },
  getUserPersonalization: function getUserPersonalization() {
    return (0, _axios2.default)({ method: 'get', url: _config2.default.apiUrl + 'user/personalization/' });
  },
  getFavouriteFoods: function getFavouriteFoods() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/favouriteFoods/');
  },
  putFavouriteFoods: function putFavouriteFoods(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'user/favouriteFoods/', model);
  },
  getDislikedFoods: function getDislikedFoods() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/dislikedFoods/');
  },
  putDislikedFoods: function putDislikedFoods(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'user/dislikedFoods/', model);
  },
  paidStatus: function paidStatus() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/paid/status');
  },
  onBoardingStatus: function onBoardingStatus() {
    return _axios2.default.get(_config2.default.apiUrl + 'onboarding/status/');
  },
  getLoginTrackings: function getLoginTrackings() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/login-trackings');
  }
};

exports.default = UserApi;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TitleManager = {
  setTitle: function setTitle(title) {
    var encodedStr = title;
    var parser = new DOMParser();
    var dom = parser.parseFromString('<!doctype html><body>' + encodedStr, 'text/html');
    title = dom.body.textContent;
    _EventBus2.default.$emit('App::setCustomTitle', title);
  },
  replaceTitle: function replaceTitle(title) {
    var encodedStr = title;
    var parser = new DOMParser();
    var dom = parser.parseFromString('<!doctype html><body>' + encodedStr, 'text/html');
    title = dom.body.textContent;
    _EventBus2.default.$emit('App::setReplaceTitle', title);
  }
};

exports.default = TitleManager;

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountApi = {
  resetWeek1: function resetWeek1() {
    return _axios2.default.get(_config2.default.apiUrl + 'account/reset');
  },
  changePassword: function changePassword(old_password, new_password) {
    return _axios2.default.post(_config2.default.apiUrl + 'account/changePassword/', {
      new_password: new_password,
      old_password: old_password
    });
  },
  getAccount: function getAccount() {
    return _axios2.default.get(_config2.default.apiUrl + 'account/');
  },
  putAccount: function putAccount(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'account/', model);
  },
  putUserGoals: function putUserGoals(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'user/goals/', model);
  },
  getUserConditions: function getUserConditions() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/conditions/');
  },
  putUserConditions: function putUserConditions(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'user/conditions/', model);
  },
  putUserLocation: function putUserLocation(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'user/location/', model);
  },
  putUserPersonalization: function putUserPersonalization(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'user/personalization/', model);
  },
  getUserPersonalization: function getUserPersonalization() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/personalization/');
  },
  sendAccountVerification: function sendAccountVerification() {
    return _axios2.default.get(_config2.default.apiUrl + 'account/sendEmailVerification');
  },
  updateAccountEmail: function updateAccountEmail(email) {
    return _axios2.default.get(_config2.default.apiUrl + 'account/sendEmailUpdateRequest', {
      params: {
        email: email
      }
    });
  },
  verifyAccountWithEmailToken: function verifyAccountWithEmailToken(token) {
    return _axios2.default.get(_config2.default.apiUrl + 'account/verifyEmailToken', {
      params: {
        token: token
      }
    });
  },
  getMarketingPreferences: function getMarketingPreferences() {
    return _axios2.default.get(_config2.default.apiUrl + 'account/marketingPreferences');
  },
  updateMarketingPreferences: function updateMarketingPreferences(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'account/marketingPreferences', model);
  },
  updateDisplayName: function updateDisplayName(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'account/display-name/', model);
  },
  createPassword: function createPassword(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'account/store-password/', model);
  }
};

exports.default = AccountApi;

/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var foodCache = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity
});

foodCache.__addFilter(/autocomplete/);
foodCache.__addFilter(/food/);

var FoodApi = {
  CancelToken: _axios2.default.CancelToken,
  CancelRequests: null,
  copyYesterdaysMeal: function copyYesterdaysMeal(mealTypeId) {
    return _axios2.default.get(_config2.default.apiUrl + 'food/copyYesterdaysMeal/', {
      params: {
        mealTypeId: mealTypeId
      }
    });
  },
  withDate: function withDate(date) {
    var self = this;
    return _axios2.default.get(_config2.default.apiUrl + 'food/withDate/' + date, {
      cancelToken: new self.CancelToken(function executor(c) {
        self.CancelRequests = c;
      })
    });
  },
  updateRecipe: function updateRecipe(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'food/recipe/', model);
  },
  deleteRecipe: function deleteRecipe(id) {
    return _axios2.default.delete(_config2.default.apiUrl + 'food/recipe/' + id);
  },
  deleteFood: function deleteFood(food_id) {
    var self = this;
    return _axios2.default.delete(_config2.default.apiUrl + 'food/' + food_id);
  },
  autoComplete: function autoComplete(search) {
    var self = this;
    return foodCache({
      url: _config2.default.apiUrl + 'food/autocomplete/',
      method: 'get',
      params: {
        q: search
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.cancel = c;
      })
    });
  },
  getById: function getById(food_id) {
    return foodCache({
      url: _config2.default.apiUrl + 'food/' + food_id,
      method: 'get'
    });
  },
  getRecents: function getRecents(mealTypeId) {
    return _axios2.default.get(_config2.default.apiUrl + 'food/recents/' + mealTypeId);
  },
  searchFoods: function searchFoods(food, page, page_size) {
    return _axios2.default.post(_config2.default.apiUrl + 'food/search/', {
      searchValue: food,
      page_number: page,
      page_size: page_size
    });
  },
  addFoods: function addFoods(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'food/foods/', model);
  },
  updateFood: function updateFood(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'food/update/', model);
  },
  getFoodWithDate: function getFoodWithDate(date) {
    var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var params = {};
    if (user_id) {
      params.user_id = user_id;
    }
    return _axios2.default.get(_config2.default.apiUrl + 'food/withDate/' + date, {
      params: params
    });
  },
  addToFavourites: function addToFavourites(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'food/favourites/', model);
  },
  getFavorites: function getFavorites() {
    return _axios2.default.get(_config2.default.apiUrl + 'food/favourites/');
  },
  deleteFavorite: function deleteFavorite(mealId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'food/favourites/' + mealId);
  }
};

exports.default = FoodApi;

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2817)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1396),
  /* template */
  __webpack_require__(3831),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscussionApi = {
  CancelToken: _axios2.default.CancelToken,
  CancelRequests: null,
  deleteAnswer: function deleteAnswer(answer_id) {
    return _axios2.default.delete(_config2.default.apiUrl + 'discussion/thread/reply/' + answer_id);
  },
  updateAnswer: function updateAnswer(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'discussion/thread/reply/', model);
  },
  updateQuestion: function updateQuestion(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'discussion/thread/', model);
  },
  deleteQuestion: function deleteQuestion(question_id) {
    return _axios2.default.delete(_config2.default.apiUrl + 'discussion/thread/' + question_id);
  },
  hideQuestion: function hideQuestion(question_id) {
    var model = {
      question_id: question_id
    };
    return _axios2.default.post(_config2.default.apiUrl + 'discussion/thread/hide/', model);
  },
  likeDiscussionQuestion: function likeDiscussionQuestion(question_id) {
    var model = {
      question_id: question_id
    };
    return _axios2.default.post(_config2.default.apiUrl + 'discussion/thread/like/', model);
  },
  likeDiscussionReply: function likeDiscussionReply(answer_id) {
    var model = {
      answer_id: answer_id
    };
    return _axios2.default.post(_config2.default.apiUrl + 'discussion/thread/reply/like/', model);
  },
  postDiscussionReply: function postDiscussionReply(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'discussion/thread/reply/', model);
  },
  getDiscussionFrequentlyAsked: function getDiscussionFrequentlyAsked() {
    return _axios2.default.get(_config2.default.apiUrl + 'discussion/frequently-asked/');
  },
  getDiscusionRecentlyAsked: function getDiscusionRecentlyAsked(user_id) {
    return _axios2.default.get(_config2.default.apiUrl + 'discussion/recently-asked/' + user_id);
  },
  getDiscussionsTopContributors: function getDiscussionsTopContributors() {
    return _axios2.default.get(_config2.default.apiUrl + 'discussion/top-contributors/5');
  },
  getDiscussionThread: function getDiscussionThread(id, model) {
    var self = this;
    return _axios2.default.get(_config2.default.apiUrl + 'discussion/thread/' + id + '?' + this.serialize(model));
  },
  createDiscussionThread: function createDiscussionThread(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'discussion/thread/', model);
  },
  getDiscussionQuestions: function getDiscussionQuestions(model) {
    var self = this;
    return _axios2.default.get(_config2.default.apiUrl + 'discussion/items?' + this.serialize(model), {
      cancelToken: new self.CancelToken(function executor(c) {
        self.CancelRequests = c;
      })
    });
  },
  serialize: function serialize(obj) {
    var str = [];
    for (var p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }return str.join("&");
  }
};

exports.default = DiscussionApi;

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1512),
  /* template */
  __webpack_require__(3717),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var foodCache = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity
});

foodCache.__addFilter(/recipes/);

exports.default = {
  CancelToken: _axios2.default.CancelToken,
  CancelRequests: null,
  deleteReviewComment: function deleteReviewComment(id) {
    return _axios2.default.delete(_config2.default.apiUrl + 'recipes/reviews/comments/' + id);
  },
  postReviewComment: function postReviewComment(reviewId, data) {
    return _axios2.default.post(_config2.default.apiUrl + 'recipes/reviews/' + reviewId + '/comments', data);
  },
  deleteMealPlan: function deleteMealPlan(id) {
    return _axios2.default.delete(_config2.default.apiUrl + 'recipes/mealplans/' + id);
  },
  getMealPlanById: function getMealPlanById(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'recipes/mealplans/get/' + id);
  },
  getMealPlans: function getMealPlans() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;

    return _axios2.default.get(_config2.default.apiUrl + 'recipes/mealplans/me', {
      params: {
        page: page,
        limit: limit
      }
    });
  },
  addMealPlan: function addMealPlan(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'recipes/mealplan/create', model);
  },
  addToFoodDiary: function addToFoodDiary(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'recipes/addToFoodDiary', model);
  },
  notingroup: function notingroup(suitabilities, dietaryTypes) {
    return _axios2.default.get(_config2.default.apiUrl + 'recipes/notingroup?suitabilities=' + suitabilities + '&dietaryTypes=' + dietaryTypes);
  },
  notingroupQuery: function notingroupQuery(query) {
    return _axios2.default.get(_config2.default.apiUrl + 'recipes/notingroup', {
      params: query
    });
  },
  getFavorites: function getFavorites() {
    return foodCache({ url: _config2.default.apiUrl + 'recipes/favorites/', method: 'GET' });
  },
  favorite: function favorite(recipeId) {
    return _axios2.default.post(_config2.default.apiUrl + 'recipes/favorite/', {
      recipeId: recipeId
    });
  },
  deleteReview: function deleteReview(reviewId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'recipes/review/' + reviewId);
  },
  reviews: function reviews(recipeId, params) {
    return _axios2.default.get(_config2.default.apiUrl + 'recipes/' + recipeId + '/reviews/', {
      params: params
    });
  },
  review: function review(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'recipes/review/', model);
  },
  rate: function rate(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'recipes/rating/', model);
  },
  search: function search(filter) {
    var self = this;
    return _axios2.default.get(_config2.default.apiUrl + 'recipes/search/', {
      params: filter,
      cancelToken: new self.CancelToken(function executor(c) {
        self.CancelRequests = c;
      })
    });
  },
  group: function group(filter) {
    return _axios2.default.get(_config2.default.apiUrl + 'recipes/bygroup/', { params: filter });
  },
  getById: function getById(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'recipes/' + id);
  },
  updateReviewComment: function updateReviewComment(commentId, data) {
    return _axios2.default.put(_config2.default.apiUrl + 'recipes/reviews/comments/' + commentId, data);
  },
  updateReview: function updateReview(reviewId, model) {
    return _axios2.default.put(_config2.default.apiUrl + 'recipes/review/' + reviewId + '/', model);
  }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarGraph = exports.LineGraph = undefined;

var _index = __webpack_require__(1658);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1656);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.LineGraph = _index2.default;
exports.BarGraph = _index4.default;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GraphManager = __webpack_require__(482);

var _GraphManager2 = _interopRequireDefault(_GraphManager);

var _gsap = __webpack_require__(126);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

moment.locale(_config2.default.language);

exports.default = {
  watch: {
    'userId': function userId() {
      var self = this;
      self.graph.userId = self.userId;
    }
  },
  methods: {
    applyCustomDate: function applyCustomDate() {
      var self = this;
      self.$emit('graphLoading', true);
      _GraphManager2.default.applyCustomDate(self);
    },

    hideCustomDate: function hideCustomDate() {
      var self = this;
      _GraphManager2.default.hideCustomDate(self);
    },
    showCustomDate: function showCustomDate() {
      var self = this;
      _GraphManager2.default.showCustomDate(self);
    },
    setToday: function setToday() {
      var self = this;
      _GraphManager2.default.setToday(self);
    },
    setDateStep: function setDateStep(step) {
      var self = this;

      var done = null;
      if (self.$route.name !== 'ProfileProgress') {
        var mainContentElement = document.getElementsByClassName('main-content')[0];
        TweenLite.to(mainContentElement, 0.2, { scrollTo: 0 });
        var waitForAnimationToComplete = setTimeout(function () {
          done = true;
          _GraphManager2.default.setDateStep(self, step);
          clearTimeout(waitForAnimationToComplete);
        }.bind(self), 300);
      } else if (done === null && done !== true) {
        _GraphManager2.default.setDateStep(self, step);
      }
    },
    dateForward: function dateForward() {
      var self = this;
      _GraphManager2.default.dateForward(self);
    },
    dateBackward: function dateBackward() {
      var self = this;
      _GraphManager2.default.dateBackward(self);
    },
    graphLoading: function graphLoading() {
      var self = this;
      _GraphManager2.default.graphLoading(self);
    },
    graphDidLoad: function graphDidLoad() {
      var self = this;
      _GraphManager2.default.graphDidLoad(self);
    },
    graphDidFail: function graphDidFail() {
      var self = this;
      _GraphManager2.default.graphDidFail(self);
    },

    humanizeDays: function humanizeDays(days) {
      switch (days) {
        case 0:
        case 1:
          return this.$t('message.labelRangeDay');
        case 7:
          return this.$t('message.labelRangeWeek');
        case 30:
          return this.$t('message.labelRangeMonth');
        case 360:
          return this.$t('message.labelRangeYear');
      }
      moment.locale(_config2.default.language);
      return moment.duration(days, 'days').humanize();
    }

  },
  computed: {
    showPoints: function showPoints() {
      return this.$store.state.graphOptions.showDots;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('updateGraphData');
    this.$EventBus.$off('updateGraph');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Graphs = __webpack_require__(350);

var _Graphs2 = _interopRequireDefault(_Graphs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  beforeDestroy: function beforeDestroy() {
    if (_Graphs2.default.Cancel !== null) {
      _Graphs2.default.Cancel();
      _Graphs2.default.Cancel = null;
    }
  }
};

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2747)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1474),
  /* template */
  __webpack_require__(3840),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(126);

var toggleTime = 0.35;

exports.default = {
  methods: {
    onToggleEnter: function onToggleEnter(el, done) {
      TweenMax.from(el, toggleTime, {
        ease: Expo.easeOut,
        height: 0,
        immediateRender: true,
        onComplete: done
      });
    },
    onToggleLeave: function onToggleLeave(el, done) {
      TweenMax.to(el, toggleTime, {
        ease: Expo.easeOut,
        height: 0,
        immediateRender: true,
        onComplete: done
      });
    }
  },
  computed: {
    computedAuto: function computedAuto() {
      var self = this;
      if (self.model.customDate || self.isInputExpanded) {
        return 'auto';
      }
    }
  }
};

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2643)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1385),
  /* template */
  __webpack_require__(3662),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APIURL = _config2.default.apiUrl;
var HCPURL = _config2.default.hcpCmsUrl;

exports.default = {
  listHcp: function listHcp(type) {
    return _axios2.default.get(APIURL + 'list/hcp/' + type);
  },
  registerHcp: function registerHcp(step, model) {
    return _axios2.default.post(APIURL + 'hcp/register/' + step, model);
  },
  uploadVerificationFiles: function uploadVerificationFiles(formData) {
    var config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return _axios2.default.post(APIURL + 'hcp/register/verify', formData, config);
  },
  getHcpUser: function getHcpUser() {
    return _axios2.default.get(APIURL + 'hcp/user/web');
  },
  getModule: function getModule(slug) {
    return _axios2.default.get(APIURL + 'hcp/posts/' + slug);
  },
  getSimilarModules: function getSimilarModules(post_id, per_page) {
    return _axios2.default.get(APIURL + 'hcp/posts/' + post_id + '/similar?per_page=' + per_page);
  },
  getCategories: function getCategories(size) {
    return _axios2.default.get(APIURL + 'hcp/categories?size=' + size);
  },
  getModulesByCat: function getModulesByCat(slug) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'large';

    return _axios2.default.get(APIURL + 'hcp/category/' + slug + '/posts?size=' + size);
  },
  switchProgram: function switchProgram() {
    return _axios2.default.put(APIURL + 'hcp/update/program');
  },
  getModules: function getModules(params) {
    return _axios2.default.get(APIURL + 'hcp/posts?' + params);
  },
  getFeaturedCoreModules: function getFeaturedCoreModules() {
    return _axios2.default.get(APIURL + 'hcp/featured/core-posts');
  },
  getPostsYouMayLike: function getPostsYouMayLike() {
    return _axios2.default.get(APIURL + 'hcp/posts-you-may-like');
  },
  getResourceCats: function getResourceCats() {
    return _axios2.default.get(APIURL + 'hcp/resource/cats');
  },
  getResourceCatDownloads: function getResourceCatDownloads(slug) {
    return _axios2.default.get(APIURL + 'hcp/resource/cat/' + slug + '/downloads');
  },
  getFeaturedDownloads: function getFeaturedDownloads() {
    return _axios2.default.get(APIURL + 'hcp/resource/quick-downloads');
  },
  searchHcp: function searchHcp(search, type) {
    return _axios2.default.get(APIURL + 'hcp/search/' + search + '?type=' + type);
  },
  acceptHcpWelcome: function acceptHcpWelcome() {
    return _axios2.default.put(APIURL + 'hcp/accept-welcome');
  }
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postCache = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity,
  ttl: 60000
});

postCache.__addFilter(/permalink/);
postCache.__addFilter(/category/);
postCache.__addFilter(/categories/);

var LifeStyleApi = {
  getCategoryPosts: function getCategoryPosts() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
    var termId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var thumbnailSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'large';

    return _axios2.default.get(_config2.default.apiUrl + 'life/category/items/', {
      params: {
        page: page,
        per_page: perPage,
        term_id: termId,
        size: thumbnailSize
      }
    });
  },
  getPosts: function getPosts() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
    var thumbnailSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'medium-400';

    return _axios2.default.get(_config2.default.apiUrl + 'life/posts/', {
      params: {
        page: page,
        per_page: perPage,
        size: thumbnailSize
      }
    });
  },
  getCategorys: function getCategorys() {
    return _axios2.default.get(_config2.default.apiUrl + 'life/categories/');
  },
  getCategory: function getCategory(slugId) {
    return postCache({
      url: _config2.default.apiUrl + 'life/category/' + slugId,
      method: 'GET'
    });
  },
  getPost: function getPost(permalink) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'large';

    return postCache({
      url: _config2.default.apiUrl + 'life/post/permalink/' + permalink,
      method: 'GET',
      params: {
        size: size
      }
    });
  },
  getPostComments: function getPostComments(params) {
    return _axios2.default.get(_config2.default.apiUrl + 'life/post/comments/' + params.post_id, {
      params: {
        page: params.page,
        page_size: params.page_size,
        type: params.type
      }
    });
  },
  likePostComment: function likePostComment(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'life/post/comment/like/', model);
  },
  getRecommendationsByPost: function getRecommendationsByPost(post_id, user_id, limit) {
    return _axios2.default.get(_config2.default.apiUrl + 'life/post/' + post_id + '/recommendations', {
      params: {
        user_id: user_id,
        limit: limit
      }
    });
  },
  addComment: function addComment(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'life/post/comment/', model);
  },
  updateComment: function updateComment(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'life/post/comment/', model);
  },
  deleteComment: function deleteComment(model) {
    return (0, _axios2.default)({
      method: 'delete',
      url: _config2.default.apiUrl + 'life/post/comment/',
      data: model,
      headers: { "Content-Type": "application/json" }
    });
  },
  favouritePost: function favouritePost(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'life/post/favourite/', model);
  },
  getSearchPosts: function getSearchPosts(search, model) {
    return _axios2.default.get(_config2.default.apiUrl + 'life/search/posts/', {
      params: {
        search: search,
        page: model.page,
        per_page: model.per_page,
        size: model.size
      }
    });
  },
  getUserRecommendedPosts: function getUserRecommendedPosts() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'large';

    return _axios2.default.get(_config2.default.apiUrl + 'life/user/recommendations', {
      params: {
        size: size
      }
    });
  },
  getSimilarPosts: function getSimilarPosts(post_id) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'large';

    return _axios2.default.get(_config2.default.apiUrl + 'life/similarposts/' + post_id, {
      params: {
        size: size
      }
    });
  },
  getMyFavouritePosts: function getMyFavouritePosts(user_id, model) {
    return _axios2.default.get(_config2.default.apiUrl + 'life/user/favourites/' + user_id, {
      params: {
        page: model.page,
        per_page: model.per_page
      }
    });
  }
};

exports.default = LifeStyleApi;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsApi = {
  getSettings: function getSettings() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/');
  },
  putUnitSettings: function putUnitSettings(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/units/', model);
  },
  putNutritionSettings: function putNutritionSettings(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/nutrition/', model);
  },
  getNutritionSettings: function getNutritionSettings() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/nutrition/');
  },
  putSettings: function putSettings(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/', model);
  },
  putPrivacySettings: function putPrivacySettings(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/privacy/', model);
  },
  getNotificationSettings: function getNotificationSettings() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/notifications/');
  },
  putNotificationSettings: function putNotificationSettings(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/notifications/', model);
  },
  getUnitSettings: function getUnitSettings() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/units/');
  },
  getBloodSugarSettings: function getBloodSugarSettings() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/blood_sugar/');
  },
  getPrivacySettings: function getPrivacySettings() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/privacy/');
  },
  updateUserSettings: function updateUserSettings(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/', model);
  },
  getCardOrder: function getCardOrder() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/cardOrder');
  },
  updateCardOrder: function updateCardOrder(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/cardOrder', model);
  },
  getHeightSettings: function getHeightSettings() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/height/');
  },
  updateHeightSettings: function updateHeightSettings(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/height/', model);
  },
  getFoodDiaryNutritionUnit: function getFoodDiaryNutritionUnit() {
    return _axios2.default.get(_config2.default.apiUrl + 'settings/food-diary/nutrition-unit');
  },
  setFoodDiaryNutritionUnit: function setFoodDiaryNutritionUnit(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'settings/food-diary/nutrition-unit', model);
  }
};

exports.default = SettingsApi;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(278);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(277);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = __webpack_require__(950);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _Token = __webpack_require__(1649);

var _Token2 = _interopRequireDefault(_Token);

var _jstimezonedetect = __webpack_require__(615);

var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthenticationManager = {
  clearSession: function clearSession() {
    _jsCookie2.default.remove('lcp_jwt', { path: '/' });
    window.localStorage.removeItem('token');
    if (_.has(_axios2.default.defaults.headers.common, 'Authorization')) {
      _axios2.default.defaults.headers.common["Timezone"] = _jstimezonedetect2.default.determine().name();
      delete _axios2.default.defaults.headers.common['Authorization'];
    }
  },
  hasToken: function hasToken() {
    var token = window.localStorage.getItem('token');
    return token !== (null && undefined && "undefined");
  },
  getToken: function getToken() {
    return JSON.parse(window.localStorage.getItem('token'));
  },
  setToken: function setToken(tokenObject) {
    _axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + tokenObject.accessToken;
    _axios2.default.defaults.headers.common["Timezone"] = _jstimezonedetect2.default.determine().name();
    window.localStorage.setItem('token', (0, _stringify2.default)(tokenObject));
  },
  setAccessTokenExpiryTime: function setAccessTokenExpiryTime(tokenObject) {
    tokenObject.expires = new Date(new Date().getTime() + 0.8 * tokenObject.expiresIn * 1000);
    return tokenObject;
  },
  refreshAccessToken: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(tokenObject) {
      var response, tokenData;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_.has(tokenObject, 'refreshToken')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return _Token2.default.refreshAccessToken(tokenObject.refreshToken);

            case 4:
              response = _context.sent;
              tokenData = this.setAccessTokenExpiryTime(response.data);

              this.setToken(tokenData);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function refreshAccessToken(_x) {
      return _ref.apply(this, arguments);
    }

    return refreshAccessToken;
  }(),
  parseJwt: function parseJwt() {

    if (!_.has(this.getToken(), 'accessToken')) {
      return;
    }

    var token = this.getToken().accessToken;
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }
};

exports.default = AuthenticationManager;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _, jQuery) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ScrollManager = {
  getScrollbarWidth: function getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar";
    document.body.appendChild(outer);
    var widthNoScroll = outer.offsetWidth;
    outer.style.overflow = "scroll";
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    var widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
  },

  isElementWithinContentView: function isElementWithinContentView(scrollingel, elem) {
    var container = $(scrollingel);
    var contHeight = container.height();
    var contTop = container.scrollTop();
    var contBottom = contTop + contHeight;
    if (_.has($(elem).offset(), 'top')) {
      var elememTop = $(elem).offset().top - container.offset().top;
      var elememBottom = elememTop + $(elem).height();
      return elememTop >= 0 && elememBottom <= contHeight;
    }
  },

  isElementInContentView: function isElementInContentView(elem) {
    var container = $(".main-content");
    var contHeight = container.height();
    var contTop = container.scrollTop();
    var contBottom = contTop + contHeight;
    if (_.has($(elem).offset(), 'top')) {
      var elememTop = $(elem).offset().top - container.offset().top;
      var elememBottom = elememTop + $(elem).height();
      return elememTop >= 0 && elememBottom <= contHeight;
    }
  },

  isElementInViewport: function isElementInViewport(elem) {
    if (typeof jQuery === "function" && elem instanceof jQuery) {
      elem = elem[0];
    }
    if (!elem) {
      return;
    }
    var rect = elem.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  },
  onVisibilityChange: function onVisibilityChange(elem, callback) {
    var old_visible;
    return function () {
      var visible = this.isElementInViewport(elem);
      if (visible !== old_visible) {
        old_visible = visible;
        if (typeof callback === 'function') {
          callback();
        }
      }
    };
  }
};

exports.default = ScrollManager;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9), __webpack_require__(11)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    var self = this;
    var element = document.getElementsByClassName('main-content')[0];
    element.addEventListener('scroll', self.handleScroll);
  },
  data: function data() {
    return {
      activeReading: {},
      loading: true,
      isReadingsLoading: true,
      disableRipple: true,
      rightTop: { horizontal: 'right', vertical: 'top' },
      data: {
        data: []
      }
    };
  },

  methods: {
    sortItems: function sortItems() {
      var self = this;
      self.data.data.sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created);
      });
    },
    sortWaistHipItems: function sortWaistHipItems() {
      var self = this;
      self.data.sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created);
      });
    },
    showItemControlsWaistHip: function showItemControlsWaistHip(item) {
      var self = this;
      if (item.isControlsVisible !== true) {
        self.hideShowControlsWaistHip(item);
      }
    },
    showItemControls: function showItemControls(item) {
      var self = this;
      if (_.has(item.userDevice, 'userDeviceId')) {
        if (item.userDevice.userDeviceId !== 0) {} else {
          self.hideShowControls(item);
        }
      } else {
        if (item.isControlsVisible !== true) {
          self.hideShowControls(item);
        }
      }
    },
    hideShowControlsWaistHip: function hideShowControlsWaistHip(item) {
      var self = this;

      self.data.map(function (reading) {
        reading.isControlsVisible = false;
      });
      item.isControlsVisible = true;
      self.$forceUpdate();
    },
    hideItemControlsWaistHip: function hideItemControlsWaistHip(item) {
      var self = this;
      if (!item.isEditMode) {
        item.isControlsVisible = false;
        self.$forceUpdate();
      }
    },
    hideShowControls: function hideShowControls(item) {
      var self = this;

      self.data.data.map(function (reading) {
        reading.isControlsVisible = false;
      });
      item.isControlsVisible = true;
      self.$forceUpdate();
    },
    hideItemControls: function hideItemControls(item) {
      var self = this;
      if (!item.isEditMode) {
        self.data.data.map(function (reading) {
          reading.isControlsVisible = false;
        });
        self.$forceUpdate();
      }
    },
    groupedDateFormat: function groupedDateFormat(date) {
      var self = this;
      return moment(date).locale(_config2.default.language).format('MMMM YYYY');
    },
    groupedItemDate: function groupedItemDate(date) {
      var offset = new Date();
      var dateMod = moment.utc(date).locale(_config2.default.language);
      return dateMod.format('hh:mm a') + ' on ' + dateMod.format('dddd Do');
    },
    groupFilter: function groupFilter(tab) {
      var self = this;
      if (tab === 'waist-hip') {
        return _.groupBy(self.data, function (reading) {
          return moment(reading.date_created).startOf('month').format();
        });
      } else {
        return _.groupBy(self.data.data, function (reading) {
          return moment(reading.date_created).startOf('month').format();
        });
      }
    },
    closeEditMode: function closeEditMode(data) {
      var self = this;
      var currentReading = self.data.data.filter(function (reading) {
        if (_.has(reading, 'dosage_id')) {
          return reading.dosage_id === data.dosage_id;
        }
        return reading.progress_id === data.progress_id;
      })[0];
      currentReading.isEditMode = false;
      currentReading.isControlsVisible = false;
      self.$forceUpdate();
    },
    closeEditModeWaistHip: function closeEditModeWaistHip(data) {
      var self = this;
      var currentReading = self.data.filter(function (reading) {
        return reading.progress_id === data.progress_id;
      })[0];
      currentReading.isEditMode = false;
      currentReading.isControlsVisible = false;
      self.$forceUpdate();
    },
    editReadingWaistHip: function editReadingWaistHip(reading) {
      var self = this;
      reading.isEditMode = true;
      self.$forceUpdate();
    },
    editReading: function editReading(reading) {
      var self = this;
      self.data.data.map(function (reading) {
        return reading.isEditMode = false;
      });
      reading.isEditMode = true;
      self.$forceUpdate();
    },

    handleScroll: function handleScroll() {
      var self = this;
      if (!self.isReadingsLoading) {
        if (_ScrollManager2.default.isElementInViewport(self.$refs['detector'])) {
          self.loadMoreData();
        }
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LessonsApi = {
  getLessonsList: function getLessonsList() {
    return _axios2.default.get(_config2.default.apiUrl + 'lessons/list/');
  },
  getLessonByPermalink: function getLessonByPermalink(permalink) {
    return _axios2.default.get(_config2.default.apiUrl + 'lessons/' + permalink);
  },
  getBonusModule: function getBonusModule(bonusId) {
    return _axios2.default.get(_config2.default.apiUrl + 'lessons/bonus/' + bonusId);
  },
  getPersonalizedContentForLesson: function getPersonalizedContentForLesson(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'lessons/personalize/' + id);
  },
  getDownloadsByCourseId: function getDownloadsByCourseId(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'lesson/downloads/' + id);
  },
  saveDownloadCount: function saveDownloadCount(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'lesson/downloads/count/', model);
  },
  saveQuizResult: function saveQuizResult(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'lesson/quiz/results/', model);
  },
  saveLessonEndRating: function saveLessonEndRating(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'lesson/rating/end/', model);
  },
  saveLessonStartRating: function saveLessonStartRating(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'lesson/rating/start/', model);
  }
};

exports.default = LessonsApi;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileApi = {
  getProfile: function getProfile(profileUrl) {
    return _axios2.default.get(_config2.default.apiUrl + 'profile/' + profileUrl);
  },
  changeProfilePicture: function changeProfilePicture(image) {
    return _axios2.default.post(_config2.default.apiUrl + 'upload/profile-picture/', {
      image: image
    });
  },
  deleteImage: function deleteImage(imageId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'profile/image/' + imageId);
  },
  follow: function follow(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'followers/follow/', model);
  },
  getFollowers: function getFollowers(params) {
    return _axios2.default.get(_config2.default.apiUrl + 'followers/' + params.user_id, {
      params: {
        type: params.type,
        page: params.page,
        page_size: params.page_size
      }
    });
  },
  saveBio: function saveBio(bio) {
    return _axios2.default.put(_config2.default.apiUrl + 'profile/bio', {
      bio: bio
    });
  },
  galleryUploadURL: function galleryUploadURL() {
    return _config2.default.apiUrl + 'profile/image/upload/';
  },
  deleteProfilePicture: function deleteProfilePicture() {
    return _axios2.default.delete(_config2.default.apiUrl + 'upload/profile-picture/remove/');
  },
  deleteCoverPhoto: function deleteCoverPhoto() {
    return _axios2.default.delete(_config2.default.apiUrl + 'upload/user/cover/remove/');
  }
};

exports.default = ProfileApi;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MedicationsApi = {
  copyDosages: function copyDosages(date) {
    return _axios2.default.get(_index2.default.apiUrl + 'tracking/medication/copy/' + date);
  },
  checkForDosages: function checkForDosages(date) {
    return _axios2.default.get(_index2.default.apiUrl + 'tracking/medication/check/' + date + '?requestFrom=web');
  },
  getMedicationsTrackingDetail: function getMedicationsTrackingDetail(page, page_size) {
    return _axios2.default.get(_index2.default.apiUrl + 'tracking/medication/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  deleteMedicationDosage: function deleteMedicationDosage(dosage_id) {
    return _axios2.default.delete(_index2.default.apiUrl + 'tracking/medication/dosage/' + dosage_id);
  },
  updateMedicationDosage: function updateMedicationDosage(model) {
    return _axios2.default.put(_index2.default.apiUrl + 'tracking/medication/dosage/', model);
  },
  deleteMedication: function deleteMedication(tracking_id) {
    return _axios2.default.delete(_index2.default.apiUrl + 'tracking/medication/', {
      data: {
        tracking_id: tracking_id
      }
    });
  },
  updateMedication: function updateMedication(model) {
    return _axios2.default.put(_index2.default.apiUrl + 'tracking/medication/', model);
  },
  getMedicationsTrackingCard: function getMedicationsTrackingCard() {
    return _axios2.default.get(_index2.default.apiUrl + 'tracking/medication/card/?requestFrom=web');
  },
  postUserMedications: function postUserMedications(model) {
    return _axios2.default.post(_index2.default.apiUrl + 'tracking/medications/', model);
  },
  postUserMedication: function postUserMedication(model) {
    return _axios2.default.post(_index2.default.apiUrl + 'tracking/medication/', model);
  },
  postMedicationsTracking: function postMedicationsTracking(model) {
    return _axios2.default.post(_index2.default.apiUrl + 'tracking/medication/dosage/', model);
  },
  getUserMedications: function getUserMedications() {
    return _axios2.default.get(_index2.default.apiUrl + 'tracking/medications/');
  },
  conditionsGet: function conditionsGet(filter, limit) {
    return _axios2.default.get(_index2.default.apiUrl + 'list/conditions/' + filter);
  },
  regimeUnitsGet: function regimeUnitsGet() {
    return _axios2.default.get(_index2.default.apiUrl + 'list/medications/units/');
  },
  regimeFrequencysGet: function regimeFrequencysGet() {
    return _axios2.default.get(_index2.default.apiUrl + 'list/medications/frequencys/');
  },
  getTreatments: function getTreatments(filter) {
    return _axios2.default.get(_index2.default.apiUrl + 'list/medications/' + filter);
  }
};

exports.default = MedicationsApi;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Provider = __webpack_require__(711);

var _Provider2 = _interopRequireDefault(_Provider);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserManager = {
  store: function store(context, user) {
    var self = context;
    self.$store.commit('setUser', user);
    self.$nextTick(function () {
      self.$forceUpdate();
      self.$EventBus.$emit('App:localUserUpdate', user);
    });
  },
  getUserAndStore: function getUserAndStore(context) {
    var self = context;
    var getData = _User2.default.getUser();
    getData.then(function (response) {
      _User2.default.onBoardingStatus().then(function (response) {
        self.$store.commit('setOnBoardingStatus', response.data);
      });

      _Provider2.default.getProvider().then(function (response) {
        self.$store.commit('setProvider', response.data);
      });

      self.$store.commit('setUser', response.data);
      self.user = self.$store.state.user;
      if (_lodash2.default.includes(_AuthenticationManager2.default.parseJwt().scope, 'standard_tasks')) {
        self.$store.commit('setPaymentStatus', true);
      }

      self.loading = false;
      self.$forceUpdate();
      self.$EventBus.$emit('App:localUserUpdate', self.user);
    }).catch(function (error) {});
  },
  get: function get(context) {
    var self = context;
    if (_lodash2.default.has(self, 'settingsUpdating')) {
      if (self.settingsUpdating === true) {
        var getData = _User2.default.getUser();
        getData.then(function (response) {
          self.$store.commit('setUser', response.data);
          self.user = self.$store.state.user;
          self.settingsUpdating = false;
          this.getUserAndStore(self);
          self.$forceUpdate();
        });
      }
    }
    if (self.$store.state.user.scope !== undefined) {
      self.user = self.$store.state.user;
    } else {
      this.getUserAndStore(context);
    }
  }
};
exports.default = UserManager;

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2658)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1375),
  /* template */
  __webpack_require__(3686),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1473),
  /* template */
  __webpack_require__(3644),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(146);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _vue2.default();

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isUpdating: false,
      dateFormat: _DatePickerManager2.default,
      maxDate: moment().format('DD-MM-YYYY'),
      timeModel: {
        date: "",
        time: ""
      }
    };
  },
  watch: {
    'timeModel.time': function timeModelTime() {
      var self = this;
      var offset = new Date();
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.reading.date = moment(dateTime).format();
    },
    'timeModel.date': function timeModelDate() {
      var self = this;
      var offset = new Date();
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.reading.date = moment(dateTime).format();
    }
  },
  mounted: function mounted() {
    var self = this;

    self.reading = JSON.parse((0, _stringify2.default)(self.item));

    var date = moment.utc(self.reading.date_created);
    self.timeModel.time = date.format('hh:mm a');
    self.timeModel.date = date.format('DD-MM-YYYY');

    self.$forceUpdate();
  },
  methods: {
    closeEditMode: function closeEditMode() {
      var self = this;
      self.$emit('closeEditPanel');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2757)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1351),
  /* template */
  __webpack_require__(3865),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntegrationApi = {
  getSubscriptions: function getSubscriptions() {
    return _axios2.default.get(_config2.default.apiUrl + 'integration/subscriptions/');
  },
  disconnectIntegration: function disconnectIntegration(key) {
    return _axios2.default.delete(_config2.default.apiUrl + 'integration/' + key);
  },


  available: {
    activity: function activity() {
      return _axios2.default.get(_config2.default.apiUrl + 'integration/available/activity');
    },
    sleep: function sleep() {
      return _axios2.default.get(_config2.default.apiUrl + 'integration/available/sleep');
    }
  },
  FITBIT: {
    getActivityLog: function getActivityLog(date) {
      return _axios2.default.get(_config2.default.apiUrl + 'integration/fitbit/activities/log/' + date);
    },
    getNext: function getNext(link) {
      return _axios2.default.post(_config2.default.apiUrl + 'integration/fitbit/next/', {
        link: link
      });
    },
    getHeartRate: function getHeartRate() {
      return _axios2.default.get(_config2.default.apiUrl + 'integration/fitbit/heart/');
    },
    getDevices: function getDevices() {
      return _axios2.default.get(_config2.default.apiUrl + 'integration/fitbit/devices/');
    },
    generateHandshake: function generateHandshake() {
      return _axios2.default.get(_config2.default.apiUrl + 'integration/fitbit/handshake');
    }
  }
};

exports.default = IntegrationApi;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postCache = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity
});

var ListsApi = {
  getGettingStartedList: function getGettingStartedList() {
    return postCache({
      method: 'get',
      url: _config2.default.apiUrl + 'list/getting_started/'
    });
  },
  getPreferenceTypes: function getPreferenceTypes() {
    return _axios2.default.get(_config2.default.apiUrl + 'list/preference_types/');
  },
  getMoodsList: function getMoodsList() {
    return _axios2.default.get(_config2.default.apiUrl + 'list/moods/chunked/');
  },
  getTagList: function getTagList() {
    return _axios2.default.get(_config2.default.apiUrl + 'list/tags/');
  },
  getInsulinTypesList: function getInsulinTypesList() {
    return _axios2.default.get(_config2.default.apiUrl + 'list/insulin_types/');
  },
  getNutritionUnitList: function getNutritionUnitList() {
    return _axios2.default.get(_config2.default.apiUrl + 'list/nutrition-units/');
  },
  getExternalLoginList: function getExternalLoginList() {
    return _axios2.default.get(_config2.default.apiUrl + 'list/social-providers');
  }
};

exports.default = ListsApi;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var HTMLStringParser = {
  toUpper: function toUpper(string) {
    return string.toLowerCase();
  },
  toLower: function toLower(string) {
    return string.toLowerCase();
  },
  encode: function encode(title) {
    var encodedStr = title;
    var parser = new DOMParser();
    var dom = parser.parseFromString('<!doctype html><body>' + encodedStr, 'text/html');
    title = dom.body.textContent;
    return title;
  }
};
exports.default = HTMLStringParser;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _pusherJs = __webpack_require__(1125);

var _pusherJs2 = _interopRequireDefault(_pusherJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pusher = new _pusherJs2.default(_config2.default.PusherKey, {
  cluster: "mt1",
  encrypted: true
});

_pusherJs2.default.logToConsole = "production" === 'development';
exports.default = pusher;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
exports.default = {
  methods: {
    getProfile: function getProfile() {
      var self = this,
          profileObj = self.$store.state.activeProfileObject;
      if (_.has(profileObj, 'information')) {
        return profileObj;
      }
    }
  },
  computed: {
    getUserInitials: function getUserInitials() {
      var self = this,
          data = self.getProfile(),
          basic = data.information.basic,
          firstname = basic.firstname.charAt(0),
          surname = basic.surname.charAt(0);
      return firstname + surname;
    },
    isAdmin: function isAdmin() {
      var self = this;
      if (_.has(self.$store.state.user, 'user_role')) {
        return self.$store.state.user.user_role.role_id === 2;
      }
    },
    showPrivacyProgress: function showPrivacyProgress() {
      var self = this;
      var data = self.getProfile();
      return self.isOwner || !self.isOwner && data.privacy.progress;
    },
    showPrivacyQuestions: function showPrivacyQuestions() {
      var self = this,
          data = self.getProfile();
      return self.isOwner || !self.isOwner && data.privacy.questions;
    },
    showPrivacyInfo: function showPrivacyInfo() {
      var self = this,
          data = self.getProfile();
      return self.isOwner === true || !self.isOwner && data.privacy.information;
    },
    showPrivacyFood: function showPrivacyFood() {
      var self = this,
          data = self.getProfile();
      return self.isOwner === true || !self.isOwner && data.privacy.food;
    },
    isOwner: function isOwner() {
      var self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.activeProfile === self.$store.state.user.scope.user_id;
      }
    },
    isGalleryEmpty: function isGalleryEmpty() {
      var self = this;
      return self.getProfile().gallery.length === 0;
    },
    isBirthday: function isBirthday() {
      var self = this;
      var date = (0, _moment2.default)().format('YYYY-M-D');
      return self.profile.dob === date;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2818)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1383),
  /* template */
  __webpack_require__(3833),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2653)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1506),
  /* template */
  __webpack_require__(3678),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2704)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1515),
  /* template */
  __webpack_require__(3766),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postCache = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity,
  ttl: 60000
});

postCache.__addFilter(/details/);

var APIURL = _config2.default.apiUrl;

var paymentApi = {
  validateVoucher: function validateVoucher(model) {
    return _axios2.default.post(APIURL + 'providers/redeem', model);
  },
  getPaymentsPaginate: function getPaymentsPaginate(params) {
    return _axios2.default.get(APIURL + 'payments/', {
      params: {
        page: params.page,
        per_page: params.per_page,
        status: params.status,
        find: params.find.key,
        v: params.find.value
      }
    });
  },
  getRefundedPayments: function getRefundedPayments(params) {
    return _axios2.default.get(APIURL + 'payments/refunded', {
      params: {
        page: params.page,
        per_page: params.per_page
      }
    });
  },
  updatePaymentStatus: function updatePaymentStatus(model) {
    return _axios2.default.put(APIURL + 'payment/status', model);
  },
  refundPayment: function refundPayment(model) {
    return _axios2.default.post(APIURL + 'payment/refund/', model);
  },
  addPayment: function addPayment(model) {
    return _axios2.default.post(APIURL + 'payment/', model);
  },
  deletePayment: function deletePayment(id) {
    return _axios2.default.delete(APIURL + 'payment/' + id);
  },
  getPaypalTransaction: function getPaypalTransaction(txn_id) {
    return _axios2.default.get(APIURL + 'paypal/transaction/' + txn_id);
  },
  getPayPalDetails: function getPayPalDetails() {
    return _axios2.default.get(APIURL + 'paypal/details');
  },
  getPayPalSubscriptionDetails: function getPayPalSubscriptionDetails() {
    return _axios2.default.get(APIURL + 'paypal/subscription/details');
  },
  getUuid: function getUuid() {
    return _axios2.default.get(APIURL + '/paypal/subscription/generate');
  },
  getStripePrices: function getStripePrices() {
    return _axios2.default.get(APIURL + 'stripe/get-prices/');
  },
  initalizePayment: function initalizePayment(data) {
    return _axios2.default.post(APIURL + 'stripe/initialize-payment/', data);
  },
  validatePayment: function validatePayment(data) {
    return _axios2.default.post(APIURL + 'stripe/validate-payment/', data);
  },
  getUpcomingInvoice: function getUpcomingInvoice() {
    return _axios2.default.get(APIURL + 'stripe/upcoming-invoice/');
  },
  cancelCurrentSubscription: function cancelCurrentSubscription() {
    return _axios2.default.post(APIURL + 'stripe/terminate-subscription/');
  },
  resumeCurrentSubscription: function resumeCurrentSubscription() {
    return _axios2.default.post(APIURL + 'stripe/resume-subscription/');
  }
};

exports.default = paymentApi;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportingApi = {
  postReport: function postReport(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'report', model);
  },
  getReasons: function getReasons() {
    return _axios2.default.get(_config2.default.apiUrl + 'list/reporting-reasons');
  },
  removeReports: function removeReports(type, type_id) {
    return _axios2.default.delete(_config2.default.apiUrl + 'reports', {
      params: {
        type: type,
        type_id: type_id
      }
    });
  },
  getLifeReports: function getLifeReports(comment_id, type) {
    return _axios2.default.get(_config2.default.apiUrl + ('report/life/' + comment_id), {
      params: {
        type: type
      }
    });
  },
  getQuestionReport: function getQuestionReport(questionId) {
    return _axios2.default.get(_config2.default.apiUrl + 'report/question/' + questionId);
  },
  getAnswerReport: function getAnswerReport(answerId) {
    return _axios2.default.get(_config2.default.apiUrl + 'report/answer/' + answerId);
  },
  getReport: function getReport(type, type_id) {
    return _axios2.default.get(_config2.default.apiUrl + 'report/', {
      params: {
        type: type,
        type_id: type_id
      }
    });
  },
  getReports: function getReports(params) {
    return _axios2.default.get(_config2.default.apiUrl + 'reports', {
      params: {
        page: params.page,
        per_page: params.per_page
      }
    });
  }
};

exports.default = ReportingApi;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SleepApi = {
  getFitBitSleepLog: function getFitBitSleepLog(beforeDate) {
    return _axios2.default.get(_config2.default.apiUrl + 'integration/fitbit/sleep/log/' + beforeDate);
  },
  getFitBitData: function getFitBitData(date) {
    return _axios2.default.get(_config2.default.apiUrl + 'integration/fitbit/sleep/' + date);
  },
  getStriivData: function getStriivData(date) {
    return _axios2.default.get(_config2.default.apiUrl + 'integration/striiv/sleep/' + date);
  },
  getSleepTrackingDetail: function getSleepTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/sleep/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getSleepTrackingWearableDetail: function getSleepTrackingWearableDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/sleep/wearable/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getSleepTrackingCard: function getSleepTrackingCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/sleep/card/?requestFrom=web');
  },
  postSleepTracking: function postSleepTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/sleep/', model);
  },
  putSleepTracking: function putSleepTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/sleep/', model);
  },
  deleteSleepTracking: function deleteSleepTracking(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/sleep/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  }
};

exports.default = SleepApi;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizeRegimeUnits: [{
        key: 'milligram(s)',
        value: 'message.medicationRegimeMilligrams'
      }, {
        key: 'gram(s)',
        value: 'message.medicationRegimeGrams'
      }, {
        key: 'drop(s)',
        value: 'message.medicationRegimeDrops'
      }, {
        key: 'tablespoon(s)',
        value: 'message.medicationRegimeTablespoons'
      }, {
        key: 'microgram(s)',
        value: 'message.medicationRegimeMicrograms'
      }, {
        key: 'tablet(s)',
        value: 'message.medicationRegimeTablets'
      }, {
        key: 'capsule(s)',
        value: 'message.medicationRegimeCapsules'
      }, {
        key: 'milliliter(s)',
        value: 'message.medicationRegimeMilliliters'
      }, {
        key: 'teaspoon(s)',
        value: 'message.medicationRegimeTeaspoons'
      }, {
        key: 'minute(s)',
        value: 'message.medicationRegimeMinutes'
      }, {
        key: 'hour(s)',
        value: 'message.medicationRegimeHours'
      }, {
        key: 'units(s)',
        value: 'message.medicationRegimeUnits'
      }]
    };
  },

  methods: {
    localizeRegime: function localizeRegime(key) {
      var self = this;
      var label = self.localizeRegimeUnits.filter(function (item) {
        return String(item.key) === String(key);
      });

      if (label.length === 1) {
        return self.$t(label[0].value);
      }
    }
  }
};

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2719)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1352),
  /* template */
  __webpack_require__(3791),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2696)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1378),
  /* template */
  __webpack_require__(3749),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2755)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1457),
  /* template */
  __webpack_require__(3862),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      months: [{
        key: "January",
        value: "message.monthJanuary"
      }, {
        key: "February",
        value: "message.monthFebruary"
      }, {
        key: "March",
        value: "message.monthMarch"
      }, {
        key: "April",
        value: "message.monthApril"
      }, {
        key: "May",
        value: "message.monthMay"
      }, {
        key: "June",
        value: "message.monthJune"
      }, {
        key: "July",
        value: "message.monthJuly"
      }, {
        key: "August",
        value: "message.monthAugust"
      }, {
        key: "September",
        value: "message.monthSeptember"
      }, {
        key: "October",
        value: "message.monthOctober"
      }, {
        key: "November",
        value: "message.monthNovember"
      }, {
        key: "December",
        value: "message.monthDecember"
      }]
    };
  },

  methods: {
    localizeMonth: function localizeMonth(key) {
      var self = this;
      var localization = self.months.filter(function (item) {
        return item.key === key;
      });
      if (localization.length === 1) {
        return self.$t(localization[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICAgIDxkZWZzPgogICAgICAgIDxzdHlsZT4KICAgICAgICAgICAgLmNscy0xe2ZpbGw6bm9uZX0uY2xzLTJ7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoKX0uY2xzLTN7ZmlsbDojODljOTNifS5jbHMtNHtmaWxsOiNmZmZ9CiAgICAgICAgPC9zdHlsZT4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDBoMjJ2MjJIMHoiIGNsYXNzPSJjbHMtMSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iaWNfc21hbGxfY2lyY2xlX3RpY2siIGNsYXNzPSJjbHMtMiI+CiAgICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV81NiIgY3g9IjExIiBjeT0iMTEiIHI9IjExIiBjbGFzcz0iY2xzLTMiIGRhdGEtbmFtZT0iRWxsaXBzZSA1NiIvPgogICAgICAgIDxnIGlkPSJHcm91cF80Njk1IiBkYXRhLW5hbWU9Ikdyb3VwIDQ2OTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01OCAtMzUzKSI+CiAgICAgICAgICAgIDxwYXRoIGlkPSJSZWN0YW5nbGVfMTU3MSIgZD0iTTAgMGgyMHYyMEgweiIgY2xhc3M9ImNscy0xIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNTcxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1OSAzNTQpIi8+CiAgICAgICAgICAgIDxwYXRoIGlkPSJwYXRoIiBkPSJNMjY2Ljc2NyA4ODMuNDMzbDguODMzLTguODMzIDEuMTY3IDEuMTY3LTEwIDEwLTQuNjY3LTQuNjY3IDEuMTY3LTEuMTY3eiIgY2xhc3M9ImNscy00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAwLjYgLTUxNS42KSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJwcmVmaXhfX2ljX3NtYWxsX2NpcmNsZV90aWNrX2luYWN0aXZlIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiI+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9InByZWZpeF9fY2xpcC1wYXRoIj4KICAgICAgICAgICAgPGNpcmNsZSBpZD0icHJlZml4X19FbGxpcHNlXzU2IiBjeD0iMTEiIGN5PSIxMSIgcj0iMTEiIGRhdGEtbmFtZT0iRWxsaXBzZSA1NiIgc3R5bGU9Im9wYWNpdHk6LjI4MztmaWxsOiNkODNlMzgiLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgogICAgPGcgaWQ9InByZWZpeF9fTWFza19Hcm91cF8yMSIgZGF0YS1uYW1lPSJNYXNrIEdyb3VwIDIxIj4KICAgICAgICA8cGF0aCBpZD0icHJlZml4X19jbG9zZS1jaXJjbGUiIGQ9Ik0xMy4yIDIuMmExMSAxMSAwIDEgMS0xMSAxMSAxMC45OSAxMC45OSAwIDAgMSAxMS0xMXptMy45NDkgNS41TDEzLjIgMTEuNjQ5IDkuMjUxIDcuNyA3LjcgOS4yNTFsMy45NDkgMy45NDlMNy43IDE3LjE0OSA5LjI1MSAxOC43bDMuOTQ5LTMuOTQ5IDMuOTQ5IDMuOTQ5IDEuNTUxLTEuNTUxLTMuOTQ5LTMuOTQ5TDE4LjcgOS4yNTF6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4yIC0yLjIpIiBzdHlsZT0iZmlsbDojZDgzZTM4Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckInApi = {
  addWeight: function addWeight(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/weight/checkIn/', model);
  },
  addHba1c: function addHba1c(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/hba1c/checkIn/', model);
  },
  addGoals: function addGoals(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/goal/checkIn/', model);
  },
  getCheckInStatus: function getCheckInStatus() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/checkIn/status/');
  }
};

exports.default = CheckInApi;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hba1cApi = {
  putHba1cTracking: function putHba1cTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/hba1c/', model);
  },
  postHba1cTracking: function postHba1cTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/hba1c/', model);
  },
  getHbA1cTrackingDetail: function getHbA1cTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/hba1c/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  deleteHbA1cReading: function deleteHbA1cReading(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/hba1c/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  }
};

exports.default = Hba1cApi;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WeightApi = {
  deleteWeightReading: function deleteWeightReading(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/weight/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  },
  updateWeightTracking: function updateWeightTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/weight/', model);
  },
  getWeightTrackingCard: function getWeightTrackingCard() {
    var self = this;
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/weight/card/?requestFrom=web');
  },
  postWeightTracking: function postWeightTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/weight/', model);
  },
  getWeightTrackingDetail: function getWeightTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/weight/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getWaistHipTrackingDetail: function getWaistHipTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/waist-hip/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  deleteWaistHipReading: function deleteWaistHipReading(trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/waist-hip/' + trackingId);
  },
  updateWaistHipTracking: function updateWaistHipTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/waist-hip/' + model.tracking_id, model);
  }
};

exports.default = WeightApi;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Objects = undefined;

var _Objects = __webpack_require__(1665);

var _Objects2 = _interopRequireDefault(_Objects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Objects = _Objects2.default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedNutrients: [{
        key: 'calories',
        value: 'message.nutrientCalories'
      }, {
        key: 'protein',
        value: 'message.nutrientProtein'
      }, {
        key: 'carbohydrate',
        value: 'message.nutrientCarbohydrate'
      }, {
        key: 'fat',
        value: 'message.nutrientFat'
      }, {
        key: 'sugar',
        value: 'message.nutrientSugar'
      }, {
        key: 'saturated_fat',
        value: 'message.nutrientSaturatedFat'
      }, {
        key: 'monounsaturated_fat',
        value: 'message.nutrientMonounsaturatedFat'
      }, {
        key: 'polyunsaturated_fat',
        value: 'message.nutrientPolyunsaturatedFat'
      }, {
        key: 'cholesterol',
        value: 'message.nutrientCholesterol'
      }, {
        key: 'fibre',
        value: 'message.nutrientFibre'
      }, {
        key: 'sodium',
        value: 'message.nutrientSodium'
      }, {
        key: 'potassium',
        value: 'message.nutrientPotassium'
      }]
    };
  },

  methods: {
    localizeNutrient: function localizeNutrient(key) {
      var self = this;
      return self.localizedNutrients.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
};

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJwcmVmaXhfX2ljX3NtYWxsX2NpcmNsZV90aWNrX2luYWN0aXZlIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiI+CiAgICA8Y2lyY2xlIGlkPSJwcmVmaXhfX0VsbGlwc2VfNTYiIGN4PSIxMSIgY3k9IjExIiByPSIxMSIgZGF0YS1uYW1lPSJFbGxpcHNlIDU2IiBzdHlsZT0iZmlsbDojYjZjMmM3O29wYWNpdHk6LjI4MyIvPgo8L3N2Zz4K"

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2726)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1355),
  /* template */
  __webpack_require__(3800),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1390),
  /* template */
  __webpack_require__(3708),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2634)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1417),
  /* template */
  __webpack_require__(3646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28c6d7af",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2664)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1433),
  /* template */
  __webpack_require__(3696),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2709)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1477),
  /* template */
  __webpack_require__(3774),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2609)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1504),
  /* template */
  __webpack_require__(3599),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2815)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1592),
  /* template */
  __webpack_require__(3827),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GraphApi = {
  CancelToken: _axios2.default.CancelToken,
  Cancel: null,

  getHeartRateGraph: function getHeartRateGraph() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { limit: 500, skip: 0 };

    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/heartRate/', {
      params: params,
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getActivityGraph: function getActivityGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/activity/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getActivityStepsGraph: function getActivityStepsGraph(fromDate, toDate, userId, type) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/activity/steps/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        type: type
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getMoodGraph: function getMoodGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/moods/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getMedicationGraph: function getMedicationGraph(fromDate, toDate, userId, medTrackingId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/medications/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        tracking_id: medTrackingId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getSleepGraph: function getSleepGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/sleep/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getSleepWearableGraph: function getSleepWearableGraph(fromDate, toDate, userId, type) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/sleep/wearable/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        type: type
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getBloodGlucoseGraph: function getBloodGlucoseGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/blood-glucose/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },
  getHba1cGraph: function getHba1cGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/hba1c/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getCholesterolGraph: function getCholesterolGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/cholesterol/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getBloodPressureGraph: function getBloodPressureGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/blood-pressure/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getWeightGraph: function getWeightGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/weight/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },
  getWaistGraph: function getWaistGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/waist-hip/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getInsulinGraph: function getInsulinGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/insulin/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getKetonesGraph: function getKetonesGraph(fromDate, toDate, userId) {
    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/ketones/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },

  getNutritionGraph: function getNutritionGraph(fromDate, toDate, userId) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "calories";

    var self = this;
    return _axios2.default.get(_index2.default.apiUrl + 'graph/nutrition/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        type: type
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  }
};

exports.default = GraphApi;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cacheCard = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity
});

cacheCard.__addFilter(/blood-glucose/);

var BloodGlucoseApi = {
  getBloodGlucoseRanges: function getBloodGlucoseRanges(fromDate, toDate) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/blood-glucose/ranges/?fromDate=' + fromDate + '&toDate' + toDate);
  },
  deleteGlucoseReading: function deleteGlucoseReading(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/blood-glucose/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  },
  getBloodGlucoseTrackingDetail: function getBloodGlucoseTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/blood-glucose/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getBloodGlucoseTrackingCard: function getBloodGlucoseTrackingCard() {
    return cacheCard({
      method: "GET",
      url: _config2.default.apiUrl + 'tracking/blood-glucose/card/?requestFrom=web'
    });
  },
  updateBloodGlucoseTracking: function updateBloodGlucoseTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/blood-glucose/', model);
  },
  postBloodGlucoseTracking: function postBloodGlucoseTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/blood-glucose/', model);
  }
};

exports.default = BloodGlucoseApi;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsulinApi = {
  deleteInsulinTracking: function deleteInsulinTracking(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/insulin/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  },
  getInsulinTrackingDetail: function getInsulinTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/insulin/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getInsulinTypes: function getInsulinTypes() {
    return _Lists2.default.getInsulinTypesList();
  },
  getInsulinTrackingCard: function getInsulinTrackingCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/insulin/card/?requestFrom=web');
  },
  putInsulinTracking: function putInsulinTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/insulin/', model);
  },
  postInsulinTracking: function postInsulinTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/insulin/', model);
  }
};

exports.default = InsulinApi;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KetonesApi = {
  updateKetonesTracking: function updateKetonesTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/ketones/', model);
  },
  getKetonesTrackingDetail: function getKetonesTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/ketones/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  deleteKetonesTracking: function deleteKetonesTracking(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/ketones/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  },
  getKetonesTrackingCard: function getKetonesTrackingCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/ketones/card/?requestFrom=web');
  },
  postKetonesTracking: function postKetonesTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/ketones/', model);
  }
};
exports.default = KetonesApi;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInteger = __webpack_require__(733);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _numeral = __webpack_require__(90);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    isWholeNumber: function isWholeNumber(num) {
      return (0, _isInteger2.default)(num);
    },
    decimalize: function decimalize(num) {
      if (isNaN(num)) {
        return 0;
      }
      var number = (0, _numeral2.default)(num);
      if (this.isWholeNumber(num)) {
        return number.format('0');
      }
      return number.format('0.0');
    },
    humanize: function humanize(str) {
      var frags = str.split("_");
      for (var i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
    getUnit: function getUnit(key) {
      switch (key) {
        case "calories":
          return "kcal";
        case "protein":
          return "g";
        case "carbohydrate":
          return "g";
        case "sugar":
          return "g";
        case "fat":
          return "g";
        case "saturated_fat":
          return "g";
        case "monounsaturated_fat":
          return "g";
        case "polyunsaturated_fat":
          return "g";
        case "cholesterol":
          return "g";
        case "fibre":
          return "g";
        case "sodium":
          return "mg";
        case "potassium":
          return "mg";
      }
    }
  }
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    mapInsulinTypes: function mapInsulinTypes(type) {
      var self = this;
      var label = '';
      switch (type) {
        case 'Basal':
          label = self.$t('message.labelBasal');
          break;
        case 'Bolus':
          label = self.$t('message.labelBolus');
          break;
        case 'Correction':
          label = self.$t('message.labelCorrection');
          break;
      }
      return label;
    }
  },
  computed: {
    lowerCaseUnitsLabel: function lowerCaseUnitsLabel() {
      var self = this;
      return self.$t('message.labelUnits').toLowerCase();
    }
  }
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedTags: [{
        key: 'Before Breakfast',
        value: 'message.tagBeforeBreakfast'
      }, {
        key: 'After Breakfast',
        value: 'message.tagAfterBreakfast'
      }, {
        key: 'Before Lunch',
        value: 'message.tagBeforeLunch'
      }, {
        key: 'After Lunch',
        value: 'message.tagAfterLunch'
      }, {
        key: 'Before Dinner/meal',
        value: "message.tagBeforeDinnerMeal"
      }, {
        key: 'After Dinner/meal',
        value: 'message.tagAfterDinnerMeal'
      }, {
        key: 'Party',
        value: 'message.tagParty'
      }, {
        key: 'Shop',
        value: 'message.tagShop'
      }, {
        key: 'Snack',
        value: 'message.tagSnack'
      }, {
        key: 'Menstruation',
        value: 'message.tagMenstruation'
      }, {
        key: 'Drink',
        value: 'message.tagDrink'
      }, {
        key: 'Fasting',
        value: 'message.tagFasting'
      }, {
        key: 'Activity',
        value: 'message.tagActivity'
      }, {
        key: 'Work',
        value: 'message.tagWork'
      }, {
        key: 'Correction',
        value: 'message.tagCorrection'
      }, {
        key: 'Driving',
        value: 'message.tagDriving'
      }]

    };
  },

  methods: {
    localizeTag: function localizeTag(key) {
      var self = this;
      return self.localizedTags.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var randomString = __webpack_require__(1126);
exports.default = {
  data: function data() {
    return {
      providers: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.providers = null;
  },

  methods: {
    connectAccount: function connectAccount(url) {
      var handshake = randomString.generate(16);
      var bearer = _axios2.default.defaults.headers.common['Authorization'];
      window.localStorage.setItem('handshake', handshake);

      var pseudoForm = document.createElement('form');
      pseudoForm.setAttribute('action', url);
      pseudoForm.setAttribute('method', 'POST');
      pseudoForm.setAttribute('style', 'display:none');

      var input = document.createElement("input");
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'handshake');
      input.setAttribute('value', handshake);

      if (bearer) {
        var token = bearer.split(' ')[1];
        var tokenInput = document.createElement("input");
        tokenInput.setAttribute('type', 'hidden');
        tokenInput.setAttribute('name', 'token');
        tokenInput.setAttribute('value', token);
        pseudoForm.appendChild(tokenInput);
      }

      pseudoForm.appendChild(input);
      document.body.appendChild(pseudoForm);
      pseudoForm.submit();
      document.body.removeChild(pseudoForm);
    }
  }

};

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2670)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1360),
  /* template */
  __webpack_require__(3703),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2676)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1447),
  /* template */
  __webpack_require__(3710),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2778)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1453),
  /* template */
  __webpack_require__(3626),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2725)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1488),
  /* template */
  __webpack_require__(3799),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bb04984",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2710)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1493),
  /* template */
  __webpack_require__(3775),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71c72f17",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2741)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1494),
  /* template */
  __webpack_require__(3829),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2638)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1495),
  /* template */
  __webpack_require__(3653),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2819)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1593),
  /* template */
  __webpack_require__(3837),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginApi = {
  Authenticate: function Authenticate(email, password, remember_me, captcha) {
    var offerCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return _axios2.default.post(_config2.default.apiUrl + 'login/v2/', {
      email: email,
      password: btoa(password),
      remember_me: remember_me,
      offerCode: offerCode,
      captcha: captcha,
      user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
  },
  ResetPassword: function ResetPassword(email) {
    return _axios2.default.post(_config2.default.apiUrl + 'reset/email/', {
      email: email
    });
  },
  updatePasswordWithToken: function updatePasswordWithToken(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'reset/password/', model);
  }
};

exports.default = LoginApi;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegistrationApi = {
  register: function register(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'register/initial/v2/', model);
  },
  amend: function amend(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'register/amend', model);
  },
  complete: function complete(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'register/complete', model);
  }
};

exports.default = RegistrationApi;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axiosCachePlugin = __webpack_require__(162);

var _axiosCachePlugin2 = _interopRequireDefault(_axiosCachePlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cacheCard = (0, _axiosCachePlugin2.default)(_axios2.default, {
  maxCacheSize: Infinity
});

cacheCard.__addFilter(/activity/);

var ActivityApi = {
  getActivityTrackingDetail: function getActivityTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/activity/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getActivityStepsTrackingDetail: function getActivityStepsTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/activity/steps/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getActivityTrackingCard: function getActivityTrackingCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/activity/card/?requestFrom=web');
  },
  addActivity: function addActivity(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/activity/', model);
  },
  deleteActivityReading: function deleteActivityReading(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/activity/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  }
};

exports.default = ActivityApi;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BloodPressureApi = {
  getBloodPressureTrackingCard: function getBloodPressureTrackingCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/blood-pressure/card/?requestFrom=web');
  },
  postBloodPressureTracking: function postBloodPressureTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/blood-pressure/', model);
  },
  putBloodPressureTracking: function putBloodPressureTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/blood-pressure/', model);
  },
  deleteBloodPressureTracking: function deleteBloodPressureTracking(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/blood-pressure/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  },
  getBloodPressureTrackingDetail: function getBloodPressureTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/blood-pressure/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  }
};

exports.default = BloodPressureApi;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CholesterolApi = {
  updateCholesterolTracking: function updateCholesterolTracking(model) {
    return _axios2.default.put(_config2.default.apiUrl + 'tracking/cholesterol/', model);
  },
  getCholesterolTrackingDetail: function getCholesterolTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/cholesterol/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  deleteCholesterolTracking: function deleteCholesterolTracking(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/cholesterol/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  },
  getCholesterolTrackingCard: function getCholesterolTrackingCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/cholesterol/card/?requestFrom=web');
  },
  postCholesterolTracking: function postCholesterolTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/cholesterol/', model);
  }
};

exports.default = CholesterolApi;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  value: 'AEROBICS',
  locale: 'message.activityAerobics'
}, {
  value: 'CYCLING',
  locale: 'message.activityCycling'
}, {
  value: 'DANCING',
  locale: 'message.activityDancing'
}, {
  value: 'TAI_CHI',
  locale: "message.activityTaiChi"
}, {
  value: 'PILATES',
  locale: 'message.activityPilates'
}, {
  value: 'SALSA_DANCING',
  locale: 'message.activitySalsaDancing'
}, {
  value: 'SWIMMING',
  locale: 'message.activitySwimming'
}, {
  value: 'GYM_ROWING',
  locale: 'message.activityGymRowing'
}, {
  value: 'GYM_TREADMILL',
  locale: 'message.activityGymTreadmill'
}, {
  value: 'GYM_CYCLING',
  locale: 'message.activityGymCycling'
}, {
  value: 'RUNNING',
  locale: 'message.activityRunning'
}, {
  value: 'STAIR_WALKING',
  locale: 'message.activityStairWalking'
}, {
  value: 'WALKING',
  locale: 'message.activityWalking'
}, {
  value: 'GYM_WEIGHTS',
  locale: 'message.activityGymWeights'
}, {
  value: 'YOGA',
  locale: 'message.activityYoga'
}, {
  value: 'SPORTS',
  locale: 'message.activitySports'
}, {
  value: 'SEX',
  locale: 'message.activitySex'
}];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Graphs = __webpack_require__(350);

var _Graphs2 = _interopRequireDefault(_Graphs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GraphManager = {
  applyCustomDate: function applyCustomDate(context) {
    var _this = this;

    var self = context;
    var fromDate = moment(self.customDate.fromDate, 'DD-MM-YYYY');
    var toDate = moment(self.customDate.toDate, 'DD-MM-YYYY');
    self.$nextTick(function () {
      var daysDifference = toDate.diff(fromDate, 'days');
      self.graph.fromDate = fromDate.format('YYYY-MM-DD');
      self.graph.toDate = toDate.format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.format('Do MMM YY');
      self.visualDate.toDate = toDate.format('Do MMM YY');

      self.visualDate.dateStep = daysDifference;

      _this.handleGraphType(context, true);
    });
  },

  hideCustomDate: function hideCustomDate(context) {
    context.isCustomDateMode = false;
  },

  showCustomDate: function showCustomDate(context) {
    var self = context;
    var fromDate = moment.utc(self.graph.fromDate, 'YYYY-MM-DD');
    var toDate = moment.utc(self.graph.toDate, 'YYYY-MM-DD');
    self.$nextTick(function () {
      self.customDate.fromDate = fromDate.format('DD-MM-YYYY');
      self.customDate.toDate = toDate.format('DD-MM-YYYY');
      self.isCustomDateMode = true;
    });
  },

  setToday: function setToday(context) {
    var self = context;
    var fromDate = moment();
    self.$nextTick(function () {
      self.graph.fromDate = today.format('YYYY-MM-DD');
      self.visualDate.fromDate = today.format('Do MMM YY');
      self.graph.toDate = today.format('YYYY-MM-DD');
      self.visualDate.toDate = today.format('Do MMM YY');
      self.visualDate.toDateIsToday = true;
    });
  },

  setDateStep: function setDateStep(context, step) {
    var self = context;
    var fromDate = moment.utc();
    if (step === 0) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('day').format('Do MMM YY'),
        toDate: fromDate.endOf('day').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('day').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('day').format('YYYY-MM-DD');
    }
    if (step === 7) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('isoWeek').format('Do MMM YY'),
        toDate: fromDate.endOf('isoWeek').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('isoWeek').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('isoWeek').format('YYYY-MM-DD');
    }
    if (step === 30) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('month').format('Do MMM YY'),
        toDate: fromDate.endOf('month').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('month').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('month').format('YYYY-MM-DD');
    }
    if (step === 360) {
      self.visualDate = {
        isDateToday: false,
        dateStep: step,
        fromDate: fromDate.startOf('year').format('Do MMM YY'),
        toDate: fromDate.endOf('year').format('Do MMM YY')
      };
      self.graph.fromDate = fromDate.startOf('year').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('year').format('YYYY-MM-DD');
    }
    self.graph.userId = self.userId;
    self.isCustomDateMode = false;
  },

  handleGraphType: function handleGraphType(context) {
    var isCustom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var self = context;
    if (isCustom === true) {
      self.type = self.graph.type;
      self.fromDate = self.customDate.fromDate;
      self.toDate = self.customDate.toDate;
      self.userId = self.graph.userId;
    }

    switch (self.type) {
      case 'activity':
        _Graphs2.default.getActivityGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'activity-steps':
        _Graphs2.default.getActivityStepsGraph(self.fromDate, self.toDate, self.userId, self.activeStepsType).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'weight':
        _Graphs2.default.getWeightGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'waist-hip':
        _Graphs2.default.getWaistGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'blood-glucose':
        _Graphs2.default.getBloodGlucoseGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'cholesterol':
        _Graphs2.default.getCholesterolGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'ketones':
        _Graphs2.default.getKetonesGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'blood-pressure':
        _Graphs2.default.getBloodPressureGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
          self.$emit('graphLoading', false);
        });
        break;
      case 'hba1c':
        _Graphs2.default.getHba1cGraph(self.fromDate, self.toDate, self.userId).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
          self.$emit('graphLoading', false);
        });
        break;
      case 'insulin':
        _Graphs2.default.getInsulinGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'sleep':
        _Graphs2.default.getSleepGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'sleep-wearable':
        _Graphs2.default.getSleepWearableGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id, self.activeSleepType).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'nutrition':
        _Graphs2.default.getNutritionGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed');
        });
        break;
      case 'medication':
        if (self.medTrackingId !== 0) {
          _Graphs2.default.getMedicationGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id, self.medTrackingId).then(function (response) {
            self.renderChartFromData(response);
          }).catch(function () {
            self.$emit('graphFailed');
          });
        }
        break;
      case 'mood':
        _Graphs2.default.getMoodGraph(self.fromDate, self.toDate, self.$store.state.user.scope.user_id).then(function (response) {
          self.renderChartFromData(response);
        }).catch(function () {
          self.$emit('graphFailed', {});
        });
        break;
    }
  },

  dateForward: function dateForward(context) {
    var self = context;
    var isDateStepZero = undefined;

    var fromDate = moment(self.graph.fromDate, "YYYY-MM-DD");
    var toDate = moment(self.graph.toDate, "YYYY-MM-DD");

    if (self.visualDate.dateStep === 0 || self.visualDate.dateStep === 1) {
      self.graph.fromDate = fromDate.add(1, 'days').startOf('day').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('day').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('day').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('day').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 7) {
      self.graph.fromDate = fromDate.add(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('isoWeek').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('isoWeek').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('isoWeek').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 30) {
      self.graph.fromDate = fromDate.add(1, 'months').startOf('month').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('month').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('month').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('month').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 360) {
      self.graph.fromDate = fromDate.add(1, 'years').startOf('year').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('year').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('year').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('year').format('Do MMM YY');
    }
  },

  dateBackward: function dateBackward(context) {
    var self = context;

    var fromDate = moment(self.graph.fromDate, "YYYY-MM-DD");
    var toDate = moment(self.graph.toDate, "YYYY-MM-DD");

    if (self.visualDate.dateStep === 0 || self.visualDate.dateStep === 1) {
      self.graph.fromDate = fromDate.subtract(1, 'days').startOf('day').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('day').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('day').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('day').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 7) {
      self.graph.fromDate = fromDate.subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('isoWeek').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('isoWeek').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('isoWeek').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 30) {
      self.graph.fromDate = fromDate.subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('month').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('month').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('month').format('Do MMM YY');
    }

    if (self.visualDate.dateStep === 360) {
      self.graph.fromDate = fromDate.subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
      self.graph.toDate = fromDate.endOf('year').format('YYYY-MM-DD');
      self.visualDate.fromDate = fromDate.startOf('year').format('Do MMM YY');
      self.visualDate.toDate = fromDate.endOf('year').format('Do MMM YY');
    }
  },

  graphLoading: function graphLoading(context) {
    context.graphIsLoading = true;
  },

  graphDidLoad: function graphDidLoad(context) {
    var self = context;
    self.$nextTick(function () {
      self.graphIsLoading = false;
      self.graphError = false;
    });
  },

  graphDidFail: function graphDidFail(context, options) {
    var self = context;
    self.$nextTick(function () {
      self.graphIsLoading = false;
      self.graphError = true;
    });
  },

  graphLineColorByType: function graphLineColorByType(context, index) {
    switch (context.type) {

      case "activity":
        if (index === 0) return "#4e2288";
        break;
      case "activity-steps":
        if (index === 0) return "#4e2288";
        break;
      case "blood-glucose":
        if (index === 0) return "#E43229";
        break;
      case "hba1c":
        if (index === 0) return "#E43229";
        break;
      case "cholesterol":
        if (index === 0) return "rgba(105,125,206, 1)";
        break;
      case "weight":
        return "#3D96DE";
      case "ketones":
        if (index === 0) {
          return "#F5950C";
        }
        if (index === 1) {
          return "red";
        }
        if (index === 2) {
          return "#68C3FF";
        }
        break;
      case "medication":
        return "#AE3463";
      case "sleep" && "sleep-wearable":
        if (index === 0) {
          return "#FEA228";
        }
        if (index === 1) {
          return "#0F3C43";
        }
        break;
      case "blood-pressure":
        if (index === 0) {
          return "rgba(163, 225, 100, 1)";
        }
        if (index === 1) {
          return "rgba(54, 147, 222, 1)";
        }
        break;
      case "insulin":
        if (index === 0) {
          return "rgba(52, 202, 185, 1)";
        }
        if (index === 1) {
          return "rgba(149, 52, 202, 1)";
        }
        if (index === 2) {
          return "rgba(254, 162, 40, 1)";
        }
        break;
      case "mood":
        return "#3123ae";
    }
  },

  graphColorGradientsByType: function graphColorGradientsByType(context, index) {
    var self = context;
    var gradient = self.$refs.canvas.getContext("2d").createLinearGradient(150.000, 0.000, 150.000, 300.000);
    if (self.type === "hba1c") {
      if (index === 0) {
        var opacity = 0.1;
        gradient.addColorStop(0, "rgba(228, 50, 41, 1)");
        gradient.addColorStop(0.5, "rgba(228, 50, 41, 0.5)");
        gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
        return gradient;
      }
    }
    if (self.override[index].pointBackgroundColor === '#FFFFFF') {
      var _opacity = 0.1;
      switch (self.type) {

        case 'activity':

          gradient.addColorStop(0, "rgba(85, 25, 140, 1)");
          gradient.addColorStop(0.5, "rgba(85, 25, 140, 0.5)");
          gradient.addColorStop(1, 'rgba(85, 25, 140,' + 0.01 + ')');
          return gradient;

          break;

        case 'activity-steps':

          gradient.addColorStop(0, "rgba(85, 25, 140, 1)");
          gradient.addColorStop(0.5, "rgba(85, 25, 140, 0.5)");
          gradient.addColorStop(1, 'rgba(85, 25, 140,' + 0.01 + ')');
          return gradient;

          break;

        case "blood-glucose":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(228, 50, 41, 1)");
            gradient.addColorStop(0.5, "rgba(228, 50, 41, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          break;

        case "cholesterol":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(105,125,206, 1)");
            gradient.addColorStop(0.5, "rgba(105,125,206, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          break;
        case "weight":
        case "waist-hip":
          gradient.addColorStop(0, "rgba(61, 150, 222, 1)");
          gradient.addColorStop(0.5, "rgba(61, 150, 222, 0.5)");
          gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
          return gradient;
          break;
        case "blood-pressure":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(163, 225, 100, 1)");
            gradient.addColorStop(0.5, "rgba(163, 225, 100, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          if (index === 1) {
            gradient.addColorStop(0, "rgba(54, 147, 222, 1)");
            gradient.addColorStop(0.5, "rgba(54, 147, 222, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          break;
        case "medication":
          gradient.addColorStop(0, "rgba(174, 52, 99, 1)");
          gradient.addColorStop(0.5, "rgba(174, 52, 99, 0.5)");
          gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
          return gradient;
          break;
        case "ketones":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(251, 183, 12, 1)");
            gradient.addColorStop(0.5, "rgba(251, 183, 12, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          break;
        case "insulin":
          if (index === 0) {
            gradient.addColorStop(0, " rgba(52, 202, 185, 1)");
            gradient.addColorStop(0.5, "rgba(52, 202, 185, 0.5) ");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }

          if (index === 1) {
            gradient.addColorStop(0, "rgba(149, 52, 202, 1)");
            gradient.addColorStop(0.5, "rgba(149, 52, 202, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }

          if (index === 2) {
            gradient.addColorStop(0, "rgba(254, 162, 40, 1)");
            gradient.addColorStop(0.5, "rgba(254, 162, 40, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          break;
        case "sleep" && "sleep-wearable":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(254, 162, 40, 1)");
            gradient.addColorStop(0.5, "rgba(254, 162, 40, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          if (index === 1) {
            gradient.addColorStop(0, "rgba(15, 60, 67,1 )");
            gradient.addColorStop(0.5, "rgba(15, 60, 67, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          break;
        case "mood":
          if (index === 0) {
            gradient.addColorStop(0, "rgba(254, 162, 40, 1)");
            gradient.addColorStop(0.5, "rgba(254, 162, 40, 0.5)");
            gradient.addColorStop(1, 'rgba(225,225,225,' + _opacity + ')');
            return gradient;
          }
          break;
        default:
          return undefined;
      }
      return undefined;
    }
  }
};

exports.default = GraphManager;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      flashMessageTitle: '',
      flashMessageBody: '',
      flashMessageType: ''
    };
  },

  computed: {
    showFlashMessage: function showFlashMessage() {
      var self = this;
      return !!(self.flashMessageType && self.flashMessageBody && self.flashMessageTitle);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getMessageDataFromStore();
    self.getMessageDataFromUrl();
  },

  methods: {
    getMessageDataFromStore: function getMessageDataFromStore() {
      var self = this;
      if (self.$store.state.flashMessage && self.$store.state.flashMessage.body) {
        self.flashMessageBody = self.$store.state.flashMessage.body;
        self.flashMessageTitle = self.$store.state.flashMessage.title;
        self.flashMessageType = self.$store.state.flashMessage.type;
        self.$store.commit('setFlashMessage', {});
      }
    },
    getMessageDataFromUrl: function getMessageDataFromUrl() {
      var self = this;
      var query = window.location.search;
      if (!query) {
        var hash = window.location.hash;
        query = hash.substr(hash.indexOf('?'));
      }
      var urlParams = new URLSearchParams(query);
      if (urlParams.has('flashMessageBody')) {
        self.flashMessageBody = urlParams.get('flashMessageBody');
      }
      if (urlParams.has('flashMessageTitle')) {
        self.flashMessageTitle = urlParams.get('flashMessageTitle');
      }
      if (urlParams.has('flashMessageType')) {
        self.flashMessageType = urlParams.get('flashMessageType');
      }
    }
  }
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedMoods: [{
        key: 'Refreshed',
        value: 'message.moodRefreshed'
      }, {
        key: 'Energetic',
        value: 'message.moodEnergetic'
      }, {
        key: 'Focused',
        value: 'message.moodFocused'
      }, {
        key: 'Restless',
        value: 'message.moodRestless'
      }, {
        key: 'Calm',
        value: 'message.moodCalm'
      }, {
        key: 'Distracted',
        value: 'message.moodDistracted'
      }, {
        key: 'Fatigued',
        value: 'message.moodFatigued'
      }, {
        key: 'Sleepy',
        value: 'message.moodSleepy'
      }, {
        key: 'Weak',
        value: 'message.moodWeak'
      }, {
        key: 'Anxious',
        value: 'message.moodAnxious'
      }, {
        key: 'Chilled',
        value: 'message.moodChilled'
      }, {
        key: 'Relieved',
        value: 'message.moodRelieved'
      }, {
        key: 'Happy',
        value: 'message.moodHappy'
      }, {
        key: 'Content',
        value: 'message.moodContent'
      }, {
        key: 'Excited',
        value: 'message.moodExcited'
      }, {
        key: 'Stressed',
        value: 'message.moodStressed'
      }, {
        key: 'Irritable',
        value: 'message.moodIrritable'
      }, {
        key: 'Hopeless',
        value: 'message.moodHopeless'
      }, {
        key: 'Angry',
        value: 'message.moodAngry'
      }, {
        key: 'Worried',
        value: 'message.moodWorried'
      }, {
        key: 'Unwell',
        value: 'message.moodUnwell'
      }, {
        key: 'Dizzy',
        value: 'message.moodDizzy'
      }, {
        key: 'Headache',
        value: 'message.moodHeadache'
      }, {
        key: 'Hypo',
        value: 'message.moodHypo'
      }, {
        key: 'Pain',
        value: 'message.moodPain'
      }]
    };
  },

  methods: {
    localizeMood: function localizeMood(key) {
      var self = this;
      return self.localizedMoods.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _Registration = __webpack_require__(477);

var _Registration2 = _interopRequireDefault(_Registration);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _Utilities = __webpack_require__(274);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _jsSha = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DobObject = _Utilities.Objects.DobObject;
exports.default = {
  data: function data() {
    return {
      siteUrl: _config2.default.siteUrl,
      isError: false,
      isSaving: false,
      terms: false,
      privacyPolicy: false,
      isTermsError: false,
      isPrivacyPolicyError: false,
      isServerValidationError: false,
      serverValidationErrorText: false,
      dobItems: DobObject,
      submitFunc: _Registration2.default.register,
      model: {
        firstname: null,
        surname: null,
        email: null,
        emailVerify: null,
        password: null,
        passwordVerify: null,
        visible: false,
        verifyVisible: false,
        dob: null,
        offerCode: null,
        terms: false,
        privacyPolicy: false,
        captcha: null,
        captchaFilled: false,
        referralId: null,
        subReferralId: null
      },
      dob: {
        day: null,
        month: null,
        year: null
      },
      prefilled: {
        firstname: false,
        surname: false,
        email: false,
        dob: false
      },
      captchaSiteKey: _config2.default.captchaSiteKey
    };
  },

  computed: {
    isValidAge: function isValidAge() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year.value + "-" + this.dob.month.value + "-" + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(18, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    },
    isOlderThan100: function isOlderThan100() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year.value + "-" + this.dob.month.value + "-" + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(100, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    }
  },
  watch: {
    'dob.day': function dobDay() {
      var self = this;
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    },
    'dob.month': function dobMonth() {
      var self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    },
    'dob.year': function dobYear() {
      var self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    }
  },
  methods: {
    formatDateOfBirth: function formatDateOfBirth() {
      var self = this;
      if (!_.isNull(self.dob.day) && !_.isNull(self.dob.month) && !_.isNull(self.dob.year)) {
        self.model.dob = self.dob.year.value + '-' + self.dob.month.value + '-' + self.dob.day;
      }
    },
    updateValidDobMonthDays: function updateValidDobMonthDays() {
      var self = this;
      if (!self.dob.month || !self.dob.month.daysCount) {
        return;
      }

      var days = self.dob.month.daysCount + 1;

      if (!_.isNull(self.dob.year) && self.dob.year.isLeap === true && self.dob.month.value === "02") {
        days = self.dob.month.daysCount + 2;
      }

      var daysArray = [];

      for (var i = 1; i < days; i++) {
        if (i < 10) {
          daysArray.push('0' + i + '');
        } else {
          daysArray.push('' + i + '');
        }
      }

      self.$set(self.dobItems, 'days', daysArray);
    },
    setTerms: function setTerms() {
      var self = this;
      self.terms = !self.terms;
      self.isTermsError = false;
    },
    setPrivacyPolicy: function setPrivacyPolicy() {
      var self = this;
      self.privacyPolicy = !self.privacyPolicy;
      self.isPrivacyPolicyError = false;
    },
    submitForm: function submitForm() {
      var self = this;
      if (self.isOlderThan100 === true) {
        self.$toastr.error("You have to be under 100 to sign up");
        return;
      }

      self.$validator.validateAll().then(function (valid) {
        if (valid && self.isValidAge) {
          var fbRegModel = {
            "data": [{
              "event_name": "Registered",
              "event_time": moment().unix(),
              "action_source": "email",
              "user_data": {
                "em": (0, _jsSha.sha256)(self.model.email),
                "client_ip_address": self.$store.state.geoLocation.host.ip,
                "client_user_agent": navigator.userAgent
              },
              "custom_data": {
                "regModel": self.model
              }
            }]
          };
          _axios2.default.post('https://graph.facebook.com/v11.0/625160948457652/events?access_token=EAALxgEaGHOQBAPhSgGaAn8wfcfGUmKNrCk6cpoQO7NX85wxgmaD56HgMmGQLUEKMPsyCAFgMuh33vl8r1go8uO1xHgCoM3y9Ggkm2JejlIX6jeoCEW3GnA9V9N6FMInLHjSh9lzKmaEAIacBfG0o4NUqUcdolpi4frbZCh8VQU1qPtpK30wSj3VbxTKQZD', fbRegModel).then(function (res) {}).catch(function (res) {});

          var clonedPassword = btoa(self.model.password);

          var registrationModel = {
            firstname: self.model.firstname,
            surname: self.model.surname,
            email: self.model.email,
            password: clonedPassword,
            dob: self.model.dob,
            offerCode: self.model.offerCode,
            captcha: self.model.captcha,
            referralId: self.model.referralId,
            subReferralId: self.model.subReferralId
          };

          var isHcp = self.$route.query.hcp;
          if (isHcp) {
            registrationModel.is_hcp = true;
          }

          if (self.model.email !== self.model.emailVerify) {
            self.$toastr.error("Emails do not match");
            return;
          }

          if (self.model.password !== self.model.passwordVerify) {
            self.$toastr.error("Please enter passwords that match");
            return;
          }

          if (self.model.terms !== true) {
            self.$toastr.error("Please agree to our terms and conditions");
            return;
          }

          if (self.model.privacyPolicy !== true) {
            self.$toastr.error("Please agree to our privacy policy");
            return;
          }

          if (self.model.captchaFilled === false) {
            self.$toastr.error("Please complete the captcha");
            return;
          }

          self.isSaving = true;
          self.submitFunc(registrationModel).then(function (response) {

            self.$gtag.event({
              'event_category': 'Registration',
              'event_label': 'New user',
              'event_action': 'RegistrationSuccess',
              'event_value': 1
            });

            self.$gtag.event({
              'event_category': 'Registration',
              'event_label': 'Initial registration form completed',
              'event_action': 'InitialRegistration',
              'event_value': 1
            });

            fbq('track', 'CompleteRegistration', { content_name: 'lowcarbprogram' });

            var token = _AuthenticationManager2.default.setAccessTokenExpiryTime(response.data.token);
            _AuthenticationManager2.default.setToken(token);
            _UserManager2.default.store(self, response.data);
            _UserManager2.default.get(self);

            if (isHcp) {
              self.$router.push({
                name: 'HcpGettingStarted'
              });
            } else {
              self.$router.push({
                name: 'Subscription'
              });
            }
          }).catch(function (error) {

            self.isSaving = false;
            self.model.captchaFilled = false;

            if (error.response.status === 500) {

              self.isError = true;
              self.$gtag.event({
                'eventCategory': 'Registration',
                'eventLabel': 'Error signing up',
                'eventAction': 'RegistrationError',
                'eventValue': 1
              });
            } else if (error.response.status === 422 || error.response.status === 400) {
              self.isServerValidationError = true;
              self.serverValidationErrorText = error.response.data.message;
            }
          });
        } else if (!self.isValidAge) {
          self.$toastr.error("You have to be 18 or over to sign up");
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      activeReport: {
        open: false
      }
    };
  },

  methods: {
    openReport: function openReport(type, type_id) {
      var self = this;
      self.activeReport.type_id = type_id;
      self.activeReport.type = type;
      self.activeReport.open = true;
      self.$forceUpdate();
    }
  }
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(146);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(1277);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    recipes: {
      searchModel: {
        "q": null,
        "suitabilities": [],
        "dietaryTypes": [],
        "cuisines": [],
        "categories": [],
        "carbs": [0, 500],
        "fat": [0, 500],
        "calories": [0, 3000],
        "protein": [0, 500],
        "totaltime": [0, 200]
      },
      filterData: null,
      categories: null,
      landingCache: {
        isBreakfast: false,
        isLunch: false,
        isDinner: false,
        isNight: false,
        excludeAt: null,
        lunch: {
          recipes: []
        },
        dinner: {
          recipes: []
        },
        snack: {
          recipes: []
        },
        seasonal: null,
        allergiesExcluded: null,
        dietaryTypes: null,
        cuisines: null,
        favoriteBased: {
          recipes: []
        }
      }
    },
    graphOptions: {
      showDots: false,
      smoothLine: true,
      showArea: true
    },
    status: {
      onboarding: {},
      payment: {
        paid: null
      }
    },
    cards: {
      activity: {},
      mood: {},
      nutrition: {},
      ketones: {},
      weight: {},
      bloodPressure: {},
      bloodGlucose: {},
      cholesterol: {},
      insulin: {},
      sleep: {},
      medication: {}
    },
    discussion: {
      topContributors: [],
      frequentlyAsked: []
    },
    account: {},
    user: {},
    provider: {},
    i18n: {},
    list: {},
    geoLocation: {},
    activeProfile: null,
    activeProfileObject: {},
    lessons: [],
    reportingReasons: [],
    moodList: [],
    bgTagList: [],
    insulinTypes: [],
    cardOrder: [],
    hcp: {
      jobs: [],
      goals: []
    },
    login: {},
    flashMessage: {},
    loginProviders: []
  },
  getters: {
    getRecipeSearchFilter: function getRecipeSearchFilter(state) {
      return state.recipes.searchModel;
    },
    getRecipeCategories: function getRecipeCategories(state) {
      return state.recipes.filterData;
    }
  },
  mutations: {
    setRecipeSearchFilter: function setRecipeSearchFilter(state, value) {
      state.recipes.searchModel = value;
    },
    setRecipesCacheTimely: function setRecipesCacheTimely(state, obj) {
      state.recipes.landingCache[obj.key] = obj.val;
    },
    setRecipeCategories: function setRecipeCategories(state, value) {
      state.recipes.categories = value;
    },
    setRecipeFilter: function setRecipeFilter(state, value) {
      state.recipes.filterData = value;
    },
    setRecipesTimely: function setRecipesTimely(state, value) {
      state.recipes.timely = value;
    },
    setLang: function setLang(state, value) {
      state.i18n.locale = value;
    },
    showGraphPoints: function showGraphPoints(state, value) {
      state.graphOptions.showDots = value;
    },
    showGraphSmooth: function showGraphSmooth(state, value) {
      state.graphOptions.smoothLine = value;
    },
    showGraphArea: function showGraphArea(state, value) {
      state.graphOptions.showArea = value;
    },
    setBgTagList: function setBgTagList(state, value) {
      value = value.sort(function (a, b) {
        var textA = a.tag.toUpperCase();
        var textB = b.tag.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      state.bgTagList = value;
    },
    setOnBoardingStatus: function setOnBoardingStatus(state, value) {
      state.status.onboarding = value;
    },
    setPaymentStatus: function setPaymentStatus(state, value) {
      state.status.payment.paid = value;
    },
    setReportingReasons: function setReportingReasons(state, value) {
      state.reportingReasons = value;
    },
    setActivityCard: function setActivityCard(state, value) {
      state.cards.activity = value;
    },
    setInsulinTypes: function setInsulinTypes(state, value) {
      state.insulinTypes = value;
    },
    setInsulinCard: function setInsulinCard(state, value) {
      state.cards.insulin = value;
    },
    setKetonesCard: function setKetonesCard(state, value) {
      state.cards.ketones = value;
    },
    setMedicationCard: function setMedicationCard(state, value) {
      state.cards.medication = value;
    },
    setCholesterolCard: function setCholesterolCard(state, value) {
      state.cards.cholesterol = value;
    },
    setBloodPressureCard: function setBloodPressureCard(state, value) {
      state.cards.bloodPressure = value;
    },
    setBloodGlucoseCard: function setBloodGlucoseCard(state, value) {
      state.cards.bloodGlucose = value;
    },
    setNutritionCard: function setNutritionCard(state, value) {
      state.cards.nutrition = value;
    },
    setMoodCard: function setMoodCard(state, value) {
      state.cards.mood = value;
    },
    setWeightCard: function setWeightCard(state, value) {
      state.cards.weight = value;
    },
    setSleepCard: function setSleepCard(state, value) {
      state.cards.sleep = value;
    },
    setDiscussionContributors: function setDiscussionContributors(state, value) {
      state.discussion.topContributors = value;
    },
    setDiscussionFrequentlyAsked: function setDiscussionFrequentlyAsked(state, value) {
      state.discussion.frequentlyAsked = value;
    },
    setProvider: function setProvider(state, value) {
      state.provider = value;
    },
    setMoodList: function setMoodList(state, value) {
      state.moodList = value;
    },
    setGeoLocation: function setGeoLocation(state, value) {
      state.geoLocation = value;
    },
    setAccount: function setAccount(state, value) {
      state.account = value;
    },
    setUser: function setUser(state, value) {
      state.user = value;
    },
    setLessons: function setLessons(state, value) {
      state.lessons = value;
    },
    setI18n: function setI18n(state, i18n) {
      state.i18n = i18n;
    },
    setList: function setList(state, value) {
      state.list = value;
    },
    setCardOrder: function setCardOrder(state, value) {
      state.cardOrder = value;
    },
    setActiveProfile: function setActiveProfile(state, value) {
      state.activeProfile = value;
    },
    setActiveProfileObject: function setActiveProfileObject(state, value) {
      state.activeProfileObject = value;
    },
    setHcpGoals: function setHcpGoals(state, value) {
      state.hcp.goals = value;
    },
    setHcpJobs: function setHcpJobs(state, value) {
      state.hcp.jobs = value;
    },
    setFlashMessage: function setFlashMessage(state, value) {
      state.flashMessage = value;
    },
    setLoginProviders: function setLoginProviders(state, value) {
      state.loginProviders = value;
    }
  }
});

exports.default = store;

/***/ }),
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 658 */,
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2672)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1348),
  /* template */
  __webpack_require__(3705),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1357),
  /* template */
  __webpack_require__(3843),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2761)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1376),
  /* template */
  __webpack_require__(3869),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2829)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1401),
  /* template */
  __webpack_require__(3871),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f76d7dac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1422),
  /* template */
  __webpack_require__(3634),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2648)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1458),
  /* template */
  __webpack_require__(3673),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2685)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1486),
  /* template */
  __webpack_require__(3728),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2745)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1487),
  /* template */
  __webpack_require__(3836),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2597)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1489),
  /* template */
  __webpack_require__(3582),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2712)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1490),
  /* template */
  __webpack_require__(3778),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2608)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1496),
  /* template */
  __webpack_require__(3598),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2779)
  __webpack_require__(2627)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1499),
  /* template */
  __webpack_require__(3631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20a3c8ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2692)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1501),
  /* template */
  __webpack_require__(3745),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2780)
  __webpack_require__(2628)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1502),
  /* template */
  __webpack_require__(3632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21295ad4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2721)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1505),
  /* template */
  __webpack_require__(3794),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2813)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1513),
  /* template */
  __webpack_require__(3820),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2798)
  __webpack_require__(2799)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1514),
  /* template */
  __webpack_require__(3743),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e848e86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Supported contexts
   lowcarbprogram
   grohealth
 * @type {{string}}
 */


var argv = __webpack_require__(992)(process.argv.slice(2));
var appcontext = argv.appcontext;
var apponly = argv.apponly;
var runmode = argv.runmode;


/**
if(process.env.NODE_ENV === 'development') {
  appcontext = "lowcarbprogram";
  apponly = true;
  runmode = "development"
}
 **/

module.exports = {
  appcontext: appcontext ? appcontext: "grohealth",
  apponly: apponly ? apponly: null,
  runmode: runmode ? runmode : null
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159)))

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Supported languages
   en-CA
   en-GB
   fr-CA

 * @type {{locale: string}}
 */
var argv = __webpack_require__(992)(process.argv.slice(2));
var lang = argv.lang;


module.exports = {
  locale: lang !== undefined ? lang :  "en-GB"
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159)))

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaqApi = {
  mostUseful: function mostUseful() {
    return _axios2.default.get(_config2.default.apiUrl + 'faqs/mostUseful');
  },
  upVote: function upVote(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'faqs/rating/up/' + id);
  },
  downVote: function downVote(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'faqs/rating/down/' + id);
  },
  getRecommendations: function getRecommendations(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'faqs/recommendations/' + id);
  },
  getById: function getById(id) {
    return _axios2.default.get(_config2.default.apiUrl + 'faqs/' + id);
  },
  getCategories: function getCategories() {
    var self = this;
    return _axios2.default.get(_config2.default.apiUrl + 'faqs/categories');
  },
  getAll: function getAll() {
    return _axios2.default.get(_config2.default.apiUrl + 'faqs');
  },
  search: function search(value) {
    return _axios2.default.post(_config2.default.apiUrl + 'faqs/search', {
      keyword: value
    });
  }
};

exports.default = FaqApi;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeoApi = {
  geoIp: function geoIp() {
    return _axios2.default.get(_config2.default.apiUrl + 'geoIp');
  }
};

exports.default = GeoApi;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderApi = {
  getProvider: function getProvider() {
    return _axios2.default.get(_config2.default.apiUrl + 'user/provider');
  }
};

exports.default = ProviderApi;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourcesApi = {
  getMealPlans: function getMealPlans() {
    return _axios2.default.get(_config2.default.apiUrl + 'mealplans/');
  },
  getSeasonalDownloads: function getSeasonalDownloads() {
    return _axios2.default.get(_config2.default.apiUrl + 'resources/seasonal/');
  },
  getResources: function getResources() {
    return _axios2.default.get(_config2.default.apiUrl + 'resources/');
  },
  saveResourceCount: function saveResourceCount(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'resource/download/count/', model);
  }
};

exports.default = ResourcesApi;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurgerySearchApi = {
  searchSurgeriesByQuery: function searchSurgeriesByQuery(filter) {
    return _axios2.default.post(_config2.default.apiUrl + 'surgery/search/', {
      query: filter
    });
  }
};

exports.default = SurgerySearchApi;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoodApi = {
  deleteMoodTracking: function deleteMoodTracking(progressId, trackingId) {
    return _axios2.default.delete(_config2.default.apiUrl + 'tracking/moods/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    });
  },
  getMoodTrackingDetail: function getMoodTrackingDetail(page, page_size) {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/moods/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  getMoodsTrackingCard: function getMoodsTrackingCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/moods/card/?requestFrom=web');
  },
  postMoodsTracking: function postMoodsTracking(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/moods/', model);
  }
};

exports.default = MoodApi;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuickTrackingApi = {
  addProgress: function addProgress(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/addProgress/', model);
  },
  postHba1cReading: function postHba1cReading(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/hba1c/', model);
  },
  postWeightReading: function postWeightReading(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'tracking/weight/', model);
  }
};

exports.default = QuickTrackingApi;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatDate = function formatDate(date) {
  date = moment.utc(date).local();
  return date.format('Do MMMM YYYY, h:mm A');
};

exports.default = formatDate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var ImageManager = {
  convertImgToBase64: function convertImgToBase64(url, callback, outputFormat) {
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      var canvas = document.createElement('CANVAS');
      var ctx = canvas.getContext('2d');
      canvas.height = this.height;
      canvas.width = this.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL(outputFormat || 'image/png');
      callback(dataURL);
      canvas = null;
    };
    img.src = url;
  }
};
exports.default = ImageManager;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOrder = [{
  name: 'ACTIVITY',
  hidden: false
}, {
  name: "WEIGHT",
  hidden: false
}, {
  name: "BLOOD_GLUCOSE",
  hidden: false
}, {
  name: "SLEEP",
  hidden: false
}, {
  name: "CHOLESTEROL",
  hidden: false
}, {
  name: "MEDICATION",
  hidden: false
}, {
  name: "BLOOD_PRESSURE",
  hidden: false
}, {
  name: "MOOD",
  hidden: false
}, {
  name: "KETONES",
  hidden: false
}, {
  name: "NUTRITION",
  hidden: false
}, {
  name: "INSULIN",
  hidden: false
}];

exports.default = {
  data: function data() {
    return {
      isCardOrderReady: false,
      order: defaultOrder
    };
  },
  mounted: function mounted() {
    var self = this;
    if (self.$store.state.cardOrder.length > 0) {
      self.order = self.$store.state.cardOrder;
      self.isCardOrderReady = true;
    } else _Settings2.default.getCardOrder().then(function (response) {
      self.order = response.data;
      self.isCardOrderReady = true;
      self.$store.commit('setCardOrder', response.data);
    });
  },

  computed: {
    chunkedOrder: function chunkedOrder() {
      var self = this;
      var filteredArray = self.order.filter(function (item) {
        return item.hidden === false;
      });
      return _.chunk(filteredArray, 4);
    },
    desktopWidth: function desktopWidth() {
      var self = this;
      if (self.chunkedOrder.length === 3) {
        return "33";
      }
      if (self.chunkedOrder.length === 2) {
        return "50";
      }
      if (self.chunkedOrder.length === 1) {
        return "100";
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    rotate: function rotate(direction) {
      var self = this;
      if (direction === 'left') {
        self.cropper.rotate(-90);
      }
      if (direction === 'right') {
        self.cropper.rotate(90);
      }
    },
    openInput: function openInput() {
      $('.vue-base64-file-upload-wrapper input').click();
    },
    onLoad: function onLoad(dataUri) {
      var self = this;
      self.image = dataUri;
      self.cropper.bind({
        url: dataUri
      });
      self.isCropperVisible = true;
    },
    onSizeExceeded: function onSizeExceeded(size) {
      alert('Image ' + size + 'Mb size exceeds limits of ' + this.customImageMaxSize + 'Mb!');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedAllergies: [{
        key: "Dairy",
        value: 'message.allergyDairy'
      }, {
        key: "Gluten",
        value: "message.allergyGluten"
      }, {
        key: "Celery",
        value: "message.allergyCelery"
      }, {
        key: "Yeast",
        value: "message.allergyYeast"
      }, {
        key: "Shellfish",
        value: "message.allergyShellfish"
      }, {
        key: "Alcohol",
        value: "message.allergyAlcohol"
      }, {
        key: "Peanuts",
        value: "message.allergyPeanuts"
      }, {
        key: "Lupin",
        value: "message.allergyLupin"
      }, {
        key: "Soybeans",
        value: "message.allergySoybeans"
      }, {
        key: "Fish",
        value: "message.allergyFish"
      }, {
        key: "Eggs",
        value: "message.allergyEggs"
      }, {
        key: "Mustard",
        value: "message.allergyMustard"
      }, {
        key: "Sulphites",
        value: "message.allergySulphites"
      }]
    };
  },

  methods: {
    localizeAllergy: function localizeAllergy(key) {
      var self = this;
      var localizedAllergy = self.localizedAllergies.filter(function (item) {
        return item.key === key;
      });
      if (localizedAllergy.length > 0) {
        return self.$t(localizedAllergy[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      dietaryPreferences: [{
        key: "No dietary preference",
        value: "message.dietPreferenceNone"
      }, {
        key: "Pescetarian",
        value: "message.dietPreferencePescetarian"
      }, {
        key: "Vegetarian",
        value: "message.dietPreferenceVegetarian"
      }, {
        key: "Vegan",
        value: "message.dietPreferenceVegan"
      }]
    };
  },

  methods: {
    localizeDietPreference: function localizeDietPreference(key) {

      var self = this;
      var localizedDietPref = self.dietaryPreferences.filter(function (item) {
        return item.key === key;
      });

      if (localizedDietPref.length > 0) {
        return self.$t(localizedDietPref[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedEthnicities: [{
        key: 1,
        value: 'message.ethnicityWhite'
      }, {
        key: 2,
        value: 'message.ethnicityArab'
      }, {
        key: 3,
        value: 'message.ethnicityIndian'
      }, {
        key: 4,
        value: 'message.ethnicityPakistani'
      }, {
        key: 5,
        value: 'message.ethnicityBangladeshi'
      }, {
        key: 6,
        value: 'message.ethnicityChinese'
      }, {
        key: 7,
        value: 'message.ethnicityOtherAsian'
      }, {
        key: 8,
        value: 'message.ethnicityBlack'
      }, {
        key: 9,
        value: 'message.ethnicityOther'
      }, {
        key: 10,
        value: 'message.ethnicityRatherNotSay'
      }]
    };
  },

  methods: {
    localizeEthnicity: function localizeEthnicity(key) {
      var self = this;
      return self.localizedEthnicities.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      sexes: [{
        key: "Male",
        value: "message.sexMale"
      }, {
        key: "Female",
        value: "message.sexFemale"
      }]
    };
  },

  methods: {
    localizeSex: function localizeSex(key) {
      var self = this;
      var localization = self.sexes.filter(function (item) {
        return item.key === key;
      });
      if (localization.length === 1) {
        return self.$t(localization[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isoLangs = {
  "ab": {
    "name": "Abkhaz",
    "nativeName": "аҧсуа"
  },
  "aa": {
    "name": "Afar",
    "nativeName": "Afaraf"
  },
  "af": {
    "name": "Afrikaans",
    "nativeName": "Afrikaans"
  },
  "ak": {
    "name": "Akan",
    "nativeName": "Akan"
  },
  "sq": {
    "name": "Albanian",
    "nativeName": "Shqip"
  },
  "am": {
    "name": "Amharic",
    "nativeName": "አማርኛ"
  },
  "ar": {
    "name": "Arabic",
    "nativeName": "العربية"
  },
  "an": {
    "name": "Aragonese",
    "nativeName": "Aragonés"
  },
  "hy": {
    "name": "Armenian",
    "nativeName": "Հայերեն"
  },
  "as": {
    "name": "Assamese",
    "nativeName": "অসমীয়া"
  },
  "av": {
    "name": "Avaric",
    "nativeName": "авар мацӀ, магӀарул мацӀ"
  },
  "ae": {
    "name": "Avestan",
    "nativeName": "avesta"
  },
  "ay": {
    "name": "Aymara",
    "nativeName": "aymar aru"
  },
  "az": {
    "name": "Azerbaijani",
    "nativeName": "azərbaycan dili"
  },
  "bm": {
    "name": "Bambara",
    "nativeName": "bamanankan"
  },
  "ba": {
    "name": "Bashkir",
    "nativeName": "башҡорт теле"
  },
  "eu": {
    "name": "Basque",
    "nativeName": "euskara, euskera"
  },
  "be": {
    "name": "Belarusian",
    "nativeName": "Беларуская"
  },
  "bn": {
    "name": "Bengali",
    "nativeName": "বাংলা"
  },
  "bh": {
    "name": "Bihari",
    "nativeName": "भोजपुरी"
  },
  "bi": {
    "name": "Bislama",
    "nativeName": "Bislama"
  },
  "bs": {
    "name": "Bosnian",
    "nativeName": "bosanski jezik"
  },
  "br": {
    "name": "Breton",
    "nativeName": "brezhoneg"
  },
  "bg": {
    "name": "Bulgarian",
    "nativeName": "български език"
  },
  "my": {
    "name": "Burmese",
    "nativeName": "ဗမာစာ"
  },
  "ca": {
    "name": "Catalan; Valencian",
    "nativeName": "Català"
  },
  "ch": {
    "name": "Chamorro",
    "nativeName": "Chamoru"
  },
  "ce": {
    "name": "Chechen",
    "nativeName": "нохчийн мотт"
  },
  "ny": {
    "name": "Chichewa; Chewa; Nyanja",
    "nativeName": "chiCheŵa, chinyanja"
  },
  "zh": {
    "name": "Chinese",
    "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
  },
  "cv": {
    "name": "Chuvash",
    "nativeName": "чӑваш чӗлхи"
  },
  "kw": {
    "name": "Cornish",
    "nativeName": "Kernewek"
  },
  "co": {
    "name": "Corsican",
    "nativeName": "corsu, lingua corsa"
  },
  "cr": {
    "name": "Cree",
    "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ"
  },
  "hr": {
    "name": "Croatian",
    "nativeName": "hrvatski"
  },
  "cs": {
    "name": "Czech",
    "nativeName": "česky, čeština"
  },
  "da": {
    "name": "Danish",
    "nativeName": "dansk"
  },
  "dv": {
    "name": "Divehi; Dhivehi; Maldivian;",
    "nativeName": "ދިވެހި"
  },
  "nl": {
    "name": "Dutch",
    "nativeName": "Nederlands, Vlaams"
  },
  "en": {
    "name": "English",
    "nativeName": "English"
  },
  "eo": {
    "name": "Esperanto",
    "nativeName": "Esperanto"
  },
  "et": {
    "name": "Estonian",
    "nativeName": "eesti, eesti keel"
  },
  "ee": {
    "name": "Ewe",
    "nativeName": "Eʋegbe"
  },
  "fo": {
    "name": "Faroese",
    "nativeName": "føroyskt"
  },
  "fj": {
    "name": "Fijian",
    "nativeName": "vosa Vakaviti"
  },
  "fi": {
    "name": "Finnish",
    "nativeName": "suomi, suomen kieli"
  },
  "fr": {
    "name": "French",
    "nativeName": "français, langue française"
  },
  "ff": {
    "name": "Fula; Fulah; Pulaar; Pular",
    "nativeName": "Fulfulde, Pulaar, Pular"
  },
  "gl": {
    "name": "Galician",
    "nativeName": "Galego"
  },
  "ka": {
    "name": "Georgian",
    "nativeName": "ქართული"
  },
  "de": {
    "name": "German",
    "nativeName": "Deutsch"
  },
  "el": {
    "name": "Greek, Modern",
    "nativeName": "Ελληνικά"
  },
  "gn": {
    "name": "Guaraní",
    "nativeName": "Avañeẽ"
  },
  "gu": {
    "name": "Gujarati",
    "nativeName": "ગુજરાતી"
  },
  "ht": {
    "name": "Haitian; Haitian Creole",
    "nativeName": "Kreyòl ayisyen"
  },
  "ha": {
    "name": "Hausa",
    "nativeName": "Hausa, هَوُسَ"
  },
  "he": {
    "name": "Hebrew (modern)",
    "nativeName": "עברית"
  },
  "hz": {
    "name": "Herero",
    "nativeName": "Otjiherero"
  },
  "hi": {
    "name": "Hindi",
    "nativeName": "हिन्दी, हिंदी"
  },
  "ho": {
    "name": "Hiri Motu",
    "nativeName": "Hiri Motu"
  },
  "hu": {
    "name": "Hungarian",
    "nativeName": "Magyar"
  },
  "ia": {
    "name": "Interlingua",
    "nativeName": "Interlingua"
  },
  "id": {
    "name": "Indonesian",
    "nativeName": "Bahasa Indonesia"
  },
  "ie": {
    "name": "Interlingue",
    "nativeName": "Originally called Occidental; then Interlingue after WWII"
  },
  "ga": {
    "name": "Irish",
    "nativeName": "Gaeilge"
  },
  "ig": {
    "name": "Igbo",
    "nativeName": "Asụsụ Igbo"
  },
  "ik": {
    "name": "Inupiaq",
    "nativeName": "Iñupiaq, Iñupiatun"
  },
  "io": {
    "name": "Ido",
    "nativeName": "Ido"
  },
  "is": {
    "name": "Icelandic",
    "nativeName": "Íslenska"
  },
  "it": {
    "name": "Italian",
    "nativeName": "Italiano"
  },
  "iu": {
    "name": "Inuktitut",
    "nativeName": "ᐃᓄᒃᑎᑐᑦ"
  },
  "ja": {
    "name": "Japanese",
    "nativeName": "日本語 (にほんご／にっぽんご)"
  },
  "jv": {
    "name": "Javanese",
    "nativeName": "basa Jawa"
  },
  "kl": {
    "name": "Kalaallisut, Greenlandic",
    "nativeName": "kalaallisut, kalaallit oqaasii"
  },
  "kn": {
    "name": "Kannada",
    "nativeName": "ಕನ್ನಡ"
  },
  "kr": {
    "name": "Kanuri",
    "nativeName": "Kanuri"
  },
  "ks": {
    "name": "Kashmiri",
    "nativeName": "कश्मीरी, كشميري‎"
  },
  "kk": {
    "name": "Kazakh",
    "nativeName": "Қазақ тілі"
  },
  "km": {
    "name": "Khmer",
    "nativeName": "ភាសាខ្មែរ"
  },
  "ki": {
    "name": "Kikuyu, Gikuyu",
    "nativeName": "Gĩkũyũ"
  },
  "rw": {
    "name": "Kinyarwanda",
    "nativeName": "Ikinyarwanda"
  },
  "ky": {
    "name": "Kirghiz, Kyrgyz",
    "nativeName": "кыргыз тили"
  },
  "kv": {
    "name": "Komi",
    "nativeName": "коми кыв"
  },
  "kg": {
    "name": "Kongo",
    "nativeName": "KiKongo"
  },
  "ko": {
    "name": "Korean",
    "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
  },
  "ku": {
    "name": "Kurdish",
    "nativeName": "Kurdî, كوردی‎"
  },
  "kj": {
    "name": "Kwanyama, Kuanyama",
    "nativeName": "Kuanyama"
  },
  "la": {
    "name": "Latin",
    "nativeName": "latine, lingua latina"
  },
  "lb": {
    "name": "Luxembourgish, Letzeburgesch",
    "nativeName": "Lëtzebuergesch"
  },
  "lg": {
    "name": "Luganda",
    "nativeName": "Luganda"
  },
  "li": {
    "name": "Limburgish, Limburgan, Limburger",
    "nativeName": "Limburgs"
  },
  "ln": {
    "name": "Lingala",
    "nativeName": "Lingála"
  },
  "lo": {
    "name": "Lao",
    "nativeName": "ພາສາລາວ"
  },
  "lt": {
    "name": "Lithuanian",
    "nativeName": "lietuvių kalba"
  },
  "lu": {
    "name": "Luba-Katanga",
    "nativeName": ""
  },
  "lv": {
    "name": "Latvian",
    "nativeName": "latviešu valoda"
  },
  "gv": {
    "name": "Manx",
    "nativeName": "Gaelg, Gailck"
  },
  "mk": {
    "name": "Macedonian",
    "nativeName": "македонски јазик"
  },
  "mg": {
    "name": "Malagasy",
    "nativeName": "Malagasy fiteny"
  },
  "ms": {
    "name": "Malay",
    "nativeName": "bahasa Melayu, بهاس ملايو‎"
  },
  "ml": {
    "name": "Malayalam",
    "nativeName": "മലയാളം"
  },
  "mt": {
    "name": "Maltese",
    "nativeName": "Malti"
  },
  "mi": {
    "name": "Māori",
    "nativeName": "te reo Māori"
  },
  "mr": {
    "name": "Marathi (Marāṭhī)",
    "nativeName": "मराठी"
  },
  "mh": {
    "name": "Marshallese",
    "nativeName": "Kajin M̧ajeļ"
  },
  "mn": {
    "name": "Mongolian",
    "nativeName": "монгол"
  },
  "na": {
    "name": "Nauru",
    "nativeName": "Ekakairũ Naoero"
  },
  "nv": {
    "name": "Navajo, Navaho",
    "nativeName": "Diné bizaad, Dinékʼehǰí"
  },
  "nb": {
    "name": "Norwegian Bokmål",
    "nativeName": "Norsk bokmål"
  },
  "nd": {
    "name": "North Ndebele",
    "nativeName": "isiNdebele"
  },
  "ne": {
    "name": "Nepali",
    "nativeName": "नेपाली"
  },
  "ng": {
    "name": "Ndonga",
    "nativeName": "Owambo"
  },
  "nn": {
    "name": "Norwegian Nynorsk",
    "nativeName": "Norsk nynorsk"
  },
  "no": {
    "name": "Norwegian",
    "nativeName": "Norsk"
  },
  "ii": {
    "name": "Nuosu",
    "nativeName": "ꆈꌠ꒿ Nuosuhxop"
  },
  "nr": {
    "name": "South Ndebele",
    "nativeName": "isiNdebele"
  },
  "oc": {
    "name": "Occitan",
    "nativeName": "Occitan"
  },
  "oj": {
    "name": "Ojibwe, Ojibwa",
    "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
  },
  "cu": {
    "name": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    "nativeName": "ѩзыкъ словѣньскъ"
  },
  "om": {
    "name": "Oromo",
    "nativeName": "Afaan Oromoo"
  },
  "or": {
    "name": "Oriya",
    "nativeName": "ଓଡ଼ିଆ"
  },
  "os": {
    "name": "Ossetian, Ossetic",
    "nativeName": "ирон æвзаг"
  },
  "pa": {
    "name": "Panjabi, Punjabi",
    "nativeName": "ਪੰਜਾਬੀ, پنجابی‎"
  },
  "pi": {
    "name": "Pāli",
    "nativeName": "पाऴि"
  },
  "fa": {
    "name": "Persian",
    "nativeName": "فارسی"
  },
  "pl": {
    "name": "Polish",
    "nativeName": "polski"
  },
  "ps": {
    "name": "Pashto, Pushto",
    "nativeName": "پښتو"
  },
  "pt": {
    "name": "Portuguese",
    "nativeName": "Português"
  },
  "qu": {
    "name": "Quechua",
    "nativeName": "Runa Simi, Kichwa"
  },
  "rm": {
    "name": "Romansh",
    "nativeName": "rumantsch grischun"
  },
  "rn": {
    "name": "Kirundi",
    "nativeName": "kiRundi"
  },
  "ro": {
    "name": "Romanian, Moldavian, Moldovan",
    "nativeName": "română"
  },
  "ru": {
    "name": "Russian",
    "nativeName": "русский язык"
  },
  "sa": {
    "name": "Sanskrit (Saṁskṛta)",
    "nativeName": "संस्कृतम्"
  },
  "sc": {
    "name": "Sardinian",
    "nativeName": "sardu"
  },
  "sd": {
    "name": "Sindhi",
    "nativeName": "सिन्धी, سنڌي، سندھی‎"
  },
  "se": {
    "name": "Northern Sami",
    "nativeName": "Davvisámegiella"
  },
  "sm": {
    "name": "Samoan",
    "nativeName": "gagana faa Samoa"
  },
  "sg": {
    "name": "Sango",
    "nativeName": "yângâ tî sängö"
  },
  "sr": {
    "name": "Serbian",
    "nativeName": "српски језик"
  },
  "gd": {
    "name": "Scottish Gaelic; Gaelic",
    "nativeName": "Gàidhlig"
  },
  "sn": {
    "name": "Shona",
    "nativeName": "chiShona"
  },
  "si": {
    "name": "Sinhala, Sinhalese",
    "nativeName": "සිංහල"
  },
  "sk": {
    "name": "Slovak",
    "nativeName": "slovenčina"
  },
  "sl": {
    "name": "Slovene",
    "nativeName": "slovenščina"
  },
  "so": {
    "name": "Somali",
    "nativeName": "Soomaaliga, af Soomaali"
  },
  "st": {
    "name": "Southern Sotho",
    "nativeName": "Sesotho"
  },
  "es": {
    "name": "Spanish; Castilian",
    "nativeName": "español, castellano"
  },
  "su": {
    "name": "Sundanese",
    "nativeName": "Basa Sunda"
  },
  "sw": {
    "name": "Swahili",
    "nativeName": "Kiswahili"
  },
  "ss": {
    "name": "Swati",
    "nativeName": "SiSwati"
  },
  "sv": {
    "name": "Swedish",
    "nativeName": "svenska"
  },
  "ta": {
    "name": "Tamil",
    "nativeName": "தமிழ்"
  },
  "te": {
    "name": "Telugu",
    "nativeName": "తెలుగు"
  },
  "tg": {
    "name": "Tajik",
    "nativeName": "тоҷикӣ, toğikī, تاجیکی‎"
  },
  "th": {
    "name": "Thai",
    "nativeName": "ไทย"
  },
  "ti": {
    "name": "Tigrinya",
    "nativeName": "ትግርኛ"
  },
  "bo": {
    "name": "Tibetan Standard, Tibetan, Central",
    "nativeName": "བོད་ཡིག"
  },
  "tk": {
    "name": "Turkmen",
    "nativeName": "Türkmen, Түркмен"
  },
  "tl": {
    "name": "Tagalog",
    "nativeName": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
  },
  "tn": {
    "name": "Tswana",
    "nativeName": "Setswana"
  },
  "to": {
    "name": "Tonga (Tonga Islands)",
    "nativeName": "faka Tonga"
  },
  "tr": {
    "name": "Turkish",
    "nativeName": "Türkçe"
  },
  "ts": {
    "name": "Tsonga",
    "nativeName": "Xitsonga"
  },
  "tt": {
    "name": "Tatar",
    "nativeName": "татарча, tatarça, تاتارچا‎"
  },
  "tw": {
    "name": "Twi",
    "nativeName": "Twi"
  },
  "ty": {
    "name": "Tahitian",
    "nativeName": "Reo Tahiti"
  },
  "ug": {
    "name": "Uighur, Uyghur",
    "nativeName": "Uyƣurqə, ئۇيغۇرچە‎"
  },
  "uk": {
    "name": "Ukrainian",
    "nativeName": "українська"
  },
  "ur": {
    "name": "Urdu",
    "nativeName": "اردو"
  },
  "uz": {
    "name": "Uzbek",
    "nativeName": "zbek, Ўзбек, أۇزبېك‎"
  },
  "ve": {
    "name": "Venda",
    "nativeName": "Tshivenḓa"
  },
  "vi": {
    "name": "Vietnamese",
    "nativeName": "Tiếng Việt"
  },
  "vo": {
    "name": "Volapük",
    "nativeName": "Volapük"
  },
  "wa": {
    "name": "Walloon",
    "nativeName": "Walon"
  },
  "cy": {
    "name": "Welsh",
    "nativeName": "Cymraeg"
  },
  "wo": {
    "name": "Wolof",
    "nativeName": "Wollof"
  },
  "fy": {
    "name": "Western Frisian",
    "nativeName": "Frysk"
  },
  "xh": {
    "name": "Xhosa",
    "nativeName": "isiXhosa"
  },
  "yi": {
    "name": "Yiddish",
    "nativeName": "ייִדיש"
  },
  "yo": {
    "name": "Yoruba",
    "nativeName": "Yorùbá"
  },
  "za": {
    "name": "Zhuang, Chuang",
    "nativeName": "Saɯ cueŋƅ, Saw cuengh"
  }
};

var getLanguageName = function getLanguageName(key) {
  key = key.slice(0, 2);
  var lang = isoLangs[key];
  return lang ? lang.name : key;
};
var getLanguageNativeName = function getLanguageNativeName(key) {
  key = key.slice(0, 2);
  var lang = isoLangs[key];
  return lang ? lang.nativeName + " (" + key + ")" : key;
};

exports.getLanguageName = getLanguageName;
exports.getLanguageNativeName = getLanguageNativeName;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizeLife: [{
        key: 21,
        value: 'message.lifeCatBehaviourChange'
      }, {
        key: 10,
        value: 'message.lifeCatCarbsVsFat'
      }, {
        key: 6,
        value: 'message.lifeCatChildren'
      }, {
        key: 8,
        value: 'message.lifeCatConditions'
      }, {
        key: 23,
        value: 'message.lifeCatDairyFree'
      }, {
        key: 18,
        value: 'message.lifeCatEducation'
      }, {
        key: 20,
        value: 'message.lifeCatExercise'
      }, {
        key: 7,
        value: 'message.lifeCatFoodAndRecipes'
      }, {
        key: 3,
        value: 'message.lifeCatFoodSwaps'
      }, {
        key: 22,
        value: 'message.lifeCatFoodHCP'
      }, {
        key: 17,
        value: 'message.lifeCatIntermittentFasting'
      }, {
        key: 14,
        value: 'message.lifeCatMotivation'
      }, {
        key: 1,
        value: 'message.lifeCatMythBusting'
      }, {
        key: 16,
        value: 'message.lifeCatPHC'
      }, {
        key: 9,
        value: 'message.lifeCatRecipesOfTheWeek'
      }, {
        key: 12,
        value: 'message.lifeCatResearch'
      }, {
        key: 15,
        value: 'message.lifeCatSeasonalVeg'
      }, {
        key: 13,
        value: 'message.lifeCatSuccessStories'
      }, {
        key: 5,
        value: 'message.lifeCatSugar'
      }, {
        key: 19,
        value: 'message.lifeCatWereListeningTo'
      }, {
        key: 11,
        value: 'message.lifeCatWereWatching'
      }, {
        key: 24,
        value: 'Evidence and Papers'
      }]
    };
  },

  methods: {
    localizeLifeCat: function localizeLifeCat(key) {
      var self = this;
      var label = self.localizeLife.filter(function (item) {
        return item.key === key;
      });

      if (label.length === 1) {
        return self.$t(label[0].value);
      }
    }
  }
};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedFrequencies: [{
        key: 'Daily',
        value: 'message.frequencyOnceDaily'
      }, {
        key: 'Twice daily',
        value: 'message.frequencyTwiceDaily'
      }, {
        key: 'Three times daily',
        value: 'message.frequencyThreeDaily'
      }, {
        key: 'Weekly',
        value: 'message.frequencyWeekly'
      }, {
        key: 'Every 6 weeks',
        value: 'message.frequencyEverySixWeeks'
      }, {
        key: 'Four times daily',
        value: 'message.frequencyFourTimesDaily'
      }, {
        key: 'Every 3 months',
        value: 'message.frequencyEveryThreeMonths'
      }, {
        key: 'Five times daily',
        value: 'message.frequencyFiveTimesDaily'
      }, {
        key: 'Every Other Week',
        value: 'message.frequencyEveryOtherWeek'
      }, {
        key: 'Every 3 Weeks',
        value: 'message.frequencyEveryThreeWeeks'
      }, {
        key: 'Monthly',
        value: 'message.frequencyMonthly'
      }, {
        key: 'Every 8 Weeks',
        value: 'message.frequencyEveryEightWeeks'
      }, {
        key: 'Every 12 Weeks',
        value: 'message.frequencyEveryTwelveWeeks'
      }, {
        key: 'Every 6 months',
        value: 'message.frequencyEverySixMonths'
      }, {
        key: 'Every 8 months',
        value: 'message.frequencyEveryEightMonths'
      }, {
        key: 'Yearly',
        value: 'message.frequencyYearly'
      }, {
        key: 'One time',
        value: 'message.frequencyOneTime'
      }, {
        key: 'As needed',
        value: 'message.frequencyAsNeeded'
      }]
    };
  },

  methods: {
    localizeFrequency: function localizeFrequency(key) {

      var self = this;
      return self.localizedFrequencies.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedOccupations: [{
        key: "Full time employment",
        value: "message.occupationFullTime"
      }, {
        key: "Part time employment",
        value: "message.occupationPartTime "
      }, {
        key: "Retired",
        value: "message.occupationRetired"
      }, {
        key: "Self-employed",
        value: "message.occupationSelfEmployed"
      }, {
        key: "Student",
        value: "message.occupationStudent"
      }, {
        key: "Unemployed",
        value: "message.occupationUnemployed"
      }, {
        key: "Prefer not to say",
        value: "message.occupationPreferNotToSay"
      }]
    };
  },

  methods: {
    localizeOccupation: function localizeOccupation(key) {
      var self = this;
      var localizedOccupation = self.localizedOccupations.filter(function (item) {
        return item.key === key;
      });
      if (localizedOccupation.length > 0) {
        return self.$t(localizedOccupation[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      diabetesTypes: [{
        key: "Prediabetes",
        value: 'message.registerReasonPrediabetes'
      }, {
        key: "Type 2 diabetes",
        value: "message.registerReasonType2Diabetes"
      }, {
        key: "Type 1 diabetes",
        value: "message.registerReasonType1Diabetes"
      }, {
        key: 'Gestational diabetes',
        value: "message.registerReasonGestationalDiabetes"
      }, {
        key: "LADA",
        value: "message.registerReasonLADA"
      }, {
        key: "MODY",
        value: "message.registerReasonMODY"
      }, {
        key: "Diabetes insipidus",
        value: "message.registerReasonDiabetesInsipidus"
      }, {
        key: "General wellbeing",
        value: "message.registerReasonWellbeing\n"
      }, {
        key: "I am a carer",
        value: "message.registerReasonCarer"
      }, {
        key: "I am a DSN",
        value: "message.registerReasonDSN"
      }, {
        key: "I am a doctor",
        value: "message.registerReasonDoctor"
      }, {
        key: "I am a healthcare professional",
        value: "message.registerReasonHCP"
      }, {
        key: "Other",
        value: "message.registerReasonOther"
      }, {
        key: "Parent of child with Type 1 diabetes",
        value: "message.registerReasonParentOfType1"
      }, {
        key: "Parent of child with Type 2 diabetes",
        value: "message.registerReasonParentOfType2"
      }, {
        key: "Professional carer",
        value: "message.registerReasonProfessionalCarer"
      }, {
        key: "Obesity",
        value: "message.registerReasonDiagnosedObesity"
      }, {
        key: "Overweight",
        value: "message.registerReasonOverweight"
      }, {
        key: "I have another health condition",
        value: "message.registerReasonAnotherHealthCondition"
      }, {
        key: "NAFLD",
        value: "message.registerReasonNAFLD"
      }]
    };
  },

  methods: {
    localizeRegistrationReason: function localizeRegistrationReason(key) {
      var self = this;
      var localized = self.diabetesTypes.filter(function (item) {
        return item.key === key;
      });
      if (localized.length === 1) {
        return self.$t(localized[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    '$route': {
      handler: function handler() {
        var self = this;
        self.initMounted();
      },
      immediate: false
    }
  },
  data: function data() {
    return {
      scrollElement: null,
      items: [],
      initialLoad: true,
      isLoading: true,
      isFinished: false,
      params: {
        user_id: "",
        type: "",
        page: 1,
        page_size: 15
      }
    };
  },

  methods: {
    loadItems: function loadItems() {
      var self = this;
      self.isLoading = true;
      if (self.isFinished !== true) {
        _Profile2.default.getFollowers(self.params).then(function (response) {
          self.$nextTick(function () {
            var callback = response.data;
            if (!_lodash2.default.isEqual(self.items, callback)) {
              self.items.push.apply(self.items, callback);
            }
            self.initialLoad = false;
            self.isLoading = false;
            if (callback.length === 0) {
              self.isFinished = true;
            } else {
              self.params.page++;
            }
          }, 1);
        });
      }
    },
    initMounted: function initMounted() {
      var self = this;
      self.params.type = self.followType;
      var profileUrl = self.$route.params.profileUrl.split('.'),
          profileUserId = profileUrl.pop();

      if (self.profile) {
        self.params.user_id = self.profile.user_id;
      }

      self.loadItems();
    },
    onScroll: function onScroll() {
      var self = this;
      if (_ScrollManager2.default.isElementInViewport(document.getElementById('infiniteScrollDetector'))) {
        if (self.isFinished === true || self.isLoading === false) {
          self.loadItems();
        }
      }
    }
  },
  computed: {
    followType: function followType() {
      var self = this;
      return self.$route.name === 'ProfileFollowers' ? 'followers' : 'following';
    },
    hasItems: function hasItems() {
      var self = this;
      return self.items.length !== 0;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.scrollElement = document.getElementsByClassName('main-content')[0];
    self.scrollElement.addEventListener('scroll', self.onScroll);
    self.initMounted();
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    if (self.scrollElement !== null) {
      self.scrollElement.removeEventListener('scroll', self.onScroll);
    }
  }
};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    clearQueryParameters: function clearQueryParameters(obj) {
      for (var propName in obj) {
        if (obj.hasOwnProperty(propName)) {
          if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
            delete obj[propName];
          }
        }
      }
      return obj;
    }
  }
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HolidaysUtils = {
  getEaster: function getEaster(Y) {
    var C = Math.floor(Y / 100);
    var N = Y - 19 * Math.floor(Y / 19);
    var K = Math.floor((C - 17) / 25);
    var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor(I / 30);
    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
    var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    var L = I - J;
    var M = 3 + Math.floor((L + 40) / 44);
    var D = L + 28 - 31 * Math.floor(M / 4);
    return Y + '-' + this.padout(M) + '-' + this.padout(D);
  },
  padout: function padout(number) {
    return number < 10 ? '0' + number : number;
  }
};

exports.default = {
  computed: {
    isDiwali: function isDiwali() {
      var now = (0, _moment2.default)();
      var diwaliDates = ["2018-11-07", "2019-10-27", "2020-11-14", "2021-11-04", "2022-10-24", "2023-11-09", "2024-11-01", "2025-10-21"];
      var isDiwali = false;
      for (var i = 0; i < diwaliDates.length; i++) {
        isDiwali = (0, _moment2.default)(diwaliDates[i], 'YYYY-MM-DD').isSame(now);
        i++;
      }
      return isDiwali;
    },
    isChristmas: function isChristmas() {
      var curYear = (0, _moment2.default)().format('YYYY');
      var now = (0, _moment2.default)();
      var beforeTime = (0, _moment2.default)(curYear + '-12-10', 'YYYY-MM-DD');
      var afterTime = (0, _moment2.default)(curYear + '-12-28', 'YYYY-MM-DD');
      return now.isBetween(beforeTime, afterTime);
    },
    isThanksGiving: function isThanksGiving() {
      var now = (0, _moment2.default)();
      var curYear = (0, _moment2.default)().format('YYYY');
      return (0, _moment2.default)(curYear + '-11-22', 'YYYY-MM-DD').isSame(now);
    },
    isHalloween: function isHalloween() {
      var now = (0, _moment2.default)();
      var curYear = (0, _moment2.default)().format('YYYY');
      return (0, _moment2.default)(curYear + '-10-31', 'YYYY-MM-DD').isSame(now);
    },
    isEaster: function isEaster() {
      var curYear = (0, _moment2.default)().format('YYYY');
      var now = (0, _moment2.default)();
      var easterDate = (0, _moment2.default)(HolidaysUtils.getEaster(curYear), 'YYYY-MM-DD');
      return now.isSame(easterDate, 'day');
    },
    isBreakfast: function isBreakfast() {
      var format = 'hh:mm:ss';
      var time = (0, _moment2.default)(),
          beforeTime = (0, _moment2.default)('05:00:00', format),
          afterTime = (0, _moment2.default)('10:29:59', format);
      return time.isBetween(beforeTime, afterTime);
    },
    isLunch: function isLunch() {
      var format = 'hh:mm:ss';
      var time = (0, _moment2.default)(),
          beforeTime = (0, _moment2.default)('10:30:00', format),
          afterTime = (0, _moment2.default)('16:59:59', format);
      return time.isBetween(beforeTime, afterTime);
    },
    isDinner: function isDinner() {
      var format = 'hh:mm:ss';
      var time = (0, _moment2.default)(),
          beforeTime = (0, _moment2.default)('17:00:00', format),
          afterTime = (0, _moment2.default)('23:59:59', format);
      return time.isBetween(beforeTime, afterTime);
    },
    isNight: function isNight() {
      var format = 'hh:mm:ss';
      var time = (0, _moment2.default)(),
          beforeTime = (0, _moment2.default)('00:00:00', format),
          afterTime = (0, _moment2.default)('04:59:59', format);
      return time.isBetween(beforeTime, afterTime);
    }
  }
};

/***/ }),
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2680)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1346),
  /* template */
  __webpack_require__(3716),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2668)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1359),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2804)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1366),
  /* template */
  __webpack_require__(3776),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2674)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1369),
  /* template */
  __webpack_require__(3707),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2644)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1370),
  /* template */
  __webpack_require__(3664),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2735)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1371),
  /* template */
  __webpack_require__(3816),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2594)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1386),
  /* template */
  __webpack_require__(3577),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01721ead",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2689)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1388),
  /* template */
  __webpack_require__(3733),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2802)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1402),
  /* template */
  __webpack_require__(3769),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2639)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1407),
  /* template */
  __webpack_require__(3654),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2729)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1418),
  /* template */
  __webpack_require__(3804),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1420),
  /* template */
  __webpack_require__(3798),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2697)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1423),
  /* template */
  __webpack_require__(3750),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6278a57a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2718)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1424),
  /* template */
  __webpack_require__(3789),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76cca36a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2690)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1427),
  /* template */
  __webpack_require__(3734),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55d3e8a3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2715)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1428),
  /* template */
  __webpack_require__(3785),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2789)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1430),
  /* template */
  __webpack_require__(3687),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2827)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1431),
  /* template */
  __webpack_require__(3859),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1438),
  /* template */
  __webpack_require__(3876),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2665)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1441),
  /* template */
  __webpack_require__(3697),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2723)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1444),
  /* template */
  __webpack_require__(3796),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a264865",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1445),
  /* template */
  __webpack_require__(3741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2666)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1451),
  /* template */
  __webpack_require__(3698),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2611)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1452),
  /* template */
  __webpack_require__(3601),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1459),
  /* template */
  __webpack_require__(3641),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2826)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1460),
  /* template */
  __webpack_require__(3857),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2636)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1461),
  /* template */
  __webpack_require__(3648),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1463),
  /* template */
  __webpack_require__(3751),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1470),
  /* template */
  __webpack_require__(3826),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2642)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1475),
  /* template */
  __webpack_require__(3660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e5bac6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2649)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1478),
  /* template */
  __webpack_require__(3674),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-369500c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2626)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1479),
  /* template */
  __webpack_require__(3629),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20587bb5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2722)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1481),
  /* template */
  __webpack_require__(3795),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7949ddde",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2711)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1482),
  /* template */
  __webpack_require__(3777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-731e40e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2613)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1483),
  /* template */
  __webpack_require__(3604),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-114255a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2623)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1484),
  /* template */
  __webpack_require__(3625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dfa7c56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2629)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1497),
  /* template */
  __webpack_require__(3636),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2701)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1498),
  /* template */
  __webpack_require__(3761),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2646)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1503),
  /* template */
  __webpack_require__(3666),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1516),
  /* template */
  __webpack_require__(3670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1588),
  /* template */
  __webpack_require__(3870),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2773)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1589),
  /* template */
  __webpack_require__(3612),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2743)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1602),
  /* template */
  __webpack_require__(3832),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2654)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1605),
  /* template */
  __webpack_require__(3679),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _regenerator = __webpack_require__(278);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(277);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(234);

var _promise2 = _interopRequireDefault(_promise);

__webpack_require__(684);

__webpack_require__(2572);

__webpack_require__(2570);

__webpack_require__(2562);

__webpack_require__(2568);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _sanitizeHtml = __webpack_require__(3327);

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _momentDurationFormat = __webpack_require__(3018);

var _momentDurationFormat2 = _interopRequireDefault(_momentDurationFormat);

var _fr = __webpack_require__(637);

var _fr2 = _interopRequireDefault(_fr);

var _frCa = __webpack_require__(433);

var _frCa2 = _interopRequireDefault(_frCa);

var _enGb = __webpack_require__(432);

var _enGb2 = _interopRequireDefault(_enGb);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _vueI18n = __webpack_require__(3362);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _index = __webpack_require__(1666);

var _index2 = _interopRequireDefault(_index);

var _vue = __webpack_require__(146);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(3388);

var _App2 = _interopRequireDefault(_App);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _alert = __webpack_require__(1674);

var _alert2 = _interopRequireDefault(_alert);

var _toastr = __webpack_require__(1675);

var _toastr2 = _interopRequireDefault(_toastr);

var _idleVue = __webpack_require__(2846);

var _idleVue2 = _interopRequireDefault(_idleVue);

var _BootLoader = __webpack_require__(1240);

var _BootLoader2 = _interopRequireDefault(_BootLoader);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _LessonInlineGrid = __webpack_require__(3391);

var _LessonInlineGrid2 = _interopRequireDefault(_LessonInlineGrid);

var _BloodGlucose = __webpack_require__(455);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _Weight = __webpack_require__(673);

var _Weight2 = _interopRequireDefault(_Weight);

var _BloodPressure = __webpack_require__(669);

var _BloodPressure2 = _interopRequireDefault(_BloodPressure);

var _Sleep = __webpack_require__(344);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _Insulin = __webpack_require__(670);

var _Insulin2 = _interopRequireDefault(_Insulin);

var _Ketones = __webpack_require__(3448);

var _Ketones2 = _interopRequireDefault(_Ketones);

var _Cholesterol = __webpack_require__(1269);

var _Cholesterol2 = _interopRequireDefault(_Cholesterol);

var _Nutrition = __webpack_require__(1271);

var _Nutrition2 = _interopRequireDefault(_Nutrition);

var _Medication = __webpack_require__(671);

var _Medication2 = _interopRequireDefault(_Medication);

var _Activity = __webpack_require__(454);

var _Activity2 = _interopRequireDefault(_Activity);

var _Mood = __webpack_require__(672);

var _Mood2 = _interopRequireDefault(_Mood);

var _LineGraph = __webpack_require__(343);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _LineGraph3 = __webpack_require__(453);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _LineGraph5 = __webpack_require__(1264);

var _LineGraph6 = _interopRequireDefault(_LineGraph5);

var _LineGraph7 = __webpack_require__(1263);

var _LineGraph8 = _interopRequireDefault(_LineGraph7);

var _LineGraph9 = __webpack_require__(1265);

var _LineGraph10 = _interopRequireDefault(_LineGraph9);

var _LineGraph11 = __webpack_require__(1266);

var _LineGraph12 = _interopRequireDefault(_LineGraph11);

var _LineGraph13 = __webpack_require__(1267);

var _LineGraph14 = _interopRequireDefault(_LineGraph13);

var _LineGraph15 = __webpack_require__(1268);

var _LineGraph16 = _interopRequireDefault(_LineGraph15);

var _LineGraph17 = __webpack_require__(452);

var _LineGraph18 = _interopRequireDefault(_LineGraph17);

var _ProfileHeader = __webpack_require__(1253);

var _ProfileHeader2 = _interopRequireDefault(_ProfileHeader);

var _ProfileAvatar = __webpack_require__(3425);

var _ProfileAvatar2 = _interopRequireDefault(_ProfileAvatar);

var _QuestionsPanel = __webpack_require__(663);

var _QuestionsPanel2 = _interopRequireDefault(_QuestionsPanel);

var _DownloadsPanel = __webpack_require__(1244);

var _DownloadsPanel2 = _interopRequireDefault(_DownloadsPanel);

var _QuizPanel = __webpack_require__(1245);

var _QuizPanel2 = _interopRequireDefault(_QuizPanel);

var _RatingPanel = __webpack_require__(1246);

var _RatingPanel2 = _interopRequireDefault(_RatingPanel);

var _AudioPlayer = __webpack_require__(1239);

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _IframeVideoPlayer = __webpack_require__(341);

var _IframeVideoPlayer2 = _interopRequireDefault(_IframeVideoPlayer);

var _UserAvatar = __webpack_require__(675);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _Notifications = __webpack_require__(1250);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _CreateQuestion = __webpack_require__(450);

var _CreateQuestion2 = _interopRequireDefault(_CreateQuestion);

var _TopContributors = __webpack_require__(1256);

var _TopContributors2 = _interopRequireDefault(_TopContributors);

var _FrequentlyAsked = __webpack_require__(3429);

var _FrequentlyAsked2 = _interopRequireDefault(_FrequentlyAsked);

var _pie = __webpack_require__(1652);

var _pie2 = _interopRequireDefault(_pie);

var _empty = __webpack_require__(1653);

var _empty2 = _interopRequireDefault(_empty);

var _MealList = __webpack_require__(1242);

var _MealList2 = _interopRequireDefault(_MealList);

var _LifeCategoryList = __webpack_require__(3415);

var _LifeCategoryList2 = _interopRequireDefault(_LifeCategoryList);

var _Height = __webpack_require__(1258);

var _Height2 = _interopRequireDefault(_Height);

var _UploadAvatar = __webpack_require__(674);

var _UploadAvatar2 = _interopRequireDefault(_UploadAvatar);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _Report = __webpack_require__(229);

var _Report2 = _interopRequireDefault(_Report);

var _ListReports = __webpack_require__(3433);

var _ListReports2 = _interopRequireDefault(_ListReports);

var _SearchQuestions = __webpack_require__(1255);

var _SearchQuestions2 = _interopRequireDefault(_SearchQuestions);

var _ImageUploader = __webpack_require__(1243);

var _ImageUploader2 = _interopRequireDefault(_ImageUploader);

var _vueMaterial = __webpack_require__(3878);

var _vueMaterial2 = _interopRequireDefault(_vueMaterial);

var _vueMarkdown = __webpack_require__(3877);

var _vueMarkdown2 = _interopRequireDefault(_vueMarkdown);

var _vueSocialSharing = __webpack_require__(3881);

var _vueSocialSharing2 = _interopRequireDefault(_vueSocialSharing);

var _veeValidate = __webpack_require__(3355);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _router = __webpack_require__(1676);

var _router2 = _interopRequireDefault(_router);

var _museUi = __webpack_require__(3023);

var _museUi2 = _interopRequireDefault(_museUi);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _vueBase64FileUpload = __webpack_require__(337);

var _vueBase64FileUpload2 = _interopRequireDefault(_vueBase64FileUpload);

var _vueCountTo = __webpack_require__(3360);

var _vueCountTo2 = _interopRequireDefault(_vueCountTo);

var _vueAnalytics = __webpack_require__(3356);

var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);

var _store = __webpack_require__(487);

var _store2 = _interopRequireDefault(_store);

var _vTooltip = __webpack_require__(3352);

var _vTooltip2 = _interopRequireDefault(_vTooltip);

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _fontawesomeSvgCore = __webpack_require__(465);

var _freeSolidSvgIcons = __webpack_require__(1310);

var _vueFontawesome = __webpack_require__(1311);

var _vueGtag = __webpack_require__(3361);

var _vueGtag2 = _interopRequireDefault(_vueGtag);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _jstimezonedetect = __webpack_require__(615);

var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _momentDurationFormat2.default)(_moment2.default);

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faInfoCircle, _freeSolidSvgIcons.faChevronDown, _freeSolidSvgIcons.faThumbsUp, _freeSolidSvgIcons.faPencilAlt, _freeSolidSvgIcons.faTrash, _freeSolidSvgIcons.faExclamationTriangle);
_vue2.default.component('font-awesome-icon', _vueFontawesome.FontAwesomeIcon);

_vue2.default.use(_vueAnalytics2.default, {
  id: _config2.default.GoogleCode
});

_vue2.default.use(_vueGtag2.default, {
  config: { id: _config2.default.GoogleCode }
}, _router2.default);

_vue2.default.use(_vTooltip2.default);
_vue2.default.use(_museUi2.default);

_veeValidate.Validator.localize(_config2.default.validationDictionary);

var customValidationDictionary = {
  en: {
    messages: {
      strong_password_regex: function strong_password_regex(field) {
        return "";
      }
    }
  },
  fr: {
    messages: {
      strong_password_regex: function strong_password_regex(field) {
        return field + " doit contenir 10 caract\xE8res, 1 caract\xE8re majuscule, 1 caract\xE8re minuscule et 1 caract\xE8re sp\xE9cial";
      }
    }
  }
};

_veeValidate.Validator.extend('strong_password_regex', {
  getMessage: function getMessage() {
    return 'The Password field must contain 1 upper case character, 1 lower case character and at least 1 special character';
  },
  validate: function validate(value) {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\W])(?=.{8,})");
    return strongRegex.test(value);
  }
});

_veeValidate.Validator.extend('display_name_regex', {
  getMessage: function getMessage() {
    return 'The username field may only include upper case characters, lower case characters, numbers and one underscore or dash. Your username cannot start with an underscore or dash.';
  },
  validate: function validate(value) {
    var strongRegex = new RegExp("^([a-zA-Z0-9][-_]{0,1})*$");
    var pass = strongRegex.test(value);
    if (!pass) {
      return pass;
    }
    return (value.match(/-/g) === null || value.match(/-/g).length < 2) && (value.match(/_/g) === null || value.match(/_/g).length < 2);
  }
});

_veeValidate.Validator.localize(customValidationDictionary);

_vue2.default.use(_veeValidate2.default, {
  locale: _config2.default.language,
  dictionary: {
    en: _config2.default.validationDictionary.EnglishMessages,
    fr: _config2.default.validationDictionary.FrenchMessages
  }
});

_moment2.default.locale(_config2.default.locale, _enGb2.default);

_vue2.default.use(_vueMaterial2.default);
_vue2.default.use(_vueSocialSharing2.default);
_vue2.default.use(_alert2.default);
_vue2.default.use(_toastr2.default);

_vue2.default.directive('date-picker', _DateTimePicker2.default);

_vue2.default.component('vue-markdown', _vueMarkdown2.default);

_vue2.default.component('boot-loader', _BootLoader2.default);
_vue2.default.component('user-avatar', _UserAvatar2.default);
_vue2.default.component('update-height', _Height2.default);
_vue2.default.component('upload-avatar', _UploadAvatar2.default);
_vue2.default.component('vue-base64-file-upload', _vueBase64FileUpload2.default);
_vue2.default.component('count-to', _vueCountTo2.default);

_vue2.default.component('blood-glucose-input', _BloodGlucose2.default);
_vue2.default.component('weight-input', _Weight2.default);
_vue2.default.component('blood-pressure-input', _BloodPressure2.default);
_vue2.default.component('sleep-input', _Sleep2.default);
_vue2.default.component('insulin-input', _Insulin2.default);
_vue2.default.component('ketones-input', _Ketones2.default);
_vue2.default.component('cholesterol-input', _Cholesterol2.default);
_vue2.default.component('nutrition-input', _Nutrition2.default);
_vue2.default.component('medication-input', _Medication2.default);
_vue2.default.component('activity-input', _Activity2.default);
_vue2.default.component('mood-input', _Mood2.default);

_vue2.default.component('bg-line-graph', _LineGraph2.default);
_vue2.default.component('weight-line-graph', _LineGraph4.default);
_vue2.default.component('cholesterol-line-graph', _LineGraph6.default);
_vue2.default.component('bp-line-graph', _LineGraph8.default);
_vue2.default.component('insulin-line-graph', _LineGraph10.default);
_vue2.default.component('ketones-line-graph', _LineGraph12.default);
_vue2.default.component('medication-line-graph', _LineGraph14.default);
_vue2.default.component('mood-line-graph', _LineGraph16.default);
_vue2.default.component('sleep-line-graph', _LineGraph18.default);

_vue2.default.component('image-uploader', _ImageUploader2.default);

_vue2.default.component('profile-header', _ProfileHeader2.default);
_vue2.default.component('profile-avatar', _ProfileAvatar2.default);

_vue2.default.component('lesson-inline-grid', _LessonInlineGrid2.default);
_vue2.default.component('lesson-questions-panel', _QuestionsPanel2.default);
_vue2.default.component('lesson-downloads-panel', _DownloadsPanel2.default);
_vue2.default.component('lesson-quiz-panel', _QuizPanel2.default);
_vue2.default.component('lesson-rating-panel', _RatingPanel2.default);
_vue2.default.component('audio-player', _AudioPlayer2.default);
_vue2.default.component('iframe-video-player', _IframeVideoPlayer2.default);

_vue2.default.component('create-question', _CreateQuestion2.default);
_vue2.default.component('top-contributors', _TopContributors2.default);
_vue2.default.component('frequently-asked', _FrequentlyAsked2.default);
_vue2.default.component('questions-search', _SearchQuestions2.default);

_vue2.default.component('food-pie-empty', _empty2.default);
_vue2.default.component('food-pie', _pie2.default);
_vue2.default.component('food-meal-list', _MealList2.default);

_vue2.default.component('notifications-panel', _Notifications2.default);

_vue2.default.component('life-category-list', _LifeCategoryList2.default);

_vue2.default.component('report', _Report2.default);
_vue2.default.component('list-reports', _ListReports2.default);
_vue2.default.component('user-badge', _UserBadge2.default);

var host = window.location.hostname;
if (host === 'www.lowcarbprogram.com') {
  _vue2.default.config.productionTip = false;
  _vue2.default.config.devtools = false;
  _vue2.default.config.silent = true;
} else {
  _vue2.default.config.productionTip = true;
  _vue2.default.config.devtools = true;
  _vue2.default.config.silent = true;
}

_vue2.default.material.registerTheme('default', {
  primary: 'light-blue',
  accent: 'grey',
  warn: 'grey',
  background: 'white'
});

_vue2.default.use(_vueI18n2.default);

var i18n = new _vueI18n2.default({
  locale: _config2.default.language,
  messages: _index2.default
});

_store2.default.commit('setI18n', i18n);

var supportedLocales = [{
  name: "en_gb",
  time: 'en'
}, {
  name: "fr_ca",
  time: 'fr'
}, {
  name: "en_ca",
  time: "en"
}];

var locale = _config2.default.locale.toLowerCase();
var localeFormat = locale.replace('-', '_');
var isSupportedLocale = supportedLocales.filter(function (item) {
  return item.name === localeFormat;
});

if (isSupportedLocale.length === 1) {

  var localeName = isSupportedLocale[0].name;

  if (localeName === "fr") {
    _moment2.default.locale("fr");
  }

  if (localeName === "fr_ca") {
    _moment2.default.locale("fr");
  }

  if (localeName === 'en_ca') {
    _moment2.default.locale("en");
  }

  if (localeName === 'en_gb') {
    _moment2.default.locale("en");
  }
  _store2.default.commit('setLang', isSupportedLocale[0].name);
} else {
  _store2.default.commit('setLang', 'en_gb');
  _moment2.default.locale(isSupportedLocale[0].time, _enGb2.default);
}

_axios2.default.defaults.headers.common["Cache-Control"] = "no-cache";
_axios2.default.defaults.headers.common["Expires"] = "-1";
_axios2.default.defaults.headers.common["Pragma"] = "no-cache";

var tokenObject = JSON.parse(window.localStorage.getItem('token'));
if (_.has(tokenObject, 'refreshToken')) {
  _axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + tokenObject.accessToken;
}

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var originalRequest = error.config;
  if (_router2.default.currentRoute.name === 'PasswordReset') {
    return;
  }

  if (error.response === undefined) {
    return _promise2.default.reject(error);
  }

  if (error.response.status === 401 && originalRequest.url.indexOf('token/refresh') !== -1) {
    _router2.default.push('/login');
    return _promise2.default.reject(error);
  }

  if (originalRequest.url.indexOf(_config2.default.apiUrl) === -1) {
    return _promise2.default.reject(error);
  }

  if (error.response.status === 401 && !originalRequest._retry && originalRequest.url.indexOf('login/v2') === -1) {
    originalRequest._retry = true;
    var token = _AuthenticationManager2.default.getToken();
    return _AuthenticationManager2.default.refreshAccessToken(token).then(function () {
      var newToken = _AuthenticationManager2.default.getToken();

      if (_.has(newToken, 'accessToken')) {
        error.config.headers['Authorization'] = 'Bearer ' + newToken.accessToken;
      }

      return (0, _axios2.default)(originalRequest);
    });
  }
  return _promise2.default.reject(error);
});

_router2.default.afterEach(function (to, from, next) {
  document.title = i18n.t(to.meta.i18n) + ' - ' + _config2.default.Application;
  to.meta.title = i18n.t(to.meta.i18n);
  _TitleManager2.default.setTitle('');
});

_router2.default.beforeEach(function (to, from, next) {
  (0, _jquery2.default)('.main-content').attr('style', '') && (0, _jquery2.default)(window).unbind('resize') && (0, _jquery2.default)('#' + to.meta.id).unbind('scroll');
  _EventBus2.default.$emit('App::dockerResizerStart');

  if (_Discussion2.default.CancelRequests !== null) {
    _Discussion2.default.CancelRequests();
  }

  if (to.meta.requireAuth) {
    if (_AuthenticationManager2.default.hasToken()) {
      var doExpiryCheck = function doExpiryCheck(next) {
        var parsedJwt = _AuthenticationManager2.default.parseJwt();
        var exp = parsedJwt.exp;

        var expiry = _moment2.default.unix(exp);

        if (false) {
          console.info('TokenWillRefreshInSeconds', expiry.diff((0, _moment2.default)(), 'seconds'));
        }

        if (expiry.diff((0, _moment2.default)(), 'seconds') > 0) {
          next();
        } else {
          doExpiryCheck(next);
        }
      };

      setToken().then(function () {
        doExpiryCheck(next);
      }).catch(function (error) {
        next({ path: '/login', query: { redirect: to.fullPath } });
      });
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

var setToken = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    var tokenObject, parsedJwt, exp, expiry;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokenObject = _AuthenticationManager2.default.getToken();
            parsedJwt = _AuthenticationManager2.default.parseJwt();
            exp = parsedJwt.exp;
            expiry = _moment2.default.unix(exp);

            if (!(expiry.diff((0, _moment2.default)(), 'seconds') <= 0)) {
              _context.next = 9;
              break;
            }

            _context.next = 7;
            return _AuthenticationManager2.default.refreshAccessToken(tokenObject);

          case 7:
            _context.next = 11;
            break;

          case 9:
            _context.next = 11;
            return _AuthenticationManager2.default.setToken(tokenObject);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function setToken() {
    return _ref.apply(this, arguments);
  };
}();

var eventBus = new _vue2.default();

_vue2.default.prototype.$EventBus = eventBus;
_vue2.default.prototype.$sanitize = _sanitizeHtml2.default;

new _vue2.default({
  el: '#app',
  i18n: i18n,
  store: _store2.default,
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(3884)
var prodEnv = __webpack_require__(687)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
const path = __webpack_require__(3025);
const langConfig = __webpack_require__(686)
const locale = langConfig.locale;
const subDir = "";
const appContextConfig = __webpack_require__(685);
const appOnly = appContextConfig.apponly;

const folderName = appOnly == "true" ? "/release/app/" :  "/release/" + locale + '/';





module.exports = {
  build: {
    env: __webpack_require__(687),
    index: path.resolve(__dirname, "../" + folderName + "index.html"),
    assetsRoot: path.resolve(__dirname, "../" +  folderName),
    assetsSubDirectory: 'static',
    assetsPublicPath: appOnly == "true" ? "/app/" : subDir + "/" +  locale + "/",
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: true,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(1303),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 1305 */
/***/ (function(module, exports) {


/**
 * appcontext
    lowcarbprogram
    grohealth
 * runmode
    production
    staging
 * lang
    en-CA
    en-GB
    fr-CA
 * @type {{string}}
 */

module.exports = {
  appcontext: "lowcarbprogram",
  runmode: "production",
  locale:"en-GB"
};


/***/ }),
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */
/***/ (function(module, exports) {

module.exports = {"name":"@vue-stripe/vue-stripe","version":"4.4.2","description":"Stripe Checkout & Elements for Vue.js","author":"jofftiquez@gmail.com","scripts":{"build":"rollup -c","lint":"vue-cli-service lint --fix","prebuild":"rimraf dist","test":"jest"},"main":"dist/index.js","module":"dist","dependencies":{"@stripe/stripe-js":"^1.13.2","vue-coerce-props":"^1.0.0"},"devDependencies":{"@babel/cli":"^7.7.5","@babel/core":"^7.7.5","@babel/plugin-proposal-export-default-from":"^7.7.4","@babel/plugin-proposal-optional-chaining":"^7.10.4","@babel/plugin-transform-runtime":"^7.7.5","@babel/preset-env":"^7.7.5","@babel/preset-es2015":"^7.0.0-beta.53","@babel/runtime":"^7.7.5","@rollup/plugin-node-resolve":"^6.0.0","@vue/cli-plugin-eslint":"~4.5.0","@vue/cli-service":"^4.5.10","@vue/eslint-config-standard":"^5.1.2","babel-eslint":"^10.1.0","babel-minify":"^0.5.1","cross-env":"^6.0.3","eslint":"^6.8.0","eslint-plugin-import":"^2.20.2","eslint-plugin-node":"^11.1.0","eslint-plugin-promise":"^4.2.1","eslint-plugin-standard":"^4.0.0","eslint-plugin-vue":"^6.2.2","jest":"^24.9.0","lint-staged":"^9.5.0","rimraf":"^3.0.0","rollup":"^1.27.9","rollup-plugin-babel":"^4.3.3","rollup-plugin-commonjs":"^10.1.0","rollup-plugin-postcss":"^2.0.3","rollup-plugin-terser":"^5.1.3","rollup-plugin-uglify":"^6.0.3","rollup-plugin-vue":"^5.1.4","vue-template-compiler":"^2.6.11"},"bugs":{"url":"https://github.com/vue-stripe/vue-stripe/issues"},"gitHooks":{"pre-commit":"lint-staged"},"homepage":"https://github.com/vue-stripe/vue-stripe#readme","keywords":["vue","vuejs","stripe","checkout","payment"],"license":"MIT","lint-staged":{"*.{js,jsx,vue}":["vue-cli-service lint","git add"]},"repository":{"type":"git","url":"git@github.com:vue-stripe/vue-stripe.git"},"typings":"typings/index.d.ts","_resolved":"https://registry.npmjs.org/@vue-stripe/vue-stripe/-/vue-stripe-4.4.2.tgz","_integrity":"sha512-+XaquPv9kwbV75dCKTM72kYTujwDIZItRmteaFtDYE/JvmqpVfLhjdcYTi3ZCxVe+i4dx02h453dj9cKfo+jiw==","_from":"@vue-stripe/vue-stripe@4.4.2"}

/***/ }),
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

var _utils = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-avatar',
  props: {
    backgroundColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconClass: {
      type: [String, Object, Array]
    },
    src: {
      type: String,
      default: ''
    },
    imgClass: {
      type: [String, Object, Array]
    },
    size: {
      type: Number
    },
    iconSize: {
      type: Number
    }
  },
  computed: {
    avatarStyle: function avatarStyle() {
      return {
        width: this.size ? this.size + 'px' : '',
        height: this.size ? this.size + 'px' : '',
        color: (0, _utils.getColor)(this.color),
        'background-color': (0, _utils.getColor)(this.backgroundColor)
      };
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('click');
    }
  },
  created: function created() {
    this._isAvatar = true;
  },

  components: {
    icon: _icon2.default
  }
};

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  name: 'mu-badge',
  props: {
    content: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    badgeClass: {
      type: [String, Object, Array]
    }
  },
  computed: {
    badgeStyle: function badgeStyle() {
      return {
        'background-color': (0, _utils.getColor)(this.color)
      };
    },
    badgeInternalClass: function badgeInternalClass() {
      var circle = this.circle,
          primary = this.primary,
          secondary = this.secondary,
          badgeClass = this.badgeClass;

      var isFloat = this.$slots && this.$slots.default && this.$slots.default.length > 0;
      var classNames = [];
      if (circle) classNames.push('mu-badge-circle');
      if (primary) classNames.push('mu-badge-primary');
      if (secondary) classNames.push('mu-badge-secondary');
      if (isFloat) classNames.push('mu-badge-float');
      return classNames.concat((0, _utils.convertClass)(badgeClass));
    }
  }
};

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-breadcrumb',
  props: {
    separator: {
      type: String,
      default: '/'
    }
  },
  methods: {
    updateChildren: function updateChildren() {
      var _this = this;

      this.$children.forEach(function (item) {
        item.separator = _this.separator;
      });
    }
  },
  mounted: function mounted() {
    this.updateChildren();
  },
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.updateChildren();
    });
  },

  watch: {
    separator: function separator() {
      this.updateChildren();
    }
  }
};

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-card-actions'
};

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-card-header',
  props: {
    title: {
      type: String
    },
    titleClass: {
      type: [String, Array, Object]
    },
    subTitle: {
      type: String
    },
    subTitleClass: {
      type: [String, Array, Object]
    }
  }
};

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-card-text'
};

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

var _touchRipple = __webpack_require__(1235);

var _touchRipple2 = _interopRequireDefault(_touchRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-checkbox',
  props: {
    name: {
      type: String
    },
    value: {},
    nativeValue: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    labelLeft: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: [String, Object, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    uncheckIcon: {
      type: String,
      default: ''
    },
    checkedIcon: {
      type: String,
      default: ''
    },
    iconClass: {
      type: [String, Object, Array]
    }
  },
  data: function data() {
    return {
      inputValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      this.inputValue = val;
    },
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    handleClick: function handleClick() {},
    handleMouseDown: function handleMouseDown(event) {
      if (this.disabled) return;
      if (event.button === 0) {
        this.$children[0].start(event);
      }
    },
    handleMouseUp: function handleMouseUp() {
      if (this.disabled) return;
      this.$children[0].end();
    },
    handleMouseLeave: function handleMouseLeave() {
      if (this.disabled) return;
      this.$children[0].end();
    },
    handleTouchStart: function handleTouchStart(event) {
      if (this.disabled) return;
      this.$children[0].start(event);
    },
    handleTouchEnd: function handleTouchEnd() {
      if (this.disabled) return;
      this.$children[0].end();
    },
    handleChange: function handleChange() {
      this.$emit('change', this.inputValue);
    }
  },
  components: {
    icon: _icon2.default,
    'touch-ripple': _touchRipple2.default
  }
};

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  name: 'mu-chip',
  props: {
    showDelete: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    deleteIconClass: {
      type: [Array, String, Object]
    },
    backgroundColor: {
      type: String
    },
    color: {
      type: String
    }
  },
  data: function data() {
    return {
      focus: false,
      hover: false
    };
  },

  computed: {
    classNames: function classNames() {
      if (this.disabled) return null;
      return this.focus ? ['hover', 'active'] : this.hover ? ['hover'] : null;
    },
    style: function style() {
      return {
        'background-color': (0, _utils.getColor)(this.backgroundColor),
        'color': (0, _utils.getColor)(this.color)
      };
    }
  },
  methods: {
    onMouseenter: function onMouseenter() {
      if ((0, _utils.isPc)()) this.hover = true;
    },
    onMouseleave: function onMouseleave() {
      if ((0, _utils.isPc)()) this.hover = false;
    },
    onMousedown: function onMousedown() {
      this.focus = true;
    },
    onMouseup: function onMouseup() {
      this.focus = false;
    },
    onTouchstart: function onTouchstart() {
      this.focus = true;
    },
    onTouchend: function onTouchend() {
      this.focus = false;
    },
    handleDelete: function handleDelete() {
      this.$emit('delete');
    },
    handleClick: function handleClick(e) {
      if (!this.disabled) this.$emit('click', e);
    }
  }
};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _circular = __webpack_require__(3374);

var _circular2 = _interopRequireDefault(_circular);

var _utils = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-circular-progress',
  props: {
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'indeterminate',
      validator: function validator(val) {
        return ['indeterminate', 'determinate'].indexOf(val) !== -1;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    color: {
      type: String
    },
    size: {
      type: Number,
      default: 24
    },
    strokeWidth: {
      type: Number,
      default: 3
    }
  },
  computed: {
    radius: function radius() {
      return (this.size - this.strokeWidth) / 2;
    },
    circularSvgStyle: function circularSvgStyle() {
      return {
        width: this.size,
        height: this.size
      };
    },
    circularPathStyle: function circularPathStyle() {
      var relVal = this.getRelativeValue();
      return {
        stroke: (0, _utils.getColor)(this.color),
        'stroke-dasharray': this.getArcLength(relVal) + ', ' + this.getArcLength(1)
      };
    }
  },
  methods: {
    getArcLength: function getArcLength(fraction) {
      return fraction * Math.PI * (this.size - this.strokeWidth);
    },
    getRelativeValue: function getRelativeValue() {
      var value = this.value,
          min = this.min,
          max = this.max;

      var clampedValue = Math.min(Math.max(min, value), max);
      return clampedValue / (max - min);
    }
  },
  components: {
    circular: _circular2.default
  }
};

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-content-block'
};

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-divider',
  props: {
    inset: {
      type: Boolean,
      default: false
    },
    shallowInset: {
      type: Boolean,
      default: false
    }
  }
};

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popover = __webpack_require__(707);

var _popover2 = _interopRequireDefault(_popover);

var _menu = __webpack_require__(1338);

var _utils = __webpack_require__(44);

var _resize = __webpack_require__(706);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-dropDown-menu',
  mixins: [_resize2.default],
  props: {
    value: {},
    maxHeight: {
      type: Number
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: [String, Array, Object]
    },
    menuClass: {
      type: [String, Array, Object]
    },
    menuListClass: {
      type: [String, Array, Object]
    },
    underlineClass: {
      type: [String, Array, Object]
    },
    iconClass: {
      type: [String, Array, Object]
    },
    openImmediately: {
      type: Boolean,
      default: false
    },
    anchorOrigin: {
      type: Object,
      default: function _default() {
        return {
          vertical: 'top',
          horizontal: 'left'
        };
      }
    },
    anchorEl: {
      type: Object
    },
    scroller: {},
    separator: {
      type: String,
      default: ','
    }
  },
  data: function data() {
    return {
      openMenu: false,
      trigger: null,
      menuWidth: null,
      label: ''
    };
  },
  mounted: function mounted() {
    this.trigger = this.anchorEl || this.$el;
    this.openMenu = this.openImmediately;
    this.label = this.getText();
    this.setMenuWidth();
  },

  methods: {
    handleClose: function handleClose() {
      this.$emit('close');
      this.openMenu = false;
    },
    handleOpen: function handleOpen() {
      this.$emit('open');
      this.openMenu = true;
    },
    itemClick: function itemClick() {
      if (!this.multiple) this.handleClose();
    },
    change: function change(value) {
      this.$emit('change', value);
    },
    setMenuWidth: function setMenuWidth() {
      if (!this.$el) return;
      this.menuWidth = this.autoWidth ? '' : this.$el.offsetWidth;
    },
    onResize: function onResize() {
      this.setMenuWidth();
    },
    getText: function getText() {
      var _this = this;

      if (!this.$slots || !this.$slots.default || this.$slots.length === 0 || (0, _utils.isNull)(this.value)) return '';
      var text = [];
      this.$slots.default.forEach(function (vNode) {
        if (!vNode.componentOptions || !vNode.componentOptions.propsData || (0, _utils.isNull)(vNode.componentOptions.propsData.value)) return;
        var _vNode$componentOptio = vNode.componentOptions.propsData,
            value = _vNode$componentOptio.value,
            title = _vNode$componentOptio.title;

        if (value === _this.value || _this.multiple && _this.value.length && _this.value.indexOf(value) !== -1) {
          text.push(title);
          return false;
        }
      });
      return text.join(this.separator);
    }
  },
  updated: function updated() {
    this.setMenuWidth();
  },

  watch: {
    anchorEl: function anchorEl(val) {
      if (val) this.trigger = val;
    },
    value: function value() {
      this.label = this.getText();
    }
  },
  components: {
    popover: _popover2.default,
    'mu-menu': _menu.menu
  }
};

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abstractButton = __webpack_require__(194);

var _abstractButton2 = _interopRequireDefault(_abstractButton);

var _routerMixin = __webpack_require__(195);

var _routerMixin2 = _interopRequireDefault(_routerMixin);

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

var _utils = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-flat-button',
  mixins: [_routerMixin2.default],
  props: {
    icon: {
      type: String
    },
    iconClass: {
      type: [String, Array, Object]
    },
    type: {
      type: String
    },
    label: {
      type: String
    },
    labelPosition: {
      type: String,
      default: 'after'
    },
    labelClass: {
      type: [String, Array, Object],
      default: ''
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    keyboardFocused: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    hoverColor: {
      type: String,
      default: ''
    },
    rippleColor: {
      type: String
    },
    rippleOpacity: {
      type: Number
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    },
    handleKeyboardFocus: function handleKeyboardFocus(isFocus) {
      this.$emit('keyboardFocus', isFocus);
      this.$emit('keyboard-focus', isFocus);
    },
    handleHover: function handleHover(event) {
      this.$emit('hover', event);
    },
    handleHoverExit: function handleHoverExit(event) {
      this.$emit('hoverExit', event);
      this.$emit('hover-exit', event);
    }
  },
  computed: {
    buttonStyle: function buttonStyle() {
      return {
        'background-color': this.hover ? (0, _utils.getColor)(this.hoverColor) : (0, _utils.getColor)(this.backgroundColor),
        'color': (0, _utils.getColor)(this.color)
      };
    },
    buttonClass: function buttonClass() {
      return {
        'mu-flat-button-primary': this.primary,
        'mu-flat-button-secondary': this.secondary,
        'label-before': this.labelPosition === 'before',
        'no-label': !this.label
      };
    }
  },
  components: {
    'abstract-button': _abstractButton2.default,
    icon: _icon2.default
  }
};

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String
  },
  computed: {
    styles: function styles() {
      return {
        'justify-content': this.justify,
        'align-items': this.align,
        'flex-wrap': this.wrap
      };
    }
  }
};

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-flexbox-item',
  props: {
    order: {
      type: [Number, String],
      default: 0
    },
    grow: {
      type: [Number, String],
      default: 1
    },
    shrink: {
      type: [Number, String],
      default: 1
    },
    basis: {
      type: [Number, String],
      default: 'auto'
    }
  },
  computed: {
    itemStyle: function itemStyle() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';
      styles[marginName] = this.$parent.gutter + 'px';
      styles['flex'] = this.grow + ' ' + this.shrink + ' ' + this.basis;
      styles['order'] = this.order;
      return styles;
    }
  }
};

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abstractButton = __webpack_require__(194);

var _abstractButton2 = _interopRequireDefault(_abstractButton);

var _routerMixin = __webpack_require__(195);

var _routerMixin2 = _interopRequireDefault(_routerMixin);

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

var _utils = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-float-button',
  mixins: [_routerMixin2.default],
  props: {
    icon: {
      type: String
    },
    iconClass: {
      type: [String, Array, Object],
      default: ''
    },
    type: {
      type: String
    },
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    buttonClass: function buttonClass() {
      var classNames = [];
      if (this.secondary) classNames.push('mu-float-button-secondary');
      if (this.mini) classNames.push('mu-float-button-mini');
      return classNames.join(' ');
    },
    buttonStyle: function buttonStyle() {
      return {
        'background-color': (0, _utils.getColor)(this.backgroundColor)
      };
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    },
    handleKeyboardFocus: function handleKeyboardFocus(isFocus) {
      this.$emit('keyboardFocus', isFocus);
      this.$emit('keyboard-focus', isFocus);
    },
    handleHover: function handleHover(event) {
      this.$emit('hover', event);
    },
    handleHoverExit: function handleHoverExit(event) {
      this.$emit('hoverExit', event);
      this.$emit('hover-exit', event);
    }
  },
  components: {
    'abstract-button': _abstractButton2.default,
    icon: _icon2.default
  }
};

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  name: 'mu-icon',
  props: {
    value: {
      type: String
    },
    size: {
      type: Number
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconStyle: function iconStyle() {
      return {
        'font-size': this.size + 'px',
        'width': this.size + 'px',
        'height': this.size + 'px',
        'color': (0, _utils.getColor)(this.color)
      };
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    }
  },
  render: function render(h) {
    var value = this.value,
        iconStyle = this.iconStyle,
        handleClick = this.handleClick;

    if (!value) return null;
    var isMaterial = value.indexOf(':') !== 0;
    var text = isMaterial ? value : '';
    return h('i', {
      class: ['mu-icon', isMaterial ? 'material-icons' : value.substring(1)],
      style: iconStyle,
      on: {
        click: handleClick
      }
    }, text);
  }
};

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abstractButton = __webpack_require__(194);

var _abstractButton2 = _interopRequireDefault(_abstractButton);

var _routerMixin = __webpack_require__(195);

var _routerMixin2 = _interopRequireDefault(_routerMixin);

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

var _tooltip = __webpack_require__(1340);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-icon-button',
  mixins: [_routerMixin2.default],
  props: {
    icon: {
      type: String
    },
    iconClass: {
      type: [String, Array, Object],
      default: ''
    },
    type: {
      type: String
    },
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    keyboardFocused: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: 'bottom-center'
    },
    touch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    verticalPosition: function verticalPosition() {
      var tooltipPosition = this.tooltipPosition.split('-');
      return tooltipPosition[0];
    },
    horizontalPosition: function horizontalPosition() {
      var tooltipPosition = this.tooltipPosition.split('-');
      return tooltipPosition[1];
    }
  },
  data: function data() {
    return {
      tooltipShown: false,
      tooltipTrigger: null
    };
  },

  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    },
    handleHover: function handleHover(event) {
      this.tooltipShown = true;
      this.$emit('hover', event);
    },
    handleHoverExit: function handleHoverExit(event) {
      this.tooltipShown = false;
      this.$emit('hoverExit', event);
      this.$emit('hover-exit', event);
    },
    handleKeyboardFocus: function handleKeyboardFocus(isFocus) {
      this.$emit('keyboardFocus', isFocus);
      this.$emit('keyboard-focus', isFocus);
    }
  },
  mounted: function mounted() {
    this.tooltipTrigger = this.$el;
  },

  components: {
    'abstract-button': _abstractButton2.default,
    icon: _icon2.default,
    tooltip: _tooltip2.default
  }
};

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  props: {
    mergeStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    color: {
      type: String,
      default: ''
    },
    opacity: {
      type: Number
    }
  },
  computed: {
    styles: function styles() {
      return (0, _utils.merge)({}, { color: this.color, opacity: this.opacity }, this.mergeStyle);
    }
  }
};

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  name: 'circle',
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: ''
    },
    borderWidth: {
      type: Number,
      default: 3
    },
    secondary: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        'border-color': (0, _utils.getColor)(this.color)
      };
    }
  }
};

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.dataset.oldPaddingTop = el.style.paddingTop;
      el.dataset.oldPaddingBottom = el.style.paddingBottom;
      el.style.height = '0';
    },
    enter: function enter(el) {
      el.dataset.oldOverflow = el.style.overflow;
      el.style.display = 'block';
      if (el.scrollHeight !== 0) {
        el.style.height = el.scrollHeight + 'px';
        el.style.paddingTop = el.dataset.oldPaddingTop;
        el.style.paddingBottom = el.dataset.oldPaddingBottom;
      } else {
        el.style.height = '';
        el.style.paddingTop = el.dataset.oldPaddingTop;
        el.style.paddingBottom = el.dataset.oldPaddingBottom;
      }
      el.style.overflow = 'hidden';
    },
    afterEnter: function afterEnter(el) {
      el.style.display = '';

      el.style.height = '';
      el.style.overflow = el.dataset.oldOverflow;
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    },
    beforeLeave: function beforeLeave(el) {
      el.dataset.oldPaddingTop = el.style.paddingTop;
      el.dataset.oldPaddingBottom = el.style.paddingBottom;
      el.dataset.oldOverflow = el.style.overflow;

      el.style.display = 'block';
      if (el.scrollHeight !== 0) {
        el.style.height = el.scrollHeight + 'px';
      }
      el.style.overflow = 'hidden';
    },
    leave: function leave(el) {
      if (el.scrollHeight !== 0) {
        setTimeout(function () {
          el.style.height = 0;
          el.style.paddingTop = 0;
          el.style.paddingBottom = 0;
        });
      }
    },
    afterLeave: function afterLeave(el) {
      el.style.display = 'none';
      el.style.height = '';
      el.style.overflow = el.dataset.oldOverflow;
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }
  }
};

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    color: {
      type: String,
      default: ''
    },
    opacity: {
      type: Number
    }
  },
  computed: {
    style: function style() {
      return {
        color: this.color,
        opacity: this.opacity
      };
    }
  },
  methods: {
    setRippleSize: function setRippleSize() {
      var el = this.$refs.innerCircle;
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;

      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }

      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  },
  mounted: function mounted() {
    this.setRippleSize();
  },
  updated: function updated() {
    this.setRippleSize();
  }
};

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-overlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function
    },
    opacity: {
      type: Number,
      default: 0.4
    },
    color: {
      type: String,
      default: '#000'
    },
    zIndex: {
      type: Number
    }
  },
  computed: {
    overlayStyle: function overlayStyle() {
      return {
        'opacity': this.opacity,
        'background-color': this.color,
        'position': this.fixed ? 'fixed' : '',
        'z-index': this.zIndex
      };
    }
  },
  methods: {
    prevent: function prevent(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    handleClick: function handleClick() {
      if (this.onClick) {
        this.onClick();
      }
    }
  }
};

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _circleRipple = __webpack_require__(3373);

var _circleRipple2 = _interopRequireDefault(_circleRipple);

var _domUtil = __webpack_require__(1342);

var domUtil = _interopRequireWildcard(_domUtil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    centerRipple: {
      type: Boolean,
      default: true
    },
    rippleWrapperClass: {},
    color: {
      type: String,
      default: ''
    },
    opacity: {
      type: Number
    }
  },
  data: function data() {
    return {
      nextKey: 0,
      ripples: []
    };
  },
  mounted: function mounted() {
    this.ignoreNextMouseDown = false;
  },

  methods: {
    start: function start(event, isRippleTouchGenerated) {
      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }
      this.ripples.push({
        key: this.nextKey++,
        color: this.color,
        opacity: this.opacity,
        style: this.centerRipple ? {} : this.getRippleStyle(event)
      });
      this.ignoreNextMouseDown = isRippleTouchGenerated;
    },
    end: function end() {
      if (this.ripples.length === 0) return;
      this.ripples.splice(0, 1);
      this.stopListeningForScrollAbort();
    },
    stopListeningForScrollAbort: function stopListeningForScrollAbort() {
      if (!this.handleMove) this.handleMove = this.handleTouchMove.bind(this);
      document.body.removeEventListener('touchmove', this.handleMove, false);
    },
    startListeningForScrollAbort: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      document.body.addEventListener('touchmove', this.handleMove, false);
    },
    handleMouseDown: function handleMouseDown(event) {
      if (event.button === 0) {
        this.start(event, false);
      }
    },
    handleTouchStart: function handleTouchStart(event) {
      if (event.touches) {
        this.startListeningForScrollAbort(event);
        this.startTime = Date.now();
      }
      this.start(event.touches[0], true);
    },
    handleTouchMove: function handleTouchMove(event) {
      var deltaY = Math.abs(event.touches[0].clientY - this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - this.firstTouchX);

      if (deltaY > 6 || deltaX > 6) this.end();
    },
    getRippleStyle: function getRippleStyle(event) {
      var el = this.$refs.holder;
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = domUtil.getOffset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;
      return {
        directionInvariant: true,
        height: rippleSize + 'px',
        width: rippleSize + 'px',
        top: top + 'px',
        left: left + 'px'
      };
    },
    calcDiag: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  },
  components: {
    'circle-ripple': _circleRipple2.default
  }
};

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  name: 'mu-linear-progress',
  props: {
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'indeterminate',
      validator: function validator(val) {
        return ['indeterminate', 'determinate'].indexOf(val) !== -1;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    color: {
      type: String
    },
    size: {
      type: Number
    }
  },
  computed: {
    percent: function percent() {
      return (this.value - this.min) / (this.max - this.min) * 100;
    },
    linearStyle: function linearStyle() {
      var size = this.size,
          color = this.color,
          mode = this.mode,
          percent = this.percent;

      return {
        height: size + 'px',
        'background-color': (0, _utils.getColor)(color),
        'border-radius': (size ? size / 2 : '') + 'px',
        width: mode === 'determinate' ? percent + '%' : ''
      };
    },
    linearClass: function linearClass() {
      return 'mu-linear-progress-' + this.mode;
    }
  }
};

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-list',
  props: {
    nestedLevel: {
      type: Number,
      default: 0
    },
    value: {}
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('change', value);
    },
    handleItemClick: function handleItemClick(listItem) {
      this.$emit('itemClick', listItem);
      this.$emit('item-click', listItem);
    }
  }
};

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abstractButton = __webpack_require__(194);

var _abstractButton2 = _interopRequireDefault(_abstractButton);

var _routerMixin = __webpack_require__(195);

var _routerMixin2 = _interopRequireDefault(_routerMixin);

var _iconButton = __webpack_require__(1332);

var _iconButton2 = _interopRequireDefault(_iconButton);

var _list = __webpack_require__(3379);

var _list2 = _interopRequireDefault(_list);

var _expandTransition = __webpack_require__(3375);

var _expandTransition2 = _interopRequireDefault(_expandTransition);

var _utils = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-list-item',
  mixins: [_routerMixin2.default],
  props: {
    href: {
      type: String
    },
    target: {
      type: String
    },
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: [String, Object, Array]
    },
    afterText: {
      type: String,
      default: ''
    },
    afterTextClass: {
      type: [String, Object, Array]
    },
    describeText: {
      type: String,
      default: ''
    },
    describeTextClass: {
      type: [String, Object, Array]
    },
    describeLine: {
      type: Number,
      default: 2
    },
    inset: {
      type: Boolean,
      default: false
    },
    nestedListClass: {
      type: [String, Object, Array]
    },
    open: {
      type: Boolean,
      default: true
    },
    toggleNested: {
      type: Boolean,
      default: false
    },
    toggleIconClass: {
      type: [String, Object, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableRipple: {
      type: Boolean,
      default: false
    },
    value: {}
  },
  data: function data() {
    return {
      nestedOpen: this.open
    };
  },

  computed: {
    hasAvatar: function hasAvatar() {
      return this.$slots && (this.$slots.leftAvatar && this.$slots.leftAvatar.length > 0 || this.$slots.rightAvatar && this.$slots.rightAvatar.length > 0);
    },
    nestedLevel: function nestedLevel() {
      return this.$parent.nestedLevel + 1;
    },
    showLeft: function showLeft() {
      return this.$slots && (this.$slots.left && this.$slots.left.length > 0 || this.$slots.leftAvatar && this.$slots.leftAvatar.length > 0);
    },
    showRight: function showRight() {
      return this.toggleNested || this.$slots && (this.$slots.right && this.$slots.right.length > 0 || this.$slots.rightAvatar && this.$slots.rightAvatar.length > 0);
    },
    showTitleRow: function showTitleRow() {
      return this.title || this.$slots && this.$slots.title && this.$slots.title.length > 0 || this.afterText || this.$slots && this.$slots.after && this.$slots.after.length > 0;
    },
    showDescribe: function showDescribe() {
      return this.describeText || this.$slots && this.$slots.describe && this.$slots.describe.length > 0;
    },
    itemClass: function itemClass() {
      var arr = ['mu-item'];
      if (this.showLeft || this.inset) arr.push('show-left');
      if (this.showRight) arr.push('show-right');
      if (this.hasAvatar) arr.push('has-avatar');
      if (this.selected) arr.push('selected');
      return arr.join(' ');
    },
    itemStyle: function itemStyle() {
      return {
        'margin-left': 18 * (this.nestedLevel - 1) + 'px'
      };
    },
    textStyle: function textStyle() {
      return {
        'max-height': 18 * this.describeLine + 'px',
        '-webkit-line-clamp': this.describeLine
      };
    },
    showNested: function showNested() {
      return this.nestedOpen && this.$slots && this.$slots.nested && this.$slots.nested.length > 0;
    },
    selected: function selected() {
      return (0, _utils.isNotNull)(this.$parent.value) && (0, _utils.isNotNull)(this.value) && this.$parent.value === this.value;
    },
    nestedSelectValue: function nestedSelectValue() {
      return this.$parent.value;
    }
  },
  methods: {
    handleToggleNested: function handleToggleNested() {
      this.nestedOpen = !this.nestedOpen;
      this.$emit('toggleNested', this.nestedOpen);
      this.$emit('toggle-nested', this.nestedOpen);
    },
    handleClick: function handleClick(e) {
      this.$emit('click', e);
      if (this.$parent.handleItemClick) this.$parent.handleItemClick(this);
      if ((0, _utils.isNotNull)(this.value)) this.$parent.handleChange(this.value);
      if (this.toggleNested) this.handleToggleNested();
    },
    handleKeyboardFocus: function handleKeyboardFocus(isFocus) {
      this.$emit('keyboardFocus', isFocus);
      this.$emit('keyboard-focus', isFocus);
    },
    handleHover: function handleHover(event) {
      this.$emit('hover', event);
    },
    handleHoverExit: function handleHoverExit(event) {
      this.$emit('hoverExit', event);
      this.$emit('hover-exit', event);
    },
    handleNestedChange: function handleNestedChange(value) {
      this.$parent.handleChange(value);
    },
    stop: function stop(e) {
      e.stopPropagation();
    }
  },
  watch: {
    open: function open(val, oldVal) {
      if (val === oldVal) return;
      this.nestedOpen = val;
    }
  },
  components: {
    'abstract-button': _abstractButton2.default,
    'mu-list': _list2.default,
    'icon-button': _iconButton2.default,
    'expand-transition': _expandTransition2.default
  }
};

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

var _keycode = __webpack_require__(616);

var _keycode2 = _interopRequireDefault(_keycode);

var _clickoutside = __webpack_require__(1333);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-menu',
  props: {
    desktop: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: true
    },
    width: {
      type: [String, Number]
    },
    maxHeight: {
      type: Number
    },
    disableAutoFocus: {
      type: Boolean,
      default: false
    },
    initiallyKeyboardFocused: {
      type: Boolean,
      default: false
    },
    listClass: {
      type: [String, Object, Array]
    },

    popover: {
      type: Boolean,
      default: false
    },
    value: {}
  },
  data: function data() {
    return {
      focusIndex: -1,
      isKeyboardFocused: false
    };
  },

  computed: {
    keyWidth: function keyWidth() {
      return this.desktop ? 64 : 56;
    },
    contentWidth: function contentWidth() {
      return this.autoWidth ? '' : (0, _utils.getWidth)(this.width);
    },
    menuListClass: function menuListClass() {
      var desktop = this.desktop,
          listClass = this.listClass;

      var classNames = [];
      if (desktop) classNames.push('mu-menu-destop');
      return classNames.concat((0, _utils.convertClass)(listClass));
    }
  },
  mounted: function mounted() {
    this.setWidth();
    var selectedIndex = this.getSelectedIndex();
    this.setScollPosition();
    this.focusIndex = this.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : this.initiallyKeyboardFocused ? 0 : -1;
    this.isKeyboardFocused = this.initiallyKeyboardFocused;
  },
  beforeUpdate: function beforeUpdate() {
    var selectedIndex = this.getSelectedIndex();
    this.focusIndex = this.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
  },
  updated: function updated() {
    this.setWidth();
  },

  methods: {
    clickoutside: function clickoutside() {
      this.setFocusIndex(-1, false);
    },
    setWidth: function setWidth() {
      if (!this.autoWidth) return;
      var el = this.$el;
      var listEl = this.$refs.list;
      var elWidth = el.offsetWidth;
      if (elWidth === 0) return;
      var keyWidth = this.keyWidth;
      var minWidth = keyWidth * 1.5;
      var keyIncrements = elWidth / keyWidth;
      var newWidth = void 0;

      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
      newWidth = keyIncrements * keyWidth;

      if (newWidth < minWidth) newWidth = minWidth;

      el.style.width = newWidth + 'px';
      listEl.style.width = newWidth + 'px';
    },
    handleChange: function handleChange(value) {
      this.$emit('change', value);
    },
    handleClick: function handleClick(item) {
      this.$emit('itemClick', item);
      this.$emit('item-click', item);
    },
    handleKeydown: function handleKeydown(event) {
      var key = (0, _keycode2.default)(event);
      switch (key) {
        case 'down':
          event.stopPropagation();
          event.preventDefault();
          this.incrementKeyboardFocusIndex();
          break;
        case 'tab':
          event.stopPropagation();
          event.preventDefault();
          if (event.shiftKey) {
            this.decrementKeyboardFocusIndex();
          } else {
            this.incrementKeyboardFocusIndex();
          }
          break;
        case 'up':
          event.stopPropagation();
          event.preventDefault();
          this.decrementKeyboardFocusIndex();
          break;
      }
    },
    decrementKeyboardFocusIndex: function decrementKeyboardFocusIndex() {
      var index = this.focusIndex;
      var maxIndex = this.getMenuItemCount() - 1;
      index--;
      if (index < 0) index = maxIndex;
      this.setFocusIndex(index, true);
    },
    incrementKeyboardFocusIndex: function incrementKeyboardFocusIndex() {
      var index = this.focusIndex;
      var maxIndex = this.getMenuItemCount() - 1;
      index++;
      if (index > maxIndex) index = 0;
      this.setFocusIndex(index, true);
    },
    getMenuItemCount: function getMenuItemCount() {
      var menuItemCount = 0;
      this.$children.forEach(function (child) {
        if (child._isMenuItem && !child.disabled) menuItemCount++;
      });
      return menuItemCount;
    },
    getSelectedIndex: function getSelectedIndex() {
      var selectedIndex = -1;
      var menuItemIndex = 0;

      this.$children.forEach(function (child) {
        if (child.active) selectedIndex = menuItemIndex;
        if (child._isMenuItem && !child.disabled) menuItemIndex++;
      });

      return selectedIndex;
    },
    setFocusIndex: function setFocusIndex(newIndex, isKeyboardFocused) {
      this.focusIndex = newIndex;
      this.isKeyboardFocused = isKeyboardFocused;
    },
    setScollPosition: function setScollPosition(selectedIndex) {
      var desktop = this.desktop;
      var focusedMenuItem = null;
      this.$children.forEach(function (child) {
        if (child.active) focusedMenuItem = child;
      });
      var menuItemHeight = desktop ? 32 : 48;

      if (focusedMenuItem) {
        var selectedOffSet = focusedMenuItem.$el.offsetTop;

        var scrollTop = selectedOffSet - menuItemHeight;
        if (scrollTop < menuItemHeight) scrollTop = 0;
        this.$refs.list.scrollTop = scrollTop;
      }
    }
  },
  watch: {
    focusIndex: function focusIndex(newVal, oldVal) {
      var _this = this;

      if (newVal === oldVal) return;
      var menuItemIndex = 0;
      this.$children.forEach(function (child) {
        if (!child._isMenuItem || child.disabled) return;
        var isFocused = menuItemIndex === newVal;
        var focusState = 'none';
        if (isFocused) {
          focusState = _this.isKeyboardFocused ? 'keyboard-focused' : 'focused';
        }
        child.focusState = focusState;
        menuItemIndex++;
      });
    },
    popover: function popover(val) {
      var _this2 = this;

      if (val) {
        setTimeout(function () {
          var selectedIndex = _this2.getSelectedIndex();
          if (_this2.disableAutoFocus) {
            _this2.$el.focus();
          } else {
            _this2.setFocusIndex(selectedIndex, false);
          }
        }, 300);
      }
    }
  },
  directives: {
    clickoutside: _clickoutside2.default
  }
};

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abstractButton = __webpack_require__(194);

var _abstractButton2 = _interopRequireDefault(_abstractButton);

var _routerMixin = __webpack_require__(195);

var _routerMixin2 = _interopRequireDefault(_routerMixin);

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

var _utils = __webpack_require__(44);

var _popover = __webpack_require__(707);

var _popover2 = _interopRequireDefault(_popover);

var _menu = __webpack_require__(1237);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-menu-item',
  mixins: [_routerMixin2.default],
  props: {
    href: {
      type: String
    },
    target: {
      type: String
    },
    title: {
      type: String
    },
    titleClass: {
      type: [String, Object, Array]
    },
    afterText: {
      type: String
    },
    afterTextClass: {
      type: [String, Object, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableFocusRipple: {
      type: Boolean,
      default: false
    },
    inset: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      type: String
    },
    leftIconColor: {
      type: String
    },
    leftIconClass: {
      type: [String, Object, Array]
    },
    rightIcon: {
      type: String
    },
    rightIconColor: {
      type: String
    },
    rightIconClass: {
      type: [String, Object, Array]
    },
    nestedMenuClass: {
      type: [String, Object, Array]
    },
    nestedMenuListClass: {
      type: [String, Object, Array]
    },
    value: {},
    nestedMenuValue: {}
  },
  computed: {
    showAfterText: function showAfterText() {
      return !this.rightIcon && this.afterText && (!this.$slot || !this.$slot.after || this.$slot.after.length === 0);
    },
    active: function active() {
      return (0, _utils.isNotNull)(this.$parent.value) && (0, _utils.isNotNull)(this.value) && (this.$parent.value === this.value || this.$parent.multiple && this.$parent.value.indexOf(this.value) !== -1);
    }
  },
  data: function data() {
    this._isMenuItem = true;
    return {
      openMenu: false,
      trigger: null,
      focusState: 'none' };
  },
  mounted: function mounted() {
    this.trigger = this.$el;
    this.applyFocusState();
  },

  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
      this.$parent.handleClick(this);
      this.open();
      if ((0, _utils.isNotNull)(this.value)) this.$parent.handleChange(this.value);
    },
    filterColor: function filterColor(color) {
      return (0, _utils.getColor)(color);
    },
    open: function open() {
      this.openMenu = this.$slots && this.$slots.default && this.$slots.default.length > 0;
    },
    close: function close() {
      this.openMenu = false;
    },
    handleKeyboardFocus: function handleKeyboardFocus(isFocus) {
      this.$emit('keyboardFocus', isFocus);
      this.$emit('keyboard-focus', isFocus);
    },
    handleHover: function handleHover(event) {
      this.$emit('hover', event);
    },
    handleHoverExit: function handleHoverExit(event) {
      this.$emit('hoverExit', event);
      this.$emit('hover-exit', event);
    },
    applyFocusState: function applyFocusState() {
      var button = this.$refs.button;
      if (button) {
        var buttonEl = button.$el;

        switch (this.focusState) {
          case 'none':
            buttonEl.blur();
            break;
          case 'focused':
            buttonEl.focus();
            break;
          case 'keyboard-focused':
            button.setKeyboardFocus();
            buttonEl.focus();
            break;
        }
      }
    }
  },
  watch: {
    focusState: function focusState() {
      this.applyFocusState();
    }
  },
  components: {
    'abstract-button': _abstractButton2.default,
    icon: _icon2.default,
    popover: _popover2.default,
    'mu-menu': _menu2.default
  }
};

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abstractButton = __webpack_require__(194);

var _abstractButton2 = _interopRequireDefault(_abstractButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    icon: {
      type: String
    },
    index: {
      type: Number
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    identifier: {
      type: String
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    handleHover: function handleHover(event) {
      this.$emit('hover', event);
    },
    handleHoverExit: function handleHoverExit(event) {
      this.$emit('hoverExit', event);
      this.$emit('hover-exit', event);
    },
    handleClick: function handleClick() {
      if (this.index) {
        this.$emit('click', this.index);
      } else {
        this.$emit('click', this.identifier);
      }
    }
  },
  components: {
    'abstract-button': _abstractButton2.default
  }
};

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pageItem = __webpack_require__(3380);

var _pageItem2 = _interopRequireDefault(_pageItem);

var _selectField = __webpack_require__(1339);

var _selectField2 = _interopRequireDefault(_selectField);

var _textField = __webpack_require__(708);

var _textField2 = _interopRequireDefault(_textField);

var _menuItem = __webpack_require__(1238);

var _menuItem2 = _interopRequireDefault(_menuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-pagination',
  props: {
    total: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    },
    defaultPageSize: {
      type: Number,
      default: 10
    },
    pageSize: {
      type: Number
    },
    showSizeChanger: {
      type: Boolean,
      default: false
    },
    pageSizeOption: {
      type: Array,
      default: function _default() {
        return [10, 20, 30, 40];
      }
    },
    pageSizeChangerText: {
      type: String,
      default: function _default() {
        return ' / 页';
      }
    }

  },
  data: function data() {
    return {
      leftDisabled: false,
      rightDisabled: false,
      actualCurrent: this.current,
      actualPageSize: this.defaultPageSize,
      totalPageCount: 0,
      pageList: [],
      quickJumpPage: ''
    };
  },
  mounted: function mounted() {
    this.iconIsDisabled(this.actualCurrent);

    if (this.showSizeChanger) {
      this.actualPageSize = this.pageSizeOption[0];
    } else if (this.pageSize) {
      this.actualPageSize = this.pageSize;
    }

    this.totalPageCount = Math.ceil(this.total / this.actualPageSize);
    this.pageList = this.calcPageList(this.actualCurrent);
  },

  methods: {
    handleClick: function handleClick(res) {
      if (typeof res === 'number') {
        this.actualCurrent = res;
      } else {
        switch (res) {
          case 'singleBack':
            this.actualCurrent = Math.max(1, this.actualCurrent - 1);
            break;
          case 'backs':
            this.actualCurrent = Math.max(1, this.actualCurrent - 5);
            break;
          case 'forwards':
            this.actualCurrent = Math.min(this.totalPageCount, this.actualCurrent + 5);
            break;
          case 'singleForward':
            this.actualCurrent = Math.min(this.totalPageCount, this.actualCurrent + 1);
            break;
        }
      }
    },
    iconIsDisabled: function iconIsDisabled(current) {
      this.leftDisabled = current === 1;
      this.rightDisabled = current === this.totalPageCount;
    },
    calcPageList: function calcPageList(current) {
      var pageList = [];
      if (this.totalPageCount > 5) {
        var left = Math.max(2, current - 2);
        var right = Math.min(current + 2, this.totalPageCount - 1);
        if (current - 1 < 2) {
          right = 4;
        }

        if (this.totalPageCount - current < 2) {
          left = this.totalPageCount - 3;
        }

        for (var i = left; i <= right; i++) {
          pageList.push(i);
        }
      } else {
        for (var _i = 2; _i < this.totalPageCount; _i++) {
          pageList.push(_i);
        }
      }

      return pageList;
    },
    pageSizeAndTotalChange: function pageSizeAndTotalChange(current) {
      this.iconIsDisabled(current);
      this.pageList = this.calcPageList(current);
    }
  },
  components: {
    'page-item': _pageItem2.default,
    'select-field': _selectField2.default,
    'text-field': _textField2.default,
    'menu-item': _menuItem2.default
  },
  watch: {
    actualCurrent: function actualCurrent(val) {
      if (val === 0) {
        return;
      }
      this.pageSizeAndTotalChange(val);
      this.$emit('pageChange', val);
      this.$emit('page-change', val);
    },
    actualPageSize: function actualPageSize(val, oldVal) {
      var itemIndex = oldVal * (this.actualCurrent - 1);
      var oldCurrent = this.actualCurrent;
      this.actualCurrent = Math.floor(itemIndex / val) + 1;

      this.totalPageCount = Math.ceil(this.total / this.actualPageSize);
      if (oldCurrent === this.actualCurrent) {
        this.pageSizeAndTotalChange(oldCurrent);
      }
      this.$emit('pageSizeChange', val);
      this.$emit('page-size-change', val);
    },
    total: function total(val) {
      var oldCurrent = this.actualCurrent;
      this.actualCurrent = Math.min(this.totalPageCount, this.actualCurrent);

      this.totalPageCount = Math.ceil(this.total / this.actualPageSize);
      if (oldCurrent === this.actualCurrent) {
        this.pageSizeAndTotalChange(oldCurrent);
      }
    },
    current: function current(val) {
      this.actualCurrent = val;
    }
  }
};

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(489);

var _extends3 = _interopRequireDefault(_extends2);

var _scroll = __webpack_require__(1337);

var _scroll2 = _interopRequireDefault(_scroll);

var _popup = __webpack_require__(1334);

var _popup2 = _interopRequireDefault(_popup);

var _resize = __webpack_require__(706);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-popover',
  mixins: [_scroll2.default, _resize2.default, _popup2.default],
  props: {
    overlay: {
      default: false
    },
    overlayOpacity: {
      default: 0.01
    },
    trigger: {},
    autoPosition: {
      type: Boolean,
      default: true
    },
    anchorOrigin: {
      type: Object,
      default: function _default() {
        return {
          vertical: 'bottom',
          horizontal: 'left'
        };
      }
    },
    targetOrigin: {
      type: Object,
      default: function _default() {
        return {
          vertical: 'top',
          horizontal: 'left'
        };
      }
    },
    popoverClass: {
      type: [String, Object, Array]
    }
  },
  methods: {
    getAnchorPosition: function getAnchorPosition(el) {
      var rect = el.getBoundingClientRect();
      var a = {
        top: rect.top,
        left: rect.left,
        width: el.width,
        height: el.height
      };

      a.right = rect.right || a.left + a.width;
      a.bottom = rect.bottom || a.top + a.height;
      a.middle = a.left + (a.right - a.left) / 2;
      a.center = a.top + (a.bottom - a.top) / 2;

      return a;
    },
    getTargetPosition: function getTargetPosition(targetEl) {
      return {
        top: 0,
        center: targetEl.offsetHeight / 2,
        bottom: targetEl.offsetHeight,
        left: 0,
        middle: targetEl.offsetWidth / 2,
        right: targetEl.offsetWidth
      };
    },
    getElInfo: function getElInfo(el) {
      var box = el.getBoundingClientRect();
      return {
        left: box.left,
        top: box.top,
        width: el.offsetWidth,
        height: el.offsetHeight
      };
    },
    setStyle: function setStyle() {
      if (!this.open) return;
      var targetOrigin = this.targetOrigin,
          anchorOrigin = this.anchorOrigin;

      var el = this.$refs.popup;
      var anchor = this.getAnchorPosition(this.trigger);
      var target = this.getTargetPosition(el);
      var targetPosition = {
        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
      };
      if (anchor.top < 0 || anchor.top > window.innerHeight || anchor.left < 0 || anchor.left > window.innerWidth) {
        this.close('overflow');
        return;
      }
      if (this.autoPosition) {
        target = this.getTargetPosition(el);
        targetPosition = this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
      }
      el.style.left = Math.max(0, targetPosition.left) + 'px';
      el.style.top = Math.max(0, targetPosition.top) + 'px';
    },
    getOverlapMode: function getOverlapMode(anchor, target, median) {
      if ([anchor, target].indexOf(median) >= 0) return 'auto';
      if (anchor === target) return 'inclusive';
      return 'exclusive';
    },
    getPositions: function getPositions(anchor, target) {
      var a = (0, _extends3.default)({}, anchor);
      var t = (0, _extends3.default)({}, target);

      var positions = {
        x: ['left', 'right'].filter(function (p) {
          return p !== t.horizontal;
        }),
        y: ['top', 'bottom'].filter(function (p) {
          return p !== t.vertical;
        })
      };

      var overlap = {
        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
      };

      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');

      if (overlap.y !== 'auto') {
        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
        if (overlap.y === 'inclusive') {
          t.vertical = t.vertical;
        }
      }

      if (overlap.x !== 'auto') {
        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
        if (overlap.y === 'inclusive') {
          t.horizontal = t.horizontal;
        }
      }

      return {
        positions: positions,
        anchorPos: a
      };
    },
    applyAutoPositionIfNeeded: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
          positions = _getPositions.positions,
          anchorPos = _getPositions.anchorPos;

      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
        if (newTop + target.bottom <= window.innerHeight) {
          targetPosition.top = Math.max(0, newTop);
        } else {
          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
          if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);
        }
      }
      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
        if (newLeft + target.right <= window.innerWidth) {
          targetPosition.left = Math.max(0, newLeft);
        } else {
          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
          if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);
        }
      }
      return targetPosition;
    },
    close: function close(reason) {
      this.$emit('close', reason);
    },
    clickOutSide: function clickOutSide(e) {
      this.close('clickOutSide');
    },
    onScroll: function onScroll() {
      this.setStyle();
    },
    onResize: function onResize() {
      this.setStyle();
    },
    show: function show() {
      this.$emit('show');
    },
    hide: function hide() {
      this.$emit('hide');
    }
  },
  mounted: function mounted() {
    this.setStyle();
  },
  updated: function updated() {
    var _this = this;

    setTimeout(function () {
      _this.setStyle();
    }, 0);
  }
};

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abstractButton = __webpack_require__(194);

var _abstractButton2 = _interopRequireDefault(_abstractButton);

var _routerMixin = __webpack_require__(195);

var _routerMixin2 = _interopRequireDefault(_routerMixin);

var _utils = __webpack_require__(44);

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-raised-button',
  mixins: [_routerMixin2.default],
  props: {
    icon: {
      type: String
    },
    iconClass: {
      type: [String, Array, Object]
    },
    label: {
      type: String
    },
    labelPosition: {
      type: String,
      default: 'after'
    },
    labelClass: {
      type: [String, Array, Object],
      default: ''
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    keyboardFocused: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    rippleColor: {
      type: String
    },
    rippleOpacity: {
      type: Number
    }
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    buttonStyle: function buttonStyle() {
      return {
        'background-color': (0, _utils.getColor)(this.backgroundColor),
        'color': (0, _utils.getColor)(this.color)
      };
    },
    inverse: function inverse() {
      return this.primary || this.secondary || this.backgroundColor;
    },
    buttonClass: function buttonClass() {
      return {
        'mu-raised-button-primary': this.primary,
        'mu-raised-button-secondary': this.secondary,
        'label-before': this.labelPosition === 'before',
        'mu-raised-button-inverse': this.inverse,
        'mu-raised-button-full': this.fullWidth,
        'focus': this.focus,
        'no-label': !this.label
      };
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    },
    handleKeyboardFocus: function handleKeyboardFocus(isFocus) {
      this.focus = isFocus;
      this.$emit('keyboardFocus', isFocus);
      this.$emit('keyboard-focus', isFocus);
    },
    handleHover: function handleHover(e) {
      this.$emit('hover', e);
    },
    handleHoverExit: function handleHoverExit(e) {
      this.$emit('hoverExit', e);
      this.$emit('hover-exit', e);
    }
  },
  components: {
    'abstract-button': _abstractButton2.default,
    icon: _icon2.default
  }
};

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _textField = __webpack_require__(708);

var _textField2 = _interopRequireDefault(_textField);

var _dropDownMenu = __webpack_require__(1331);

var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);

var _utils = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-select-field',
  props: {
    name: {
      type: String
    },
    label: {
      type: String
    },
    labelFloat: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: [String, Array, Object]
    },
    labelFocusClass: {
      type: [String, Array, Object]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hintText: {
      type: String
    },
    hintTextClass: {
      type: [String, Array, Object]
    },
    helpText: {
      type: String
    },
    helpTextClass: {
      type: [String, Array, Object]
    },
    errorText: {
      type: String
    },
    errorColor: {
      type: String
    },
    icon: {
      type: String
    },
    iconClass: {
      type: [String, Array, Object]
    },
    maxHeight: {
      type: Number
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    underlineShow: {
      type: Boolean,
      default: true
    },
    underlineClass: {
      type: [String, Array, Object]
    },
    underlineFocusClass: {
      type: [String, Array, Object]
    },
    dropDownIconClass: {
      type: [String, Array, Object]
    },
    value: {},
    multiple: {
      type: Boolean,
      default: false
    },
    scroller: {},
    separator: {
      type: String,
      default: ','
    }
  },
  data: function data() {
    var defaultVal = this.value;
    if ((0, _utils.isNull)(defaultVal)) defaultVal = '';
    if (this.multiple && !(defaultVal instanceof Array)) {
      defaultVal = [];
    }
    return {
      anchorEl: null,
      inputValue: defaultVal
    };
  },
  mounted: function mounted() {
    this.anchorEl = this.$children[0].$refs.input;
  },

  methods: {
    handlehange: function handlehange(val) {
      if (val === this.inputValue) return;
      if (this.multiple) {
        var index = this.inputValue.indexOf(val);
        if (index === -1) {
          this.inputValue.push(val);
        } else {
          this.inputValue.splice(index, 1);
        }
      } else {
        this.inputValue = val;
      }
      this.$emit('change', this.inputValue);
    },
    handleOpen: function handleOpen() {
      this.$refs.textField.handleFocus();
      this.$emit('open');
    },
    handleClose: function handleClose() {
      this.$refs.textField.handleBlur();
      this.$emit('close');
    }
  },
  watch: {
    value: function value(val) {
      this.inputValue = val;
    },
    inputValue: function inputValue(val, oldVal) {
      if (val === oldVal) return;
      this.$emit('input', val);
    }
  },
  components: {
    'text-field': _textField2.default,
    'dropDown-menu': _dropDownMenu2.default
  }
};

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    rows: {
      type: Number,
      default: 1
    },
    rowsMax: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    normalClass: {
      type: [String, Array, Object]
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    resizeTextarea: function resizeTextarea() {
      var element = this.$refs.textarea;
      if (!element) return;
      var hiddenEl = this.$refs.textareaHidden;
      var lineHeight = window.getComputedStyle(element, null).getPropertyValue('line-height');
      lineHeight = Number(lineHeight.substring(0, lineHeight.indexOf('px')));
      var pt = window.getComputedStyle(element, null).getPropertyValue('padding-top');
      pt = Number(pt.substring(0, pt.indexOf('px')));
      var pd = window.getComputedStyle(element, null).getPropertyValue('padding-bottom');
      pd = Number(pd.substring(0, pd.indexOf('px')));
      var minHeight = pd + pt + lineHeight * this.rows;
      var maxHeight = pd + pt + lineHeight * (this.rowsMax || 0);
      var height = hiddenEl.scrollHeight;
      element.style.height = (height < minHeight ? minHeight : height > maxHeight && maxHeight > 0 ? maxHeight : height) + 'px';
    },
    handleInput: function handleInput(e) {
      this.$emit('input', e.target.value);
    },
    handleChange: function handleChange(e) {
      this.$emit('change', e);
    },
    handleFocus: function handleFocus(e) {
      this.$emit('focus', e);
    },
    handleBlur: function handleBlur(e) {
      this.$emit('blur', e);
    },
    focus: function focus() {
      var textarea = this.$refs.textarea;

      if (textarea) {
        textarea.focus();
      }
    }
  },
  mounted: function mounted() {
    this.resizeTextarea();
  },

  watch: {
    value: function value(val, oldVal) {
      var _this = this;

      if (val === oldVal) return;
      this.$nextTick(function () {
        _this.resizeTextarea();
      });
    }
  }
};

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(163);

var _icon2 = _interopRequireDefault(_icon);

var _textFieldUnderline = __webpack_require__(3386);

var _textFieldUnderline2 = _interopRequireDefault(_textFieldUnderline);

var _enhancedTextarea = __webpack_require__(3383);

var _enhancedTextarea2 = _interopRequireDefault(_enhancedTextarea);

var _textFieldLabel = __webpack_require__(3385);

var _textFieldLabel2 = _interopRequireDefault(_textFieldLabel);

var _utils = __webpack_require__(44);

var _textFieldHint = __webpack_require__(3384);

var _textFieldHint2 = _interopRequireDefault(_textFieldHint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'mu-text-field',
  props: {
    name: {
      type: String
    },
    type: {
      type: String
    },
    icon: {
      type: String
    },
    iconClass: {
      type: [String, Array, Object]
    },
    label: {
      type: String
    },
    labelFloat: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: [String, Array, Object]
    },
    labelFocusClass: {
      type: [String, Array, Object]
    },
    hintText: {
      type: String
    },
    hintTextClass: {
      type: [String, Array, Object]
    },
    value: {},
    inputClass: {
      type: [String, Array, Object]
    },
    multiLine: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    rowsMax: {
      type: Number
    },
    errorText: {
      type: String
    },
    errorColor: {
      type: String
    },
    helpText: {
      type: String
    },
    helpTextClass: {
      type: [String, Array, Object]
    },
    maxLength: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    underlineShow: {
      type: Boolean,
      default: true
    },
    underlineClass: {
      type: [String, Array, Object]
    },
    underlineFocusClass: {
      type: [String, Array, Object]
    },
    max: {
      type: [Number, String]
    },
    min: {
      type: [Number, String]
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isFocused: false,
      inputValue: this.value,
      charLength: 0
    };
  },

  computed: {
    textFieldClass: function textFieldClass() {
      return {
        'focus-state': this.isFocused,
        'has-label': this.label,
        'no-empty-state': this.inputValue,
        'has-icon': this.icon,
        'error': this.errorText,
        'multi-line': this.multiLine,
        'disabled': this.disabled,
        'full-width': this.fullWidth
      };
    },
    float: function float() {
      return this.labelFloat && !this.isFocused && !this.inputValue && this.inputValue !== 0;
    },
    errorStyle: function errorStyle() {
      return {
        color: !this.disabled && this.errorText ? (0, _utils.getColor)(this.errorColor) : ''
      };
    },
    showHint: function showHint() {
      return !this.float && !this.inputValue && this.inputValue !== 0;
    }
  },
  methods: {
    handleFocus: function handleFocus(event) {
      this.isFocused = true;
      this.$emit('focus', event);
    },
    handleBlur: function handleBlur(event) {
      this.isFocused = false;
      if (this.type === 'number' && !this.inputValue && this.inputValue !== 0 && this.$refs.input) {
        this.$refs.input.value = '';
      }
      this.$emit('blur', event);
    },
    handleInput: function handleInput(val) {
      this.inputValue = val.target ? val.target.value : val;
    },
    handleChange: function handleChange(e) {
      this.$emit('change', e, e.target.value);
    },
    handleLabelClick: function handleLabelClick() {
      this.$emit('labelClick');
    },
    focus: function focus() {
      var _$refs = this.$refs,
          input = _$refs.input,
          textarea = _$refs.textarea;

      if (input) {
        input.focus();
      } else if (textarea) {
        textarea.focus();
      }
    }
  },
  watch: {
    value: function value(val) {
      this.inputValue = val;
    },
    inputValue: function inputValue(val, oldVal) {
      this.charLength = this.maxLength && String(this.inputValue) ? String(this.inputValue).length : 0;
      this.$emit('input', val);
    },
    charLength: function charLength(val) {
      if (val > this.maxLength && !this.isTextOverflow) {
        this.isTextOverflow = true;
        this.$emit('textOverflow', true);
        this.$emit('text-overflow', true);
      }
      if (this.isTextOverflow && val <= this.maxLength) {
        this.isTextOverflow = false;
        this.$emit('textOverflow', false);
        this.$emit('text-overflow', false);
      }
    }
  },
  components: {
    icon: _icon2.default,
    underline: _textFieldUnderline2.default,
    'enhanced-textarea': _enhancedTextarea2.default,
    'text-field-label': _textFieldLabel2.default,
    'text-field-hint': _textFieldHint2.default
  }
};

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    text: {
      type: String
    },
    show: {
      type: Boolean,
      default: true
    }
  }
};

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    float: {
      type: Boolean,
      default: false
    },
    normalClass: {
      type: [String, Object, Array]
    },
    focusClass: {
      type: [String, Object, Array]
    }
  },
  computed: {
    labelClass: function labelClass() {
      var float = this.float,
          focus = this.focus,
          normalClass = this.normalClass,
          focusClass = this.focusClass;

      var classNames = [];
      if (float) classNames.push('float');
      classNames = classNames.concat((0, _utils.convertClass)(normalClass));
      if (focus) classNames = classNames.concat((0, _utils.convertClass)(focusClass));
      return classNames;
    }
  }
};

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(44);

exports.default = {
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean
    },
    errorColor: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    normalClass: {
      type: [String, Object, Array]
    },
    focusClass: {
      type: [String, Object, Array]
    }
  },
  computed: {
    lineClass: function lineClass() {
      var disabled = this.disabled,
          normalClass = this.normalClass;

      var classNames = [];
      if (disabled) classNames.push('disabled');
      return classNames.concat((0, _utils.convertClass)(normalClass));
    },
    focusLineClass: function focusLineClass() {
      var normalClass = this.normalClass,
          focus = this.focus,
          focusClass = this.focusClass,
          error = this.error;

      var classNames = [];
      classNames.concat((0, _utils.convertClass)(normalClass));
      if (error) classNames.push('error');
      if (focus) classNames.push('focus');
      return classNames.concat((0, _utils.convertClass)(focusClass));
    },
    errorStyle: function errorStyle() {
      return {
        'background-color': this.error ? (0, _utils.getColor)(this.errorColor) : ''
      };
    }
  }
};

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mu-tooltip',
  props: {
    label: {
      type: String
    },
    trigger: {},
    verticalPosition: {
      type: String,
      default: 'bottom'
    },
    horizontalPosition: {
      type: String,
      default: 'center'
    },
    show: {
      type: Boolean,
      default: false
    },
    touch: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      offsetWidth: 0,
      triggerWidth: 0,
      triggerHeight: 0
    };
  },

  computed: {
    tooltipStyle: function tooltipStyle() {
      var horizontalPosition = this.horizontalPosition,
          verticalPosition = this.verticalPosition,
          offsetWidth = this.offsetWidth,
          touch = this.touch,
          triggerWidth = this.triggerWidth,
          triggerHeight = this.triggerHeight,
          show = this.show;

      var touchMarginOffset = touch ? 10 : 0;
      var touchOffsetTop = touch ? -20 : -10;
      var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
      return {
        right: horizontalPosition === 'left' ? '0' : null,
        left: horizontalPosition === 'center' ? (offsetWidth - triggerWidth) / 2 * -1 + 'px' : horizontalPosition === 'right' ? '0' : '',
        top: !show ? '-3000px' : verticalPosition === 'top' ? touchOffsetTop + 'px' : triggerHeight - offset + touchMarginOffset + 2 + 'px',
        transform: 'translate(0px, ' + offset + 'px)'
      };
    },
    rippleStyle: function rippleStyle() {
      var horizontalPosition = this.horizontalPosition,
          verticalPosition = this.verticalPosition;

      return {
        left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
        top: verticalPosition === 'bottom' ? '0' : '100%'
      };
    }
  },
  methods: {
    setRippleSize: function setRippleSize() {
      var ripple = this.$refs.ripple;
      var tooltip = this.$el;
      if (!tooltip || !ripple) return;
      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.horizontalPosition === 'center' ? 2 : 1);
      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
      if (this.show) {
        ripple.style.height = rippleDiameter + 'px';
        ripple.style.width = rippleDiameter + 'px';
      } else {
        ripple.style.width = '0px';
        ripple.style.height = '0px';
      }
    },
    setTooltipSize: function setTooltipSize() {
      this.offsetWidth = this.$el.offsetWidth;
      if (!this.trigger) return;
      this.triggerWidth = this.trigger.offsetWidth;
      this.triggerHeight = this.trigger.offsetHeight;
    }
  },
  mounted: function mounted() {
    this.setRippleSize();
    this.setTooltipSize();
  },
  beforeUpdate: function beforeUpdate() {
    this.setTooltipSize();
  },
  updated: function updated() {
    this.setRippleSize();
  }
};

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'VueSliderComponent',
  data: function data() {
    return {
      flag: false,
      size: 0,
      currentValue: 0,
      currentSlider: 0,
      isComponentExists: true
    };
  },

  props: {
    width: {
      type: [Number, String],
      default: 'auto'
    },
    height: {
      type: [Number, String],
      default: 6
    },
    data: {
      type: Array,
      default: null
    },
    dotSize: {
      type: Number,
      default: 16
    },
    dotWidth: {
      type: Number,
      required: false
    },
    dotHeight: {
      type: Number,
      required: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    interval: {
      type: Number,
      default: 1
    },
    show: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    piecewise: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: [String, Boolean],
      default: 'always'
    },
    eventType: {
      type: String,
      default: 'auto'
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    reverse: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    speed: {
      type: Number,
      default: 0.5
    },
    realTime: {
      type: Boolean,
      default: false
    },
    stopPropagation: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array],
      default: 0
    },
    piecewiseLabel: {
      type: Boolean,
      default: false
    },
    sliderStyle: [Array, Object, Function],
    tooltipDir: [Array, String],
    formatter: [String, Function],
    piecewiseStyle: Object,
    piecewiseActiveStyle: Object,
    processStyle: Object,
    bgStyle: Object,
    tooltipStyle: [Array, Object, Function],
    labelStyle: Object,
    labelActiveStyle: Object
  },
  computed: {
    dotWidthVal: function dotWidthVal() {
      return typeof this.dotWidth === 'number' ? this.dotWidth : this.dotSize;
    },
    dotHeightVal: function dotHeightVal() {
      return typeof this.dotHeight === 'number' ? this.dotHeight : this.dotSize;
    },
    flowDirection: function flowDirection() {
      return 'vue-slider-' + (this.direction + (this.reverse ? '-reverse' : ''));
    },
    tooltipDirection: function tooltipDirection() {
      var dir = this.tooltipDir || (this.direction === 'vertical' ? 'left' : 'top');
      if (Array.isArray(dir)) {
        return this.isRange ? dir : dir[1];
      } else {
        return this.isRange ? [dir, dir] : dir;
      }
    },
    tooltipStatus: function tooltipStatus() {
      return this.tooltip === 'hover' && this.flag ? 'vue-slider-always' : this.tooltip ? 'vue-slider-' + this.tooltip : '';
    },
    tooltipClass: function tooltipClass() {
      return ['vue-slider-tooltip-' + this.tooltipDirection, 'vue-slider-tooltip'];
    },
    isDisabled: function isDisabled() {
      return this.eventType === 'none' ? true : this.disabled;
    },
    disabledClass: function disabledClass() {
      return this.disabled ? 'vue-slider-disabled' : '';
    },
    isRange: function isRange() {
      return Array.isArray(this.value);
    },
    slider: function slider() {
      return this.isRange ? [this.$refs.dot0, this.$refs.dot1] : this.$refs.dot;
    },
    minimum: function minimum() {
      return this.data ? 0 : this.min;
    },

    val: {
      get: function get() {
        return this.data ? this.isRange ? [this.data[this.currentValue[0]], this.data[this.currentValue[1]]] : this.data[this.currentValue] : this.currentValue;
      },
      set: function set(val) {
        if (this.data) {
          if (this.isRange) {
            var index0 = this.data.indexOf(val[0]);
            var index1 = this.data.indexOf(val[1]);
            if (index0 > -1 && index1 > -1) {
              this.currentValue = [index0, index1];
            }
          } else {
            var index = this.data.indexOf(val);
            if (index > -1) {
              this.currentValue = index;
            }
          }
        } else {
          this.currentValue = val;
        }
      }
    },
    currentIndex: function currentIndex() {
      if (this.isRange) {
        return this.data ? this.currentValue : [(this.currentValue[0] - this.minimum) / this.spacing, (this.currentValue[1] - this.minimum) / this.spacing];
      } else {
        return (this.currentValue - this.minimum) / this.spacing;
      }
    },
    indexRange: function indexRange() {
      if (this.isRange) {
        return this.currentIndex;
      } else {
        return [0, this.currentIndex];
      }
    },
    maximum: function maximum() {
      return this.data ? this.data.length - 1 : this.max;
    },
    multiple: function multiple() {
      var decimals = ('' + this.interval).split('.')[1];
      return decimals ? Math.pow(10, decimals.length) : 1;
    },
    spacing: function spacing() {
      return this.data ? 1 : this.interval;
    },
    total: function total() {
      if (this.data) {
        return this.data.length - 1;
      } else if (~~((this.maximum - this.minimum) * this.multiple) % (this.interval * this.multiple) !== 0) {
        console.error('[Vue-slider warn]: Prop[interval] is illegal, Please make sure that the interval can be divisible');
      }
      return (this.maximum - this.minimum) / this.interval;
    },
    gap: function gap() {
      return this.size / this.total;
    },
    position: function position() {
      return this.isRange ? [(this.currentValue[0] - this.minimum) / this.spacing * this.gap, (this.currentValue[1] - this.minimum) / this.spacing * this.gap] : (this.currentValue - this.minimum) / this.spacing * this.gap;
    },
    limit: function limit() {
      return this.isRange ? [[0, this.position[1]], [this.position[0], this.size]] : [0, this.size];
    },
    valueLimit: function valueLimit() {
      return this.isRange ? [[this.minimum, this.currentValue[1]], [this.currentValue[0], this.maximum]] : [this.minimum, this.maximum];
    },
    wrapStyles: function wrapStyles() {
      return this.direction === 'vertical' ? {
        height: typeof this.height === 'number' ? this.height + 'px' : this.height,
        padding: this.dotHeightVal / 2 + 'px ' + this.dotWidthVal / 2 + 'px'
      } : {
        width: typeof this.width === 'number' ? this.width + 'px' : this.width,
        padding: this.dotHeightVal / 2 + 'px ' + this.dotWidthVal / 2 + 'px'
      };
    },
    sliderStyles: function sliderStyles() {
      if (Array.isArray(this.sliderStyle)) {
        return this.isRange ? this.sliderStyle : this.sliderStyle[1];
      } else if (typeof this.sliderStyle === 'function') {
        return this.sliderStyle(this.val, this.currentIndex);
      } else {
        return this.isRange ? [this.sliderStyle, this.sliderStyle] : this.sliderStyle;
      }
    },
    tooltipStyles: function tooltipStyles() {
      if (Array.isArray(this.tooltipStyle)) {
        return this.isRange ? this.tooltipStyle : this.tooltipStyle[1];
      } else if (typeof this.tooltipStyle === 'function') {
        return this.tooltipStyle(this.val, this.currentIndex);
      } else {
        return this.isRange ? [this.tooltipStyle, this.tooltipStyle] : this.tooltipStyle;
      }
    },
    elemStyles: function elemStyles() {
      return this.direction === 'vertical' ? {
        width: this.width + 'px',
        height: '100%'
      } : {
        height: this.height + 'px'
      };
    },
    dotStyles: function dotStyles() {
      return this.direction === 'vertical' ? {
        width: this.dotWidthVal + 'px',
        height: this.dotHeightVal + 'px',
        left: -(this.dotWidthVal - this.width) / 2 + 'px'
      } : {
        width: this.dotWidthVal + 'px',
        height: this.dotHeightVal + 'px',
        top: -(this.dotHeightVal - this.height) / 2 + 'px'
      };
    },
    piecewiseDotStyle: function piecewiseDotStyle() {
      return this.direction === 'vertical' ? {
        width: this.width + 'px',
        height: this.width + 'px'
      } : {
        width: this.height + 'px',
        height: this.height + 'px'
      };
    },
    piecewiseDotWrap: function piecewiseDotWrap() {
      if (!this.piecewise && !this.piecewiseLabel) {
        return false;
      }

      var arr = [];
      for (var i = 0; i <= this.total; i++) {
        var style = this.direction === 'vertical' ? {
          bottom: this.gap * i - this.width / 2 + 'px',
          left: 0
        } : {
          left: this.gap * i - this.height / 2 + 'px',
          top: 0
        };
        var index = this.reverse ? this.total - i : i;
        var label = this.data ? this.data[index] : this.spacing * index + this.min;
        arr.push({
          style: style,
          label: this.formatter ? this.formatting(label) : label,
          inRange: index >= this.indexRange[0] && index <= this.indexRange[1]
        });
      }
      return arr;
    }
  },
  watch: {
    value: function value(val) {
      this.flag || this.setValue(val, true);
    },
    max: function max(val) {
      var resetVal = this.limitValue(this.val);
      resetVal !== false && this.setValue(resetVal);
      this.refresh();
    },
    min: function min(val) {
      var resetVal = this.limitValue(this.val);
      resetVal !== false && this.setValue(resetVal);
      this.refresh();
    },
    show: function show(bool) {
      var _this = this;

      if (bool && !this.size) {
        this.$nextTick(function () {
          _this.refresh();
        });
      }
    }
  },
  methods: {
    bindEvents: function bindEvents() {
      document.addEventListener('touchmove', this.moving, { passive: false });
      document.addEventListener('touchend', this.moveEnd, { passive: false });
      document.addEventListener('mousemove', this.moving);
      document.addEventListener('mouseup', this.moveEnd);
      document.addEventListener('mouseleave', this.moveEnd);

      window.addEventListener('resize', this.refresh);
    },
    unbindEvents: function unbindEvents() {
      window.removeEventListener('resize', this.refresh);

      document.removeEventListener('touchmove', this.moving);
      document.removeEventListener('touchend', this.moveEnd);
      document.removeEventListener('mousemove', this.moving);
      document.removeEventListener('mouseup', this.moveEnd);
      document.removeEventListener('mouseleave', this.moveEnd);
    },
    formatting: function formatting(value) {
      return typeof this.formatter === 'string' ? this.formatter.replace(/\{value\}/, value) : this.formatter(value);
    },
    getPos: function getPos(e) {
      this.realTime && this.getStaticData();
      return this.direction === 'vertical' ? this.reverse ? e.pageY - this.offset : this.size - (e.pageY - this.offset) : this.reverse ? this.size - (e.clientX - this.offset) : e.clientX - this.offset;
    },
    wrapClick: function wrapClick(e) {
      if (this.isDisabled || !this.clickable) return false;
      var pos = this.getPos(e);
      if (this.isRange) {
        this.currentSlider = pos > (this.position[1] - this.position[0]) / 2 + this.position[0] ? 1 : 0;
      }
      this.setValueOnPos(pos);
    },
    moveStart: function moveStart(e, index) {
      if (this.stopPropagation) {
        e.stopPropagation();
      }

      if (this.isDisabled) return false;else if (this.isRange) {
        this.currentSlider = index;
      }
      this.flag = true;
      this.$emit('drag-start', this);
    },
    moving: function moving(e) {
      if (this.stopPropagation) {
        e.stopPropagation();
      }

      if (!this.flag) return false;
      e.preventDefault();

      if (e.targetTouches && e.targetTouches[0]) e = e.targetTouches[0];
      this.setValueOnPos(this.getPos(e), true);
    },
    moveEnd: function moveEnd(e) {
      if (this.stopPropagation) {
        e.stopPropagation();
      }

      if (this.flag) {
        this.$emit('drag-end', this);
        if (this.lazy && this.isDiff(this.val, this.value)) {
          this.syncValue();
        }
      } else {
        return false;
      }
      this.flag = false;
      this.setPosition();
    },
    setValueOnPos: function setValueOnPos(pos, isDrag) {
      var range = this.isRange ? this.limit[this.currentSlider] : this.limit;
      var valueRange = this.isRange ? this.valueLimit[this.currentSlider] : this.valueLimit;
      if (pos >= range[0] && pos <= range[1]) {
        this.setTransform(pos);
        var v = (Math.round(pos / this.gap) * (this.spacing * this.multiple) + this.minimum * this.multiple) / this.multiple;
        this.setCurrentValue(v, isDrag);
      } else if (pos < range[0]) {
        this.setTransform(range[0]);
        this.setCurrentValue(valueRange[0]);
        if (this.currentSlider === 1) this.currentSlider = 0;
      } else {
        this.setTransform(range[1]);
        this.setCurrentValue(valueRange[1]);
        if (this.currentSlider === 0) this.currentSlider = 1;
      }
    },
    isDiff: function isDiff(a, b) {
      if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b)) {
        return true;
      } else if (Array.isArray(a) && a.length === b.length) {
        return a.some(function (v, i) {
          return v !== b[i];
        });
      }
      return a !== b;
    },
    setCurrentValue: function setCurrentValue(val, bool) {
      if (val < this.minimum || val > this.maximum) return false;
      if (this.isRange) {
        if (this.isDiff(this.currentValue[this.currentSlider], val)) {
          this.currentValue.splice(this.currentSlider, 1, val);
          if (!this.lazy || !this.flag) {
            this.syncValue();
          }
        }
      } else if (this.isDiff(this.currentValue, val)) {
        this.currentValue = val;
        if (!this.lazy || !this.flag) {
          this.syncValue();
        }
      }
      bool || this.setPosition();
    },
    setIndex: function setIndex(val) {
      if (Array.isArray(val) && this.isRange) {
        var value = void 0;
        if (this.data) {
          value = [this.data[val[0]], this.data[val[1]]];
        } else {
          value = [this.spacing * val[0] + this.minimum, this.spacing * val[1] + this.minimum];
        }
        this.setValue(value);
      } else {
        val = this.spacing * val + this.minimum;
        if (this.isRange) {
          this.currentSlider = val > (this.currentValue[1] - this.currentValue[0]) / 2 + this.currentValue[0] ? 1 : 0;
        }
        this.setCurrentValue(val);
      }
    },
    setValue: function setValue(val, noCb, speed) {
      var _this2 = this;

      if (this.isDiff(this.val, val)) {
        var resetVal = this.limitValue(val);
        if (resetVal !== false) {
          this.val = this.isRange ? resetVal.concat() : resetVal;
        } else {
          this.val = this.isRange ? val.concat() : val;
        }
        this.syncValue(noCb);
      }

      this.$nextTick(function () {
        return _this2.setPosition(speed);
      });
    },
    setPosition: function setPosition(speed) {
      this.flag || this.setTransitionTime(speed === undefined ? this.speed : speed);
      if (this.isRange) {
        this.currentSlider = 0;
        this.setTransform(this.position[this.currentSlider]);
        this.currentSlider = 1;
        this.setTransform(this.position[this.currentSlider]);
      } else {
        this.setTransform(this.position);
      }
      this.flag || this.setTransitionTime(0);
    },
    setTransform: function setTransform(val) {
      var value = (this.direction === 'vertical' ? this.dotHeightVal / 2 - val : val - this.dotWidthVal / 2) * (this.reverse ? -1 : 1);
      var translateValue = this.direction === 'vertical' ? 'translateY(' + value + 'px)' : 'translateX(' + value + 'px)';
      var processSize = (this.currentSlider === 0 ? this.position[1] - val : val - this.position[0]) + 'px';
      var processPos = (this.currentSlider === 0 ? val : this.position[0]) + 'px';
      if (this.isRange) {
        this.slider[this.currentSlider].style.transform = translateValue;
        this.slider[this.currentSlider].style.WebkitTransform = translateValue;
        this.slider[this.currentSlider].style.msTransform = translateValue;
        if (this.direction === 'vertical') {
          this.$refs.process.style.height = processSize;
          this.$refs.process.style[this.reverse ? 'top' : 'bottom'] = processPos;
        } else {
          this.$refs.process.style.width = processSize;
          this.$refs.process.style[this.reverse ? 'right' : 'left'] = processPos;
        }
      } else {
        this.slider.style.transform = translateValue;
        this.slider.style.WebkitTransform = translateValue;
        this.slider.style.msTransform = translateValue;
        if (this.direction === 'vertical') {
          this.$refs.process.style.height = val + 'px';
          this.$refs.process.style[this.reverse ? 'top' : 'bottom'] = 0;
        } else {
          this.$refs.process.style.width = val + 'px';
          this.$refs.process.style[this.reverse ? 'right' : 'left'] = 0;
        }
      }
    },
    setTransitionTime: function setTransitionTime(time) {
      time || this.$refs.process.offsetWidth;

      if (this.isRange) {
        for (var i = 0; i < this.slider.length; i++) {
          this.slider[i].style.transitionDuration = time + 's';
          this.slider[i].style.WebkitTransitionDuration = time + 's';
        }
        this.$refs.process.style.transitionDuration = time + 's';
        this.$refs.process.style.WebkitTransitionDuration = time + 's';
      } else {
        this.slider.style.transitionDuration = time + 's';
        this.slider.style.WebkitTransitionDuration = time + 's';
        this.$refs.process.style.transitionDuration = time + 's';
        this.$refs.process.style.WebkitTransitionDuration = time + 's';
      }
    },
    limitValue: function limitValue(val) {
      var _this3 = this;

      if (this.data) {
        return val;
      }

      var bool = false;
      if (this.isRange) {
        val = val.map(function (v) {
          if (v < _this3.min) {
            bool = true;
            return _this3.min;
          } else if (v > _this3.max) {
            bool = true;
            return _this3.max;
          }
          return v;
        });
      } else if (val > this.max) {
        bool = true;
        val = this.max;
      } else if (val < this.min) {
        bool = true;
        val = this.min;
      }
      return bool && val;
    },
    syncValue: function syncValue(noCb) {
      var val = this.isRange ? this.val.concat() : this.val;
      this.$emit('input', val);
      noCb || this.$emit('callback', val);
    },
    getValue: function getValue() {
      return this.val;
    },
    getIndex: function getIndex() {
      return this.currentIndex;
    },
    getStaticData: function getStaticData() {
      if (this.$refs.elem) {
        this.size = this.direction === 'vertical' ? this.$refs.elem.offsetHeight : this.$refs.elem.offsetWidth;
        this.offset = this.direction === 'vertical' ? this.$refs.elem.getBoundingClientRect().top + window.pageYOffset || document.documentElement.scrollTop : this.$refs.elem.getBoundingClientRect().left;
      }
    },
    refresh: function refresh() {
      if (this.$refs.elem) {
        this.getStaticData();
        this.setPosition();
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.isComponentExists = true;

    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return console.warn('[VueSlider warn]: window or document is undefined, can not be initialization.');
    }

    this.$nextTick(function () {
      if (_this4.isComponentExists) {
        _this4.getStaticData();
        _this4.setValue(_this4.value, true, 0);
        _this4.bindEvents();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.isComponentExists = false;
    this.unbindEvents();
  }
};

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(234);

var _promise2 = _interopRequireDefault(_promise);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _vueClickaway = __webpack_require__(338);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

var _Geo = __webpack_require__(710);

var _Geo2 = _interopRequireDefault(_Geo);

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _Provider = __webpack_require__(711);

var _Provider2 = _interopRequireDefault(_Provider);

var _IOManager = __webpack_require__(1663);

var _IOManager2 = _interopRequireDefault(_IOManager);

var _Notifications = __webpack_require__(1250);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _Provider3 = __webpack_require__(3427);

var _Provider4 = _interopRequireDefault(_Provider3);

var _BootLoader = __webpack_require__(1240);

var _BootLoader2 = _interopRequireDefault(_BootLoader);

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

var _core = __webpack_require__(1320);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _Paywall = __webpack_require__(3514);

var _Paywall2 = _interopRequireDefault(_Paywall);

var _LanguagePicker = __webpack_require__(3413);

var _LanguagePicker2 = _interopRequireDefault(_LanguagePicker);

var _config3 = __webpack_require__(1304);

var _config4 = _interopRequireDefault(_config3);

var _PaymentCallToAction = __webpack_require__(3419);

var _PaymentCallToAction2 = _interopRequireDefault(_PaymentCallToAction);

var _textField = __webpack_require__(228);

var _textField2 = _interopRequireDefault(_textField);

var _contentBlock = __webpack_require__(227);

var _contentBlock2 = _interopRequireDefault(_contentBlock);

var _Search = __webpack_require__(3410);

var _Search2 = _interopRequireDefault(_Search);

var _SwitchProgram = __webpack_require__(3412);

var _SwitchProgram2 = _interopRequireDefault(_SwitchProgram);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.headers.common['applicationContext'] = _config2.default.ApplicationContext;

exports.default = {
  mixins: [_HCPMixin2.default],
  watch: {
    'connected': function connected() {
      var self = this;
    },
    '$route': function $route(from, to) {
      var self = this;
      if (self.$route.name === 'Dashboard') {
        self.getUser();
        self.showPaywall = false;

        if ($(window).width() >= 1196) {
          self.docked = true;
          self.isOpen = true;
        }
      } else {
        self.showPaywall = true;
      }

      if (to.name !== 'Subscription') {
        self.checkOnboarding();
      }

      self.initPusher();

      self.replaceTitle = '';

      self.hasTransHeader = self.$route.meta.hasTransHeader;
      self.initializeLifeStyleTransparentHeader();
      if (self.$route.meta.hideLeftNav === true) {
        self.docked = false;
        self.isOpen = false;
      }
      if ($(window).width() <= 1196) {
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        }
      } else {
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        }
      }
    }
  },
  components: {
    HcpSwitchModal: _SwitchProgram2.default,
    HcpSearch: _Search2.default,
    MuContentBlock: _contentBlock2.default,
    MuTextField: _textField2.default,
    LanguagePicker: _LanguagePicker2.default,
    Paywall: _Paywall2.default,
    BootLoader: _BootLoader2.default,
    Provider: _Provider4.default,
    NotificationsPanel: _Notifications2.default,
    PaymentCallToAction: _PaymentCallToAction2.default
  },
  name: 'app',
  directives: {
    onClickaway: _vueClickaway.directive
  },
  data: function data() {
    return {
      toggleHcpSwitchModal: false,
      externalTitle: '',
      replaceTitle: '',
      applicationContext: _config2.default.ApplicationContext,
      isLowCarb: _config4.default.ApplicationContext === 'lowcarbprogram',
      hasTransHeader: false,
      isNotificationsPanelVisible: false,
      menuOpen: false,
      recipesOpen: false,
      shopOpen: false,
      connected: true,
      isOpen: false,
      docked: false,
      loading: false,
      loadingMessage: "",
      loader: false,
      pusher: null,
      showTestimonial: false,
      showPaywall: true,
      currentYear: moment().format('YYYY'),
      supportedLocales: [{
        name: 'en_gb',
        time: 'en'
      }, {
        name: 'fr_ca',
        time: 'fr'
      }]
    };
  },
  mounted: function mounted() {
    var self = this;

    self.checkOnboarding();

    _axios2.default.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/utilities/alloptions").then(function (response) {
      self.$store.commit('setRecipeCategories', {
        suitabilities: response.data.suitabilities,
        dietaryTypes: response.data.dietaryTypes,
        cuisines: response.data.cuisines,
        occasions: response.data.occasions,
        categories: response.data.categories
      });
    });

    if (self.$route.name === 'Dashboard') {
      self.showPaywall = false;
    }

    _EventBus2.default.$on('App::triggerPaywall', function (data) {
      self.showPaywall = data;
      self.$forceUpdate();
    });

    self.initializeLifeStyleTransparentHeader();

    self.loadingMessage = self.$t('message.bootloaderConnecting');

    _promise2.default.all([_Geo2.default.geoIp(), _Lists2.default.getGettingStartedList(), _Lists2.default.getMoodsList(), _Lists2.default.getExternalLoginList()]).then(function (responses) {
      self.$store.commit('setGeoLocation', responses[0].data);

      self.loadingMessage = self.$t('message.bootloaderDownloadingAssets');
      self.$store.commit('setList', responses[1].data);

      self.loadingMessage = self.$t('message.bootloaderInitializing');
      self.$store.commit('setMoodList', responses[2].data);
      self.$store.commit('setLoginProviders', responses[3].data.providers);
    });

    if (_AuthenticationManager2.default.hasToken()) {
      var tokenObject = _AuthenticationManager2.default.getToken();
      if (tokenObject.expires < new Date()) {
        _AuthenticationManager2.default.refreshAccessToken(tokenObject).then(function () {
          self.loadingMessage = self.$t('message.bootloaderProfile');
          self.getUser();
        });
      } else {
        _AuthenticationManager2.default.setToken(tokenObject);
        self.loadingMessage = self.$t('message.bootloaderProfile');
        self.getUser();
      }
    }

    var StatusChecker = new _IOManager2.default();
    setInterval(function () {
      StatusChecker.ConnectivityStatusWithAppState(self);
    }.bind(self), 5000);

    _EventBus2.default.$on('App::triggerLoading', function () {
      self.loader = true;
    });

    _EventBus2.default.$on('App::stopLoading', function () {
      self.loader = false;
    });

    _EventBus2.default.$on('App::setCustomTitle', function (title) {
      self.externalTitle = title;
    });

    _EventBus2.default.$on('App::setReplaceTitle', function (title) {
      self.replaceTitle = title;
    });

    _EventBus2.default.$on('App::dockerResizerStart', function () {
      self.barDockerListen();
    });

    self.$EventBus.$on('App::_onIdle', function () {
      if (self.loggedIn) {
        self.$store.commit('setFlashMessage', {
          type: 'error',
          title: self.$t('message.idleLogoutTitle'),
          body: self.$t('message.idleLogoutBody')
        });

        self.logOut();
      }
    });

    if ($(window).width() <= 1196) {
      if (self.$route.meta.hideLeftNav === true) {
        self.docked = false;
        self.isOpen = false;
      } else {
        self.docked = true;
        self.isOpen = false;
      }
    } else {
      if (self.$route.meta.hideLeftNav === true) {
        self.docked = false;
        self.isOpen = false;
      } else {
        self.docked = true;
        self.isOpen = true;
      }
    }
    if (self.$route.meta.hideLeftNav === true) {
      self.docked = false;
      self.isOpen = false;
    }
    self.barDockerListen();

    document.addEventListener("touchstart", function () {}, true);

    _EventBus2.default.$on('App::onProgramSwitch', function () {
      self.$store.state.user.scope = "";
      self.loadingMessage = "Switching Program ...";
      setTimeout(function () {
        self.getUser();
      }, 2000);
    });
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    document.removeEventListener('click', self.onSettingsOutsideClick, true);
    if (self.settingsPopper) {
      self.settingsPopper.destroy();
      self.settingsPopper = null;
    }
  },

  methods: {
    closeHcpSwitchModal: function closeHcpSwitchModal(e) {
      var self = this;
      self.toggleHcpSwitchModal = false;
    },
    getUser: function getUser() {
      var self = this;
      _User2.default.getUser().then(function (response) {
        var user = response.data;
        self.$store.commit('setUser', user);

        var weeks = 2,
            weekDays = weeks * 7,
            now = moment();
        if (_lodash2.default.has(self.$store.state.user.scope, 'date_joined')) {
          if (now <= moment(self.$store.state.user.scope.date_joined).add('days', weekDays)) {
            self.showTestimonial = true;
          }
          self.showTestimonial = false;
        }

        _axios2.default.get(_config2.default.apiUrl + 'user/updateComm/' + response.data.scope.user_id).then(function (response) {});

        _User2.default.onBoardingStatus().then(function (response) {
          self.$store.commit('setOnBoardingStatus', response.data);
          self.checkOnboarding();
        });

        _Provider2.default.getProvider().then(function (response) {
          self.$store.commit('setProvider', response.data);
          self.loading = false;
        });

        self.initPusher();

        var tokenObject = _AuthenticationManager2.default.getToken();
        if (!_lodash2.default.has(tokenObject, 'refreshToken')) {
          return;
        }

        var applyScopeFromToken = function applyScopeFromToken() {
          var jwt = _AuthenticationManager2.default.parseJwt();
          if (!jwt) {
            return;
          }
          if (_lodash2.default.includes(jwt.scope, 'standard_tasks')) {
            self.$store.commit('setPaymentStatus', true);
          } else if (_lodash2.default.includes(jwt.scope, 'unsubscribed_tasks')) {
            self.$router.push({
              path: '/subscribe'
            });
          }
        };

        var isExpired = tokenObject.expires && new Date(tokenObject.expires) < new Date();
        if (isExpired) {
          _AuthenticationManager2.default.refreshAccessToken(tokenObject).then(applyScopeFromToken);
        } else {
          applyScopeFromToken();
        }
      });
    },
    initPusher: function initPusher() {
      var self = this;

      if (self.loggedIn) {
        var userId = self.$store.state.user.scope.user_id;

        _PusherManager2.default.unsubscribe('settings_' + userId);
        _PusherManager2.default.unsubscribe('payment_' + userId);
        _PusherManager2.default.unsubscribe('profileUpdated_' + userId);
        _PusherManager2.default.unsubscribe('queueSyncComplete_' + userId);
        _PusherManager2.default.unsubscribe('subscription_' + userId);

        self.pusher = _PusherManager2.default.subscribe('payment_' + userId);
        self.pusher.bind('refund', function (data) {
          if (data.refunded === true) {
            self.$store.state.status.payment.paid = false;
            self.showPaywall = true;
            self.$forceUpdate();
          }
        });

        var subscr = _PusherManager2.default.subscribe('payment_' + userId);
        subscr.bind('cancel', function (data) {
          if (data.cancelled === true) {
            self.$store.state.status.payment.paid = false;
            self.showPaywall = true;
            self.$forceUpdate();
          }
        });

        var bindProfilePicture = _PusherManager2.default.subscribe('profileUpdated_' + userId);
        bindProfilePicture.bind('profileUpdated', function (data) {
          self.$store.state.user.scope.firstname = data.firstname;
          self.$store.state.user.scope.surname = data.surname;
          self.$store.state.user.scope.display_name = data.display_name;
          self.$store.state.user.scope.use_display_name = data.use_display_name;
          self.$store.state.user.scope.profile_thumb = data.profile_thumb;
          self.$store.state.user.scope.profile_large = data.profile_large;
        });

        var bindSettings = _PusherManager2.default.subscribe('settings_' + userId);
        bindSettings.bind('onSettingsChange', function (data) {
          if (_lodash2.default.has(data, 'onAccountChange')) {
            var account = data.onAccountChange;
            self.$store.state.user.scope.firstname = account.firstname;
            self.$store.state.user.scope.surname = account.surname;
            self.$store.state.user.scope.display_name = account.surname;
            self.$store.state.user.scope.use_display_name = account.use_display_name;
            self.$store.commit('setAccount', account);
          }

          if (_lodash2.default.has(data, 'onUnitsWebChange')) {
            self.$store.state.user.settings = data.onUnitsWebChange;
          }
        });

        var bindPulseSyncComplete = _PusherManager2.default.subscribe('queueSyncComplete_' + userId);
        bindPulseSyncComplete.bind('heartRate', function (data) {
          if (data.service === 'STRIIV') {
            self.$toastr.success('New pulse readings imported from Striiv');
          }
        });
      }
    },
    barDockerListen: function barDockerListen() {
      var self = this;
      $(window).resize(function () {
        if ($(window).width() <= 1196) {
          if (self.$route.meta.hideLeftNav === true) {
            self.docked = false;
            self.isOpen = false;
          } else {
            self.docked = true;
            self.isOpen = false;
          }
        } else {
          if (self.$route.meta.hideLeftNav === true) {
            self.docked = false;
            self.isOpen = false;
          } else {
            self.docked = true;
            self.isOpen = true;
          }
        }
      });
    },

    handleScroll: function handleScroll(e) {
      var self = this;
      self.initializeLifeStyleTransparentHeader();
    },
    initializeLifeStyleTransparentHeader: function initializeLifeStyleTransparentHeader() {
      var self = this;
      self.hasTransHeader = self.$route.meta.hasTransHeader;
      var el = '#' + self.$route.meta.id;
      if (self.hasTransHeader === true) {
        if (self.$route.name === "LifeStyleArticle") {
          if ($(el).scrollTop() >= $(el).outerHeight() - 64) {
            if (self.hasTransHeader === true) self.hasTransHeader = false;
          } else {
            if (self.hasTransHeader === false) {
              self.hasTransHeader = true;
            }
          }
        }
      }
    },
    goTo: function goTo(path) {
      var self = this;
      self.$router.push({
        path: path
      });
    },
    toggleSettingsMenu: function toggleSettingsMenu() {
      var self = this;
      self.menuOpen ? self.closeAppMenu() : self.openSettingsMenu();
    },
    openSettingsMenu: function openSettingsMenu() {
      var self = this;
      self.menuOpen = true;
      self.$nextTick(function () {
        var dropdown = self.$refs.settingsDropdown,
            trigger = self.$refs.settingsTrigger;
        if (!dropdown || !trigger) {
          return;
        }

        document.body.appendChild(dropdown);
        self.settingsPopper = (0, _core.createPopper)(trigger, dropdown, {
          placement: 'right-start',
          modifiers: [{ name: 'offset', options: { offset: [0, 8] } }, { name: 'flip', options: { fallbackPlacements: ['bottom-start', 'left-start'] } }, { name: 'preventOverflow', options: { padding: 8 } }]
        });
        document.addEventListener('click', self.onSettingsOutsideClick, true);
      });
    },
    closeAppMenu: function closeAppMenu() {
      var self = this;
      if (!self.menuOpen) {
        return;
      }
      self.menuOpen = false;
      document.removeEventListener('click', self.onSettingsOutsideClick, true);
      if (self.settingsPopper) {
        self.settingsPopper.destroy();
        self.settingsPopper = null;
      }

      var dropdown = self.$refs.settingsDropdown,
          menu = self.$refs.settingsMenu;
      if (dropdown && menu && dropdown.parentNode !== menu) {
        menu.appendChild(dropdown);
      }
    },
    onSettingsOutsideClick: function onSettingsOutsideClick(e) {
      var self = this,
          dropdown = self.$refs.settingsDropdown,
          trigger = self.$refs.settingsTrigger;
      if (dropdown && dropdown.contains(e.target)) {
        return;
      }
      if (trigger && trigger.contains(e.target)) {
        return;
      }
      self.closeAppMenu();
    },
    closeIfMobile: function closeIfMobile() {
      var self = this;
      if ($(window).width() <= 1196) {
        self.docked = true;
        self.isOpen = false;
      } else {
        self.docked = true;
        self.isOpen = true;
      }
    },
    goToProfile: function goToProfile() {
      var self = this;
      if (self.isHcpUser && self.isHcpView) {
        self.$router.push({
          path: '/profile/' + self.$store.state.user.profile.profile_url
        });
      } else {
        self.$router.push({
          path: '/profile/' + self.$store.state.user.profile.profile_url + '/progress'
        });
      }
    },
    toggle: function toggle(flag) {
      this.isOpen = !this.isOpen;
      _EventBus2.default.$emit('redraw');
      if ($(window).width() <= 1196) {
        this.docked = false;
      } else {
        this.docked = true;
      }
    },
    logOut: function logOut() {
      var self = this;

      self.$store.commit('setOnBoardingStatus', {});
      self.$store.commit('setPaymentStatus', {});
      self.$store.commit('setLessons', []);
      self.$store.commit('setUser', {});
      self.$store.commit('setAccount', {});
      self.$store.commit('setBloodGlucoseCard', {});
      self.$store.commit('setBloodPressureCard', {});
      self.$store.commit('setNutritionCard', {});
      self.$store.commit('setWeightCard', {});
      self.$store.commit('setSleepCard', {});
      self.$store.commit('setMedicationCard', {});
      self.$store.commit('setCholesterolCard', {});
      self.$store.commit('setInsulinCard', {});
      self.$store.commit('setKetonesCard', {});
      self.$store.commit('setMoodCard', {});
      self.$store.commit('setCardOrder', {});
      self.$store.commit('setProvider', {});
      self.$store.commit('setMoodCard', {});

      _axios2.default.get(_config2.default.apiUrl + 'logout/').then(function (response) {
        if (_lodash2.default.has(_axios2.default.defaults.headers.common, 'Authorization')) {
          delete _axios2.default.defaults.headers.common['Authorization'];
        }

        _AuthenticationManager2.default.clearSession();
        self.$router.push({
          name: 'Login'
        });
      });
    },
    goToContact: function goToContact() {
      var self = this;
      self.$router.push({
        name: 'Contact'
      });
    },
    goBack: function goBack(route) {
      var self = this;
      self.$router.go(-1);
    },
    replaceDashes: function replaceDashes(url) {
      var urlLength = url.length;
      url = url.split('-').join('.');
      return url;
    },
    upperFirstChar: function upperFirstChar(string) {
      return string.charAt(0) + string.slice(1);
    },
    openNotificationPanel: function openNotificationPanel() {
      var self = this;
      self.isNotificationsPanelVisible = true;
    },
    away: function away() {
      var self = this;
      self.isNotificationsPanelVisible = false;
    },
    hidePanelFn: function hidePanelFn() {
      var self = this;
      self.isNotificationsPanelVisible = false;
    },
    checkOnboarding: function checkOnboarding() {
      var self = this;

      if (self.$route.name === 'Subscription' || self.$route.name === 'Payment' || self.$route.name === 'AmendRegistration' || self.$route.name === 'Register') {
        return;
      }

      if (self.$store.state.status.payment.paid === false && self.$route.name !== 'AmendRegistration') {
        self.$router.push({
          name: 'Subscription'
        });
      } else {
        if (!self.isHcpUser) {
          if (self.$route.name === 'GettingStartedAboutYourself' || self.$route.name === 'GettingStartedYourHealth' || self.$route.name === 'GettingStartedLocation' || self.$route.name === 'GettingStartedGoals' || self.$route.name === 'GettingStartedPersonalise') {} else {
            if (self.$store.state.status.onboarding.about === false) {
              self.$router.push({
                name: 'GettingStartedAboutYourself'
              });
            } else {
              if (self.$store.state.status.onboarding.location === false) {
                self.$router.push({
                  name: 'GettingStartedLocation'
                });
              } else {
                if (self.$store.state.status.onboarding.goals === false) {
                  self.$router.push({
                    name: 'GettingStartedGoals'
                  });
                } else {
                  if (self.$store.state.status.onboarding.personalise === false) {
                    self.$router.push({
                      name: 'GettingStartedPersonalise'
                    });
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  computed: {
    showLogOut: function showLogOut() {
      var routeName = this.$route.name;
      return routeName === 'Subscription' || routeName === 'GettingStartedAboutYourself' || routeName === 'GettingStartedYourHealth' || routeName === 'GettingStartedLocation' || routeName === 'GettingStartedGoals' || routeName === 'GettingStartedPersonalise';
    },
    loggedIn: function loggedIn() {
      var self = this;
      return _lodash2.default.has(self.$store.state.user, 'scope');
    },
    questionsDisabled: function questionsDisabled() {
      return !this.isHcpVerified && this.isHcpView;
    },

    profileUrl: {
      get: function get() {
        var self = this,
            url = self.$store.state.user.profile.profile_url;
        url = url.split('-').join('.');
        return url;
      },
      set: function set() {
        var self = this,
            url = self.$store.state.user.profile.profile_url;
        url = url.split('-').join('.');
        return url;
      }
    },
    upperTwoInitials: {
      get: function get() {
        var self = this;
        return self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name ? self.$store.state.user.scope.display_name.toString().charAt(0) : self.$store.state.user.scope.firstname.charAt(0) + self.$store.state.user.scope.surname.charAt(0);
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(2)))

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "alert",
  props: {
    type: {
      type: String,
      validator: function validator(value) {
        if (value === 'info') {
          return true;
        }
        if (value === 'warning') {
          return true;
        }
        if (value === 'success') {
          return true;
        }
        if (value === 'danger') {
          return true;
        }
        if (value === 'alert-color') {
          return true;
        }
      }
    },
    align: {
      type: String,
      default: 'middle',
      validator: function validator(value) {
        return value === 'top' || value === 'middle';
      }
    },
    icon: {
      type: String,
      required: false
    }
  }
};

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(358);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _name$mixins$componen;

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

var _AudioPlayerMixin = __webpack_require__(1651);

var _AudioPlayerMixin2 = _interopRequireDefault(_AudioPlayerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playerSliderOptions = {
  width: 130,
  height: 16,
  dotSize: 16,
  bgStyle: {
    backgroundColor: '#D8D8D8'
  },
  processStyle: {
    backgroundColor: "#7ECB46"
  },
  sliderStyle: {
    backgroundColor: '#FFFFFF'
  }
};

var volumeSliderOptions = {
  height: 8,
  width: 68,
  direction: "horizontal",
  speed: 0.1,
  interval: 0.1,
  min: 0,
  max: 1
};

exports.default = (_name$mixins$componen = {
  name: 'audio-player',
  mixins: [_AudioPlayerMixin2.default],
  components: { vueSlider: _vue2Slider2.default }
}, (0, _defineProperty3.default)(_name$mixins$componen, 'name', 'audio-player'), (0, _defineProperty3.default)(_name$mixins$componen, 'props', {
  url: {
    type: String,
    required: true
  }
}), (0, _defineProperty3.default)(_name$mixins$componen, 'data', function data() {
  return {
    isVolumeControlsVisible: true,
    isPlaying: false,
    isMuted: false,
    volumeBeforeMuted: 0,
    isAudioReady: false,
    userSeeking: false,
    audio: undefined,
    percentage: 0,
    duration: 0,
    volume: 0.5,
    currentDuration: 0,
    currentTime: '00:00',
    playerSliderOptions: playerSliderOptions,
    volumeSliderOptions: volumeSliderOptions
  };
}), (0, _defineProperty3.default)(_name$mixins$componen, 'mounted', function mounted() {
  var self = this;
  self.initAudio();
}), _name$mixins$componen);

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'BannerBlock',
  props: { size: Array, path: String, id: String },
  beforeCreate: function beforeCreate() {
    window.googletag.cmd.push(function () {
      window.googletag.destroySlots();
    });
  },
  mounted: function mounted() {
    var path = this.path,
        size = this.size,
        id = this.id;

    window.googletag.cmd.push(function () {
      window.googletag.defineSlot(path, size, id).addService(window.googletag.pubads());
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
      window.googletag.display(id);
    });
  }
};

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(126);

exports.default = {
  name: 'boot-loader',
  props: {
    loadingMessage: ""
  }
};

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "CoachingCards",
  props: {
    image: String,
    title: String,
    text: String,
    list: Array,
    buttonText: String,
    buttonLink: String
  },
  data: function data() {
    return {};
  },

  methods: {
    goToArticle: function goToArticle(path) {
      var self = this;
      self.$router.push({
        path: path
      });
    }
  },
  computed: {}
};

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'country-badge',
  props: {
    alpha2: {
      type: String,
      default: 'gb'
    },
    tooltip: {
      type: String,
      default: 'United Kingdom'
    }
  },
  methods: {
    getCountryClass: function getCountryClass(code) {
      return 'flag-' + code;
    }
  }
};

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(732);

var _from2 = _interopRequireDefault(_from);

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_HCPMixin2.default],
  name: "lesson-inline-grid",
  data: function data() {
    return {
      isLoading: true,
      activeLesson: 1,
      dummyLoaders: 10,
      list: []
    };
  },
  mounted: function mounted() {
    var self = this;
    if (self.$store.state.lessons.length > 0) {
      self.setList(self.$store.state.lessons);
    } else {
      _Lessons2.default.getLessonsList().then(function (response) {
        self.$store.state.lessons = response.data;
        self.setList(response.data);
      });
    }
  },

  methods: {
    setList: function setList(lessons) {
      var self = this;
      self.list = lessons;
      self.isLoading = false;

      self.$nextTick(function () {
        self.activeLesson = self.latestUnlockedLesson();
        self.scrollToLesson(self.activeLesson);
      });
    },
    latestUnlockedLesson: function latestUnlockedLesson() {
      var self = this;
      var unlocked = self.list.filter(function (lesson) {
        return lesson.status.locked === false;
      }).length;
      return unlocked > 0 ? unlocked : 1;
    },
    goLeft: function goLeft() {
      this.animateToLesson(this.activeLesson - 1);
    },
    goRight: function goRight() {
      this.animateToLesson(this.activeLesson + 1);
    },
    animateToLesson: function animateToLesson(lessonNumber) {
      var self = this;
      self.activeLesson = Math.min(Math.max(lessonNumber, 1), self.list.length);
      self.scrollToLesson(self.activeLesson);
    },
    scrollToLesson: function scrollToLesson(lessonNumber) {
      var self = this;
      var rail = self.$refs.rail;
      if (!rail) {
        return;
      }
      var tile = rail.querySelector('[data-lesson="' + lessonNumber + '"]');
      if (!tile) {
        return;
      }
      var left = tile.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
      rail.scrollTo({ left: left, behavior: 'auto' });
    },
    goToBonus: function goToBonus(bonus, tile) {
      var self = this;
      if (self.$store.state.status.payment.paid === true) {
        if (tile.status.locked !== true) {
          self.$router.push({
            name: 'LessonBonus',
            params: {
              id: bonus.id
            }
          });
        }
      } else {
        self.triggerPaywall();
      }
    },
    goToPermalink: function goToPermalink(tile) {
      var self = this;
      if (self.$store.state.status.payment.paid === true) {
        if (tile.status.locked !== true) {
          self.$router.push({
            name: 'Lesson',
            params: {
              permalink: tile.permalink
            }
          });
        }
      } else {
        self.triggerPaywall();
      }
    },
    triggerPaywall: function triggerPaywall() {
      this.$EventBus.$emit('App::triggerPaywall', true);
    }
  },
  computed: {
    tiles: function tiles() {
      var self = this;
      if (self.isLoading) {
        return (0, _from2.default)({ length: self.dummyLoaders }, function (value, index) {
          return { kind: 'loader', key: index };
        });
      }

      var paid = self.$store.state.status.payment.paid;
      var out = [];
      self.list.forEach(function (lesson, index) {
        var locked = lesson.status.locked === true || !paid;
        out.push({
          kind: 'lesson',
          key: index,
          lessonNumber: index + 1,
          locked: locked,
          data: lesson
        });
        (lesson.bonus_modules || []).forEach(function (bonus, bonusIndex) {
          out.push({
            kind: 'bonus',
            key: index + '-' + bonusIndex,
            locked: locked,
            data: bonus,
            parent: lesson
          });
        });
      });
      return out;
    },
    isLeftLocked: function isLeftLocked() {
      return this.activeLesson <= 1;
    },
    isRightLocked: function isRightLocked() {
      return this.activeLesson >= this.list.length;
    },
    currentLessonObject: function currentLessonObject() {
      var self = this;
      if (self.list.length > 0) {
        var items = self.list.filter(function (lesson) {
          return lesson.status.locked === false;
        });
        if (items.length > 0) {
          return items[items.length - 1];
        }
      }
      return false;
    }
  }
};

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CardOrderMixin = __webpack_require__(718);

var _CardOrderMixin2 = _interopRequireDefault(_CardOrderMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Cards',
  mixins: [_CardOrderMixin2.default],
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {}
};

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "DisplayNameModal",
  props: ['display'],
  data: function data() {
    return {
      displayName: '',
      saved: false,
      saving: false,
      rejected: false,
      showModal: false,
      show_display_name: false
    };
  },
  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      self.showModal = self.display;
    });
  },

  methods: {
    toggleVisibility: function toggleVisibility() {
      var self = this;
      self.showModal = !self.showModal;
      self.saved = false;
      self.rejected = false;
    },
    reject: function reject() {
      var self = this;
      self.rejected = true;
      self.show_display_name = false;
      self.submit();
    },
    accept: function accept() {
      this.show_display_name = true;
      this.submit();
    },
    submit: function submit() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (!valid) {
          return;
        }
        self.saving = true;
        _Account2.default.updateDisplayName({
          'display_name': self.displayName,
          'show_display_name': self.show_display_name
        }).then(function (response) {
          self.saved = true;
          self.$store.state.user.scope.accepted_display_name = true;
          _UserManager2.default.getUserAndStore(self);
          self.saving = false;
        }).catch(function (error) {
          if (error.response.data && error.response.data.sub_message && error.response.data.sub_message === "DISPLAY_NAME_UNAVAILABLE") {
            self.$toastr.error("Display name unavailable, please choose a different one");
          }
          self.saving = false;
        });
      });
    }
  }
};

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _SliderModules = __webpack_require__(3411);

var _SliderModules2 = _interopRequireDefault(_SliderModules);

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

var _GettingStartedModal = __webpack_require__(3408);

var _GettingStartedModal2 = _interopRequireDefault(_GettingStartedModal);

var _LatestQuestions = __webpack_require__(3409);

var _LatestQuestions2 = _interopRequireDefault(_LatestQuestions);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HcpForum: _LatestQuestions2.default,
    HcpGettingStartedModal: _GettingStartedModal2.default,
    HcpSliderModules: _SliderModules2.default
  },
  mixins: [_HCPMixin2.default],
  name: 'hcp-view',
  data: function data() {
    return {
      downloads: {
        isLoading: true,
        modules: []
      },
      recent: {
        isLoading: true,
        modules: []
      },
      cats: {
        isLoading: true,
        data: []
      },
      quickLinks: [{
        label: 'Evidence and Papers',
        icon: 'chrome_reader_mode',
        to: 'evidence-and-papers',
        type: 'lifecat'
      }, {
        label: 'RCGP eLearning Module',
        icon: 'book',
        to: 'https://www.lowcarbprogram.com/hcp/rcgp-module',
        type: 'link'
      }, {
        label: 'Education',
        icon: 'school',
        to: 'HcpCategories',
        type: 'view'
      }]
    };
  },

  methods: {
    goToFeedbackCommission: function goToFeedbackCommission() {
      var self = this;
      self.$router.push({
        name: 'Contact',
        query: {
          commission: true
        }
      });
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.floor(Math.random() * (max - min) + min) + '%';
    },
    goToResources: function goToResources() {
      var self = this;
      self.$router.push({
        name: 'Downloads'
      });
    },
    goToFeedback: function goToFeedback() {
      var self = this;
      self.$router.push({
        name: 'Contact'
      });
    },
    getFeaturedDownloads: function getFeaturedDownloads() {
      var self = this;
      _Hcp2.default.getFeaturedDownloads().then(function (res) {
        self.downloads.modules = res.data;
        self.downloads.isLoading = false;
      });
    },
    getRecentModules: function getRecentModules() {
      var self = this;
      var params = {
        amount: 3,
        orderby: "date"
      };
      _Hcp2.default.getModules($.param(params)).then(function (res) {
        self.recent.modules = res.data;
        self.recent.isLoading = false;
      });
    },
    getCats: function getCats() {
      var self = this;
      _Hcp2.default.getResourceCats().then(function (response) {
        self.cats.data = response.data;
        self.cats.isLoading = false;
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.getRecentModules();
      self.getFeaturedDownloads();
      self.getCats();
    },
    goToResourceCat: function goToResourceCat(slug) {
      var self = this;
      self.$router.push({
        name: 'DownloadsCategory',
        params: {
          slug: slug
        }
      });
    },
    goToModule: function goToModule(slug) {
      var self = this;
      self.$router.push({
        name: 'HcpArticle',
        params: {
          slug: slug
        }
      });
    },
    goTo: function goTo(link, type) {
      var self = this;
      if (type === 'link') {
        window.open(link, '_blank');
      } else if (type === 'lifecat') {
        self.$router.push({
          name: "LifeStyleCategory",
          params: {
            slug: link
          }
        });
      } else {
        self.$router.push({
          name: link
        });
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
    if (self.isHcpVerified === false) {
      self.$router.push({
        name: 'HcpGettingStarted'
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _Weight = __webpack_require__(673);

var _Weight2 = _interopRequireDefault(_Weight);

var _BloodGlucose = __webpack_require__(455);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _index = __webpack_require__(113);

var _index2 = _interopRequireDefault(_index);

var _CardOrderMixin = __webpack_require__(718);

var _CardOrderMixin2 = _interopRequireDefault(_CardOrderMixin);

var _vueClickaway = __webpack_require__(338);

var _BloodPressure = __webpack_require__(669);

var _BloodPressure2 = _interopRequireDefault(_BloodPressure);

var _Sleep = __webpack_require__(344);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _Insulin = __webpack_require__(670);

var _Insulin2 = _interopRequireDefault(_Insulin);

var _Cholesterol = __webpack_require__(1269);

var _Cholesterol2 = _interopRequireDefault(_Cholesterol);

var _Mood = __webpack_require__(672);

var _Mood2 = _interopRequireDefault(_Mood);

var _Medication = __webpack_require__(671);

var _Medication2 = _interopRequireDefault(_Medication);

var _Nutrition = __webpack_require__(1271);

var _Nutrition2 = _interopRequireDefault(_Nutrition);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _EmailVerification = __webpack_require__(3399);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

__webpack_require__(126);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

var _Activity = __webpack_require__(454);

var _Activity2 = _interopRequireDefault(_Activity);

var _gdprReminder = __webpack_require__(3407);

var _gdprReminder2 = _interopRequireDefault(_gdprReminder);

var _MobilePhoneInput = __webpack_require__(1249);

var _MobilePhoneInput2 = _interopRequireDefault(_MobilePhoneInput);

var _Cards = __webpack_require__(3392);

var _Cards2 = _interopRequireDefault(_Cards);

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _Resources = __webpack_require__(712);

var _Resources2 = _interopRequireDefault(_Resources);

var _RecipeRating = __webpack_require__(456);

var _RecipeRating2 = _interopRequireDefault(_RecipeRating);

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _index3 = __webpack_require__(97);

var _index4 = _interopRequireDefault(_index3);

var _Category = __webpack_require__(1273);

var _Category2 = _interopRequireDefault(_Category);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(950);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _DailyCache = __webpack_require__(1661);

var _DailyCache2 = _interopRequireDefault(_DailyCache);

var _BannerBlock = __webpack_require__(3389);

var _BannerBlock2 = _interopRequireDefault(_BannerBlock);

var _vueCarousel = __webpack_require__(3357);

var _DisplayNameModal = __webpack_require__(3393);

var _DisplayNameModal2 = _interopRequireDefault(_DisplayNameModal);

var _jsSha = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  directives: {
    onClickaway: _vueClickaway.directive
  },
  mixins: [_CardOrderMixin2.default, _ScrollerMixin2.default, _HCPMixin2.default, _Category2.default],
  components: {
    DisplayNameModal: _DisplayNameModal2.default,
    Carousel: _vueCarousel.Carousel,
    Slide: _vueCarousel.Slide,
    RecipeRating: _RecipeRating2.default,
    Cards: _Cards2.default,
    MobilePhoneInput: _MobilePhoneInput2.default,
    GdprReminder: _gdprReminder2.default,
    ActivityInput: _Activity2.default,
    Alert: _Alert2.default,
    EmailVerificationPanel: _EmailVerification2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    NutritionInput: _Nutrition2.default,
    MedicationInput: _Medication2.default,
    MoodInput: _Mood2.default,
    CholesterolInput: _Cholesterol2.default,
    InsulinInput: _Insulin2.default,
    SleepInput: _Sleep2.default,
    BloodPressureInput: _BloodPressure2.default,
    BloodGlucoseInput: _BloodGlucose2.default,
    WeightInput: _Weight2.default,
    BannerBlock: _BannerBlock2.default
  },
  name: 'patient-view',
  data: function data() {
    return {
      isFabShown: true,
      settingsUpdating: false,
      fabOpen: false,
      gettingStarted: false,
      myLessons: false,
      justForYou: true,
      startedData: [],
      tipsList: null,
      list: [],
      activeLesson: 0,
      currentLesson: {},
      downloads: [],
      todaysMeals: false,
      community: false,
      trackHealth: false,
      recipes: [],
      discussions: [],
      recipesLoader: false,
      articles: [],
      articlesLoader: false,
      downloadsBg: '',
      scroller: document.getElementsByClassName('main-content')[0],
      showTips: false,
      showStarted: false,
      showLesson: false,
      lifestyleBg: '',
      communityLoader: false
    };
  },
  created: function created() {
    var self = this;

    self.$EventBus.$on('lc:settingsUpdated', function () {
      self.settingsUpdating = true;
      _index2.default.getUserAndStore(self);
    });
    self.gettingStarted = true;
    self.myLessons = true;
    self.todaysMeals = true;
    self.justForYou = true;
    self.community = true;
    self.trackHealth = true;
  },

  watch: {
    gettingStarted: function gettingStarted() {
      var self = this;
      self.$nextTick(function () {
        _jsCookie2.default.set('gettingStarted', self.gettingStarted);
      });
    },
    myLessons: function myLessons() {
      var self = this;
      self.$nextTick(function () {
        _jsCookie2.default.set('myLessons', self.myLessons);
      });
    },
    todaysMeals: function todaysMeals() {
      var self = this;
      self.$nextTick(function () {
        _jsCookie2.default.set('meals', self.todaysMeals);
      });
    },
    justForYou: function justForYou() {
      var self = this;
      self.$nextTick(function () {
        _jsCookie2.default.set('articles', self.justForYou);
      });
    },
    community: function community() {
      var self = this;
      self.$nextTick(function () {
        _jsCookie2.default.set('community', self.community);
      });
    },
    trackHealth: function trackHealth() {
      var self = this;
      self.$nextTick(function () {
        _jsCookie2.default.set('track', self.trackHealth);
      });
    },
    fabOpen: function fabOpen() {
      var self = this;
      if (self.$refs.speedDial.$el.classList.contains('md-active')) {
        self.$refs.addProgressIcon.$el._tooltip.hide();
        self.$refs.addFoodDiaryIcon.$el._tooltip.hide();
      } else {
        window.setTimeout(function () {
          self.$refs.addProgressIcon.$el._tooltip.show();
          self.$refs.addFoodDiaryIcon.$el._tooltip.show();
        }.bind(self), 300);
      }
    }
  },

  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/dashboard');
    self.scroller.addEventListener('scroll', self.checkIfFabShouldBeShown);

    if (self.fabOpen) {
      self.$refs.addProgressIcon.$el._tooltip.show();
      self.$refs.addFoodDiaryIcon.$el._tooltip.show();
    }

    self.initMounted();

    if (_jsCookie2.default.get('gettingStarted')) {
      var pref = JSON.parse(_jsCookie2.default.get('gettingStarted'));
      self.gettingStarted = pref;
    }

    if (_jsCookie2.default.get('myLessons')) {
      var lesson = JSON.parse(_jsCookie2.default.get('myLessons'));
      self.myLessons = lesson;
    }

    if (_jsCookie2.default.get('meals')) {
      var meal = JSON.parse(_jsCookie2.default.get('meals'));
      self.todaysMeals = meal;
    }

    if (_jsCookie2.default.get('articles')) {
      var articles = JSON.parse(_jsCookie2.default.get('articles'));
      self.justForYou = articles;
    }

    if (_jsCookie2.default.get('community')) {
      var community = JSON.parse(_jsCookie2.default.get('community'));
      self.community = community;
    }

    if (_jsCookie2.default.get('track')) {
      var track = JSON.parse(_jsCookie2.default.get('track'));
      self.trackHealth = track;
    }
  },

  methods: {
    gettingStartedPush: function gettingStartedPush(data) {
      var self = this;
      switch (data.category) {
        case 'activity':
          self.goToCurrentLesson();
          break;
        case 'blood-glucose':
        case 'progress':
          self.$router.push({
            name: 'WeightCheckin'
          });
          break;
        case 'discussion':
        case 'support':
          self.$router.push({
            name: 'QuestionsIndex'
          });
          break;
        case 'food-diary':
          self.$router.push({
            name: 'RecipeIndex'
          });
          break;
        case 'class':
          self.$router.push({
            name: "LifeStyleCategory",
            params: {
              slug: 'fitness-classes'
            }
          });
          break;
        case 'lifestyle':
          self.$router.push({
            name: "LifeStyle"
          });
          break;
        default:
          break;
      }
    },
    getBreakfast: function getBreakfast() {
      var self = this;
      self.recipes[0] = {};
      self.$forceUpdate();
      _Recipes2.default.search({
        page: 0,
        limit: 1,
        categories: 'breakfast',
        dietaryTypes: self.dietaryTypesList().join(','),
        shuffle: true
      }).then(function (response) {
        self.recipes[0] = response.data.recipes[0];
        self.$forceUpdate();
        _DailyCache2.default.set(self.recipesCacheKey(), self.recipes);
      });
    },
    getLunch: function getLunch() {
      var self = this;
      self.recipes[1] = {};
      self.$forceUpdate();
      _Recipes2.default.search({
        page: 0,
        limit: 1,
        categories: 'lunch',
        dietaryTypes: self.dietaryTypesList().join(','),
        shuffle: true
      }).then(function (response) {
        self.recipes[1] = response.data.recipes[0];
        self.$forceUpdate();
        _DailyCache2.default.set(self.recipesCacheKey(), self.recipes);
      });
    },
    getDinner: function getDinner() {
      var self = this;
      self.recipes[2] = {};
      self.$forceUpdate();
      _Recipes2.default.search({
        page: 0,
        limit: 1,
        categories: 'dinner',
        dietaryTypes: self.dietaryTypesList().join(','),
        shuffle: true
      }).then(function (response) {
        self.recipes[2] = response.data.recipes[0];
        self.$forceUpdate();
        _DailyCache2.default.set(self.recipesCacheKey(), self.recipes);
      });
    },
    upperTwoInitials: function upperTwoInitials(displayName) {
      if (displayName.indexOf(' ') !== -1) {
        var splitString = displayName.split(' ');
        return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
      }
      return displayName.charAt(0).toUpperCase();
    },
    formatDate: function formatDate(data) {
      var self = this;
      return moment(data).fromNow();
    },
    setInitialActiveLesson: function setInitialActiveLesson() {
      var self = this;

      self.activeLesson = self.list.filter(function (lesson) {
        return lesson.status.locked === false;
      }).length;
      self.currentLesson = self.list[self.activeLesson - 1];
    },
    clickOutsideOfSpeedDial: function clickOutsideOfSpeedDial() {
      var self = this;
      self.$refs.addProgressIcon.$el._tooltip.hide();
      self.$refs.addFoodDiaryIcon.$el._tooltip.hide();
    },
    toggle: function toggle() {
      var self = this;
      self.fabOpen = !self.fabOpen;
    },
    closeFab: function closeFab() {

      var self = this;

      self.fabOpen = false;
    },
    checkIfFabShouldBeShown: function checkIfFabShouldBeShown() {
      var self = this;
      if (self.scroller.clientWidth <= 600) {
        _ScrollManager2.default.isElementInViewport(self.$refs.scrollDetector) ? self.isFabShown = false : self.isFabShown = true;
      }
    },
    getScrollbarWidth: function getScrollbarWidth() {
      return _ScrollManager2.default.getScrollbarWidth();
    },
    goTo: function goTo(name) {
      this.$router.push({
        name: name
      });
    },
    openGettingStarted: function openGettingStarted() {
      var self = this;
      self.gettingStarted = !self.gettingStarted;
    },
    openMyLessons: function openMyLessons() {
      var self = this;
      self.myLessons = !self.myLessons;
    },
    openTodaysMeals: function openTodaysMeals() {
      var self = this;
      self.todaysMeals = !self.todaysMeals;
    },
    openPersonalised: function openPersonalised() {
      var self = this;
      self.justForYou = !self.justForYou;
    },
    openCommunity: function openCommunity() {
      var self = this;
      self.community = !self.community;
    },
    openTrackers: function openTrackers() {
      var self = this;
      self.trackHealth = !self.trackHealth;
    },
    goToCurrentLesson: function goToCurrentLesson() {
      var self = this;
      self.$router.push({
        name: 'Lesson',
        params: {
          permalink: self.currentLesson.permalink
        }
      });
    },
    downloadResource: function downloadResource(data) {
      window.open(data.link, '_blank');
    },
    goToDownloads: function goToDownloads() {
      var self = this;
      self.$router.push({
        name: 'Downloads'
      });
    },
    goToLifestyle: function goToLifestyle() {
      var self = this;
      self.$router.push({
        name: 'LifeStyle'
      });
    },
    goToArticle: function goToArticle(data) {
      var self = this;
      self.$router.push({
        name: 'LifeStyleArticle',
        params: {
          permalink: data.post_slug
        }
      });
    },
    goToCommunity: function goToCommunity() {
      var self = this;
      self.$router.push({
        name: 'QuestionsIndex'
      });
    },
    goToDiscussion: function goToDiscussion(data) {
      var self = this;
      self.$router.push({
        name: 'QuestionThread',
        params: {
          id: data.question_id
        }
      });
    },
    goToRecipe: function goToRecipe(data) {
      var self = this;
      self.$router.push({
        name: 'RecipeDetail',
        params: {
          id: data
        }
      });
    },
    getArticles: function getArticles() {
      var self = this;
      var cacheKey = 'dashboard:articles:' + self.$store.state.user.scope.user_id;

      var applyArticles = function applyArticles(data) {
        var list = (data || []).slice();
        if (list[4]) self.lifestyleBg = list[4].post_image;
        self.articles = list.slice(0, 4);
        self.articlesLoader = true;
      };
      _DailyCache2.default.get(cacheKey).then(function (cached) {
        if (cached) {
          applyArticles(cached);
          return;
        }
        self.articlesLoader = false;
        _index4.default.getPosts(1, 10, 'medium').then(function (response) {
          _DailyCache2.default.set(cacheKey, response.data);
          applyArticles(response.data);
        });
      });
    },
    recipesCacheKey: function recipesCacheKey() {
      return 'dashboard:recipes:' + this.$store.state.user.scope.user_id;
    },
    getRecipes: function getRecipes() {
      var self = this;
      _DailyCache2.default.get(self.recipesCacheKey()).then(function (cached) {
        if (cached && cached.length) {
          self.recipes = cached.slice();
          self.recipesLoader = false;
          return;
        }
        self.recipesLoader = true;

        _Recipes2.default.search({
          page: 0,
          limit: 1,
          categories: 'breakfast',
          dietaryTypes: self.dietaryTypesList().join(','),
          shuffle: true
        }).then(function (response) {
          self.recipes.unshift(response.data.recipes[0]);
          _Recipes2.default.search({
            page: 0,
            limit: 1,
            categories: 'lunch',
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true
          }).then(function (response) {
            self.recipes.push(response.data.recipes[0]);
            _Recipes2.default.search({
              page: 0,
              limit: 1,
              categories: 'dinner',
              dietaryTypes: self.dietaryTypesList().join(','),
              shuffle: true
            }).then(function (response) {
              self.recipesLoader = false;
              self.recipes.push(response.data.recipes[0]);
              _DailyCache2.default.set(self.recipesCacheKey(), self.recipes);
            });
          });
        });
      });
    },
    getDiscussions: function getDiscussions() {
      var self = this;
      self.communityLoader = false;
      _Discussion2.default.getDiscussionQuestions({
        page: 1,
        per_page: 4,
        type: "MOST_RECENT"
      }).then(function (response) {

        if (response === undefined) return;

        self.discussions = response.data.questions;
        self.communityLoader = true;
        var chunked = _lodash2.default.chunk(self.discussions, 2);
        self.discussions = chunked;
      });
    },
    getResources: function getResources() {
      var self = this;
      var cacheKey = 'dashboard:resources:' + self.$store.state.user.scope.user_id;

      var applyResources = function applyResources(data) {
        self.downloads = (data || []).slice();
        self.$nextTick(function () {
          self.downloadsBg = self.downloads[0].image_url;
          self.downloads.reverse();
          self.downloads = self.downloads.slice(0, 2);
        });
        self.showLesson = true;
      };
      _DailyCache2.default.get(cacheKey).then(function (cached) {
        if (cached) {
          applyResources(cached);
          return;
        }
        _Resources2.default.getResources().then(function (response) {
          _DailyCache2.default.set(cacheKey, response.data);
          applyResources(response.data);
        });
      });
    },
    getLessons: function getLessons() {
      var self = this;
      if (self.$store.state.lessons.length > 0) {
        self.list = self.$store.state.lessons;
        self.$nextTick(function () {
          self.setInitialActiveLesson();
          self.isLoading = false;
        });
      } else {
        self.isLoading = true;
        _Lessons2.default.getLessonsList().then(function (response) {
          self.list = response.data;
          self.$store.state.lessons = response.data;
          self.$nextTick(function () {
            self.setInitialActiveLesson();
            self.isLoading = false;
          });
        });
      }
    },
    getTips: function getTips() {
      var self = this;
      _axios2.default.get(_config2.default.apiUrl + 'tips/list').then(function (res) {
        self.tipsList = res.data;
        self.showTips = true;
      }).catch(function (err) {
        console.error(err);
      });
    },
    getStartedData: function getStartedData() {
      var self = this;
      var cacheKey = 'dashboard:getting-started:' + self.$store.state.user.scope.user_id;
      _DailyCache2.default.get(cacheKey).then(function (cached) {
        if (cached) {
          self.startedData = cached;
          self.showStarted = true;
          return;
        }
        _axios2.default.get(_config2.default.apiUrl + 'onboarding/getting-started').then(function (res) {
          self.showStarted = true;
          self.startedData = res.data;
          _DailyCache2.default.set(cacheKey, res.data);
        }).catch(function (err) {
          console.error(err);
        });
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.getLessons();
      self.getResources();
      self.getRecipes();
      self.getArticles();
      self.getDiscussions();
      self.getTips();
      self.getStartedData();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'date-picker',
  props: {
    iconMode: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: moment().format('DD-MM-YYYY hh:mm a')
    },
    type: {
      type: String,
      default: "datetime",
      validator: function validator(value) {
        switch (value) {
          case 'date':
            return true;
            break;
          case 'datetime':
            return true;
            break;
          default:
            return false;
            break;
        }
      }
    }
  },
  data: function data() {
    return {
      dateFormat: _DatePickerManager2.default,
      date: "",
      time: ""
    };
  },
  mounted: function mounted() {
    var self = this;
    self.date = moment().format('DD-MM-YYYY');
    self.time = moment().format('hh:mm a');
    self.$nextTick(function () {
      self.emitValue();
    });
  },

  methods: {
    dateChanged: function dateChanged(value) {
      var self = this;
      self.date = value;
      self.emitValue();
    },
    timeChanged: function timeChanged(value) {
      var self = this;
      self.time = value;
      self.emitValue();
    },
    emitValue: function emitValue() {
      var self = this;
      if (self.isHydrated()) {
        var finalDate = void 0;
        if (self.type === "datetime") {
          var dateTime = moment(self.date + ' ' + self.time, 'DD-MM-YYYY hh:mm a');
          finalDate = dateTime.format();
          self.$emit('input', finalDate);
        }
        if (self.type === "date") {
          var date = moment(self.date, 'DD-MM-YYYY');
          var _finalDate = date.format('YYYY-MM-DD');
          self.$emit('input', _finalDate);
        }
      }
    },
    isHydrated: function isHydrated() {
      var self = this;
      if (self.type === "datetime") {
        return self.time !== "" && self.date !== "";
      } else {
        return self.date !== "";
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'hcp-downloads',
  data: function data() {
    return {
      isLoading: true,
      cats: []
    };
  },

  methods: {
    getResources: function getResources() {
      var self = this;
      _Hcp2.default.getResourceCats().then(function (response) {
        self.cats = response.data;
        self.isLoading = false;
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.isLoading = true;
      self.getResources();
    },
    goTo: function goTo(slug) {
      var self = this;
      self.$router.push({
        name: 'DownloadsCategory',
        params: {
          slug: slug
        }
      });
    }
  },
  computed: {
    chunkedItems: function chunkedItems() {
      var self = this;
      return _lodash2.default.chunk(_lodash2.default.toArray(self.cats), 2);
    }
  },
  mounted: function mounted() {
    var self = this;
    _TitleManager2.default.replaceTitle("Resources");
    self.initMounted();
  }
};

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(1679);

var _set2 = _interopRequireDefault(_set);

var _Resources = __webpack_require__(712);

var _Resources2 = _interopRequireDefault(_Resources);

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'patient-downloads',
  data: function data() {
    return {
      isLoading: true,
      selectedFilter: "resources",
      user: {},
      items: [],
      activeTab: 'grid',
      showFilterLoader: false,
      tabs: [{
        label: this.$t('message.gridViewText'),
        key: 'grid'
      }, {
        label: this.$t('message.listViewText'),
        key: 'list'
      }]
    };
  },

  methods: {
    saveTrackingCount: function saveTrackingCount(res) {
      var self = this;
      if (self.$store.state.status.payment.paid === true) {
        if (self.selectedFilter === 'resources') {
          _Resources2.default.saveResourceCount({
            resource_id: res.resource_id
          });
        } else {
          _Lessons2.default.saveDownloadCount({
            download_id: res.download_id
          });
        }
        window.open(res.link, '_blank');
      } else {
        self.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    updateFilter: function updateFilter(value) {
      var locked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (locked !== true) {
        var self = this;
        self.items = [];
        self.isLoading = false;
        self.showFilterLoader = true;

        self.selectedFilter = value;
        self.$nextTick(function () {

          if (value === 'seasonal') {
            self.loadSeasonal();
          }

          if (value === 'resources') {
            self.loadResources();
          } else {

            if (value === 'mealplans') {
              self.loadMealPlans();
            } else {
              self.loadDownloads(value);
            }
          }
        });
      }
    },
    setTab: function setTab(tab) {
      var self = this;
      self.activeTab = tab;
    },
    loadSeasonal: function loadSeasonal() {
      var self = this;
      _Resources2.default.getSeasonalDownloads().then(function (response) {
        self.items = response.data;
        self.isLoading = false;
        self.showFilterLoader = false;
      });
    },
    loadMealPlans: function loadMealPlans() {
      var self = this;
      _Resources2.default.getMealPlans().then(function (response) {
        self.items = response.data;
        self.isLoading = false;
        self.showFilterLoader = false;
      });
    },
    loadResources: function loadResources() {
      var self = this;
      _Resources2.default.getResources().then(function (response) {
        self.items = response.data;
        self.isLoading = false;
        self.showFilterLoader = false;
      });
    },
    loadDownloads: function loadDownloads(lesson_id) {
      var self = this;
      _Lessons2.default.getDownloadsByCourseId(lesson_id).then(function (response) {
        self.items = response.data;
        self.isLoading = false;
        self.showFilterLoader = false;
      });
    }
  },
  computed: {
    chunkedItems: function chunkedItems() {
      var self = this;
      return _lodash2.default.chunk(_lodash2.default.toArray(self.items), 3);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/downloads');
    _Lessons2.default.getLessonsList().then(function (response) {

      var uniqueWeekNames = new _set2.default();
      self.lessons = response.data.filter(function (lesson) {
        if (!lesson.week_name) return false;
        if (uniqueWeekNames.has(lesson.week_name)) return false;
        uniqueWeekNames.add(lesson.week_name);
        return true;
      });

      if (self.selectedFilter === 'resources') {
        self.loadResources();
      }
    });
  }
};

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'email-update',
  data: function data() {
    return {
      isSaving: false,
      model: {
        new_email: ''
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          _Account2.default.updateAccountEmail(self.model.new_email).then(function (response) {
            self.$toastr.success(self.$t('message.securityPreferencesCheckEmailAt') + ' ' + self.model.new_email);
            self.isSaving = false;
            self.$router.push({
              name: 'SettingsGeneral'
            });
          }).catch(function (error) {
            if (error.response) {
              self.$toastr.error(error.response.data.message);
              self.isSaving = false;
            }
          });
        }
      });
    }
  }
};

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Alert: _Alert2.default },
  name: 'email-verification-panel',
  data: function data() {
    return {
      hasSent: false,
      isSending: false
    };
  },

  methods: {
    sendConfirmationEmail: function sendConfirmationEmail() {
      var self = this;
      self.isSending = true;
      _Account2.default.sendAccountVerification().then(function () {
        self.hasSent = true;
        self.isSending = false;
      });
    }
  }
};

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "MessageBox",
  props: {
    title: String,
    message: String,
    messageType: String
  },
  computed: {
    messageClass: function messageClass() {
      var self = this;
      var containerClass = "info";
      if (self.messageType === 'error') {
        containerClass = "error";
      }
      if (self.messageType === 'success') {
        containerClass = "success";
      }
      return containerClass;
    },
    messageIcon: function messageIcon() {
      var self = this;
      var messageIcon = "https://res.cloudinary.com/grohealth/image/upload/v1587108815/Low%20Carb%20Program/Email-Assets/warning-yellow-24px.png";
      if (self.messageType === 'error') {
        messageIcon = "https://res.cloudinary.com/grohealth/image/upload/v1587109063/Low%20Carb%20Program/Email-Assets/warning-red-24px.png";
      }
      if (self.messageType === 'success') {
        messageIcon = "https://res.cloudinary.com/grohealth/image/upload/v1587108821/Low%20Carb%20Program/Email-Assets/ic_small_circle_tick.png";
      }
      return messageIcon;
    }
  }
};

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _rxjs = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'fd-autocomplete-dialog',
  props: {
    searchTerm: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      voiceSupported: false,
      recognition: null,
      isListening: false,
      isSearching: false,
      searchValue: "",
      suggestions: []
    };
  },

  watch: {
    'searchValue': function searchValue() {
      if (this.searchValue === "") {
        this.suggestions = [];
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.searchValue = self.searchTerm;

    if (self.searchTerm !== "") {
      self.autoComplete();
    }

    self.initVoiceRecognition();

    self.initScrollFix();
    $(window).resize(function () {
      self.initScrollFix();
    });

    var autoCompleteElement = $('.mu-paper.search-area .mu-text-field-input');
    var observableConditionElement = _rxjs.Observable.fromEvent(autoCompleteElement, 'keydown').map(function (x) {
      return x;
    });
    var delayedSearch = observableConditionElement.debounceTime(300).distinctUntilChanged();
    delayedSearch.subscribe(function (e) {
      if (e.key === "Enter") {
        self.handleSelection(self.searchValue);
      }
      if (self.searchValue !== "") {
        self.autoComplete();
      }
    });
  },

  methods: {
    initVoiceRecognition: function initVoiceRecognition() {
      var self = this,
          isSupported = window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition;
      if (isSupported !== undefined) {

        self.voiceSupported = true;
        self.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition)();
        self.recognition.lang = 'en-GB';
        self.recognition.interimResults = false;
        self.recognition.maxAlternatives = 5;

        self.recognition.onaudiostart = function (event) {
          self.isListening = true;
        };

        self.recognition.onaudioend = function (event) {
          self.isListening = false;
        };

        self.recognition.onresult = function (event) {
          if (typeof event.results === 'undefined') {
            recognition.stop();
            return;
          }
          for (var i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
              self.searchValue = event.results[i][0].transcript;
              self.autoComplete();
              self.isListening = false;
            } else {
              self.searchValue = event.results[i][0].transcript;
              self.autoComplete();
              self.isListening = false;
            }
          }
        };
      } else {
        self.voiceSupported = false;
      }
    },
    startVoiceRecognition: function startVoiceRecognition() {
      var self = this;
      if (!self.isListening) {
        self.isListening = true;
        self.recognition.start();
      } else {
        self.recognition.stop();
      }
    },
    stopVoiceRecognition: function stopVoiceRecognition() {
      var self = this;
      if (self.isListening === true) {
        self.isListening = false;
        self.recognition.stop();
      }
    },
    initScrollFix: function initScrollFix() {
      var headerHeight = $('.add-food-dialog .blueHeader').outerHeight();
      var searchHeight = $('.add-food-dialog .mu-content-block').outerHeight();
      var panelHeight = $('.add-food-dialog').outerHeight();
      var scrollHeight = panelHeight - (searchHeight + headerHeight) - 8;
      $('.food-search-dialog .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
    },
    handleSelection: function handleSelection(food) {
      var self = this;
      self.$emit('foodNameSelected', 's', food);
    },
    highlight: function highlight(word) {
      var self = this;
      return word.replace(self.searchValue.toLowerCase(), '<span class=\'highlight\'>' + self.searchValue.toLowerCase() + '</span>');
    },
    autoComplete: function autoComplete() {
      var self = this;
      self.isSearching = true;
      self.suggestions = [];
      _Food2.default.autoComplete(self.searchValue).then(function (response) {
        self.suggestions = response.data;
        self.isSearching = false;
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _FoodDiaryNutritionMixin = __webpack_require__(354);

var _FoodDiaryNutritionMixin2 = _interopRequireDefault(_FoodDiaryNutritionMixin);

var _NutrientLocalizer = __webpack_require__(275);

var _NutrientLocalizer2 = _interopRequireDefault(_NutrientLocalizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeral = __webpack_require__(90);

var leftPaneWidth = {
  desktop: "50",
  tablet: "50"
};

var servingPickerWidth = {
  servingInput: {
    desktop: "40",
    tablet: "40"
  },
  servingSelector: {
    desktop: "60",
    tablet: "60"
  }
};

exports.default = {
  name: 'fd-edit-food-dialog',
  mixins: [_FoodDiaryNutritionMixin2.default, _NutrientLocalizer2.default],
  props: {
    title: {
      type: String,
      default: "Edit"
    },
    foodObj: {
      type: Object
    },
    mealTypeId: {
      type: Number
    }
  },
  watch: {
    'timeModel.time': function timeModelTime() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    },
    'timeModel.date': function timeModelDate() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    },
    'model.serving_id': function modelServing_id() {
      var self = this,
          serving_id = self.model.serving_id;
      self.activeServingObject = self.food.servings.filter(function (item) {
        return item.serving_id === self.model.serving_id;
      })[0];
      self.computeHeightForRightPane();
    }
  },
  data: function data() {
    return {
      maxDate: moment().format('DD-MM-YYYY'),
      dateFormat: _DatePickerManager2.default,
      date: new Date(),
      isSaving: false,
      isLoading: true,
      isNutritionPaneVisible: true,
      scroller: document.getElementsByClassName('main-content')[0],
      activeServingObject: {},
      food: {},
      leftPaneWidth: leftPaneWidth,
      servingPickerWidth: servingPickerWidth,
      timeModel: {
        date: "",
        time: ""
      },
      model: {
        date: "",
        servings: 1,
        serving_id: 1
      }
    };
  },
  mounted: function mounted() {
    var self = this;

    var date = moment(self.foodObj.date_created),
        time = date.format('hh:mm a');
    self.timeModel.time = time;
    self.timeModel.date = date.format('DD-MM-YYYY');

    _Food2.default.getById(self.foodObj.fs_food_id).then(function (response) {
      self.food = response.data.food;
      self.model.serving_id = self.foodObj.fs_serving_id;
      self.model.servings = self.foodObj.servings;
      self.isLoading = false;
      self.$nextTick(function () {
        self.initScrollFix();
        self.computeHeightForRightPane();
      });
    });
  },

  methods: {
    isDst: function isDst(now) {
      if (moment(now).isDST()) {
        return true;
      }
      return false;
    },
    setServingSize: function setServingSize(size) {
      var self = this;
      self.model.servings = size;
      self.$forceUpdate();
    },
    updateFood: function updateFood() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          var model = {
            date: self.model.date,
            food_id: self.foodObj.food_id,
            food_name: self.food.food_name,
            servings: self.model.servings,
            serving_id: self.model.serving_id,
            nutrients: self.activeServingObject.nutrients
          };
          _Food2.default.updateFood(model).then(function (response) {
            self.$emit('foodUpdated');
            self.closeDialog('addFoodDialog');
          });
        }
      });
    },
    toggleNutritionPane: function toggleNutritionPane() {
      var self = this;
      self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
      if (self.isNutritionPaneVisible !== true) {
        self.leftPaneWidth.tablet = "100";
        self.leftPaneWidth.desktop = "100";
        self.servingPickerWidth.servingInput.desktop = "20";
        self.servingPickerWidth.servingInput.tablet = "20";
        self.servingPickerWidth.servingSelector.desktop = "80";
        self.servingPickerWidth.servingSelector.tablet = "80";
      } else {
        self.leftPaneWidth.tablet = "50";
        self.leftPaneWidth.desktop = "50";
        self.servingPickerWidth.servingInput.desktop = "40";
        self.servingPickerWidth.servingInput.tablet = "40";
        self.servingPickerWidth.servingSelector.desktop = "60";
        self.servingPickerWidth.servingSelector.tablet = "60";
      }
      self.$nextTick(function () {
        self.computeHeightForRightPane();
      });
    },
    rounded: function rounded(num) {
      var number = numeral(num.toFixed(2));
      return number.format('0,0.0');
    },
    initScrollFix: function initScrollFix() {
      var headerHeight = $('.food-result .blueHeader').outerHeight(true);
      var displayBar = $('.food-result .mu-paper').outerHeight(true);
      var panelHeight = $('.add-food-dialog').outerHeight(true);
      var cardActionsHeight = $('.card-actions').outerHeight(true);
      var scrollHeight = panelHeight - (headerHeight + displayBar + cardActionsHeight);
      $('.food-dialog-container .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
    },
    computeHeightForRightPane: function computeHeightForRightPane() {
      var scrollHeight = $('.food-result .scrollable-area').outerHeight(true);
      $('.rightPane').attr('style', 'height:' + scrollHeight + 'px;overflow:auto');
    },
    userDecidesTo: function userDecidesTo(option) {
      this.$emit('choseToSearchWith', option);
    },
    closeDialog: function closeDialog(ref) {
      this.$emit('closeDialog', ref);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(11)))

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _NutrientLocalizer = __webpack_require__(275);

var _NutrientLocalizer2 = _interopRequireDefault(_NutrientLocalizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeral = __webpack_require__(90);

var leftPaneWidth = {
  desktop: "50",
  tablet: "50"
};

var servingPickerWidth = {
  servingInput: {
    desktop: "40",
    tablet: "40"
  },
  servingSelector: {
    desktop: "60",
    tablet: "60"
  }
};

exports.default = {
  mixins: [_NutrientLocalizer2.default],
  name: 'fd-food-result-dialog',
  props: {
    inputDate: {
      type: String
    },
    title: {
      type: String,
      default: ""
    },
    foodId: {
      type: Number
    },
    mealTypeId: {
      type: Number
    },
    mode: {
      type: String,
      default: ""
    }
  },
  watch: {
    'model.serving_id': function modelServing_id() {
      var self = this,
          serving_id = self.model.serving_id;
      self.activeServingObject = self.food.servings.filter(function (item) {
        return item.serving_id === self.model.serving_id;
      })[0];
      self.computeHeightForRightPane();
    },
    'timeModel.time': function timeModelTime() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    },
    'timeModel.date': function timeModelDate() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    }
  },
  data: function data() {
    return {
      maxDate: moment().format('DD-MM-YYYY'),
      modelDate: "",
      isSaving: false,
      isLoading: true,
      isNutritionPaneVisible: true,
      dateFormat: _DatePickerManager2.default,
      scroller: document.getElementsByClassName('main-content')[0],
      activeServingObject: {},
      food: {},
      leftPaneWidth: leftPaneWidth,
      servingPickerWidth: servingPickerWidth,
      model: {
        servings: 1,
        serving_id: 0
      },
      timeModel: {
        date: "",
        time: ""
      }
    };
  },
  mounted: function mounted() {

    var self = this;
    var date = moment(self.inputDate, 'DD-MM-YYYY hh:mm a'),
        time = date.format('hh:mm a');
    var checkToday = moment();
    self.timeModel.time = time;
    self.timeModel.date = date.format('DD-MM-YYYY');
    _Food2.default.getById(self.foodId).then(function (response) {
      self.food = response.data.food;
      self.model.serving_id = self.food.servings[0].serving_id;
      self.isLoading = false;
      self.$nextTick(function () {
        self.initScrollFix();
        self.computeHeightForRightPane();
        $(self.$refs['dateInput']).val(moment(self.modelDate).format('YYYY-MM-DD'));
        $(self.$refs['timeInput']).val(moment(self.modelDate).format('hh:mm'));
      });
      self.$forceUpdate();
    });
  },

  methods: {
    dateChanged: function dateChanged() {
      var self = this;
      var date = self.$refs['dateInput'].value;
      var time = self.$refs['timeInput'].value;
      var datetime = date + ' ' + time;
    },
    isDst: function isDst(date) {
      if (moment(date).isDST()) {
        return true;
      }
      return false;
    },
    setServingSize: function setServingSize(size) {
      var self = this;
      self.model.servings = size;
      self.$forceUpdate();
    },
    saveFood: function saveFood() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          var model = {
            date: self.model.date,
            meal_type_id: self.mealTypeId,
            foods: [{
              food_id: self.food.food_id,
              food_name: self.food.food_name,
              servings: self.model.servings,
              serving_id: self.model.serving_id,
              nutrients: self.activeServingObject.nutrients
            }]
          };
          _Food2.default.addFoods(model).then(function (response) {
            self.isSaving = false;
            self.$emit('foodAdded');
            self.closeDialog('addFoodDialog');
          }).catch(function (error) {
            self.isSaving = false;
            self.closeDialog('addFoodDialog');
          });
        }
      });
    },
    toggleNutritionPane: function toggleNutritionPane() {
      var self = this;
      self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
      if (self.isNutritionPaneVisible !== true) {
        self.leftPaneWidth.tablet = "100";
        self.leftPaneWidth.desktop = "100";
        self.servingPickerWidth.servingInput.desktop = "20";
        self.servingPickerWidth.servingInput.tablet = "20";
        self.servingPickerWidth.servingSelector.desktop = "80";
        self.servingPickerWidth.servingSelector.tablet = "80";
      } else {
        self.leftPaneWidth.tablet = "50";
        self.leftPaneWidth.desktop = "50";
        self.servingPickerWidth.servingInput.desktop = "40";
        self.servingPickerWidth.servingInput.tablet = "40";
        self.servingPickerWidth.servingSelector.desktop = "60";
        self.servingPickerWidth.servingSelector.tablet = "60";
      }
      self.$nextTick(function () {
        self.computeHeightForRightPane();
      });
    },
    rounded: function rounded(num) {
      var number = numeral(num.toFixed(2));
      return number.format('0,0.0');
    },
    humanize: function humanize(str) {
      var frags = str.split('_');
      for (var i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    getUnit: function getUnit(key) {
      switch (key) {
        case 'calories':
          return 'kcal';
          break;
        case 'protein':
          return 'g';
          break;
        case 'carbohydrate':
          return 'g';
          break;
        case 'sugar':
          return 'g';
          break;
        case 'fat':
          return 'g';
          break;
        case 'saturated_fat':
          return 'g';
          break;
        case 'monounsaturated_fat':
          return 'g';
          break;
        case 'polyunsaturated_fat':
          return 'g';
          break;
        case 'cholesterol':
          return 'g';
          break;
        case 'fibre':
          return 'g';
          break;
        case 'sodium':
          return 'mg';
          break;
        case 'potassium':
          return 'mg';
          break;
      }
    },
    initScrollFix: function initScrollFix() {
      var headerHeight = $('.add-food-dialog .blueHeader').outerHeight(true);
      var displayBar = $('.food-result .mu-paper').outerHeight(true);
      var panelHeight = $('.add-food-dialog').outerHeight(true);
      var cardActionsHeight = $('.card-actions').outerHeight(true);
      var scrollHeight = panelHeight - (headerHeight + displayBar + cardActionsHeight);
      $('.food-dialog-container .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
    },
    computeHeightForRightPane: function computeHeightForRightPane() {
      var scrollHeight = $('.food-dialog-container .scrollable-area').outerHeight(true);
      $('.rightPane').attr('style', 'height:' + scrollHeight + 'px;overflow:auto');
    },
    userDecidesTo: function userDecidesTo(option) {
      this.$emit('choseToSearchWith', option);
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(11)))

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FoodDiaryNutritionMixin = __webpack_require__(354);

var _FoodDiaryNutritionMixin2 = _interopRequireDefault(_FoodDiaryNutritionMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ProgressItem",
  mixins: [_FoodDiaryNutritionMixin2.default],
  props: {
    barMode: {
      type: String, default: function _default() {
        return "indeterminate";
      }
    },
    value: Number,
    total: Number,
    color: String,
    unit: {
      type: String,
      default: function _default() {
        return 'g';
      }
    },
    isLast: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    chartLabel: function chartLabel() {
      switch (this.label.toLowerCase()) {
        case "carbs":
          return this.$t('message.nutrientCarbohydrateShort');
        case "fat":
          return this.$t('message.nutrientFat');
        case "protein":
          return this.$t('message.nutrientProtein');
        default:
          return this.label;
      }
    }
  }

};

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _contentBlock = __webpack_require__(227);

var _contentBlock2 = _interopRequireDefault(_contentBlock);

var _flexbox = __webpack_require__(3371);

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__(660);

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuFlexboxItem: _flexboxItem2.default,
    MuFlexbox: _flexbox2.default,
    MuContentBlock: _contentBlock2.default
  },
  name: 'fd-landing-dialog',
  props: {
    title: {
      type: String,
      default: ""
    },
    mealTypeId: {
      type: Number,
      default: 1
    },
    date: {
      type: String,
      default: ''
    }

  },
  watch: {
    'mealTypeId': function mealTypeId() {
      var self = this;
      _Food2.default.getRecents(self.mealTypeId).then(function (response) {
        self.recents = response.data;
      });
    }
  },
  data: function data() {
    return {
      isRecentsLoading: true,
      recents: []
    };
  },
  mounted: function mounted() {
    var self = this;

    _Food2.default.getRecents(self.mealTypeId).then(function (response) {
      self.recents = response.data;
    });
  },

  methods: {
    copyYesterdaysMeal: function copyYesterdaysMeal() {
      var self = this;
      _Food2.default.copyYesterdaysMeal(self.mealTypeId).then(function (response) {
        self.$emit('closeDialogAndReload');
      }).catch(function () {
        var meal = void 0;
        switch (self.mealTypeId) {
          case 1:
            meal = self.$t('message.foodDiaryBreakfast');
            break;
          case 2:
            meal = self.$t('message.foodDiaryLunch');
            break;
          case 3:
            meal = self.$t('message.foodDiaryDinner');
          case 4:
            meal = self.$t('message.foodDiarySnack');
            break;
        }
      });
    },
    userDecidesTo: function userDecidesTo(option) {
      this.$emit('choseToSearchWith', option);
    },
    selectRecent: function selectRecent(item) {
      this.$emit('onRecentItemSelected', item.fs_food_id);
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  },
  computed: {
    isDateToday: function isDateToday() {
      var self = this;
      var date = moment(self.date);

      var today = moment();

      if (date.isSame(today, 'day')) {
        return true;
      } else return false;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _FoodDiaryNutritionMixin = __webpack_require__(354);

var _FoodDiaryNutritionMixin2 = _interopRequireDefault(_FoodDiaryNutritionMixin);

var _NutrientLocalizer = __webpack_require__(275);

var _NutrientLocalizer2 = _interopRequireDefault(_NutrientLocalizer);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _numeral = __webpack_require__(90);

var _numeral2 = _interopRequireDefault(_numeral);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _iconButton = __webpack_require__(449);

var _iconButton2 = _interopRequireDefault(_iconButton);

var _textField = __webpack_require__(228);

var _textField2 = _interopRequireDefault(_textField);

var _cardActions = __webpack_require__(1233);

var _cardActions2 = _interopRequireDefault(_cardActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuCardActions: _cardActions2.default,
    MuTextField: _textField2.default,
    MuIconButton: _iconButton2.default,
    MuRaisedButton: _raisedButton2.default
  },
  mixins: [_ScrollerMixin2.default, _FoodDiaryNutritionMixin2.default, _NutrientLocalizer2.default],
  name: 'food-diary-meal-list',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    mealTypeTitle: {
      type: String,
      default: "Breakfast"
    },
    mealType: {
      type: String,
      default: 'breakfast'
    },
    foods: {
      type: Array,
      default: []
    },
    recipes: {
      type: Array,
      default: []
    },
    totals: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isRecipeUpdating: false,
      deleteId: null,
      quickAddHidden: false,
      activeFoodObject: {},
      activeRecipeObject: {},
      mealPlateName: null,
      isMealPlateSaving: false,
      editRecipeEntryModel: {
        servings: 0,
        id: 0,
        name: null
      },
      dummyLoaders: [{}]
    };
  },

  watch: {
    'foods': function foods() {
      var self = this;
    }
  },
  methods: {
    viewRecipeNutrients: function viewRecipeNutrients(recipe) {
      var self = this;
      var copy = recipe;
      var activeRecipeObject = {
        name: recipe.name,
        servings: recipe.servings,
        nutrients: {
          carbohydrate: recipe.carbohydrate,
          calories: recipe.calories,
          sodium: recipe.sodium,
          sugar: recipe.sugar,
          monounsaturated_fat: recipe.monounsaturated_fat,
          polyunsaturated_fat: recipe.polyunsaturated_fat,
          saturated_fat: recipe.saturated_fat,
          fat: recipe.fat,
          fibre: recipe.fibre,
          protein: recipe.protein,
          potassium: recipe.potassium
        }
      };

      self.activeRecipeObject = activeRecipeObject;
      self.$refs.recipeNutritionDialog.open();
    },
    openEditRecipeEntryDialog: function openEditRecipeEntryDialog(recipe) {
      var self = this;
      self.editRecipeEntryModel.name = recipe.name;
      self.editRecipeEntryModel.id = recipe.id;
      self.editRecipeEntryModel.servings = recipe.servings;
      self.$refs.editRecipeDialog.open();
    },
    updateRecipeEntry: function updateRecipeEntry(recipe) {
      var self = this;
      self.isRecipeUpdating = true;
      _Food2.default.updateRecipe(self.editRecipeEntryModel).then(function (response) {
        self.$refs.editRecipeDialog.close();
        self.isRecipeUpdating = false;
        self.$emit('reloadData');
      }).catch(function (error) {
        self.isRecipeUpdating = false;
      });
    },
    deleteRecipe: function deleteRecipe(recipe, index) {

      var self = this;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveFoodItem') + recipe.name,
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Food2.default.deleteRecipe(recipe.id);
        }
      }).then(function () {
        self.$emit('removeRecipe', {
          type: self.mealType,
          index: index
        });
        self.$forceUpdate();
        self.$emit('updateTotals', recipe);
      }).catch(self.$alert.noop);
    },
    saveMealPlate: function saveMealPlate() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true && self.mealPlateName !== null && self.mealPlateName !== "") {
          var foods = [];
          var recipes = self.recipes;
          for (var i = 0; i < self.foods.length; i++) {
            var food = {
              food_id: self.foods[i].fs_food_id,
              food_name: self.foods[i].food_name,
              nutrients: self.foods[i].nutrients,
              serving_id: self.foods[i].fs_serving_id,
              servings: self.foods[i].servings
            };
            foods.push(food);
          }

          var model = {
            meal_name: self.mealPlateName,
            foods: foods,
            recipes: recipes
          };

          self.isMealPlateSaving = true;
          _Food2.default.addToFavourites(model).then(function (response) {
            self.isMealPlateSaving = false;
            self.$refs['mealPlateNamer'].close();
            self.$toastr.success(self.$t('message.labelSuccess'));
          }).catch(function (error) {
            self.isMealPlateSaving = false;
            self.$refs['mealPlateNamer'].close();
            self.$toastr.success(self.$t('message.labelError'));
          });
        }
      });
    },
    editFood: function editFood(food, index) {
      var self = this;
      if (self.mealType === "breakfast") {
        food.mealTypeId = 1;
      } else if (self.mealType === "lunch") {
        food.mealTypeId = 2;
      } else if (self.mealType === "dinner") {
        food.mealTypeId = 3;
      } else if (self.mealType === "snack") {
        food.mealTypeId = 4;
      }
      self.$emit('foodSelected', food);
    },
    viewNutrients: function viewNutrients(food) {
      var self = this;
      self.activeFoodObject = food;
      self.$refs['nutritionDialog'].open();
    },
    emitParent: function emitParent() {
      var self = this;
      self.$emit('removeFood', self.deleteId);
    },
    addToMealPlate: function addToMealPlate() {
      var self = this;
      self.$refs['mealPlateNamer'].open();

      self.quickAddHidden = true;
    },
    goToRecipe: function goToRecipe(item) {
      var self = this;
      self.$router.push({
        name: 'RecipeDetail',
        params: {
          id: item.recipeID
        }
      });
    },
    deleteFood: function deleteFood(food, index) {
      var self = this;
      var swal = self.$alert;
      self.deleteId = index;

      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveFoodItem') + food.food_name,
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Food2.default.deleteFood(food.food_id);
        }
      }).then(function () {

        var substitutableNutrients = food.nutrients;
        for (var key in substitutableNutrients) {
          if (substitutableNutrients.hasOwnProperty(key)) {
            substitutableNutrients[key] = substitutableNutrients[key] * food.servings;
          }
        }
        Number.prototype.clamp = function (min, max) {
          return Math.min(Math.max(this, min), max);
        };
        self.totals.calories = (self.totals.calories - substitutableNutrients.calories).clamp(0, Infinity);
        self.totals.carbohydrate = (self.totals.carbohydrate - substitutableNutrients.carbohydrate).clamp(0, Infinity);
        self.totals.cholesterol = (self.totals.cholesterol - substitutableNutrients.cholesterol).clamp(0, Infinity);
        self.totals.fat = (self.totals.fat - substitutableNutrients.fat).clamp(0, Infinity);
        self.totals.fibre = (self.totals.fibre - substitutableNutrients.fibre).clamp(0, Infinity);
        self.totals.monounsaturated_fat = (self.totals.monounsaturated_fat - substitutableNutrients.monounsaturated_fat).clamp(0, Infinity);
        self.totals.polyunsaturated_fat = (self.totals.polyunsaturated_fat - substitutableNutrients.polyunsaturated_fat).clamp(0, Infinity);
        self.totals.potassium = (self.totals.potassium - substitutableNutrients.potassium).clamp(0, Infinity);
        self.totals.protein = (self.totals.protein - substitutableNutrients.protein).clamp(0, Infinity);
        self.totals.saturated_fat = (self.totals.saturated_fat - substitutableNutrients.saturated_fat).clamp(0, Infinity);
        self.totals.sodium = (self.totals.sodium - substitutableNutrients.sodium).clamp(0, Infinity);
        self.totals.sugar = (self.totals.sugar - substitutableNutrients.sugar).clamp(0, Infinity);
        self.emitParent();
        self.$emit('updateTotals', substitutableNutrients);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: food.food_name + ' ' + self.$t('message.confirmedRemoveFoodItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
        if (self.foods.length === 0) {
          self.totals.calories = 0;
          self.totals.carbohydrate = 0;
          self.totals.cholesterol = 0;
          self.totals.fat = 0;
          self.totals.fibre = 0;
          self.totals.monounsaturated_fat = 0;
          self.totals.polyunsaturated_fat = 0;
          self.totals.potassium = 0;
          self.totals.protein = 0;
          self.totals.saturated_fat = 0;
          self.totals.sodium = 0;
          self.totals.sugar = 0;
        }
      }.bind(self)).catch(self.$alert.noop);
    }
  }
};

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _rxjs = __webpack_require__(91);

var _flexboxItem = __webpack_require__(660);

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _listItem = __webpack_require__(1236);

var _listItem2 = _interopRequireDefault(_listItem);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default],
  components: {
    MuListItem: _listItem2.default,
    MuFlexboxItem: _flexboxItem2.default
  },
  name: 'fd-mymeals-dialog',
  props: {
    title: {
      type: String,
      default: ""
    },
    mealTypeId: {
      type: Number,
      default: 0
    },
    date: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      isLoading: false,
      meals: {}

    };
  },
  mounted: function mounted() {
    var self = this;
    _Food2.default.getFavorites().then(function (response) {
      self.meals = response.data;
    });
    self.initScrollFix();
    $(window).resize(function () {
      self.initScrollFix();
    });
  },

  methods: {
    loadMeal: function loadMeal(meal) {
      var self = this;

      var date = moment(self.date);
      if (self.mealTypeId === 1) {
        date.set({
          'hour': 9,
          'minute': 0,
          'second': 0
        });
      }

      if (self.mealTypeId === 2) {
        date.set({
          'hour': 12,
          'minute': 0,
          'second': 0
        });
      }

      if (self.mealTypeId === 3) {
        date.set({
          'hour': 18,
          'minute': 0,
          'second': 0
        });
      }
      self.isLoading = true;

      _Food2.default.addFoods({
        date: date.format(),
        meal_type_id: self.mealTypeId,
        foods: meal.foods,
        recipes: meal.recipes
      }).then(function (response) {
        self.$toastr.success(self.$t('message.labelSuccess'));
        self.$router.replace({
          name: 'FoodDiary',
          query: {
            date: moment(self.date).format('YYYY-MM-DD')
          }
        });
        self.$emit('closeDialogAndReload');
      }).catch(function () {
        self.isLoading = false;
      });
    },
    deleteMeal: function deleteMeal(mealId) {
      var self = this;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Food2.default.deleteFavorite(mealId);
        }
      }).then(function () {
        var index = self.meals.findIndex(function (obj) {
          return obj.meal_id === mealId;
        });
        if (index !== -1) self.meals.splice(index, 1);
        self.$toastr.success(self.$t('message.foodDiaryMealPlateRemoved'));
      });
    },
    initScrollFix: function initScrollFix() {
      var headerHeight = $('.add-food-dialog .blueHeader').outerHeight();
      var searchHeight = $('.add-food-dialog .subHeader').outerHeight();
      var panelHeight = $('.add-food-dialog').outerHeight();
      var scrollHeight = panelHeight - (searchHeight + headerHeight);
      $('.food-search-dialog .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(2)))

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "NutritionUnitDialog",
  props: {
    show: Boolean,
    initialUnit: Boolean
  },
  data: function data() {
    return {
      unit: "g",
      unitUpdated: false
    };
  },
  mounted: function mounted() {
    this.resetMutableUnit();
  },

  methods: {
    resetMutableUnit: function resetMutableUnit() {
      this.unit = this.initialUnit;
    },
    update: function update() {
      this.unitUpdated = true;
      this.$emit('nutritionUnitChanged', this.unit);
      this.hide();
    },
    hide: function hide() {
      this.$refs['dialog'].close();
      this.close();
    },
    close: function close() {
      if (!this.unitUpdated) {
        this.resetMutableUnit();
      }
      this.unitUpdated = false;
    },
    open: function open() {
      this.$refs['dialog'].open();
    }
  }
};

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _rxjs = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var optionsDefault = {
  page_number: 0,
  max_results: 10,
  total_results: 0
};

exports.default = {
  name: 'fd-search-results-dialog',
  props: {
    title: {
      type: String,
      default: ""
    },
    searchTerm: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      isAppending: false,
      isLoading: true,
      options: optionsDefault,
      results: []
    };
  },

  watch: {
    'searchTerm': function searchTerm() {
      var self = this;
      self.getData();
    }
  },
  mounted: function mounted() {
    var self = this;
    if (self.searchTerm !== "") {
      self.getData();
    }

    self.initScrollFix();
    $(window).resize(function () {
      self.initScrollFix();
    });

    var element = document.getElementById('resultScroller');
    element.addEventListener('scroll', self.handleScroll);
  },

  methods: {
    selectFood: function selectFood(food) {
      var self = this;
      self.$emit('foodSelected', food);
    },
    initScrollFix: function initScrollFix() {
      var $panelheight = $('.food-dialog-container').find('#md-dialog'),
          $scrollHeight = $($panelheight.prevObject[0].children[0]).outerHeight() - (54 + 48);
      $('.food-search-results-dialog .scrollable-area').attr('style', "height:" + $scrollHeight + 'px;overflow:auto');
    },

    isElementInViewport: function isElementInViewport(el) {
      if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
      }
      if (!el) {
        return;
      }
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    onVisibilityChange: function onVisibilityChange(el, callback) {
      var old_visible;
      return function () {
        var visible = this.isElementInViewport(el);
        if (visible != old_visible) {
          old_visible = visible;
          if (typeof callback == 'function') {
            callback();
          }
        }
      };
    },
    handleScroll: function handleScroll() {
      var self = this;
      if (!self.isAppending) {
        if (self.isElementInViewport(document.getElementById('infinite-scroll-detector'))) {
          self.loadMoreData();
        }
      }
    },
    closeDialog: function closeDialog() {
      var self = this;
      self.$emit('closeDialog');
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.options.page_number + 1;
      self.isAppending = true;
      _Food2.default.searchFoods(self.searchTerm, page, self.options.max_results).then(function (response) {
        self.options = response.data.options;
        self.results.push.apply(self.results, response.data.foods);
        self.isAppending = false;
      }).catch(function (error) {
        self.isAppending = false;
      });
    },
    getData: function getData() {
      var self = this;

      self.results = [];

      _Food2.default.searchFoods(self.searchTerm, self.options.page_number, self.options.max_results).then(function (response) {
        self.results = response.data.foods;
        self.options = response.data.options;
        self.isLoading = false;
      }).catch(function (error) {
        self.isLoading = false;
        self.results = [];
        self.options = optionsDefault;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(11)))

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Alert: _Alert2.default },
  name: "gdpr-reminder"
};

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'hcp-getting-started-modal',
  mixins: [_HCPMixin2.default],
  data: function data() {
    return {
      dialog: true
    };
  },

  methods: {
    acceptWelcome: function acceptWelcome() {
      var self = this;
      _Hcp2.default.acceptHcpWelcome().then(function (response) {
        if (response.data.error === false) {
          self.close();
        }
      });
    },
    open: function open() {
      var self = this;
      self.dialog = true;
    },
    close: function close() {
      var self = this;
      self.dialog = false;
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'hcp-forum',
  watch: {
    "$route": function $route() {
      var self = this;
      self.initMounted();
    }
  },
  props: {
    amount: {
      type: Number,
      required: false,
      default: 5
    }
  },
  data: function data() {
    return {
      isLoading: true,
      questions: []
    };
  },

  methods: {
    date: function date(_date) {
      return moment(_date).format("MMMM Do YYYY");
    },
    loadQuestions: function loadQuestions() {
      var self = this;
      self.isLoading = true;
      _Discussion2.default.getDiscussionQuestions({
        page: 1,
        per_page: self.amount,
        type: 'HCP'
      }).then(function (res) {
        self.questions = res.data.questions;
        self.isLoading = false;
      });
    },
    upperTwoInitials: function upperTwoInitials(displayName) {
      if (displayName.indexOf(' ') !== -1) {
        var splitString = displayName.split(' ');
        return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
      }
      return displayName.charAt(0).toUpperCase();
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.floor(Math.random() * (max - min) + min) + '%';
    },
    goToQuestionThread: function goToQuestionThread(id) {
      var self = this;
      self.$router.push({
        name: 'QuestionThread',
        params: {
          id: id
        }
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.loadQuestions();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'hcp-search',
  watch: {
    "$route": function $route() {
      var self = this;
      self.searchTerm = self.$route.params.search;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      searchTerm: ''
    };
  },

  methods: {
    onSearch: function onSearch() {
      var self = this;
      var q = null;
      if (q = self.searchTerm) {
        var options = {
          name: 'HcpSearch',
          params: {
            search: q
          }
        };
        var route = self.$route.name;
        if (route === 'Downloads' || route === 'DownloadsCategory') {
          options.query = {
            type: "resources"
          };
        }
        self.$router.push(options);
      } else {
        self.$toastr.error('Please enter a search value');
      }
    },
    initMounted: function initMounted() {
      var self = this;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.searchTerm = self.$route.params.search;
    self.initMounted();
  },

  computed: {
    show: function show() {
      var self = this;
      var route = self.$route.name;
      if (route === 'Dashboard' || route === 'HcpCategories' || route === 'HcpCategory' || route === 'Downloads' || route === 'DownloadsCategory' || route === 'HcpSearch') {
        return true;
      }
    }
  }
};

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_HCPMixin2.default],
  name: 'hcp-slider-modules',
  data: function data() {
    return {
      posts: [],
      isLoading: true
    };
  },

  methods: {
    goToModule: function goToModule(slug) {
      var self = this;
      self.$router.push({
        name: 'HcpArticle',
        dummy: 8,
        params: {
          slug: slug
        }
      });
    },
    getFeaturedCorePosts: function getFeaturedCorePosts() {
      var self = this;
      self.isLoading = true;
      if (self.isHcpView) {
        _Hcp2.default.getFeaturedCoreModules().then(function (response) {
          self.posts = response.data;
          self.isLoading = false;
        });
      }
    },
    listen: function listen() {
      var self = this;
      self.$EventBus.$on('onProgramSwitchHCP', function () {
        self.getFeaturedCorePosts();
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.getFeaturedCorePosts();
      self.listen();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_HCPMixin2.default],
  watch: {
    "open": function open() {
      var self = this;
      self.dialog = self.open;
    }
  },
  name: 'hcp-switch-modal',
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: function data() {
    return {
      dialog: false
    };
  },

  methods: {
    doSwitch: function doSwitch() {
      var self = this;
      self.closeModal();
      self.switchProgram();
    },
    closeModal: function closeModal() {
      var self = this;
      self.$emit("close", false);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.dialog = self.open;
  }
};

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'iframe-video-player',
  props: {
    src: {
      type: String,
      required: true
    }
  }
};

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBase64FileUpload = __webpack_require__(337);

var _vueBase64FileUpload2 = _interopRequireDefault(_vueBase64FileUpload);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _index2 = _interopRequireDefault(_index);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

var _flatButton = __webpack_require__(339);

var _flatButton2 = _interopRequireDefault(_flatButton);

var _icon = __webpack_require__(1234);

var _icon2 = _interopRequireDefault(_icon);

var _iconButton = __webpack_require__(449);

var _iconButton2 = _interopRequireDefault(_iconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileManager = {
  uploadFile: function uploadFile(uri, width, height) {
    return _axios2.default.post(_index2.default.apiUrl + 'uploader/image', {
      file: uri,
      width: width,
      height: height
    });
  }
};
exports.default = {
  props: {
    icon: {
      type: String,
      default: 'image'
    },
    label: {
      type: String
    },
    size: {
      type: Number,
      default: 22
    }
  },
  name: "image-uploader",
  components: {
    MuIconButton: _iconButton2.default,
    MuIcon: _icon2.default,
    MuFlatButton: _flatButton2.default,
    MuCircularProgress: _circularProgress2.default,
    VueBase64FileUpload: _vueBase64FileUpload2.default
  },
  data: function data() {
    return {
      isUploading: false,
      maxSize: 3,
      progress: 0
    };
  },

  methods: {
    selectFile: function selectFile() {
      var el = this._uid;
      var self = this;
      $('#uploader-' + self._uid + ' .vue-base64-file-upload-wrapper input').click();
    },
    onLoad: function onLoad(dataURI) {
      var self = this;
      var progressConfig = {
        onUploadProgress: function onUploadProgress(progressEvent) {
          self.progress = Math.floor(progressEvent.loaded * 100 / progressEvent.total);
        }
      };
      self.isUploading = true;
      _axios2.default.post(_index2.default.apiUrl + 'uploader/image', {
        file: dataURI
      }, progressConfig).then(function (response) {
        var url = response.data.secure_url;
        self.isUploading = false;
        self.progress = 0;
        self.$emit('onComplete');
        self.$emit('input', url);
      });
    },
    onSizeExceeded: function onSizeExceeded() {
      alert('File must not be above 3mb!');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _isoCountriesLanguages = __webpack_require__(2848);

var _isoCountriesLanguages2 = _interopRequireDefault(_isoCountriesLanguages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    position: {
      type: String,
      default: "top"
    },
    showName: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      toggleLocales: true,
      selected: 1,

      url: _config2.default.ApplicationContext === 'lowcarbprogram' ? 'https://www.lowcarbprogram.com/' : "https://www.grohealth.com/",
      locales: [{
        flag: "gb",
        cc: "GB",
        cl: "en",
        locale: "en_GB"

      }, {
        flag: "ca",
        cc: "CA",
        cl: "en",
        locale: "en_CA"
      }, {
        flag: "ca",
        cc: "CA",
        cl: "fr",
        locale: "fr_CA"
      }]
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      var self = this;
      self.toggleLocales = !self.toggleLocales;
    },
    onSelect: function onSelect(i) {
      var self = this;
      self.selected = i;
      var obj = self.locales[self.selected];
      self.setCookie("locale", obj.locale, 7);
      var url = self.url + obj.locale + '/';
      url = url.replace('_', '-');
      window.location.href = url;
    },
    setCookie: function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie: function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    explodeLocaleCookie: function explodeLocaleCookie() {
      var self = this;
      var split = self.getCookie("locale") || "en_GB";
      var cookie = split.split("_");
      return cookie;
    },
    getCountryLabel: function getCountryLabel(country) {
      var self = this;
      var lang = self.explodeLocaleCookie()[0];
      return _isoCountriesLanguages2.default.getCountry(lang, country);
    },
    getLangLabel: function getLangLabel(cl) {
      var self = this;
      var lang = self.explodeLocaleCookie()[0];
      return _isoCountriesLanguages2.default.getLanguage(lang, cl);
    }
  },
  mounted: function mounted() {
    var self = this;
    var cookieValue = self.getCookie('locale') || 'en_GB';
    var index = _.findIndex(self.locales, { locale: cookieValue });
    self.selected = index;
    self.toggleLocales = false;
    $('.locale-picker .menu').mouseleave(function () {
      self.toggleLocales = false;
    });
    $('body, html').on('click', function (eve) {
      if ($('.locale-picker .menu').hasClass('visible')) {
        self.toggleLocales = false;
      }
    });
  },

  computed: {
    localeSelected: function localeSelected() {
      var self = this;
      return self.locales[self.selected];
    },
    isMenuTop: function isMenuTop() {
      var self = this;
      return self.position === 'top';
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(11)))

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "downloads-panel",
  props: {
    downloads: {
      type: Array
    }
  },
  methods: {
    saveTrackingCount: function saveTrackingCount(download) {
      _Lessons2.default.saveDownloadCount({
        download_id: download.download_id
      });
      window.open(download.link, '_blank');
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

var _IframeVideoPlayer = __webpack_require__(341);

var _IframeVideoPlayer2 = _interopRequireDefault(_IframeVideoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    IframeVideoPlayer: _IframeVideoPlayer2.default
  },
  name: 'lesson-personalised-panel',
  props: {
    courseId: {
      type: Number,
      required: true
    },
    course: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isDefaultView: true,
      isVideoVisible: false,
      content: null,
      imageHeight: 0,
      activeTab: 'local'
    };
  },

  watch: {
    'isVideoVisible': function isVideoVisible() {
      var self = this;
      self.$nextTick(function () {
        self.setImageHeight();
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    $(window).resize(function () {
      self.setImageHeight();
    });
    _Lessons2.default.getPersonalizedContentForLesson(self.courseId).then(function (response) {

      if (response.data.length > 0) {
        self.content = response.data[0];

        if (self.content.intl_language_video !== "" || self.content.intl_language_video !== null) {
          self.activeTab = 'intl';
        }
        self.setImageHeight();
        self.$nextTick(function () {
          self.setImageHeight();
        }, 300);
      }
    });
  },

  methods: {
    showVideo: function showVideo() {
      var self = this;
      self.isDefaultView = !self.isDefaultView;
      if (self.isDefaultView === false) {
        self.isVideoVisible = true;
        self.$emit('isMainVideoVisible', false);
      } else {
        self.isVideoVisible = false;
        self.$emit('isMainVideoVisible', true);
      }
    },
    setImageHeight: function setImageHeight() {
      var self = this;
      var imageHeight = $('.calcHeight');
      self.imageHeight = imageHeight.outerHeight(true);
    },
    handleTabChange: function handleTabChange(val) {
      var self = this;
      self.activeTab = val;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _CreateQuestion = __webpack_require__(450);

var _CreateQuestion2 = _interopRequireDefault(_CreateQuestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CreateQuestion: _CreateQuestion2.default
  },
  name: "questions-panel",
  props: {
    courseId: {
      type: Number
    }
  },
  data: function data() {
    var self = this;
    return {
      query: {
        page: 1,
        per_page: 5,
        type: "MOST_RECENT",
        course_id: self.courseId
      },
      paginator: [],
      data: {},
      changeData: false
    };
  },
  mounted: function mounted() {
    var self = this;
    _Discussion2.default.getDiscussionQuestions(self.query).then(function (response) {
      self.data = response.data;
    });
  },

  computed: {
    hasQuestions: function hasQuestions() {
      var self = this;
      if (!_.has(self.data, 'questions')) {
        return false;
      }
      return self.data.questions.length > 0;
    }
  },
  methods: {
    askQuestion: function askQuestion() {
      var self = this;
      self.$router.push({
        name: 'Ask a question'
      });
    },
    handlePageChange: function handlePageChange(page) {
      var self = this;
      self.loadData();
    },
    loadData: function loadData(page) {
      var self = this;
      _Discussion2.default.getDiscussionQuestions(self.query).then(function (response) {
        self.data = response.data;
      });
    },
    goToQuestion: function goToQuestion(id) {
      var self = this;
      self.$router.push({
        path: '/questions/thread/' + id,
        query: {
          page: 1,
          per_page: 10
        }
      });
    },
    upperTwoInitials: function upperTwoInitials(displayName) {
      if (displayName.indexOf(' ') !== -1) {
        var splitString = displayName.split(' ');
        return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
      }
      return displayName.charAt(0).toUpperCase();
    },
    formatDate: function formatDate(date) {
      return moment.utc(date).fromNow();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(488);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "lesson-quiz-panel",
  props: {
    quiz: {
      type: Array
    },
    course_id: {
      type: Number
    },
    quiz_id: {
      type: Number
    }
  },
  data: function data() {
    return {
      isQuizComplete: false,
      percentage: 0,
      questions: 0,
      questionNumberIndex: 0,
      activeAnswerStore: [],
      markable: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.questions = self.quiz.length;
  },

  computed: {
    activeQuestion: function activeQuestion() {
      return this.quiz[this.questionNumberIndex];
    },
    totalCorrectAnswers: function totalCorrectAnswers() {
      return this.quiz.map(function (x) {
        return x.correct;
      }).reduce(function (a, b) {
        return a + b;
      });
    }
  },
  methods: {
    startAgain: function startAgain() {
      var self = this;
      self.isQuizComplete = false;
      self.percentage = 0;
      self.activeAnswerStore = [];
      self.markable = [];
      self.questionNumberIndex = 0;
    },
    getQuizResults: function getQuizResults() {},
    addAnswersToMarkable: function addAnswersToMarkable() {
      var self = this;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(self.activeAnswerStore), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          self.markable.push({
            question_id: self.activeQuestion.question_id,
            answer_id: item
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      self.activeAnswerStore = [];
    },
    nextQuestion: function nextQuestion() {
      var self = this;
      if (self.activeAnswerStore.length === 0) {
        return;
      }

      self.addAnswersToMarkable();

      if (this.questionNumberIndex === this.quiz.length) {
        self.finishQuiz();
        return;
      }

      if (self.markable.length === self.totalCorrectAnswers && !self.isQuizComplete) {
        self.finishQuiz();
      } else {
        self.questionNumberIndex++;
      }
    },
    finishQuiz: function finishQuiz() {
      var self = this;
      var model = {
        course_id: self.course_id,
        quiz_id: self.quiz_id,
        selectedAnswers: self.markable
      };
      _Lessons2.default.saveQuizResult(model).then(function (response) {
        self.isQuizComplete = true;
        self.percentage = response.data.percentage.toFixed(0);
      }).catch(function (error) {});
    }
  }
};

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "lesson-rating-panel",
  props: {
    course: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      ratingStart: {
        ratings: [{ label: 'Very' }, { label: 'Somewhat' }, { label: 'It made no difference' }, { label: 'Not particularly' }, { label: 'I didn\'t do this one' }],
        saved: false,
        activeIndex: 0,
        scores: []
      },
      ratingEnd: {
        ratings: 5,
        saved: false
      }
    };
  },

  methods: {
    addScoreToMarkers: function addScoreToMarkers(question_id, rating) {
      var self = this;

      self.ratingStart.scores.push({
        question_id: question_id,
        rating: rating
      });
      if (self.ratingStart.scores.length === self.course.start_questions.length) {
        self.saveRatingStart();
      } else {
        self.ratingStart.activeIndex += 1;
      }
    },
    saveRatingStart: function saveRatingStart() {
      var self = this;
      _Lessons2.default.saveLessonStartRating({
        ratings: self.ratingStart.scores
      }).then(function (response) {
        self.ratingStart.saved = true;
      }).catch(function (error) {});
    },
    saveRatingEnd: function saveRatingEnd(rating) {
      var self = this;
      var r = self.ratingEnd.ratings - rating + 1;

      _Lessons2.default.saveLessonEndRating({
        course_id: self.course.course_id,
        rating: r
      }).then(function (response) {
        if (response.data.complete) {
          self.ratingEnd.saved = true;
        }
      }).catch(function (error) {
        alert('Failed');
      });
    }
  },
  mounted: function mounted() {
    var self = this;
  }
};

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _index2 = _interopRequireDefault(_index);

var _LifeStyle = __webpack_require__(97);

var _LifeStyle2 = _interopRequireDefault(_LifeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "life-category-list",
  props: {
    postId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isSaving: false,
      limit: 5,
      dummyLoaders: [{}, {}, {}, {}, {}],
      data: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.isLoading = true;
    _LifeStyle2.default.getRecommendationsByPost(self.postId, self.userId, self.limit).then(function (response) {
      self.isLoading = false;
      self.data = response.data;
    });
  },

  methods: {
    favouritePost: function favouritePost(post_id, index) {
      var self = this;
      _LifeStyle2.default.favouritePost({
        post_id: post_id
      }).then(function (res) {
        var callback = res.data;
        if (callback.fav_status) {
          self.data[index].post_favourited = true;
          self.data[index].post_favourites += 1;
        } else {
          self.data[index].post_favourited = false;
          self.data[index].post_favourites -= 1;
        }
      });
    },
    goTo: function goTo(slug) {
      var self = this;
      self.$router.push({
        path: '/life/' + slug
      });
    }
  },
  computed: {
    userId: function userId() {
      var self = this;
      if (self.$store.state.user.scope) {
        return self.$store.state.user.scope.user_id;
      }
      return false;
    }
  }
};

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LifeCommentsMixin = __webpack_require__(1655);

var _LifeCommentsMixin2 = _interopRequireDefault(_LifeCommentsMixin);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _ReportingMixin = __webpack_require__(486);

var _ReportingMixin2 = _interopRequireDefault(_ReportingMixin);

var _Reporting = __webpack_require__(664);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _Report = __webpack_require__(229);

var _Report2 = _interopRequireDefault(_Report);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UserBadge: _UserBadge2.default,
    Report: _Report2.default,
    ReportModal: _Reporting2.default
  },
  name: 'life-comments',
  mixins: [_LifeCommentsMixin2.default, _ScrollerMixin2.default, _ReportingMixin2.default],
  props: {
    postId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  methods: {
    time: function time(date) {
      return moment(date).format('MMMM Do YYYY [at] h:mma');
    },
    setReported: function setReported() {
      var self = this,
          currentThread = void 0;
      if (self.activeReport.type === 'LIFE_REPLY') {
        currentThread = self.comments.filter(function (item) {
          return item.comment_id === self.activeReport.type_id;
        })[0];
      } else if (self.activeReport.type === 'LIFE_SUBREPLY') {
        var i = 0;
        for (i in self.comments) {
          currentThread = self.comments[i].replies.filter(function (item) {
            return item.sub_comment_id === self.activeReport.type_id;
          })[0];
        }
      }
      currentThread.reported = true;
      self.$forceUpdate();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "LifePostInfo",
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    favourites: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    }
  },
  methods: {
    goToArticle: function goToArticle(slug) {
      var self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          name: 'LifeStyleArticle',
          params: {
            permalink: slug
          }
        });
      } else {
        self.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      return moment(date);
    })
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'life-search-bar',
  props: {
    value: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      searchTerm: ""
    };
  },

  methods: {
    onSearch: function onSearch() {
      var self = this;
      if (self.searchTerm) {
        self.$router.push({
          name: 'LifeStyleSearch',
          params: {
            search: self.searchTerm
          }
        });
      } else {
        self.$toastr.error('Please enter a search value');
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    if (self.value) {
      self.searchTerm = self.value;
    }
  }
};

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LifeStyle = __webpack_require__(97);

var _LifeStyle2 = _interopRequireDefault(_LifeStyle);

var _LifePostInfo = __webpack_require__(1247);

var _LifePostInfo2 = _interopRequireDefault(_LifePostInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LifePostInfo: _LifePostInfo2.default
  },
  props: {
    post_id: {
      type: Number,
      required: true
    },
    size: {
      type: String,
      default: 'medium',
      required: false
    }
  },
  name: 'life-similar-posts',
  data: function data() {
    return {
      isLoading: true,
      posts: []
    };
  },

  methods: {
    loadSimilarPosts: function loadSimilarPosts() {
      var self = this;
      _LifeStyle2.default.getSimilarPosts(self.post_id, self.size).then(function (response) {
        self.posts = response.data;
        self.isLoading = false;
      });
    },
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      return moment(date);
    }),
    goToArticle: function goToArticle(slug) {
      var self = this;
      self.$router.push({
        name: 'LifeStyleArticle',
        params: {
          permalink: slug
        }
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.isLoading = true;
      self.loadSimilarPosts();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { MuRaisedButton: _raisedButton2.default },
  name: "mobile-phone-input",
  data: function data() {
    return {
      areaCodes: [{
        "name": "Afghanistan",
        "dial_code": "+93",
        "code": "AF"
      }, {
        "name": "Aland Islands",
        "dial_code": "+358",
        "code": "AX"
      }, {
        "name": "Albania",
        "dial_code": "+355",
        "code": "AL"
      }, {
        "name": "Algeria",
        "dial_code": "+213",
        "code": "DZ"
      }, {
        "name": "AmericanSamoa",
        "dial_code": "+1 684",
        "code": "AS"
      }, {
        "name": "Andorra",
        "dial_code": "+376",
        "code": "AD"
      }, {
        "name": "Angola",
        "dial_code": "+244",
        "code": "AO"
      }, {
        "name": "Anguilla",
        "dial_code": "+1 264",
        "code": "AI"
      }, {
        "name": "Antarctica",
        "dial_code": "+672",
        "code": "AQ"
      }, {
        "name": "Antigua and Barbuda",
        "dial_code": "+1268",
        "code": "AG"
      }, {
        "name": "Argentina",
        "dial_code": "+54",
        "code": "AR"
      }, {
        "name": "Armenia",
        "dial_code": "+374",
        "code": "AM"
      }, {
        "name": "Aruba",
        "dial_code": "+297",
        "code": "AW"
      }, {
        "name": "Australia",
        "dial_code": "+61",
        "code": "AU"
      }, {
        "name": "Austria",
        "dial_code": "+43",
        "code": "AT"
      }, {
        "name": "Azerbaijan",
        "dial_code": "+994",
        "code": "AZ"
      }, {
        "name": "Bahamas",
        "dial_code": "+1 242",
        "code": "BS"
      }, {
        "name": "Bahrain",
        "dial_code": "+973",
        "code": "BH"
      }, {
        "name": "Bangladesh",
        "dial_code": "+880",
        "code": "BD"
      }, {
        "name": "Barbados",
        "dial_code": "+1 246",
        "code": "BB"
      }, {
        "name": "Belarus",
        "dial_code": "+375",
        "code": "BY"
      }, {
        "name": "Belgium",
        "dial_code": "+32",
        "code": "BE"
      }, {
        "name": "Belize",
        "dial_code": "+501",
        "code": "BZ"
      }, {
        "name": "Benin",
        "dial_code": "+229",
        "code": "BJ"
      }, {
        "name": "Bermuda",
        "dial_code": "+1 441",
        "code": "BM"
      }, {
        "name": "Bhutan",
        "dial_code": "+975",
        "code": "BT"
      }, {
        "name": "Bolivia, Plurinational State of",
        "dial_code": "+591",
        "code": "BO"
      }, {
        "name": "Bosnia and Herzegovina",
        "dial_code": "+387",
        "code": "BA"
      }, {
        "name": "Botswana",
        "dial_code": "+267",
        "code": "BW"
      }, {
        "name": "Brazil",
        "dial_code": "+55",
        "code": "BR"
      }, {
        "name": "British Indian Ocean Territory",
        "dial_code": "+246",
        "code": "IO"
      }, {
        "name": "Brunei Darussalam",
        "dial_code": "+673",
        "code": "BN"
      }, {
        "name": "Bulgaria",
        "dial_code": "+359",
        "code": "BG"
      }, {
        "name": "Burkina Faso",
        "dial_code": "+226",
        "code": "BF"
      }, {
        "name": "Burundi",
        "dial_code": "+257",
        "code": "BI"
      }, {
        "name": "Cambodia",
        "dial_code": "+855",
        "code": "KH"
      }, {
        "name": "Cameroon",
        "dial_code": "+237",
        "code": "CM"
      }, {
        "name": "Canada",
        "dial_code": "+1",
        "code": "CA"
      }, {
        "name": "Cape Verde",
        "dial_code": "+238",
        "code": "CV"
      }, {
        "name": "Cayman Islands",
        "dial_code": "+ 345",
        "code": "KY"
      }, {
        "name": "Central African Republic",
        "dial_code": "+236",
        "code": "CF"
      }, {
        "name": "Chad",
        "dial_code": "+235",
        "code": "TD"
      }, {
        "name": "Chile",
        "dial_code": "+56",
        "code": "CL"
      }, {
        "name": "China",
        "dial_code": "+86",
        "code": "CN"
      }, {
        "name": "Christmas Island",
        "dial_code": "+61",
        "code": "CX"
      }, {
        "name": "Cocos (Keeling) Islands",
        "dial_code": "+61",
        "code": "CC"
      }, {
        "name": "Colombia",
        "dial_code": "+57",
        "code": "CO"
      }, {
        "name": "Comoros",
        "dial_code": "+269",
        "code": "KM"
      }, {
        "name": "Congo",
        "dial_code": "+242",
        "code": "CG"
      }, {
        "name": "Congo, The Democratic Republic of the Congo",
        "dial_code": "+243",
        "code": "CD"
      }, {
        "name": "Cook Islands",
        "dial_code": "+682",
        "code": "CK"
      }, {
        "name": "Costa Rica",
        "dial_code": "+506",
        "code": "CR"
      }, {
        "name": "Cote d'Ivoire",
        "dial_code": "+225",
        "code": "CI"
      }, {
        "name": "Croatia",
        "dial_code": "+385",
        "code": "HR"
      }, {
        "name": "Cuba",
        "dial_code": "+53",
        "code": "CU"
      }, {
        "name": "Cyprus",
        "dial_code": "+357",
        "code": "CY"
      }, {
        "name": "Czech Republic",
        "dial_code": "+420",
        "code": "CZ"
      }, {
        "name": "Denmark",
        "dial_code": "+45",
        "code": "DK"
      }, {
        "name": "Djibouti",
        "dial_code": "+253",
        "code": "DJ"
      }, {
        "name": "Dominica",
        "dial_code": "+1 767",
        "code": "DM"
      }, {
        "name": "Dominican Republic",
        "dial_code": "+1 849",
        "code": "DO"
      }, {
        "name": "Ecuador",
        "dial_code": "+593",
        "code": "EC"
      }, {
        "name": "Egypt",
        "dial_code": "+20",
        "code": "EG"
      }, {
        "name": "El Salvador",
        "dial_code": "+503",
        "code": "SV"
      }, {
        "name": "Equatorial Guinea",
        "dial_code": "+240",
        "code": "GQ"
      }, {
        "name": "Eritrea",
        "dial_code": "+291",
        "code": "ER"
      }, {
        "name": "Estonia",
        "dial_code": "+372",
        "code": "EE"
      }, {
        "name": "Ethiopia",
        "dial_code": "+251",
        "code": "ET"
      }, {
        "name": "Falkland Islands (Malvinas)",
        "dial_code": "+500",
        "code": "FK"
      }, {
        "name": "Faroe Islands",
        "dial_code": "+298",
        "code": "FO"
      }, {
        "name": "Fiji",
        "dial_code": "+679",
        "code": "FJ"
      }, {
        "name": "Finland",
        "dial_code": "+358",
        "code": "FI"
      }, {
        "name": "France",
        "dial_code": "+33",
        "code": "FR"
      }, {
        "name": "French Guiana",
        "dial_code": "+594",
        "code": "GF"
      }, {
        "name": "French Polynesia",
        "dial_code": "+689",
        "code": "PF"
      }, {
        "name": "Gabon",
        "dial_code": "+241",
        "code": "GA"
      }, {
        "name": "Gambia",
        "dial_code": "+220",
        "code": "GM"
      }, {
        "name": "Georgia",
        "dial_code": "+995",
        "code": "GE"
      }, {
        "name": "Germany",
        "dial_code": "+49",
        "code": "DE"
      }, {
        "name": "Ghana",
        "dial_code": "+233",
        "code": "GH"
      }, {
        "name": "Gibraltar",
        "dial_code": "+350",
        "code": "GI"
      }, {
        "name": "Greece",
        "dial_code": "+30",
        "code": "GR"
      }, {
        "name": "Greenland",
        "dial_code": "+299",
        "code": "GL"
      }, {
        "name": "Grenada",
        "dial_code": "+1 473",
        "code": "GD"
      }, {
        "name": "Guadeloupe",
        "dial_code": "+590",
        "code": "GP"
      }, {
        "name": "Guam",
        "dial_code": "+1 671",
        "code": "GU"
      }, {
        "name": "Guatemala",
        "dial_code": "+502",
        "code": "GT"
      }, {
        "name": "Guernsey",
        "dial_code": "+44",
        "code": "GG"
      }, {
        "name": "Guinea",
        "dial_code": "+224",
        "code": "GN"
      }, {
        "name": "Guinea-Bissau",
        "dial_code": "+245",
        "code": "GW"
      }, {
        "name": "Guyana",
        "dial_code": "+595",
        "code": "GY"
      }, {
        "name": "Haiti",
        "dial_code": "+509",
        "code": "HT"
      }, {
        "name": "Holy See (Vatican City State)",
        "dial_code": "+379",
        "code": "VA"
      }, {
        "name": "Honduras",
        "dial_code": "+504",
        "code": "HN"
      }, {
        "name": "Hong Kong",
        "dial_code": "+852",
        "code": "HK"
      }, {
        "name": "Hungary",
        "dial_code": "+36",
        "code": "HU"
      }, {
        "name": "Iceland",
        "dial_code": "+354",
        "code": "IS"
      }, {
        "name": "India",
        "dial_code": "+91",
        "code": "IN"
      }, {
        "name": "Indonesia",
        "dial_code": "+62",
        "code": "ID"
      }, {
        "name": "Iran, Islamic Republic of Persian Gulf",
        "dial_code": "+98",
        "code": "IR"
      }, {
        "name": "Iraq",
        "dial_code": "+964",
        "code": "IQ"
      }, {
        "name": "Ireland",
        "dial_code": "+353",
        "code": "IE"
      }, {
        "name": "Isle of Man",
        "dial_code": "+44",
        "code": "IM"
      }, {
        "name": "Israel",
        "dial_code": "+972",
        "code": "IL"
      }, {
        "name": "Italy",
        "dial_code": "+39",
        "code": "IT"
      }, {
        "name": "Jamaica",
        "dial_code": "+1 876",
        "code": "JM"
      }, {
        "name": "Japan",
        "dial_code": "+81",
        "code": "JP"
      }, {
        "name": "Jersey",
        "dial_code": "+44",
        "code": "JE"
      }, {
        "name": "Jordan",
        "dial_code": "+962",
        "code": "JO"
      }, {
        "name": "Kazakhstan",
        "dial_code": "+7 7",
        "code": "KZ"
      }, {
        "name": "Kenya",
        "dial_code": "+254",
        "code": "KE"
      }, {
        "name": "Kiribati",
        "dial_code": "+686",
        "code": "KI"
      }, {
        "name": "Korea, Democratic People's Republic of Korea",
        "dial_code": "+850",
        "code": "KP"
      }, {
        "name": "Korea, Republic of South Korea",
        "dial_code": "+82",
        "code": "KR"
      }, {
        "name": "Kuwait",
        "dial_code": "+965",
        "code": "KW"
      }, {
        "name": "Kyrgyzstan",
        "dial_code": "+996",
        "code": "KG"
      }, {
        "name": "Laos",
        "dial_code": "+856",
        "code": "LA"
      }, {
        "name": "Latvia",
        "dial_code": "+371",
        "code": "LV"
      }, {
        "name": "Lebanon",
        "dial_code": "+961",
        "code": "LB"
      }, {
        "name": "Lesotho",
        "dial_code": "+266",
        "code": "LS"
      }, {
        "name": "Liberia",
        "dial_code": "+231",
        "code": "LR"
      }, {
        "name": "Libyan Arab Jamahiriya",
        "dial_code": "+218",
        "code": "LY"
      }, {
        "name": "Liechtenstein",
        "dial_code": "+423",
        "code": "LI"
      }, {
        "name": "Lithuania",
        "dial_code": "+370",
        "code": "LT"
      }, {
        "name": "Luxembourg",
        "dial_code": "+352",
        "code": "LU"
      }, {
        "name": "Macao",
        "dial_code": "+853",
        "code": "MO"
      }, {
        "name": "Macedonia",
        "dial_code": "+389",
        "code": "MK"
      }, {
        "name": "Madagascar",
        "dial_code": "+261",
        "code": "MG"
      }, {
        "name": "Malawi",
        "dial_code": "+265",
        "code": "MW"
      }, {
        "name": "Malaysia",
        "dial_code": "+60",
        "code": "MY"
      }, {
        "name": "Maldives",
        "dial_code": "+960",
        "code": "MV"
      }, {
        "name": "Mali",
        "dial_code": "+223",
        "code": "ML"
      }, {
        "name": "Malta",
        "dial_code": "+356",
        "code": "MT"
      }, {
        "name": "Marshall Islands",
        "dial_code": "+692",
        "code": "MH"
      }, {
        "name": "Martinique",
        "dial_code": "+596",
        "code": "MQ"
      }, {
        "name": "Mauritania",
        "dial_code": "+222",
        "code": "MR"
      }, {
        "name": "Mauritius",
        "dial_code": "+230",
        "code": "MU"
      }, {
        "name": "Mayotte",
        "dial_code": "+262",
        "code": "YT"
      }, {
        "name": "Mexico",
        "dial_code": "+52",
        "code": "MX"
      }, {
        "name": "Micronesia, Federated States of Micronesia",
        "dial_code": "+691",
        "code": "FM"
      }, {
        "name": "Moldova",
        "dial_code": "+373",
        "code": "MD"
      }, {
        "name": "Monaco",
        "dial_code": "+377",
        "code": "MC"
      }, {
        "name": "Mongolia",
        "dial_code": "+976",
        "code": "MN"
      }, {
        "name": "Montenegro",
        "dial_code": "+382",
        "code": "ME"
      }, {
        "name": "Montserrat",
        "dial_code": "+1664",
        "code": "MS"
      }, {
        "name": "Morocco",
        "dial_code": "+212",
        "code": "MA"
      }, {
        "name": "Mozambique",
        "dial_code": "+258",
        "code": "MZ"
      }, {
        "name": "Myanmar",
        "dial_code": "+95",
        "code": "MM"
      }, {
        "name": "Namibia",
        "dial_code": "+264",
        "code": "NA"
      }, {
        "name": "Nauru",
        "dial_code": "+674",
        "code": "NR"
      }, {
        "name": "Nepal",
        "dial_code": "+977",
        "code": "NP"
      }, {
        "name": "Netherlands",
        "dial_code": "+31",
        "code": "NL"
      }, {
        "name": "Netherlands Antilles",
        "dial_code": "+599",
        "code": "AN"
      }, {
        "name": "New Caledonia",
        "dial_code": "+687",
        "code": "NC"
      }, {
        "name": "New Zealand",
        "dial_code": "+64",
        "code": "NZ"
      }, {
        "name": "Nicaragua",
        "dial_code": "+505",
        "code": "NI"
      }, {
        "name": "Niger",
        "dial_code": "+227",
        "code": "NE"
      }, {
        "name": "Nigeria",
        "dial_code": "+234",
        "code": "NG"
      }, {
        "name": "Niue",
        "dial_code": "+683",
        "code": "NU"
      }, {
        "name": "Norfolk Island",
        "dial_code": "+672",
        "code": "NF"
      }, {
        "name": "Northern Mariana Islands",
        "dial_code": "+1 670",
        "code": "MP"
      }, {
        "name": "Norway",
        "dial_code": "+47",
        "code": "NO"
      }, {
        "name": "Oman",
        "dial_code": "+968",
        "code": "OM"
      }, {
        "name": "Pakistan",
        "dial_code": "+92",
        "code": "PK"
      }, {
        "name": "Palau",
        "dial_code": "+680",
        "code": "PW"
      }, {
        "name": "Palestinian Territory, Occupied",
        "dial_code": "+970",
        "code": "PS"
      }, {
        "name": "Panama",
        "dial_code": "+507",
        "code": "PA"
      }, {
        "name": "Papua New Guinea",
        "dial_code": "+675",
        "code": "PG"
      }, {
        "name": "Paraguay",
        "dial_code": "+595",
        "code": "PY"
      }, {
        "name": "Peru",
        "dial_code": "+51",
        "code": "PE"
      }, {
        "name": "Philippines",
        "dial_code": "+63",
        "code": "PH"
      }, {
        "name": "Pitcairn",
        "dial_code": "+872",
        "code": "PN"
      }, {
        "name": "Poland",
        "dial_code": "+48",
        "code": "PL"
      }, {
        "name": "Portugal",
        "dial_code": "+351",
        "code": "PT"
      }, {
        "name": "Puerto Rico",
        "dial_code": "+1 939",
        "code": "PR"
      }, {
        "name": "Qatar",
        "dial_code": "+974",
        "code": "QA"
      }, {
        "name": "Romania",
        "dial_code": "+40",
        "code": "RO"
      }, {
        "name": "Russia",
        "dial_code": "+7",
        "code": "RU"
      }, {
        "name": "Rwanda",
        "dial_code": "+250",
        "code": "RW"
      }, {
        "name": "Reunion",
        "dial_code": "+262",
        "code": "RE"
      }, {
        "name": "Saint Barthelemy",
        "dial_code": "+590",
        "code": "BL"
      }, {
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "dial_code": "+290",
        "code": "SH"
      }, {
        "name": "Saint Kitts and Nevis",
        "dial_code": "+1 869",
        "code": "KN"
      }, {
        "name": "Saint Lucia",
        "dial_code": "+1 758",
        "code": "LC"
      }, {
        "name": "Saint Martin",
        "dial_code": "+590",
        "code": "MF"
      }, {
        "name": "Saint Pierre and Miquelon",
        "dial_code": "+508",
        "code": "PM"
      }, {
        "name": "Saint Vincent and the Grenadines",
        "dial_code": "+1 784",
        "code": "VC"
      }, {
        "name": "Samoa",
        "dial_code": "+685",
        "code": "WS"
      }, {
        "name": "San Marino",
        "dial_code": "+378",
        "code": "SM"
      }, {
        "name": "Sao Tome and Principe",
        "dial_code": "+239",
        "code": "ST"
      }, {
        "name": "Saudi Arabia",
        "dial_code": "+966",
        "code": "SA"
      }, {
        "name": "Senegal",
        "dial_code": "+221",
        "code": "SN"
      }, {
        "name": "Serbia",
        "dial_code": "+381",
        "code": "RS"
      }, {
        "name": "Seychelles",
        "dial_code": "+248",
        "code": "SC"
      }, {
        "name": "Sierra Leone",
        "dial_code": "+232",
        "code": "SL"
      }, {
        "name": "Singapore",
        "dial_code": "+65",
        "code": "SG"
      }, {
        "name": "Slovakia",
        "dial_code": "+421",
        "code": "SK"
      }, {
        "name": "Slovenia",
        "dial_code": "+386",
        "code": "SI"
      }, {
        "name": "Solomon Islands",
        "dial_code": "+677",
        "code": "SB"
      }, {
        "name": "Somalia",
        "dial_code": "+252",
        "code": "SO"
      }, {
        "name": "South Africa",
        "dial_code": "+27",
        "code": "ZA"
      }, {
        "name": "South Georgia and the South Sandwich Islands",
        "dial_code": "+500",
        "code": "GS"
      }, {
        "name": "Spain",
        "dial_code": "+34",
        "code": "ES"
      }, {
        "name": "Sri Lanka",
        "dial_code": "+94",
        "code": "LK"
      }, {
        "name": "Sudan",
        "dial_code": "+249",
        "code": "SD"
      }, {
        "name": "Suriname",
        "dial_code": "+597",
        "code": "SR"
      }, {
        "name": "Svalbard and Jan Mayen",
        "dial_code": "+47",
        "code": "SJ"
      }, {
        "name": "Swaziland",
        "dial_code": "+268",
        "code": "SZ"
      }, {
        "name": "Sweden",
        "dial_code": "+46",
        "code": "SE"
      }, {
        "name": "Switzerland",
        "dial_code": "+41",
        "code": "CH"
      }, {
        "name": "Syrian Arab Republic",
        "dial_code": "+963",
        "code": "SY"
      }, {
        "name": "Taiwan",
        "dial_code": "+886",
        "code": "TW"
      }, {
        "name": "Tajikistan",
        "dial_code": "+992",
        "code": "TJ"
      }, {
        "name": "Tanzania, United Republic of Tanzania",
        "dial_code": "+255",
        "code": "TZ"
      }, {
        "name": "Thailand",
        "dial_code": "+66",
        "code": "TH"
      }, {
        "name": "Timor-Leste",
        "dial_code": "+670",
        "code": "TL"
      }, {
        "name": "Togo",
        "dial_code": "+228",
        "code": "TG"
      }, {
        "name": "Tokelau",
        "dial_code": "+690",
        "code": "TK"
      }, {
        "name": "Tonga",
        "dial_code": "+676",
        "code": "TO"
      }, {
        "name": "Trinidad and Tobago",
        "dial_code": "+1 868",
        "code": "TT"
      }, {
        "name": "Tunisia",
        "dial_code": "+216",
        "code": "TN"
      }, {
        "name": "Turkey",
        "dial_code": "+90",
        "code": "TR"
      }, {
        "name": "Turkmenistan",
        "dial_code": "+993",
        "code": "TM"
      }, {
        "name": "Turks and Caicos Islands",
        "dial_code": "+1 649",
        "code": "TC"
      }, {
        "name": "Tuvalu",
        "dial_code": "+688",
        "code": "TV"
      }, {
        "name": "Uganda",
        "dial_code": "+256",
        "code": "UG"
      }, {
        "name": "Ukraine",
        "dial_code": "+380",
        "code": "UA"
      }, {
        "name": "United Arab Emirates",
        "dial_code": "+971",
        "code": "AE"
      }, {
        "name": "United Kingdom",
        "dial_code": "+44",
        "code": "GB"
      }, {
        "name": "United States",
        "dial_code": "+1",
        "code": "US"
      }, {
        "name": "Uruguay",
        "dial_code": "+598",
        "code": "UY"
      }, {
        "name": "Uzbekistan",
        "dial_code": "+998",
        "code": "UZ"
      }, {
        "name": "Vanuatu",
        "dial_code": "+678",
        "code": "VU"
      }, {
        "name": "Venezuela, Bolivarian Republic of Venezuela",
        "dial_code": "+58",
        "code": "VE"
      }, {
        "name": "Vietnam",
        "dial_code": "+84",
        "code": "VN"
      }, {
        "name": "Virgin Islands, British",
        "dial_code": "+1 284",
        "code": "VG"
      }, {
        "name": "Virgin Islands, U.S.",
        "dial_code": "+1 340",
        "code": "VI"
      }, {
        "name": "Wallis and Futuna",
        "dial_code": "+681",
        "code": "WF"
      }, {
        "name": "Yemen",
        "dial_code": "+967",
        "code": "YE"
      }, {
        "name": "Zambia",
        "dial_code": "+260",
        "code": "ZM"
      }, {
        "name": "Zimbabwe",
        "dial_code": "+263",
        "code": "ZW"
      }],
      dial_number: null,
      selectedCode: {
        "name": "Afghanistan",
        "dial_code": "+93",
        "code": "AF"
      }
    };
  },

  props: ['value'],
  mounted: function mounted() {
    var self = this;

    if (_.has(self.value, 'dial_code')) {
      self.dial_number = self.value.dial_number;
      self.dial_code = self.value.dial_code;
      var findFromPassedCode = self.areaCodes.filter(function (item) {
        return item.dial_code === self.value.dial_code;
      });
      if (findFromPassedCode.length > 1) {
        var country = self.getCountry();
        var findDefaultCountry = self.areaCodes.filter(function (item) {
          return item.code === self.getCountry();
        });
        if (findDefaultCountry.length > 0) {
          self.selectedCode = findDefaultCountry[0];
        }
      } else {
        self.selectedCode = findFromPassedCode[0];
      }
    } else {
      var _findDefaultCountry = self.areaCodes.filter(function (item) {
        return item.code === self.getCountry();
      });
      if (_findDefaultCountry.length > 0) {
        self.selectedCode = _findDefaultCountry[0];
      }
    }
  },

  methods: {
    getCountry: function getCountry() {
      return this.$store.state.geoLocation.host.country;
    },
    getCountryClass: function getCountryClass(country) {
      return 'flag-' + country.toLowerCase();
    },
    validateAndEmit: function validateAndEmit() {
      var self = this;
      if (_.has(self.selectedCode, 'code') && self.telephoneNumber !== null) {
        self.$emit('value', {
          dial_code: self.selectedCode.dial_code,
          dial_number: self.dial_number
        });
      }
    },
    areaCodeChanged: function areaCodeChanged() {
      this.validateAndEmit();
    },
    telephoneChanged: function telephoneChanged() {
      this.validateAndEmit();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(1684);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vueClickaway = __webpack_require__(338);

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

var _Notifications = __webpack_require__(1646);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _pusherJs = __webpack_require__(1125);

var _pusherJs2 = _interopRequireDefault(_pusherJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  directives: {
    onClickaway: _vueClickaway.directive
  },
  name: 'notifications-panel',
  data: function data() {
    return {
      page: 1,
      perPage: 15,
      icon: '',
      showIndicator: false,
      isLoading: true,
      isAppending: false,
      visible: false,
      scroller: null,
      notificationsModel: {
        notifications: []
      },
      notifications: [],
      loadMoreCount: 5,
      skip: 0,
      notificationEndedFromServer: false
    };
  },

  watch: {
    'visible': function visible() {
      var self = this;
      if (self.visible) {
        self.icon = "notifications";
        self.showIndicator = true;
      }
      if (!self.visible) {
        self.icon = "notifications_none";
      } else {
        self.icon = "notifications";
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    var channel = _PusherManager2.default.subscribe('notification_' + self.$store.state.user.scope.user_id);
    channel.bind('notification_' + self.$store.state.user.scope.user_id, function (data) {
      self.icon = 'notifications';
      self.showIndicator = true;
    });
  },
  created: function created() {
    var self = this;
    _Notifications2.default.getNotifications().then(function (response) {
      var isViewedArr = [];
      response.data.notifications.forEach(function (item) {
        isViewedArr.push(item.isViewed);
      });
      if (isViewedArr.includes(false)) {
        self.icon = 'notifications_active';
      } else {
        self.icon = 'notifications_none';
      }

      self.notifications = response.data.notifications.slice(0, 5);
      self.isLoading = false;
      self.showIndicator = true;
    }).catch(function (error) {
      self.icon = 'notifications_none';
      self.showIndicator = false;
    });
  },

  methods: {
    showMore: function showMore() {
      var self = this;
      self.isAppending = true;
      self.loadMoreCount += 5;
      self.skip += 5;
      _Notifications2.default.getNotifications(self.skip).then(function (response) {
        self.notifications = [].concat((0, _toConsumableArray3.default)(self.notifications), (0, _toConsumableArray3.default)(response.data.notifications));
        if (response.data.notifications.length < 5) self.notificationEndedFromServer = true;
      }).finally(function () {
        return self.isAppending = false;
      });
    },
    markAllRead: function markAllRead() {
      var self = this;
      self.notifications.forEach(function (item) {
        if (item.isViewed === false) {
          self.notificationsModel.notifications.push(item.id);
        }
      });
      var notificationIds = [];
      self.notifications.forEach(function (notification) {
        return notificationIds.push(notification.notification_id);
      });
      _Notifications2.default.markAsRead({ "notificationId": notificationIds }).then(function (response) {}).finally(function () {
        self.notifications = [];
      });
      self.showMore();
    },
    away: function away() {
      var self = this;
      self.visible = false;
    },
    formatDate: function formatDate(date) {
      return _config2.default.dateFormatting.fromNow(date);
    },
    routeTo: function routeTo(notification) {
      var self = this;
      switch (notification.type) {
        case 'answer':
          this.$router.push({
            path: '/questions/thread/' + notification.routesTo
          });
          self.visible = false;
          break;
        case 'follow':
          break;
      }
    },
    loadMore: function loadMore() {
      var self = this;
      if (self.data.count.totalCount > self.data.notifications.length) {
        self.isAppending = true;
        self.page += 1;
        _Notifications2.default.getNotifications(self.page, self.perPage).then(function (response) {
          self.data.count = response.data.count;
          self.data.notifications.push.apply(self.data.notifications, response.data.notifications);
          self.isAppending = false;
        });
      }
    },
    markReadAndGo: function markReadAndGo(notification) {
      var self = this;

      switch (notification.screenLinkProperties ? notification.screenLinkProperties.type : null) {
        case 'NONE':
        case 'HOME':
          self.$router.push({
            name: 'Dashboard'
          });
          break;
        case 'LIFESTYLE':
          self.$router.push({
            name: 'LifeStyle'
          });
          break;
        case 'COMMUNITY':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
            case 'RECENT':
              self.$router.push({
                name: 'QuestionsIndex'
              });
              break;
            case 'TRENDING':
              self.$router.push({
                path: '/questions?page=1&per_page=25&type=MOST_TRENDING'
              });
              break;
            case 'USEFUL':
              self.$router.push({
                path: '/questions?page=1&per_page=25&type=MOST_USEFUL'
              });
              break;
            case 'POST':
              self.$router.push({
                name: 'QuestionThread',
                params: {
                  id: notification.screenLinkProperties.id
                }
              });
              break;
            case 'NEW':
              self.$router.push({
                name: 'QuestionCreate'
              });
              break;
          }
          break;
        case 'EDUCATION':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
              self.$router.push({
                name: 'Dashboard'
              });
              break;
            case 'LESSON':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id
                }
              });
              break;
            case 'ACTION':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id + '#action_points'
                }
              });
              break;
            case 'QUIZ':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id + '#lessonQuiz'
                }
              });
              break;
            case 'DOWNLOADS':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id + '#downloadsPanel'
                }
              });
              break;

          }
          break;
        case 'FOOD_DIARY':
          self.$router.push({
            name: 'ProfileFoodDiary'
          });
          break;
        case 'TRACKING':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
            case 'WEIGHT':
            case 'MOOD':
            case 'BLOOD_GLUCOSE':
            case 'MEDICATION':
            case 'SLEEP':
            case 'BLOOD_PRESSURE':
            case 'CHOLESTEROL':
            case 'INSULIN':
            case 'KETONES':
            case 'ACTIVITY':
              self.$router.push({
                path: '/dashboard#trackHealth'
              });
              break;
            case 'NEW':
              self.$router.push({
                name: 'AddProgress'
              });
              break;
          }
          break;
        case 'PROFILE':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
              self.$router.push({
                name: 'Profile',
                params: {
                  profileUrl: notification.screenLinkProperties.id
                }
              });
              break;
            case 'NEW':
              self.$router.push({
                name: 'Profile'
              });
              break;
          }
          break;
        case 'FAQ':
          self.$router.push({
            name: 'Faq'
          });
          break;
        case 'RECIPES':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
            case 'HOME':
            case 'INSPIRE_ME':
              self.$router.push({
                name: 'RecipeIndex'
              });
              break;
            case 'FAVOURITES':
              self.$router.push({
                name: 'RecipeFavorites'
              });
              break;
            case 'CATEGORY':
              self.$router.push({
                name: 'recipes/bygroup?' + notification.screenLinkProperties.id
              });
              break;
            case 'RECIPE':
              self.$router.push({
                name: 'RecipeDetail',
                params: {
                  id: notification.screenLinkProperties.id
                }
              });
              break;
          }
          break;
        case 'DOWNLOADS_AND_RESOURCES':
          self.$router.push({
            name: 'Downloads'
          });
          break;
        case 'SETTINGS':
          self.$router.push({
            name: 'SettingsGeneral'
          });
          break;
      }
      _Notifications2.default.markAsRead({ "notificationId": [notification.notification_id] }).then(function (response) {}).finally(function () {
        self.notifications = self.notifications.filter(function (not) {
          return not != notification;
        });
      });
      self.visible = false;
    },
    generateText: function generateText(item) {
      var name = item.user ? item.user.display_name ? item.user.display_name : item.user.firstname : '';
      name = name ? name[0].toUpperCase() + name.substring(1) : '';
      return name + ' ' + item.phrase + ' ' + item.thread_title;
    }
  },
  computed: {
    newNotifications: function newNotifications() {
      var self = this;
      if (!self.notifications.length) {
        return false;
      } else {
        return true;
      }
    }
  }
};

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "PasswordLimitValidation.vue",
  props: {
    password: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      isPasswordLengthValid: false,
      maxCharacter: 64
    };
  },

  watch: {
    'password': function password() {
      var self = this;
      var pw = this.password;
      if (pw.length <= self.maxCharacter) {
        this.isPasswordLengthValid = true;
      } else {
        this.isPasswordLengthValid = 'error';
      }
    }
  }
};

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "PasswordStrengthValidation.vue",
  props: {
    password: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      passwordCheck: {
        upper: false,
        lower: false,
        number: false,
        special: false,
        length: false
      }
    };
  },

  watch: {
    'password': function password() {
      var self = this;
      var pw = this.password;
      self.passwordCheck.upper = RegExp('(?=.*?[A-Z])').test(pw);
      if (self.passwordCheck.upper === false) {
        self.passwordCheck.upper = 'error';
      }
      self.passwordCheck.lower = RegExp('(?=.*?[a-z])').test(pw);
      if (self.passwordCheck.lower === false) {
        self.passwordCheck.lower = 'error';
      }
      self.passwordCheck.number = RegExp('(?=.*?[0-9])').test(pw);
      if (self.passwordCheck.number === false) {
        self.passwordCheck.number = 'error';
      }
      self.passwordCheck.length = RegExp('.{10,}').test(pw);
      if (self.passwordCheck.length === false) {
        self.passwordCheck.length = 'error';
      }
      self.passwordCheck.special = RegExp('(?=.*?[#?!@$%^&*-])').test(pw);
      if (self.passwordCheck.special === false) {
        self.passwordCheck.special = 'error';
      }
    }
  }
};

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Payment = __webpack_require__(196);

var _Payment2 = _interopRequireDefault(_Payment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "payment-call-to-action",
  data: function data() {
    return {
      paypal: null
    };
  },
  mounted: function mounted() {
    this.fetchPaymentDetails();
  },

  methods: {
    goToPayment: function goToPayment() {
      var self = this;
      self.$router.push({
        name: 'Payment'
      });
    },
    fetchPaymentDetails: function fetchPaymentDetails() {
      var self = this;
      _Payment2.default.getPayPalDetails().then(function (response) {
        self.paypal = response.data;
      }).catch(function (error) {});
    }
  }
};

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _ProfileMixin = __webpack_require__(168);

var _ProfileMixin2 = _interopRequireDefault(_ProfileMixin);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'add-profile-bio',
  mixins: [_ProfileMixin2.default],
  data: function data() {
    return {
      bio: "",
      error: "",
      max: 260
    };
  },

  methods: {
    handleOverflow: function handleOverflow(isOverflow) {
      var self = this;
      self.error = isOverflow ? "Must be under " + self.max + " characters " : '';
    },
    saveBio: function saveBio() {
      var self = this;
      _Profile2.default.saveBio(self.bio).then(function (response) {
        if (response.data.error === false) {
          self.closeBio();
          self.$store.state.activeProfileObject.information.basic.bio = self.bio;
          self.$toastr.success("Bio updated");
        }
      }).catch(function (error) {
        if (error) {
          self.$toastr.error("There was an error updating your bio");
          self.closeBio();
        }
      });
    },
    closeBio: function closeBio() {
      var self = this;
      self.$emit('bioClosed', 'bio');
    }
  },
  computed: {
    isBioError: function isBioError() {
      var self = this;
      return self.bio !== null && self.bio.length >= self.max;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.bio = self.getProfile().information.basic.bio;
    (0, _jquery2.default)('.bioField textarea').focus();
  }
};

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _vueBase64FileUpload = __webpack_require__(337);

var _vueBase64FileUpload2 = _interopRequireDefault(_vueBase64FileUpload);

var _croppie = __webpack_require__(537);

var _croppie2 = _interopRequireDefault(_croppie);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _CropperMixin = __webpack_require__(719);

var _CropperMixin2 = _interopRequireDefault(_CropperMixin);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  mixins: [_CropperMixin2.default, _ScrollerMixin2.default],
  components: {
    VueBase64FileUpload: _vueBase64FileUpload2.default
  },
  name: 'add-profile-cover',
  data: function data() {
    return {
      title: "Update cover photo",
      dialog: false,
      customImageMaxSize: 2,
      image: "",
      isUploading: false,
      isCropperVisible: false,
      cropper: undefined,
      completionPercentage: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    self.open();
    var url = void 0;
    if (self.activeProfile.information.basic.cover_photo !== "") {
      url = self.activeProfile.information.basic.cover_photo;
    } else {
      url = 'static/avatar.png';
    }
    var wait = setTimeout(function () {
      var el = self.$refs['imageCropper'];
      if (el) self.cropper = new _croppie2.default(el, {
        size: 'viewport',
        viewport: { width: 1024, height: 400 },
        boundary: { width: 1024, height: 400 },
        showZoomer: false,
        enableOrientation: true
      });
      self.cropper.bind({
        url: url,
        orientation: 4
      });
      clearTimeout(wait);
    }.bind(self), 500);
  },

  methods: {
    open: function open() {
      this.dialog = true;
    },
    close: function close() {
      this.dialog = false;
      this.$emit('coverClosed', 'cover');
    },
    doCrop: function doCrop() {
      var self = this;
      self.isUploading = true;
      self.isCropperVisible = false;
      self.cropper.result('base64').then(function (image) {
        var xhrProgress = {
          onUploadProgress: function onUploadProgress(progressEvent) {
            self.completionPercentage = Math.floor(progressEvent.loaded * 100 / progressEvent.total);
          }
        };
        _axios2.default.post(_config2.default.apiUrl + 'upload/user/cover/', { image: image }, xhrProgress).then(function (response) {
          self.close();
          self.$store.state.activeProfileObject.information.basic.cover_photo = response.data.rows.original;
          self.$store.state.user.cover_photo = response.data.rows.original;
          _all.TweenLite.to(self.scroller, 0.2, {
            scrollTo: {
              y: 0
            }
          });
        });
      }).catch(function () {
        self.$toastr.error("Error updating cover photo");
        self.isUploading = false;
      });
    }
  },
  computed: {
    activeProfile: function activeProfile() {
      var self = this;
      return self.$store.state.activeProfileObject;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    if (self.cropper !== undefined) {
      self.cropper.destroy();
    }
  }
};

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _vueBase64FileUpload = __webpack_require__(337);

var _vueBase64FileUpload2 = _interopRequireDefault(_vueBase64FileUpload);

var _croppie = __webpack_require__(537);

var _croppie2 = _interopRequireDefault(_croppie);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _CropperMixin = __webpack_require__(719);

var _CropperMixin2 = _interopRequireDefault(_CropperMixin);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  mixins: [_CropperMixin2.default, _ScrollerMixin2.default],
  components: {
    VueBase64FileUpload: _vueBase64FileUpload2.default
  },
  name: 'add-profile-picture',
  data: function data() {
    return {
      title: "Update profile picture",
      dialog: false,
      customImageMaxSize: 2,
      image: "",
      isUploading: false,
      isCropperVisible: false,
      cropper: undefined,
      completionPercentage: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    self.open();
    var url = void 0;
    if (self.activeProfile.information.basic.cover_photo !== "") {
      url = self.activeProfile.information.basic.cover_photo;
    } else {
      url = 'static/avatar.png';
    }
    var wait = setTimeout(function () {
      var el = self.$refs['imageCropper'];
      if (el) self.cropper = new _croppie2.default(el, {
        size: 'viewport',
        viewport: { width: 250, height: 250 },
        boundary: { width: 250, height: 250 },
        showZoomer: true,
        enableOrientation: true
      });
      self.cropper.bind({
        url: url,
        orientation: 4
      });
      clearTimeout(wait);
    }.bind(self), 500);
  },

  methods: {
    open: function open() {
      this.dialog = true;
    },
    close: function close() {
      this.dialog = false;
      this.$emit('pictureClosed', 'avatar');
    },
    cancel: function cancel() {
      this.close();
    },
    doCrop: function doCrop() {
      var self = this;
      self.isUploading = true;
      self.isCropperVisible = false;
      self.cropper.result('base64').then(function (image) {
        var xhrProgress = {
          onUploadProgress: function onUploadProgress(progressEvent) {
            self.completionPercentage = Math.floor(progressEvent.loaded * 100 / progressEvent.total);
          }
        };
        _axios2.default.post(_config2.default.apiUrl + 'upload/profile-picture/', { image: image }, xhrProgress).then(function (response) {
          self.close();
          self.$store.state.activeProfileObject.information.basic.profile_image = response.data.profile_large;
          self.$store.state.user.scope.profile_large = response.data.profile_large;
          _all.TweenLite.to(self.scroller, 0.2, {
            scrollTo: {
              y: 0
            }
          });
        });
      }).catch(function () {
        self.$toastr.error("Error updating cover photo");
        self.isUploading = false;
      });
    }
  },
  computed: {
    activeProfile: function activeProfile() {
      var self = this;
      return self.$store.state.activeProfileObject;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    if (self.cropper !== undefined) {
      self.cropper.destroy();
    }
  }
};

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'follower-item',
  props: {
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      tabs: [{
        label: "Followers",
        route: 'followers'
      }, {
        label: "Following",
        route: 'following'
      }]
    };
  },

  methods: {
    followUser: function followUser(item) {
      var self = this,
          follow_id = null;
      item.is_sending = true;
      self.$forceUpdate();
      if (self.type === 'following') {
        follow_id = item.follow_id;
      } else if (self.type === 'followers') {
        follow_id = item.user_id;
      }
      if (follow_id !== null) {
        _Profile2.default.follow({ follow_id: follow_id }).then(function (response) {
          var callback = response.data;
          if (callback.isFollowing) {
            item.is_following = true;
          } else {
            item.is_following = false;
          }
          item.is_sending = false;
        }).catch(function (error) {
          self.$toastr.error(error.response.data.message);
          item.is_sending = false;
        });
      }
    },
    goToProfile: function goToProfile(profileUrl) {
      var self = this;
      self.$router.push({
        name: 'Profile',
        params: {
          profileUrl: profileUrl
        }
      });
    }
  },
  computed: {
    isOwnProfile: function isOwnProfile() {
      var self = this;
      if (_lodash2.default.has(self.$store.state.user, 'scope')) {
        return self.$store.state.activeProfile === self.$store.state.user.scope.user_id;
      }
    }
  }
};

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _FoodDiaryTab = __webpack_require__(3424);

var _FoodDiaryTab2 = _interopRequireDefault(_FoodDiaryTab);

__webpack_require__(946);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    FoodDairyTab: _FoodDiaryTab2.default
  },
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  name: 'food-diary',
  data: function data() {
    return {
      isLoading: false,
      date: null,
      formatDateAs: 'YYYY-MM-DD',
      activeTab: 'All',
      tabs: [{ label: 'All' }, { label: 'Breakfast' }, { label: 'Lunch' }, { label: 'Dinner' }, { label: 'Snack' }],
      diary: {}
    };
  },

  methods: {
    onDeleteFood: function onDeleteFood(food) {
      var self = this;
      self.loadFoodByDay();
    },
    loadFoodByDay: function loadFoodByDay() {
      var self = this;
      self.isLoading = true;
      _Food2.default.getFoodWithDate(self.date, self.userId).then(function (response) {
        self.diary = response.data;
        self.isLoading = false;

        self.setActiveTab('All');
      }).catch(function (error) {
        self.$toastr.error('Error loading your diary');
      });
    },
    initMounted: function initMounted() {
      var self = this;

      self.date = self.getNowDate();

      self.loadFoodByDay();
    },
    getNowDate: function getNowDate() {
      var self = this;

      return moment().format(self.formatDateAs);
    },
    filterDiaryByDay: function filterDiaryByDay(direction) {
      var self = this,
          newDate = null;
      if (direction === 'next') {
        newDate = moment(self.date).add('1', 'days').format(self.formatDateAs);
      }
      if (direction === 'back') {
        newDate = moment(self.date).subtract('1', 'days').format(self.formatDateAs);
      }

      self.date = newDate;

      self.loadFoodByDay();
    },
    formatDate: function formatDate(date, format) {
      return moment(date).format(format);
    },
    setActiveTab: function setActiveTab(tab) {
      var self = this;
      self.activeTab = tab;
    },
    filterDiaryBy: function filterDiaryBy(type, tab) {
      var self = this,
          data = null;

      tab = tab.toLowerCase();
      if (type === 'meal_types') {
        data = self.diary.foods.meal_types[tab];
      }
      if (type === 'totals') {
        data = self.diary.totals[tab];
      }

      return data;
    },
    filterRecipeDiaryBy: function filterRecipeDiaryBy(type, tab) {
      var self = this,
          data = null;

      tab = tab.toLowerCase();
      if (type === 'meal_types') {
        data = self.diary.recipes[tab];
      }

      return data;
    }
  },
  computed: {
    hasFoods: function hasFoods() {
      var self = this;
      return self.diary.total > 0 || self.diary.recipes && self.diary.recipes.all && self.diary.recipes.all.length > 0;
    },
    isToday: function isToday() {
      var self = this;
      return moment(self.date).isSame(moment(), 'day');
    }
  },
  mounted: function mounted() {
    var self = this;

    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

__webpack_require__(946);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    userId: {
      type: Number,
      default: 0
    },
    tab: {
      type: String,
      required: true
    },
    foods: {
      type: Array,
      required: true
    },
    recipes: {
      type: Array,
      required: true
    },
    totals: {
      type: Object,
      required: true
    }
  },
  name: 'food-dairy-tab',
  data: function data() {
    return {
      nutritionalKeys: [{ key: "carbohydrate", label: "Carbs", unit: "g" }, { key: "fat", label: "Fat", unit: "g" }, { key: "protein", label: "Protein", unit: "g" }, { key: "sugar", label: "Sugar", unit: "g" }, { key: "calories", label: "Cals", unit: "kcal" }]
    };
  },

  methods: {
    getValueByNutritionKey: function getValueByNutritionKey(key) {
      var self = this;
      return self.totals[key];
    },
    deleteFood: function deleteFood(food, foodIndex) {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "Are you sure you wish to delete this food",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white"
      }).then(function () {
        food.foodIndex = foodIndex;
        self.processDeleteFood(food);
      }).catch(function () {});
    },
    processDeleteFood: function processDeleteFood(food) {
      var self = this;
      _Food2.default.deleteFood(food.food_id).then(function (response) {
        if (response.data.complete) {
          self.$emit('onDelete', food);
          self.$toastr.success(response.data.message);
        }
      }).catch(function (error) {
        var message = "";
        if (error.response.data.error) {
          message = error.response.data.message;
        } else {
          message = 'Error deleting food';
        }
        self.$toastr.error(message);
      });
    },
    deleteRecipe: function deleteRecipe(recipe, recipeIndex) {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "Are you sure you wish to delete this recipe",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white"
      }).then(function () {
        recipe.recipeIndex = recipeIndex;
        self.processDeleteRecipe(recipe);
      }).catch(function () {});
    },
    processDeleteRecipe: function processDeleteRecipe(recipe) {
      var self = this;
      _Food2.default.deleteRecipe(recipe.id).then(function (response) {
        if (response.data.complete) {
          self.$emit('onDelete', recipe);
          self.$toastr.success(response.data.message);
        }
      }).catch(function (error) {
        var message = "";
        if (error.response.data.error) {
          message = error.response.data.message;
        } else {
          message = 'Error deleting food';
        }
        self.$toastr.error(message);
      });
    }
  },

  computed: {
    hasFoods: function hasFoods() {
      var self = this;
      return self.foods.length > 0;
    },
    hasRecipes: function hasRecipes() {
      var self = this;
      return self.recipes.length > 0;
    }
  }
};

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

__webpack_require__(2588);

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _UploadAvatar = __webpack_require__(674);

var _UploadAvatar2 = _interopRequireDefault(_UploadAvatar);

var _ImageManager = __webpack_require__(717);

var _ImageManager2 = _interopRequireDefault(_ImageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { AvatarUploader: _UploadAvatar2.default },
  name: 'profile-gallery',
  props: {
    isOwner: {
      type: Boolean,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      uploadProgress: 0,
      profileImage: null
    };
  },

  methods: {
    deleteImage: function deleteImage(index, imageId) {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "Are you sure you want to remove the following picture?",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white"
      }).then(function (response) {
        _Profile2.default.deleteImage(imageId).then(function (response) {
          if (response.data.complete) {
            self.$toastr.success('Image deleted');
            self.images.splice(index, 1);
          }
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    bindUploadEvent: function bindUploadEvent() {
      $('#uploadBtn').next().trigger('click');
    },
    chooseImage: function chooseImage(event) {
      var self = this,
          input = event.target;

      if (input.files && input.files[0]) {
        self.uploadImage(input.files[0]);
      }
    },
    setAsProfile: function setAsProfile(image) {
      var self = this;

      self.profileImage = null;
      setTimeout(function () {
        self.profileImage = image.image_url;
      }, 500);
    },
    uploadImage: function uploadImage(file) {
      var self = this,
          data = new FormData();
      data.append('file', file);
      var config = {
        onUploadProgress: function onUploadProgress(progressEvent) {
          self.uploadProgress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
        }
      };
      _axios2.default.post(_Profile2.default.galleryUploadURL(), data, config).then(function (response) {
        if (response.data.complete === true) {
          self.images.unshift(response.data.image);
          self.$toastr.success(self.$t('message.labelSuccess'));
          self.uploadProgress = 0;
        }
      }).catch(function (error) {
        if (error.data.response) {
          self.$toastr.error(error.data.response.message);
          self.uploadProgress = 0;
        }
      });
    }
  },
  computed: {
    isUploadingImage: function isUploadingImage() {
      var self = this;
      return self.uploadProgress !== 0 ? true : false;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.scroller = $('.scroller');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _AddProfileBio = __webpack_require__(3420);

var _AddProfileBio2 = _interopRequireDefault(_AddProfileBio);

var _AddProfileCover = __webpack_require__(3421);

var _AddProfileCover2 = _interopRequireDefault(_AddProfileCover);

var _ProfileMixin = __webpack_require__(168);

var _ProfileMixin2 = _interopRequireDefault(_ProfileMixin);

var _ProfileGoals = __webpack_require__(3426);

var _ProfileGoals2 = _interopRequireDefault(_ProfileGoals);

var _AddProfilePicture = __webpack_require__(3422);

var _AddProfilePicture2 = _interopRequireDefault(_AddProfilePicture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    AddProfilePicture: _AddProfilePicture2.default,
    AddProfileCover: _AddProfileCover2.default,
    AddProfileBio: _AddProfileBio2.default,
    ProfileGoals: _ProfileGoals2.default
  },
  mixins: [_ProfileMixin2.default],
  name: 'profile-avatar',
  props: {
    profile: {
      type: Object
    }
  },
  data: function data() {
    return {
      metaFields: [{
        key: "bio",
        label: !this.profile.bio ? this.$t('message.labelEnterBio') : this.$t('message.labelUpdateBio'),
        toggle: false
      }, {
        key: "avatar",
        label: this.$t('message.labelChangeProfilePicture'),
        toggle: false
      }, {
        key: "remove-avatar",
        label: this.$t('message.labelRemoveProfilePicture'),
        toggle: false,
        to: "remove-avatar"
      }, {
        key: "cover",
        label: !this.profile.cover_photo ? this.$t('message.labelAddCoverPhoto') : this.$t('message.labelUpdateCoverPhoto'),
        toggle: false
      }, {
        key: "remove-cover",
        label: this.$t('message.labelRemoveCoverPhoto'),
        toggle: false,
        to: "remove-cover"
      }],
      isProcessFollowing: false
    };
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    onClose: function onClose(field) {
      var self = this;
      var data = _.find(self.metaFields, function (meta) {
        if (meta.key === field) {
          meta.toggle = false;
        }
      });
    },
    onCoverPhotoUpdated: function onCoverPhotoUpdated(url) {
      this.$EventBus.$emit('CoverPhotoUpdated', url);
    },
    goTo: function goTo(name) {
      var self = this;
      self.$router.push({
        name: name
      });
    },
    follow: function follow() {
      var self = this;
      self.isProcessFollowing = true;
      _Profile2.default.follow({ follow_id: self.profile.user_id }).then(function (response) {
        var callback = response.data;
        self.isProcessFollowing = false;
        if (callback.complete) {
          if (callback.isFollowing) {
            self.profile.auth_user_following = true;
            self.profile.followers += 1;
          } else {
            self.profile.auth_user_following = false;
            self.profile.followers -= 1;
          }
        }
      }).catch(function (error) {
        self.isProcessFollowing = false;
        self.$toastr.error(error.response.data.message);
      });
    },
    doMetaField: function doMetaField(field) {
      if (field.toggle === true) {
        field.toggle = false;
      } else {
        field.toggle = true;
      }
    },
    removeProfilePicture: function removeProfilePicture() {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "You are about to remove your profile picture",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white"
      }).then(function () {
        self.deleteProfilePicture();
      }).catch(function () {});
    },
    deleteProfilePicture: function deleteProfilePicture() {
      var self = this;
      _Profile2.default.deleteProfilePicture().then(function (res) {
        self.$store.state.user.scope.profile_large = null;
        self.$store.state.activeProfileObject.information.basic.profile_image = null;
      }).catch(function (err) {});
    },
    removeCoverPhoto: function removeCoverPhoto() {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "You are about to remove your cover photo",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white"
      }).then(function () {
        self.deleteCoverPhoto();
      }).catch(function () {});
    },
    deleteCoverPhoto: function deleteCoverPhoto() {
      var self = this;
      _Profile2.default.deleteCoverPhoto().then(function (res) {
        self.$store.state.activeProfileObject.information.basic.cover_photo = null;
        self.$store.state.user.cover_photo = null;
      }).catch(function (err) {});
    }
  },
  computed: {
    showProfileInfo: function showProfileInfo() {
      var self = this;
      return !self.showPrivacyInfo && !self.showPrivacyQuestions;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(168);

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'profile-goals',
  mixins: [_index2.default],
  data: function data() {
    return {};
  },

  computed: {
    computedGoals: function computedGoals() {
      var self = this,
          store = self.getProfile();
      return store.goals;
    }
  }
};

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

var _ProfileMixin = __webpack_require__(168);

var _ProfileMixin2 = _interopRequireDefault(_ProfileMixin);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _CountryBadge = __webpack_require__(340);

var _CountryBadge2 = _interopRequireDefault(_CountryBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CountryBadge: _CountryBadge2.default,
    UserBadge: _UserBadge2.default },
  name: 'profile-header',
  mixins: [_ProfileMixin2.default, _HCPMixin2.default],
  props: {
    profile: {
      type: Object
    }
  },
  data: function data() {
    return {
      loading: true
    };
  },

  methods: {
    follow: function follow() {
      var self = this;
      _Profile2.default.follow({ follow_id: self.profile.user_id }).then(function (response) {
        var callback = response.data;
        if (callback.complete) {
          if (callback.isFollowing === true) {
            self.profile.auth_user_following = true;
            self.profile.followers += 1;
          } else {
            self.profile.auth_user_following = false;
            self.profile.followers -= 1;
          }
        }
      }).catch(function (error) {
        self.$toastr.error(error.response.data.message);
      });
    }
  }
};

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _cardText = __webpack_require__(659);

var _cardText2 = _interopRequireDefault(_cardText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { MuCardText: _cardText2.default },
  name: "user-profile-questions",
  props: {
    type: {
      type: String,
      required: true,
      default: "MY_QUESTIONS"
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: true,
      items: [],
      params: {
        page: 1,
        per_page: 5,
        type: "",
        user_id: 0
      }
    };
  },

  methods: {
    fromNow: function fromNow(date) {
      return _config2.default.dateFormatting.fromNow(date);
    },
    loadQuestions: function loadQuestions() {
      var self = this;
      self.params.type = self.type;
      self.params.user_id = self.userId;
      _Discussion2.default.getDiscussionQuestions(self.params).then(function (response) {
        self.isLoading = false;
        self.items = response.data.questions;
      }).catch(function (error) {
        self.isLoading = false;
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.loadQuestions();
    }
  },
  computed: {
    hasItems: function hasItems() {
      var self = this;
      return self.items.length > 0 ? true : false;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'provider',
  computed: {
    provider: function provider() {
      var self = this;
      return self.$store.state.provider;
    }
  }
};

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _textField = __webpack_require__(228);

var _textField2 = _interopRequireDefault(_textField);

var _flatButton = __webpack_require__(339);

var _flatButton2 = _interopRequireDefault(_flatButton);

var _selectField = __webpack_require__(661);

var _selectField2 = _interopRequireDefault(_selectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuSelectField: _selectField2.default,
    MuFlatButton: _flatButton2.default,
    MuTextField: _textField2.default
  },
  name: "create-question",
  data: function data() {
    return {
      isSaving: false,
      user: {},
      model: {},
      categories: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.user = self.$store.state.user;
    $('#focusable input').focus();

    if (typeof _Discussion2.default.getCategories === 'function') {
      _Discussion2.default.getCategories().then(function (response) {
        self.categories = response.data;
      });
    }
  },

  methods: {
    goBack: function goBack() {
      window.history.back();
    },
    saveQuestion: function saveQuestion() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        self.isSaving = true;
        if (valid) {
          _Discussion2.default.createDiscussionThread(self.model).then(function (response) {

            self.$gtag.event('AskedQuestion', {
              'event_category': 'Questions',
              'event_label': 'Asked a question',
              'value': 1
            });

            self.isSaving = false;

            self.$router.push({
              path: '/questions/thread/' + response.data.last_id,
              query: {
                page: 1,
                per_page: 10
              }
            });
          }).catch(function (error) {
            if (error.response.data) {
              self.isSaving = false;
              self.$toastr.error(error.response.data.message);
            }
          });
        } else {
          self.isSaving = false;
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _medium = __webpack_require__(3017);

var _medium2 = _interopRequireDefault(_medium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'edit-question-title',
  data: function data() {
    return {
      isSaving: false,
      isEditMode: false,
      editor: undefined
    };
  },

  props: {
    title: {
      type: String
    },
    questionId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    cancel: function cancel() {
      var self = this;
      self.isEditMode = false;
    },
    editMode: function editMode() {
      var self = this;
      self.isEditMode = true;
      self.editor = new _medium2.default({
        mode: _medium2.default.inlineMode,
        autoHR: false,
        element: document.getElementById('q-editor'),
        pasteAsText: true,
        beforeInvokeElement: function beforeInvokeElement() {
          this.setClean(false);
        }
      });
      self.editor.value(self.title);
      self.$nextTick(function () {
        self.editor.focus();
        self.editor.cursor.set(self.title.length);
      });
    },
    updateQuestion: function updateQuestion() {
      var self = this;
      if (self.editor.value().trim() === '') {
        self.$toastr.error('The title cannot be empty');
        return;
      }

      if (self.editor.value().includes('&nbsp;')) {
        self.$toastr.error('The title cannot be empty or start with a space');
        return;
      }
      self.isSaving = true;
      var model = {
        question_id: self.questionId,
        question: self.editor.value()
      };
      _Discussion2.default.updateQuestion(model).then(function () {
        self.isSaving = false;
        self.isEditMode = false;
        self.$emit('questionUpdated', model.question);
        self.$toastr.success('Updated question');
      });
    }
  }
};

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "frequently-asked",
  data: function data() {
    return {
      isLoading: true,
      isSaving: false,
      data: []
    };
  },

  methods: {
    goToQuestion: function goToQuestion(id) {
      var self = this;
      self.$router.push({
        name: 'QuestionThread',
        params: {
          id: id
        }
      });
    },
    encode: function encode(title) {
      return _HTMLStringParser2.default.encode(title);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.isLoading = true;
    if (self.$store.state.discussion.frequentlyAsked.length > 0) {
      self.data = self.$store.state.discussion.frequentlyAsked;
      self.isLoading = false;
    } else _Discussion2.default.getDiscussionFrequentlyAsked().then(function (response) {
      self.isLoading = false;
      self.data = response.data;
      self.$store.commit('setDiscussionFrequentlyAsked', response.data);
    });
  }
};

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "my-questions",
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'userId': function userId() {
      var self = this;
      _Discussion2.default.getDiscusionRecentlyAsked(self.userId).then(function (response) {
        self.data = response.data;
        self.isLoading = false;
      }).catch(function (error) {
        self.data = [];
        self.isLoading = false;
      });
    }
  },
  data: function data() {
    return {
      isLoading: true,
      dummyLoaders: [{}, {}, {}, {}],
      isSaving: false,
      data: []
    };
  },
  mounted: function mounted() {
    var self = this;
    _Discussion2.default.getDiscusionRecentlyAsked(self.userId).then(function (response) {
      self.data = response.data;
      self.isLoading = false;
    }).catch(function (error) {
      self.data = [];
      self.isLoading = false;
    });
  },

  methods: {
    askQuestion: function askQuestion() {
      var self = this;
      self.$router.push({
        name: 'Ask a question'
      });
    }
  }
};

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'search-questions',
  data: function data() {
    return {
      searchTerm: ""
    };
  },

  props: {
    isSearching: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.$router.replace({
            name: 'QuestionsIndex',
            query: {
              type: 'SEARCH',
              page: 1,
              per_page: 15,
              q: self.searchTerm
            }
          });
        }
      });
    }
  }
};

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "top-contributors",
  data: function data() {
    return {
      isLoading: true,
      isSaving: false,
      data: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.isLoading = true;

    if (self.$store.state.discussion.topContributors == null) {
      _Discussion2.default.getDiscussionsTopContributors().then(function (response) {
        self.isLoading = false;
        self.data = response.data;
        self.$store.commit('setDiscussionContributors', response.data);
      }).catch(function (err) {});

      return;
    }

    if (self.$store.state.discussion.topContributors.length > 0) {
      self.data = self.$store.state.discussion.topContributors;
      self.isLoading = false;
    } else _Discussion2.default.getDiscussionsTopContributors().then(function (response) {
      self.isLoading = false;
      self.data = response.data;
      self.$store.commit('setDiscussionContributors', response.data);
    }).catch(function (err) {});
  },

  methods: {
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.floor(Math.random() * (max - min) + min) + '%';
    },
    profileUrl: function profileUrl(url) {
      url = url.split('-').join('.');
      return url;
    },
    goTo: function goTo(url) {
      var self = this;
      self.$router.push({
        name: 'Profile',
        params: {
          profileUrl: url
        }
      });
    }
  }
};

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2240);

var _radialProgressChart = __webpack_require__(3028);

var _radialProgressChart2 = _interopRequireDefault(_radialProgressChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "radial-progress",
  props: {
    mode: {
      type: String,
      default: 'normal'
    },
    dataId: {
      type: String
    },
    color: {
      type: String,
      default: 'red'
    },
    outOfValue: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    suffix: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      rb: 'undefined'
    };
  },
  mounted: function mounted() {
    var self = this;
    if (self.mode === 'normal') {
      self.rb = new _radialProgressChart2.default('#' + self.dataId, {
        stroke: {
          width: 8,
          gap: 2
        },
        shadow: {
          width: 0
        },
        diameter: 200,
        max: 100,
        round: false,
        series: [{

          value: self.value,
          color: self.color
        }],
        center: function center(d) {
          return d.toFixed(0) + self.suffix;
        }
      });
    }
    if (self.mode === 'outOf') {
      self.rb = new _radialProgressChart2.default('#' + self.dataId, {
        stroke: {
          width: 3,
          gap: 0
        },
        shadow: {
          width: 0
        },
        diameter: 190,
        max: self.outOfValue,
        round: true,
        series: [{

          value: self.value,
          color: self.color
        }],
        center: {
          content: [function (value) {
            return value + self.suffix;
          }, ' OF ' + self.outOfValue + self.suffix],
          y: 15
        }
      });
    }

    if (self.mode === 'duration') {
      var outOf = void 0;
      moment.relativeTimeThreshold('m', 60);
      moment.relativeTimeThreshold('s', 60);
      var start = moment();
      var end = moment();
      end.add(self.outOfValue, 'minutes');
      var diff = end.diff(start);
      var object = moment.utc(diff).toObject();
      if (object.hours === 0) {
        outOf = moment.duration(object.minutes, 'minutes').format('m _');
      }
      outOf = moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
      self.rb = new _radialProgressChart2.default('#' + self.dataId, {
        stroke: {
          width: 3,
          gap: 0
        },
        shadow: {
          width: 0
        },
        diameter: 300,
        max: self.outOfValue,
        round: true,
        series: [{
          value: self.value,
          color: self.color
        }],
        center: {
          content: [function (value) {
            var outOf = void 0;
            moment.relativeTimeThreshold('m', 60);
            moment.relativeTimeThreshold('s', 60);
            var start = moment();
            var end = moment();
            end.add(value, 'minutes');
            var diff = end.diff(start);
            var object = moment.utc(diff).toObject();
            if (object.hours === 0) {
              outOf = moment.duration(object.minutes, 'minutes').format('m _');
              return moment.duration(object.minutes, 'minutes').format('m _');
            } else {
              outOf = moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
            }
            return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
          }, ' OF ' + outOf],
          y: 15
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DateMonths = __webpack_require__(232);

var _DateMonths2 = _interopRequireDefault(_DateMonths);

var _SocialLoginMixin = __webpack_require__(357);

var _SocialLoginMixin2 = _interopRequireDefault(_SocialLoginMixin);

var _RegistrationMixin = __webpack_require__(485);

var _RegistrationMixin2 = _interopRequireDefault(_RegistrationMixin);

var _PasswordStrengthValidation = __webpack_require__(342);

var _PasswordStrengthValidation2 = _interopRequireDefault(_PasswordStrengthValidation);

var _Registration = __webpack_require__(477);

var _Registration2 = _interopRequireDefault(_Registration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      prefilled: {
        firstname: false,
        surname: false,
        email: true,
        dob: false
      },
      submitFunc: _Registration2.default.complete
    };
  },

  computed: {},
  name: "CompleteSocialRegistration",
  mixins: [_DateMonths2.default, _SocialLoginMixin2.default, _RegistrationMixin2.default],
  components: {
    PasswordStrengthValidation: _PasswordStrengthValidation2.default
  },
  mounted: function mounted() {
    var self = this;
    var user = self.$store.state.user.scope;
    if (user.firstname && user.firstname.length) {
      self.prefilled.firstname = user.firstname;
      self.model.firstname = user.firstname;
    }

    if (user.surname && user.surname.length) {
      self.prefilled.surname = user.surname;
      self.model.surname = user.surname;
    }

    if (user.email && user.email.length) {
      self.prefilled.email = user.email;
      self.model.email = user.email;
      self.model.emailVerify = user.email;
    }

    if (user.dob && user.dob.length) {
      self.prefilled.dob = user.dob;
      self.model.dob = user.dob;
      self.explodeDob();
    }
  },

  methods: {
    explodeDob: function explodeDob() {
      var self = this;
      var dobBits = self.model.dob.toString().split('-');
      var yearObject = self.dobItems.years.find(function (elem) {
        return elem.value === dobBits[0];
      });
      var monthObject = self.dobItems.months.find(function (elem) {
        return elem.value === dobBits[1].toString();
      });
      self.dob.day = dobBits[2];
      self.dob.month = monthObject;
      self.dob.year = yearObject;
    }
  }
};

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DateMonths = __webpack_require__(232);

var _DateMonths2 = _interopRequireDefault(_DateMonths);

var _SocialLoginMixin = __webpack_require__(357);

var _SocialLoginMixin2 = _interopRequireDefault(_SocialLoginMixin);

var _RegistrationMixin = __webpack_require__(485);

var _RegistrationMixin2 = _interopRequireDefault(_RegistrationMixin);

var _PasswordStrengthValidation = __webpack_require__(342);

var _PasswordStrengthValidation2 = _interopRequireDefault(_PasswordStrengthValidation);

var _PasswordLimitValidation = __webpack_require__(3418);

var _PasswordLimitValidation2 = _interopRequireDefault(_PasswordLimitValidation);

var _vueRecaptcha = __webpack_require__(676);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "InitialRegistration",
  mixins: [_DateMonths2.default, _SocialLoginMixin2.default, _RegistrationMixin2.default],
  watch: {
    '$route': {
      handler: function handler() {
        if (_.has(this.$route.query, 'oc')) {
          this.model.offerCode = this.$route.query.oc;
        }
        if (_.has(this.$route.query, 'rid')) {
          this.model.referralId = this.$route.query.rid;
        }
        if (_.has(this.$route.query, 'sid')) {
          this.model.subReferralId = this.$route.query.sid;
        }
      },
      immediate: true
    },
    'model.captchaFilled': {
      handler: function handler(val) {
        if (val === false) this.onCaptchaExpired();
      }
    }
  },
  components: {
    PasswordStrengthValidation: _PasswordStrengthValidation2.default,
    PasswordLimitValidation: _PasswordLimitValidation2.default,
    VueRecaptcha: _vueRecaptcha2.default
  },
  computed: {
    confirmPassErr: function confirmPassErr() {
      var self = this;
      var error = self.errors.first('passwordVerify');
      if (error === "The Confirm Password confirmation does not match.") {
        return 'Please enter passwords that match';
      } else {
        return error;
      }
    }
  },
  methods: {
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.model.captcha = recaptchaToken;
      this.model.captchaFilled = true;
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.model.captcha = '';
      this.model.captchaFilled = false;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _Reporting = __webpack_require__(197);

var _Reporting2 = _interopRequireDefault(_Reporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'list-reports',
  data: function data() {
    return {
      scrollingElement: null,
      reports: [],
      isAppending: false,
      isFinished: false,
      params: {
        page: 1,
        per_page: 10
      }
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment(date).format('lll');
    },
    goToReport: function goToReport(report) {
      var self = this,
          routeName = void 0;

      switch (report.type) {
        case 'THREAD_QUESTION':
          routeName = 'QuestionReport';
          break;
        case 'THREAD_ANSWER':
          routeName = 'AnswerReport';
          break;
        case 'LIFE_REPLY':
          routeName = 'LifeReplyReport';
          break;
        case 'LIFE_SUBREPLY':
          routeName = 'LifeSubReplyReport';
          break;
        default:
          break;
      }

      self.$router.push({
        name: routeName,
        params: {
          id: report.type_id
        }
      });
    },
    loadReports: function loadReports() {
      var self = this;
      self.isAppending = true;
      _Reporting2.default.getReports(self.params).then(function (response) {
        var callback = response.data;
        self.reports.push.apply(self.reports, callback.data);
        self.isAppending = false;
        if (self.params.page === callback.last_page) {
          self.isFinished = true;
        } else {
          self.params.page += 1;
        }
      }).catch(function (error) {});
    },
    onScroll: function onScroll() {
      var self = this;

      if (self.hasReports) {
        if (_ScrollManager2.default.isElementWithinContentView('#listReportsScroll', '#scrollDetector')) {
          if (self.isFinished === false) {
            self.loadReports();
          }
        }
      }
    },
    initMounted: function initMounted() {
      var self = this;
      self.loadReports();
    }
  },
  computed: {
    hasReports: function hasReports() {
      var self = this;
      return self.reports.length !== 0;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.scrollingElement = document.getElementById('listReportsScroll');
    self.scrollingElement.addEventListener('scroll', self.onScroll);
    self.initMounted();
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    if (self.scrollingElement !== null) {
      self.scrollingElement.addEventListener('scroll', self.onScroll);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _Reporting = __webpack_require__(197);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _flatButton = __webpack_require__(339);

var _flatButton2 = _interopRequireDefault(_flatButton);

var _cardText = __webpack_require__(659);

var _cardText2 = _interopRequireDefault(_cardText);

var _avatar = __webpack_require__(3363);

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuAvatar: _avatar2.default,
    MuCardText: _cardText2.default,
    MuFlatButton: _flatButton2.default
  },
  name: 'report',
  props: {
    type: {
      type: String,
      default: 'THREAD_ANSWER'
    },
    typeId: {
      type: Number
    }
  },
  data: function data() {
    return {
      limitSize: 1,
      report: {
        reasons: []
      },
      message: ""
    };
  },
  mounted: function mounted() {
    var self = this;

    if (self.type === 'THREAD_QUESTION') {
      self.message = "This question has been reported";
    }
    if (self.type === 'THREAD_ANSWER') {
      self.message = "This answer has been reported";
    }
    if (self.type === 'LIFE_REPLY' || self.type === 'LIFE_SUBREPLY') {
      self.message = "This comment has been reported";
    }

    _Reporting2.default.getReport(self.type, self.typeId).then(function (response) {
      self.report = response.data;
    });
  },

  methods: {
    goTo: function goTo(type) {
      var self = this;

      var routeName = void 0;
      if (type === 'THREAD_QUESTION') {
        routeName = 'QuestionReport';
      }
      if (type === 'THREAD_ANSWER') {
        routeName = 'AnswerReport';
      }
      if (type === 'LIFE_REPLY') {
        routeName = 'LifeReplyReport';
      }
      if (type === 'LIFE_SUBREPLY') {
        routeName = 'LifeSubReplyReport';
      }

      self.$router.push({
        name: routeName,
        params: {
          id: self.typeId
        }
      });
    },
    showAllReasons: function showAllReasons() {
      var self = this;
      self.limitSize = Infinity;
    },
    hideReasons: function hideReasons() {
      var self = this;
      self.limitSize = 1;
    }
  },
  computed: {
    splicedReports: function splicedReports() {
      var self = this;
      var reasons = JSON.parse((0, _stringify2.default)(self.report.reasons));
      return reasons.splice(0, self.limitSize);
    },
    notReportingPage: function notReportingPage() {
      var self = this;
      return self.$route.name !== 'QuestionReport' && self.$route.name !== 'AnswerReport' && self.$route.name !== 'LifeReplyReport' && self.$route.name !== 'LifeSubReplyReport';
    }
  }
};

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Reporting = __webpack_require__(197);

var _Reporting2 = _interopRequireDefault(_Reporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    type_id: {
      type: Number,
      required: true
    }
  },
  name: "report-modal",
  data: function data() {
    return {
      reasons: {},
      chosen_reason: null
    };
  },

  methods: {
    close: function close() {
      var self = this;
      self.$emit('onClose', false);
    },
    loadReasons: function loadReasons() {
      var self = this;

      if (self.$store.state.reportingReasons.length === 0) {
        _Reporting2.default.getReasons().then(function (response) {
          self.reasons = response.data;
          self.$store.commit('setReportingReasons', self.reasons);
        });
      } else {
        self.reasons = self.$store.state.reportingReasons;
      }
    },
    submit: function submit() {
      var self = this;
      _Reporting2.default.postReport({
        type_id: self.type_id,
        type: self.type,
        reason_id: parseInt(self.chosen_reason)
      }).then(function (response) {
        var message = "";
        if (!response.data.error) {
          message = "Content reported. Thanks";
          self.$emit('onComplete');
          self.chosen_reason = null;
        } else {
          message = response.data.message;
        }
        self.$toastr.success(message);
      }).catch(function (error) {
        if (error.response.data) {
          self.$toastr.error(error.response.data.message);
        }
      });

      self.close();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.loadReasons();
  }
};

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Alert: _Alert2.default },
  name: 'reset-account',
  methods: {
    confirmRestart: function confirmRestart() {
      var self = this;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmResetAccount'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Account2.default.resetWeek1();
        }
      }).then(function () {
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedResetAccount'),
          type: "success",
          showCancelButton: false,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white"
        });
        setTimeout(function () {
          window.location.reload();
        }.bind(self), 1000);
      });
    }
  }
};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _textField = __webpack_require__(228);

var _textField2 = _interopRequireDefault(_textField);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuRaisedButton: _raisedButton2.default,
    MuTextField: _textField2.default
  },
  name: "update-height",
  data: function data() {
    return {
      title: this.$t('message.heightUpdateFormTitle'),
      subTitle: this.$t('message.heightUpdateFormSubTitle'),
      isSaving: false,
      model: null
    };
  },
  mounted: function mounted() {
    var self = this;
    self.getHeightSettings();
  },

  methods: {
    getHeightSettings: function getHeightSettings() {
      var self = this;
      _Settings2.default.getHeightSettings().then(function (response) {
        self.model = response.data;
      });
    },
    updateHeightSettings: function updateHeightSettings() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          _Settings2.default.updateHeightSettings(self.model).then(function (response) {
            self.isSaving = false;
            self.$toastr.success(self.$t('message.labelSuccess'));
          });
        }
      });
    }
  }
};

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'tab-selector',
  props: {
    value: 0,
    list: {
      type: Array,
      required: true,
      default: []
    },
    textKey: {
      type: String,
      required: true,
      default: "unit"
    },
    valueKey: {
      type: String,
      required: true,
      default: "preference_id"
    },
    label: {
      type: String,
      default: ''
    }
  },
  methods: {
    getText: function getText(item) {
      return item[this.textKey];
    },
    getValue: function getValue(item) {
      return item[this.valueKey];
    },
    selectItem: function selectItem(value) {
      var self = this.$emit('input', value);
    }
  }
};

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(278);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(277);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(196);

var _index2 = _interopRequireDefault(_index);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _numeral2 = __webpack_require__(90);

var _numeral3 = _interopRequireDefault(_numeral2);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _jsSha = __webpack_require__(319);

var _vueStripe = __webpack_require__(705);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'subscription-form',
  components: {
    StripeCheckout: _vueStripe.StripeCheckout
  },
  data: function data() {
    return {
      stats: {},
      isLoading: true,
      app_url: null,
      subscription: {},
      selectedPackage: false,
      voucher: {
        code: "",
        error: false,
        message: "",
        isSending: false
      },
      fbPrice: null,
      loading: false,
      prices: [],
      sessionId: null,
      publishableKey: '' + _config2.default.stripePublishableKey,
      discountData: null
    };
  },

  methods: {
    createStripeSession: function createStripeSession(price) {
      var _this = this;

      if (this.selectedPackage) {
        return;
      }
      this.selectedPackage = true;
      price.selected = true;
      self.fbPrice = price.amount;
      _index2.default.initalizePayment({ price: price.id, nickname: price.description }).then(function (res) {
        _this.sessionId = res.data.data.session.session_id;
        _this.$refs.sessionCheckoutRef.redirectToCheckout();
      }).catch(function (e) {
        alert("Payment not possible at this time, Please try again later");
      }).finally(function () {
        price.selected = false;
        _this.selectedPackage = false;
      });
    },
    activateStripePlan: function activateStripePlan(price) {
      price.selected = true;
      var priceRef = price.id + 'checkoutRef';
      this.$refs[priceRef][0].redirectToCheckout();
    },
    numeral: function numeral(num) {
      return (0, _numeral3.default)(num);
    },
    getStats: function getStats() {
      var self = this;
      _axios2.default.get(_config2.default.apiUrl + 'stats').then(function (response) {
        self.stats = response.data;
      });
    },
    getDiscount: function getDiscount() {
      var self = this;
      _axios2.default.get(_config2.default.apiUrl + 'discount/current/user/').then(function (response) {
        self.discountData = response.data.data;
      });
    },
    continueProgram: function continueProgram() {
      var self = this;
      if (self.$store.state.status.onboarding.about || self.$store.state.status.onboarding.location || self.$store.state.status.goals || self.$store.state.status.personalise) {
        self.goTo('Dashboard');
      } else {
        self.goTo('GettingStartedAboutYourself');
      }
    },
    processVoucher: function processVoucher() {
      var self = this;
      self.voucher.error = false;
      self.voucher.isSending = true;
      _index2.default.validateVoucher({
        voucher: self.voucher.code.toUpperCase().trim()
      }).then(function (response) {
        if (response.data.error === false) {
          var trackedVouchers = ['EASYHEALTH', 'EASYHEALTH42', 'EASYHEALTH43', 'COMMUNITY', 'HURRY', 'RESEARCH51', 'RESEARCH52', 'RESEARCH53', 'RESEARCH54', 'RESEARCH55', 'RESEARCH56', 'LOWCARBNOW'];

          var containsTrackable = trackedVouchers.indexOf(self.voucher.code.toUpperCase().trim()) > -1;
          if (containsTrackable) {
            self.$gtag.event(self.voucher.code.toUpperCase().trim(), {
              'event_category': 'Vouchers',
              'event_label': 'Redeemed voucher code',
              'value': 1
            });
          }

          var fbVoucherModel = {
            "data": [{
              "event_name": "RedeemedVoucher",
              "event_time": moment().unix(),
              "action_source": "email",
              "user_data": {
                "em": (0, _jsSha.sha256)(self.$store.state.user.scope.email),
                "client_ip_address": self.$store.state.geoLocation.host.ip,
                "client_user_agent": navigator.userAgent
              },
              "custom_data": {
                "voucher": self.voucher.code
              }
            }]
          };
          _axios2.default.post('https://graph.facebook.com/v11.0/625160948457652/events?access_token=EAALxgEaGHOQBAPhSgGaAn8wfcfGUmKNrCk6cpoQO7NX85wxgmaD56HgMmGQLUEKMPsyCAFgMuh33vl8r1go8uO1xHgCoM3y9Ggkm2JejlIX6jeoCEW3GnA9V9N6FMInLHjSh9lzKmaEAIacBfG0o4NUqUcdolpi4frbZCh8VQU1qPtpK30wSj3VbxTKQZD', fbVoucherModel).then(function (res) {}).catch(function (res) {});

          self.$gtag.event('VoucherRedemption', {
            'event_category': 'Registration',
            'event_label': 'Redeemed a voucher code',
            'value': 1
          });
          self.voucher.isSending = false;
          self.voucher.error = false;
          self.voucher.message = response.data.message + '. Redirecting...';

          self.goToGetStarted();
        }
      }, function (error) {
        self.$gtag.event('VoucherRedemption', {
          'event_category': 'Registration',
          'event_label': 'Redeem voucher failed',
          'value': 0
        });
        var callback = error.response.data;
        if (callback.error) {
          self.voucher.isSending = false;
          self.voucher.error = true;
          self.voucher.message = callback.message;
          self.voucher.code = "";
        }
      });
    },
    goToGetStarted: function goToGetStarted() {
      var self = this;
      if (_AuthenticationManager2.default.hasToken()) {
        var tokenObject = _AuthenticationManager2.default.getToken();
        _AuthenticationManager2.default.refreshAccessToken(tokenObject).then(function () {
          if (_lodash2.default.includes(_AuthenticationManager2.default.parseJwt().scope, "standard_tasks")) {
            if (self.$store.state.status.onboarding.about || self.$store.state.status.onboarding.location || self.$store.state.status.goals || self.$store.state.status.personalise) {
              self.goTo('Dashboard');
            } else {
              self.goTo('GettingStartedAboutYourself');
            }
          } else {
            self.$toastr.error('Having trouble getting started. Please email support@lowcarbprogram.com');
          }
        });
      }
    },
    activatePlan: function activatePlan(p) {
      var self = this;
      if (self.selectedPackage) {
        return;
      }
      self.selectedPackage = true;
      p.selected = true;
      self.fbPrice = p.price;

      self.$forceUpdate();
      _index2.default.getUuid().then(function (response) {
        var uuid = response.data.uuid;
        if (!uuid.length) {
          throw "uuid cannot be blank";
        }
        setTimeout(function () {
          window.location.href = self.Config('apiUrl') + ('paypal/subscription/express-checkout?package=' + p.key + '&uuid=' + uuid);
        }, 800);
      }).catch(function (error) {});
    },
    getParam: function getParam(param) {
      var self = this;
      return self.$route.query[param];
    },
    Config: function Config(key) {
      return _config2.default[key];
    },
    getDetails: function getDetails() {
      var _this2 = this;

      var self = this;
      _index2.default.getPayPalSubscriptionDetails().then(function (response) {
        self.subscription = response.data;

        var packages = response.data.packages;

        if (!_this2.$store.state.user.wasAvivaEligible) {
          delete packages['aviva-yearly-discount'];
        } else {
          delete packages['yearly'];
        }

        self.subscription.packages = packages;
      });
    },
    getUser: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                _context.next = 3;
                return _User2.default.getUser();

              case 3:
                response = _context.sent;

                self.$store.commit('setUser', response.data);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUser() {
        return _ref.apply(this, arguments);
      }

      return getUser;
    }(),
    initMounted: function initMounted() {
      var self = this;
      self.getDiscount();
      self.getStripePrices();
      var siteURL = '';
      if (_config2.default.ApplicationContext === 'lowcarbprogram') {
        siteURL = 'https://www.lowcarbprogram.com/';
      } else {
        siteURL = 'https://www.grohealth.com/';
      }
      self.app_url = siteURL + _config2.default.locale + '/';
      self.getDetails();
      self.getStats();
      self.getUserPaidStatus();

      if (self.getParam('success') == 1) {
        this.getUser().then(function () {
          self.$gtag.event({
            'event_category': 'Registration',
            'event_label': 'PayPal',
            'event_action': 'Subscription',
            'event_value': 1
          });

          var planName = self.getParam('item_name');
          var amount = self.getParam('amt');
          var currency = self.getParam('cc');

          try {
            self.$gtag.query('event', 'conversion', {
              'send_to': planName.toLowerCase().includes('monthly') ? 'AW-1020622366/_hvYCN3Y_sADEJ7s1eYD' : 'AW-1020622366/siWpCNrY_sADEJ7s1eYD',
              'transaction_id': self.getParam('subscr_id')
            });

            var fbPaidModel = {
              "data": [{
                "event_name": planName.toLowerCase().includes('monthly') ? "MonthlySubscription" : "YearlySubscription",
                "event_time": moment().unix(),
                "action_source": "email",
                "user_data": {
                  "em": (0, _jsSha.sha256)(self.$store.state.user.scope.email),
                  "client_ip_address": self.$store.state.geoLocation.host.ip,
                  "client_user_agent": navigator.userAgent
                },
                "custom_data": {
                  "currency": currency,
                  "value": Number(amount),
                  "plan": planName
                }
              }]
            };

            _axios2.default.post('https://graph.facebook.com/v11.0/625160948457652/events?access_token=EAALxgEaGHOQBAPhSgGaAn8wfcfGUmKNrCk6cpoQO7NX85wxgmaD56HgMmGQLUEKMPsyCAFgMuh33vl8r1go8uO1xHgCoM3y9Ggkm2JejlIX6jeoCEW3GnA9V9N6FMInLHjSh9lzKmaEAIacBfG0o4NUqUcdolpi4frbZCh8VQU1qPtpK30wSj3VbxTKQZD', fbPaidModel).then(function (res) {}).catch(function (res) {});
          } catch (e) {}
        });
      }
    },
    getStripePrices: function getStripePrices() {
      var _this3 = this;

      _index2.default.getStripePrices().then(function (res) {
        _this3.prices = res.data.data.prices;
      });
    },
    getUserPaidStatus: function getUserPaidStatus() {
      var self = this;
      if (_AuthenticationManager2.default.hasToken()) {
        var tokenObject = _AuthenticationManager2.default.getToken();
        _AuthenticationManager2.default.refreshAccessToken(tokenObject).then(function () {

          if (_lodash2.default.includes(_AuthenticationManager2.default.parseJwt().scope, "standard_tasks")) {
            self.isLoading = false;
            self.$store.commit('setPaymentStatus', true);
            if (self.$store.state.status.onboarding.about || self.$store.state.status.onboarding.location || self.$store.state.status.goals || self.$store.state.status.personalise) {
              self.goTo('Dashboard');
            } else {
              self.goTo('GettingStartedAboutYourself');
            }
          } else {
            self.isLoading = false;
          }
        });
      } else {
        self.isLoading = false;
      }
    },
    goTo: function goTo(name) {
      var self = this;
      self.$router.push({
        name: name
      });
    }
  },
  computed: {
    hasPaymentProcessed: function hasPaymentProcessed() {
      var self = this;
      return self.getParam('success');
    },
    isPaymentCancelled: function isPaymentCancelled() {
      var self = this;
      return self.getParam('cancelled');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(488);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _BloodGlucose = __webpack_require__(351);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

var _TagLocalizerMixin = __webpack_require__(356);

var _TagLocalizerMixin2 = _interopRequireDefault(_TagLocalizerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingEditMixin2.default, _ScrollerMixin2.default, _TagLocalizerMixin2.default],
  name: 'bg-edit',
  props: {
    preference: {
      type: String,
      default: 'mmoll'
    },
    item: {
      type: Object,
      default: {}
    },
    tags: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      readingTags: [],
      listTags: [],
      reading: {
        tags: []
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.listTags = JSON.parse((0, _stringify2.default)(self.tags));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(self.reading.tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var tag = _step.value;

        self.readingTags.push(tag.tag_id);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    self.$forceUpdate();
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.isUpdating = true;
      self.reading.tags = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop = function _loop() {
          var tag = _step2.value;

          var tagFound = self.listTags.filter(function (item) {
            return item.tag_id === tag;
          })[0];
          self.reading.tags.push(tagFound);
        };

        for (var _iterator2 = (0, _getIterator3.default)(self.readingTags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      _BloodGlucose2.default.updateBloodGlucoseTracking(self.reading).then(function (response) {
        self.isUpdating = false;
        var offset = new Date();
        self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
        self.$EventBus.$emit('bgReadingUpdated');
        self.$EventBus.$emit('updateGraphData');
        self.$emit('updateReading', self.reading);
        self.$emit('closeEditPanel');
      }).catch(function () {
        self.isUpdating = false;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BloodPressure = __webpack_require__(479);

var _BloodPressure2 = _interopRequireDefault(_BloodPressure);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingEditMixin2.default],
  name: 'bp-edit',
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      reading: {}
    };
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isUpdating = true;
          _BloodPressure2.default.putBloodPressureTracking(self.reading).then(function (response) {
            var offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel');
            self.isUpdating = false;
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cholesterol = __webpack_require__(480);

var _Cholesterol2 = _interopRequireDefault(_Cholesterol);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingEditMixin2.default, _ScrollerMixin2.default],
  name: 'cholesterol-edit',
  props: {
    preference: {
      type: String,
      default: 'mmoll'
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      listTags: [],
      reading: {
        tags: []
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$forceUpdate();
  },

  methods: {
    submitForm: function submitForm() {

      var self = this;
      var model = {};
      model.tracking_id = self.reading.tracking_id;
      model.progress_id = self.reading.progress_id;
      model.date = self.reading.date;

      if (self.preference === 'mmoll') {

        model.total_mmoll = self.reading.total_mmoll;
        model.ldl_mmoll = self.reading.ldl_mmoll;
        model.hdl_mmoll = self.reading.hdl_mmoll;
        model.triglycerides_mmoll = self.reading.triglycerides_mmoll;
      }

      if (self.preference === 'mgdl') {
        model.total_mgdl = self.reading.total_mgdl;
        model.ldl_mgdl = self.reading.ldl_mgdl;
        model.hdl_mgdl = self.reading.hdl_mgdl;
        model.triglycerides_mgdl = self.reading.triglycerides_mgdl;
      }

      self.isUpdating = true;
      _Cholesterol2.default.updateCholesterolTracking(model).then(function (response) {
        self.isUpdating = false;
        var offset = new Date();
        self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
        self.$EventBus.$emit('cholesterolReadingUpdated');
        self.$EventBus.$emit('updateGraphData');
        self.$emit('updateReading', self.reading);
        self.$emit('closeEditPanel');
      }).catch(function () {
        self.isUpdating = false;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HbA1c = __webpack_require__(272);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingEditMixin2.default],
  name: 'hba1c-edit',
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      reading: {}
    };
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isUpdating = true;
          _HbA1c2.default.putHba1cTracking(self.reading).then(function (response) {
            self.isUpdating = false;
            var offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$EventBus.$emit('updateGraphData');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel');
          }).catch(function () {
            self.isUpdating = false;
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Insulin = __webpack_require__(352);

var _Insulin2 = _interopRequireDefault(_Insulin);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

var _InsulinMixin = __webpack_require__(355);

var _InsulinMixin2 = _interopRequireDefault(_InsulinMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingEditMixin2.default, _InsulinMixin2.default],
  name: 'insulin-edit',
  props: {
    insulinTypes: {
      type: Array,
      required: true,
      default: []
    },
    item: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      reading: {}
    };
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isUpdating = true;
          _Insulin2.default.putInsulinTracking(self.reading).then(function (response) {
            var offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel');
            self.isUpdating = false;
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Ketones = __webpack_require__(353);

var _Ketones2 = _interopRequireDefault(_Ketones);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingEditMixin2.default, _ScrollerMixin2.default],
  name: 'ketones-edit',
  props: {
    preference: {
      type: String,
      default: 'mmoll'
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      reading: {}
    };
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.isUpdating = true;
      _Ketones2.default.updateKetonesTracking(self.reading).then(function (response) {
        self.isUpdating = false;
        var offset = new Date();
        self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
        self.$EventBus.$emit('ketonesReadingUpdated');
        self.$emit('updateReading', self.reading);
        self.$emit('closeEditPanel');
      }).catch(function () {
        self.isUpdating = false;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

var _MedicationRegimes = __webpack_require__(199);

var _MedicationRegimes2 = _interopRequireDefault(_MedicationRegimes);

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingEditMixin2.default, _MedicationRegimes2.default],
  name: 'medication-edit',
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      reading: {}
    };
  },

  methods: {
    closeEditMode: function closeEditMode() {
      var self = this;
      self.$emit('closeEditPanel', self.reading);
    },
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isUpdating = true;
          _Medication2.default.updateMedicationDosage(self.reading).then(function (response) {
            self.reading.date_created = self.reading.date;
            self.isUpdating = false;
            self.$emit('updateReading', self.reading);
          });
        }
      });
    }
  }
};

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sleep = __webpack_require__(198);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sliderSettings = {
  min: 0,
  max: 10,
  tooltipDir: "right",
  bgStyle: {
    "backgroundColor": "#fff",
    "boxShadow": "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
  },
  processStyle: {
    "backgroundImage": "-webkit-linear-gradient(left, #183A43, #183A43)"
  },
  sliderStyle: [{
    "backgroundColor": "#CCCCCC"
  }],
  model: {
    hours: 10,
    quality: 5
  }
};

exports.default = {
  components: { vueSlider: _vue2Slider2.default },
  mixins: [_TrackingEditMixin2.default],
  name: 'sleep-edit',
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      sliderSettings: sliderSettings,
      isUpdating: false,
      reading: {}
    };
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isUpdating = true;
          _Sleep2.default.putSleepTracking(self.reading).then(function (response) {
            var offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel');
            self.isUpdating = false;
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Weight = __webpack_require__(273);

var _Weight2 = _interopRequireDefault(_Weight);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default, _TrackingEditMixin2.default],
  name: 'weight-edit',
  props: {
    preference: {
      type: String,
      default: 'cm'
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      reading: {}
    };
  },
  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          var model = {};
          self.isUpdating = true;
          model.date = self.reading.date;
          model.tracking_id = self.reading.tracking_id;
          if (self.preference === 'cm') {
            model.waist_cm = self.reading.waist_cm;
            model.hip_cm = self.reading.hip_cm;
          }
          if (self.preference === 'in') {
            model.waist_in = self.reading.waist_in;
            model.hip_in = self.reading.hip_in;
          }

          _Weight2.default.updateWaistHipTracking(model).then(function (response) {
            var offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel');
            self.isUpdating = false;
          }).catch(function () {
            self.isUpdating = false;
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Weight = __webpack_require__(273);

var _Weight2 = _interopRequireDefault(_Weight);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _TrackingEditMixin = __webpack_require__(133);

var _TrackingEditMixin2 = _interopRequireDefault(_TrackingEditMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default, _TrackingEditMixin2.default],
  name: 'weight-edit',
  props: {
    preference: {
      type: String,
      default: 'kg'
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isUpdating: false,
      reading: {}
    };
  },
  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          var model = {};
          self.isUpdating = true;
          model.date = self.reading.date;
          model.progress_id = self.reading.progress_id;
          model.tracking_id = self.reading.tracking_id;
          if (self.preference === 'st-lbs') {
            model.stones = self.reading.stones;
            model.pounds = self.reading.pounds;
          }
          if (self.preference === 'lbs') {
            model.lbs = self.reading.lbs;
          }
          if (self.preference === 'kg') {
            model.kg = self.reading.kg;
          }
          _Weight2.default.updateWeightTracking(model).then(function (response) {
            var offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel');
            self.isUpdating = false;
          }).catch(function () {
            self.isUpdating = false;
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _downloadjs = __webpack_require__(872);

var _downloadjs2 = _interopRequireDefault(_downloadjs);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_CardAnimationMixin2.default],
  name: 'tracking-exporter',
  props: {
    type: {
      type: String,
      default: 'weight'
    }

  },
  data: function data() {
    return {
      isExporting: false,
      isOpen: false,
      dateFormat: _DatePickerManager2.default,
      fromDate: moment().subtract(1, 'month').format('DD-MM-YYYY'),
      toDate: moment().format('DD-MM-YYYY')
    };
  },

  methods: {
    exportData: function exportData() {
      var self = this;
      var fileName = self.type + ("_" + self.fromDate + "_" + self.toDate + ".xlsx");
      var requestPath = "tracking/" + self.type + "/export?fromDate=" + self.fromDate + "&toDate=" + self.toDate;
      var finalUrl = _config2.default.apiUrl + requestPath;
      var errorMessage = self.$t('message.errorExportEmpty');
      self.isExporting = true;
      _axios2.default.get(finalUrl, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.ms-excel'
        }
      }).then(function (response) {
        if (response.status === 200) {
          var timestamp = self.isExporting = false;
          self.$toastr.success(self.$t('message.justAMomentText'));
          (0, _downloadjs2.default)(response.data, fileName);
        } else if (response.status === 204) {
          self.$toastr.error(errorMessage);
          self.isExporting = false;
        } else {
          self.$toastr.error(errorMessage);
          self.isExporting = false;
        }
      }).catch(function () {
        self.$toastr.error(errorMessage);
        self.isExporting = false;
      });
    },
    toggleOpen: function toggleOpen() {
      var self = this;
      self.isOpen = !self.isOpen;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { MuRaisedButton: _raisedButton2.default },
  name: "graph-point-toggle",
  mixins: [_ScrollerMixin2.default],
  props: {
    isDisabled: true
  },
  data: function data() {
    return {
      showPoints: false,
      smoothLine: true,
      showArea: true,
      open: false,
      trigger: null,
      anchorOrigin: { "vertical": "bottom", "horizontal": "left" },
      targetOrigin: { "vertical": "middle", "horizontal": "left" }
    };
  },

  watch: {
    'showPoints': function showPoints() {
      this.$store.commit('showGraphPoints', this.showPoints === true);
    },
    'smoothLine': function smoothLine() {
      this.$store.commit('showGraphSmooth', this.smoothLine === true);
    },
    'showArea': function showArea() {
      this.$store.commit('showGraphArea', this.showArea === true);
    }
  },
  mounted: function mounted() {
    this.trigger = this.$refs.button.$el;
    var self = this;
    self.showPoints = self.$store.state.graphOptions.showDots;
    self.smoothLine = self.$store.state.graphOptions.smoothLine;
    self.showArea = self.$store.state.graphOptions.showArea;
  },

  methods: {
    toggle: function toggle() {
      this.open = !this.open;
    },
    handleClose: function handleClose(e) {
      this.open = false;
    },
    handleToggle: function handleToggle(key) {
      this[key] = !this[key];
    }
  }
};

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

var _contentBlock = __webpack_require__(227);

var _contentBlock2 = _interopRequireDefault(_contentBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('month');
var toDate = moment().locale(_config2.default.language).endOf('month');

exports.default = {
  name: "activity-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    MuContentBlock: _contentBlock2.default,
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'activity',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      },
      customDate: {
        fromDate: "",
        toDate: ""
      }
    };
  },

  methods: {
    onTrackingTypeActivity: function onTrackingTypeActivity(value) {
      var self = this;
      switch (value) {
        case 'FITBIT':
          self.$router.push({
            name: 'ActivityProgressFitbit'
          });
          break;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

var _contentBlock = __webpack_require__(227);

var _contentBlock2 = _interopRequireDefault(_contentBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('month');
var toDate = moment().locale(_config2.default.language).endOf('month');

exports.default = {
  name: "activity-steps-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    MuContentBlock: _contentBlock2.default,
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      activeType: 'steps',
      activeTypes: [{
        name: "calories",
        value: 'calories'
      }, {
        name: 'steps',
        value: "steps"
      }, {
        name: 'floors',
        value: "floors"
      }],
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'activity-steps',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      },
      customDate: {
        fromDate: "",
        toDate: ""
      }
    };
  },
  mounted: function mounted() {
    this.activeType = 'steps';
    this.$forceUpdate();
  },

  methods: {
    onTrackingTypeActivity: function onTrackingTypeActivity(value) {
      var self = this;
      switch (value) {
        case 'FITBIT':
          self.$router.push({
            name: 'ActivityProgressFitbit'
          });
          break;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _Graph = __webpack_require__(77);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('month');
var toDate = moment().locale(_config2.default.language).endOf('month');

exports.default = {
  name: "bg-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),

      customDate: {
        fromDate: "",
        toDate: ""
      },
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'blood-glucose',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Graph = __webpack_require__(77);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().startOf('month');
var toDate = moment().endOf('month');

exports.default = {
  name: "bp-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      customDate: {
        fromDate: "",
        toDate: ""
      },
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'blood-pressure',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().startOf('month');
var toDate = moment().endOf('month');

exports.default = {
  name: "cholesterol-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      customDate: {
        fromDate: "",
        toDate: ""
      },
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'cholesterol',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().startOf('month');
var toDate = moment().endOf('month');

exports.default = {
  name: "hba1c-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      customDate: {
        fromDate: "",
        toDate: ""
      },
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'hba1c',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('month');
var toDate = moment().locale(_config2.default.language).endOf('month');

exports.default = {
  name: "insulin-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      customDate: {
        fromDate: "",
        toDate: ""
      },
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'insulin',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().startOf('month');
var toDate = moment().endOf('month');

exports.default = {
  name: "ketones-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      customDate: {
        fromDate: "",
        toDate: ""
      },
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'ketones',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().startOf('month');
var toDate = moment().endOf('month');

exports.default = {
  name: "medication-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    medTrackingId: {
      type: Number
    },
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      activeTrackingId: 0,
      medications: [],
      graphReady: false,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      customDate: {
        fromDate: "",
        toDate: ""
      },
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'medication',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      }
    };
  },
  mounted: function mounted() {
    var self = this;

    _Medication2.default.getUserMedications().then(function (response) {
      self.medications = response.data;
      self.setActiveMedicationByIndex(0);
      self.isLoading = false;
    });
  },

  methods: {
    setActiveMedicationByIndex: function setActiveMedicationByIndex(index) {
      var self = this;
      self.activeTrackingId = self.medications[index].tracking_id;
      self.$nextTick(function () {
        self.graphReady = true;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('month');
var toDate = moment().locale(_config2.default.language).endOf('month');

exports.default = {
  name: "mood-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'mood',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      },
      customDate: {
        fromDate: "",
        toDate: ""
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LineGraph = __webpack_require__(1660);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _Graphs = __webpack_require__(350);

var _Graphs2 = _interopRequireDefault(_Graphs);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    "date": function date() {
      var self = this;
      self.data = [];
      self.chartData = null;
      self.isLoading = true;
      if (_Graphs2.default.Cancel !== null) {
        _Graphs2.default.Cancel();
      }
      self.getPulseReadings();
    }
  },
  components: {
    Alert: _Alert2.default,
    LineChart: _LineGraph2.default
  },
  name: 'striiv-pulse-line-graph',
  data: function data() {
    return {
      isLoading: true,
      chartData: null,
      chartOptions: null,
      data: []
    };
  },

  props: {
    date: {
      type: String,
      required: true
    }
  },
  methods: {
    getPulseReadings: function getPulseReadings() {
      var self = this;
      _Graphs2.default.getHeartRateGraph({
        limit: 500,
        skip: self.data.length,
        service: 'STRIIV',
        date: self.date
      }).then(function (response) {
        var res = response.data;
        if (res.data.length === 0) {
          self.isLoading = false;
          var heartStats = {
            date: moment(self.date),
            min: res.stats.min,
            max: res.stats.max,
            avg: res.stats.avg
          };
          self.$EventBus.$emit('emitHeartRateStats', heartStats);
          self.renderGraph(self.data);
        } else {
          self.data.push.apply(self.data, res.data);
          self.getPulseReadings();
        }
      });
      if (self.hasData) {
        self.renderGraph([]);
      }
    },
    renderGraph: function renderGraph(data) {
      var self = this;
      var datasetData = [];
      var datasetLabels = [];

      if (data.length) {
        data.forEach(function (item) {
          if (item.bpm !== 0) {
            datasetData.push(item.bpm);
            var date = moment(item.date).utc().local();
            if (date.isDST()) {
              date.add(1, 'hour');
            }
            datasetLabels.push(date.format());
          }
        });

        var datasetTemplate = {
          borderCapStyle: 'butt',
          borderColor: '#FA6956',
          fill: true,
          lineTension: 0.1,
          pointBackgroundColor: '#FFFFFF',
          pointBorderColor: "#FA6956",
          pointBorderWidth: 0,
          pointHitRadius: 10,
          pointHoverBackgroundColor: "#FFF",
          pointHoverBorderColor: "#FFF",
          pointHoverBorderWidth: 1,
          pointHoverRadius: 2,
          pointRadius: 0,
          data: datasetData
        };

        self.chartData = {
          labels: datasetLabels,
          datasets: [datasetTemplate]
        };

        self.chartOptions = {
          responsive: false,
          maintainAspectRatio: true,
          tooltips: {
            cornerRadius: 5,
            mode: "nearest",
            enabled: true,
            displayColors: false,
            xPadding: 16,
            yPadding: 16,
            titleFontFamily: "Poppins",
            titleFontStyle: "200",
            bodyFontFamily: "Poppins",
            backgroundColor: "#0179d5",
            titleFontSize: 16,
            titleFontColor: "white",
            bodyFontColor: "white",
            bodyFontSize: 14,

            callbacks: {
              title: function title(tooltipItem) {
                return moment(tooltipItem[0].xLabel).format("DD-MM-YYYY HH:mm a");
              },
              label: function label(tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label;
                var value = tooltipItem.yLabel;
                return tooltipItem.yLabel + ' ' + 'BPM';
              }
            }
          },
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'hour'
              },
              gridLines: {
                display: false,
                showLine: false,
                lineWidth: 0
              }
            }],
            yAxes: [{
              time: {
                unit: 'hour'
              },
              gridLines: {
                spanGaps: false,
                showLine: false,
                display: true,
                lineWidth: 1,
                borderWidth: 0,
                borderDashOffset: 0,
                borderDash: [6, 8]
              },
              ticks: {
                padding: 0,
                fontFamily: 'Poppins',
                fontSize: 13,
                beginAtZero: false
              }
            }]
          }
        };
      }
    },
    getScrollbarHeight: function getScrollbarHeight() {
      var outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.width = "100px";
      outer.style.msOverflowStyle = "scrollbar";
      document.body.appendChild(outer);
      var widthNoScroll = outer.offsetWidth;
      outer.style.overflow = "scroll";
      var inner = document.createElement("div");
      inner.style.width = "100%";
      outer.appendChild(inner);
      var widthWithScroll = inner.offsetWidth;
      outer.parentNode.removeChild(outer);
      return widthNoScroll - widthWithScroll;
    },
    initMounted: function initMounted() {
      var self = this;
      self.getPulseReadings();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  },

  computed: {
    hasData: function hasData() {
      var self = this;
      return self.data.length !== 0;
    },
    computedHeight: function computedHeight() {
      var self = this;
      return 340 - self.getScrollbarHeight();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _divider = __webpack_require__(3369);

var _divider2 = _interopRequireDefault(_divider);

var _cardHeader = __webpack_require__(3366);

var _cardHeader2 = _interopRequireDefault(_cardHeader);

var _cardActions = __webpack_require__(1233);

var _cardActions2 = _interopRequireDefault(_cardActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuCardActions: _cardActions2.default,
    MuCardHeader: _cardHeader2.default,
    MuDivider: _divider2.default
  },
  name: "fitbit-sleep-stages",
  props: {
    date: {
      type: String,
      default: ''
    },
    fitbitData: {
      type: Object,
      default: {}
    }
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    normalizeDuration: function normalizeDuration(minutes) {
      var hourString = void 0;
      var minuteString = 'min';
      if (minutes > 60) {
        var hours = Math.floor(minutes / 60);
        var outputMins = minutes % 60;
        if (hours > 1) {
          hourString = 'hrs';
        } else {
          hourString = 'hr';
        }
        if (outputMins > 1) {
          minuteString = 'mins';
        } else {
          minuteString = 'min';
        }
        return hours + hourString + ' ' + outputMins + minuteString;
      }
      return minutes + ' ' + minuteString;
    }
  },
  computed: {
    normalizeDate: function normalizeDate() {
      var self = this;
    },
    sleepBreakdown: function sleepBreakdown() {
      var self = this;
      if (_.has(self.fitbitData.sleep[0], 'levels')) {
        if (_.has(self.fitbitData.sleep[0].levels, 'summary')) {

          if (self.fitbitData.sleep[0].type === 'stages') {
            var deepMinutes = self.fitbitData.sleep[0].levels.summary.deep.minutes;
            var awakeMinutes = self.fitbitData.sleep[0].levels.summary.wake.minutes;
            var lightMinutes = self.fitbitData.sleep[0].levels.summary.light.minutes;
            var remMinutes = self.fitbitData.sleep[0].levels.summary.rem.minutes;
            var totalMinutes = deepMinutes + awakeMinutes + lightMinutes + remMinutes;
            var totalAsleep = deepMinutes + lightMinutes + remMinutes;

            var deepPercent = deepMinutes / totalMinutes * 100;
            var awakePercent = awakeMinutes / totalMinutes * 100;
            var remPercent = remMinutes / totalMinutes * 100;
            var lightPercent = lightMinutes / totalMinutes * 100;

            return {
              type: 'stages',
              totalInBed: totalMinutes,
              total: totalAsleep,
              deep: deepPercent,
              wake: awakePercent,
              rem: remPercent,
              light: lightPercent,
              minutes: {
                deep: deepMinutes,
                wake: awakeMinutes,
                rem: remMinutes,
                light: lightMinutes
              },
              formatted: {
                deep: deepPercent.toFixed(1),
                wake: awakePercent.toFixed(1),
                rem: remPercent.toFixed(1),
                light: lightPercent.toFixed(1)
              }
            };
          }

          if (self.fitbitData.sleep[0].type === 'classic') {
            var levels = self.fitbitData.sleep[0].levels.summary;
            var asleepPercent = levels.asleep.minutes / self.fitbitData.summary.totalTimeInBed * 100;
            var _awakePercent = levels.awake.minutes / self.fitbitData.summary.totalTimeInBed * 100;
            var restlessPercent = levels.restless.minutes / self.fitbitData.summary.totalTimeInBed * 100;

            return {
              type: 'classic',
              totalInBed: self.fitbitData.summary.totalTimeInBed,
              total: self.fitbitData.summary.totalMinutesAsleep,
              minutes: {
                asleep: levels.asleep.minutes,
                awake: levels.awake.minutes,
                restless: levels.restless.minutes
              },
              formatted: {
                asleep: asleepPercent.toFixed(1),
                awake: _awakePercent.toFixed(1),
                restless: restlessPercent.toFixed(1)
              }
            };
          }
        }
      } else {
        return false;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sleep = __webpack_require__(198);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _index = __webpack_require__(1657);

var _index2 = _interopRequireDefault(_index);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options = {

  responsive: true,
  maintainAspectRatio: false,
  bezierCurve: true,
  legend: {
    display: false
  },
  layout: {
    padding: {
      top: 40
    }
  },
  tooltips: {
    mode: 'nearest',
    intersect: false
  },
  elements: {
    line: {
      tension: 0.5
    }
  },
  scales: {
    xAxes: [{
      gridLines: {
        display: false,
        color: '#738F9A',
        zeroLineColor: "transparent",
        borderDash: [1, 10],
        drawBorder: true
      },
      display: true,
      scaleLabel: {
        display: true
      },
      time: {
        unit: 'minute',
        stepSize: 2,
        source: 'auto'
      },
      ticks: {
        autoSkip: true,
        autoSkipPadding: 60,
        maxRotation: 0,
        minRotation: 0
      }
    }],
    yAxes: [{
      gridLines: {
        display: true,
        color: '#738F9A',
        zeroLineColor: "transparent",
        borderDash: [1, 10],
        drawBorder: false
      },
      type: 'category',
      position: 'left',
      display: true,
      scaleLabel: {
        display: true
      }
    }]
  }
};

exports.default = {
  name: "sleep-fitbit-graph",
  components: {
    FitbitSleepChart: _index2.default,
    Alert: _Alert2.default
  },
  props: {
    fitbitData: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isLoading: true,
      sleepData: {},
      data: {},
      options: options
    };
  },
  mounted: function mounted() {
    var self = this;
    self.isLoading = true;
    var data = self.fitbitData.sleep[0];
    var graphData = {
      xLabels: [],
      datasets: []
    };

    if (self.fitbitData.sleep.length > 0) {
      self.sleepData = data;

      if (data.type === 'classic') {
        graphData.yLabels = ['', 'Asleep', 'Awake', 'Restless', ''];
      }

      if (data.type === 'stages') {
        graphData.yLabels = ['', 'Wake', 'REM', 'Light', 'Deep', ''];
      }

      var levels = data.levels.data;
      var length = levels.length;
      var labels = [];
      var pointBackgrounds = [];
      var datasets = [];

      var dataset = {
        label: "Sleep",
        data: [],
        fill: false,
        borderWidth: 4,
        borderColor: '#17343A',
        pointBackgroundColor: ['transparent'],
        pointRadius: 0,
        steppedLine: true
      };

      for (var i = 0; i < length; i++) {
        pointBackgrounds.push();
        labels.push(moment(levels[i].dateTime).format('HH:mm a'));
        if (data.type === 'classic') {
          if (levels[i].level === 'asleep') {
            dataset.data.push('Asleep');
          }
          if (levels[i].level === 'awake') {
            dataset.data.push('Awake');
          }
          if (levels[i].level === 'restless') {
            dataset.data.push('Restless');
          }
        }
        if (data.type === 'stages') {
          if (levels[i].level === 'wake') {
            dataset.data.push('Wake');
          }
          if (levels[i].level === 'light') {
            dataset.data.push('Light');
          }
          if (levels[i].level === 'rem') {
            dataset.data.push('REM');
          }

          if (levels[i].level === 'deep') {
            dataset.data.push('Deep');
          }
        }
      }

      graphData.xLabels = labels;
      graphData.datasets = [dataset];

      self.data = graphData;
      self.$forceUpdate();

      self.isLoading = false;
    } else {
      self.isLoading = false;
    }
  },

  computed: {}

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().startOf('month');
var toDate = moment().endOf('month');

exports.default = {
  name: "sleep-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      selectedService: 'LCP',
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'sleep',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      },
      customDate: {
        fromDate: "",
        toDate: ""
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

var _StriivSleep = __webpack_require__(1659);

var _StriivSleep2 = _interopRequireDefault(_StriivSleep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options = {
  responsive: true,
  maintainAspectRatio: false,
  bezierCurve: true,
  legend: {
    display: false
  },
  layout: {
    padding: {
      top: 40
    }
  },
  tooltips: {
    mode: 'nearest',
    intersect: false
  },
  elements: {
    line: {
      tension: 0.5
    }
  },
  scales: {
    xAxes: [{
      gridLines: {
        display: false,
        color: '#738F9A',
        zeroLineColor: "transparent",
        borderDash: [1, 10],
        drawBorder: true
      },
      display: true,
      scaleLabel: {
        display: true
      },
      time: {
        unit: 'minute',
        stepSize: 2,
        source: 'auto'
      },
      ticks: {
        autoSkip: true,
        autoSkipPadding: 60,
        maxRotation: 0,
        minRotation: 0
      }
    }],
    yAxes: [{
      gridLines: {
        display: true,
        color: '#738F9A',
        zeroLineColor: "transparent",
        borderDash: [1, 10],
        drawBorder: false
      },
      type: 'category',
      position: 'left',
      display: true,
      scaleLabel: {
        display: true
      }
    }]
  }
};

exports.default = {
  name: 'striiv-sleep-graph',
  components: {
    StriivSleepChart: _StriivSleep2.default,
    Alert: _Alert2.default
  },
  props: {
    striivData: {
      type: Object,
      defaut: {}
    }
  },
  data: function data() {
    return {
      isLoading: true,
      sleepData: {},
      data: {},
      options: options
    };
  },

  methods: {
    dateToLocalTime: function dateToLocalTime(date) {
      var date = moment.utc(date).local();
      return date.format('HH:mm a');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.isLoading = true;

    self.sleepData = self.striivData;

    if (self.hasSleepData) {

      var levels = self.sleepData;
      var length = levels.length;
      var labels = [];
      var pointBackgrounds = [];
      var graphData = {
        xLabels: [],
        datasets: []
      };

      if (self.sleepData[0].totals.awake === 0) {
        graphData.yLabels = ['', 'Light', 'Deep', ''];
      } else {
        graphData.yLabels = ['', 'Awake', 'Light', 'Deep', ''];
      }

      var dataset = {
        label: "Sleep",
        data: [],
        fill: false,
        borderWidth: 4,
        borderColor: '#17343A',
        pointBackgroundColor: ['transparent'],
        pointRadius: 0,
        steppedLine: true
      };

      for (var i = 0; i < length; i++) {
        pointBackgrounds.push();
        labels.push(self.dateToLocalTime(levels[i].date));
        dataset.data.push(_.startCase(levels[i].state));
      }

      graphData.xLabels = labels;
      graphData.datasets = [dataset];

      self.data = graphData;
      self.$forceUpdate();
    }
    self.isLoading = false;
  },

  computed: {
    hasSleepData: function hasSleepData() {
      var self = this;
      if (self.sleepData.length) {
        return true;
      } else {
        return false;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "striiv-sleep-stages",
  props: {
    date: {
      type: String,
      default: ''
    },
    striivData: {
      type: Object,
      default: {}
    }
  },
  methods: {
    normalizeDuration: function normalizeDuration(minutes) {
      var hourString = void 0;
      var minuteString = 'min';
      if (minutes > 60) {
        var hours = Math.floor(minutes / 60);
        var outputMins = minutes % 60;
        if (hours > 1) {
          hourString = 'hrs';
        } else {
          hourString = 'hr';
        }
        if (outputMins > 1) {
          minuteString = 'mins';
        } else {
          minuteString = 'min';
        }
        return hours + hourString + ' ' + outputMins + minuteString;
      }
      return minutes + ' ' + minuteString;
    }
  },
  computed: {
    sleepBreakdown: function sleepBreakdown() {
      var self = this;
      var data = self.striivData[0];

      if (data) {
        var totals = data.totals;
        var deepMinutes = totals.deep;
        var lightMinutes = totals.light;
        var totalMinutes = deepMinutes + lightMinutes;
        var awake = data.awakenings;

        var deepPercent = deepMinutes / totalMinutes * 100;
        var lightPercent = lightMinutes / totalMinutes * 100;

        return {
          total: totalMinutes,
          deep: deepPercent,
          awake: awake,
          light: lightPercent,
          minutes: {
            deep: deepMinutes,
            light: lightMinutes
          },
          formatted: {
            deep: deepPercent.toFixed(1),
            light: lightPercent.toFixed(1)
          }
        };
      } else {
        return false;
      }
    }
  }
};

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().startOf('month');
var toDate = moment().endOf('month');

exports.default = {
  name: "sleep-wearable-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      selectedService: 'LCP',
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      activeType: 'minutesAsleep',
      activeTypes: [{
        name: this.$t('message.minutesAsleep'),
        value: 'minutesAsleep'
      }, {
        name: this.$t('message.minutesAwake'),
        value: "minutesAwake"
      }, {
        name: this.$t('message.stageRemMinutes'),
        value: 'stageRemMinutes'
      }, {
        name: this.$t('message.stageLightMinutes'),
        value: 'stageLightMinutes'
      }, {
        name: this.$t('message.stageDeepMinutes'),
        value: 'stageDeepMinutes'
      }],
      visualDate: {
        toDateIsToday: false,
        dateStep: 30,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'sleep-wearable',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')

      },
      customDate: {
        fromDate: "",
        toDate: ""
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('year');
var toDate = moment().locale(_config2.default.language).endOf('year');

exports.default = {
  name: "weight-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      visualDate: {
        toDateIsToday: false,
        dateStep: 360,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'waist-hip',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      },
      customDate: {
        fromDate: "",
        toDate: ""
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _Graph = __webpack_require__(77);

var _GraphMixin = __webpack_require__(78);

var _GraphMixin2 = _interopRequireDefault(_GraphMixin);

var _GraphRequestAborter = __webpack_require__(79);

var _GraphRequestAborter2 = _interopRequireDefault(_GraphRequestAborter);

var _graphPointToggle = __webpack_require__(84);

var _graphPointToggle2 = _interopRequireDefault(_graphPointToggle);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('year');
var toDate = moment().locale(_config2.default.language).endOf('year');

exports.default = {
  name: "weight-line-graph",
  mixins: [_GraphMixin2.default, _GraphRequestAborter2.default],
  components: {
    GraphPointToggle: _graphPointToggle2.default,
    LineGraph: _Graph.LineGraph
  },
  props: {
    userId: {
      type: Number
    },
    height: {
      type: String,
      default: "284px"
    }
  },
  data: function data() {
    var self = this;
    return {
      graphReady: true,
      isCustomDateMode: false,
      graphIsLoading: true,
      graphError: false,
      graphErrorObject: {},
      dateFormat: _DatePickerManager2.default,
      maxDate: moment.utc().endOf('year').format('DD-MM-YYYY'),
      visualDate: {
        toDateIsToday: false,
        dateStep: 360,
        fromDate: fromDate.format('Do MMM YY'),
        toDate: toDate.format('Do MMM YY')
      },
      graph: {
        type: 'weight',
        userId: self.userId,
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD')
      },
      customDate: {
        fromDate: "",
        toDate: ""
      }
    };
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _numeral = __webpack_require__(90);

var _numeral2 = _interopRequireDefault(_numeral);

var _Activity = __webpack_require__(478);

var _Activity2 = _interopRequireDefault(_Activity);

var _activityTypes = __webpack_require__(481);

var _activityTypes2 = _interopRequireDefault(_activityTypes);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _contentBlock = __webpack_require__(227);

var _contentBlock2 = _interopRequireDefault(_contentBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  mixins: [_CardAnimationMixin2.default],
  components: {
    MuContentBlock: _contentBlock2.default,
    Alert: _Alert2.default,
    DatePicker: _DateTimePicker2.default
  },
  name: 'activity-input',
  props: {
    bmr: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      isSaving: false,
      title: this.$t('message.cardActivity'),
      isOpenInput: false,
      scroller: document.getElementsByClassName('main-content')[0],
      data: {},
      model: {
        type: null,
        minutes: null,
        calories_burnt: 0
      },
      activityTypes: _activityTypes2.default,
      loading: true
    };
  },
  mounted: function mounted() {
    var self = this;
    self.getData();
    _EventBus2.default.$on('activityPusherReceived', function (model) {
      self.data.progres_id = model.progress_id;
      self.data.type = model.type;
      self.data.minutes = model.minutes;
      self.data.calories_burnt = model.calories_burnt;
    });
  },

  methods: {
    formatNumber: function formatNumber(num) {
      var number = (0, _numeral2.default)(num);
      return number.format();
    },
    getLocaleLabel: function getLocaleLabel(key) {
      var self = this;
      var activeKey = self.activityTypes.filter(function (item) {
        return item.value === key;
      })[0];
      return self.$t(activeKey.locale);
    },
    getData: function getData() {
      var self = this;
      self.$nextTick(function () {
        if (_.has(self.$store.state.cards.activity, 'progress_id')) {
          self.loading = false;
          self.data = self.$store.state.cards.activity;
        } else {
          _Activity2.default.getActivityTrackingCard().then(function (response) {
            self.loading = false;
            self.data = response.data;
            self.$store.commit('setActivityCard', response.data);
          });
        }
      });
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        name: 'ActivityProgress'
      });
    },
    saveReading: function saveReading() {
      var self = this;
      if (!_.has(self.model, 'date')) {
        self.model.date = moment().format();
      }
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          _Activity2.default.addActivity(self.model).then(function (response) {
            self.$gtag.event('ReadingAdded', {
              'event_category': 'ActivityCard',
              'event_label': 'Added reading',
              'value': 1
            });
            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            }
            self.data = response.data;
            self.isSaving = false;
            self.$toastr.success("Activity entry added");
            self.$store.commit('setActivityCard', response.data);
            self.model = {
              type: null,
              minutes: null,
              calories_burnt: 0
            };
            self.isOpenInput = false;
          }.bind(self), 300);
        }
      });
    },
    toggle: function toggle() {
      var self = this;
      if (self.isOpenInput === false) {
        self.$gtag.event('Open', {
          'event_category': 'ActivityCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      self.isOpenInput = !self.isOpenInput;
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'ActivityCard',
        'event_label': 'Closed card',
        'value': 0
      });
    }
  },
  computed: {
    isStepsMoreRecent: function isStepsMoreRecent() {
      var self = this;
      if (self.data.steps === null) {
        return false;
      }
      return moment(self.data.steps.date_created).isAfter(moment(self.data.date_created));
    },
    hasStepsAndNoSelfReportedReadings: function hasStepsAndNoSelfReportedReadings() {
      var self = this;
      if (!_.has(self.data, 'steps')) {
        return false;
      }
      return self.data.selfReportedCount === 0 && _.has(self.data, 'steps') && _.has(self.data.steps, 'steps');
    },
    deviceName: function deviceName() {
      var self = this;
      switch (self.data.steps.device) {
        case 'FITBIT':
          return 'FitBit';
        default:
          return 'N/A';
      }
    },
    calorieBurn: function calorieBurn() {
      var self = this;
      var calorieBurn = 0;
      var duration = self.model.minutes;
      duration = duration /= 60.0;
      if (self.model.type !== null && self.model.minutes !== null) {
        switch (self.model.type) {
          case 'CYCLING':
          case 'SWIMMING':
          case 'GYM_ROWING':
          case 'GYM_TREADMILL':
            calorieBurn = self.bmr / 24.0 * 8 * duration;
            break;
          case 'AEROBICS':
            calorieBurn = self.bmr / 24.0 * 6 * duration;
            break;
          case 'GYM_CYCLING':
            calorieBurn = self.bmr / 24.0 * 4 * duration;
            break;
          case 'RUNNING':
            calorieBurn = self.bmr / 24.0 * 7.5 * duration;
            break;
          case 'STAIR_WALKING':
            calorieBurn = self.bmr / 24.0 * 5 * duration;
            break;
          case 'WALKING':
            calorieBurn = self.bmr / 24.0 * 3.8 * duration;
            break;
          case 'GYM_WEIGHTS':
            calorieBurn = self.bmr / 24.0 * 5 * duration;
            break;
          case 'YOGA':
            calorieBurn = self.bmr / 24.0 * 4.8 * duration;
            break;
          case 'TAI_CHI':
            calorieBurn = self.bmr / 24.0 * 4.4 * duration;
            break;
          case 'PILATES':
            calorieBurn = self.bmr / 24.0 * 4.9 * duration;
            break;
          case 'SPORTS':
            calorieBurn = self.bmr / 24.0 * 5.1 * duration;
            break;
          case 'DANCING':
            calorieBurn = self.bmr / 24.0 * 4.8 * duration;
            break;
          case 'SALSA_DANCING':
            calorieBurn = self.bmr / 24.0 * 4 * duration;
            break;
          case 'GENERAL':
          case 'SEX':
            calorieBurn = self.bmr / 24.0 * 2.5 * duration;
            break;
        }
        self.model.calories_burnt = calorieBurn.toFixed(0);
        return calorieBurn.toFixed(0);
      } else {
        return 0;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    _EventBus2.default.$off('activityPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _BloodGlucose = __webpack_require__(351);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _HbA1c = __webpack_require__(272);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _TagLocalizerMixin = __webpack_require__(356);

var _TagLocalizerMixin2 = _interopRequireDefault(_TagLocalizerMixin);

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  name: 'blood-glucose-input',
  mixins: [_CardAnimationMixin2.default, _TagLocalizerMixin2.default],
  components: {
    DatePicker: _DateTimePicker2.default,
    vueSlider: _vue2Slider2.default
  },
  props: {
    bloodGlucose: {},
    hba1c: {}
  },
  data: function data() {
    return {
      title: this.$t('message.cardBloodGlucose'),
      latestReadingTitle: this.$t('message.cardLatestReading'),
      lastReadingAtTitle: this.$t('message.cardLatestReadingAt'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      value: [0, 5],
      settings: {},
      scroller: document.getElementsByClassName('main-content')[0],
      sliderSettings: {
        value: [4, 6],
        width: '100%',
        height: 8,
        dotSize: 16,
        min: 0,
        max: 500,
        disabled: false,
        show: true,
        tooltip: 'always',
        formatter: '{value}',
        bgStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        },
        tooltipStyle: {
          backgroundColor: '#E74C27',
          borderColor: '#E74C27'
        },
        processStyle: {
          backgroundColor: '#E74C27'
        }
      },
      readingTags: [],
      model: {
        blood_glucose_mmoll: null,
        blood_glucose_mgdl: null,
        hba1c_percent: null,
        hba1c_mmol_mol: null,
        tags: [],
        tag: null
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.loadTags();
    self.loadData();
    self.averageTitle = self.$t('message.cardBloodGlucose30DayAverage');
    self.inRangeTitle = self.$t('message.cardBloodGlucoseInRange');

    self.$EventBus.$on('lc:settingsUpdated', function () {
      self.loadData();
    });

    self.$EventBus.$on('bgPusherReceived', function (data) {
      self.$nextTick(function () {
        self.data = data;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('bgReadingUpdated', function () {
      self.$store.commit('setBloodGlucoseCard', {});
      self.loadData();
    });
  },

  methods: {
    onEnter: function onEnter(el, done) {
      _all.TweenMax.from(el, 0.3, {
        height: 0,
        immediateRender: true,
        onComplete: done
      });
    },
    onLeave: function onLeave(el, done) {
      _all.TweenMax.to(el, 0.3, {
        height: 0,
        immediateRender: true,
        onComplete: done
      });
    },
    formatDate: function formatDate(date) {
      return moment(date).subtract(30, 'seconds').fromNow();
    },
    saveReading: function saveReading() {
      var self = this;

      self.$validator.validateAll().then(function (valid) {

        if (self.model.tag !== null) {
          self.model.tags = [self.model.tag];
        }

        if (valid) {

          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          var hasBloodGlucose = false;
          var hasHba1c = false;

          if (self.bloodGlucose.measure === 'mmoll') {
            if (self.model.blood_glucose_mmoll !== null) {
              hasBloodGlucose = true;
              if (self.hba1c.measure === 'percentage') {
                if (self.model.hba1c_percent !== null) {
                  hasHba1c = true;
                }
              }
              if (self.hba1c.measure === 'mmol-mol') {
                if (self.model.hba1c_mmol_mol !== null) {
                  hasHba1c = true;
                }
              }
            } else {
              hasBloodGlucose = false;
              if (self.hba1c.measure === 'percentage') {
                if (self.model.hba1c_percent !== null) {
                  hasHba1c = true;
                }
              }
              if (self.hba1c.measure === 'mmol-mol') {
                if (self.model.hba1c_mmol_mol !== null) {
                  hasHba1c = true;
                }
              }
            }
          }

          if (self.bloodGlucose.measure === 'mgdl') {
            if (self.model.blood_glucose_mgdl !== null) {
              hasBloodGlucose = true;
              if (self.hba1c.measure === 'percentage') {
                if (self.model.hba1c_percent !== null) {
                  hasHba1c = true;
                }
              }
              if (self.hba1c.measure === 'mmol-mol') {
                if (self.model.hba1c_mmol_mol !== null) {
                  hasHba1c = true;
                }
              }
            } else {
              hasBloodGlucose = false;
              if (self.hba1c.measure === 'percentage') {
                if (self.model.hba1c_percent !== null) {
                  hasHba1c = true;
                }
              }
              if (self.hba1c.measure === 'mmol-mol') {
                if (self.model.hba1c_mmol_mol !== null) {
                  hasHba1c = true;
                }
              }
            }
          }

          if (hasHba1c) {
            self.isSaving = true;
            var model = {};
            if (_.has(self.model, 'hba1c_percent')) {
              model.date = self.model.date;
              model.percent = self.model.hba1c_percent;
            }
            if (_.has(self.model, 'hba1c_mmol_mol')) {
              model.date = self.model.date;
              model.mmol_mol = self.model.hba1c_mmol_mol;
            }

            var postHba1c = _HbA1c2.default.postHba1cTracking(model).then(function (response) {
              self.isSaving = true;
              self.$store.commit('setBloodGlucoseCard', {});
              self.$toastr.success("Hba1c reading added");
              if (self.$route.name === 'Dashboard') {
                _all.TweenLite.to(self.scroller, 0.2, {
                  scrollTo: {
                    y: self.$el,
                    offsetY: 16
                  }
                });
              }
              if (!hasBloodGlucose) {
                self.model = {
                  blood_glucose_mmoll: null,
                  blood_glucose_mgdl: null,
                  hba1c_percent: null,
                  hba1c_mmol_mol: null,
                  tags: []
                };
                self.isSaving = false;
                self.loadData();
              }
            });
          }

          if (hasBloodGlucose) {
            self.isSaving = true;
            if (_.has(self.model, 'hba1c_percent')) {
              delete self.model.hba1c_percent;
            }
            if (_.has(self.model, 'hba1c_mmol_mol')) {
              delete self.model.hba1c_mmol_mol;
            }

            var postData = _BloodGlucose2.default.postBloodGlucoseTracking(self.model);
            postData.then(function (response) {
              self.$store.commit('setBloodGlucoseCard', {});
              self.$gtag.event('ReadingAdded', {
                'event_category': 'BloodGlucoseCard',
                'event_label': 'Added reading',
                'value': 1
              });
              self.$toastr.success(self.$t('message.cardBloodGlucoseAdded'));
              if (self.$route.name === 'Dashboard') {
                _all.TweenLite.to(self.scroller, 0.2, {
                  scrollTo: {
                    y: self.$el,
                    offsetY: 16
                  }
                });
              }
              self.model = {
                blood_glucose_mmoll: null,
                blood_glucose_mgdl: null,
                hba1c_percent: null,
                hba1c_mmol_mol: null,
                tags: []
              };
              self.isSaving = false;
              self.loadData();
            });
          }
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    loadTags: function loadTags() {
      var self = this;
      if (self.$store.state.bgTagList.length > 0) {
        self.readingTags = self.$store.state.bgTagList;
      } else {
        var getData = _Lists2.default.getTagList();
        getData.then(function (response) {
          var data = response.data;
          self.$store.commit('setBgTagList', data);
          data = data.sort(function (a, b) {
            var textA = a.tag.toUpperCase();
            var textB = b.tag.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });
          self.readingTags = data;
        });
      }
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isSaving = false;
      self.isOpen = false;
      self.isOpenInput = false;
      if (_.has(self.$store.state.cards.bloodGlucose, 'value')) {
        self.loading = false;
        self.data = self.$store.state.cards.bloodGlucose;
      } else {
        var getData = _BloodGlucose2.default.getBloodGlucoseTrackingCard();
        getData.then(function (response) {
          var status = response.status;
          if (status === 200) {
            var data = response.data;
            self.loading = false;
            self.data = data;
            if (_.has(self.data, 'missing_settings.glucose_range')) {
              self.sliderSettings.min = 0;
              self.sliderSettings.max = self.data.missing_settings.glucose_range.max_value;
              var measure = self.data.missing_settings.glucose_range.measure;
              var unit = void 0;
              if (measure === 'mgdl') {
                self.sliderSettings.value = [72, 108];
                unit = 'mg/dL';
              } else {
                self.sliderSettings.value = [4, 6];
                unit = "mmol/L";
              }
              self.sliderSettings.formatter = "{value} " + unit;
              self.isBackgroundShown = false;
            } else {
              if (_.has(self.data, 'value')) {
                self.$store.commit('setBloodGlucoseCard', response.data);
              }
            }
          } else {
            if (status === 201) {
              var _data = response.data;
              if (_data) {
                self.data = _data;
                self.loading = false;
              } else {
                self.loading = false;
              }
            }
          }
        });
      }
    },
    saveSettings: function saveSettings() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          if (_.has(self.data, 'missing_settings.glucose_range')) {
            self.isSaving = true;
            var min = self.sliderSettings.value[0];
            var max = self.sliderSettings.value[1];
            var body = {
              glucose_range: {
                min: min,
                max: max
              }
            };
            _Settings2.default.updateUserSettings(body).then(function (response) {
              self.$EventBus.$emit('lc:settingsUpdated', true);
            }, function (error) {
              self.data = error;
              self.isSaving = false;
              self.loading = false;
            });
          } else if (self.settings.hba1c !== 0 || self.settings.blood_glucose !== 0) {
            self.isSaving = true;
            _Settings2.default.updateUserSettings(self.settings).then(function (response) {
              self.isSaving = false;
              self.$EventBus.$emit('lc:settingsUpdated', true);
            }, function (error) {
              self.data = error;
              self.isSaving = false;
              self.loading = false;
            });
          }
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'BloodGlucoseCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'BloodGlucoseCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    closeInput: function closeInput() {
      var self = this;
      this.model = {
        tags: []
      };
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'BloodGlucoseCard',
        'event_label': 'Closed card',
        'value': 0
      });
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/blood-glucose/'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('bgPusherReceived');
    this.$EventBus.$off('bgReadingUpdated');
    this.$EventBus.$off('lc:settingsUpdated');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _BloodPressure = __webpack_require__(479);

var _BloodPressure2 = _interopRequireDefault(_BloodPressure);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  components: { DatePicker: _DateTimePicker2.default },
  name: 'blood-pressure-input',
  mixins: [_ScrollerMixin2.default, _CardAnimationMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.cardBloodPressure'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      value: [0, 5],
      model: {
        customDate: false
      }
    };
  },
  mounted: function mounted() {
    var self = this;

    self.$EventBus.$on('bloodPressurePusherReceived', function (model) {
      self.$nextTick(function () {
        self.data = model;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('bloodPressureReadingUpdated', function () {
      self.$store.commit('setBloodPressureCard', {});
      self.loadData();
    });

    self.loadData();
  },

  methods: {
    saveReading: function saveReading() {
      var self = this;
      self.isSaving = true;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {

          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          _BloodPressure2.default.postBloodPressureTracking(self.model).then(function (response) {
            self.$store.commit('setBloodPressureCard', {});
            self.$EventBus.$emit('bpReadingAdded');
            self.$EventBus.$emit('updateGraph');
            self.$toastr.success(self.$t('message.cardBloodPressureAdded'));
            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            }
            self.isSaving = false;
            self.loadData();
          }).catch(function () {
            self.isSaving = false;
            self.loadData();
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'BloodPressureCard',
        'event_label': 'Closed card',
        'value': 0
      });
      self.model = {};
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'BloodPressureCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'BloodPressureCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
      self.model = {};
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      self.model = {};
      if (_.has(self.$store.state.cards.bloodPressure, 'measure')) {
        self.loading = false;
        self.data = self.$store.state.cards.bloodPressure;
      } else {
        _BloodPressure2.default.getBloodPressureTrackingCard().then(function (response) {
          var status = response.status;
          if (status === 200) {
            self.data = response.data;
            self.loading = false;
            self.$store.commit('setBloodPressureCard', response.data);
          } else {
            if (status === 201) {
              self.data = response.data;
              self.loading = false;
            }
          }
        });
      }
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/blood-pressure/'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('bloodPressureUpdated');
    this.$EventBus.$off('bloodPressurePusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _Cholesterol = __webpack_require__(480);

var _Cholesterol2 = _interopRequireDefault(_Cholesterol);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  components: { DatePicker: _DateTimePicker2.default },
  mixins: [_ScrollerMixin2.default, _CardAnimationMixin2.default],
  name: 'cholesterol-input',
  props: {
    blood_glucose: {}
  },
  data: function data() {
    return {
      title: this.$t('message.cardCholesterol'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      value: [0, 5],
      settings: {
        blood_glucose: 0
      },
      readingTags: [],
      model: {
        tags: []
      }
    };
  },
  mounted: function mounted() {
    var self = this;

    self.loadData();

    self.$EventBus.$on('cholesterolPusherReceived', function (model) {
      self.$nextTick(function () {
        self.data = model;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('cholesterolReadingUpdated', function () {
      self.$store.commit('setCholesterolCard', {});
      self.loadData();
    });

    self.$EventBus.$on('lc:settingsUpdated', function () {
      self.loadData();
    });
  },

  methods: {
    formatDate: function formatDate(date) {
      return _config2.default.dateFormatting.fromNow(date);
    },
    saveReading: function saveReading() {
      var self = this;
      self.isSaving = true;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {

          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          self.isSaving = true;
          var postData = _Cholesterol2.default.postCholesterolTracking(self.model);
          postData.then(function (response) {
            self.$store.commit('setCholesterolCard', {});
            self.$gtag.event('ReadingAdded', {
              'event_category': 'CholesterolCard',
              'event_label': 'Added reading',
              'value': 1
            });
            self.$toastr.success(self.$t('message.cholesterolReadingAdded'));
            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            } else {
              self.$EventBus.$emit('updateGraph');
              self.$EventBus.$emit('cholesterolReadingAdded');
            }
            self.model = {};
            self.isSaving = false;
            self.loadData();
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isSaving = false;
      self.isOpen = false;
      self.isOpenInput = false;

      if (_.has(self.$store.state.cards.cholesterol, 'measure')) {
        self.loading = false;
        self.data = self.$store.state.cards.cholesterol;
      } else {
        var getData = _Cholesterol2.default.getCholesterolTrackingCard();
        getData.then(function (response) {
          var status = response.status;
          if (status === 200) {
            var data = response.data;
            self.loading = false;
            self.data = data;
            self.$store.commit('setCholesterolCard', response.data);
          } else {
            if (status === 201) {
              self.data = response.data;
              self.loading = false;
            }
          }
        });
      }
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        name: 'CholesterolProgress'
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;

      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'CholesterolCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'CholesterolCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    closeInput: function closeInput() {
      var self = this;
      self.model = {
        tags: []
      };
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'CholesterolCard',
        'event_label': 'Closed card',
        'value': 0
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('cholesterolReadingUpdated');
    this.$EventBus.$off('cholesterolPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _HbA1c = __webpack_require__(272);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  mixins: [_CardAnimationMixin2.default],
  components: { DatePicker: _DateTimePicker2.default },
  name: 'hba1c-input',
  props: {
    hba1c: {}
  },
  data: function data() {
    return {
      isSaving: false,
      title: this.$t('message.cardHbA1c'),
      isOpenInput: false,
      scroller: document.getElementsByClassName('main-content')[0],
      model: {}
    };
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    formatDate: function formatDate(date) {
      return _config2.default.dateFormatting.fromNow(date);
    },
    saveReading: function saveReading() {
      var self = this;

      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          _HbA1c2.default.postHba1cTracking(self.model).then(function (response) {
            self.$nextTick(function () {
              self.isSaving = false;
              self.isOpenInput = false;
              self.$gtag.event('ReadingAdded', {
                'event_category': 'HbA1cCard',
                'event_label': 'Added reading',
                'value': 1
              });
              self.$toastr.success(self.$t('message.cardHbA1cAdded'));
              self.goToDetail();
            });
          });
        }
      });
    },
    toggle: function toggle() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'HbA1cCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'HbA1cCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    closeInput: function closeInput() {
      var self = this;
      this.model = {
        tags: []
      };
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'HbA1cCard',
        'event_label': 'Closed card',
        'value': 0
      });
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/hba1c/'
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _Insulin = __webpack_require__(352);

var _Insulin2 = _interopRequireDefault(_Insulin);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _InsulinMixin = __webpack_require__(355);

var _InsulinMixin2 = _interopRequireDefault(_InsulinMixin);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];
exports.default = {
  name: 'insulin-input',
  mixins: [_ScrollerMixin2.default, _CardAnimationMixin2.default, _InsulinMixin2.default],
  components: { DatePicker: _DateTimePicker2.default },
  data: function data() {
    return {
      title: this.$t('message.cardInsulin'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {
        no_setting: false,
        error: false
      },
      value: [0, 5],
      model: {},
      insulinTypes: []
    };
  },
  mounted: function mounted() {
    var self = this;

    self.$EventBus.$on('insulinPusherReceived', function (model) {
      self.$nextTick(function () {
        self.data = model;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('insulinReadingUpdated', function () {
      self.$store.commit('setInsulinCard', {});
      self.loadData();
    });

    self.loadData();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment.utc(date).subtract(30, 'seconds').fromNow();
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
      self.model = {};
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'InsulinCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'InsulinCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
      self.model = {};
    },
    saveReading: function saveReading() {
      var self = this;
      self.isSaving = true;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {

          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          _Insulin2.default.postInsulinTracking(self.model).then(function (response) {
            self.$store.commit('setInsulinCard', {});
            self.$gtag.event('ReadingAdded', {
              'event_category': 'InsulinCard',
              'event_label': 'Added reading',
              'value': 1
            });
            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            }
            if (self.$route.name === 'InsulinProgress') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: 0
                }
              });
              self.$EventBus.$emit('updateGraphData');
              self.$EventBus.$emit('insulinReadingAdded');
            }
            self.$toastr.success("Insulin entry added");
            self.isSaving = false;
            self.$store.commit('setInsulinCard', {});
            self.loadData();
          }).catch(function (error) {
            self.isSaving = false;
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      self.model = {};

      if (_.has(self.$store.state.cards.insulin, 'units')) {
        self.insulinTypes = self.$store.state.insulinTypes;
        self.data = self.$store.state.cards.insulin;
        self.loading = false;
      } else {
        _Insulin2.default.getInsulinTypes().then(function (response) {
          self.insulinTypes = response.data;
          self.$store.commit('setInsulinTypes', response.data);
        });

        _Insulin2.default.getInsulinTrackingCard().then(function (response) {
          var status = response.status;
          if (status === 200) {
            self.data = response.data;
            self.$store.commit('setInsulinCard', response.data);
            self.loading = false;
          } else {
            if (status === 201) {
              self.data = response.data;
              self.loading = false;
            }
          }
        });
      }
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/insulin/'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('insulinReadingUpdated');
    this.$EventBus.$off('insulinPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _Ketones = __webpack_require__(353);

var _Ketones2 = _interopRequireDefault(_Ketones);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  name: 'ketones-input',
  mixins: [_ScrollerMixin2.default, _CardAnimationMixin2.default],
  components: { DatePicker: _DateTimePicker2.default },
  props: {
    bloodGlucose: {}
  },
  data: function data() {
    return {
      latestReadingTitle: "",
      lastOccurrenceTitle: "",
      totalOccurrenceTitle: "",
      title: this.$t('message.cardKetones'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      hasData: false,
      loading: true,
      data: {},
      model: {}
    };
  },
  created: function created() {
    var self = this;
    self.latestReadingTitle = self.$store.state.i18n.t('message.cardLatestReading');
    self.lastReadingAtTitle = self.$store.state.i18n.t('message.cardLatestReadingAt');
    self.lastOccurrenceTitle = self.$store.state.i18n.t('message.cardKetonesLastOccurrence');
    self.totalOccurrenceTitle = self.$store.state.i18n.t('message.cardKetonesTotalOccurrences');
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();

    self.$EventBus.$on('ketonesPusherReceived', function (model) {
      self.$nextTick(function () {
        self.data = model;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('ketonesReadingUpdated', function () {
      self.$store.commit('setKetonesCard', {});
      self.loadData();
    });

    self.$EventBus.$on('lc:settingsUpdated', function () {
      self.loadData();
    });
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment(date).subtract(30, 'seconds').fromNow();
    },
    saveReading: function saveReading() {
      var self = this;
      self.isSaving = true;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {

          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          _Ketones2.default.postKetonesTracking(self.model).then(function (response) {
            self.$store.commit('setKetonesCard', {});
            self.$gtag.event('ReadingAdded', {
              'event_category': 'KetonesCard',
              'event_label': 'Added reading',
              'value': 1
            });
            self.isSaving = false;

            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            }
            self.$toastr.success(self.$t('message.cardKetonesAdded'));
            self.$EventBus.$emit('ketonesReadingAdded');
            self.$EventBus.$emit('updateGraph');
            self.loadData();
          }).catch(function () {
            self.isSaving = false;
            self.loadData();
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;

      self.$gtag.event('Closed', {
        'event_category': 'KetonesCard',
        'event_label': 'Closed card',
        'value': 0
      });

      self.model = {};
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;

      if (self.isOpenInput === true) {
        self.$gtag.event('Open', {
          'event_category': 'KetonesCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'KetonesCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
      self.model = {};
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      self.model = {};

      if (_.has(self.$store.state.cards.ketones, 'ketoacidosis')) {
        self.data = self.$store.state.cards.ketones;
        self.loading = false;
      } else {
        _Ketones2.default.getKetonesTrackingCard().then(function (response) {
          var status = response.status;
          if (status === 200) {
            self.data = response.data;
            self.$store.commit('setKetonesCard', response.data);
            self.loading = false;
          } else {
            if (status === 201) {
              self.data = response.data;
              self.loading = false;
            }
          }
        });
      }
    },
    goToSettings: function goToSettings() {
      var self = this;
      self.$router.push({
        name: 'SettingsUnits'
      });
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/ketones/'
      });
    },
    decimalize: function decimalize(num) {
      if (isNaN(num)) {
        return 0;
      }
      var number = numeral(num);
      if (this.isWholeNumber(num)) {
        return number.format('0');
      }
      return number.format('0.0');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('ketonesReadingUpdated');
    this.$EventBus.$off('ketonesPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _index = __webpack_require__(112);

var _index2 = _interopRequireDefault(_index);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _flatButton = __webpack_require__(339);

var _flatButton2 = _interopRequireDefault(_flatButton);

var _MedicationRegimes = __webpack_require__(199);

var _MedicationRegimes2 = _interopRequireDefault(_MedicationRegimes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  mixins: [_CardAnimationMixin2.default, _MedicationRegimes2.default],
  components: {
    MuFlatButton: _flatButton2.default,
    DatePicker: _DateTimePicker2.default,
    MedicationRegimeMixin: _MedicationRegimes2.default
  },
  name: 'medication-input',
  data: function data() {
    return {
      alreadyCopied: false,
      yesterdayDosageCount: 0,
      hasMedsToCopy: false,
      scroller: document.getElementsByClassName('main-content')[0],
      title: this.$t('message.cardMedication'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasMedications: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      medications: [],
      model: {
        tracking_id: null,
        dosage: null
      }
    };
  },
  mounted: function mounted() {
    var self = this;

    if (window.sessionStorage.getItem('copiedMeds') !== null) {
      if (moment().subtract(1, 'day').format('YYYY-MM-DD') === window.sessionStorage.getItem('copiedMeds')) {
        self.alreadyCopied = true;
      } else {
        self.alreadyCopied = false;
      }
    } else {
      self.alreadyCopied = false;
      _index2.default.checkForDosages(moment().subtract(1, 'day').format('YYYY-MM-DD')).then(function (response) {

        if (response.status === 201) {
          self.hasMedsToCopy = false;
          return;
        }

        self.yesterdayDosageCount = response.data.count;
        self.hasMedsToCopy = true;
      }).catch(function (error) {
        self.hasMedsToCopy = false;
      });
    }

    self.$EventBus.$on('medicationPusherReceived', function (model) {
      self.$nextTick(function () {
        self.data = model;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('medicationReadingUpdated', function () {
      self.$store.commit('setMedicationCard', {});
      self.loadData();
    });

    self.loadData();
  },

  methods: {
    copyYesterdaysMedication: function copyYesterdaysMedication() {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "You are repeating yesterday's medication",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _index2.default.copyDosages(moment().subtract(1, 'day').format('YYYY-MM-DD'));
        }
      }).then(function (response) {
        self.$alert({
          title: "Success!",
          text: "Dosages from yesterday were copied to today",
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
        self.alreadyCopied = true;
        window.sessionStorage.setItem('copiedMeds', moment().subtract(1, 'day').format('YYYY-MM-DD'));

        self.$EventBus.$emit('medicationReadingAdded');
        self.$EventBus.$emit('updateGraph');
        self.loadData();
      }.bind(self)).catch(self.$alert.noop);
    },
    goToSettings: function goToSettings() {
      var self = this;
      self.$router.push({
        path: '/settings/medications'
      });
    },
    saveReading: function saveReading() {
      var self = this;
      self.isSaving = true;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }
          _index2.default.postMedicationsTracking(self.model).then(function (response) {
            self.$store.commit('setMedicationCard', {});
            self.isSaving = false;
            self.$gtag.event('ReadingAdded', {
              'event_category': 'MedicationCard',
              'event_label': 'Added reading',
              'value': 1
            });
            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            } else {
              self.$EventBus.$emit('medicationReadingAdded');
              self.$EventBus.$emit('updateGraph');
            }
            self.$toastr.success(self.$t('message.cardMedicationAdded'));
            self.loadData();
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'MedicationCard',
        'event_label': 'Closed card',
        'value': 0
      });
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;

      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'MedicationCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'MedicationCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      _index2.default.getUserMedications().then(function (response) {
        self.medications = response.data;
        var medicationsLength = self.medications.length;
        if (medicationsLength > 0) {
          if (self.activeMedications.length > 0) {
            self.hasMedications = true;
            self.model.tracking_id = self.activeMedications[0].tracking_id;
          }
        } else {
          self.hasMedications = false;
        }
      });
      if (_.has(self.$store.state.cards.medication, 'dosage')) {
        self.loading = false;
        self.data = self.$store.state.cards.medication;
      } else {
        _index2.default.getMedicationsTrackingCard().then(function (response) {
          var status = response.status;
          if (status === 200) {
            self.$store.commit('setMedicationCard', response.data);
            self.data = response.data;
            self.loading = false;
          } else {
            if (status === 201) {
              self.data = response.data;
              self.loading = false;
            }
          }
        });
      }
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/medication/'
      });
    }
  },
  computed: {
    activeMedications: function activeMedications() {
      var self = this;
      return self.medications.filter(function (item) {
        return item.active === true;
      });
    },
    activeLabel: function activeLabel() {
      var self = this;
      var tracking_id = self.model.tracking_id;
      if (self.medications.length > 0) {
        var unitLabel = self.medications.filter(function (item) {
          return item.tracking_id === tracking_id;
        })[0].unit_label;
        return unitLabel;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('medicationPusherReceived');
    this.$EventBus.$off('medicationReadingUpdated');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

__webpack_require__(945);

var _all = __webpack_require__(65);

__webpack_require__(64);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _Mood = __webpack_require__(714);

var _Mood2 = _interopRequireDefault(_Mood);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _MoodLocalizerMixin = __webpack_require__(484);

var _MoodLocalizerMixin2 = _interopRequireDefault(_MoodLocalizerMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  components: { DatePicker: _DateTimePicker2.default },
  name: 'mood-input',
  mixins: [_ScrollerMixin2.default, _CardAnimationMixin2.default, _MoodLocalizerMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.cardMood'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      moods: {},
      model: {
        moods: [],
        customDate: false
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.moods = JSON.parse((0, _stringify2.default)(self.$store.state.moodList));

    self.$EventBus.$on('moodPusherReceived', function (model) {
      self.$nextTick(function () {
        self.data = self.$store.state.cards.mood;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('moodReadingUpdated', function () {
      self.loadData();
    });

    self.loadData();
  },

  methods: {
    getImageUrl: function getImageUrl(mood) {
      return _config2.default.siteUrl + 'assets/moods/svg/' + mood.icon + '.svg';
    },
    toggleMood: function toggleMood(mood) {
      var self = this;
      mood.isActive = !mood.isActive;
      if (mood.isActive === true) {
        self.model.moods.push(mood.mood_id);
      }
      if (mood.isActive === false) {
        var index = self.model.moods.indexOf(mood.mood_id);
        self.model.moods.splice(index, 1);
      }
      self.$forceUpdate();
    },
    saveReading: function saveReading() {
      var self = this;
      self.isSaving = true;
      if (self.model.moods.length > 0) {

        if (!_.has(self.model, 'date')) {
          self.model.date = moment().format();
        }

        _Mood2.default.postMoodsTracking(self.model).then(function (response) {
          self.$store.commit('setMoodCard', {});
          self.$gtag.event('ReadingAdded', {
            'event_category': 'MoodCard',
            'event_label': 'Added moods',
            'value': 1
          });

          self.model.customDate = false;

          self.isSaving = false;
          if (self.$route.name === 'Dashboard') {
            _all.TweenLite.to(self.scroller, 0.2, {
              scrollTo: {
                y: self.$el,
                offsetY: 16
              }
            });
          }
          self.$toastr.success(self.$t('message.cardMoodAdded'));
          self.loadData();
        });
      } else {
        self.isSaving = false;
      }
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'MoodCard',
        'event_label': 'Closed card',
        'value': 0
      });
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
      self.moods = JSON.parse((0, _stringify2.default)(self.$store.state.moodList));
      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'MoodCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'MoodCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      if (_.has(self.$store.state.cards.mood, 'most_recent')) {
        self.data = self.$store.state.cards.mood;
        self.loading = false;
      } else {
        _Mood2.default.getMoodsTrackingCard().then(function (response) {

          var status = response.status;
          if (status === 200) {
            self.$store.commit('setMoodCard', response.data);
            self.data = response.data;
            self.loading = false;
          } else {
            if (status === 201) {
              self.data = response.data;
              self.loading = false;
            }
          }
        });
      }
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/mood/'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    self.$EventBus.$off('moodReadingUpdated');
    self.$EventBus.$off('moodPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _Nutrition = __webpack_require__(1650);

var _Nutrition2 = _interopRequireDefault(_Nutrition);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  name: 'nutrition-input',
  mixins: [_ScrollerMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.cardNutrition'),
      isBackgroundShown: true,
      hasData: false,
      noData: true,
      loading: true,
      data: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();
  },

  methods: {
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      self.model = {};

      _Nutrition2.default.getNutritionCard().then(function (response) {
        var status = response.status;
        if (status === 200) {
          self.hasData = true;
          self.data = response.data;
          self.$store.commit('setNutritionCard', response.data);
          self.loading = false;
        } else {
          if (status === 201) {
            self.hasData = false;
            self.data = response.data;
            self.loading = false;
          }
        }
      });
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/food-diary'
      });
    }
  }
};

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _Sleep = __webpack_require__(198);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

var sliderSettings = {
  min: 1,
  max: 10,
  tooltip: 'false',
  tooltipDir: "top",
  bgStyle: {
    "backgroundColor": "#fff",
    "boxShadow": "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
  },
  processStyle: {
    "backgroundImage": "-webkit-linear-gradient(left, #183A43, #183A43)"
  },
  sliderStyle: [{
    "backgroundColor": "#CCCCCC"
  }],
  value: 5
};

exports.default = {
  name: 'sleep-input',
  mixins: [_ScrollerMixin2.default, _CardAnimationMixin2.default],
  components: {
    DatePicker: _DateTimePicker2.default,
    vueSlider: _vue2Slider2.default
  },
  data: function data() {
    return {
      title: this.$t('message.cardSleep'),
      sliderSettings: sliderSettings,
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      model: {
        hours: 10,
        quality: 5
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();

    self.$EventBus.$on('sleepPusherReceived', function (model) {
      self.$nextTick(function () {
        self.data = model;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('sleepReadingUpdated', function () {
      self.$store.commit('setSleepCard', {});
      self.loadData();
    });
  },

  methods: {
    saveReading: function saveReading() {
      var self = this;
      self.isSaving = true;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {

          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          _Sleep2.default.postSleepTracking(self.model).then(function (response) {
            self.$store.commit('setSleepCard', {});
            self.$gtag.event('ReadingAdded', {
              'event_category': 'SleepCard',
              'event_label': 'Added reading',
              'value': 1
            });

            self.$EventBus.$emit('sleepReadingAdded');

            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            }

            self.$toastr.success(self.$t('message.cardSleepEntryAdded'));

            self.isSaving = false;
            self.loadData();
          }).catch(function (error) {
            self.isSaving = false;
            self.loadData();
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;

      self.$gtag.event('Closed', {
        'event_category': 'SleepCard',
        'event_label': 'Closed card',
        'value': 0
      });
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;

      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'SleepCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'SleepCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      if (_.has(self.$store.state.cards.sleep, 'hours')) {
        self.loading = false;
        self.data = self.$store.state.cards.sleep;
      } else {
        _Sleep2.default.getSleepTrackingCard().then(function (response) {
          self.data = response.data;
          self.$store.commit('setSleepCard', response.data);
          self.loading = false;
        }).catch(function (error) {
          self.data = error.response.data;
          self.loading = false;
        });
      }
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/sleep/'
      });
    }
  },
  computed: {
    wearableTimeAwake: function wearableTimeAwake() {
      var self = this;
      var start = moment();

      var end = moment().add(self.data.wearable.minutesAwake, 'minutes');

      var diff = end.diff(start);
      var object = moment.utc(diff).toObject();

      if (self.data.wearable.minutesAwake <= 60) {
        return moment.duration(self.data.wearable.minutesAwake, 'minutes').format('m _');
      } else {
        return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
      }
    },
    wearableAsleepDuration: function wearableAsleepDuration() {
      var self = this;
      var start = moment();
      var end = moment().add(self.data.wearable.minutesAsleep, 'minutes');
      var diff = end.diff(start);
      var object = moment.utc(diff).toObject();

      if (self.data.wearable.minutesAwake <= 60) {
        return moment.duration(self.data.wearable.minutesAwake, 'minutes').format('m _');
      } else {
        return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
      }
    },
    wearablePredictionDuration: function wearablePredictionDuration() {
      var self = this;
      var start = moment();

      if (self.data.wearable.predictions.minutesAsleep <= 60) {
        return moment.duration(self.data.wearable.predictions.minutesAsleep, 'minutes').format('m _');
      } else {
        return moment.duration(self.data.wearable.predictions.minutesAsleep, 'minutes').format('h _ m _');
      }
    },
    wearableDuration: function wearableDuration() {
      var self = this;
      var start = moment(self.data.wearable.startTime);
      var end = moment(self.data.wearable.endTime);
      var diff = end.diff(start);
      var object = moment.utc(diff).toObject();

      if (self.data.wearable.minutesAwake <= 60) {
        return moment.duration(self.data.wearable.minutesAwake, 'minutes').format('m _');
      } else {
        return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
      }
    },
    isWearableMoreRecent: function isWearableMoreRecent() {
      var self = this;
      if (self.data.wearable === false) {
        return false;
      }
      return moment(self.data.wearable.date_created).isAfter(moment(self.data.date_created));
    },
    hasWearableAndNoSelfReportedReadings: function hasWearableAndNoSelfReportedReadings() {
      var self = this;
      if (!_.has(self.data, 'wearable')) {
        return false;
      }
      return self.data.selfReportedCount === 0 && _.has(self.data, 'wearable') && _.has(self.data.wearable, 'duration');
    },
    lowercaseHoursLabel: function lowercaseHoursLabel() {
      var self = this;
      return self.$t('message.labelHours').toLowerCase();
    },
    hours: function hours() {
      var self = this;
      if (self.data.hours !== undefined) {
        var humanizedHours = moment.duration(self.data.hours, 'hour').humanize();
        return humanizedHours;
      }
    },
    average: function average() {
      var self = this;
      if (self.data.average !== undefined) {
        var humanizedHours = moment.duration(self.data.average, 'hour').humanize();
        return humanizedHours;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('sleepReadingUpdated');
    this.$EventBus.$off('sleepPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(65);

__webpack_require__(64);

var _Weight = __webpack_require__(273);

var _Weight2 = _interopRequireDefault(_Weight);

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _ImageUploader = __webpack_require__(1243);

var _ImageUploader2 = _interopRequireDefault(_ImageUploader);

var _flexboxItem = __webpack_require__(660);

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _flatButton = __webpack_require__(339);

var _flatButton2 = _interopRequireDefault(_flatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_all.ScrollToPlugin];

exports.default = {
  components: {
    MuFlatButton: _flatButton2.default,
    MuFlexboxItem: _flexboxItem2.default,
    ImageUploader: _ImageUploader2.default,
    DatePicker: _DateTimePicker2.default
  },
  mixins: [_ScrollerMixin2.default, _CardAnimationMixin2.default],
  name: 'weight-input',
  props: {
    weight: {},
    waist: {},
    height: {}
  },
  data: function data() {
    return {
      title: this.$t('message.cardWeight'),
      data: {},
      hasData: false,
      isOpenSetting: false,
      isOpenHeightSetting: false,
      isOpenInput: false,
      isInputExpanded: false,
      isSaving: false,
      loading: true,
      settings: {},
      heightSettings: {},
      model: {},
      pusher: null
    };
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();

    self.$EventBus.$on('weightPusherReceived', function () {
      self.$nextTick(function () {
        self.data = self.$store.state.cards.weight;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('weightReadingUpdated', function () {
      self.$store.commit('setWeightCard', {});
      self.loadData();
    });
  },

  methods: {
    removeImage: function removeImage() {
      var self = this;
      delete self.model['image'];
      self.$forceUpdate();
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isSaving = false;
      self.isOpenSetting = false;
      self.isOpenHeightSetting = false;
      self.isOpenInput = false;

      if (_.has(self.$store.state.cards.weight, 'difference')) {
        self.loading = false;
        self.data = self.$store.state.cards.weight;
      } else {
        var getData = _Weight2.default.getWeightTrackingCard();
        getData.then(function (response) {
          var status = response.status;
          if (status === 200) {
            self.loading = false;
            self.data = response.data;
            self.$store.commit('setWeightCard', response.data);
          } else {
            if (status === 201) {
              self.data = response.data;
              self.loading = false;
            } else {
              self.loading = false;
            }
          }
        });
      }
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'WeightCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'WeightCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    closeInput: function closeInput() {
      this.model = {};
      this.isInputExpanded = false;
      this.isOpenInput = false;
    },
    openSettings: function openSettings() {
      var self = this;
      if (_.has(self.data, 'no_height_setting')) {
        self.isOpenHeightSetting = true;
      } else this.isOpenSetting = true;
    },
    closeSettings: function closeSettings() {
      this.isOpenSetting = false;
    },
    closeHeightSettings: function closeHeightSettings() {
      this.isOpenHeightSetting = false;
    },
    saveHeightSettings: function saveHeightSettings() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          var _canUpdate = void 0;
          self.isSaving = true;
          if (self.height.measure === 'ft-in') {
            if (_.has(self.heightSettings, 'ft') && _.has(self.heightSettings, 'in')) {
              _canUpdate = true;
            } else _canUpdate = false, self.isSaving = false;
          } else {
            if (_.has(self.heightSettings, 'cm')) {
              _canUpdate = true;
            } else _canUpdate = false, self.isSaving = false;
          }
          if (_canUpdate) _Settings2.default.updateHeightSettings(self.heightSettings).then(function (response) {
            self.loadData();
            self.$EventBus.$emit('lc:settingsUpdated', true);
          }).catch(function (error) {
            self.isSaving = false;
          });
        } else {
          self.isSaving = false;
          canUpdate = false;
        }
      }).catch(function () {});
    },
    saveSettings: function saveSettings() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          _Settings2.default.updateUserSettings(self.settings).then(function () {
            self.loadData();
            self.$EventBus.$emit('lc:settingsUpdated', true);
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    saveReading: function saveReading() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;

          if (!_.has(self.model, 'date')) {
            self.model.date = moment().format();
          }

          _Weight2.default.postWeightTracking(self.model).then(function () {
            self.$store.commit('setWeightCard', {});
            if (self.$route.name === 'Dashboard') {
              _all.TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: self.$el,
                  offsetY: 16
                }
              });
            }
            self.$toastr.success(self.$t('message.cardWeightAdded'));
            self.$gtag.event('ReadingAdded', {
              'event_category': 'WeightCard',
              'event_label': 'Added reading',
              'value': 1
            });
            self.model = {};
            self.loadData();
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    toggleExpandedInput: function toggleExpandedInput() {
      var self = this;
      self.isInputExpanded = !self.isInputExpanded;
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        path: '/tracking/weight/'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    self.$EventBus.$off('weightReadingUpdated');
    self.$EventBus.$off('weightPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'service-tracking-types',
  props: {
    type: {
      type: String,
      required: true,
      default: 'sleep'
    },
    serviceList: {
      type: Array,
      default: []
    },
    currentService: {
      type: String,
      default: 'LCP'
    }
  },
  data: function data() {
    return {
      isLoading: true,
      services: [],
      activeService: 'LCP'
    };
  },

  methods: {
    capitalize: function capitalize(txt) {
      return _.capitalize(txt);
    },
    getIntegrationsWithType: function getIntegrationsWithType() {
      var self = this;
      if (self.type === 'sleep') {
        _Integrations2.default.available.sleep().then(function (response) {
          self.pushServices(response.data);
          self.$nextTick(function () {
            self.activeService = self.currentService;
          });

          self.isLoading = false;
        });
      }
      if (self.type === 'activity') {
        _Integrations2.default.available.activity().then(function (response) {
          self.pushServices(response.data);
          self.$nextTick(function () {
            self.activeService = self.currentService;
          });

          self.isLoading = false;
        });
      }
    },
    initMounted: function initMounted() {
      var self = this;
      self.isLoading = true;

      if (self.serviceList.length === 0) {
        self.services.push({
          service: 'LCP'
        });
        self.getIntegrationsWithType();
      } else {
        self.services = self.serviceList;
        self.activeService = self.currentService;
      }
    },
    pushServices: function pushServices(services) {
      var self = this;
      services.forEach(function (service, i) {
        self.services.push(service);
      });
    },
    getService: function getService(service) {
      var self = this,
          fileName = null,
          tooltip = null;
      switch (service) {
        case 'LCP':
          fileName = 'lcp.png';
          tooltip = 'Low Carb Program';
          break;
        case 'FITBIT':
          fileName = 'fitbit.svg';
          tooltip = 'FitBit';
          break;
        case 'STRIIV':
          fileName = 'striiv.png';
          tooltip = 'Striiv';
          break;
      }
      return {
        logo: 'static/integrations/' + fileName,
        tooltip: tooltip + ' ' + self.capitalize(self.type) + ' Data'
      };
    },
    handleService: function handleService(service) {
      var self = this;
      self.activeService = service;
      var key = 'onTrackingType_' + self.type;
      self.$emit(key, self.activeService);
      self.$EventBus.$emit(key, self.activeService);
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  },

  computed: {
    hasServices: function hasServices() {
      var self = this;
      return self.services.length !== 0;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _CardAnimationMixin = __webpack_require__(86);

var _CardAnimationMixin2 = _interopRequireDefault(_CardAnimationMixin);

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

var _gsap = __webpack_require__(126);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'blood-glucose-targets',
  mixins: [_CardAnimationMixin2.default],
  components: {
    DatePicker: _DateTimePicker2.default,
    vueSlider: _vue2Slider2.default
  },
  props: {
    bloodGlucose: {},
    hba1c: {}
  },
  data: function data() {
    return {
      title: this.$t('message.labelUpdateRange'),
      isOpenInput: false,
      isSaving: false,
      loading: true,
      value: [0, 5],
      settings: {},
      scroller: document.getElementsByClassName('main-content')[0],
      sliderSettings: {
        value: [4, 7],
        width: '100%',
        height: 8,
        dotSize: 16,
        min: 0,
        max: 500,
        disabled: false,
        show: true,
        tooltip: 'always',
        formatter: '{value}',
        bgStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        },
        tooltipStyle: {
          backgroundColor: '#E74C27',
          borderColor: '#E74C27'
        },
        processStyle: {
          backgroundColor: '#E74C27'
        }
      },
      readingTags: [],
      model: {
        tags: []
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.sliderSettings.max = self.bloodGlucose.measure === 'mmoll' ? 30 : 500;
    _Settings2.default.getBloodSugarSettings().then(function (response) {
      self.sliderSettings.value = [response.data.glucose_range.min, response.data.glucose_range.max];
    });
  },

  methods: {
    saveSettings: function saveSettings() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {

          self.isSaving = true;
          var min = self.sliderSettings.value[0];
          var max = self.sliderSettings.value[1];
          var body = {
            glucose_range: {
              min: min,
              max: max
            }
          };
          _Settings2.default.updateUserSettings(body).then(function (response) {
            self.$toastr.success(self.$t('message.labelRangeUpdated'));
            self.isSaving = false;
            self.isOpenInput = false;
          }, function (error) {
            self.data = error;
            self.isSaving = false;
            self.loading = false;
          });
        } else {
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    close: function close() {
      this.isOpenInput = false;
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    }
  }
};

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadialProgress = __webpack_require__(451);

var _RadialProgress2 = _interopRequireDefault(_RadialProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { RadialProgress: _RadialProgress2.default },
  name: "activity-wearable-visualisation"
};

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BloodGlucose = __webpack_require__(351);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _RadialProgress = __webpack_require__(451);

var _RadialProgress2 = _interopRequireDefault(_RadialProgress);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuCircularProgress: _circularProgress2.default,
    RadialProgress: _RadialProgress2.default
  },
  name: "blood-glucose-range",
  data: function data() {
    return {
      isLoading: true,
      ranges: {
        total: 0
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var now = moment();
    var fromDate = now.startOf('month').format('YYYY-MM-DD');
    var toDate = now.format('YYYY-MM-DD');
    self.$EventBus.$on('bgPusherReceived', function () {
      self.isLoading = true;
      _BloodGlucose2.default.getBloodGlucoseRanges(fromDate, toDate).then(function (response) {
        self.ranges = response.data.ranges;
        self.isLoading = false;
      }).catch(function (error) {});
    });
    _BloodGlucose2.default.getBloodGlucoseRanges(fromDate, toDate).then(function (response) {
      self.ranges = response.data.ranges;
      self.isLoading = false;
    }).catch(function (error) {});
  },

  computed: {
    lower: function lower() {
      var self = this;
      var totals = self.ranges.total;
      if (self.ranges.total === 0) {
        return 0;
      }
      return self.ranges.lower / self.ranges.total * 100;
    },
    inRange: function inRange() {
      var self = this;
      var totals = self.ranges.total;
      if (self.ranges.total === 0) {
        return 0;
      }
      return self.ranges.in_range / self.ranges.total * 100;
    },
    upper: function upper() {
      var self = this;
      var totals = self.ranges.total;
      if (self.ranges.total === 0) {
        return 0;
      }
      return self.ranges.upper / self.ranges.total * 100;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadialProgress = __webpack_require__(451);

var _RadialProgress2 = _interopRequireDefault(_RadialProgress);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuCircularProgress: _circularProgress2.default,
    RadialProgress: _RadialProgress2.default
  },
  name: "pulse-range",
  data: function data() {
    return {
      isLoading: false,
      data: {}
    };
  },

  methods: {
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      return moment(date);
    })
  },
  mounted: function mounted() {
    var self = this;
    self.$EventBus.$on('emitHeartRateStats', function (data) {
      self.isLoading = true;
      self.data = data;
      self.$nextTick(function () {
        self.isLoading = false;
      }, 1000);
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadialProgress = __webpack_require__(451);

var _RadialProgress2 = _interopRequireDefault(_RadialProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { RadialProgress: _RadialProgress2.default },
  name: "sleep-visualisation"
};

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

var _Weight = __webpack_require__(273);

var _Weight2 = _interopRequireDefault(_Weight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'tracking-notifier',
  model: function model() {
    return {
      pusher: undefined
    };
  },

  props: {
    userId: {
      type: Number
    }
  },
  mounted: function mounted() {
    var self = this;
    self.pusher = _PusherManager2.default.subscribe('tracking_' + self.userId);

    self.pusher.bind('onActivityChanged', function (model) {
      self.$store.commit('setActivityCard', model);
      self.$EventBus.$emit('activityPusherReceived', model);
      if (self.$route.name === "ActivityProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onKetonesChanged', function (model) {
      self.$store.commit('setKetonesCard', model);
      self.$EventBus.$emit('ketonesPusherReceived', model);
      if (self.$route.name === "KetonesProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onCholesterolChanged', function (model) {
      self.$store.commit('setCholesterolCard', model);
      self.$EventBus.$emit('cholesterolPusherReceived', model);
      if (self.$route.name === "CholesterolProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onMoodChanged', function (model) {
      self.$store.commit('setMoodCard', model);
      self.$EventBus.$emit('moodPusherReceived', model);
      if (self.$route.name === "MoodProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onInsulinChanged', function (model) {
      self.$store.commit('setInsulinCard', model);
      self.$EventBus.$emit('insulinPusherReceived', model);
      if (self.$route.name === "InsulinProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onSleepChanged', function (model) {
      self.$store.commit('setSleepCard', model);
      self.$EventBus.$emit('sleepPusherReceived', model);
      if (self.$route.name === "SleepProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onWeightChanged', function (model) {
      self.$store.commit('setWeightCard', model);
      self.$EventBus.$emit('weightPusherReceived', model);
      if (self.$route.name === "WeightProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onBloodGlucoseChanged', function (model) {
      self.$store.commit('setBloodGlucoseCard', model);
      self.$EventBus.$emit('bgPusherReceived', model);
      if (self.$route.name === "BloodGlucoseProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onMedicationChanged', function (model) {
      self.$store.commit('setMedicationCard', model);
      self.$EventBus.$emit('medicationPusherReceived', model);
      if (self.$route.name === "MedicationProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });

    self.pusher.bind('onBloodPressureChanged', function (model) {
      self.$store.commit('setBloodPressureCard', model);
      self.$EventBus.$emit('bloodPressurePusherReceived', model);
      if (self.$route.name === "BloodPressureProgress") {
        self.$EventBus.$emit('updateGraphData');
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    self.pusher.unbind_all();
  }
};

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _croppie = __webpack_require__(537);

var _croppie2 = _interopRequireDefault(_croppie);

__webpack_require__(1947);

var _vueBase64FileUpload = __webpack_require__(337);

var _vueBase64FileUpload2 = _interopRequireDefault(_vueBase64FileUpload);

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    VueBase64FileUpload: _vueBase64FileUpload2.default
  },
  props: {
    hideAvatar: {
      type: Boolean,
      required: false
    },
    imageUrl: {
      type: String,
      required: false
    }
  },
  name: 'avatar-uploader',
  data: function data() {
    return {
      isSaving: false,
      customImageMaxSize: 2,
      src: "",
      image: "",
      loading: true,
      user: {},
      cropper: undefined,
      isImagePresent: false,
      snackbar: false
    };
  },
  mounted: function mounted() {
    var self = this;
    var wait = setTimeout(function () {
      var el = self.$refs['imageCropper'];
      if (el) {
        if (self.imageUrl) {
          self.initCropper(el);
          self.cropper.bind({
            url: self.imageUrl,
            orientation: 1
          });
          self.isImagePresent = true;
        } else {
          self.initCropper(el);
          self.cropper.bind({
            url: 'static/avatar.png',
            orientation: 1
          });
        }
      }
      clearTimeout(wait);
    }.bind(self), 500);
  },
  created: function created() {
    var self = this;
  },

  methods: {
    openInput: function openInput() {
      var self = this;
      $('.vue-base64-file-upload-wrapper input').click();
    },
    doCancel: function doCancel() {
      var self = this;
      self.isImagePresent = false;
      self.$emit('destroyUploader', null);
    },
    onLoad: function onLoad(dataUri) {
      var self = this;
      self.image = dataUri;
      self.cropper.bind({
        url: dataUri
      });
      self.isImagePresent = true;
    },
    onSizeExceeded: function onSizeExceeded(size) {
      alert('Image ' + size + 'Mb size exceeds limits of ' + this.customImageMaxSize + 'Mb!');
    },
    doCrop: function doCrop() {
      var self = this;
      self.isSaving = true;
      self.isImagePresent = false;
      self.$forceUpdate();
      $('.main-content').animate({
        scrollTop: $("#upload-avatar").offset().top
      }, 300);
      self.cropper.result('base64').then(function (image) {
        _Profile2.default.changeProfilePicture(image).then(function (response) {

          if (_.has(self.$store.state.activeProfileObject, 'information')) {
            self.$store.state.activeProfileObject.information.basic.profile_image = response.data.profile_large;
          }

          self.isSaving = false;
          self.$toastr.success("Updated profile picture");
          self.$emit('destroyUploader', null);
        });
      });
    },
    rotate: function rotate(direction) {
      var self = this;
      if (direction === 'left') {
        self.cropper.rotate(-90);
      }
      if (direction === 'right') {
        self.cropper.rotate(90);
      }
    },
    initCropper: function initCropper(el) {
      var self = this;
      self.cropper = new _croppie2.default(el, {
        viewport: { width: 200, height: 200 },
        boundary: { width: 250, height: 250 },
        showZoomer: true,
        enableOrientation: true
      });
    }
  },
  computed: {
    upperTwoInitials: {
      get: function get() {
        var self = this;
        return self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name ? self.$store.state.user.scope.display_name.charAt(0).toUpperCase() + self.$store.state.user.scope.display_name.charAt(1).toUpperCase() : self.$store.state.user.scope.firstname.charAt(0).toUpperCase() + self.$store.state.user.scope.surname.charAt(0).toUpperCase();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    if (self.cropper !== undefined) {
      self.cropper.destroy();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9)))

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'user-avatar',
  data: function data() {
    return {};
  },

  computed: {
    upperFirstChar: {
      get: function get() {
        var self = this,
            firstname = void 0,
            surname = void 0;
        firstname = self.$store.state.user.scope.firstname.charAt(0).toUpperCase() + self.$store.state.user.scope.firstname.slice(1);
        surname = self.$store.state.user.scope.surname.charAt(0).toUpperCase() + self.$store.state.user.scope.surname.slice(1);
        if (self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name) {
          return self.$store.state.user.scope.display_name;
        }
        return firstname + ' ' + surname;
      }
    },
    upperTwoInitials: {
      get: function get() {
        var self = this;
        if (self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name) {
          return self.$store.state.user.scope.display_name.charAt(0).toUpperCase();
        }
        return self.$store.state.user.scope.firstname.charAt(0).toUpperCase() + self.$store.state.user.scope.surname.charAt(0).toUpperCase();
      }
    }
  }
};

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    type: {
      type: String
    },
    mode: {
      type: String,
      default: 'text'
    }
  },
  name: 'user-badge',
  data: function data() {
    return {
      badges: [{
        key: "support",
        label: this.$t('message.badgeSupport'),
        image: 'static/badges/low-carb-support-team.svg'
      }, {
        key: "champion",
        label: this.$t('message.badgeChampion'),
        image: "static/badges/champion.svg"
      }, {
        key: "finished-program",
        label: this.$t('message.badgeCompleted'),
        image: "static/badges/completed-program-100.svg"
      }, {
        key: "hcp-verified",
        label: "HCP Verified",
        image: "static/badges/completed-program-100.svg"
      }],
      badge: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    var badge = _lodash2.default.findKey(self.badges, ['key', self.type]);
    self.badge = self.badges[badge];
  }
};

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInteger = __webpack_require__(733);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _isFinite = __webpack_require__(1678);

var _isFinite2 = _interopRequireDefault(_isFinite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'currency-input',
  props: {
    value: {
      type: Number
    },
    currency: {
      type: Object
    },
    label: {
      type: String,
      default: "Weekly grocery cost"
    }
  },
  data: function data() {
    return {
      inputValue: 0,
      castingType: "number",
      isInputActive: false,
      currencyElement: undefined
    };
  },
  mounted: function mounted() {
    var self = this;
    self.inputValue = self.value;
    self.currencyElement = $('.currencyInput');
  },

  computed: {
    displayValue: function displayValue() {
      var self = this;
      if ((0, _isFinite2.default)(self.inputValue) || (0, _isInteger2.default)(self.inputValue)) {
        return self.currency.currencySymbol + ' ' + self.inputValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
      return self.currency.currencySymbol + 0;
    }
  },
  methods: {
    changed: function changed() {
      var self = this;
      var elementText = self.currencyElement.val();
      self.$emit('input', elementText);
    },
    formatString: function formatString(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(126);

exports.default = {
  data: function data() {
    return {
      title: '404',
      message: 'The page you were looking for seems to have gone missing'
    };
  },
  mounted: function mounted() {
    var self = this;
    function stars() {
      var tl = new TimelineMax({
        repeat: -1
      });
      tl.to(self.$refs['starsBg'], 100, {
        backgroundPosition: "-2247px bottom",
        force3D: true,
        rotation: 90,
        z: 0.5,
        ease: Linear.easeNone
      });
      return tl;
    }
    var TimeLine = new TimelineMax({
      repeat: -1
    });
    TimeLine.add(stars(), 0).timeScale(0.7).progress(1).progress(0).play();
  },

  methods: {
    goBack: function goBack() {
      var self = this;
      self.$router.push({
        name: "Dashboard"
      });
    }
  }
};

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _Sleep = __webpack_require__(3465);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _HbA1c = __webpack_require__(3459);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _BloodGlucose = __webpack_require__(3456);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _BloodPressure = __webpack_require__(3457);

var _BloodPressure2 = _interopRequireDefault(_BloodPressure);

var _Mood = __webpack_require__(3463);

var _Mood2 = _interopRequireDefault(_Mood);

var _Ketones = __webpack_require__(3461);

var _Ketones2 = _interopRequireDefault(_Ketones);

var _Medication = __webpack_require__(3462);

var _Medication2 = _interopRequireDefault(_Medication);

var _Insulin = __webpack_require__(3460);

var _Insulin2 = _interopRequireDefault(_Insulin);

var _Weight = __webpack_require__(3466);

var _Weight2 = _interopRequireDefault(_Weight);

var _Cholesterol = __webpack_require__(3458);

var _Cholesterol2 = _interopRequireDefault(_Cholesterol);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Tracking = __webpack_require__(715);

var _Tracking2 = _interopRequireDefault(_Tracking);

var _Pictures = __webpack_require__(3464);

var _Pictures2 = _interopRequireDefault(_Pictures);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default],
  components: {
    AioPictures: _Pictures2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    AioCholesterol: _Cholesterol2.default,
    AioMedication: _Medication2.default,
    AioKetones: _Ketones2.default,
    AioMood: _Mood2.default,
    AioBloodPressure: _BloodPressure2.default,
    AioBloodGlucose: _BloodGlucose2.default,
    AioHba1c: _HbA1c2.default,
    AioSleep: _Sleep2.default,
    AioInsulin: _Insulin2.default,
    AioWeight: _Weight2.default,
    DatePicker: _DateTimePicker2.default
  },
  watch: {
    model: {
      handler: function handler() {
        var self = this;
        var objectsHydrated = _.filter(self.model, function (object) {
          return object !== null;
        });
        self.objectsHydrated = _(objectsHydrated).size();
      },

      deep: true
    }
  },
  data: function data() {
    return {
      objectsHydrated: 0,
      date: "",
      isFabShown: true,
      isSaving: false,
      model: {
        weight: null,
        hba1c: null,
        bloodGlucose: null,
        sleep: null,
        cholesterol: null,
        ketones: null,
        mood: null,
        medication: null,
        bloodPressure: null,
        insulin: null
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.scroller.addEventListener('scroll', self.checkIfFabShouldBeShown);
  },

  methods: {
    checkIfFabShouldBeShown: function checkIfFabShouldBeShown() {
      var self = this;
      if (self.scroller.clientWidth <= 600) {
        _ScrollManager2.default.isElementInViewport(self.$refs.scrollDetector) ? self.isFabShown = false : self.isFabShown = true;
      }
    },
    getScrollbarWidth: function getScrollbarWidth() {
      return _ScrollManager2.default.getScrollbarWidth();
    },
    processQueue: function processQueue() {
      var self = this;
      var model = JSON.parse((0, _stringify2.default)(self.model));
      for (var prop in model) {
        if (model.hasOwnProperty(prop)) {
          if (model[prop] === null || model[prop] === undefined) {
            delete model[prop];
          }
        }
      }
      for (var _prop in model) {
        if (model.hasOwnProperty(_prop)) {
          model[_prop].date = self.date;
        }
      }
      self.isSaving = true;
      _Tracking2.default.addProgress(model).then(function (response) {
        var complete = response.data;
        if (complete.weight === true) {
          self.$store.commit('setWeightCard', {});
        }
        if (complete.bloodGlucose === true) {
          self.$store.commit('setBloodGlucoseCard', {});
        }
        if (complete.bloodPressure === true) {
          self.$store.commit('setBloodPressureCard', {});
        }
        if (complete.medication === true) {
          self.$store.commit('setMedicationCard', {});
        }
        if (complete.ketones === true) {
          self.$store.commit('setKetonesCard', {});
        }
        if (complete.sleep === true) {
          self.$store.commit('setSleepCard', {});
        }
        if (complete.mood === true) {
          self.$store.commit('setMoodCard', {});
        }
        if (complete.insulin === true) {
          self.$store.commit('setInsulinCard', {});
        }
        self.$router.push({
          name: 'Dashboard'
        });
        self.$toastr.success("Progress data added");
      });
    },
    onCholesterolValid: function onCholesterolValid(model) {
      this.model.cholesterol = model;
    },
    onMedicationValid: function onMedicationValid(model) {
      this.model.medication = model;
    },
    onWeightValid: function onWeightValid(model) {
      this.model.weight = model;
    },
    onBloodPressureValid: function onBloodPressureValid(model) {
      this.model.bloodPressure = model;
    },
    onBloodGlucoseValid: function onBloodGlucoseValid(model) {
      this.model.bloodGlucose = model;
    },
    onHba1cValid: function onHba1cValid(model) {
      this.model.hba1c = model;
    },
    onInsulinValid: function onInsulinValid(model) {
      this.model.insulin = model;
    },
    onSleepValid: function onSleepValid(model) {
      this.model.sleep = model;
    },
    onMoodValid: function onMoodValid(model) {
      this.model.mood = null;
      this.model.mood = model;
    },
    onKetonesValid: function onKetonesValid(model) {
      this.model.ketones = model;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    if (self.scroller !== null) {
      self.scroller.removeEventListener('scroll', self.checkIfFabShouldBeShown);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TagLocalizerMixin = __webpack_require__(356);

var _TagLocalizerMixin2 = _interopRequireDefault(_TagLocalizerMixin);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

var _gsap = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TagLocalizerMixin2.default],
  name: 'aio-bloodGlucose',
  data: function data() {
    return {
      title: this.$t('message.cardBloodGlucose'),
      isOpenInput: false,
      scroller: document.getElementsByClassName('main-content')[0],
      readingTags: [],
      model: {
        blood_glucose_mgdl: null,
        blood_glucose_mmoll: null,
        tags: []
      }
    };
  },

  watch: {
    'model.blood_glucose_mgdl': function modelBlood_glucose_mgdl() {
      this.trySubmitAndEmitValue();
    },
    'model.blood_glucose_mmoll': function modelBlood_glucose_mmoll() {
      this.trySubmitAndEmitValue();
    },
    'model.tags': function modelTags() {
      this.trySubmitAndEmitValue();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.loadTags();
  },

  methods: {
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          var model = {};
          if (self.$store.state.user.settings.blood_glucose.measure === 'mgdl') {
            model.blood_glucose_mgdl = self.model.blood_glucose_mgdl;
            model.tags = self.model.tags;
          }
          if (self.$store.state.user.settings.blood_glucose.measure === 'mmoll') {
            model.blood_glucose_mmoll = self.model.blood_glucose_mmoll;
            model.tags = self.model.tags;
          }
          self.$emit('onValid', model);
        } else {
          self.$emit('onValid', null);
        }
      });
    },
    loadTags: function loadTags() {
      var self = this;
      var getData = _Lists2.default.getTagList();
      getData.then(function (response) {
        var data = response.data;
        data = data.sort(function (a, b) {
          var textA = a.tag.toUpperCase();
          var textB = b.tag.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        self.readingTags = data;
      });
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    },
    closeInput: function closeInput() {
      var self = this;
      this.model = {
        tags: []
      };
      self.isOpenInput = false;
    }
  }
};

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'aio-bloodPressure',
  data: function data() {
    return {
      title: this.$t('message.cardBloodPressure'),
      isOpenInput: false,
      model: {
        systolic: null,
        diastolic: null,
        pulse: null
      }
    };
  },

  watch: {
    'model.systolic': function modelSystolic() {
      this.trySubmitAndEmitValue();
    },
    'model.diastolic': function modelDiastolic() {
      this.trySubmitAndEmitValue();
    },
    'model.pulse': function modelPulse() {
      this.trySubmitAndEmitValue();
    }
  },
  methods: {
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          var model = {};
          model.systolic = self.model.systolic;
          model.diastolic = self.model.diastolic;
          if (self.model.pulse !== null) {
            model.pulse = self.model.pulse;
          }
          self.$emit('onValid', model);
        } else {
          self.$emit('onValid', null);
        }
      });
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    }
  }
};

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default],
  name: 'aio-cholesterol',
  data: function data() {
    return {
      title: this.$t('message.cardCholesterol'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      value: [0, 5],
      settings: {
        blood_glucose: 0
      },
      readingTags: [],
      model: {
        total_mmoll: null,
        ldl_mmoll: null,
        hdl_mmoll: null,
        triglycerides_mmoll: null,
        total_mgdl: null,
        ldl_mgdl: null,
        hdl_mgdl: null,
        triglycerides_mgdl: null,
        tags: []
      }
    };
  },

  watch: {
    'model.total_mmoll': function modelTotal_mmoll() {
      this.trySubmitAndEmitValue();
    },
    'model.ldl_mmoll': function modelLdl_mmoll() {
      this.trySubmitAndEmitValue();
    },
    'model.hdl_mmoll': function modelHdl_mmoll() {
      this.trySubmitAndEmitValue();
    },
    'model.triglycerides_mmoll': function modelTriglycerides_mmoll() {
      this.trySubmitAndEmitValue();
    },
    'model.total_mgdl': function modelTotal_mgdl() {
      this.trySubmitAndEmitValue();
    },
    'model.ldl_mgdl': function modelLdl_mgdl() {
      this.trySubmitAndEmitValue();
    },
    'model.hdl_mgdl': function modelHdl_mgdl() {
      this.trySubmitAndEmitValue();
    },
    'model.triglycerides_mgdl': function modelTriglycerides_mgdl() {
      this.trySubmitAndEmitValue();
    }
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {

          var model = JSON.parse((0, _stringify2.default)(self.model));

          for (var prop in model) {
            if (model.hasOwnProperty(prop)) {
              if (model[prop] === null || model[prop] === undefined) {
                delete model[prop];
              }
            }
          }
          self.$emit('onValid', model);
        } else {
          self.$emit('onValid', null);
        }
      });
    },
    formatDate: function formatDate(date) {
      return _config2.default.dateFormatting.fromNow(date);
    },
    goToDetail: function goToDetail() {
      var self = this;
      self.$router.push({
        name: 'CholesterolProgress'
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;

      if (self.isOpenInput) {
        self.$gtag.event('Open', {
          'event_category': 'CholesterolCard',
          'event_label': 'Opened card',
          'value': 0
        });
      }
      if (!self.isOpenInput) {
        self.$gtag.event('Closed', {
          'event_category': 'CholesterolCard',
          'event_label': 'Closed card',
          'value': 0
        });
      }
    },
    closeInput: function closeInput() {
      var self = this;
      self.model = {
        tags: []
      };
      self.isOpenInput = false;
      self.$gtag.event('Closed', {
        'event_category': 'CholesterolCard',
        'event_label': 'Closed card',
        'value': 0
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('cholesterolReadingUpdated');
    this.$EventBus.$off('cholesterolPusherReceived');
  }
};

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HbA1c = __webpack_require__(272);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'aio-hba1c',
  props: {
    hba1c: {}
  },
  data: function data() {
    return {
      isSaving: false,
      title: this.$t('message.cardHbA1c'),
      isOpenInput: false,
      scroller: document.getElementsByClassName('main-content')[0],
      model: {
        mmol_mol: null,
        percent: null
      }
    };
  },

  watch: {
    'model.percent': function modelPercent() {
      this.trySubmitAndEmitValue();
    },
    'model.mmol_mol': function modelMmol_mol() {
      this.trySubmitAndEmitValue();
    }
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    formatDate: function formatDate(date) {
      return _config2.default.dateFormatting.fromNow(date);
    },
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          var model = {};
          if (self.$store.state.user.settings.hba1c.measure === 'mmol-mol') {
            model.mmol_mol = self.model.mmol_mol;
          } else {
            model.percent = self.model.percent;
          }
          self.$emit('onValid', model);
        } else {
          self.$emit('onValid', null);
        }
      });
    },
    toggle: function toggle() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    }
  }
};

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _InsulinMixin = __webpack_require__(355);

var _InsulinMixin2 = _interopRequireDefault(_InsulinMixin);

var _Insulin = __webpack_require__(352);

var _Insulin2 = _interopRequireDefault(_Insulin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'aio-insulin',
  mixins: [_ScrollerMixin2.default, _InsulinMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.cardInsulin'),
      isOpenInput: false,
      model: {
        units: null,
        type: null
      },
      isInsulinTypesReady: false,
      insulinTypes: []
    };
  },

  watch: {
    'model.units': function modelUnits() {
      this.trySubmitAndEmitValue();
    },
    'model.type': function modelType() {
      this.trySubmitAndEmitValue();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();
  },

  methods: {
    loadData: function loadData() {
      var self = this;
      if (_.has(self.$store.state.cards.insulin, 'units')) {
        self.insulinTypes = self.$store.state.insulinTypes;
        self.data = self.$store.state.cards.insulin;
        self.loading = false;
        self.isInsulinTypesReady = true;
      } else {
        _Insulin2.default.getInsulinTypes().then(function (response) {
          self.insulinTypes = response.data;
          self.isInsulinTypesReady = true;
          self.$store.commit('setInsulinTypes', response.data);
        });
      }
    },
    openInput: function openInput() {
      this.isOpenInput = !this.isOpenInput;
    },
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.$emit('onValid', self.model);
        } else {
          self.$emit('onValid', null);
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Ketones = __webpack_require__(353);

var _Ketones2 = _interopRequireDefault(_Ketones);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'aio-ketones',
  data: function data() {
    return {
      latestReadingTitle: "",
      lastOccurrenceTitle: "",
      totalOccurrenceTitle: "",
      title: this.$t('message.cardKetones'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      hasData: false,
      loading: true,
      data: {},
      model: {
        mmoll: null,
        mgdl: null
      }
    };
  },

  watch: {
    'model.mgdl': function modelMgdl() {
      this.trySubmitAndEmitValue();
    },
    'model.mmoll': function modelMmoll() {
      this.trySubmitAndEmitValue();
    }
  },
  methods: {
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          var model = {};
          if (self.$store.state.user.settings.blood_glucose.measure === 'mgdl') {
            if (self.model.mgdl !== null) {
              model.mgdl = self.model.mgdl;
              self.$emit('onValid', model);
            }
          }
          if (self.$store.state.user.settings.blood_glucose.measure === 'mmoll') {

            if (self.model.mmoll !== null) {
              model.mmoll = self.model.mmoll;
              self.$emit('onValid', model);
            }
          }
        } else {
          self.$emit('onValid', null);
        }
      });
    },
    formatDate: function formatDate(date) {
      return moment.utc(date).subtract(30, 'seconds').fromNow();
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(112);

var _index2 = _interopRequireDefault(_index);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _MedicationRegimes = __webpack_require__(199);

var _MedicationRegimes2 = _interopRequireDefault(_MedicationRegimes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default, _MedicationRegimes2.default],
  name: 'aio-medication',
  data: function data() {
    return {
      title: this.$t('message.cardMedication'),
      isOpen: false,
      isOpenInput: false,
      hasMedications: true,
      data: {},
      medications: [],
      model: {
        tracking_id: null,
        dosage: null
      }
    };
  },

  watch: {
    'model.tracking_id': function modelTracking_id() {
      if (this.model.dosage !== null) {
        this.trySubmitAndEmitValue();
      }
    },
    'model.dosage': function modelDosage() {
      if (this.model.tracking_id !== null) {
        this.trySubmitAndEmitValue();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();
  },

  methods: {
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;

      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          self.$emit('onValid', self.model);
        } else {
          self.$emit('onValid', null);
          self.isSaving = false;
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    },
    loadData: function loadData() {
      var self = this;
      self.loading = true;
      self.isOpenInput = false;
      _index2.default.getUserMedications().then(function (response) {
        self.medications = response.data;
        var medicationsLength = self.medications.length;
        if (medicationsLength > 0) {
          self.hasMedications = true;
          self.model.tracking_id = self.medications[0].tracking_id;
        } else {
          self.hasMedications = false;
        }
      });
    },
    goToSettings: function goToSettings() {
      var self = this;
      self.$router.push({
        path: '/settings/medications'
      });
    }
  },
  computed: {
    activeLabel: function activeLabel() {
      var self = this;
      var tracking_id = self.model.tracking_id;
      if (self.medications.length > 0) {
        return self.medications.filter(function (item) {
          return item.tracking_id === tracking_id;
        })[0].unit_label;
      }
    }
  }
};

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

__webpack_require__(945);

var _MoodLocalizerMixin = __webpack_require__(484);

var _MoodLocalizerMixin2 = _interopRequireDefault(_MoodLocalizerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'aio-mood',
  mixins: [_MoodLocalizerMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.cardMood'),
      isOpen: false,
      isOpenInput: false,
      isSaving: false,
      isBackgroundShown: true,
      hasData: false,
      noData: false,
      loading: true,
      data: {},
      moods: {},
      model: {
        moods: []
      }
    };
  },

  watch: {
    'model.moods': function modelMoods() {
      this.trySubmitAndEmitValue();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.moods = JSON.parse((0, _stringify2.default)(self.$store.state.moodList));
  },

  methods: {
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      if (self.model.moods.length > 0) {
        self.$emit('onValid', self.model);
      } else self.$emit('onValid', null);
    },
    getImageUrl: function getImageUrl(mood) {
      return config.siteUrl + 'assets/moods/svg/' + mood.icon + '.svg';
    },
    toggleMood: function toggleMood(mood) {
      var self = this;
      mood.isActive = !mood.isActive;
      if (mood.isActive === true) {
        self.model.moods.push(mood.mood_id);
      }
      if (mood.isActive === false) {
        var index = self.model.moods.indexOf(mood.mood_id);
        self.model.moods.splice(index, 1);
      }
      self.$forceUpdate();
    },
    closeInput: function closeInput() {
      var self = this;
      self.isOpenInput = false;
      self.$emit('onValid', null);
      self.$forceUpdate();
    },
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
      self.model.moods = [];
      self.$emit('onValid', null);
      self.moods = JSON.parse((0, _stringify2.default)(self.$store.state.moodList));
    }
  }
};

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _ImageManager = __webpack_require__(717);

var _ImageManager2 = _interopRequireDefault(_ImageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'aio-pictures',
  data: function data() {
    return {
      isOpenInput: false,
      uploadProgress: 0,
      profileImage: null,
      images: []
    };
  },

  methods: {
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    },
    bindUploadEvent: function bindUploadEvent() {
      $('#uploadBtn').next().trigger('click');
    },
    chooseImage: function chooseImage(event) {
      var self = this,
          input = event.target;
      if (input.files && input.files[0]) {
        self.uploadImage(input.files[0]);
      }
    },
    uploadImage: function uploadImage(file) {
      var self = this,
          data = new FormData();
      data.append('file', file);
      var config = {
        onUploadProgress: function onUploadProgress(progressEvent) {
          self.uploadProgress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
        }
      };
      _axios2.default.post(_Profile2.default.galleryUploadURL(), data, config).then(function (response) {
        if (response.data.complete === true) {
          self.images.unshift(response.data.image);
          self.$toastr.success('Success, image added');
          self.uploadProgress = 0;
        }
      }).catch(function (error) {
        if (error.data.response) {
          self.$toastr.error(error.data.response.message);
          self.uploadProgress = 0;
        }
      });
    }
  },
  computed: {
    isUploadingImage: function isUploadingImage() {
      var self = this;
      return self.uploadProgress !== 0;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.scroller = $('.scroller');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

var _gsap = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sliderSettings = {
  min: 0,
  max: 10,
  tooltipDir: "right",
  bgStyle: {
    "backgroundColor": "#fff",
    "boxShadow": "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
  },
  processStyle: {
    "backgroundImage": "-webkit-linear-gradient(left, #183A43, #183A43)"
  },
  sliderStyle: [{
    "backgroundColor": "#CCCCCC"
  }],
  value: 5
};

exports.default = {
  name: 'aio-sleep',
  mixins: [_ScrollerMixin2.default],
  components: {
    vueSlider: _vue2Slider2.default
  },
  watch: {
    'model.hours': function modelHours() {
      this.trySubmitAndEmitValue();
    },
    'model.quality': function modelQuality() {
      this.trySubmitAndEmitValue();
    }
  },
  data: function data() {
    return {
      title: this.$t('message.cardSleep'),
      sliderSettings: sliderSettings,
      isOpenInput: false,
      data: {},
      model: {
        hours: 10,
        quality: 5
      }
    };
  },

  methods: {
    openInput: function openInput() {
      var self = this;
      self.isOpenInput = !self.isOpenInput;
    },
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.$emit('onValid', self.model);
        } else {
          self.$emit('onValid', null);
        }
      });
    }
  }
};

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2586);

exports.default = {
  name: 'aio-weight',
  watch: {
    'model.stones': function modelStones() {
      this.trySubmitAndEmitValue();
    },
    'model.pounds': function modelPounds() {
      this.trySubmitAndEmitValue();
    },
    'model.kg': function modelKg() {
      this.trySubmitAndEmitValue();
    },
    'model.lbs': function modelLbs() {
      this.trySubmitAndEmitValue();
    }
  },
  data: function data() {
    return {
      title: this.$t('message.cardWeight'),
      isOpenInput: false,
      model: {
        stones: null,
        pounds: null,
        lbs: null,
        kg: null
      }
    };
  },

  methods: {
    openInput: function openInput() {
      this.isOpenInput = !this.isOpenInput;
    },
    trySubmitAndEmitValue: function trySubmitAndEmitValue() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          var model = {};
          if (self.$store.state.user.settings.weight.measure === 'kg') {
            model.kg = self.model.kg;
          }
          if (self.$store.state.user.settings.weight.measure === 'lbs') {
            model.lbs = self.model.lbs;
          }
          if (self.$store.state.user.settings.weight.measure === 'st-lbs') {
            model.stones = self.model.stones;
            model.pounds = self.model.pounds;
          }
          self.$emit('onValid', model);
        } else {
          self.$emit('onValid', null);
        }
      });
    }
  }
};

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckIn = __webpack_require__(271);

var _CheckIn2 = _interopRequireDefault(_CheckIn);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      activeStep: 0,
      isProcessing: false,
      isFinished: false,
      goals: [],
      model: [],
      slider: {
        min: 0,
        max: 10,
        step: 1
      },
      evaluation: {
        old: 0,
        now: 0
      }
    };
  },

  methods: {
    addToModel: function addToModel() {
      var self = this,
          goal = self.getActiveGoal;
      if (goal) {
        self.model.push({
          goal_id: goal.goal_id,
          evaluation: self.evaluation.now
        });
      }
    },
    getGoals: function getGoals() {
      var self = this;
      _User2.default.getUserGoals().then(function (response) {
        var callback = response.data;
        self.goals = callback.goals;
        self.evaluation.old = callback.evaluation;
        self.evaluation.now = callback.evaluation;
        self.isLoading = false;
      });
    },
    handleNext: function handleNext() {
      var self = this;

      if (self.activeStep == self.model.length && !self.isProcessing) {
        self.addToModel();
      }
      if (self.isLastPanel) {
        self.submitForm();
      } else {
        self.activeStep += 1;
      }
    },
    submitForm: function submitForm() {
      var self = this;
      self.isProcessing = true;
      _CheckIn2.default.addGoals(self.model).then(function (response) {
        if (!response.data.error) {
          self.isProcessing = false;
          self.isFinished = true;
          self.$toastr.success('Your goal evaluation have been saved');

          var redirect = window.sessionStorage.getItem('checkInRedirect');
          if (redirect) {
            window.sessionStorage.removeItem('checkInRedirect');
            self.$router.push(redirect);
          } else {
            self.$router.push({
              name: 'Dashboard'
            });
          }
        }
      }).catch(function (error) {
        if (error.response.data) {
          self.isProcessing = false;
          self.$toastr.error('Failed to save evaluation');
        }
      });
    }
  },
  computed: {
    getActiveGoal: function getActiveGoal() {
      var self = this;
      return self.goals[self.activeStep];
    },
    isLastPanel: function isLastPanel() {
      var self = this;
      return self.goals.length === self.activeStep + 1;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getGoals();
  }
};

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckIn = __webpack_require__(271);

var _CheckIn2 = _interopRequireDefault(_CheckIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isProcessing: false,
      model: {}
    };
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isProcessing = true;
          _CheckIn2.default.addHba1c(self.model).then(function (response) {
            self.$router.push({
              name: 'GoalsCheckin'
            });
          });
        }
      });
    }
  }
};

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _CheckIn = __webpack_require__(271);

var _CheckIn2 = _interopRequireDefault(_CheckIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      window: undefined,
      contentElement: undefined,
      stickyCheckTime: 300,
      stickyFooterInterval: undefined,
      status: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    self.contentElement = $('.main-content');
    self.window = $(window);
    self.stickyFooterInterval = setInterval(function () {
      if (self.window.outerWidth(true) >= 600) {
        $('.footer').attr('style', 'width: ' + self.contentElement.prop("clientWidth") + 'px;' + 'right: ' + _ScrollManager2.default.getScrollbarWidth() + 'px;');
      } else {
        $('.footer').attr('style', '');
      }
    }, self.stickyCheckTime);

    self.window.resize(function () {
      if (self.window.outerWidth(true) >= 600) {
        $('.footer').attr('style', 'width: ' + self.contentElement.prop("clientWidth") + 'px;' + 'right: ' + _ScrollManager2.default.getScrollbarWidth() + 'px;');
      } else {
        $('.footer').attr('style', '');
      }
    });
    _CheckIn2.default.getCheckInStatus().then(function (response) {
      self.status = response.data;
    });
  },

  methods: {
    determineRoute: function determineRoute() {
      if (this.status.isDiabetic) {
        this.$router.push({
          name: 'Hba1cCheckin'
        });
      } else {
        this.$router.push({
          name: 'GoalsCheckin'
        });
      }
    },
    navigate: function navigate(name) {
      this.$router.push({
        name: 'GoalsCheckin'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    clearInterval(self.stickyFooterInterval);

    window.sessionStorage.setItem('checkInIgnored', true);
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckIn = __webpack_require__(271);

var _CheckIn2 = _interopRequireDefault(_CheckIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isProcessing: false,
      model: {},
      status: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    _CheckIn2.default.getCheckInStatus().then(function (response) {
      self.status = response.data;
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isProcessing = true;
          _CheckIn2.default.addWeight(self.model).then(function (response) {
            self.isProcessing = false;
            if (self.status.isDiabetic === true) {
              self.$router.push({
                name: 'Hba1cCheckin'
              });
            } else {
              self.$router.push({
                name: 'GoalsCheckin'
              });
            }
            self.$toastr.success("Added weight reading");
          });
        }
      });
    }
  }
};

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2589);

var _CoachingCard = __webpack_require__(3390);

var _CoachingCard2 = _interopRequireDefault(_CoachingCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CoachingCard: _CoachingCard2.default
  },
  name: 'coaching',
  data: function data() {
    return {};
  },

  methods: {
    goToArticle: function goToArticle(path) {
      var self = this;
      self.$router.push({
        path: path
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    var self = this;
  }
};

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _index = __webpack_require__(1645);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(2590);

var _ResetAccount = __webpack_require__(1257);

var _ResetAccount2 = _interopRequireDefault(_ResetAccount);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _vueRecaptcha = __webpack_require__(676);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_HCPMixin2.default],
  components: { ResetAccount: _ResetAccount2.default, VueRecaptcha: _vueRecaptcha2.default },
  name: 'contact',
  watch: {
    "$route": function $route() {
      var self = this;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      isSending: false,
      options: [{ key: "APP", label: this.$t('message.contactReasonApp') }, { key: "WEB", label: this.$t('message.contactReasonWebsite') }, { key: "TECHNICAL", label: this.$t('message.contactReasonTechnical') }, { key: 'FEATURE_REQUEST', label: this.$t('message.contactReasonFeatureRequest') }, { key: 'OTHER', label: this.$t('message.contactReasonOther') }],
      messageModel: {
        platform: "WEB",
        message: "",
        rtoken: null
      }
    };
  },

  methods: {
    submitMessage: function submitMessage() {
      var self = this;
      if (this.messageModel.message === "") {
        self.$toastr.error('Please enter a message');
        return;
      }
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function onVerify(token) {
      var self = this;
      self.messageModel.rtoken = token;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSending = true;
          _index2.default.postMessage(self.messageModel).then(function () {
            self.$toastr.success(self.$t('message.contactAdded'));
            self.$router.push({ name: 'Dashboard' });
          }).catch(function () {
            self.isSending = false;
            self.$toastr.error(self.$t('message.labelError'));
          });
        }
      });
    },
    initMounted: function initMounted() {
      var self = this;
      if (self.isHcpView) {
        _TitleManager2.default.replaceTitle('Feedback');
        self.options = [{ key: "HCP_COMMISSION", label: self.$t('message.contactReasonHcpCommission') }, { key: "HCP_TRAINING", label: self.$t('message.contactReasonHcpTraining') }, { key: "HCP_LEAFLETS_FLYERS", label: self.$t('message.contactReasonHcpLeaflets') }, { key: "HCP_SUGGESTIONS", label: "Platform development suggestions" }, { key: "HCP_FEEDBACK", label: "Feedback" }, { key: 'OTHER', label: this.$t('message.contactReasonOther') }];
      }
      if (self.$route.query.commission) {
        self.messageModel.platform = "HCP_COMMISSION";
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _Patient = __webpack_require__(3395);

var _Patient2 = _interopRequireDefault(_Patient);

var _HCP = __webpack_require__(3394);

var _HCP2 = _interopRequireDefault(_HCP);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_HCPMixin2.default],
  components: {
    HcpView: _HCP2.default,
    PatientView: _Patient2.default
  },
  name: 'dashboard'
};

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _Payment = __webpack_require__(196);

var _Payment2 = _interopRequireDefault(_Payment);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueStripe = __webpack_require__(705);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Discount",
  components: {
    StripeCheckout: _vueStripe.StripeCheckout
  },
  data: function data() {
    return {
      originalCost: 69.99,
      discountData: {},
      subscription: null,
      publishableKey: "" + _config2.default.stripePublishableKey,
      sessionId: null,
      isLoading: true
    };
  },

  methods: {
    getPackageAndPay: function getPackageAndPay() {
      var self = this;
      _Payment2.default.getPayPalSubscriptionDetails().then(function (response) {
        var packages = response.data.packages;

        var discountKey = packages["yearly-subscription-thirty-limited-time-plan"].key;

        _Payment2.default.getUuid().then(function (response) {
          var uuid = response.data.uuid;
          if (!uuid.length) {
            throw "uuid cannot be blank";
          }
          setTimeout(function () {
            window.location.href = self.Config("apiUrl") + ("paypal/subscription/express-checkout?package=" + discountKey + "&uuid=" + uuid);
          }, 800);
        });
      });
    },
    getDiscount: function getDiscount() {
      var self = this;
      _axios2.default.get(_config2.default.apiUrl + ("stripe/discount/" + self.$route.query.slug + "/")).then(function (response) {
        self.discountData = response.data.data.user;
        self.sessionId = response.data.data.session.session_id;
      }).catch(function (err) {
        self.$router.push({
          path: "/dashboard"
        });
      }).finally(function () {
        self.isLoading = false;
      });
    },
    submitDiscount: function submitDiscount() {
      var self = this;
      self.$refs.sessionCheckoutRef.redirectToCheckout();
    },
    Config: function Config(key) {
      return _config2.default[key];
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getDiscount();
  },

  computed: {
    usersDiscount: function usersDiscount() {
      var self = this;
      var discount = self.discountData.discount / 100;
      return (self.originalCost * discount).toFixed(2);
    },
    calculatedCost: function calculatedCost() {
      var self = this;
      return (self.originalCost - self.usersDiscount).toFixed(2);
    }
  }
};

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _HCPDownloads = __webpack_require__(3396);

var _HCPDownloads2 = _interopRequireDefault(_HCPDownloads);

var _PatientDownloads = __webpack_require__(3397);

var _PatientDownloads2 = _interopRequireDefault(_PatientDownloads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    PatientDownloads: _PatientDownloads2.default,
    HcpDownloads: _HCPDownloads2.default
  },
  name: 'downloads',
  mixins: [_HCPMixin2.default]
};

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_HCPMixin2.default],
  watch: {
    "$route": function $route() {
      var self = this;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      isLoading: true,
      data: {}
    };
  },

  methods: {
    openLink: function openLink(res) {
      window.open(res.link, '_blank');
    },
    getCategory: function getCategory() {
      var self = this;
      _Hcp2.default.getResourceCatDownloads(self.$route.params.slug).then(function (response) {
        self.data = response.data;
        self.isLoading = false;
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.isLoading = true;
      self.getCategory();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isVerifying: true
    };
  },
  mounted: function mounted() {
    var self = this;
    if (_.has(self.$route.query, 'token')) {
      var token = self.$route.query.token;
      self.verify(token);
    } else {
      self.goToDashboard();
    }
  },

  methods: {
    verify: function verify(token) {
      var self = this;
      _Account2.default.verifyAccountWithEmailToken(token).then(function () {
        _User2.default.getUser().then(function (response) {
          self.$store.commit('setUser', response.data);
          self.isVerifying = false;
        });
      }).catch(function () {
        self.goToDashboard();
      });
    },
    goToDashboard: function goToDashboard() {
      var self = this;
      self.$router.push({
        name: 'Dashboard'
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Faq = __webpack_require__(709);

var _Faq2 = _interopRequireDefault(_Faq);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _breadcrumb = __webpack_require__(3365);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { MuBreadcrumb: _breadcrumb2.default },
  name: "detail",
  watch: {
    '$route': function $route() {
      var self = this;
      self.isLoading = true;
      self.isRecsLoading = true;
      _Faq2.default.getById(self.$route.params.id).then(function (response) {
        self.content.question = response.data.question;
        self.content.answer = response.data.answer;
        self.content.category = response.data.name;
        self.content.rating = response.data.rating;
        self.content.video_url = response.data.video_url;
        _Faq2.default.getRecommendations(self.$route.params.id).then(function (response) {
          self.recommendations = response.data;
          self.isRecsLoading = false;
          self.isLoading = false;
        });
      }).catch(function (error) {});
    }
  },
  data: function data() {
    return {
      isLoading: true,
      content: {
        question: "",
        answer: ""
      },
      isRecsLoading: true,
      recommendations: []
    };
  },
  mounted: function mounted() {
    var self = this;

    _Faq2.default.getById(self.$route.params.id).then(function (response) {
      self.content.question = response.data.question;
      self.content.answer = response.data.answer;
      self.content.category = response.data.name;
      self.content.rating = response.data.rating;
      self.content.video_url = response.data.video_url;

      _Faq2.default.getRecommendations(self.$route.params.id).then(function (response) {
        self.isRecsLoading = false;
        self.recommendations = response.data;
        self.isLoading = false;
      });
    }).catch(function (error) {});
  },

  methods: {
    goToFAQ: function goToFAQ() {
      var self = this;
      self.router.push({
        name: 'Faq'
      });
    },
    upVote: function upVote(id) {
      var self = this;
      _Faq2.default.upVote(self.$route.params.id).then(function () {
        self.content.rating = 'UP';
        self.$forceUpdate();
      });
    },
    downVote: function downVote(id) {
      var self = this;
      _Faq2.default.downVote(self.$route.params.id).then(function () {
        self.content.rating = 'DOWN';
        self.$forceUpdate();
      });
    },
    goToFaq: function goToFaq(id) {
      var self = this;
      self.$router.push({
        name: 'FaqDetail',
        params: {
          id: id
        }
      });
    }
  }
};

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Observable = __webpack_require__(3);

var _Faq = __webpack_require__(709);

var _Faq2 = _interopRequireDefault(_Faq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      searchValue: null,
      categories: [],
      faqs: [],
      mostUseful: []
    };
  },
  mounted: function mounted() {
    var self = this;
    var autoCompleteElement = $('.searchInput');
    var observableConditionElement = _Observable.Observable.fromEvent(autoCompleteElement, 'keyup').map(function (x) {
      return x;
    });
    var delayedSearch = observableConditionElement.debounceTime(300).distinctUntilChanged();
    delayedSearch.subscribe(function (e) {
      self.searchFaqs();
    });

    _Faq2.default.mostUseful().then(function (response) {
      self.mostUseful = response.data;
    });

    _Faq2.default.getCategories().then(function (response) {
      self.categories = response.data;
    });
    _Faq2.default.getAll().then(function (response) {
      self.faqs = response.data;
      self.faqs.reverse();
      self.isLoading = false;
    }).catch(function (error) {});
  },

  methods: {
    goToFaq: function goToFaq(id) {
      var self = this;
      self.$router.push({
        name: 'FaqDetail',
        params: {
          id: id
        }
      });
    },
    highlight: function highlight(word) {
      var self = this;

      if (self.searchValue !== null) {
        var reg = new RegExp('(' + self.searchValue + ')', 'gi');
        var res = word.replace(reg, '<span class=\'highlight\'>' + self.searchValue + '</span>');
        return res;
      } else {
        return word;
      }
    },
    searchFaqs: function searchFaqs() {
      var self = this;

      if (self.searchValue === "") {
        _Faq2.default.getAll().then(function (response) {
          self.faqs = response.data;
          self.faqs.reverse();
          self.isLoading = false;
        });
      }

      _Faq2.default.search(self.searchValue).then(function (response) {
        if (response.data.length > 0) {
          self.faqs = response.data;
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _NutrientLocalizer = __webpack_require__(275);

var _NutrientLocalizer2 = _interopRequireDefault(_NutrientLocalizer);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeral = __webpack_require__(90);

var leftPaneWidth = {
  desktop: "100",
  tablet: "100"
};

var servingPickerWidth = {
  servingInput: {
    desktop: "20",
    tablet: "20"
  },
  servingSelector: {
    desktop: "80",
    tablet: "80"
  }
};

exports.default = {
  mixins: [_NutrientLocalizer2.default],
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  watch: {
    'model.serving_id': function modelServing_id() {
      var self = this,
          serving_id = self.model.serving_id;
      self.activeServingObject = self.food.servings.filter(function (item) {
        return item.serving_id === self.model.serving_id;
      })[0];
    },
    'timeModel.time': function timeModelTime() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    },
    'timeModel.date': function timeModelDate() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    }
  },
  data: function data() {
    return {
      maxDate: moment().format('DD-MM-YYYY'),
      modelDate: "",
      mealTypeId: 1,
      isSaving: false,
      isLoading: true,
      isNutritionPaneVisible: false,
      dateFormat: _DatePickerManager2.default,
      scroller: document.getElementsByClassName('main-content')[0],
      activeServingObject: {},
      food: {},
      leftPaneWidth: leftPaneWidth,
      servingPickerWidth: servingPickerWidth,
      model: {
        date: "",
        servings: 1,
        serving_id: 0
      },
      timeModel: {
        date: "",
        time: ""
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.modelDate = self.$route.query.date;
    self.mealTypeId = parseInt(self.$route.query.mealTypeId);
    var date = moment(self.modelDate),
        time = date.format('hh:mm a');
    if (self.isDst(date)) {
      date.add(1, 'hour');
    }
    self.timeModel.time = time;
    self.timeModel.date = date.format('DD-MM-YYYY');
    self.leftPaneWidth.desktop = "100";
    self.leftPaneWidth.tablet = "100";
    _Food2.default.getById(self.$route.query.foodId).then(function (response) {
      self.food = response.data.food;
      self.model.serving_id = self.food.servings[0].serving_id;
      self.isLoading = false;
      self.$nextTick(function () {
        $(self.$refs['dateInput']).val(moment(self.modelDate).format('YYYY-MM-DD'));
        $(self.$refs['timeInput']).val(moment(self.modelDate).format('hh:mm'));
      });
    });
  },

  methods: {
    isDst: function isDst(date) {
      return moment(date).isDST();
    },
    setServingSize: function setServingSize(size) {
      var self = this;
      self.model.servings = size;
      self.$forceUpdate();
    },
    saveFood: function saveFood() {
      var self = this;

      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          var inputDate = moment.utc(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY HH:mm a');
          if (self.isDst(inputDate)) {
            inputDate.add(1, 'hour');
          }
          var model = {
            date: self.model.date,
            meal_type_id: self.mealTypeId,
            foods: [{
              food_id: self.food.food_id,
              food_name: self.food.food_name,
              servings: self.model.servings,
              serving_id: self.model.serving_id,
              nutrients: self.activeServingObject.nutrients
            }]
          };
          _Food2.default.addFoods(model).then(function (response) {
            self.isSaving = false;
            self.$router.push({
              name: 'FoodDiary',
              query: {
                date: inputDate.format('YYYY-MM-DD')
              }
            });
          }).catch(function (error) {
            self.isSaving = false;
            self.$router.push({
              name: 'FoodDiary',
              query: {
                date: inputDate.format('YYYY-MM-DD')
              }
            });
          });
        }
      });
    },
    toggleNutritionPane: function toggleNutritionPane() {
      var self = this;
      self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
      if (self.isNutritionPaneVisible !== true) {
        self.leftPaneWidth.tablet = "100";
        self.leftPaneWidth.desktop = "100";
        self.servingPickerWidth.servingInput.desktop = "20";
        self.servingPickerWidth.servingInput.tablet = "20";
        self.servingPickerWidth.servingSelector.desktop = "80";
        self.servingPickerWidth.servingSelector.tablet = "80";
      } else {
        self.leftPaneWidth.tablet = "50";
        self.leftPaneWidth.desktop = "50";
        self.servingPickerWidth.servingInput.desktop = "40";
        self.servingPickerWidth.servingInput.tablet = "40";
        self.servingPickerWidth.servingSelector.desktop = "60";
        self.servingPickerWidth.servingSelector.tablet = "60";
      }
    },
    rounded: function rounded(num) {
      var number = numeral(num.toFixed(2));
      return number.format('0,0.0');
    },
    humanize: function humanize(str) {
      var frags = str.split('_');
      for (var i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    getUnit: function getUnit(key) {
      switch (key) {
        case 'calories':
          return 'kcal';
          break;
        case 'protein':
          return 'g';
          break;
        case 'carbohydrate':
          return 'g';
          break;
        case 'sugar':
          return 'g';
          break;
        case 'fat':
          return 'g';
          break;
        case 'saturated_fat':
          return 'g';
          break;
        case 'monounsaturated_fat':
          return 'g';
          break;
        case 'polyunsaturated_fat':
          return 'g';
          break;
        case 'cholesterol':
          return 'g';
          break;
        case 'fibre':
          return 'g';
          break;
        case 'sodium':
          return 'mg';
          break;
        case 'potassium':
          return 'mg';
          break;
      }
    },
    goBack: function goBack() {
      var self = this;
      self.$router.go(-1);
    },
    closeDialog: function closeDialog() {
      var self = this;
      self.$router.push({
        name: 'FoodDiary'
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(11)))

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _NutrientLocalizer = __webpack_require__(275);

var _NutrientLocalizer2 = _interopRequireDefault(_NutrientLocalizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeral = __webpack_require__(90);

var leftPaneWidth = {
  desktop: "100",
  tablet: "100"
};

var servingPickerWidth = {
  servingInput: {
    desktop: "20",
    tablet: "20"
  },
  servingSelector: {
    desktop: "80",
    tablet: "80"
  }
};

exports.default = {
  mixins: [_NutrientLocalizer2.default],
  props: {
    title: {
      type: String,
      default: "Edit"
    },
    foodObj: {
      type: Object
    },
    mealTypeId: {
      type: Number
    }
  },
  watch: {
    'timeModel.time': function timeModelTime() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    },
    'timeModel.date': function timeModelDate() {
      var self = this;
      var dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
      self.model.date = moment(dateTime).format();
    },
    'model.serving_id': function modelServing_id() {
      var self = this,
          serving_id = self.model.serving_id;
      self.activeServingObject = self.food.servings.filter(function (item) {
        return item.serving_id === self.model.serving_id;
      })[0];
    }
  },
  data: function data() {
    return {
      maxDate: moment().format('DD-MM-YYYY'),
      dateFormat: _DatePickerManager2.default,
      date: new Date(),
      isSaving: false,
      isLoading: true,
      isNutritionPaneVisible: false,
      scroller: document.getElementsByClassName('main-content')[0],
      activeServingObject: {},
      food: {},
      leftPaneWidth: leftPaneWidth,
      servingPickerWidth: servingPickerWidth,
      timeModel: {
        date: "",
        time: ""
      },
      model: {
        date: "",
        servings: 1,
        serving_id: 1
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    if (self.mealTypeId === undefined) {
      self.$router.push({
        name: "FoodDiary"
      });
    } else {
      var date = moment(self.foodObj.date_created);
      self.timeModel.time = date.format('hh:mm a');
      self.timeModel.date = date.format('DD-MM-YYYY');
      self.leftPaneWidth.desktop = "100";
      self.leftPaneWidth.tablet = "100";
      _Food2.default.getById(self.foodObj.fs_food_id).then(function (response) {
        self.food = response.data.food;
        self.model.serving_id = self.foodObj.fs_serving_id;
        self.model.servings = self.foodObj.servings;
        self.isLoading = false;
      });
    }
  },

  methods: {
    isDst: function isDst(now) {
      if (moment(now).isDST()) {
        return true;
      }
      return false;
    },
    setServingSize: function setServingSize(size) {
      var self = this;
      self.model.servings = size;
      self.$forceUpdate();
    },
    updateFood: function updateFood() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          var model = {
            date: self.model.date,
            food_id: self.foodObj.food_id,
            food_name: self.food.food_name,
            servings: self.model.servings,
            serving_id: self.model.serving_id,
            nutrients: self.activeServingObject.nutrients
          };
          _Food2.default.updateFood(model).then(function (response) {
            self.$router.push({
              name: "FoodDiary",
              query: {
                date: moment(self.model.date).format('YYYY-MM-DD')
              }
            });
          });
        }
      });
    },
    toggleNutritionPane: function toggleNutritionPane() {
      var self = this;
      self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
      if (self.isNutritionPaneVisible !== true) {
        self.leftPaneWidth.tablet = "100";
        self.leftPaneWidth.desktop = "100";
        self.servingPickerWidth.servingInput.desktop = "20";
        self.servingPickerWidth.servingInput.tablet = "20";
        self.servingPickerWidth.servingSelector.desktop = "80";
        self.servingPickerWidth.servingSelector.tablet = "80";
      } else {
        self.leftPaneWidth.tablet = "50";
        self.leftPaneWidth.desktop = "50";
        self.servingPickerWidth.servingInput.desktop = "40";
        self.servingPickerWidth.servingInput.tablet = "40";
        self.servingPickerWidth.servingSelector.desktop = "60";
        self.servingPickerWidth.servingSelector.tablet = "60";
      }
    },
    rounded: function rounded(num) {
      var number = numeral(num.toFixed(2));
      return number.format('0,0.0');
    },
    humanize: function humanize(str) {
      var frags = str.split('_');
      for (var i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    getUnit: function getUnit(key) {
      switch (key) {
        case 'calories':
          return 'kcal';
          break;
        case 'protein':
          return 'g';
          break;
        case 'carbohydrate':
          return 'g';
          break;
        case 'sugar':
          return 'g';
          break;
        case 'fat':
          return 'g';
          break;
        case 'saturated_fat':
          return 'g';
          break;
        case 'monounsaturated_fat':
          return 'g';
          break;
        case 'polyunsaturated_fat':
          return 'g';
          break;
        case 'cholesterol':
          return 'g';
          break;
        case 'fibre':
          return 'g';
          break;
        case 'sodium':
          return 'mg';
          break;
        case 'potassium':
          return 'mg';
          break;
      }
    },
    userDecidesTo: function userDecidesTo(option) {
      this.$emit('choseToSearchWith', option);
    },
    closeDialog: function closeDialog(ref) {
      var self = this;
      self.$router.push({
        name: "FoodDiary",
        query: {
          date: moment(self.model.date).format('YYYY-MM-DD')
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(278);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(234);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(277);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _ProgressItem = __webpack_require__(3402);

var _ProgressItem2 = _interopRequireDefault(_ProgressItem);

__webpack_require__(2587);

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _downloadjs = __webpack_require__(872);

var _downloadjs2 = _interopRequireDefault(_downloadjs);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _MealList = __webpack_require__(1242);

var _MealList2 = _interopRequireDefault(_MealList);

var _LandingDialog = __webpack_require__(3403);

var _LandingDialog2 = _interopRequireDefault(_LandingDialog);

var _AutocompleteDialog = __webpack_require__(1241);

var _AutocompleteDialog2 = _interopRequireDefault(_AutocompleteDialog);

var _SearchResultsDialog = __webpack_require__(3406);

var _SearchResultsDialog2 = _interopRequireDefault(_SearchResultsDialog);

var _FoodResultDialog = __webpack_require__(3401);

var _FoodResultDialog2 = _interopRequireDefault(_FoodResultDialog);

var _FoodEditDialog = __webpack_require__(3400);

var _FoodEditDialog2 = _interopRequireDefault(_FoodEditDialog);

var _FoodDiaryNutritionMixin = __webpack_require__(354);

var _FoodDiaryNutritionMixin2 = _interopRequireDefault(_FoodDiaryNutritionMixin);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _MyMeals = __webpack_require__(3404);

var _MyMeals2 = _interopRequireDefault(_MyMeals);

var _NutritionUnitDialog = __webpack_require__(3405);

var _NutritionUnitDialog2 = _interopRequireDefault(_NutritionUnitDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var barMode = "indeterminate",
    defaults = { fat: 0, protein: 0, carbohydrate: 0 };

var nutrientPresets = [{
  name: 'Low Carb',
  locale: 'message.dietPlanLowCarb',
  fat: 100,
  protein: 100,
  carbohydrate: 120
}, {
  name: 'Keto',
  locale: 'message.dietPlanKeto',
  fat: 150,
  protein: 120,
  carbohydrate: 50
}, {
  name: 'Custom',
  locale: 'message.labelCustom',
  fat: 100,
  protein: 100,
  carbohydrate: 120
}];

var foods = {
  breakfast: [],
  lunch: [],
  dinner: [],
  snack: []
};

exports.default = {
  mixins: [_FoodDiaryNutritionMixin2.default],
  components: {
    NutritionUnitDialog: _NutritionUnitDialog2.default,
    ProgressItem: _ProgressItem2.default,
    FdMymealsDialog: _MyMeals2.default,
    DatePicker: _DateTimePicker2.default,
    FdEditFoodDialog: _FoodEditDialog2.default,
    FdFoodResultDialog: _FoodResultDialog2.default,
    FdAutocompleteDialog: _AutocompleteDialog2.default,
    FdLandingDialog: _LandingDialog2.default,
    FdMealList: _MealList2.default,
    FdSearchResultsDialog: _SearchResultsDialog2.default
  },
  name: 'food-diary',
  data: function data() {
    return {
      nutrientPresets: nutrientPresets,
      isExporting: false,
      preset: {
        name: 'Low Carb',
        fat: 100,
        protein: 100,
        carbohydrate: 120
      },
      exportDate: {
        fromDate: moment().subtract(7, 'days').format('DD-MM-YYYY'),
        toDate: moment().format('DD-MM-YYYY')
      },
      window: $(window),
      dateFormat: _DatePickerManager2.default,

      isInitialising: true,
      isLoading: true,
      picker: "",
      foodResultId: 0,
      selectedFood: {},
      selectedSearchTerm: "",
      foodResultMode: "",
      activeDialogMethod: null,
      foods: foods,
      recipes: {
        all: [],
        breakfast: [],
        lunch: [],
        dinner: [],
        snack: []
      },
      config: {
        wrap: true,
        dateFormat: "d-m-y"
      },
      activeMealType: {},
      barMode: barMode,
      nutritionTargets: defaults,
      settingsModel: defaults,
      isSettingsUpdating: false,
      totals: {
        all: defaults,
        breakfast: defaults,
        dinner: defaults,
        snack: defaults
      },
      currentDate: {
        ddmmyy: moment().utc().local().format('DD-MM-YYYY HH:mm a'),
        actual: moment.utc().local(),
        presentational: _config2.default.dateFormatting.foodDiaryDate(moment().utc().local())
      },
      nutritionUnit: 'g'
    };
  },
  mounted: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var self;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = this;

              self.$gtag.pageview('/food-diary');
              self.window = $(window);
              if (self.isDst(self.currentDate.actual)) {
                self.currentDate.actual = moment.utc().add(1, 'hour').toDate();
                self.currentDate.ddmmyy = moment.utc().add(1, 'hour').format('DD-MM-YYYY');
                self.currentDate.presentational = _config2.default.dateFormatting.foodDiaryDate(moment().utc().add(1, 'hour'));
              }

              if (self.$route.query.date) {
                self.currentDate.actual = moment(self.$route.query.date, 'YYYY-MM-DD');
                self.currentDate.ddmmyy = moment(self.$route.query.date, 'YYYY-MM-DD').format('DD-MM-YYYY');
                self.currentDate.presentational = _config2.default.dateFormatting.foodDiaryDate(self.currentDate.actual);
                self.$forceUpdate();
              }

              _context2.next = 7;
              return self.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var responses, nutritionTargets, unit;
                return _regenerator2.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return _promise2.default.all([_Settings2.default.getNutritionSettings(), _Settings2.default.getFoodDiaryNutritionUnit()]);

                      case 3:
                        responses = _context.sent;
                        nutritionTargets = responses[0].data;

                        self.nutritionTargets = nutritionTargets;
                        self.settingsModel = JSON.parse((0, _stringify2.default)(nutritionTargets));

                        if (self.settingsModel.carbohydrate === 120 && self.settingsModel.protein === 100 && self.settingsModel.fat === 100) {
                          self.preset = self.nutrientPresets[0];
                        }
                        if (self.settingsModel.carbohydrate === 50 && self.settingsModel.protein === 120 && self.settingsModel.fat === 150) {
                          self.preset = self.nutrientPresets[1];
                        } else if (self.settingsModel.carbohydrate === 0 && self.settingsModel.protein === 0 && self.settingsModel.fat === 0) {
                          self.preset = self.nutrientPresets[0];
                        } else {
                          self.preset = self.nutrientPresets[2];
                          self.preset.carbohydrate = nutritionTargets.carbohydrate;
                          self.preset.fat = nutritionTargets.fat;
                          self.preset.protein = nutritionTargets.protein;
                        }
                        unit = responses[1].data.unit;

                        if (unit && unit.length) {
                          self.nutritionUnit = unit;
                        }
                        self.getData();
                        _context.next = 16;
                        break;

                      case 14:
                        _context.prev = 14;
                        _context.t0 = _context["catch"](0);

                      case 16:
                        _context.prev = 16;

                        self.isInitialising = false;
                        return _context.finish(16);

                      case 19:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this, [[0, 14, 16, 19]]);
              })));

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),

  watch: {
    '$route.query.date': function $routeQueryDate() {
      var self = this;
      if (self.$route.query.date) {
        self.currentDate.actual = moment(self.$route.query.date);
        self.currentDate.presentational = _config2.default.dateFormatting.foodDiaryDate(self.$route.query.date);
        self.$forceUpdate();
        self.getData();
      }
    },
    'preset': function preset() {
      this.settingsModel.carbohydrate = this.preset.carbohydrate;
      this.settingsModel.fat = this.preset.fat;
      this.settingsModel.protein = this.preset.protein;
    },
    "currentDate.ddmmyy": function currentDateDdmmyy() {
      var self = this;
      self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').format('dddd Do MMMM, YYYY');
      self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY');
      self.$forceUpdate();

      if (!self.isInitialising) {
        self.getData();
      }
    }
  },
  methods: {
    isDst: function isDst(date) {
      return moment(date).isDST();
    },

    closeDialogAndReload: function closeDialogAndReload(ref) {
      var self = this;
      self.currentDate.actual = moment(self.currentDate.actual);
      self.getData();
      $('.scrollable-area').attr('style', '');
      self.$refs[ref].close();
      setTimeout(function () {
        self.activeDialogMethod = null;
        self.foodResultMode = "";
      }.bind(self), 300);
    },
    selectRecent: function selectRecent(foodId) {
      var self = this;
      self.activeDialogMethod = "searchResult";
      self.foodResultMode = "noBack";
      self.foodResultId = foodId;
    },
    removeRecipe: function removeRecipe(event) {
      var self = this;
      Number.prototype.clamp = function (min, max) {
        return Math.min(Math.max(this, min), max);
      };
      var recipe = self.recipes[event.type][event.index];
      var currentItem = self.recipes.all.filter(function (item) {
        return item.id === recipe.id;
      });
      var allIndex = self.recipes.all.indexOf(currentItem[0]);
      self.recipes.all.splice(allIndex, 1);
      self.recipes[event.type].splice(event.index, 1);
      self.getData();
      self.$forceUpdate();
    },
    removeBreakfast: function removeBreakfast(index) {
      var self = this;
      self.foods.breakfast.splice(index, 1);
      self.getData();
    },
    removeLunch: function removeLunch(index) {
      var self = this;
      self.foods.lunch.splice(index, 1);
      self.getData();
    },
    removeDinner: function removeDinner(index) {
      var self = this;
      self.foods.dinner.splice(index, 1);
      self.getData();
    },
    removeSnack: function removeSnack(index) {
      var self = this;
      self.foods.snack.splice(index, 1);
      self.getData();
    },
    openEditPane: function openEditPane(food) {
      var self = this;
      self.openDialog('editFoodDialog', food);
    },
    foodSelected: function foodSelected(food) {
      var self = this;
      self.activeDialogMethod = "searchResult";
      self.foodResultId = parseInt(food.food_id);
      self.$forceUpdate();
    },

    foodNameSelected: function foodNameSelected(method, foodName) {
      var self = this;
      self.searchMethod(method);
      self.selectedSearchTerm = foodName;
    },

    searchMethod: function searchMethod(method) {
      var self = this;
      switch (method) {
        case 's':
          self.activeDialogMethod = "searchResults";
          break;
        case 'a':
          self.activeDialogMethod = "autocomplete";

          break;
        case 'b':
          self.activeDialogMethod = "barcode";

          break;

        case 'mm':
          self.activeDialogMethod = "mymeals";

          break;
      }
    },

    openCalendar: function openCalendar() {
      $('#dateInput').click();
    },
    updateTargets: function updateTargets() {
      var self = this;
      self.isSettingsUpdating = true;
      _Settings2.default.putNutritionSettings(self.settingsModel).then(function (response) {
        self.nutritionTargets = JSON.parse((0, _stringify2.default)(self.settingsModel));
        self.isSettingsUpdating = false;
        self.closeDialog('setTargetsDialog');
      });
    },

    getData: function getData() {
      var self = this;


      self.barMode = "indeterminate";
      if (_Food2.default.CancelRequests !== null) {
        _Food2.default.CancelRequests();
      }
      _Food2.default.withDate(moment(self.currentDate.actual).format('YYYY-MM-DD')).then(function (response) {
        self.totals = response.data.totals;
        self.foods = response.data.foods.meal_types;
        self.recipes = response.data.recipes;
        self.barMode = "determinate";
        self.isLoading = false;
        self.$forceUpdate();
        _Food2.default.CancelRequests = null;
      }).catch(function () {});
    },

    addDay: function addDay() {
      var self = this;
      self.currentDate.actual.add(1, 'day');
      self.$nextTick(function () {
        self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
        self.currentDate.presentational = self.currentDate.actual.format('dddd Do MMMM, YYYY');
      });
    },

    subtractDay: function subtractDay() {
      var self = this;
      self.currentDate.actual.subtract(1, 'day');
      self.$nextTick(function () {
        self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
        self.currentDate.presentational = self.currentDate.actual.format('dddd Do MMMM, YYYY');
      });
    },
    exportData: function exportData() {
      var self = this;
      var fileName = 'nutrition' + ("_" + self.exportDate.fromDate + "_" + self.exportDate.toDate + ".xlsx");
      var requestPath = "tracking/nutrition/export?fromDate=" + self.exportDate.fromDate + "&toDate=" + self.exportDate.toDate;
      var finalUrl = _config2.default.apiUrl + requestPath;
      var errorMessage = "Nothing to export";
      self.isExporting = true;
      _axios2.default.get(finalUrl, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.ms-excel'
        }
      }).then(function (response) {
        if (response.status === 200) {
          var timestamp = self.isExporting = false;
          self.$toastr.success(self.$t('message.justAMomentText'));
          (0, _downloadjs2.default)(response.data, fileName);
          self.$refs['exportDataDialog'].close();
        } else if (response.status === 204) {
          self.$toastr.error(errorMessage);
          self.$toastr.error(self.$t('message.errorExportEmpty'));
          self.isExporting = false;
        } else {
          self.$toastr.error(errorMessage);
          self.isExporting = false;
        }
      }).catch(function () {
        self.$toastr.error(errorMessage);
        self.isExporting = false;
      });
    },

    isToday: function isToday(date) {
      return moment(date).isSame(moment(), 'day');
    },
    openDialog: function openDialog(ref, options) {
      var self = this;

      if (ref === 'exportDataDialog') {
        self.$refs[ref].open();
      }

      if (ref === 'addFoodDialog') {
        if ($(window).width() <= 768) {
          self.$router.push({
            name: 'FoodDiaryLanding',
            query: {
              date: self.currentDate.actual.format('YYYY-MM-DD'),
              mealTypeId: options.mealTypeId
            },
            params: {
              title: options.panelTitle,
              mealTypeId: options.mealTypeId
            }
          });
        } else {
          self.activeMealType = options;
          self.$refs[ref].open();
        }
      }
      if (ref === 'editFoodDialog') {
        self.selectedFood = options;
        if ($(window).width() <= 768) {
          self.$router.push({
            name: 'FoodDiaryEdit',
            params: {
              title: options.panelTitle,
              mealTypeId: options.mealTypeId,
              foodObj: options
            }
          });
        } else {
          self.$refs[ref].open();
        }
      } else {
        self.$refs[ref].open();
      }
    },

    onFoodDialogClose: function onFoodDiaryClose() {
      var self = this;
      var timeout = setTimeout(function () {
        self.activeDialogMethod = null;
        clearTimeout(timeout);
      }.bind(self), 300);
    },

    onEditDialogClose: function onEditDialogClose() {
      var self = this;
      var timeout = setTimeout(function () {
        self.selectedFood = {};
        clearTimeout(timeout);
      }.bind(self), 300);
    },

    onFoodDialogOpen: function onFoodDialogOpen() {
      var self = this;
      var $panelheight = $('.food-dialog-container').find('#md-dialog');
      var windowWidth = $(window).width();
      var $scrollHeight = $($panelheight.prevObject[0].children[0]).outerHeight() - 54;
      $('.scrollable-area').attr('style', "height:" + $scrollHeight + 'px;');
    },
    updateTotals: function updateTotals(substitutableNutrients) {
      var self = this;

      if (self.foods.all.length === 0 && self.recipes.all.length === 0) {
        self.totals.all.calories = 0;
        self.totals.all.carbohydrate = 0;
        self.totals.all.cholesterol = 0;
        self.totals.all.fat = 0;
        self.totals.all.fibre = 0;
        self.totals.all.monounsaturated_fat = 0;
        self.totals.all.polyunsaturated_fat = 0;
        self.totals.all.potassium = 0;
        self.totals.all.protein = 0;
        self.totals.all.saturated_fat = 0;
        self.totals.all.sodium = 0;
        self.totals.all.sugar = 0;
      } else self.$nextTick(function () {
        self.totals.all.calories -= substitutableNutrients.calories;
        self.totals.all.carbohydrate -= substitutableNutrients.carbohydrate;
        self.totals.all.cholesterol -= substitutableNutrients.cholesterol;
        self.totals.all.fat -= substitutableNutrients.fat;
        self.totals.all.fibre -= substitutableNutrients.fibre;
        self.totals.all.monounsaturated_fat -= substitutableNutrients.monounsaturated_fat;
        self.totals.all.polyunsaturated_fat -= substitutableNutrients.polyunsaturated_fat;
        self.totals.all.potassium -= substitutableNutrients.potassium;
        self.totals.all.protein -= substitutableNutrients.protein;
        self.totals.all.saturated_fat -= substitutableNutrients.saturated_fat;
        self.totals.all.sodium -= substitutableNutrients.sodium;
        self.totals.all.sugar -= substitutableNutrients.sugar;
        self.$forceUpdate();
      });
    },
    onNutritionUnitUpdate: function onNutritionUnitUpdate(payload) {
      this.setNutritionUnit(payload);
      this.closeDialog('editNutritionUnitDialog');
    },

    closeDialog: function closeDialog(ref) {
      var self = this;
      $('.scrollable-area').attr('style', '');
      self.$refs[ref].close();
      setTimeout(function () {
        self.activeDialogMethod = null;
        self.foodResultMode = "";
      }.bind(self), 300);
    },
    goTo: function goTo(name) {
      this.$router.push({
        name: name
      });
    },
    setNutritionUnit: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(unit) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.nutritionUnit !== unit)) {
                  _context3.next = 11;
                  break;
                }

                this.nutritionUnit = unit;
                this.$forceUpdate();
                _context3.prev = 3;
                _context3.next = 6;
                return _Settings2.default.setFoodDiaryNutritionUnit({
                  unit: unit
                });

              case 6:
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](3);

                this.$toastr.error("Unable to save selection");

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 8]]);
      }));

      function setNutritionUnit(_x) {
        return _ref3.apply(this, arguments);
      }

      return setNutritionUnit;
    }(),
    calculateCalorieValue: function calculateCalorieValue(value, nutrient) {
      if (value < 0) {
        return 0;
      }
      switch (nutrient) {
        case 'fat':
          return value * 9;
        case 'carbohydrate':
        case 'protein':
          return value * 4;
      }
    },
    getNutrientDisplayValue: function getNutrientDisplayValue(value, nutrient, hasMeasurement) {
      if (this.nutritionUnit === 'kcal') {
        if (hasMeasurement) {
          return this.calculateCalorieValue(value, nutrient).toFixed(1).toString() + 'kcal';
        } else {
          return this.calculateCalorieValue(value, nutrient).toFixed(1).toString();
        }
      }

      if (hasMeasurement) {
        return value.toFixed(1) + 'g';
      } else {
        if (value === 0) {
          return value;
        } else {
          return value.toFixed(1);
        }
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(11)))

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerManager = __webpack_require__(37);

var _DatePickerManager2 = _interopRequireDefault(_DatePickerManager);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _stackedBar = __webpack_require__(1654);

var _stackedBar2 = _interopRequireDefault(_stackedBar);

var _TabSelector = __webpack_require__(1259);

var _TabSelector2 = _interopRequireDefault(_TabSelector);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var desiredDay = 0;
var CancelToken = _axios2.default.CancelToken;
var cancel = null;

exports.default = {
  watch: {
    "currentDate.ddmmyy": function currentDateDdmmyy() {
      var self = this;
      self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').format('Do MMMM YY');
      self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY');
      self.$forceUpdate();
      self.getData();
    },
    "activeTab": function activeTab() {
      var self = this;
      if (self.activeTab === 7) {
        self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('week').format('Do MMMM YY');
        self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('week');
      }
      if (self.activeTab === 30) {
        self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('month').format('Do MMMM YY');
        self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('month');
      }
      if (self.activeTab === 1) {
        self.currentDate.presentational = moment().startOf('day').format('Do MMMM YY');
        self.currentDate.actual = moment();
      }
      self.$forceUpdate();
      self.getData();
    }
  },
  data: function data() {
    return {
      activeTab: 30,
      dateFormat: _DatePickerManager2.default,
      toDate: "",
      currentDate: {
        ddmmyy: moment().startOf('month').format('DD-MM-YYYY HH:mm a'),
        actual: moment().startOf('month').utc(),
        presentational: moment().startOf('month').format('Do MMMM YY')
      },
      selectorOptions: [{
        title: 'Daily',
        value: 'DAILY',
        days: 1
      }, {
        title: 'Weekly',
        value: 'WEEKLY',
        days: 7
      }, {
        title: 'Monthly',
        value: 'MONTHLY',
        days: 30
      }],
      graphReady: false,
      hasData: true,
      graph: {
        labels: [],
        datasets: []
      }
    };
  },

  components: {
    Alert: _Alert2.default,
    TabSelector: _TabSelector2.default,
    foodDiaryStackedHistory: _stackedBar2.default
  },
  methods: {
    isToday: function isToday(date) {
      return moment(date).isSame(moment().utc().add(1, 'hour'), 'day');
    },
    addDate: function addDate() {
      var self = this;
      if (self.activeTab === 7) {
        self.currentDate.actual.add(1, 'weeks').startOf('week');
      }
      if (self.activeTab === 30) {
        self.currentDate.actual.add(1, 'months').startOf('month');
      }
      if (self.activeTab === 1) {
        self.currentDate.actual.add(1, 'day');
      }
      self.$nextTick(function () {
        self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
        self.currentDate.presentational = self.currentDate.actual.format('Do MMMM YY');
      });
    },
    subtractDate: function subtractDate() {
      var self = this;
      if (self.activeTab === 7) {
        self.currentDate.actual.subtract(1, 'weeks').startOf('week');
      }
      if (self.activeTab === 30) {
        self.currentDate.actual.subtract(1, 'months').startOf('month');
      }
      if (self.activeTab === 1) {
        self.currentDate.actual.subtract(1, 'day');
      }
      self.$nextTick(function () {
        self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
        self.currentDate.presentational = self.currentDate.actual.format('Do MMMM YY');
      });
    },
    getData: function getData() {
      var self = this;
      if (cancel !== null) {
        cancel();
        cancel = null;
      }

      self.graphReady = false;
      self.hasData = true;
      self.graph.labels = [];
      self.graph.datasets = [];

      var dateObject = moment(self.currentDate.actual);
      var toDate = void 0;
      var fromDate = void 0;
      if (self.activeTab === 7) {
        self.toDate = self.currentDate.actual.endOf('week').format('Do MMMM YY');
        fromDate = self.currentDate.actual.startOf('week').format('YYYY-MM-DD');
        toDate = self.currentDate.actual.endOf('week').format('YYYY-MM-DD');
      }
      if (self.activeTab === 30) {
        self.toDate = self.currentDate.actual.endOf('month').format('Do MMMM YY');
        fromDate = self.currentDate.actual.startOf('month').format('YYYY-MM-DD');
        toDate = self.currentDate.actual.endOf('month').format('YYYY-MM-DD');
      }
      if (self.activeTab === 1) {
        self.toDate = self.currentDate.actual.endOf('day').format('Do MMMM YY');
        fromDate = self.currentDate.actual.startOf('day').format('YYYY-MM-DD');
        toDate = self.currentDate.actual.endOf('day').format('YYYY-MM-DD');
      }

      _axios2.default.get(_config2.default.apiUrl + 'graph/nutrition/v2/', {
        params: {
          toDate: toDate,
          fromDate: fromDate,
          type: 'nutrients'
        },
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        })
      }).then(function (response) {
        self.graph.labels = response.data.labels;
        var datasetLength = response.data.series.length - 1;
        for (var i = 0; i < datasetLength; i++) {
          var key = response.data.series[i],
              color = void 0;
          if (key === 'Fat') {
            color = '#C44FD3';
          }
          if (key === 'Carbohydrate') {
            color = '#31DAD9';
          }
          if (key === 'Protein') {
            color = '#E66555';
          }
          self.graph.datasets.push({
            label: response.data.series[i],
            backgroundColor: color,
            data: response.data.data[i],
            percentages: response.data.percentages[i]
          });
        }
        self.graphReady = true;
      }).catch(function () {
        self.graphReady = false;
        self.hasData = false;
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.activeTab = 30;
    self.getData();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    title: {
      type: String,
      default: "Breakfast"
    },
    mealTypeId: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      recents: []
    };
  },

  mounted: function mounted() {
    var self = this;
    _Food2.default.getRecents(self.mealTypeId).then(function (response) {
      self.recents = response.data;
    });
  },
  methods: {
    copyYesterdaysMeal: function copyYesterdaysMeal() {
      var self = this;
      _Food2.default.copyYesterdaysMeal(self.mealTypeId).then(function (response) {
        self.$emit('closeDialogAndReload');
      }).catch(function () {
        var meal = void 0;
        switch (self.mealTypeId) {
          case 1:
            meal = self.$t('message.foodDiaryBreakfast');
            break;
          case 2:
            meal = self.$t('message.foodDiaryLunch');
            break;
          case 3:
            meal = self.$t('message.foodDiaryDinner');
          case 4:
            meal = self.$t('message.foodDiarySnack');
            break;
        }
      });
      self.$router.push({
        name: 'FoodDiary'
      });
    },

    goToMyMeals: function goToMyMeals() {
      var self = this;
      self.$router.push({
        name: "FoodDiaryMyMeals",
        query: {
          mealTypeId: self.mealTypeId,
          date: self.$route.query.date
        },
        params: {
          title: self.title
        }
      });
    },
    selectRecent: function selectRecent(recent) {
      var self = this;
      self.$router.push({
        name: 'FoodDiaryAdd',
        query: {
          foodId: recent.fs_food_id,
          mealTypeId: self.mealTypeId,
          date: self.$route.query.date
        },
        params: {
          title: self.title
        }
      });
    },
    goBack: function goBack() {
      var self = this;
      self.$router.push({ name: 'FoodDiary' });
    },
    goToSearch: function goToSearch() {
      var self = this;
      self.$router.push({
        name: 'FoodDiarySearch',
        params: {
          title: self.title,
          mealTypeId: self.mealTypeId
        },
        query: {
          date: self.$route.query.date,
          mealTypeId: self.$route.query.mealTypeId
        }
      });
    }
  }
};

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "my-meals",
  props: {
    title: {
      type: String,
      default: "Breakfast"
    },

    date: {
      type: Object
    }
  },
  data: function data() {
    return {
      meals: [],
      mealTypeId: 1
    };
  },
  mounted: function mounted() {
    var self = this;
    self.mealTypeId = self.$route.query.mealTypeId;
    _Food2.default.getFavorites().then(function (response) {
      self.meals = response.data;
    });
  },

  methods: {
    loadMeal: function loadMeal(meal) {
      var self = this;
      var date = moment(self.date);
      if (self.mealTypeId === 1) {
        date.set({
          'hour': 9,
          'minute': 0,
          'second': 0
        });
      }

      if (self.mealTypeId === 2) {
        date.set({
          'hour': 12,
          'minute': 0,
          'second': 0
        });
      }

      if (self.mealTypeId === 3) {
        date.set({
          'hour': 18,
          'minute': 0,
          'second': 0
        });
      }
      self.isLoading = true;

      _Food2.default.addFoods({
        date: date.format(),
        meal_type_id: self.mealTypeId,
        foods: meal.foods,
        recipes: meal.recipes
      }).then(function (response) {
        self.$toastr.success(self.$t('message.labelSuccess'));

        self.$router.replace({
          name: 'FoodDiary',
          query: {
            date: moment(self.date).format('YYYY-MM-DD')
          }
        });
      }).catch(function () {
        self.isLoading = false;
      });
    },
    deleteMeal: function deleteMeal(mealId) {
      var self = this;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Food2.default.deleteFavorite(mealId);
        }
      }).then(function () {
        var index = self.meals.findIndex(function (obj) {
          return obj.meal_id === mealId;
        });
        if (index !== -1) self.meals.splice(index, 1);
        self.$toastr.success(self.$t('message.foodDiaryMealPlateRemoved'));
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AutocompleteDialog = __webpack_require__(1241);

var _AutocompleteDialog2 = _interopRequireDefault(_AutocompleteDialog);

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _Rx = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    FdAutocompleteDialog: _AutocompleteDialog2.default
  },
  props: {
    title: {
      type: String,
      default: "Breakfast"
    },
    mealTypeId: {
      type: Number,
      default: 1
    },
    date: {
      type: Object
    }
  },
  data: function data() {
    return {
      recognition: null,
      isListening: false,
      isSearching: false,
      searchValue: "",
      suggestions: []
    };
  },

  watch: {
    'searchValue': function searchValue() {
      if (this.searchValue === "") {
        this.suggestions = [];
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    $('.mu-text-field-input').focus();
    self.searchValue = self.searchTerm;
    if (self.$route.query.q !== "") {
      self.searchValue = self.$route.query.q;
    }
    if (self.searchTerm !== "") {
      self.autoComplete();
    }
    self.initScrollFix();
    $(window).resize(function () {
      self.initScrollFix();
    });
    var autoCompleteElement = $('.mu-paper.search-area .mu-text-field-input');
    var observableConditionElement = _Rx.Observable.fromEvent(autoCompleteElement, 'keydown').map(function (x) {
      return x;
    });
    var delayedSearch = observableConditionElement.debounceTime(300).distinctUntilChanged();
    delayedSearch.subscribe(function (e) {
      if (e.key === "Enter") {
        self.handleSelection(self.searchValue);
      }
      if (self.searchValue !== "") {
        self.autoComplete();
      }
    });
  },

  methods: {
    initScrollFix: function initScrollFix() {
      var searchArea = $('.mu-content-block.food-search-dialog').outerHeight(true) + 8;
      var header = $('.mu-appbar').outerHeight(true);
      var mainContent = $(window).outerHeight(true);
      mainContent = mainContent - (header + searchArea);
      $('.oddEven').attr('style', 'height:' + mainContent + 'px;padding-top: 0px; padding-bottom: 0px;');
    },
    goBack: function goBack() {
      var self = this;
      self.$router.push({
        name: 'FoodDiaryLanding',
        query: {
          date: self.$route.query.date,
          mealTypeId: self.$route.query.mealTypeId
        },
        params: {
          title: self.title,
          mealTypeId: self.mealTypeId
        }
      });
    },
    handleSelection: function handleSelection(food) {
      var self = this;
      self.$router.push({
        name: 'FoodDiarySearchResults',
        query: {
          q: food,
          date: self.$route.query.date,
          mealTypeId: self.$route.query.mealTypeId
        },
        params: {
          title: self.title,
          mealTypeId: self.mealTypeId
        }
      });
    },
    highlight: function highlight(word) {
      var self = this;
      return word.replace(self.searchValue.toLowerCase(), '<span class=\'highlight\'>' + self.searchValue.toLowerCase() + '</span>');
    },
    autoComplete: function autoComplete() {
      var self = this;
      self.isSearching = true;
      self.suggestions = [];
      _Food2.default.autoComplete(self.searchValue).then(function (response) {
        self.suggestions = response.data;
        self.isSearching = false;
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var optionsDefault = {
  page_number: 0,
  max_results: 25,
  total_results: 0
};

exports.default = {
  props: {
    title: {
      type: String,
      default: "Breakfast"
    },
    mealTypeId: {
      type: Number,
      default: 1
    },
    date: {
      type: Object
    },
    searchValue: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      isAppending: false,
      isLoading: true,
      options: optionsDefault,
      results: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.mealTypeId = self.$route.query.mealTypeId;
    self.searchTerm = self.$route.query.q;
    self.getData();
    $(window).resize(function () {
      self.fixScrollHeight();
    });
    var scrollableElement = document.getElementById('resultScroller');
    scrollableElement.addEventListener('scroll', self.handleScroll);
  },

  methods: {
    selectFood: function selectFood(food) {
      var self = this;
      self.$router.push({
        name: 'FoodDiaryAdd',
        query: {
          foodId: food.food_id,
          mealTypeId: self.mealTypeId,
          date: self.$route.query.date
        },
        params: {
          title: self.title
        }
      });
    },
    fixScrollHeight: function fixScrollHeight() {
      var self = this;
      self.$nextTick(function () {
        var appBarHeight = $('.mu-appbar').outerHeight();
        var searchReminderHeight = $('.searchReminder').outerHeight();
        $('#resultScroller').attr('style', 'height:' + ($(window).innerHeight() - (appBarHeight + searchReminderHeight) - 8) + 'px;overflow-y:scroll');
      });
    },
    handleScroll: function handleScroll() {
      var self = this;
      if (!self.isAppending) {
        if (_ScrollManager2.default.isElementInViewport(document.getElementById('infinite-scroll-detector'))) {
          self.loadMoreData();
        }
      }
    },
    goBack: function goBack() {
      var self = this;
      self.$router.push({
        name: 'FoodDiarySearch',
        params: {
          title: self.title,
          mealTypeId: self.mealTypeId
        },
        query: {
          q: self.searchTerm,
          date: self.$route.query.date,
          mealTypeId: self.$route.query.mealTypeId
        }
      });
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.options.page_number + 1;
      self.isAppending = true;
      _Food2.default.searchFoods(self.searchTerm, page, self.options.max_results).then(function (response) {
        self.options = response.data.options;
        self.results.push.apply(self.results, response.data.foods);
        self.isAppending = false;
      }).catch(function (error) {
        self.isAppending = false;
      });
    },
    getData: function getData() {
      var self = this;

      self.results = [];
      _Food2.default.searchFoods(self.searchTerm, self.options.page_number, self.options.max_results).then(function (response) {
        self.results = response.data.foods;
        self.options = response.data.options;
        self.isLoading = false;
        self.fixScrollHeight();
      }).catch(function (error) {
        self.isLoading = false;
        self.results = [];
        self.options = optionsDefault;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(476);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      email: null,
      isSending: false
    };
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {

          self.isSending = true;

          _Login2.default.ResetPassword(self.email).then(function (response) {
            self.isSending = false;

            self.$alert({
              title: self.$t('message.forgotPasswordEmailSentMessageTitle'),
              text: self.$t('message.forgotPasswordEmailSendMessageSubTitle') + ' ' + self.email,
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            });
          }).catch(function (error) {
            self.isSending = false;
            self.$toastr.error(self.$t('message.forgotPasswordEmailNotFound'));
          });
        }
      });
    }
  }
};

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Utilities = __webpack_require__(274);

var _Relationships = __webpack_require__(1672);

var _Relationships2 = _interopRequireDefault(_Relationships);

var _DateMonths = __webpack_require__(232);

var _DateMonths2 = _interopRequireDefault(_DateMonths);

var _Genders = __webpack_require__(723);

var _Genders2 = _interopRequireDefault(_Genders);

var _RegisterReasons = __webpack_require__(728);

var _RegisterReasons2 = _interopRequireDefault(_RegisterReasons);

var _AnalyticsTrackingMixin = __webpack_require__(1667);

var _AnalyticsTrackingMixin2 = _interopRequireDefault(_AnalyticsTrackingMixin);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _jsSha = __webpack_require__(319);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _Payment = __webpack_require__(196);

var _Payment2 = _interopRequireDefault(_Payment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DobObject = _Utilities.Objects.DobObject;

exports.default = {
  mixins: [_Relationships2.default, _DateMonths2.default, _Genders2.default, _RegisterReasons2.default, _AnalyticsTrackingMixin2.default],
  name: 'about-yourself',
  data: function data() {
    return {
      title: this.$t('message.gettingStartedAboutTitle'),
      subTitle: this.$t('message.gettingStartedAboutSubTitle'),
      activeDiabetesType: {},
      isLoading: true,
      isSaving: false,
      isDiabetic: true,
      activeStep: 0,
      fullWidth: true,
      underlineShow: true,
      model: {
        diabetes_type_id: null
      },
      lists: {},
      dobItems: DobObject,
      dob: {
        day: null,
        month: null,
        year: null
      },
      paidAmount: 0
    };
  },

  watch: {
    'model.diabetes_type_id': function modelDiabetes_type_id(newValue, oldValue) {
      var self = this;
      var types = JSON.parse((0, _stringify2.default)(self.lists.diabetes_types));
      if (newValue != null) {
        self.activeDiabetesType = types.filter(function (type) {
          return type.diabetes_type_id === newValue;
        })[0];
        if (_lodash2.default.has(self.activeDiabetesType, 'is_diabetic')) {
          if (self.activeDiabetesType.is_diabetic === true) {
            self.isDiabetic = true;
          } else {
            self.isDiabetic = false;
          }
        }
      }
    },
    'dob.day': function dobDay() {
      var self = this;
      self.formatDateOfBirth();
    },
    'dob.month': function dobMonth() {
      var self = this;
      self.formatDateOfBirth();
    },
    'dob.year': function dobYear() {
      var self = this;
      self.formatDateOfBirth();
    }
  },
  computed: {
    isValidAge: function isValidAge() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year + '-' + this.dob.month + '-' + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(18, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    },
    isOlderThan100: function isOlderThan100() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year + '-' + this.dob.month + '-' + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(100, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/getting-started/about-you');
    self.lists = self.$store.state.list;
    _Account2.default.getAccount().then(function (response) {
      self.model = response.data;
      self.lists = self.$store.state.list;
      if (self.model.diabetes_type_id === 0) {
        self.model.diabetes_type_id = null;
      }
      if (self.model.gender_id === 0) {
        self.model.gender_id = null;
      }
      if (self.model.dob !== null) {
        var dob = self.model.dob.split('-');
        self.dob.year = dob[0];
        self.dob.month = dob[1];
        self.dob.day = dob[2];
        self.$forceUpdate();
      }
      if (self.model.on_behalf) {} else {
        self.model.on_behalf = false;
      }
      self.$nextTick(function () {
        self.errors.clear();
        setTimeout(function () {}.bind(self), 500);
        self.isLoading = false;
        self.trackPagePinterest();
        self.trackPageReddit();
      });
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      if (self.isOlderThan100 === true) {
        self.$toastr.error("You have to be under 100 to sign up");
        return;
      }

      self.$validator.validateAll().then(function (valid) {
        if (valid && self.isValidAge) {
          self.isSaving = true;
          _Account2.default.putAccount(self.model).then(function (response) {
            _User2.default.onBoardingStatus().then(function (response) {
              self.$store.commit('setOnBoardingStatus', response.data);
              var timeout = setTimeout(function () {
                self.$gtag.event('AboutPanelComplete', {
                  'event_category': 'Onboarding',
                  'event_label': 'Completed about you panel',
                  'value': 1
                });
                self.$router.push({
                  name: 'GettingStartedYourHealth'
                });
                clearTimeout(timeout);
              }, 300);
            });
          });
        } else if (!self.isValidAge) {
          self.$toastr.error("You have to be 18 or over to sign up");
        }
      }).catch(function (error) {});
    },
    formatDateOfBirth: function formatDateOfBirth() {
      var self = this;
      if (!_lodash2.default.isNull(self.dob.day) && !_lodash2.default.isNull(self.dob.month) && !_lodash2.default.isNull(self.dob.year)) {
        self.model.dob = self.dob.year + '-' + self.dob.month + '-' + self.dob.day;
      }
    },
    forceUpdate: function forceUpdate() {
      var self = this;
      self.$forceUpdate();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Goals = __webpack_require__(1671);

var _Goals2 = _interopRequireDefault(_Goals);

var _GoalReasons = __webpack_require__(1670);

var _GoalReasons2 = _interopRequireDefault(_GoalReasons);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'goals',
  mixins: [_ScrollerMixin2.default, _Goals2.default, _GoalReasons2.default],
  data: function data() {
    return {
      isVideoPlaying: false,
      activeDiabetesType: {},
      isSaving: false,
      isDiabetic: false,
      fullWidth: true,
      underlineShow: true,
      isLoading: true,
      activeStep: 3,
      title: this.$t('message.gettingStartedGoalsTitle'),
      subTitle: this.$t('message.gettingStartedGoalsSubTitle'),
      lists: {},
      checkedGoals: [],
      model: {},
      goalModel: {
        goals: [],
        goal_relation_id: null,
        goal_evaluation: 5,
        goal_text: ''
      }
    };
  },
  mounted: function mounted() {
    var self = this;

    self.$gtag.pageview('/getting-started/goals');

    $(self.$refs['goalVideo']).hover(function () {
      $(self.$refs['goalVideo']).prop('controls', true);
    });

    self.lists = JSON.parse((0, _stringify2.default)(self.$store.state.list));
    self.lists.diabetes_types = self.lists.diabetes_types.filter(function (type) {
      return type.is_diabetic === true;
    });

    _Account2.default.getAccount().then(function (response) {
      $.extend(self.model, response.data);
      self.model.diabetes_type_id = response.data.diabetes_type_id;
      self.model.diagnosis_year = '' + response.data.diagnosis_year + '';

      self.activeDiabetesType = self.lists.diabetes_types.filter(function (type) {
        return type.diabetes_type_id === response.data.diabetes_type_id;
      })[0];
      if (_.has(self.activeDiabetesType, 'is_diabetic')) {
        if (self.activeDiabetesType.is_diabetic === true) {
          self.isDiabetic = true;
        } else {
          self.isDiabetic = false;
        }
      }
      self.$forceUpdate();
      setTimeout(function () {
        self.isLoading = false;
      }.bind(self), 500);
    }).catch(function (error) {
      window.location.href = '../login';
    });
    self.$nextTick(function () {
      !function (w, d) {
        if (!w.rdt) {
          var p = w.rdt = function () {
            p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
          };
          p.callQueue = [];
          var t = d.createElement("script");
          t.src = "https://www.redditstatic.com/ads/pixel.js", t.async = !0;
          var s = d.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(t, s);
        }
      }(window, document);
      rdt('init', 't2_pd1aslc');
      rdt('track', 'SignUp');
    });
  },

  methods: {
    playPauseVideo: function playPauseVideo(ref) {
      var self = this;
      var video = self.$refs[ref];
      if (video.paused) {
        video.play();
        self.isVideoPlaying = true;
      } else {
        self.isVideoPlaying = false;
        video.pause();
      }
    },
    updateGoal: function updateGoal(item) {
      var self = this;
      item.checked = !item.checked;
      self.$nextTick(function () {
        self.updateGoals();
      });
    },
    updateGoals: function updateGoals() {
      var self = this;
      self.getCheckedGoals();
    },
    getCheckedGoals: function getCheckedGoals() {
      var self = this;
      self.checkedGoals = self.lists.goals.filter(function (goal) {
        return goal.checked === true;
      });
    },
    loadRelationPlural: function loadRelationPlural(id) {
      var self = this;
      return self.localizeGoalReason(self.lists.goal_relations.filter(function (goal_relation) {
        return goal_relation.goal_relation_id === id;
      })[0].plural);
    },
    forceUpdate: function forceUpdate() {
      var self = this;
      self.$forceUpdate();
    },
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          var data = [];
          self.isSaving = true;
          self.$nextTick(function () {
            for (var i = 0; i < self.checkedGoals.length; i++) {
              self.goalModel.goals.push(self.checkedGoals[i].goal_id);
            }
            data = self.lists.goals.filter(function (goal) {
              return goal.checked === true;
            });

            if (data.length === 0) {
              self.isSaving = false;
              alert(self.$t('message.gettingStartedGoalsEmptyError'));
            } else {
              _Account2.default.putUserGoals(self.goalModel).then(function (response) {
                _User2.default.onBoardingStatus().then(function (response) {
                  self.$gtag.event('GoalsPanelComplete', {
                    'event_category': 'Onboarding',
                    'event_label': 'Completed goals panel',
                    'value': 1
                  });
                  self.$store.commit('setOnBoardingStatus', response.data);
                  self.$router.push({
                    name: 'GettingStartedPersonalise'
                  });
                });
              });
            }
          });
        }
      }).catch(function (error) {
        self.isSaving = false;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9)))

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Countries = __webpack_require__(1669);

var _Countries2 = _interopRequireDefault(_Countries);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _Surgery = __webpack_require__(713);

var _Surgery2 = _interopRequireDefault(_Surgery);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _Rx = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataSourceConfig = {
  text: 'surgery_name',
  value: 'surgery_id'
};
exports.default = {
  name: 'location',
  mixins: [_ScrollerMixin2.default, _Countries2.default],
  data: function data() {
    return {
      title: this.$t('message.gettingStartedLocationTitle'),
      subTitle: this.$t('message.gettingStartedLocationSubTitle'),
      activeDiabetesType: {},
      activeSurgery: {},
      isLoading: true,
      isSaving: false,
      isDiabetic: true,
      activeStep: 1,
      fullWidth: true,
      underlineShow: true,
      unableToFindSurgery: false,
      model: {
        country_id: null,
        postcode: null,
        diabetes_type_id: null,
        surgery_id: null,
        surgery: {}
      },
      lists: {},
      surgerySearchValue: '',
      surgeries: [],
      dataSourceConfig: dataSourceConfig
    };
  },

  watch: {
    'model.country_id': function modelCountry_id() {
      var self = this;
      self.$nextTick(function () {
        self.$forceUpdate();
      });
    },
    'model.diabetes_type_id': function modelDiabetes_type_id(newValue, oldValue) {
      var self = this;
      if (newValue != null) {
        self.activeDiabetesType = self.lists.diabetes_types.filter(function (type) {
          return type.diabetes_type_id === newValue;
        })[0];
        if (_.has(self.activeDiabetesType, 'is_diabetic')) {
          if (self.activeDiabetesType.is_diabetic === true) {
            self.isDiabetic = true;
            self.activeStep = 2;
          } else {
            self.isDiabetic = false;
            self.activeStep = 1;
          }
        }
        self.$forceUpdate();
      }
    }
  },
  mounted: function mounted() {
    var self = this;

    self.$gtag.pageview('/getting-started/location');

    _Rx.Observable.fromEvent($('.surgerySearchTxt'), 'input').map(function (x) {
      return x.currentTarget.value;
    }).debounceTime(100).distinctUntilChanged().subscribe(function (eventText) {
      self.handleSurgerySearch(eventText);
    });
    var countryId = 235;
    if (_.has(self.$store.state.geoLocation, 'country_id')) {
      countryId = self.$store.state.geoLocation.country_id;
      if (countryId === 0) {
        self.model.country_id = 235;
      } else {
        self.model.country_id = countryId;
      }
    }
    self.lists = self.$store.state.list;

    _Account2.default.getAccount().then(function (response) {
      self.model.diabetes_type_id = response.data.diabetes_type_id;
      self.model.postcode = response.data.postcode_zip;
      if (self.model.diabetes_type_id === 0) {
        self.model.diabetes_type_id = null;
      }
      self.isLoading = false;
      self.$nextTick(function () {
        self.errors.clear();
      });
    }).catch(function (error) {
      window.location.href = '../login/';
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSaving = true;
          _Account2.default.putUserLocation(self.model).then(function (response) {
            _User2.default.onBoardingStatus().then(function (response) {
              self.$store.commit('setOnBoardingStatus', response.data);
              self.$router.push({
                name: 'GettingStartedGoals'
              });
            });
          }).catch(function (error) {
            self.isSaving = false;
          });
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    forceUpdate: function forceUpdate() {
      var self = this;
      self.$forceUpdate();
    },
    handleSurgerySelected: function handleSurgerySelected(value) {
      var self = this;
      var object = self.surgeries.filter(function (surgery) {
        return surgery.surgery_name === value;
      })[0];
      self.activeSurgery = object;
      self.model.surgery_id = object.surgery_id;
    },
    handleSurgerySearch: function handleSurgerySearch(filter) {
      var self = this;
      _Surgery2.default.searchSurgeriesByQuery(filter).then(function (response) {
        var surgeryLength = response.data.surgeries.length;
        for (var i = 0; i < surgeryLength; i++) {
          response.data.surgeries[i].surgery_name += ', ' + response.data.surgeries[i].address_line_2 + ', ' + response.data.surgeries[i].postcode;
        }
        self.surgeries = response.data.surgeries;
      });
    },
    clearSurgery: function clearSurgery() {
      var self = this;
      self.model.surgery_id = null;
      self.surgerySearchValue = '';
      self.activeSurgery = {};
      self.surgeries = [];
      $('#surgery .mu-auto-complete .mu-text-field-input').focus();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(11)))

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _Geo = __webpack_require__(710);

var _Geo2 = _interopRequireDefault(_Geo);

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _Tracking = __webpack_require__(715);

var _Tracking2 = _interopRequireDefault(_Tracking);

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _Allergies = __webpack_require__(720);

var _Allergies2 = _interopRequireDefault(_Allergies);

var _DietaryPreferences = __webpack_require__(721);

var _DietaryPreferences2 = _interopRequireDefault(_DietaryPreferences);

var _Occupations = __webpack_require__(727);

var _Occupations2 = _interopRequireDefault(_Occupations);

var _Ethnicity = __webpack_require__(722);

var _Ethnicity2 = _interopRequireDefault(_Ethnicity);

var _Languages = __webpack_require__(724);

var _Rx = __webpack_require__(91);

var _countryJs = __webpack_require__(789);

var _countryJs2 = _interopRequireDefault(_countryJs);

var _CurrencyInput = __webpack_require__(1272);

var _CurrencyInput2 = _interopRequireDefault(_CurrencyInput);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _jsSha = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default, _Allergies2.default, _Occupations2.default, _DietaryPreferences2.default, _Ethnicity2.default],
  components: {
    CurrencyInput: _CurrencyInput2.default
  },
  name: 'personalise',
  data: function data() {
    return {
      user_id: null,
      title: this.$t('message.gettingStartedPersonalizeTitle'),
      subTitle: this.$t('message.gettingStartedPersonalizeSubTitle'),
      allergySearch: '',
      favouriteSearch: '',
      activeDiabetesType: {},
      activeHba1cMonth: {},
      activeHba1cType: {},
      foodSearching: false,
      isLoading: true,
      isSaving: false,
      isDiabetic: true,
      activeStep: 4,
      fullWidth: true,
      underlineShow: true,
      model: {
        diabetes_type_id: null,
        weekly_shop_cost: 53.20,
        currency_code: '',
        dietry_preference_id: null,
        allergies: [],
        hba1c_month_id: 1
      },
      lists: {},
      currency: {},
      settings: {},
      settingsModel: {
        blood_glucose: null,
        hba1c: null,
        height: null
      },
      bloodGlucoseModel: {
        blood_glucose_mgdl: null,
        blood_glucose_mmoll: null
      },
      heightModel: {
        ft: null,
        in: null,
        cm: null
      },
      hba1cModel: {
        percent: null,
        mmol_mol: null,
        date: ''
      },
      weightModel: {
        kg: null,
        lbs: null,
        stones: null,
        pounds: null
      },
      allergyDataSource: [],
      favouriteDataSource: [],
      allergyModel: [],
      favouriteModel: [],
      foodDataSourceConfig: {
        text: 'food_name',
        value: 'food_id'
      },
      allergies: []
    };
  },

  watch: {
    'settingsModel.hba1c': function settingsModelHba1c() {
      var self = this;
      self.activeHba1cType = self.settings.hba1c.dropdown.filter(function (item) {
        return item.preference_id === self.settingsModel.hba1c;
      })[0];
      self.hba1cModel = {
        percent: null,
        mmol_mol: null,
        date: ''
      };
    },
    'settingsModel.weight': function settingsModelWeight() {
      var self = this;
      self.weightModel = {
        kg: null,
        lbs: null,
        stones: null,
        pounds: null
      };
    },
    'settingsModel.blood_glucose': function settingsModelBlood_glucose() {
      var self = this;
      self.bloodGlucoseModel = {
        blood_glucose_mgdl: null,
        blood_glucose_mmoll: null
      };
      self.$forceUpdate();
    },
    'settingsModel.height': function settingsModelHeight() {
      var self = this;
      self.heightModel = {
        ft: null,
        in: null,
        cm: null
      };
      self.$forceUpdate();
    },
    'heightModel.cm': function heightModelCm() {
      var self = this;
      if (self.heightModel.cm === '') {
        self.heightModel.cm = null;
      }
    },
    'heightModel.ft': function heightModelFt() {
      var self = this;
      if (self.heightModel.ft === '') {
        self.heightModel.ft = null;
      }
    },
    'heightModel.in': function heightModelIn() {
      var self = this;
      if (self.heightModel.in === '') {
        self.heightModel.in = null;
      }
    },
    'weightModel.kg': function weightModelKg() {
      var self = this;
      if (self.weightModel.kg === '') {
        self.weightModel.kg = null;
      }
    },
    'weightModel.lbs': function weightModelLbs() {
      var self = this;
      if (self.weightModel.lbs === '') {
        self.weightModel.lbs = null;
      }
    },
    'weightModel.stones': function weightModelStones() {
      var self = this;
      if (self.weightModel.stones === '') {
        self.weightModel.stones = null;
      }
    },
    'weightModel.pounds': function weightModelPounds() {
      var self = this;
      if (self.weightModel.pounds === '') {
        self.weightModel.pounds = null;
      }
    },
    'model.weekly_shop_cost': function modelWeekly_shop_cost() {
      var self = this;
      self.$forceUpdate();
    },
    '$route': function $route() {
      var self = this;
      self.initPersonalisation();
    }
  },

  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/getting-started/personalise');
    self.initPersonalisation();
  },
  updated: function updated() {
    var self = this;
  },


  methods: {
    getNativeName: function getNativeName(key) {
      return (0, _Languages.getLanguageNativeName)(key);
    },
    updateCommuicator: function updateCommuicator() {
      var self = this;
      _axios2.default.get(_config2.default.apiUrl + 'user/updateComm/' + self.user_id);
      _axios2.default.get(_config2.default.apiUrl + 'user/sendEmail');
    },
    initPersonalisation: function initPersonalisation() {
      var self = this;

      var favouriteAutoCompleteElement = $('#favouriteSearch .mu-auto-complete .mu-text-field-input');
      var observableFavourite = _Rx.Observable.fromEvent(favouriteAutoCompleteElement, 'keydown').map(function (x) {
        return x.currentTarget.value;
      });
      var debouncedFavourite = observableFavourite.debounceTime(250).distinctUntilChanged();
      debouncedFavourite.subscribe(function (eventText) {
        self.handleFoodSearch(self.favouriteSearch, 'favourite');
      }.bind(self));

      _User2.default.getFavouriteFoods().then(function (response) {
        self.favouriteModel = response.data;
      });

      self.lists = self.$store.state.list;
      _Account2.default.getAccount().then(function (response) {
        self.user_id = response.data.user_id;
        self.model.country_id = null;
        self.model.diabetes_type_id = response.data.diabetes_type_id;
        self.model.postcode = response.data.postcode_zip;
        self.model.language_id = 1;
        self.model.weekly_shop_cost = 52.20;
        if (self.model.diabetes_type_id === 0) {
          self.model.diabetes_type_id = null;
        }

        var diabetesType = self.$store.state.list.diabetes_types.filter(function (item) {
          return item.diabetes_type_id === response.data.diabetes_type_id;
        })[0];

        self.activeDiabetesType = diabetesType;
        if (_.has(self.activeDiabetesType, 'is_diabetic')) {
          if (self.activeDiabetesType.is_diabetic === true) {
            self.isDiabetic = true;
          } else {
            self.isDiabetic = false;
          }
        }

        _Account2.default.getUserPersonalization().then(function (response) {
          if (response.data !== false) {
            self.model = response.data;
            self.model.weekly_shop_cost = 52.50;
            if (self.model.dietry_preference_id === null) {
              self.model.dietry_preference_id = 1;
            }
            if (self.model.dietry_preference === undefined) {
              self.model.dietry_preference_id = 1;
            }
            if (self.model.language_id === undefined) {
              self.model.language_id = 1;
            }
            self.$forceUpdate();
          }
        });
        _Settings2.default.getSettings().then(function (response) {
          self.settings = response.data;
          _Geo2.default.geoIp().then(function (response) {
            if (_.has(response.data, 'host') && response.data.country_id !== 0) {
              var country = response.data.host.country,
                  country_id = response.data.country_id,
                  countriesFound = _countryJs2.default.search(country);
              self.determineSettingsFromCountryOrCurrentSettings(country_id);
              if (countriesFound.length >= 0) {
                self.currency = countriesFound[0];
                self.isLoading = false;
              }
            } else {
              var _country = 'UK',
                  _country_id = 235,
                  _countriesFound = _countryJs2.default.search(_country);
              self.determineSettingsFromCountryOrCurrentSettings(235);
              self.currency = _countriesFound[0];
              self.isLoading = false;
            }
          });
        });
        self.$nextTick(function () {
          self.errors.clear();
        });
      });
    },
    triggerGaEvent: function triggerGaEvent() {
      var self = this;
      self.$gtag.event('PersonalisePanelComplete', {
        'event_category': 'Onboarding',
        'event_label': 'Completed personalise panel',
        'value': 1
      });
      self.$gtag.event('OnboardingComplete', {
        'event_category': 'Registration',
        'event_label': 'Completed onboarding/personalization process',
        'value': 1
      });
    },
    handleFavouriteSelected: function handleFavouriteSelected(value) {
      var self = this;
      var checkExists = self.favouriteModel.filter(function (item) {
        return item.food_name === value;
      });
      if (checkExists.length === 0) {
        var object = self.favouriteDataSource.filter(function (item) {
          return item.food_name === value;
        })[0];
        self.favouriteModel.push(object);
        self.$nextTick(function () {
          self.favouriteSearch = '';
        });
      } else {
        self.$nextTick(function () {
          self.favouriteSearch = '';
        });
      }
    },
    handleFoodSearch: function handleFoodSearch(value, type) {
      var self = this;
      if (type === 'favourite') {

        self.foodSearching = true;
        _Food2.default.autoComplete(value).then(function (response) {

          var items = [];

          var itemLength = response.data.length;

          if (_.isArray(response.data)) {
            for (var i = 0; i < itemLength; i++) {
              var model = {
                food_id: 0,
                food_name: response.data[i]
              };
              items.push(model);
            }
            self.favouriteDataSource = items;
            self.foodSearching = false;
            self.$nextTick(function () {
              self.favouriteDataSource = items.sort(function (a, b) {
                return a.food_name.toLowerCase() > value.toLowerCase();
              });
            });
          }
        });
      }
    },
    weightQualifier: function weightQualifier() {
      var self = this;
      if (self.weightModel.kg !== null) {
        return true;
      }
      if (self.weightModel.lbs !== null) {
        return true;
      }
      if (self.weightModel.stones !== null && self.weightModel.pounds !== null) {
        return true;
      }
      return false;
    },
    heightQualifier: function heightQualifier() {
      var self = this;
      if (self.heightModel.cm !== null || self.heightModel.ft !== null && self.heightModel.in) {
        return true;
      }
      return false;
    },
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          var fbCompleteRegModel = {
            "data": [{
              "event_name": "CompleteRegistration",
              "event_time": moment().unix(),
              "action_source": "email",
              "user_data": {
                "em": (0, _jsSha.sha256)(self.$store.state.user.scope.email),
                "client_ip_address": self.$store.state.geoLocation.host.ip,
                "client_user_agent": navigator.userAgent
              }
            }]
          };
          _axios2.default.post('https://graph.facebook.com/v11.0/625160948457652/events?access_token=EAALxgEaGHOQBAPhSgGaAn8wfcfGUmKNrCk6cpoQO7NX85wxgmaD56HgMmGQLUEKMPsyCAFgMuh33vl8r1go8uO1xHgCoM3y9Ggkm2JejlIX6jeoCEW3GnA9V9N6FMInLHjSh9lzKmaEAIacBfG0o4NUqUcdolpi4frbZCh8VQU1qPtpK30wSj3VbxTKQZD', fbCompleteRegModel).then(function (res) {}).catch(function (res) {});

          self.isSaving = true;
          self.model.currency_code = self.currency.currency.currencyCode;
          self.$forceUpdate();
          _User2.default.putFavouriteFoods(self.favouriteModel).then(function (response) {
            if (self.heightQualifier()) {
              _Settings2.default.updateHeightSettings(self.heightModel).then(function (response) {
                self.doPost();
              });
            } else {
              self.doPost();
            }
          }).catch(function (error) {
            if (self.heightQualifier()) {
              _Settings2.default.updateHeightSettings(self.heightModel).then(function (response) {
                self.doPost();
              });
            } else {
              self.doPost();
            }
          });
        }
      });
    },
    doPost: function doPost() {
      var self = this;
      if (self.isDiabetic === true) {
        if (self.model.hba1c_month_id !== null) {
          self.activeHba1cMonth = self.lists.hba1c_months.filter(function (item) {
            return item.id === self.model.hba1c_month_id;
          })[0];
          if (_.has(self.activeHba1cMonth, 'days')) {
            var days = self.activeHba1cMonth.days;
            var date = moment();
            date.subtract(days, 'day');
            self.hba1cModel.date = date.format('YYYY-MM-DD HH:MM');
          }
        }
      }
      _Account2.default.putUserPersonalization(self.model).then(function (response) {

        self.triggerGaEvent();

        _User2.default.onBoardingStatus().then(function (response) {
          self.$store.commit('setOnBoardingStatus', response.data);
          _Settings2.default.putSettings(self.settingsModel).then(function (response) {
            _UserManager2.default.getUserAndStore(self);
            self.$forceUpdate();
            _Tracking2.default.postHba1cReading(self.hba1cModel).then(function (response) {
              if (self.weightQualifier()) {
                _Tracking2.default.postWeightReading(self.weightModel).then(function (response) {
                  self.updateCommuicator();
                  self.$router.push({
                    name: 'Dashboard'
                  });
                }).catch(function (error) {
                  self.updateCommuicator();
                  self.$router.push({
                    name: 'Dashboard'
                  });
                });
              } else {
                self.updateCommuicator();
                self.$router.push({
                  name: 'Dashboard'
                });
              }
            }).catch(function (error) {
              self.updateCommuicator();
              self.$router.push({
                name: 'Dashboard'
              });
            });
          });
        });
      });
    },
    determineSettingsFromCountryOrCurrentSettings: function determineSettingsFromCountryOrCurrentSettings(country_id) {
      var self = this;
      _Settings2.default.getUnitSettings().then(function (response) {
        if (response.data.blood_glucose !== null) {
          self.settingsModel = response.data;
        } else {
          switch (country_id) {
            case 237:
              self.settingsModel = {
                blood_glucose: 1,
                hba1c: 1,
                weight: 3,
                waist: 1,
                height: 2
              };
              break;
            case 126:
              self.settingsModel = {
                blood_glucose: 1,
                hba1c: 1,
                weight: 3,
                waist: 1,
                height: 2
              };
              break;
            case 153:
              self.settingsModel = {
                blood_glucose: 1,
                hba1c: 1,
                weight: 3,
                waist: 1,
                height: 2
              };
              break;
            default:
              self.settingsModel = {
                blood_glucose: 2,
                hba1c: 2,
                weight: 1,
                height: 2,
                waist: 2
              };
          }
        }
      }).catch(function (error) {
        switch (country_id) {
          case 237:
            self.settingsModel = {
              blood_glucose: 1,
              hba1c: 1,
              weight: 3,
              waist: 1,
              height: 2
            };
            break;
          case 126:
            self.settingsModel = {
              blood_glucose: 1,
              hba1c: 1,
              weight: 3,
              waist: 1,
              height: 2
            };
            break;
          case 153:
            self.settingsModel = {
              blood_glucose: 1,
              hba1c: 1,
              weight: 3,
              waist: 1,
              height: 2
            };
            break;
          default:
            self.settingsModel = {
              blood_glucose: 2,
              hba1c: 2,
              weight: 1,
              height: 2,
              waist: 2
            };
        }
      });
    },
    forceUpdate: function forceUpdate() {
      var self = this;
      self.$forceUpdate();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _MedicationRegimes = __webpack_require__(199);

var _MedicationRegimes2 = _interopRequireDefault(_MedicationRegimes);

var _MedicationFrequencies = __webpack_require__(726);

var _MedicationFrequencies2 = _interopRequireDefault(_MedicationFrequencies);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _index = __webpack_require__(112);

var _index2 = _interopRequireDefault(_index);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _Rx = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'health',
  mixins: [_ScrollerMixin2.default, _MedicationRegimes2.default, _MedicationFrequencies2.default],
  data: function data() {
    return {
      scroller: document.body,
      moment: moment,
      activeStep: 1,
      isDiabetic: false,
      title: this.$t('message.gettingStartedHealthTitle'),
      subTitle: this.$t('message.gettingStartedHealthSubTitle'),
      isSaving: false,
      isLoading: true,
      activeDiabetesType: {},
      conditionSearchValue: '',
      conditionSearching: false,
      conditionHelpText: this.$t('message.gettingStartedHealthTypeCondition'),
      medicationSearchValue: '',
      medicationSearching: false,
      medicationHelpText: 'Type a medication to add it',
      fullWidth: true,
      underlineShow: true,
      lists: {},
      model: {
        user_conditions: [],
        user_medications: [],
        smokes_cigarettes: false,
        has_other_conditions: false,
        takes_medication: false,
        diabetes_type_id: null
      },
      conditionDataSource: [],
      conditionDataSourceConfig: {
        text: 'condition_label',
        value: 'condition_id'
      },
      medicationDataSource: [],
      medicationDataSourceConfig: {
        text: 'treatment_name',
        value: 'treatment_id'
      },
      medicationUnitRegimes: [],
      medicationFrequencyRegimes: []
    };
  },

  watch: {
    'model.has_other_conditions': function modelHas_other_conditions() {
      var self = this;
      self.$forceUpdate();
    },
    'model.diabetes_type_id': function modelDiabetes_type_id(newValue, oldValue) {
      var self = this;
      self.lists = JSON.parse((0, _stringify2.default)(self.$store.state.list));
      if (newValue != null) {
        self.activeDiabetesType = self.lists.diabetes_types.filter(function (type) {
          return type.diabetes_type_id == newValue;
        })[0];
        if (_.has(self.activeDiabetesType, 'is_diabetic')) {
          if (self.activeDiabetesType.is_diabetic == true) {
            self.isDiabetic = true;
          } else {
            self.isDiabetic = false;
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/getting-started/your-health');

    var medicationInputElement = $('.mediSearchInput');
    var conditionInputElement = $('.conSearchInput');

    _Rx.Observable.fromEvent(medicationInputElement, 'input').map(function (x) {
      return x.currentTarget.value;
    }).debounceTime(250).subscribe(function (eventText) {
      self.handleMedicationSearch(eventText);
    });

    _Rx.Observable.fromEvent(conditionInputElement, 'input').map(function (x) {
      return x.currentTarget.value;
    }).debounceTime(250).subscribe(function (eventText) {
      self.handleConditionSearch(eventText);
    });

    _Account2.default.getUserConditions().then(function (response) {
      if (response.data.length > 0) {
        self.model.has_other_conditions = true;
        self.model.user_conditions = response.data;
        self.$forceUpdate();
      } else {
        self.model.has_other_conditions = false;
        self.model.user_conditions = [];
        self.$forceUpdate();
      }
    });

    _Account2.default.getAccount().then(function (response) {
      self.lists = self.$store.state.list;
      $.extend(self.model, response.data);
      self.model.diabetes_type_id = response.data.diabetes_type_id;
      self.model.diagnosis_year = '' + response.data.diagnosis_year + '';
      if (self.model.diagnosis_year == '0') {
        self.model.diagnosis_year = null;
      }
      setTimeout(function () {
        self.isLoading = false;
      }.bind(self), 500);

      _index2.default.regimeUnitsGet().then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          var unit = {
            'unit_id': response.data[i].ID,
            'unit_label': response.data[i].regimeUnitLabel
          };
          self.medicationUnitRegimes.push(unit);
        }
      });

      _index2.default.regimeFrequencysGet().then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          var frequency = {
            'frequency_id': response.data[i].ID,
            'frequency_label': response.data[i].frequency
          };
          self.medicationFrequencyRegimes.push(frequency);
        }
      });
    }).catch(function (error) {
      self.$router.push({
        name: 'Login'
      });
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          if (self.model.user_conditions.length > 0) {
            _Account2.default.putUserConditions(self.model.user_conditions).then(function (response) {
              if (self.model.user_medications.length > 0) {
                _index2.default.postUserMedications(self.model.user_medications).then(function (response) {
                  _Account2.default.putAccount(self.model).then(function (response) {
                    self.$gtag.event('HealthPanelComplete', {
                      'event_category': 'Onboarding',
                      'event_label': 'Completed health panel',
                      'value': 1
                    });
                    self.$router.push({
                      name: 'GettingStartedLocation'
                    });
                  });
                });
              } else {
                _Account2.default.putAccount(self.model).then(function (response) {
                  self.isSaving = false;
                  self.$gtag.event('HealthPanelComplete', {
                    'event_category': 'Onboarding',
                    'event_label': 'Completed health panel',
                    'value': 1
                  });
                  self.$router.push({
                    name: 'GettingStartedLocation'
                  });
                });
              }
            });
          }

          if (self.model.user_medications.length > 0) {
            _index2.default.postUserMedications(self.model.user_medications).then(function (response) {
              _Account2.default.putAccount(self.model).then(function (response) {
                self.$gtag.event('HealthPanelComplete', {
                  'event_category': 'Onboarding',
                  'event_label': 'Completed health panel',
                  'value': 1
                });
                self.$router.push({
                  name: 'GettingStartedLocation'
                });
              });
            });
          } else {
            _Account2.default.putAccount(self.model).then(function (response) {
              self.isSaving = false;
              self.$gtag.event('HealthPanelComplete', {
                'event_category': 'Onboarding',
                'event_label': 'Completed health panel',
                'value': 1
              });
              self.$router.push({
                name: 'GettingStartedLocation'
              });
            });
          }
        }
      });
    },
    forceUpdate: function forceUpdate() {
      var self = this;
      self.$forceUpdate();
    },
    yearList: function yearList() {
      var years = 110,
          yearStartAt = new Date().getFullYear(),
          yearsArray = [];
      for (var i = 0; i < years; i++) {
        yearsArray.push('' + yearStartAt-- + '');
      }
      return yearsArray;
    },
    handleConditionSearch: function handleConditionSearch(value) {
      var self = this;
      self.conditionSearching = true;
      _index2.default.conditionsGet(value, 10).then(function (response) {
        self.conditionDataSource = [];
        for (var i = 0; i < response.data.length; i++) {
          var condition = {
            'condition_id': response.data[i].ID,
            'condition_label': response.data[i].title,
            'rightIcon': 'add'
          };
          self.conditionDataSource.push(condition);
        }
        self.conditionSearching = false;
      }).catch(function (error) {
        self.conditionDataSource = [];
        self.conditionSearching = false;
      });
    },
    handleConditionSelected: function handleConditionSelected(value) {
      var self = this;
      var object = _.filter(self.conditionDataSource, function (o) {
        return o.condition_label === value;
      });
      var checkExists = _.filter(self.model.user_conditions, function (o) {
        return o.condition_label === value;
      });
      if (checkExists.length === 0) {
        self.model.user_conditions.unshift(object[0]);
        self.$nextTick(function () {
          self.conditionSearchValue = '';
          self.conditionDataSource = [];
          self.forceUpdate();
        });
      } else {
        self.$nextTick(function () {
          self.conditionSearchValue = '';
          self.conditionDataSource = [];
          self.forceUpdate();
        });
      }
    },
    handleConditionRemoval: function handleConditionRemoval(condition) {
      var self = this;
      var index = self.model.user_conditions.indexOf(condition);
      self.model.user_conditions.splice(index, 1);
    },
    handleMedicationSearch: function handleMedicationSearch(value) {
      var self = this;
      self.medicationSearching = true;
      _index2.default.getTreatments(value).then(function (response) {
        self.medicationDataSource = [];
        for (var i = 0; i < response.data.length; i++) {
          var medication = {
            'treatment_id': response.data[i].ID,
            'treatment_name': response.data[i].title,
            'rightIcon': 'add'
          };
          self.medicationDataSource.push(medication);
        }
        self.medicationSearching = false;
      });
    },
    handleMedicationSelected: function handleMedicationSelected(value) {
      var self = this;

      var object = self.medicationDataSource.filter(function (medication) {
        return medication.treatment_name == value;
      });

      var checkExists = self.model.user_medications.filter(function (medication) {
        return medication.treatment_name == value;
      });

      if (checkExists.length == 0) {
        self.model.user_medications.unshift(object[0]);
        self.$nextTick(function () {
          self.medicationHelpText = 'Add another medication';
          self.medicationSearchValue = '';
          self.medicationDataSource = [];
          self.forceUpdate();
        });
      } else {
        self.$nextTick(function () {
          self.medicationHelpText = 'You have already added that medication';
          self.medicationSearchValue = '';
          self.medicationDataSource = [];
          self.forceUpdate();
        });
      }
    },
    handleToggle: function handleToggle(key) {
      var self = this;
      self.model[key] = !self.model[key];
      self.$forceUpdate();
    },
    reformatMedications: function reformatMedications() {
      var self = this;
      self.$forceUpdate();
      self.$nextTick(function () {
        var length = self.model.user_medications.length;
        for (var i = 0; i < length; i++) {
          var item = self.model.user_medications[i];
          if (_.has(item, 'frequency_id') && _.has(item, 'unit_id')) {
            item.frequency_label = self.getFrequencyLabelById(item.frequency_id);
            item.unit_label = self.getUnitLabelById(item.unit_id);
            self.$forceUpdate();
          }
        }
      });
    },
    getUnitLabelById: function getUnitLabelById(unit_id) {
      var self = this;
      return self.medicationUnitRegimes.filter(function (unit) {
        return unit.unit_id === unit_id;
      })[0].unit_label;
    },
    getFrequencyLabelById: function getFrequencyLabelById(frequency_id) {
      var self = this;
      return self.medicationFrequencyRegimes.filter(function (frequency) {
        return frequency.frequency_id === frequency_id;
      })[0].frequency_label;
    },
    handleMedicationDeleted: function handleMedicationDeleted(item) {
      var self = this;
      var index = self.model.user_medications.indexOf(item);
      self.model.user_medications.splice(index, 1);
      self.$forceUpdate();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9), __webpack_require__(11)))

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2591);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    "$route": function $route() {
      var self = this;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      initialLoad: true,
      article: {},
      activeReference: null,
      toggle: {
        references: false
      },
      similar: {
        articles: {},
        per_page: 3,
        isLoading: true
      }
    };
  },

  methods: {
    toggleReferences: function toggleReferences() {
      var self = this;
      self.toggle.references = !self.toggle.references;
      self.activeReference = null;
    },
    fetchArticle: function fetchArticle() {
      var self = this;
      self.initialLoad = true;
      self.similar.isLoading = true;
      _Hcp2.default.getModule(self.$route.params.slug).then(function (response) {
        self.article = response.data;
        self.initialLoad = false;
        _TitleManager2.default.setTitle(self.substr(self.article.post_title, 0, 40));
        self.handleReferences();
        self.fetchSimilarArticles();
      }).catch(function (error) {
        if (error.response.status === 404) {
          self.$router.push({
            name: '404'
          });
        }
      });
    },
    fetchSimilarArticles: function fetchSimilarArticles() {
      var self = this,
          post_id = self.article.post_id;
      _Hcp2.default.getSimilarModules(post_id, self.similar.per_page).then(function (response) {
        self.similar.isLoading = false;
        self.similar.articles = response.data;
      });
    },
    handleReferences: function handleReferences() {
      var self = this;
      $('body').on('click', '.desc sup', function () {
        self.toggle.references = true;
        var text = $(this).text(),
            reference = parseInt(text.replace(/[\[\]']+/g, ''));
        self.activeReference = reference;
        setTimeout(function () {
          $('.main-content').scrollTop($("#reference-" + self.activeReference).offset().top);
        });
      });
    },
    substr: function substr(content, start, end) {
      return content.substr(start, end) + '...';
    },
    goToArticle: function goToArticle(slug) {
      var self = this;
      self.$route.push({
        name: 'HcpArticle',
        params: {
          slug: slug
        }
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.fetchArticle();
    }
  },
  computed: {
    hasReferences: function hasReferences() {
      var self = this;
      return self.article.post_references.length !== 0;
    },
    hasFurtherReading: function hasFurtherReading() {
      var self = this;
      return self.article.post_further_reading.length !== 0;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2592);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      categories: []
    };
  },

  methods: {
    getCats: function getCats() {
      var self = this;
      _Hcp2.default.getCategories('large').then(function (response) {
        self.categories = response.data;
        self.isLoading = false;
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.getCats();
    },
    goTo: function goTo(slug) {
      var self = this;
      self.$router.push({
        name: 'HcpCategory',
        params: {
          slug: slug
        }
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  },

  computed: {
    chunkedItems: function chunkedItems() {
      var self = this;
      return _.chunk(_.toArray(self.categories), 2);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    "$route": function $route() {
      var self = this;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      isLoading: true,
      cat: {},
      posts: []
    };
  },

  methods: {
    initMounted: function initMounted() {
      var self = this;
      self.isLoading = true;
      self.posts = [];
      self.setTitle(self.$t('message.loadingText'));
      self.getModules();
    },
    initScroll: function initScroll() {
      var self = this,
          el = self.$route.meta.id;
      $(function () {
        $('#' + el).on('scroll', function () {
          if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
            if (!self.isFinished) {
              self.getModules();
              self.isAppending = true;
            }
          }
        });
      });
    },
    getModules: function getModules() {
      var self = this;
      _Hcp2.default.getModulesByCat(self.$route.params.slug, 'large').then(function (response) {
        self.setTitle(response.data.category.name);
        self.cat = response.data.category;
        self.posts = response.data.posts;
        self.isLoading = false;
      });
    },
    setTitle: function setTitle(title) {
      _TitleManager2.default.setTitle(title);
    },
    goTo: function goTo(slug) {
      var self = this;
      self.$router.push({
        name: 'HcpArticle',
        params: {
          slug: slug
        }
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

var _Surgery = __webpack_require__(713);

var _Surgery2 = _interopRequireDefault(_Surgery);

var _Rx = __webpack_require__(91);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataSourceConfig = {
  text: 'surgery_name',
  value: 'surgery_id'
};

var terms = '<a href="' + _config2.default.siteUrl + 'terms">here</a>';

exports.default = {
  data: function data() {
    return {
      siteUrl: _config2.default.siteUrl,
      isFinished: false,
      status: {},
      isSaving: false,
      scroller: document.body,
      listManualSurgery: false,
      surgerySearchValue: '',
      dataSourceConfig: dataSourceConfig,
      activeStep: 0,
      steps: [{
        label: 'Surgery',
        title: 'Low Carb Program for Healthcare Professionals',
        subTitle: 'Please confirm your credentials to gain access to the Healthcare Professional Platform.',
        key: 'step1'
      }, {
        label: 'Verify',
        title: 'Identity Verification',
        subTitle: 'Verification is how we ensure a safe and robust environment for healthcare professionals. Please upload up to two valid forms of documentation to confirm your identity and credentials.',
        key: 'step2'
      }],
      list: {
        state: [],
        goals: [],
        jobs: [],
        surgeries: []
      },
      model: {
        step1: {
          work_email: '',
          job_id: 1,
          goals: [],
          surgery: {
            surgery_name: '',
            address_line_1: '',
            address_line_2: '',
            postcode: '',
            city: '',
            county: ''
          },
          country_id: 235
        },
        step2: {
          files: [],
          agree: false
        }
      }
    };
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var self = this;
      self.clearFiles();
      var files = e.target.files || e.dataTransfer.files;
      if (files.length > 3) {
        self.$toastr.error('Maximum 3 files allowed');
        self.clearFiles();
      } else {
        for (var i = files.length - 1; i >= 0; i--) {
          self.model.step2.files.push(files[i]);
        }
      }
    },
    removeFile: function removeFile(file) {
      var self = this;
      self.model.step2.files.splice(self.model.step2.files.indexOf(file), 1);
    },
    clearFiles: function clearFiles() {
      var self = this;
      self.model.step2.files = [];
    },
    onListManualSurgery: function onListManualSurgery() {
      var self = this;
      self.model.step1.surgery = {};
      self.surgerySearchValue = "";
    },
    nextStep: function nextStep() {
      var self = this;
      self.saveStep();
    },
    saveStep: function saveStep() {
      var self = this,
          step = self.steps[self.activeStep],
          errorMessage = 'Sorry, you do not have access to the HCP';
      if (step.key === 'step1') {
        self.isSaving = true;
        _Hcp2.default.registerHcp('surgery', self.model.step1).then(function (response) {
          if (!response.data.error) {
            self.isSaving = false;
            self.$toastr.success(response.data.message);
            self.activeStep += 1;
          }
        }).catch(function (error) {
          if (error.response.data) {
            self.isSaving = false;
            if (Array.isArray(error.response.data.message)) {
              for (var i = 0; i < error.response.data.message.length; i++) {
                self.$toastr.error(error.response.data.message[i]);
              }
            } else {
              self.$toastr.error(error.response.data.message || errorMessage);
            }
          }
        });
      }
      if (step.key === 'step2') {
        if (self.model.step2.agree) {
          if (self.hasSelectedFiles) {
            self.isSaving = true;
            var fd = new FormData();
            var filesLength = self.model.step2.files.length;
            for (var i = 0; i < filesLength; i++) {
              var file = self.model.step2.files[i];
              fd.append("files[]", file);
            }
            if (filesLength < 2) {
              self.$toastr.error("Please upload at least two documents");
              self.isSaving = false;
            } else {
              _Hcp2.default.uploadVerificationFiles(fd).then(function (response) {
                self.isSaving = false;
                $.each(response.data.message, function (i, value) {
                  if (value.error) {
                    self.$toastr.error(value.message);
                  } else {
                    self.$toastr.success(value.message);
                  }
                  self.fetchHcpStatus();
                });
              });
            }
          } else {
            self.$toastr.error("Please upload verification files to proceed");
          }
        } else {
          self.$toastr.error("Please confirm you are the person represented in the submitted documents");
        }
      }
    },
    listHcpGoals: function listHcpGoals() {
      var self = this;
      if (self.$store.state.hcp.goals.length > 0) {
        self.list.goals = self.$store.state.hcp.goals;
      } else {
        _Hcp2.default.listHcp('goals').then(function (response) {
          self.list.goals = response.data;
          self.$store.commit('setHcpGoals', response.data);
        });
      }
    },
    listHcpJobs: function listHcpJobs() {
      var self = this;
      if (self.$store.state.hcp.jobs.length > 0) {
        self.list.jobs = self.$store.state.hcp.jobs;
      } else {
        _Hcp2.default.listHcp('jobs').then(function (response) {
          self.list.jobs = response.data;
          self.$store.commit('setHcpJobs', response.data);
        });
      }
    },
    handleSurgerySelected: function handleSurgerySelected(value) {
      var self = this;
      var object = self.list.surgeries.filter(function (surgery) {
        return surgery.surgery_name === value;
      })[0];
      self.model.step1.surgery = object;
    },
    handleSurgerySearch: function handleSurgerySearch(filter) {
      var self = this;
      _Surgery2.default.searchSurgeriesByQuery(filter).then(function (response) {
        var surgeryLength = response.data.surgeries.length;
        for (var i = 0; i < surgeryLength; i++) {
          response.data.surgeries[i].surgery_name += ', ' + response.data.surgeries[i].address_line_2 + ', ' + response.data.surgeries[i].postcode;
        }
        self.list.surgeries = response.data.surgeries;
      });
    },
    convertSize: function convertSize(size) {
      var _size = size,
          fSExt = ['Bytes', 'KB', 'MB', 'GB'],
          i = 0;while (_size > 900) {
        _size /= 1024;i++;
      }
      return Math.round(_size * 100) / 100 + ' ' + fSExt[i];
    },
    goTo: function goTo(name) {
      var self = this;
      self.$router.push({
        name: name
      });
    },
    fetchHcpStatus: function fetchHcpStatus() {
      var self = this;
      self.status = {};
      _Hcp2.default.getHcpUser().then(function (response) {
        self.status = response.data.steps;
        if (response.data.scope.verified) {
          self.$router.push({
            name: 'Dashboard'
          });
        } else {
          if (self.status.complete) {
            self.isFinished = true;
          } else {
            if (self.status.surgery) {
              self.activeStep = 1;
            } else if (self.status.verify) {
              self.activeStep = 0;
            }
          }
        }
      }).catch(function (error) {
        if (error.response.data.status === 403) {
          self.$router.push({
            name: 'Dashboard'
          });
        }
      });
    },
    initMounted: function initMounted() {
      var self = this;
      _Rx.Observable.fromEvent($('.surgerySearchTxt'), 'input').map(function (x) {
        return x.currentTarget.value;
      }).debounceTime(100).distinctUntilChanged().subscribe(function (eventText) {
        self.handleSurgerySearch(eventText);
      });
      self.list.state = self.$store.state.list;
      self.$nextTick(function () {
        if (self.$store.state.user.isHcp === false) {
          self.$router.push({
            name: 'Dashboard'
          });
        }
      }, 1000);
      self.fetchHcpStatus();
      self.listHcpGoals();
      self.listHcpJobs();
    }
  },
  computed: {
    hasSelectedFiles: function hasSelectedFiles() {
      var self = this;
      return self.model.step2.files.length > 0;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hcp = __webpack_require__(96);

var _Hcp2 = _interopRequireDefault(_Hcp);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    "filterType": function filterType() {
      var self = this;
      var type = self.filterType;
      self.$router.replace({
        query: {
          type: type
        }
      });
      self.doSearch();
    }
  },
  data: function data() {
    return {
      filterType: 'education',
      isLoading: true,
      results: []
    };
  },

  methods: {
    doSearch: function doSearch() {
      var self = this;
      self.results = [];
      _Hcp2.default.searchHcp(self.$route.params.search, self.filterType).then(function (response) {
        _TitleManager2.default.setTitle(self.$route.params.search);
        self.results = response.data;
        self.isLoading = false;
      });
    },
    highlightKeyword: function highlightKeyword(input, wordsToBold) {
      return input.replace(new RegExp('(\\b)(' + wordsToBold.join('|') + ')(\\b)', 'ig'), '$1<b>$2</b>$3');
    },
    initMounted: function initMounted() {
      var self = this;
      self.isLoading = true;
      self.results = [{}];
      _TitleManager2.default.setTitle(self.$t('message.loadingText'));
      window.document.title = self.$route.params.search + ' | Low Carb Program';
      self.doSearch();
    },
    getSearchType: function getSearchType(type) {
      var icon = null;
      if (type === 'resource') {
        icon = 'file_download';
      }
      if (type === 'education') {
        icon = 'local_florist';
      }
      return {
        icon: icon
      };
    },
    linkSearchItem: function linkSearchItem(type, link) {
      var self = this;
      if (type === 'resource') {
        window.open(link, '_blank');
      }
      if (type === 'education') {
        self.$router.push({
          name: 'HcpArticle',
          params: {
            slug: link
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.filterType = self.$route.query.type || 'education';
    self.initMounted();
  },

  computed: {
    hasResults: function hasResults() {
      var self = this;
      return self.results.length > 0;
    }
  }
};

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Striiv = __webpack_require__(1647);

var _Striiv2 = _interopRequireDefault(_Striiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      type: "FITBIT"
    };
  },

  methods: {
    doStriivImport: function doStriivImport() {
      var self = this;
      _Striiv2.default.massImportHeartRate().then(function (response) {
        self.$toastr.success('Synchronizing heart rate data to your health tracking profile. This may take up to 5 - 10 minutes to complete.');
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.type = self.$route.query.name;
    if (self.type === 'STRIIV') {
      self.doStriivImport();
    }
  }
};

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _index = __webpack_require__(110);

var _index2 = _interopRequireDefault(_index);

var _CheckIn = __webpack_require__(271);

var _CheckIn2 = _interopRequireDefault(_CheckIn);

var _QuestionsPanel = __webpack_require__(663);

var _QuestionsPanel2 = _interopRequireDefault(_QuestionsPanel);

var _DownloadsPanel = __webpack_require__(1244);

var _DownloadsPanel2 = _interopRequireDefault(_DownloadsPanel);

var _QuizPanel = __webpack_require__(1245);

var _QuizPanel2 = _interopRequireDefault(_QuizPanel);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _RatingPanel = __webpack_require__(1246);

var _RatingPanel2 = _interopRequireDefault(_RatingPanel);

var _AudioPlayer = __webpack_require__(1239);

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _IframeVideoPlayer = __webpack_require__(341);

var _IframeVideoPlayer2 = _interopRequireDefault(_IframeVideoPlayer);

var _PersonalizationPanel = __webpack_require__(3414);

var _PersonalizationPanel2 = _interopRequireDefault(_PersonalizationPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {

    IframeVideoPlayer: _IframeVideoPlayer2.default,
    AudioPlayer: _AudioPlayer2.default,
    LessonRatingPanel: _RatingPanel2.default,
    LessonQuizPanel: _QuizPanel2.default,
    LessonDownloadsPanel: _DownloadsPanel2.default,
    LessonQuestionsPanel: _QuestionsPanel2.default,
    LessonPersonalisedPanel: _PersonalizationPanel2.default
  },
  name: 'lesson',
  data: function data() {
    return {
      data: {},
      isMainVideoVisible: true,
      isTranscriptOpen: false,
      isLoading: true,
      checkInStatus: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/lesson');
    if (self.$store.state.status.payment.paid === false) {
      self.$router.push({ name: 'Dashboard' });
    }
    _TitleManager2.default.setTitle(this.$t('message.loadingText'));
    _index2.default.getLessonByPermalink(self.$route.params.permalink).then(function (response) {
      self.data = response.data;
      self.isLoading = false;
      _TitleManager2.default.setTitle(self.data.title);
      if (_.has(self.$store.state.user.scope, 'date_joined')) {
        var days = 7,
            now = moment(),
            futureDays = moment(self.$store.state.user.scope.date_joined).add('days', days);
        if (now >= futureDays) {
          if (!self.isHcpUser) {
            self.getCheckInStatus();
          }
        }
      }
    });
  },

  methods: {
    getCheckInStatus: function getCheckInStatus() {
      var self = this;
      _CheckIn2.default.getCheckInStatus().then(function (response) {
        self.checkInStatus = response.data;
        self.$nextTick(function () {
          if (window.sessionStorage.getItem('checkInIgnored')) {} else {
            var needsCheckIn = self.checkInStatus.isDiabetic ? self.checkInStatus.weightNeedsCheckIn || self.checkInStatus.hba1cNeedsCheckin || self.checkInStatus.hba1cNeedsCheckIn : self.checkInStatus.weightNeedsCheckIn;
            if (needsCheckIn) {
              window.sessionStorage.setItem('checkInRedirect', self.$route.fullPath);
            }
            if (self.checkInStatus.isDiabetic === true) {
              if (self.checkInStatus.weightNeedsCheckIn === true && self.checkInStatus.hba1cNeedsCheckin === true) {
                self.$router.push({
                  name: 'Hba1cCheckin',
                  query: {
                    diabetic: true,
                    hba1c: true,
                    weight: true
                  }
                });
              } else {
                if (self.checkInStatus.hba1cNeedsCheckIn === true) {
                  self.$router.push({
                    name: 'Hba1cCheckin',
                    query: {
                      diabetic: true,
                      hba1c: true,
                      weight: false
                    }
                  });
                }
                if (self.checkInStatus.weightNeedsCheckIn === true) {
                  self.$router.push({
                    name: 'WeightCheckin',
                    query: {
                      diabetic: true,
                      weight: true,
                      hba1c: false
                    }
                  });
                }
              }
            } else {
              if (self.checkInStatus.weightNeedsCheckIn === true) {
                self.$router.push({
                  name: 'WeightCheckin',
                  query: {
                    diabetic: false,
                    weight: true,
                    hba1c: false
                  }
                });
              }
            }
          }
        });
      });
    },
    toggleMainVideo: function toggleMainVideo(value) {
      var self = this;
      self.isMainVideoVisible = value;
    },
    goToDashboard: function goToDashboard() {
      var self = this;
      self.$router.push({
        name: 'Dashboard'
      });
    },
    toggleTranscript: function toggleTranscript() {
      var self = this;
      self.isTranscriptOpen = !self.isTranscriptOpen;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _IframeVideoPlayer = __webpack_require__(341);

var _IframeVideoPlayer2 = _interopRequireDefault(_IframeVideoPlayer);

var _QuestionsPanel = __webpack_require__(663);

var _QuestionsPanel2 = _interopRequireDefault(_QuestionsPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    QuestionsPanel: _QuestionsPanel2.default,
    IframeVideoPlayer: _IframeVideoPlayer2.default
  },
  data: function data() {
    return {
      isLoading: true,
      data: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    _Lessons2.default.getBonusModule(self.$route.params.id).then(function (response) {
      self.data = response.data;
      _TitleManager2.default.setTitle(self.data.title);
      self.isLoading = false;
    }).catch(function () {
      self.$router.push({
        path: '/404'
      });
    });
  }
};

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _index = __webpack_require__(97);

var _index2 = _interopRequireDefault(_index);

var _LifeComments = __webpack_require__(3416);

var _LifeComments2 = _interopRequireDefault(_LifeComments);

var _LifeSimilarPosts = __webpack_require__(3417);

var _LifeSimilarPosts2 = _interopRequireDefault(_LifeSimilarPosts);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LifeSimilarPosts: _LifeSimilarPosts2.default,
    LifeComments: _LifeComments2.default
  },
  mixins: [_HCPMixin2.default],
  name: 'life-detail',
  watch: {
    '$route': function $route() {
      var self = this;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      isLoggedOut: false,
      isError: false,
      isLocked: false,
      attempts: {
        amount: 3,
        read: parseInt(localStorage.getItem('lifeLock')) || 0
      },
      scroller: document.getElementsByClassName('main-content')[0],
      isLoading: true,
      articleUrl: "",
      post: {},
      stickyElement: {
        el: null,
        appHeaderHeight: null
      }
    };
  },

  methods: {
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      return moment(date);
    }),
    getData: function getData() {
      var self = this,
          params = self.$route.params;
      if (self.$store.state.status.payment.paid === false) {
        self.goToRoute('LifeStyle');
      } else {
        _index2.default.getPost(params.permalink, 'large').then(function (response) {
          self.isLoading = false;
          self.post = response.data;
          _TitleManager2.default.setTitle(self.post.post_title);
          if (self.isHcpUser) {
            _TitleManager2.default.replaceTitle(self.post.post_title);
          }
          window.document.title = self.post.post_title + ' | LifeStyle';
          self.$gtag.pageview('/life/' + self.post.post_slug);
          self.$forceUpdate();
          if (self.userId) {
            window.localStorage.removeItem('LifeLock');
          }
          self.$nextTick(function () {
            $("iframe").wrap("<div class='video-container'/>");

            $('p').each(function () {
              var $this = $(this);
              if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) $this.remove();
            });

            $('.wp-caption').each(function (i, e) {
              $(e).attr('style', '');
            });
          });
        }).catch(function (error) {
          if (error) {
            if (error.response.status === 404) {
              _TitleManager2.default.setTitle('Article not found');
              self.isError = true;
              self.goToRoute('404');
            }
          }
          if (error.response.status === 403) {
            _TitleManager2.default.setTitle('Unauthorized');
            self.isError = true;
            self.isLoading = false;
          }
        });
      }
    },
    favouritePost: function favouritePost() {
      var self = this;
      _index2.default.favouritePost({
        post_id: self.post.post_id
      }).then(function (res) {
        var callback = res.data;
        if (callback.fav_status) {
          self.post.post_favourited = true;
          self.post.post_favourites += 1;
        } else {
          self.post.post_favourited = false;
          self.post.post_favourites -= 1;
        }
      });
    },
    getArticleUrl: function getArticleUrl() {
      var self = this;
      self.articleUrl = window.location.href;
    },
    goToRoute: function goToRoute(name) {
      var self = this;
      self.$router.push({
        name: name
      });
    },
    goToLogin: function goToLogin() {
      var self = this;
      self.$router.push({
        path: '/login?redirect=life/' + self.post.post_slug
      });
    },
    initMounted: function initMounted() {
      var self = this,
          params = self.$route.params;
      _TitleManager2.default.setTitle(self.$t('message.loadingText'));
      if (self.isHcpUser) {
        _TitleManager2.default.replaceTitle(self.$t('message.loadingText'));
      }
      self.post = [];
      self.isLoading = true;
      setTimeout(function () {
        self.getData();
        setTimeout(function () {
          if (self.userId) {
            self.isLoggedOut = false;
            localStorage.removeItem('lifeLock');
          } else {
            self.isLoggedOut = true;
            if (!self.userId) {
              if (self.attempts.read !== self.attempts.amount) {
                if (self.isLoggedOut === true) {
                  var count = parseInt(self.attempts.read);
                  localStorage.setItem('lifeLock', count + 1);
                }
              }
            } else {
              localStorage.removeItem('lifeLock');
            }
          }
        }, 1000);
      }, 1000);
      self.getArticleUrl();
    }
  },
  computed: {
    userId: function userId() {
      var self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.user.scope.user_id;
      }
      return false;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(11), __webpack_require__(9)))

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _index = __webpack_require__(97);

var _index2 = _interopRequireDefault(_index);

var _Life = __webpack_require__(725);

var _Life2 = _interopRequireDefault(_Life);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _fontawesomeSvgCore = __webpack_require__(465);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_Life2.default, _HCPMixin2.default],
  name: 'life-category',
  watch: {
    "$route.params.slug": function $routeParamsSlug(slug) {
      var self = this;
      if (!slug) return;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      posts: [],
      category: {},
      getPostParams: {
        page: 1,
        per_page: 10,
        size: 'medium-400'
      },
      slug: "",
      isLoading: true,
      isPostsFinished: false,
      isAppending: false,
      termId: null
    };
  },

  methods: {
    findIconDefinition: _fontawesomeSvgCore.findIconDefinition,
    truncate: function truncate(string) {
      return _.truncate(string, {
        'length': 77
      });
    },
    loadCatPosts: function loadCatPosts(params, term_id, mode) {
      var self = this;

      if (mode !== 'append') {
        this.isLoading = true;
      }

      this.isAppending = true;
      _index2.default.getCategoryPosts(params.page, params.per_page, term_id, params.size).then(function (response) {
        self.isLoading = false;
        var callback = response.data;
        if (callback.length) {
          if (self.getPostParams.page === 1) {
            self.posts = callback;
          } else {
            self.posts.push.apply(self.posts, callback);
            self.isAppending = false;
          }
        } else {
          self.isPostsFinished = true;
          self.isAppending = false;
        }
      });
      self.getPostParams.page += 1;
    },
    loadCat: function loadCat(slug) {
      var self = this;
      self.category = {};
      self.posts = [];
      self.setTitle(self.$t('message.loadingText'));
      _index2.default.getCategory(slug).then(function (response) {
        self.getPostParams.page = 1;
        self.posts = [];
        self.category = response.data;
        self.setTitle(self.localizeLifeCat(self.category.term_id) || self.category.name);
        window.document.title = (self.localizeLifeCat(self.category.term_id) || self.category.name) + ' | LifeStyle';
        if (self.isHcpUser) {
          _TitleManager2.default.replaceTitle(self.localizeLifeCat(self.category.term_id) || self.category.name);
        }
        self.termId = response.data.term_id;
        self.loadCatPosts(self.getPostParams, response.data.term_id);
        self.initScroll();
      });
    },
    setTitle: function setTitle(title) {
      _TitleManager2.default.setTitle(title);
    },
    favouritePost: function favouritePost(post_id) {
      var self = this,
          post = _.find(self.posts, ['post_id', post_id]);
      _index2.default.favouritePost({
        post_id: post_id
      }).then(function (res) {
        var callback = res.data;
        if (callback.fav_status) {
          post.post_favourited = true;
          post.post_favourites += 1;
        } else {
          post.post_favourited = false;
          post.post_favourites -= 1;
        }
      });
    },
    goTo: function goTo(slug) {
      var self = this;
      self.$router.push({ name: 'LifeStyleArticle', params: { permalink: slug } });
    },
    calcPostHeight: function calcPostHeight() {
      var self = this;
      $(function () {
        calcEachPost();
        $(window).resize(function () {
          calcEachPost();
        });
        function calcEachPost() {
          $('.post').each(function () {
            var post = $(this),
                contentHeight = post.find('.desc').outerHeight();
            post.find('.overlay').css({
              'bottom': '-' + contentHeight + 'px'
            });
          });
        }
      });
    },
    initScroll: function initScroll() {
      var self = this;
      var el = self.$route.meta.id;

      function debounce(func, wait) {
        var timeout = void 0;
        return function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var context = this;
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            return func.apply(context, args);
          }, wait);
        };
      }

      function handleScroll() {
        var container = document.getElementById(el);

        if (!container) {
          return;
        }
        if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
          if (!self.isPostsFinished && !self.isLoading) {
            self.isLoading = true;
            self.loadCatPosts(self.getPostParams, self.category.term_id);
            self.isLoading = false;
            self.isAppending = true;
          }
        }
      }

      var debouncedHandleScroll = debounce(handleScroll, 100);
      var container = document.getElementById(el);

      if (container) {
        if (self._scrollContainer && self._scrollHandler) {
          self._scrollContainer.removeEventListener('scroll', self._scrollHandler);
        }
        self._scrollContainer = container;
        self._scrollHandler = debouncedHandleScroll;
        container.addEventListener('scroll', debouncedHandleScroll);
      }
    },
    initMounted: function initMounted() {
      var self = this,
          el = self.$route.meta.id;
      self.slug = self.$route.params.slug;
      self.posts = [];
      self.category = {};
      self.getPostParams.page = 1;
      self.isLoading = true;
      self.isPostsFinished = false;
      self.isAppending = false;
      self.loadCat(self.slug);
    }
  },
  computed: {
    chunkedItems: function chunkedItems() {
      var self = this;
      return _.chunk(_.toArray(self.posts), 2);
    },
    userId: function userId() {
      var self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.user.scope.user_id;
      }
      return false;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    if (self._scrollContainer && self._scrollHandler) {
      self._scrollContainer.removeEventListener('scroll', self._scrollHandler);
      self._scrollContainer = null;
      self._scrollHandler = null;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(11)))

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _index = __webpack_require__(97);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    "$route": function $route() {
      var self = this;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      posts: [],
      getPostParams: {
        page: 1,
        per_page: 10,
        size: 'large'
      },
      isLoading: true,
      isPostsFinished: false,
      isAppending: false
    };
  },

  methods: {
    loadPosts: function loadPosts() {
      var self = this;
      self.setTitle(self.$t('message.loadingText'));
      _index2.default.getMyFavouritePosts(self.$store.state.user.scope.user_id, self.getPostParams).then(function (response) {
        self.setTitle(self.$t('message.lifeMyFavourites'));
        self.isLoading = false;
        var callback = response.data;
        if (callback.length) {
          if (self.getPostParams.page === 1) {
            self.posts = callback;
          } else {
            self.posts.push.apply(self.posts, callback);
            self.isAppending = false;
          }
        } else {
          self.isPostsFinished = true;
          self.isAppending = false;
        }
      });
      self.getPostParams.page += 1;
    },
    setTitle: function setTitle(title) {
      _TitleManager2.default.setTitle(title);
    },
    favouritePost: function favouritePost(post_id) {
      var self = this,
          post = _.find(self.posts, ['post_id', post_id]);
      _index2.default.favouritePost({
        post_id: post_id
      }).then(function (res) {
        var callback = res.data;
        if (callback.fav_status) {
          post.post_favourited = true;
          post.post_favourites += 1;
        } else {
          post.post_favourited = false;
          post.post_favourites -= 1;
        }
      });
    },
    goTo: function goTo(slug) {
      var self = this;
      self.$router.push({ name: 'LifeStyleArticle', params: { permalink: slug } });
    },
    initScroll: function initScroll() {
      var self = this,
          el = self.$route.meta.id;
      $(function () {
        $('#' + el).on('scroll', function () {
          if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
            if (!self.isPostsFinished) {
              self.loadPosts();
              self.isAppending = true;
            }
          }
        });
      });
    },
    initMounted: function initMounted() {
      var self = this,
          el = self.$route.meta.id;
      self.posts = [];
      self.getPostParams.page = 1;
      self.isLoading = true;
      self.isPostsFinished = false;
      self.isAppending = false;
      setTimeout(function () {
        self.loadPosts();
      }, 1);
      self.initScroll();
    }
  },
  computed: {
    hasFavourites: function hasFavourites() {
      var self = this;
      return self.posts.length;
    },
    chunkedItems: function chunkedItems() {
      var self = this;
      return _.chunk(_.toArray(self.posts), 2);
    },
    userId: function userId() {
      var self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.user.scope.user_id;
      }
      return false;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(11)))

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(97);

var _index2 = _interopRequireDefault(_index);

var _LifeSearchBar = __webpack_require__(1248);

var _LifeSearchBar2 = _interopRequireDefault(_LifeSearchBar);

var _Life = __webpack_require__(725);

var _Life2 = _interopRequireDefault(_Life);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _LifePostInfo = __webpack_require__(1247);

var _LifePostInfo2 = _interopRequireDefault(_LifePostInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_Life2.default, _HCPMixin2.default],
  components: {
    LifeSearchBar: _LifeSearchBar2.default,
    LifePostInfo: _LifePostInfo2.default
  },
  name: 'life-style',
  watch: {
    '$route': function $route() {
      var self = this;
      self.initMounted();
    },
    isLoading: function isLoading() {
      if (this.isLoading === false) {
        $('.main-content').attr('style', 'overflow-y: scroll');
      }
    }
  },
  data: function data() {
    return {
      posts: [],
      cats: [],
      recommendations: [],
      isLoading: true,
      loaderHeight: 0
    };
  },

  methods: {
    goToFavourites: function goToFavourites() {
      var self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          name: 'LifeStyleFavourites'
        });
      } else {
        self.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    loadPosts: function loadPosts() {
      var _this = this;

      this.isLoading = true;
      _index2.default.getPosts(1, 12, 'medium').then(function (response) {
        _this.posts = response.data;
        _this.isLoading = false;
      });
    },
    loadCats: function loadCats() {
      var self = this;
      _index2.default.getCategorys().then(function (response) {
        var data = response.data;
        self.cats = data;
      });
    },
    goTo: function goTo(slug) {
      var self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          name: 'LifeStyleCategory',
          params: {
            slug: slug
          }
        });
      } else {
        self.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      return moment(date);
    }),
    goToArticle: function goToArticle(slug) {
      var self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          name: 'LifeStyleArticle',
          params: {
            permalink: slug
          }
        });
      } else {
        self.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    initMounted: function initMounted() {
      var self = this;

      $('.main-content').attr('style', 'overflow-y: hidden');

      var loaderHeight = $('.main-content').outerHeight();
      self.loaderHeight = loaderHeight;

      self.isLoading = true;
      self.loadPosts();
      self.loadCats();
      setTimeout(function () {
        self.isLoading = false;
      }, 2500);
    }
  },
  computed: {
    shuffleRecommendations: function shuffleRecommendations() {
      var self = this;
      return _.shuffle(self.recommendations);
    },
    hasRecommendations: function hasRecommendations() {
      var self = this;
      return self.recommendations.length;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _index = __webpack_require__(97);

var _index2 = _interopRequireDefault(_index);

var _LifeSearchBar = __webpack_require__(1248);

var _LifeSearchBar2 = _interopRequireDefault(_LifeSearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { LifeSearchBar: _LifeSearchBar2.default },
  watch: {
    "$route": function $route() {
      var self = this;
      self.initMounted();
    }
  },
  data: function data() {
    return {
      posts: [],
      getPostParams: {
        page: 1,
        per_page: 9,
        size: 'large'
      },
      total_pages: '',
      isLoading: true,
      isPostsFinished: false,
      isAppending: false,
      sortBy: 1,
      loadingMore: false,
      loadMore: true
    };
  },

  methods: {
    updateResults: function updateResults() {
      var self = this;
      self.getPostParams.page++;
      self.loadingMore = true;
      var searchValue = self.$route.params.search;
      _index2.default.getSearchPosts(searchValue, self.getPostParams).then(function (response) {
        self.loadingMore = false;
        if (response.data.posts.length === 0) {
          self.loadMore = false;
        }
        self.posts.push.apply(self.posts, response.data.posts);
        self.filterResults();
      });
    },
    filterResults: function filterResults(value) {
      var self = this;
      self.$nextTick(function () {
        if (self.sortBy === 1) {
          var mostFavourites = _.orderBy(self.posts, function (item) {
            return item.post_favourites;
          }, ['desc']);
          self.posts = mostFavourites;
        }

        if (self.sortBy === 2) {
          var newestResults = _.orderBy(self.posts, function (item) {
            return moment(item.post_date).format('YYYYMMDD');
          }, ['desc']);
          self.posts = newestResults;
        }
        self.$forceUpdate();
      });
    },
    handlePageChange: function handlePageChange(page) {
      var self = this;
      self.isLoading = true;
      self.getPostParams.page = page;
      self.loadPosts();
    },
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      return moment(date);
    }),
    loadPosts: function loadPosts() {
      var self = this;
      var searchValue = self.$route.params.search;
      _index2.default.getSearchPosts(searchValue, self.getPostParams).then(function (response) {
        self.isLoading = false;
        self.posts = response.data.posts;
        self.total_pages = response.data.total_pages;
        self.filterResults();
      });
    },
    setTitle: function setTitle(title) {
      _TitleManager2.default.setTitle(title);
    },
    favouritePost: function favouritePost(post_id) {
      var self = this,
          post = _.find(self.posts, ['post_id', post_id]);
      _index2.default.favouritePost({
        post_id: post_id
      }).then(function (res) {
        var callback = res.data;
        if (callback.fav_status) {
          post.post_favourited = true;
          post.post_favourites += 1;
        } else {
          post.post_favourited = false;
          post.post_favourites -= 1;
        }
      });
    },
    goTo: function goTo(slug) {
      var self = this;
      self.$router.push({ name: 'LifeStyleArticle', params: { permalink: slug } });
    },
    initMounted: function initMounted() {
      var self = this,
          el = self.$route.meta.id;
      self.posts = [];
      self.isLoading = true;
      self.isPostsFinished = false;
      self.isAppending = false;
      self.loadMore = true;
      self.loadPosts();
    }
  },
  computed: {
    chunkedItems: function chunkedItems() {
      var self = this;
      return _.chunk(_.toArray(self.posts), 3);
    },
    userId: function userId() {
      var self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.user.scope.user_id;
      }
      return false;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(476);

var _Login2 = _interopRequireDefault(_Login);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _FlashMessageMixin = __webpack_require__(483);

var _FlashMessageMixin2 = _interopRequireDefault(_FlashMessageMixin);

var _SocialLoginMixin = __webpack_require__(357);

var _SocialLoginMixin2 = _interopRequireDefault(_SocialLoginMixin);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

var _MessageBox = __webpack_require__(662);

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _Rx = __webpack_require__(91);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

var _LifeStyle = __webpack_require__(97);

var _LifeStyle2 = _interopRequireDefault(_LifeStyle);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueRecaptcha = __webpack_require__(676);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var randomString = __webpack_require__(1126);
exports.default = {
  mixins: [_HCPMixin2.default, _FlashMessageMixin2.default, _SocialLoginMixin2.default],
  components: { Alert: _Alert2.default, MessageBox: _MessageBox2.default, VueRecaptcha: _vueRecaptcha2.default },
  data: function data() {
    return {
      offerCode: null,
      email: '',
      password: '',
      remember_me: true,
      isLoggingIn: false,
      hasError: false,
      errorMessage: '',
      passwordVisible: false,
      captcha: '',
      captchaFilled: false,
      captchaSiteKey: _config2.default.captchaSiteKey
    };
  },
  mounted: function mounted() {
    var self = this;
    var voucher = self.$route.query.voucher;
    if (voucher) {
      self.setCookie('voucher', voucher, 7);
    }

    if (_lodash2.default.has(this.$route.query, 'oc')) {
      this.offerCode = this.$route.query.oc;
    }

    if (_AuthenticationManager2.default.hasToken()) {
      self.$router.push({
        name: 'Dashboard'
      });
    } else {
      _AuthenticationManager2.default.clearSession();

      if (_lodash2.default.has(_axios2.default.defaults.headers.common, 'Authorization')) {
        delete _axios2.default.defaults.headers.common['Authorization'];
      }
    }

    if (self.$route.query.emailUpdated) {
      self.email = self.$route.query.email;
      self.$alert({
        title: "Successfully updated your email address",
        text: "You can now login with " + self.email,
        type: "success",
        showCancelButton: false,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white"
      });
    } else if (self.$route.query.tokenInvalid) {
      self.$alert({
        title: "Token Invalid",
        text: "Token is invalid",
        type: "warning",
        showCancelButton: false,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white"
      });
    }
    self.$gtag.pageview('/login');
  },

  computed: {
    title: function title() {
      if (this.offerCode !== null) {
        return 'Log in to get 30% off';
      }

      return this.$t('message.logInText');
    }
  },
  methods: {
    setCookie: function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isLoggingIn = true;
          _Login2.default.Authenticate(self.email, self.password, self.remember_me, self.captcha, self.offerCode).then(function (response) {
            var token = _AuthenticationManager2.default.setAccessTokenExpiryTime(response.data);
            _AuthenticationManager2.default.setToken(token);
            _Lessons2.default.getLessonsList().then(function (response) {
              self.$store.commit('setLessons', response.data);
            });

            _UserManager2.default.getUserAndStore(self);

            if (_lodash2.default.includes(_AuthenticationManager2.default.parseJwt().scope, "standard_tasks")) {
              if (self.isHcpView) {
                self.$router.push({
                  name: 'HcpGettingStarted'
                });
              } else {
                if (self.$route.query.redirect) {
                  self.$router.push({
                    path: self.$route.query.redirect
                  });
                } else {
                  self.$router.push({
                    name: 'Dashboard'
                  });
                }
              }
              self.$gtag.event('LoggedIn', {
                'event_category': 'Authentication',
                'event_label': 'Logged in',
                'value': 1
              });
            } else if (_lodash2.default.includes(_AuthenticationManager2.default.parseJwt().scope, 'unsubscribed_tasks')) {
              self.$router.push({
                path: '/subscribe'
              });
            }
          }).catch(function (error) {
            if (!_lodash2.default.has(error, 'response')) {
              self.isLoggingIn = false;
              return;
            }

            self.isLoggingIn = false;
            self.onCaptchaExpired();
            if (error.response.status === 401 || error.response.status === 500 || error.response.status === 400) {
              self.hasError = true;
              self.errorMessage = error.response.data.message;
              self.$gtag.event('LoginFailed', {
                'event_category': 'Authentication',
                'event_label': 'Login failed',
                'value': 1
              });
            }
            self.countdownError();
          });
        }
      });
    },

    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.captcha = recaptchaToken;
      this.captchaFilled = true;
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.captcha = '';
      this.captchaFilled = false;
    },
    countdownError: function countdownError() {
      var _this = this;

      setTimeout(function () {
        _this.hasError = false;
      }, 7000);
    }
  }
};

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Callback",
  data: function data() {
    return {
      'handshakeId': null,
      'externalUser': {},
      'user': {}
    };
  },
  mounted: function mounted() {
    var self = this;
    self.setHandshakeId();
    self.getExternalUser().then(function (response) {
      self.externalUser = response.data.externalUser;
      var token = _AuthenticationManager2.default.setAccessTokenExpiryTime(response.data.token);
      _AuthenticationManager2.default.setToken(token);
      self.getUser().then(function (response) {
        self.user = response.data.scope;
        self.$store.commit('setUser', response.data);
        self.routeUser();
      });
    });
  },

  methods: {
    setHandshakeId: function setHandshakeId() {
      var self = this;
      self.handshakeId = window.localStorage.getItem('handshake');
      window.localStorage.removeItem('handshake');
    },
    getExternalUser: function getExternalUser() {
      var self = this;
      var data = {
        'handshake_id': self.handshakeId
      };
      return _axios2.default.post(_config2.default.apiUrl + 'auth/external/user', data);
    },
    getUser: function getUser() {
      return _User2.default.getUser();
    },
    routeUser: function routeUser() {
      var self = this;
      if (self.externalUser.completed_registration === 2) {
        self.$router.push({ name: 'Dashboard' });
      } else if (self.externalUser.completed_registration === 1) {
        self.$router.push({ name: 'Subscription' });
      } else {
        self.$store.state.flashMessage = {
          title: "Account created!",
          body: "Please enter a few more details to get started with the Low Carb Program",
          type: "success"
        };
        self.$router.push({ name: 'Register' });
      }
    }
  }
};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(476);

var _Login2 = _interopRequireDefault(_Login);

var _PasswordStrengthValidation = __webpack_require__(342);

var _PasswordStrengthValidation2 = _interopRequireDefault(_PasswordStrengthValidation);

var _MessageBox = __webpack_require__(662);

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _FlashMessageMixin = __webpack_require__(483);

var _FlashMessageMixin2 = _interopRequireDefault(_FlashMessageMixin);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_FlashMessageMixin2.default],
  components: {
    PasswordStrengthValidation: _PasswordStrengthValidation2.default,
    MessageBox: _MessageBox2.default
  },
  data: function data() {
    return {
      model: {
        password: null,
        password_confirm: null,
        token: ""
      },
      isSending: false
    };
  },

  computed: {
    confirmPassErr: function confirmPassErr() {
      var self = this;
      var error = self.errors.first('password_confirmation');
      if (error === "The Confirm Password confirmation does not match.") {
        return 'Please enter passwords that match';
      } else {
        return error;
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    if (_.has(self.$route.query, 'token')) {
      self.model.token = self.$route.query.token;
    } else {
      self.$router.push({
        name: 'Login'
      });
    }
  },

  methods: {
    triggerValidate: function triggerValidate() {
      this.$validator.validateAll();
    },
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid === true) {
          self.isSending = true;
          _Login2.default.updatePasswordWithToken(self.model).then(function (response) {
            self.$toastr.success("Password was successfully reset, you may now login in to your account");
            self.$router.push({
              name: "Login"
            });
          }).catch(function (error) {
            self.$toastr.error("There was an error processing your request, please request a NEW password reset email");
            self.isSending = false;
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
exports.default = {
  name: 'paypal-form',
  data: function data() {
    return {
      app_url: null,
      api_url: null,
      product_name: ''
    };
  },

  props: {
    paypal: {
      type: Object,
      required: true
    }
  },
  methods: {
    submitPayment: function submitPayment() {
      var self = this;

      if (self.paypal.custom === "" || self.paypal.custom === null || self.paypal.custom === 0 || self.paypal.custom === undefined) {
        self.$toastr.error('Cannot process payment. Please try again later');
      } else {
        self.paypal.hasSubmitted = true;
        $('#paymentForm')[0].submit();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    var siteURL = '';
    if (_config2.default.ApplicationContext === 'lowcarbprogram') {
      siteURL = 'https://www.lowcarbprogram.com/';
    } else {
      siteURL = 'https://www.grohealth.com/';
    }
    self.app_url = siteURL + _config2.default.locale + '/';
    self.api_url = _config2.default.apiUrl;
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Payment = __webpack_require__(196);

var _Payment2 = _interopRequireDefault(_Payment);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _index = __webpack_require__(3512);

var _index2 = _interopRequireDefault(_index);

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

var _index3 = __webpack_require__(6);

var _index4 = _interopRequireDefault(_index3);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _numeral2 = __webpack_require__(90);

var _numeral3 = _interopRequireDefault(_numeral2);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    PaypalForm: _index2.default
  },
  data: function data() {
    return {
      stats: {},
      isLoading: true,
      status: {},
      paypal: {},
      voucher: {
        code: "",
        error: false,
        message: "",
        isSending: false
      }
    };
  },

  methods: {
    numeral: function numeral(num) {
      return (0, _numeral3.default)(num);
    },
    getStats: function getStats() {
      var self = this;
      _axios2.default.get(_index4.default.apiUrl + 'stats').then(function (response) {
        self.stats = response.data;
      });
    },
    fetchPaymentDetails: function fetchPaymentDetails() {
      var self = this;
      _Payment2.default.getPayPalDetails().then(function (response) {
        self.paypal = response.data;
        self.paypal.hasSubmitted = false;
      }).catch(function (error) {
        if (error.response.data.error === true) {
          self.goTo('Login');
        }
      });
    },
    getUserPaidStatus: function getUserPaidStatus() {
      var self = this;
      if (_AuthenticationManager2.default.hasToken()) {
        var tokenObject = _AuthenticationManager2.default.getToken();
        _AuthenticationManager2.default.refreshAccessToken(tokenObject).then(function () {
          if (_lodash2.default.includes(_AuthenticationManager2.default.parseJwt().scope, "standard_tasks")) {
            self.isLoading = false;
            self.$store.commit('setPaymentStatus', true);

            if (!self.getParam('success')) {
              self.goTo('Dashboard');
            }
          }
        });
      }
    },
    goTo: function goTo(name) {
      var self = this;
      self.$router.replace({
        name: name
      });
    },
    goToGetStarted: function goToGetStarted() {
      var self = this;
      if (_AuthenticationManager2.default.hasToken()) {
        var tokenObject = _AuthenticationManager2.default.getToken();
        _AuthenticationManager2.default.refreshAccessToken(tokenObject).then(function () {
          if (_lodash2.default.includes(_AuthenticationManager2.default.parseJwt().scope, "standard_tasks")) {
            self.$store.commit('setPaymentStatus', true);
            if (self.$store.state.status.onboarding.about || self.$store.state.status.onboarding.location || self.$store.state.status.goals || self.$store.state.status.personalise) {
              self.goTo('Dashboard');
            } else {
              self.goTo('GettingStartedAboutYourself');
            }
          } else {
            self.$toastr.error('Having trouble getting started. Please email support@lowcarbprogram.com');
          }
        });
      }
    },
    continueFree: function continueFree() {
      var self = this;
      if (self.$store.state.status.onboarding.about || self.$store.state.status.onboarding.location || self.$store.state.status.goals || self.$store.state.status.personalise) {
        self.goTo('Dashboard');
      } else {
        self.goTo('GettingStartedAboutYourself');
      }
    },
    processVoucher: function processVoucher() {
      var self = this;
      self.voucher.error = false;
      self.voucher.isSending = true;
      _Payment2.default.validateVoucher({
        voucher: self.voucher.code.toUpperCase().trim()
      }).then(function (response) {
        if (response.data.error === false) {

          var trackedVouchers = ['EASYHEALTH', 'EASYHEALTH42', 'EASYHEALTH43', 'COMMUNITY', 'HURRY', 'RESEARCH51', 'RESEARCH52', 'RESEARCH53', 'RESEARCH54', 'RESEARCH55', 'RESEARCH56', 'LOWCARBNOW'];

          var containsTrackable = trackedVouchers.indexOf(self.voucher.code.toUpperCase().trim()) > -1;
          if (containsTrackable) {
            self.$gtag.event(self.voucher.code.toUpperCase().trim(), {
              'event_category': 'Vouchers',
              'event_label': 'Redeemed voucher code',
              'value': 1
            });
          }

          self.$gtag.event('VoucherRedemption', {
            'event_category': 'Registration',
            'event_label': 'Redeemed a voucher code',
            'value': 1
          });
          self.voucher.isSending = false;
          self.voucher.error = false;
          self.voucher.message = response.data.message + '. Redirecting...';

          self.goToGetStarted();
        }
      }, function (error) {
        var callback = error.response.data;
        if (callback.error) {
          self.voucher.isSending = false;
          self.voucher.error = true;
          self.voucher.message = callback.message;
          self.voucher.code = "";
        }
      });
    },
    getParam: function getParam(param) {
      var self = this;
      return self.$route.query[param];
    },
    printInvoice: function printInvoice() {
      window.print();
    },
    getOnBoardingStatus: function getOnBoardingStatus() {
      var self = this;
      _User2.default.onBoardingStatus().then(function (response) {
        self.$store.commit('setOnBoardingStatus', response.data);
      });
    },
    validateStripePayment: function validateStripePayment() {
      if (_lodash2.default.has(this.$route.query, 'uuid')) {
        var uuid = this.$route.query.uuid;
        _Payment2.default.validatePayment({ uuid: uuid });
        this.$router.push({
          path: '/dashboard'
        });
      }
    },
    initMounted: function initMounted() {
      var self = this;
      self.validateStripePayment();
      self.getStats();
      self.fetchPaymentDetails();
      self.getUserPaidStatus();
      self.getOnBoardingStatus();
      var getCode = self.getCookie("voucher");
      if (getCode) {
        self.voucher.code = getCode;
      }
      if (self.hasPaymentProcessed) {
        self.$gtag.event('Paid', {
          'event_category': 'Registration',
          'event_label': 'Paid',
          'value': 1
        });
        fbq('track', 'Purchase', {
          currency: 'GBP',
          value: 29.99
        });
      }
      self.$gtag.pageview('/payment');
    },
    getCookie: function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  },
  computed: {
    hasPaymentProcessed: function hasPaymentProcessed() {
      var self = this;
      return self.getParam('success');
    },
    isPaymentCancelled: function isPaymentCancelled() {
      var self = this;
      return self.getParam('cancelled');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Payment = __webpack_require__(196);

var _Payment2 = _interopRequireDefault(_Payment);

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'paywall',
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      paypal: {}
    };
  },

  methods: {
    fetchPaymentDetails: function fetchPaymentDetails() {
      var self = this;
      _Payment2.default.getPayPalDetails().then(function (response) {
        self.paypal = response.data;
      }).catch(function (error) {});
    },
    initMounted: function initMounted() {
      var self = this;
      self.show = false;
      self.fetchPaymentDetails();
    },
    closeModal: function closeModal() {
      var self = this;
      self.show = false;
      _EventBus2.default.$emit('App::triggerPaywall', false);
    }
  },
  mounted: function mounted() {
    var self = this;
    $('#paywall').mousedown(function (e) {
      if ($(e.target).attr('id') === 'paywall') {
        self.closeModal();
      }
    });
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(608);

var _index = __webpack_require__(132);

var _index2 = _interopRequireDefault(_index);

var _Profile = __webpack_require__(111);

var _Profile2 = _interopRequireDefault(_Profile);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _UserAvatar = __webpack_require__(675);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _ProfileHeader = __webpack_require__(1253);

var _ProfileHeader2 = _interopRequireDefault(_ProfileHeader);

var _LineGraph = __webpack_require__(343);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _LineGraph3 = __webpack_require__(453);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _Gallery = __webpack_require__(1252);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _UserQuestions = __webpack_require__(1254);

var _UserQuestions2 = _interopRequireDefault(_UserQuestions);

__webpack_require__(126);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default, _HCPMixin2.default],
  components: {
    UserProfileQuestions: _UserQuestions2.default,
    ProfileGallery: _Gallery2.default,
    WeightLineGraph: _LineGraph4.default,
    BgLineGraph: _LineGraph2.default,
    ProfileHeader: _ProfileHeader2.default,
    UserAvatar: _UserAvatar2.default
  },
  name: 'profile',
  watch: {
    '$route': function $route() {
      var self = this;
      self.initMounted();
      $('#profile').scrollTop(0);
    }
  },
  data: function data() {
    return {
      isLoading: true,
      profile: {},
      privacy: {},
      gallery: [],
      authUser: {},
      routes: [{
        name: "ProfileProgress",
        label: this.$t('message.labelProgress'),
        route: "progress"
      }, {
        name: "ProfileDiscussion",
        label: this.$t('message.labelPostsAndReplies'),
        route: "discussion"
      }, {
        name: "ProfileGallery",
        label: this.$t('message.labelGallery'),
        route: "gallery"
      }, {
        name: "ProfileFoodDiary",
        label: this.$t('message.labelFood'),
        route: "food-diary"
      }],
      avatarDocked: false,
      window: undefined,
      contentElement: undefined,
      profileTabs: undefined,
      profileHeader: undefined
    };
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
    self.window = $(window);
    self.contentElement = $('.main-content');
    self.profileHeader = $('#profileHeader');

    self.scroller.addEventListener('scroll', self.onScroll);
    if (!self.isHcpView) {
      self.$router.replace({
        name: 'ProfileProgress'
      });
    }
  },

  methods: {
    hideTabItems: function hideTabItems(name) {
      var self = this;
      if (self.isHcpView) {
        if (name === 'ProfileFoodDiary' || name === 'ProfileProgress') {
          return false;
        }
      }
      return true;
    },
    onScroll: function onScroll() {
      var self = this;
      var windowWidth = self.window.outerWidth(true);
      if (windowWidth >= 1024) {
        if (_ScrollManager2.default.isElementInContentView(document.getElementById('scroll-detector'))) {
          self.avatarDocked = false;
          self.unDockAvatar();
        } else {
          self.avatarDocked = true;
          $('#profileTabs').attr('style', 'width: ' + self.contentElement.prop("clientWidth") + 'px');
        }
      } else {
        self.unDockAvatar();
      }
    },
    unDockAvatar: function unDockAvatar() {
      var self = this;
      self.avatarDocked = false;

      $('#profileTabs').removeAttr('style');
      self.$forceUpdate();
    },
    goTo: function goTo(name) {
      var self = this;
      self.$router.replace({
        name: name
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.loadProfile();
    },
    setTitle: function setTitle(title) {
      _TitleManager2.default.setTitle(title);
    },
    loadProfile: function loadProfile() {
      var self = this;
      var url = self.$route.params.profileUrl;
      self.$gtag.pageview('/profile/' + url);
      self.setTitle(self.$t('message.loadingText'));
      self.authUser = self.$store.state.user.scope;
      _Profile2.default.getProfile(url).then(function (response) {
        if (_.has(response.data.information, 'basic')) {
          var user_id = response.data.information.basic.user_id;
          self.$store.commit('setActiveProfile', user_id);
          self.$store.commit('setActiveProfileObject', response.data);
          self.profile = response.data.information.basic;
          self.gallery = response.data.gallery;
          self.privacy = response.data.privacy;
          self.isLoading = false;
          self.setTitle('' + self.profile.display_name);
          $('#profile').scrollTop(0);
          if (_ScrollManager2.default.isElementInContentView(document.getElementById('scroll-detector'))) {
            self.avatarDocked = false;
            self.unDockAvatar();
          }
        }
      });
    },
    replaceDashes: function replaceDashes(url) {
      url = url.split('-').join('.');
      return url;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    self.scroller.removeEventListener('scroll', self.onScroll);
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9)))

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserQuestions = __webpack_require__(1254);

var _UserQuestions2 = _interopRequireDefault(_UserQuestions);

var _ProfileMixin = __webpack_require__(168);

var _ProfileMixin2 = _interopRequireDefault(_ProfileMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ProfileMixin2.default],
  components: { UserProfileQuestions: _UserQuestions2.default },
  data: function data() {
    return {};
  },

  computed: {
    userId: function userId() {
      var self = this;
      return self.$store.state.activeProfile;
    }
  }
};

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProfileFollowerMixin = __webpack_require__(729);

var _ProfileFollowerMixin2 = _interopRequireDefault(_ProfileFollowerMixin);

var _FollowerItem = __webpack_require__(1251);

var _FollowerItem2 = _interopRequireDefault(_FollowerItem);

__webpack_require__(608);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { FollowerItem: _FollowerItem2.default },
  props: ['profile'],
  mixins: [_ProfileFollowerMixin2.default],
  name: 'profile-followers',
  watch: {
    profile: function profile() {
      this.initMounted();
    }
  }
};

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProfileFollowerMixin = __webpack_require__(729);

var _ProfileFollowerMixin2 = _interopRequireDefault(_ProfileFollowerMixin);

var _FollowerItem = __webpack_require__(1251);

var _FollowerItem2 = _interopRequireDefault(_FollowerItem);

__webpack_require__(608);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { FollowerItem: _FollowerItem2.default },
  props: ['profile'],
  mixins: [_ProfileFollowerMixin2.default],
  name: 'profile-following',
  watch: {
    profile: function profile() {
      this.initMounted();
    }
  }
};

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProfileMixin = __webpack_require__(168);

var _ProfileMixin2 = _interopRequireDefault(_ProfileMixin);

var _FoodDiary = __webpack_require__(3423);

var _FoodDiary2 = _interopRequireDefault(_FoodDiary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { FoodDiary: _FoodDiary2.default },
  watch: {
    "$route": function $route() {
      self.profile = self.getProfile();
    }
  },
  mixins: [_ProfileMixin2.default],
  data: function data() {
    return {
      profile: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    self.profile = self.getProfile();
  }
};

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Gallery = __webpack_require__(1252);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _ProfileMixin = __webpack_require__(168);

var _ProfileMixin2 = _interopRequireDefault(_ProfileMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ProfileMixin2.default],
  components: { ProfileGallery: _Gallery2.default },
  data: function data() {
    return {
      images: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.images = self.getProfile().gallery;
  }
};

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LineGraph = __webpack_require__(343);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _LineGraph3 = __webpack_require__(453);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _ProfileMixin = __webpack_require__(168);

var _ProfileMixin2 = _interopRequireDefault(_ProfileMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    WeightLineGraph: _LineGraph4.default,
    BgLineGraph: _LineGraph2.default
  },
  mixins: [_ProfileMixin2.default],
  data: function data() {
    return {};
  }
};

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CreateQuestion = __webpack_require__(450);

var _CreateQuestion2 = _interopRequireDefault(_CreateQuestion);

var _UserAvatar = __webpack_require__(675);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UserAvatar: _UserAvatar2.default,
    CreateQuestion: _CreateQuestion2.default
  },
  name: 'ask-a-question',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/questions/create');
  }
};

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

var _CountryBadge = __webpack_require__(340);

var _CountryBadge2 = _interopRequireDefault(_CountryBadge);

var _ReportingMixin = __webpack_require__(486);

var _ReportingMixin2 = _interopRequireDefault(_ReportingMixin);

var _Report = __webpack_require__(229);

var _Report2 = _interopRequireDefault(_Report);

var _Reporting = __webpack_require__(664);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _EditQuestionTitle = __webpack_require__(3428);

var _EditQuestionTitle2 = _interopRequireDefault(_EditQuestionTitle);

__webpack_require__(947);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _IframeVideoPlayer = __webpack_require__(341);

var _IframeVideoPlayer2 = _interopRequireDefault(_IframeVideoPlayer);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _cardText = __webpack_require__(659);

var _cardText2 = _interopRequireDefault(_cardText);

var _FormatDate = __webpack_require__(716);

var _FormatDate2 = _interopRequireDefault(_FormatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageSizes = [10, 20, 40];

exports.default = {
  components: {
    MuCardText: _cardText2.default,
    IframeVideoPlayer: _IframeVideoPlayer2.default,
    EditQuestionTitle: _EditQuestionTitle2.default,
    Report: _Report2.default,
    ReportModal: _Reporting2.default,
    UserBadge: _UserBadge2.default,
    CountryBadge: _CountryBadge2.default
  },
  name: 'questions-thread',
  mixins: [_ScrollerMixin2.default, _ReportingMixin2.default, _HCPMixin2.default],
  data: function data() {
    return {
      showEmbed: false,
      embedUrl: '',
      embedObject: {},
      page: 1,
      per_page: 10,
      orderBy: 'CHRONOLOGICAL',
      pageSizes: pageSizes,
      isQuestionEditOpen: false,
      questionEditModel: {},
      isLoading: true,
      isSaving: false,
      isReplySaving: false,
      isLiking: false,
      isNewMessage: false,
      answerRemoved: false,
      leftTop: { horizontal: 'left', vertical: 'top' },
      leftBottom: { horizontal: 'left', vertical: 'bottom' },
      rightBottom: { horizontal: 'right', vertical: 'bottom' },
      rightTop: { horizontal: 'right', vertical: 'top' },
      data: {
        replies: []
      },
      model: {
        question_id: parseInt(this.$route.params.id)
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    if (self.$store.state.status.payment.paid === false) {
      self.$router.push({
        name: 'QuestionsIndex'
      });
    }
    var channel = _PusherManager2.default.subscribe('discussion_' + this.$route.params.id);
    channel.bind('reply_create', function (data) {
      if (data.last_id.user.user_id !== self.user.scope.user_id) {
        self.isNewMessage = true;
      }
    });
    self.page = parseInt(self.$route.query.page ? self.$route.query.page : self.page);
    self.per_page = parseInt(self.$route.query.per_page ? self.$route.query.per_page : self.per_page);
    if (self.orderBy === 'CHRONOLOGICAL') {
      self.loadData({
        page: self.page,
        per_page: self.per_page
      });
    } else {
      self.loadData({
        page: self.page,
        per_page: self.per_page,
        latest: true
      });
    }
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var self = this;
      self.page = parseInt(self.$route.query.page ? self.$route.query.page : self.page);
      self.per_page = parseInt(self.$route.query.per_page ? self.$route.query.per_page : self.per_page);
      if (self.orderBy === 'CHRONOLOGICAL') {
        self.loadData({
          page: self.page,
          per_page: self.per_page
        });
      } else {
        self.loadData({
          page: self.page,
          per_page: self.per_page,
          latest: 'true'
        });
      }
    },
    'orderBy': function orderBy() {
      var self = this;
      self.page = parseInt(self.$route.query.page ? self.$route.query.page : self.page);
      self.per_page = parseInt(self.$route.query.per_page ? self.$route.query.per_page : self.per_page);
      if (self.orderBy === 'CHRONOLOGICAL') {
        self.loadData({
          page: self.page,
          per_page: self.per_page,
          softLoad: true
        });
      } else {
        self.loadData({
          page: self.page,
          per_page: self.per_page,
          latest: true,
          softLoad: true
        });
      }
    },
    'per_page': function per_page() {
      var self = this;
      self.$router.replace({
        query: {
          page: self.page,
          per_page: self.per_page
        }
      });
    }
  },
  methods: {
    capitalize: function capitalize(str) {
      return _.capitalize(str);
    },
    updatePerPage: function updatePerPage() {
      var self = this;
      self.page = 1;
    },
    getPageIndex: function getPageIndex(index) {
      var self = this,
          i = self.per_page * self.page - self.per_page + 1;
      if (i !== 0) {
        return i += index;
      }
    },
    escape: function escape(str) {
      str = this.$sanitize(_HTMLStringParser2.default.encode(str));
      return _.unescape(str);
    },
    openEmbedModal: function openEmbedModal() {
      var self = this;
      self.showEmbed = true;
    },
    closeEmbedModal: function closeEmbedModal() {
      var self = this;
      self.showEmbed = false;
      self.embedUrl = "";
    },
    getEmbed: function getEmbed() {
      var self = this;
      if (self.isValidUrl(self.embedUrl) == 1) {
        _axios2.default.get(_config2.default.apiUrl + 'video/parse?url=' + self.embedUrl).then(function (response) {
          self.embedObject = response.data;
          self.closeEmbedModal();
        });
      }
    },
    isValidUrl: function isValidUrl(url) {
      if (/^(http|https|ftp):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(url)) {
        return true;
      } else {
        return false;
      }
    },
    questionDidUpdate: function questionDidUpdate(value) {
      var self = this;
      self.data.question.question = value;
      _TitleManager2.default.setTitle(self.data.question.question);
    },
    updateQuestion: function updateQuestion() {
      var self = this;
      if (self.questionEditModel.content.trim() === '') {
        self.$toastr.error('Your post cannot be empty');
        return;
      }
      _Discussion2.default.updateQuestion(self.questionEditModel).then(function () {
        self.data.question.content = self.questionEditModel.content.trim();
        self.toggleEditQuestion();
      });
    },
    toggleEditQuestion: function toggleEditQuestion() {
      var self = this;
      var question = JSON.parse((0, _stringify2.default)(self.data.question));
      self.questionEditModel = {
        question_id: question.question_id,
        content: question.content
      };
      self.isQuestionEditOpen = !self.isQuestionEditOpen;
    },
    encodeText: function encodeText(string) {
      var sanitized = this.$sanitize(string);
      return _HTMLStringParser2.default.encode(sanitized);
    },
    avatarInitials: function avatarInitials(name) {
      if (!name) return '?';
      var parts = ('' + name).trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return '?';
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    },
    markQuestionUseful: function markQuestionUseful() {
      var self = this;
      _Discussion2.default.likeDiscussionQuestion(self.data.question.question_id).then(function (response) {
        self.data.question.liked = response.data.like_status;
        if (self.data.question.liked === true) {
          self.data.question.likes++;
          self.isLiking = false;
        } else {
          self.data.question.likes--;
          self.isLiking = false;
        }
      });
    },
    markUseful: function markUseful(answer) {
      var self = this;
      answer.isLiking = true;
      self.$forceUpdate();
      _Discussion2.default.likeDiscussionReply(answer.answer_id).then(function (response) {
        answer.liked = response.data.like_status;
        if (answer.liked === true) {
          answer.likes++;
          answer.isLiking = false;
        } else {
          answer.likes--;
          answer.isLiking = false;
        }
        self.$forceUpdate();
      });
    },
    saveAnswer: function saveAnswer() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          _Discussion2.default.postDiscussionReply(self.model).then(function (response) {
            if (self.data.replies.length == 0) {
              self.loadData({
                page: 1,
                per_page: 10,
                latest: 'true',
                softLoad: true
              });
              self.isSaving = false;
              self.model.answer = '';
              self.$nextTick(function () {
                self.resetErrors();
              });
              self.$forceUpdate();
            } else {
              self.data.replies.push(response.data.last_id);
              self.isSaving = false;
              self.model.answer = '';
              self.$nextTick(function () {
                self.resetErrors();
              });
              self.$forceUpdate();
            }
          });
        }
      });
    },
    editAnswer: function editAnswer(answer) {
      var self = this;
      answer.editOpen = true;
      answer.editableReply = _.unescape(this.$sanitize(answer.answer));
      self.$forceUpdate();
      var timeout = setTimeout(function () {
        var element = document.getElementById('reply-' + answer.answer_id).children[0].children[1].children[1];
        $(element).focus();
        clearTimeout(timeout);
      });
    },
    discardEdit: function discardEdit(answer) {
      var self = this;
      answer.editOpen = false;
      self.$forceUpdate();
    },
    updateAnswer: function updateAnswer(answer) {
      var self = this;
      self.$validator.validateAll('updateAnswer').then(function (valid) {
        if (valid === true) {
          answer.answer = answer.editableReply;
          answer.isUpdating = true;
          self.$forceUpdate();
          _Discussion2.default.updateAnswer(answer).then(function (response) {
            answer.editOpen = false;
            answer.isUpdating = false;
            self.$forceUpdate();
          });
        }
      });
    },
    deleteAnswer: function deleteAnswer(answer, answer_id) {
      var self = this;

      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveAnswerItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Discussion2.default.deleteAnswer(answer_id);
        }
      }).then(function (response) {
        var index = self.data.replies.indexOf(answer);
        self.data.replies.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveAnswerItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    hideToast: function hideToast() {
      var self = this;
      self.isNewMessage = false;
    },
    toggleReplyPanel: function toggleReplyPanel(answer) {
      var self = this;
      if (answer.replyOpen) {
        answer.replyOpen = !answer.replyOpen;
        self.$forceUpdate();
      } else {
        var repliesLength = self.data.replies.length;
        for (var i = 0; i < repliesLength; i++) {
          self.data.replies[i].replyOpen = false;
        }
        answer.replyOpen = true;
        self.$forceUpdate();
        var timeout = setTimeout(function () {
          var element = document.getElementById('reply-' + answer.answer_id).children[0].children[1].children[1];
          var timeout = setTimeout(function () {
            $('.main-content').animate({
              scrollTop: $("#reply-" + answer.answer_id).offset().top - $('.main-content').offset().top + $('.main-content').scrollTop() - 16
            }, 200, function () {
              $(element).focus();
            });
            clearTimeout(timeout);
          }.bind(self), 100);
        });
      }
    },
    replyToAnswer: function replyToAnswer(answer) {
      var self = this;
      if (answer.replyable) {
        answer.isSaving = true;
        self.$forceUpdate();
        var model = {
          question_id: this.$route.params.id,
          answer: answer.replyable,
          replies: [{
            answer_id: answer.answer_id
          }]
        };
        _Discussion2.default.postDiscussionReply(model).then(function (response) {
          self.data.replies.unshift(response.data.last_id);
          answer.isSaving = false;
          answer.replyOpen = false;
          answer.replyable = '';
          self.$nextTick(function () {
            self.resetErrors();
          });
          self.$forceUpdate();
        });
      }
    },
    resetErrors: function resetErrors() {
      var self = this;
      self.errors.clear();
    },
    formatDate: function formatDate(date) {
      return (0, _FormatDate2.default)(date);
    },
    handlePageChange: function handlePageChange(page) {
      var self = this;
      self.$router.replace({
        query: {
          page: page,
          per_page: self.per_page
        }
      });
    },
    loadData: function loadData(queryModel) {
      var fromToast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var self = this;
      if (!queryModel.softLoad) {
        _TitleManager2.default.setTitle(self.$t('message.loadingText'));
        self.isLoading = true;
      }

      if (fromToast === true) {
        self.isNewMessage = false;
      }

      _Discussion2.default.getDiscussionThread(self.$route.params.id, queryModel).then(function (response) {
        self.data = response.data.data;
        _TitleManager2.default.setTitle(self.data.question.question);
        self.isLoading = false;
        self.isSaving = false;
        self.model.answer = '';
        self.$nextTick(function () {
          self.resetErrors();
        });
      }).catch(function (error) {
        if (error.response.status === 404) {
          self.$router.push({
            name: '404'
          });
        }

        if (error.response.status === 403) {
          self.$router.push({
            name: 'QuestionsIndex'
          });
        }
      });
      setTimeout(function () {
        var repliesEl = document.getElementById('replies');
        if (!repliesEl) {
          return;
        }
        var anchors = repliesEl.getElementsByTagName('a');

        for (var i = 0; i < anchors.length; i++) {
          anchors[i].setAttribute('target', '_blank');
        }
      }, 500);
    },
    pluralizeUseful: function pluralizeUseful(count, liked) {
      var self = this;
      var plural = void 0;
      if (count === 1) {
        if (liked) plural = '<strong>' + self.$t('message.youText') + '</strong> ' + self.$t('message.threadSingleUseful');else plural = '<strong>' + count + '</strong>' + ' ' + self.$t('message.threadUseful');
      }
      if (count > 1) {
        if (liked) plural = '<strong>' + self.$t('message.youText') + '</strong> ' + self.$t('message.andText') + ' <strong> ' + (count - 1) + '</strong> ' + self.$t('message.discussionYouAndOthersFoundUseful');else plural = '<strong>' + count + '</strong>' + ' ' + self.$t('message.threadUsefulPlural');
      }
      return plural;
    },
    getInitialsFromName: function getInitialsFromName(name, delimeter) {
      if (name) {
        var array = name.split(delimeter);
        switch (array.length) {
          case 1:
            return array[0].charAt(0).toUpperCase();
            break;
          default:
            return array[0].charAt(0).toUpperCase() + array[array.length - 1].charAt(0).toUpperCase();
        }
      }
      return false;
    },
    deleteQuestion: function deleteQuestion(question_id) {
      var self = this;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveQuestionItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Discussion2.default.deleteQuestion(question_id);
        }
      }).then(function (response) {
        self.$router.push({
          name: 'QuestionsIndex'
        });
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveQuestionItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    setReported: function setReported() {
      var self = this;
      if (self.activeReport.type === 'THREAD_ANSWER') {
        var currentThread = self.data.replies.filter(function (item) {
          return item.answer_id === self.activeReport.type_id;
        })[0];
        currentThread.reported = true;
      } else {
        self.data.question.reported = true;
      }
      self.$forceUpdate();
    }
  },
  computed: {
    user: {
      get: function get() {
        var self = this;
        return self.$store.state.user;
      },
      set: function set() {
        var self = this;
        return self.$store.state.user;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(11)))

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

var _CreateQuestion = __webpack_require__(450);

var _CreateQuestion2 = _interopRequireDefault(_CreateQuestion);

var _TopContributors = __webpack_require__(1256);

var _TopContributors2 = _interopRequireDefault(_TopContributors);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _MyQuestions = __webpack_require__(3430);

var _MyQuestions2 = _interopRequireDefault(_MyQuestions);

var _SearchQuestions = __webpack_require__(1255);

var _SearchQuestions2 = _interopRequireDefault(_SearchQuestions);

__webpack_require__(947);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _ReportingMixin = __webpack_require__(486);

var _ReportingMixin2 = _interopRequireDefault(_ReportingMixin);

var _Reporting = __webpack_require__(664);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _badge = __webpack_require__(3364);

var _badge2 = _interopRequireDefault(_badge);

var _FormatDate = __webpack_require__(716);

var _FormatDate2 = _interopRequireDefault(_FormatDate);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuBadge: _badge2.default,
    SearchQuestions: _SearchQuestions2.default,
    MyQuestions: _MyQuestions2.default,
    TopContributors: _TopContributors2.default,
    CreateQuestion: _CreateQuestion2.default,
    ReportModal: _Reporting2.default
  },
  mixins: [_ScrollerMixin2.default, _ReportingMixin2.default, _HCPMixin2.default],
  data: function data() {
    return {
      isSearching: false,
      isLoading: true,
      rightTop: { horizontal: 'right', vertical: 'top' },
      dummyLoaders: [],
      categories: [],
      query: {
        page: 1,
        per_page: 25,
        type: "MOST_RECENT"
      },
      filterTypes: [{
        title: this.$t('message.discussionTabRecent'),
        type: "MOST_RECENT"
      }, {
        title: this.$t('message.discussionTabTrending'),
        type: "MOST_TRENDING"
      }, {
        title: this.$t('message.discussionTabUseful'),
        type: "MOST_USEFUL"
      }, {
        title: this.$t('message.discussionTabMyQuestions'),
        type: 'MY_QUESTIONS'
      }, {
        title: this.$t('message.discussionTabMyAnswers'),
        type: 'MY_ANSWERS'
      }, {
        title: this.$t('message.discussionTabUnanswered'),
        type: 'UNANSWERED'
      }],
      data: {},
      user: {
        user_id: 0
      },
      userAnswers: 0,
      userQuestions: 0
    };
  },

  watch: {
    '$route': function $route() {
      var self = this;
      self.getAmountNumbers();
      self.query.page = parseInt(self.$route.query.page ? self.$route.query.page : 1);
      self.query.type = self.$route.query.type ? self.$route.query.type : 'MOST_RECENT';
      self.query.q = self.$route.query.q ? self.$route.query.q : 'false';
      self.query.category = self.$route.query.category ? self.$route.query.category : null;

      var query = {};

      if (self.$route.query.type === 'CATEGORY') {
        query = {
          page: self.query.page,
          per_page: self.query.per_page,
          type: self.query.type,
          category: self.$route.query.category
        };
      } else {
        query = {
          page: self.query.page,
          per_page: self.query.per_page,
          type: self.query.type
        };
      }

      if (self.query.type === 'SEARCH') {
        self.isSearching = true;
        query.q = self.query.q;
      }

      if (self.isHcpView && self.query.type != 'SEARCH') {
        self.query.type = 'HCP';
        query.type = self.query.type;
        self.$router.push({
          name: 'QuestionsIndex'
        });
      } else {
        self.$router.replace({
          query: query
        });
      }

      self.loadData(query);
    },
    'query.category': function queryCategory() {
      var self = this;

      var query = {
        page: self.query.page,
        per_page: self.query.per_page,
        type: self.query.type,
        q: self.query.q,
        category: self.query.category
      };

      if (self.query.type !== 'CATEGORY') {

        query = {
          page: self.query.page,
          per_page: self.query.per_page,
          type: self.query.type,
          q: self.query.q
        };
      }

      if (self.isHcpView && self.query.type !== 'SEARCH' && self.query.type !== 'CATEGORY') {
        self.query.type = 'HCP';
        query.type = self.query.type;
        self.$router.push({
          name: 'QuestionsIndex'
        });
      } else {
        self.$router.replace({
          query: query
        });
      }
    },
    'query.type': function queryType() {
      var self = this;
      var query = {
        page: self.query.page,
        per_page: self.query.per_page,
        type: self.query.type,
        q: self.query.q,
        category: self.query.category
      };

      if (self.isHcpView && self.query.type != 'SEARCH') {
        self.query.type = 'HCP';
        query.type = self.query.type;
        self.$router.push({
          name: 'QuestionsIndex'
        });
      } else {
        self.$router.replace({
          query: query
        });
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.user = self.$store.state.user.scope;
    self.getAmountNumbers();

    if (self.isHcpView) {
      _TitleManager2.default.replaceTitle("Forum");
    }

    self.createDummyLoaders();

    self.$gtag.pageview('/questions');

    if (_.has(self.$route.query, 'page')) {
      self.query.page = parseInt(self.$route.query.page);
    }
    if (_.has(self.$route.query, 'type')) {
      self.query.type = self.$route.query.type || 'MOST_RECENT';
    }

    if (_.has(self.$route.query, 'category')) {
      self.query.category = self.$route.query.category;
    }

    if (_.has(self.$route.query, 'q')) {
      self.query.q = self.$route.query.q;
    }

    if (self.isHcpView) {
      self.query.type = 'HCP';
    }

    self.loadData(self.query);
  },

  methods: {
    getAmountNumbers: function getAmountNumbers() {
      var self = this;
      _User2.default.getUser().then(function (res) {
        self.userQuestions = res.data.stats.userQuestions;
        self.userAnswers = res.data.stats.userAnswers;
      });
    },
    upperCaseFirst: function upperCaseFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    setReported: function setReported() {
      var self = this,
          currentThread = void 0;
      if (self.activeReport.type === 'THREAD_QUESTION') {
        currentThread = self.data.questions.filter(function (item) {
          return item.question_id === self.activeReport.type_id;
        })[0];
      }
      currentThread.reported = true;
      self.$forceUpdate();
    },
    goToProfile: function goToProfile(url) {
      var self = this;
      self.$router.push({
        name: 'Profile',
        params: {
          profileUrl: url
        }
      });
    },
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.floor(Math.random() * (max - min) + min) + '%';
    },
    setCategory: function setCategory(item) {
      var self = this;
      self.$nextTick(function () {
        self.query.type = 'CATEGORY';
        self.query.category = item.id;
        self.query.page = 1;

        self.$router.replace({ query: self.query });
      });
    },
    setFilter: function setFilter(item) {
      var self = this;
      self.$nextTick(function () {
        self.query.type = item.type;
        self.query.page = 1;
        self.$router.replace({ query: self.query });
      });
    },
    hideQuestion: function hideQuestion(question, index) {
      var self = this;
      _Discussion2.default.hideQuestion(question.question_id).then(function (response) {
        var hidden = void 0,
            hiddenVal = response.data.message;
        hidden = hiddenVal === "Hidden";
        self.$nextTick(function () {
          question.hidden = hidden;
        });
      });
    },
    deleteQuestion: function deleteQuestion(question, index) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: "Are you sure?",
        text: "You are about to delete a question",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Discussion2.default.deleteQuestion(question.question_id);
        }
      }).then(function (response) {
        self.$alert({
          title: "Success!",
          text: "Question was deleted",
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
        self.data.questions.splice(index, 1);
      }.bind(self)).catch(self.$alert.noop);
    },
    createDummyLoaders: function createDummyLoaders() {
      var self = this;
      var dummyItems = self.query.per_page;
      for (var i = 0; i < dummyItems; i++) {
        self.dummyLoaders.push({});
      }
    },
    refresh: function refresh() {
      var self = this;
      self.query.page = 1;
      self.query.per_page = 10;
      self.query.type = 'MOST_RECENT';
      self.query.category = null;
      self.loadData(self.query);
      self.$router.replace({
        page: 1,
        type: "MOST_RECENT"
      });
    },
    askQuestion: function askQuestion() {
      var self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          name: 'Ask a question'
        });
      } else {
        self.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    encodeText: function encodeText(string) {
      return _HTMLStringParser2.default.encode(string);
    },
    handlePageChange: function handlePageChange(page) {
      var self = this;
      if (self.query.type === 'SEARCH') {
        self.$router.replace({
          query: {
            q: self.query.q,
            page: page,
            per_page: self.query.per_page,
            type: self.query.type
          }
        });
      } else {

        if (self.query.type === 'CATEGORY') {
          self.$router.replace({
            query: {
              page: page,
              type: self.query.type,
              per_page: self.query.per_page,
              category: self.$route.query.category
            }
          });
        } else {
          self.$router.replace({
            query: {
              page: page,
              type: self.query.type
            }
          });
        }
      }
    },
    loadData: function loadData(query) {
      var self = this;
      self.isLoading = true;
      if (_Discussion2.default.CancelRequests !== null) {
        _Discussion2.default.CancelRequests();
      }
      _Discussion2.default.getDiscussionQuestions(query).then(function (response) {
        self.data = response.data;
        self.isLoading = false;
        self.isSearching = false;
      }).catch(function (error) {});
    },
    goToQuestion: function goToQuestion(id) {
      var self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          path: '/questions/thread/' + id,
          query: {
            page: 1,
            per_page: 10
          }
        });
      } else {
        self.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    upperTwoInitials: function upperTwoInitials(displayName) {
      if (displayName.indexOf(' ') !== -1) {
        var splitString = displayName.split(' ');
        return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
      }
      return displayName.charAt(0).toUpperCase();
    },
    formatDate: function formatDate(date) {
      return (0, _FormatDate2.default)(date);
    }
  },

  computed: {
    isAuthAdmin: function isAuthAdmin() {
      var self = this;
      if (self.$store.state.user.scope) {
        return self.$store.state.user.user_role.role_id === 2;
      }
    },
    displayMessage: function displayMessage() {
      var self = this,
          message = "";
      if (self.data.total_questions === 0) {
        switch (self.query.type) {
          case "MY_ANSWERS":
            message = self.$t('message.discussionMyAnswersEmpty');
            break;
          case "MY_QUESTIONS":
            message = self.$t('message.discussionMyQuestionsEmpty');
            break;
          case "HCP":
            message = self.$t('message.discussionHcpEmpty');
            break;
        }
        return message;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _RecipeCard = __webpack_require__(345);

var _RecipeCard2 = _interopRequireDefault(_RecipeCard);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuCircularProgress: _circularProgress2.default,
    RecipeCard: _RecipeCard2.default
  },
  name: "RecipeCategory",
  data: function data() {
    return {
      loaderHeight: 0,
      isAppending: false,
      isLoading: true,
      query: {
        page: 0
      },
      lastResponse: [],
      data: {
        recipes: [],
        paginationInfo: {}
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.addScrollListener();

    _Account2.default.getUserPersonalization().then(function (response) {
      self.dietaryPreferenceId = response.data.dietry_preference_id;

      self.loaderHeight = $('.main-content').outerHeight();
      var category = self.$route.query;
      if (category.grouping === 'dietaryTypes') {
        self.query = {
          page: 0,
          limit: 15,
          dietaryTypes: category.route
        };
      }

      if (category.grouping === 'favorites') {
        self.query = {
          page: 0,
          limit: 15,
          search: category.route,
          dietaryTypes: self.dietaryTypesList().join(',')
        };
      }

      if (category.grouping === 'categories') {
        self.query = {
          page: 0,
          limit: 15,
          categories: category.route,
          dietaryTypes: self.dietaryTypesList().join(',')
        };
      }

      if (category.grouping === 'seasonal') {
        self.query = {
          page: 0,
          limit: 15,
          seasonal: category.route,
          dietaryTypes: self.dietaryTypesList().join(',')
        };
      }

      if (category.grouping === 'allergies') {
        self.query = {
          page: 0,
          limit: 500,
          suitabilities: category.route,
          dietaryTypes: self.dietaryTypesList().join(',')
        };
      }

      if (category.grouping !== 'allergies') {
        _Recipes2.default.search(self.query).then(function (response) {
          self.data = response.data;
          self.lastResponse = response.data.recipes;
          self.$nextTick(function () {
            self.isLoading = false;
          });
        });
      } else {
        _Recipes2.default.notingroupQuery(self.query).then(function (response) {
          self.data.recipes = response.data;
          self.lastResponse = response.data.recipes;
          self.$nextTick(function () {
            self.isLoading = false;
          });
        });
      }
    });
  },

  methods: {
    dietaryTypesList: function dietaryTypesList() {
      var self = this;
      switch (self.dietaryPreferenceId) {
        case 1:
          return ['Gluten-free', 'Iron rich', 'Ketogenic', 'Low GI', 'Organic', 'Paleolithic', 'Pescetarian', 'Raw Foods', 'Vegan', 'Vegetarian'];
        case 2:
          return ['Pescetarian'];
        case 3:
          return ['Vegetarian'];
        case 4:
          return ['Vegan'];
        default:
          return ['Gluten-free', 'Iron rich', 'Ketogenic', 'Low GI', 'Organic', 'Paleolithic', 'Pescetarian', 'Raw Foods', 'Vegan', 'Vegetarian'];
      }
    },
    loadMoreData: function loadMoreData() {
      var self = this;
      var category = self.$route.query;
      if (category.grouping === 'allergies') {} else {
        if (self.lastResponse.length !== 0) {
          self.query.page++;
          self.isAppending = true;
          self.$nextTick(function () {
            _Recipes2.default.search(self.query).then(function (response) {
              self.lastResponse = response.data.recipes;
              self.data.recipes.push.apply(self.data.recipes, response.data.recipes);
              self.data.paginationInfo = response.data.paginationInfo;
              self.$nextTick(function () {
                self.isAppending = false;
              });
            });
          });
        } else {
          self.isAppending = false;
        }
      }
    },
    addScrollListener: function addScrollListener() {
      var self = this;
      var element = document.getElementsByClassName('main-content')[0];
      element.addEventListener('scroll', self.handleScroll);
    },
    handleScroll: function handleScroll() {
      var self = this;
      if (_ScrollManager2.default.isElementInViewport(self.$refs['detector'])) {
        if (self.isAppending === false) {
          self.loadMoreData();
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    var element = document.getElementsByClassName('main-content')[0];
    element.removeEventListener('scroll', self.handleScroll);
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(3024);

__webpack_require__(2585);

__webpack_require__(2584);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _RecipeCard = __webpack_require__(345);

var _RecipeCard2 = _interopRequireDefault(_RecipeCard);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _contentBlock = __webpack_require__(227);

var _contentBlock2 = _interopRequireDefault(_contentBlock);

var _gsap = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuContentBlock: _contentBlock2.default,
    MuRaisedButton: _raisedButton2.default,
    RecipeCard: _RecipeCard2.default
  },
  name: "horizontal-scroller",
  props: ['recipes', 'title', 'linkTo', 'groupingType', 'groupingRoute'],
  data: function data() {
    return {
      id: this._uid,
      isHoverFocused: false,
      owl: null
    };
  },
  mounted: function mounted() {
    var self = this;
    self.box = (0, _jquery2.default)('#scrolling-recipe-' + self.id);
    self.$nextTick(function () {
      self.owl = self.box.owlCarousel({
        loop: false,
        nav: true,
        margin: 16,
        responsiveClass: true,
        navText: ['<button style="background: white;" class="mu-icon-button"><i class="material-icons" aria-hidden="true">keyboard_arrow_left</i></button>', '<button style="background: white;" class="mu-icon-button"><i class="material-icons" aria-hidden="true">keyboard_arrow_right</i></button>'],
        responsive: {
          0: {
            items: 2,
            slideBy: 2
          },
          800: {
            slideBy: 3,
            items: 3,
            stagePadding: 100
          },
          1000: {
            slideBy: 4,
            items: 4,
            stagePadding: 100
          },
          1100: {
            slideBy: 4,
            items: 4,
            stagePadding: 100
          },
          1024: {
            slideBy: 4,
            items: 4
          },
          1200: {
            slideBy: 3,
            items: 3,
            stagePadding: 100
          },
          1500: {
            items: 5,
            slideBy: 5,
            stagePadding: 100
          },
          10000: {
            items: 6,
            slideBy: 6,
            stagePadding: 100
          }
        },
        afterMove: function afterMove() {
          if (this.currentItem === this.maximumItem) {
            alert((0, _jquery2.default)('.owl-item').eq(this.maximumItem));
          }
        }
      });
      (0, _jquery2.default)(self.$el).on('keyup', self.onKeyboardEvent);
    });
  },

  methods: {
    addRecipeTween: function addRecipeTween(ev) {
      if (this.owl === null) {
        return false;
      }

      var el = ev.target;
      var parent = el.parentElement;
      if (!(0, _jquery2.default)(parent).hasClass('bringToFront')) {
        (0, _jquery2.default)(parent).addClass('bringToFront');
        _gsap.TweenMax.to(el.firstChild, .2, { scaleX: 1.1, scaleY: 1.1 });
      }
    },
    removeRecipeTween: function removeRecipeTween(ev) {
      if (this.owl === null) {
        return false;
      }

      var el = ev.target;
      var parent = el.parentElement;
      if ((0, _jquery2.default)(parent).hasClass('bringToFront')) {
        (0, _jquery2.default)(parent).removeClass('bringToFront');
        _gsap.TweenMax.to(el.firstChild, .2, { scaleX: 1, scaleY: 1 });
      }
    },
    addHoverFocus: function addHoverFocus() {
      var self = this;
      self.isHoverFocused = true;
      self.$nextTick(function () {
        self.$el.focus({
          preventScroll: true
        }, function () {
          return false;
        });
      }, 500);
      self.$forceUpdate();
    },
    removeHoverFocus: function removeHoverFocus() {
      var self = this;
      self.isHoverFocused = false;
      (0, _jquery2.default)(self.$el).blur();
      self.$forceUpdate();
    },
    goToGroupingCategory: function goToGroupingCategory() {
      var self = this;
      self.$router.push({
        name: 'RecipeCategory',
        query: {
          grouping: self.groupingType,
          route: self.groupingRoute
        }
      });
    },
    invalidateOldActiveTile: function invalidateOldActiveTile() {
      var self = this;
      var $scrollingWrapper = (0, _jquery2.default)('#scrolling-recipe-' + self.id + ' .owl-stage .owl-item');
      $scrollingWrapper.each(function (el, item) {
        var $item = $scrollingWrapper.eq(el);
        if ($item.hasClass('bringToFront')) {
          $item.removeClass('bringToFront');
          var firstChild = $scrollingWrapper.eq(el).find('.recipe-item')[0];
          _gsap.TweenMax.to(firstChild.firstChild, .2, { scaleX: 1, scaleY: 1, opacity: 1 });
        }
      });
    },
    onKeyboardEvent: function onKeyboardEvent(e) {
      var self = this;
      var key = e.keyCode ? e.keyCode : e.which;
      if (self.isHoverFocused) {
        switch (key) {
          case 68:
          case 39:
            self.invalidateOldActiveTile();
            self.owl.trigger('next.owl.carousel');
            break;
          case 65:
          case 37:
            self.invalidateOldActiveTile();
            self.owl.trigger('prev.owl.carousel');
            break;
        }
      }
      return false;
    }
  },

  beforeDestroy: function beforeDestroy() {
    var self = this;
    (0, _jquery2.default)(self.$el).off('keyup');
  }
};

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "multiple-image-uploader",
  props: {
    existingImages: {
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      id: null,
      images: [],
      imageUrls: []
    };
  },
  mounted: function mounted() {
    this.id = 'multi_uploader_' + this._uid;
  },

  methods: {
    onBtnClick: function onBtnClick() {
      var self = this;
      (0, _jquery2.default)('#' + self.id).click();
    },
    fileInputChanged: function fileInputChanged(e) {
      var self = this;
      self.images = [];
      self.imageUrls = [];

      var images = [];
      var imageUrls = [];

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files.length > 0) {
        var fl = files.length;

        var _loop = function _loop(i) {
          var reader = new FileReader();
          var file = files[i];
          reader.readAsDataURL(file);
          reader.onload = function (e) {
            var dataURI = e.target.result;
            if (dataURI) {
              images.push(dataURI);
              self.images.push(dataURI);

              self.$nextTick(function () {

                if (i === files.length - 1) {
                  self.$emit('uploading', true);
                  _axios2.default.post(_config2.default.apiUrl + 'uploader/files', {
                    files: images,
                    dimensions: {
                      width: 700,
                      height: 400
                    }
                  }).then(function (response) {
                    imageUrls = self.existingImages;
                    for (var imi = 0; imi < response.data.length; imi++) {
                      imageUrls.push(response.data[imi].secure_url);
                      self.imageUrls.push(response.data[imi].secure_url);
                      self.$emit('input', imageUrls);
                      self.$emit('uploading', false);
                    }
                  });
                }
              });
            }
          };
        };

        for (var i = 0; i < fl; i++) {
          _loop(i);
        }
      }
    }
  }
};

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "number-spinner",
  props: ['value', 'mode', 'icon'],
  data: function data() {
    return {
      numberValue: this.value
    };
  },
  mounted: function mounted() {
    this.numberValue = this.value;
  },

  methods: {
    increment: function increment() {
      this.numberValue++;
      this.$emit('input', this.numberValue);
    },
    decrement: function decrement() {
      if (this.numberValue !== 1) {
        this.numberValue--;
        this.$emit('input', this.numberValue);
      }
    }
  }
};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _imagesloaded = __webpack_require__(949);

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _RecipeRating = __webpack_require__(456);

var _RecipeRating2 = _interopRequireDefault(_RecipeRating);

var _chip = __webpack_require__(3368);

var _chip2 = _interopRequireDefault(_chip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuChip: _chip2.default,
    RecipeRating: _RecipeRating2.default
  },
  name: "recipe-card",
  props: ['recipe'],
  data: function data() {
    return {
      uid: this._uid,
      imageLoaded: false
    };
  },

  watch: {
    'recipe': 'runImageLoader'
  },
  mounted: function mounted() {
    this.runImageLoader();
  },

  computed: {
    oneCarbPortion: function oneCarbPortion() {
      var self = this;
      var carbValue = self.recipe.nutrition.carbohydrate.val,
          servings = self.recipe.servings;

      return carbValue * (1 / servings);
    }
  },
  methods: {
    goTo: function goTo(id) {
      var self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          name: 'RecipeDetail',
          params: {
            id: id
          }
        });
      } else {
        _EventBus2.default.$emit('App::triggerPaywall', true);
      }
    },
    isInt: function isInt(n) {
      return n % 1 === 0;
    },
    formatTime: function formatTime(ms) {
      var self = this;
      _moment2.default.relativeTimeThreshold('ss', 1000);
      _moment2.default.relativeTimeThreshold('s', 59);
      _moment2.default.relativeTimeThreshold('m', 59);
      _moment2.default.relativeTimeThreshold('h', 23);

      var totalMinutes = _moment2.default.duration(ms, 'milliseconds').asMinutes();
      var hours = parseInt(totalMinutes / 60);
      var minutes = parseInt(totalMinutes - hours * 60);

      if (self.isInt(hours) && parseInt(minutes) === 0) {
        return hours + 'h';
      }
      if (hours < 1 && minutes > 0) {
        return minutes + ' min';
      }
      if (hours >= 1 && minutes >= 1) {
        return hours + 'h ' + minutes + ' min';
      }
    },
    runImageLoader: function runImageLoader() {
      var self = this;
      (0, _imagesloaded2.default)((0, _jquery2.default)('.imgloadContainer_' + self.uid), function () {

        self.imageLoaded = true;
      });
    }
  }
};

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "recipe-rating",
  props: {
    rating: {
      type: Number,
      default: 0
    },
    userRating: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    },
    recipe: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    'rating': 'countInit',
    'count': 'countInit'
  },
  data: function data() {
    return {
      hoverRating: -1,
      maxRating: 5,
      currentRating: 0,
      currentCount: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    self.currentRating = parseInt(self.rating);
    self.currentCount = parseInt(self.count);
  },

  methods: {
    calcStars: function calcStars(id) {
      var self = this;
      if (self.currentRating === 0) {
        return 'gold';
      } else {
        return self.currentRating < id + 1 ? '#CCCCCC' : 'gold';
      }
    },
    countInit: function countInit() {
      this.currentRating = parseInt(this.rating);
      this.currentCount = parseInt(this.count);
    },
    onClick: function onClick(ratingIndex) {
      var self = this;
      if (self.readOnly !== true) {
        var model = {
          recipe_id: self.recipe.id,
          rating: ratingIndex + 1
        };
        _Recipes2.default.rate(model).then(function (response) {
          self.$emit('ratingPicked', response.data);
        });
      }
    },
    onMouseOver: function onMouseOver(ratingIndex) {
      if (this.readOnly !== true) {
        this.hoverRating = ratingIndex;
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (this.readOnly !== true) {
        this.hoverRating = -1;
      }
    }
  }
};

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(358);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(489);

var _extends5 = _interopRequireDefault(_extends4);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _MultipleImageUploader = __webpack_require__(3525);

var _MultipleImageUploader2 = _interopRequireDefault(_MultipleImageUploader);

var _RecipeRating = __webpack_require__(456);

var _RecipeRating2 = _interopRequireDefault(_RecipeRating);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuCircularProgress: _circularProgress2.default,
    MuRaisedButton: _raisedButton2.default,
    RecipeRating: _RecipeRating2.default,
    MultipleImageUploader: _MultipleImageUploader2.default
  },
  name: "recipe-reviews",
  props: ['recipe'],
  data: function data() {
    return {
      isImagesUploading: false,
      isAppending: false,
      isSaving: false,
      images: [],
      reviews: {
        paginationInfo: {
          actualPage: 0,
          itemsPerPage: 5,
          totalPages: 0,
          totalItems: 0
        },
        data: []
      },
      commentModel: {
        body: ""
      },
      editableReviewModel: {},
      editableCommentModel: {},
      reviewAdded: false,
      model: {
        recipe_id: null,
        images: [],
        updateImages: []
      },
      showReply: "Show reply box",
      hideReply: "Hide reply box",
      imgModal: false,
      isImagesUploadingForUpdate: false,
      imgModalSrc: null
    };
  },

  watch: {
    '$route': 'getReviews',
    'recipe': 'getReviews'
  },
  mounted: function mounted() {
    var self = this;
    self.getReviews();
  },

  methods: {
    openImg: function openImg(img) {
      this.imgModalSrc = img;
      this.imgModal = true;
    },
    closeImg: function closeImg() {
      this.imgModal = false;
      this.imgModalSrc = null;
    },
    showReplyBlock: function showReplyBlock(item) {
      item.isReplyOpen = !item.isReplyOpen;
      this.$forceUpdate();
    },
    showUpdateCommentBlock: function showUpdateCommentBlock(comments) {
      comments.isUpdateCommentOpen = !comments.isUpdateCommentOpen;
      this.editableCommentModel = (0, _extends5.default)({}, this.editableCommentModel, (0, _defineProperty3.default)({}, "" + comments.id, comments.body));
      this.$forceUpdate();
    },
    showUpdateReviewBlock: function showUpdateReviewBlock(item) {
      item.isUpdateReviewOpen = !item.isUpdateReviewOpen;
      if (item.isUpdateReviewOpen) {
        this.model.updateImages = item.images;
        this.editableReviewModel = (0, _extends5.default)({}, this.editableReviewModel, (0, _defineProperty3.default)({}, "" + item.id, {
          "review": item.review,
          "isSaving": false
        }));
      }
      this.$forceUpdate();
    },
    fromNow: function fromNow(time) {
      return _moment2.default.utc(time).local().fromNow();
    },
    upperTwoInitials: function upperTwoInitials(displayName) {
      if (typeof displayName !== 'string') {
        return 'N/A';
      }

      if (displayName.length === 0) {
        return 'N/A';
      }

      return displayName.charAt(0).toUpperCase();
    },
    removeReview: function removeReview(review) {
      var self = this;
      var index = self.reviews.data.indexOf(review);
      self.$alert({
        title: "Are you sure?",
        text: "You are about to delete your recipe review",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Recipes2.default.deleteReview(review.id);
        }
      }).then(function () {
        self.$alert({
          title: "Success!",
          text: "Review was deleted",
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
        self.reviews.data.splice(index, 1);
        self.$nextTick(function () {
          self.$forceUpdate();
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    deleteComment: function deleteComment(id, item) {
      var self = this;
      var index = item.comments.findIndex(function (x) {
        return x.id == id;
      });

      self.$alert({
        title: "Are you sure?",
        text: "You are about to delete your comment",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Recipes2.default.deleteReviewComment(id);
        }
      }).then(function () {
        self.$alert({
          title: "Success!",
          text: "Comment was deleted",
          type: "success",
          showCancelButton: false,
          confirmButtonColour: "white"
        });
        item.comments.splice(index, 1);
        self.$forceUpdate();
      });
    },
    addComment: function addComment(item) {
      var self = this;
      if (self.commentModel.body) {
        _Recipes2.default.postReviewComment(item.id, self.commentModel).then(function (res) {
          if (item.comments === undefined) {
            item.comments = [res.data];
          } else {
            item.comments.push(res.data);
          }
          self.$nextTick(function () {
            self.$forceUpdate();
            self.commentModel.body = "";
          });
        });
      } else {
        alert('Please add a comment');
      }
    },
    getReviews: function getReviews() {
      var self = this;
      self.reviews.paginationInfo.actualPage++;
      self.isAppending = true;
      _Recipes2.default.reviews(self.recipe.id, {
        page: self.reviews.paginationInfo.actualPage,
        limit: self.reviews.paginationInfo.itemsPerPage
      }).then(function (response) {
        self.reviews.paginationInfo = response.data.paginationInfo;
        self.reviews.data.push.apply(self.reviews.data, response.data.data);

        self.reviews.data.forEach(function (item) {
          item.isReplyOpen = false;
          item.addedByCurrentUser = false;
        });

        self.$nextTick(function () {
          self.isAppending = false;
        });
      });
    },
    submitForm: function submitForm() {
      var self = this;

      self.model.recipe_id = self.recipe.id;
      if (self.model.review == null || self.model.review.trim() === "") {
        alert('Please add a recipe review');
      } else {

        self.isSaving = true;
        _Recipes2.default.review(self.model).then(function (response) {
          self.isSaving = false;
          self.reviews.data.unshift(response.data);
          self.$forceUpdate();
          self.model.images = [];
          self.model.review = null;
          self.reviewAdded = true;
        }).catch(function (error) {
          self.isSaving = false;
        });
      }
    },
    onRatingPicked: function onRatingPicked(rating) {
      this.$emit('ratingPicked', rating);
    },
    onUploading: function onUploading(state) {
      this.isImagesUploading = state;
    },
    onUploadingForUpdate: function onUploadingForUpdate(state) {
      this.isImagesUploadingForUpdate = state;
    },
    editComment: function editComment(comments) {
      this.showUpdateCommentBlock(comments);
    },
    updateComment: function updateComment(comments) {
      var _this = this;

      var self = this;
      if (self.editableCommentModel[comments.id]) {
        _Recipes2.default.updateReviewComment(comments.id, { body: self.editableCommentModel[comments.id] }).then(function (res) {
          comments.body = self.editableCommentModel[comments.id];
          _this.showUpdateCommentBlock(comments);
        });
      }
    },
    editReview: function editReview(item) {
      this.showUpdateReviewBlock(item);
    },
    updateReview: function updateReview(item) {
      var _this2 = this;

      var self = this;

      if (self.editableReviewModel[item.id].review == null || self.editableReviewModel[item.id].review.trim() === "") {
        alert('Please add a recipe review');
      } else {
        var updateReviewModel = {
          review: self.editableReviewModel[item.id].review
        };

        if (self.model.updateImages.length > 0) {
          updateReviewModel["images"] = self.model.updateImages;
        } else {
          updateReviewModel["images"] = item.images;
        }
        self.editableReviewModel[item.id].isSaving = true;
        _Recipes2.default.updateReview(item.id, updateReviewModel).then(function (response) {
          self.editableReviewModel[item.id].isSaving = false;
          item.review = self.editableReviewModel[item.id].review;
          if (self.model.updateImages.length > 0) {
            item.images = self.model.updateImages;
          }
          _this2.showUpdateReviewBlock(item);
          self.model.updateImages = [];
          self.editableReviewModel[item.id].review = null;
        }).catch(function (error) {
          self.editableReviewModel[item.id].isSaving = false;
        });
      }
    },
    removeImage: function removeImage(item, index) {
      item.images.splice(index, 1);
    }
  }
};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2583);

var _vueClickaway = __webpack_require__(338);

var _gsap = __webpack_require__(126);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _Timings = __webpack_require__(731);

var _Timings2 = _interopRequireDefault(_Timings);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _Rx = __webpack_require__(91);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  directives: {
    onClickaway: _vueClickaway.directive
  },
  components: {
    MuCircularProgress: _circularProgress2.default,
    MuRaisedButton: _raisedButton2.default
  },
  name: "recipe-search-header",
  mixins: [_Timings2.default],
  data: function data() {
    return {
      isSearching: false,
      isAutoCompleteOpen: false,
      suggestionIndex: 0,
      suggestions: [],
      params: {
        q: null
      }
    };
  },
  mounted: function mounted() {
    var self = this;
  },

  methods: {
    onItemMouseover: function onItemMouseover(index) {
      this.suggestionIndex = index;
    },
    onBlur: function onBlur() {
      this.isAutoCompleteOpen = false;
    },
    onFocus: function onFocus() {
      this.isAutoCompleteOpen = true;
    },
    handleDirectionalKey: function handleDirectionalKey(direction) {
      var self = this;
      if (self.suggestions.length > 0) {
        if (direction === 'up') {
          self.isAutoCompleteOpen = true;
          if (self.suggestionIndex !== 0) {
            self.suggestionIndex--;
            self.$nextTick(function () {
              TweenLite.to((0, _jquery2.default)('.suggestions'), 0.2, {
                scrollTo: {
                  y: (0, _jquery2.default)('.item.active')
                }
              });
            });
          } else {
            self.suggestionIndex = self.suggestions.length - 1;
            self.$nextTick(function () {
              TweenLite.to((0, _jquery2.default)('.suggestions'), 0.2, {
                scrollTo: {
                  y: (0, _jquery2.default)('.item.active')
                }
              });
            });
          }
        }
        if (direction === 'down') {
          self.isAutoCompleteOpen = true;
          if (self.suggestionIndex !== self.suggestions.length - 1) {
            self.suggestionIndex++;
            self.$nextTick(function () {
              TweenLite.to((0, _jquery2.default)('.suggestions'), 0.2, {
                scrollTo: {
                  y: (0, _jquery2.default)('.item.active')
                }
              });
            });
          } else {
            self.suggestionIndex = 0;
            self.$nextTick(function () {
              TweenLite.to((0, _jquery2.default)('.suggestions'), 0.2, {
                scrollTo: {
                  y: (0, _jquery2.default)('.item.active')
                }
              });
            });
          }
        }
      }
    },
    handleDebouncedText: function handleDebouncedText(eventText) {
      var self = this;
      self.suggestionIndex = 0;
      self.isAutoCompleteOpen = true;
      _axios2.default.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/title?filter=" + eventText).then(function (response) {
        self.suggestions = response.data;
      });
    },
    loadTypes: function loadTypes() {
      var self = this;
      _axios2.default.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/utilities/alloptions").then(function (response) {
        self.$store.commit('setRecipeCategories', {
          suitabilities: response.data.suitabilities,
          dietaryTypes: response.data.dietaryTypes,
          cuisines: response.data.cuisines,
          occasions: response.data.occasions,
          categories: response.data.categories
        });
      });
    },
    submitSearch: function submitSearch() {
      var self = this;
      var queryParams = {
        search: self.params.q,
        page: 0,
        limit: 15
      };
      if (self.suggestions.length > 0) {
        self.isSearching = true;
        self.isAutoCompleteOpen = false;
        var title = self.suggestions[self.suggestionIndex].title;
        self.params.q = title;
        _Recipes2.default.search({
          search: title,
          page: 0,
          limit: 15
        }).then(function (response) {
          self.$store.commit('setRecipeFilter', queryParams);
          self.$router.push({
            name: 'RecipeSearchResults',
            query: {
              search: title,
              page: 0,
              limit: 15
            },
            params: {
              data: response.data,
              filterModel: queryParams
            }
          });
        });
      } else {
        self.isAutoCompleteOpen = false;
        self.isSearching = true;
        _Recipes2.default.search({
          search: self.params.q,
          page: 0,
          limit: 15
        }).then(function (response) {
          self.$store.commit('setRecipeFilter', queryParams);
          self.$router.push({
            name: 'RecipeSearchResults',
            query: {
              search: self.params.q,
              page: 0,
              limit: 15
            },
            params: {
              data: response.data,
              filterModel: queryParams
            }
          });
        });
      }
    },
    goFavorites: function goFavorites() {
      this.$router.push({
        name: 'RecipeFavorites'
      });
    },
    goSearch: function goSearch() {
      this.$router.push({
        name: 'RecipeSearch'
      });
    }
  }
};

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(233);

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _HorizontalScroller = __webpack_require__(1274);

var _HorizontalScroller2 = _interopRequireDefault(_HorizontalScroller);

var _NumberSpinner = __webpack_require__(3526);

var _NumberSpinner2 = _interopRequireDefault(_NumberSpinner);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _RecipeRating = __webpack_require__(456);

var _RecipeRating2 = _interopRequireDefault(_RecipeRating);

var _RecipeReviews = __webpack_require__(3527);

var _RecipeReviews2 = _interopRequireDefault(_RecipeReviews);

var _imagesloaded = __webpack_require__(949);

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

var _listItem = __webpack_require__(1236);

var _listItem2 = _interopRequireDefault(_listItem);

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

var _DateTimePicker = __webpack_require__(67);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _selectField = __webpack_require__(661);

var _selectField2 = _interopRequireDefault(_selectField);

var _textField = __webpack_require__(228);

var _textField2 = _interopRequireDefault(_textField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuTextField: _textField2.default,
    MuSelectField: _selectField2.default,
    DatePicker: _DateTimePicker2.default,
    MuListItem: _listItem2.default,
    MuCircularProgress: _circularProgress2.default,
    RecipeReviews: _RecipeReviews2.default,
    RecipeRating: _RecipeRating2.default,
    NumberSpinner: _NumberSpinner2.default,
    HorizontalScroller: _HorizontalScroller2.default
  },
  name: "detail",
  data: function data() {
    return {
      isRecipeSaving: false,
      model: {
        mealTypeId: 1,
        recipeId: null,
        date: moment().format(),
        servings: 1
      },
      mealTypes: [{
        value: 1,
        label: this.$t('message.foodDiaryBreakfast')
      }, {
        value: 2,
        label: this.$t('message.foodDiaryLunch')
      }, {
        value: 3,
        label: this.$t('message.foodDiaryDinner')
      }, {
        value: 4,
        label: this.$t('message.foodDiarySnack')
      }],
      isFoodDiaryDialogOpen: false,
      imageLoaderHeight: 0,
      loaderHeight: 0,
      isLoading: true,
      imageLoaded: false,
      recipe: {
        userFavorites: false
      },
      instructions: [],
      refresh: true,
      hideUl: false,
      servings: 1,
      playerOptions: {
        muted: false,
        fluid: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
        }],
        poster: "/static/images/author.jpg"
      },
      similarRecipes: { recipes: [] }
    };
  },

  watch: {
    '$route': 'getData'
  },
  methods: {
    printRecipe: function printRecipe() {
      var self = this;
      window.open('https://recipe-gen.lowcarbprogram.com/generateFile/' + self.recipe.id);
    },
    parseHtmlEncoding: function parseHtmlEncoding(html) {
      return _HTMLStringParser2.default.encode(html);
    },
    onDialogClose: function onDialogClose() {
      this.isRecipeSaving = false;
      this.isFoodDiaryDialogOpen = false;
    },
    openAddToDiaryModal: function openAddToDiaryModal() {
      this.isFoodDiaryDialogOpen = true;
    },
    addToFoodDiary: function addToFoodDiary() {
      var self = this;
      self.model.recipeId = self.recipe.id;
      self.isRecipeSaving = true;

      _Recipes2.default.addToFoodDiary(self.model).then(function () {
        self.onDialogClose();
        var timer = setTimeout(function () {
          self.$alert({
            title: self.$t('message.labelSuccess'),
            text: self.$t('message.recipeAddedToDiary'),
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "white"
          });
          clearTimeout(timer);
        }, 500);
      }).catch(function (error) {});
    },
    onFavorite: function onFavorite() {
      var self = this;
      _Recipes2.default.favorite(self.recipe.id).then(function (response) {
        var data = response.data;
        self.recipe.userFavorites = data.favorite;
      });
    },
    onRatingPicked: function onRatingPicked(rating) {
      this.recipe.rating = rating;
      this.$forceUpdate();
    },
    getData: function getData() {
      var self = this;
      self.isLoading = true;

      self.imageLoaded = false;
      _TitleManager2.default.setTitle(self.$t('message.loadingText'));
      _Recipes2.default.getById(self.$route.params.id).then(function (response) {
        self.recipe = response.data;
        self.$nextTick(function () {

          self.model.servings = self.recipe.servings;

          _TitleManager2.default.setTitle(response.data.title);
          self.similarRecipes.recipes = [];

          if (self.recipe.video_url !== null) {
            self.playerOptions.poster = self.recipe.recipePhotoLargeUri;
            self.playerOptions.sources = [{
              type: 'video/mp4',
              src: self.recipe.video_url
            }];
          }

          var occasions = [];
          var suitabilities = [];
          var dietaryTypes = [];

          var query = {
            page: 0,
            limit: 25
          };
          self.recipe.occasions.forEach(function (item) {
            occasions.push(item.label);
          });
          if (occasions.length > 0) {
            (0, _assign2.default)(query, {
              occasions: occasions.join(',')
            });
          }

          self.recipe.suitabilities.forEach(function (item) {
            suitabilities.push(item.label);
          });
          if (suitabilities.length > 0) {
            (0, _assign2.default)(query, {
              suitabilities: suitabilities.join(',')
            });
          }

          self.recipe.dietaryTypes.forEach(function (item) {
            dietaryTypes.push(item.label);
          });
          if (dietaryTypes.length > 0) {
            (0, _assign2.default)(query, {
              dietaryTypes: dietaryTypes.join(',')
            });
          }

          self.$nextTick(function () {
            self.isLoading = false;

            (0, _imagesloaded2.default)((0, _jquery2.default)('.imgLoadContainer'), function () {
              setTimeout(function () {
                self.imageLoaded = true;
                self.$forceUpdate();
              }.bind(self), 500);
            });

            self.$forceUpdate();

            _Recipes2.default.group(query).then(function (response) {
              self.similarRecipes = response.data;
            });
            var cookingInstructions = [];
            var $listContainer = (0, _jquery2.default)('.cookingInstructions ul li');
            $listContainer.each(function (item, el) {
              var text = (0, _jquery2.default)(this).eq(item).prevObject[0].outerText;
              if (text !== "" && text !== undefined && text !== null) {
                cookingInstructions.push(text);
                self.instructions = cookingInstructions;
                self.servings = self.recipe.servings;
              }
            });
          });
        });
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    var loaderHeight = (0, _jquery2.default)('.main-content').outerHeight();
    self.loaderHeight = loaderHeight;
    self.getData();
  },

  computed: {
    ingredients: function ingredients() {
      var self = this;
      var copyIngredients = JSON.parse((0, _stringify2.default)(self.recipe.ingredients));
      for (var key in copyIngredients) {
        if (!copyIngredients.hasOwnProperty(key)) continue;
        var obj = copyIngredients[key];
        if (_lodash2.default.has(obj, 'portionQuantity') && _lodash2.default.has(obj, 'portionValue')) {
          obj.portionValueOriginal = obj.portionValue;
          obj.computedQuantity = obj.portionQuantity * self.servings / self.recipe.servings;
        }
      }
      return copyIngredients;
    },
    nutrition: function nutrition() {
      var self = this;
      var copyNutrition = JSON.parse((0, _stringify2.default)(self.recipe.nutrition));
      for (var key in copyNutrition) {
        if (!copyNutrition.hasOwnProperty(key)) continue;
        var obj = copyNutrition[key];
        if (_lodash2.default.has(obj, 'val')) {
          obj.val = obj.val / self.recipe.servings * self.servings;
        }
      }
      return copyNutrition;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _RecipeCard = __webpack_require__(345);

var _RecipeCard2 = _interopRequireDefault(_RecipeCard);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { RecipeCard: _RecipeCard2.default },
  name: "recipe-favorites",
  data: function data() {
    return {
      isLoading: true,
      recipeData: {
        recipes: []
      },
      loaderHeight: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    self.getFavorites();
    var loaderHeight = (0, _jquery2.default)('.main-content').outerHeight();
    self.loaderHeight = loaderHeight;
  },

  methods: {
    getFavorites: function getFavorites() {
      var self = this;
      if (_Recipes2.default.CancelRequests !== null) {
        _Recipes2.default.CancelRequests();
      }

      _Recipes2.default.getFavorites().then(function (response) {
        self.recipeData = response.data;
        self.isLoading = false;
      }).catch(function (err) {
        setTimeout(function () {
          self.getFavorites();
        }, 5000);
      });
    }
  }
};

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(234);

var _promise2 = _interopRequireDefault(_promise);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _RecipeCard = __webpack_require__(345);

var _RecipeCard2 = _interopRequireDefault(_RecipeCard);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _RecipeSearchHeader = __webpack_require__(3528);

var _RecipeSearchHeader2 = _interopRequireDefault(_RecipeSearchHeader);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Timings = __webpack_require__(731);

var _Timings2 = _interopRequireDefault(_Timings);

var _HorizontalScroller = __webpack_require__(1274);

var _HorizontalScroller2 = _interopRequireDefault(_HorizontalScroller);

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HorizontalScroller: _HorizontalScroller2.default,
    RecipeSearchHeader: _RecipeSearchHeader2.default,
    RecipeCard: _RecipeCard2.default
  },
  mixins: [_Timings2.default],
  name: "recipes-index",
  data: function data() {
    return {
      scroller: document.getElementsByClassName('main-content')[0],
      dietaryPreferenceId: 0,
      loaderHeight: 0,
      isLoading: true,
      isAppending: false,
      lists: {},
      recipeLimit: 15,
      timely: {
        recipes: []
      },
      seasonal: {
        christmas: [],
        easter: [],
        thanksgiving: [],
        halloween: [],
        diwali: []
      },
      cuisines: {
        recipes: []
      },
      allergiesExcluded: {
        recipes: []
      },
      dietaryTypes: {
        recipes: []
      },
      favoriteBased: {
        recipes: []
      },
      favorites: [],
      favoriteFoodsCsv: "",
      allergyCsv: ""
    };
  },

  watch: {
    isLoading: function isLoading() {
      if (this.isLoading === false) {
        $('.main-content').attr('style', 'overflow-y: scroll');
      }
    },
    '$route': {
      immediate: true,
      handler: function handler() {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    var element = document.getElementsByClassName('main-content')[0];
    element.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      if (_ScrollManager2.default.isElementInViewport(this.$refs['scroll-detector'])) {
        if (this.isAppending === false) {
          this.loadCuisines();
        }
      }
    },
    init: function init() {
      var self = this;
      self.lists = self.$store.state.list;

      $('.main-content').attr('style', 'overflow-y: hidden');

      var loaderHeight = $('.main-content').outerHeight();
      self.loaderHeight = loaderHeight;

      var allergies = self.lists.allergies;

      var loadAll = function loadAll() {
        _User2.default.getFavouriteFoods().then(function (response) {
          var foods = [];
          for (var i = 0; i < response.data.length; i++) {
            foods.push(response.data[i].food_name);
          }
          self.favorites = foods;

          var favoriteFoodsAsString = self.favorites.join(' ');
          self.favoriteFoodsCsv = favoriteFoodsAsString;

          _Recipes2.default.search({
            page: 0,
            limit: self.recipeLimit,
            dietaryTypes: self.dietaryTypesList().join(','),
            suitabilities: self.allergyCsv,
            favorite: true,
            search: favoriteFoodsAsString,
            shuffle: true
          }).then(function (response) {
            self.favoriteBased = response.data;

            self.loadTimely().then(function () {
              if (self.isDiwali === true) {
                _Recipes2.default.search({
                  page: 0,
                  limit: self.recipeLimit,
                  occasions: 'diwali',
                  suitabilities: self.allergyCsv,
                  dietaryTypes: self.dietaryTypesList().join(','),
                  shuffle: true
                }).then(function (response) {
                  self.seasonal.diwali = response.data.recipes;
                });
              }

              if (self.isEaster === true) {
                _Recipes2.default.search({
                  page: 0,
                  limit: self.recipeLimit,
                  occasions: 'easter',
                  dietaryTypes: self.dietaryTypesList().join(','),
                  suitabilities: self.allergyCsv,
                  shuffle: true
                }).then(function (response) {
                  self.seasonal.easter = response.data.recipes;
                });
              }

              if (self.isChristmas === true) {
                _Recipes2.default.search({
                  page: 0,
                  limit: self.recipeLimit,
                  occasions: 'christmas',
                  dietaryTypes: self.dietaryTypesList().join(','),
                  shuffle: true
                }).then(function (response) {
                  self.seasonal.christmas = response.data.recipes;
                });
              }

              if (self.isThanksGiving) {
                _Recipes2.default.search({
                  occasions: 'thanksgiving',
                  page: 0,
                  limit: self.recipeLimit,
                  dietaryTypes: self.dietaryTypesList().join(','),
                  suitabilities: self.allergyCsv,
                  shuffle: true
                }).then(function (response) {
                  self.seasonal.thanksgiving = response.data.recipes;
                });
              }

              if (self.isHalloween) {
                _Recipes2.default.search({
                  occasions: 'halloween',
                  page: 0,
                  limit: self.recipeLimit,
                  dietaryTypes: self.dietaryTypesList().join(','),
                  suitabilities: self.allergyCsv,
                  shuffle: true
                }).then(function (response) {
                  self.seasonal.halloween = response.data.recipes;
                });
              }

              self.loadDietaryTypes();
            });
          });
        });
      };

      _Account2.default.getUserPersonalization().then(function (response) {
        self.dietaryPreferenceId = response.data.dietry_preference_id;
        var allergyStrings = [];
        if (response.data.allergies.length === 0) {
          loadAll();
        } else {
          var _loop = function _loop(i) {
            var foundAllergy = allergies.filter(function (item) {
              return item.allergy_id === response.data.allergies[i];
            });

            if (foundAllergy.length > 0) {
              allergyStrings.push(foundAllergy[0].name);
            }
          };

          for (var i = 0; i < response.data.allergies.length; i++) {
            _loop(i);
          }

          self.allergyCsv = allergyStrings.join(',');

          _Recipes2.default.search({
            page: 0,
            limit: self.recipeLimit,
            suitabilities: allergyStrings.join(','),
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true
          }).then(function (response) {
            self.allergiesExcluded.recipes = response.data.recipes;

            self.$nextTick(function () {
              loadAll();
            });
          });
        }
      });
    },
    cuisinesList: function cuisinesList() {
      return ["African", "American", "British", "Caribbean", "Chinese", "French", "Greek", "Iberian", "Indian", "Irish", "Italian", "Japanese", "Mediterranean", "Mexican", "Moroccan", "Nordic", "Portuguese", "South", "American", "Spanish", "Thai", "Turkish", "Vietnamese"];
    },
    loadCuisines: function loadCuisines() {
      var self = this;
      self.isAppending = true;
      _Recipes2.default.group({
        'limit': self.recipeLimit,
        'type': 'cuisines',
        'cuisines': self.cuisinesList().join(','),
        'filterSuitabilities': self.allergyCsv,
        'dietaryTypes': self.dietaryTypesList().join(','),
        'shuffle': true
      }).then(function (response) {
        self.isAppending = false;
        self.$forceUpdate();
        self.$nextTick(function () {
          self.cuisines.recipes = response.data.recipes;
        });
      });
    },
    dietaryTypesList: function dietaryTypesList() {
      var self = this;
      switch (self.dietaryPreferenceId) {
        case 1:
          return ['Gluten-free', 'Iron rich', 'Ketogenic', 'Low GI', 'Organic', 'Paleolithic', 'Pescetarian', 'Raw Foods', 'Vegan', 'Vegetarian'];
        case 2:
          return ['Pescetarian'];
        case 3:
          return ['Vegetarian'];
        case 4:
          return ['Vegan'];
        default:
          return ['Gluten-free', 'Iron rich', 'Ketogenic', 'Low GI', 'Organic', 'Paleolithic', 'Pescetarian', 'Raw Foods', 'Vegan', 'Vegetarian'];
      }
    },
    loadDietaryTypes: function loadDietaryTypes() {
      var self = this;
      _Recipes2.default.group({
        'type': 'dietaryTypes',
        'dietaryTypes': self.dietaryTypesList().join(','),
        'filterSuitabilities': self.allergyCsv,
        'page': 0,
        'limit': self.recipeLimit,
        'shuffle': true
      }).then(function (response) {
        self.dietaryTypes = response.data;
        self.isLoading = false;
      });
    },
    loadTimely: function loadTimely() {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        if (self.isBreakfast) {
          _Recipes2.default.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'breakfast',
            dietaryTypes: self.dietaryTypesList().join(','),
            suitabilities: self.allergyCsv,
            shuffle: true
          }).then(function (response) {
            self.timely = response.data;
            resolve();
          }).catch(function () {
            reject();
          });
        }
        if (self.isLunch) {
          _Recipes2.default.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'lunch',
            suitabilities: self.allergyCsv,
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true

          }).then(function (response) {
            self.timely = response.data;
            resolve();
          }).catch(function () {
            reject();
          });
        }
        if (self.isDinner) {
          _Recipes2.default.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'dinner',
            suitabilities: self.allergyCsv,
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true
          }).then(function (response) {
            self.timely = response.data;
            resolve();
          }).catch(function () {
            reject();
          });
        }
        if (self.isNight) {
          _Recipes2.default.search({
            page: 0,
            limit: self.recipeLimit,
            categories: 'breakfast',
            suitabilities: self.allergyCsv,
            dietaryTypes: self.dietaryTypesList().join(','),
            shuffle: true
          }).then(function (response) {
            self.timely = response.data;
            resolve();
          }).catch(function () {
            reject();
          });
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    $('.main-content').attr('style', '');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _mealPlanPanel = __webpack_require__(1275);

var _mealPlanPanel2 = _interopRequireDefault(_mealPlanPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { MealPlanPanel: _mealPlanPanel2.default },
  name: "meal-plan-detail",
  data: function data() {
    return {
      dialogOpen: false,
      readonly: true,
      activeDay: null,
      data: false,
      target: false,
      custom: {
        name: null
      }
    };
  },

  watch: {
    '$route': function $route() {
      var self = this;
      _Recipes2.default.getMealPlanById(self.$route.params.id).then(function (response) {
        self.activeDay = response.data.availableDays[0];
        self.data = response.data;
      }).catch(function (error) {
        self.$router.push({
          name: 'RecipeMealPlans'
        });
      });
    }
  },
  methods: {
    saveMealPlan: function saveMealPlan() {
      var self = this;

      var model = self.data;
      model.name = self.custom.name;

      _Recipes2.default.addMealPlan(model).then(function (response) {
        self.custom.name = "";
        self.dialogOpen = false;
        self.readonly = true;
        self.$router.push({
          name: 'MealPlanDetail',
          params: {
            id: response.data.id
          }
        });
      });
    },
    openModal: function openModal() {
      this.dialogOpen = true;
    },
    toggleReadonly: function toggleReadonly() {
      var self = this;
      self.readonly = !self.readonly;

      if (self.readonly === true) {
        _Recipes2.default.getMealPlanById(self.$route.params.id).then(function (response) {
          self.activeDay = response.data.availableDays[0];
          self.data = response.data;
        }).catch(function (error) {
          self.$router.push({
            name: 'RecipeMealPlans'
          });
        });
      }
    },
    deleteMealPlan: function deleteMealPlan() {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: "You about about to remove a meal plan!",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Recipes2.default.deleteMealPlan(self.data.id);
        }
      }).then(function (response) {
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: "Meal plan was removed",
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
        self.$router.push({
          name: 'RecipeMealPlans'
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    setDay: function setDay(day) {
      this.activeDay = day;
    },
    pushToBreakfast: function pushToBreakfast(recipe) {
      var self = this;
      var currentDay = self.data.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      var day = currentDay[0];
      day.breakfast = [];
      day.breakfast.push(recipe);
    },
    pushToLunch: function pushToLunch(recipe) {
      var self = this;
      var currentDay = self.data.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      var day = currentDay[0];
      day.lunch = [];
      day.lunch.push(recipe);
    },
    pushToDinner: function pushToDinner(recipe) {
      var self = this;
      var currentDay = self.data.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      var day = currentDay[0];
      day.dinner = [];
      day.dinner.push(recipe);
    }
  },
  computed: {
    activeBreakfastForDay: function activeBreakfastForDay() {
      var self = this;
      if (self.data === false) {
        return [];
      }

      var item = self.data.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      if (item[0].breakfast.length > 0) {
        return item[0].breakfast;
      }
      return [];
    },
    activeDinnerForDay: function activeDinnerForDay() {
      var self = this;
      if (self.data === false) {
        return [];
      }

      var item = self.data.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      if (item[0].dinner.length > 0) {
        return item[0].dinner;
      }
      return [];
    },
    activeLunchForDay: function activeLunchForDay() {
      var self = this;
      if (self.data === false) {
        return [];
      }

      var item = self.data.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      if (item[0].lunch.length > 0) {
        return item[0].lunch;
      }
      return [];
    }
  },
  mounted: function mounted() {
    var self = this;

    _Recipes2.default.getMealPlanById(self.$route.params.id).then(function (response) {
      self.activeDay = response.data.availableDays[0];
      self.data = response.data;
    }).catch(function (error) {
      self.$router.push({
        name: 'RecipeMealPlans'
      });
    });
  }
};

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(233);

var _assign2 = _interopRequireDefault(_assign);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _mealPlanPanel = __webpack_require__(1275);

var _mealPlanPanel2 = _interopRequireDefault(_mealPlanPanel);

var _floatButton = __webpack_require__(3372);

var _floatButton2 = _interopRequireDefault(_floatButton);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _textField = __webpack_require__(228);

var _textField2 = _interopRequireDefault(_textField);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

var _mealPlanFilterModal = __webpack_require__(3534);

var _mealPlanFilterModal2 = _interopRequireDefault(_mealPlanFilterModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MealPlanFilterModal: _mealPlanFilterModal2.default,
    MuCircularProgress: _circularProgress2.default,
    MuTextField: _textField2.default,
    MuRaisedButton: _raisedButton2.default,
    MuFloatButton: _floatButton2.default,
    MealPlanPanel: _mealPlanPanel2.default
  },
  name: "meaplan-generator-index",
  data: function data() {
    return {
      isMealPlanShown: false,
      dialogOpen: false,
      dietaryPreferenceId: 0,
      activeDay: 'MONDAY',
      allergyCsv: "",
      listener: 0,
      filters: {},
      model: {
        name: null,
        servingslte: 1,
        servings: 0,
        availableMeals: ['BREAKFAST', 'LUNCH', 'DINNER'],
        availableDays: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'],
        days: [{
          label: 'M',
          name: 'MONDAY',
          breakfast: [],
          lunch: [],
          dinner: []
        }, {
          label: 'T',
          name: 'TUESDAY',
          breakfast: [],
          lunch: [],
          dinner: []
        }, {
          label: 'W',
          name: 'WEDNESDAY',
          breakfast: [],
          lunch: [],
          dinner: []
        }, {
          label: 'T',
          name: 'THURSDAY',
          breakfast: [],
          lunch: [],
          dinner: []
        }, {
          label: 'F',
          name: 'FRIDAY',
          breakfast: [],
          lunch: [],
          dinner: []
        }, {
          label: 'S',
          name: 'SATURDAY',
          breakfast: [],
          lunch: [],
          dinner: []
        }, {
          label: 'S',
          name: 'SUNDAY',
          breakfast: [],
          lunch: [],
          dinner: []
        }]
      }
    };
  },


  methods: {
    filtersSet: function filtersSet(data) {
      this.filters = data;
    },
    daySatisfied: function daySatisfied(day) {
      var self = this;
      var mealsForThisDayCount = self.model.availableMeals.length;
      var mealsChecked = 0;
      self.model.availableMeals.forEach(function (item) {
        if (day[item.toLowerCase()].length > 0) {
          mealsChecked++;
        }
      });
      return mealsChecked === mealsForThisDayCount;
    },
    toggleMeal: function toggleMeal(meal) {
      var self = this;
      if (self.model.availableMeals.includes(meal)) {
        var index = self.model.availableMeals.indexOf(meal);
        self.model.availableMeals.splice(index, 1);
      } else {
        self.model.availableMeals.push(meal);
      }
      var meals = ['BREAKFAST', 'LUNCH', 'DINNER'];
      var sortMeals = function sortMeals(a, b) {
        a = meals.indexOf(a);
        b = meals.indexOf(b);
        return a < b ? 0 : 1;
      };
      self.model.availableMeals = self.model.availableMeals.sort(sortMeals);
      self.$forceUpdate();
    },
    saveMealPlan: function saveMealPlan() {
      var self = this;

      self.model.servings = self.model.servingslte;

      if (self.model.name === null || self.model.name === "") {
        self.$alert({
          title: "Error!",
          text: "Must give your meal plan a name",
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      } else {
        _Recipes2.default.addMealPlan(self.model).then(function (response) {
          self.$router.push({
            name: 'MealPlanDetail',
            params: {
              id: response.data.id
            }
          });
        });
      }
    },
    openMealPlanModal: function openMealPlanModal() {
      this.dialogOpen = true;
    },
    generateMealPlans: function generateMealPlans() {

      var token = _axios2.default.CancelToken;

      _Recipes2.default.CancelToken = token;

      var self = this;

      if (self.model.availableMeals.length === 0) {
        self.$alert({
          title: "Error!",
          text: "Select at least one meal type",
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }

      if (self.model.availableDays.length === 0) {
        self.$alert({
          title: "Error!",
          text: "Select at least one day of the week",
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }

      if (self.model.availableMeals.length > 0 && self.model.availableDays.length > 0) {

        self.lists = self.$store.state.list;
        var allergies = self.lists.allergies;

        self.activeDay = self.model.availableDays[0];
        _Account2.default.getUserPersonalization().then(function (response) {

          self.dietaryPreferenceId = response.data.dietry_preference_id;
          var allergyStrings = [];
          if (response.data.allergies.length > 0) {
            var _loop = function _loop(i) {
              var foundAllergy = allergies.filter(function (item) {
                return item.allergy_id === response.data.allergies[i];
              });

              if (foundAllergy.length > 0) {
                allergyStrings.push(foundAllergy[0].name);
              }
            };

            for (var i = 0; i < response.data.allergies.length; i++) {
              _loop(i);
            }
            self.allergyCsv = allergyStrings.join(',');
          }

          var allergyObj = {
            suitabilities: self.allergyCsv
          };

          self.dietaryPreferenceId = response.data.dietry_preference_id;
          self.isMealPlanShown = true;
          var model = self.model;
          model.days.forEach(function (item, index) {
            if (self.model.availableDays.includes(item.name)) {

              if (self.model.availableMeals.includes('BREAKFAST')) {
                var filter = self.filters;
                var breakfastObject = {
                  servingslte: self.model.servingslte,
                  categories: 'Breakfast',
                  suitabilities: allergyStrings.join(','),
                  dietaryTypes: self.dietaryTypesList().join(','),
                  limit: 1,
                  shuffle: true
                };
                var bObj = (0, _assign2.default)(breakfastObject, filter);
                _Recipes2.default.CancelToken = token;
                _Recipes2.default.search(bObj).then(function (response) {

                  var data = response.data.recipes[0];
                  var self = this;
                  var currentDay = model.days.filter(function (e) {
                    return e.name === item.name;
                  });
                  var day = currentDay[0];
                  day.breakfast = [];
                  day.breakfast.push(data);
                  self.listener = index;
                  if (index === 0) {
                    self.activeDay = self.sorted[1];
                    self.$nextTick(function () {
                      self.activeDay = self.sorted[0];
                      self.$forceUpdate();
                    });
                  }
                }.bind(self));
              }
              if (self.model.availableMeals.includes('LUNCH')) {

                var _filter = self.filters;
                var lunchObject = {
                  servingslte: self.model.servingslte,
                  categories: 'Lunch',
                  suitabilities: allergyStrings.join(','),
                  dietaryTypes: self.dietaryTypesList().join(','),
                  limit: 1,
                  shuffle: true
                };
                var lObj = (0, _assign2.default)(lunchObject, _filter);

                _Recipes2.default.CancelToken = token;
                _Recipes2.default.search(lObj).then(function (response) {
                  var data = response.data.recipes[0];
                  var self = this;
                  var currentDay = model.days.filter(function (e) {
                    return e.name === item.name;
                  });
                  var day = currentDay[0];
                  day.lunch = [];
                  day.lunch.push(data);
                  self.listener = index;
                  self.$nextTick(function () {
                    if (index === 0) {
                      self.activeDay = self.sorted[1];
                      self.$nextTick(function () {
                        self.activeDay = self.sorted[0];
                        self.$forceUpdate();
                      });
                    }
                    self.$forceUpdate();
                  });
                }.bind(self));
              }
              if (self.model.availableMeals.includes('DINNER')) {
                var _filter2 = self.filters;
                var dinnerObj = {
                  servingslte: self.model.servingslte,
                  categories: 'Dinner',
                  suitabilities: allergyStrings.join(','),
                  dietaryTypes: self.dietaryTypesList().join(','),
                  limit: 1,
                  shuffle: true
                };

                var dObj = (0, _assign2.default)(dinnerObj, _filter2);

                _Recipes2.default.CancelToken = token;
                _Recipes2.default.search(dObj).then(function (response) {

                  var data = response.data.recipes[0];
                  var self = this;
                  var currentDay = model.days.filter(function (e) {
                    return e.name === item.name;
                  });
                  var day = currentDay[0];
                  day.dinner = [];
                  day.dinner.push(data);
                  self.listener = index;
                  if (index === 0) {
                    self.activeDay = self.sorted[1];
                    self.$nextTick(function () {
                      self.activeDay = self.sorted[0];
                      self.$forceUpdate();
                    });
                  }
                }.bind(self));
              }
            }
          });
        });
      }
    },
    incrementServings: function incrementServings() {
      if (this.model.servingslte < 28) {
        this.model.servingslte++;
      }
    },
    decrementServings: function decrementServings() {
      if (this.model.servingslte > 1) {
        this.model.servingslte--;
      }
    },
    addToAvailableDays: function addToAvailableDays(day) {
      var self = this;
      if (self.model.availableDays.includes(day)) {
        self.model.availableDays.splice(self.model.availableDays.indexOf(day), 1);
      } else {
        self.model.availableDays.push(day);
      }
    },
    dietaryTypesList: function dietaryTypesList() {
      var self = this;
      switch (self.dietaryPreferenceId) {
        case 1:
          return ['Gluten-free', 'Iron rich', 'Ketogenic', 'Low GI', 'Organic', 'Paleolithic', 'Pescetarian', 'Raw Foods', 'Vegan', 'Vegetarian'];
        case 2:
          return ['Pescetarian'];
        case 3:
          return ['Vegetarian'];
        case 4:
          return ['Vegan'];
        default:
          return ['Gluten-free', 'Iron rich', 'Ketogenic', 'Low GI', 'Organic', 'Paleolithic', 'Pescetarian', 'Raw Foods', 'Vegan', 'Vegetarian'];
      }
    },
    pushToBreakfast: function pushToBreakfast(recipe) {
      var self = this;
      var currentDay = self.model.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      var day = currentDay[0];
      day.breakfast = [];
      day.breakfast.push(recipe);
    },
    pushToLunch: function pushToLunch(recipe) {
      var self = this;
      var currentDay = self.model.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      var day = currentDay[0];
      day.lunch = [];
      day.lunch.push(recipe);
    },
    pushToDinner: function pushToDinner(recipe) {
      var self = this;
      var currentDay = self.model.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      var day = currentDay[0];
      day.dinner = [];
      day.dinner.push(recipe);
    },
    setDay: function setDay(day) {
      this.activeDay = day;
    }
  },
  computed: {
    satisfiedDays: function satisfiedDays() {
      var self = this;
      var satisfiableCount = self.model.availableDays.length;
      var satisfiedDataStructure = [];
      self.model.availableDays.forEach(function (item) {
        var day = self.model.days.filter(function (dayItem) {
          return dayItem.name === item;
        })[0];
        var conditions = [];
        self.model.availableMeals.forEach(function (item) {
          conditions.push(day[item.toLowerCase()].length > 0);
        });
        var checkTrueAll = conditions.filter(function (e) {
          return e === true;
        });
        if (checkTrueAll.length === self.model.availableMeals.length) {
          satisfiedDataStructure.push(day);
        }
      });
      return satisfiedDataStructure.length === satisfiableCount;
    },
    sorted: function sorted() {
      var self = this;
      var days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
      var sortDays = function sortDays(a, b) {
        a = days.indexOf(a);
        b = days.indexOf(b);
        return a < b ? 0 : 1;
      };
      return self.model.availableDays.sort(sortDays);
    },
    activeBreakfastForDay: function activeBreakfastForDay() {
      var self = this;
      var item = self.model.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      if (item[0].breakfast.length > 0) {
        return item[0].breakfast;
      }
      return [];
    },
    activeDinnerForDay: function activeDinnerForDay() {
      var self = this;
      var item = self.model.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      if (item[0].dinner.length > 0) {
        return item[0].dinner;
      }
      return [];
    },
    activeLunchForDay: function activeLunchForDay() {
      var self = this;
      var item = self.model.days.filter(function (item) {
        return item.name === self.activeDay;
      });
      if (item[0].lunch.length > 0) {
        return item[0].lunch;
      }
      return [];
    }
  },
  beforeDestroy: function beforeDestroy() {
    _Recipes2.default.CancelRequests();
  }
};

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(233);

var _assign2 = _interopRequireDefault(_assign);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { MuRaisedButton: _raisedButton2.default, vueSlider: _vue2Slider2.default },
  name: "meal-plan-filter-modal",
  data: function data() {
    return {
      isModalShown: false,
      sliderOptions: {
        carbs: {
          min: 0,
          max: 500,
          trackColor: 'rgb(126, 211, 33)',
          backgroundColor: 'rgba(126, 211, 33, 0.3)'
        },
        fat: {
          min: 0,
          max: 500,
          trackColor: 'rgb(60, 177, 255)',
          backgroundColor: 'rgba(60, 177, 255, 0.3)'
        },
        calories: {
          min: 0,
          max: 3000,
          trackColor: 'rgb(80, 227, 194)',
          backgroundColor: 'rgba(80, 227, 194, 0.3)'
        },
        protein: {
          min: 0,
          max: 500,
          trackColor: 'rgb(255, 94, 7)',
          backgroundColor: 'rgba(255, 94, 7, 0.3)'
        }
      },
      model: {
        carbs: [0, 500],
        fat: [0, 500],
        calories: [0, 3000],
        protein: [0, 500],
        totaltime: [0, 200]
      }
    };
  },

  watch: {
    'model.carbs': function modelCarbs() {
      this.valuesChanged();
    },
    'model.fat': function modelFat() {
      this.valuesChanged();
    },
    'model.calories': function modelCalories() {
      this.valuesChanged();
    },
    'model.protein': function modelProtein() {
      this.valuesChanged();
    }
  },
  mounted: function mounted() {
    this.valuesChanged();
  },

  methods: {
    valuesChanged: function valuesChanged() {
      var self = this;
      self.$emit('change', {
        carbgte: self.model.carbs[0],
        carblte: self.model.carbs[1],
        fatgte: self.model.fat[0],
        fatlte: self.model.fat[1],
        caloriesgte: self.model.calories[0],
        calorieslte: self.model.calories[1],
        proteingte: self.model.protein[0],
        proteinlte: self.model.protein[1]
      });
    },
    assignSliderOptions: function assignSliderOptions(key) {
      var self = this;
      var sliderSettings = self.sliderSettings;
      var sliderOptions = {
        value: [self.sliderOptions[key].min, self.sliderOptions[key].max],
        min: self.sliderOptions[key].min,
        max: self.sliderOptions[key].max,
        tooltip: false,
        bgStyle: {
          backgroundColor: self.sliderOptions[key].backgroundColor
        },
        processStyle: {
          backgroundColor: self.sliderOptions[key].trackColor
        }
      };
      return self.mergeSliderOptions(sliderSettings, sliderOptions);
    },
    mergeSliderOptions: function mergeSliderOptions(sliderSettings, sliderValidation) {
      return (0, _assign2.default)({}, sliderSettings, sliderValidation);
    }
  },
  computed: {
    carbSlider: function carbSlider() {
      var self = this;
      return self.assignSliderOptions('carbs');
    },
    fatSlider: function fatSlider() {
      return this.assignSliderOptions('fat');
    },
    calorieSlider: function calorieSlider() {
      return this.assignSliderOptions('calories');
    },
    proteinSlider: function proteinSlider() {
      return this.assignSliderOptions('protein');
    }
  }
};

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(233);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _iconButton = __webpack_require__(449);

var _iconButton2 = _interopRequireDefault(_iconButton);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

var _linearProgress = __webpack_require__(3378);

var _linearProgress2 = _interopRequireDefault(_linearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuLinearProgress: _linearProgress2.default,
    MuCircularProgress: _circularProgress2.default,
    MuIconButton: _iconButton2.default
  },
  name: "meal-plan-panel",
  props: {
    type: {
      type: String,
      default: 'breakfast'
    },
    activeDay: {
      type: String,
      default: 'MONDAY'
    },
    recipe: {
      type: Array,
      default: []
    },
    dietaryTypes: {
      type: String,
      default: ''
    },
    allergies: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isGraphShown: false,
      isLoading: true,
      data: false
    };
  },

  watch: {
    'recipe': function recipe() {
      if (this.recipe.length > 0) {
        this.isLoading = false;
        this.data = this.recipe[0];
        this.$forceUpdate();
      } else {

        this.isLoading = true;
        this.data = this.recipe[0];
        this.$emit('changed', this.data);
      }
    },
    'activeDay': function activeDay() {
      if (this.recipe.length > 0) {
        this.isLoading = false;
        this.data = this.recipe[0];
        this.$emit('changed', this.data);
      } else {
        this.refresh();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    if (self.readonly === true) {
      self.data = self.recipe[0];
      self.isLoading = false;
    } else {
      self.isLoading = true;
    }
  },

  methods: {
    getRandomArbitrary: function getRandomArbitrary(min, max) {
      return Math.floor(Math.random() * (max - min) + min) + '%';
    },
    favorite: function favorite(id) {
      var self = this;
      _Recipes2.default.favorite(id).then(function (response) {
        self.data.userFavorites = response.data.favorite;
        self.$forceUpdate();
      });
    },
    goTo: function goTo(id) {
      var url = this.$router.resolve({
        name: 'RecipeDetail',
        params: {
          id: id
        }
      });
      window.open(url.href, '_blank');
    },
    refresh: function refresh() {
      var self = this;
      self.isLoading = true;

      var searchObject = {
        categories: self.type,
        dietaryTypes: self.dietaryTypes,
        suitabilities: self.allergies,
        servingslte: self.data.servings,
        limit: 1,
        shuffle: true
      };

      var filter = JSON.parse((0, _stringify2.default)(self.filters));
      var searchObj = (0, _assign2.default)(filter, searchObject);

      _Recipes2.default.search(searchObj).then(function (response) {
        self.isLoading = false;
        self.data = response.data.recipes[0];
        self.$emit('changed', self.data);
      });
    }
  },

  computed: {
    nutrientPercentage: function nutrientPercentage() {
      var self = this;
      var total = self.oneCarbPortion + self.oneFatPortion + self.oneProteinPortion;
      return {
        carbs: self.oneCarbPortion / total * 100,
        fat: self.oneFatPortion / total * 100,
        protein: self.oneProteinPortion / total * 100
      };
    },
    oneProteinPortion: function oneProteinPortion() {
      var self = this;
      var carbValue = self.data.nutrition.protein.val,
          servings = self.data.servings;
      return carbValue * (1 / servings);
    },
    oneFatPortion: function oneFatPortion() {
      var self = this;
      var carbValue = self.data.nutrition.fat.val,
          servings = self.data.servings;
      return carbValue * (1 / servings);
    },
    oneCarbPortion: function oneCarbPortion() {
      var self = this;
      var carbValue = self.data.nutrition.carbohydrate.val,
          servings = self.data.servings;
      return carbValue * (1 / servings);
    }
  }
};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _contentBlock = __webpack_require__(227);

var _contentBlock2 = _interopRequireDefault(_contentBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MuContentBlock: _contentBlock2.default,
    MuRaisedButton: _raisedButton2.default
  },
  name: "recipe-meal-plans",
  data: function data() {
    return {
      data: null,
      paginationInfo: null
    };
  },

  methods: {
    getRandomInt: function getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    getImage: function getImage(item) {
      var self = this;
      var first = item.availableDays[0];
      var day = item.days.filter(function (item) {
        return item.name === first;
      });
      var firstMeal = item.availableMeals[0].toLowerCase();
      var randomObjectInMealPlan = day[0][firstMeal];
      return randomObjectInMealPlan[0].photoSmallUri;
    },
    generateGradient: function generateGradient() {
      var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e"];

      function populate(a) {
        for (var i = 0; i < 6; i++) {
          var x = Math.round(Math.random() * 14);
          var y = hexValues[x];
          a += y;
        }
        return a;
      }

      var newColor1 = populate('#');
      var newColor2 = populate('#');
      var angle = 45;
      return "linear-gradient(" + angle + "deg, " + newColor1 + ", " + newColor2 + ")";
    },
    loadMore: function loadMore() {
      var _this = this;

      _Recipes2.default.getMealPlans(this.paginationInfo.actualPage + 1, 10).then(function (response) {
        if (response.data.data.length === 0) {
          return;
        }

        _this.paginationInfo = response.data.paginationInfo;
        _this.data.push.apply(_this.data, response.data.data);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    _Recipes2.default.getMealPlans(1, 10).then(function (response) {
      _this2.paginationInfo = response.data.paginationInfo;
      _this2.data = response.data.data;
    });
  }
};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(489);

var _extends3 = _interopRequireDefault(_extends2);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _vuex = __webpack_require__(1277);

var _RecipeCard = __webpack_require__(345);

var _RecipeCard2 = _interopRequireDefault(_RecipeCard);

var _Search = __webpack_require__(1276);

var _Search2 = _interopRequireDefault(_Search);

var _Filter = __webpack_require__(730);

var _Filter2 = _interopRequireDefault(_Filter);

var _pagination = __webpack_require__(3381);

var _pagination2 = _interopRequireDefault(_pagination);

var _circularProgress = __webpack_require__(145);

var _circularProgress2 = _interopRequireDefault(_circularProgress);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_Filter2.default],
  components: {
    MuCircularProgress: _circularProgress2.default,
    MuPagination: _pagination2.default,
    RecipeSearch: _Search2.default,
    RecipeCard: _RecipeCard2.default
  },
  name: "recipe-search-results",
  props: {
    data: null
  },
  watch: {
    'getRecipeSearchFilter': function getRecipeSearchFilter(data) {
      this.filterModel = data;
    },
    '$route': {
      immediate: false,
      handler: function handler() {
        this.refiningFilters = false;
        this.checkWindowWidth();
        this.filterData = this.$route.params.filterData;
        this.$forceUpdate();
      }
    },
    'data': function data() {
      if (this.data) {
        this.recipeData = this.data;
      }
    }
  },
  data: function data() {
    return {
      isLoading: true,
      refiningFilters: true,
      filterData: null,
      recipeData: {
        recipes: []
      },
      filterModel: {
        search: null
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.refiningFilters = false;
    self.filterData = self.$store.state.recipes.filterData;
    self.filterModel = self.$store.state.recipes.filterData;

    self.checkWindowWidth();

    if (self.filterModel === undefined) {
      var data = self.$store.state.recipes.filterData;
      self.filterData = data;
      if (data == null) {
        this.isLoading = false;

        var carbsGTE = self.getRecipeSearchFilter.carbs[0],
            carbsLTE = self.getRecipeSearchFilter.carbs[1];
        var fatGTE = self.getRecipeSearchFilter.fat[0],
            fatLTE = self.getRecipeSearchFilter.fat[1];
        var caloriesGTE = self.getRecipeSearchFilter.calories[0],
            caloriesLTE = self.getRecipeSearchFilter.calories[1];
        var proteinGTE = self.getRecipeSearchFilter.protein[0] !== undefined ? self.getRecipeSearchFilter.protein[0] : 0,
            proteinLTE = self.getRecipeSearchFilter.protein[1] !== undefined ? self.getRecipeSearchFilter.protein[1] : 500;

        var totaltimeGTE = self.getRecipeSearchFilter.totaltime[0];
        var totaltimeLTE = self.getRecipeSearchFilter.totaltime[1];

        var queryParams = {
          search: self.$route.query.search,
          page: self.$route.query.page,
          limit: 15,
          carblte: carbsLTE,
          carbgte: carbsGTE,
          fatlte: fatLTE,
          fatgte: fatGTE,
          totaltimelte: totaltimeLTE,
          totaltimegte: totaltimeGTE,
          caloriesgte: caloriesGTE,
          calorieslte: caloriesLTE,
          proteinlte: proteinLTE,
          proteingte: proteinGTE,
          suitabilities: self.getChecked('suitabilities').join(','),
          dietaryTypes: self.getChecked('dietaryTypes').join(','),
          cuisines: self.getChecked('cuisines').join(','),
          occasions: self.getChecked('occasions').join(','),
          categories: self.getChecked('categories').join(',')
        };

        _Recipes2.default.search(self.clearQueryParameters(queryParams)).then(function (response) {
          self.$nextTick(function () {
            self.isLoading = false;
            this.recipeData = res.data;
            self.$router.replace({
              name: 'RecipeSearchResults',
              query: self.clearQueryParameters(queryParams),
              params: {
                data: response.data
              }
            });
          });
        });
      } else {
        var _queryParams = {
          search: self.$route.query.search,
          page: self.$route.query.page,
          limit: 15
        };
        _Recipes2.default.search(self.clearQueryParameters(_queryParams)).then(function (response) {
          self.$nextTick(function () {
            self.isLoading = false;
            self.recipeData = response.data;
          });
        });
      }
    } else {

      var _carbsGTE = self.getRecipeSearchFilter.carbs[0],
          _carbsLTE = self.getRecipeSearchFilter.carbs[1];
      var _fatGTE = self.getRecipeSearchFilter.fat[0],
          _fatLTE = self.getRecipeSearchFilter.fat[1];
      var _caloriesGTE = self.getRecipeSearchFilter.calories[0],
          _caloriesLTE = self.getRecipeSearchFilter.calories[1];
      var _proteinGTE = self.getRecipeSearchFilter.protein[0] !== undefined ? self.getRecipeSearchFilter.protein[0] : 0,
          _proteinLTE = self.getRecipeSearchFilter.protein[1] !== undefined ? self.getRecipeSearchFilter.protein[1] : 500;

      var _totaltimeGTE = self.getRecipeSearchFilter.totaltime[0];
      var _totaltimeLTE = self.getRecipeSearchFilter.totaltime[1];

      var _queryParams2 = {
        search: self.$route.query.search,
        page: self.$route.query.page,
        limit: 10,
        carblte: _carbsLTE,
        carbgte: _carbsGTE,
        fatlte: _fatLTE,
        fatgte: _fatGTE,
        totaltimelte: _totaltimeLTE,
        totaltimegte: _totaltimeGTE,
        caloriesgte: _caloriesGTE,
        calorieslte: _caloriesLTE,
        proteinlte: _proteinLTE,
        proteingte: _proteinGTE,
        suitabilities: self.getChecked('suitabilities').join(','),
        dietaryTypes: self.getChecked('dietaryTypes').join(','),
        cuisines: self.getChecked('cuisines').join(','),
        occasions: self.getChecked('occasions').join(','),
        categories: self.getChecked('categories').join(',')
      };

      this.isLoading = false;
      this.recipeData = this.data;
      this.filterData = this.filterModel;

      self.isLoading = true;

      _Recipes2.default.search(self.clearQueryParameters(_queryParams2)).then(function (res) {
        self.$nextTick(function () {
          this.recipeData = res.data;
          self.isLoading = false;
          self.$router.replace({
            name: 'RecipeSearchResults',
            query: self.clearQueryParameters(_queryParams2),
            params: {
              data: res.data,
              filterModel: self.filterData
            }
          });
        });
      });
    }
  },

  methods: {
    onSearchInitiated: function onSearchInitiated() {
      this.isLoading = true;
    },
    onFilterModelChange: function onFilterModelChange(data) {
      this.filterModel = data;
    },
    onRecipeSearchLoaded: function onRecipeSearchLoaded(data) {
      if (data) {
        this.recipeData = data;
        this.isLoading = false;
      }
    },
    checkWindowWidth: function checkWindowWidth() {
      var self = this;
      var windowWidth = (0, _jquery2.default)('body').outerWidth();
      if (windowWidth > 1024) {
        self.$nextTick(function () {
          self.refiningFilters = true;
        });
      } else {
        self.refiningFilters = false;
      }
    },
    getChecked: function getChecked(key) {
      var self = this;
      var checkedItems = [];
      var checked = self.getRecipeSearchFilter[key].filter(function (item) {
        return item.checked === true;
      });
      checked.forEach(function (item) {
        checkedItems.push(item.label);
      });
      return checkedItems;
    },
    handlePageChange: function handlePageChange(page) {
      var self = this;
      var actualPage = page;

      var carbsGTE = 0;
      var carbsLTE = 0;

      var fatGTE = 0;
      var fatLTE = 0;

      var caloriesGTE = 0;
      var caloriesLTE = 0;

      var proteinGTE = 0;
      var proteinLTE = 0;

      if (_.has(self.filterModel, 'carbs')) {
        carbsGTE = self.filterModel.carbs[0], carbsLTE = self.filterModel.carbs[1];
      }

      if (_.has(self.filterModel, 'fat')) {
        fatGTE = self.filterModel.fat[0], fatLTE = self.filterModel.fat[1];
      }

      if (_.has(self.filterModel, 'calories')) {
        caloriesGTE = self.filterModel.calories[0], caloriesLTE = self.filterModel.calories[1];
      }

      if (_.has(self.filterModel, 'protein')) {
        proteinGTE = self.filterModel.protein[0], proteinLTE = self.filterModel.protein[1];
      }

      var totaltimeGTE = self.filterModel.totaltime[0];
      var totaltimeLTE = self.filterModel.totaltime[1];

      var queryParams = {
        search: self.$route.query.search ? self.$route.query.search : '',
        page: actualPage - 1,
        limit: 10,
        carblte: carbsLTE,
        carbgte: carbsGTE,
        fatlte: fatLTE,
        fatgte: fatGTE,
        caloriesgte: caloriesGTE,
        calorieslte: caloriesLTE,
        proteinlte: proteinLTE,
        proteingte: proteinGTE,
        totaltimelte: totaltimeLTE,
        totaltimegte: totaltimeGTE,
        suitabilities: self.getChecked('suitabilities').join(','),
        dietaryTypes: self.getChecked('dietaryTypes').join(','),
        cuisines: self.getChecked('cuisines').join(','),
        occasions: self.getChecked('occasions').join(','),
        categories: self.getChecked('categories').join(',')
      };

      self.isLoading = true;
      _Recipes2.default.search(self.clearQueryParameters(queryParams)).then(function (response) {
        if (_.has(self.$route.query, 'search')) {
          self.filterModel.search = self.$route.query.search;
        }

        self.$store.commit('setRecipeFilter', self.filterModel);
        self.$router.replace({
          name: 'RecipeSearchResults',
          query: self.clearQueryParameters(queryParams),
          params: {
            data: response.data,
            filterModel: self.filterModel
          }
        });
        self.isLoading = false;
      });
    },
    toggleFilterShowing: function toggleFilterShowing() {
      this.refiningFilters = !this.refiningFilters;
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getRecipeSearchFilter']))
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(233);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _vue2Slider = __webpack_require__(187);

var _vue2Slider2 = _interopRequireDefault(_vue2Slider);

var _Filter = __webpack_require__(730);

var _Filter2 = _interopRequireDefault(_Filter);

var _Recipes = __webpack_require__(76);

var _Recipes2 = _interopRequireDefault(_Recipes);

var _raisedButton = __webpack_require__(128);

var _raisedButton2 = _interopRequireDefault(_raisedButton);

var _checkbox = __webpack_require__(3367);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_Filter2.default],
  components: {
    MuCheckbox: _checkbox2.default,
    MuRaisedButton: _raisedButton2.default,
    vueSlider: _vue2Slider2.default
  },
  name: "recipe-search",
  props: ['filterData', 'categories', 'fullWidth', 'isResultsPage'],
  watch: {
    '$route': 'getTypes'
  },
  data: function data() {
    return {
      timeFilter: '',
      isSearching: false,
      sliderOptions: {
        carbs: {
          min: 0,
          max: 500,
          trackColor: 'rgb(126, 211, 33)',
          backgroundColor: 'rgba(126, 211, 33, 0.3)',
          range: true
        },
        fat: {
          min: 0,
          max: 500,
          trackColor: 'rgb(60, 177, 255)',
          backgroundColor: 'rgba(60, 177, 255, 0.3)'
        },
        calories: {
          min: 0,
          max: 6000,
          trackColor: 'rgb(80, 227, 194)',
          backgroundColor: 'rgba(80, 227, 194, 0.3)'
        },
        protein: {
          min: 0,
          max: 500,
          trackColor: 'rgb(255, 94, 7)',
          backgroundColor: 'rgba(255, 94, 7, 0.3)'
        },
        totaltime: {
          min: 0,
          max: 200,
          trackColor: 'rgb(255, 94, 7)',
          backgroundColor: 'rgba(255, 94, 7, 0.3)'
        }
      },
      model: {
        q: null,
        suitabilities: [],
        dietaryTypes: [],
        cuisines: [],
        categories: [],
        carbs: [0, 500],
        fat: [0, 700],
        calories: [0, 6000],
        protein: [0, 500],
        totaltime: [0, 200]
      },
      sliderSettings: {
        interval: 1,
        disabled: false,
        tooltip: false,
        startAnimation: false
      },
      additionalOptions: true
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('setRecipeSearchFilter', self.model);

    if (self.fullWidth) {
      this.additionalOptions = false;
    }

    if (_.has(self.$route.query, 'search')) {
      self.model.q = self.$route.query.search;
    }

    if (_.has(self.$route.query, 'totaltimelte') && _.has(self.$route.query, 'totaltimegte')) {
      self.model.totaltime = [parseInt(self.$route.query.totaltimegte), parseInt(self.$route.query.totaltimelte)];
    }

    if (_.has(self.$route.query, 'carbgte') && _.has(self.$route.query, 'carblte')) {
      self.model.carbs = [parseInt(self.$route.query.carbgte), parseInt(self.$route.query.carblte)];
    }

    if (_.has(self.$route.query, 'fatgte') && _.has(self.$route.query, 'fatlte')) {
      self.model.fat = [parseInt(self.$route.query.fatgte), parseInt(self.$route.query.fatlte)];
    }

    if (_.has(self.$route.query, 'caloriesgte') && _.has(self.$route.query, 'calorieslte')) {
      self.model.calories = [parseInt(self.$route.query.caloriesgte), parseInt(self.$route.query.calorieslte)];
    } else {
      self.model.calories = [0, 6000];
    }

    if (_.has(self.$route.query, 'proteinlte') && _.has(self.$route.query, 'proteingte')) {
      self.model.protein = [parseInt(self.$route.query.proteingte), parseInt(self.$route.query.proteinlte)];
    } else {
      self.model.protein = [0, 500];
    }

    self.$emit('filterModel', self.getValues());
    self.getTypes();
  },

  methods: {
    setUnder10Min: function setUnder10Min() {
      this.timeFilter = "underTenMin";
      this.model.totaltime = [0, 10];
      this.checkChanged();
    },
    setUnderThirtyMinOverTen: function setUnderThirtyMinOverTen() {
      this.timeFilter = 'underThirtyMinOverTen';
      this.model.totaltime = [10, 30];
      this.checkChanged();
    },
    setUnderHourOver30: function setUnderHourOver30() {
      this.timeFilter = 'underHourOver30';
      this.model.totaltime = [30, 60];
      this.checkChanged();
    },
    setOverHour: function setOverHour() {
      var self = this;
      this.timeFilter = "overHour";
      this.model.totaltime = [60, self.sliderOptions.totaltime.max];
      this.checkChanged();
    },
    checkChanged: function checkChanged() {
      this.timeFilter = '';
      this.$emit('changed', this.model);
      this.$store.commit('setRecipeSearchFilter', this.model);
      if (this.isResultsPage === true) {
        this.$nextTick(function () {
          this.submitSearch();
        });
      }
    },
    getValues: function getValues() {
      var self = this;
      var carbsGTE = self.model.carbs[0],
          carbsLTE = self.model.carbs[1];
      var fatGTE = self.model.fat[0],
          fatLTE = self.model.fat[1];
      var caloriesGTE = self.model.calories[0],
          caloriesLTE = self.model.calories[1];
      var proteinGTE = self.model.protein[0],
          proteinLTE = self.model.protein[1];
      var totaltimeGTE = self.model.totaltime[0],
          totaltimeLTE = self.model.totaltime[1];
      return {
        search: self.model.q,
        page: 0,
        limit: 15,
        carblte: carbsLTE,
        carbgte: carbsGTE,
        fatlte: fatLTE,
        fatgte: fatGTE,
        totaltimegte: totaltimeGTE,
        totaltimelte: totaltimeLTE === 200 ? 750 : totaltimeLTE,
        caloriesgte: caloriesGTE,
        calorieslte: caloriesLTE,
        proteingte: proteinGTE,
        proteinlte: proteinLTE,
        suitabilities: self.getChecked('suitabilities').join(','),
        dietaryTypes: self.getChecked('dietaryTypes').join(','),
        cuisines: self.getChecked('cuisines').join(','),
        occasions: self.getChecked('occasions').join(','),
        categories: self.getChecked('categories').join(',')
      };
    },
    handleSearchKeydown: function handleSearchKeydown(event) {
      if (event.keyCode === 13) {
        this.submitSearch();
      }
    },
    submitSearch: function submitSearch() {
      var _this = this;

      var self = this;
      self.isSearching = true;
      if (_Recipes2.default.CancelRequests !== null) {
        _Recipes2.default.CancelRequests();
      }
      this.$emit('isSearching', this.isSearching);
      _Recipes2.default.search(self.clearQueryParameters(this.getValues())).then(function (response) {
        _Recipes2.default.CancelRequests = null;
        self.isSearching = false;
        self.$store.commit('setRecipeSearchFilter', self.model);
        _this.$emit('recipeData', response.data);
        _this.$nextTick(function () {
          _this.$router.push({
            name: 'RecipeSearchResults',
            query: _this.clearQueryParameters(_this.getValues()),
            params: {
              data: response.data
            }
          });
        });
      });
    },
    getChecked: function getChecked(key) {
      var self = this;
      var checkedItems = [];

      if (_.has(self.model, key)) {
        var checked = self.model[key].filter(function (item) {
          return item.checked === true;
        });
        checked.forEach(function (item) {
          checkedItems.push(item.label);
        });
        return checkedItems;
      } else return [];
    },
    checkOrUnCheck: function checkOrUnCheck(array, bool) {
      var self = this;
      array.forEach(function (key) {
        self.model[key].forEach(function (item) {
          item.checked = bool;
          self.$forceUpdate();
        });
      });
    },
    getTypes: function getTypes() {
      var self = this;
      if (_.has(self.$route.query, 'search')) {
        self.model.q = self.$route.query.search;
      }

      if (this.filterData !== undefined) {
        if (_.has(self.$store.state.recipes.categories, 'suitabilities')) {
          self.model.suitabilities = self.$store.state.recipes.categories.suitabilities;
        }
        if (_.has(self.$store.state.recipes.categories, 'dietaryTypes')) {
          self.model.dietaryTypes = self.$store.state.recipes.categories.dietaryTypes;
        }
        if (_.has(self.$store.state.recipes.categories, 'cuisines')) {
          self.model.cuisines = self.$store.state.recipes.categories.cuisines;
        }
        if (_.has(self.$store.state.recipes.categories, 'categories')) {
          self.model.categories = self.$store.state.recipes.categories.categories;
        }
        if (_.has(self.$store.state.recipes.categories, 'occasions')) {
          self.model.occasions = self.$store.state.recipes.categories.occasions;
        }
      } else if (self.$store.state.recipes.categories) {

        self.model.suitabilities = self.$store.state.recipes.categories.suitabilities;
        self.model.dietaryTypes = self.$store.state.recipes.categories.dietaryTypes;
        self.model.cuisines = self.$store.state.recipes.categories.cuisines;
        self.model.categories = self.$store.state.recipes.categories.categories;
        self.model.occasions = self.$store.state.recipes.categories.occasions;
      } else {
        if (this.filterData === undefined) {
          _axios2.default.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/utilities/alloptions").then(function (response) {
            self.model.suitabilities = response.data.suitabilities;
            self.model.dietaryTypes = response.data.dietaryTypes;
            self.model.cuisines = response.data.cuisines;
            self.model.occasions = response.data.occasions;
            self.model.categories = response.data.categories;
            self.checkOrUnCheck(['suitabilities', 'dietaryTypes', 'cuisines', 'occasions', 'categories'], false);
            self.$store.commit('setRecipeCategories', {
              suitabilities: response.data.suitabilities,
              dietaryTypes: response.data.dietaryTypes,
              cuisines: response.data.cuisines,
              occasions: response.data.occasions,
              categories: response.data.categories
            });
          });
        }
      }
    },
    assignSliderOptions: function assignSliderOptions(key) {
      var self = this;
      var sliderSettings = self.sliderSettings;

      var sliderOptions = {
        min: self.sliderOptions[key].min,
        max: self.sliderOptions[key].max,
        speed: 0,
        startAnimation: false,
        bgStyle: {
          backgroundColor: self.sliderOptions[key].backgroundColor
        },
        processStyle: {
          backgroundColor: self.sliderOptions[key].trackColor
        }
      };
      return self.mergeSliderOptions(sliderSettings, sliderOptions);
    },
    mergeSliderOptions: function mergeSliderOptions(sliderSettings, sliderValidation) {
      return (0, _assign2.default)({}, sliderSettings, sliderValidation);
    }
  },
  computed: {
    timeSlider: function timeSlider() {
      var self = this;
      return self.assignSliderOptions('totaltime');
    },
    carbSlider: function carbSlider() {
      var self = this;
      return self.assignSliderOptions('carbs');
    },
    fatSlider: function fatSlider() {
      return this.assignSliderOptions('fat');
    },
    calorieSlider: function calorieSlider() {
      return this.assignSliderOptions('calories');
    },
    proteinSlider: function proteinSlider() {
      return this.assignSliderOptions('protein');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Utilities = __webpack_require__(274);

var _Registration = __webpack_require__(477);

var _Registration2 = _interopRequireDefault(_Registration);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _DateMonths = __webpack_require__(232);

var _DateMonths2 = _interopRequireDefault(_DateMonths);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DobObject = _Utilities.Objects.DobObject;

exports.default = {
  mixins: [_DateMonths2.default],
  components: { Alert: _Alert2.default },
  data: function data() {
    return {
      siteUrl: _config2.default.siteUrl,
      isError: false,
      isSaving: false,
      terms: true,
      isTermsError: false,
      isServerValidationError: false,
      serverValidationErrorText: false,
      dobItems: DobObject,
      dummyPassword: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, Math.floor(Math.random() * (16 - 8 + 1)) + 8),
      model: {
        firstname: null,
        surname: null,
        dob: null
      },
      dob: {
        day: null,
        month: null,
        year: null
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/register/amend');

    _Account2.default.getAccount().then(function (response) {
      self.model = response.data;
      if (self.model.dob !== null) {
        var dob = self.model.dob.split('-');
        self.dob.year = self.dobItems.years.find(function (year) {
          return year.value === dob[0];
        });
        self.dob.month = self.dobItems.months.find(function (month) {
          return month.value === dob[1];
        });
        self.dob.day = dob[2];
      }
      self.isLoading = false;
    });
  },

  computed: {
    isAmendAgeValid: function isAmendAgeValid() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year.value + '-' + this.dob.month.value + '-' + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(18, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    },
    isOlderThan100: function isOlderThan100() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year.value + '-' + this.dob.month.value + '-' + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(100, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    }
  },
  watch: {
    'dob.day': function dobDay() {
      var self = this;
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    },
    'dob.month': function dobMonth() {
      var self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    },
    'dob.year': function dobYear() {
      var self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
      self.isServerValidationError = false;
    }
  },
  methods: {
    formatDateOfBirth: function formatDateOfBirth() {
      var self = this;
      if (!_.isNull(self.dob.day) && !_.isNull(self.dob.month) && !_.isNull(self.dob.year)) {
        self.model.dob = self.dob.year.value + '-' + self.dob.month.value + '-' + self.dob.day;
      }
    },
    updateValidDobMonthDays: function updateValidDobMonthDays() {
      var self = this;
      if (!self.dob.month || !self.dob.month.daysCount) {
        return;
      }

      var days = self.dob.month.daysCount + 1;

      if (!_.isNull(self.dob.year) && self.dob.year.isLeap === true && self.dob.month.value === "02") {
        days = self.dob.month.daysCount + 2;
      }

      var daysArray = [];

      for (var i = 1; i < days; i++) {
        if (i < 10) {
          daysArray.push('0' + i + '');
        } else {
          daysArray.push('' + i + '');
        }
      }

      self.$set(self.dobItems, 'days', daysArray);
    },
    setTerms: function setTerms() {
      var self = this;
      self.terms = !self.terms;
      self.isTermsError = false;
    },
    submitForm: function submitForm() {
      var self = this;

      if (self.isOlderThan100 === true) {
        self.$toastr.error("You have to be under 100 to sign up");
        return;
      }

      if (!self.terms) {
        self.isTermsError = true;
        return;
      }

      self.$validator.validateAll().then(function (valid) {
        if (valid && self.isAmendAgeValid) {
          var registrationModel = {
            firstname: self.model.firstname,
            surname: self.model.surname,
            dob: self.model.dob
          };

          self.isSaving = true;
          _Registration2.default.amend(registrationModel).then(function (response) {

            self.$router.push({
              name: 'Subscription'
            });
          }).catch(function (error) {
            self.isSaving = false;

            if (error.response.status === 500) {

              self.isError = true;
              self.$gtag.event('RegistrationError', {
                'event_category': 'Registration Amend',
                'event_label': 'Error Amending Details',
                'value': 1
              });
            } else if (error.response.status === 422) {
              self.isServerValidationError = true;
              self.serverValidationErrorText = error.response.data.message;
            }
          });
        } else if (!self.isAmendAgeValid) {
          self.$toastr.error("You have to be 18 or over to sign up");
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Utilities = __webpack_require__(274);

var _SocialLoginMixin = __webpack_require__(357);

var _SocialLoginMixin2 = _interopRequireDefault(_SocialLoginMixin);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

var _DateMonths = __webpack_require__(232);

var _DateMonths2 = _interopRequireDefault(_DateMonths);

var _PasswordStrengthValidation = __webpack_require__(342);

var _PasswordStrengthValidation2 = _interopRequireDefault(_PasswordStrengthValidation);

var _InitialRegistration = __webpack_require__(3432);

var _InitialRegistration2 = _interopRequireDefault(_InitialRegistration);

var _RegistrationMixin = __webpack_require__(485);

var _RegistrationMixin2 = _interopRequireDefault(_RegistrationMixin);

var _CompleteSocialRegistration = __webpack_require__(3431);

var _CompleteSocialRegistration2 = _interopRequireDefault(_CompleteSocialRegistration);

var _MessageBox = __webpack_require__(662);

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _FlashMessageMixin = __webpack_require__(483);

var _FlashMessageMixin2 = _interopRequireDefault(_FlashMessageMixin);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DobObject = _Utilities.Objects.DobObject;

exports.default = {
  mixins: [_DateMonths2.default, _SocialLoginMixin2.default, _RegistrationMixin2.default, _FlashMessageMixin2.default],
  components: { MessageBox: _MessageBox2.default, CompleteSocialRegistration: _CompleteSocialRegistration2.default, Alert: _Alert2.default, PasswordStrengthValidation: _PasswordStrengthValidation2.default, InitialRegistration: _InitialRegistration2.default },

  mounted: function mounted() {
    if (!this.completingSocialRegistration) {
      _AuthenticationManager2.default.clearSession();
    }

    this.$gtag.pageview('/register');
  },

  computed: {
    completingSocialRegistration: function completingSocialRegistration() {
      var self = this;
      if (self.$store.state.user.scope) {
        return true;
      }
    },
    title: function title() {
      if (this.model.offerCode !== null) {
        return this.$t('message.labelLetsGetStarted') + ': 50% off';
      }

      return this.$t('message.labelLetsGetStarted');
    },
    isValidAge: function isValidAge() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year.value + '-' + this.dob.month.value + '-' + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(18, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    },
    confirmPassErr: function confirmPassErr() {
      var self = this;
      var error = self.errors.first('passwordVerify');
      if (error === "The Confirm Password confirmation does not match.") {
        return 'Please enter passswords that match';
      } else {
        return error;
      }
    }
  }

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

var _Reporting = __webpack_require__(197);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

var _CountryBadge = __webpack_require__(340);

var _CountryBadge2 = _interopRequireDefault(_CountryBadge);

var _Report = __webpack_require__(229);

var _Report2 = _interopRequireDefault(_Report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Report: _Report2.default,
    UserBadge: _UserBadge2.default,
    CountryBadge: _CountryBadge2.default
  },
  data: function data() {
    return {
      isLoading: true,
      question: {},
      answer: {},
      report: {},
      isAmmending: false,
      model: {
        status: "REMOVE"
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var answerId = self.$route.params.id;
    self.isLoading = true;
    _TitleManager2.default.setTitle(self.$t('message.loadingText'));
    _Reporting2.default.getAnswerReport(answerId).then(function (response) {
      self.question = response.data.question;
      self.answer = response.data.answer;
      self.report = response.data.report;
      self.isLoading = false;
      _TitleManager2.default.setTitle(self.answer.answer);
    }).catch(function () {
      self.$router.push({
        name: 'QuestionsIndex'
      });
    });
  },

  methods: {
    goToThread: function goToThread() {
      var self = this;
      self.$router.push({
        name: 'QuestionThread',
        params: {
          id: self.answer.question_id
        }
      });
    },
    submitForm: function submitForm() {
      var self = this;
      if (self.$validator.validateAll()) {
        self.isAmmending = true;
        if (self.model.status === 'REMOVE') {
          self.$alert({
            title: "Are you sure?",
            text: "You are removing an answer and all of its reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              return _Discussion2.default.deleteAnswer(self.answer.answer_id);
            }
          }).then(function (response) {
            self.$router.push({
              name: 'QuestionThread',
              params: {
                id: self.answer.question_id
              }
            });
            self.$toastr.success("Answer was removed from " + self.question.user.display_name + 's question');
          }.bind(self)).catch(self.$alert.noop);
        }

        if (self.model.status === 'KEEP') {
          self.$alert({
            title: "Are you sure?",
            text: "You want to keep the answer and reject all reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              return _Reporting2.default.removeReports("THREAD_ANSWER", self.answer.answer_id);
            }
          }).then(function (response) {
            self.$router.push({
              name: 'QuestionThread',
              params: {
                id: self.answer.question_id
              }
            });
            self.$toastr.success("All reports for this answer were removed");
          }.bind(self)).catch(self.$alert.noop);
        }
      }
    },
    encodeText: function encodeText(string) {
      return _HTMLStringParser2.default.encode(string);
    }
  }
};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

var _Reporting = __webpack_require__(197);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _LifeStyle = __webpack_require__(97);

var _LifeStyle2 = _interopRequireDefault(_LifeStyle);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

var _CountryBadge = __webpack_require__(340);

var _CountryBadge2 = _interopRequireDefault(_CountryBadge);

var _Report = __webpack_require__(229);

var _Report2 = _interopRequireDefault(_Report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UserBadge: _UserBadge2.default,
    CountryBadge: _CountryBadge2.default,
    Report: _Report2.default
  },
  data: function data() {
    return {
      isLoading: true,
      comment: {},
      post: {},
      reports: {},
      isAmmending: false,
      model: {
        status: "REMOVE"
      }
    };
  },

  methods: {
    goToArticle: function goToArticle() {
      var self = this;
      self.$router.push({
        name: 'LifeStyleArticle',
        params: {
          permalink: self.post.post_slug
        }
      });
    },
    submitForm: function submitForm() {
      var self = this;
      if (self.$validator.validateAll()) {
        self.isAmmending = true;
        if (self.model.status === 'REMOVE') {
          self.$alert({
            title: "Are you sure?",
            text: "Are you sure you want to remove the following comment, as well as all sub comments and reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              var model = {
                comment_id: self.$route.params.id,
                level: 0,
                post_id: self.post.post_id
              };
              return _LifeStyle2.default.deleteComment(model);
            }
          }).then(function (response) {
            self.$toastr.success('Comment successfully removed');
            self.goToArticle();
          }.bind(self)).catch(self.$alert.noop);
        }
        if (self.model.status === 'KEEP') {
          self.$alert({
            title: "Are you sure?",
            text: "Are you sure you want keep the comment and remove all reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              return _Reporting2.default.removeReports("LIFE_REPLY", self.$route.params.id);
            }
          }).then(function (response) {
            self.$toastr.success('All reports for this comments have been removed');
            self.goToArticle();
          }.bind(self)).catch(self.$alert.noop);
        }
      }
    },
    encodeText: function encodeText(string) {
      return _HTMLStringParser2.default.encode(string);
    },
    loadLifeReports: function loadLifeReports() {
      var self = this;
      self.isLoading = true;
      _TitleManager2.default.setTitle(self.$t('message.loadingText'));
      _Reporting2.default.getLifeReports(self.$route.params.id, 'LIFE_REPLY').then(function (response) {
        self.comment = response.data.comment;
        self.post = response.data.post;
        self.reports = response.data.report;
        _TitleManager2.default.setTitle(self.post.post_title);
        self.isLoading = false;
        if (self.reports.reasons.length === 0) {
          self.goToArticle();
        }
      }).catch(function (error) {
        if (error.response.data) {
          self.$router.push({
            name: 'Dashboard'
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.loadLifeReports();
  }
};

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

var _Reporting = __webpack_require__(197);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _LifeStyle = __webpack_require__(97);

var _LifeStyle2 = _interopRequireDefault(_LifeStyle);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

var _Report = __webpack_require__(229);

var _Report2 = _interopRequireDefault(_Report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UserBadge: _UserBadge2.default,
    Report: _Report2.default
  },
  data: function data() {
    return {
      isLoading: true,
      comment: {},
      post: {},
      reports: {},
      isAmmending: false,
      model: {
        status: "REMOVE"
      }
    };
  },

  methods: {
    goToArticle: function goToArticle() {
      var self = this;
      self.$router.push({
        name: 'LifeStyleArticle',
        params: {
          permalink: self.post.post_slug
        }
      });
    },
    submitForm: function submitForm() {
      var self = this;
      if (self.$validator.validateAll()) {
        self.isAmmending = true;
        if (self.model.status === 'REMOVE') {
          self.$alert({
            title: "Are you sure?",
            text: "Are you sure you want to remove the following comment and all reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              var model = {
                comment_id: self.$route.params.id,
                level: 1,
                post_id: self.post.post_id
              };
              return _LifeStyle2.default.deleteComment(model);
            }
          }).then(function (response) {
            self.$toastr.success('Comment successfully removed');
            self.goToArticle();
          }.bind(self)).catch(self.$alert.noop);
        }
        if (self.model.status === 'KEEP') {
          self.$alert({
            title: "Are you sure?",
            text: "Are you sure you want keep the comment and remove all reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              return _Reporting2.default.removeReports("LIFE_SUBREPLY", self.$route.params.id);
            }
          }).then(function (response) {
            self.$toastr.success('All reports for this comments have been removed');
            self.goToArticle();
          }.bind(self)).catch(self.$alert.noop);
        }
      }
    },
    encodeText: function encodeText(string) {
      return _HTMLStringParser2.default.encode(string);
    },
    loadLifeReports: function loadLifeReports() {
      var self = this;
      self.isLoading = true;
      _TitleManager2.default.setTitle(self.$t('message.loadingText'));
      _Reporting2.default.getLifeReports(self.$route.params.id, 'LIFE_SUBREPLY').then(function (response) {
        self.comment = response.data.comment;
        self.post = response.data.post;
        self.reports = response.data.report;
        _TitleManager2.default.setTitle(self.post.post_title);
        self.isLoading = false;
        if (self.reports.reasons.length === 0) {
          self.goToArticle();
        }
      }).catch(function (error) {
        if (error.response.data) {
          self.$router.push({
            name: 'Dashboard'
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.loadLifeReports();
  }
};

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HTMLStringParser = __webpack_require__(166);

var _HTMLStringParser2 = _interopRequireDefault(_HTMLStringParser);

var _Reporting = __webpack_require__(197);

var _Reporting2 = _interopRequireDefault(_Reporting);

var _Discussion = __webpack_require__(69);

var _Discussion2 = _interopRequireDefault(_Discussion);

var _TitleManager = __webpack_require__(46);

var _TitleManager2 = _interopRequireDefault(_TitleManager);

var _UserBadge = __webpack_require__(189);

var _UserBadge2 = _interopRequireDefault(_UserBadge);

var _CountryBadge = __webpack_require__(340);

var _CountryBadge2 = _interopRequireDefault(_CountryBadge);

var _Report = __webpack_require__(229);

var _Report2 = _interopRequireDefault(_Report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Report: _Report2.default,
    UserBadge: _UserBadge2.default,
    CountryBadge: _CountryBadge2.default
  },
  data: function data() {
    return {
      isLoading: true,
      question: {},
      answer: {},
      report: {},
      isAmmending: false,
      model: {
        status: "REMOVE"
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var questionId = self.$route.params.id;
    self.isLoading = true;
    _TitleManager2.default.setTitle(self.$t('message.loadingText'));
    _Reporting2.default.getQuestionReport(questionId).then(function (response) {
      self.question = response.data.question;
      self.report = response.data.report;
      self.isLoading = false;
      _TitleManager2.default.setTitle(self.question.question);
    }).catch(function () {
      self.$router.push({
        name: 'QuestionThread',
        params: {
          id: self.$route.params.id
        }
      });
    });
  },

  methods: {
    goToThread: function goToThread() {
      var self = this;
      self.$router.push({
        name: 'QuestionThread',
        params: {
          id: self.$route.params.id
        }
      });
    },
    submitForm: function submitForm() {
      var self = this;
      if (self.$validator.validateAll()) {
        self.isAmmending = true;
        if (self.model.status === 'REMOVE') {
          self.$alert({
            title: "Are you sure?",
            text: "You are removing an question and all of its reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              return _Discussion2.default.deleteQuestion(self.$route.params.id);
            }
          }).then(function (response) {
            self.$router.push({
              name: 'QuestionsIndex'
            });
            self.$toastr.success(self.question.user.display_name + 's' + ' question was removed!');
          }.bind(self)).catch(self.$alert.noop);
        }

        if (self.model.status === 'KEEP') {
          self.$alert({
            title: "Are you sure?",
            text: "You want to keep the question and reject all reports",
            type: "warning",
            showCancelButton: true,
            showLoaderOnConfirm: false,
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            preConfirm: function preConfirm() {
              return _Reporting2.default.removeReports("THREAD_QUESTION", self.$route.params.id);
            }
          }).then(function (response) {
            self.$router.push({
              name: 'QuestionThread',
              params: {
                id: self.$route.params.id
              }
            });
            self.$toastr.success("All reports for this answer were removed");
          }.bind(self)).catch(self.$alert.noop);
        }
      }
    },
    encodeText: function encodeText(string) {
      return _HTMLStringParser2.default.encode(string);
    }
  }
};

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      title: this.$t('message.activitySettingsTitle'),
      subTitle: this.$t('message.activitySettingsSubTitle'),
      logins: [],
      isLoading: true
    };
  },

  methods: {
    initMounted: function initMounted() {
      var self = this;
      self.getTrackings();
    },
    getTrackings: function getTrackings() {
      var self = this;
      self.isLoading = true;
      _User2.default.getLoginTrackings().then(function (response) {
        self.logins = response.data;
        self.isLoading = false;
      });
    },
    formatDate: function formatDate(date) {
      return moment(date).format('MMMM Do YYYY, h:mm a');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _ConditionSearchMixin = __webpack_require__(1668);

var _ConditionSearchMixin2 = _interopRequireDefault(_ConditionSearchMixin);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ConditionSearchMixin2.default, _ScrollerMixin2.default],
  name: 'settings-conditions',
  data: function data() {
    return {
      title: this.$t('message.conditionsPreferencesTitle'),
      subTitle: this.$t('message.conditionsPreferencesSubTitle'),
      isSaving: false,
      isLoading: true,
      conditions: [],
      model: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/conditions');
    _User2.default.getUserConditions().then(function (response) {
      self.conditions = response.data;
      self.isLoading = false;
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.isSaving = true;
      _Account2.default.putUserConditions(self.conditions).then(function (response) {
        self.isSaving = false;
        self.conditions = response.data;
        self.$toastr.success(self.$t('message.updatedText'));
      });
    },
    deleteCondition: function deleteCondition(item) {
      var self = this;
      var index = self.conditions.indexOf(item);
      self.conditions.splice(index, 1);
      _Account2.default.putUserConditions(self.conditions).then(function (response) {
        self.isSaving = false;
        self.conditions = response.data;
      });
    }
  }
};

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _vuedraggable = __webpack_require__(3883);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    draggable: _vuedraggable2.default
  },
  data: function data() {
    return {
      title: this.$t('message.dashboardPreferencesTitle'),
      subTitle: this.$t('message.dashboardPreferencesSubTitle'),
      isUpdating: false,
      isLoading: true,
      order: []
    };
  },
  mounted: function mounted() {
    var self = this;
    if (self.$store.state.cardOrder.length > 0) {
      self.order = self.$store.state.cardOrder;
      self.isLoading = false;
    } else {
      _Settings2.default.getCardOrder().then(function (response) {
        self.order = response.data;
        self.$store.commit('setCardOrder', response.data);
        self.isLoading = false;
      });
    }
  },

  methods: {
    getNameByKey: function getNameByKey(key) {
      switch (key) {
        case "ACTIVITY":
          return "message.cardActivity";
        case "WEIGHT":
          return "message.cardWeight";
        case "BLOOD_GLUCOSE":
          return "message.cardBloodGlucose";
        case "SLEEP":
          return "message.cardSleep";
        case "CHOLESTEROL":
          return "message.cardCholesterol";
        case "MEDICATION":
          return "message.cardMedication";
        case "BLOOD_PRESSURE":
          return "message.cardBloodPressure";
        case "MOOD":
          return "message.cardMood";
        case "KETONES":
          return "message.cardKetones";
        case "NUTRITION":
          return "message.cardNutrition";
        case "INSULIN":
          return "message.cardInsulin";
      }
    },
    submitForm: function submitForm() {
      var self = this;
      self.isUpdating = true;
      self.$store.commit('setCardOrder', self.order);
      _Settings2.default.updateCardOrder(self.order).then(function (response) {
        self.isUpdating = false;
        self.$toastr.success("Updated card order");
        self.$router.push({
          name: 'Dashboard'
        });
      });
    }
  }
};

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Food = __webpack_require__(53);

var _Food2 = _interopRequireDefault(_Food);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _Rx = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ScrollerMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.foodPreferencesTitle'),
      subTitle: this.$t('message.foodPreferencesSubTitle'),
      isUpdating: false,
      foodDataSourceConfig: {
        text: "food_name",
        value: "food_id"
      },
      favoriteDataSource: [],
      favoriteSearchValue: "",
      favoriteSearching: false,
      dislikeDataSource: [],
      dislikeSearchValue: "",
      dislikeSearching: false,
      favorites: [],
      dislikes: []
    };
  },
  mounted: function mounted() {
    var self = this;

    self.getDislikedFoods();
    self.getFavoriteFoods();

    var favoriteAutocompleteElement = $('.favoriteAutocomplete');
    _Rx.Observable.fromEvent(favoriteAutocompleteElement, 'input').map(function (x) {
      return x.currentTarget.value;
    }).debounceTime(250).subscribe(function (eventText) {
      self.searchFoods(eventText, "favorite");
    });

    var dislikeAutocompleteElement = $('.dislikeAutocomplete');
    _Rx.Observable.fromEvent(dislikeAutocompleteElement, 'input').map(function (x) {
      return x.currentTarget.value;
    }).debounceTime(250).subscribe(function (eventText) {
      self.searchFoods(eventText, "disliked");
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.isUpdating = true;
      _User2.default.putFavouriteFoods(self.favorites).then(function () {
        self.getFavoriteFoods();
        _User2.default.putDislikedFoods(self.dislikes).then(function () {
          self.getDislikedFoods();
          self.isUpdating = false;
        });
      });
    },
    handleFavoriteSelected: function handleFavoriteSelected(value) {
      var self = this;
      var checkExists = self.favorites.filter(function (item) {
        return item.food_name === value;
      });
      if (checkExists.length === 0) {
        var currentFavorite = self.favoriteDataSource.filter(function (item) {
          return item.food_name === value;
        })[0];
        self.favorites.push(currentFavorite);
        self.favoriteSearchValue = "";
        self.favoriteDataSource = [];
        _User2.default.putFavouriteFoods(self.favorites).then(function (response) {});
      }
    },
    handleDislikeSelected: function handleDislikeSelected(value) {
      var self = this;
      var checkExists = self.dislikes.filter(function (item) {
        return item.food_name === value;
      });
      if (checkExists.length === 0) {
        var currentDislike = self.dislikeDataSource.filter(function (item) {
          return item.food_name === value;
        })[0];
        self.dislikes.push(currentDislike);
        self.dislikeSearchValue = "";
        self.dislikeDataSource = [];
        _User2.default.putDislikedFoods(self.dislikes).then(function (response) {});
      }
    },
    deleteFavorite: function deleteFavorite(item) {
      var self = this;
      var index = self.favorites.indexOf(item);
      self.favorites.splice(index, 1);
      _User2.default.putFavouriteFoods(self.favorites);
    },
    deleteDislike: function deleteDislike(item) {
      var self = this;
      var index = self.dislikes.indexOf(item);
      self.dislikes.splice(index, 1);
      _User2.default.putDislikedFoods(self.dislikes);
    },
    getFavoriteFoods: function getFavoriteFoods() {
      var self = this;
      _User2.default.getFavouriteFoods().then(function (response) {
        self.favorites = response.data;
      });
    },
    getDislikedFoods: function getDislikedFoods() {
      var self = this;
      _User2.default.getDislikedFoods().then(function (response) {
        self.dislikes = response.data;
      });
    },
    searchFoods: function searchFoods(eventText) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "favorite";

      var self = this;

      _Food2.default.autoComplete(eventText).then(function (response) {

        var items = [];
        var foods = [];
        var itemLength = response.data.length;

        if (_.isArray(response.data)) {
          for (var i = 0; i < itemLength; i++) {
            var model = {
              food_id: 0,
              food_name: response.data[i]
            };
            items.push(model);
          }
          foods = items;
          self.$nextTick(function () {
            foods = items.sort(function (a, b) {
              return a.food_name.toLowerCase() > eventText.toLowerCase();
            });
            if (to === "favorite") {
              self.favoriteDataSource = foods;
            }
            if (to === "disliked") {
              self.dislikeDataSource = foods;
            }
          });
        }
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9)))

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

var _RegisterReasons = __webpack_require__(728);

var _RegisterReasons2 = _interopRequireDefault(_RegisterReasons);

var _Occupations = __webpack_require__(727);

var _Occupations2 = _interopRequireDefault(_Occupations);

var _Allergies = __webpack_require__(720);

var _Allergies2 = _interopRequireDefault(_Allergies);

var _Genders = __webpack_require__(723);

var _Genders2 = _interopRequireDefault(_Genders);

var _DateMonths = __webpack_require__(232);

var _DateMonths2 = _interopRequireDefault(_DateMonths);

var _DietaryPreferences = __webpack_require__(721);

var _DietaryPreferences2 = _interopRequireDefault(_DietaryPreferences);

var _Ethnicity = __webpack_require__(722);

var _Ethnicity2 = _interopRequireDefault(_Ethnicity);

var _Languages = __webpack_require__(724);

var _Lessons = __webpack_require__(110);

var _Lessons2 = _interopRequireDefault(_Lessons);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _Utilities = __webpack_require__(274);

var _Height = __webpack_require__(1258);

var _Height2 = _interopRequireDefault(_Height);

var _UploadAvatar = __webpack_require__(674);

var _UploadAvatar2 = _interopRequireDefault(_UploadAvatar);

var _CurrencyInput = __webpack_require__(1272);

var _CurrencyInput2 = _interopRequireDefault(_CurrencyInput);

var _countryJs = __webpack_require__(789);

var _countryJs2 = _interopRequireDefault(_countryJs);

var _Alert = __webpack_require__(92);

var _Alert2 = _interopRequireDefault(_Alert);

var _ResetAccount = __webpack_require__(1257);

var _ResetAccount2 = _interopRequireDefault(_ResetAccount);

var _MobilePhoneInput = __webpack_require__(1249);

var _MobilePhoneInput2 = _interopRequireDefault(_MobilePhoneInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DobObject = _Utilities.Objects.DobObject;

exports.default = {
  components: {
    MobilePhoneInput: _MobilePhoneInput2.default,
    ResetAccount: _ResetAccount2.default,
    Alert: _Alert2.default,
    CurrencyInput: _CurrencyInput2.default,
    AvatarUploader: _UploadAvatar2.default,
    UpdateHeight: _Height2.default,
    DietPreferenceLocalizerMixin: _DietaryPreferences2.default
  },
  name: 'settings-general',
  mixins: [_ScrollerMixin2.default, _RegisterReasons2.default, _Occupations2.default, _Allergies2.default, _Genders2.default, _DateMonths2.default, _DietaryPreferences2.default, _HCPMixin2.default, _Ethnicity2.default],
  data: function data() {
    return {
      title: this.$t('message.accountPreferencesTitle'),
      subTitle: this.$t('message.accountPreferencesSubTitle'),
      isSaving: false,
      isLoading: true,
      fullWidth: true,
      underlineShow: true,
      model: {},
      personalizationModel: {},
      lists: {},
      snackbar: false,
      dobItems: DobObject,
      dob: {
        day: null,
        month: null,
        year: null
      },
      hideNameInputs: false
    };
  },

  watch: {
    'dob.day': function dobDay() {
      var self = this;
      self.formatDateOfBirth();
    },
    'dob.month': function dobMonth() {
      var self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
    },
    'dob.year': function dobYear() {
      var self = this;
      self.updateValidDobMonthDays();
      self.formatDateOfBirth();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/general');
    self.lists = self.$store.state.list;

    if (this.$store.state.user.scope.use_display_name === true) {
      this.hideNameInputs = true;
    }

    _Account2.default.getUserPersonalization().then(function (response) {
      self.personalizationModel = response.data;
      self.personalizationModel.currency_code = self.currencyCode.currencyCode;
    });

    _Account2.default.getAccount().then(function (response) {
      self.model = response.data;
      if (self.model.dob !== null) {
        var dob = self.model.dob.split('-');
        self.dob.year = self.dobItems.years.find(function (year) {
          return year.value === dob[0];
        });
        self.dob.month = self.dobItems.months.find(function (month) {
          return month.value === dob[1];
        });
        self.dob.day = dob[2];
      }
      self.isLoading = false;
    });
  },

  methods: {
    switchInputs: function switchInputs() {
      this.hideNameInputs = !this.hideNameInputs;
    },
    getNativeName: function getNativeName(key) {
      return (0, _Languages.getLanguageNativeName)(key);
    },
    yearList: function yearList() {
      var years = 110,
          yearStartAt = new Date().getFullYear(),
          yearsArray = [];
      for (var i = 0; i < years; i++) {
        yearsArray.push(yearStartAt--);
      }
      return yearsArray;
    },
    formatDateOfBirth: function formatDateOfBirth() {
      var self = this;
      if (!_.isNull(self.dob.day) && !_.isNull(self.dob.month) && !_.isNull(self.dob.year)) {
        self.model.dob = self.dob.year.value + '-' + self.dob.month.value + '-' + self.dob.day;
      }
    },
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {

        if (self.isOlderThan100 === true) {
          self.$toastr.error("You have to be under 100");
          return;
        }

        if (!self.isValidAge) {
          self.$toastr.error("Age has to be 18 or over");
          self.isSaving = false;
          return;
        }

        if (!valid) {
          self.isSaving = false;
          self.$toastr.error("There were some errors, please check your inputs");
          return;
        }

        self.isSaving = true;
        _Account2.default.putAccount(self.model).then(function (response) {
          _UserManager2.default.getUserAndStore(self);
          _Account2.default.putUserPersonalization(self.personalizationModel).then(function (response) {
            self.isSaving = false;
            _Lessons2.default.getLessonsList().then(function (response) {
              self.$store.commit('setLessons', response.data);
              self.$forceUpdate();
            });
            self.$toastr.success("Updated account");
          });
        }).catch(function (error) {
          if (error.response.data && error.response.data.sub_message && error.response.data.sub_message === "DISPLAY_NAME_UNAVAILABLE") {
            self.$toastr.error("Display name unavailable, please choose a different one");
            self.isSaving = false;
          }
        });
      }).catch(function () {
        self.isSaving = false;
        self.$toastr.error("An error occurred updating your account");
      });
    },
    updateValidDobMonthDays: function updateValidDobMonthDays() {
      var self = this;
      if (!self.dob.month || !self.dob.month.daysCount) {
        return;
      }

      var days = self.dob.month.daysCount + 1;

      if (!_.isNull(self.dob.year) && self.dob.year.isLeap === true && self.dob.month.value === "02") {
        days = self.dob.month.daysCount + 2;
      }

      var daysArray = [];

      for (var i = 1; i < days; i++) {
        if (i < 10) {
          daysArray.push('0' + i + '');
        } else {
          daysArray.push('' + i + '');
        }
      }

      self.$set(self.dobItems, 'days', daysArray);
    }
  },
  computed: {
    currencyCode: function currencyCode() {
      var self = this;
      if (self.$store.state.geoLocation.host != null && self.$store.state.geoLocation.host.country) {
        return _countryJs2.default.search(self.$store.state.geoLocation.host.country)[0].currency;
      }
      return _countryJs2.default.search('GB')[0].currency;
    },

    isValidAge: function isValidAge() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year.value + '-' + this.dob.month.value + '-' + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(18, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    },
    isOlderThan100: function isOlderThan100() {
      if (this.dob.day && this.dob.month && this.dob.year) {
        var userDob = this.dob.year.value + '-' + this.dob.month.value + '-' + this.dob.day;
        var dob = moment(userDob);
        var ageRestrict = moment().subtract(100, 'years');
        var validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(2)))

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      title: this.$t('message.integrationPreferencesTitle'),
      subTitle: this.$t('message.integrationPreferencesSubTitle'),
      isUpdating: false,
      isLoading: true,
      subscriptions: [],
      canStriivSync: false,
      hasStriivSyncStarted: false,
      integrations: [{
        key: "FITBIT",
        title: 'FitBit',
        image: "static/integrations/fitbit.svg",
        description: this.$t('message.integrationFitBitExplain'),
        url: _config2.default.apiUrl + "integration/fitbit/auth/",
        cookie: "FITBIT_REDIRECT_URI",
        handshake: _Integrations2.default.FITBIT.generateHandshake
      }]
    };
  },
  mounted: function mounted() {
    var self = this;
    self.getSubscriptions();
  },

  methods: {
    getSubscriptions: function getSubscriptions() {
      var self = this;
      _Integrations2.default.getSubscriptions().then(function (response) {
        self.subscriptions = response.data;
        self.subscriptions.forEach(function (item) {});
      });
    },
    disconnectIntegration: function disconnectIntegration(key) {
      var self = this;
      _Integrations2.default.disconnectIntegration(key).then(function (response) {
        self.getSubscriptions();
      });
    },
    windowOpen: function windowOpen(url, key, cookie, handshake) {
      var self = this;
      var value = '';
      if (handshake && typeof handshake === 'function') {
        handshake().then(function (response) {
          var uuid = response.data.uuid;
          if (!uuid || !uuid.length) {
            throw "Invalid response";
          }
          url = url + '?uuid=' + uuid;
          setLocation();
        });
      } else {
        setLocation();
      }

      var setLocation = function setLocation() {
        if (_config2.default.ApplicationContext === 'lowcarbprogram') {
          value = "https://www.lowcarbprogram.com/" + _config2.default.locale + "/#/integrated?name=" + key;
        } else {
          value = "https://www.grohealth.com/" + _config2.default.locale + "/#/integrated?name=" + key;
        }
        self.setCookie(cookie, value, 1);
        window.location.href = url;
      };
    },
    setCookie: function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    subscribedTo: function subscribedTo(key) {
      var self = this;
      var found = self.subscriptions.indexOf(key);
      return found !== -1;
    }
  }
};

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _HCPMixin = __webpack_require__(40);

var _HCPMixin2 = _interopRequireDefault(_HCPMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var settingsNavRoutes = [{
  name: "General",
  icon: "person",
  i18n: "message.settingsGeneralTitleText",
  route: "/settings/general"
}, {
  name: "Security",
  icon: "lock",
  i18n: "message.settingsSecurityTitleText",
  route: "/settings/security"
}, {
  name: "Subscription",
  icon: "payment",
  i18n: "message.settingsSubscriptionTitleText",
  route: "/settings/subscription"
}, {
  name: "Privacy",
  icon: "remove_red_eye",
  i18n: "message.settingsPrivacyTitleText",
  route: "/settings/privacy"
}, {
  name: "Notifications",
  icon: "notifications",
  i18n: "message.settingsNotificationsTitleText",
  route: "/settings/notifications"
}, {
  name: "Units",
  icon: "assessment",
  i18n: "message.settingsUnitsTitleText",
  route: "/settings/units"
}, {
  name: "Conditions",
  icon: "local_hospital",
  i18n: "message.settingsConditionsTitleText",
  route: "/settings/conditions"
}, {
  name: "Medications",
  icon: "healing",
  i18n: "message.settingsMedicationTitleText",
  route: "/settings/medications"
}, {
  name: "Food",
  icon: "local_dining",
  i18n: "message.settingsFoodTitleText",
  route: "/settings/food"
}, {
  name: "Dashboard",
  icon: "dashboard",
  i18n: "message.settingsDashboardTitleText",
  route: "/settings/dashboard"
}, {
  name: "Integrations",
  icon: "settings_input_hdmi",
  i18n: "message.settingsIntegrationTitleText",
  route: "/settings/integrations"
}, {
  name: "Preferences",
  icon: "settings_cog",
  i18n: "message.marketingPreferencesTitle",
  route: "/settings/preferences"
}, {
  name: "Activity",
  icon: "desktop_mac",
  i18n: "message.settingsActivityTitleText",
  route: "/settings/activity"
}];

exports.default = {
  mixins: [_ScrollerMixin2.default, _HCPMixin2.default],
  name: 'settings',
  watch: {
    '$route': function $route() {
      var self = this;
      self.setActiveRoute();
    },
    'activeRoute': function activeRoute() {
      var self = this;
      self.$router.push({ path: self.activeRoute.route });
    }
  },
  data: function data() {
    return {
      routes: settingsNavRoutes,
      activeRoute: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    self.setActiveRoute();
  },

  methods: {
    hideSettingsMenu: function hideSettingsMenu(name) {
      var self = this;
      if (self.isHcpView) {
        if (name === 'Preferences' || name === 'Integrations' || name === 'Dashboard' || name === 'Food' || name === 'Medications' || name === 'Conditions' || name === 'Units' || name === 'Privacy' || name === 'Notifications') {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    setActiveRoute: function setActiveRoute() {
      var self = this;
      var currentPath = self.$route.fullPath;
      self.activeRoute = self.routes.filter(function (item) {
        return item.route === currentPath;
      })[0];
    }
  }
};

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MedicationSearchMixin = __webpack_require__(1673);

var _MedicationSearchMixin2 = _interopRequireDefault(_MedicationSearchMixin);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_MedicationSearchMixin2.default, _ScrollerMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.medicationPreferencesAdd'),
      subTitle: this.$t('message.medicationPreferencesAddSubTitle'),
      isSaving: false,
      isError: false,
      errorMessage: "",
      model: {
        frequency_id: null,
        frequency_label: null,
        treatment_id: null,
        treatment_name: null,
        unit_id: null,
        unit_label: null,
        condition_id: "",
        condition_label: "",
        defaultDosage: 1,
        forDiabetes: 0
      },
      regimes: [],
      frequencies: [],
      conditions: []
    };
  },

  watch: {
    'model.frequency_id': function modelFrequency_id() {
      var self = this;
      if (self.model.frequency_id) {
        self.model.frequency_label = self.frequencies.filter(function (frequency) {
          return frequency.ID === self.model.frequency_id;
        })[0].frequency;
      }
    },
    'model.unit_id': function modelUnit_id() {
      var self = this;
      if (self.model.unit_id) {
        self.model.unit_label = self.regimes.filter(function (unit) {
          return unit.ID === self.model.unit_id;
        })[0].regimeUnitLabel;
      }
    },
    'model.condition_id': function modelCondition_id() {
      var self = this;
      if (self.model.condition_id) {
        self.model.condition_label = self.conditions.filter(function (condition) {
          return condition.condition_id === self.model.condition_id;
        })[0].condition_label;
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    _User2.default.getUserConditions().then(function (response) {
      self.conditions = response.data;
    });

    _Medication2.default.regimeUnitsGet().then(function (response) {
      self.regimes = response.data;
    });

    _Medication2.default.regimeFrequencysGet().then(function (response) {
      self.frequencies = response.data;
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      if (!self.model.treatment_name) {
        self.$toastr.error("Please enter a medication name");
        return;
      }
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          _Medication2.default.postUserMedication(self.model).then(function () {
            self.isSaving = false;
            self.$router.push({ name: 'SettingsMedication' });
          }).catch(function (error) {
            self.errorMessage = self.$t('message.medicationAlreadyTrackingError');
            self.isError = true;
            self.isSaving = false;
            setTimeout(function () {
              self.isError = false;
              self.isSaving = false;
            }.bind(self), 2000);
          });
        } else {}
      });
    },
    goBack: function goBack() {
      var self = this;
      self.$router.push({
        name: 'SettingsMedication'
      });
    },
    handleMedicationSelected: function handleMedicationSelected(value) {
      var self = this;
      if (value.length > 0) {
        if (self.medicationDataSource.length > 0) {
          var medication = self.medicationDataSource.filter(function (medication) {
            return medication.treatment_name === value;
          })[0];
          self.$nextTick(function () {
            self.model.treatment_name = medication.treatment_name;
            self.model.treatment_id = medication.treatment_id;
          });
        }
      } else {
        self.medicationDataSource = [];
        self.model.treatment_id = null;
        self.model.treatment_name = null;
      }
    }
  },
  computed: {
    user: function user() {
      var self = this;
      return self.$store.state.user.scope;
    }
  }
};

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _MedicationFrequencies = __webpack_require__(726);

var _MedicationFrequencies2 = _interopRequireDefault(_MedicationFrequencies);

var _MedicationRegimes = __webpack_require__(199);

var _MedicationRegimes2 = _interopRequireDefault(_MedicationRegimes);

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    medication: {
      type: Object,
      required: true
    }
  },
  mixins: [_ScrollerMixin2.default, _MedicationFrequencies2.default, _MedicationRegimes2.default],
  data: function data() {
    return {
      title: this.medication.treatment_name,
      subTitle: this.$t('message.medicationPreferenceUpdateSubTitle'),
      isLoading: true,
      isSaving: false,
      isError: false,
      model: {
        active: null,
        tracking_id: null,
        treatment_id: null,
        frequency_id: null,
        unit_id: null,
        condition_id: null,
        forDiabetes: 0
      },
      conditions: [],
      regimes: [],
      frequencies: []
    };
  },

  watch: {
    'model.frequency_id': function modelFrequency_id() {
      var self = this;
      if (self.model.frequency_id) {
        self.model.frequency_label = self.frequencies.filter(function (frequency) {
          return frequency.ID === self.model.frequency_id;
        })[0].frequency;
      }
    },
    'model.unit_id': function modelUnit_id() {
      var self = this;
      if (self.model.unit_id) {
        self.model.unit_label = self.regimes.filter(function (unit) {
          return unit.ID === self.model.unit_id;
        })[0].regimeUnitLabel;
      }
    },
    'model.condition_id': function modelCondition_id() {
      var self = this;
      if (self.model.condition_id) {
        self.model.condition_label = self.conditions.filter(function (condition) {
          return condition.condition_id === self.model.condition_id;
        })[0].condition_label;
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.model.active = self.medication.active;
    self.model.defaultDosage = self.medication.defaultDosage;
    self.model.tracking_id = self.medication.tracking_id;
    self.model.forDiabetes = self.medication.forDiabetes;
    _User2.default.getUserConditions().then(function (response) {
      self.conditions = response.data;
      self.model.condition_id = self.medication.condition_id;
      _Medication2.default.regimeUnitsGet().then(function (response) {
        self.regimes = response.data;
        self.model.unit_id = self.medication.unit_id;
        _Medication2.default.regimeFrequencysGet().then(function (response) {
          self.frequencies = response.data;
          self.model.frequency_id = self.medication.frequency_id;
          self.isLoading = false;
        });
      });
    });
    self.model.treatment_id = self.medication.treatment_id;
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          _Medication2.default.updateMedication(self.model).then(function (response) {
            self.isSaving = false;
            self.$router.push({
              name: 'SettingsMedication'
            });
          });
        } else {
          self.isSaving = false;
        }
      });
    },
    goBack: function goBack() {
      var self = this;
      self.$router.push({
        name: 'SettingsMedication'
      });
    }
  },
  computed: {
    user: function user() {
      var self = this;
      return self.$store.state.user.scope;
    }
  }
};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(59);

var _stringify2 = _interopRequireDefault(_stringify);

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'settings-medications',
  mixins: [_ScrollerMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.medicationPreferencesTitle'),
      subTitle: this.$t('message.medicationPreferencesSubTitle'),
      fullWidth: true,
      model: {},
      medications: [],
      isLoading: true,
      isSaving: false,
      snackbar: false,
      rightTop: { horizontal: 'right', vertical: 'top' }
    };
  },

  watch: {
    '$route': function $route() {
      var self = this;
      self.loadData();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/medication');
    self.loadData();
  },

  methods: {
    loadData: function loadData() {
      var self = this;
      _Medication2.default.getUserMedications().then(function (response) {
        var data = response.data;
        self.$nextTick(function () {
          self.medications = data.sort(function (a, b) {
            var nameA = a.treatment_name.toLowerCase(),
                nameB = b.treatment_name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          self.isLoading = false;
        });
      });
    },
    editMedication: function editMedication(item) {
      var self = this;
      self.$router.push({
        name: 'SettingsEditMedications',
        params: {
          medication: item
        }
      });
    },
    enableMedication: function enableMedication(item) {
      var self = this;
      item.active = true;
      _Medication2.default.updateMedication(item).then(function () {});
    },
    disableMedication: function disableMedication(item) {
      var self = this;
      self.$alert({
        title: self.$t('message.medicationConfirmAlertTitle'),
        text: self.$t('message.medicationConfirmAlertText'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          var model = JSON.parse((0, _stringify2.default)(item));
          model.active = false;
          return _Medication2.default.updateMedication(model);
        }
      }).then(function (response) {
        item.active = false;
        self.$alert({
          title: self.$t('message.medicationConfirmAlertSuccessTitle'),
          text: self.$t('message.medicationConfirmAlertSuccessText'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    handleToggle: function handleToggle(item) {
      item.active = !item.active;
      this.$forceUpdate();
    },
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          SettingsApi.putSettings(self.model).then(function (response) {
            self.showSnackbar();
            self.isSaving = false;
            self.$forceUpdate();
          }).catch(function (error) {
            self.isSaving = false;
          });
        }
      }).catch(function () {
        self.isSaving = false;
      });
    },
    showSnackbar: function showSnackbar() {
      var _this = this;

      this.snackbar = true;
      if (this.snackTimer) clearTimeout(this.snackTimer);
      this.snackTimer = setTimeout(function () {
        _this.snackbar = false;
      }, 2000);
    },
    hideSnackbar: function hideSnackbar() {
      this.snackbar = false;
      if (this.snackTimer) clearTimeout(this.snackTimer);
    }
  },
  computed: {
    activeMedications: function activeMedications() {
      var self = this;
      return self.medications.filter(function (item) {
        return item.active === true;
      });
    },
    inActiveMedications: function inActiveMedications() {
      var self = this;
      return self.medications.filter(function (item) {
        return item.active === false;
      });
    }
  }
};

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'settings-notifications',
  data: function data() {
    return {
      title: this.$t('message.notificationPreferencesTitle'),
      subTitle: this.$t('message.notificationPreferencesSubTitle'),
      model: {},
      isSaving: false,
      isLoading: true,
      snackbar: false
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/notifications');
    setTimeout(function () {
      _Settings2.default.getNotificationSettings().then(function (response) {
        self.isLoading = false;
        self.model = response.data;
      }).catch(function () {
        self.isLoading = false;
        self.model = {};
      });
    }.bind(self), 300);
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.isSaving = true;
      _Settings2.default.putNotificationSettings(self.model).then(function (response) {
        self.isSaving = false;
        self.$toastr.success("Updated notifications");
      });
    }
  }
};

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _User = __webpack_require__(45);

var _User2 = _interopRequireDefault(_User);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'settings-personalize',
  data: function data() {
    return {
      title: "Personalise your program",
      subTitle: "Update your personal info",
      isSaving: false,
      isLoading: true,
      fullWidth: true,
      underlineShow: true,
      model: {},
      lists: {},
      scroller: document.getElementsByClassName('main-content')[0]
    };
  },
  mounted: function mounted() {
    var self = this;
    _Lists2.default.getGettingStartedList().then(function (response) {
      self.lists = response.data;

      _User2.default.getUserPersonalization().then(function (response) {
        self.isLoading = false;
        self.model = response.data;
      });
    });
  }
};

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

exports.default = {
  name: 'settings-preferences',
  watch: {
    "route": function route() {
      var self = this;
      self.getPreferences();
    }
  },
  data: function data() {
    return {
      title: this.$t('message.marketingPreferencesTitle'),
      subTitle: this.$t('message.marketingPreferencesSubTitle'),
      dialog: false,
      model: {
        email_promotions: null,
        email_research: null,
        email_newsletter: null,
        email_updates: null,
        email_community: null
      }
    };
  },

  methods: {
    getPreferences: function getPreferences() {
      var self = this;
      _Account2.default.getMarketingPreferences().then(function (response) {
        var data = response.data;
        if (data.has_engaged_preference) {
          self.model.email_promotions = data.email_promotions;
          self.model.email_research = data.email_research;
          self.model.email_newsletter = data.email_newsletter;
          self.model.email_updates = data.email_updates;
          self.model.email_community = data.email_community;
        } else {
          self.model.email_updates = true;
          self.$forceUpdate();
        }
      });
    },
    savePreferences: function savePreferences() {
      var self = this;
      if (self.model.email_promotions === null || self.model.email_newsletter === null || self.model.email_research === null || self.model.email_updates === null || self.model.email_community === null) {
        self.$toastr.error('Please select all your communication preferences');
      } else {
        _Account2.default.updateMarketingPreferences(self.model).then(function (response) {
          self.$toastr.success('Updated');
          self.$store.state.user.scope.has_engaged_preference = true;
        });
      }
    },
    open: function open() {
      var self = this;
      self.dialog = true;
    },
    close: function close() {
      var self = this;
      self.dialog = false;
    },
    closeSet: function closeSet() {
      var self = this;
      self.dialog = false;
      self.model.email_updates = true;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getPreferences();
  }
};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'settings-privacy',
  data: function data() {
    return {
      title: this.$t('message.privacyPreferencesTitle'),
      subTitle: this.$t('message.privacyPreferencesSubTitle'),
      isSaving: false,
      isLoading: true,
      model: {
        medication: false
      },
      snackbar: false
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/privacy');
    setTimeout(function () {
      _Settings2.default.getPrivacySettings().then(function (response) {
        self.model = response.data;
        self.isLoading = false;
      }).catch(function () {
        self.model = {};
        self.isLoading = false;
      });
    }.bind(self), 300);
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.isSaving = true;
      _Settings2.default.putPrivacySettings(self.model).then(function (response) {
        self.$toastr.success("Updated privacy");
        self.isSaving = false;
      }).catch(function (error) {
        self.isSaving = false;
      });
    }
  }
};

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _EmailUpdate = __webpack_require__(3398);

var _EmailUpdate2 = _interopRequireDefault(_EmailUpdate);

var _PasswordStrengthValidation = __webpack_require__(342);

var _PasswordStrengthValidation2 = _interopRequireDefault(_PasswordStrengthValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmailUpdate: _EmailUpdate2.default,
    PasswordStrengthValidation: _PasswordStrengthValidation2.default
  },
  name: 'settings-security',
  data: function data() {
    return {
      title: this.$t('message.securityPreferencesTitle'),
      subTitle: this.$t('message.securityPreferencesSubTitle'),
      isSaving: false,
      isError: false,
      model: {
        visible: false
      },
      message: ""
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/security');
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function () {
        self.isSaving = true;
        _Account2.default.changePassword(self.model.old_password, self.model.new_password).then(function (response) {
          self.isSaving = false;
          self.isError = false;
          self.message = "You've updated your password";
          self.$toastr.success(self.message);
        }).catch(function (error) {
          self.isSaving = false;
          self.isError = true;
          self.message = error.response.data.message;
          self.$toastr.success(self.message);
        });
      });
    }
  }
};

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Payment = __webpack_require__(196);

var _Payment2 = _interopRequireDefault(_Payment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  name: 'settings-subscription',
  data: function data() {
    return {
      title: this.$t('message.subscriptionPreferencesTitle'),
      subTitle: this.$t('message.subscriptionPreferencesSubTitle'),
      isSaving: false,
      isLoading: false,
      subscription: null,
      invoice: null
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/subscription');
    self.fetchUserInvoice();
  },

  methods: {
    formatDate: function formatDate(date) {
      return new Date(date * 1000).toDateString();
    },
    fetchUserInvoice: function fetchUserInvoice() {
      var _this = this;

      this.isLoading = true;
      _Payment2.default.getUpcomingInvoice().then(function (res) {
        _this.subscription = res.data.data.subscription;
        _this.invoice = res.data.data.invoice;
        _this.isLoading = false;
      }).catch(function (e) {
        _this.subscription = null;
        _this.invoice = null;
        _this.isLoading = false;
      });
    },
    manageSubscription: function manageSubscription() {
      if (this.invoice) this.cancelSubscription();else this.restoreSubscription();
    },
    cancelSubscription: function cancelSubscription() {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "Your subscription will be terminated at the end of the current billing cycle, Are you sure you want to proceed?",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          self.isSaving = true;
          return _Payment2.default.cancelCurrentSubscription();
        }
      }).then(function (response) {
        self.isSaving = false;
        self.$toastr.success(response.data.message);
        self.fetchUserInvoice();
      }.bind(self)).catch(self.$alert.noop);
    },
    restoreSubscription: function restoreSubscription() {
      var self = this;
      self.$alert({
        title: "Are you sure?",
        text: "Your subscription will be renewed at the end of the current billing cycle, Are you sure you want to proceed?",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          self.isSaving = true;
          return _Payment2.default.resumeCurrentSubscription();
        }
      }).then(function (response) {
        self.isSaving = false;
        self.$toastr.success(response.data.message);
        self.fetchUserInvoice();
      }.bind(self)).catch(self.$alert.noop);
    }
  }
};

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

var _ScrollerMixin = __webpack_require__(14);

var _ScrollerMixin2 = _interopRequireDefault(_ScrollerMixin);

var _UserManager = __webpack_require__(113);

var _UserManager2 = _interopRequireDefault(_UserManager);

var _TabSelector = __webpack_require__(1259);

var _TabSelector2 = _interopRequireDefault(_TabSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { TabSelector: _TabSelector2.default },
  name: 'settings-units',
  mixins: [_ScrollerMixin2.default],
  data: function data() {
    return {
      title: this.$t('message.unitsPreferencesTitle'),
      subTitle: this.$t('message.unitsPreferencesSubTitle'),
      fullWidth: true,
      model: {},
      bindings: {},
      isLoading: true,
      isSaving: false
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/settings/units');
    _Lists2.default.getPreferenceTypes().then(function (response) {
      self.bindings = response.data;
      _Settings2.default.getUnitSettings().then(function (response) {
        self.model = response.data;
        self.isLoading = false;
      });
    });
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          self.isSaving = true;
          _Settings2.default.putUnitSettings(self.model).then(function (response) {
            self.isSaving = false;
            self.$toastr.success("Updated units");

            self.$store.commit('setBloodGlucoseCard', {});
            self.$store.commit('setWeightCard', {});
            self.$store.commit('setKetonesCard', {});
            self.$store.commit('setCholesterolCard', {});

            self.$forceUpdate();
          }).catch(function (error) {
            self.isSaving = false;
          });
        }
      }).catch(function () {
        self.isSaving = false;
      });
    }
  }
};

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SubscriptionForm = __webpack_require__(3434);

var _SubscriptionForm2 = _interopRequireDefault(_SubscriptionForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    SubscriptionForm: _SubscriptionForm2.default
  }
};

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(1648);

var _index2 = _interopRequireDefault(_index);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      siteUrl: _config2.default.siteUrl,
      isLoading: true,
      cardTitle: this.$t('message.labelAddTestimonial'),
      cardSubTitle: this.$t('message.labelTestimonialSubTitle'),
      questions: [],
      isSubmitting: false,
      terms: {
        agreed: false,
        label: ""
      },
      progressImage: {
        before: null,
        after: null
      },
      maxSize: 3
    };
  },

  methods: {
    openImage: function openImage(opt) {
      var element = $('#' + opt);
      element.find('input').click();
    },
    onLoadBefore: function onLoadBefore(image) {
      var self = this;
      self.progressImage.before = image;
    },
    onLoadAfter: function onLoadAfter(image) {
      var self = this;
      self.progressImage.after = image;
    },
    onSizeExceeded: function onSizeExceeded(size) {
      var self = this;
      self.$toastr.error('File exceeds max file size of ' + self.maxSize);
    },
    loadQuestions: function loadQuestions() {
      var self = this;
      _index2.default.getQuestions().then(function (response) {
        self.isLoading = false;
        var data = _.mapValues(response.data, function (val) {
          val.answer = "";
          return val;
        });
        self.questions = data;
      }).catch(function (error) {
        if (error.response) {
          self.$toastr.error(self.$t('message.labelError'));
        }
      });
    },
    submitTestimonial: function submitTestimonial() {
      var self = this;
      if (self.progressImage.before === null || self.progressImage.after === null) {
        self.$toastr.error('Please add progress pictures');
        return;
      }
      self.$validator.validateAll().then(function (valid) {
        if (valid) {
          if (self.terms.agreed === true) {
            self.isSubmitting = true;

            var answers = _.mapValues(self.questions, function (question) {
              return {
                question_id: question.question_id,
                answer: question.answer
              };
            });
            var testimonialData = {
              beforeImage: self.progressImage.before,
              afterImage: self.progressImage.after,
              answers: answers
            };
            _index2.default.saveTestimonial(testimonialData).then(function (response) {
              if (!response.data.error) {
                self.$toastr.success('Thanks!, your testimonial has been submitted');
                self.$router.push({
                  name: 'Dashboard'
                });
                self.isSubmitting = false;
              }
            }).catch(function (error) {
              if (error.response) {
                self.$toastr.error(self.$t('message.labelError'));
                self.isSubmitting = false;
              }
            });
          } else {
            self.$toastr.error('Please accept the terms and conditions');
            return;
          }
        } else {
          self.$toastr.error('Please fill in the form');
          return;
        }
      });
    },
    initMounted: function initMounted() {
      var self = this;
      self.loadQuestions();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.initMounted();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9)))

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _numeral = __webpack_require__(90);

var _numeral2 = _interopRequireDefault(_numeral);

var _Activity = __webpack_require__(478);

var _Activity2 = _interopRequireDefault(_Activity);

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _Activity3 = __webpack_require__(454);

var _Activity4 = _interopRequireDefault(_Activity3);

var _LineGraph = __webpack_require__(1262);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _activityTypes = __webpack_require__(481);

var _activityTypes2 = _interopRequireDefault(_activityTypes);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

var _LineGraph3 = __webpack_require__(3443);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _WearableVisualisation = __webpack_require__(3450);

var _WearableVisualisation2 = _interopRequireDefault(_WearableVisualisation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingDetailMixin2.default],
  components: {
    ActivityWearableVisualisation: _WearableVisualisation2.default,
    ActivityStepsLineGraph: _LineGraph4.default,
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    ActivityLineGraph: _LineGraph2.default,
    ActivityInput: _Activity4.default,
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default
  },
  data: function data() {
    return {
      btnColor: '#4f2bb4',
      activityTypes: _activityTypes2.default,
      mode: 'STEPS',
      modes: [{
        name: 'Manual logs',
        value: 'SELF_REPORTED'
      }, {
        name: 'Steps',
        value: 'STEPS'
      }]
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/activity');
    self.loadData();

    _Integrations2.default.available.activity().then(function (response) {
      if (response.data.length > 0) {}
    });

    self.$EventBus.$on('activityPusherReceived', function () {
      self.loadData();
    });
  },

  watch: {
    'mode': function mode() {
      var self = this;
      self.data.page = 1;
      self.data.page_size = 15;
      self.data.data = [];
      self.isReadingsLoading = true;
      if (self.mode === 'SELF_REPORTED') {
        _Activity2.default.getActivityTrackingDetail(1, 15).then(function (response) {
          self.isReadingsLoading = false;
          self.data = response.data;
          self.$forceUpdate();
        });
      }

      if (self.mode === 'STEPS') {
        _Activity2.default.getActivityStepsTrackingDetail(1, 15).then(function (response) {
          self.isReadingsLoading = false;
          self.data = response.data;
          self.$forceUpdate();
        });
      }
    }
  },
  methods: {
    numberFormat: function numberFormat(num) {
      var number = (0, _numeral2.default)(num);
      return number.format();
    },
    getStartedIntegrations: function getStartedIntegrations() {
      var self = this;
      self.$router.push({
        name: 'SettingsIntegrations'
      });
    },
    groupedStepDate: function groupedStepDate(date) {
      var offset = new Date();
      var dateMod = moment.utc(date).locale(_config2.default.language);
      return dateMod.format('dddd Do');
    },
    getLocaleLabel: function getLocaleLabel(key) {
      var self = this;
      var activeKey = self.activityTypes.filter(function (item) {
        return item.value === key;
      })[0];
      return self.$t(activeKey.locale);
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveActivityItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Activity2.default.deleteActivityReading(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveActivityItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    loadData: function loadData() {
      var self = this;

      if (self.mode === 'SELF_REPORTED') {
        _Activity2.default.getActivityTrackingDetail(1, 15).then(function (response) {
          self.isReadingsLoading = false;
          self.data = response.data;
          self.$forceUpdate();
        });
      }

      if (self.mode === 'STEPS') {
        _Activity2.default.getActivityStepsTrackingDetail(1, 15).then(function (response) {
          self.isReadingsLoading = false;
          self.data = response.data;
          self.$forceUpdate();
        });
      }
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;

        if (self.mode === 'SELF_REPORTED') {
          page++;
          _Activity2.default.getActivityTrackingDetail(page, 15).then(function (response) {
            self.data.page = response.data.page;
            self.data.data.push.apply(self.data.data, response.data.data);
            self.isReadingsLoading = false;
          });
        }
        if (self.mode === 'STEPS') {
          page++;
          _Activity2.default.getActivityStepsTrackingDetail(page, 15).then(function (response) {
            self.data.page = response.data.page;
            self.data.data.push.apply(self.data.data, response.data.data);
            self.isReadingsLoading = false;
          });
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('activityReadingAdded');
    this.$EventBus.$off('activityReadingReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollManager = __webpack_require__(100);

var _ScrollManager2 = _interopRequireDefault(_ScrollManager);

var _LineGraph = __webpack_require__(452);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _Sleep = __webpack_require__(198);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _Sleep3 = __webpack_require__(344);

var _Sleep4 = _interopRequireDefault(_Sleep3);

var _SleepEdit = __webpack_require__(1261);

var _SleepEdit2 = _interopRequireDefault(_SleepEdit);

var _Activity = __webpack_require__(478);

var _Activity2 = _interopRequireDefault(_Activity);

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _Activity3 = __webpack_require__(454);

var _Activity4 = _interopRequireDefault(_Activity3);

var _LineGraph3 = __webpack_require__(1262);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _activityTypes = __webpack_require__(481);

var _activityTypes2 = _interopRequireDefault(_activityTypes);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _numeral = __webpack_require__(90);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  components: {
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    ActivityLineGraph: _LineGraph4.default,
    ActivityInput: _Activity4.default,
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    SleepEdit: _SleepEdit2.default,
    SleepInput: _Sleep4.default,
    SleepGraph: _LineGraph2.default
  },
  data: function data() {
    return {
      btnColor: '#4f2bb4',
      data: [],
      isReadingsLoading: true
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/activity/fitbit');
    self.loadData();
    self.$nextTick(function () {
      var element = document.getElementsByClassName('main-content')[0];
      element.addEventListener('scroll', self.handleScroll);
    });
  },

  methods: {
    numberFormat: function numberFormat(num) {
      var number = (0, _numeral2.default)(num);
      return number.format();
    },
    fatBurnPercentageMins: function fatBurnPercentageMins(zones) {
      var fatBurnMinutes = zones[1].minutes;
      return moment.duration(fatBurnMinutes, 'minutes').humanize(false);
    },
    fatBurnPercentage: function fatBurnPercentage(zones) {
      var outOfRangeMinutes = zones[0].minutes;
      var fatBurnMinutes = zones[1].minutes;
      var cardioMinutes = zones[2].minutes;
      var peakMinutes = zones[3].minutes;
      var total = outOfRangeMinutes + fatBurnMinutes + cardioMinutes + peakMinutes;
      return (fatBurnMinutes / total * 100).toFixed(1) + '%';
    },
    duration: function duration(ms) {
      var self = this;
      var hours = moment.duration(ms, 'milliseconds').get('hours');
      var minutes = moment.duration(ms, 'milliseconds').get('minutes');
      if (hours === 0) {
        return minutes + ' min';
      }
      if (hours > 0) {
        return hours + 'h ' + minutes + ' min';
      }
    },

    handleScroll: function handleScroll() {
      var self = this;
      if (!self.isReadingsLoading) {
        if (_ScrollManager2.default.isElementInViewport(self.$refs['detector'])) {
          self.loadMoreData();
        }
      }
    },
    loadMoreData: function loadMoreData() {
      var self = this;
    },
    groupedDateFormat: function groupedDateFormat(date) {
      var self = this;
      return moment(date).calendar(null, {
        lastDay: '[This week]',
        sameDay: '[This week]',
        nextDay: '[Tomorrow]',
        lastWeek: '[last] dddd',
        nextWeek: 'dddd',
        sameElse: moment(date).startOf('isoWeek').format('DD/MM/YYYY') + ' - ' + moment(date).endOf('isoWeek').format('DD/MM/YYYY')
      });
    },
    groupedItemDate: function groupedItemDate(date, duration) {
      var self = this;
      var offset = new Date();
      var dateMod = moment.utc(date).local().locale(_config2.default.language);
      return dateMod.format('hh:mm a') + ' on ' + dateMod.format('dddd Do');
    },
    onTrackingTypeActivity: function onTrackingTypeActivity(value) {
      var self = this;
      if (value === 'LCP') {
        self.$router.push({
          name: 'ActivityProgress'
        });
      }
    },
    loadData: function loadData() {
      var self = this;
      var today = moment().utc().local();
      self.isReadingsLoading = true;
      _Integrations2.default.FITBIT.getActivityLog(today.format('YYYY-MM-DD')).then(function (response) {
        self.isReadingsLoading = false;
        self.data = response.data.activities;

        self.$forceUpdate();
      }).catch(function (error) {
        self.isReadingsLoading = false;
      });
    },
    groupFilter: function groupFilter() {
      var self = this;
      return _.groupBy(self.data, function (reading) {
        return moment(reading.startTime).startOf('isoWeek').format();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('activityReadingAdded');
    this.$EventBus.$off('activityReadingReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BloodGlucose = __webpack_require__(351);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _Lists = __webpack_require__(165);

var _Lists2 = _interopRequireDefault(_Lists);

var _Settings = __webpack_require__(98);

var _Settings2 = _interopRequireDefault(_Settings);

var _LineGraph = __webpack_require__(343);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _BloodGlucose3 = __webpack_require__(455);

var _BloodGlucose4 = _interopRequireDefault(_BloodGlucose3);

var _BloodGlucoseEdit = __webpack_require__(1260);

var _BloodGlucoseEdit2 = _interopRequireDefault(_BloodGlucoseEdit);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _HbA1c = __webpack_require__(1270);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _BloodGlucose5 = __webpack_require__(3449);

var _BloodGlucose6 = _interopRequireDefault(_BloodGlucose5);

var _BloodGlucoseRange = __webpack_require__(3451);

var _BloodGlucoseRange2 = _interopRequireDefault(_BloodGlucoseRange);

var _TagLocalizerMixin = __webpack_require__(356);

var _TagLocalizerMixin2 = _interopRequireDefault(_TagLocalizerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  components: {
    BloodGlucoseRange: _BloodGlucoseRange2.default,
    BloodGlucoseTargets: _BloodGlucose6.default,
    Hba1cInput: _HbA1c2.default,
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    BgEdit: _BloodGlucoseEdit2.default,
    BloodGlucoseInput: _BloodGlucose4.default,
    BgLineGraph: _LineGraph2.default
  },
  mixins: [_TrackingDetailMixin2.default, _TagLocalizerMixin2.default],
  data: function data() {
    var self = this;
    return {
      btnColor: '#E84341',
      bgSettings: {},
      readingTags: [],
      selectedTab: "bloodGlucose"
    };
  },
  mounted: function mounted() {
    var self = this;

    self.$gtag.pageview('/tracking/blood-glucose');

    self.loadTags();
    _Settings2.default.getBloodSugarSettings().then(function (response) {
      self.bgSettings = response.data;
      _BloodGlucose2.default.getBloodGlucoseTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
        self.$forceUpdate();
      });
    });

    self.$EventBus.$on('bgPusherReceived', function () {
      self.isReadingsLoading = true;
      _BloodGlucose2.default.getBloodGlucoseTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
        self.$forceUpdate();
      });
    });
  },

  methods: {
    goTo: function goTo(name) {
      var self = this;
      self.$router.push({
        name: name
      });
    },
    loadTags: function loadTags() {
      var self = this;
      var getData = _Lists2.default.getTagList();
      getData.then(function (response) {
        var data = response.data;
        data = data.sort(function (a, b) {
          var textA = a.tag.toUpperCase();
          var textB = b.tag.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        self.readingTags = data;
        self.$forceUpdate();
      });
    },
    updateReading: function updateReading(data) {
      var self = this;
      var currentReading = self.data.data.filter(function (reading) {
        return reading.progress_id === data.progress_id;
      })[0];

      currentReading.blood_glucose_mgdl = data.blood_glucose_mgdl;
      currentReading.blood_glucose_mmoll = data.blood_glucose_mmoll;
      currentReading.tags = data.tags;
      currentReading.date_created = data.date_created;

      self.$emit('updateGraphData');

      self.sortItems();
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveBloodGlucoseItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _BloodGlucose2.default.deleteGlucoseReading(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveBloodGlucoseItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    determineRange: function determineRange(reading, preference) {
      var self = this;
      if (preference === 'mmoll') {
        if (reading.blood_glucose_mmoll > self.bgSettings.glucose_range.max) {
          return 'inHyper';
        }
        if (reading.blood_glucose_mmoll < self.bgSettings.glucose_range.min) {
          return 'inHypo';
        }
        if (reading.blood_glucose_mmoll >= self.bgSettings.glucose_range.min && reading.blood_glucose_mmoll <= self.bgSettings.glucose_range.max) {
          return 'inRange';
        }
      }
      if (preference === 'mgdl') {
        if (reading.blood_glucose_mgdl > self.bgSettings.glucose_range.max) {
          return 'inHyper';
        }
        if (reading.blood_glucose_mgdl < self.bgSettings.glucose_range.min) {
          return 'inHypo';
        }
        if (reading.blood_glucose_mgdl >= self.bgSettings.glucose_range.min && reading.blood_glucose_mgdl <= self.bgSettings.glucose_range.max) {
          return 'inRange';
        }
      }
    },
    determineColor: function determineColor(reading) {
      var self = this;

      if (self.determineRange(reading, self.data.preference) === 'inRange') {
        return "#8DC948";
      }
      if (self.determineRange(reading, self.data.preference) === 'inHypo') {
        return "#0179d5";
      }
      if (self.determineRange(reading, self.data.preference) === 'inHyper') {
        return "#E74C3C";
      }
    },
    showAllTags: function showAllTags(item) {
      var self = this;
      if (item.showAllTags === undefined) {
        item.showAllTags = true;
      } else {
        item.showAllTags = !item.showAllTags;
      }
      self.$forceUpdate();
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _BloodGlucose2.default.getBloodGlucoseTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('bgReadingAdded');
    this.$EventBus.$off('bgPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LineGraph = __webpack_require__(1263);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _BloodPressure = __webpack_require__(669);

var _BloodPressure2 = _interopRequireDefault(_BloodPressure);

var _BloodPressure3 = __webpack_require__(479);

var _BloodPressure4 = _interopRequireDefault(_BloodPressure3);

var _BloodPressureEdit = __webpack_require__(3435);

var _BloodPressureEdit2 = _interopRequireDefault(_BloodPressureEdit);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _LineGraph3 = __webpack_require__(3445);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _Pulse = __webpack_require__(3452);

var _Pulse2 = _interopRequireDefault(_Pulse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  mixins: [_TrackingDetailMixin2.default],
  components: {
    PulseRange: _Pulse2.default,
    StriivPulseLineGraph: _LineGraph4.default,
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    BpEdit: _BloodPressureEdit2.default,
    BloodPressureInput: _BloodPressure2.default,
    BpLineGraph: _LineGraph2.default
  },
  data: function data() {
    return {
      devices: [],
      selectedDevice: '',
      btnColor: '#FA6957',
      date: toDate
    };
  },
  mounted: function mounted() {
    var self = this;
    self.listUserDevices();

    self.date = toDate.format('YYYY-MM-DD');

    self.$gtag.pageview('/tracking/blood-pressure');
    self.loadData();

    self.$EventBus.$on('bloodPressurePusherReceived', function () {
      self.loadData();
    });
  },

  computed: {
    isToday: function isToday() {
      var self = this;
      return moment().isSame(moment(self.date), 'day');
    },
    isStriiv: function isStriiv() {
      var self = this;
      return self.selectedDevice === 'STRIIV';
    }
  },
  methods: {
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      return moment(date);
    }),
    filterDate: function filterDate(position) {
      var self = this,
          date = moment(self.date),
          newDate = null;
      if (position === 'prev') {
        date = date.subtract(1, "days");
        newDate = date;
      }
      if (position === 'next') {
        date = date.add(1, "days");
        newDate = date;
      }
      self.date = newDate.format('YYYY-MM-DD');
    },
    capitialize: function capitialize(str) {
      return _.capitalize(str);
    },
    listUserDevices: function listUserDevices() {
      var self = this;
      _Integrations2.default.getSubscriptions().then(function (response) {
        var data = response.data;
        self.devices = data;
        self.selectedDevice = data[0];
      });
    },
    loadData: function loadData() {
      var self = this;
      _BloodPressure4.default.getBloodPressureTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
      });
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveBloodPressureItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _BloodPressure4.default.deleteBloodPressureTracking(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveBloodPressureItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _BloodPressure4.default.getBloodPressureTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    },
    updateReading: function updateReading(item) {
      var self = this;
      var currentReading = self.data.data.filter(function (reading) {
        return reading.progress_id === item.progress_id;
      })[0];

      currentReading.date_created = item.date_created;
      currentReading.systolic = item.systolic;
      currentReading.diastolic = item.diastolic;
      currentReading.pulse = item.pulse;

      self.$emit('updateGraphData');
      self.$EventBus.$emit('bloodPressureReadingUpdated');

      self.sortItems();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('bpReadingAdded');
    this.$EventBus.$off('bloodPressurePusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cholesterol = __webpack_require__(480);

var _Cholesterol2 = _interopRequireDefault(_Cholesterol);

var _CholesterolEdit = __webpack_require__(3436);

var _CholesterolEdit2 = _interopRequireDefault(_CholesterolEdit);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _LineGraph = __webpack_require__(1264);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  components: {
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    CholesterolLineGraph: _LineGraph2.default,
    CholesterolEdit: _CholesterolEdit2.default
  },
  mixins: [_TrackingDetailMixin2.default],
  data: function data() {
    var self = this;
    return {
      activeFilter: "TOTAL_CHOLESTEROL",
      ranges: {
        mmoll: {
          ldl: {
            value: 3
          },
          hdl: {
            value: 1
          },
          total: {
            value: 5
          }
        },
        mgdl: {
          ldl: {
            value: 54
          },
          hdl: {
            value: 18
          },
          total: {
            value: 90
          }
        }
      },
      filters: [{
        key: "TOTAL_CHOLESTEROL",
        value: this.$t('message.labelCholesterolTotal') + " " + this.$t('message.cardCholesterol')
      }, {
        key: "LDL_CHOLESTEROL",
        value: this.$t('message.labelCholesterolLDL') + " " + this.$t('message.cardCholesterol')
      }, {
        key: "HDL_CHOLESTEROL",
        value: this.$t('message.labelCholesterolHDL') + " " + this.$t('message.cardCholesterol')
      }, {
        key: "TRIGLYCERIDES",
        value: this.$t('message.labelCholesterolTriglycerides')
      }],
      btnColor: 'rgb(105,125,206)'
    };
  },
  mounted: function mounted() {
    var self = this;

    self.$gtag.pageview('/tracking/cholesterol');

    self.loadData();

    self.$EventBus.$on('cholesterolPusherReceived', function () {
      self.loadData();
    });
  },

  methods: {
    updateReading: function updateReading(data) {
      var self = this;
      var currentReading = self.data.data.filter(function (reading) {
        return reading.progress_id === data.progress_id;
      })[0];

      currentReading.date_created = data.date_created;
      currentReading.total_mmoll = data.total_mmoll;
      currentReading.total_mgdl = data.total_mgdl;
      currentReading.ldl_mmoll = data.ldl_mmoll;
      currentReading.ldl_mgdl = data.ldl_mgdl;
      currentReading.hdl_mmoll = data.hdl_mmoll;
      currentReading.hdl_mgdl = data.hdl_mgdl;
      currentReading.triglycerides_mmoll = data.triglycerides_mmoll;
      currentReading.triglycerides_mgdl = data.triglycerides_mgdl;

      self.sortItems();
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveCholesterolItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Cholesterol2.default.deleteCholesterolTracking(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveCholesterolItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    determineColor: function determineColor(reading) {
      var self = this;
      var bloodPreference = self.data.preference;
      var green = "#5FB737";
      var orange = "#FCA039";
      if (self.activeFilter === 'TOTAL_CHOLESTEROL') {
        if (bloodPreference === 'mmoll') {
          if (reading.total_mmoll < self.ranges.mmoll.total.value) {
            return green;
          } else {
            return orange;
          }
        }
        if (bloodPreference === 'mgdl') {
          if (reading.total_mgdl < self.ranges.mgdl.total.value) {
            return green;
          } else {
            return orange;
          }
        }
      }
      if (self.activeFilter === 'HDL_CHOLESTEROL') {
        if (bloodPreference === 'mmoll') {
          if (reading.hdl_mmoll < self.ranges.mmoll.hdl.value) {
            return green;
          } else {
            return orange;
          }
        }
        if (bloodPreference === 'mgdl') {
          if (reading.hdl_mgdl < self.ranges.mgdl.hdl.value) {
            return green;
          } else {
            return orange;
          }
        }
      }
      if (self.activeFilter === 'LDL_CHOLESTEROL') {
        if (bloodPreference === 'mmoll') {
          if (reading.ldl_mmoll < self.ranges.mmoll.ldl.value) {
            return green;
          } else {
            return orange;
          }
        }
        if (bloodPreference === 'mgdl') {
          if (reading.hdl_mgdl < self.ranges.mgdl.ldl.value) {
            return green;
          } else {
            return orange;
          }
        }
      }
    },
    loadData: function loadData() {
      var self = this;
      self.isReadingsLoading = true;
      _Cholesterol2.default.getCholesterolTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
      });
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Cholesterol2.default.getCholesterolTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('cholesterolReadingAdded');
    this.$EventBus.$off('cholesterolPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HbA1c = __webpack_require__(272);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _LineGraph = __webpack_require__(343);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _BloodGlucose = __webpack_require__(455);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _BloodGlucoseEdit = __webpack_require__(1260);

var _BloodGlucoseEdit2 = _interopRequireDefault(_BloodGlucoseEdit);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _HbA1c3 = __webpack_require__(1270);

var _HbA1c4 = _interopRequireDefault(_HbA1c3);

var _LineGraph3 = __webpack_require__(3444);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _HbA1cEdit = __webpack_require__(3437);

var _HbA1cEdit2 = _interopRequireDefault(_HbA1cEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  components: {
    Hba1cEdit: _HbA1cEdit2.default,
    Hba1cLineGraph: _LineGraph4.default,
    Hba1cInput: _HbA1c4.default,
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    BgEdit: _BloodGlucoseEdit2.default,
    BloodGlucoseInput: _BloodGlucose2.default,
    BgLineGraph: _LineGraph2.default
  },
  mixins: [_TrackingDetailMixin2.default],
  data: function data() {
    var self = this;
    return {
      btnColor: '#E84341',
      bgSettings: {},
      selectedTab: "hba1c"
    };
  },
  mounted: function mounted() {
    var self = this;

    self.$gtag.pageview('/tracking/hba1c');

    _HbA1c2.default.getHbA1cTrackingDetail(1, 15).then(function (response) {
      self.data = response.data;
      self.isReadingsLoading = false;
    });

    self.$EventBus.$on('bgPusherReceived', function () {
      self.isReadingsLoading = true;
      _HbA1c2.default.getHbA1cTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
      });
    });
  },

  methods: {
    goTo: function goTo(name) {
      var self = this;
      self.$router.push({
        name: name
      });
    },
    updateReading: function updateReading(data) {
      var self = this;
      var currentReading = self.data.data.filter(function (reading) {
        return reading.progress_id === data.progress_id;
      })[0];

      currentReading.percent = data.percent;
      currentReading.mmol_mol = data.mmol_mol;
      currentReading.date_created = data.date_created;

      self.$emit('updateGraphData');

      self.sortItems();
    },
    deleteReading: function deleteReading(reading) {

      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveHbA1cItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _HbA1c2.default.deleteHbA1cReading(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveHbA1cItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _HbA1c2.default.getHbA1cTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    }
  },
  computed: {
    hba1cSetting: function hba1cSetting() {
      var self = this;
      return self.$store.state.user.settings.hba1c;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('bgReadingAdded');
    this.$EventBus.$off('bgPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Insulin = __webpack_require__(352);

var _Insulin2 = _interopRequireDefault(_Insulin);

var _LineGraph = __webpack_require__(1265);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _Insulin3 = __webpack_require__(670);

var _Insulin4 = _interopRequireDefault(_Insulin3);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _InsulinEdit = __webpack_require__(3438);

var _InsulinEdit2 = _interopRequireDefault(_InsulinEdit);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _InsulinMixin = __webpack_require__(355);

var _InsulinMixin2 = _interopRequireDefault(_InsulinMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  mixins: [_TrackingDetailMixin2.default, _InsulinMixin2.default],
  components: {
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    InsulinEdit: _InsulinEdit2.default,
    InsulinInput: _Insulin4.default,
    InsulinLineGraph: _LineGraph2.default
  },
  data: function data() {
    return {
      insulinTypes: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/insulin');

    _Insulin2.default.getInsulinTypes().then(function (response) {
      self.insulinTypes = response.data;
    });

    self.$EventBus.$on('insulinPusherReceived', function () {
      self.getData();
    });

    self.getData();
  },

  methods: {
    updateReading: function updateReading(reading) {
      var self = this;

      var currentReading = self.data.data.filter(function (item) {
        return item.progress_id === reading.progress_id;
      })[0];

      currentReading.units = reading.units;
      currentReading.type = reading.type;
      currentReading.type_name = reading.type_name;
      currentReading.date_created = reading.date_created;

      var typeId = currentReading.type;
      var findInsulinType = self.insulinTypes.filter(function (item) {
        return item.insulin_type_id === reading.type;
      })[0];

      currentReading.type_name = findInsulinType.type;
      self.$forceUpdate();
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveInsulinItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Insulin2.default.deleteInsulinTracking(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveInsulinItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    getData: function getData() {
      var self = this;
      _Insulin2.default.getInsulinTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
      });
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Insulin2.default.getInsulinTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    },
    btnColor: function btnColor(item) {
      if (item.type_name === 'Basal') {
        return '#34CAB9';
      }
      if (item.type_name === 'Bolus') {
        return '#9838C5';
      }

      if (item.type_name === 'Correction') {
        return '#A5DD85';
      } else {
        return "#00CBB4";
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('insulinReadingAdded');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Ketones = __webpack_require__(353);

var _Ketones2 = _interopRequireDefault(_Ketones);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _LineGraph = __webpack_require__(1266);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _KetonesEdit = __webpack_require__(3439);

var _KetonesEdit2 = _interopRequireDefault(_KetonesEdit);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  components: {
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    KetonesEdit: _KetonesEdit2.default,
    KetonesLineGraph: _LineGraph2.default
  },
  mixins: [_TrackingDetailMixin2.default],
  data: function data() {
    return {
      btnColor: '#2761ff'
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/ketones');
    self.$EventBus.$on('ketonesPusherReceived', function () {
      self.getData();
    });
    self.getData();
  },

  methods: {
    updateReading: function updateReading(item) {
      var self = this;
      var currentReading = self.data.data.filter(function (reading) {
        return item.progress_id === reading.progress_id;
      })[0];
      currentReading.mgdl = item.mgdl;
      currentReading.mmoll = item.mmoll;
      currentReading.date_created = item.date_created;
      self.$EventBus.$emit('ketonesReadingUpdated');
      self.sortItems();
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveKetoneItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Ketones2.default.deleteKetonesTracking(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveKetoneItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    getData: function getData() {
      var self = this;
      _Ketones2.default.getKetonesTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
      });
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Ketones2.default.getKetonesTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('ketonesReadingAdded');
    this.$EventBus.$off('ketonesPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LineGraph = __webpack_require__(1267);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

var _Medication3 = __webpack_require__(671);

var _Medication4 = _interopRequireDefault(_Medication3);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _MedicationRegimes = __webpack_require__(199);

var _MedicationRegimes2 = _interopRequireDefault(_MedicationRegimes);

var _MedicationEdit = __webpack_require__(3440);

var _MedicationEdit2 = _interopRequireDefault(_MedicationEdit);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingDetailMixin2.default, _MedicationRegimes2.default],
  components: {
    TrackingNotifier: _TrackingNotifier2.default,
    MedicationEdit: _MedicationEdit2.default,
    MedicationInput: _Medication4.default,
    MedicationLineGraph: _LineGraph2.default
  },
  data: function data() {
    return {
      btnColor: '#AE3463',
      isLoading: true,
      activeTrackingId: 0,
      medications: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();

    self.$EventBus.$on('medicationPusherReceived', function () {
      self.loadData();
    });

    _Medication2.default.getUserMedications().then(function (response) {
      self.medications = response.data;
      self.setActiveMedicationByIndex(0);
      self.$nextTick(function () {
        self.isLoading = false;
      });
    });
  },

  methods: {
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Medication2.default.getMedicationsTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    },
    loadData: function loadData() {
      var self = this;
      _Medication2.default.getMedicationsTrackingDetail(1, 15).then(function (response) {
        self.data = response.data;
        self.isReadingsLoading = false;
      });
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveMedicationItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Medication2.default.deleteMedicationDosage(reading.dosage_id);
        }
      }).then(function () {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveMedicationItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    updateReading: function updateReading(item) {
      var self = this;
      var currentReading = self.data.data.filter(function (dosage) {
        return dosage.dosage_id === item.dosage_id;
      })[0];
      currentReading.dosage = item.dosage;
      currentReading.date_created = item.date_created;
      currentReading.isEditMode = false;

      self.sortItems();
    },
    setActiveMedicationByIndex: function setActiveMedicationByIndex(index) {
      var self = this;
      self.activeTrackingId = self.medications[index].tracking_id;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('medicationPusherReceived');
    this.$EventBus.$off('medicationReadingAdded');
  }
};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _Mood = __webpack_require__(714);

var _Mood2 = _interopRequireDefault(_Mood);

var _Mood3 = __webpack_require__(672);

var _Mood4 = _interopRequireDefault(_Mood3);

var _LineGraph = __webpack_require__(1268);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _MoodLocalizerMixin = __webpack_require__(484);

var _MoodLocalizerMixin2 = _interopRequireDefault(_MoodLocalizerMixin);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  mixins: [_TrackingDetailMixin2.default, _MoodLocalizerMixin2.default],
  components: {
    TrackingNotifier: _TrackingNotifier2.default,
    MoodLineGraph: _LineGraph2.default,
    MoodInput: _Mood4.default
  },
  data: function data() {
    return {
      btnColor: '#302ca9'
    };
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/mood');
    self.loadData();
    self.$EventBus.$on('moodPusherReceived', function () {
      self.loadData();
    });
  },

  methods: {
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveMoodItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Mood2.default.deleteMoodTracking(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveMoodItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    loadData: function loadData() {
      var self = this;
      _Mood2.default.getMoodTrackingDetail(1, 15).then(function (response) {
        self.isReadingsLoading = false;
        self.data = response.data;
      });
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Mood2.default.getMoodTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    },
    groupedDateFormat: function groupedDateFormat(date) {
      var self = this;
      return moment(date).format('dddd Do  MMMM YYYY');
    },
    groupedItemDate: function groupedItemDate(date) {
      var offset = new Date();
      var dateMod = moment.utc(date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
      return dateMod.format('hh:mm a') + ' on ' + dateMod.format('dddd Do');
    },
    groupFilter: function groupFilter() {
      var self = this;
      return _.groupBy(self.data.data, function (reading) {
        return moment(reading.date_created).startOf('day').format();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('moodPusherReceived');
    this.$EventBus.$off('moodReadingAdded');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LineGraph = __webpack_require__(452);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _Sleep = __webpack_require__(198);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _Sleep3 = __webpack_require__(344);

var _Sleep4 = _interopRequireDefault(_Sleep3);

var _SleepEdit = __webpack_require__(1261);

var _SleepEdit2 = _interopRequireDefault(_SleepEdit);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _FitbitSteppedChart = __webpack_require__(666);

var _FitbitSteppedChart2 = _interopRequireDefault(_FitbitSteppedChart);

var _FitbitSleepStages = __webpack_require__(665);

var _FitbitSleepStages2 = _interopRequireDefault(_FitbitSleepStages);

var _StriivSleepGraph = __webpack_require__(667);

var _StriivSleepGraph2 = _interopRequireDefault(_StriivSleepGraph);

var _StriivSleepStages = __webpack_require__(668);

var _StriivSleepStages2 = _interopRequireDefault(_StriivSleepStages);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  mixins: [_TrackingDetailMixin2.default],
  components: {
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    StriivSleepGraph: _StriivSleepGraph2.default,
    StriivSleepStages: _StriivSleepStages2.default,
    FitbitSleepGraph: _FitbitSteppedChart2.default,
    FitbitSleepStages: _FitbitSleepStages2.default,
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    SleepEdit: _SleepEdit2.default,
    SleepInput: _Sleep4.default,
    SleepGraph: _LineGraph2.default
  },
  watch: {
    "date": function date() {
      var self = this;

      if (self.locksDate === false) {
        self.isLoading = true;
        if (self.service === 'FITBIT') {
          self.loadFitbitData();
        }
        if (self.service === 'STRIIV') {
          self.loadStriivData();
        }
      }
    },
    "mode": function mode() {
      if (this.mode === 'DEVICE') {
        this.$router.push({
          path: '/tracking/sleep/history'
        });
      }
    },
    "service": function service() {
      var self = this;
      self.isLoading = true;
      if (self.service === 'FITBIT') {

        self.loadFitbitSleepLog();
      }
      if (self.service === 'STRIIV') {
        self.loadStriivData();
      }
    }
  },
  data: function data() {
    return {
      service: 'LCP',
      mode: 'SELF_REPORTED',
      striivData: {},

      fitbitIndex: 0,
      fitbitData: {},
      fitbitSleepLog: [],
      isLoading: false,
      date: moment(),
      btnColor: '#183A43',
      selectedTab: 'sleepDiary',
      showDeviceTab: false,
      pageReady: false,
      locksDate: true

    };
  },

  methods: {
    addDay: function addDay() {
      var self = this;
      self.date = moment(self.date).add(1, 'day');
    },
    subtractDay: function subtractDay() {
      var self = this;
      self.date = moment(self.date).subtract(1, 'day');
    },
    loadFitbitSleepLog: function loadFitbitSleepLog() {
      var self = this;
      var startOfYear = moment().startOf('year').format('YYYY-MM-DD');
      _Sleep2.default.getFitBitSleepLog(startOfYear).then(function (response) {
        if (response.data.sleep.length > 0) {

          var date = moment(response.data.sleep[self.fitbitIndex].dateOfSleep);
          self.fitbitData = response.data.sleep[self.fitbitIndex];
          self.fitbitSleepLog = response.data.sleep;
          self.locksDate = true;
          self.$nextTick(function () {
            self.date = date;
            self.isLoading = false;
            self.locksDate = false;
          });
        }
      });
    },
    loadFitbitData: function loadFitbitData() {
      var self = this;
      _Sleep2.default.getFitBitData(self.date.format('YYYY-MM-DD')).then(function (response) {
        self.fitbitData = response.data;
        self.isLoading = false;
      });
    },
    loadStriivData: function loadStriivData() {
      var self = this;
      _Sleep2.default.getStriivData(self.date.format('YYYY-MM-DD')).then(function (response) {
        self.striivData = response.data;
        self.isLoading = false;
      });
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveSleepItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Sleep2.default.deleteSleepTracking(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: self.$t('message.labelSuccess'),
          text: self.$t('message.confirmedRemoveSleepItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    updateReading: function updateReading(reading) {
      var self = this;
      var currentReading = self.data.data.filter(function (data) {
        return data.progress_id === reading.progress_id;
      })[0];
      currentReading.hours = reading.hours;
      currentReading.quality = reading.quality;
      currentReading.date_created = reading.date_created;
      currentReading.isControlsVisible = false;

      self.$EventBus.$emit('updateGraphData');
      self.$EventBus.$emit('sleepReadingUpdated');
      self.sortItems();
    },
    loadData: function loadData() {
      var self = this;
      _Integrations2.default.available.sleep().then(function (response) {
        if (response.data.length > 0) {
          self.showDeviceTab = true;
          self.selectedTab = 'sleepDiary';
        } else {
          self.showDeviceTab = false;
          self.selectedTab = 'sleepDiary';
        }
        _Sleep2.default.getSleepTrackingDetail(1, 15).then(function (response) {
          self.isReadingsLoading = false;
          self.data = response.data;
        });
      }).catch(function (error) {
        self.showDeviceTab = false;
        self.selectedTab = 'sleepDiary';
      });
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Sleep2.default.getSleepTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    },
    humanizedHours: function humanizedHours(hours) {
      var self = this;
      var humanisedHours = moment.duration(hours, 'hour').humanize();
      return humanisedHours;
    },
    goTo: function goTo(name) {
      this.$router.push({
        name: name
      });
    }
  },
  computed: {
    isToday: function isToday() {
      var self = this;
      return moment().isSame(self.date, 'day');
    },
    humanizeDate: function humanizeDate() {
      var self = this;
      if (moment().isSame(self.date, 'day')) {
        return 'Today';
      }
      return self.date.format('dddd, MMMM Do YYYY');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/sleep');
    self.loadData();
    self.$EventBus.$on('sleepPusherReceived', function () {
      self.loadData();
    });

    self.$EventBus.$on('onTrackingType_sleep', function (service) {
      self.service = service;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('sleepReadingAdded');
    this.$EventBus.$off('sleepPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FitbitSteppedChart = __webpack_require__(666);

var _FitbitSteppedChart2 = _interopRequireDefault(_FitbitSteppedChart);

var _FitbitSleepStages = __webpack_require__(665);

var _FitbitSleepStages2 = _interopRequireDefault(_FitbitSleepStages);

var _Sleep = __webpack_require__(198);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _StriivSleepGraph = __webpack_require__(667);

var _StriivSleepGraph2 = _interopRequireDefault(_StriivSleepGraph);

var _StriivSleepStages = __webpack_require__(668);

var _StriivSleepStages2 = _interopRequireDefault(_StriivSleepStages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    StriivSleepStages: _StriivSleepStages2.default,
    StriivSleepGraph: _StriivSleepGraph2.default,
    FitbitSleepStages: _FitbitSleepStages2.default,
    FitbitSleepGraph: _FitbitSteppedChart2.default
  },
  data: function data() {
    return {
      integrationsLoaded: false,
      isLoading: true,
      fitbitData: {},
      striivData: {},
      btnColor: '#183A43',
      selectedTab: 'deviceHistory',
      integration: '',
      integrations: [],
      date: moment()
    };
  },

  watch: {
    'date': function date() {
      var self = this;
      self.isLoading = true;
      var formatDate = self.date.format('YYYY-MM-DD');
      if (self.integration === 'FITBIT') {
        _Sleep2.default.getFitBitData(self.date.format('YYYY-MM-DD')).then(function (response) {
          self.fitbitData = response.data;
          self.isLoading = false;
        });
      }
      if (self.integration === 'STRIIV') {
        self.loadStriivData(formatDate);
      }
    },
    'integration': function integration() {
      var self = this;
      self.isLoading = true;
      var formatDate = self.date.format('YYYY-MM-DD');
      if (self.integration === 'FITBIT') {
        _Sleep2.default.getFitBitData(self.date.format('YYYY-MM-DD')).then(function (response) {
          self.fitbitData = response.data;
          self.isLoading = false;
        });
      }
      if (self.integration === 'STRIIV') {
        self.loadStriivData(formatDate);
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/device-history');
    _Integrations2.default.available.sleep().then(function (response) {
      self.integrations = response.data;
      self.integration = response.data[0].service;
      var formatDate = self.date.format('YYYY-MM-DD');

      if (self.integration === 'FITBIT') {
        _Sleep2.default.getFitBitData(self.date.format('YYYY-MM-DD')).then(function (response) {
          self.fitbitData = response.data;
          self.isLoading = false;
        });
      }

      if (self.integration === 'STRIIV') {
        self.loadStriivData(formatDate);
      }

      self.integrationsLoaded = true;
    });
  },

  computed: {
    isSameDay: function isSameDay() {
      var self = this;
      return moment().isSame(this.date, 'day');
    },
    humanizeDate: function humanizeDate() {
      if (moment().isSame(this.date, 'day')) {
        return 'Today';
      }
      return this.date.format('dddd, MMMM Do YYYY');
    }
  },
  methods: {
    loadStriivData: function loadStriivData(date) {
      var self = this;
      _Sleep2.default.getStriivData(date).then(function (response) {
        self.striivData = response.data;
        self.isLoading = false;
      });
    },
    formatIntegrationLabel: function formatIntegrationLabel(item) {
      if (item.service === 'FITBIT') {
        if (_.has(item.device, 'deviceVersion')) {
          return 'Fitbit ' + item.device.deviceVersion;
        }
        return 'Fitbit';
      } else {
        return _.startCase(item.service.toLowerCase());
      }
    },
    addDay: function addDay() {
      var self = this;
      self.date = moment(self.date).add(1, 'day');
    },
    subtractDay: function subtractDay() {
      var self = this;
      self.date = moment(self.date).subtract(1, 'day');
    },
    goTo: function goTo(name) {
      this.$router.push({
        name: name
      });
    }
  }

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(9)))

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _EventBus = __webpack_require__(132);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _LineGraph = __webpack_require__(452);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _Sleep = __webpack_require__(198);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _Integrations = __webpack_require__(164);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _Sleep3 = __webpack_require__(344);

var _Sleep4 = _interopRequireDefault(_Sleep3);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _FitbitSteppedChart = __webpack_require__(666);

var _FitbitSteppedChart2 = _interopRequireDefault(_FitbitSteppedChart);

var _FitbitSleepStages = __webpack_require__(665);

var _FitbitSleepStages2 = _interopRequireDefault(_FitbitSleepStages);

var _StriivSleepGraph = __webpack_require__(667);

var _StriivSleepGraph2 = _interopRequireDefault(_StriivSleepGraph);

var _StriivSleepStages = __webpack_require__(668);

var _StriivSleepStages2 = _interopRequireDefault(_StriivSleepStages);

var _ServiceTrackingTypes = __webpack_require__(188);

var _ServiceTrackingTypes2 = _interopRequireDefault(_ServiceTrackingTypes);

var _LineGraph3 = __webpack_require__(3446);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _SleepVisualisation = __webpack_require__(3453);

var _SleepVisualisation2 = _interopRequireDefault(_SleepVisualisation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_TrackingDetailMixin2.default],
  components: {
    SleepVisualisation: _SleepVisualisation2.default,
    SleepWearableLineGraph: _LineGraph4.default,
    ServiceTrackingTypes: _ServiceTrackingTypes2.default,
    StriivSleepGraph: _StriivSleepGraph2.default,
    StriivSleepStages: _StriivSleepStages2.default,
    FitbitSleepGraph: _FitbitSteppedChart2.default,
    FitbitSleepStages: _FitbitSleepStages2.default,
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    SleepInput: _Sleep4.default,
    SleepGraph: _LineGraph2.default
  },
  watch: {
    "date": function date() {
      var self = this;

      if (self.locksDate === false) {
        self.isLoading = true;
        if (self.service === 'FITBIT') {
          self.loadFitbitData();
        }
        if (self.service === 'STRIIV') {
          self.loadStriivData();
        }
      }
    },
    "mode": function mode() {
      if (this.mode === 'SELF_REPORTED') {
        this.$router.push({
          path: '/tracking/sleep/'
        });
      }
    },
    "service": function service() {
      var self = this;
      self.isLoading = true;
      if (self.service === 'FITBIT') {
        self.loadFitbitSleepLog();
      }
      if (self.service === 'STRIIV') {
        self.loadStriivData();
      }
    }
  },
  data: function data() {
    return {
      service: 'LCP',
      mode: 'DEVICE',
      striivData: {},
      fitbitIndex: 0,
      fitbitData: {},
      fitbitSleepLog: [],
      isLoading: false,
      date: moment(),
      btnColor: '#183A43',
      selectedTab: 'sleepDiary',
      showDeviceTab: false,
      pageReady: false,
      locksDate: true
    };
  },

  methods: {
    getStartedIntegrations: function getStartedIntegrations() {
      var self = this;
      self.$router.push({
        name: 'SettingsIntegrations'
      });
    },
    getTime: function getTime(minutes) {
      moment.relativeTimeThreshold('m', 60);
      moment.relativeTimeThreshold('s', 60);
      var start = moment();
      var end = moment();end.add(minutes, 'minutes');
      var diff = end.diff(start);
      var object = moment.utc(diff).toObject();
      if (object.hours === 0) {
        return moment.duration(object.minutes, 'minutes').format('m _');
      }
      return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
    },
    groupedItemDate: function groupedItemDate(date, duration) {
      var self = this;
      var offset = new Date();
      var dateMod = moment.utc(date).local().locale(_config2.default.language);
      return dateMod.format('dddd Do');
    },
    addDay: function addDay() {
      var self = this;
      self.date = moment(self.date).add(1, 'day');
    },
    subtractDay: function subtractDay() {
      var self = this;
      self.date = moment(self.date).subtract(1, 'day');
    },
    loadFitbitSleepLog: function loadFitbitSleepLog() {
      var self = this;
      var startOfYear = moment().startOf('year').format('YYYY-MM-DD');
      _Sleep2.default.getFitBitSleepLog(startOfYear).then(function (response) {
        if (response.data.sleep.length > 0) {
          var date = moment(response.data.sleep[self.fitbitIndex].dateOfSleep);
          self.fitbitData = response.data.sleep[self.fitbitIndex];
          self.fitbitSleepLog = response.data.sleep;
          self.locksDate = true;
          self.$nextTick(function () {
            self.date = date;
            self.isLoading = false;
            self.locksDate = false;
          });
        }
      });
    },
    loadFitbitData: function loadFitbitData() {
      var self = this;
      _Sleep2.default.getFitBitData(self.date.format('YYYY-MM-DD')).then(function (response) {
        self.fitbitData = response.data;
        self.isLoading = false;
      });
    },
    loadStriivData: function loadStriivData() {
      var self = this;
      _Sleep2.default.getStriivData(self.date.format('YYYY-MM-DD')).then(function (response) {
        self.striivData = response.data;
        self.isLoading = false;
      });
    },
    loadData: function loadData() {
      var self = this;
      _Integrations2.default.available.sleep().then(function (response) {
        if (response.data.length > 0) {
          self.showDeviceTab = true;
          self.selectedTab = 'sleepDiary';
        } else {
          self.showDeviceTab = false;
          self.selectedTab = 'sleepDiary';
        }
        _Sleep2.default.getSleepTrackingWearableDetail(1, 15).then(function (response) {
          self.isReadingsLoading = false;
          self.data = response.data;
        });
      }).catch(function (error) {
        self.showDeviceTab = false;
        self.selectedTab = 'sleepDiary';
      });
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Sleep2.default.getSleepTrackingWearableDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    },
    humanizedHours: function humanizedHours(hours) {
      return moment.duration(hours, 'hour').humanize();
    },
    goTo: function goTo(name) {
      this.$router.push({
        name: name
      });
    }
  },
  computed: {
    isToday: function isToday() {
      var self = this;
      return moment().isSame(self.date, 'day');
    },
    humanizeDate: function humanizeDate() {
      var self = this;
      if (moment().isSame(self.date, 'day')) {
        return 'Today';
      }
      return self.date.format('dddd, MMMM Do YYYY');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$gtag.pageview('/tracking/sleep');
    self.loadData();
    _EventBus2.default.$on('sleepPusherReceived', function () {
      self.loadData();
    });

    _EventBus2.default.$on('onTrackingType_sleep', function (service) {
      self.service = service;
    });
  },
  beforeDestroy: function beforeDestroy() {
    _EventBus2.default.$off('sleepReadingAdded');
    _EventBus2.default.$off('sleepPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Weight = __webpack_require__(273);

var _Weight2 = _interopRequireDefault(_Weight);

var _TrackingDetailMixin = __webpack_require__(101);

var _TrackingDetailMixin2 = _interopRequireDefault(_TrackingDetailMixin);

var _LineGraph = __webpack_require__(453);

var _LineGraph2 = _interopRequireDefault(_LineGraph);

var _LineGraph3 = __webpack_require__(3447);

var _LineGraph4 = _interopRequireDefault(_LineGraph3);

var _Weight3 = __webpack_require__(673);

var _Weight4 = _interopRequireDefault(_Weight3);

var _WeightEdit = __webpack_require__(3442);

var _WeightEdit2 = _interopRequireDefault(_WeightEdit);

var _WaistHipEdit = __webpack_require__(3441);

var _WaistHipEdit2 = _interopRequireDefault(_WaistHipEdit);

var _vueClickaway = __webpack_require__(338);

var _TrackingNotifier = __webpack_require__(74);

var _TrackingNotifier2 = _interopRequireDefault(_TrackingNotifier);

var _Exporter = __webpack_require__(129);

var _Exporter2 = _interopRequireDefault(_Exporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = {
  mixins: [_TrackingDetailMixin2.default],

  components: {
    TrackingExporter: _Exporter2.default,
    TrackingNotifier: _TrackingNotifier2.default,
    WeightEdit: _WeightEdit2.default,
    WaistHipEdit: _WaistHipEdit2.default,
    WeightInput: _Weight4.default,
    WeightLineGraph: _LineGraph2.default,
    WaistHipLineGraph: _LineGraph4.default
  },
  data: function data() {
    return {
      btnColor: '#1692DA',
      activeTab: 'weight'
    };
  },
  directives: {
    onClickaway: _vueClickaway.directive
  },
  mounted: function mounted() {
    var self = this;
    self.loadData();
    self.$gtag.pageview('/tracking/weight');

    self.$EventBus.$on('weightPusherReceived', function () {
      self.loadData();
    });
  },
  watch: {
    activeTab: function activeTab() {
      this.loadData();
    }
  },
  methods: {
    handleTabChange: function handleTabChange(val) {
      var self = this;
      self.activeTab = val;
    },

    loadData: function loadData() {
      var self = this;
      if (self.activeTab === 'weight') {
        self.isReadingsLoading = true;
        _Weight2.default.getWeightTrackingDetail(1, 15).then(function (response) {
          self.data = response.data;
          self.isReadingsLoading = false;
        });
      } else if (self.activeTab === 'waist-hip') {
        self.isReadingsLoading = true;
        _Weight2.default.getWaistHipTrackingDetail(1, 15).then(function (response) {
          self.data = response.data.reverse();
          self.isReadingsLoading = false;
        });
      }
    },
    loadMoreData: function loadMoreData() {
      var self = this,
          page = self.data.page,
          pages = self.data.pages;
      if (page >= pages) {
        self.isReadingsLoading = false;
        return;
      }
      if (page < pages) {
        self.isReadingsLoading = true;
        page++;
        _Weight2.default.getWeightTrackingDetail(page, 15).then(function (response) {
          self.data.page = response.data.page;
          self.data.data.push.apply(self.data.data, response.data.data);
          self.isReadingsLoading = false;
        });
      }
    },
    decideWhetherLostOrGained: function decideWhetherLostOrGained(item) {
      var self = this;
      var index = self.data.data.indexOf(item);
      if (index === self.data.data.length - 1) {
        return 'same';
      } else {
        if (index >= 0 && self.data.data.length > 0) {
          var checkingIndex = Number;
          checkingIndex = index + 1;
          if (checkingIndex < self.data.data.length) {
            if (self.data.data[index].kg < self.data.data[checkingIndex].kg) {
              return 'lost';
            }
            if (self.data.data[index].kg > self.data.data[checkingIndex].kg) {
              return 'gained';
            }
            if (self.data.data[index].kg === self.data.data[checkingIndex].kg) {
              return 'same';
            }
          } else {
            return 'same';
          }
        }
      }
    },
    determineLostOrGainedWaistHip: function determineLostOrGainedWaistHip(item) {
      var self = this;
      var index = self.data.indexOf(item);
      if (index === self.data.length - 1) {
        return 'same';
      }
      if (index >= 0 && self.data.length > 0) {
        var checkingIndex = Number;
        checkingIndex = index + 1;
        if (checkingIndex < self.data.length) {
          if (self.data[index].ratio_cm < self.data[checkingIndex].ratio_cm) {
            return 'lost';
          }
          if (self.data[index].ratio_cm > self.data[checkingIndex].ratio_cm) {
            return 'gained';
          }
          if (self.data[index].ratio_cm === self.data[checkingIndex].ratio_cm) {
            return 'same';
          }
        } else {
          return 'same';
        }
      }
    },
    determineIcon: function determineIcon(item) {
      var self = this;
      if (self.activeTab === 'weight') {
        var index = self.data.data.indexOf(item);
        if (index === self.data.data.length - 1) {
          return 'trending_flat';
        } else {
          if (index >= 0 && self.data.data.length > 0) {
            var checkingIndex = Number;
            checkingIndex = index + 1;
            if (checkingIndex < self.data.data.length) {
              if (self.data.data[index].kg < self.data.data[checkingIndex].kg) {
                return 'arrow_downwards';
              }
              if (self.data.data[index].kg > self.data.data[checkingIndex].kg) {
                return 'arrow_upwards';
              }
              if (self.data.data[index].kg === self.data.data[checkingIndex].kg) {
                return 'trending_flat';
              }
            } else {
              return 'trending_flat';
            }
          }
        }
      } else if (self.activeTab === 'waist-hip') {
        var _index = self.data.indexOf(item);
        if (_index === self.data.length - 1) {
          return 'trending_flat';
        } else {
          if (_index >= 0 && self.data.length > 0) {
            var _checkingIndex = Number;
            _checkingIndex = _index + 1;
            if (_checkingIndex < self.data.length) {
              if (self.data[_index].ratio_cm < self.data[_checkingIndex].ratio_cm) {
                return 'arrow_downwards';
              }
              if (self.data[_index].ratio_cm > self.data[_checkingIndex].ratio_cm) {
                return 'arrow_upwards';
              }
              if (self.data[_index].ratio_cm === self.data[_checkingIndex].ratio_cm) {
                return 'trending_flat';
              }
            } else {
              return 'trending_flat';
            }
          }
        }
      }
    },
    updateReading: function updateReading(data) {
      var self = this;
      var currentReading = self.data.data.filter(function (reading) {
        return reading.progress_id === data.progress_id;
      })[0];

      currentReading.kg = data.kg;
      currentReading.lbs = data.lbs;
      currentReading.stones = data.stones;
      currentReading.pounds = data.pounds;
      currentReading.date_created = data.date_created;
      currentReading.isControlsVisible = false;
      self.sortItems();
      self.$EventBus.$emit('weightReadingUpdated');
      self.$emit('updateGraphData');
    },
    deleteReading: function deleteReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveWeightItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Weight2.default.deleteWeightReading(reading.progress_id, reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.data.indexOf(reading);
        self.data.data.splice(index, 1);
        self.$alert({
          title: "Success!",
          text: self.$t('message.confirmedRemoveWeightItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    deleteWaistHipReading: function deleteWaistHipReading(reading) {
      var self = this;
      var swal = self.$alert;
      self.$alert({
        title: self.$t('message.confirmRemoveTitle'),
        text: self.$t('message.confirmRemoveWeightItem'),
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _Weight2.default.deleteWaistHipReading(reading.tracking_id);
        }
      }).then(function (response) {
        var index = self.data.indexOf(reading);
        self.data.splice(index, 1);
        self.$alert({
          title: "Success!",
          text: self.$t('message.confirmedRemoveWeightItem'),
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "white"
        });
      }.bind(self)).catch(self.$alert.noop);
    },
    updateWaistHipReading: function updateWaistHipReading(data) {
      var self = this;
      var currentReading = self.data.filter(function (reading) {
        return reading.tracking_id === data.tracking_id;
      })[0];

      currentReading.waist_cm = data.waist_cm;
      currentReading.hip_cm = data.hip_cm;

      currentReading.waist_in = data.waist_in;
      currentReading.hip_in = data.hip_in;

      currentReading.date_created = data.date_created;
      currentReading.isControlsVisible = false;
      self.sortWaistHipItems();
      self.$EventBus.$emit('weightReadingUpdated');
      self.$emit('updateGraphData');
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    self.$EventBus.$off('weightReadingAdded');
    self.$EventBus.$off('weightPusherReceived');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APIURL = _config2.default.apiUrl;

var ContactApi = {
  postMessage: function postMessage(model) {
    return _axios2.default.post(APIURL + 'contact/v2', model);
  }
};

exports.default = ContactApi;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsApi = {
  getNotifications: function getNotifications() {
    var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var limit = 5;
    return _axios2.default.get(_config2.default.apiUrl + 'notifications/user/v2?limit=' + limit + '&skip=' + skip);
  },
  markAsRead: function markAsRead(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'notifications/read/v2', model);
  },
  bulkReadNotifications: function bulkReadNotifications(model) {
    return _axios2.default.post(_config2.default.apiUrl + 'notifications/read/bulk', model);
  }
};

exports.default = NotificationsApi;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  massImportHeartRate: function massImportHeartRate() {
    return _axios2.default.get(_config2.default.apiUrl + 'integration/striiv/massimport/heartrate');
  }
};

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APIURL = _config2.default.apiUrl;

var TestimonialsApi = {
  getQuestions: function getQuestions() {
    return _axios2.default.get(APIURL + 'testimonial/questions/');
  },
  saveTestimonial: function saveTestimonial(model) {
    return _axios2.default.post(APIURL + 'testimonial/', model);
  }
};

exports.default = TestimonialsApi;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(278);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(277);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiUrl = _config2.default.apiUrl;

var TokenApi = {
  refreshAccessToken: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(refreshToken) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', _axios2.default.post(apiUrl + 'token/refresh', {
                refreshToken: refreshToken
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function refreshAccessToken(_x) {
      return _ref.apply(this, arguments);
    }

    return refreshAccessToken;
  }()
};

exports.default = TokenApi;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NutritionApi = {
  getNutritionCard: function getNutritionCard() {
    return _axios2.default.get(_config2.default.apiUrl + 'tracking/nutrition/card/?requestFrom=web');
  }
};

exports.default = NutritionApi;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var convertTimeHHMMSS = function convertTimeHHMMSS(val) {
  var hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};

exports.default = {
  methods: {
    initAudio: function initAudio() {
      var self = this;
      self.audio = self.$refs['audioFile'];
      self.audio.addEventListener('loadeddata', self.onAudioLoaded);
      self.audio.addEventListener('timeupdate', self.onAudioTimeUpdate);
      self.audio.addEventListener('ended', self.onAudioEnded);
    },
    onAudioLoaded: function onAudioLoaded() {
      var self = this;
      if (self.audio.readyState >= 2) {
        self.duration = self.audio.duration;
        self.volume = self.audio.volume;
        self.isAudioReady = true;
      }
    },
    onAudioTimeUpdate: function onAudioTimeUpdate() {
      var self = this;
      var currentTime = parseInt(self.audio.currentTime);
      var audioDuration = self.duration;
      self.percentage = parseInt(currentTime / audioDuration * 100);
      self.currentTime = convertTimeHHMMSS(currentTime);
      self.currentDuration = self.audio.currentTime;
    },
    onAudioEnded: function onAudioEnded() {
      var self = this;
      self.currentDuration = 0;
      self.audio.currentTime = 0;
      self.pause();
    },
    playOrPause: function playOrPause() {
      var self = this;
      self.isPlaying === false ? self.play() : self.pause();
    },
    play: function play() {
      var self = this;
      self.isPlaying = true;
      self.audio.play();
    },
    pause: function pause() {
      var self = this;
      self.isPlaying = false;
      self.audio.pause();
    },
    mute: function mute() {
      var self = this;
      if (self.isMuted === true) {
        self.isMuted = false;
        self.volume = self.volumeBeforeMuted;
        self.setVolume(self.volumeBeforeMuted);
      } else {
        self.isMuted = true;
        self.volumeBeforeMuted = self.volume;
        self.volume = 0;
        self.setVolume(0);
      }
    },
    dragSeekDurationStarted: function dragSeekDurationStarted() {
      var self = this;
      self.userSeeking = true;
      self.pause();
    },
    dragSeekDurationEnded: function dragSeekDurationEnded() {
      var self = this;
      self.audio.currentTime = self.currentDuration;
      self.audio.currentDuration = self.currentDuration;
      self.$nextTick(function () {
        self.userSeeking = false;
        self.play();
      });
    },
    durationChanged: function durationChanged(value) {
      var self = this;
      if (self.userSeeking === false) {
        self.currentDuration = value;
        self.audio.currentTime = self.currentDuration;
      }
    },
    setVolume: function setVolume(value) {
      var self = this;
      self.audio.volume = value;
    },
    dragVolumeStarted: function dragVolumeStarted() {
      var self = this;
    },
    dragVolumeEnded: function dragVolumeEnded() {
      var self = this;
      self.audio.volume = self.volume;
    }
  },
  computed: {
    audioDuration: function audioDuration() {
      var self = this;
      if (self.audio !== undefined) {
        return convertTimeHHMMSS(self.duration);
      }
    },
    audioIcon: function audioIcon() {
      var self = this;
      var volume = self.volume;
      if (volume < .1) {
        return 'volume_off';
      } else if (volume <= .5) {
        return 'volume_down';
      }
      if (volume > .5) {
        return 'volume_up';
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    self.audio.removeEventListener('loadeddata', self.onAudioLoaded);
    self.audio.removeEventListener('timeupdate', self.onAudioTimeUpdate);
    self.audio.removeEventListener('ended', self.onAudioEnded);
    self.audio.src = "";
  }
};

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numeral = __webpack_require__(90);

var _numeral2 = _interopRequireDefault(_numeral);

var _vueChartjs = __webpack_require__(658);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _vueChartjs.Doughnut,
  name: 'food-pie',
  props: {
    fat: {
      type: Number,
      default: 40
    },
    carbs: {
      type: Number,
      default: 60
    },
    protein: {
      type: Number,
      default: 50
    },
    calories: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: "kcal"
    }
  },
  watch: {
    'fat': function fat() {
      this.render();
    },
    'protein': function protein() {
      this.render();
    },
    'carbs': function carbs() {
      this.render();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.addPlugin({
      id: 'pieLabel',
      beforeDraw: function beforeDraw(chart) {
        var width = chart.chart.width,
            height = chart.chart.height,
            ctx = self.$refs.canvas.getContext("2d");
        ctx.restore();
        var fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "#333";
        var number = (0, _numeral2.default)(self.calories.toFixed(2));
        var text = self.labelText,
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
    self.render();
  },

  computed: {
    labelText: function labelText() {
      var number = 0;
      if (this.unit === "kcal") {
        number = this.calories.toFixed(2);
      } else {
        number = (this.fat + this.carbs + this.protein).toFixed(2);
      }
      number = (0, _numeral2.default)(number);
      return '' + number.format('0,0') + this.unit;
    }
  },
  methods: {
    render: function render() {
      var self = this;
      self.renderChart({
        labels: [this.$t('message.nutrientFat'), this.$t('message.nutrientCarbohydrate'), this.$t('message.nutrientProtein')],
        datasets: [{
          backgroundColor: ['rgb(192, 77, 216)', 'rgb(78, 216, 218)', 'rgb(224, 105, 80)'],
          data: [this.fat, this.carbs, this.protein]
        }]
      }, {
        legend: false,
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        percentageInnerCutout: 24,
        hover: {
          mode: null
        },
        tooltips: {
          enabled: false
        },
        plugins: {
          pieLabel: true
        }
      });
    }
  }

};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numeral = __webpack_require__(90);

var _numeral2 = _interopRequireDefault(_numeral);

var _vueChartjs = __webpack_require__(658);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _vueChartjs.Doughnut,
  name: 'food-pie-empty',
  props: {
    calories: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: "kcal"
    }
  },
  mounted: function mounted() {
    var self = this;
    self.addPlugin({
      id: 'pieLabel',
      beforeDraw: function beforeDraw(chart) {
        var width = chart.chart.width,
            height = chart.chart.height,
            ctx = self.$refs.canvas.getContext("2d");
        ctx.restore();
        var fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "#333";
        var number = (0, _numeral2.default)(self.calories.toFixed(2));
        var text = '' + number.format('0,0') + self.unit,
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
    self.render();
  },

  methods: {
    render: function render() {
      var self = this;
      self.renderChart({
        labels: [this.$t('message.nutrientFat')],
        datasets: [{
          backgroundColor: ['#DEDCE2'],
          data: [1]
        }]
      }, {
        legend: false,
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        percentageInnerCutout: 24,
        hover: { mode: null },
        tooltips: {
          enabled: false
        },
        plugins: {
          pieLabel: true
        }
      });
    }
  }
};

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__(658);

exports.default = {
  extends: _vueChartjs.Bar,
  name: 'food-diary-stacked-history',
  props: ['data'],
  mounted: function mounted() {
    var self = this;
    self.render();
  },

  methods: {
    render: function render() {
      var self = this;
      self.renderChart(self.data, {
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex];
              var percentage = parseInt(data.datasets[tooltipItem.datasetIndex].percentages[tooltipItem.index]);
              return tooltipItem.yLabel.toFixed(1) + 'kcal ' + '(' + percentage + '% ' + data.datasets[tooltipItem.datasetIndex].label + ')';
            }
          },
          displayColors: false,
          xPadding: 16,
          yPadding: 16,
          titleFontFamily: "Poppins",
          titleFontStyle: "200",
          bodyFontFamily: "Poppins",
          backgroundColor: "#0179d5",
          titleFontSize: 16,
          titleFontColor: "white",
          bodyFontColor: "white",
          bodyFontSize: 14,
          intersect: false
        },
        title: {
          display: true,
          position: 'left',
          text: "CALORIES (kcal)"
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      });
    }
  }

};

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PusherManager = __webpack_require__(167);

var _PusherManager2 = _interopRequireDefault(_PusherManager);

var _LifeStyle = __webpack_require__(97);

var _LifeStyle2 = _interopRequireDefault(_LifeStyle);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isCommentsLoading: true,
      isCommentsComplete: false,
      addCommentModel: {
        message: ''
      },
      commentParams: {},
      commentFilters: [{ label: "Most Popular", model: "MOST_POPULAR" }, { label: "Most Recent", model: "MOST_RECENT" }, { label: "Most Replies", model: "MOST_REPLIES" }],
      isAddingComment: false,
      comments: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.isCommentsLoading = true;
    self.isCommentsComplete = false;
    self.commentParams = self.pageDefaults();
    self.initPusherCalls(self.postId);
    self.loadPostComments(self.postId);
  },

  computed: {
    isAdmin: function isAdmin() {
      var self = this;
      return self.$store.state.user.user_role.role_id === 2;
    }
  },
  methods: {
    getInitialsFromName: function getInitialsFromName(name, delimeter) {
      if (name) {
        var array = name.split(delimeter);
        switch (array.length) {
          case 1:
            return array[0].charAt(0).toUpperCase();
            break;
          default:
            return array[0].charAt(0).toUpperCase() + array[array.length - 1].charAt(0).toUpperCase();
        }
      }
      return false;
    },
    containsAvatarMed: function containsAvatarMed(string, hasString) {
      return string && string.includes(hasString);
    },
    fromNow: function fromNow(date) {
      return _config2.default.dateFormatting.fromNow(date);
    },
    initPusherCalls: function initPusherCalls(post_id) {
      var self = this,
          params = self.$route.params;
      var userId = self.$store.state.user.scope.user_id;
      var channel = _PusherManager2.default.subscribe('post_' + post_id);

      channel.bind('comment_added', function (data) {
        if (data.level === 0) {
          data.comment.editcomment = false;
          data.comment.edit_comment = data.comment.comment;
          self.comments.splice(0, 0, data.comment);
          self.commentParams.totalComments = data.commentsCount;
        } else if (data.level === 1) {
          var length = self.comments.length;
          for (var i = 0; i < length; i++) {
            if (self.comments[i].comment_id === data.comment.comment_id) {
              data.comment.edit_comment = data.comment.comment;
              data.comment.editcomment = false;
              self.comments[i].replies.splice(0, 0, data.comment);
              self.comments[i].reply_count++;
            }
          }
        }
      });

      channel.bind('comment_liked', function (data) {
        if (data.level === 0) {
          if (data.status) {
            data.user_id === userId ? self.comments[data.index].likes.liked = true : '';
            self.comments[data.index].total_likes++;
          } else {
            data.user_id === userId ? self.comments[data.index].likes.liked = false : '';
            self.comments[data.index].total_likes--;
          }
        } else if (data.level === 1) {
          var replies = self.comments[data.parenti].replies[data.index];
          if (data.status) {
            data.user_id === userId ? replies.likes.liked = true : '';
            replies.total_likes++;
          } else {
            data.user_id === userId ? replies.likes.liked = false : '';
            replies.total_likes--;
          }
        }
      });

      channel.bind('comment_edited', function (data) {
        if (data.level === 0) {
          self.comments[data.index].comment = data.comment;
        } else if (data.level === 1) {
          self.comments[data.parenti].replies[data.index].comment = data.comment;
        }
      });

      channel.bind('comment_deleted', function (data) {
        if (data.level === 0) {
          self.comments.splice(data.index, 1);
          self.commentParams.totalComments = data.commentsCount;
        } else if (data.level === 1) {
          self.comments[data.parenti].replies.splice(data.index, 1);
          self.comments[data.parenti].reply_count--;
        }
      });
    },
    loadPostComments: function loadPostComments(post_id) {
      var self = this;
      self.isCommentsLoading = true;
      self.commentParams.post_id = post_id;
      _LifeStyle2.default.getPostComments(self.commentParams).then(function (response) {
        var data = response.data;

        _.mapValues(data.comments, function (val) {
          val.new_comment = "";
          val.edit_comment = val.comment;
          val.editcomment = false;
          val.show = false;
          return val;
        });

        data.comments.forEach(function (comment) {
          _.mapValues(comment.replies, function (val) {
            val.new_comment = "";
            val.edit_comment = val.comment;
            val.editcomment = false;
            val.show = false;
            return val;
          });
        });
        self.commentParams.totalComments = data.comments_count;
        if (self.commentParams.page === 1) {
          self.comments = data.comments;
        } else {
          self.comments.push.apply(self.comments, data.comments);
        }
        if (data.comments.length === 0) {
          self.isCommentsComplete = true;
        } else {
          self.commentParams.page += 1;
        }
        self.isCommentsLoading = false;
      }).catch(function (error) {
        self.isCommentsLoading = false;
      });
    },
    pageDefaults: function pageDefaults() {
      return {
        loading: true,
        page: 1,
        page_size: 20,
        type: "MOST_RECENT",
        totalComments: 0 };
    },
    updateCommentsView: function updateCommentsView() {
      var self = this;
      self.commentParams.page = 1;
      self.isCommentsComplete = false;
      self.$nextTick(function () {
        self.loadPostComments(self.postId);
      });
    },
    likeTopComment: function likeTopComment(comment_id, idx) {
      var self = this;
      var model = {
        post_id: self.postId,
        comment_id: comment_id,
        level: 0,
        index: idx
      };
      _LifeStyle2.default.likePostComment(model);
    },
    likeSubComment: function likeSubComment(comment_id, sub_comment_id, parenti, idx) {
      var self = this;
      var model = {
        post_id: self.postId,
        parent_id: comment_id,
        comment_id: sub_comment_id,
        level: 1,
        parenti: parenti,
        index: idx
      };
      _LifeStyle2.default.likePostComment(model);
    },
    addComment: function addComment() {
      var self = this;
      var model = {
        comment: self.addCommentModel.message.trim(),
        post_id: self.postId,
        level: 0
      };
      if (model.comment.length) {
        self.isAddingComment = true;
        _LifeStyle2.default.addComment(model).then(function (response) {
          if (response.data.complete) {
            self.isAddingComment = false;
            self.addCommentModel.message = '';
            self.$toastr.success('Success!');
          }
        });
      } else {
        self.$toastr.error('The comment field cannot be empty');
      }

      self.addCommentModel.message = '';
    },
    addSubComment: function addSubComment(comment) {
      var self = this;
      if (comment.new_comment === "") {
        self.$toastr.error('Cannot have an empty comment');
        return;
      }
      var model = {
        comment: comment.new_comment.trim(),
        comment_id: comment.comment_id,
        post_id: self.postId,
        level: 1
      };
      if (model.comment.length) {
        _LifeStyle2.default.addComment(model).then(function (response) {
          if (response.data.complete) {
            comment.new_comment = '';
          }
        });
      }
    },
    editComment: function editComment(level, index, parenti) {
      var self = this;
      if (level === 0) {
        self.comments[index].editcomment = true;
        self.comments[index].edit_comment = self.comments[index].comment;
      } else if (level === 1) {
        self.comments[parenti].replies[index].editcomment = true;
        self.comments[parenti].replies[index].edit_comment = self.comments[parenti].replies[index].comment;
      }
    },
    updateComment: function updateComment(level, comment, index, parenti) {
      var self = this;
      if (comment.edit_comment === "") {
        self.$toastr.error('Cannot have an empty comment');
        return;
      }
      var model = {
        post_id: self.postId,
        level: level,
        comment_id: level === 0 ? comment.comment_id : comment.sub_comment_id,
        comment: comment.edit_comment,
        parenti: parenti,
        index: index
      };
      _LifeStyle2.default.updateComment(model).then(function (res) {
        if (res.data.complete) {
          self.closeReply(level, index, parenti);
        } else {
          alert('Sorry could not update comment');
        }
      });
    },
    closeReply: function closeReply(level, index, parenti) {
      var self = this;
      if (level === 0) {
        var comment = self.comments[index];
        comment.show = false;
        comment.editcomment = false;
        comment.edit_comment = comment.comment;
      } else if (level === 1) {
        var _comment = self.comments[parenti];
        _comment.replies[index].show = false;
        _comment.replies[index].editcomment = false;
        _comment.replies[index].edit_comment = _comment.replies[index].comment;
      }
    },
    deleteComment: function deleteComment(level, comment_id, index, parenti) {
      var self = this;
      var model = {
        post_id: self.postId,
        comment_id: comment_id,
        level: level,
        parenti: parenti,
        index: index
      };
      self.$alert({
        title: "Are you sure?",
        text: "Are you sure you want to remove the following comment",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function preConfirm() {
          return _LifeStyle2.default.deleteComment(model);
        }
      }).then(function (response) {
        self.$toastr.success('Comment successfully removed');
      }.bind(self)).catch(self.$alert.noop);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(358);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _name$extends$mixins$;

var _vueChartjs = __webpack_require__(448);

var _index = __webpack_require__(350);

var _index2 = _interopRequireDefault(_index);

var _GraphManager = __webpack_require__(482);

var _GraphManager2 = _interopRequireDefault(_GraphManager);

var _index3 = __webpack_require__(6);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reactiveData = _vueChartjs.mixins.reactiveData;


var fromDate = moment().subtract(1, 'month');
var toDate = moment();

exports.default = (_name$extends$mixins$ = {
  name: 'bar-graph',
  extends: _vueChartjs.Bar,
  mixins: [reactiveData],
  props: {
    type: {
      type: String
    },
    userId: {
      type: Number
    },
    fromDate: {
      type: String,
      default: fromDate.format('YYYY-MM-DD')
    },
    toDate: {
      type: String,
      default: toDate.format('YYYY-MM-DD')
    },
    medTrackingId: {
      type: Number
    }
  },
  watch: {
    'fromDate': function fromDate() {
      var self = this;
      self.loadData();
    }
  }
}, (0, _defineProperty3.default)(_name$extends$mixins$, 'name', 'bar-graph'), (0, _defineProperty3.default)(_name$extends$mixins$, 'data', function data() {
  return {
    chartData: null,
    series: [],
    data: [],
    Labels: [],
    override: [],
    dataset: [],
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        labels: {
          fontColor: "white",
          fontSize: 14,
          usePointStyle: true,
          padding: 16
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            autoSkip: true,
            fontColor: "white",
            fontSize: 14,
            beginAtZero: false,
            maxRotation: 0,
            minRotation: 0
          },
          gridLines: {
            display: true,
            color: 'rgba(255, 255, 255, 0.15)',
            zeroLineColor: 'transparent'
          }
        }],
        xAxes: [{
          ticks: {
            autoSkip: true,
            fontColor: "white",
            fontSize: 14,
            stepSize: 2,
            beginAtZero: true,
            zeroLineColor: 'transparent',
            showXAxisLabel: false,
            maxRotation: 0,
            minRotation: 0
          },
          gridLines: {
            display: true,
            color: "rgba(255, 255, 255, 0.15)",
            zeroLineColor: 'transparent'
          }
        }]
      }
    }
  };
}), (0, _defineProperty3.default)(_name$extends$mixins$, 'mounted', function mounted() {
  var self = this;
  self.loadData();
}), (0, _defineProperty3.default)(_name$extends$mixins$, 'methods', {
  loadData: function loadData() {
    var self = this;
    self.$emit('graphLoading', true);
    _GraphManager2.default.handleGraphType(self);
  },
  renderChartFromData: function renderChartFromData(response) {
    var self = this;
    self.data = response.data.data;
    self.labels = response.data.labels;
    self.series = response.data.series;
    self.override = response.data.override;
    self.dataset = [];
    var dataLength = self.data.length;
    for (var i = 0; i < dataLength; i++) {
      self.dataset.push({
        label: self.series[i],
        data: self.data[i],
        backgroundColor: self.override[i].backgroundColor,
        borderColor: self.override[i].borderColor,
        pointBackgroundColor: self.override[i].borderColor,
        pointBorderColor: self.override[i].pointBorderColor,
        borderWidth: self.override[i].borderWidth,
        borderDash: self.override[i].borderDash
      });
    }

    var labelLength = self.labels.length;
    for (var _i = 0; _i < labelLength; _i++) {
      self.labels[_i] = _index4.default.dateFormatting.graphLabels(self.labels[_i]);
    }

    if (self.chartData) {
      self.chartData = {
        labels: self.labels,
        datasets: self.dataset
      };
    } else {
      self.chartData = {
        labels: self.labels,
        datasets: self.dataset
      };
      self.renderChart(self.chartData, {
        tooltips: {
          cornerRadius: 4,
          mode: "nearest",
          callbacks: {
            label: function label(tooltipItem, data) {
              return tooltipItem.yLabel + ' ' + data.datasets[tooltipItem.datasetIndex].label;
            }
          },
          displayColors: true,
          intersect: false,
          xPadding: 16,
          yPadding: 16,
          titleFontFamily: 'Poppins',
          titleFontStyle: '200',
          bodyFontFamily: 'Poppins',
          backgroundColor: '#0179d5',
          titleFontSize: 16,
          titleFontColor: 'white',
          bodyFontColor: 'white',
          bodyFontSize: 14
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: "white",
            fontSize: 14,
            usePointStyle: true,
            padding: 16
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              fontFamily: 'Poppins',
              autoSkip: true,
              fontColor: "white",
              fontSize: 14,
              beginAtZero: false,
              maxRotation: 0,
              minRotation: 0
            },
            gridLines: {
              display: true,
              color: 'rgba(255, 255, 255, 0.15)',
              zeroLineColor: 'transparent'
            }
          }],
          xAxes: [{
            ticks: {
              fontFamily: 'Poppins',
              autoSkip: true,
              fontColor: "white",
              fontSize: 14,
              stepSize: 2,
              beginAtZero: true,
              zeroLineColor: 'transparent',
              showXAxisLabel: false,
              maxRotation: 0,
              minRotation: 0
            },
            gridLines: {
              display: true,
              color: "rgba(255, 255, 255, 0.15)",
              zeroLineColor: 'transparent'
            }
          }]
        }
      });
    }
    self.$forceUpdate();
    self.$emit('graphLoading', false);
    self.$emit('graphLoaded', response);
  }
}), _name$extends$mixins$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(276);

var _keys2 = _interopRequireDefault(_keys);

var _vueChartjs = __webpack_require__(448);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reactiveProp = _vueChartjs.mixins.reactiveProp;

exports.default = {
  name: 'fitbit-sleep-chart',
  extends: _vueChartjs.Line,
  mixins: [reactiveProp],
  props: ['options'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var self = this;

    self.renderChart(self.chartData, self.options);

    var chart = this.$data._chart;
    var metaData = chart.config.data.datasets[0]._meta;
    var arbitraryKey = (0, _keys2.default)(metaData);

    var chartMetaDatas = metaData[arbitraryKey].data;

    for (var i = 0; i < chartMetaDatas.length; i++) {
      chartMetaDatas[i]._view.backgroundColor = 'green';
    }

    chart.update();
  }
};

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(276);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(735);

var _typeof3 = _interopRequireDefault(_typeof2);

var _echarts = __webpack_require__(2241);

var echarts = _interopRequireWildcard(_echarts);

var _all = __webpack_require__(65);

__webpack_require__(64);

var _GraphManager = __webpack_require__(482);

var _GraphManager2 = _interopRequireDefault(_GraphManager);

var _clinicalRanges = __webpack_require__(1662);

var _clinicalRanges2 = _interopRequireDefault(_clinicalRanges);

var _config = __webpack_require__(6);

var _config2 = _interopRequireDefault(_config);

var _MedicationRegimes = __webpack_require__(199);

var _MedicationRegimes2 = _interopRequireDefault(_MedicationRegimes);

var _store = __webpack_require__(487);

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fromDate = moment().locale(_config2.default.language).startOf('month');
var toDate = moment().locale(_config2.default.language).endOf('month');

var AXIS_COLOR = '#767576';
var GRID_COLOR = '#E3E9EC';
var FONT = 'Poppins';

var ONE_PER_DAY_TYPES = ['weight', 'waist-hip'];

var FALLBACK_PALETTE = ['#3D96DE', '#FEA228', '#0F3C43', '#AE3463', '#34CAB9', '#9534CA'];

var TYPE_BRAND_COLORS = {
  'weight': '#3D96DE',
  'waist-hip': '#3D96DE',
  'blood-glucose': '#E43229',
  'hba1c': '#E43229',
  'cholesterol': '#697DCE',
  'ketones': '#F5950C',
  'medication': '#AE3463',
  'sleep': '#FEA228',
  'sleep-wearable': '#FEA228',
  'blood-pressure': '#3693DE',
  'insulin': '#34CAB9',
  'mood': '#8150E4',
  'activity': '#4E2288',
  'activity-steps': '#4E2288'
};

exports.default = {
  name: 'line-graph',
  mixins: [_MedicationRegimes2.default],
  props: {
    showPoints: false,
    type: {
      type: String
    },
    dateStep: 0,
    userId: 0,
    medTrackingId: 0,
    activeStepsType: '',
    activeSleepType: '',
    fromDate: {
      type: String,
      default: fromDate.format('YYYY-MM-DD')
    },
    toDate: {
      type: String,
      default: toDate.format('YYYY-MM-DD')
    }
  },
  data: function data() {
    return {
      chart: null,
      resizeObserver: null,
      pointsVisible: false,

      rawResponse: null,
      data: [],
      labels: [],
      series: [],
      override: [],
      labelsAreDates: false,
      axisSpanMs: 0
    };
  },

  watch: {
    userId: function userId() {
      this.loadData();
    },
    fromDate: function fromDate() {
      this.loadData();
    },
    toDate: function toDate() {
      this.loadData();
    },
    medTrackingId: function medTrackingId() {
      this.loadData();
    },
    activeStepsType: function activeStepsType() {
      this.loadData();
    },
    activeSleepType: function activeSleepType() {
      this.loadData();
    },
    showPoints: function showPoints(val) {
      this.setPointsVisible(val === true);
    },
    '$store.state.graphOptions.smoothLine': function $storeStateGraphOptionsSmoothLine() {
      this.refreshDisplay();
    },
    '$store.state.graphOptions.showArea': function $storeStateGraphOptionsShowArea() {
      this.refreshDisplay();
    }
  },
  render: function render(h) {
    return h('div', {
      ref: 'chartEl',
      staticStyle: { width: '100%', minHeight: '200px' }
    });
  },
  mounted: function mounted() {
    var self = this;
    var mainContentElement = document.getElementsByClassName('main-content')[0];

    self.pointsVisible = self.showPoints === true;
    self.loadData();

    self.$EventBus.$on('showGraphPoints', function () {
      self.setPointsVisible(true);
    });
    self.$EventBus.$on('hideGraphPoints', function () {
      self.setPointsVisible(false);
    });
    self.$EventBus.$on('updateGraphData', function () {
      self.loadData();
    });
    self.$EventBus.$on('updateGraph', function () {
      if (mainContentElement) _all.TweenLite.to(mainContentElement, 0.2, { scrollTo: 0 });
      self.loadData();
    });

    window.addEventListener('resize', self.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off('updateGraph');
    this.$EventBus.$off('updateGraphData');
    this.$EventBus.$off('showGraphPoints');
    this.$EventBus.$off('hideGraphPoints');
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },

  methods: {
    loadData: function loadData() {
      this.$emit('graphLoading', true);
      _GraphManager2.default.handleGraphType(this);
    },
    ensureChart: function ensureChart() {
      var self = this;
      if (self.chart || !self.$refs.chartEl) return;
      self.chart = echarts.init(self.$refs.chartEl, null, { renderer: 'canvas' });

      if (typeof ResizeObserver !== 'undefined') {
        self.resizeObserver = new ResizeObserver(function () {
          self.handleResize();
        });
        self.resizeObserver.observe(self.$refs.chartEl);
      }
    },
    handleResize: function handleResize() {
      if (this.chart) this.chart.resize();
    },
    setPointsVisible: function setPointsVisible(visible) {
      this.pointsVisible = visible;
      if (!this.chart) return;
      var option = this.chart.getOption();
      if (!option || !option.series) return;
      option.series.forEach(function (s) {
        s.showSymbol = visible;
      });
      this.chart.setOption({ series: option.series });
    },
    refreshDisplay: function refreshDisplay() {
      var self = this;
      if (!self.chart) return;
      var option = self.chart.getOption();
      if (!option || !option.series) return;
      var smooth = _store2.default.state.graphOptions.smoothLine ? 0.4 : false;
      var showArea = _store2.default.state.graphOptions.showArea && self.series.length === 1;
      option.series.forEach(function (s, i) {
        var dashed = self.isDashed(i);
        s.smooth = smooth;
        s.areaStyle = showArea && !dashed ? { color: self.areaGradient(self.seriesColor(i)) } : { opacity: 0 };
      });
      self.chart.setOption({ series: option.series });
    },
    timeFormatPattern: function timeFormatPattern() {
      switch (this.dateStep) {
        case 0:
        case 1:
          return 'HH:mm';
        case 7:
          return 'ddd';
        case 30:
          return 'D MMM';
        case 360:
          return 'MMM';
      }
      var DAY = 24 * 3600 * 1000;
      var span = this.axisSpanMs || 0;
      if (span > 0 && span <= 2 * DAY) return 'HH:mm';
      if (span <= 95 * DAY) return 'DD MMM';
      if (span <= 3 * 365 * DAY) return "MMM 'YY";
      return 'YYYY';
    },
    categoryLabel: function categoryLabel(val) {
      var s = '' + val;
      if (this.labelsAreDates) return moment(s).format(this.timeFormatPattern());
      return s;
    },
    pointTimestamp: function pointTimestamp(p, idx) {
      if (p && (typeof p === 'undefined' ? 'undefined' : (0, _typeof3.default)(p)) === 'object') {
        var t = p.x != null ? p.x : p.t != null ? p.t : p.date != null ? p.date : null;
        if (t != null) return moment(t).valueOf();
      }
      if (this.labels[idx] != null && this.labelsAreDates) return moment(this.labels[idx]).valueOf();
      return null;
    },
    pointValue: function pointValue(p) {
      if (p && (typeof p === 'undefined' ? 'undefined' : (0, _typeof3.default)(p)) === 'object') return p.y != null ? p.y : p.value;
      return p;
    },
    dedupeReadings: function dedupeReadings() {
      if (!this.labelsAreDates || !this.labels.length) return;

      var isDayView = this.dateStep === 0 || this.dateStep === 1;
      var perDay = ONE_PER_DAY_TYPES.indexOf(this.type) !== -1 && !isDayView;

      var chosen = {};
      for (var idx = 0; idx < this.labels.length; idx++) {
        var ts = moment(this.labels[idx]).valueOf();
        if (isNaN(ts)) continue;
        var key = perDay ? moment(this.labels[idx]).format('YYYY-MM-DD') : ts;
        var prev = chosen[key];
        if (prev == null || ts >= moment(this.labels[prev]).valueOf()) chosen[key] = idx;
      }

      var keep = (0, _keys2.default)(chosen).map(function (k) {
        return chosen[k];
      });
      keep.sort(function (a, b) {
        return moment(this.labels[a]).valueOf() - moment(this.labels[b]).valueOf();
      }.bind(this));

      this.labels = keep.map(function (i) {
        return this.labels[i];
      }, this);
      this.data = this.data.map(function (arr) {
        if (!Array.isArray(arr)) return arr;
        return keep.map(function (i) {
          return arr[i];
        });
      });
    },
    dataTimeSpan: function dataTimeSpan() {
      var min = Infinity,
          max = -Infinity;
      for (var i = 0; i < this.data.length; i++) {
        var arr = this.data[i] || [];
        for (var j = 0; j < arr.length; j++) {
          var ts = this.pointTimestamp(arr[j], j);
          if (ts == null) continue;
          if (ts < min) min = ts;
          if (ts > max) max = ts;
        }
      }
      return max > min ? max - min : 0;
    },
    toPoint: function toPoint(p, idx) {
      var ts = this.pointTimestamp(p, idx);
      var y = this.pointValue(p);
      if (ts != null) return [ts, y];

      return y;
    },
    detectLabelsAreDates: function detectLabelsAreDates() {
      if (!this.labels || !this.labels.length) return false;
      var parseable = 0,
          considered = 0;
      for (var i = 0; i < this.labels.length; i++) {
        var l = this.labels[i];
        if (l == null) continue;
        considered++;

        if (typeof l === 'number') return false;
        if (/^\d+$/.test('' + l)) return false;
        if (moment('' + l, moment.ISO_8601, false).isValid() || moment(new Date('' + l)).isValid()) parseable++;
      }
      return considered > 0 && parseable === considered;
    },
    hasTimeAxis: function hasTimeAxis() {
      if (this.labelsAreDates) return true;
      for (var i = 0; i < this.data.length; i++) {
        var arr = this.data[i] || [];
        for (var j = 0; j < arr.length; j++) {
          var p = arr[j];
          if (p && (typeof p === 'undefined' ? 'undefined' : (0, _typeof3.default)(p)) === 'object' && (p.x != null || p.t != null || p.date != null)) return true;
        }
      }
      return false;
    },
    seriesColor: function seriesColor(index) {
      var color = _GraphManager2.default.graphLineColorByType(this, index);
      if (!color && this.override[index] && this.override[index].borderColor) {
        color = this.override[index].borderColor;
      }

      if (!color || this.isWhiteish(color)) {
        var brand = TYPE_BRAND_COLORS[this.type];
        color = index === 0 && brand ? brand : FALLBACK_PALETTE[index % FALLBACK_PALETTE.length];
      }
      return color;
    },
    isWhiteish: function isWhiteish(color) {
      var c = ('' + color).trim().toLowerCase();
      if (c === 'white' || c === '#fff' || c === '#ffffff') return true;
      var rgb = c.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
      if (rgb) return +rgb[1] >= 240 && +rgb[2] >= 240 && +rgb[3] >= 240;
      var hex = c.match(/^#([0-9a-f]{6})$/);
      if (hex) {
        var n = parseInt(hex[1], 16);
        return (n >> 16 & 255) >= 240 && (n >> 8 & 255) >= 240 && (n & 255) >= 240;
      }
      return false;
    },
    areaGradient: function areaGradient(color) {
      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: this.withAlpha(color, 0.32) }, { offset: 1, color: this.withAlpha(color, 0.02) }]);
    },
    withAlpha: function withAlpha(color, alpha) {
      var c = ('' + color).trim();
      var rgb = c.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
      if (rgb) return 'rgba(' + rgb[1] + ',' + rgb[2] + ',' + rgb[3] + ',' + alpha + ')';
      var hex = c.match(/^#([0-9a-f]{6})$/i);
      if (hex) {
        var n = parseInt(hex[1], 16);
        return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + alpha + ')';
      }
      return c;
    },
    isDashed: function isDashed(index) {
      if (this.type === 'hba1c') return false;
      var dash = this.override[index] && this.override[index].borderDash;
      return Array.isArray(dash) && dash.some(function (n) {
        return n > 0;
      });
    },
    formatValue: function formatValue(label, value, index) {
      var self = this;
      if (value == null) return label;

      if (label === 'Stones & Pounds') {
        var pounds = Math.round(value * 14);
        var stones = parseInt(pounds * 0.071429, 10);
        var remainder = pounds % 14;
        return stones + 'st ' + remainder + (remainder === 1 ? 'lb' : 'lbs');
      }
      if (['minutesAsleep', 'minutesAwake', 'stageRemMinutes', 'stageDeepMinutes', 'stageLightMinutes'].indexOf(label) !== -1) {
        if (value >= 60) {
          var hours = Math.floor(value / 60);
          var minutes = value % 60;
          return moment.duration(hours, 'hours').format('h _') + ' ' + moment.duration(minutes, 'minutes').format('m _');
        }
        return moment.duration(value, 'minutes').format('m _');
      }
      if (label === 'Pounds') return value + ' lbs';
      if (label === 'Kilograms') return value + ' kg';
      if (label === 'ratio') {
        var waist = self.rawResponse && self.rawResponse.data['waist-hip'] && self.rawResponse.data['waist-hip'][index];
        var lines = ['Waist-hip ratio: ' + value];
        if (waist) {
          if (_store2.default.state.user.settings.waist.measure === 'cm') {
            lines.push('Waist: ' + waist.waist_cm + 'cm Hip: ' + waist.hip_cm + 'cm');
          } else if (_store2.default.state.user.settings.waist.measure === 'in') {
            lines.push('Waist: ' + waist.waist_in + 'in Hip: ' + waist.hip_in + 'in');
          }
        }
        return lines.join('<br/>');
      }
      if (label === 'Calories Burnt') return value + 'kcal';
      if (label === 'Systolic (mmHg)') return value + ' ' + self.$t('message.labelSystolic') + ' (mmHg)';
      if (label === 'Diastolic (mmHg)') return value + ' ' + self.$t('message.labelDiastolic') + ' (mmHg)';
      if (label === 'Basal') return value + ' ' + self.$t('message.labelBasal');
      if (label === 'Bolus') return value + ' ' + self.$t('message.labelBolus');
      if (label === 'Correction') return value + ' ' + self.$t('message.labelCorrection');
      if (label === 'Lower ketone range' || label === 'Upper range') return value + ' ' + self.$t('message.labelUpperRange');
      if (label === 'Upper ketone range' || label === 'Lower range') return value + ' ' + self.$t('message.labelLowerRange');
      if (self.type === 'medication') return value + ' ' + self.$t(self.localizeRegime(label));
      if (self.type === 'mood') {
        return label === 'Mood' ? value + ' ' + self.$t('message.cardMood') : value + ' ' + self.$t('message.labelBaseLine');
      }
      return value + ' ' + label;
    },
    tooltipFormatter: function tooltipFormatter(params) {
      var self = this;
      if (!params || !params.length) return '';
      var first = params[0];
      var axisValue = first.axisValue != null ? first.axisValue : first.value && first.value[0];
      var title = void 0;
      if (self.hasTimeAxis()) {
        var intraday = self.axisSpanMs > 0 && self.axisSpanMs <= 2 * 24 * 3600 * 1000;
        title = moment(axisValue).format(intraday ? 'DD-MM-YYYY HH:mm a' : 'DD-MM-YYYY');
      } else {
        title = '' + axisValue;
      }
      var body = '';
      params.forEach(function (p) {
        var value = Array.isArray(p.value) ? p.value[1] : p.value;
        if (value == null) return;
        body += '<div style="display:flex;align-items:center;margin-top:4px">' + '<span style="display:inline-block;width:9px;height:9px;border-radius:50%;background:' + p.color + ';margin-right:8px"></span>' + self.formatValue(p.seriesName, value, p.dataIndex) + '</div>';
      });
      return '<div style="font-size:13px;opacity:0.85">' + title + '</div>' + body;
    },
    renderChartFromData: function renderChartFromData(response) {
      var self = this;
      self.rawResponse = response;
      self.data = response.data.data || [];
      self.labels = response.data.labels || [];
      self.series = response.data.series || [];
      self.override = response.data.override || [];
      self.labelsAreDates = self.detectLabelsAreDates();
      self.dedupeReadings();

      if (self.series.length === 1) self.pointsVisible = true;

      var useTime = self.hasTimeAxis();
      var singleSeries = self.series.length === 1;
      var refs = (0, _clinicalRanges2.default)(self.type, _store2.default);

      var smooth = _store2.default.state.graphOptions.smoothLine ? 0.4 : false;
      var showArea = _store2.default.state.graphOptions.showArea && singleSeries;

      var echartsSeries = self.data.map(function (arr, i) {
        var color = self.seriesColor(i);
        var dashed = self.isDashed(i);
        var points = (arr || []).map(function (p, idx) {
          return self.toPoint(p, idx);
        });

        var overrideWidth = self.override[i] && self.override[i].borderWidth;
        var width = overrideWidth ? Math.max(1, Math.min(overrideWidth, 3)) : 2.5;

        var s = {
          name: self.series[i] || 'Series ' + (i + 1),
          type: 'line',
          data: points,
          smooth: smooth,
          connectNulls: true,
          showSymbol: self.pointsVisible,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: {
            color: color,
            width: width,
            type: dashed ? 'dashed' : 'solid'
          },
          itemStyle: { color: color },
          emphasis: { focus: 'series' },
          z: dashed ? 2 : 3,

          areaStyle: showArea && !dashed ? { color: self.areaGradient(color) } : { opacity: 0 }
        };
        return s;
      });

      if (echartsSeries.length && (refs.bands.length || refs.lines.length)) {
        var target = echartsSeries[0];
        if (refs.bands.length) {
          target.markArea = {
            silent: true,
            label: {
              show: true,
              position: ['8px', '6px'],
              color: '#5FB737',
              fontFamily: FONT,
              fontSize: 11
            },
            data: refs.bands.map(function (b) {
              return [{ yAxis: b.from, name: b.label, itemStyle: { color: b.color } }, { yAxis: b.to }];
            })
          };
        }
        if (refs.lines.length) {
          target.markLine = {
            silent: true,
            symbol: 'none',
            data: refs.lines.map(function (l) {
              return {
                yAxis: l.value,
                lineStyle: { color: l.color, type: 'dashed', width: 1.5 },
                label: {
                  formatter: l.label,
                  position: 'insideEndTop',
                  color: l.color,
                  fontFamily: FONT,
                  fontSize: 11
                }
              };
            })
          };
        }
      }

      var xAxis = {
        type: useTime ? 'time' : 'category',
        boundaryGap: false,
        axisLine: { lineStyle: { color: GRID_COLOR } },
        axisTick: { show: false },
        axisLabel: {
          color: AXIS_COLOR,
          fontFamily: FONT,
          fontSize: 12,
          margin: 12,
          hideOverlap: true,
          formatter: useTime ? function (val) {
            return moment(val).format(self.timeFormatPattern());
          } : function (val) {
            return self.categoryLabel(val);
          }
        },
        splitLine: { show: false }
      };
      if (!useTime) {
        xAxis.data = self.labels;

        if (self.labels.length > 12) xAxis.axisLabel.interval = Math.ceil(self.labels.length / 8) - 1;
      } else {
        var from = moment(self.fromDate, 'YYYY-MM-DD', true);
        var to = moment(self.toDate, 'YYYY-MM-DD', true);
        var isPreset = [0, 1, 7, 30, 360].indexOf(self.dateStep) !== -1;
        if (isPreset && from.isValid() && to.isValid()) {
          xAxis.min = from.clone().startOf('day').valueOf();
          xAxis.max = to.clone().endOf('day').valueOf();
          self.axisSpanMs = xAxis.max - xAxis.min;
        } else {
          self.axisSpanMs = self.dataTimeSpan();
        }

        xAxis.splitNumber = self.dateStep === 7 ? 7 : self.dateStep === 360 ? 12 : 6;
      }

      var totalPoints = self.data.reduce(function (n, arr) {
        return n + (arr && arr.length || 0);
      }, 0);
      var enableZoom = totalPoints > 2;
      var dataZoom = enableZoom ? [{
        type: 'inside',
        xAxisIndex: 0,
        filterMode: 'none',
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        moveOnMouseWheel: false,

        preventDefaultMouseMove: false
      }] : [];

      var option = {
        animationDuration: 600,
        textStyle: { fontFamily: FONT },
        grid: { left: 12, right: 18, top: 24, bottom: 12, containLabel: true },
        dataZoom: dataZoom,
        legend: {
          show: self.series.length > 1,
          top: 0,
          icon: 'circle',
          textStyle: { color: AXIS_COLOR, fontFamily: FONT, fontSize: 13 }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line', lineStyle: { color: '#B9C6CC', width: 1 } },
          backgroundColor: '#0179d5',
          borderWidth: 0,
          padding: [10, 14],
          textStyle: { color: '#fff', fontFamily: FONT, fontSize: 14 },
          formatter: function formatter(params) {
            return self.tooltipFormatter(params);
          }
        },
        xAxis: xAxis,
        yAxis: {
          type: 'value',
          scale: !(self.type === 'blood-glucose' || self.type === 'ketones' || self.type === 'cholesterol' || self.type === 'sleep'),
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: AXIS_COLOR, fontFamily: FONT, fontSize: 13 },
          splitLine: { lineStyle: { color: GRID_COLOR, type: [1, 6] } }
        },
        series: echartsSeries
      };

      self.$nextTick(function () {
        var scrollingElement = $('.main-content');
        var previousPagePosition = scrollingElement.scrollTop();
        self.ensureChart();
        if (self.chart) {
          self.chart.setOption(option, true);
          self.chart.resize();
          scrollingElement.scrollTop(previousPagePosition);
        }
        self.$emit('graphLoading', false);
        self.$emit('graphLoaded', response);
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(11)))

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(276);

var _keys2 = _interopRequireDefault(_keys);

var _vueChartjs = __webpack_require__(448);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reactiveProp = _vueChartjs.mixins.reactiveProp;

exports.default = {
  name: 'striiv-sleep-chart',
  extends: _vueChartjs.Line,
  mixins: [reactiveProp],
  props: ['options'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var self = this;

    self.renderChart(self.chartData, self.options);

    var chart = this.$data._chart;
    var metaData = chart.config.data.datasets[0]._meta;
    var arbitraryKey = (0, _keys2.default)(metaData);

    var chartMetaDatas = metaData[arbitraryKey].data;

    for (var i = 0; i < chartMetaDatas.length; i++) {
      chartMetaDatas[i]._view.backgroundColor = 'green';
    }

    chart.update();
  }
};

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__(448);

exports.default = {
  extends: _vueChartjs.Line,
  props: ['data', 'options'],
  mounted: function mounted() {
    var self = this;
    self.data.datasets[0].backgroundColor = self.getGradient();
    self.$nextTick(function () {
      self.renderChart(self.data, self.options);
    });
  },

  methods: {
    getGradient: function getGradient() {
      var self = this;
      var gradient = this.$refs.canvas.getContext("2d").createLinearGradient(150.000, 0.000, 150.000, 300.000);
      gradient.addColorStop(0, "rgba(228, 50, 41, 1)");
      gradient.addColorStop(0.5, "rgba(228, 50, 41, 0.5)");
      gradient.addColorStop(1, 'rgba(225,225,225,' + 0.1 + ')');
      return gradient;
    }
  },
  watch: {
    'data': function data() {
      var self = this;
      self.data.datasets[0].backgroundColor = self.$refs.canvas.getContext("2d").createLinearGradient(150.000, 0.000, 150.000, 300.000);

      self.$nextTick(function () {

        self.$data._chart.update();
      });
    }
  }
};

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(234);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DB_NAME = 'lcp-cache';
var STORE = 'kv';
var VERSION = 1;
var DAY_MS = 24 * 60 * 60 * 1000;

var dbPromise = null;

function openDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new _promise2.default(function (resolve, reject) {
    if (typeof indexedDB === 'undefined' || indexedDB === null) {
      reject(new Error('IndexedDB unavailable'));
      return;
    }
    var req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = function () {
      var db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = function () {
      resolve(req.result);
    };
    req.onerror = function () {
      reject(req.error);
    };
  });

  dbPromise.catch(function () {
    dbPromise = null;
  });
  return dbPromise;
}

function runTx(mode, fn) {
  return openDb().then(function (db) {
    return new _promise2.default(function (resolve, reject) {
      var tx = db.transaction(STORE, mode);
      var request = fn(tx.objectStore(STORE));
      tx.oncomplete = function () {
        resolve(request ? request.result : undefined);
      };
      tx.onerror = function () {
        reject(tx.error);
      };
      tx.onabort = function () {
        reject(tx.error);
      };
    });
  });
}

var DailyCache = {
  get: function get(key) {
    return runTx('readonly', function (store) {
      return store.get(key);
    }).then(function (record) {
      if (!record) return null;
      if (record.expires && record.expires < Date.now()) return null;
      return record.value;
    }).catch(function () {
      return null;
    });
  },

  set: function set(key, value, ttl) {
    var expires = Date.now() + (typeof ttl === 'number' ? ttl : DAY_MS);
    return runTx('readwrite', function (store) {
      return store.put({ value: value, expires: expires }, key);
    }).catch(function () {});
  },

  DAY_MS: DAY_MS
};

exports.default = DailyCache;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clinicalRanges;


var GREEN = '#5FB737';
var GREEN_FILL = 'rgba(95, 183, 55, 0.10)';
var AMBER = '#FCA039';

function clinicalRanges(type, store) {
  var empty = { bands: [], lines: [] };
  var settings = store && store.state && store.state.user && store.state.user.settings || {};
  var bgMeasure = settings.blood_glucose && settings.blood_glucose.measure || 'mmoll';
  var hba1cMeasure = settings.hba1c && settings.hba1c.measure || 'mmol-mol';

  switch (type) {
    case 'blood-glucose':
      return bgMeasure === 'mgdl' ? { bands: [{ from: 72, to: 140, color: GREEN_FILL, label: 'Target range' }], lines: [] } : { bands: [{ from: 4.0, to: 7.8, color: GREEN_FILL, label: 'Target range' }], lines: [] };

    case 'ketones':
      if (bgMeasure === 'mgdl') return empty;
      return { bands: [{ from: 0.5, to: 3.0, color: GREEN_FILL, label: 'Nutritional ketosis' }], lines: [] };

    case 'hba1c':
      return hba1cMeasure === 'percent' ? {
        bands: [],
        lines: [{ value: 5.7, color: AMBER, label: 'Prediabetes' }, { value: 6.5, color: GREEN, label: 'Diabetes threshold' }]
      } : {
        bands: [],
        lines: [{ value: 42, color: AMBER, label: 'Prediabetes' }, { value: 48, color: GREEN, label: 'Diabetes threshold' }]
      };

    case 'cholesterol':
      return bgMeasure === 'mgdl' ? { bands: [], lines: [{ value: 193, color: GREEN, label: 'Target < 193 mg/dL' }] } : { bands: [], lines: [{ value: 5.0, color: GREEN, label: 'Target < 5 mmol/L' }] };

    case 'blood-pressure':
      return {
        bands: [],
        lines: [{ value: 140, color: AMBER, label: 'High systolic' }, { value: 90, color: AMBER, label: 'High diastolic' }]
      };

    default:
      return empty;
  }
}

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1682);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1683);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IOManager = function () {
  function IOManager() {
    (0, _classCallCheck3.default)(this, IOManager);
  }

  (0, _createClass3.default)(IOManager, [{
    key: "ConnectivityStatusWithAppState",
    value: function ConnectivityStatusWithAppState(context) {
      var self = this;
      context.$nextTick(function () {
        if (!navigator.onLine) {
          context.connected = false;
        } else {
          context.connected = true;
        }
      });
    }
  }]);
  return IOManager;
}();

exports.default = IOManager;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var days = 32,
    daysArray = [];
for (var i = 1; i < days; i++) {
  if (i < 10) {
    daysArray.push('0' + i + '');
  } else {
    daysArray.push('' + i + '');
  }
}
var years = 90,
    yearStartAt = new Date().getFullYear() - 17,
    yearsArray = [];
for (var _i = 0; _i < years; ++_i) {
  var currentYear = --yearStartAt;
  var date = new Date();
  date.setFullYear(currentYear);
  var isLeap = new Date(date.getFullYear() + "-02-29").getMonth() === 1;
  yearsArray.push({ value: '' + currentYear + '', isLeap: isLeap });
}

var DobObject = {};
exports.default = DobObject = {
  days: daysArray,
  months: [{
    value: '01',
    name: 'January',
    daysCount: 31
  }, {
    value: '02',
    name: 'February',
    daysCount: 28
  }, {
    value: '03',
    name: 'March',
    daysCount: 31
  }, {
    value: '04',
    name: 'April',
    daysCount: 30

  }, {
    value: '05',
    name: 'May',
    daysCount: 31
  }, {
    value: '06',
    name: 'June',
    daysCount: 30
  }, {
    value: '07',
    name: 'July',
    daysCount: 31
  }, {
    value: '08',
    name: 'August',
    daysCount: 31
  }, {
    value: '09',
    name: 'September',
    daysCount: 30
  }, {
    value: '10',
    name: 'October',
    daysCount: 31
  }, {
    value: '11',
    name: 'November',
    daysCount: 30
  }, {
    value: '12',
    name: 'December',
    daysCount: 31
  }],
  years: yearsArray
};

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DateOfBirth = __webpack_require__(1664);

var _DateOfBirth2 = _interopRequireDefault(_DateOfBirth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Objects = {
  DobObject: _DateOfBirth2.default
};

exports.default = Objects;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en_gb = __webpack_require__(3922);

var _en_gb2 = _interopRequireDefault(_en_gb);

var _en_ca = __webpack_require__(3921);

var _en_ca2 = _interopRequireDefault(_en_ca);

var _en_us = __webpack_require__(3923);

var _en_us2 = _interopRequireDefault(_en_us);

var _fr_ca = __webpack_require__(3924);

var _fr_ca2 = _interopRequireDefault(_fr_ca);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = {
  "en_us": {
    message: _en_us2.default
  },
  "en_gb": {
    message: _en_gb2.default
  },
  'en_ca': {
    message: _en_ca2.default
  },
  "fr_ca": {
    message: _fr_ca2.default
  }
};

exports.default = messages;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    trackPageReddit: function trackPageReddit() {
      rdt('init', 't2_pd1aslc');
      rdt('track', 'SignUp');
    },
    trackPagePinterest: function trackPagePinterest() {
      pintrk('load', '2613205418059', { em: '<user_email_address>' });
      pintrk('page');
    }
  },
  beforeMount: function beforeMount() {
    var self = this;

    self.$nextTick(function () {
      !function (w, d) {
        if (!w.rdt) {
          var p = w.rdt = function () {
            p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
          };
          p.callQueue = [];
          var t = d.createElement("script");
          t.src = "https://www.redditstatic.com/ads/pixel.js", t.async = !0;
          var s = d.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(t, s);
        }
      }(window, document);

      !function (e) {
        if (!window.pintrk) {
          window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments));
          };
          var n = window.pintrk;
          n.queue = [], n.version = "3.0";
          var t = document.createElement("script");
          t.async = !0, t.src = e;
          var r = document.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(t, r);
        }
      }("https://s.pinimg.com/ct/core.js");
    });
  }
};

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

var _Account = __webpack_require__(51);

var _Account2 = _interopRequireDefault(_Account);

var _Rx = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      conditionSearchClass: 'conditionAutocomplete',
      conditionSearchValue: '',
      conditionSearching: false,
      conditionHelpText: 'Type a condition here',
      conditionDataSource: [],
      conditionDataSourceConfig: {
        text: 'condition_label',
        value: 'condition_id'
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var conditionInputElement = $('.' + self.conditionSearchClass);
    _Rx.Observable.fromEvent(conditionInputElement, 'input').map(function (x) {
      return x.currentTarget.value;
    }).debounceTime(250).subscribe(function (eventText) {
      self.handleConditionSearch(eventText);
    });
  },

  methods: {
    handleConditionSelected: function handleConditionSelected(value) {
      var self = this;
      var object = _.filter(self.conditionDataSource, function (o) {
        return o.condition_label === value;
      });
      var checkExists = _.filter(self.conditions, function (o) {
        return o.condition_label === value;
      });
      if (checkExists.length === 0) {
        self.conditions.unshift(object[0]);
        _Account2.default.putUserConditions(self.conditions).then(function () {});
        self.$nextTick(function () {
          self.conditionSearchValue = '';
          self.conditionDataSource = [];
        });
      } else {
        self.$nextTick(function () {
          self.conditionSearchValue = '';
          self.conditionDataSource = [];
        });
      }
    },
    handleConditionSearch: function handleConditionSearch(value) {
      var self = this;
      self.conditionSearching = true;
      _Medication2.default.conditionsGet(value, 10).then(function (response) {
        self.conditionDataSource = [];
        for (var i = 0; i < response.data.length; i++) {
          var condition = {
            'condition_id': response.data[i].ID,
            'condition_label': response.data[i].title,
            'rightIcon': 'add'
          };
          self.conditionDataSource.push(condition);
        }
        self.conditionSearching = false;
      }).catch(function (error) {
        self.conditionDataSource = [];
        self.conditionSearching = false;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(9)))

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18nIsoCountries = __webpack_require__(2843);

var _i18nIsoCountries2 = _interopRequireDefault(_i18nIsoCountries);

var _index = __webpack_require__(6);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_i18nIsoCountries2.default.registerLocale(__webpack_require__(2844));
_i18nIsoCountries2.default.registerLocale(__webpack_require__(2845));
exports.default = {
  methods: {
    localizeCountry: function localizeCountry(alpha3) {
      return _i18nIsoCountries2.default.getName(alpha3, _index2.default.language);
    }
  }
};

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedGoalReasons: [{
        key: "Feel more relaxed",
        value: "message.goalReasonRelaxed"
      }, {
        key: "more relaxed",
        value: "message.goalReasonRelaxedShort"
      }, {
        key: "Feel more in control",
        value: "message.goalReasonControl"
      }, {
        key: "more in control",
        value: "message.goalReasonControlShort"
      }, {
        key: "More confidence",
        value: "message.goalReasonConfidence"
      }, {
        key: "more confident",
        value: "message.goalReasonConfidenceShort"
      }, {
        key: "Be more active",
        value: "message.goalReasonMoreActive"
      }, {
        key: "more active",
        value: "message.goalReasonMoreActiveShort"
      }, {
        key: "Feel healthier",
        value: "message.goalReasonHealthier"
      }, {
        key: "healthier",
        value: "message.goalReasonHealthierShort"
      }, {
        key: "Feel happier",
        value: "message.goalReasonHappier"
      }, {
        key: "happier",
        value: "message.goalReasonHappierShort"
      }]
    };
  },

  methods: {
    localizeGoalReason: function localizeGoalReason(key) {
      var self = this;
      var localizedGoalReason = self.localizedGoalReasons.filter(function (item) {
        return item.key === key;
      })[0];
      return self.$t(localizedGoalReason.value);
    }
  }
};

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      localizedGoals: [{
        key: "Reduce medication dependency",
        value: "message.goalReduceMedication"
      }, {
        key: "reduced your medication",
        value: "message.goalReducedMedication"
      }, {
        key: "Lose weight",
        value: "message.goalLoseWeight"
      }, {
        key: "lost weight",
        value: "message.goalLostWeight"
      }, {
        key: "Reduce blood glucose/HbA1c",
        value: "message.goalReduceBloodGlucose"
      }, {
        key: "improved blood glucose control",
        value: "message.goalReducedBloodGlucose"
      }, {
        key: 'Healthy lifestyle for me and my family',
        value: "message.goalHealthyLifestyle"
      }, {
        key: "improved the health of your family",
        value: "message.goalImprovedHealth"
      }, {
        key: "Sense of wellbeing",
        value: "message.goalSenseOfWellbeing"
      }, {
        key: "achieved a greater sense of wellbeing",
        value: "message.goalImprovedSenseOfWellbeing"
      }, {
        key: "Something else",
        value: "message.goalSomethingElse"
      }, {
        key: "accomplished your other goal",
        value: "message.goalImprovedSomethingElse"
      }]
    };
  },

  methods: {
    localizeGoal: function localizeGoal(key) {
      var self = this;
      var localizedGoal = self.localizedGoals.filter(function (item) {
        return item.key === key;
      });
      if (localizedGoal.length === 1) {
        return self.$t(localizedGoal[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      relationships: [{
        key: 'My mother',
        value: 'message.relationshipMother'
      }, {
        key: 'My father',
        value: 'message.relationshipFather'
      }, {
        key: 'My wife',
        value: 'message.relationshipWife'
      }, {
        key: 'My husband',
        value: 'message.relationshipHusband'
      }, {
        key: 'My sister',
        value: 'message.relationshipSister'
      }, {
        key: 'My brother',
        value: 'message.relationshipBrother'
      }, {
        key: 'My son',
        value: 'message.relationshipSon'
      }, {
        key: 'My daughter',
        value: 'message.relationshipDaughter'
      }, {
        key: 'My patient',
        value: 'message.relationshipPatient'
      }]
    };
  },

  methods: {
    localizeRelationship: function localizeRelationship(key) {
      var self = this;
      var localized = self.relationships.filter(function (item) {
        return item.key === key;
      });
      if (localized.length === 1) {
        return self.$t(localized[0].value);
      } else {
        return key;
      }
    }
  }
};

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rx = __webpack_require__(91);

var _Medication = __webpack_require__(112);

var _Medication2 = _interopRequireDefault(_Medication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      medicationSearchValue: "",
      medicationInputClass: "mediSearchInput",
      medicationSearching: false,
      medicationDataSource: [],
      medicationDataSourceConfig: {
        text: 'treatment_name',
        value: 'treatment_id'
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var medicationInputElement = $('.' + self.medicationInputClass);
    _Rx.Observable.fromEvent(medicationInputElement, 'input').map(function (x) {
      return x.currentTarget.value;
    }).debounceTime(250).subscribe(function (eventText) {
      self.handleSearch(eventText);
    });
  },

  methods: {
    handleSearch: function handleSearch(searchText) {
      var self = this;
      self.medicationSearching = true;
      _Medication2.default.getTreatments(searchText).then(function (response) {
        self.medicationDataSource = [];
        for (var i = 0; i < response.data.length; i++) {
          var medication = {
            'treatment_id': response.data[i].ID,
            'treatment_name': response.data[i].title,
            'rightIcon': 'add'
          };
          self.medicationDataSource.push(medication);
        }
        self.medicationSearching = false;
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = __webpack_require__(3330);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alert = {};
alert.install = function (Vue) {
  Vue.prototype.$alert = _sweetalert2.default;
};
exports.default = alert;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toastr = __webpack_require__(3331);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toastr = {};

_toastr2.default.options = {
  closeButton: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: "toast-bottom-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: 300,
  hideDuration: 300,
  timeOut: 3000,
  extendedTimeOut: 1000,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut"
};

toastr.install = function (Vue) {
  Vue.prototype.$toastr = _toastr2.default;
};

exports.default = toastr;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(146);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(3880);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Login = __webpack_require__(3509);

var _Login2 = _interopRequireDefault(_Login);

var _Register = __webpack_require__(3538);

var _Register2 = _interopRequireDefault(_Register);

var _Amend = __webpack_require__(3537);

var _Amend2 = _interopRequireDefault(_Amend);

var _ForgotPassword = __webpack_require__(3488);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _PasswordReset = __webpack_require__(3511);

var _PasswordReset2 = _interopRequireDefault(_PasswordReset);

var _EmailVerification = __webpack_require__(3477);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

var _Payment = __webpack_require__(3513);

var _Payment2 = _interopRequireDefault(_Payment);

var _Subscription = __webpack_require__(3560);

var _Subscription2 = _interopRequireDefault(_Subscription);

var _FoodDiary = __webpack_require__(3482);

var _FoodDiary2 = _interopRequireDefault(_FoodDiary);

var _History = __webpack_require__(3483);

var _History2 = _interopRequireDefault(_History);

var _Landing = __webpack_require__(3484);

var _Landing2 = _interopRequireDefault(_Landing);

var _Search = __webpack_require__(3486);

var _Search2 = _interopRequireDefault(_Search);

var _SearchResults = __webpack_require__(3487);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

var _Add = __webpack_require__(3480);

var _Add2 = _interopRequireDefault(_Add);

var _Edit = __webpack_require__(3481);

var _Edit2 = _interopRequireDefault(_Edit);

var _MyMeals = __webpack_require__(3485);

var _MyMeals2 = _interopRequireDefault(_MyMeals);

var _Dashboard = __webpack_require__(3473);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Lesson = __webpack_require__(3502);

var _Lesson2 = _interopRequireDefault(_Lesson);

var _LessonBonus = __webpack_require__(3503);

var _LessonBonus2 = _interopRequireDefault(_LessonBonus);

var _Layout = __webpack_require__(3491);

var _Layout2 = _interopRequireDefault(_Layout);

var _AboutYourself = __webpack_require__(3489);

var _AboutYourself2 = _interopRequireDefault(_AboutYourself);

var _YourHealth = __webpack_require__(3494);

var _YourHealth2 = _interopRequireDefault(_YourHealth);

var _Location = __webpack_require__(3492);

var _Location2 = _interopRequireDefault(_Location);

var _Goals = __webpack_require__(3490);

var _Goals2 = _interopRequireDefault(_Goals);

var _Personalise = __webpack_require__(3493);

var _Personalise2 = _interopRequireDefault(_Personalise);

var _Profile = __webpack_require__(3515);

var _Profile2 = _interopRequireDefault(_Profile);

var _ProfileFollowers = __webpack_require__(3517);

var _ProfileFollowers2 = _interopRequireDefault(_ProfileFollowers);

var _ProfileFollowing = __webpack_require__(3518);

var _ProfileFollowing2 = _interopRequireDefault(_ProfileFollowing);

var _ProfileProgress = __webpack_require__(3521);

var _ProfileProgress2 = _interopRequireDefault(_ProfileProgress);

var _ProfileDiscussion = __webpack_require__(3516);

var _ProfileDiscussion2 = _interopRequireDefault(_ProfileDiscussion);

var _ProfileGallery = __webpack_require__(3520);

var _ProfileGallery2 = _interopRequireDefault(_ProfileGallery);

var _ProfileFood = __webpack_require__(3519);

var _ProfileFood2 = _interopRequireDefault(_ProfileFood);

var _QuestionsIndex = __webpack_require__(3524);

var _QuestionsIndex2 = _interopRequireDefault(_QuestionsIndex);

var _QuestionCreate = __webpack_require__(3522);

var _QuestionCreate2 = _interopRequireDefault(_QuestionCreate);

var _QuestionThread = __webpack_require__(3523);

var _QuestionThread2 = _interopRequireDefault(_QuestionThread);

var _AnswerReport = __webpack_require__(3539);

var _AnswerReport2 = _interopRequireDefault(_AnswerReport);

var _QuestionReport = __webpack_require__(3542);

var _QuestionReport2 = _interopRequireDefault(_QuestionReport);

var _LifeReplyReport = __webpack_require__(3540);

var _LifeReplyReport2 = _interopRequireDefault(_LifeReplyReport);

var _LifeSubReplyReport = __webpack_require__(3541);

var _LifeSubReplyReport2 = _interopRequireDefault(_LifeSubReplyReport);

var _Layout3 = __webpack_require__(3469);

var _Layout4 = _interopRequireDefault(_Layout3);

var _AddProgress = __webpack_require__(3455);

var _AddProgress2 = _interopRequireDefault(_AddProgress);

var _BloodGlucose = __webpack_require__(3564);

var _BloodGlucose2 = _interopRequireDefault(_BloodGlucose);

var _HbA1c = __webpack_require__(3567);

var _HbA1c2 = _interopRequireDefault(_HbA1c);

var _Weight = __webpack_require__(3575);

var _Weight2 = _interopRequireDefault(_Weight);

var _Sleep = __webpack_require__(3572);

var _Sleep2 = _interopRequireDefault(_Sleep);

var _SleepWearable = __webpack_require__(3574);

var _SleepWearable2 = _interopRequireDefault(_SleepWearable);

var _SleepDeviceHistory = __webpack_require__(3573);

var _SleepDeviceHistory2 = _interopRequireDefault(_SleepDeviceHistory);

var _BloodPressure = __webpack_require__(3565);

var _BloodPressure2 = _interopRequireDefault(_BloodPressure);

var _Ketones = __webpack_require__(3569);

var _Ketones2 = _interopRequireDefault(_Ketones);

var _Insulin = __webpack_require__(3568);

var _Insulin2 = _interopRequireDefault(_Insulin);

var _Medication = __webpack_require__(3570);

var _Medication2 = _interopRequireDefault(_Medication);

var _Mood = __webpack_require__(3571);

var _Mood2 = _interopRequireDefault(_Mood);

var _Cholesterol = __webpack_require__(3566);

var _Cholesterol2 = _interopRequireDefault(_Cholesterol);

var _Activity = __webpack_require__(3562);

var _Activity2 = _interopRequireDefault(_Activity);

var _ActivityFitbit = __webpack_require__(3563);

var _ActivityFitbit2 = _interopRequireDefault(_ActivityFitbit);

var _Weight3 = __webpack_require__(3470);

var _Weight4 = _interopRequireDefault(_Weight3);

var _Hba1c = __webpack_require__(3468);

var _Hba1c2 = _interopRequireDefault(_Hba1c);

var _Goals3 = __webpack_require__(3467);

var _Goals4 = _interopRequireDefault(_Goals3);

var _Layout5 = __webpack_require__(3549);

var _Layout6 = _interopRequireDefault(_Layout5);

var _General = __webpack_require__(3547);

var _General2 = _interopRequireDefault(_General);

var _Privacy = __webpack_require__(3556);

var _Privacy2 = _interopRequireDefault(_Privacy);

var _Security = __webpack_require__(3557);

var _Security2 = _interopRequireDefault(_Security);

var _Notifications = __webpack_require__(3553);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _Units = __webpack_require__(3559);

var _Units2 = _interopRequireDefault(_Units);

var _Subscription3 = __webpack_require__(3558);

var _Subscription4 = _interopRequireDefault(_Subscription3);

var _Personalise3 = __webpack_require__(3554);

var _Personalise4 = _interopRequireDefault(_Personalise3);

var _Food = __webpack_require__(3546);

var _Food2 = _interopRequireDefault(_Food);

var _Conditions = __webpack_require__(3544);

var _Conditions2 = _interopRequireDefault(_Conditions);

var _Medications = __webpack_require__(3552);

var _Medications2 = _interopRequireDefault(_Medications);

var _Add3 = __webpack_require__(3550);

var _Add4 = _interopRequireDefault(_Add3);

var _Edit3 = __webpack_require__(3551);

var _Edit4 = _interopRequireDefault(_Edit3);

var _Dashboard3 = __webpack_require__(3545);

var _Dashboard4 = _interopRequireDefault(_Dashboard3);

var _Integrations = __webpack_require__(3548);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _Preferences = __webpack_require__(3555);

var _Preferences2 = _interopRequireDefault(_Preferences);

var _Activity3 = __webpack_require__(3543);

var _Activity4 = _interopRequireDefault(_Activity3);

var _IntegratedConfirmation = __webpack_require__(3501);

var _IntegratedConfirmation2 = _interopRequireDefault(_IntegratedConfirmation);

var _Downloads = __webpack_require__(3475);

var _Downloads2 = _interopRequireDefault(_Downloads);

var _DownloadsCategory = __webpack_require__(3476);

var _DownloadsCategory2 = _interopRequireDefault(_DownloadsCategory);

var _LifeStyle = __webpack_require__(3507);

var _LifeStyle2 = _interopRequireDefault(_LifeStyle);

var _LifeArticle = __webpack_require__(3504);

var _LifeArticle2 = _interopRequireDefault(_LifeArticle);

var _LifeCategory = __webpack_require__(3505);

var _LifeCategory2 = _interopRequireDefault(_LifeCategory);

var _LifeSearch = __webpack_require__(3508);

var _LifeSearch2 = _interopRequireDefault(_LifeSearch);

var _LifeFavourites = __webpack_require__(3506);

var _LifeFavourites2 = _interopRequireDefault(_LifeFavourites);

var _Coaching = __webpack_require__(3471);

var _Coaching2 = _interopRequireDefault(_Coaching);

var _Contact = __webpack_require__(3472);

var _Contact2 = _interopRequireDefault(_Contact);

var _ = __webpack_require__(3454);

var _2 = _interopRequireDefault(_);

var _Testimonials = __webpack_require__(3561);

var _Testimonials2 = _interopRequireDefault(_Testimonials);

var _Layout7 = __webpack_require__(3499);

var _Layout8 = _interopRequireDefault(_Layout7);

var _Article = __webpack_require__(3495);

var _Article2 = _interopRequireDefault(_Article);

var _Search3 = __webpack_require__(3500);

var _Search4 = _interopRequireDefault(_Search3);

var _Category = __webpack_require__(3497);

var _Category2 = _interopRequireDefault(_Category);

var _Categories = __webpack_require__(3496);

var _Categories2 = _interopRequireDefault(_Categories);

var _GettingStarted = __webpack_require__(3498);

var _GettingStarted2 = _interopRequireDefault(_GettingStarted);

var _Index = __webpack_require__(3531);

var _Index2 = _interopRequireDefault(_Index);

var _Detail = __webpack_require__(3529);

var _Detail2 = _interopRequireDefault(_Detail);

var _Category3 = __webpack_require__(1273);

var _Category4 = _interopRequireDefault(_Category3);

var _Search5 = __webpack_require__(1276);

var _Search6 = _interopRequireDefault(_Search5);

var _Results = __webpack_require__(3536);

var _Results2 = _interopRequireDefault(_Results);

var _Favorites = __webpack_require__(3530);

var _Favorites2 = _interopRequireDefault(_Favorites);

var _MealPlans = __webpack_require__(3535);

var _MealPlans2 = _interopRequireDefault(_MealPlans);

var _Index3 = __webpack_require__(3533);

var _Index4 = _interopRequireDefault(_Index3);

var _MealPlanDetail = __webpack_require__(3532);

var _MealPlanDetail2 = _interopRequireDefault(_MealPlanDetail);

var _Index5 = __webpack_require__(3479);

var _Index6 = _interopRequireDefault(_Index5);

var _Detail3 = __webpack_require__(3478);

var _Detail4 = _interopRequireDefault(_Detail3);

var _Callback = __webpack_require__(3510);

var _Callback2 = _interopRequireDefault(_Callback);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _AuthenticationManager = __webpack_require__(99);

var _AuthenticationManager2 = _interopRequireDefault(_AuthenticationManager);

var _Discount = __webpack_require__(3474);

var _Discount2 = _interopRequireDefault(_Discount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: "*",
    name: "404",
    component: _2.default,
    meta: {
      title: "Sign in",
      i18n: "message.fourZeroFourAppBarText",
      hideLeftNav: false,
      requireAuth: false,
      hideLoader: true
    }
  }, {
    path: "/",
    redirect: "/dashboard"
  }, {
    path: "/login",
    name: "Login",
    component: _Login2.default,
    meta: {
      id: "login",
      title: "Sign in",
      i18n: "message.loginAppBarText",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: false,
      hideRegisterAppBar: true,
      hideShadow: true
    }
  }, {
    path: "/register",
    name: "Register",
    component: _Register2.default,
    meta: {
      id: "register",
      title: "Register",
      i18n: "message.registerAppBarText",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: false,
      hideShadow: true,
      hideRegisterAppBar: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (_AuthenticationManager2.default.hasToken()) {
        if (_AuthenticationManager2.default.parseJwt().scope[0] === 'unsubscribed_tasks') {
          return next({ path: '/subscribe' });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }, {
    path: "/register/amend",
    name: "AmendRegistration",
    component: _Amend2.default,
    meta: {
      id: "register",
      title: "Register",
      i18n: "message.registerAppBarText",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: true,
      hideShadow: true
    }
  }, {
    name: "Payment",
    path: "/payment",
    component: _Payment2.default,
    meta: {
      id: "Payment",
      title: "Payment",
      i18n: "Payment",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: false
    }
  }, {
    name: "Subscription",
    path: "/subscribe",
    component: _Subscription2.default,
    meta: {
      id: "Subscription",
      title: "Subscription",
      i18n: "Subscription",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: true
    }
  }, {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: _ForgotPassword2.default,
    meta: {
      id: "forgot-password",
      title: "Forgot Password",
      i18n: "message.forgotPasswordAppBarText",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: false,
      hideShadow: true
    }
  }, {
    path: '/password-reset',
    name: 'PasswordReset',
    component: _PasswordReset2.default,
    meta: {
      id: "reset-password",
      title: "Reset Password",
      i18n: "message.resetPasswordAppBarText",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: false,
      hideShadow: true,
      hideRegisterAppBar: true
    }
  }, {
    path: '/email-verification',
    name: 'EmailVerification',
    component: _EmailVerification2.default,
    meta: {
      id: "verification",
      i18n: "message.verifyAccountAppBarText",
      requireAuth: true
    }
  }, {
    path: "/getting-started/",
    redirect: "/getting-started/about-you",
    component: _Layout2.default,
    meta: {
      id: "getting-started",
      title: "Getting started",
      i18n: "message.obAboutAppBarText",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: true,
      hideShadow: true
    },
    children: [{
      path: "/getting-started/about-you",
      name: "GettingStartedAboutYourself",
      component: _AboutYourself2.default,
      meta: {
        reuse: false,
        id: "getting-started",
        title: "Getting started",
        i18n: "message.obAboutAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true,
        hideShadow: true
      }
    }, {
      path: "/getting-started/your-health",
      name: "GettingStartedYourHealth",
      component: _YourHealth2.default,
      meta: {
        reuse: false,
        id: "getting-started",
        title: "Your Health",
        i18n: "message.obHealthAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true
      }
    }, {
      path: "/getting-started/location",
      name: "GettingStartedLocation",
      component: _Location2.default,
      meta: {
        reuse: false,
        id: "getting-started",
        title: "Location",
        i18n: "message.obLocationAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true
      }
    }, {
      path: "/getting-started/goals",
      name: "GettingStartedGoals",
      component: _Goals2.default,
      meta: {
        reuse: false,
        id: "getting-started",
        title: "Goals",
        i18n: "message.obGoalsAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true
      }
    }, {
      path: "/getting-started/personalise",
      name: "GettingStartedPersonalise",
      component: _Personalise2.default,
      meta: {
        reuse: false,
        id: "getting-started",
        title: "Personalise",
        i18n: "message.obPersonalizeAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true
      }
    }],
    beforeEnter: function beforeEnter(to, from, next) {
      if (_AuthenticationManager2.default.hasToken()) {
        if (_AuthenticationManager2.default.parseJwt().scope[0] === 'unsubscribed_tasks') {
          return next({ path: '/subscribe' });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }, {
    path: "/dashboard",
    name: "Dashboard",
    component: _Dashboard2.default,
    meta: {
      isChild: false,
      id: "dashboard",
      title: "Your dashboard",
      i18n: "message.dashboardAppBarText",
      requireAuth: true
    }
  }, {
    path: "/food-diary",
    name: "FoodDiary",
    component: _FoodDiary2.default,
    meta: {
      isChild: true,
      id: "food-diary",
      i18n: "message.foodDiaryAppBarText",
      requireAuth: true
    }
  }, {
    path: "/food-diary/history",
    name: "FoodDiaryHistory",
    component: _History2.default,
    meta: {
      id: "food-diary",
      i18n: 'message.foodDiaryAppBarText',
      requireAuth: true,
      isChild: true
    }
  }, {
    path: "/food-diary/new-entry",
    name: "FoodDiaryLanding",
    component: _Landing2.default,
    props: true,
    meta: {
      id: "food-diary",
      i18n: "message.foodDiaryAddFoodAppBarText",
      requireAuth: true
    }
  }, {
    path: "/food-diary/search",
    name: "FoodDiarySearch",
    component: _Search2.default,
    props: true,
    meta: {
      id: "food-diary-search",
      i18n: "message.foodDiaryAddFoodAppBarText",
      requireAuth: true
    }
  }, {
    path: "/food-diary/results/",
    name: "FoodDiarySearchResults",
    component: _SearchResults2.default,
    meta: {
      id: "food-diary-search-results",
      i18n: "message.foodDiaryAddFoodAppBarText",
      requireAuth: true
    }
  }, {
    path: "/food-diary/add/",
    name: "FoodDiaryAdd",
    component: _Add2.default,
    props: true,
    meta: {
      id: "food-diary-add",
      i18n: "message.foodDiaryAddFoodAppBarText",
      requireAuth: true
    }
  }, {
    path: "/food-diary/edit/",
    name: "FoodDiaryEdit",
    component: _Edit2.default,
    props: true,
    meta: {
      id: "food-diary-edit",
      i18n: "message.foodDiaryAppBarText",
      requireAuth: true,
      isChild: true
    }
  }, {
    path: "/food-diary/my-meals/",
    name: "FoodDiaryMyMeals",
    component: _MyMeals2.default,
    props: true,
    meta: {
      id: "food-diary-my-meals",
      i18n: "message.foodDiaryAppBarText",
      requireAuth: true,
      isChild: true
    }
  }, {
    path: "/lesson/:permalink",
    name: "Lesson",
    component: _Lesson2.default,
    meta: {
      id: "lesson",
      i18n: "message.lessonTitleText",
      hasCustomTitle: true,
      isChild: true,
      requireAuth: true,
      paymentWall: true
    }
  }, {
    path: "/lesson/bonus/:id",
    name: "LessonBonus",
    component: _LessonBonus2.default,
    meta: {
      id: "lesson",
      i18n: "message.lessonBonusTitleText",
      hasCustomTitle: true,
      isChild: true,
      requireAuth: true,
      paymentWall: true
    }
  }, {
    path: "/questions/most_recent/page/1/",
    redirect: "/questions"
  }, {
    path: "/questions",
    name: "QuestionsIndex",
    component: _QuestionsIndex2.default,
    meta: {
      title: "Questions",
      id: "questions-index",
      i18n: "message.questionsAppBarText",
      requireAuth: true,
      paymentWall: true
    }
  }, {
    path: "/questions/thread/:id",
    name: "QuestionThread",
    component: _QuestionThread2.default,
    meta: {
      title: "QuestionThread",
      id: "question-thread",
      i18n: "message.threadTitleText",
      hasCustomTitle: true,
      isChild: true,
      requireAuth: true,
      paymentWall: true
    }
  }, {
    path: "/questions/create/",
    name: "Ask a question",
    component: _QuestionCreate2.default,
    meta: {
      id: "question-create",
      title: "Ask a question",
      isChild: true,
      i18n: "message.questionsAppBarText",
      requireAuth: true,
      paymentWall: true
    }
  }, {
    path: "/profile/:profileUrl",
    name: "Profile",
    component: _Profile2.default,
    meta: {
      id: "profile",
      title: "Profile",
      i18n: "message.profileAppBarText",
      requireAuth: true,
      hasCustomTitle: true
    },
    children: [{
      path: "progress",
      name: "ProfileProgress",
      component: _ProfileProgress2.default,
      meta: {
        id: "profile",
        title: "Profile",
        i18n: "message.profileAppBarText",
        requireAuth: true,
        isProfilePage: true
      }
    }, {
      path: "discussion",
      name: "ProfileDiscussion",
      component: _ProfileDiscussion2.default,
      meta: {
        id: "profile",
        title: "Profile",
        i18n: "message.profileAppBarText",
        requireAuth: true,
        isProfilePage: true
      }
    }, {
      path: "gallery",
      name: "ProfileGallery",
      component: _ProfileGallery2.default,
      meta: {
        id: "profile",
        title: "Profile",
        i18n: "message.profileAppBarText",
        requireAuth: true,
        isProfilePage: true
      }
    }, {
      path: "food-diary",
      name: "ProfileFoodDiary",
      component: _ProfileFood2.default,
      meta: {
        id: "profile",
        title: "Profile",
        i18n: "message.profileAppBarText",
        requireAuth: true,
        isProfilePage: true
      }
    }, {
      path: "followers",
      name: "ProfileFollowers",
      component: _ProfileFollowers2.default,
      meta: {
        id: "profile",
        title: "Profile",
        i18n: "message.profileAppBarText",
        requireAuth: true,
        hasCustomTitle: true,
        isProfilePage: true
      }
    }, {
      path: "following",
      name: "ProfileFollowing",
      component: _ProfileFollowing2.default,
      meta: {
        id: "profile",
        title: "Profile",
        i18n: "message.profileAppBarText",
        requireAuth: true,
        hasCustomTitle: true,
        isProfilePage: true
      }
    }]
  }, {
    path: "/life",
    name: "LifeStyle",
    component: _LifeStyle2.default,
    meta: {
      id: "lifestyle",
      title: "Lifestyle",
      i18n: "message.lifestyleAppBarText",
      hideLoader: true,
      paymentWall: true,
      hasTransHeader: true
    }
  }, {
    path: "/life/my-favourites",
    name: "LifeStyleFavourites",
    component: _LifeFavourites2.default,
    meta: {
      id: "LifeStyleFavourites",
      title: "Lifestyle",
      isChild: true,
      i18n: "message.lifestyleAppBarText",
      hasCustomTitle: true,
      hideLoader: true
    }
  }, {
    path: "/life/:permalink",
    name: "LifeStyleArticle",
    component: _LifeArticle2.default,
    meta: {

      id: "LifeStyleDetail",
      title: "Lifestyle",
      isChild: true,
      i18n: "message.lifestyleAppBarText",
      hasCustomTitle: true,
      hideLoader: true,
      paymentWall: true
    }
  }, {
    path: "/life/category/:slug",
    name: "LifeStyleCategory",
    component: _LifeCategory2.default,
    meta: {
      id: "LifeStyleCategory",
      title: "Lifestyle",
      isChild: true,
      i18n: "message.lifestyleAppBarText",
      hasCustomTitle: true,
      hideLoader: true,
      paymentWall: true
    }
  }, {
    path: "/life/search/:search",
    name: "LifeStyleSearch",
    component: _LifeSearch2.default,
    meta: {
      id: "LifeStyleSearch",
      title: "Lifestyle",
      isChild: true,
      i18n: "message.lifestyleAppBarText",
      hasCustomTitle: true,
      hideLoader: true
    }
  }, {
    path: '/check-in',
    name: "CheckIn",
    component: _Layout4.default,
    meta: {
      id: "add-progress",
      title: "Add progress",
      i18n: "message.checkInAppBarText",
      isChild: true,
      noShadow: true,
      requireAuth: true,
      isBlueBg: false
    },
    children: [{
      path: 'weight',
      name: "WeightCheckin",
      component: _Weight4.default,
      meta: {
        id: "add-progress",
        title: "Add progress",
        i18n: "message.checkInAppBarText",
        noShadow: true,
        requireAuth: true,
        isBlueBg: false
      }
    }, {
      path: 'hba1c',
      name: "Hba1cCheckin",
      component: _Hba1c2.default,
      meta: {
        id: "add-progress",
        title: "Add progress",
        i18n: "message.checkInAppBarText",
        noShadow: true,
        requireAuth: true,
        isBlueBg: false
      }
    }, {
      path: 'goals',
      name: "GoalsCheckin",
      component: _Goals4.default,
      meta: {
        id: "add-progress",
        title: "Add progress",
        i18n: "message.checkInAppBarText",
        noShadow: true,
        requireAuth: true,
        isBlueBg: false
      }
    }]
  }, {
    path: "/add-progress",
    name: "AddProgress",
    component: _AddProgress2.default,
    meta: {
      id: "add-progress",
      title: "Add progress",
      i18n: "message.addProgressAppBarText",
      isChild: true,
      noShadow: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/blood-glucose/",
    name: "BloodGlucoseProgress",
    component: _BloodGlucose2.default,
    meta: {
      id: "blood-glucose",
      title: "Your blood glucose progress",
      i18n: "message.bloodGlucoseAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/hba1c/",
    name: "HbA1cProgress",
    component: _HbA1c2.default,
    meta: {
      id: "blood-glucose",
      title: "Your HbA1c progress",
      i18n: "message.hbA1cAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: '/tracking/activity/',
    name: 'ActivityProgress',
    component: _Activity2.default,
    meta: {
      id: 'activity',
      title: 'Your activity progress',
      i18n: 'message.activityAppBarText',
      isChild: true,
      requireAuth: true
    }
  }, {
    path: '/tracking/activity/fitbit',
    name: 'ActivityProgressFitbit',
    component: _ActivityFitbit2.default,
    meta: {
      id: 'activity-fb',
      title: 'Your activity progress',
      i18n: 'message.activityAppBarText',
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/weight/",
    name: "WeightProgress",
    component: _Weight2.default,
    meta: {
      id: "weight",
      title: "Your weight progress",
      i18n: "message.weightAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/sleep/",
    name: "SleepProgress",
    component: _Sleep2.default,
    meta: {
      id: "sleep",
      title: "Your sleep progress",
      i18n: "message.sleepAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/sleep/history",
    name: "SleepProgress",
    component: _SleepWearable2.default,
    meta: {
      id: "sleep",
      title: "Your sleep progress",
      i18n: "message.sleepAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: '/tracking/sleep/deviceHistory',
    name: "SleepDeviceHistory",
    component: _SleepDeviceHistory2.default,
    meta: {
      id: "sleep",
      title: "Your sleep progress",
      i18n: "message.sleepAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/blood-pressure/",
    name: "BloodPressureProgress",
    component: _BloodPressure2.default,
    meta: {
      id: "blood-pressure",
      title: "Your blood pressure progress",
      i18n: "message.bloodPressureAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/ketones/",
    name: "KetonesProgress",
    component: _Ketones2.default,
    meta: {
      id: "ketones",
      title: "Your ketones progress",
      i18n: "message.ketonesAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/insulin/",
    name: "InsulinProgress",
    component: _Insulin2.default,
    meta: {
      id: "insulin",
      title: "Your insulin progress",
      i18n: "message.insulinAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/medication",
    name: "MedicationProgress",
    component: _Medication2.default,
    meta: {
      id: "medication",
      title: "Your medication progress",
      i18n: "message.medicationAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/mood",
    name: "MoodProgress",
    component: _Mood2.default,
    meta: {
      id: "mood",
      title: "Your mood progress",
      i18n: "message.moodAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/tracking/cholesterol",
    name: "CholesterolProgress",
    component: _Cholesterol2.default,
    meta: {
      id: "cholesterol",
      title: "Your cholesterol progress",
      i18n: "message.cholesterolAppBarText",
      isChild: true,
      requireAuth: true
    }
  }, {
    path: "/settings",
    redirect: "/settings/general",
    component: _Layout6.default,
    meta: {
      id: "settings",
      title: "Your settings",
      i18n: "message.settingsAppBarText",
      isChild: true,
      requireAuth: true
    },
    children: [{
      name: "SettingsPreferences",
      path: "preferences",
      component: _Preferences2.default,
      meta: {
        id: "settings-preferences",
        title: "General account settings",
        i18n: "message.settingsPreferencesTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsGeneral",
      path: "general",
      component: _General2.default,
      meta: {
        id: "settings-general",
        title: "General account settings",
        i18n: "message.settingsGeneralTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsSecurity",
      path: "security",
      component: _Security2.default,
      meta: {
        id: "settings-security",
        title: "Security settings",
        i18n: "message.settingsSecurityTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsSubscription",
      path: "subscription",
      component: _Subscription4.default,
      meta: {
        id: "settings-subscription",
        title: "Subscription settings",
        i18n: "message.settingsSubscriptionTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsPrivacy",
      path: "Privacy",
      component: _Privacy2.default,
      meta: {
        id: "settings-privacy",
        title: "Privacy settings",
        i18n: "message.settingsPrivacyTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsNotifications",
      path: "notifications",
      component: _Notifications2.default,
      meta: {
        id: "settings-notifications",
        title: "Notifications settings",
        i18n: "message.settingsNotificationsTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsUnits",
      path: "units",
      component: _Units2.default,
      meta: {
        id: "settings-units",
        title: "Unit settings",
        i18n: "message.settingsUnitsTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsPersonalization",
      path: "personalise",
      component: _Personalise4.default,
      meta: {
        id: "settings-personalize",
        title: "Personalise",
        i18n: "message.settingsPersonalizeTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsFood",
      path: "food",
      component: _Food2.default,
      meta: {
        id: "settings-conditions",
        title: "Conditions",
        i18n: "message.settingsFoodTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsConditions",
      path: "conditions",
      component: _Conditions2.default,
      meta: {
        id: "settings-conditions",
        title: "Conditions",
        i18n: "message.settingsConditionsTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsMedication",
      path: "medications",
      component: _Medications2.default,
      meta: {
        id: "settings-medication",
        title: "Medication",
        i18n: "message.settingsMedicationTitleText",
        isChild: false,
        requireAuth: true
      },
      children: [{
        name: "SettingsAddMedications",
        path: "add",
        component: _Add4.default,
        meta: {
          id: "settings-medication",
          title: "Set up a new medication",
          i18n: "message.settingsMedicationTitleText",
          isChild: false,
          requireAuth: true
        }
      }, {
        name: "SettingsEditMedications",
        path: "edit",
        component: _Edit4.default,
        props: true,
        meta: {
          id: "settings-medication",
          title: "Editing medication",
          i18n: "message.settingsMedicationTitleText",
          isChild: false,
          requireAuth: true
        }
      }]
    }, {
      name: "SettingsDashboard",
      path: "dashboard",
      component: _Dashboard4.default,
      meta: {
        id: "settings-dashboard",
        title: "Dashboard",
        i18n: "message.settingsDashboardTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsIntegrations",
      path: "integrations",
      component: _Integrations2.default,
      meta: {
        id: "settings-integrations",
        title: "Integrations",
        i18n: "message.settingsIntegrationTitleText",
        isChild: false,
        requireAuth: true
      }
    }, {
      name: "SettingsActivity",
      path: "activity",
      component: _Activity4.default,
      meta: {
        title: "Activity",
        i18n: "message.settingsActivityTitleText",
        isChild: false,
        requireAuth: true
      }
    }]
  }, {
    name: "Downloads",
    path: "/downloads",
    component: _Downloads2.default,
    meta: {
      id: "downloads",
      title: "Downloads",
      i18n: "message.downloadsAppBarText",
      requireAuth: true,
      paymentWall: true
    }
  }, {
    name: "DownloadsCategory",
    path: "/downloads/category/:slug",
    component: _DownloadsCategory2.default,
    meta: {
      id: "downloads",
      title: "Downloads",
      i18n: "message.downloadsAppBarText",
      requireAuth: true,
      paymentWall: false
    }
  }, {
    name: "Coaching",
    path: "/coaching",
    component: _Coaching2.default,
    meta: {
      id: "coaching",
      title: "Coaching",
      i18n: "message.coachingAppBarText",
      requireAuth: true
    }
  }, {
    name: "AnswerReport",
    path: '/reports/answer/:id',
    component: _AnswerReport2.default,
    meta: {
      id: "answer-reporting",
      title: "Answer reporting",
      isChild: true,
      i18n: "message.answerReportAppBarText",
      hasCustomTitle: true,
      requireAuth: true
    }
  }, {
    name: 'QuestionReport',
    path: '/reports/question/:id',
    component: _QuestionReport2.default,
    meta: {
      id: "answer-reporting",
      title: "Answer reporting",
      isChild: true,
      i18n: "message.questionReportAppBarText",
      hasCustomTitle: true,
      requireAuth: true
    }
  }, {
    name: 'LifeReplyReport',
    path: '/reports/life/reply/:id',
    component: _LifeReplyReport2.default,
    meta: {
      id: "life-reporting",
      title: "Life comment reporting",
      isChild: true,
      i18n: "message.lifeReportAppBarText",
      hasCustomTitle: true,
      requireAuth: true
    }
  }, {
    name: 'LifeSubReplyReport',
    path: '/reports/life/subreply/:id',
    component: _LifeSubReplyReport2.default,
    meta: {
      id: "life-reporting",
      title: "Life comment reporting",
      isChild: true,
      i18n: "message.lifeReportAppBarText",
      hasCustomTitle: true,
      requireAuth: true
    }
  }, {
    name: "Contact",
    path: "/contact",
    component: _Contact2.default,
    meta: {
      id: "contact",
      title: "Contact us",
      i18n: "message.contactAppBarText",
      requireAuth: true
    }
  }, {
    name: "Testimonials",
    path: "/testimonials",
    component: _Testimonials2.default,
    meta: {
      id: "testimonials",
      title: "Testimonials",
      i18n: "message.testimonialAppBarText",
      requireAuth: true
    }
  }, {
    name: "Integrated",
    path: "/integrated",
    component: _IntegratedConfirmation2.default,
    meta: {
      id: "integration",
      title: "Integration complete",
      i18n: "message.integrationCompleteAppBarText",
      requireAuth: true
    }
  }, {
    name: 'HealthCareProfessional',
    path: '/hcp',
    redirect: '/hcp/categories',
    component: _Layout8.default,
    meta: {
      id: 'hcp',
      title: 'Health Care Professional',
      i18n: 'message.hcpAppBarText',
      requireAuth: true,
      requireHcpVerification: true
    },
    children: [{
      path: "/hcp/getting-started",
      name: "HcpGettingStarted",
      component: _GettingStarted2.default,
      meta: {
        reuse: false,
        id: "hcp",
        title: "Getting started",
        i18n: "message.hcpAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true,
        hideShadow: true
      }
    }, {
      path: "/hcp/categories",
      name: "HcpCategories",
      component: _Categories2.default,
      meta: {
        id: "hcpCategory",
        title: "Health Care Professionals",
        i18n: "Education",
        requireAuth: true,
        requireHcpVerification: true
      }
    }, {
      path: "/hcp/category/:slug",
      name: 'HcpCategory',
      component: _Category2.default,
      meta: {
        id: "hcpCategory",
        isChild: true,
        title: "Health Care Professionals",
        i18n: "Education",
        requireAuth: true,
        hasCustomTitle: true,
        requireHcpVerification: true
      }
    }, {
      path: "/hcp/article/:slug",
      name: 'HcpArticle',
      component: _Article2.default,
      meta: {
        id: "hcpArticle",
        isChild: true,
        title: "Health Care Professionals",
        i18n: "message.hcpAppBarText",
        requireAuth: true,
        hasCustomTitle: true,
        requireHcpVerification: true
      }
    }, {
      path: "/hcp/search/:search",
      name: 'HcpSearch',
      component: _Search4.default,
      meta: {
        id: "hcpSearch",
        isChild: true,
        title: "Health Care Professionals",
        i18n: "message.hcpAppBarText",
        requireAuth: true,
        hasCustomTitle: true,
        requireHcpVerification: true
      }
    }]
  }, {
    name: 'Faq',
    path: '/faq',
    component: _Index6.default,
    meta: {
      id: 'faq',
      title: 'Frequently asked questions',
      i18n: 'message.faqAppBarText',
      requireAuth: true,
      isBlueBg: true
    },
    children: [{
      name: 'FaqDetail',
      path: ':id',
      component: _Detail4.default,
      meta: {
        id: 'faq',
        title: 'Frequently asked questions',
        i18n: 'message.faqAppBarText',
        requireAuth: true,
        isChild: true
      }
    }]
  }, {
    path: "/recipes",
    name: "RecipeIndex",
    component: _Index2.default,
    meta: {
      id: "recipes",
      title: "Recipes",
      i18n: "message.recipesAppBarText",
      isChild: true,
      requireAuth: true,
      paymentWall: true,
      hasTransHeader: true
    }
  }, {
    path: '/recipes/mealplans',
    name: 'RecipeMealPlans',
    component: _MealPlans2.default,
    meta: {
      id: "recipe-meal-plans",
      title: "Recipes",
      i18n: "message.recipesAppBarText",
      isChild: true,
      requireAuth: true,
      paymentWall: true,
      hasTransHeader: false
    }
  }, {
    path: '/recipes/mealplans/:id',
    name: 'MealPlanDetail',
    component: _MealPlanDetail2.default,
    meta: {
      id: "recipe-meal-plans",
      title: "Recipes",
      i18n: "message.recipesAppBarText",
      isChild: true,
      requireAuth: true,
      paymentWall: true,
      hasTransHeader: false
    }
  }, {
    path: '/recipes/bygroup/',
    name: 'RecipeCategory',
    component: _Category4.default,
    meta: {
      id: 'recipe-dietary-types',
      title: 'Recipes',
      i18n: "message.recipesAppBarText",
      isChild: true,
      requireAuth: true,
      paymentWall: true,
      hasTransHeader: false
    }
  }, {
    path: '/recipes/favorites',
    name: 'RecipeFavorites',
    component: _Favorites2.default,
    meta: {
      id: 'recipes-search',
      title: "Recipes",
      i18n: "message.recipesFavoritesAppBarText",
      requireAuth: true,
      paymentWall: true,
      isChild: true
    }
  }, {
    path: '/recipes/search',
    name: 'RecipeSearch',
    component: _Search6.default,
    meta: {
      id: 'recipes-search',
      title: "Recipes",
      i18n: "message.recipesAdvancedSearchAppBarText",
      requireAuth: true,
      paymentWall: true,
      isChild: true
    }
  }, {
    path: '/recipes/generator/',
    name: 'RecipeMealPlanGenerator',
    component: _Index4.default,
    meta: {
      id: 'recipes-meal-plan-generator',
      title: "Recipes",
      i18n: "message.mealPlanGeneratorAppBarText",
      requireAuth: true,
      paymentWall: true,
      isChild: true,
      hasTransHeader: false
    }
  }, {
    path: '/recipes/results',
    name: 'RecipeSearchResults',
    component: _Results2.default,
    props: true,
    meta: {
      id: 'recipes-search',
      title: "Recipes",
      i18n: "message.recipesAdvancedSearchAppBarText",
      requireAuth: true,
      paymentWall: true,
      isChild: true
    }
  }, {
    path: '/recipes/:id',
    name: 'RecipeDetail',
    component: _Detail2.default,
    meta: {
      id: 'recipes-detail',
      title: "Recipes",
      i18n: "message.recipeAppBarText",
      hasCustomTitle: true,
      requireAuth: true,
      paymentWall: true,
      isChild: true
    }
  }, {
    path: '/oauth/callback',
    name: 'OauthCallback',
    component: _Callback2.default,
    meta: {
      id: 'oauth-callback',
      title: "callback",
      hasCustomTitle: false,
      requireAuth: false,
      paymentWall: false,
      isChild: false
    }
  }, {
    path: '/discount-page',
    name: 'Discount',
    component: _Discount2.default,
    meta: {
      id: "discount",
      title: "Discount",
      i18n: "Discount",
      hideLeftNav: true,
      isAuthView: true,
      requireAuth: false,
      hideRegisterAppBar: true,
      hideShadow: true
    }
  }],
  scrollBehavior: function scrollBehavior(to, from) {
    (0, _jquery2.default)("#" + to.meta.id).scrollTop(0);
  }
});

/***/ }),
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */
/***/ (function(module, exports) {

module.exports = [{"code":"AF","name":"AFGHANISTAN","currency":{"currencyName":"AFGHANISTAN AFGHANI","currencyCode":"AFN","currencySymbol":"؋"},"geo":{"latitude":33.93911,"longitude":67.709953},"capital":"KABUL","phone":"93"},{"code":"AL","name":"ALBANIA","currency":{"currencyName":"ALBANIAN LEK","currencyCode":"ALL","currencySymbol":"lekë"},"geo":{"latitude":41.153332,"longitude":20.168331},"capital":"TIRANA","phone":"355"},{"code":"DZ","name":"ALGERIA","currency":{"currencyName":"ALGERIAN DINAR","currencyCode":"DZD","currencySymbol":"د.ج"},"geo":{"latitude":28.033886,"longitude":1.659626},"capital":"ALGIERS","phone":"213"},{"code":"AS","name":"AMERICAN SAMOA","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":-14.270972,"longitude":-170.132217},"capital":"PAGO PAGO","phone":"684"},{"code":"AD","name":"ANDORRA","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":42.546245,"longitude":1.601554},"capital":"ANDORRA","phone":"376"},{"code":"AO","name":"ANGOLA","currency":{"currencyName":"ANGOLAN KWANZA","currencyCode":"AOA","currencySymbol":"Kz"},"geo":{"latitude":-11.202692,"longitude":17.873887},"capital":"LUANDA","phone":"244"},{"code":"AI","name":"ANGUILLA","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":18.220554,"longitude":-63.068615},"capital":"THE VALLEY","phone":"1-264"},{"code":"AQ","name":"ANTARCTICA","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":-75.250973,"longitude":-0.071389},"capital":"","phone":"672"},{"code":"AG","name":"ANTIGUA AND BARBUDA","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":17.060816,"longitude":-61.796428},"capital":"ST. JOHNS","phone":"1-268"},{"code":"AR","name":"ARGENTINA","currency":{"currencyName":"ARGENTINE PESO","currencyCode":"ARS","currencySymbol":"$"},"geo":{"latitude":-38.416097,"longitude":-63.616672},"capital":"BUENOS AIRES","phone":"54"},{"code":"AM","name":"ARMENIA","currency":{"currencyName":"ARMENIAN DRAM","currencyCode":"AMD","currencySymbol":"դր."},"geo":{"latitude":40.069099,"longitude":45.038189},"capital":"YEREVAN","phone":"374"},{"code":"AW","name":"ARUBA","currency":{"currencyName":"ARUBAN GUILDER","currencyCode":"AWG","currencySymbol":"ƒ"},"geo":{"latitude":12.52111,"longitude":-69.968338},"capital":"ORANJESTAD","phone":"297"},{"code":"AU","name":"AUSTRALIA","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-25.274398,"longitude":133.775136},"capital":"CANBERRA","phone":"61"},{"code":"AT","name":"AUSTRIA","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":47.516231,"longitude":14.550072},"capital":"VIENNA","phone":"43"},{"code":"AZ","name":"AZERBAIJAN","currency":{"currencyName":"AZERBAIJAN NEW MANAT","currencyCode":"AZN","currencySymbol":"₼"},"geo":{"latitude":40.143105,"longitude":47.576927},"capital":"BAKU","phone":"994"},{"code":"BS","name":"BAHAMAS","currency":{"currencyName":"BAHAMIAN DOLLAR","currencyCode":"BSD","currencySymbol":"$"},"geo":{"latitude":25.03428,"longitude":-77.39628},"capital":"NASSAU","phone":"1-242"},{"code":"BH","name":"BAHRAIN","currency":{"currencyName":"BAHRAINI DINAR","currencyCode":"BHD","currencySymbol":".د.ب"},"geo":{"latitude":25.930414,"longitude":50.637772},"capital":"AL-MANAMAH","phone":"973"},{"code":"BD","name":"BANGLADESH","currency":{"currencyName":"BANGLADESHI TAKA","currencyCode":"BDT","currencySymbol":"৳"},"geo":{"latitude":23.684994,"longitude":90.356331},"capital":"DHAKA","phone":"880"},{"code":"BB","name":"BARBADOS","currency":{"currencyName":"BARBADOS DOLLAR","currencyCode":"BBD","currencySymbol":"$"},"geo":{"latitude":13.193887,"longitude":-59.543198},"capital":"BRIDGETOWN","phone":"1-246"},{"code":"BY","name":"BELARUS","currency":{"currencyName":"BELARUSSIAN RUBLE","currencyCode":"BYR","currencySymbol":"p."},"geo":{"latitude":53.709807,"longitude":27.953389},"capital":"MINSK","phone":"375"},{"code":"BE","name":"BELGIUM","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":50.503887,"longitude":4.469936},"capital":"BRUSSELS","phone":"32"},{"code":"BZ","name":"BELIZE","currency":{"currencyName":"BELIZE DOLLAR","currencyCode":"BZD","currencySymbol":"BZ$"},"geo":{"latitude":17.189877,"longitude":-88.49765},"capital":"BELMOPAN","phone":"501"},{"code":"BJ","name":"BENIN","currency":{"currencyName":"CFA FRANC BCEAO","currencyCode":"XOF","currencySymbol":"Fr"},"geo":{"latitude":9.30769,"longitude":2.315834},"capital":"PORTO-NOVO","phone":"229"},{"code":"BM","name":"BERMUDA","currency":{"currencyName":"BERMUDIAN DOLLAR","currencyCode":"BMD","currencySymbol":"$"},"geo":{"latitude":32.321384,"longitude":-64.75737},"capital":"HAMILTON","phone":"1-441"},{"code":"BT","name":"BHUTAN","currency":{"currencyName":"BHUTAN NGULTRUM","currencyCode":"BTN","currencySymbol":"Nu."},"geo":{"latitude":27.514162,"longitude":90.433601},"capital":"THIMPHU","phone":"975"},{"code":"BO","name":"BOLIVIA","currency":{"currencyName":"BOLIVIANO","currencyCode":"BOB","currencySymbol":"Bs."},"geo":{"latitude":-16.290154,"longitude":-63.588653},"capital":"LA PAZ","phone":"591"},{"code":"BA","name":"BOSNIA-HERZEGOVINA","currency":{"currencyName":"MARKA","currencyCode":"BAM","currencySymbol":"KM"},"geo":{"latitude":43.915886,"longitude":17.679076},"capital":"SARAJEVO","phone":"387"},{"code":"BW","name":"BOTSWANA","currency":{"currencyName":"BOTSWANA PULA","currencyCode":"BWP","currencySymbol":"P"},"geo":{"latitude":-22.328474,"longitude":24.684866},"capital":"GABORONE","phone":"267"},{"code":"BV","name":"BOUVET ISLAND","currency":{"currencyName":"NORWEGIAN KRONE","currencyCode":"NOK","currencySymbol":"kr"},"geo":{"latitude":-54.423199,"longitude":3.413194},"capital":"","phone":"0047"},{"code":"BR","name":"BRAZIL","currency":{"currencyName":"BRAZILIAN REAL","currencyCode":"BRL","currencySymbol":"R$"},"geo":{"latitude":-14.235004,"longitude":-51.92528},"capital":"BRASILIA","phone":"55"},{"code":"IO","name":"BRITISH INDIAN OCEAN TERRITORY","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":-6.343194,"longitude":71.876519},"capital":"","phone":"00246"},{"code":"BN","name":"BRUNEI DARUSSALAM","currency":{"currencyName":"BRUNEI DOLLAR","currencyCode":"BND","currencySymbol":"$"},"geo":{"latitude":4.535277,"longitude":114.727669},"capital":"BANDAR SERI BEGAWAN","phone":"673"},{"code":"BG","name":"BULGARIA","currency":{"currencyName":"BULGARIAN LEV","currencyCode":"BGN","currencySymbol":"лв"},"geo":{"latitude":42.733883,"longitude":25.48583},"capital":"SOFIA","phone":"359"},{"code":"BF","name":"BURKINA FASO","currency":{"currencyName":"CFA FRANC BCEAO","currencyCode":"XOF","currencySymbol":"Fr"},"geo":{"latitude":12.238333,"longitude":-1.561593},"capital":"OUAGADOUGOU","phone":"226"},{"code":"BI","name":"BURUNDI","currency":{"currencyName":"BURUNDI FRANC","currencyCode":"BIF","currencySymbol":"Fr"},"geo":{"latitude":-3.373056,"longitude":29.918886},"capital":"BUJUMBURA","phone":"257"},{"code":"KH","name":"CAMBODIA","currency":{"currencyName":"KAMPUCHEAN RIEL","currencyCode":"KHR","currencySymbol":"៛"},"geo":{"latitude":12.565679,"longitude":104.990963},"capital":"PHNOM PENH","phone":"855"},{"code":"CM","name":"CAMEROON","currency":{"currencyName":"CFA FRANC BEAC","currencyCode":"XAF","currencySymbol":"Fr"},"geo":{"latitude":7.369722,"longitude":12.354722},"capital":"YAOUNDE","phone":"237"},{"code":"CA","name":"CANADA","currency":{"currencyName":"CANADIAN DOLLAR","currencyCode":"CAD","currencySymbol":"$"},"geo":{"latitude":56.130366,"longitude":-106.346771},"capital":"OTTAWA","phone":"1"},{"code":"CV","name":"CAPE VERDE","currency":{"currencyName":"CAPE VERDE ESCUDO","currencyCode":"CVE","currencySymbol":"$"},"geo":{"latitude":16.002082,"longitude":-24.013197},"capital":"PRAIA","phone":"238"},{"code":"KY","name":"CAYMAN ISLANDS","currency":{"currencyName":"CAYMAN ISLANDS DOLLAR","currencyCode":"KYD","currencySymbol":"$"},"geo":{"latitude":19.513469,"longitude":-80.566956},"capital":"GEORGETOWN","phone":"1-345"},{"code":"CF","name":"CENTRAL AFRICAN REPUBLIC","currency":{"currencyName":"CFA FRANC BEAC","currencyCode":"XAF","currencySymbol":"Fr"},"geo":{"latitude":6.611111,"longitude":20.939444},"capital":"BANGUI","phone":"236"},{"code":"TD","name":"CHAD","currency":{"currencyName":"CFA FRANC BEAC","currencyCode":"XAF","currencySymbol":"Fr"},"geo":{"latitude":15.454166,"longitude":18.732207},"capital":"N'DJAMENA","phone":"235"},{"code":"CL","name":"CHILE","currency":{"currencyName":"CHILEAN PESO","currencyCode":"CLP","currencySymbol":"$"},"geo":{"latitude":-35.675147,"longitude":-71.542969},"capital":"SANTIAGO","phone":"56"},{"code":"CN","name":"CHINA","currency":{"currencyName":"YUAN RENMINBI","currencyCode":"CNY","currencySymbol":"¥"},"geo":{"latitude":35.86166,"longitude":104.195397},"capital":"BEIJING","phone":"86"},{"code":"CX","name":"CHRISTMAS ISLAND","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-10.447525,"longitude":105.690449},"capital":"THE SETTLEMENT","phone":"61"},{"code":"CC","name":"COCOS (KEELING) ISLANDS","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-12.164165,"longitude":96.870956},"capital":"WEST ISLAND","phone":"61"},{"code":"CO","name":"COLOMBIA","currency":{"currencyName":"COLOMBIAN PESO","currencyCode":"COP","currencySymbol":"$"},"geo":{"latitude":4.570868,"longitude":-74.297333},"capital":"BOGOTA","phone":"57"},{"code":"KM","name":"COMOROS","currency":{"currencyName":"COMOROS FRANC","currencyCode":"KMF","currencySymbol":"Fr"},"geo":{"latitude":-11.875001,"longitude":43.872219},"capital":"MORONI","phone":"269"},{"code":"CG","name":"CONGO","currency":{"currencyName":"CFA FRANC BEAC","currencyCode":"XAF","currencySymbol":"Fr"},"geo":{"latitude":-0.228021,"longitude":15.827659},"capital":"BRAZZAVILLE","phone":"242"},{"code":"CD","name":"CONGO, DEM. REPUBLIC","currency":{"currencyName":"FRANCS","currencyCode":"CDF","currencySymbol":"Fr"},"geo":{"latitude":-4.038333,"longitude":21.758664},"capital":"KINSHASA","phone":"243"},{"code":"CK","name":"COOK ISLANDS","currency":{"currencyName":"NEW ZEALAND DOLLAR","currencyCode":"NZD","currencySymbol":"$"},"geo":{"latitude":-21.236736,"longitude":-159.777671},"capital":"AVARUA","phone":"682"},{"code":"CR","name":"COSTA RICA","currency":{"currencyName":"COSTA RICAN COLON","currencyCode":"CRC","currencySymbol":"₡"},"geo":{"latitude":9.748917,"longitude":-83.753428},"capital":"SAN JOSE","phone":"506"},{"code":"HR","name":"CROATIA","currency":{"currencyName":"CROATIAN KUNA","currencyCode":"HRK","currencySymbol":"kn"},"geo":{"latitude":45.1,"longitude":15.2},"capital":"ZAGREB","phone":"385"},{"code":"CU","name":"CUBA","currency":{"currencyName":"CUBAN PESO","currencyCode":"CUP","currencySymbol":"₱"},"geo":{"latitude":21.521757,"longitude":-77.781167},"capital":"HAVANA","phone":"53"},{"code":"CY","name":"CYPRUS","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":35.126413,"longitude":33.429859},"capital":"NICOSIA","phone":"357"},{"code":"CZ","name":"CZECH REP.","currency":{"currencyName":"CZECH KORUNA","currencyCode":"CZK","currencySymbol":"Kč"},"geo":{"latitude":49.817492,"longitude":15.472962},"capital":"PRAGUE","phone":"420"},{"code":"DK","name":"DENMARK","currency":{"currencyName":"DANISH KRONE","currencyCode":"DKK","currencySymbol":"kr"},"geo":{"latitude":56.26392,"longitude":9.501785},"capital":"COPENHAGEN","phone":"45"},{"code":"DJ","name":"DJIBOUTI","currency":{"currencyName":"DJIBOUTI FRANC","currencyCode":"DJF","currencySymbol":"Fr"},"geo":{"latitude":11.825138,"longitude":42.590275},"capital":"DJIBOUTI","phone":"253"},{"code":"DM","name":"DOMINICA","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":15.414999,"longitude":-61.370976},"capital":"ROSEAU","phone":"1-767"},{"code":"DO","name":"DOMINICAN REPUBLIC","currency":{"currencyName":"DOMINICAN PESO","currencyCode":"DOP","currencySymbol":"RD$"},"geo":{"latitude":18.735693,"longitude":-70.162651},"capital":"SANTO DOMINGO","phone":"809"},{"code":"EC","name":"ECUADOR","currency":{"currencyName":"ECUADOR SUCRE","currencyCode":"ECS","currencySymbol":"S/."},"geo":{"latitude":-1.831239,"longitude":-78.183406},"capital":"QUITO","phone":"593"},{"code":"EG","name":"EGYPT","currency":{"currencyName":"EGYPTIAN POUND","currencyCode":"EGP","currencySymbol":"£"},"geo":{"latitude":26.820553,"longitude":30.802498},"capital":"CAIRO","phone":"20"},{"code":"SV","name":"EL SALVADOR","currency":{"currencyName":"EL SALVADOR COLON","currencyCode":"SVC","currencySymbol":"$"},"geo":{"latitude":13.794185,"longitude":-88.89653},"capital":"SAN SALVADOR","phone":"503"},{"code":"GQ","name":"EQUATORIAL GUINEA","currency":{"currencyName":"CFA FRANC BEAC","currencyCode":"XAF","currencySymbol":"Fr"},"geo":{"latitude":1.650801,"longitude":10.267895},"capital":"MALABO","phone":"240"},{"code":"ER","name":"ERITREA","currency":{"currencyName":"ERITREAN NAKFA","currencyCode":"ERN","currencySymbol":"Nfk"},"geo":{"latitude":15.179384,"longitude":39.782334},"capital":"ASMARA","phone":"291"},{"code":"EE","name":"ESTONIA","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":58.595272,"longitude":25.013607},"capital":"TALLINN","phone":"372"},{"code":"ET","name":"ETHIOPIA","currency":{"currencyName":"ETHIOPIAN BIRR","currencyCode":"ETB","currencySymbol":"Br"},"geo":{"latitude":9.145,"longitude":40.489673},"capital":"ADDIS ABABA","phone":"251"},{"code":"EU.INT","name":"EUROPEAN UNION","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":9.0485,"longitude":7.4728},"capital":"BRUSSELS","phone":"0032"},{"code":"FK","name":"FALKLAND ISLANDS (MALVINAS)","currency":{"currencyName":"FALKLAND ISLANDS POUND","currencyCode":"FKP","currencySymbol":"£"},"geo":{"latitude":-51.796253,"longitude":-59.523613},"capital":"STANLEY","phone":"500"},{"code":"FO","name":"FAROE ISLANDS","currency":{"currencyName":"DANISH KRONE","currencyCode":"DKK","currencySymbol":"kr"},"geo":{"latitude":61.892635,"longitude":-6.911806},"capital":"TORSHAVN","phone":"298"},{"code":"FJ","name":"FIJI","currency":{"currencyName":"FIJI DOLLAR","currencyCode":"FJD","currencySymbol":"$"},"geo":{"latitude":-16.578193,"longitude":179.414413},"capital":"SUVA","phone":"679"},{"code":"FI","name":"FINLAND","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":61.92411,"longitude":25.748151},"capital":"HELSINKI","phone":"358"},{"code":"Fr","name":"FRANCE","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":46.227638,"longitude":2.213749},"capital":"PARIS","phone":"33"},{"code":"GF","name":"FRENCH GUIANA","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":3.933889,"longitude":-53.125782},"capital":"CAYENNE","phone":"594"},{"code":"TF","name":"FRENCH SOUTHERN TERRITORIES","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":-49.280366,"longitude":69.348557},"capital":"","phone":"00262"},{"code":"GA","name":"GABON","currency":{"currencyName":"CFA FRANC BEAC","currencyCode":"XAF","currencySymbol":"Fr"},"geo":{"latitude":-0.803689,"longitude":11.609444},"capital":"LIBREVILLE","phone":"241"},{"code":"GM","name":"GAMBIA","currency":{"currencyName":"GAMBIAN DALASI","currencyCode":"GMD","currencySymbol":"D"},"geo":{"latitude":13.443182,"longitude":-15.310139},"capital":"BANJUL","phone":"220"},{"code":"GE","name":"GEORGIA","currency":{"currencyName":"GEORGIAN LARI","currencyCode":"GEL","currencySymbol":"ლ"},"geo":{"latitude":42.315407,"longitude":43.356892},"capital":"TBILISI","phone":"995"},{"code":"DE","name":"GERMANY","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":51.165691,"longitude":10.451526},"capital":"BERLIN","phone":"49"},{"code":"GH","name":"GHANA","currency":{"currencyName":"GHANAIAN CEDI","currencyCode":"GHS","currencySymbol":"₵"},"geo":{"latitude":7.946527,"longitude":-1.023194},"capital":"ACCRA","phone":"233"},{"code":"GI","name":"GIBRALTAR","currency":{"currencyName":"GIBRALTAR POUND","currencyCode":"GIP","currencySymbol":"£"},"geo":{"latitude":36.137741,"longitude":-5.345374},"capital":"GIBRALTAR","phone":"350"},{"code":"GB","name":"GREAT BRITAIN","currency":{"currencyName":"POUND STERLING","currencyCode":"GBP","currencySymbol":"£"},"geo":{"latitude":55.378051,"longitude":-3.435973},"capital":"LONDON","phone":"44"},{"code":"GR","name":"GREECE","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":39.074208,"longitude":21.824312},"capital":"ATHENS","phone":"30"},{"code":"GL","name":"GREENLAND","currency":{"currencyName":"DANISH KRONE","currencyCode":"DKK","currencySymbol":"kr"},"geo":{"latitude":71.706936,"longitude":-42.604303},"capital":"GODTHAB","phone":"299"},{"code":"GD","name":"GRENADA","currency":{"currencyName":"EAST CARRIBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":12.262776,"longitude":-61.604171},"capital":"ST. GEORGE'S","phone":"1-473"},{"code":"GP","name":"GUADELOUPE (FRENCH)","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":16.995971,"longitude":-62.067641},"capital":"BASSE-TERRE","phone":"590"},{"code":"GU","name":"GUAM (USA)","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":13.444304,"longitude":144.793731},"capital":"AGANA","phone":"1-671"},{"code":"GT","name":"GUATEMALA","currency":{"currencyName":"GUATEMALAN QUETZAL","currencyCode":"QTQ","currencySymbol":"Q"},"geo":{"latitude":15.783471,"longitude":-90.230759},"capital":"GUATEMALA CITY","phone":"502"},{"code":"GG","name":"GUERNSEY","currency":{"currencyName":"POUND STERLING","currencyCode":"GGP","currencySymbol":"£"},"geo":{"latitude":49.465691,"longitude":-2.585278},"capital":"ST. PETER PORT","phone":"0044"},{"code":"GN","name":"GUINEA","currency":{"currencyName":"GUINEA FRANC","currencyCode":"GNF","currencySymbol":"Fr"},"geo":{"latitude":9.945587,"longitude":-9.696645},"capital":"CONAKRY","phone":"224"},{"code":"GW","name":"GUINEA BISSAU","currency":{"currencyName":"GUINEA-BISSAU PESO","currencyCode":"GWP","currencySymbol":"pesos"},"geo":{"latitude":11.803749,"longitude":-15.180413},"capital":"BISSAU","phone":"245"},{"code":"GY","name":"GUYANA","currency":{"currencyName":"GUYANA DOLLAR","currencyCode":"GYD","currencySymbol":"$"},"geo":{"latitude":4.860416,"longitude":-58.93018},"capital":"GEORGETOWN","phone":"592"},{"code":"HT","name":"HAITI","currency":{"currencyName":"HAITIAN GOURDE","currencyCode":"HTG","currencySymbol":"G"},"geo":{"latitude":18.971187,"longitude":-72.285215},"capital":"PORT-AU-PRINCE","phone":"509"},{"code":"HM","name":"HEARD ISLAND AND MCDONALD ISLANDS","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-53.08181,"longitude":73.504158},"capital":"","phone":"00672"},{"code":"HN","name":"HONDURAS","currency":{"currencyName":"HONDURAN LEMPIRA","currencyCode":"HNL","currencySymbol":"L"},"geo":{"latitude":15.199999,"longitude":-86.241905},"capital":"TEGUCIGALPA","phone":"504"},{"code":"HK","name":"HONG KONG","currency":{"currencyName":"HONG KONG DOLLAR","currencyCode":"HKD","currencySymbol":"$"},"geo":{"latitude":22.396428,"longitude":114.109497},"capital":"VICTORIA","phone":"852"},{"code":"HU","name":"HUNGARY","currency":{"currencyName":"HUNGARIAN FORINT","currencyCode":"HUF","currencySymbol":"Ft"},"geo":{"latitude":47.162494,"longitude":19.503304},"capital":"BUDAPEST","phone":"36"},{"code":"IS","name":"ICELAND","currency":{"currencyName":"ICELAND KRONA","currencyCode":"ISK","currencySymbol":"kr"},"geo":{"latitude":64.963051,"longitude":-19.020835},"capital":"REYKJAVIK","phone":"354"},{"code":"IN","name":"INDIA","currency":{"currencyName":"INDIAN RUPEE","currencyCode":"INR","currencySymbol":"₹"},"geo":{"latitude":20.593684,"longitude":78.96288},"capital":"NEW DELHI","phone":"91"},{"code":"ID","name":"INDONESIA","currency":{"currencyName":"INDONESIAN RUPIAH","currencyCode":"IDR","currencySymbol":"Rp"},"geo":{"latitude":-0.789275,"longitude":113.921327},"capital":"JAKARTA","phone":"62"},{"code":"IR","name":"IRAN","currency":{"currencyName":"IRANIAN RIAL","currencyCode":"IRR","currencySymbol":"﷼"},"geo":{"latitude":32.427908,"longitude":53.688046},"capital":"TEHRAN","phone":"98"},{"code":"IQ","name":"IRAQ","currency":{"currencyName":"IRAQI DINAR","currencyCode":"IQD","currencySymbol":"ع.د"},"geo":{"latitude":33.223191,"longitude":43.679291},"capital":"BAGHDAD","phone":"964"},{"code":"IE","name":"IRELAND","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":53.41291,"longitude":-8.24389},"capital":"DUBLIN","phone":"353"},{"code":"IM","name":"ISLE OF MAN","currency":{"currencyName":"POUND STERLING","currencyCode":"GBP","currencySymbol":"£"},"geo":{"latitude":54.236107,"longitude":-4.548056},"capital":"DOUGLAS","phone":"0044"},{"code":"IL","name":"ISRAEL","currency":{"currencyName":"ISRAELI NEW SHEKEL","currencyCode":"ILS","currencySymbol":"₪"},"geo":{"latitude":31.046051,"longitude":34.851612},"capital":"JERUSALEM","phone":"972"},{"code":"IT","name":"ITALY","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":41.87194,"longitude":12.56738},"capital":"ROME","phone":"39"},{"code":"CI","name":"IVORY COAST","currency":{"currencyName":"CFA FRANC BCEAO","currencyCode":"XOF","currencySymbol":"Fr"},"geo":{"latitude":7.539989,"longitude":-5.54708},"capital":"ABIDJAN","phone":"225"},{"code":"JM","name":"JAMAICA","currency":{"currencyName":"JAMAICAN DOLLAR","currencyCode":"JMD","currencySymbol":"J$"},"geo":{"latitude":18.109581,"longitude":-77.297508},"capital":"KINGSTON","phone":"1-876"},{"code":"JP","name":"JAPAN","currency":{"currencyName":"JAPANESE YEN","currencyCode":"JPY","currencySymbol":"¥"},"geo":{"latitude":36.204824,"longitude":138.252924},"capital":"TOKYO","phone":"81"},{"code":"JE","name":"JERSEY","currency":{"currencyName":"POUND STERLING","currencyCode":"GBP","currencySymbol":"£"},"geo":{"latitude":49.214439,"longitude":-2.13125},"capital":"SAINT HELIER","phone":"0044"},{"code":"JO","name":"JORDAN","currency":{"currencyName":"JORDANIAN DINAR","currencyCode":"JOD","currencySymbol":"د.ا"},"geo":{"latitude":30.585164,"longitude":36.238414},"capital":"AMMAN","phone":"962"},{"code":"KZ","name":"KAZAKHSTAN","currency":{"currencyName":"KAZAKHSTAN TENGE","currencyCode":"KZT","currencySymbol":"лв"},"geo":{"latitude":48.019573,"longitude":66.923684},"capital":"ASTANA","phone":"7"},{"code":"KE","name":"KENYA","currency":{"currencyName":"KENYAN SHILLING","currencyCode":"KES","currencySymbol":"KSh"},"geo":{"latitude":-0.023559,"longitude":37.906193},"capital":"NAIROBI","phone":"254"},{"code":"KI","name":"KIRIBATI","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-3.370417,"longitude":-168.734039},"capital":"TARAWA","phone":"686"},{"code":"KP","name":"KOREA-NORTH","currency":{"currencyName":"NORTH KOREAN WON","currencyCode":"KPW","currencySymbol":"₩"},"geo":{"latitude":40.339852,"longitude":127.510093},"capital":"PYONGYANG","phone":"850"},{"code":"KR","name":"KOREA-SOUTH","currency":{"currencyName":"KOREAN WON","currencyCode":"KRW","currencySymbol":"₩"},"geo":{"latitude":35.907757,"longitude":127.766922},"capital":"SEOUL","phone":"82"},{"code":"KW","name":"KUWAIT","currency":{"currencyName":"KUWAITI DINAR","currencyCode":"KWD","currencySymbol":"د.ك"},"geo":{"latitude":29.31166,"longitude":47.481766},"capital":"KUWAIT CITY","phone":"965"},{"code":"KG","name":"KYRGYZSTAN","currency":{"currencyName":"SOM","currencyCode":"KGS","currencySymbol":"лв"},"geo":{"latitude":41.20438,"longitude":74.766098},"capital":"BISHKEK","phone":"996"},{"code":"LA","name":"LAOS","currency":{"currencyName":"LAO KIP","currencyCode":"LAK","currencySymbol":"₭"},"geo":{"latitude":19.85627,"longitude":102.495496},"capital":"VIENTIANE","phone":"856"},{"code":"LV","name":"LATVIA","currency":{"currencyName":"LATVIAN LATS","currencyCode":"LVL","currencySymbol":"Ls"},"geo":{"latitude":56.879635,"longitude":24.603189},"capital":"RIGA","phone":"371"},{"code":"LB","name":"LEBANON","currency":{"currencyName":"LEBANESE POUND","currencyCode":"LBP","currencySymbol":"£"},"geo":{"latitude":33.854721,"longitude":35.862285},"capital":"BEIRUT","phone":"961"},{"code":"LS","name":"LESOTHO","currency":{"currencyName":"LESOTHO LOTI","currencyCode":"LSL","currencySymbol":"L"},"geo":{"latitude":-29.609988,"longitude":28.233608},"capital":"MASERU","phone":"266"},{"code":"LR","name":"LIBERIA","currency":{"currencyName":"LIBERIAN DOLLAR","currencyCode":"LRD","currencySymbol":"$"},"geo":{"latitude":6.428055,"longitude":-9.429499},"capital":"MONROVIA","phone":"231"},{"code":"LY","name":"LIBYA","currency":{"currencyName":"LIBYAN DINAR","currencyCode":"LYD","currencySymbol":"ل.د"},"geo":{"latitude":26.3351,"longitude":17.228331},"capital":"TRIPOLI","phone":"218"},{"code":"LI","name":"LIECHTENSTEIN","currency":{"currencyName":"SWISS FRANC","currencyCode":"CHF","currencySymbol":"CHF"},"geo":{"latitude":47.166,"longitude":9.555373},"capital":"VADUZ","phone":"423"},{"code":"LT","name":"LITHUANIA","currency":{"currencyName":"LITHUANIAN LITAS","currencyCode":"LTL","currencySymbol":"Lt"},"geo":{"latitude":55.169438,"longitude":23.881275},"capital":"VILNIUS","phone":"370"},{"code":"LU","name":"LUXEMBOURG","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":49.815273,"longitude":6.129583},"capital":"LUXEMBOURG","phone":"352"},{"code":"MO","name":"MACAU","currency":{"currencyName":"MACAU PATACA","currencyCode":"MOP","currencySymbol":"P"},"geo":{"latitude":22.198745,"longitude":113.543873},"capital":"MACAU","phone":"853"},{"code":"MK","name":"MACEDONIA","currency":{"currencyName":"DENAR","currencyCode":"MKD","currencySymbol":"ден"},"geo":{"latitude":41.608635,"longitude":21.745275},"capital":"SKOPJE","phone":"389"},{"code":"MG","name":"MADAGASCAR","currency":{"currencyName":"MALAGASY FRANC","currencyCode":"MGF","currencySymbol":"Ar"},"geo":{"latitude":-18.766947,"longitude":46.869107},"capital":"ANTANANARIVO","phone":"261"},{"code":"MW","name":"MALAWI","currency":{"currencyName":"MALAWI KWACHA","currencyCode":"MWK","currencySymbol":"MK"},"geo":{"latitude":-13.254308,"longitude":34.301525},"capital":"LILONGWE","phone":"265"},{"code":"MY","name":"MALAYSIA","currency":{"currencyName":"MALAYSIAN RINGGIT","currencyCode":"MYR","currencySymbol":"RM"},"geo":{"latitude":4.210484,"longitude":101.975766},"capital":"KUALA LUMPUR","phone":"60"},{"code":"MV","name":"MALDIVES","currency":{"currencyName":"MALDIVE RUFIYAA","currencyCode":"MVR","currencySymbol":"Rf."},"geo":{"latitude":3.202778,"longitude":73.22068},"capital":"MALE","phone":"960"},{"code":"ML","name":"MALI","currency":{"currencyName":"CFA FRANC BCEAO","currencyCode":"XOF","currencySymbol":"Fr"},"geo":{"latitude":17.570692,"longitude":-3.996166},"capital":"BAMAKO","phone":"223"},{"code":"MT","name":"MALTA","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":35.937496,"longitude":14.375416},"capital":"VALLETTA","phone":"356"},{"code":"MH","name":"MARSHALL ISLANDS","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":7.131474,"longitude":171.184478},"capital":"MAJURO","phone":"692"},{"code":"MQ","name":"MARTINIQUE (FRENCH)","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":14.641528,"longitude":-61.024174},"capital":"FORT-DE-FRANCE","phone":"596"},{"code":"MR","name":"MAURITANIA","currency":{"currencyName":"MAURITANIAN OUGUIYA","currencyCode":"MRO","currencySymbol":"UM"},"geo":{"latitude":21.00789,"longitude":-10.940835},"capital":"NOUAKCHOTT","phone":"222"},{"code":"MU","name":"MAURITIUS","currency":{"currencyName":"MAURITIUS RUPEE","currencyCode":"MUR","currencySymbol":"₨"},"geo":{"latitude":-20.348404,"longitude":57.552152},"capital":"PORT LOUIS","phone":"230"},{"code":"YT","name":"MAYOTTE","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":-12.8275,"longitude":45.166244},"capital":"DZAOUDZI","phone":"269"},{"code":"MX","name":"MEXICO","currency":{"currencyName":"MEXICAN NUEVO PESO","currencyCode":"MXN","currencySymbol":"$"},"geo":{"latitude":23.634501,"longitude":-102.552784},"capital":"MEXICO CITY","phone":"52"},{"code":"FM","name":"MICRONESIA","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":7.425554,"longitude":150.550812},"capital":"PALIKIR","phone":"691"},{"code":"MD","name":"MOLDOVA","currency":{"currencyName":"MOLDOVAN LEU","currencyCode":"MDL","currencySymbol":"L"},"geo":{"latitude":47.411631,"longitude":28.369885},"capital":"KISHINEV","phone":"373"},{"code":"MC","name":"MONACO","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":43.750298,"longitude":7.412841},"capital":"MONACO","phone":"377"},{"code":"MN","name":"MONGOLIA","currency":{"currencyName":"MONGOLIAN TUGRIK","currencyCode":"MNT","currencySymbol":"₮"},"geo":{"latitude":46.862496,"longitude":103.846656},"capital":"ULAN BATOR","phone":"976"},{"code":"ME","name":"MONTENEGRO","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":42.708678,"longitude":19.37439},"capital":"PODGORICA","phone":"382"},{"code":"MS","name":"MONTSERRAT","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":16.742498,"longitude":-62.187366},"capital":"PLYMOUTH","phone":"1-664"},{"code":"MA","name":"MOROCCO","currency":{"currencyName":"MOROCCAN DIRHAM","currencyCode":"MAD","currencySymbol":"د.م."},"geo":{"latitude":31.791702,"longitude":-7.09262},"capital":"RABAT","phone":"212"},{"code":"MZ","name":"MOZAMBIQUE","currency":{"currencyName":"MOZAMBIQUE METICAL","currencyCode":"MZN","currencySymbol":"MT"},"geo":{"latitude":-18.665695,"longitude":35.529562},"capital":"MAPUTO","phone":"258"},{"code":"MM","name":"MYANMAR","currency":{"currencyName":"MYANMAR KYAT","currencyCode":"MMK","currencySymbol":"K"},"geo":{"latitude":21.913965,"longitude":95.956223},"capital":"NAYPYIDAW","phone":"95"},{"code":"NA","name":"NAMIBIA","currency":{"currencyName":"NAMIBIAN DOLLAR","currencyCode":"NAD","currencySymbol":"$"},"geo":{"latitude":-22.95764,"longitude":18.49041},"capital":"WINDHOEK","phone":"264"},{"code":"NR","name":"NAURU","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-0.522778,"longitude":166.931503},"capital":"YAREN","phone":"674"},{"code":"NP","name":"NEPAL","currency":{"currencyName":"NEPALESE RUPEE","currencyCode":"NPR","currencySymbol":"₨"},"geo":{"latitude":28.394857,"longitude":84.124008},"capital":"KATHMANDU","phone":"977"},{"code":"NL","name":"NETHERLANDS","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":52.132633,"longitude":5.291266},"capital":"AMSTERDAM","phone":"31"},{"code":"AN","name":"NETHERLANDS ANTILLES","currency":{"currencyName":"NETHERLANDS ANTILLEAN GUILDER","currencyCode":"ANG","currencySymbol":"ƒ"},"geo":{"latitude":12.226079,"longitude":-69.060087},"capital":"WILLEMSTAD","phone":"599"},{"code":"NC","name":"NEW CALEDONIA (FRENCH)","currency":{"currencyName":"CFP FRANC","currencyCode":"XPF","currencySymbol":"Fr"},"geo":{"latitude":-20.904305,"longitude":165.618042},"capital":"NOUMEA","phone":"687"},{"code":"NZ","name":"NEW ZEALAND","currency":{"currencyName":"NEW ZEALAND DOLLAR","currencyCode":"NZD","currencySymbol":"$"},"geo":{"latitude":-40.900557,"longitude":174.885971},"capital":"WELLINGTON","phone":"64"},{"code":"NI","name":"NICARAGUA","currency":{"currencyName":"NICARAGUAN CORDOBA ORO","currencyCode":"NIO","currencySymbol":"C$"},"geo":{"latitude":12.865416,"longitude":-85.207229},"capital":"MANAGUA","phone":"505"},{"code":"NE","name":"NIGER","currency":{"currencyName":"CFA FRANC BCEAO","currencyCode":"XOF","currencySymbol":"Fr"},"geo":{"latitude":17.607789,"longitude":8.081666},"capital":"NIAMEY","phone":"227"},{"code":"NG","name":"NIGERIA","currency":{"currencyName":"NIGERIAN NAIRA","currencyCode":"NGN","currencySymbol":"₦"},"geo":{"latitude":9.081999,"longitude":8.675277},"capital":"LAGOS","phone":"234"},{"code":"NU","name":"NIUE","currency":{"currencyName":"NEW ZEALAND DOLLAR","currencyCode":"NZD","currencySymbol":"$"},"geo":{"latitude":-19.054445,"longitude":-169.867233},"capital":"ALOFI","phone":"683"},{"code":"NF","name":"NORFOLK ISLAND","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-29.040835,"longitude":167.954712},"capital":"KINGSTON","phone":"672"},{"code":"MP","name":"NORTHERN MARIANA ISLANDS","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":17.33083,"longitude":145.38469},"capital":"SAIPAN","phone":"670"},{"code":"NO","name":"NORWAY","currency":{"currencyName":"NORWEGIAN KRONE","currencyCode":"NOK","currencySymbol":"kr"},"geo":{"latitude":60.472024,"longitude":8.468946},"capital":"OSLO","phone":"47"},{"code":"OM","name":"OMAN","currency":{"currencyName":"OMANI RIAL","currencyCode":"OMR","currencySymbol":"﷼"},"geo":{"latitude":21.512583,"longitude":55.923255},"capital":"MUSCAT","phone":"968"},{"code":"PK","name":"PAKISTAN","currency":{"currencyName":"PAKISTAN RUPEE","currencyCode":"PKR","currencySymbol":"₨"},"geo":{"latitude":30.375321,"longitude":69.345116},"capital":"ISLAMABAD","phone":"92"},{"code":"PW","name":"PALAU","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":7.51498,"longitude":134.58252},"capital":"KOROR","phone":"680"},{"code":"PA","name":"PANAMA","currency":{"currencyName":"PANAMANIAN BALBOA","currencyCode":"PAB","currencySymbol":"B/."},"geo":{"latitude":8.537981,"longitude":-80.782127},"capital":"PANAMA CITY","phone":"507"},{"code":"PG","name":"PAPUA NEW GUINEA","currency":{"currencyName":"PAPUA NEW GUINEA KINA","currencyCode":"PGK","currencySymbol":"K"},"geo":{"latitude":-6.314993,"longitude":143.95555},"capital":"PORT MORESBY","phone":"675"},{"code":"PY","name":"PARAGUAY","currency":{"currencyName":"PARAGUAY GUARANI","currencyCode":"PYG","currencySymbol":"Gs"},"geo":{"latitude":-23.442503,"longitude":-58.443832},"capital":"ASUNCION","phone":"595"},{"code":"PE","name":"PERU","currency":{"currencyName":"PERUVIAN NUEVO SOL","currencyCode":"PEN","currencySymbol":"S/."},"geo":{"latitude":-9.189967,"longitude":-75.015152},"capital":"LIMA","phone":"51"},{"code":"PH","name":"PHILIPPINES","currency":{"currencyName":"PHILIPPINE PESO","currencyCode":"PHP","currencySymbol":"₱"},"geo":{"latitude":12.879721,"longitude":121.774017},"capital":"MANILA","phone":"63"},{"code":"PN","name":"PITCAIRN ISLAND","currency":{"currencyName":"NEW ZEALAND DOLLAR","currencyCode":"NZD","currencySymbol":"$"},"geo":{"latitude":-24.703615,"longitude":-127.439308},"capital":"ADAMSTOWN","phone":"0064"},{"code":"PL","name":"POLAND","currency":{"currencyName":"POLISH ZLOTY","currencyCode":"PLN","currencySymbol":"zł"},"geo":{"latitude":51.919438,"longitude":19.145136},"capital":"WARSAW","phone":"48"},{"code":"PF","name":"POLYNESIA (FRENCH)","currency":{"currencyName":"CFP FRANC","currencyCode":"XPF","currencySymbol":"Fr"},"geo":{"latitude":-17.679742,"longitude":-149.406843},"capital":"PAPEETE","phone":"689"},{"code":"PT","name":"PORTUGAL","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":39.399872,"longitude":-8.224454},"capital":"LISBON","phone":"351"},{"code":"PR","name":"PUERTO RICO","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":18.220833,"longitude":-66.590149},"capital":"SAN JUAN","phone":"1-787"},{"code":"QA","name":"QATAR","currency":{"currencyName":"QATARI RIAL","currencyCode":"QAR","currencySymbol":"﷼"},"geo":{"latitude":25.354826,"longitude":51.183884},"capital":"DOHA","phone":"974"},{"code":"RE","name":"REUNION (FRENCH)","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":-21.115141,"longitude":55.536384},"capital":"SAINT-DENIS","phone":"262"},{"code":"RO","name":"ROMANIA","currency":{"currencyName":"ROMANIAN NEW LEU","currencyCode":"RON","currencySymbol":"lei"},"geo":{"latitude":45.943161,"longitude":24.96676},"capital":"BUCHAREST","phone":"40"},{"code":"RU","name":"RUSSIA","currency":{"currencyName":"RUSSIAN RUBLE","currencyCode":"RUB","currencySymbol":"₽"},"geo":{"latitude":61.52401,"longitude":105.318756},"capital":"MOSCOW","phone":"7"},{"code":"RW","name":"RWANDA","currency":{"currencyName":"RWANDA FRANC","currencyCode":"RWF","currencySymbol":"Fr"},"geo":{"latitude":-1.940278,"longitude":29.873888},"capital":"KIGALI","phone":"250"},{"code":"SH","name":"SAINT HELENA","currency":{"currencyName":"ST. HELENA POUND","currencyCode":"SHP","currencySymbol":"£"},"geo":{"latitude":-24.143474,"longitude":-10.030696},"capital":"JAMESTOWN","phone":"290"},{"code":"KN","name":"SAINT KITTS & NEVIS ANGUILLA","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":17.357822,"longitude":-62.782998},"capital":"BASSETERRE","phone":"1-869"},{"code":"LC","name":"SAINT LUCIA","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":13.909444,"longitude":-60.978893},"capital":"CASTRIES","phone":"1-758"},{"code":"PM","name":"SAINT PIERRE AND MIQUELON","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":46.941936,"longitude":-56.27111},"capital":"ST. PIERRE","phone":"508"},{"code":"VC","name":"SAINT VINCENT & GRENADINES","currency":{"currencyName":"EAST CARIBBEAN DOLLAR","currencyCode":"XCD","currencySymbol":"$"},"geo":{"latitude":12.984305,"longitude":-61.287228},"capital":"KINGSTOWN","phone":"1-784"},{"code":"WS","name":"SAMOA","currency":{"currencyName":"SAMOAN TALA","currencyCode":"WST","currencySymbol":"T"},"geo":{"latitude":-13.759029,"longitude":-172.104629},"capital":"APIA","phone":"684"},{"code":"SM","name":"SAN MARINO","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":43.94236,"longitude":12.457777},"capital":"SAN MARINO","phone":"378"},{"code":"ST","name":"SAO TOME AND PRINCIPE","currency":{"currencyName":"DOBRA","currencyCode":"STD","currencySymbol":"Db"},"geo":{"latitude":0.18636,"longitude":6.613081},"capital":"SAO TOME","phone":"239"},{"code":"SA","name":"SAUDI ARABIA","currency":{"currencyName":"SAUDI RIYAL","currencyCode":"SAR","currencySymbol":"﷼"},"geo":{"latitude":23.885942,"longitude":45.079162},"capital":"RIYADH","phone":"966"},{"code":"SN","name":"SENEGAL","currency":{"currencyName":"CFA FRANC BCEAO","currencyCode":"XOF","currencySymbol":"Fr"},"geo":{"latitude":14.497401,"longitude":-14.452362},"capital":"DAKAR","phone":"221"},{"code":"RS","name":"SERBIA","currency":{"currencyName":"DINAR","currencyCode":"RSD","currencySymbol":"Дин."},"geo":{"latitude":44.016521,"longitude":21.005859},"capital":"BELGRADE","phone":"381"},{"code":"SC","name":"SEYCHELLES","currency":{"currencyName":"SEYCHELLES RUPEE","currencyCode":"SCR","currencySymbol":"₨"},"geo":{"latitude":-4.679574,"longitude":55.491977},"capital":"VICTORIA","phone":"248"},{"code":"SL","name":"SIERRA LEONE","currency":{"currencyName":"SIERRA LEONE LEONE","currencyCode":"SLL","currencySymbol":"Le"},"geo":{"latitude":8.460555,"longitude":-11.779889},"capital":"FREETOWN","phone":"232"},{"code":"SG","name":"SINGAPORE","currency":{"currencyName":"SINGAPORE DOLLAR","currencyCode":"SGD","currencySymbol":"S$"},"geo":{"latitude":1.352083,"longitude":103.819836},"capital":"SINGAPORE","phone":"65"},{"code":"SK","name":"SLOVAKIA","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":48.669026,"longitude":19.699024},"capital":"BRATISLAVA","phone":"421"},{"code":"SI","name":"SLOVENIA","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":46.151241,"longitude":14.995463},"capital":"LJUBLJANA","phone":"386"},{"code":"SB","name":"SOLOMON ISLANDS","currency":{"currencyName":"SOLOMON ISLANDS DOLLAR","currencyCode":"SBD","currencySymbol":"$"},"geo":{"latitude":-9.64571,"longitude":160.156194},"capital":"HONIARA","phone":"677"},{"code":"SO","name":"SOMALIA","currency":{"currencyName":"SOMALI SHILLING","currencyCode":"SOS","currencySymbol":"S"},"geo":{"latitude":5.152149,"longitude":46.199616},"capital":"MOGADISHU","phone":"252"},{"code":"ZA","name":"SOUTH AFRICA","currency":{"currencyName":"SOUTH AFRICAN RAND","currencyCode":"ZAR","currencySymbol":"R"},"geo":{"latitude":-30.559482,"longitude":22.937506},"capital":"PRETORIA","phone":"27"},{"code":"GS","name":"SOUTH GEORGIA & SOUTH SANDWICH ISLANDS","currency":{"currencyName":"POUND STERLING","currencyCode":"GBP","currencySymbol":"£"},"geo":{"latitude":-54.429579,"longitude":-36.587909},"capital":"","phone":"00500"},{"code":"SS","name":"SOUTH SUDAN","currency":{"currencyName":"SOUTH SUDAN POUND","currencyCode":"SSP","currencySymbol":"£"},"geo":{"latitude":7.9631,"longitude":30.1589},"capital":"RAMCIEL","phone":"00211"},{"code":"ES","name":"SPAIN","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":40.463667,"longitude":-3.74922},"capital":"MADRID","phone":"34"},{"code":"LK","name":"SRI LANKA","currency":{"currencyName":"SRI LANKA RUPEE","currencyCode":"LKR","currencySymbol":"₨"},"geo":{"latitude":7.873054,"longitude":80.771797},"capital":"COLOMBO","phone":"94"},{"code":"SD","name":"SUDAN","currency":{"currencyName":"SUDANESE POUND","currencyCode":"SDG","currencySymbol":"£"},"geo":{"latitude":12.862807,"longitude":30.217636},"capital":"KHARTOUM","phone":"249"},{"code":"SR","name":"SURINAME","currency":{"currencyName":"SURINAM DOLLAR","currencyCode":"SRD","currencySymbol":"$"},"geo":{"latitude":3.919305,"longitude":-56.027783},"capital":"PARAMARIBO","phone":"597"},{"code":"SJ","name":"SVALBARD AND JAN MAYEN ISLANDS","currency":{"currencyName":"NORWEGIAN KRONE","currencyCode":"NOK","currencySymbol":"kr"},"geo":{"latitude":77.553604,"longitude":23.670272},"capital":"LONGYEARBYEN","phone":"0047"},{"code":"SZ","name":"SWAZILAND","currency":{"currencyName":"SWAZILAND LILANGENI","currencyCode":"SZL","currencySymbol":"L"},"geo":{"latitude":-26.522503,"longitude":31.465866},"capital":"MBABANE","phone":"268"},{"code":"SE","name":"SWEDEN","currency":{"currencyName":"SWEDISH KRONA","currencyCode":"SEK","currencySymbol":"kr"},"geo":{"latitude":60.128161,"longitude":18.643501},"capital":"STOCKHOLM","phone":"46"},{"code":"CH","name":"SWITZERLAND","currency":{"currencyName":"SWISS FRANC","currencyCode":"CHF","currencySymbol":"CHF"},"geo":{"latitude":46.818188,"longitude":8.227512},"capital":"BERN","phone":"41"},{"code":"SY","name":"SYRIA","currency":{"currencyName":"SYRIAN POUND","currencyCode":"SYP","currencySymbol":"£"},"geo":{"latitude":34.802075,"longitude":38.996815},"capital":"DAMASCUS","phone":"963"},{"code":"TW","name":"TAIWAN","currency":{"currencyName":"TAIWAN DOLLAR","currencyCode":"TWD","currencySymbol":"NT$"},"geo":{"latitude":23.69781,"longitude":120.960515},"capital":"TAIPEI","phone":"886"},{"code":"TJ","name":"TAJIKISTAN","currency":{"currencyName":"TAJIK SOMONI","currencyCode":"TJS","currencySymbol":"SM"},"geo":{"latitude":38.861034,"longitude":71.276093},"capital":"DUSHANBE","phone":"992"},{"code":"TZ","name":"TANZANIA","currency":{"currencyName":"TANZANIAN SHILLING","currencyCode":"TZS","currencySymbol":"TSh"},"geo":{"latitude":-6.369028,"longitude":34.888822},"capital":"DODOMA","phone":"255"},{"code":"TH","name":"THAILAND","currency":{"currencyName":"THAI BAHT","currencyCode":"THB","currencySymbol":"฿"},"geo":{"latitude":15.870032,"longitude":100.992541},"capital":"BANGKOK","phone":"66"},{"code":"TG","name":"TOGO","currency":{"currencyName":"CFA FRANC BCEAO","currencyCode":"XOF","currencySymbol":"Fr"},"geo":{"latitude":8.619543,"longitude":0.824782},"capital":"LOME","phone":"228"},{"code":"TK","name":"TOKELAU","currency":{"currencyName":"NEW ZEALAND DOLLAR","currencyCode":"NZD","currencySymbol":"$"},"geo":{"latitude":-8.967363,"longitude":-171.855881},"capital":"","phone":"690"},{"code":"TO","name":"TONGA","currency":{"currencyName":"TONGAN PA'ANGA","currencyCode":"TOP","currencySymbol":"T$"},"geo":{"latitude":-21.178986,"longitude":-175.198242},"capital":"NUKU'ALOFA","phone":"676"},{"code":"TT","name":"TRINIDAD AND TOBAGO","currency":{"currencyName":"TRINIDAD AND TOBAGO DOLLAR","currencyCode":"TTD","currencySymbol":"TT$"},"geo":{"latitude":10.691803,"longitude":-61.222503},"capital":"PORT OF SPAIN","phone":"1-868"},{"code":"TN","name":"TUNISIA","currency":{"currencyName":"TUNISIAN DOLLAR","currencyCode":"TND","currencySymbol":"د.ت"},"geo":{"latitude":33.886917,"longitude":9.537499},"capital":"TUNIS","phone":"216"},{"code":"TR","name":"TURKEY","currency":{"currencyName":"TURKISH LIRA","currencyCode":"TRY","currencySymbol":"TL"},"geo":{"latitude":38.963745,"longitude":35.243322},"capital":"ANKARA","phone":"90"},{"code":"TM","name":"TURKMENISTAN","currency":{"currencyName":"MANAT","currencyCode":"TMT","currencySymbol":"m"},"geo":{"latitude":38.969719,"longitude":59.556278},"capital":"ASHGABAT","phone":"993"},{"code":"TC","name":"TURKS AND CAICOS ISLANDS","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":21.694025,"longitude":-71.797928},"capital":"GRAND TURK","phone":"1-649"},{"code":"TV","name":"TUVALU","currency":{"currencyName":"AUSTRALIAN DOLLAR","currencyCode":"AUD","currencySymbol":"$"},"geo":{"latitude":-7.109535,"longitude":177.64933},"capital":"FUNAFUTI","phone":"688"},{"code":"UK","name":"UNITED KINGDOM","currency":{"currencyName":"POUND STERLING","currencyCode":"GBP","currencySymbol":"£"},"geo":{"latitude":55.3781,"longitude":-3.436},"capital":"LONDON","phone":"44"},{"code":"US","name":"USA","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":37.09024,"longitude":-95.712891},"capital":"WASHINGTON","phone":"1"},{"code":"UM","name":"USA MINOR OUTLYING ISLANDS","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":-0.37435,"longitude":-159.996719},"capital":"","phone":"001"},{"code":"UG","name":"UGANDA","currency":{"currencyName":"UGANDA SHILLING","currencyCode":"UGX","currencySymbol":"USh"},"geo":{"latitude":1.373333,"longitude":32.290275},"capital":"KAMPALA","phone":"256"},{"code":"UA","name":"UKRAINE","currency":{"currencyName":"UKRAINE HRYVNIA","currencyCode":"UAH","currencySymbol":"₴"},"geo":{"latitude":48.379433,"longitude":31.16558},"capital":"KIEV","phone":"380"},{"code":"AE","name":"UNITED ARAB EMIRATES","currency":{"currencyName":"ARAB EMIRATES DIRHAM","currencyCode":"AED","currencySymbol":"د.إ"},"geo":{"latitude":23.424076,"longitude":53.847818},"capital":"ABU DHABI","phone":"971"},{"code":"UY","name":"URUGUAY","currency":{"currencyName":"URUGUAYAN PESO","currencyCode":"UYU","currencySymbol":"$U"},"geo":{"latitude":-32.522779,"longitude":-55.765835},"capital":"MONTEVIDEO","phone":"598"},{"code":"UZ","name":"UZBEKISTAN","currency":{"currencyName":"UZBEKISTAN SUM","currencyCode":"UZS","currencySymbol":"лв"},"geo":{"latitude":41.377491,"longitude":64.585262},"capital":"TASHKENT","phone":"998"},{"code":"VU","name":"VANUATU","currency":{"currencyName":"VANUATU VATU","currencyCode":"VUV","currencySymbol":"Vt"},"geo":{"latitude":-15.376706,"longitude":166.959158},"capital":"PORT VILA","phone":"678"},{"code":"VA","name":"VATICAN","currency":{"currencyName":"EURO","currencyCode":"EUR","currencySymbol":"€"},"geo":{"latitude":41.902916,"longitude":12.453389},"capital":"VATICAN CITY","phone":"39"},{"code":"VE","name":"VENEZUELA","currency":{"currencyName":"VENEZUELAN BOLIVAR","currencyCode":"VEF","currencySymbol":"Bs"},"geo":{"latitude":6.42375,"longitude":-66.58973},"capital":"CARACAS","phone":"58"},{"code":"VN","name":"VIETNAM","currency":{"currencyName":"VIETNAMESE DONG","currencyCode":"VND","currencySymbol":"₫"},"geo":{"latitude":14.058324,"longitude":108.277199},"capital":"HANOI","phone":"84"},{"code":"VG","name":"VIRGIN ISLANDS (BRITISH)","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":18.420695,"longitude":-64.639968},"capital":"ROAD TOWN","phone":"1-284"},{"code":"VI","name":"VIRGIN ISLANDS (USA)","currency":{"currencyName":"US DOLLAR","currencyCode":"USD","currencySymbol":"$"},"geo":{"latitude":18.335765,"longitude":-64.896335},"capital":"CHARLOTTE AMALIE","phone":"1-340"},{"code":"WF","name":"WALLIS AND FUTUNA ISLANDS","currency":{"currencyName":"CFP FRANC","currencyCode":"XPF","currencySymbol":"Fr"},"geo":{"latitude":-13.768752,"longitude":-177.156097},"capital":"MATA-UTU","phone":"681"},{"code":"EH","name":"WESTERN SAHARA","currency":{"currencyName":"MOROCCAN DIRHAM","currencyCode":"MAD","currencySymbol":"د.م."},"geo":{"latitude":24.215527,"longitude":-12.885834},"capital":"EL AAIUN","phone":"00212"},{"code":"YE","name":"YEMEN","currency":{"currencyName":"YEMENI RIAL","currencyCode":"YER","currencySymbol":"﷼"},"geo":{"latitude":15.552727,"longitude":48.516388},"capital":"SAN'A","phone":"967"},{"code":"ZM","name":"ZAMBIA","currency":{"currencyName":"ZAMBIAN KWACHA","currencyCode":"ZMW","currencySymbol":"ZK"},"geo":{"latitude":-13.133897,"longitude":27.849332},"capital":"LUSAKA","phone":"260"},{"code":"ZW","name":"ZIMBABWE","currency":{"currencyName":"ZIMBABWE DOLLAR","currencyCode":"ZWD","currencySymbol":"Z$"},"geo":{"latitude":-19.015438,"longitude":29.154857},"capital":"HARARE","phone":"263"}]

/***/ }),
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */
/***/ (function(module, exports) {

module.exports = [["AF","AFG","004","ISO 3166-2:AF"],["AX","ALA","248","ISO 3166-2:AX"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BQ","BES","535","ISO 3166-2:BQ"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CW","CUW","531","ISO 3166-2:CW"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GG","GGY","831","ISO 3166-2:GG"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IM","IMN","833","ISO 3166-2:IM"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JE","JEY","832","ISO 3166-2:JE"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MK","MKD","807","ISO 3166-2:MK"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["ME","MNE","499","ISO 3166-2:ME"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["BL","BLM","652","ISO 3166-2:BL"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["MF","MAF","663","ISO 3166-2:MF"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["RS","SRB","688","ISO 3166-2:RS"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SX","SXM","534","ISO 3166-2:SX"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["SS","SSD","728","ISO 3166-2:SS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["XK","XKX","","ISO 3166-2:XK"]]

/***/ }),
/* 2843 */,
/* 2844 */
/***/ (function(module, exports) {

module.exports = {"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, the Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Cote D'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and Mcdonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":"South Korea","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the Former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territory, Occupied","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States of America","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Viet Nam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":"Åland Islands","BQ":"Bonaire, Sint Eustatius and Saba","CW":"Curaçao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barthélemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}

/***/ }),
/* 2845 */
/***/ (function(module, exports) {

module.exports = {"locale":"fr","countries":{"AF":"Afghanistan","AL":"Albanie","DZ":"Algérie","AS":"Samoa américaine","AD":"Andorre","AO":"Angola","AI":"Anguilla","AQ":"Antarctique","AG":"Antigua et Barbuda","AR":"Argentine","AM":"Arménie","AW":"Aruba","AU":"Australie","AT":"Autriche","AZ":"Azerbaidjan","BS":"Bahamas","BH":"Bahrein","BD":"Bangladesh","BB":"Barbade","BY":"Bielorussie","BE":"Belgique","BZ":"Belize","BJ":"Bénin","BM":"Bermudes","BT":"Bhoutan","BO":"Bolivie","BA":"Bosnie-Herzégovine","BW":"Botswana","BV":"Île Bouvet","BR":"Brésil","IO":"Océan Indien Britannique","BN":"Brunei Darussalam","BG":"Bulgarie","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodge","CM":"Cameroun","CA":"Canada","CV":"Cap-Vert","KY":"Caïmanes","CF":"Centrafricaine, République","TD":"Tchad","CL":"Chili","CN":"Chine","CX":"Île Christmas","CC":"Cocos","CO":"Colombie","KM":"Comores","CG":"Congo, République populaire","CD":"Congo, République démocratique","CK":"Îles Cook","CR":"Costa Rica","CI":"Côte-d'Ivoire","HR":"Croatie","CU":"Cuba","CY":"Chypre","CZ":"Tchéquie","DK":"Danemark","DJ":"Djibouti","DM":"Dominique","DO":"République Dominicaine","EC":"Équateur","EG":"Égypte","SV":"El Salvador","GQ":"Guinée équatoriale","ER":"Érythrée","EE":"Estonie","ET":"Éthiopie","FK":"Îles Malouines","FO":"Îles Féroé","FJ":"Fidji","FI":"Finlande","FR":"France","GF":"Guyane française","PF":"Polynésie française","TF":"Terres australes françaises","GA":"Gabon","GM":"Gambie","GE":"Géorgie","DE":"Allemagne","GH":"Ghana","GI":"Gibraltar","GR":"Grèce","GL":"Groenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinée","GW":"Guinée-Bissau","GY":"Guyana","HT":"Haïti","HM":"Îles Heard-et-MacDonald","VA":"Saint-Siège","HN":"Honduras","HK":"Hong Kong","HU":"Hongrie","IS":"Islande","IN":"Inde","ID":"Indonésie","IR":"Iran","IQ":"Irak","IE":"Irlande","IL":"Israël","IT":"Italie","JM":"Jamaïque","JP":"Japon","JO":"Jordanie","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Corée du Nord, République populaire démocratique","KR":"Corée du Sud, République","KW":"Koweit","KG":"Kirghistan","LA":"Laos","LV":"Lettonie","LB":"Liban","LS":"Lesotho","LR":"Libéria","LY":"Libye","LI":"Liechtenstein","LT":"Lituanie","LU":"Luxembourg, Grand-Duché","MO":"Macao","MK":"Macédoine, Ex-République yougoslave","MG":"Madagascar","MW":"Malawi","MY":"Malaisie","MV":"Maldives","ML":"Mali","MT":"Malte","MH":"Îles Marshall","MQ":"Martinique","MR":"Mauritanie","MU":"Maurice","YT":"Mayotte","MX":"Mexique","FM":"Micronésie","MD":"Moldavie","MC":"Monaco","MN":"Mongolie","MS":"Montserrat","MA":"Maroc","MZ":"Mozambique","MM":"Myanmar","NA":"Namibie","NR":"Nauru","NP":"Népal","NL":"Pays-Bas","NC":"Nouvelle-Calédonie","NZ":"Nouvelle-Zélande","NI":"Nicaragua","NE":"Niger","NG":"Nigéria","NU":"Niué","NF":"Île Norfolk","MP":"Mariannes du Nord","NO":"Norvège","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine","PA":"Panama","PG":"Papouasie-Nouvelle-Guinée","PY":"Paraguay","PE":"Pérou","PH":"Philippines","PN":"Pitcairn","PL":"Pologne","PT":"Portugal","PR":"Porto Rico","QA":"Qatar","RE":"Réunion","RO":"Roumanie","RU":"Russie","RW":"Rwanda","SH":"Sainte-Hélène","KN":"Saint-Christophe-et-Niévès","LC":"Sainte-Lucie","PM":"Saint Pierre and Miquelon","VC":"Saint-Vincent et les Grenadines","WS":"Samoa","SM":"Saint-Marin","ST":"São Tomé et Principe","SA":"Arabie Saoudite","SN":"Sénégal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapour","SK":"Slovaquie","SI":"Slovénie","SB":"Salomon","SO":"Somalie","ZA":"Afrique du Sud","GS":"Géorgie du Sud-et-les Îles Sandwich du Sud","ES":"Espagne","LK":"Sri Lanka","SD":"Soudan","SR":"Suriname","SJ":"Svalbard et Île Jan Mayen","SZ":"Ngwane, Royaume du Swaziland","SE":"Suède","CH":"Suisse","SY":"Syrie","TW":"Taïwan","TJ":"Tadjikistan","TZ":"Tanzanie, République unie","TH":"Thaïlande","TL":"Timor Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad et Tobago","TN":"Tunisie","TR":"Turquie","TM":"Turkménistan","TC":"Îles Turques-et-Caïques","TV":"Tuvalu","UG":"Ouganda","UA":"Ukraine","AE":"Émirats Arabes Unis","GB":"Royaume-Uni","US":"États-Unis d'Amérique","UM":"Îles mineures éloignées des États-Unis","UY":"Uruguay","UZ":"Ouzbékistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Îles vierges britanniques","VI":"Îles vierges américaines","WF":"Wallis et Futuna","EH":"Sahara occidental","YE":"Yémen","ZM":"Zambie","ZW":"Zimbabwe","AX":"Åland","BQ":"Bonaire, Saint-Eustache et Saba","CW":"Curaçao","GG":"Guernesey","IM":"Île de Man","JE":"Jersey","ME":"Monténégro","BL":"Saint-Barthélemy","MF":"Saint-Martin (partie française)","RS":"Serbie","SX":"Saint-Martin (partie néerlandaise)","SS":"Sud-Soudan","XK":"Kosovo"}}

/***/ }),
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */,
/* 2902 */,
/* 2903 */,
/* 2904 */,
/* 2905 */,
/* 2906 */,
/* 2907 */,
/* 2908 */,
/* 2909 */,
/* 2910 */,
/* 2911 */,
/* 2912 */,
/* 2913 */,
/* 2914 */,
/* 2915 */,
/* 2916 */,
/* 2917 */,
/* 2918 */,
/* 2919 */,
/* 2920 */,
/* 2921 */,
/* 2922 */,
/* 2923 */,
/* 2924 */,
/* 2925 */,
/* 2926 */,
/* 2927 */,
/* 2928 */,
/* 2929 */,
/* 2930 */,
/* 2931 */,
/* 2932 */,
/* 2933 */,
/* 2934 */,
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */
/***/ (function(module, exports) {

module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 3020 */,
/* 3021 */,
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 993,
	"./af.js": 993,
	"./ar": 1000,
	"./ar-dz": 994,
	"./ar-dz.js": 994,
	"./ar-kw": 995,
	"./ar-kw.js": 995,
	"./ar-ly": 996,
	"./ar-ly.js": 996,
	"./ar-ma": 997,
	"./ar-ma.js": 997,
	"./ar-sa": 998,
	"./ar-sa.js": 998,
	"./ar-tn": 999,
	"./ar-tn.js": 999,
	"./ar.js": 1000,
	"./az": 1001,
	"./az.js": 1001,
	"./be": 1002,
	"./be.js": 1002,
	"./bg": 1003,
	"./bg.js": 1003,
	"./bm": 1004,
	"./bm.js": 1004,
	"./bn": 1006,
	"./bn-bd": 1005,
	"./bn-bd.js": 1005,
	"./bn.js": 1006,
	"./bo": 1007,
	"./bo.js": 1007,
	"./br": 1008,
	"./br.js": 1008,
	"./bs": 1009,
	"./bs.js": 1009,
	"./ca": 1010,
	"./ca.js": 1010,
	"./cs": 1011,
	"./cs.js": 1011,
	"./cv": 1012,
	"./cv.js": 1012,
	"./cy": 1013,
	"./cy.js": 1013,
	"./da": 1014,
	"./da.js": 1014,
	"./de": 1017,
	"./de-at": 1015,
	"./de-at.js": 1015,
	"./de-ch": 1016,
	"./de-ch.js": 1016,
	"./de.js": 1017,
	"./dv": 1018,
	"./dv.js": 1018,
	"./el": 1019,
	"./el.js": 1019,
	"./en-au": 1020,
	"./en-au.js": 1020,
	"./en-ca": 1021,
	"./en-ca.js": 1021,
	"./en-gb": 432,
	"./en-gb.js": 432,
	"./en-ie": 1022,
	"./en-ie.js": 1022,
	"./en-il": 1023,
	"./en-il.js": 1023,
	"./en-in": 1024,
	"./en-in.js": 1024,
	"./en-nz": 1025,
	"./en-nz.js": 1025,
	"./en-sg": 1026,
	"./en-sg.js": 1026,
	"./eo": 1027,
	"./eo.js": 1027,
	"./es": 1031,
	"./es-do": 1028,
	"./es-do.js": 1028,
	"./es-mx": 1029,
	"./es-mx.js": 1029,
	"./es-us": 1030,
	"./es-us.js": 1030,
	"./es.js": 1031,
	"./et": 1032,
	"./et.js": 1032,
	"./eu": 1033,
	"./eu.js": 1033,
	"./fa": 1034,
	"./fa.js": 1034,
	"./fi": 1035,
	"./fi.js": 1035,
	"./fil": 1036,
	"./fil.js": 1036,
	"./fo": 1037,
	"./fo.js": 1037,
	"./fr": 637,
	"./fr-ca": 433,
	"./fr-ca.js": 433,
	"./fr-ch": 1038,
	"./fr-ch.js": 1038,
	"./fr.js": 637,
	"./fy": 1039,
	"./fy.js": 1039,
	"./ga": 1040,
	"./ga.js": 1040,
	"./gd": 1041,
	"./gd.js": 1041,
	"./gl": 1042,
	"./gl.js": 1042,
	"./gom-deva": 1043,
	"./gom-deva.js": 1043,
	"./gom-latn": 1044,
	"./gom-latn.js": 1044,
	"./gu": 1045,
	"./gu.js": 1045,
	"./he": 1046,
	"./he.js": 1046,
	"./hi": 1047,
	"./hi.js": 1047,
	"./hr": 1048,
	"./hr.js": 1048,
	"./hu": 1049,
	"./hu.js": 1049,
	"./hy-am": 1050,
	"./hy-am.js": 1050,
	"./id": 1051,
	"./id.js": 1051,
	"./is": 1052,
	"./is.js": 1052,
	"./it": 1054,
	"./it-ch": 1053,
	"./it-ch.js": 1053,
	"./it.js": 1054,
	"./ja": 1055,
	"./ja.js": 1055,
	"./jv": 1056,
	"./jv.js": 1056,
	"./ka": 1057,
	"./ka.js": 1057,
	"./kk": 1058,
	"./kk.js": 1058,
	"./km": 1059,
	"./km.js": 1059,
	"./kn": 1060,
	"./kn.js": 1060,
	"./ko": 1061,
	"./ko.js": 1061,
	"./ku": 1062,
	"./ku.js": 1062,
	"./ky": 1063,
	"./ky.js": 1063,
	"./lb": 1064,
	"./lb.js": 1064,
	"./lo": 1065,
	"./lo.js": 1065,
	"./lt": 1066,
	"./lt.js": 1066,
	"./lv": 1067,
	"./lv.js": 1067,
	"./me": 1068,
	"./me.js": 1068,
	"./mi": 1069,
	"./mi.js": 1069,
	"./mk": 1070,
	"./mk.js": 1070,
	"./ml": 1071,
	"./ml.js": 1071,
	"./mn": 1072,
	"./mn.js": 1072,
	"./mr": 1073,
	"./mr.js": 1073,
	"./ms": 1075,
	"./ms-my": 1074,
	"./ms-my.js": 1074,
	"./ms.js": 1075,
	"./mt": 1076,
	"./mt.js": 1076,
	"./my": 1077,
	"./my.js": 1077,
	"./nb": 1078,
	"./nb.js": 1078,
	"./ne": 1079,
	"./ne.js": 1079,
	"./nl": 1081,
	"./nl-be": 1080,
	"./nl-be.js": 1080,
	"./nl.js": 1081,
	"./nn": 1082,
	"./nn.js": 1082,
	"./oc-lnc": 1083,
	"./oc-lnc.js": 1083,
	"./pa-in": 1084,
	"./pa-in.js": 1084,
	"./pl": 1085,
	"./pl.js": 1085,
	"./pt": 1087,
	"./pt-br": 1086,
	"./pt-br.js": 1086,
	"./pt.js": 1087,
	"./ro": 1088,
	"./ro.js": 1088,
	"./ru": 1089,
	"./ru.js": 1089,
	"./sd": 1090,
	"./sd.js": 1090,
	"./se": 1091,
	"./se.js": 1091,
	"./si": 1092,
	"./si.js": 1092,
	"./sk": 1093,
	"./sk.js": 1093,
	"./sl": 1094,
	"./sl.js": 1094,
	"./sq": 1095,
	"./sq.js": 1095,
	"./sr": 1097,
	"./sr-cyrl": 1096,
	"./sr-cyrl.js": 1096,
	"./sr.js": 1097,
	"./ss": 1098,
	"./ss.js": 1098,
	"./sv": 1099,
	"./sv.js": 1099,
	"./sw": 1100,
	"./sw.js": 1100,
	"./ta": 1101,
	"./ta.js": 1101,
	"./te": 1102,
	"./te.js": 1102,
	"./tet": 1103,
	"./tet.js": 1103,
	"./tg": 1104,
	"./tg.js": 1104,
	"./th": 1105,
	"./th.js": 1105,
	"./tk": 1106,
	"./tk.js": 1106,
	"./tl-ph": 1107,
	"./tl-ph.js": 1107,
	"./tlh": 1108,
	"./tlh.js": 1108,
	"./tr": 1109,
	"./tr.js": 1109,
	"./tzl": 1110,
	"./tzl.js": 1110,
	"./tzm": 1112,
	"./tzm-latn": 1111,
	"./tzm-latn.js": 1111,
	"./tzm.js": 1112,
	"./ug-cn": 1113,
	"./ug-cn.js": 1113,
	"./uk": 1114,
	"./uk.js": 1114,
	"./ur": 1115,
	"./ur.js": 1115,
	"./uz": 1117,
	"./uz-latn": 1116,
	"./uz-latn.js": 1116,
	"./uz.js": 1117,
	"./vi": 1118,
	"./vi.js": 1118,
	"./x-pseudo": 1119,
	"./x-pseudo.js": 1119,
	"./yo": 1120,
	"./yo.js": 1120,
	"./zh-cn": 1121,
	"./zh-cn.js": 1121,
	"./zh-hk": 1122,
	"./zh-hk.js": 1122,
	"./zh-mo": 1123,
	"./zh-mo.js": 1123,
	"./zh-tw": 1124,
	"./zh-tw.js": 1124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3022;

/***/ }),
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 3343 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAJ1BMVEUTdb0VdbsJdcdHcEwAd9MAdtE6c583cps9dZ6hcDXVbwHBcBXAbxb5P5iVAAAACXRSTlP1sfIAIic1ODI9tMFeAAAANElEQVQI12MwDlQSMWYw59w9IZkhYNWqVSwMkkByIoM2kDwEJSEiDmBZM84zE5oZjB2BugCBKBWRcfmehgAAAABJRU5ErkJggg=="

/***/ }),
/* 3344 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDI4IDIxIj4KICAgIDxwYXRoIGlkPSJwcmVmaXhfX3F1b3RlIiBkPSJNNC42NzYtMTEuNDQ1YzUuMDkxLTMuMDU2IDkuMy03Ljg4NyA5LjMtMTQuMiAwLTMuNjQ4LTEuNzYyLTYuOC01Ljc3Ni02LjhhNS40MDkgNS40MDkgMCAwIDAtNS40ODMgNS40MjNBNS4zMTggNS4zMTggMCAwIDAgNy4zMi0yMS43YTIuMTkxIDIuMTkxIDAgMCAwIC42OC4xIDE0LjYwNyAxNC42MDcgMCAwIDEtNi4wNyA2LjYwNnptMTUuOTU4IDBjNS4xODktMy4wNTYgOS4zLTcuODg3IDkuMy0xNC4yIDAtMy42NDgtMS43NjItNi44LTUuNzc2LTYuOGE1LjM4OCA1LjM4OCAwIDAgMC01LjM4NSA1LjQyMyA1LjMxOCA1LjMxOCAwIDAgMCA0LjYgNS4zMjQgMS45IDEuOSAwIDAgMCAuNjg1LjEgMTUuMzg3IDE1LjM4NyAwIDAgMS02LjE2OCA2LjYwNnoiIHRyYW5zZm9ybT0icm90YXRlKDE4MCAxNC45NjcgLTUuNzIyKSIgc3R5bGU9ImZpbGw6IzAxNzlkNSIvPgo8L3N2Zz4K"

/***/ }),
/* 3345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/testimonial-reg.89ad20d.png";

/***/ }),
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2740)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1343),
  /* template */
  __webpack_require__(3825),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2746)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1344),
  /* template */
  __webpack_require__(3839),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3365 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1345),
  /* template */
  __webpack_require__(3768),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2720)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1347),
  /* template */
  __webpack_require__(3793),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2683)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1349),
  /* template */
  __webpack_require__(3722),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3368 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2694)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1350),
  /* template */
  __webpack_require__(3747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2632)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1353),
  /* template */
  __webpack_require__(3642),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2605)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1354),
  /* template */
  __webpack_require__(3592),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2751)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1356),
  /* template */
  __webpack_require__(3856),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2616)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1358),
  /* template */
  __webpack_require__(3608),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2700)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1361),
  /* template */
  __webpack_require__(3760),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2637)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1362),
  /* template */
  __webpack_require__(3652),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2606)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1363),
  /* template */
  __webpack_require__(3593),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2598)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1364),
  /* template */
  __webpack_require__(3584),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2772)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1365),
  /* template */
  __webpack_require__(3611),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2596)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1367),
  /* template */
  __webpack_require__(3580),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3379 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2707)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1368),
  /* template */
  __webpack_require__(3772),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3380 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2630)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1372),
  /* template */
  __webpack_require__(3639),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3381 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2651)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1373),
  /* template */
  __webpack_require__(3676),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3382 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2731)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1374),
  /* template */
  __webpack_require__(3806),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3383 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2593)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1377),
  /* template */
  __webpack_require__(3576),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3384 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2699)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1379),
  /* template */
  __webpack_require__(3757),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3385 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2703)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1380),
  /* template */
  __webpack_require__(3764),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3386 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2659)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1381),
  /* template */
  __webpack_require__(3689),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2671)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1382),
  /* template */
  __webpack_require__(3704),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3388 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2744)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1384),
  /* template */
  __webpack_require__(3834),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3389 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1387),
  /* template */
  __webpack_require__(3621),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2759)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1389),
  /* template */
  __webpack_require__(3867),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f13dc906",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2732)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1391),
  /* template */
  __webpack_require__(3807),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2617)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1392),
  /* template */
  __webpack_require__(3614),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2602)
  __webpack_require__(2601)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1393),
  /* template */
  __webpack_require__(3588),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a4c67c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2691)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1394),
  /* template */
  __webpack_require__(3740),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2657)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1395),
  /* template */
  __webpack_require__(3683),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2706)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1397),
  /* template */
  __webpack_require__(3771),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2801)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1398),
  /* template */
  __webpack_require__(3765),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1399),
  /* template */
  __webpack_require__(3738),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1400),
  /* template */
  __webpack_require__(3725),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2776)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1403),
  /* template */
  __webpack_require__(3617),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2823)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1404),
  /* template */
  __webpack_require__(3853),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3402 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2806)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1405),
  /* template */
  __webpack_require__(3786),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7613c39e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2777)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1406),
  /* template */
  __webpack_require__(3618),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2812)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1408),
  /* template */
  __webpack_require__(3818),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2821)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1409),
  /* template */
  __webpack_require__(3846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d06a41c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2784)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1410),
  /* template */
  __webpack_require__(3655),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1411),
  /* template */
  __webpack_require__(3838),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3408 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2698)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1412),
  /* template */
  __webpack_require__(3753),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2612)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1413),
  /* template */
  __webpack_require__(3602),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3410 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2708)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1414),
  /* template */
  __webpack_require__(3773),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3411 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2610)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1415),
  /* template */
  __webpack_require__(3600),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2650)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1416),
  /* template */
  __webpack_require__(3675),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2822)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1419),
  /* template */
  __webpack_require__(3847),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2705)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1421),
  /* template */
  __webpack_require__(3767),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c1d4080",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1425),
  /* template */
  __webpack_require__(3726),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1426),
  /* template */
  __webpack_require__(3663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2702)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1429),
  /* template */
  __webpack_require__(3763),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2750)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1432),
  /* template */
  __webpack_require__(3852),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2771)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1434),
  /* template */
  __webpack_require__(3610),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1435),
  /* template */
  __webpack_require__(3735),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3421 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2830)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1436),
  /* template */
  __webpack_require__(3872),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2788)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1437),
  /* template */
  __webpack_require__(3680),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1439),
  /* template */
  __webpack_require__(3668),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1440),
  /* template */
  __webpack_require__(3730),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3425 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1442),
  /* template */
  __webpack_require__(3630),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3426 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1443),
  /* template */
  __webpack_require__(3637),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2794)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1446),
  /* template */
  __webpack_require__(3727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52c8851d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2756)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1448),
  /* template */
  __webpack_require__(3863),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2656)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1449),
  /* template */
  __webpack_require__(3682),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1450),
  /* template */
  __webpack_require__(3721),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3431 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1454),
  /* template */
  __webpack_require__(3671),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3432 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1455),
  /* template */
  __webpack_require__(3810),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2682)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1456),
  /* template */
  __webpack_require__(3719),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2734)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1462),
  /* template */
  __webpack_require__(3814),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3435 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1464),
  /* template */
  __webpack_require__(3811),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3436 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1465),
  /* template */
  __webpack_require__(3754),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3437 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1466),
  /* template */
  __webpack_require__(3758),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3438 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1467),
  /* template */
  __webpack_require__(3835),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1468),
  /* template */
  __webpack_require__(3603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3440 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1469),
  /* template */
  __webpack_require__(3700),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3441 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1471),
  /* template */
  __webpack_require__(3813),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1472),
  /* template */
  __webpack_require__(3581),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2684)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1476),
  /* template */
  __webpack_require__(3723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-516eb3ff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3444 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1480),
  /* template */
  __webpack_require__(3844),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3445 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2624)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1485),
  /* template */
  __webpack_require__(3627),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3446 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2595)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1491),
  /* template */
  __webpack_require__(3579),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02c109f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3447 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2760)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1492),
  /* template */
  __webpack_require__(3868),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f2c823b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2748)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1500),
  /* template */
  __webpack_require__(3845),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3449 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1507),
  /* template */
  __webpack_require__(3619),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2781)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1508),
  /* template */
  __webpack_require__(3635),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2716)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1509),
  /* template */
  __webpack_require__(3787),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2688)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1510),
  /* template */
  __webpack_require__(3731),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2805)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1511),
  /* template */
  __webpack_require__(3781),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74032694",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2663)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1517),
  /* template */
  __webpack_require__(3695),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2785)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1518),
  /* template */
  __webpack_require__(3667),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3456 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1519),
  /* template */
  __webpack_require__(3657),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1520),
  /* template */
  __webpack_require__(3783),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1521),
  /* template */
  __webpack_require__(3692),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3459 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1522),
  /* template */
  __webpack_require__(3762),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1523),
  /* template */
  __webpack_require__(3649),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3461 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1524),
  /* template */
  __webpack_require__(3737),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3462 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1525),
  /* template */
  __webpack_require__(3755),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3463 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2808)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1526),
  /* template */
  __webpack_require__(3801),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e220585",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2714)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1527),
  /* template */
  __webpack_require__(3782),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3465 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1528),
  /* template */
  __webpack_require__(3590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1529),
  /* template */
  __webpack_require__(3713),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3467 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2754)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1530),
  /* template */
  __webpack_require__(3861),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3468 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1531),
  /* template */
  __webpack_require__(3779),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3469 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2640)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1532),
  /* template */
  __webpack_require__(3656),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2728)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1533),
  /* template */
  __webpack_require__(3803),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3471 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1534),
  /* template */
  __webpack_require__(3808),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1535),
  /* template */
  __webpack_require__(3633),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3473 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1536),
  /* template */
  __webpack_require__(3638),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3474 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2662)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1537),
  /* template */
  __webpack_require__(3694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42a55992",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2607)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1538),
  /* template */
  __webpack_require__(3597),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3476 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2717)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1539),
  /* template */
  __webpack_require__(3788),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1540),
  /* template */
  __webpack_require__(3613),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2753)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1541),
  /* template */
  __webpack_require__(3860),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2660)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1542),
  /* template */
  __webpack_require__(3691),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2764)
  __webpack_require__(2763)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1543),
  /* template */
  __webpack_require__(3583),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07daf7b1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2796)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1544),
  /* template */
  __webpack_require__(3739),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3482 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2767)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1545),
  /* template */
  __webpack_require__(3596),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1546),
  /* template */
  __webpack_require__(3690),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2787)
  __webpack_require__(2786)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1547),
  /* template */
  __webpack_require__(3672),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-343640c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2795)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1548),
  /* template */
  __webpack_require__(3732),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2791)
  __webpack_require__(2790)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1549),
  /* template */
  __webpack_require__(3688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f719f2d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2814)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1550),
  /* template */
  __webpack_require__(3821),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2800)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1551),
  /* template */
  __webpack_require__(3756),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64893317",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2828)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1552),
  /* template */
  __webpack_require__(3864),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2770)
  __webpack_require__(2769)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1553),
  /* template */
  __webpack_require__(3609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12596796",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1554),
  /* template */
  __webpack_require__(3701),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2824)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1555),
  /* template */
  __webpack_require__(3854),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2810)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1556),
  /* template */
  __webpack_require__(3812),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2803)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1557),
  /* template */
  __webpack_require__(3770),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1558),
  /* template */
  __webpack_require__(3849),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1559),
  /* template */
  __webpack_require__(3759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2652)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1560),
  /* template */
  __webpack_require__(3677),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2730)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1561),
  /* template */
  __webpack_require__(3805),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1562),
  /* template */
  __webpack_require__(3744),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2620)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1563),
  /* template */
  __webpack_require__(3622),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2673)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1564),
  /* template */
  __webpack_require__(3706),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2693)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1565),
  /* template */
  __webpack_require__(3746),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5fbbbad7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2811)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1566),
  /* template */
  __webpack_require__(3817),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2739)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1567),
  /* template */
  __webpack_require__(3824),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2614)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1568),
  /* template */
  __webpack_require__(3605),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2647)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1569),
  /* template */
  __webpack_require__(3669),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2604)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1570),
  /* template */
  __webpack_require__(3591),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2675)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1571),
  /* template */
  __webpack_require__(3709),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2793)
  __webpack_require__(2679)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1572),
  /* template */
  __webpack_require__(3715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c11002a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3510 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1573),
  /* template */
  __webpack_require__(3792),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3511 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2792)
  __webpack_require__(2678)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1574),
  /* template */
  __webpack_require__(3712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49ccd3c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1575),
  /* template */
  __webpack_require__(3848),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2669)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1576),
  /* template */
  __webpack_require__(3702),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2645)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1577),
  /* template */
  __webpack_require__(3665),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3515 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2816)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1578),
  /* template */
  __webpack_require__(3828),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3516 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1579),
  /* template */
  __webpack_require__(3714),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1580),
  /* template */
  __webpack_require__(3685),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3518 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1581),
  /* template */
  __webpack_require__(3587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3519 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1582),
  /* template */
  __webpack_require__(3650),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1583),
  /* template */
  __webpack_require__(3661),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3521 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1584),
  /* template */
  __webpack_require__(3752),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3522 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1585),
  /* template */
  __webpack_require__(3784),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3523 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2641)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1586),
  /* template */
  __webpack_require__(3659),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3524 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2762)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1587),
  /* template */
  __webpack_require__(3578),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3525 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1590),
  /* template */
  __webpack_require__(3658),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3526 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2775)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1591),
  /* template */
  __webpack_require__(3616),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3527 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2807)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1594),
  /* template */
  __webpack_require__(3790),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3528 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2695)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1595),
  /* template */
  __webpack_require__(3748),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3529 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2635)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1596),
  /* template */
  __webpack_require__(3647),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3530 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2797)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1597),
  /* template */
  __webpack_require__(3742),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3531 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2774)
  __webpack_require__(2618)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1598),
  /* template */
  __webpack_require__(3615),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3532 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1599),
  /* template */
  __webpack_require__(3595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3533 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2667)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1600),
  /* template */
  __webpack_require__(3699),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3534 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2736)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1601),
  /* template */
  __webpack_require__(3819),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3535 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2603)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1603),
  /* template */
  __webpack_require__(3589),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3536 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1604),
  /* template */
  __webpack_require__(3720),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3537 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2765)
  __webpack_require__(2599)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1606),
  /* template */
  __webpack_require__(3585),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-092b1fea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3538 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2686)
  __webpack_require__(2687)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1607),
  /* template */
  __webpack_require__(3729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53ecbd12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3539 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2622)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1608),
  /* template */
  __webpack_require__(3624),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3540 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2619)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1609),
  /* template */
  __webpack_require__(3620),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2661)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1610),
  /* template */
  __webpack_require__(3693),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2752)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1611),
  /* template */
  __webpack_require__(3858),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3543 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2737)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1612),
  /* template */
  __webpack_require__(3822),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3544 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2832)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1613),
  /* template */
  __webpack_require__(3875),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3545 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2724)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1614),
  /* template */
  __webpack_require__(3797),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3546 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2742)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1615),
  /* template */
  __webpack_require__(3830),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1616),
  /* template */
  __webpack_require__(3851),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2681)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1617),
  /* template */
  __webpack_require__(3718),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3549 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2625)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1618),
  /* template */
  __webpack_require__(3628),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3550 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2768)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1619),
  /* template */
  __webpack_require__(3606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-11884076",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3551 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2820)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1620),
  /* template */
  __webpack_require__(3842),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7f27fd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3552 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2825)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1621),
  /* template */
  __webpack_require__(3855),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e28b0b40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1622),
  /* template */
  __webpack_require__(3873),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1623),
  /* template */
  __webpack_require__(3736),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3555 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2621)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1624),
  /* template */
  __webpack_require__(3623),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1625),
  /* template */
  __webpack_require__(3815),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3557 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2831)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1626),
  /* template */
  __webpack_require__(3874),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3558 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2783)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1627),
  /* template */
  __webpack_require__(3651),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3559 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2782)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1628),
  /* template */
  __webpack_require__(3643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-274157cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1629),
  /* template */
  __webpack_require__(3684),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2749)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1630),
  /* template */
  __webpack_require__(3850),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3562 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2677)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1631),
  /* template */
  __webpack_require__(3711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4985204f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3563 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2809)
  __webpack_require__(2727)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1632),
  /* template */
  __webpack_require__(3802),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7eb4b48b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3564 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2713)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1633),
  /* template */
  __webpack_require__(3780),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3565 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2655)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1634),
  /* template */
  __webpack_require__(3681),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3566 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2738)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1635),
  /* template */
  __webpack_require__(3823),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9d59a204",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2758)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1636),
  /* template */
  __webpack_require__(3866),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-efb32fee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3568 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2631)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1637),
  /* template */
  __webpack_require__(3640),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2600)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1638),
  /* template */
  __webpack_require__(3586),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0956c817",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3570 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1639),
  /* template */
  __webpack_require__(3724),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2633)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1640),
  /* template */
  __webpack_require__(3645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28acef92",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3572 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2733)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1641),
  /* template */
  __webpack_require__(3809),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-80931672",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3573 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1642),
  /* template */
  __webpack_require__(3841),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2615)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1643),
  /* template */
  __webpack_require__(3607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-119b32c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2766)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1644),
  /* template */
  __webpack_require__(3594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c7a0590",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-text-field-multiline"
  }, [_c('textarea', {
    ref: "textareaHidden",
    staticClass: "mu-text-field-textarea-hide mu-text-field-input",
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "textarea",
    staticClass: "mu-text-field-input mu-text-field-textarea",
    class: _vm.normalClass,
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.handleChange,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudioReady),
      expression: "isAudioReady"
    }],
    staticClass: "lcAudioPlayer nonSelectable"
  }, [_c('mu-card-text', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "width": "410%"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('mu-icon', {
    staticClass: "playButton",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px"
    },
    attrs: {
      "color": "#1692DA",
      "value": _vm.isPlaying ? 'pause_circle_outline' : 'play_circle_outline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.playOrPause()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "playerBar"
  }, [_c('div', [_c('vue-slider', {
    attrs: {
      "bgStyle": _vm.playerSliderOptions.bgStyle,
      "processStyle": _vm.playerSliderOptions.processStyle,
      "sliderStyle": _vm.playerSliderOptions.sliderStyle,
      "height": _vm.playerSliderOptions.height,
      "width": _vm.playerSliderOptions.width,
      "dotSize": _vm.playerSliderOptions.dotSize,
      "tooltip": "false",
      "min": 0,
      "max": _vm.duration,
      "speed": 0
    },
    on: {
      "callback": _vm.durationChanged,
      "drag-start": function($event) {
        return _vm.dragSeekDurationStarted()
      },
      "drag-end": function($event) {
        return _vm.dragSeekDurationEnded()
      }
    },
    model: {
      value: (_vm.currentDuration),
      callback: function($$v) {
        _vm.currentDuration = $$v
      },
      expression: "currentDuration"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "durationStats left"
  }, [_vm._v("\n      " + _vm._s(_vm.currentTime) + "/" + _vm._s(_vm.audioDuration) + "\n    ")]), _vm._v(" "), (_vm.isAudioReady === true) ? _c('div', {
    staticClass: "volume-controls left"
  }, [_c('mu-icon', {
    staticStyle: {
      "float": "left",
      "cursor": "pointer"
    },
    attrs: {
      "color": "#1692DA",
      "value": _vm.audioIcon
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mute()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVolumeControlsVisible === true),
      expression: "isVolumeControlsVisible === true"
    }],
    staticClass: "control desktopOnly"
  }, [_c('vue-slider', {
    attrs: {
      "direction": _vm.volumeSliderOptions.direction,
      "tooltip": "false",
      "min": _vm.volumeSliderOptions.min,
      "max": _vm.volumeSliderOptions.max,
      "interval": _vm.volumeSliderOptions.interval,
      "speed": _vm.volumeSliderOptions.speed,
      "width": _vm.volumeSliderOptions.width,
      "height": _vm.volumeSliderOptions.height
    },
    on: {
      "drag-start": function($event) {
        return _vm.dragVolumeStarted()
      },
      "drag-ended": function($event) {
        return _vm.dragVolumeEnded()
      },
      "callback": _vm.setVolume
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('audio', {
    ref: "audioFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.url,
      "preload": "auto",
      "controls": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 3578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isHcpView) ? _c('mu-paper', {
    staticClass: "nav bottom"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "horizontalScroll",
    staticStyle: {
      "white-space": "nowrap",
      "padding": "0"
    }
  }, [_vm._l((_vm.filterTypes), function(item, index) {
    return _c('li', {
      key: 'filter-' + index,
      class: {
        isActive: item.type === _vm.query.type
      },
      on: {
        "click": function($event) {
          return _vm.setFilter(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n          "), (item.type === 'MY_ANSWERS') ? _c('span', {
      staticStyle: {
        "margin-left": "8px",
        "color": "white"
      }
    }, [_c('mu-badge', {
      attrs: {
        "primary": "",
        "content": _vm.userAnswers
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 'MY_QUESTIONS') ? _c('span', {
      staticStyle: {
        "margin-left": "8px",
        "color": "white"
      }
    }, [_c('mu-badge', {
      attrs: {
        "primary": "",
        "content": _vm.userQuestions
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.categories), function(item, index) {
    return (item.count > 0) ? _c('li', {
      class: {
        isActive: item.id === _vm.query.category
      },
      attrs: {
        "index": 'category-' + item.id
      },
      on: {
        "click": function($event) {
          return _vm.setCategory(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n          "), _c('span', {
      staticStyle: {
        "margin-left": "8px",
        "color": "white"
      }
    }, [_c('mu-badge', {
      attrs: {
        "primary": "",
        "content": item.count
      }
    })], 1)]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "desktop": "70",
      "tablet": "60",
      "width": "100"
    }
  }, [(_vm.query.type === 'SEARCH') ? _c('mu-card', [_c('mu-card-text', [_c('div', [_vm._v("Search term: "), _c('strong', [_vm._v(_vm._s(_vm.query.q))])]), _vm._v(" "), (!_vm.isLoading) ? _c('div', [(_vm.data.total_questions > _vm.query.per_page) ? _c('span', [_vm._v(" Showing "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.query.per_page)
    }
  }), _vm._v(" of ")]) : _vm._e(), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_questions)
    }
  }), _vm._v(" results\n          ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('mu-card', [_c('div', [_c('mu-list', [(_vm.isLoading) ? _c('div', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dummy-loader-' + index,
      staticClass: "noCursor",
      attrs: {
        "title": item.display_name
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "14px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      style: ({
        width: _vm.getRandomArbitrary(40, 50)
      }),
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.image,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 0, 'dummy-loader-' + index), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "12px",
        "width": "15%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.questions), function(question, index) {
    return (!_vm.isLoading) ? _c('mu-list-item', {
      key: 'question-' + index,
      staticClass: "questionItem",
      class: {
        isHidden: _vm.isAuthAdmin && question.hidden
      },
      attrs: {
        "disableRipple": ""
      }
    }, [(!question.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n                " + _vm._s(_vm.upperTwoInitials(question.display_name ? question.display_name : question.firstname + ' ' + question.surname)) + "\n              ")]) : _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": question.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(question.url)
        }
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('router-link', {
      staticClass: "linkSize",
      attrs: {
        "to": {}
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToQuestion(question.question_id)
        }
      }
    }, [(question.question.length < 200) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.upperCaseFirst(question.question)))
      }
    }) : _vm._e(), _vm._v(" "), (question.question.length > 200) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(("$sanitize(" + (question.question.substr(0, 200)) + "...)"))
      }
    }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('div', {
      staticClass: "asked-by"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.$t('message.discussionAskedBySuffix'))
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/profile/' + question.url
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(question.display_name)
      }
    })]), _vm._v("\n                  " + _vm._s(_vm.$t('message.discussionAskedAtSuffix'))), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(question.timestamp)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [(question.replies > 0) ? _c('span', {
      staticClass: "label-container"
    }, [_c('mu-icon', {
      attrs: {
        "color": "#0179d5",
        "value": "reply",
        "size": 24
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(question.replies + (question.replies > 1 ? (" " + (_vm.$t('message.repliesText'))) : (" " + (_vm.$t('message.replyText'))))))
      }
    })], 1) : _vm._e(), _vm._v(" "), (question.likes > 0) ? _c('span', {
      staticClass: "label-container"
    }, [_c('mu-icon', {
      attrs: {
        "color": "red",
        "size": 24,
        "value": question.liked ? 'favorite' : 'favorite_border'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label",
      domProps: {
        "innerHTML": _vm._s(question.likes + (question.likes > 1 ? (" " + (_vm.$t('message.likesText'))) : (" " + (_vm.$t('message.likeText')))))
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin && question.report_count > 0) ? _c('span', {
      staticClass: "label-container"
    }, [_c('mu-icon', {
      attrs: {
        "size": 24,
        "color": "#E74C3C",
        "value": "report_problem"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label",
      domProps: {
        "innerHTML": _vm._s(question.report_count)
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin && question.hidden) ? _c('span', [_c('mu-icon', {
      attrs: {
        "value": "visibility_off",
        "size": 24
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin && question.hcp == 1) ? _c('span', [_c('mu-icon', {
      attrs: {
        "value": "local_hospital",
        "color": "#8bc34a",
        "size": 24
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label"
    }, [_vm._v("HCP Question")])], 1) : _vm._e()])]), _vm._v(" "), ((!question.is_admin || _vm.isAuthAdmin) && _vm.$store.state.status.payment.paid) ? _c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "anchorOrigin": _vm.rightTop,
        "targetOrigin": _vm.rightTop,
        "scroller": _vm.scroller,
        "icon": "more_vert",
        "desktop": ""
      },
      slot: "right"
    }, [(!question.is_admin && !_vm.isAuthAdmin) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "report",
        "title": question.reported ? 'Reported' : 'Report',
        "disabled": question.reported
      },
      on: {
        "click": function($event) {
          return _vm.openReport('THREAD_QUESTION', question.question_id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": question.hidden === false ? 'visibility_off' : 'visibility',
        "title": question.hidden === false ? _vm.$t('message.hideText') : _vm.$t('message.restoreText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.hideQuestion(question, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "delete",
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteQuestion(question, index)
        }
      }
    }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.query.per_page < _vm.data.total_questions || _vm.data.total_questions === 0) ? _c('mu-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.data.total_questions === 0) ? _c('div', {
    staticClass: "errorMessage"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.displayMessage)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.query.per_page < _vm.data.total_questions) ? _c('div', {
    staticClass: "pagination"
  }, [_c('a', {
    staticClass: "mu-pagination-item firstItem",
    on: {
      "click": function($event) {
        return _vm.handlePageChange(1)
      }
    }
  }, [_vm._v("First")]), _vm._v(" "), _c('mu-pagination', {
    attrs: {
      "total": _vm.data.total_questions,
      "current": _vm.data.page,
      "defaultPageSize": 5,
      "pageSize": _vm.query.per_page
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mu-pagination-item lastItem",
    on: {
      "click": function($event) {
        return _vm.handlePageChange(_vm.data.total_questions)
      }
    }
  }, [_vm._v("Last")])], 1) : _vm._e()]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "40",
      "width": "100"
    }
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('mu-flat-button', {
    staticClass: "askButton",
    attrs: {
      "backgroundColor": "#3d8517",
      "color": "white",
      "label": _vm.isHcpView ? 'New Topic' : _vm.$t('message.discussionButtonAsk')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.askQuestion.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('search-questions', {
    staticClass: "bottom",
    attrs: {
      "isSearching": _vm.isSearching
    }
  }), _vm._v(" "), (!_vm.isHcpView) ? _c('top-contributors', {
    staticClass: "bottom"
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('frequently-asked', {
    staticClass: "bottom"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeReport.type && _vm.activeReport.type_id) ? _c('report-modal', {
    attrs: {
      "open": _vm.activeReport.open,
      "type": _vm.activeReport.type,
      "type_id": _vm.activeReport.type_id
    },
    on: {
      "onClose": function($event) {
        _vm.activeReport.open = false
      },
      "onComplete": function($event) {
        return _vm.setReported(_vm.activeReport)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sleep-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#183C45"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmpty'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmptyExplain'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "activeSleepType": _vm.activeType,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  })], 1), _vm._v(" "), _c('mu-paper', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-select-field', {
    model: {
      value: (_vm.activeType),
      callback: function($$v) {
        _vm.activeType = $$v
      },
      expression: "activeType"
    }
  }, _vm._l((_vm.activeTypes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'types-selector-' + index,
      attrs: {
        "value": item.value,
        "title": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(0)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(7)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(30)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(360)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-linear-progress",
    style: ({
      'height': _vm.size + 'px',
      'border-radius': (_vm.size ? _vm.size / 2 : '') + 'px'
    })
  }, [_c('div', {
    class: _vm.linearClass,
    style: (_vm.linearStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 3581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-row', [(_vm.preference === 'kg') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:635',
      "data-vv-name": "kg",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('kg'),
      "type": "number",
      "label": "KG",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.kg),
      callback: function($$v) {
        _vm.$set(_vm.reading, "kg", _vm._n($$v))
      },
      expression: "reading.kg"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:750',
      "data-vv-name": "lbs",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('lbs'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.lbs),
      callback: function($$v) {
        _vm.$set(_vm.reading, "lbs", _vm._n($$v))
      },
      expression: "reading.lbs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:100',
      "data-vv-name": "stones",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('stones'),
      "type": "number",
      "label": "ST",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.stones),
      callback: function($$v) {
        _vm.$set(_vm.reading, "stones", _vm._n($$v))
      },
      expression: "reading.stones"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('pounds'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.pounds),
      callback: function($$v) {
        _vm.$set(_vm.reading, "pounds", _vm._n($$v))
      },
      expression: "reading.pounds"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "striiv-sleep-graph"
    }
  }, [_c('mu-paper', [(_vm.hasSleepData && !_vm.isLoading) ? _c('striiv-sleep-chart', {
    attrs: {
      "chart-data": _vm.data,
      "options": _vm.options
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasSleepData) ? _c('mu-card-text', [_c('alert', {
    attrs: {
      "type": "info",
      "icon": "info"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Not enough data to create a chart\n        ")])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-paper', {
    staticStyle: {
      "position": "relative",
      "z-index": "99",
      "margin-bottom": "8px"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "describeText": _vm.food.brand_name
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : _vm.food.food_name)
    }
  })]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-divider')], 1)], 1), _vm._v(" "), _c('mu-paper', [_c('div', [(!_vm.isLoading) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "width": "100",
      "desktop": _vm.leftPaneWidth.desktop,
      "tablet": _vm.leftPaneWidth.tablet
    }
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:99'),
      expression: "'required|min_value:0|max_value:99'"
    }],
    attrs: {
      "data-vv-name": "serving_size",
      "data-vv-as": _vm.$t('message.labelServingSize'),
      "errorText": _vm.errors.first('serving_size'),
      "min": 1,
      "max": 99,
      "type": "number",
      "hintText": _vm.$t('message.labelMultiplier'),
      "label": _vm.$t('message.labelServingSize'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.servings),
      callback: function($$v) {
        _vm.$set(_vm.model, "servings", _vm._n($$v))
      },
      expression: "model.servings"
    }
  }), _vm._v(" "), _c('span')], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "maxHeight": 248,
      "label": " ",
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.serving_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "serving_id", _vm._n($$v))
      },
      expression: "model.serving_id"
    }
  }, _vm._l((_vm.food.servings), function(serving, index) {
    return _c('mu-menu-item', {
      key: 'serving-' + index,
      attrs: {
        "value": serving.serving_id,
        "title": serving.serving_description
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('mu-col', {
    staticStyle: {
      "font-weight": "500",
      "margin-bottom": "8px"
    },
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryQuickPortionLabel'))
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.25')
      }
    }
  }, [_vm._v("1/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.5')
      }
    }
  }, [_vm._v("1/2")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.75')
      }
    }
  }, [_vm._v("3/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('1')
      }
    }
  }, [_vm._v("1")])], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": "TIME",
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": "DATE",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Full nutrition",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNutritionPane()
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.isNutritionPaneVisible) ? _c('mu-col', {
    staticClass: "rightPane",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    staticClass: "removePadding",
    attrs: {
      "subTitle": _vm.model.servings + ' x ' + _vm.activeServingObject.serving_description
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeServingObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrient-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.rounded(value * _vm.model.servings) + _vm.getUnit(key)
      }
    })
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading) ? _c('mu-card-actions', {
    staticClass: "card-actions",
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText'),
      "disabled": _vm.isSaving,
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveFood()
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-focus-ripple-wrapper"
  }, [_c('div', {
    ref: "innerCircle",
    staticClass: "mu-focus-ripple",
    style: (_vm.style)
  })])
},staticRenderFns: []}

/***/ }),
/* 3585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInUp",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('mu-card-text', [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelModifyDetails'),
      "titleClass": "largeTitle blueTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.$route.query.hcp) ? _c('p', [_vm._v(_vm._s(_vm.$t('message.modifySubTitle')))]) : _vm._e(), _vm._v(" "), (_vm.$route.query.hcp) ? _c('p', [_vm._v("Join the free Healthcare Professional Platform")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max:40, regex: /^[a-zA-Z ]*$/}"
    }],
    staticStyle: {
      "margin-bottom": "-8px"
    },
    attrs: {
      "id": "firstnameTxt",
      "data-vv-name": "first_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesFirstName'),
      "errorText": _vm.errors.first('first_name'),
      "label": _vm.$t('message.labelYourName'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesFirstName'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.firstname),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstname", $$v)
      },
      expression: "model.firstname"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max:40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "id": "surnameTxt",
      "data-vv-name": "last_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesSurname'),
      "errorText": _vm.errors.first('last_name'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesSurname'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.surname),
      callback: function($$v) {
        _vm.$set(_vm.model, "surname", $$v)
      },
      expression: "model.surname"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "id": "emailTxt",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": "",
      "disabled": true
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "id": "emailTxtV",
      "data-vv-as": _vm.$t('message.accountPreferencesEmailVerify'),
      "label": _vm.$t('message.accountPreferencesEmailVerify'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": "",
      "disabled": true
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n                  Date of birth\n                ")]), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.day),
      expression: "dob.day"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_day')
    },
    attrs: {
      "name": "birth_day",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-as": "day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Day")]), _vm._v(" "), _vm._l((_vm.dobItems.days), function(day, index) {
    return _c('option', {
      key: 'day-' + index,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.month),
      expression: "dob.month"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_month')
    },
    attrs: {
      "name": "birth_month",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-as": "month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._m(0)], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.year),
      expression: "dob.year"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_year')
    },
    attrs: {
      "name": "birth_year",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-as": "year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._m(1)], 2)])], 1), _vm._v(" "), _c('p', {
    staticClass: "privacyDisclaimer",
    on: {
      "click": _vm.setTerms
    }
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.terms),
      callback: function($$v) {
        _vm.terms = $$v
      },
      expression: "terms"
    }
  }), _vm._v("\n                  " + _vm._s(_vm.$t('message.registerTermsByContinuing')) + "\n                  "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "terms"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerTermsAndCondtions')))]), _vm._v("\n                  " + _vm._s(_vm.$t('message.registerTermsJoin')) + " "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "privacy"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerPrivacyPolicy')))]), _vm._v(",\n                  "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "cookies"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerIncludingCookie')))])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": _vm.isSaving ? _vm.$t('message.labelProcessing') : _vm.$t('message.amendAppBarText'),
      "disabled": _vm.isSaving,
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.registerErrorUserExists')) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.isTermsError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    Please agree to our terms and conditions\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.isServerValidationError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.serverValidationErrorText) + "\n                  ")])]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('option', {
      key: 'month-' + index,
      domProps: {
        "value": month
      }
    }, [_vm._v(_vm._s(_vm.localizeMonth(month.name)) + "\n                      ")])
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('option', {
      key: 'year-' + index,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year.value) + "\n                      ")])
  })
}]}

/***/ }),
/* 3586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.state.user.scope) ? _c('ketones-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('ketones-input', {
    staticClass: "card-spacing bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "blood-glucose": _vm.$store.state.user.settings.blood_glucose
    }
  }), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "ketones"
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        class: {
          spacingBottom: item.isControlsVisible
        },
        domProps: {
          "textContent": _vm._s(_vm.$store.state.user.settings.blood_glucose.measure === 'mmoll' ? '' + item.mmoll + ' mmol/L' : item.mgdl + ' mg/dL')
        }
      }) : _vm._e()])], 1), _vm._v(" "), (item.isControlsVisible && !item.isEditMode) ? _c('div', {
        attrs: {
          "align": "right"
        }
      }, [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('ketones-edit', {
        attrs: {
          "preference": _vm.$store.state.user.settings.blood_glucose.measure,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v("One sec...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.initialLoad) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasItems) ? _c('follower-item', {
    attrs: {
      "items": _vm.items,
      "type": "following"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.initialLoad === false || _vm.isLoading === false) ? _c('div', {
    attrs: {
      "id": "infiniteScrollDetector"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.initialLoad && !_vm.hasItems) ? _c('p', [_vm._v("This user isn't following anyone")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "dialog-class": "cardRounded relative",
      "body-class": _vm.modalVisible,
      "open": _vm.showModal
    },
    on: {
      "close": _vm.toggleVisibility
    }
  }, [_c('div', {
    staticClass: "outerWrap"
  }, [(!_vm.saved && !_vm.rejected) ? _c('div', {
    staticClass: "contentWrap"
  }, [_c('button', {
    staticClass: "transparent close"
  }, [_c('mu-icon', {
    staticClass: "closeIcon",
    attrs: {
      "value": "close"
    },
    on: {
      "click": _vm.toggleVisibility
    }
  })], 1), _vm._v(" "), _c('mu-card-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.usernameInitialModalTitle')))]), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalBody')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "full-width": "",
      "hint-text": "Max. 30 characters",
      "label": "Desired Username",
      "data-vv-rules": 'display_name_regex|min:2|max:30',
      "data-vv-name": "displayName",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDisplayName'),
      "errorText": _vm.errors.first('displayName'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesDisplayName')
    },
    model: {
      value: (_vm.displayName),
      callback: function($$v) {
        _vm.displayName = $$v
      },
      expression: "displayName"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalTip')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    staticClass: "spaceBelow"
  }, [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnPrimary btnAction",
    attrs: {
      "primary": true,
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.accept
    }
  }, [_vm._v("\n            " + _vm._s(_vm.saving ? _vm.$t('message.savingText') : _vm.$t('message.usernameInitialModalSave')) + "\n          ")])], 1), _vm._v(" "), _c('mu-row', [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnSecondary btnAction",
    attrs: {
      "secondary": true
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.$t('message.usernameInitialModalReject')) + "\n          ")])], 1)], 1)], 1) : (_vm.saved) ? _c('div', {
    staticClass: "contentWrap"
  }, [_c('mu-card-text', {
    staticClass: "title"
  }, [_c('mu-icon', {
    staticClass: "circleCheck",
    attrs: {
      "value": "check"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalConfirmTitle')) + "\n      ")], 1), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalConfirmBody')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnPrimary btnAction",
    attrs: {
      "primary": true
    },
    on: {
      "click": _vm.toggleVisibility
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelContinueText')) + "\n        ")])], 1)], 1) : (_vm.rejected) ? _c('div', {
    staticClass: "contentWrap"
  }, [_c('mu-card-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.usernameInitialModalRejectTitle')))]), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalRejectBody')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnPrimary btnAction",
    attrs: {
      "primary": true
    },
    on: {
      "click": _vm.toggleVisibility
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelContinueText')) + "\n        ")])], 1)], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 3589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('mu-content-block', [_c('h1', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("My meal plans")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("Browse meal plans generated and saved by you")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "to": "/recipes/generator",
      "label": "Generate meal plan"
    }
  })], 1)]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "align": "left",
      "gutter": ""
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('mu-col', {
      key: 'meal-plan-' + index,
      staticClass: "text-white mealPlan bottom",
      style: ({
        'background': 'url(' + _vm.getImage(item) + ') center center no-repeat no-repeat',
        'backgroundSize': 'cover'
      }),
      attrs: {
        "width": "100",
        "desktop": "50",
        "tablet": "50"
      }
    }, [_c('router-link', {
      staticClass: "text-white",
      attrs: {
        "to": {
          name: 'MealPlanDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "inFront"
    }, [_c('div', [_vm._v("\n            " + _vm._s(item.availableDays.length) + " days\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "recipeTitle"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "absolutePos",
      style: ({
        'backgroundImage': _vm.generateGradient()
      })
    })])], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-raised-button', {
    staticClass: "full-width",
    attrs: {
      "label": "Load more"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadMore.apply(null, arguments)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "sleep-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "12px",
      "viewBox": "20 194 16 12",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.2435599,197.367016 C24.2435599,196.292061 24.5552121,195.286354 25.0950382,194.418171 C25.2258208,194.208164 25.0286034,193.948647 24.7757338,194.008834 C21.8609512,194.705193 19.7527773,197.267998 20.023386,200.25082 C20.279386,203.066347 22.725299,205.364459 25.7496469,205.627858 C27.8480816,205.810684 29.7555599,205.041843 31.0439077,203.735524 C31.2178208,203.558845 31.069299,203.272148 30.8122556,203.282179 C30.7440816,203.285091 30.6748643,203.286385 30.6056469,203.286385 C27.0919077,203.286385 24.2435599,200.636535 24.2435599,197.367016 Z M28.0501686,194.238904 L28.3691251,195.090908 L29.3388643,195.110647 C29.4619947,195.113235 29.5120816,195.258202 29.4146903,195.327126 L28.6421686,195.873017 L28.9221686,196.736669 C28.9583425,196.846041 28.8251251,196.935351 28.7246034,196.870634 L27.927386,196.356131 L27.1308643,196.870634 C27.0299947,196.935675 26.8981686,196.846041 26.9329512,196.736669 L27.2129512,195.873017 L26.4404295,195.327126 C26.3430382,195.258202 26.3938208,195.113235 26.5162556,195.110647 L27.4859947,195.090908 L27.805299,194.238904 C27.8456469,194.13115 28.0094729,194.13115 28.0501686,194.238904 Z M34.0035599,200.982449 L34.3099947,201.801123 L35.2418208,201.819567 C35.3771251,201.82248 35.4327773,201.982008 35.325299,202.058051 L34.5830382,202.582585 L34.8515599,203.412261 C34.8901686,203.532311 34.7440816,203.631329 34.6334729,203.559169 L33.8679077,203.065052 L33.1026903,203.559169 C32.9920816,203.631329 32.8456469,203.532311 32.8849512,203.412261 L33.1534729,202.582585 L32.4115599,202.058051 C32.3037338,201.982331 32.3597338,201.822156 32.4943425,201.819567 L33.4261686,201.801123 L33.7336469,200.982449 C33.7781686,200.864016 33.9586903,200.864016 34.0035599,200.982449 Z M33.887386,195.047224 L34.3482556,196.276529 L35.7468643,196.304358 C35.9040816,196.307593 35.9691251,196.493332 35.8435599,196.581995 L34.7291251,197.369605 L35.133299,198.616384 C35.1788643,198.756497 35.0094729,198.87137 34.8797338,198.787561 L33.7298208,198.045253 L32.5802556,198.787561 C32.4508643,198.87137 32.2811251,198.756173 32.3266903,198.616384 L32.7305164,197.369605 L31.6157338,196.581995 C31.4912121,196.493656 31.5559077,196.30727 31.7127773,196.304358 L33.1117338,196.276529 L33.5722556,195.047224 C33.6254729,194.909376 33.8352121,194.909376 33.887386,195.047224 Z",
      "id": "Combined-Shape",
      "stroke": "none",
      "fill": "#183B43",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": _vm.isOpenInput ? 'remove_circle_outline' : 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "1",
      "max": "24",
      "data-vv-rules": 'required|min_value:1|max_value:24',
      "data-vv-name": "hours",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hours'),
      "type": "number",
      "label": _vm.$t('message.labelHours'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hours),
      callback: function($$v) {
        _vm.$set(_vm.model, "hours", _vm._n($$v))
      },
      expression: "model.hours"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": "required|min_value:1|max_value:10",
      "data-vv-name": "quality",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('quality'),
      "type": "number",
      "label": _vm.$t('message.cardSleepQuality'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.quality),
      callback: function($$v) {
        _vm.$set(_vm.model, "quality", _vm._n($$v))
      },
      expression: "model.quality"
    }
  }), _vm._v(" "), _c('vue-slider', _vm._b({
    model: {
      value: (_vm.model.quality),
      callback: function($$v) {
        _vm.$set(_vm.model, "quality", $$v)
      },
      expression: "model.quality"
    }
  }, 'vue-slider', _vm.sliderSettings, false)), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.model.quality)
    }
  }), _vm._v("/10")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading || (_vm.posts.length === 0 && _vm.isLoading === false)),
      expression: "isLoading || (posts.length === 0 && isLoading === false)"
    }],
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")])]), _vm._v(" "), (_vm.isLoading === false && _vm.posts.length > 0) ? _c('div', {
    attrs: {
      "id": "lifeView"
    }
  }, [_c('div', {
    staticClass: "life-header",
    style: (("background-position: center center;background-size: cover;background-image: linear-gradient(180deg,rgba(0,0,0,.68),rgba(0,0,0,.68)),url(" + (_vm.posts[0].post_image) + ");"))
  }, [_c('span', [_vm._v("Trending now")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.posts[0].post_title))]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "to": ("life/" + (_vm.posts[0].post_slug)),
      "label": "Read now"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('life-search-bar')], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "75"
    }
  }, [(_vm.hasRecommendations && !_vm.isHcpView) ? _c('div', {
    staticClass: "section",
    attrs: {
      "id": "lifeRecommendations"
    }
  }, [_c('h2', [_vm._v("Recommended reading")]), _vm._v(" "), _c('mu-flexbox', {
    attrs: {
      "justify": "flex-start",
      "align": "stretch",
      "wrap": "wrap"
    }
  }, _vm._l((_vm.shuffleRecommendations), function(post, index) {
    return (index <= 2) ? _c('mu-flexbox-item', {
      key: ("recommendation-" + index),
      attrs: {
        "basis": "25%"
      }
    }, [_c('life-post-info', {
      attrs: {
        "slug": post.post_slug,
        "image": post.post_image,
        "title": post.post_title,
        "time": post.post_date,
        "favourites": post.post_favourites
      }
    })], 1) : _vm._e()
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.lifeBrowseCategory'))
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listCats"
    }
  }, [_c('div', {
    staticClass: "cat-col"
  }, [_c('mu-card', {
    staticClass: "cat",
    staticStyle: {
      "background-image": "url('static/life/coffee-heart.jpg')"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/life/my-favourites"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToFavourites()
      }
    }
  }, [_c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "catMeta"
  }, [_c('h3', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.lifeMyFavourites'))
    }
  })])])])], 1)], 1), _vm._v(" "), _vm._l((_vm.cats), function(cat, index) {
    return (cat.count !== 0) ? _c('div', {
      key: 'cat-' + index,
      staticClass: "cat-col"
    }, [_c('mu-card', {
      staticClass: "cat",
      style: ({
        'background-image': 'url(' + cat.image + ')'
      })
    }, [_c('router-link', {
      attrs: {
        "to": {}
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(cat.slug)
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }, [_c('div', {
      staticClass: "catMeta"
    }, [_c('h3', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.localizeLifeCat(cat.term_id) || cat.name))
      }
    }), _vm._v(" "), _vm._o(_c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(cat.count) + " " + _vm._s(cat.count === 1 ? _vm.$t('message.labelArticle') : _vm.$t('message.labelArticles')))]), 0, 'cat-' + index)])])])], 1)], 1) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "25"
    }
  }, [(_vm.posts.length) ? _c('div', {
    attrs: {
      "id": "lifeSideBar"
    }
  }, _vm._l((_vm.posts), function(post, index) {
    return _c('div', {
      key: ("sidepost-" + index),
      staticClass: "sidePost"
    }, [_c('life-post-info', {
      attrs: {
        "slug": post.post_slug,
        "image": post.post_image,
        "title": post.post_title,
        "time": post.post_date,
        "favourites": post.post_favourites
      }
    })], 1)
  }), 0) : _vm._e()])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-dropDown-menu",
    class: {
      'disabled': _vm.disabled
    }
  }, [_c('svg', {
    staticClass: "mu-dropDown-menu-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mu-dropDown-menu-text",
    class: _vm.labelClass,
    on: {
      "click": _vm.handleOpen
    }
  }, [_c('div', {
    staticClass: "mu-dropDown-menu-text-overflow"
  }, [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
    staticClass: "mu-dropDown-menu-line",
    class: _vm.underlineClass
  }), _vm._v(" "), (!_vm.disabled && _vm.$slots && _vm.$slots.default && _vm.$slots.default.length > 0) ? _c('popover', {
    attrs: {
      "scroller": _vm.scroller,
      "open": _vm.openMenu,
      "trigger": _vm.trigger,
      "anchorOrigin": _vm.anchorOrigin
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('mu-menu', {
    class: _vm.menuClass,
    style: ({
      width: _vm.menuWidth + 'px'
    }),
    attrs: {
      "listClass": _vm.menuListClass,
      "value": _vm.value,
      "multiple": _vm.multiple,
      "autoWidth": _vm.autoWidth,
      "popover": _vm.openMenu,
      "desktop": "",
      "maxHeight": _vm.maxHeight
    },
    on: {
      "change": _vm.change,
      "itemClick": _vm.itemClick
    }
  }, [_vm._t("default")], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mu-expand"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.state.user.scope && _vm.activeTab === 'weight') ? _c('weight-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope && _vm.activeTab === 'waist-hip') ? _c('waist-hip-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [(_vm.$store.state.user.settings) ? _c('weight-input', {
    staticClass: "card-spacing bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "height": _vm.$store.state.user.settings.height,
      "weight": _vm.$store.state.user.settings.weight,
      "waist": _vm.$store.state.user.settings.waist
    }
  }) : _vm._e(), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "weight"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-tabs', {
    staticClass: "weight-tabs",
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    staticClass: "tabTitle",
    attrs: {
      "value": "weight",
      "title": "WEIGHT"
    }
  }), _vm._v(" "), _c('mu-tab', {
    staticClass: "tabTitle",
    attrs: {
      "value": "waist-hip",
      "title": "WAIST-HIP"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), (_vm.activeTab === 'weight') ? _c('div', [_c('mu-timeline', _vm._l((_vm.groupFilter(_vm.activeTab)), function(group, groupKey) {
    return _c('div', {
      key: 'group-filter-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'group-inner-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'group-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-icon', {
        class: _vm.decideWhetherLostOrGained(item),
        staticStyle: {
          "margin-left": "-4px"
        },
        attrs: {
          "slot": "icon",
          "value": _vm.determineIcon(item)
        },
        slot: "icon"
      }), _vm._v(" "), (item.image) ? _c('div', [(item.image) ? _c('img', {
        attrs: {
          "width": "50%",
          "src": item.image
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [(_vm.$store.state.user.settings.weight.measure === 'kg') ? _c('div', [(item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: ('From device: ' + item.userDevice.nickname),
          expression: "'From device: ' +  item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "2px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "18",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(item.kg + ' kg')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'lbs') ? _c('div', [(item.userDevice && item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: ('From device: ' + item.userDevice.nickname),
          expression: "'From device: ' +  item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "2px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "18",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(item.lbs + ' lbs')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('div', [(item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: ('From device: ' + item.userDevice.nickname),
          expression: "'From device: ' +  item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "2px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "18",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(item.stones + 'st ' + item.pounds + ' lbs')
        }
      })]) : _vm._e()]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('weight-edit', {
        attrs: {
          "preference": _vm.$store.state.user.settings.weight.measure,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v("One sec...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'waist-hip') ? _c('div', [(!_vm.isReadingsLoading) ? _c('mu-timeline', _vm._l((_vm.groupFilter(_vm.activeTab)), function(group, groupKey) {
    return _c('div', {
      key: 'group-filter-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'group-inner-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'group-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControlsWaistHip(item)
          }
        }
      }, [_c('mu-icon', {
        class: _vm.determineLostOrGainedWaistHip(item),
        staticStyle: {
          "margin-left": "-4px"
        },
        attrs: {
          "slot": "icon",
          "value": _vm.determineIcon(item)
        },
        slot: "icon"
      }), _vm._v(" "), (item.image) ? _c('div', [(item.image) ? _c('img', {
        attrs: {
          "width": "50%",
          "src": item.image
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        staticStyle: {
          "text-align": "right"
        }
      }, [(_vm.$store.state.user.settings.waist.measure === 'cm') ? _c('div', [(typeof(item.ratio_cm) === 'number') ? _c('span', {
        domProps: {
          "textContent": _vm._s(item.ratio_cm.toFixed(2))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "block"
        },
        domProps: {
          "textContent": _vm._s('(' + item.waist_cm + 'cm/' + item.hip_cm + 'cm)')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.waist.measure === 'in') ? _c('div', [(typeof(item.ratio_in) === 'number') ? _c('span', {
        domProps: {
          "textContent": _vm._s(item.ratio_in.toFixed(2))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "block"
        },
        domProps: {
          "textContent": _vm._s('(' + item.waist_in + 'in/' + item.hip_in + 'in)')
        }
      })]) : _vm._e()]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReadingWaistHip(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteWaistHipReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('waist-hip-edit', {
        attrs: {
          "preference": _vm.$store.state.user.settings.waist.measure,
          "item": item
        },
        on: {
          "updateReading": _vm.updateWaistHipReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditModeWaistHip(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v("One sec...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.data) ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "24px",
      "margin-top": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-self": "center"
    }
  }, _vm._l((_vm.data.days), function(day, dayIndex) {
    return (_vm.data.availableDays.includes(day.name)) ? _c('mu-float-button', {
      key: 'day-' + dayIndex,
      staticClass: "day-button",
      class: {
        'activeDay': day.name === _vm.activeDay
      },
      staticStyle: {
        "margin": "2px"
      },
      attrs: {
        "mini": "",
        "label": "M"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setDay(day.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(day.label) + "\n        ")]) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-content-block', [(_vm.data) ? _c('h1', [_vm._v(_vm._s(_vm.data.name))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "24px"
    }
  }, [_vm._v(_vm._s(_vm.data.availableDays.length) + " day meal plan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [(_vm.readonly) ? _c('mu-raised-button', {
    attrs: {
      "icon": "delete",
      "label": "Delete"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteMealPlan.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Create a new meal plan based of this one.'),
      expression: "'Create a new meal plan based of this one.'",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "icon": _vm.readonly ? 'save_alt' : 'cancel',
      "label": _vm.readonly ? 'Create from' : 'Cancel'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleReadonly.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (!_vm.readonly) ? _c('mu-raised-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Save as new meal'),
      expression: "'Save as new meal'",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "primary": "",
      "icon": "check",
      "label": _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openModal.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), (_vm.data.availableMeals.includes('BREAKFAST')) ? _c('meal-plan-panel', {
    attrs: {
      "readonly": _vm.readonly,
      "activeDay": _vm.activeDay,
      "type": "breakfast",
      "recipe": _vm.activeBreakfastForDay
    },
    on: {
      "changed": _vm.pushToBreakfast
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.availableMeals.includes('LUNCH')) ? _c('meal-plan-panel', {
    attrs: {
      "readonly": _vm.readonly,
      "activeDay": _vm.activeDay,
      "type": "lunch",
      "recipe": _vm.activeLunchForDay
    },
    on: {
      "changed": _vm.pushToLunch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.availableMeals.includes('DINNER')) ? _c('meal-plan-panel', {
    attrs: {
      "readonly": _vm.readonly,
      "activeDay": _vm.activeDay,
      "type": "dinner",
      "recipe": _vm.activeDinnerForDay
    },
    on: {
      "changed": _vm.pushToDinner
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "title": "Give your meal plan a name"
    },
    on: {
      "close": function($event) {
        _vm.dialogOpen = false
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMealPlan.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    attrs: {
      "full-width": "",
      "label": "Name",
      "hint-text": "Enter a name for your meal plan"
    },
    model: {
      value: (_vm.custom.name),
      callback: function($$v) {
        _vm.$set(_vm.custom, "name", $$v)
      },
      expression: "custom.name"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.cancelText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "slot": "actions",
      "type": "button",
      "primary": "",
      "label": _vm.$t('message.okText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveMealPlan.apply(null, arguments)
      }
    },
    slot: "actions"
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "food-diary"
    }
  }, [_c('mu-paper', {
    staticClass: "foodbar"
  }, [_c('mu-content-block', {
    staticClass: "foodBar inner"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "25",
      "tablet": "30",
      "align": "right"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subtractDay()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticStyle: {
      "flex": "auto"
    },
    attrs: {
      "width": "50",
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "46px"
    },
    attrs: {
      "align": "center center",
      "justify": "center center"
    }
  }, [_c('mu-flexbox-item', {
    ref: "datepicker",
    staticClass: "c-datepicker-btn mediumTitle",
    attrs: {
      "align": "center",
      "grow": ""
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "justify": "center center",
      "align": "center",
      "wrap": "disallow"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-date-picker', {
    staticClass: "hiddenPicker",
    attrs: {
      "inputClass": "datePicker",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.currentDate.ddmmyy),
      callback: function($$v) {
        _vm.$set(_vm.currentDate, "ddmmyy", $$v)
      },
      expression: "currentDate.ddmmyy"
    }
  }), _vm._v(" "), _c('span', [_c('mu-icon', {
    staticStyle: {
      "position": "relative",
      "top": "4px"
    },
    attrs: {
      "value": "date_range"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.currentDate.presentational) + "\n                  ")], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "25",
      "tablet": "30",
      "align": "left"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDay()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "foodbar",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "controls"
    }
  }, [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('mu-raised-button', {
    attrs: {
      "fullWidth": "",
      "label": "Add food"
    }
  })], 1), _vm._v(" "), (!_vm.isToday(_vm.currentDate.actual)) ? _c('mu-flexbox-item', {
    attrs: {
      "align": "left"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "fullWidth": "",
      "secondary": "",
      "label": _vm.$t('message.labelToday')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setToday()
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "intakebar desktop bottom"
  }, [_c('mu-content-block', {
    staticClass: "content"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "mediumTitle progress-item",
    domProps: {
      "textContent": _vm._s(_vm.isToday(_vm.currentDate.actual) ? _vm.$t('message.foodDiaryIntakeBar') : _vm.$t('message.foodDiaryIntakeBarNotToday'))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.foodDiaryTodayYouveHad')) + "\n          ")]), _vm._v(" "), _c('ProgressItem', {
    attrs: {
      "bar-mode": _vm.barMode,
      "color": "#4ed8da",
      "total": _vm.getNutrientDisplayValue(_vm.nutritionTargets.carbohydrate, 'carbohydrate'),
      "unit": this.nutritionUnit,
      "value": _vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate'),
      "label": "carbs"
    }
  }), _vm._v(" "), _c('ProgressItem', {
    attrs: {
      "bar-mode": _vm.barMode,
      "color": "#c04dd8",
      "total": _vm.getNutrientDisplayValue(_vm.nutritionTargets.fat, 'fat'),
      "unit": this.nutritionUnit,
      "value": _vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat'),
      "label": "fat"
    }
  }), _vm._v(" "), _c('ProgressItem', {
    attrs: {
      "bar-mode": _vm.barMode,
      "color": "#e06950",
      "total": _vm.getNutrientDisplayValue(_vm.nutritionTargets.protein, 'protein'),
      "unit": this.nutritionUnit,
      "value": _vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein'),
      "last": true,
      "label": "protein"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "id": 'editNutritionUnit',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": "Configure Charts",
      "icon": "settings",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('editNutritionUnitDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "id": 'setTargets',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": _vm.$t('message.foodDiaryModifyTargets'),
      "icon": "edit",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('setTargetsDialog')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "holdDoughnut",
    staticStyle: {
      "margin-top": "-8px"
    },
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "innerDoughnut",
    staticStyle: {
      "height": "201px"
    }
  }, [(_vm.barMode === 'indeterminate') ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%",
      "margin-top": "16px"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 156
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.barMode === 'indeterminate') ? _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "align": "center",
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.loadingText')) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate' && _vm.totals.all.calories === 0) ? _c('food-pie-empty', {
    staticClass: "foodPie"
  }) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate' && _vm.totals.all.calories > 0) ? _c('food-pie', {
    staticClass: "foodPie",
    attrs: {
      "fat": _vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat'),
      "carbs": _vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate'),
      "protein": _vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein'),
      "calories": _vm.totals.all.calories
    }
  }) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate') ? _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#4ed8da !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#c04dd8 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#e06950 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  })])], 1) : _vm._e()], 1)])], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "intakebar mobile bottom",
    staticStyle: {
      "padding": "24px"
    }
  }, [_c('mu-content-block', [_c('md-boards', {
    attrs: {
      "md-auto": false,
      "md-swipeable": true
    }
  }, [_c('md-board', [_c('div', [(_vm.barMode === 'indeterminate') ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%",
      "margin-top": "16px"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "height": "148px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 74
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('message.loadingText')) + "\n              ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate') ? _c('div', {
    staticStyle: {
      "height": "148px"
    }
  }, [(_vm.totals.all.calories === 0) ? _c('food-pie-empty', {
    staticStyle: {
      "height": "148px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totals.all.calories > 0) ? _c('food-pie', {
    staticStyle: {
      "height": "148px"
    },
    attrs: {
      "fat": _vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat'),
      "carbs": _vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate'),
      "protein": _vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein'),
      "calories": _vm.totals.all.calories
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate') ? _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#4ed8da !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#c04dd8 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#e06950 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  })])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('md-board', [_c('div', {
    staticClass: "mediumTitle progress-item",
    domProps: {
      "textContent": _vm._s(_vm.isToday(_vm.currentDate.actual) ? _vm.$t('message.foodDiaryIntakeBar') : _vm.$t('message.foodDiaryIntakeBarNotToday'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-item"
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  }), _vm._v(":\n              " + _vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate', true)))]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? 'rgba(78, 216, 218, 0.24)' : '#4ed8da',
      "size": 16,
      "mode": _vm.barMode,
      "value": (_vm.totals.all.carbohydrate) ? (_vm.totals.all.carbohydrate / _vm.nutritionTargets.carbohydrate * 100) : 0
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress-item"
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }), _vm._v(":\n              " + _vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat', true)))]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? 'rgba(192, 77, 216, 0.24)' : '#c04dd8',
      "size": 16,
      "mode": _vm.barMode,
      "value": (_vm.totals.all.fat) ? (_vm.totals.all.fat / _vm.nutritionTargets.fat * 100) : 0
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress-item last"
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  }), _vm._v(":\n              " + _vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein', true)))]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? 'rgba(224, 105, 80, 0.24)' : '#e06950',
      "size": 16,
      "mode": _vm.barMode,
      "value": (_vm.totals.all.protein) ? (_vm.totals.all.protein / _vm.nutritionTargets.protein * 100) : 0
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "id": 'editNutritionUnit',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": "Configure Charts",
      "icon": "settings",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('editNutritionUnitDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "id": 'setTargets',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": _vm.$t('message.foodDiaryModifyTargets'),
      "icon": "edit",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('setTargetsDialog')
      }
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content bottom"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-raised-button', {
    staticStyle: {
      "height": "54px",
      "color": "#0179d5"
    },
    attrs: {
      "icon": "equalizer",
      "label": _vm.$t('message.labelViewHistory'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('FoodDiaryHistory')
      }
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-raised-button', {
    staticStyle: {
      "height": "54px",
      "color": "#0179d5"
    },
    attrs: {
      "icon": "file_download",
      "label": _vm.$t('message.exportTextData'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('exportDataDialog')
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "setTargetsDialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.foodDiaryNutritionPanelHeaderText'),
      "subTitle": _vm.$t('message.foodDiaryNutritionPanelSubHeaderText'),
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "label": _vm.$t('message.labelNutrientTargetHelpText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.preset),
      callback: function($$v) {
        _vm.preset = $$v
      },
      expression: "preset"
    }
  }, _vm._l((_vm.nutrientPresets), function(item, index) {
    return _c('mu-menu-item', {
      key: 'preset-' + index,
      attrs: {
        "title": item.name,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('form', [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0179d5"
    },
    domProps: {
      "textContent": _vm._s(_vm.settingsModel.carbohydrate + 'g')
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    },
    domProps: {
      "textContent": _vm._s(300 + 'g')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-slider', {
    staticClass: "carbohydrate-slider",
    attrs: {
      "step": 1,
      "max": 300
    },
    model: {
      value: (_vm.settingsModel.carbohydrate),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "carbohydrate", _vm._n($$v))
      },
      expression: "settingsModel.carbohydrate"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff895e"
    },
    domProps: {
      "textContent": _vm._s(_vm.settingsModel.fat + 'g')
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    },
    domProps: {
      "textContent": _vm._s(350 + 'g')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-slider', {
    staticClass: "fat-slider",
    attrs: {
      "step": 1,
      "max": 350
    },
    model: {
      value: (_vm.settingsModel.fat),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "fat", _vm._n($$v))
      },
      expression: "settingsModel.fat"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff5a5f"
    },
    domProps: {
      "textContent": _vm._s(_vm.settingsModel.protein + 'g')
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    },
    domProps: {
      "textContent": _vm._s(350 + 'g')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-slider', {
    staticClass: "protein-slider",
    attrs: {
      "step": 1,
      "max": 350
    },
    model: {
      value: (_vm.settingsModel.protein),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "protein", _vm._n($$v))
      },
      expression: "settingsModel.protein"
    }
  })], 1)])], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('setTargetsDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": _vm.isSettingsUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateTargets.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "exportDataDialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.foodDiaryExportDataTitle'),
      "subTitle": _vm.$t('message.foodDiaryExportDataSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelFromDate'),
      "dateTimeFormat": _vm.dateFormat,
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.exportDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.exportDate, "fromDate", $$v)
      },
      expression: "exportDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelToDate'),
      "dateTimeFormat": _vm.dateFormat,
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.exportDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.exportDate, "toDate", $$v)
      },
      expression: "exportDate.toDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('exportDataDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "disabled": _vm.isExporting,
      "label": _vm.isExporting ? _vm.$t('message.exportingText') : _vm.$t('message.exportText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exportData.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "addFoodDialog",
    staticClass: "food-dialog-container",
    on: {
      "close": _vm.onFoodDialogClose,
      "open": _vm.onFoodDialogOpen
    }
  }, [_c('div', {
    staticClass: "add-food-dialog",
    class: {
      extraHeight: _vm.activeDialogMethod === 'searchResult'
    }
  }, [(_vm.activeDialogMethod === null) ? _c('fd-landing-dialog', {
    attrs: {
      "title": _vm.activeMealType.panelTitle,
      "mealTypeId": _vm.activeMealType.mealTypeId,
      "date": _vm.currentDate.actual.format()
    },
    on: {
      "choseToSearchWith": _vm.searchMethod,
      "closeDialogAndReload": function($event) {
        return _vm.closeDialogAndReload('addFoodDialog')
      },
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      },
      "onRecentItemSelected": _vm.selectRecent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'autocomplete') ? _c('fd-autocomplete-dialog', {
    attrs: {
      "searchTerm": _vm.selectedSearchTerm,
      "title": _vm.activeMealType.panelTitle
    },
    on: {
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      },
      "foodNameSelected": _vm.foodNameSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'mymeals') ? _c('fd-mymeals-dialog', {
    attrs: {
      "mealTypeId": _vm.activeMealType.mealTypeId,
      "date": _vm.currentDate.actual.format(),
      "title": _vm.activeMealType.panelTitle
    },
    on: {
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      },
      "closeDialogAndReload": function($event) {
        return _vm.closeDialogAndReload('addFoodDialog')
      },
      "foodNameSelected": _vm.foodNameSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'searchResults') ? _c('fd-search-results-dialog', {
    attrs: {
      "title": _vm.activeMealType.panelTitle,
      "searchTerm": _vm.selectedSearchTerm
    },
    on: {
      "goBack": _vm.searchMethod,
      "foodSelected": _vm.foodSelected,
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'searchResult' || _vm.activeDialogMethod === 'editResult') ? _c('fd-food-result-dialog', {
    attrs: {
      "inputDate": _vm.currentDate.ddmmyy,
      "title": _vm.activeMealType.panelTitle,
      "mealTypeId": _vm.activeMealType.mealTypeId,
      "foodId": _vm.foodResultId,
      "mode": _vm.foodResultMode
    },
    on: {
      "foodAdded": function($event) {
        return _vm.getData()
      },
      "goBack": _vm.searchMethod,
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('md-dialog', {
    ref: "editFoodDialog",
    staticClass: "food-dialog-container",
    on: {
      "close": _vm.onEditDialogClose
    }
  }, [_c('mu-card', {
    staticClass: "add-food-dialog",
    class: {
      extraHeight: _vm.selectedFood.fs_food_id
    }
  }, [(_vm.selectedFood.fs_food_id) ? _c('fd-edit-food-dialog', {
    attrs: {
      "mealTypeId": 1,
      "foodObj": _vm.selectedFood
    },
    on: {
      "closeDialog": function($event) {
        return _vm.closeDialog('editFoodDialog')
      },
      "foodUpdated": function($event) {
        return _vm.getData()
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.breakfast,
      "foods": _vm.foods.breakfast,
      "recipes": _vm.recipes.breakfast,
      "mealTypeTitle": _vm.$t('message.foodDiaryBreakfast'),
      "mealType": "breakfast",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeBreakfast,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingBreakfast'),
          mealType: 'breakfast',
          mealTypeId: 1
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.lunch,
      "foods": _vm.foods.lunch,
      "recipes": _vm.recipes.lunch,
      "mealTypeTitle": _vm.$t('message.foodDiaryLunch'),
      "mealType": "lunch",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeLunch,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingLunch'),
          mealType: 'lunch',
          mealTypeId: 2
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.dinner,
      "foods": _vm.foods.dinner,
      "recipes": _vm.recipes.dinner,
      "mealTypeTitle": _vm.$t('message.foodDiaryDinner'),
      "mealType": "dinner",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeDinner,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingDinner'),
          mealType: 'dinner',
          mealTypeId: 3
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.snack,
      "foods": _vm.foods.snack,
      "recipes": _vm.recipes.snack,
      "mealTypeTitle": _vm.$t('message.foodDiarySnack'),
      "mealType": "snack",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeSnack,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingSnack'),
          mealType: 'snack',
          mealTypeId: 4
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('NutritionUnitDialog', {
    ref: "editNutritionUnitDialog",
    attrs: {
      "initialUnit": _vm.nutritionUnit
    },
    on: {
      "nutritionUnitChanged": _vm.onNutritionUnitUpdate,
      "close": function($event) {
        return _vm.closeDialog('editNutritionUnitDialog')
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isHcpView) ? _c('hcp-downloads') : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('patient-downloads') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "blood-pressure-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardLatestReading')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.latest_systolic + '/' + _vm.data.latest_diastolic + ' mmHG')
    }
  })])])], 1)], 1), _vm._v(" "), (_vm.data.previous_systolic !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardPreviousReading')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.previous_systolic + '/' + _vm.data.previous_diastolic + 'mmHG')
    }
  })])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "10px",
      "viewBox": "20 195 16 10",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.000831,196.05636 C32.0007895,196.056319 32.0007064,196.056319 32.0006648,196.056278 C29.5330536,194.647969 26.4672788,194.647887 23.999626,196.056155 C23.9995014,196.056237 23.9993352,196.056278 23.9992105,196.05636 C21.6008227,197.424633 20,199.980785 20,202.890183 C20,203.059962 20.1395272,203.197531 20.31163,203.197531 L26.1818257,203.197531 C26.3304109,204.054991 27.0889184,204.709847 28,204.709847 C28.9149458,204.709847 29.6534259,204.084537 29.8156812,203.197531 L35.68837,203.197531 C35.8604728,203.197531 36,203.059962 36,202.890183 C36.0000416,199.979638 34.3982216,197.424059 32.000831,196.05636 L32.000831,196.05636 Z M28.0000416,204.095151 C27.326339,204.095151 26.7782441,203.554628 26.7782441,202.890183 C26.7782441,202.22668 27.3266298,201.685091 28.0001247,201.685091 C28.6587859,201.685091 29.2129056,202.206559 29.2215482,202.874118 C29.2187643,203.485085 28.7620809,204.095151 28.0000416,204.095151 L28.0000416,204.095151 Z M29.710558,202.195043 C29.655171,202.06272 29.583413,201.936707 29.4958242,201.819587 L30.3388873,201.602599 L29.710558,202.195043 L29.710558,202.195043 Z M30.2012715,202.582794 L31.6378444,201.228167 C31.8691985,201.00995 31.6538829,200.628962 31.3437903,200.708626 L29.334192,201.225872 L31.9554577,196.748098 C33.9382142,197.992776 35.2657581,200.135606 35.370258,202.582794 L30.2012715,202.582794 L30.2012715,202.582794 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#FA6956",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen
    },
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "30",
      "max": "300",
      "data-vv-validate-on": "none",
      "data-vv-rules": "required|min_value:30|max_value:300",
      "data-vv-name": "systolic",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelSystolic'),
      "errorText": _vm.errors.first('systolic'),
      "label": _vm.$t('message.labelSystolic'),
      "hintText": _vm.$t('message.cardBloodPressuremmHGPlaceholder'),
      "fullWidth": true,
      "helpText": 'mmHG'
    },
    model: {
      value: (_vm.model.systolic),
      callback: function($$v) {
        _vm.$set(_vm.model, "systolic", _vm._n($$v))
      },
      expression: "model.systolic"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "30",
      "max": "300",
      "data-vv-validate-on": "none",
      "data-vv-rules": "required|min_value:30|max_value:300",
      "data-vv-name": "diastolic",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelDiastolic'),
      "errorText": _vm.errors.first('diastolic'),
      "label": _vm.$t('message.labelDiastolic'),
      "hintText": _vm.$t('message.cardBloodPressuremmHGPlaceholder'),
      "fullWidth": true,
      "helpText": 'mmHG'
    },
    model: {
      value: (_vm.model.diastolic),
      callback: function($$v) {
        _vm.$set(_vm.model, "diastolic", _vm._n($$v))
      },
      expression: "model.diastolic"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading()
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "sleep-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.hasWearableAndNoSelfReportedReadings || _vm.isWearableMoreRecent) ? _c('div', {
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTimeInBed'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearableDuration)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTimeAsleep'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearableAsleepDuration)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTonightsPrediction'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearablePredictionDuration)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelEfficiency'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.wearable.efficiency + '%')
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelTimeAwake'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.wearableTimeAwake)
    }
  })])])], 1)], 1)], 1) : _c('div', [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n              "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepLastNight'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.hours)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepAverage'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.average)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepQuality'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.quality + '/10')
    }
  })])], 1)], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "12px",
      "viewBox": "20 194 16 12",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.2435599,197.367016 C24.2435599,196.292061 24.5552121,195.286354 25.0950382,194.418171 C25.2258208,194.208164 25.0286034,193.948647 24.7757338,194.008834 C21.8609512,194.705193 19.7527773,197.267998 20.023386,200.25082 C20.279386,203.066347 22.725299,205.364459 25.7496469,205.627858 C27.8480816,205.810684 29.7555599,205.041843 31.0439077,203.735524 C31.2178208,203.558845 31.069299,203.272148 30.8122556,203.282179 C30.7440816,203.285091 30.6748643,203.286385 30.6056469,203.286385 C27.0919077,203.286385 24.2435599,200.636535 24.2435599,197.367016 Z M28.0501686,194.238904 L28.3691251,195.090908 L29.3388643,195.110647 C29.4619947,195.113235 29.5120816,195.258202 29.4146903,195.327126 L28.6421686,195.873017 L28.9221686,196.736669 C28.9583425,196.846041 28.8251251,196.935351 28.7246034,196.870634 L27.927386,196.356131 L27.1308643,196.870634 C27.0299947,196.935675 26.8981686,196.846041 26.9329512,196.736669 L27.2129512,195.873017 L26.4404295,195.327126 C26.3430382,195.258202 26.3938208,195.113235 26.5162556,195.110647 L27.4859947,195.090908 L27.805299,194.238904 C27.8456469,194.13115 28.0094729,194.13115 28.0501686,194.238904 Z M34.0035599,200.982449 L34.3099947,201.801123 L35.2418208,201.819567 C35.3771251,201.82248 35.4327773,201.982008 35.325299,202.058051 L34.5830382,202.582585 L34.8515599,203.412261 C34.8901686,203.532311 34.7440816,203.631329 34.6334729,203.559169 L33.8679077,203.065052 L33.1026903,203.559169 C32.9920816,203.631329 32.8456469,203.532311 32.8849512,203.412261 L33.1534729,202.582585 L32.4115599,202.058051 C32.3037338,201.982331 32.3597338,201.822156 32.4943425,201.819567 L33.4261686,201.801123 L33.7336469,200.982449 C33.7781686,200.864016 33.9586903,200.864016 34.0035599,200.982449 Z M33.887386,195.047224 L34.3482556,196.276529 L35.7468643,196.304358 C35.9040816,196.307593 35.9691251,196.493332 35.8435599,196.581995 L34.7291251,197.369605 L35.133299,198.616384 C35.1788643,198.756497 35.0094729,198.87137 34.8797338,198.787561 L33.7298208,198.045253 L32.5802556,198.787561 C32.4508643,198.87137 32.2811251,198.756173 32.3266903,198.616384 L32.7305164,197.369605 L31.6157338,196.581995 C31.4912121,196.493656 31.5559077,196.30727 31.7127773,196.304358 L33.1117338,196.276529 L33.5722556,195.047224 C33.6254729,194.909376 33.8352121,194.909376 33.887386,195.047224 Z",
      "id": "Combined-Shape",
      "stroke": "none",
      "fill": "#183B43",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen || _vm.loading
    },
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": _vm.isOpenInput ? 'remove' : 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "1",
      "max": "24",
      "data-vv-rules": 'required|min_value:1|max_value:24',
      "data-vv-name": "hours",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelHours'),
      "errorText": _vm.errors.first('hours'),
      "type": "number",
      "label": _vm.$t('message.labelHours'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hours),
      callback: function($$v) {
        _vm.$set(_vm.model, "hours", _vm._n($$v))
      },
      expression: "model.hours"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('label', {
    staticClass: "mu-text-field-label sliderTitle",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardSleepQuality'))
    }
  }), _vm._v(" "), _c('vue-slider', _vm._b({
    model: {
      value: (_vm.model.quality),
      callback: function($$v) {
        _vm.$set(_vm.model, "quality", $$v)
      },
      expression: "model.quality"
    }
  }, 'vue-slider', _vm.sliderSettings, false)), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.model.quality)
    }
  }), _vm._v("/10")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHcpView) ? _c('div', [_c('div', {
    staticClass: "gridlist-container"
  }, [_c('mu-grid-list', {
    staticClass: "article"
  }, [_vm._l((_vm.dummy), function(post, index) {
    return (_vm.isLoading) ? _c('mu-grid-tile', {
      key: ("post-" + index),
      staticClass: "pointer"
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.posts), function(post, index) {
    return (!_vm.isLoading) ? _c('mu-grid-tile', {
      key: ("post-" + index),
      staticClass: "pointer",
      nativeOn: {
        "click": function($event) {
          return _vm.goToModule(post.post_slug)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": post.post_video_thumb
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(post.post_title))])]) : _vm._e()
  })], 2)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "top-contributors"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.discussionTopContributorsTitle'),
      "subTitle": _vm.$t('message.discussionTopContributorsSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-flexbox', [_vm._l((5), function(item, index) {
    return (_vm.isLoading) ? _c('mu-flexbox-item', {
      key: 'contributor-loading-' + index
    }, [_c('mu-avatar', {
      attrs: {
        "backgroundColor": "#E9E9E8",
        "size": 40
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (!_vm.isLoading) ? _c('mu-flexbox-item', {
      key: 'contributor-' + index
    }, [_c('mu-avatar', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.bottom",
        value: (item.display_name),
        expression: "item.display_name",
        modifiers: {
          "bottom": true
        }
      }],
      attrs: {
        "src": item.image,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(item.profile_url)
        }
      }
    })], 1) : _vm._e()
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-list', {
    attrs: {
      "id": "hcp-recent-questions"
    }
  }, [_vm._l((_vm.amount), function(item, index) {
    return (_vm.isLoading) ? _c('mu-list-item', {
      key: 'dummy-loader-' + index,
      staticClass: "noCursor",
      attrs: {
        "title": item.display_name
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "14px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      style: ({
        width: _vm.getRandomArbitrary(40, 50)
      }),
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.image,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 0, 'dummy-loader-' + index), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "12px",
        "width": "15%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.questions), function(q, index) {
    return _c('div', {
      key: ("question-" + index),
      staticClass: "item-wrap"
    }, [(!_vm.isLoading) ? _c('mu-list-item', {
      attrs: {
        "titleClass": "blueTitle",
        "title": q.question,
        "describeText": ("by " + (q.display_name ? q.display_name : q.firstname + ' ' + q.surname) + ", " + (_vm.date(q.timestamp))),
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToQuestionThread(q.question_id)
        }
      }
    }, [(!q.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n        " + _vm._s(_vm.upperTwoInitials(q.display_name ? q.display_name : q.firstname + ' ' + q.surname)) + "\n      ")]) : _vm._e(), _vm._v(" "), (q.profile_large) ? _vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": q.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 1, ("question-" + index)) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "q-stats",
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(((q.likes) + " likes"))
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(((q.replies) + " replies"))
      }
    })])], 1) : _vm._e(), _vm._v(" "), (index + 1 !== _vm.questions.length) ? _c('mu-divider', {
      attrs: {
        "inset": true
      }
    }) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 3603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.preference === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:63',
      "data-vv-name": "ketones_mgdl",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('ketones_mgdl'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.reading.mgdl),
      callback: function($$v) {
        _vm.$set(_vm.reading, "mgdl", _vm._n($$v))
      },
      expression: "reading.mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:3.5',
      "data-vv-name": "ketones_mmoll",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('ketones_mmoll'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": "mmol/L"
    },
    model: {
      value: (_vm.reading.mmoll),
      callback: function($$v) {
        _vm.$set(_vm.reading, "mmoll", _vm._n($$v))
      },
      expression: "reading.mmoll"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "medication-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#AE3463"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmpty'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmptyExplain'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.graphReady) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "medTrackingId": _vm.activeTrackingId,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-select-field', {
    model: {
      value: (_vm.activeTrackingId),
      callback: function($$v) {
        _vm.activeTrackingId = $$v
      },
      expression: "activeTrackingId"
    }
  }, _vm._l((_vm.medications), function(item, index) {
    return _c('mu-menu-item', {
      key: 'medication-selector-' + index,
      attrs: {
        "afterText": item.unit_label,
        "value": item.tracking_id,
        "title": item.treatment_name
      }
    })
  }), 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(0)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(7)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(30)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(360)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "content",
    attrs: {
      "id": "lifeCategoryView"
    }
  }, [_vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      attrs: {
        "gutter": 16
      }
    }, _vm._l((chunks), function(post, index) {
      return _c('mu-flexbox-item', {
        key: 'post-' + index,
        staticClass: "post"
      }, [_c('mu-card', [_c('router-link', {
        attrs: {
          "to": {
            name: 'LifeStyleArticle',
            params: {
              permalink: post.post_slug
            }
          }
        }
      }, [_c('mu-card-media', {
        staticClass: "imgHolder"
      }, [_c('div', {
        staticClass: "img",
        style: ({
          'background-image': 'url(' + post.post_image + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "overlay"
      }, [_c('mu-flexbox', {
        staticClass: "item",
        attrs: {
          "justify": "flex-end",
          "align": "align"
        }
      }, [_c('h3', {
        staticClass: "largeTitle"
      }, [(_vm.isHcpView) ? _vm._o(_c('span', [_vm._v(_vm._s(_vm.truncate(post.post_title)))]), 0, 'post-' + index) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('span', [_vm._v(_vm._s(post.post_title))]) : _vm._e()]), _vm._v(" "), _c('mu-card-text', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "extract"
      }, [_c('div', [_vm._v(_vm._s(post.post_excerpt) + "\n                        ")])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "stats-bar"
      }, [_c('div', {
        staticClass: "stat favourites"
      }, [_c('mu-icon-button', {
        attrs: {
          "icon": post.post_favourited ? 'favorite' : 'favorite_border',
          "disabled": _vm.userId === false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.favouritePost(post.post_id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        domProps: {
          "textContent": _vm._s(post.post_favourites)
        }
      })], 1)])], 1)], 1)
    }), 1)
  }), _vm._v(" "), (!_vm.isPostsFinished) ? _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "full-width": "",
      "disabled": _vm.isAppending || _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.loadCatPosts(_vm.getPostParams, _vm.termId, 'append')
      }
    }
  }, [_vm._v(_vm._s(_vm.isAppending ? 'Loading...' : 'Load more'))]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }, [_c('mu-icon-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "slot": "avatar",
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "80",
      "tablet": "100"
    }
  }, [(_vm.user.diabetes_type.is_diabetic) ? _c('div', [_c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v(_vm._s(_vm.$t('message.labelITakeThisForMy')) + " " + _vm._s(_vm.user.diabetes_type.diabetes_type))]), _vm._v(" "), _c('mu-radio', {
    staticClass: "demo-radio",
    attrs: {
      "label": _vm.$t('message.labelYes'),
      "name": "group",
      "nativeValue": 1
    },
    model: {
      value: (_vm.model.forDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.model, "forDiabetes", $$v)
      },
      expression: "model.forDiabetes"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-radio', {
    staticClass: "demo-radio",
    attrs: {
      "label": _vm.$t('message.labelNo'),
      "name": "group",
      "nativeValue": 0
    },
    model: {
      value: (_vm.model.forDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.model, "forDiabetes", $$v)
      },
      expression: "model.forDiabetes"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('mu-auto-complete', {
    attrs: {
      "scroller": _vm.scroller,
      "maxHeight": 250,
      "inputClass": _vm.medicationInputClass,
      "inputClass": "mediSearchInput",
      "openOnFocus": true,
      "dataSource": _vm.medicationDataSource,
      "dataSourceConfig": _vm.medicationDataSourceConfig,
      "fullWidth": true,
      "maxSearchResults": 10,
      "hintText": "Start typing for suggestions",
      "filter": "noFilter",
      "fullWidth": "",
      "label": _vm.$t('message.labelMedicationName')
    },
    on: {
      "change": _vm.handleMedicationSelected
    },
    model: {
      value: (_vm.medicationSearchValue),
      callback: function($$v) {
        _vm.medicationSearchValue = $$v
      },
      expression: "medicationSearchValue"
    }
  }), _vm._v(" "), (_vm.model.forDiabetes === 0 && _vm.user.diabetes_type.is_diabetic || _vm.model.forDiabetes === 0 && _vm.user.diabetes_type.is_diabetic === false) ? _c('mu-row', [(_vm.conditions.length > 0) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "condition",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('condition'),
      "hintText": _vm.$t('message.searchText'),
      "label": _vm.$t('message.labelWhatDoYouTakeItFor'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.condition_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "condition_id", $$v)
      },
      expression: "model.condition_id"
    }
  }, _vm._l((_vm.conditions), function(item) {
    return _c('mu-menu-item', {
      key: 'condition-' + item.condition_id,
      attrs: {
        "title": item.condition_label,
        "value": item.condition_id
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "dosage",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('dosage'),
      "min": "0",
      "type": "number",
      "label": _vm.$t('message.labelDosage'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.defaultDosage),
      callback: function($$v) {
        _vm.$set(_vm.model, "defaultDosage", _vm._n($$v))
      },
      expression: "model.defaultDosage"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "units",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('units'),
      "maxHeight": 250,
      "scroller": _vm.scroller,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.labelUnits'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.unit_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "unit_id", $$v)
      },
      expression: "model.unit_id"
    }
  }, _vm._l((_vm.regimes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'regime-' + index,
      attrs: {
        "value": item.ID,
        "title": item.regimeUnitLabel
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "frequency",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('frequency'),
      "maxHeight": 250,
      "scroller": _vm.scroller,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.labelHowOften'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.frequency_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "frequency_id", $$v)
      },
      expression: "model.frequency_id"
    }
  }, _vm._l((_vm.frequencies), function(item, index) {
    return _c('mu-menu-item', {
      key: 'frequency-' + index,
      attrs: {
        "value": item.ID,
        "title": item.frequency
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "type": "button",
      "fullWidth": "",
      "label": !_vm.isSaving ? _vm.$t('message.saveText') : _vm.$t('message.savingText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1), _vm._v(" "), (_vm.isError) ? _c('div', {
    staticClass: "isError",
    staticStyle: {
      "margin-top": "16px"
    },
    domProps: {
      "textContent": _vm._s(_vm.errorMessage)
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-paper', {
    staticClass: "insetGraph"
  }, [_c('mu-row', {
    staticClass: "headingRow"
  }, [_c('mu-col', {
    staticClass: "deviceHeading",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "75"
    }
  }, [(_vm.service != 'LCP') ? _c('mu-row', [(_vm.service != 'LCP') ? _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subtractDay.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "70",
      "tablet": "70",
      "desktop": "70"
    }
  }, [_c('span', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.humanizeDate)
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right",
      "disabled": _vm.isToday
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDay.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "25"
    }
  }, [_c('service-tracking-types', {
    attrs: {
      "type": "sleep"
    }
  })], 1)], 1), _vm._v(" "), (_vm.service === 'LCP') ? _c('sleep-wearable-line-graph') : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'FITBIT') ? _c('fitbit-sleep-graph', {
    attrs: {
      "fitbitData": _vm.fitbitData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'STRIIV') ? _c('striiv-sleep-graph', {
    attrs: {
      "striivData": _vm.striivData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading && _vm.service != 'LCP') ? _c('mu-card', {
    staticClass: "card-spacing",
    staticStyle: {
      "min-height": "430px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n        "), _c('mu-circular-progress')], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticStyle: {
      "padding-top": "24px"
    },
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [(_vm.isLoading && _vm.service != 'LCP') ? _c('mu-card', {
    staticClass: "card-spacing",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_c('mu-circular-progress')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'STRIIV') ? _c('striiv-sleep-stages', {
    staticClass: "card-spacing",
    attrs: {
      "striivData": _vm.striivData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'FITBIT') ? _c('fitbit-sleep-stages', {
    staticClass: "card-spacing",
    attrs: {
      "fitbitData": _vm.fitbitData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e(), _vm._v(" "), _c('sleep-input', {
    staticClass: "card-spacing"
  }), _vm._v(" "), (_vm.$store.state.cards.sleep.wearable) ? _c('sleep-visualisation') : _vm._e(), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "sleep"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "DEVICE"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'DEVICE'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelFromDevice').charAt(0).toUpperCase() + _vm.$t('message.labelFromDevice').substr(1)))]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "SELF_REPORTED"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'SELF_REPORTED'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelManualEntry')))])], 1), _vm._v(" "), _c('mu-timeline', [(_vm.data.data.length === 0 && !_vm.isReadingsLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "24px"
    }
  }, [_c('h3', [_vm._v("You don't have any sleep data yet")]), _vm._v(" "), _c('p', [_vm._v("To get started connect your favorite health app below")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Add a sleep integration"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getStartedIntegrations.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelEfficiency')) + ": " + _vm._s(item.efficiency) + "%")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTimeInBed')) + ": " + _vm._s(_vm.getTime(item.timeInBed)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTimeAwake')) + ": " + _vm._s(_vm.getTime(item.minutesAwake)))])]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                        " + _vm._s(_vm.getTime(item.minutesAsleep)) + "\n                      ")]) : _vm._e()])], 1)], 1) : _vm._e()])], 1)
    })], 2)
  })], 2), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-float-button",
    class: [_vm.buttonClass],
    style: (_vm.buttonStyle),
    attrs: {
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick,
      "keyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [_c('div', {
    staticClass: "mu-float-button-wrapper"
  }, [_vm._t("default", function() {
    return [_c('icon', {
      class: _vm.iconClass,
      attrs: {
        "value": this.icon
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 3609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": 3
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "grey"
  }, [_c('div', {
    staticClass: "subHeader"
  }, [_vm._v(_vm._s(_vm.$t('message.gettingStartedGoalsSubHeader')))]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": "",
      "id": "goalsSection"
    }
  }, _vm._l((_vm.lists.goals), function(item, index) {
    return _c('mu-col', {
      key: 'goal-' + index,
      staticStyle: {
        "margin-bottom": "16px"
      },
      attrs: {
        "desktop": "33",
        "tablet": "50",
        "width": "100"
      }
    }, [_c('mu-paper', {
      staticClass: "goalCard hvr-grow",
      staticStyle: {
        "width": "100%"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.updateGoal(item)
        }
      }
    }, [_c('mu-flexbox', {
      staticStyle: {
        "min-height": "44px"
      },
      attrs: {
        "align": "center center",
        "justify": "center center"
      }
    }, [_c('mu-flexbox-item', {
      staticStyle: {
        "margin-left": "8px !important",
        "margin-right": "8px"
      },
      attrs: {
        "align": "center",
        "grow": "0.5"
      }
    }, [_c('img', {
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "width": "40",
        "src": 'static/goals/' + item.icon + '.svg'
      }
    })]), _vm._v(" "), _c('mu-flexbox-item', {
      attrs: {
        "grow": "2"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.localizeGoal(item.goal)) + "\n                ")]), _vm._v(" "), _c('mu-flexbox-item', {
      staticClass: "layerBehind",
      attrs: {
        "grow": "1"
      }
    }, [_c('mu-checkbox', {
      key: 'goal-' + index,
      staticStyle: {
        "display": "flex",
        "float": "right",
        "margin-right": "8px"
      },
      attrs: {
        "checkedIcon": "check_circle",
        "uncheckIcon": "radio_button_unchecked",
        "color": "red"
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-card-text', [(_vm.checkedGoals.length > 0) ? _c('div', [_c('h2', [_vm._v("\n            " + _vm._s(_vm.$t('message.gettingStartedGoalsWhenYouHave')) + "\n            "), _vm._l((_vm.checkedGoals), function(item, index) {
    return _c('span', {
      key: 'goals-checked-' + index
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.localizeGoal(item.plural) + (index === (_vm.checkedGoals.length) - 1 ? '...' : ''))
      }
    }), _vm._v(" "), (index < (_vm.checkedGoals.length - 2)) ? _c('span', {
      staticStyle: {
        "margin-left": "-2px"
      }
    }, [_vm._v(_vm._s(index < (_vm.checkedGoals.length - 2) ? ', ' : ''))]) : _vm._e(), _vm._v(" "), (index === (_vm.checkedGoals.length) - 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.andText')) + " ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "goalRelationTxt",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "difference",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "",
      "errorText": _vm.errors.first('difference'),
      "fullWidth": true,
      "label": _vm.$t('message.gettingStartedGoalsWhatDifference')
    },
    model: {
      value: (_vm.goalModel.goal_relation_id),
      callback: function($$v) {
        _vm.$set(_vm.goalModel, "goal_relation_id", $$v)
      },
      expression: "goalModel.goal_relation_id"
    }
  }, _vm._l((_vm.lists.goal_relations), function(item, index) {
    return _c('mu-menu-item', {
      key: 'goal-id-' + index,
      attrs: {
        "value": item.goal_relation_id,
        "title": _vm.localizeGoalReason(item.title)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.goalModel.goal_relation_id) ? _c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "goalTxt",
      "label": _vm.$t('message.gettingStartedGoalsWhenYouAreFeeling') + ' ' + _vm.loadRelationPlural(_vm.goalModel.goal_relation_id) + ' ' + _vm.$t('message.gettingStartedGoalsWhatWillYouNoticeIsDifferent'),
      "data-vv-rules": 'required',
      "data-vv-name": "reason",
      "data-vv-as": "",
      "data-vv-validate-on": "none",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('reason'),
      "hintText": _vm.$t('message.labelStartTyping'),
      "fullWidth": "",
      "rows": 3
    },
    model: {
      value: (_vm.goalModel.goal_text),
      callback: function($$v) {
        _vm.$set(_vm.goalModel, "goal_text", $$v)
      },
      expression: "goalModel.goal_text"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label",
    staticStyle: {
      "width": "100%",
      "font-size": "16px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.gettingStartedGoalsRatingScale')) + "\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "black",
      "text-align": "right",
      "font-size": "18px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#0179d5"
    },
    domProps: {
      "textContent": _vm._s(_vm.goalModel.goal_evaluation)
    }
  }), _vm._v("/10\n            ")])]), _vm._v(" "), _c('mu-slider', {
    staticClass: "demo-slider",
    attrs: {
      "step": 1,
      "min": 0,
      "max": 10
    },
    model: {
      value: (_vm.goalModel.goal_evaluation),
      callback: function($$v) {
        _vm.$set(_vm.goalModel, "goal_evaluation", $$v)
      },
      expression: "goalModel.goal_evaluation"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "fullWidth": "",
      "secondary": "",
      "backgroundColor": "#9ACA3F",
      "color": "white",
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText'),
      "disabled": _vm.isSaving
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-content-block', {
    staticClass: "cta-payment"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.paymentCtaUpgrade')))]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.paymentCtaEducation')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.paymentCtaCommunitySupport')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('message.paymentCtaResources')) + "\n\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('message.paymentCtaMealPlans')) + "\n\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.paymentCtaUpdatesInformation')) + "\n\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('message.paymentCtaFriendlySupport')) + "\n    ")])]), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-top": "8px",
      "margin-bottom": "8px"
    },
    attrs: {
      "fullWidth": "",
      "label": _vm.$t('message.labelUpgrade')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToPayment.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mu-overlay-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "mu-overlay",
    style: (_vm.overlayStyle),
    on: {
      "click": _vm.handleClick,
      "touchmove": _vm.prevent
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipe-slider",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "mouseenter": _vm.addHoverFocus,
      "mouseover": _vm.addHoverFocus,
      "mouseout": _vm.removeHoverFocus,
      "mouseleave": _vm.removeHoverFocus
    }
  }, [_c('mu-card', [_c('div', {
    staticClass: "title"
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_vm._m(0)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50",
      "align": "right"
    }
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "0"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "See all"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToGroupingCategory.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "owl-carousel horizontal-scroller scrolling-wrapper",
    attrs: {
      "id": 'scrolling-recipe-' + _vm.id
    }
  }, _vm._m(1), 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-content-block', {
    staticClass: "title",
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "0"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.recipes), function(item, recipeI) {
    return _c('recipe-card', {
      key: 'recipe-' + recipeI + _vm._uid,
      attrs: {
        "recipe": item
      },
      nativeOn: {
        "mouseenter": function($event) {
          return _vm.addRecipeTween.apply(null, arguments)
        },
        "mouseleave": function($event) {
          return _vm.removeRecipeTween.apply(null, arguments)
        }
      }
    })
  })
}]}

/***/ }),
/* 3613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "100"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "100"
    }
  }, [(_vm.isVerifying) ? _c('mu-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelVerifyingAccount')) + "\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('mu-circular-progress', {
    attrs: {
      "size": 60
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.isVerifying) ? _c('mu-card', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelAccountActivated')) + "\n        ")]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "label": _vm.$t('message.labelContinueText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDashboard()
      }
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "100"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "id": "dashboardCards",
      "gutter": ""
    }
  }, _vm._l((_vm.chunkedOrder), function(chunk, chunkIndex) {
    return _c('mu-col', {
      key: 'card-chunk-group-' + chunkIndex,
      attrs: {
        "width": "100",
        "desktop": _vm.desktopWidth,
        "tablet": "50"
      }
    }, _vm._l((chunk), function(item, chunkedIndex) {
      return _c('div', {
        key: 'card-order-' + chunkedIndex
      }, [(item.name === 'ACTIVITY') ? _c('div', [_c('activity-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "bmr": _vm.$store.state.user.stats.bmr
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'BLOOD_GLUCOSE') ? _c('div', [_c('blood-glucose-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "blood-glucose": _vm.$store.state.user.settings.blood_glucose,
          "hba1c": _vm.$store.state.user.settings.hba1c
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'CHOLESTEROL') ? _c('div', [_c('cholesterol-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "blood_glucose": _vm.$store.state.user.settings.blood_glucose
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'WEIGHT') ? _c('div', [_c('weight-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "height": _vm.$store.state.user.settings.height,
          "waist": _vm.$store.state.user.settings.waist,
          "weight": _vm.$store.state.user.settings.weight
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'KETONES') ? _c('div', [_c('ketones-input', {
        staticClass: "card-spacing bottom",
        attrs: {
          "blood-glucose": _vm.$store.state.user.settings.blood_glucose
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'BLOOD_PRESSURE') ? _c('div', [_c('blood-pressure-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'SLEEP') ? _c('div', [_c('sleep-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'MOOD') ? _c('div', [(_vm.$store.state.moodList) ? _c('mood-input', {
        staticClass: "card-spacing bottom"
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.name === 'MEDICATION') ? _c('div', [_c('medication-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'INSULIN') ? _c('div', [_c('insulin-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e(), _vm._v(" "), (item.name === 'NUTRITION') ? _c('div', [_c('nutrition-input', {
        staticClass: "card-spacing bottom"
      })], 1) : _vm._e()])
    }), 0)
  }), 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipeIndex"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")])]), _vm._v(" "), _c('recipe-search-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    class: {
      'isBreakfast': _vm.isBreakfast,
      'isLunch': _vm.isLunch,
      'isDinner': _vm.isDinner,
      'isNight': _vm.isNight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "paddingMobile"
  }, [_c('div', {
    staticClass: "recipesContainer"
  }, [_c('div', {
    staticClass: "seasonalRecipes"
  }, [(_vm.isChristmas && _vm.seasonal.christmas.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Merry Christmas! Here are this years best picks",
      "recipes": _vm.seasonal.christmas,
      "grouping-type": "occasions",
      "grouping-route": "christmas"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThanksGiving && _vm.seasonal.thanksgiving.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Thanksgiving!",
      "recipes": _vm.seasonal.thanksgiving,
      "grouping-type": "occasions",
      "grouping-route": "thanksgiving"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEaster && _vm.seasonal.easter.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Easter!",
      "recipes": _vm.seasonal.easter,
      "grouping-type": "occasions",
      "grouping-route": "easter"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHalloween && _vm.seasonal.halloween.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Halloween!",
      "recipes": _vm.seasonal.easter,
      "grouping-type": "occasions",
      "grouping-route": "halloween"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDiwali && _vm.seasonal.diwali.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Diwali!",
      "recipes": _vm.seasonal.diwali,
      "grouping-type": "occasions",
      "grouping-route": "diwali"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "timelyRecipes"
  }, [(_vm.timely.recipes.length > 0) ? _c('div', [(_vm.isBreakfast) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Browse today's breakfast recipes",
      "groupingType": "categories",
      "groupingRoute": "breakfast",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isLunch) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Browse today's lunch recipes",
      "groupingType": "categories",
      "groupingRoute": "lunch",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isDinner) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Browse this evening's dinner recipes",
      "groupingType": "categories",
      "groupingRoute": "dinner",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isNight) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Get ready for tomorrow morning's breakfast",
      "groupingType": "categories",
      "groupingRoute": "breakfast",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.allergiesExcluded.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "linkTo": "dietaryTypes",
      "grouping-type": "allergies",
      "grouping-route": _vm.allergyCsv,
      "title": "Based on your allergies",
      "recipes": _vm.allergiesExcluded.recipes
    }
  }) : _vm._e(), _vm._v(" "), (_vm.favoriteBased.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Based on your favourites",
      "groupingType": "favourites",
      "groupingRoute": _vm.favoriteFoodsCsv,
      "recipes": _vm.favoriteBased.recipes
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticClass: "dietaryTypes",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.dietaryTypes.recipes), function(item, dtIndex) {
    return (item.recipes.length > 3) ? _c('mu-col', {
      key: 'dt-index-' + dtIndex,
      attrs: {
        "width": "100",
        "desktop": "100",
        "tablet": "100"
      }
    }, [_c('horizontal-scroller', {
      attrs: {
        "title": item.grouping,
        "groupingType": "dietaryTypes",
        "grouping-route": item.grouping,
        "recipes": item.recipes
      }
    })], 1) : _vm._e()
  }), 1), _vm._v(" "), (!_vm.cuisines.recipes.length > 0) ? _c('div', {
    ref: "scroll-detector"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAppending),
      expression: "isAppending"
    }],
    attrs: {
      "size": 32
    }
  })], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "cuisines",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.cuisines.recipes), function(item, cIndex) {
    return (item.recipes.length > 3) ? _c('mu-col', {
      key: 'c-index-' + cIndex,
      attrs: {
        "width": "100",
        "desktop": "100",
        "tablet": "100"
      }
    }, [_c('horizontal-scroller', {
      attrs: {
        "title": item.grouping,
        "groupingType": "cuisines",
        "grouping-route": item.grouping,
        "recipes": item.recipes
      }
    })], 1) : _vm._e()
  }), 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinnerInput"
  }, [_c('div', [_c('div', [_c('mu-icon', {
    attrs: {
      "size": 21,
      "value": _vm.icon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "numberMiddle"
  }, [_vm._v(_vm._s(_vm.numberValue))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-result edit-dialog"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('md-icon', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticStyle: {
      "position": "relative",
      "z-index": "99"
    }
  }, [_c('mu-list', [_c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "describeText": _vm.food.brand_name
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : _vm.food.food_name)
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [(!_vm.isLoading) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "width": "100",
      "desktop": _vm.leftPaneWidth.desktop,
      "tablet": _vm.leftPaneWidth.tablet
    }
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:99'),
      expression: "'required|min_value:0|max_value:99'"
    }],
    attrs: {
      "data-vv-name": "serving_size",
      "data-vv-as": _vm.$t('message.labelServingSize'),
      "errorText": _vm.errors.first('serving_size'),
      "min": 0,
      "type": "number",
      "hintText": _vm.$t('message.labelMultiplier'),
      "label": _vm.$t('message.labelServingSize'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.servings),
      callback: function($$v) {
        _vm.$set(_vm.model, "servings", _vm._n($$v))
      },
      expression: "model.servings"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "maxHeight": 248,
      "label": " ",
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.serving_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "serving_id", _vm._n($$v))
      },
      expression: "model.serving_id"
    }
  }, _vm._l((_vm.food.servings), function(serving, index) {
    return _c('mu-menu-item', {
      key: 'serving-' + index,
      attrs: {
        "value": serving.serving_id,
        "title": serving.serving_description
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('span', [_c('mu-flexbox', {
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryQuickPortionLabel'))
    }
  })], 1)], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('span', [_c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.25')
      }
    }
  }, [_vm._v("1/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.5')
      }
    }
  }, [_vm._v("1/2")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.75')
      }
    }
  }, [_vm._v("3/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('1')
      }
    }
  }, [_vm._v("1")])], 1)])], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "container": "inline",
      "label": _vm.$t('message.labelTime'),
      "mode": "landscape",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "container": "inline",
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isNutritionPaneVisible) ? _c('mu-col', {
    staticClass: "rightPane",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    staticClass: "removePadding",
    attrs: {
      "subTitle": _vm.model.servings + ' x ' + _vm.activeServingObject.serving_description
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeServingObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrient-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.rounded(value * _vm.model.servings) + _vm.getUnit(key)
      }
    })
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "card-actions",
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateFood()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('message.foodDiaryLandingExplain')) + "\n\n      "), (_vm.recents.length == 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('message.foodDiaryRecentsEmpty')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.recents.length > 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('message.foodDiaryHasRecents')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "padding": "0px 24px 24px 24px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.recents.length > 0 ? '50' : '100',
      "tablet": _vm.recents.length > 0 ? '50' : '100',
      "width": "100"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.userDecidesTo('a')
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/search.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.searchText')))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.userDecidesTo('mm')
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/baseline-restaurant_menu-24px.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiaryLoadFromMyMeals')))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "yesterday-btn",
    attrs: {
      "icon": "refresh",
      "label": _vm.$t('message.foodDiaryRepeatYesterdayMeal'),
      "disabled": !_vm.isDateToday,
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyYesterdaysMeal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "mobileTop",
    attrs: {
      "desktop": _vm.recents.length > 0 ? '50' : '100',
      "tablet": _vm.recents.length > 0 ? '50' : '100',
      "width": "100"
    }
  }, [_c('mu-card', [_c('mu-list', {
    attrs: {
      "id": "recents"
    }
  }, _vm._l((_vm.recents), function(item, index) {
    return _c('mu-list-item', {
      key: 'recent-' + index,
      attrs: {
        "title": item.food_name
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectRecent(item)
        }
      }
    }, [_c('mu-icon', {
      staticClass: "left8",
      attrs: {
        "slot": "left",
        "value": "history"
      },
      slot: "left"
    })], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "blood-glucose-targets"
    }
  }, [_c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('mu-icon', {
    staticClass: "card-left-icon",
    staticStyle: {
      "width": "16px"
    },
    attrs: {
      "size": 20,
      "value": "settings_cog"
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.isOpenInput ? _vm.$t('message.closeText') : 'Configure range'),
      expression: "isOpenInput ? $t('message.closeText') : 'Configure range'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'add_circle'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'remove_circle_outline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('div', [_c('vue-slider', _vm._b({
    model: {
      value: (_vm.sliderSettings.value),
      callback: function($$v) {
        _vm.$set(_vm.sliderSettings, "value", $$v)
      },
      expression: "sliderSettings.value"
    }
  }, 'vue-slider', _vm.sliderSettings, false))], 1)]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report",
    attrs: {
      "id": "question-thread"
    }
  }, [(!_vm.isLoading) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.comment.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 90,
      "color": "#0179d5",
      "backgroundColor": "#E9E9E8",
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comment.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 90,
      "src": _vm.comment.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.comment.user.profile.url
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.encodeText(_vm.comment.user.display_name)) + " "), _c('country-badge', {
    attrs: {
      "alpha2": _vm.comment.user.country.alpha2,
      "tooltip": _vm.comment.user.country.country_name
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }, [_vm._v(_vm._s(_vm.comment.user.diabetes_type))])]), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [(_vm.comment.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comment.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comment.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.comment.comment) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.comment.comment)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', [_c('mu-flat-button', {
    attrs: {
      "icon": "history",
      "label": "Go to comment"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToArticle()
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.reports.reasons.length) ? _c('report', {
    attrs: {
      "typeId": parseInt(_vm.$route.params.id),
      "type": "LIFE_REPLY"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Handle report"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._v("\n            What do you want to do this with comment?\n          ")]), _vm._v(" "), _c('mu-card-text', [_c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "KEEP",
      "label": "Keep it (removes reports)"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1), _vm._v(" "), _c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "REMOVE",
      "label": "Remove it"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "type": "button",
      "label": "Ammend",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcpSearchView"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('span', [_vm._v("Showing results from")]), _vm._v(" "), _c('mu-select-field', {
    model: {
      value: (_vm.filterType),
      callback: function($$v) {
        _vm.filterType = $$v
      },
      expression: "filterType"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "education",
      "title": "Education"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "resources",
      "title": "Resources"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-card', [_c('mu-card-title', {
    attrs: {
      "title": ("Results for: \"" + (_vm.$route.params.search) + "\"")
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.hasResults) ? _c('p', [_vm._v("Could not find any results based on your search")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.results), function(item, index) {
    return (!_vm.isLoading) ? _c('div', {
      key: ("item-" + index),
      staticClass: "item"
    }, [_c('mu-list-item', {
      attrs: {
        "title": item.title
      },
      nativeOn: {
        "click": function($event) {
          return _vm.linkSearchItem(item.type, item.link)
        }
      }
    }, [_c('div', {
      staticClass: "icon",
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_c('mu-icon', {
      attrs: {
        "value": _vm.getSearchType(item.type).icon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mu-item-text",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.highlightKeyword(item.desc, [_vm.$route.params.search, _vm.$route.params.search + 's'])))
      }
    })]), _vm._v(" "), ((index + 1) !== _vm.results.length) ? _c('mu-divider', {
      attrs: {
        "inset": true
      }
    }) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((10), function(item, index) {
    return (_vm.isLoading) ? _c('mu-list-item', {
      key: ("item-" + index)
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "15px",
        "width": "15%",
        "background": "#f1f1f1",
        "margin": "0 0 16px"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "height": "20px",
        "width": "50%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  })], 2)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 3623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "preferences"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "wrapPreferences"
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferencePromotion')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferencePromotionExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "promotions",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    model: {
      value: (_vm.model.email_promotions),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_promotions", $$v)
      },
      expression: "model.email_promotions"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "promotions",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_promotions),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_promotions", $$v)
      },
      expression: "model.email_promotions"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferenceSurveys')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferenceSurveysExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "research",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    model: {
      value: (_vm.model.email_research),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_research", $$v)
      },
      expression: "model.email_research"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "research",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_research),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_research", $$v)
      },
      expression: "model.email_research"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferenceNewsletters')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferenceNewslettersExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "newsletter",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    model: {
      value: (_vm.model.email_newsletter),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_newsletter", $$v)
      },
      expression: "model.email_newsletter"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "newsletter",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_newsletter),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_newsletter", $$v)
      },
      expression: "model.email_newsletter"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.marketingPreferenceUpdates')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.marketingPreferenceUpdatesExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "updates",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    on: {
      "change": _vm.open
    },
    model: {
      value: (_vm.model.email_updates),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_updates", $$v)
      },
      expression: "model.email_updates"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "updates",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_updates),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_updates", $$v)
      },
      expression: "model.email_updates"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticClass: "radioText",
    attrs: {
      "desktop": "60",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.communityEmailPreferences')))]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.communityEmailPreferencesExplain'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "community",
      "nativeValue": false,
      "label": _vm.$t('message.labelNo')
    },
    on: {
      "change": _vm.open
    },
    model: {
      value: (_vm.model.email_community),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_community", $$v)
      },
      expression: "model.email_community"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "centerItems radioButtons",
    attrs: {
      "desktop": "20",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-radio', {
    attrs: {
      "name": "community",
      "nativeValue": true,
      "label": _vm.$t('message.labelYes')
    },
    model: {
      value: (_vm.model.email_community),
      callback: function($$v) {
        _vm.$set(_vm.model, "email_community", $$v)
      },
      expression: "model.email_community"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btnwrap"
  }, [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "secondary": "",
      "label": _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.savePreferences.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.$store.state.status.payment.paid) ? _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "Just a moment..."
    },
    on: {
      "close": _vm.close
    }
  }, [_vm._v("\n      Opting out will mean that you will no longer received Personalised Support emails which are included as part of the fee for the Low Carb Program. Are you sure you wish to opt out of this paid for feature?\n      "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "Opt out"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "Cancel"
    },
    on: {
      "click": _vm.closeSet
    },
    slot: "actions"
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report",
    attrs: {
      "id": "question-thread"
    }
  }, [(!_vm.isLoading) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "color": "#0179d5",
      "backgroundColor": "#E9E9E8",
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "src": _vm.question.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', {
    staticClass: "badges"
  }, [(_vm.question.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.question.user.profile.url
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.encodeText(_vm.question.user.display_name)) + " "), _c('country-badge', {
    attrs: {
      "alpha2": _vm.question.user.country.alpha2,
      "tooltip": _vm.question.user.country.country_name
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }, [_vm._v(_vm._s(_vm.question.user.diabetes_type))]), _vm._v(" "), _c('div', [_vm._v("Posts: " + _vm._s(_vm.question.posts))])])], 1) : _vm._e(), _vm._v(" "), (_vm.question.content) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.question.content)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', [_c('mu-flat-button', {
    attrs: {
      "icon": "history",
      "label": "See all replies"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToThread()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('h2', [_vm._v("Reported answer")]), _vm._v(" "), _c('mu-card', [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.answer.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "color": "#0179d5",
      "backgroundColor": "#E9E9E8",
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "src": _vm.answer.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', {
    staticClass: "badges"
  }, [(_vm.answer.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.answer.user.profile.url
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.encodeText(_vm.answer.user.display_name)) + " "), _c('country-badge', {
    attrs: {
      "alpha2": _vm.answer.user.country.alpha2,
      "tooltip": _vm.answer.user.country.country_name
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }, [_vm._v(_vm._s(_vm.answer.user.diabetes_type))]), _vm._v(" "), _c('div', [_vm._v("Posts: " + _vm._s(_vm.answer.posts))])])], 1) : _vm._e(), _vm._v(" "), (_vm.answer.answer) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.answer.answer)
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('report', {
    attrs: {
      "typeId": parseInt(_vm.$route.params.id),
      "type": "THREAD_ANSWER"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Handle report"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._v("\n            What do you want to do this with answer?\n          ")]), _vm._v(" "), _c('mu-card-text', [_c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "KEEP",
      "label": "Keep it"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1), _vm._v(" "), _c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "REMOVE",
      "label": "Remove it"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "type": "button",
      "label": "Ammend",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mood-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "padding-left": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#3425AF"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.graphEmpty')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.graphEmptyExplain')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  })], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(0)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(7)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(30)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(360)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": "From date",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": "To date",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "radial",
    attrs: {
      "id": _vm.dataId
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'noData': !_vm.hasData && !_vm.isLoading
    },
    attrs: {
      "id": "striiv-pulse-line-graph"
    }
  }, [_c('div', {
    staticClass: "loadingStatus"
  }, [(_vm.isLoading) ? _c('mu-circular-progress', {
    staticClass: "noDataStatus",
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#F75039"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading && _vm.hasData) ? _c('line-chart', {
    attrs: {
      "width": "1500",
      "data": _vm.chartData,
      "options": _vm.chartOptions,
      "height": _vm.computedHeight
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasData && !_vm.isLoading) ? _c('div', {
    staticClass: "noDataStatus"
  }, [_c('alert', {
    attrs: {
      "type": "info",
      "icon": "info",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n        Not enough data to create a chart\n      ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "settings-nav"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "width": "100",
      "tablet": "40",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "tabletDesktopOnly"
  }, [_c('mu-list', {
    staticClass: "routes"
  }, _vm._l((_vm.routes), function(route, index) {
    return (_vm.hideSettingsMenu(route.name)) ? _c('mu-list-item', {
      key: 'setting-route-' + index,
      attrs: {
        "to": route.route,
        "title": _vm.$t(route.i18n)
      }
    }, [_c('mu-icon', {
      staticClass: "left8",
      attrs: {
        "slot": "left",
        "value": route.icon
      },
      slot: "left"
    })], 1) : _vm._e()
  }), 1)], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "60",
      "desktop": "70"
    }
  }, [_c('mu-paper', {
    staticClass: "settings"
  }, [(_vm.$route.name !== 'SettingsEditMedications' && _vm.$route.name !== 'SettingsAddMedications') ? _c('mu-content-block', {
    staticClass: "mobileOnly",
    staticStyle: {
      "margin-bottom": "-28px"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "fullWidth": ""
    },
    model: {
      value: (_vm.activeRoute),
      callback: function($$v) {
        _vm.activeRoute = $$v
      },
      expression: "activeRoute"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return (_vm.hideSettingsMenu(route.name)) ? _c('mu-menu-item', {
      key: 'setting-nav-' + index,
      attrs: {
        "title": _vm.$t(route.i18n),
        "value": route
      }
    }) : _vm._e()
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cholesterol-line-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [(_vm.visualDate.dateStep !== 0) ? _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  }) : _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#3355E3"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmpty'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmptyExplain'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "dateStep": _vm.visualDate.dateStep,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(0)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(7)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(30)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(360)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n       " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile) ? _c('mu-card', {
    attrs: {
      "id": "profileAvatar"
    }
  }, [_c('mu-card-text', [(!_vm.isOwner) ? _c('mu-raised-button', {
    staticClass: "followBtn",
    attrs: {
      "fullWidth": "",
      "primary": "",
      "label": _vm.isProcessFollowing ? 'Processing' : _vm.profile.auth_user_following ? 'Following' : 'Follow',
      "disabled": _vm.isProcessFollowing
    },
    nativeOn: {
      "click": function($event) {
        return _vm.follow()
      }
    }
  }, [(_vm.isProcessFollowing) ? _c('mu-circular-progress', {
    attrs: {
      "size": 24,
      "color": "white"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo && _vm.isBirthday) ? _c('p', {
    staticClass: "birthday"
  }, [_c('mu-icon', {
    attrs: {
      "value": "cake"
    }
  }), _vm._v("\n      Happy Birthday!!\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo && _vm.profile.diabetes_type) ? _c('p', {
    staticClass: "diabetesType",
    domProps: {
      "textContent": _vm._s(_vm.profile.diabetes_type)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo && _vm.profile.bio) ? _c('p', {
    staticClass: "bio preWrap",
    domProps: {
      "textContent": _vm._s(_vm.profile.bio)
    }
  }) : _vm._e(), _vm._v(" "), _c('profile-goals'), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "emptyFields"
  }, _vm._l((_vm.metaFields), function(field, fieldIndex) {
    return _c('div', {
      key: ("meta-field-" + fieldIndex),
      staticClass: "field"
    }, [(field.to === undefined) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.doMetaField(field)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "add"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    })], 1) : _vm._e(), _vm._v(" "), (field.key === 'bio' && field.toggle) ? _c('add-profile-bio', {
      on: {
        "bioClosed": _vm.onClose
      }
    }) : _vm._e(), _vm._v(" "), (field.key === 'avatar' && field.toggle) ? _c('add-profile-picture', {
      on: {
        "pictureClosed": _vm.onClose
      }
    }) : _vm._e(), _vm._v(" "), (field.key === 'remove-avatar' && _vm.profile.profile_image) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.removeProfilePicture()
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "remove"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    })], 1) : _vm._e(), _vm._v(" "), (field.key === 'cover' && field.toggle) ? _c('add-profile-cover', {
      on: {
        "coverClosed": _vm.onClose
      }
    }) : _vm._e(), _vm._v(" "), (field.key === 'remove-cover' && _vm.profile.cover_photo) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.removeCoverPhoto()
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "remove"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    })], 1) : _vm._e()], 1)
  }), 0) : _vm._e()], 1), _vm._v(" "), (!_vm.showProfileInfo) ? _c('mu-divider') : _vm._e(), _vm._v(" "), (!_vm.showProfileInfo) ? _c('mu-menu', {
    attrs: {
      "desktop": ""
    }
  }, [(_vm.showPrivacyInfo) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelFollowers'),
      "afterText": '' + _vm.profile.followers + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileFollowers')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelFollowing'),
      "afterText": '' + _vm.profile.following + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileFollowing')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyQuestions) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelQuestionsAnswered'),
      "afterText": '' + _vm.profile.answers + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileDiscussion')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyQuestions) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelQuestionsAsked'),
      "afterText": '' + _vm.profile.questions + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileDiscussion')
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "profileProgress"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('message.labelProgramProgress')))]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": false
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "tablet": "80",
      "desktop": "80"
    }
  }, [_c('mu-linear-progress', {
    attrs: {
      "mode": "determinate",
      "size": 15,
      "value": _vm.profile.progress.percentage,
      "min": 0,
      "max": 100,
      "color": _vm.profile.progress.colour
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('span', {
    staticClass: "percentage",
    domProps: {
      "textContent": _vm._s(((_vm.profile.progress.percentage) + "%"))
    }
  })])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "card-spacing",
    attrs: {
      "id": "insulin-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), (_vm.data.units !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardLatestReading')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(((_vm.data.units) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.basal !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardInsulinLatestBasal')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(((_vm.data.basal) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.bolus !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardInsulinLatestBolus')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(((_vm.data.bolus) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.correction !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardInsulinLatestCorrection')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(((_vm.data.correction) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "17px",
      "viewBox": "24 191 16 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.8354615,192.110676 C39.6853846,191.963108 39.4416923,191.963108 39.2916154,192.110676 L36.9870769,194.375519 L36.7159231,194.109187 C36.4047692,193.803544 35.9911538,193.635187 35.5511538,193.635187 C35.1109231,193.635187 34.6970769,193.803695 34.386,194.10964 L26.7518462,201.615245 L26.2917692,201.163244 C26.1789231,201.052417 26.029,200.99141 25.8694615,200.99141 C25.7098462,200.99141 25.5598462,201.052568 25.4476923,201.162866 L25.4374615,201.172845 C25.2047692,201.401832 25.2048462,201.774228 25.4376923,202.002912 L26.3272308,202.87675 L25.0699231,204.11293 L25.0356154,204.079213 C24.922,203.967631 24.7711538,203.906245 24.6106154,203.906245 C24.45,203.906245 24.2989231,203.967706 24.1843077,204.080423 L24.1758462,204.08889 C23.9413846,204.319237 23.9413846,204.694128 24.1758462,204.924551 L26.8508462,207.552416 C26.9644615,207.663999 27.1153077,207.725385 27.2758462,207.725385 C27.4365385,207.725385 27.5875385,207.663848 27.701,207.552265 L27.7106154,207.542815 C27.9450769,207.312468 27.9450769,206.937577 27.7106154,206.707154 L27.6746154,206.67185 L28.9319231,205.435745 L29.8194615,206.307618 C29.9323077,206.418445 30.0823077,206.479453 30.2417692,206.479453 C30.4013846,206.479453 30.5513846,206.418369 30.6640769,206.307543 L30.6737692,206.298017 C30.9064615,206.069106 30.9063846,205.69671 30.6735385,205.46795 L30.2056154,205.008238 L37.8397692,197.502633 C38.482,196.871238 38.4818462,195.844087 37.8393846,195.212843 L37.531,194.909922 L39.8353846,192.64523 C39.9856923,192.497662 39.9856923,192.258319 39.8354615,192.110676 L39.8354615,192.110676 Z M37.2957692,196.968231 L33.3056154,200.891242 L32.9046923,200.497376 L36.2495385,197.210144 C36.3997692,197.062501 36.3997692,196.823158 36.2495385,196.67559 C36.238,196.664251 36.2250769,196.655481 36.2125385,196.64588 C36.2027692,196.633482 36.1936923,196.620706 36.1820769,196.609291 L35.4078462,195.848472 C35.2576154,195.700829 35.0141538,195.700829 34.8639231,195.848472 C34.7137692,195.996115 34.7137692,196.235383 34.864,196.383026 L35.4337692,196.942905 L35.055,197.31515 L34.4850769,196.75512 C34.3348462,196.607477 34.0913846,196.607477 33.9411538,196.75512 C33.791,196.902763 33.791,197.142031 33.9412308,197.289674 L34.511,197.849553 L34.1322308,198.221798 L33.5624615,197.661843 C33.4123846,197.514276 33.1686923,197.514276 33.0186154,197.661843 C32.8683846,197.809486 32.8683846,198.04883 33.0186154,198.196397 L33.5883077,198.756352 L33.2095385,199.128597 L32.6397692,198.568642 C32.4896923,198.421075 32.246,198.421075 32.0959231,198.568642 C31.9456923,198.716285 31.9456923,198.955629 32.0959231,199.103196 L32.6656154,199.663076 L32.3606154,199.962746 L30.9398462,198.566979 L34.93,194.643967 C35.0959231,194.480827 35.3164615,194.391016 35.5511538,194.391016 C35.7856923,194.391016 36.0061538,194.480751 36.172,194.643665 L37.2954615,195.747322 C37.638,196.08396 37.6380769,196.631592 37.2957692,196.968231 L37.2957692,196.968231 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#34CAB9",
      "fill-rule": "evenodd",
      "transform": "translate(31.974063, 199.862692) scale(-1, -1) translate(-31.974063, -199.862692) "
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen
    },
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "250",
      "data-vv-rules": 'required|min_value:0|max_value:250',
      "data-vv-name": "units",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelUnits'),
      "errorText": _vm.errors.first('units'),
      "type": "number",
      "label": _vm.$t('message.labelUnits'),
      "hintText": ((_vm.$t('message.cardInsulin')) + " " + _vm.lowerCaseUnitsLabel),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.units),
      callback: function($$v) {
        _vm.$set(_vm.model, "units", _vm._n($$v))
      },
      expression: "model.units"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": _vm.$t('message.selectText'),
      "data-vv-rules": 'required',
      "data-vv-as": _vm.$t('message.labelInsulinType'),
      "data-vv-name": "insulin_type",
      "data-vv-value-path": "inputValue",
      "scroller": _vm.scroller,
      "errorText": _vm.errors.first('insulin_type'),
      "label": _vm.$t('message.labelInsulinType'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }, _vm._l((_vm.insulinTypes), function(type, index) {
    return _c('mu-menu-item', {
      key: 'insulin-type' + index,
      attrs: {
        "value": type.insulin_type_id,
        "title": _vm.mapInsulinTypes(type.type)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "mood-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardMoodLatest')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, _vm._l((_vm.data.most_recent), function(item, index) {
    return _c('img', {
      key: 'recent-' + index,
      staticClass: "hvr-grow",
      staticStyle: {
        "margin-left": "4px"
      },
      attrs: {
        "width": "28",
        "alt": _vm.$t(_vm.localizeMood(item.mood)),
        "src": _vm.getImageUrl(item)
      }
    })
  }), 0)])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardMoodMostCommon')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t(_vm.localizeMood(_vm.data.most_recent[0].mood)))
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardMoodOftenTogether')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, _vm._l((_vm.data.often_seen_together), function(item, index) {
    return (index < 2) ? _c('span', {
      key: 'st' + index
    }, [_vm._v("\n               " + _vm._s(_vm.$t(_vm.localizeMood(item.mood)))), (index + 1 < _vm.data.often_seen_together.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()]) : _vm._e()
  }), 0)], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "19 193 17 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "moodIcon",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(20.000000, 193.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.728,2.30929587 C15.6869333,2.24827023 15.6218667,2.20673177 15.5477333,2.19391126 L15.5424,2.19339844 C14.8528,2.41134716 13.3312,2.39083433 11.6,2.10109075 C9.8688,1.81134716 8.432,1.33596254 7.85813333,0.906731771 L7.85386667,0.90621895 C7.77973333,0.893911258 7.70346667,0.911859976 7.64373333,0.95596254 C7.584,1.0000651 7.54613333,1.06621895 7.53973333,1.137501 L7.32053333,3.53442408 C7.384,3.52519331 7.44693333,3.51442408 7.51093333,3.51442408 C7.78453333,3.51442408 8.04693333,3.59391126 8.27093333,3.74570613 C8.4992,3.89955228 8.66826667,4.11852664 8.75946667,4.36724459 C8.92,4.25391126 9.16213333,4.17544972 9.43893333,4.16468049 C9.93386667,4.14673177 10.344,4.34980869 10.3546667,4.61801382 C10.3658667,4.88570613 9.97173333,5.11801382 9.4768,5.13544972 C9.24853333,5.14365485 9.04106667,5.10314203 8.87946667,5.03288562 L9.2112,7.45185998 C9.59733333,7.0949369 10.1445333,6.90980869 10.7125333,7.00468049 C11.5706667,7.14827023 12.1706667,7.8749369 12.1525333,8.68775741 C12.1525333,8.6949369 12.1493333,8.7000651 12.1434667,8.70519331 C12.1381333,8.70929587 12.1317333,8.71134716 12.1248,8.70980869 L9.3184,8.2400651 L9.52853333,9.76775741 C9.54613333,9.91083433 9.55573333,10.0539113 9.55946667,10.1949369 C9.73706667,10.2528856 9.92,10.3016036 10.1093333,10.3339113 C11.9872,10.6482702 13.8090667,9.54365485 14.3205333,7.77903946 L15.7594667,2.51442408 C15.7813333,2.44519331 15.7685333,2.37032151 15.728,2.30929587 L15.728,2.30929587 Z M13.5541333,5.5200651 C13.4506667,5.76878305 12.9936,5.82673177 12.5328,5.64827023 C12.0736,5.47032151 11.7856,5.12468049 11.8885333,4.87596254 C11.9925333,4.62775741 12.4501333,4.56980869 12.9098667,4.74775741 C13.3696,4.92570613 13.6581333,5.27134716 13.5541333,5.5200651 L13.5541333,5.5200651 Z",
      "id": "Shape",
      "fill": "#8150E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.76586667,4.75544972 C7.75626667,4.68724459 7.71786667,4.62621895 7.6592,4.58621895 C7.61546667,4.55647536 7.56426667,4.54160357 7.512,4.54160357 C7.49386667,4.54160357 7.47573333,4.54365485 7.45706667,4.54724459 L7.4528,4.54827023 C6.92693333,4.97852664 5.5808,5.48775741 3.94773333,5.83185998 C2.8784,6.05698818 1.89013333,6.16929587 1.14826667,6.16929587 C0.757333333,6.16929587 0.4352,6.137501 0.205333333,6.07596254 L0.201066667,6.07698818 C0.1312,6.09134716 0.0709333333,6.13339844 0.0346666667,6.19339844 C-0.0016,6.25288562 -0.0096,6.32416767 0.0112,6.38980869 L1.60533333,11.3364754 C2.0896,12.7569882 3.46346667,13.6764754 4.96106667,13.6764754 C5.21173333,13.6764754 5.4656,13.6508343 5.71946667,13.597501 C7.49066667,13.2236548 8.68,11.6210907 8.47093333,9.88980869 L7.76586667,4.75544972 L7.76586667,4.75544972 Z M2.1568,8.79647536 C2.1552,8.54211639 2.536,8.33339844 3.00746667,8.33032151 C3.47893333,8.32673177 3.8624,8.53288562 3.864,8.78724459 C3.8656,9.04211639 3.4848,9.25134716 3.01333333,9.25391126 C2.5424,9.25647536 2.15893333,9.05185998 2.1568,8.79647536 L2.1568,8.79647536 Z M5.37333333,12.0785266 C4.59306667,12.2426292 3.82293333,11.8492959 3.5088,11.1744241 C3.4976,11.1492959 3.4976,11.1210907 3.5104,11.0964754 C3.5232,11.0713472 3.54666667,11.0544241 3.57493333,11.0482702 L6.5584,10.4185266 C6.58613333,10.4128856 6.61493333,10.4190395 6.63733333,10.4364754 C6.65973333,10.4533984 6.67253333,10.4795523 6.67306667,10.5067318 C6.6816,11.246219 6.15306667,11.9144241 5.37333333,12.0785266 L5.37333333,12.0785266 Z M6.2864,8.56365485 C5.85653333,8.75032151 5.41973333,8.71442408 5.3104,8.48211639 C5.20053333,8.24929587 5.45973333,7.90980869 5.88906667,7.72314203 C6.31893333,7.53647536 6.75573333,7.5723728 6.86506667,7.80416767 C6.97493333,8.03647536 6.71626667,8.37647536 6.2864,8.56365485 L6.2864,8.56365485 Z",
      "id": "Shape",
      "fill": "#8150E4"
    }
  })])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen
    },
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": _vm.isOpenInput ? 'remove' : 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpenInput),
      expression: "isOpenInput"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('div', {
    staticClass: "upper-label"
  }, [_c('mu-icon', {
    attrs: {
      "size": 12,
      "value": "flash_on"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.labelEnergy')) + "\n        ")], 1), _vm._v(" "), _vm._l((_vm.moods.energy), function(group, groupIndex) {
    return _c('mu-row', {
      key: 'mood-group-1-' + groupIndex,
      staticClass: "bottom"
    }, _vm._l((group), function(item, index) {
      return _c('mu-col', {
        key: 'im1-' + index,
        attrs: {
          "width": "20",
          "tablet": "20",
          "desktop": "20",
          "align": "center"
        }
      }, [_c('div', {
        staticClass: "hvr-grow pointer",
        class: {
          isActiveMood: item.isActive
        },
        on: {
          "click": function($event) {
            return _vm.toggleMood(item)
          }
        }
      }, [_c('div', {
        staticClass: "moodButton"
      }, [_c('div', {
        staticClass: "moodToggle"
      }), _vm._v(" "), _c('img', {
        attrs: {
          "width": "48",
          "src": item.icon,
          "alt": _vm.$t(_vm.localizeMood(item.mood))
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.$t(_vm.localizeMood(item.mood))))])])])
    }), 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "upper-label"
  }, [_c('mu-icon', {
    attrs: {
      "size": 12,
      "value": "thumb_up"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.labelMood')) + "\n        ")], 1), _vm._v(" "), _vm._l((_vm.moods.mood), function(group, groupIndex) {
    return _c('mu-row', {
      key: 'mood-group-2-' + groupIndex,
      staticClass: "bottom"
    }, _vm._l((group), function(item, index) {
      return _c('mu-col', {
        key: 'im2-' + index,
        attrs: {
          "width": "20",
          "tablet": "20",
          "desktop": "20",
          "align": "center"
        }
      }, [_c('div', {
        staticClass: "hvr-grow pointer",
        class: {
          isActiveMood: item.isActive
        },
        on: {
          "click": function($event) {
            return _vm.toggleMood(item)
          }
        }
      }, [_c('div', {
        staticClass: "moodButton"
      }, [_c('div', {
        staticClass: "moodToggle"
      }), _vm._v(" "), _c('img', {
        attrs: {
          "width": "48",
          "src": item.icon,
          "alt": _vm.$t(_vm.localizeMood(item.mood))
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.$t(_vm.localizeMood(item.mood))))])])])
    }), 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "upper-label"
  }, [_c('mu-icon', {
    attrs: {
      "size": 12,
      "value": "favorite"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.labelHealth')) + "\n        ")], 1), _vm._v(" "), _vm._l((_vm.moods.health), function(group, groupIndex) {
    return _c('mu-row', {
      key: 'mood-group-3-' + groupIndex,
      staticClass: "bottom"
    }, _vm._l((group), function(item, index) {
      return _c('mu-col', {
        key: 'im3-' + index,
        attrs: {
          "width": "20",
          "tablet": "20",
          "desktop": "20",
          "align": "center"
        }
      }, [_c('div', {
        staticClass: "hvr-grow pointer",
        class: {
          isActiveMood: item.isActive
        },
        on: {
          "click": function($event) {
            return _vm.toggleMood(item)
          }
        }
      }, [_c('div', {
        staticClass: "moodButton"
      }, [_c('div', {
        staticClass: "moodToggle"
      }), _vm._v(" "), _c('img', {
        attrs: {
          "width": "48",
          "src": item.icon,
          "alt": _vm.$t(_vm.localizeMood(item.mood))
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.$t(_vm.localizeMood(item.mood))))])])])
    }), 1)
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contactView"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "0",
      "width": "0"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-card', {
    attrs: {
      "id": "contactForm"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.isHcpView ? 'Further Information and Feedback' : _vm.$t('message.contactTitle'),
      "titleClass": "largeTitle boldTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.isHcpView) ? _c('reset-account') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitMessage.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.isHcpView ? 'Subject' : _vm.$t('message.contactSubTitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      staticClass: "radio-item"
    }, [_c('mu-radio', {
      key: 'platformOption-' + index,
      staticClass: "radio",
      attrs: {
        "label": option.label,
        "nativeValue": option.key
      },
      model: {
        value: (_vm.messageModel.platform),
        callback: function($$v) {
          _vm.$set(_vm.messageModel, "platform", $$v)
        },
        expression: "messageModel.platform"
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "mainTitle",
    domProps: {
      "textContent": _vm._s(_vm.isHcpView ? 'Your message' : _vm.$t('message.contactBodyLabel'))
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": _vm.isHcpView ? 'Enter your message here' : _vm.$t('message.placeholderText'),
      "multiLine": "",
      "rows": 5,
      "rowsMax": 6,
      "fullWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "message",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.contactBodyLabel'),
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('message')
    },
    model: {
      value: (_vm.messageModel.message),
      callback: function($$v) {
        _vm.$set(_vm.messageModel, "message", $$v)
      },
      expression: "messageModel.message"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('vue-recaptcha', {
    ref: "invisibleRecaptcha",
    attrs: {
      "sitekey": "6Lf_8LsUAAAAAPqMvImMQATwGHVXXM_Ke1oNLi-T",
      "size": "invisible"
    },
    on: {
      "verify": _vm.onVerify
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSending,
      "label": _vm.isSending ? _vm.$t('message.sendingText') : _vm.isHcpView ? 'Send' : _vm.$t('message.submitText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitMessage.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "0",
      "width": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-header', {
    staticClass: "noPaddingRight",
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.lessonQuestionsTitle'),
      "subTitle": _vm.$t('message.lessonQuestionsSubTitle')
    }
  }), _vm._v(" "), (_vm.changeData) ? _c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeData) ? _c('div', [_c('mu-list', _vm._l((_vm.data.questions), function(question, index) {
    return (_vm.hasQuestions) ? _c('mu-list-item', {
      key: 'question-index-' + index,
      nativeOn: {
        "click": function($event) {
          return _vm.goToQuestion(question.question_id)
        }
      }
    }, [(!question.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n              " + _vm._s(_vm.upperTwoInitials(question.display_name)) + "\n            ")]) : _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": question.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(question.question))
      },
      slot: "title"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      staticStyle: {
        "color": "rgba(0, 0, 0, .87)"
      },
      domProps: {
        "textContent": _vm._s(question.display_name)
      }
    }), _vm._v("\n                ·\n              "), _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.formatDate(question.timestamp))
      }
    }), _vm._v(" "), (question.replies !== 0) ? _c('span', [_vm._v("\n                  ·\n                  "), _c('span', {
      domProps: {
        "textContent": _vm._s(question.replies + (question.replies > 1 ? ' replies' : ' reply'))
      }
    })]) : _vm._e()])], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('mu-card-text', [(!_vm.hasQuestions) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$t('message.lessonQuestionsEmpty')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "60",
      "tablet": "70"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "40",
      "tablet": "30",
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "backgroundColor": "#3d8517",
      "color": "white",
      "label": "Ask a question"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.askQuestion.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-text', [_c('div', {
    staticClass: "v-header"
  }, [_vm._v(_vm._s(_vm.$t('message.labelTodaysPrediction')) + " "), _c('mu-icon', {
    attrs: {
      "value": "help"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTodaysPredictionExplain')))])]), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "center-text",
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('radial-progress', {
    attrs: {
      "mode": "outOf",
      "data-id": "radial-loading-1",
      "value": _vm.$store.state.cards.activity.steps.steps,
      "outOfValue": _vm.$store.state.cards.activity.steps.predictions.steps,
      "suffix": "",
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelSteps')[0].toUpperCase() + _vm.$t('message.labelSteps').substr(1)))])], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "center-text",
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('radial-progress', {
    attrs: {
      "mode": "outOf",
      "data-id": "radial-loading-3",
      "value": _vm.$store.state.cards.activity.steps.calories,
      "outOfValue": _vm.$store.state.cards.activity.steps.predictions.calories,
      "suffix": "",
      "color": "#89C93B"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.nutrientCalories')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "cholesterol-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    },
    attrs: {
      "id": "cl-moving-bg"
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardCholesterolLatestTotal')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.total + ' ' + _vm.data.measure)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardCholesterolLatestHDL')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.hdl + ' ' + _vm.blood_glucose.unit)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardCholesterolLatestLDL')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.ldl + ' ' + _vm.blood_glucose.unit)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardCholesterolLatestTriglycerides')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.triglycerides + ' ' + _vm.blood_glucose.unit)
    }
  })])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "14px",
      "viewBox": "20 193 16 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36,197.265908 C36,194.909874 34.0654937,193 31.6791924,193 C30.1209817,193 28.7601736,193.817042 27.9999513,195.038086 C27.2398264,193.817042 25.8784338,193 24.3202556,193 C21.9339542,193 20,194.909874 20,197.265908 C20,198.548637 20.5757115,199.696228 21.4830684,200.477715 L27.6056657,206.522912 C27.7102283,206.626148 27.8520374,206.684147 27.9999513,206.684147 C28.1478652,206.684147 28.2896742,206.626148 28.3942369,206.522912 L34.5168341,200.477715 C35.4242235,199.696228 36,198.548637 36,197.265908 L36,197.265908 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#D14905",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), (_vm.data.no_setting) ? _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen || _vm.loading
    },
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": "settings"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.open.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.data.no_setting) ? _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [(_vm.blood_glucose.measure == 'mmoll') ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "12.95",
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'required|min_value:0|max_value:12.95',
      "data-vv-name": "total_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolTotal'),
      "errorText": _vm.errors.first('total_mmoll'),
      "label": _vm.$t('message.labelCholesterolTotal'),
      "helpText": "mmol/L",
      "fullWidth": true
    },
    model: {
      value: (_vm.model.total_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "total_mmoll", $$v)
      },
      expression: "model.total_mmoll"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "12.95",
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'min_value:0|max_value: 12.95',
      "data-vv-name": "hdl_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolHDL'),
      "errorText": _vm.errors.first('hdl_mmoll'),
      "label": _vm.$t('message.labelCholesterolHDL'),
      "helpText": "mmol/L",
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hdl_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "hdl_mmoll", $$v)
      },
      expression: "model.hdl_mmoll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.blood_glucose.measure == 'mgdl') ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "700",
      "hintText": "Enter mg/dL",
      "data-vv-rules": 'required|min_value:0|max_value:700',
      "data-vv-name": "total_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolTotal'),
      "errorText": _vm.errors.first('total_mgdl'),
      "label": _vm.$t('message.labelCholesterolTotal'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.model.total_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "total_mgdl", $$v)
      },
      expression: "model.total_mgdl"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "700",
      "hintText": "Enter mg/dL",
      "data-vv-rules": 'min_value:0|max_value:700',
      "data-vv-name": "hdl_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolHDL'),
      "errorText": _vm.errors.first('hdl_mgdl'),
      "label": _vm.$t('message.labelCholesterolHDL'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.model.hdl_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "hdl_mgdl", $$v)
      },
      expression: "model.hdl_mgdl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.blood_glucose.measure == 'mmoll') ? _c('mu-row', {
    staticClass: "bottom"
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "18.1",
      "hintText": "mmol/L",
      "data-vv-rules": 'min_value:0|max_value:18.1',
      "data-vv-name": "triglycerides_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolTriglycerides'),
      "errorText": _vm.errors.first('triglycerides_mmoll'),
      "label": _vm.$t('message.labelCholesterolTriglycerides'),
      "fullWidth": true,
      "helpText": "mmol/L"
    },
    model: {
      value: (_vm.model.triglycerides_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "triglycerides_mmoll", _vm._n($$v))
      },
      expression: "model.triglycerides_mmoll"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "18.1",
      "hintText": "mmol/L",
      "data-vv-rules": 'min_value:0|max_value: 18.1',
      "data-vv-name": "ldl_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolLDL'),
      "errorText": _vm.errors.first('ldl_mmoll'),
      "label": _vm.$t('message.labelCholesterolLDL'),
      "fullWidth": true,
      "helpText": _vm.blood_glucose.unit
    },
    model: {
      value: (_vm.model.ldl_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "ldl_mmoll", _vm._n($$v))
      },
      expression: "model.ldl_mmoll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.blood_glucose.measure == 'mgdl') ? _c('mu-row', {
    staticClass: "bottom"
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "700",
      "hintText": "mg/dL",
      "data-vv-rules": 'min_value:0|max_value: 700',
      "data-vv-name": "triglycerides_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolTriglycerides'),
      "errorText": _vm.errors.first('triglycerides_mgdl'),
      "label": _vm.$t('message.labelCholesterolTriglycerides'),
      "fullWidth": true,
      "helpText": _vm.blood_glucose.unit
    },
    model: {
      value: (_vm.model.triglycerides_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "triglycerides_mgdl", _vm._n($$v))
      },
      expression: "model.triglycerides_mgdl"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "700",
      "hintText": "mg\\dL",
      "data-vv-rules": 'min_value:0|max_value:700',
      "data-vv-name": "ldl_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelCholesterolLDL'),
      "errorText": _vm.errors.first('ldl_mgdl'),
      "label": _vm.$t('message.labelCholesterolLDL'),
      "fullWidth": true,
      "helpText": _vm.blood_glucose.unit
    },
    model: {
      value: (_vm.model.ldl_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "ldl_mgdl", _vm._n($$v))
      },
      expression: "model.ldl_mgdl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading()
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.computedGoals.length > 0) ? _c('div', {
    attrs: {
      "id": "userGoals"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('message.labelMyGoals')))]), _vm._v(" "), _vm._l((_vm.computedGoals), function(goal, index) {
    return _c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.bottom",
        value: (goal.goal),
        expression: "goal.goal",
        modifiers: {
          "bottom": true
        }
      }],
      key: ("goal-" + index),
      staticClass: "goal"
    }, [_c('img', {
      attrs: {
        "src": 'static/goals/' + goal.icon + '.png'
      }
    })])
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', [(!_vm.isHcpView) ? _c('patient-view') : _vm._e(), _vm._v(" "), (_vm.isHcpView) ? _c('hcp-view') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-pagination-item",
    class: {
      'circle': _vm.isCircle,
      'active': _vm.isActive
    },
    attrs: {
      "wrapperClass": "mu-pagination-item-wrapper",
      "centerRipple": false,
      "disabled": _vm.disabled,
      "containerElement": "div"
    },
    on: {
      "click": _vm.handleClick,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [(_vm.index) ? _c('span', [_vm._v(_vm._s(_vm.index))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('insulin-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('insulin-input', {
    staticStyle: {
      "margin-top": "24px"
    }
  }), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "insulin"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor(item),
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.mapInsulinTypes(item.type_name)))])]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                        " + _vm._s(item.units + ' ' + _vm.lowerCaseUnitsLabel) + "\n                      ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor(''),
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor(''),
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('insulin-edit', {
        attrs: {
          "insulinTypes": _vm.insulinTypes,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()])], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('alert', {
    attrs: {
      "type": "info",
      "icon": "warning",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('message.labelStartProgramOver')) + "\n    "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelClickHere'))
    },
    on: {
      "click": _vm.confirmRestart
    },
    slot: "action"
  })])])
},staticRenderFns: []}

/***/ }),
/* 3642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hr', {
    staticClass: "mu-divider",
    class: {
      'inset': _vm.inset,
      'shallow-inset': _vm.shallowInset
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unitsList"
  }, [(!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), (_vm.bindings.height) ? _c('mu-card-text', [_c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureWeight'),
      "list": _vm.bindings.weight,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.weight),
      callback: function($$v) {
        _vm.$set(_vm.model, "weight", $$v)
      },
      expression: "model.weight"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureHeight'),
      "list": _vm.bindings.height,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.height),
      callback: function($$v) {
        _vm.$set(_vm.model, "height", $$v)
      },
      expression: "model.height"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureWaist'),
      "list": _vm.bindings.waist,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.waist),
      callback: function($$v) {
        _vm.$set(_vm.model, "waist", $$v)
      },
      expression: "model.waist"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureHba1c'),
      "list": _vm.bindings.hba1c,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.hba1c),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c", $$v)
      },
      expression: "model.hba1c"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureBloodGlucose'),
      "list": _vm.bindings.blood_glucose,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.blood_glucose),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose", $$v)
      },
      expression: "model.blood_glucose"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "secondary": "",
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('mu-icon', {
    staticClass: "card-left-icon",
    attrs: {
      "size": 16,
      "value": "file_download"
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16"
  }, [_vm._v(_vm._s(_vm.$t('message.exportTextData')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": _vm.isOpen ? 'remove_circle_outline' : 'add_circle'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleOpen.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpen) ? _c('mu-card-text', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelFromDate'),
      "dateTimeFormat": _vm.dateFormat,
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelToDate'),
      "dateTimeFormat": _vm.dateFormat,
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleOpen.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": _vm.isExporting ? _vm.$t('message.exportingText') : _vm.$t('message.exportText'),
      "disabled": _vm.isExporting
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exportData.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.state.user.scope) ? _c('mood-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [_c('mood-input', {
    staticClass: "card-spacing",
    staticStyle: {
      "margin-top": "24px"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        key: 'tl-' + index,
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        domProps: {
          "textContent": _vm._s(_vm.$t(_vm.localizeMood(item.mood)))
        }
      })]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('img', {
        attrs: {
          "src": item.icon,
          "width": "32"
        }
      })]) : _vm._e()])], 1), _vm._v(" "), (item.isControlsVisible && !item.isEditMode) ? _c('div', {
        attrs: {
          "align": "right"
        }
      }, [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v("One sec...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedContainer bottom"
  }, [_c('iframe', {
    attrs: {
      "allowfullscreen": "",
      "frameborder": "0",
      "src": _vm.src
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "recipe-detail"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "relative bottom"
  }, [(!_vm.imageLoaded) ? _c('img', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "width": "100%",
      "src": "data:image/png;base64,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"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "imagesContainer",
    staticClass: "imgLoadContainer",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "24px"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoLargeUri !== null && _vm.imageLoaded),
      expression: "recipe.photoLargeUri !== null && imageLoaded"
    }],
    attrs: {
      "src": _vm.recipe.photoLargeUri,
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoLargeUri == null && _vm.imageLoaded),
      expression: "recipe.photoLargeUri == null && imageLoaded"
    }],
    attrs: {
      "src": "static/recipe-placeholder.png",
      "width": "100%"
    }
  }), _vm._v(" "), (!_vm.imageLoaded) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.imageLoaderHeight
    })
  }, [_c('mu-circular-progress', {
    staticStyle: {
      "margin": "0px auto",
      "position": "absolute",
      "height": "100%",
      "width": "100%",
      "vertical-align": "middle",
      "align-items": "center",
      "display": "flex",
      "text-align": "center",
      "align-content": "center",
      "top": "0",
      "left": "calc(50% - 16px)"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "absoluteTopRight"
  }, [(_vm.recipe.userFavorites) ? _c('mu-float-button', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": 'favorite',
      "background-color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFavorite.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.recipe.userFavorites) ? _c('mu-float-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.$t('message.addToFavouritesText')),
      expression: "$t('message.addToFavouritesText')",
      modifiers: {
        "left": true
      }
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": 'favorite_border',
      "background-color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFavorite.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-float-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: (_vm.$t('message.printPageText')),
      expression: "$t('message.printPageText')",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "printPage",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": 'print',
      "background-color": "#0179d5"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.printRecipe.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "absoluteBottomLeft"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.labelPrepTime')),
      expression: "$t('message.labelPrepTime')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "greyBox"
  }, [_c('mu-icon', {
    attrs: {
      "size": 16,
      "value": "timer"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.preparationTime) + "min\n          ")], 1), _vm._v(" "), (_vm.recipe.cookingTime !== 0) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.labelCookingTime')),
      expression: "$t('message.labelCookingTime')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "greyBox"
  }, [_c('img', {
    staticClass: "svgIcon",
    attrs: {
      "src": "static/ic_cooktime.svg"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.cookingTime) + "min\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Servings'),
      expression: "'Servings'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "greyBox"
  }, [_c('mu-icon', {
    attrs: {
      "size": 16,
      "value": "restaurant"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.servings) + "\n          ")], 1), _vm._v(" "), (_vm.recipe.userFavoriteCount !== 0) ? _c('div', {
    staticClass: "greyBox"
  }, [_c('mu-icon', {
    attrs: {
      "size": 16,
      "value": "favorite"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.userFavoriteCount) + "\n          ")], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "insetTitleMobile"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('mu-raised-button', {
    staticClass: "fullWidthMobileBtn",
    attrs: {
      "backgroundColor": "#0179d5",
      "label": "Add to food diary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openAddToDiaryModal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.recipe.title))]), _vm._v(" "), (_vm.recipe.author) ? _c('div', {
    staticClass: "authorBlock"
  }, [_c('p', [_vm._v("By " + _vm._s(_vm.recipe.author.firstName) + " " + _vm._s(_vm.recipe.author.lastName))])]) : _vm._e(), _vm._v(" "), _c('recipe-rating', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "read-only": true,
      "count": _vm.recipe.rating.ratingCount,
      "rating": _vm.recipe.rating.ratingScore,
      "recipe": _vm.recipe
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "60"
    }
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-text', [(_vm.recipe) ? _c('number-spinner', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "person"
    },
    model: {
      value: (_vm.recipe.servings),
      callback: function($$v) {
        _vm.$set(_vm.recipe, "servings", $$v)
      },
      expression: "recipe.servings"
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.recipe.intro))]), _vm._v(" "), (_vm.recipe.suitabilities.length > 0) ? _c('div', [_c('h3', [_vm._v("Allergens")]), _vm._v(" "), _c('div', _vm._l((_vm.recipe.suitabilities), function(item, sKey) {
    return _c('mu-chip', {
      key: 's-' + sKey
    }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.recipe.dietaryTypes.length > 0) ? _c('div', [_c('h3', [_vm._v("Dietary types")]), _vm._v(" "), _c('div', _vm._l((_vm.recipe.dietaryTypes), function(item, dKey) {
    return _c('mu-chip', {
      key: 'd-' + dKey
    }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.recipe.occasions.length > 0) ? _c('div', [_c('h3', [_vm._v("Occasions")]), _vm._v(" "), _c('div', _vm._l((_vm.recipe.occasions), function(item, oKey) {
    return _c('mu-chip', {
      key: 'o-' + oKey
    }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)], 1), _vm._v(" "), (_vm.recipe.video_url) ? _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Watch video",
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "embedContainer"
  }, [_c('iframe-video-player', {
    attrs: {
      "autoplay": "off",
      "src": _vm.recipe.video_url,
      "width": "100%",
      "options": _vm.playerOptions
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Ingredients",
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.ingredients), function(item, ingredientI) {
    return _c('mu-list-item', {
      key: 'ingredient-' + ingredientI,
      attrs: {
        "title": item.ingredientTitle
      }
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [(item.portionName !== 'Serving') ? _c('span', [_c('span', [_vm._v(_vm._s(item.portionQuantity) + " " + _vm._s(item.portionName) + " (" + _vm._s(item.portionValue.toFixed(1) + item.portionUnit) + ")")])]) : _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.portionQuantity.toFixed(1) + item.portionUnit + '')
      }
    }), _vm._v(" "), _c('div', [(item.allergens.length > 0) ? _c('span', [_vm._v("Allergens: ")]) : _vm._e(), _vm._v(" "), _vm._l((item.allergens), function(allergen, allergyIndex) {
      return (item.allergens.length > 0) ? _c('span', {
        key: 'allergy-index-' + allergyIndex
      }, [_vm._v(_vm._s(allergen.name)), (allergyIndex != item.allergens.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()]) : _vm._e()
    })], 2)])])
  }), 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom",
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Step-by-step",
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cookingInstructions",
    staticStyle: {
      "display": "none"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.recipe.cookingInstructions))
    }
  }), _vm._v(" "), _vm._l((_vm.recipe.cookingInstructions.steps), function(item, i) {
    return _c('mu-list-item', {
      key: 'instruction-' + i,
      attrs: {
        "title": _vm.parseHtmlEncoding(item)
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n                " + _vm._s(i + 1) + "\n              ")])], 1)
  })], 2), _vm._v(" "), _c('recipe-reviews', {
    staticClass: "bottom hidePrint",
    attrs: {
      "recipe": _vm.recipe
    },
    on: {
      "ratingPicked": _vm.onRatingPicked
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "40"
    }
  }, [_c('mu-card', {
    staticClass: "bottom hidePrint"
  }, [_c('mu-card-text', [_c('food-pie', {
    staticClass: "foodPie",
    staticStyle: {
      "height": "200px",
      "width": "200px",
      "margin": "24px auto"
    },
    attrs: {
      "enable-animation": false,
      "fat": _vm.nutrition.fat.val,
      "carbs": _vm.nutrition.carbohydrate.val,
      "protein": _vm.nutrition.protein.val,
      "calories": _vm.nutrition.kcal.val
    }
  }), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#4ed8da !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("  " + _vm._s(_vm.nutrition.carbohydrate.val.toFixed(0)) + "g")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#c04dd8 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.nutrition.fat.val.toFixed(0)) + "g")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#e06950 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.nutrition.protein.val.toFixed(0)) + "g")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Nutritional information",
      "subTitle": 'Per 1 serving',
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "nutritionList"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientCarbohydrate')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.carbohydrate.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientSugar')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.sugars.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.fat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientMonounsaturatedFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.monoFat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientPolyunsaturatedFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.polyFat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientSaturatedFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.satFat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientProtein')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.protein.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientFibre')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.fibre.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientPotassium')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.potassium.val.toFixed(0)) + "mg\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    Salt\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.salt.val.toFixed(0)) + "g\n                  ")])])])])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "mobileSliderPadding",
    staticStyle: {
      "margin-left": "-24px",
      "margin-right": "-24px",
      "background": "transparent"
    }
  }, [(_vm.similarRecipes.recipes.length > 0) ? _c('h2', {
    staticStyle: {
      "padding-left": "16px",
      "padding-top": "16px",
      "margin-bottom": "2px"
    }
  }, [_vm._v("Similar\n      recipes")]) : _vm._e(), _vm._v(" "), (_vm.similarRecipes.recipes.length > 0) ? _c('mu-row', {
    staticClass: "dietaryTypes",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.similarRecipes.recipes), function(item, dtIndex) {
    return _c('mu-col', {
      key: 'dt-index-' + dtIndex,
      attrs: {
        "width": "100",
        "desktop": "100",
        "tablet": "100"
      }
    }, [_c('horizontal-scroller', {
      attrs: {
        "title": item.grouping,
        "grouping-type": item.groupingType,
        "grouping-route": item.grouping,
        "recipes": item.recipes
      }
    })], 1)
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isFoodDiaryDialogOpen,
      "title": "Add this recipe to your food diary"
    },
    on: {
      "close": _vm.onDialogClose
    }
  }, [_c('div', [_c('mu-row', [_c('mu-col', [_c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n            Date and time\n          ")]), _vm._v(" "), _c('date-picker', {
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "min": 0,
      "full-width": "",
      "label": "Servings",
      "type": "number"
    },
    model: {
      value: (_vm.model.servings),
      callback: function($$v) {
        _vm.$set(_vm.model, "servings", $$v)
      },
      expression: "model.servings"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n            Meal type\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "select",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('svg', {
    staticClass: "customMenu-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5z"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.mealTypeId),
      expression: "model.mealTypeId"
    }],
    staticClass: "borderedSelect",
    staticStyle: {
      "margin-top": "8px",
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "mealTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.mealTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.closeText')
    },
    on: {
      "click": function($event) {
        _vm.isFoodDiaryDialogOpen = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "slot": "actions",
      "disabled": _vm.isRecipeSaving,
      "primary": "",
      "label": _vm.$t('message.saveText')
    },
    on: {
      "click": _vm.addToFoodDiary
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-selector"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "col",
      class: {
        isSelectedTab: _vm.getValue(item) === _vm.value
      },
      domProps: {
        "textContent": _vm._s(_vm.getText(item))
      },
      on: {
        "click": function($event) {
          _vm.selectItem(_vm.getValue(item))
        }
      }
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 3649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "insulin-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "17px",
      "viewBox": "24 191 16 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M39.8354615,192.110676 C39.6853846,191.963108 39.4416923,191.963108 39.2916154,192.110676 L36.9870769,194.375519 L36.7159231,194.109187 C36.4047692,193.803544 35.9911538,193.635187 35.5511538,193.635187 C35.1109231,193.635187 34.6970769,193.803695 34.386,194.10964 L26.7518462,201.615245 L26.2917692,201.163244 C26.1789231,201.052417 26.029,200.99141 25.8694615,200.99141 C25.7098462,200.99141 25.5598462,201.052568 25.4476923,201.162866 L25.4374615,201.172845 C25.2047692,201.401832 25.2048462,201.774228 25.4376923,202.002912 L26.3272308,202.87675 L25.0699231,204.11293 L25.0356154,204.079213 C24.922,203.967631 24.7711538,203.906245 24.6106154,203.906245 C24.45,203.906245 24.2989231,203.967706 24.1843077,204.080423 L24.1758462,204.08889 C23.9413846,204.319237 23.9413846,204.694128 24.1758462,204.924551 L26.8508462,207.552416 C26.9644615,207.663999 27.1153077,207.725385 27.2758462,207.725385 C27.4365385,207.725385 27.5875385,207.663848 27.701,207.552265 L27.7106154,207.542815 C27.9450769,207.312468 27.9450769,206.937577 27.7106154,206.707154 L27.6746154,206.67185 L28.9319231,205.435745 L29.8194615,206.307618 C29.9323077,206.418445 30.0823077,206.479453 30.2417692,206.479453 C30.4013846,206.479453 30.5513846,206.418369 30.6640769,206.307543 L30.6737692,206.298017 C30.9064615,206.069106 30.9063846,205.69671 30.6735385,205.46795 L30.2056154,205.008238 L37.8397692,197.502633 C38.482,196.871238 38.4818462,195.844087 37.8393846,195.212843 L37.531,194.909922 L39.8353846,192.64523 C39.9856923,192.497662 39.9856923,192.258319 39.8354615,192.110676 L39.8354615,192.110676 Z M37.2957692,196.968231 L33.3056154,200.891242 L32.9046923,200.497376 L36.2495385,197.210144 C36.3997692,197.062501 36.3997692,196.823158 36.2495385,196.67559 C36.238,196.664251 36.2250769,196.655481 36.2125385,196.64588 C36.2027692,196.633482 36.1936923,196.620706 36.1820769,196.609291 L35.4078462,195.848472 C35.2576154,195.700829 35.0141538,195.700829 34.8639231,195.848472 C34.7137692,195.996115 34.7137692,196.235383 34.864,196.383026 L35.4337692,196.942905 L35.055,197.31515 L34.4850769,196.75512 C34.3348462,196.607477 34.0913846,196.607477 33.9411538,196.75512 C33.791,196.902763 33.791,197.142031 33.9412308,197.289674 L34.511,197.849553 L34.1322308,198.221798 L33.5624615,197.661843 C33.4123846,197.514276 33.1686923,197.514276 33.0186154,197.661843 C32.8683846,197.809486 32.8683846,198.04883 33.0186154,198.196397 L33.5883077,198.756352 L33.2095385,199.128597 L32.6397692,198.568642 C32.4896923,198.421075 32.246,198.421075 32.0959231,198.568642 C31.9456923,198.716285 31.9456923,198.955629 32.0959231,199.103196 L32.6656154,199.663076 L32.3606154,199.962746 L30.9398462,198.566979 L34.93,194.643967 C35.0959231,194.480827 35.3164615,194.391016 35.5511538,194.391016 C35.7856923,194.391016 36.0061538,194.480751 36.172,194.643665 L37.2954615,195.747322 C37.638,196.08396 37.6380769,196.631592 37.2957692,196.968231 L37.2957692,196.968231 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#34CAB9",
      "fill-rule": "evenodd",
      "transform": "translate(31.974063, 199.862692) scale(-1, -1) translate(-31.974063, -199.862692) "
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "iconClass": "blueIcon",
      "icon": 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "iconClass": "blueIcon",
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', [_c('mu-card-text', {
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "250",
      "data-vv-rules": 'required|min_value:0|max_value:250',
      "data-vv-name": "units",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('units'),
      "type": "number",
      "label": _vm.$t('message.labelUnits'),
      "hintText": ((_vm.$t('message.cardInsulin')) + " " + _vm.lowerCaseUnitsLabel),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.units),
      callback: function($$v) {
        _vm.$set(_vm.model, "units", _vm._n($$v))
      },
      expression: "model.units"
    }
  })], 1), _vm._v(" "), (_vm.isInsulinTypesReady) ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Select",
      "data-vv-rules": 'required',
      "data-vv-name": "insulin_type",
      "data-vv-as": "Type",
      "data-vv-value-path": "inputValue",
      "scroller": _vm.scroller,
      "errorText": _vm.errors.first('insulin_type'),
      "label": _vm.$t('message.labelInsulinType'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }, _vm._l((_vm.insulinTypes), function(type, index) {
    return _c('mu-menu-item', {
      key: 'insulin-type' + index,
      attrs: {
        "value": type.insulin_type_id,
        "title": _vm.mapInsulinTypes(type.type)
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPrivacyFood && _vm.profile.information && _vm.profile.information.basic) ? _c('food-diary', {
    attrs: {
      "userId": _vm.profile.information.basic.user_id
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPrivacyProgress) ? _c('p', [_vm._v("User has chosen to keep their food diary private")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.subscription) ? _c('mu-card-text', {
    staticClass: "form-group subscription-card"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    class: _vm.subscription.isActive === 'active' ? 'detail spacing active-detail' : 'detail spacing inactive-detail'
  }, [_vm._v("\n        " + _vm._s(_vm.subscription.isActive === 'active' ? 'Active' : 'Inactive'))]), _vm._v(" "), (!_vm.invoice && _vm.subscription.isActive === 'active') ? _c('div', {
    staticClass: "detail active-detail spacing"
  }, [_vm._v("\n        Cancelling " + _vm._s(_vm.formatDate(parseInt(_vm.subscription.end_date))) + " "), _c('mu-icon', {
    attrs: {
      "value": "timer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.invoice && _vm.subscription.isActive !== 'active') ? _c('div', {
    staticClass: "detail active-detail spacing"
  }, [_vm._v("\n        Cancelled ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "duration spacing"
  }, [_vm._v(_vm._s(_vm.subscription.interval))]), _vm._v(" "), _c('div', [_c('span', [_vm._v(" - ")])]), _vm._v(" "), _c('div', {
    staticClass: "amount spacing"
  }, [_vm._v(" " + _vm._s(_vm.subscription.currency + " ") + _vm._s(_vm.subscription.amount))])]), _vm._v(" "), (_vm.invoice) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "info spacing"
  }, [_vm._v("\n        Next Invoice on " + _vm._s(_vm.formatDate(parseInt(_vm.subscription.end_date))) + " " + _vm._s(_vm.subscription.currency + " ") + _vm._s(_vm.subscription.amount) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.subscription.isActive === 'active') ? _c('div', {
    staticClass: "flex flex-right"
  }, [_c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.sendingText') + '...' : (!_vm.invoice) ? _vm.$t('message.restoreText') : _vm.$t('message.cancelText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.manageSubscription()
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.subscription) ? _c('mu-card-text', {
    staticClass: "form-group subscription-card"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "info spacing"
  }, [_vm._v("\n        No Active Stripe Subscription at the moment\n      ")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-circle-wrapper active",
    style: ({
      'width': _vm.size + 'px',
      'height': _vm.size + 'px'
    })
  }, [_c('div', {
    staticClass: "mu-circle-spinner active",
    class: {
      'mu-circle-secondary': _vm.secondary
    },
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "mu-circle-clipper left"
  }, [_c('div', {
    staticClass: "mu-circle",
    style: ({
      'border-width': _vm.borderWidth + 'px'
    })
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mu-circle-clipper right"
  }, [_c('div', {
    staticClass: "mu-circle",
    style: ({
      'border-width': _vm.borderWidth + 'px'
    })
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-circle-gap-patch"
  }, [_c('div', {
    staticClass: "mu-circle"
  })])
}]}

/***/ }),
/* 3653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "blood-glucose-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "orient": "horizontal",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.latestReadingTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.value + ' ' + _vm.data.measure)
    }
  }), _vm._v(" "), (_vm.data.userDevice && _vm.data.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('From device: ' + _vm.data.userDevice.nickname),
      expression: "'From device: ' + data.userDevice.nickname",
      modifiers: {
        "left": true
      }
    }],
    staticStyle: {
      "position": "relative",
      "top": "6px",
      "margin-left": "4px"
    },
    attrs: {
      "width": "22",
      "src": "/static/ic_devices_bg@3x.png"
    }
  })]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lastReadingAtTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.data.date))
    }
  }), _vm._v(" "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.inRangeTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.in_range_today)
    }
  }), _vm._v(" "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.averageTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.average + ' ' + _vm.data.measure)
    }
  }), _vm._v(" "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "14px",
      "height": "16px",
      "viewBox": "26 191 11 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.3873266,202.013826 C36.3873266,201.047215 36.0280503,199.003253 34.5350319,197.082478 C33.2459103,195.424041 31.1433712,191 31.1433712,191 C31.1433712,191 29.1414164,195.424041 27.8522947,197.082448 C26.3592763,199.003223 26,201.047186 26,202.013826 C26,204.564452 28.2936491,206.63741 31.1433712,206.685209 L31.1433712,206.686322 C31.1601681,206.686322 31.1768993,206.685883 31.1936633,206.685766 C31.2104602,206.685912 31.2271914,206.686322 31.2439883,206.686322 L31.2439883,206.685209 C34.0936775,206.63741 36.3873266,204.564452 36.3873266,202.013826 L36.3873266,202.013826 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#E74C3C",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), (_vm.data.no_setting) ? _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen || _vm.loading
    },
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": "settings"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.open.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.data.no_setting) ? _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.isOpenInput ? _vm.$t('message.closeText') : _vm.$t('message.addEntryText')),
      expression: "isOpenInput ? $t('message.closeText') : $t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isOpen && _vm.data.no_setting) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [(_vm.data.missing_settings.blood_glucose) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "blood_glucose_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Blood glucose settings",
      "errorText": _vm.errors.first('blood_glucose_setting'),
      "label": "BLOOD GLUCOSE MEASUREMENT",
      "fullWidth": true,
      "scroller": _vm.scroller,
      "separator": ", "
    },
    model: {
      value: (_vm.settings.blood_glucose),
      callback: function($$v) {
        _vm.$set(_vm.settings, "blood_glucose", $$v)
      },
      expression: "settings.blood_glucose"
    }
  }, _vm._l((_vm.data.missing_settings.blood_glucose), function(item, index) {
    return _c('mu-menu-item', {
      key: 'blood-glucose-setting-' + item,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.glucose_range) ? _c('div', [_c('vue-slider', _vm._b({
    model: {
      value: (_vm.sliderSettings.value),
      callback: function($$v) {
        _vm.$set(_vm.sliderSettings, "value", $$v)
      },
      expression: "sliderSettings.value"
    }
  }, 'vue-slider', _vm.sliderSettings, false))], 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.hba1c) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "hba1c_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hbA1c settings",
      "errorText": _vm.errors.first('hba1c_setting'),
      "label": "HBA1C MEASUREMENT",
      "fullWidth": true,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.settings.hba1c),
      callback: function($$v) {
        _vm.$set(_vm.settings, "hba1c", $$v)
      },
      expression: "settings.hba1c"
    }
  }, _vm._l((_vm.data.missing_settings.hba1c), function(item, index) {
    return _c('mu-menu-item', {
      key: 'hba1c-setting-' + item,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onEnter,
      "leave": _vm.onLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.bloodGlucose.measure === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "540",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:540',
      "data-vv-as": "mg/dL",
      "data-vv-name": "mgdl",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mgdl'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mgdl", _vm._n($$v))
      },
      expression: "model.blood_glucose_mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose.measure === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "30",
      "data-vv-validate-on": "none",
      "data-vv-as": "mmol/L",
      "data-vv-rules": 'min_value:0|max_value:30',
      "data-vv-name": "mmoll",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mmoll'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mmoll", _vm._n($$v))
      },
      expression: "model.blood_glucose_mmoll"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "25",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": "%",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_percent),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_percent", _vm._n($$v))
      },
      expression: "model.hba1c_percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "300",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_mmol_mol", _vm._n($$v))
      },
      expression: "model.hba1c_mmol_mol"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "label": _vm.$t('message.labelTagYourReading'),
      "fullWidth": true,
      "maxHeight": 300,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.model.tag),
      callback: function($$v) {
        _vm.$set(_vm.model, "tag", $$v)
      },
      expression: "model.tag"
    }
  }, _vm._l((_vm.readingTags), function(tag, index) {
    return _c('mu-menu-item', {
      key: 'reading-tag' + index,
      attrs: {
        "value": tag,
        "title": _vm.$t(_vm.localizeTag(tag.tag))
      }
    })
  }), 1), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-list",
    class: {
      isLoading: _vm.isLoading
    }
  }, [_c('mu-card', [_c('mu-content-block', {
    staticClass: "meal-list-header"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "600"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.mealTypeTitle) + "\n        ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_vm._t("button")], 2)], 1)], 1), _vm._v(" "), (!_vm.isLoading && _vm.foods.length === 0 && _vm.recipes.length === 0) ? _c('mu-card-text', [(_vm.mealType === 'breakfast') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoBreakfastLabel'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealType === 'lunch') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoLunchLabel'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealType === 'dinner') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoDinnerLabel'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mealType === 'snack') ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryNoSnackLabel'))
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('md-list', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dl-' + index,
      attrs: {
        "title": '',
        "disableRipple": ""
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "150px",
        "height": "8px",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#0179d5"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "margin-bottom": "16px",
        "height": "8px",
        "width": "80px",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#0179d5"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && (_vm.foods.length > 0 || _vm.recipes.length > 0)) ? _c('md-list', [((_vm.foods.length > 0 || _vm.recipes.length > 0) && !_vm.quickAddHidden) ? _c('div', {
    staticClass: "quickSaveNotice"
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "vertAlign",
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_vm._v("\n\n            " + _vm._s(_vm.$t('message.foodDiarySaveMealForNextTime')) + "\n\n          ")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "tooltip": _vm.$t('message.labelYes'),
      "icon": "check"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addToMealPlate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": _vm.$t('message.labelNo'),
      "icon": "close"
    },
    nativeOn: {
      "click": function($event) {
        _vm.quickAddHidden = true
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.recipes), function(item, index) {
    return (_vm.recipes.length > 0) ? _c('mu-list-item', {
      key: 'recipe-' + index
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('img', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: ('Low Carb Program Recipe'),
        expression: "'Low Carb Program Recipe'",
        modifiers: {
          "top": true
        }
      }],
      staticStyle: {
        "position": "relative",
        "top": "4px",
        "margin-right": "4px"
      },
      attrs: {
        "width": "16",
        "src": "static/lcp-logo.svg"
      }
    }), _vm._v("\n\n            " + _vm._s(item.name) + "\n\n\n          ")]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "4px"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.servings + ' serving(s)')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nutrients"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrateShort')) + " " + _vm._s(_vm.decimalize(item.carbohydrate)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCaloriesShort')) + " " + _vm._s(_vm.decimalize(item.calories)) + "kcal · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')) + " " + _vm._s(_vm.decimalize(item.protein)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientTotalFatShort')) + " " + _vm._s(_vm.decimalize(item.fat)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientSaturatedFatShort')) + " " + _vm._s(_vm.decimalize(item.saturated_fat)) + "g")])])]), _vm._v(" "), _c('mu-icon-menu', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('View/Edit/Delete'),
        expression: "'View/Edit/Delete'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.labelViewNutrition')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.viewRecipeNutrients(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": "Go to recipe"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToRecipe(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openEditRecipeEntryDialog(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteRecipe(item, index)
        }
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.foods), function(food, index) {
    return (_vm.foods.length > 0) ? _c('mu-list-item', {
      key: 'food-' + index,
      attrs: {
        "title": food.food_name,
        "disableRipple": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [(food.brand_name !== '') ? _c('div', {
      staticClass: "brandName",
      domProps: {
        "textContent": _vm._s(food.brand_name)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      domProps: {
        "textContent": _vm._s(food.servings + ' x ' + food.serving_description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "nutrients"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrateShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.carbohydrate * food.servings)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientCaloriesShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.calories * food.servings)) + "kcal · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')) + " " + _vm._s(_vm.decimalize(food.nutrients.protein * food.servings)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientTotalFatShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.fat * food.servings)) + "g · ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.nutrientSaturatedFatShort')) + " " + _vm._s(_vm.decimalize(food.nutrients.saturated_fat * food.servings)) + "g")])])]), _vm._v(" "), _c('mu-icon-menu', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('View/Edit/Delete'),
        expression: "'View/Edit/Delete'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.labelViewNutrition')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.viewNutrients(food)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editFood(food)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteFood(food, index)
        }
      }
    })], 1)], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-flexbox', {
    staticClass: "nutritionalValues"
  }, [_c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrateShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.carbohydrate)) + "g\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCaloriesShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.calories)) + "kcal\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.protein)) + "g\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(" " + _vm._s(_vm.$t('message.nutrientTotalFatShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.fat)) + "g\n        ")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "center last"
  }, [_c('div', {
    staticClass: "nutritional-header"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientSaturatedFatShort')))]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.decimalize(_vm.totals.saturated_fat)) + "g\n        ")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('md-dialog', {
    ref: "recipeNutritionDialog",
    staticClass: "nutrition-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.activeRecipeObject.name,
      "subTitle": _vm.activeRecipeObject.servings + ' serving(s)',
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeRecipeObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrients-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.decimalize(value) + _vm.getUnit(key)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "editRecipeDialog",
    staticClass: "edit-recipe-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.editRecipeEntryModel.name,
      "subTitle": " This food is added from the recipe area and is limited to modifying serving sizes only"
    }
  }), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateRecipeEntry.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-text-field', {
    attrs: {
      "fullWidth": "",
      "label": "Servings",
      "type": "number"
    },
    model: {
      value: (_vm.editRecipeEntryModel.servings),
      callback: function($$v) {
        _vm.$set(_vm.editRecipeEntryModel, "servings", $$v)
      },
      expression: "editRecipeEntryModel.servings"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isRecipeUpdating,
      "type": "button",
      "full-width": "",
      "label": _vm.$t('message.updateText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateRecipeEntry.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "disabled": _vm.isRecipeUpdating,
      "type": "submit",
      "full-width": "",
      "label": _vm.$t('message.updateText')
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "nutritionDialog",
    staticClass: "nutrition-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.activeFoodObject.food_name,
      "subTitle": _vm.activeFoodObject.servings + ' x ' + _vm.activeFoodObject.serving_description,
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeFoodObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrient-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.decimalize(value * _vm.activeFoodObject.servings) + _vm.getUnit(key)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "mealPlateNamer",
    staticClass: "nutrition-dialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.foodDiaryMealPlateNameTitle'),
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMealPlate.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('div', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "nameText",
      "data-vv-as": _vm.$t('message.nameText'),
      "data-vv-value-path": "inputValue",
      "label": _vm.$t('message.nameText'),
      "hint-text": _vm.$t('message.placeholderText'),
      "full-width": ""
    },
    model: {
      value: (_vm.mealPlateName),
      callback: function($$v) {
        _vm.mealPlateName = $$v
      },
      expression: "mealPlateName"
    }
  })], 1)]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "type": "button",
      "secondarys": "",
      "disabled": _vm.isRecipeUpdating,
      "label": _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveMealPlate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-search-results-dialog"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticStyle: {
      "position": "relative",
      "z-index": "99"
    }
  }, [_c('mu-list', [_c('mu-list-item', {
    attrs: {
      "disableRipple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.searchTerm)
    }
  })]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    attrs: {
      "slot": "after"
    },
    slot: "after"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.results.length)
    }
  }), _vm._v(" of "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.options.total_results + ' ' + _vm.$t('message.labelFoods'))
    }
  })]) : _vm._e(), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('goBack', 'a')
      }
    },
    slot: "left"
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area",
    attrs: {
      "id": "resultScroller"
    }
  }, [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.results.length === 0) ? _c('mu-list', {
    staticClass: "oddEven"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.labelFoodSearchResultsEmpty')
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "warning"
    },
    slot: "left"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.results.length >= 1) ? _c('mu-list', {
    staticClass: "oddEven"
  }, [_vm._l((_vm.results), function(result, index) {
    return _c('mu-list-item', {
      key: 'result-' + index,
      attrs: {
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectFood(result)
        }
      }
    }, [_vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "textContent": _vm._s(result.food_name)
      },
      slot: "title"
    }), 0, 'result-' + index), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(result.food_description)
      }
    }), _vm._v(" "), (result.brand_name) ? _c('div', {
      staticClass: "brandName",
      domProps: {
        "textContent": _vm._s(result.brand_name)
      }
    }) : _vm._e()]), _vm._v(" "), _vm._o(_c('div', {
      attrs: {
        "slot": "after"
      },
      slot: "after"
    }), 1, 'result-' + index), _vm._v(" "), _vm._o(_c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "add_circle"
      },
      slot: "right"
    }), 2, 'result-' + index)], 1)
  }), _vm._v(" "), (!_vm.isAppending && _vm.options.total_results > _vm.results.length) ? _c('div', {
    attrs: {
      "id": "infinite-scroll-detector"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isAppending) ? _c('div', {
    staticStyle: {
      "padding": "24px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.settings) ? _c('div', {
    staticStyle: {
      "height": "90%"
    },
    attrs: {
      "id": "check-in"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "90%"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "white content"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "10",
      "desktop": "10"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "80",
      "desktop": "80"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "10",
      "desktop": "10"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "navigation"
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.status.isDiabetic) ? _c('div', [_c('div', {
    staticClass: "oval left",
    class: {
      active: _vm.$route.name === 'WeightCheckin'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "oval left",
    class: {
      active: _vm.$route.name === 'Hba1cCheckin'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "oval",
    class: {
      active: _vm.$route.name === 'GoalsCheckin'
    }
  })]) : _c('div', [_c('div', {
    staticClass: "oval",
    class: {
      active: _vm.$route.name === 'WeightCheckin'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "oval left",
    class: {
      active: _vm.$route.name === 'GoalsCheckin'
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.$route.name === 'WeightCheckin') ? _c('mu-flat-button', {
    staticClass: "transparent",
    attrs: {
      "label": "Skip"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.determineRoute()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Hba1cCheckin') ? _c('mu-flat-button', {
    staticClass: "transparent",
    attrs: {
      "label": "I don't know my HbA1c"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigate('GoalsCheckin')
      }
    }
  }) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "blood-glucose-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "14px",
      "height": "16px",
      "viewBox": "26 191 11 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.3873266,202.013826 C36.3873266,201.047215 36.0280503,199.003253 34.5350319,197.082478 C33.2459103,195.424041 31.1433712,191 31.1433712,191 C31.1433712,191 29.1414164,195.424041 27.8522947,197.082448 C26.3592763,199.003223 26,201.047186 26,202.013826 C26,204.564452 28.2936491,206.63741 31.1433712,206.685209 L31.1433712,206.686322 C31.1601681,206.686322 31.1768993,206.685883 31.1936633,206.685766 C31.2104602,206.685912 31.2271914,206.686322 31.2439883,206.686322 L31.2439883,206.685209 C34.0936775,206.63741 36.3873266,204.564452 36.3873266,202.013826 L36.3873266,202.013826 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#E74C3C",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.isOpenInput ? _vm.$t('message.closeText') : _vm.$t('message.addEntryText')),
      expression: "isOpenInput ? $t('message.closeText') : $t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "novalidate": ""
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.$store.state.user.settings.blood_glucose.measure === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "540",
      "data-vv-rules": 'required|min_value:0|max_value:540',
      "data-vv-as": "mg/dL",
      "data-vv-name": "mgdl",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mgdl'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mgdl", _vm._n($$v))
      },
      expression: "model.blood_glucose_mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "30",
      "data-vv-as": "mmol/L",
      "data-vv-rules": 'required|min_value:0|max_value:30',
      "data-vv-name": "mmoll",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mmoll'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mmoll", _vm._n($$v))
      },
      expression: "model.blood_glucose_mmoll"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "25",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": _vm.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_percent),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_percent", _vm._n($$v))
      },
      expression: "model.hba1c_percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "300",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_mmol_mol", _vm._n($$v))
      },
      expression: "model.hba1c_mmol_mol"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "multiple": "",
      "separator": ", ",
      "label": _vm.$t('message.labelTagYourReading'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": true,
      "maxHeight": 300,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.model.tags),
      callback: function($$v) {
        _vm.$set(_vm.model, "tags", $$v)
      },
      expression: "model.tags"
    }
  }, _vm._l((_vm.readingTags), function(tag, index) {
    return _c('mu-menu-item', {
      key: 'reading-tag-' + index,
      attrs: {
        "value": tag,
        "title": _vm.$t(_vm.localizeTag(tag.tag))
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-flex",
      "height": "100%"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "icon": "image",
      "label": "Add pictures"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onBtnClick()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.id,
      "accept": "image/png,image/jpg",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.fileInputChanged
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.user.scope) ? _c('div', [_c('div', {
    staticClass: "headerGroup"
  }, [(_vm.data.question.user.user_id === _vm.user.scope.user_id) ? _c('edit-question-title', {
    attrs: {
      "question-id": _vm.data.question.question_id,
      "title": _vm.data.question.question
    },
    on: {
      "questionUpdated": _vm.questionDidUpdate
    }
  }) : _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.data.question.question))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "thread-date"
  }, [_vm._v(_vm._s(_vm.$t('message.threadAskedBy')) + " "), _c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.data.question.user.profile.url
      }
    }
  }, [_vm._v(_vm._s(_vm.encodeText(_vm.data.question.user.display_name)))]), _vm._v(" on " + _vm._s(_vm.formatDate(_vm.data.question.timestamp)))], 1)], 1), _vm._v(" "), _c('mu-card', [_c('mu-card-text', {
    staticClass: "userCard"
  }, [_c('div', {
    staticClass: "userImage",
    class: {
      'has-photo': !!_vm.data.question.user.avatar
    },
    style: (_vm.data.question.user.avatar ? {
      backgroundImage: 'url(' + _vm.data.question.user.avatar + ')'
    } : null)
  }, [(!_vm.data.question.user.avatar) ? _c('span', [_vm._v(_vm._s(_vm.avatarInitials(_vm.data.question.user.display_name)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', {
    staticClass: "badges"
  }, [(_vm.data.question.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_mentor) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_moderator) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.data.question.user.profile.url
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.encodeText(_vm.data.question.user.display_name)) + " "), (_vm.data.question.user.country.country_id !== 0) ? _c('country-badge', {
    attrs: {
      "alpha2": _vm.data.question.user.country.alpha2,
      "tooltip": _vm.data.question.user.country.country_name
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data.hcp_question && _vm.data.question.user.is_hcp && _vm.data.question.user.hcp_verified) ? _c('user-badge', {
    staticClass: "hcpBadge",
    attrs: {
      "type": "hcp-verified",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine",
    domProps: {
      "textContent": _vm._s(_vm.data.hcp_question && _vm.data.question.user.is_hcp ? _vm.data.question.user.hcp_role : _vm.data.question.user.diabetes_type)
    }
  }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "posts"
  }, [_vm._v(_vm._s(_vm.$t('message.threadPostsCount')) + " " + _vm._s(_vm.data.question.posts))])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "date",
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.data.question.timestamp))
    }
  })])], 1)], 1)]), _vm._v(" "), (!_vm.isQuestionEditOpen) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.data.question.content || _vm.data.question.question)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isQuestionEditOpen) ? _c('mu-card-text', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateQuestion.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "textarea",
    attrs: {
      "data-vv-scope": "editQuestion",
      "data-vv-name": "question",
      "data-vv-validate-on": "none",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('question'),
      "data-vv-as": _vm.$t('message.labelBody'),
      "labelFloat": false,
      "multiLine": "",
      "rows": 1,
      "rowsMax": 10,
      "hintText": _vm.$t('message.labelBody'),
      "fullWidth": true
    },
    model: {
      value: (_vm.questionEditModel.content),
      callback: function($$v) {
        _vm.$set(_vm.questionEditModel, "content", $$v)
      },
      expression: "questionEditModel.content"
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditQuestion.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.updateText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateQuestion()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isQuestionEditOpen) ? _c('div', [(_vm.data.question.likes !== 0) ? _c('mu-card-text', {
    staticClass: "likesCounter",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.pluralizeUseful(_vm.data.question.likes, _vm.data.question.liked)))
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
    staticClass: "actions",
    attrs: {
      "align": "left"
    }
  }, [((_vm.user.user_role.role_id !== 2 && _vm.data.question.user.is_admin !== true) && _vm.data.question.user.user_id !== _vm.user.scope.user_id) ? _c('mu-flat-button', {
    staticClass: "reportBtn",
    attrs: {
      "color": "#D83E38",
      "disabled": _vm.data.question.reported,
      "icon": "report_problem",
      "label": _vm.data.question.reported ? _vm.$t('message.reportedText') : _vm.$t('message.reportText')
    },
    on: {
      "click": function($event) {
        return _vm.openReport('THREAD_QUESTION', _vm.data.question.question_id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.user_id !== _vm.user.scope.user_id) ? _c('mu-flat-button', {
    class: {
      active: _vm.data.question.liked
    },
    attrs: {
      "color": "#0179d9",
      "icon": "thumb_up",
      "label": _vm.$t('message.discussionTabUseful'),
      "disabled": _vm.isLiking
    },
    nativeOn: {
      "click": function($event) {
        return _vm.markQuestionUseful.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.user_id === _vm.user.scope.user_id) ? _c('mu-flat-button', {
    attrs: {
      "color": "#0179d9",
      "icon": "edit",
      "label": _vm.$t('message.editText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditQuestion()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.user_id === _vm.user.scope.user_id || _vm.user.user_role.role_id === 2) ? _c('mu-flat-button', {
    attrs: {
      "color": "#0179d9",
      "icon": "delete",
      "label": _vm.$t('message.deleteText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteQuestion(_vm.data.question.question_id)
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.data.question.report_count > 0 && _vm.user.user_role.role_id === 2) ? _c('report', {
    attrs: {
      "type": "THREAD_QUESTION",
      "typeId": parseInt(_vm.$route.params.id)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.data.replies.length > 0) ? _c('div', {
    attrs: {
      "id": "replies"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "width": "100",
      "tablet": "50"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "pagination"
  }, [(_vm.data.replies.length !== 0) ? _c('mu-pagination', {
    attrs: {
      "total": _vm.data.count_replies,
      "current": _vm.page,
      "defaultPageSize": _vm.per_page,
      "pageSize": _vm.per_page
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "width": "50",
      "tablet": "25"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "underlineFocusClass": "underlineFocus",
      "fullWidth": ""
    },
    model: {
      value: (_vm.orderBy),
      callback: function($$v) {
        _vm.orderBy = $$v
      },
      expression: "orderBy"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "CHRONOLOGICAL",
      "title": _vm.$t('message.threadChronological')
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "MOST_RECENT",
      "title": _vm.$t('message.threadMostRecent')
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "width": "50",
      "tablet": "25"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "underlineFocusClass": "underlineFocus",
      "fullWidth": ""
    },
    on: {
      "change": function($event) {
        return _vm.updatePerPage()
      }
    },
    model: {
      value: (_vm.per_page),
      callback: function($$v) {
        _vm.per_page = $$v
      },
      expression: "per_page"
    }
  }, _vm._l((_vm.pageSizes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'page-size-' + index,
      attrs: {
        "value": item,
        "title": item + ' per page'
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.data.replies), function(thread, index) {
    return _c('mu-row', {
      key: 'reply-' + index
    }, [_c('mu-col', {
      attrs: {
        "desktop": "100",
        "width": "100",
        "tablet": "100"
      }
    }, [_c('mu-card', {
      class: {
        'bottom': index !== (_vm.data.replies.length - 1) && _vm.user.user_role.role_id !== 2 || thread.report_count === 0
      }
    }, [_c('mu-card-text', {
      staticClass: "userCard"
    }, [_c('div', {
      staticClass: "userImage",
      class: {
        'has-photo': !!thread.user.avatar
      },
      style: (thread.user.avatar ? {
        backgroundImage: 'url(' + thread.user.avatar + ')'
      } : null)
    }, [(!thread.user.avatar) ? _c('span', [_vm._v(_vm._s(_vm.avatarInitials(thread.user.display_name)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "userBlock"
    }, [_c('div', {
      staticClass: "badges"
    }, [(thread.user.is_admin) ? _c('user-badge', {
      attrs: {
        "type": "support",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_mentor) ? _c('user-badge', {
      attrs: {
        "type": "support",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_moderator) ? _c('user-badge', {
      attrs: {
        "type": "support",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_champion) ? _c('user-badge', {
      attrs: {
        "type": "champion",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_complete) ? _c('user-badge', {
      attrs: {
        "type": "finished-program",
        "mode": "image"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
      attrs: {
        "to": {
          path: '/profile/' + thread.user.profile.url
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.encodeText(thread.user.display_name)) + " "), (thread.user.country.country_id !== 0) ? _c('country-badge', {
      attrs: {
        "alpha2": thread.user.country.alpha2,
        "tooltip": thread.user.country.country_name
      }
    }) : _vm._e()], 1), _vm._v(" "), (_vm.data.hcp_question && thread.user.is_hcp && thread.user.hcp_verified) ? _c('user-badge', {
      staticClass: "hcpBadge",
      attrs: {
        "type": "hcp-verified",
        "mode": "image"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "blueLine",
      domProps: {
        "textContent": _vm._s(_vm.data.hcp_question && thread.user.is_hcp ? thread.user.hcp_role : thread.user.diabetes_type)
      }
    }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "50"
      }
    }, [_c('div', {
      staticClass: "posts"
    }, [_vm._v(_vm._s(_vm.$t('message.threadPostsCount')) + " " + _vm._s(thread.posts))])]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "50"
      }
    }, [_c('div', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(_vm.formatDate(thread.timestamp))
      }
    })])], 1)], 1)]), _vm._v(" "), _vm._l((thread.answer_quotes), function(reply, index) {
      return (reply.display_name) ? _c('mu-card-text', {
        key: 'reply' + index,
        staticClass: "quotes"
      }, [_c('mu-card', [_c('mu-card-header', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.$sanitize(reply.display_name + ' ' + _vm.$t('message.threadUserSaid') + ' &uarr;'))
        }
      })]), _vm._v(" "), _c('mu-card-text', [_c('vue-markdown', {
        attrs: {
          "source": _vm.$sanitize(reply.answer.substr(0, 300) + ' ...')
        }
      })], 1)], 1)], 1) : _vm._e()
    }), _vm._v(" "), _c('mu-card-text', [(!thread.editOpen) ? _c('vue-markdown', {
      staticStyle: {
        "white-space": "pre-wrap"
      },
      attrs: {
        "source": _vm.escape(_vm.$sanitize(thread.answer))
      }
    }) : _vm._e()], 1), _vm._v(" "), (thread.editOpen) ? _c('mu-card-text', [_c('form', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-scope": "updateAnswer"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateAnswer(thread)
        }
      }
    }, [(thread.editOpen) ? _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|min:5'),
        expression: "'required|min:5'"
      }],
      staticClass: "textarea",
      attrs: {
        "id": 'reply-' + thread.answer_id,
        "data-vv-validate-on": "none",
        "data-vv-name": 'reply-' + thread.answer_id,
        "data-vv-value-path": "inputValue",
        "data-vv-as": _vm.$t('message.labelBody'),
        "errorText": _vm.errors.first('reply-' + thread.answer_id),
        "labelFloat": false,
        "multiLine": "",
        "rows": 1,
        "rowsMax": 10,
        "hintText": _vm.$t('message.replyToText') + ' ' + thread.user.display_name,
        "fullWidth": true,
        "readonly": _vm.isSaving,
        "disabled": _vm.isSaving
      },
      model: {
        value: (thread.editableReply),
        callback: function($$v) {
          _vm.$set(thread, "editableReply", $$v)
        },
        expression: "thread.editableReply"
      }
    }) : _vm._e(), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "label": _vm.$t('message.discardText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.discardEdit(thread)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "submit"
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      attrs: {
        "secondary": "",
        "disabled": thread.isUpdating,
        "label": thread.isUpdating ? _vm.$t('message.updatingText') + '...' : _vm.$t('message.updateText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.updateAnswer(thread)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (thread.likes !== 0) ? _c('mu-card-text', {
      staticClass: "likesCounter",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.pluralizeUseful(thread.likes, thread.liked)))
      }
    }) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
      staticClass: "actions",
      attrs: {
        "align": "left"
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v("#" + _vm._s(_vm.getPageIndex(index)))]), _vm._v(" "), ((_vm.user.user_role.role_id !== 2 && thread.user.is_admin !== true) && thread.user.user_id !== _vm.user.scope.user_id) ? _c('mu-flat-button', {
      staticClass: "reportBtn",
      attrs: {
        "color": "#D83E38",
        "disabled": thread.reported,
        "icon": "report_problem",
        "label": thread.reported ? _vm.$t('message.reportedText') : _vm.$t('message.reportText')
      },
      on: {
        "click": function($event) {
          return _vm.openReport('THREAD_ANSWER', thread.answer_id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.user.scope.user_id !== thread.user.user_id) ? _c('mu-flat-button', {
      class: {
        active: thread.liked
      },
      attrs: {
        "color": "#0179d5",
        "icon": "thumb_up",
        "label": _vm.$t('message.discussionTabUseful'),
        "disabled": thread.isLiking
      },
      nativeOn: {
        "click": function($event) {
          return _vm.markUseful(thread)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.user.scope.user_id === thread.user.user_id) ? _c('mu-flat-button', {
      attrs: {
        "color": "#0179d5",
        "icon": "edit",
        "label": "Edit"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editAnswer(thread)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.user.scope.user_id === thread.user.user_id || _vm.user.user_role.role_id === 2) ? _c('mu-flat-button', {
      attrs: {
        "color": "#0179d5",
        "icon": "delete",
        "label": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteAnswer(thread, thread.answer_id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "color": "#0179d5",
        "icon": "reply",
        "label": _vm.capitalize(_vm.$t('message.replyText'))
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggleReplyPanel(thread)
        }
      }
    })], 1), _vm._v(" "), (thread.replyOpen) ? _c('mu-card-text', [_c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "textarea",
      attrs: {
        "id": 'reply-' + thread.answer_id,
        "data-vv-name": 'reply-' + thread.answer_id,
        "data-vv-value-path": "inputValue",
        "errorText": _vm.errors.first('reply-' + thread.answer_id),
        "data-vv-as": _vm.$t('message.labelBody'),
        "labelFloat": false,
        "multiLine": "",
        "rows": 1,
        "rowsMax": 10,
        "hintText": _vm.$store.state.status.payment.paid ? _vm.$t('message.replyToText') + ' ' + thread.user.display_name : 'Only premium users can answer a question',
        "fullWidth": true,
        "readonly": _vm.isSaving,
        "disabled": _vm.isSaving
      },
      model: {
        value: (thread.replyable),
        callback: function($$v) {
          _vm.$set(thread, "replyable", $$v)
        },
        expression: "thread.replyable"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (thread.replyOpen),
        expression: "thread.replyOpen"
      }],
      attrs: {
        "align": "right"
      }
    }, [_c('mu-flat-button', {
      attrs: {
        "label": _vm.$t('message.discardText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggleReplyPanel(thread)
        }
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "color": "white",
        "backgroundColor": "#7CBE30",
        "label": thread.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.submitText'),
        "disabled": thread.isSaving || !_vm.$store.state.status.payment.paid
      },
      nativeOn: {
        "click": function($event) {
          return _vm.replyToAnswer(thread)
        }
      }
    })], 1)], 2), _vm._v(" "), (thread.report_count > 0 && _vm.user.user_role.role_id === 2) ? _c('report', {
      attrs: {
        "type": "THREAD_ANSWER",
        "typeId": thread.answer_id
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [(_vm.data.replies.length !== 0) ? _c('mu-pagination', {
    staticClass: "top",
    attrs: {
      "total": _vm.data.count_replies,
      "current": _vm.page,
      "defaultPageSize": _vm.per_page,
      "pageSize": _vm.per_page
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.data.replies.length === 0) ? _c('mu-card', {
    staticClass: "top"
  }, [_c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.threadAnswersEmpty')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navigate"
  }, [(_vm.data.prev) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'QuestionThread',
        params: {
          id: _vm.data.prev
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.threadPreviousQuestion')))]) : _vm._e(), _vm._v(" "), (_vm.data.prev != 0 && _vm.data.next != 0) ? _c('span', {
    staticClass: "sep"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.data.next) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'QuestionThread',
        params: {
          id: _vm.data.next
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.threadNextQuestion')))]) : _vm._e()], 1), _vm._v(" "), _c('form', {
    attrs: {
      "id": "submitReplyForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveAnswer.apply(null, arguments)
      }
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "textarea",
    attrs: {
      "data-vv-name": "answer",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.labelBody'),
      "errorText": _vm.errors.first('answer'),
      "labelFloat": false,
      "multiLine": "",
      "rows": 3,
      "rowsMax": 6,
      "hintText": _vm.$store.state.status.payment.paid ? _vm.$t('message.threadInputPlaceholder') : 'Only premium users can ask a question',
      "fullWidth": "",
      "readonly": _vm.isSaving,
      "disabled": _vm.isSaving
    },
    model: {
      value: (_vm.model.answer),
      callback: function($$v) {
        _vm.$set(_vm.model, "answer", $$v)
      },
      expression: "model.answer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "backgroundColor": "#3d8517",
      "color": "white",
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.threadSubmitReplyText'),
      "disabled": _vm.isSaving || !_vm.$store.state.status.payment.paid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveAnswer.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.activeReport.type && _vm.activeReport.type_id) ? _c('report-modal', {
    attrs: {
      "open": _vm.activeReport.open,
      "type": _vm.activeReport.type,
      "type_id": _vm.activeReport.type_id
    },
    on: {
      "onClose": function($event) {
        _vm.activeReport.open = false
      },
      "onComplete": function($event) {
        return _vm.setReported(_vm.activeReport)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-top": "34px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#1FA3FF",
      "size": 40
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isNewMessage) ? _c('mu-snackbar', {
    attrs: {
      "message": "1 new reply - reload the page?",
      "action": _vm.$t('message.okText'),
      "actionColor": "#1FA3FF"
    },
    on: {
      "actionClick": function($event) {
        return _vm.loadData({
          page: 1,
          per_page: 10,
          latest: 'true'
        }, true)
      },
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answerRemoved) ? _c('mu-toast', {
    attrs: {
      "message": "Your answer was removed"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "activity-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-paper', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-content-block', [_c('service-tracking-types', {
    staticStyle: {
      "float": "right",
      "display": "inline-block",
      "margin-top": "4px",
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "activity"
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#183C45"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.graphEmpty')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.graphEmptyExplain')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  })], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(0)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(7)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(30)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(360)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPrivacyProgress || _vm.isAdmin) ? _c('profile-gallery', {
    attrs: {
      "images": _vm.images,
      "isOwner": _vm.isOwner
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPrivacyProgress && !_vm.isAdmin) ? _c('p', [_vm._v("User has chosen to keep their gallery private")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert bottom"
  }, [_c('mu-card', {
    class: [_vm.type]
  }, [_c('mu-card-text', [_c('div', {
    staticClass: "alert-left",
    class: {
      topAlign: _vm.align === 'top',
      middleAlign: _vm.align === 'middle'
    }
  }, [_c('mu-icon', {
    staticClass: "flex",
    attrs: {
      "value": _vm.icon
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "alert-body",
    class: {
      topAlign: _vm.align === 'top',
      middleAlign: _vm.align === 'middle'
    }
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "alert-after",
    class: {
      topAlign: _vm.align === 'top',
      middleAlign: _vm.align === 'middle'
    }
  }, [_vm._t("after")], 2), _vm._v(" "), _c('div', [_vm._t("action")], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.userId !== false) ? _c('mu-card', {
    attrs: {
      "id": "commentForm"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "addCommentTitle",
      "title": 'Add a comment'
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('form', {
    attrs: {
      "name": "commentForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addComment.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    staticClass: "addCommentInput",
    attrs: {
      "hintText": "Add a comment",
      "multiLine": "",
      "fullWidth": "",
      "rows": 3,
      "rowsMax": 6,
      "underlineShow": false
    },
    model: {
      value: (_vm.addCommentModel.message),
      callback: function($$v) {
        _vm.$set(_vm.addCommentModel, "message", $$v)
      },
      expression: "addCommentModel.message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "addComment",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "fullWidth": "",
      "type": "button",
      "label": _vm.$t('message.addCommentText'),
      "disabled": _vm.isAddingComment
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addComment.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.userId !== false) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "flex-start"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "grow": ""
    }
  }, [_c('h2', {
    staticClass: "commentsTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize('Comments ' + ' <span>&middot</span> ' + _vm.commentParams.totalComments))
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.comments.length === 0 && !_vm.isCommentsLoading) ? _c('mu-card', {
    staticClass: "noComments"
  }, [_c('mu-card-text', [_vm._v("\n      No comments yet\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCommentsLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.comments), function(comment, commentIndex) {
    return (!_vm.isCommentsLoading) ? _c('mu-card', {
      key: 'comment-' + commentIndex,
      staticClass: "comment"
    }, [_c('mu-card-header', {
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('div', {
      staticClass: "mu-card-header-title",
      staticStyle: {
        "padding-right": "40px"
      }
    }, [_c('div', {
      staticClass: "mu-card-title"
    }, [_c('div', {
      staticClass: "titleBlock"
    }, [_c('router-link', {
      staticClass: "name",
      attrs: {
        "to": '/profile/' + comment.user.profile_url
      },
      domProps: {
        "textContent": _vm._s(comment.user.display_name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dateBadgeWrap"
    }, [_c('div', {
      staticClass: "badges"
    }, [(comment.user.is_admin) ? _c('user-badge', {
      attrs: {
        "mode": "text",
        "type": "support"
      }
    }) : _vm._e(), _vm._v(" "), (comment.user.is_complete) ? _c('user-badge', {
      attrs: {
        "mode": "text",
        "type": "finished-program"
      }
    }) : _vm._e(), _vm._v(" "), (comment.user.is_champion) ? _c('user-badge', {
      attrs: {
        "type": "champion",
        "mode": "text"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(_vm.time(comment.timestamp))
      }
    })])], 1)])]), _vm._v(" "), (!_vm.containsAvatarMed(comment.user.profile_large, 'avatar-med') && comment.user.profile_large != null) ? _c('mu-avatar', {
      attrs: {
        "slot": "avatar",
        "src": comment.user.profile_large
      },
      slot: "avatar"
    }) : _vm._e(), _vm._v(" "), (_vm.containsAvatarMed(comment.user.profile_large, 'avatar-med') || comment.user.profile_large === null) ? _c('mu-avatar', {
      attrs: {
        "slot": "avatar"
      },
      slot: "avatar"
    }, [_vm._v("\n        " + _vm._s(_vm.getInitialsFromName(comment.user.display_name, ' ')) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('mu-card-text', {
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_c('vue-markdown', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!comment.editcomment),
        expression: "!comment.editcomment"
      }],
      attrs: {
        "source": comment.comment
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (comment.editcomment),
        expression: "comment.editcomment"
      }],
      staticClass: "editable"
    }, [_c('mu-text-field', {
      attrs: {
        "multiLine": "",
        "fullWidth": "",
        "rows": 3,
        "rowsMax": 6
      },
      model: {
        value: (comment.edit_comment),
        callback: function($$v) {
          _vm.$set(comment, "edit_comment", $$v)
        },
        expression: "comment.edit_comment"
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      staticClass: "demo-flat-button",
      attrs: {
        "label": _vm.$t('message.cancelText'),
        "primary": ""
      },
      on: {
        "click": function($event) {
          return _vm.closeReply(0, commentIndex)
        }
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      staticClass: "demo-flat-button",
      attrs: {
        "label": "Save edit",
        "secondary": ""
      },
      on: {
        "click": function($event) {
          return _vm.updateComment(0, comment, commentIndex)
        }
      }
    })], 1)], 1), _vm._v(" "), (comment.report_count > 0 && _vm.isAdmin) ? _c('report', {
      attrs: {
        "type": "LIFE_REPLY",
        "typeId": comment.comment_id
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', [_c('div', {
      staticClass: "buttonsWrap"
    }, [_c('div', [_c('mu-flat-button', {
      staticClass: "likeButton",
      class: {
        'active': comment.likes.liked === true
      },
      on: {
        "click": function($event) {
          return _vm.likeTopComment(comment.comment_id, commentIndex)
        }
      }
    }, [_c('div', {
      staticClass: "likeInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-up"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "like-label",
      domProps: {
        "textContent": _vm._s(comment.likes.liked ? 'Unlike' : 'Like')
      }
    })], 1)]), _vm._v(" "), ((comment.user.user_id === _vm.$store.state.user.scope.user_id)) ? _c('mu-flat-button', {
      staticClass: "editButton",
      on: {
        "click": function($event) {
          return _vm.editComment(0, commentIndex, null)
        }
      }
    }, [_c('div', {
      staticClass: "editInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "pencil-alt"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Edit")])], 1)]) : _vm._e(), _vm._v(" "), ((comment.user.user_id === _vm.$store.state.user.scope.user_id) || (_vm.isAdmin)) ? _c('mu-flat-button', {
      staticClass: "deleteButton",
      on: {
        "click": function($event) {
          return _vm.deleteComment(0, comment.comment_id, commentIndex, null)
        }
      }
    }, [_c('div', {
      staticClass: "deleteInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "trash"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Delete")])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "reportWrap"
    }, [((comment.user.user_id != _vm.$store.state.user.scope.user_id) && (!_vm.isAdmin)) ? _c('mu-flat-button', {
      staticClass: "reportButton",
      attrs: {
        "disabled": comment.reported
      },
      on: {
        "click": function($event) {
          return _vm.openReport('LIFE_REPLY', comment.comment_id)
        }
      }
    }, [_c('div', {
      staticClass: "reportInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "exclamation-triangle"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(comment.reported ? 'Reported' : 'Report')
      }
    })], 1)]) : _vm._e()], 1)])]), _vm._v(" "), (comment.total_likes !== 0) ? _c('div', {
      staticClass: "likeCounter"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-up"
      }
    }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(comment.total_likes))]), _vm._v(" people liked this comment")])], 1) : _vm._e(), _vm._v(" "), _c('form', {
      staticClass: "addReply",
      attrs: {
        "name": "commentForm"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.addSubComment(comment)
        }
      }
    }, [_c('mu-flexbox', {
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "align": "flex-start",
        "wrap": "nowrap"
      }
    }, [_c('mu-flexbox-item', {
      attrs: {
        "grow": "5"
      }
    }, [_c('h3', {
      staticClass: "replyTo"
    }, [_vm._v("Reply to " + _vm._s(comment.user.display_name) + "'s comment")]), _vm._v(" "), _c('mu-text-field', {
      staticClass: "replyInput",
      attrs: {
        "hintText": "Reply to " + comment.user.display_name + "'s comment.",
        "multiLine": "",
        "fullWidth": "",
        "rows": 3,
        "rowsMax": 6,
        "required": "",
        "underlineShow": false
      },
      model: {
        value: (comment.new_comment),
        callback: function($$v) {
          _vm.$set(comment, "new_comment", $$v)
        },
        expression: "comment.new_comment"
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "submit"
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      staticClass: "replyButton",
      attrs: {
        "label": "Add reply",
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addSubComment(comment)
        }
      }
    })], 1)], 1)], 1), _vm._v(" "), (comment.replies) ? _c('mu-list', _vm._l((comment.replies), function(sub, subCommentIndex) {
      return _c('div', {
        key: 'subComment-' + subCommentIndex,
        staticClass: "subComment"
      }, [_c('mu-list-item', {
        staticClass: "allowSelection",
        attrs: {
          "disableRipple": ""
        }
      }, [_c('div', {
        staticStyle: {
          "display": "flex",
          "flex-direction": "row",
          "align-items": "center"
        },
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [(!_vm.containsAvatarMed(sub.user.profile_large, 'avatar-med') && sub.user.profile_large != null) ? _c('mu-avatar', {
        staticStyle: {
          "margin-right": "18px"
        },
        attrs: {
          "src": sub.user.profile_large
        }
      }) : _vm._e(), _vm._v(" "), (_vm.containsAvatarMed(sub.user.profile_large, 'avatar-med') || sub.user.profile_large === null) ? _c('mu-avatar', {
        staticStyle: {
          "margin-rt": "18px"
        }
      }, [_vm._v("\n              " + _vm._s(_vm.getInitialsFromName(sub.user.display_name, ' ')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
        staticClass: "name blueTitle",
        attrs: {
          "to": '/profile/' + sub.user.profile_url
        },
        domProps: {
          "textContent": _vm._s(sub.user.display_name)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "dateBadgeWrap"
      }, [_c('div', {
        staticClass: "badges"
      }, [(sub.user.is_admin) ? _c('user-badge', {
        attrs: {
          "mode": "text",
          "type": "support"
        }
      }) : _vm._e(), _vm._v(" "), (sub.user.is_complete) ? _c('user-badge', {
        attrs: {
          "mode": "text",
          "type": "finished-program"
        }
      }) : _vm._e(), _vm._v(" "), (sub.user.is_champion) ? _c('user-badge', {
        attrs: {
          "type": "champion",
          "mode": "text"
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('span', {
        staticClass: "date",
        domProps: {
          "textContent": _vm._s(_vm.time(sub.timestamp))
        }
      })])], 1), _vm._v(" "), _c('div', {
        staticClass: "desc",
        attrs: {
          "slot": "describe"
        },
        slot: "describe"
      }, [_c('vue-markdown', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!sub.editcomment),
          expression: "!sub.editcomment"
        }],
        attrs: {
          "source": sub.comment
        }
      }), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (sub.editcomment),
          expression: "sub.editcomment"
        }],
        staticClass: "editable"
      }, [_c('mu-text-field', {
        attrs: {
          "multiLine": "",
          "fullWidth": "",
          "rows": 3,
          "rowsMax": 6
        },
        model: {
          value: (sub.edit_comment),
          callback: function($$v) {
            _vm.$set(sub, "edit_comment", $$v)
          },
          expression: "sub.edit_comment"
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        staticClass: "demo-flat-button",
        attrs: {
          "label": _vm.$t('message.cancelText'),
          "primary": ""
        },
        on: {
          "click": function($event) {
            return _vm.closeReply(1, subCommentIndex, commentIndex)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        staticClass: "demo-flat-button",
        attrs: {
          "label": "Save edit",
          "secondary": ""
        },
        on: {
          "click": function($event) {
            return _vm.updateComment(1, sub, subCommentIndex, commentIndex)
          }
        }
      })], 1)], 1), _vm._v(" "), (sub.report_count > 0 && _vm.isAdmin) ? _c('report', {
        attrs: {
          "type": "LIFE_SUBREPLY",
          "typeId": sub.sub_comment_id
        }
      }) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
        staticClass: "actions"
      }, [_c('div', {
        staticClass: "buttonsWrap"
      }, [_c('div', [_c('mu-flat-button', {
        staticClass: "likeButton",
        class: {
          'active': sub.likes.liked === true
        },
        on: {
          "click": function($event) {
            return _vm.likeSubComment(sub.comment_id, sub.sub_comment_id, commentIndex, subCommentIndex)
          }
        }
      }, [_c('div', {
        staticClass: "likeInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "thumbs-up"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "like-label",
        domProps: {
          "textContent": _vm._s(sub.likes.liked ? 'Unlike' : 'Like')
        }
      })], 1)]), _vm._v(" "), ((sub.user.user_id === _vm.$store.state.user.scope.user_id)) ? _c('mu-flat-button', {
        staticClass: "editButton",
        nativeOn: {
          "click": function($event) {
            return _vm.editComment(1, subCommentIndex, commentIndex)
          }
        }
      }, [_c('div', {
        staticClass: "editInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "pencil-alt"
        }
      }), _vm._v(" "), _c('span', [_vm._v("Edit")])], 1)]) : _vm._e(), _vm._v(" "), ((sub.user.user_id === _vm.$store.state.user.scope.user_id) || (_vm.isAdmin)) ? _c('mu-flat-button', {
        staticClass: "deleteButton",
        nativeOn: {
          "click": function($event) {
            return _vm.deleteComment(1, sub.sub_comment_id, subCommentIndex, commentIndex)
          }
        }
      }, [_c('div', {
        staticClass: "deleteInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "trash"
        }
      }), _vm._v(" "), _c('span', [_vm._v("Delete")])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "reportWrap"
      }, [((sub.user.user_id != _vm.$store.state.user.scope.user_id) && (!_vm.isAdmin)) ? _c('mu-flat-button', {
        staticClass: "reportButton",
        attrs: {
          "disabled": sub.reported
        },
        on: {
          "click": function($event) {
            return _vm.openReport('LIFE_SUBREPLY', sub.sub_comment_id)
          }
        }
      }, [_c('div', {
        staticClass: "reportInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "exclamation-triangle"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(sub.reported ? 'Reported' : 'Report')
        }
      })], 1)]) : _vm._e()], 1)])]), _vm._v(" "), (sub.total_likes !== 0) ? _c('div', {
        staticClass: "likeCounter"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "thumbs-up"
        }
      }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(sub.total_likes))]), _vm._v(" people liked this comment")])], 1) : _vm._e()], 1)], 1)
    }), 0) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCommentsComplete || _vm.userId !== false),
      expression: "!isCommentsComplete || userId !== false"
    }],
    staticClass: "load-more alignCenter"
  }, [(_vm.commentParams.totalComments > _vm.commentParams.page_size) ? _c('mu-raised-button', {
    attrs: {
      "label": (_vm.isCommentsLoading) ? _vm.$t('message.loadingText') : _vm.$t('message.loadCommentsText'),
      "disabled": _vm.isCommentsComplete || _vm.isCommentsLoading,
      "secondary": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadPostComments(_vm.postId)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeReport.type && _vm.activeReport.type_id) ? _c('report-modal', {
    attrs: {
      "open": _vm.activeReport.open,
      "type": _vm.activeReport.type,
      "type_id": _vm.activeReport.type_id
    },
    on: {
      "onClose": function($event) {
        _vm.activeReport.open = false
      },
      "onComplete": function($event) {
        return _vm.setReported(_vm.activeReport)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.clickoutside),
      expression: "clickoutside"
    }],
    staticClass: "mu-menu",
    style: ({
      'width': _vm.contentWidth
    }),
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": _vm.handleKeydown
    }
  }, [_c('div', {
    ref: "list",
    staticClass: "mu-menu-list",
    class: _vm.menuListClass,
    style: ({
      'width': _vm.contentWidth,
      'max-height': _vm.maxHeight + 'px'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 3665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "id": "paywall"
    }
  }, [_c('div', {
    attrs: {
      "id": "pay-modal"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "close"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.paymentModalFeatureNotAvailable'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('mu-icon', {
    attrs: {
      "value": "lock",
      "size": 50,
      "color": "#0179d5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('message.paymentModalUpgrade')) + " "), _c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.paypal.currency_sym + _vm.paypal.amount))
    }
  })])]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "backgroundColor": "#0179d5",
      "to": "payment",
      "type": "button",
      "label": _vm.$t('message.paymentModalProceedPayment'),
      "fullWidth": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "nutrition-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn pointer",
    on: {
      "click": _vm.goToDetail
    }
  }, [(!_vm.hasData) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('message.cardNutritionEmpty')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.cardNutritionSubLine')))])], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrate')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_carbohydrate + 'g')
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_protein + 'g')
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientFat')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_fat + 'g')
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCalories')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_calories + 'kcal')
    }
  })])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "26 191 14 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-4",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(26.000000, 191.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.66316596,4.72800156 C7.06563404,4.87701832 6.44003404,4.87701832 5.84250213,4.72800156 C2.73012766,3.95229786 0.12413617,4.24974815 0.154229787,10.1646347 C0.169565957,13.194545 2.98505532,17.1232218 5.94406809,16.4510425 C6.47475745,16.3306043 7.03062128,16.3306043 7.56131064,16.4510425 C10.5203234,17.1232218 13.3358128,13.194545 13.3511489,10.1646347 C13.3812426,4.25003977 10.7755404,3.95229786 7.66316596,4.72800156 L7.66316596,4.72800156 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.6010383,8.65347057 C1.44102128,8.65347057 1.3116766,8.52282573 1.3116766,8.36185263 C1.3116766,6.75387135 2.47982979,5.44567329 3.91593191,5.44567329 C4.07594894,5.44567329 4.20529362,5.57631813 4.20529362,5.73729123 C4.20529362,5.89826433 4.07594894,6.02890916 3.91593191,6.02890916 C2.79928511,6.02890916 1.8904,7.07552593 1.8904,8.36185263 C1.8904,8.52282573 1.76076596,8.65347057 1.6010383,8.65347057 L1.6010383,8.65347057 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.732,5.83206706 C6.57661277,5.83206706 6.44813617,5.7075462 6.44321702,5.5497809 C6.40415319,4.3156538 5.93365106,2.76628772 4.72961702,2.11918752 C4.58869787,2.04336686 4.53516596,1.86693801 4.6104,1.72462846 C4.6859234,1.58261053 4.86040851,1.52866121 5.00219574,1.60448187 C6.42411915,2.36852086 6.97766809,4.13368421 7.02165106,5.53111735 C7.02685957,5.69209045 6.90156596,5.82681793 6.74154894,5.83177544 C6.7380766,5.83206706 6.73518298,5.83206706 6.732,5.83206706 L6.732,5.83206706 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.70624681,6.87985029 C6.22011915,6.87985029 5.7626383,6.68884055 5.41858723,6.3418152 C5.30544681,6.22808421 5.30544681,6.04349006 5.41858723,5.92946745 C5.53172766,5.81544483 5.71460426,5.81544483 5.82774468,5.92946745 C6.06270638,6.16626121 6.37492766,6.29661442 6.70624681,6.29661442 C7.03756596,6.29661442 7.34978723,6.16626121 7.58445957,5.92946745 C7.6976,5.81544483 7.8804766,5.81544483 7.99361702,5.92946745 C8.10675745,6.04319844 8.10675745,6.22779259 7.99361702,6.3418152 C7.64956596,6.68884055 7.19237447,6.87985029 6.70624681,6.87985029 L6.70624681,6.87985029 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.45421277,3.80269786 L6.63043404,2.61114698 C6.81649362,1.35281559 7.79685106,0.364814035 9.04544681,0.177303704 L10.2274894,0 L10.0512681,1.19155088 C9.86520851,2.44988226 8.88485106,3.43788382 7.63625532,3.62539415 L6.45421277,3.80269786 L6.45421277,3.80269786 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  })])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDetail.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', {
    staticClass: "content",
    class: {
      fullHeight: _vm.isSaving
    }
  }, [(!_vm.isSaving) ? _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    staticClass: "greyed aio-input-header",
    attrs: {
      "title": _vm.$t('message.labelTime'),
      "titleClass": "alignMiddle lightTitle"
    }
  }, [_c('mu-icon', {
    staticClass: "alignMiddle dateIcon",
    attrs: {
      "slot": "avatar",
      "value": "access_time"
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('p', [_vm._v(_vm._s(_vm.$t('message.labelProgressDatePickerExplain')))])]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "mobile",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('date-picker', {
    attrs: {
      "iconMode": "",
      "type": "datetime"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('aio-pictures', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('aio-weight', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onWeightValid
    }
  }), _vm._v(" "), _c('aio-blood-glucose', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onBloodGlucoseValid
    }
  }), _vm._v(" "), _c('aio-hba1c', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onHba1cValid
    }
  }), _vm._v(" "), _c('aio-insulin', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onInsulinValid
    }
  }), _vm._v(" "), _c('aio-sleep', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onSleepValid
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('aio-ketones', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onKetonesValid
    }
  }), _vm._v(" "), _c('aio-blood-pressure', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onBloodPressureValid
    }
  }), _vm._v(" "), _c('aio-mood', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onMoodValid
    }
  }), _vm._v(" "), _c('aio-medication', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onMedicationValid
    }
  }), _vm._v(" "), _c('aio-cholesterol', {
    on: {
      "onValid": _vm.onCholesterolValid
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48,
      "mode": "indeterminate",
      "color": "#0179d5 !important"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.savingText')) + "\n    ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.objectsHydrated > 0 && !_vm.isSaving && _vm.isFabShown === true) ? _c('mu-float-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Save all'),
      expression: "'Save all'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "confirmFloat animated fadeIn",
    style: ({
      'right': _vm.getScrollbarWidth() + 24 + 'px'
    }),
    attrs: {
      "icon": "check",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processQueue()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "scrollDetector"
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profileFoodDiary"
    }
  }, [_c('mu-card', {
    attrs: {
      "id": "diary"
    }
  }, [_c('mu-card-header', {
    staticClass: "headerTitle"
  }, [_c('mu-float-button', {
    staticClass: "direction back",
    attrs: {
      "icon": "chevron_left",
      "mini": "",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.filterDiaryByDay('back')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.date, 'dddd, MMMM Do YYYY'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title mobileDate",
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.date, 'MMM Do YY'))
    }
  }), _vm._v(" "), _c('mu-float-button', {
    staticClass: "direction next",
    attrs: {
      "icon": "chevron_right",
      "mini": "",
      "disabled": _vm.isLoading || _vm.isToday
    },
    on: {
      "click": function($event) {
        return _vm.filterDiaryByDay('next')
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticClass: "loader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.hasFoods) ? _c('div', {
    staticClass: "tabs"
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.setActiveTab
    }
  }, _vm._l((_vm.tabs), function(tab, tabindex) {
    return _c('mu-tab', {
      key: ("tab-" + tabindex),
      attrs: {
        "value": tab.label,
        "title": tab.label
      }
    })
  }), 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _vm._l((_vm.tabs), function(tab, tabindex) {
    return (_vm.activeTab === tab.label) ? _c('food-dairy-tab', {
      key: ("tab-" + tabindex),
      attrs: {
        "userId": _vm.userId,
        "tab": tab.label,
        "foods": _vm.filterDiaryBy('meal_types', tab.label),
        "recipes": _vm.filterRecipeDiaryBy('meal_types', tab.label),
        "totals": _vm.filterDiaryBy('totals', tab.label)
      },
      on: {
        "onDelete": _vm.onDeleteFood
      }
    }) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasFoods) ? _c('div', {
    staticClass: "noFoods"
  }, [_c('p', [_vm._v("No foods have been added for this day.")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.hasFavourites) ? _c('div', {
    attrs: {
      "id": "lifeFavourites"
    }
  }, _vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      attrs: {
        "gutter": 16
      }
    }, _vm._l((chunks), function(post, index) {
      return _c('mu-flexbox-item', {
        key: 'post-' + index,
        staticClass: "post"
      }, [_c('mu-card', [_c('router-link', {
        attrs: {
          "to": {
            name: 'LifeStyleArticle',
            params: {
              permalink: post.post_slug
            }
          }
        }
      }, [_c('mu-card-media', {
        staticClass: "imgHolder"
      }, [_c('div', {
        staticClass: "img",
        style: ({
          'background-image': 'url(' + post.post_image + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "overlay"
      }, [_c('mu-flexbox', {
        staticClass: "item",
        attrs: {
          "justify": "flex-end",
          "align": "align"
        }
      }, [_c('h3', {
        staticClass: "largeTitle"
      }, [_vm._o(_c('span', [_vm._v(_vm._s(post.post_title))]), 0, 'post-' + index)]), _vm._v(" "), _c('mu-card-text', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "extract"
      }, [_c('div', [_vm._v(_vm._s(post.post_excerpt) + "\n                        ")])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "stats-bar"
      }, [_c('div', {
        staticClass: "stat favourites"
      }, [_c('mu-icon-button', {
        attrs: {
          "icon": post.post_favourited ? 'favorite' : 'favorite_border',
          "disabled": _vm.userId === false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.favouritePost(post.post_id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        domProps: {
          "textContent": _vm._s(post.post_favourites)
        }
      })], 1)])], 1)], 1)
    }), 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasFavourites) ? _c('div', [_c('p', [_vm._v("You have favourited no articles")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 3670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-text-field', {
    attrs: {
      "min": 0,
      "inputClass": "currencyInput",
      "hintText": 'Enter in ' + _vm.currency.currencyCode,
      "helpText": _vm.displayValue + ' ' + _vm.$t('message.labelPerWeek'),
      "label": _vm.label,
      "type": _vm.castingType,
      "fullWidth": true
    },
    on: {
      "blur": function($event) {
        _vm.isInputActive = false
      },
      "focus": function($event) {
        _vm.isInputActive = true
      },
      "change": function($event) {
        return _vm.changed()
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = _vm._n($$v)
      },
      expression: "inputValue"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "reg-form"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelLetsGetStarted'),
      "titleClass": "regTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.$route.query.hcp) ? _c('p', [_vm._v("Enter the basics to begin personalising your Low Carb Program experience. If\n      you already have an account, "), (_vm.model.offerCode) ? _c('span', [_c('router-link', {
    attrs: {
      "to": ("/login?oc=" + (_vm.model.offerCode))
    }
  }, [_vm._v("click here to log in")])], 1) : _c('span', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("click here to log in")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.hcp) ? _c('p', [_vm._v("Join the free Healthcare Professional Platform")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "baseline"
    }
  }, [_c('mu-flexbox-item', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40
      }),
      expression: "{required:true, max: 40}"
    }],
    attrs: {
      "id": "firstnameTxt",
      "data-vv-name": "first_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesFirstName'),
      "errorText": _vm.errors.first('first_name'),
      "label": _vm.$t('message.labelYourName'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesFirstName'),
      "fullWidth": "",
      "disabled": _vm.prefilled.firstname
    },
    model: {
      value: (_vm.model.firstname),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstname", $$v)
      },
      expression: "model.firstname"
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40
      }),
      expression: "{required:true, max: 40}"
    }],
    attrs: {
      "id": "surnameTxt",
      "data-vv-name": "last_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesSurname'),
      "errorText": _vm.errors.first('last_name'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesSurname'),
      "fullWidth": "",
      "disabled": _vm.prefilled.surname
    },
    model: {
      value: (_vm.model.surname),
      callback: function($$v) {
        _vm.$set(_vm.model, "surname", $$v)
      },
      expression: "model.surname"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "emailTxt",
      "data-vv-name": "email",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "errorText": _vm.errors.first('email'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": "",
      "disabled": _vm.prefilled.email
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n        Date of birth\n      ")]), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.day),
      expression: "dob.day"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_day')
    },
    attrs: {
      "name": "birth_day",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-as": "day",
      "disabled": _vm.prefilled.dob
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Day")]), _vm._v(" "), _vm._l((_vm.dobItems.days), function(day, index) {
    return _c('option', {
      key: 'day-' + index,
      attrs: {
        "disabled": _vm.prefilled.dob
      },
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.month),
      expression: "dob.month"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_month')
    },
    attrs: {
      "name": "birth_month",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-as": "month",
      "disabled": _vm.prefilled.dob
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._m(0)], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.year),
      expression: "dob.year"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_year')
    },
    attrs: {
      "name": "birth_year",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-as": "year",
      "disabled": _vm.prefilled.dob
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._m(1)], 2)])], 1), _vm._v(" "), _c('p', {
    staticClass: "privacyDisclaimer",
    on: {
      "click": _vm.setTerms
    }
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.terms),
      callback: function($$v) {
        _vm.terms = $$v
      },
      expression: "terms"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.registerTermsByContinuing')) + "\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "terms"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerTermsAndCondtions')))]), _vm._v("\n        " + _vm._s(_vm.$t('message.registerTermsJoin')) + " "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "privacy"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerPrivacyPolicy')))]), _vm._v(",\n        " + _vm._s(_vm.$t('message.registerIncluding')) + "\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "privacy"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerIncludingCookie')))])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": _vm.isSaving ? _vm.$t('message.labelProcessing') : _vm.$t('message.registerAppBarText'),
      "disabled": _vm.isSaving,
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.registerErrorUserExists')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isTermsError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Please agree to our terms and conditions\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isServerValidationError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          " + _vm._s(_vm.serverValidationErrorText) + "\n        ")])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('option', {
      key: 'month-' + index,
      attrs: {
        "disabled": _vm.prefilled.dob
      },
      domProps: {
        "value": month
      }
    }, [_vm._v(_vm._s(_vm.localizeMonth(month.name)) + "\n            ")])
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('option', {
      key: 'year-' + index,
      attrs: {
        "disabled": _vm.prefilled.dob
      },
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year.value) + "\n            ")])
  })
}]}

/***/ }),
/* 3672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-header', {
    staticClass: "headerHasBack",
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.$t('message.foodDiaryLandingExplain'),
      "titleClass": "mediumTitle"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "avatar",
      "icon": "arrow_back",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.goToSearch.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/search.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.searchText')))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.goToMyMeals.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/baseline-restaurant_menu-24px.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiaryLoadFromMyMeals')))])])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-raised-button', {
    staticClass: "yesterday-btn",
    attrs: {
      "icon": "refresh",
      "label": _vm.$t('message.foodDiaryRepeatYesterdayMeal'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyYesterdaysMeal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.recents.length > 0) ? _c('mu-col', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelRecents')
    }
  }), _vm._v(" "), _c('mu-list', {
    attrs: {
      "id": "recents"
    }
  }, _vm._l((_vm.recents), function(item, index) {
    return _c('mu-list-item', {
      key: 'recent-' + index,
      attrs: {
        "title": item.food_name
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectRecent(item)
        }
      }
    }, [_c('mu-icon', {
      staticClass: "left8",
      attrs: {
        "slot": "left",
        "value": "history"
      },
      slot: "left"
    })], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "dialogClass": "report-modal",
      "id": "report-modal",
      "open": _vm.open
    },
    on: {
      "close": _vm.close,
      "click": _vm.close
    }
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Reporting a post")]), _vm._v(" "), _c('p', [_vm._v("Please choose a reason for reporting this post")]), _vm._v(" "), _vm._l((_vm.reasons), function(reason, index) {
    return _c('div', {
      key: ("reason-" + index),
      staticClass: "radio"
    }, [_c('mu-radio', {
      attrs: {
        "name": "group",
        "label": reason.reason,
        "nativeValue": ("" + (reason.id))
      },
      model: {
        value: (_vm.chosen_reason),
        callback: function($$v) {
          _vm.chosen_reason = $$v
        },
        expression: "chosen_reason"
      }
    })], 1)
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action-btn",
    attrs: {
      "slot": "actions",
      "label": "Cancel"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action-btn",
    attrs: {
      "slot": "actions",
      "label": "Okay",
      "primary": ""
    },
    on: {
      "click": _vm.submit
    },
    slot: "actions"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 3674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "blood-pressure-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#F75039"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmpty'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmptyExplain'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(0)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(7)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(30)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(360)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n        Custom date\n      ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dialog) ? _c('div', {
    attrs: {
      "id": "hcp-switch-modal"
    }
  }, [_c('mu-dialog'), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('p', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.isHcpView ? 'Go to patient view' : 'Go to HCP view')
    }
  }), _vm._v(" "), (_vm.isHcpView) ? _c('p', [_vm._v("You're about to switch to the patient view of the website")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('p', [_vm._v("You're about to switch to the HCP view of the website")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions",
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "action close",
    attrs: {
      "label": "Close",
      "color": "#0179d5"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action continue",
    attrs: {
      "label": "Continue",
      "color": "#0179d5"
    },
    on: {
      "click": function($event) {
        return _vm.doSwitch()
      }
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.total) ? _c('div', {
    staticClass: "mu-pagination"
  }, [_c('page-item', {
    attrs: {
      "identifier": "singleBack",
      "disabled": _vm.leftDisabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('svg', {
    staticClass: "mu-pagination-svg-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }
  })])]), _vm._v(" "), _c('page-item', {
    attrs: {
      "index": 1,
      "isActive": _vm.actualCurrent === 1
    },
    on: {
      "click": _vm.handleClick
    }
  }), _vm._v(" "), (_vm.totalPageCount > 5 && _vm.actualCurrent - 1 >= 4) ? _c('page-item', {
    attrs: {
      "identifier": "backs",
      "title": "前5页"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageList), function(item) {
    return _c('page-item', {
      key: item,
      attrs: {
        "index": item,
        "isActive": _vm.actualCurrent === item
      },
      on: {
        "click": _vm.handleClick
      }
    })
  }), _vm._v(" "), (_vm.totalPageCount > 5 && _vm.totalPageCount - _vm.actualCurrent >= 4) ? _c('page-item', {
    attrs: {
      "identifier": "forwards",
      "title": "后5页"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.totalPageCount !== 1) ? _c('page-item', {
    attrs: {
      "index": _vm.totalPageCount,
      "isActive": _vm.actualCurrent === _vm.totalPageCount
    },
    on: {
      "click": _vm.handleClick
    }
  }) : _vm._e(), _vm._v(" "), _c('page-item', {
    attrs: {
      "identifier": "singleForward",
      "disabled": _vm.rightDisabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('svg', {
    staticClass: "mu-pagination-svg-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }
  })])]), _vm._v(" "), (_vm.showSizeChanger) ? _c('select-field', {
    style: ({
      width: '100px'
    }),
    model: {
      value: (_vm.actualPageSize),
      callback: function($$v) {
        _vm.actualPageSize = $$v
      },
      expression: "actualPageSize"
    }
  }, _vm._l((_vm.pageSizeOption), function(item) {
    return _c('menu-item', {
      key: 'mt_' + item,
      style: ({
        width: '100px'
      }),
      attrs: {
        "value": item,
        "title": item + _vm.pageSizeChangerText
      }
    })
  }), 1) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcp-category"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticClass: "contentLoader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "cat-view"
  }, [_c('div', {
    staticClass: "cat-bg",
    style: ('background-image: url(' + _vm.cat.image + ');')
  }, [_c('div', {
    staticClass: "cat"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.cat.name,
      "subTitle": _vm.cat.desc,
      "titleClass": "largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.posts), function(post, index) {
    return _c('mu-list-item', {
      key: ("post-" + index),
      staticClass: "item",
      attrs: {
        "title": post.post_title
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(post.post_slug)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "src": post.post_video_thumb
      }
    })], 1), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(post.post_video_desc))
      },
      slot: "describe"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('mu-icon', {
      attrs: {
        "value": "play_circle_filled",
        "color": "#0179d5"
      }
    })], 1), _vm._v(" "), _c('mu-divider')], 1)
  }), 1)], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.cat.name)
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc",
    domProps: {
      "textContent": _vm._s(_vm.cat.desc)
    }
  })
}]}

/***/ }),
/* 3678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasServices) ? _c('div', {
    staticClass: "tracking-types"
  }, _vm._l((_vm.services), function(service, i) {
    return _c('span', {
      key: ("service-" + i),
      staticClass: "service",
      class: {
        'active': _vm.activeService === service.service
      },
      on: {
        "click": function($event) {
          return _vm.handleService(service.service)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.getService(service.service).tooltip),
        expression: "getService(service.service).tooltip"
      }],
      attrs: {
        "src": _vm.getService(service.service).logo
      },
      on: {
        "click": function($event) {
          return _vm.handleService(service.service)
        }
      }
    })])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', {
    attrs: {
      "id": "recipeSearch"
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.q),
      expression: "model.q"
    }],
    staticClass: "search-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by; title, ingredient or category"
    },
    domProps: {
      "value": (_vm.model.q)
    },
    on: {
      "keydown": _vm.handleSearchKeydown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "q", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Cooking time")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50",
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'underTenMin'
    },
    staticStyle: {
      "margin-bottom": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setUnder10Min()
      }
    }
  }, [_vm._v("\n            0 - 10 min\n          ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'underThirtyMinOverTen'
    },
    staticStyle: {
      "margin-bottom": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setUnderThirtyMinOverTen()
      }
    }
  }, [_vm._v("\n            Under 30 min\n          ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50",
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'underHourOver30'
    },
    staticStyle: {
      "margin-bottom": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setUnderHourOver30()
      }
    }
  }, [_vm._v("\n            30 min - 1 hour\n          ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'overHour'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setOverHour()
      }
    }
  }, [_vm._v("\n            Over 1 hour\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.model.totaltime.length > 0) ? _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0
    },
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.totaltime),
      callback: function($$v) {
        _vm.$set(_vm.model, "totaltime", $$v)
      },
      expression: "model.totaltime"
    }
  }, 'vue-slider', _vm.timeSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "bottom"
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50",
      "align": "left"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.model.totaltime[0]) + " min(s)\n        ")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50",
      "align": "right"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.model.totaltime[1]) + " min(s)\n        ")])], 1), _vm._v(" "), _c('h2', [_vm._v("Nutrition")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Carbohydrate "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.carbs[0] + ' - ' + _vm.model.carbs[1]) + "g")])]), _vm._v(" "), (_vm.model.carbs.length > 0) ? _c('vue-slider', _vm._b({
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.carbs),
      callback: function($$v) {
        _vm.$set(_vm.model, "carbs", $$v)
      },
      expression: "model.carbs"
    }
  }, 'vue-slider', _vm.carbSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Fat "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.fat[0] + ' - ' + _vm.model.fat[1]) + "g")])]), _vm._v(" "), (_vm.model.fat.length > 0) ? _c('vue-slider', _vm._b({
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.fat),
      callback: function($$v) {
        _vm.$set(_vm.model, "fat", $$v)
      },
      expression: "model.fat"
    }
  }, 'vue-slider', _vm.fatSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Calories "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.calories[0] + ' - ' + _vm.model.calories[1]) + "kcal")])]), _vm._v(" "), (_vm.model.calories.length > 0) ? _c('vue-slider', _vm._b({
    attrs: {
      "start-animation": false
    },
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.calories),
      callback: function($$v) {
        _vm.$set(_vm.model, "calories", $$v)
      },
      expression: "model.calories"
    }
  }, 'vue-slider', _vm.calorieSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Protein "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.protein[0] + ' - ' + _vm.model.protein[1]) + "g")])]), _vm._v(" "), (_vm.model.protein.length > 0) ? _c('vue-slider', _vm._b({
    attrs: {
      "start-animation": false
    },
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.protein),
      callback: function($$v) {
        _vm.$set(_vm.model, "protein", $$v)
      },
      expression: "model.protein"
    }
  }, 'vue-slider', _vm.proteinSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('h2', [_vm._v("Dietary types")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.dietaryTypes), function(item, dietaryTypeI) {
    return _c('mu-col', {
      key: 'dietaryType-' + dietaryTypeI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])], 1)
  }), 1), _vm._v(" "), _c('h2', [_vm._v("Categories")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.categories), function(item, catI) {
    return _c('mu-col', {
      key: 'category-' + catI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])], 1)
  }), 1), _vm._v(" "), (!_vm.additionalOptions && _vm.fullWidth) ? _c('div', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "16px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "More filters",
      "full-width": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.additionalOptions = !_vm.additionalOptions
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.additionalOptions && _vm.fullWidth) ? _c('div', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "16px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "Hide filters",
      "full-width": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.additionalOptions = !_vm.additionalOptions
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.additionalOptions),
      expression: "additionalOptions"
    }]
  }, [_c('h2', [_vm._v("Allergies")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.suitabilities), function(item, suitabilityI) {
    return _c('mu-col', {
      key: 'suitability-' + suitabilityI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n            ")])], 1)
  }), 1), _vm._v(" "), _c('h2', [_vm._v("Cuisines")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.cuisines), function(item, cuisineI) {
    return _c('mu-col', {
      key: 'cuisine-' + cuisineI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n            ")])], 1)
  }), 1), _vm._v(" "), _c('h2', [_vm._v("Occasions")]), _vm._v(" "), _c('mu-row', {
    staticClass: "bottom"
  }, _vm._l((_vm.model.occasions), function(item, occasionI) {
    return _c('mu-col', {
      key: 'occasion-' + occasionI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n            ")])], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSearching,
      "secondary": "",
      "label": _vm.isSearching === true ? _vm.$t('message.loadingText') : _vm.$t('message.searchText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitSearch.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-dialog', {
    staticStyle: {
      "width": "1024px"
    },
    attrs: {
      "open": _vm.dialog,
      "dialogClass": "profilePictureDialog"
    },
    on: {
      "close": _vm.close
    }
  }, [(!_vm.isCropperVisible) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isUploading) ? _c('div', [_c('h2', [_vm._v("Just a moment")])]) : _vm._e(), _vm._v(" "), (!_vm.isUploading) ? _c('mu-raised-button', {
    attrs: {
      "icon": "photo",
      "label": "Select image"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('vue-base64-file-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disable-preview": "",
      "placeholder": "Tap to choose image",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.customImageMaxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCropperVisible && _vm.isCropperVisible),
      expression: "isCropperVisible && isCropperVisible"
    }],
    ref: "imageCropper"
  }), _vm._v(" "), _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUploading && _vm.isCropperVisible),
      expression: "!isUploading && isCropperVisible"
    }],
    attrs: {
      "align": "center"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "tooltip": "Cancel",
      "icon": "close",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate left",
      "icon": "rotate_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('left')
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate right",
      "icon": "rotate_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('right')
      }
    }
  }), _vm._v(" "), _c('mu-circular-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploading),
      expression: "isUploading"
    }],
    attrs: {
      "size": 16
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "icon": "crop",
      "label": _vm.isUploading ? 'Uploading...' : 'Crop & Upload'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doCrop()
      }
    }
  })], 1), _vm._v(" "), (_vm.isUploading) ? _c('div', [_vm._v("Uploading...")]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('mu-linear-progress', {
    attrs: {
      "mode": "determinate",
      "value": _vm.completionPercentage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bpView"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [(_vm.$store.state.user.scope) ? _c('bp-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [_c('blood-pressure-input', {
    staticClass: "card-spacing",
    staticStyle: {
      "margin-top": "24px"
    }
  }), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "blood-pressure"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                        " + _vm._s(item.systolic) + "/" + _vm._s(item.diastolic + ' mmHG') + "\n                      ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('bp-edit', {
        attrs: {
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()])], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "frequently-asked"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.discussionFaqTitle'),
      "subTitle": _vm.$t('message.discussionFaqSubTitle')
    }
  }), _vm._v(" "), _c('mu-list', [(_vm.isLoading === true) ? _c('div', _vm._l((5), function(item, index) {
    return _c('mu-list-item', {
      key: 'dummy-loader' + index
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "width": "16%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.isLoading === false) ? _c('mu-list-item', {
      key: 'frequent-question-' + index,
      staticClass: "faq",
      attrs: {
        "title": _vm.encode(item.question)
      },
      on: {
        "click": function($event) {
          return _vm.goToQuestion(item.question_id)
        }
      }
    }) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', [_c('lesson-inline-grid'), _vm._v(" "), _c('div', {
    staticClass: "dashboard-patients"
  }, [(_vm.showTips) ? _c('div', {
    staticClass: "tip-details"
  }, [_c('carousel', {
    attrs: {
      "paginationEnabled": false,
      "perPage": 1,
      "navigationEnabled": true,
      "loop": true,
      "navigationPrevLabel": "<img src='static/dashboard/chevron-left.svg'/>",
      "navigationNextLabel": "<img src='static/dashboard/chevron-right.svg'/>"
    }
  }, _vm._l((_vm.tipsList), function(item, index) {
    return _c('slide', {
      key: ("tip-" + index),
      staticClass: "text item"
    }, [_c('mu-icon', {
      attrs: {
        "value": "info"
      }
    }), _vm._v(" "), _c('h2', [_vm._v("Tip " + _vm._s(index + 1) + " of " + _vm._s(_vm.tipsList.length) + ": "), _c('span', [_vm._v(_vm._s(item.tip))])])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openGettingStarted()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("How to get started:")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.gettingStarted ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.gettingStarted) ? _c('div', {
    staticClass: "getting-started"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.startedData), function(item, index) {
    return (_vm.showStarted) ? _c('mu-col', {
      key: ("started-data-" + index),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "25"
      }
    }, [_c('mu-card', {
      staticClass: "started-block",
      class: item.category
    }, [_c('mu-avatar', [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('button', {
      staticClass: "started-cta",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.gettingStartedPush(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.cta)), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_forward")])])], 1)], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((4), function(item) {
    return (!_vm.showStarted) ? _c('mu-col', {
      key: ("dummy-started-loader-" + item),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "25"
      }
    }, [_c('mu-card', {
      staticClass: "started-loader"
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "text"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "btn"
    })], 1)])], 1) : _vm._e()
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openMyLessons()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("My lessons")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.myLessons ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.myLessons) ? _c('div', {
    staticClass: "lessons-block"
  }, [(_vm.showLesson) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "lessons"
  }, [_c('h2', [_vm._v("This week's lesson:")]), _vm._v(" "), _c('div', {
    staticClass: "lesson-module",
    style: ({
      backgroundImage: 'url(' + _vm.currentLesson.image_url + ')'
    }),
    on: {
      "click": function($event) {
        return _vm.goToCurrentLesson()
      }
    }
  }, [_c('div', {
    staticClass: "lesson-text"
  }, [_c('h3', [_vm._v(_vm._s(_vm.currentLesson.week_name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentLesson.title))])]), _vm._v(" "), _c('div', {
    staticClass: "lesson-play"
  }, [_c('img', {
    attrs: {
      "src": "static/dashboard/play-large.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('div', {
    staticClass: "downloads"
  }, [_c('h2', [_vm._v("This week's downloads")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.downloads), function(item, index) {
    return _c('mu-col', {
      key: ("download-" + index),
      staticClass: "download-module",
      style: ({
        backgroundImage: 'url(' + item.image_url + ')'
      }),
      attrs: {
        "width": "100",
        "tablet": "33",
        "desktop": "33"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.downloadResource(item)
        }
      }
    }, [_c('div', {
      staticClass: "download-text"
    }, [_c('h3', [_vm._v(_vm._s(item.title))])])])
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "download-module",
    style: ({
      backgroundImage: 'url(' + _vm.downloadsBg + ')'
    }),
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDownloads()
      }
    }
  }, [_c('div', {
    staticClass: "allDownloads"
  }, [_c('div', {
    staticClass: "download-inner"
  }, [_c('mu-icon', {
    attrs: {
      "value": "get_app"
    }
  }), _vm._v(" "), _c('span', [_vm._v("View all downloads")])], 1)])])], 2)], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.showLesson) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "lessons"
  }, [_c('h2', [_vm._v("This week's lesson:")]), _vm._v(" "), _c('div', {
    staticClass: "lesson-module"
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  })], 1)])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "70"
    }
  }, [_c('div', {
    staticClass: "downloads"
  }, [_c('h2', [_vm._v("This week's downloads:")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((3), function(i) {
    return _c('mu-col', {
      key: ("download-module-dummy-" + i),
      staticClass: "download-module",
      attrs: {
        "width": "100",
        "tablet": "33",
        "desktop": "33"
      }
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      key: i,
      staticClass: "img"
    })], 1)])
  }), 1)], 1)])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openTodaysMeals()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Today's meals")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.todaysMeals ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.todaysMeals) ? _c('div', {
    staticClass: "meals"
  }, [(_vm.recipesLoader) ? _c('div', {
    staticClass: "dummyLoader"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "title"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "text"
  })], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "title"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "text"
  })], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "title"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "text"
  })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.recipesLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.recipes), function(item, index) {
    return _c('mu-col', {
      key: ("recipe-" + index),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "33"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "recipe-card recipe-block"
    }, [(index === 0 && item.id) ? _c('mu-float-button', {
      staticClass: "refresh",
      attrs: {
        "icon": "refresh"
      },
      on: {
        "click": function($event) {
          return _vm.getBreakfast()
        }
      }
    }) : _vm._e(), _vm._v(" "), (index === 1 && item.id) ? _c('mu-float-button', {
      staticClass: "refresh",
      attrs: {
        "icon": "refresh"
      },
      on: {
        "click": function($event) {
          return _vm.getLunch()
        }
      }
    }) : _vm._e(), _vm._v(" "), (index === 2 && item.id) ? _c('mu-float-button', {
      staticClass: "refresh",
      attrs: {
        "icon": "refresh"
      },
      on: {
        "click": function($event) {
          return _vm.getDinner()
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.photoLargeUri) ? _c('img', {
      attrs: {
        "src": item.photoLargeUri,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.goToRecipe(item.id)
        }
      }
    }) : _c('div', {
      staticClass: "no-image",
      on: {
        "click": function($event) {
          return _vm.goToRecipe(item.id)
        }
      }
    }, [_c('span', [_vm._v("No image available")])]), _vm._v(" "), (index === 0) ? _c('p', [_vm._v("Breakfast")]) : _vm._e(), _vm._v(" "), (index === 1) ? _c('p', [_vm._v("Lunch")]) : _vm._e(), _vm._v(" "), (index === 2) ? _c('p', [_vm._v("Dinner")]) : _vm._e(), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.goToRecipe(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.rating) ? _c('recipe-rating', {
      staticStyle: {
        "margin-bottom": "24px"
      },
      attrs: {
        "read-only": true,
        "count": item.rating.ratingCount,
        "rating": item.rating.ratingScore,
        "recipe": item
      }
    }) : _vm._e()], 1) : _c('div', {
      staticClass: "recipe-load"
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "text"
    })], 1)])])
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "recipes-banner"
  }, [_c('banner-block', {
    attrs: {
      "path": "/310087275/LCP_730x100",
      "size": [730, 100],
      "id": "div-gpt-ad-1585223997152-0"
    }
  })], 1)])], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openPersonalised()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Just for you")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.justForYou ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.justForYou) ? _c('div', {
    staticClass: "personalised"
  }, [(_vm.articlesLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.articles), function(item, index) {
    return _c('mu-col', {
      key: ("article-" + index),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "20"
      }
    }, [_c('div', {
      staticClass: "article",
      on: {
        "click": function($event) {
          return _vm.goToArticle(item)
        }
      }
    }, [_c('div', {
      staticClass: "likes"
    }, [_c('mu-icon', {
      attrs: {
        "value": "favorite"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.post_favourites))])], 1), _vm._v(" "), _c('div', {
      staticClass: "image-wrap",
      style: ({
        backgroundImage: 'url(' + item.post_image + ')'
      })
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.post_title))])])])
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "20"
    }
  }, [_c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "image-wrap",
    style: ({
      backgroundImage: 'url(' + this.lifestyleBg + ')'
    }),
    on: {
      "click": function($event) {
        return _vm.goToLifestyle()
      }
    }
  }, [_c('div', {
    staticClass: "lifestyle"
  }, [_c('mu-icon', {
    attrs: {
      "value": "local_florist"
    }
  }), _vm._v(" "), _c('span', [_vm._v("View Lifestyle")])], 1)])])])], 2) : _vm._e(), _vm._v(" "), (!_vm.articlesLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((4), function(i) {
    return _c('mu-col', {
      key: ("articles-dummy-loader-" + i),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "25"
      }
    }, [_c('div', {
      staticClass: "article"
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title"
    })], 1)])])
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openCommunity()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Trending in the community")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.community ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.community) ? _c('div', {
    staticClass: "community"
  }, [(_vm.communityLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "align-motivated",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "motivated",
    on: {
      "click": function($event) {
        return _vm.goToCommunity()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/dashboard/community-general.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "motivated-btn"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "Ask our community"
    }
  })], 1)])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('mu-row', {
    staticClass: "discussion-row",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((_vm.discussions[0]), function(item, index) {
    return _c('mu-card', {
      key: ("discussion-item-" + index),
      nativeOn: {
        "click": function($event) {
          return _vm.goToDiscussion(item)
        }
      }
    }, [_c('h2', {
      domProps: {
        "innerHTML": _vm._s(item.question)
      }
    }), _vm._v(" "), _c('mu-list-item', {
      attrs: {
        "title": item.display_name,
        "disabled": ""
      }
    }, [(item.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.profile_large
      },
      slot: "left"
    }) : _c('mu-avatar', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_vm._v(_vm._s(_vm.upperTwoInitials(item.display_name)))])], 1), _vm._v(" "), _c('mu-row', {
      attrs: {
        "gutter": ""
      }
    }, [_c('mu-col', {
      attrs: {
        "width": "40",
        "tablet": "50",
        "desktop": "40"
      }
    }, [_c('div', {
      staticClass: "replies"
    }, [_c('mu-icon', {
      attrs: {
        "value": "reply"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.replies) + " replies")])], 1)]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "60",
        "tablet": "50",
        "desktop": "60"
      }
    }, [_c('div', {
      staticClass: "created"
    }, [_c('mu-icon', {
      attrs: {
        "value": "access_time"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(item.timestamp)))])], 1)])], 1), _vm._v(" "), _c('img', {
      staticClass: "quote",
      attrs: {
        "src": "static/quote.svg",
        "alt": ""
      }
    })], 1)
  }), 1), _vm._v(" "), _c('mu-col', {
    staticClass: "spaceArticle",
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((_vm.discussions[1]), function(item, index) {
    return _c('mu-card', {
      key: ("discusstion-item-2-" + index),
      nativeOn: {
        "click": function($event) {
          return _vm.goToDiscussion(item)
        }
      }
    }, [_c('h2', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('mu-list-item', {
      attrs: {
        "title": item.display_name,
        "disabled": ""
      }
    }, [(item.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.profile_large
      },
      slot: "left"
    }) : _c('mu-avatar', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_vm._v(_vm._s(_vm.upperTwoInitials(item.display_name)))])], 1), _vm._v(" "), _c('mu-row', {
      attrs: {
        "gutter": ""
      }
    }, [_c('mu-col', {
      attrs: {
        "width": "40",
        "tablet": "50",
        "desktop": "40"
      }
    }, [_c('div', {
      staticClass: "replies"
    }, [_c('mu-icon', {
      attrs: {
        "value": "reply"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.replies) + " replies")])], 1)]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "60",
        "tablet": "50",
        "desktop": "60"
      }
    }, [_c('div', {
      staticClass: "created"
    }, [_c('mu-icon', {
      attrs: {
        "value": "access_time"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(item.timestamp)))])], 1)])], 1), _vm._v(" "), _c('img', {
      staticClass: "quote",
      attrs: {
        "src": "static/quote.svg",
        "alt": ""
      }
    })], 1)
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.communityLoader) ? _c('mu-row', {
    staticClass: "loader",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "align-motivated",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "motivated"
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  })], 1)])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('mu-row', {
    staticClass: "discussion-row",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((2), function(item, index) {
    return _c('div', {
      key: ("discussion-dummy-row-" + index),
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "card"
    })], 1)
  }), 0), _vm._v(" "), _c('mu-col', {
    staticClass: "spaceArticle",
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((2), function(item, index) {
    return _c('div', {
      key: ("discussion-dummy-row-2-" + index),
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "card"
    })], 1)
  }), 0)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "trackHealth"
    },
    on: {
      "click": function($event) {
        return _vm.openTrackers()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Track your health")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.trackHealth ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.trackHealth) ? _c('cards') : _vm._e(), _vm._v(" "), _c('DisplayNameModal', {
    attrs: {
      "display": !_vm.$store.state.user.scope.accepted_display_name
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('subscription-form')
},staticRenderFns: []}

/***/ }),
/* 3685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.initialLoad) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasItems) ? _c('follower-item', {
    attrs: {
      "profile": _vm.profile,
      "items": _vm.items,
      "type": "followers"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.initialLoad === false || _vm.isLoading === false) ? _c('div', {
    attrs: {
      "id": "infiniteScrollDetector"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.initialLoad && !_vm.hasItems) ? _c('p', [_vm._v("This user has no followers")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-raised-button",
    class: _vm.buttonClass,
    style: (_vm.buttonStyle),
    attrs: {
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "rippleColor": _vm.rippleColor,
      "rippleOpacity": _vm.rippleOpacity,
      "disabled": _vm.disabled,
      "keyboardFocused": _vm.keyboardFocused,
      "wrapperClass": "mu-raised-button-wrapper",
      "centerRipple": false
    },
    on: {
      "KeyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit,
      "click": _vm.handleClick
    }
  }, [(_vm.label && _vm.labelPosition === 'before') ? _c('span', {
    staticClass: "mu-raised-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('icon', {
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.label && _vm.labelPosition === 'after') ? _c('span', {
    staticClass: "mu-raised-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "telInput"
  }, [_c('mu-card-text', {
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "src": "static/keep_up@2x.png"
    }
  })]), _vm._v(" "), _c('mu-card-header', {
    staticClass: "blueTitle noPadding absoluteHeader",
    attrs: {
      "subTitle": "Get hints, tips and notifications",
      "title": "Add your mobile number"
    }
  })], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "bottom",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "40",
      "desktop": "40",
      "tablet": "40"
    }
  }, [_c('span', {
    staticClass: "flag",
    class: _vm.getCountryClass(_vm.selectedCode.code)
  }), _vm._v(" "), _c('span', {
    staticClass: "blueupper"
  }, [_vm._v("Area code")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCode),
      expression: "selectedCode"
    }],
    staticClass: "blue-input",
    attrs: {
      "id": "areaCode"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.areaCodeChanged]
    }
  }, _vm._l((_vm.areaCodes), function(code) {
    return _c('option', {
      domProps: {
        "value": code
      }
    }, [_vm._v("\n              " + _vm._s(code.dial_code) + " (" + _vm._s(code.name) + ")\n            ")])
  }), 0)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "60",
      "desktop": "60",
      "tablet": "60"
    }
  }, [_c('label', {
    staticClass: "blueupper",
    attrs: {
      "for": "telephone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dial_number),
      expression: "dial_number"
    }],
    staticClass: "blue-input",
    attrs: {
      "id": "telephone",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.dial_number)
    },
    on: {
      "change": _vm.telephoneChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dial_number = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-card-text', [_c('mu-raised-button', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "fullWidth": "",
      "primary": "",
      "label": "Save"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "fullWidth": "",
      "label": "Maybe later..."
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('mu-content-block', {
    staticClass: "food-search-dialog",
    staticStyle: {
      "padding-bottom": "0",
      "margin-bottom": "8px"
    },
    style: ({
      height: (_vm.isSearching === true) ? '100%' : 'auto'
    })
  }, [_c('mu-paper', {
    staticClass: "search-area"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "grow": "45",
      "shrink": "45"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "icon": "search",
      "hintText": "Search a food name",
      "underlineShow": false,
      "hintTextClass": "hidden",
      "fullWidth": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "5",
      "grow": "5",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "close"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isSearching) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isListening) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('div', {
    staticClass: "load-wrapp"
  }, [_c('div', {
    staticClass: "load-3 bottom"
  }, [_c('div', {
    staticClass: "line loaderRed"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderGreen"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderBlue"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n        Go ahead and say something...\n      ")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Stop"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.stopVoiceRecognition()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isListening) ? _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('mu-list-item', {
      key: 'suggestion-' + index,
      attrs: {
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelection(suggestion)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "slot": "left",
        "value": "search"
      },
      slot: "left"
    }), _vm._v(" "), _vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.highlight(suggestion)))
      },
      slot: "title"
    }), 0, 'suggestion-' + index)], 1)
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr', {
    staticClass: "mu-text-field-line",
    class: _vm.lineClass
  }), _vm._v(" "), (!_vm.disabled) ? _c('hr', {
    staticClass: "mu-text-field-focus-line",
    class: _vm.focusLineClass,
    style: (_vm.errorStyle)
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "food-diary"
    }
  }, [_c('mu-paper', {
    staticClass: "foodbar"
  }, [_c('mu-content-block', {
    staticClass: "foodBar inner"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "25",
      "tablet": "30",
      "align": "right"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subtractDate()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticStyle: {
      "flex": "auto"
    },
    attrs: {
      "width": "50",
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "46px"
    },
    attrs: {
      "align": "center center",
      "justify": "center center"
    }
  }, [_c('mu-flexbox-item', {
    ref: "datepicker",
    staticClass: "c-datepicker-btn mediumTitle",
    attrs: {
      "align": "center",
      "grow": ""
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "justify": "center center",
      "align": "center",
      "wrap": "disallow"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-date-picker', {
    staticClass: "hiddenPicker",
    attrs: {
      "inputClass": "datePicker",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.currentDate.ddmmyy),
      callback: function($$v) {
        _vm.$set(_vm.currentDate, "ddmmyy", $$v)
      },
      expression: "currentDate.ddmmyy"
    }
  }), _vm._v(" "), _c('span', [_c('mu-icon', {
    staticStyle: {
      "position": "relative",
      "top": "4px"
    },
    attrs: {
      "value": "date_range"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.currentDate.presentational) + "\n                    "), (_vm.activeTab !== 1) ? _c('span', [_vm._v("\n                      - " + _vm._s(_vm.toDate) + "\n                    ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "25",
      "tablet": "30",
      "align": "left"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.isToday(_vm.currentDate.actual),
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-top": "46px"
    }
  }, [_c('tab-selector', {
    attrs: {
      "value-key": "days",
      "text-key": "title",
      "list": _vm.selectorOptions
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }), _vm._v(" "), (!_vm.hasData) ? _c('alert', {
    attrs: {
      "type": "danger",
      "icon": "warning"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.cardEmpty')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.graphReady && _vm.hasData) ? _c('food-diary-stacked-history', {
    attrs: {
      "data": _vm.graph
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-landing"
  }, [(_vm.$route.name !== 'FaqDetail') ? _c('div', [_c('div', {
    staticClass: "header",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "searchBox",
    staticStyle: {
      "align-self": "flex-end",
      "width": "100%"
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticStyle: {
      "align-self": "center",
      "margin": "0 auto"
    },
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchFaqs.apply(null, arguments)
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('message.labelFindExactlyWhatYouAreLookingFor')))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search"
    }
  }, [_c('mu-paper', {
    staticClass: "rounded"
  }, [_c('mu-text-field', {
    attrs: {
      "inputClass": "searchInput",
      "label": "",
      "id": "search",
      "name": "search",
      "icon": "search",
      "underline-show": false,
      "full-width": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1)], 1)])])], 1)], 1)])]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "whiteContainer top"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "60"
    }
  }, [_c('mu-paper', [_c('mu-list', _vm._l((_vm.faqs), function(faq, faqIndex) {
    return _c('mu-list-item', {
      key: 'faq' + faqIndex,
      nativeOn: {
        "click": function($event) {
          return _vm.goToFaq(faq.faq_id)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(faq.question))
      },
      slot: "title"
    })])
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "40"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelMostUseful'),
      "titleClass": "blackTitle largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.mostUseful), function(useful, index) {
    return _c('mu-list-item', {
      key: 'index-' + useful.faq_id,
      staticStyle: {
        "align-items": "flex-start"
      },
      attrs: {
        "title": useful.question
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToFaq(useful.faq_id)
        }
      }
    }, [_c('div', {
      staticClass: "question",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n                    " + _vm._s(useful.question) + "\n                  ")])])
  }), 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "top"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress')], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'FaqDetail') ? _c('div', {
    staticClass: "faq-detail"
  }, [_c('router-view')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "cholesterol-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "14px",
      "viewBox": "20 193 16 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36,197.265908 C36,194.909874 34.0654937,193 31.6791924,193 C30.1209817,193 28.7601736,193.817042 27.9999513,195.038086 C27.2398264,193.817042 25.8784338,193 24.3202556,193 C21.9339542,193 20,194.909874 20,197.265908 C20,198.548637 20.5757115,199.696228 21.4830684,200.477715 L27.6056657,206.522912 C27.7102283,206.626148 27.8520374,206.684147 27.9999513,206.684147 C28.1478652,206.684147 28.2896742,206.626148 28.3942369,206.522912 L34.5168341,200.477715 C35.4242235,199.696228 36,198.548637 36,197.265908 L36,197.265908 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#D14905",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'add_circle'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [_c('mu-card-text', [(_vm.$store.state.user.settings.blood_glucose.measure == 'mmoll') ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "12.95",
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'required|min_value:0|max_value:12.95',
      "data-vv-name": "total_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "total",
      "errorText": _vm.errors.first('total_mmoll'),
      "label": _vm.$t('message.labelCholesterolTotal'),
      "helpText": "mmol/L",
      "fullWidth": true
    },
    model: {
      value: (_vm.model.total_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "total_mmoll", _vm._n($$v))
      },
      expression: "model.total_mmoll"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "12.95",
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'min_value:0|max_value: 12.95',
      "data-vv-name": "hdl_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('hdl_mmoll'),
      "label": _vm.$t('message.labelCholesterolHDL'),
      "helpText": "mmol/L",
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hdl_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "hdl_mmoll", _vm._n($$v))
      },
      expression: "model.hdl_mmoll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure == 'mgdl') ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "700",
      "hintText": "Enter mg/dL",
      "data-vv-rules": 'required|min_value:0|max_value:700',
      "data-vv-name": "total_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "total",
      "errorText": _vm.errors.first('total_mgdl'),
      "label": _vm.$t('message.labelCholesterolTotal'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.model.total_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "total_mgdl", _vm._n($$v))
      },
      expression: "model.total_mgdl"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "700",
      "hintText": "Enter mg/dL",
      "data-vv-rules": 'min_value:0|max_value:700',
      "data-vv-name": "hdl_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('hdl_mgdl'),
      "label": _vm.$t('message.labelCholesterolHDL'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.model.hdl_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "hdl_mgdl", _vm._n($$v))
      },
      expression: "model.hdl_mgdl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure == 'mmoll') ? _c('mu-row', {
    staticClass: "bottom"
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "hintText": "Enter mmol/L",
      "min": "0",
      "max": "18.1",
      "data-vv-rules": 'min_value:0|max_value:18.1',
      "data-vv-name": "triglycerides_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "triglycerides",
      "errorText": _vm.errors.first('triglycerides_mmoll'),
      "label": _vm.$t('message.labelCholesterolTriglycerides'),
      "fullWidth": true,
      "helpText": "mmol/L"
    },
    model: {
      value: (_vm.model.triglycerides_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "triglycerides_mmoll", _vm._n($$v))
      },
      expression: "model.triglycerides_mmoll"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "hintText": "Enter mmol/L",
      "min": "0",
      "max": "18.1",
      "data-vv-rules": 'min_value:0|max_value: 18.1',
      "data-vv-name": "ldl_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('ldl_mmoll'),
      "label": _vm.$t('message.labelCholesterolLDL'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.ldl_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "ldl_mmoll", _vm._n($$v))
      },
      expression: "model.ldl_mmoll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure == 'mgdl') ? _c('mu-row', {
    staticClass: "bottom"
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "hintText": "Enter mg/dL",
      "min": "0",
      "max": "700",
      "data-vv-rules": 'min_value:0|max_value: 700',
      "data-vv-name": "triglycerides_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "triglycerides",
      "errorText": _vm.errors.first('triglycerides_mgdl'),
      "label": _vm.$t('message.labelCholesterolTriglycerides'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.triglycerides_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "triglycerides_mgdl", _vm._n($$v))
      },
      expression: "model.triglycerides_mgdl"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "700",
      "hintText": "Enter mg\\dL",
      "data-vv-rules": 'min_value:0|max_value:700',
      "data-vv-name": "ldl_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('ldl_mgdl'),
      "label": _vm.$t('message.labelCholesterolLDL'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.ldl_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "ldl_mgdl", _vm._n($$v))
      },
      expression: "model.ldl_mgdl"
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report",
    attrs: {
      "id": "question-thread"
    }
  }, [(!_vm.isLoading) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.comment.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 90,
      "color": "#0179d5",
      "backgroundColor": "#E9E9E8",
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comment.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 90,
      "src": _vm.comment.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.comment.user.profile.url
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.encodeText(_vm.comment.user.display_name)) + " "), _c('country-badge', {
    attrs: {
      "alpha2": _vm.comment.user.country.alpha2,
      "tooltip": _vm.comment.user.country.country_name
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }, [_vm._v(_vm._s(_vm.comment.user.diabetes_type))])]), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [(_vm.comment.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comment.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comment.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.comment.comment) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.comment.comment)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', [_c('mu-flat-button', {
    attrs: {
      "icon": "history",
      "label": "Go to comment"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToArticle()
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.reports.reasons.length) ? _c('report', {
    attrs: {
      "typeId": parseInt(_vm.$route.params.id),
      "type": "LIFE_SUBREPLY"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Handle report"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._v("\n            What do you want to do this with comment?\n          ")]), _vm._v(" "), _c('mu-card-text', [_c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "KEEP",
      "label": "Keep it (removes reports)"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1), _vm._v(" "), _c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "REMOVE",
      "label": "Remove it"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "type": "button",
      "label": "Ammend",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discount-page"
  }, [(_vm.discountData) ? _c('div', {
    staticClass: "discount-inner"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [(!_vm.isLoading) ? _c('h1', [_vm._v("Get " + _vm._s(_vm.discountData.discount) + "% off")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("12 months of Low Carb Program")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "pricing"
  }, [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "pricing-inner"
  }, [_c('div', {
    staticClass: "receipt-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("£" + _vm._s(_vm.originalCost))])])]), _vm._v(" "), _c('div', {
    staticClass: "receipt-row"
  }, [_c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("Discount (" + _vm._s(_vm.discountData.discount) + "%)")])]), _vm._v(" "), _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("-£" + _vm._s(_vm.usersDiscount))])])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "receipt-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', {
    staticClass: "bolder-right"
  }, [_vm._v("£" + _vm._s(_vm.calculatedCost))])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#5b617c",
      "margin-top": "1rem",
      "font-size": "14px"
    }
  }, [_vm._v("\n          *£" + _vm._s(_vm.calculatedCost) + " for one year, renewing at £" + _vm._s(_vm.originalCost) + ", billed annually\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "paypal-button w-inline-block",
    on: {
      "click": function($event) {
        return _vm.submitDiscount()
      }
    }
  }, [_c('div', {
    staticClass: "slider-right"
  }, [_vm._v("Subscribe now")])]), _vm._v(" "), _c('stripe-checkout', {
    ref: "sessionCheckoutRef",
    attrs: {
      "pk": _vm.publishableKey,
      "session-id": _vm.sessionId
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "greyText"
  }, [_vm._v("\n          The yearly membership gives you unlimited access to the Low Carb\n          Program's entire library of content and virtual events. You will be\n          charged £" + _vm._s(_vm.calculatedCost) + " for a 1 year subscription that will\n          renew at £" + _vm._s(_vm.originalCost) + ", billed annually.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "greyText"
  }, [_vm._v("\n          You may cancel your subscription at any time by going to your\n          Profile and following the instructions on the 'Manage Subscription'\n          page.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "greyText account"
  }, [_vm._v("\n          Upgrading account: "), _c('span', [_vm._v(_vm._s(_vm.discountData.email))])])], 1) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/logos/lcp-logo.svg",
      "alt": "Low Carb Program"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("\n            Embrace life-changing low carb lifestyle with expert-led education\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            Group and one-to-one virtual meetups with Low Carb Program experts\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            Browse 1,837 recipes and tailor meal plans to your preferences\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "testimonial"
  }, [_c('img', {
    attrs: {
      "src": "static/chrissy-after.jpg",
      "alt": "Chrissy"
    }
  }), _vm._v(" "), _c('span', [_vm._v("“My start weight was 105kg (16st 8 lbs) and now I weigh 80kg\n            (12st 9 lbs). I’ve had to buy a new wardrobe – I bought two pairs\n            of trousers last year that were too tight and now they’re falling\n            off me! I also have type 2 diabetes and it has helped my blood\n            sugars to come down”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("Original cost per year")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', {
    staticClass: "bolder-left"
  }, [_vm._v("Cost per year")])])
}]}

/***/ }),
/* 3695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-404"
    }
  }, [_c('div', {
    ref: "starsBg",
    attrs: {
      "id": "starsBg"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "goBackBtn",
      "label": "Go Back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordCheck"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "baseline"
    }
  }, [_c('mu-flexbox-item', [_c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.upper === true) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.upper === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(336),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.upper === 'error') ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.upper === true,
      error: _vm.passwordCheck.upper === 'error'
    }
  }, [_vm._v("At least one "), _c('strong', [_vm._v("upper case letter (A-Z)")])])]), _vm._v(" "), _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.lower === true) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.lower === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(336),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.lower === 'error') ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.lower === true,
      error: _vm.passwordCheck.lower === 'error'
    }
  }, [_vm._v("At least one "), _c('strong', [_vm._v("lower case letter (a-z)")])])]), _vm._v(" "), _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.number === true) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.number === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(336),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.number === 'error') ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.number === true,
      error: _vm.passwordCheck.number === 'error'
    }
  }, [_vm._v("At least one "), _c('strong', [_vm._v("number")]), _vm._v(" (0-9)")])])]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.special === true) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.special === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(336),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.special === 'error') ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.special === true,
      error: _vm.passwordCheck.special === 'error'
    }
  }, [_c('strong', [_vm._v("1 special character")]), _vm._v(", e.g. "), _c('strong', [_vm._v("#?!@$%^&*")])])]), _vm._v(" "), _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.passwordCheck.length === true) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.length === false) ? _c('img', {
    attrs: {
      "src": __webpack_require__(336),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordCheck.length === 'error') ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.passwordCheck.length === true,
      error: _vm.passwordCheck.length === 'error'
    }
  }, [_c('strong', [_vm._v("10+ characters")]), _vm._v(" in length")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profileGallery"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blueTitle",
      "title": _vm.$t('message.labelGallery')
    }
  }), _vm._v(" "), _c('mu-card-text', [(_vm.isOwner) ? _c('div', {
    attrs: {
      "id": "uploadImage"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "id": "uploadBtn",
      "label": _vm.$t('message.labelUploadPhoto'),
      "disabled": _vm.isUploadingImage
    },
    on: {
      "click": _vm.bindUploadEvent
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.chooseImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUploadingImage) ? _c('mu-linear-progress', {
    staticClass: "uploadProgress",
    attrs: {
      "mode": "determinate",
      "size": 10,
      "value": _vm.uploadProgress
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "galleryScroller"
    }
  }, [_c('mu-grid-list', {
    staticClass: "scroller",
    attrs: {
      "cell-height": 250,
      "padding": 0
    }
  }, _vm._l((_vm.images), function(image, index) {
    return _c('mu-grid-tile', {
      key: 'image-' + index,
      staticClass: "item",
      class: {
        'isOwner': _vm.isOwner
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": image.image_url
      }
    }), _vm._v(" "), (_vm.isOwner) ? _c('mu-icon-button', {
      attrs: {
        "slot": "action",
        "icon": "photo",
        "tooltip": "Set as profile picture",
        "tooltipPosition": "bottom-center"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setAsProfile(image)
        }
      },
      slot: "action"
    }) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('mu-icon-button', {
      attrs: {
        "slot": "action",
        "icon": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteImage(index, image.image_id)
        }
      },
      slot: "action"
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), (_vm.profileImage) ? _c('avatar-uploader', {
    attrs: {
      "hideAvatar": true,
      "imageUrl": _vm.profileImage
    },
    on: {
      "destroyUploader": function($event) {
        _vm.profileImage = $event
      }
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "search-panel"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.searchText')
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-paper', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "paperSearch",
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "search",
      "data-vv-as": "search",
      "underlineShow": false,
      "icon": "search",
      "hintText": _vm.$t('message.discussionSearchHintText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "searchButton",
    attrs: {
      "disabled": _vm.isSearching || !_vm.searchTerm.length,
      "primary": "",
      "label": _vm.isSearching ? _vm.$t('message.searchingText') : _vm.$t('message.searchText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 3699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-generator"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('mu-content-block', [_c('h1', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("Meal plan generator")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "8px",
      "margin-bottom": "24px"
    }
  }, [_vm._v("Generate a meal plan from hundreds of delicious recipes in our\n        database.")])])], 1), _vm._v(" "), (!_vm.isMealPlanShown) ? _c('div', {
    staticClass: "content"
  }, [_c('mu-card', [_c('mu-card-text', [_c('meal-plan-filter-modal', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    on: {
      "change": _vm.filtersSet
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("Which days do you want to plan for")]), _vm._v(" "), _vm._l((_vm.model.days), function(day, index) {
    return _c('mu-float-button', {
      key: 'day-' + index,
      staticClass: "day-button outline",
      class: {
        'active': _vm.model.availableDays.includes(day.name)
      },
      staticStyle: {
        "margin": "4px"
      },
      attrs: {
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addToAvailableDays(day.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(day.label) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label",
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n          Which meals do you want to plan for?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "align-icon-right",
    attrs: {
      "full-width": "",
      "label": "Breakfast",
      "label-position": "before",
      "icon": "radio_button_unchecked",
      "icon": _vm.model.availableMeals.includes('BREAKFAST') ? 'radio_button_checked' : 'radio_button_unchecked'
    },
    on: {
      "click": function($event) {
        return _vm.toggleMeal('BREAKFAST')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "align-icon-right",
    attrs: {
      "full-width": "",
      "label": "Lunch",
      "label-position": "before",
      "icon": "radio_button_unchecked",
      "icon": _vm.model.availableMeals.includes('LUNCH') ? 'radio_button_checked' : 'radio_button_unchecked'
    },
    on: {
      "click": function($event) {
        return _vm.toggleMeal('LUNCH')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "align-icon-right",
    attrs: {
      "full-width": "",
      "label": "Dinner",
      "label-position": "before",
      "icon": _vm.model.availableMeals.includes('DINNER') ? 'radio_button_checked' : 'radio_button_unchecked'
    },
    on: {
      "click": function($event) {
        return _vm.toggleMeal('DINNER')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label",
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_vm._v("\n          How many people are you planning for?\n        ")]), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('mu-col', {
    attrs: {
      "align": "left",
      "width": "15"
    }
  }, [_c('mu-float-button', {
    staticClass: "incrementor-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.decrementServings.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "remove_circle_outline"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "center",
      "width": "70"
    }
  }, _vm._l((_vm.model.servingslte), function(item, sin) {
    return _c('img', {
      key: 'serving-' + sin,
      staticStyle: {
        "margin": "8px"
      },
      attrs: {
        "src": "static/ic_male.png"
      }
    })
  }), 0), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "right",
      "width": "15"
    }
  }, [_c('mu-float-button', {
    staticClass: "incrementor-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.incrementServings.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "add_circle_outline"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "24px"
    }
  }, [_c('mu-col', {
    attrs: {
      "align": "left",
      "width": "33"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "center",
      "width": "33"
    }
  }, [_vm._v(_vm._s(_vm.model.servingslte) + " people")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "right",
      "width": "33"
    }
  })], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "full-width": "",
      "secondary": "",
      "label": "Create plan"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.generateMealPlans.apply(null, arguments)
      }
    }
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMealPlanShown) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "left",
      "margin-bottom": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-self": "center"
    }
  }, _vm._l((_vm.model.days), function(day, dayIndex) {
    return (_vm.model.availableDays.includes(day.name)) ? _c('mu-float-button', {
      key: 'shown-day-' + dayIndex,
      staticClass: "day-button",
      class: {
        'activeDay': day.name === _vm.activeDay,
        'faded': !_vm.daySatisfied(day)
      },
      staticStyle: {
        "margin": "2px"
      },
      attrs: {
        "mini": "",
        "label": "M"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setDay(day.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(day.label) + "\n        ")]) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('mu-row', [_c('mu-col', [_c('meal-plan-filter-modal')], 1), _vm._v(" "), _c('mu-col')], 1)], 1), _vm._v(" "), (_vm.model.availableMeals.includes('BREAKFAST')) ? _c('meal-plan-panel', {
    attrs: {
      "allergies": _vm.allergyCsv,
      "filters": _vm.filters,
      "dietaryTypes": _vm.dietaryTypesList().join(','),
      "activeDay": _vm.activeDay,
      "type": "breakfast",
      "recipe": _vm.activeBreakfastForDay
    },
    on: {
      "changed": _vm.pushToBreakfast
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.availableMeals.includes('LUNCH')) ? _c('meal-plan-panel', {
    attrs: {
      "allergies": _vm.allergyCsv,
      "filters": _vm.filters,
      "dietaryTypes": _vm.dietaryTypesList().join(','),
      "activeDay": _vm.activeDay,
      "type": "lunch",
      "recipe": _vm.activeLunchForDay
    },
    on: {
      "changed": _vm.pushToLunch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.availableMeals.includes('DINNER')) ? _c('meal-plan-panel', {
    attrs: {
      "allergies": _vm.allergyCsv,
      "filters": _vm.filters,
      "dietaryTypes": _vm.dietaryTypesList().join(','),
      "activeDay": _vm.activeDay,
      "type": "dinner",
      "recipe": _vm.activeDinnerForDay
    },
    on: {
      "changed": _vm.pushToDinner
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "disabled": !_vm.satisfiedDays,
      "label": "Create plan"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openMealPlanModal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "title": "Give your meal plan a name"
    },
    on: {
      "close": function($event) {
        _vm.dialogOpen = false
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMealPlan.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    attrs: {
      "full-width": "",
      "label": "Name",
      "hint-text": "Enter a name for your meal plan"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.cancelText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "slot": "actions",
      "type": "button",
      "primary": "",
      "label": _vm.$t('message.okText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveMealPlan.apply(null, arguments)
      }
    },
    slot: "actions"
  })], 1)], 1)])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.reading.treatment_name) + "\n          ")])], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max_value:2500'),
      expression: "'required|max_value:2500'"
    }],
    attrs: {
      "data-vv-name": "dosage",
      "errorText": _vm.errors.first('dosage'),
      "hintText": _vm.$t('message.labelDosage'),
      "label": _vm.$t('message.labelDosage'),
      "helpText": _vm.localizeRegime(_vm.reading.unit_label),
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.dosage),
      callback: function($$v) {
        _vm.$set(_vm.reading, "dosage", $$v)
      },
      expression: "reading.dosage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "15",
      "width": "100",
      "tablet": "0"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('router-view', {
    key: 'getting-started-route-' + _vm.$route.path
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "15",
      "width": "100",
      "tablet": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "paymentView"
    }
  }, [(!_vm.isLoading) ? _c('mu-stepper', {
    attrs: {
      "activeStep": 1
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n          " + _vm._s(_vm.$t('message.labelProceed')) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "paymentModal loading"
  }, [_c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "paymentModal",
    class: {
      'processedOrCancelled': _vm.isPaymentCancelled || _vm.hasPaymentProcessed
    }
  }, [_c('mu-row', [(_vm.isPaymentCancelled) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "block cancelled"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailed')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailedExplain')))]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "label": "Try again"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Payment')
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasPaymentProcessed) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [(_vm.hasPaymentProcessed) ? _c('div', {
    staticClass: "block success"
  }, [_c('div', {
    attrs: {
      "id": "invoice"
    }
  }, [_c('h1', [_vm._v("Payment Receipt")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "paymentDetails"
    }
  }, [(_vm.getParam('st') === 'Completed') ? _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallStatusComplete')))]) : _vm._e(), _vm._v(" "), (_vm.getParam('st') === 'Pending') ? _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallStatusPending')))]) : _vm._e(), _vm._v(" "), (_vm.getParam('st') === 'Failed') ? _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallStatusFailed')))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Description")]), _vm._v(" "), _c('td', {
    domProps: {
      "textContent": _vm._s(_vm.getParam('item_name'))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TXNID")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm.getParam('tx')) + "\n                      "), _c('span', {
    staticClass: "keepsafe"
  }, [_vm._v("Keep safe")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', {
    domProps: {
      "textContent": _vm._s(_vm.getParam('st'))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('amt')) + _vm._s(_vm.getParam('cc')))])])])])]), _vm._v(" "), (_vm.getParam('st') === 'Completed') ? _c('mu-flat-button', {
    staticClass: "button getStartedBtn",
    attrs: {
      "icon": "verified_user",
      "type": "button",
      "label": "Get started"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToGetStarted.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button printBtn",
    attrs: {
      "icon": "print",
      "type": "button",
      "label": "Print a copy"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.printInvoice.apply(null, arguments)
      }
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isPaymentCancelled && !_vm.hasPaymentProcessed) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "60",
      "desktop": "60"
    }
  }, [_c('div', {
    staticClass: "block payment"
  }, [_c('h1', [_vm._v("Personalise your program")]), _vm._v(" "), _c('p', [_vm._v("Get access and support for " + _vm._s(_vm.paypal.currency_sym + _vm.paypal.amount) + ". "), _c('br'), _vm._v(" Join over " + _vm._s(_vm.numeral(_vm.stats.count).format('0,0')) + " people today")]), _vm._v(" "), _c('paypal-form', {
    attrs: {
      "paypal": _vm.paypal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('img', {
    attrs: {
      "src": "https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppppcmcvdam.png",
      "alt": "Pay with PayPal, PayPal Credit or any major credit card"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "seperator"
  }, [_c('div', {
    staticClass: "overlay"
  }, [_c('span', [_vm._v("Or")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "voucherForm",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "voucher"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "tablet": "65",
      "desktop": "65",
      "width": "65"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "id": "voucherTxt",
      "hintText": "Voucher code",
      "fullWidth": "",
      "min": 20
    },
    model: {
      value: (_vm.voucher.code),
      callback: function($$v) {
        _vm.$set(_vm.voucher, "code", $$v)
      },
      expression: "voucher.code"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30",
      "width": "30"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "apply",
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": "Redeem",
      "disabled": (_vm.voucher.code.length <= 3) || _vm.voucher.isSending,
      "color": "#FFF",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "message",
    class: {
      error: _vm.voucher.error === true,
      success: _vm.voucher.error === false
    },
    domProps: {
      "textContent": _vm._s(_vm.voucher.isSending ? 'Processing...' : _vm.voucher.message)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("After paying, you will be asked to customise your program. You will receive:")]), _vm._v(" "), _c('div', {
    staticClass: "benefits"
  }, [_c('ul', [_c('li', [_vm._v("Award-winning structured education on therapeutic nutrition")]), _vm._v(" "), _c('li', [_vm._v("Practical Action Points to achieve your health goal")]), _vm._v(" "), _c('li', [_vm._v("Daily meal plans for 12 weeks to kick start your journey")]), _vm._v(" "), _c('li', [_vm._v("Tailored messages from your mentor to keep you on track")]), _vm._v(" "), _c('li', [_vm._v("Support from behavioural health mentors")]), _vm._v(" "), _c('li', [_vm._v("Peer support 24/7 from " + _vm._s(_vm.numeral(_vm.stats.count).format('0,0')) + " members")]), _vm._v(" "), _c('li', [_vm._v("Integrated food diary with food search and barcode scanner")]), _vm._v(" "), _c('li', [_vm._v("Integrated health tracking and data exporting")]), _vm._v(" "), _c('li', [_vm._v("Searchable library of recipes tailored to your preferences")]), _vm._v(" "), _c('li', [_vm._v("Daily updated news, research and expert opinions")]), _vm._v(" "), _c('li', [_vm._v("Library of resources")]), _vm._v(" "), _c('li', [_vm._v("Access on any device on web, iOS and Android")]), _vm._v(" "), _c('li', [_vm._v("Connect to Apple Health and sync your data")]), _vm._v(" "), _c('li', [_vm._v("Receive constantly updated features and enhancements")]), _vm._v(" "), _c('li', [_vm._v("Sync with FitBit")]), _vm._v(" "), _c('li', [_vm._v("Access on your Apple Watch")]), _vm._v(" "), _c('li', [_vm._v("Friendly technical support")])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.hasPaymentProcessed && !_vm.isPaymentCancelled) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "40",
      "desktop": "40"
    }
  }, [_c('h2', [_vm._v("Free health tracking")]), _vm._v(" "), _c('p', [_vm._v("Continue without paying to get health and nutrition tracking. Pay to upgrade instantly at any time.")]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button paypalBtn free",
    attrs: {
      "type": "button",
      "label": "Proceed for free"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.continueFree()
      }
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-icon-button",
    attrs: {
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "disabled": _vm.disabled,
      "keyboardFocused": _vm.keyboardFocused
    },
    on: {
      "click": _vm.handleClick,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit,
      "keyboardFocus": _vm.handleKeyboardFocus
    }
  }, [_vm._t("default", function() {
    return [_c('icon', {
      class: _vm.iconClass,
      attrs: {
        "value": _vm.icon
      }
    })]
  }), _vm._v(" "), (_vm.tooltip) ? _c('tooltip', {
    attrs: {
      "trigger": _vm.tooltipTrigger,
      "verticalPosition": _vm.verticalPosition,
      "horizontalPosition": _vm.horizontalPosition,
      "show": _vm.tooltipShown,
      "label": _vm.tooltip,
      "touch": _vm.touch
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-tooltip",
    class: {
      'touched': _vm.touch,
      'when-shown': _vm.show
    },
    style: (_vm.tooltipStyle)
  }, [_c('div', {
    ref: "ripple",
    staticClass: "mu-tooltip-ripple",
    class: {
      'when-shown': _vm.show
    },
    style: (_vm.rippleStyle)
  }), _vm._v(" "), _c('span', {
    staticClass: "mu-tooltip-label"
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),
/* 3705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-card-text"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight",
    attrs: {
      "id": "integration-confirmation"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "white",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33",
      "align": "center"
    }
  }, [(_vm.type === 'FITBIT') ? _c('div', [_c('img', {
    attrs: {
      "src": "static/integrations/fitbit.svg",
      "width": "20%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Congratulations!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("\n              You are now integrated with FitBit\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'STRIIV') ? _c('div', [_c('img', {
    attrs: {
      "src": "static/integrations/striiv.png",
      "width": "20%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Congratulations!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("\n              You are now integrated with Striiv\n            ")])]) : _vm._e()]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('abstract-button', {
    staticClass: "mu-item-wrapper",
    style: (_vm.disabled ? _vm.itemStyle : {}),
    attrs: {
      "containerElement": "div",
      "href": _vm.href,
      "disabled": _vm.disabled,
      "disableFocusRipple": _vm.disableRipple,
      "disableTouchRipple": _vm.disableRipple,
      "target": _vm.target,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "wrapperStyle": _vm.itemStyle,
      "centerRipple": false
    },
    on: {
      "click": _vm.handleClick,
      "keyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [_c('div', {
    class: _vm.itemClass
  }, [(_vm.showLeft) ? _c('div', {
    staticClass: "mu-item-left"
  }, [_vm._t("left"), _vm._v(" "), _vm._t("leftAvatar")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-item-content"
  }, [(_vm.showTitleRow) ? _c('div', {
    staticClass: "mu-item-title-row"
  }, [_c('div', {
    staticClass: "mu-item-title",
    class: _vm.titleClass
  }, [_vm._t("title", function() {
    return [_vm._v("\n               " + _vm._s(_vm.title) + "\n             ")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "mu-item-after",
    class: _vm.afterTextClass
  }, [_vm._t("after", function() {
    return [_vm._v("\n                " + _vm._s(_vm.afterText) + "\n              ")]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showDescribe) ? _c('div', {
    staticClass: "mu-item-text",
    class: _vm.describeTextClass,
    style: (_vm.textStyle)
  }, [_vm._t("describe", function() {
    return [_vm._v("\n            " + _vm._s(_vm.describeText) + "\n          ")]
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.showRight) ? _c('div', {
    staticClass: "mu-item-right"
  }, [(_vm.toggleNested) ? _c('icon-button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleToggleNested.apply(null, arguments)
      }
    },
    nativeOn: {
      "mousedown": function($event) {
        return _vm.stop.apply(null, arguments)
      },
      "touchstart": function($event) {
        return _vm.stop.apply(null, arguments)
      }
    }
  }, [(_vm.nestedOpen) ? _c('svg', {
    staticClass: "mu-item-svg-icon",
    class: _vm.toggleIconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 15L12 9L18 15"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.nestedOpen) ? _c('svg', {
    staticClass: "mu-item-svg-icon",
    class: _vm.toggleIconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 9L12 15L18 9"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("right"), _vm._v(" "), _vm._t("rightAvatar")], 2) : _vm._e()])]), _vm._v(" "), _c('expand-transition', [(_vm.showNested) ? _c('mu-list', {
    class: _vm.nestedListClass,
    attrs: {
      "nestedLevel": _vm.nestedLevel,
      "value": _vm.nestedSelectValue
    },
    on: {
      "change": _vm.handleNestedChange
    }
  }, [_vm._t("nested")], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: (_vm.tooltip),
      expression: "tooltip",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "flag",
    class: _vm.getCountryClass(_vm.alpha2)
  })
},staticRenderFns: []}

/***/ }),
/* 3709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('life-search-bar', {
    staticClass: "search",
    attrs: {
      "value": _vm.$route.params.search
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "title-block"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Search results for \"" + _vm._s(_vm.$route.params.search) + "\"")])]), _vm._v(" "), _c('div', {
    staticClass: "sortBy"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "chevron-down"
    }
  }), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "underlineShow": false
    },
    on: {
      "change": _vm.filterResults
    },
    model: {
      value: (_vm.sortBy),
      callback: function($$v) {
        _vm.sortBy = $$v
      },
      expression: "sortBy"
    }
  }, [_c('mu-menu-item', {
    staticClass: "sortByItems",
    attrs: {
      "value": 1,
      "title": "Most favourites"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    staticClass: "sortByItems",
    attrs: {
      "value": 2,
      "title": "Newest first"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "lifeSearchArticles"
    }
  }, [_vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      staticStyle: {
        "margin-top": "20px",
        "margin-bottom": "20px"
      },
      attrs: {
        "gutter": 16,
        "align": "flex-start"
      }
    }, _vm._l((chunks), function(post, index) {
      return _c('mu-flexbox-item', {
        key: 'post-' + index,
        staticClass: "post"
      }, [_c('div', {
        staticClass: "search-card"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'LifeStyleArticle',
            params: {
              permalink: post.post_slug
            }
          }
        }
      }, [_c('figure', {
        staticClass: "img"
      }, [_c('img', {
        attrs: {
          "src": post.post_image
        }
      })]), _vm._v(" "), _c('h4', {
        domProps: {
          "textContent": _vm._s(post.post_title)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('div', {
        staticClass: "date"
      }, [_c('mu-icon', {
        attrs: {
          "value": "watch_later",
          "color": "#5b617c"
        }
      }), _vm._v(" "), _c('time', {
        attrs: {
          "datetime": "post.post_date"
        },
        domProps: {
          "textContent": _vm._s(_vm.moment(post.post_date).fromNow())
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "favourites"
      }, [_c('mu-icon', {
        attrs: {
          "value": "favorite",
          "color": "#d83e38"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(post.post_favourites)
        }
      })], 1)])])], 1)])
    }), 1)
  }), _vm._v(" "), (!_vm.chunkedItems.length) ? _c('p', [_vm._v("Sorry, could not not find any articles based on your search")]) : _vm._e(), _vm._v(" "), (_vm.loadingMore) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [(_vm.loadMore) ? _c('mu-flat-button', {
    staticClass: "load-more",
    attrs: {
      "label": "Load more"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateResults()
      }
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 3710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveQuestion.apply(null, arguments)
      }
    }
  }, [_c('mu-card', {
    attrs: {
      "id": "create-question"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.questionCreateTitle'),
      "titleClass": "blueTitle largeTitle titleRemovePadding"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('div', {
    staticClass: "communityText",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.questionCreateSubTitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "question",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.questionCreateLabelTitle'),
      "errorText": _vm.errors.first('question'),
      "id": "focusable",
      "label": _vm.$t('message.questionCreateLabelTitle'),
      "hintText": _vm.$t('message.questionCreateTitlePlaceholder'),
      "helpText": _vm.$t('message.questionCreateTitleHelpText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.question),
      callback: function($$v) {
        _vm.$set(_vm.model, "question", $$v)
      },
      expression: "model.question"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "textarea",
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "content",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.questionCreateLabelText'),
      "errorText": _vm.errors.first('content'),
      "label": _vm.$t('message.questionCreateLabelText'),
      "multiLine": "",
      "rows": 3,
      "rowsMax": 6,
      "hintText": _vm.$t('message.questionCreateTextPlaceholder'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.content),
      callback: function($$v) {
        _vm.$set(_vm.model, "content", $$v)
      },
      expression: "model.content"
    }
  })], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submitBtn",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.submitText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveQuestion.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mode === 'SELF_REPORTED') ? _c('div', {
    staticClass: "insetGraph"
  }, [(_vm.$store.state.user.scope) ? _c('activity-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'STEPS') ? _c('div', {
    staticClass: "insetGraph"
  }, [(_vm.$store.state.user.scope) ? _c('activity-steps-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto",
      "text-align": "center"
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [_c('activity-input', {
    staticClass: "card-spacing",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "bmr": _vm.$store.state.user.stats.bmr
    }
  }), _vm._v(" "), (_vm.mode === 'STEPS') ? _c('activity-wearable-visualisation') : _vm._e(), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "STEPS"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'STEPS'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelSteps').charAt(0).toUpperCase() + _vm.$t('message.labelSteps').substr(1)))]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "SELF_REPORTED"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'SELF_REPORTED'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelManualEntry')))])], 1), _vm._v(" "), (_vm.mode === 'SELF_REPORTED') ? _c('div', [_c('mu-timeline', [_vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelActivityType')) + ": " + _vm._s(_vm.getLocaleLabel(item.type)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelCaloriesBurnt')) + ": " + _vm._s(item.calories_burnt) + " kcal")])]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                          " + _vm._s(item.minutes) + " " + _vm._s(_vm.$t('message.labelMinute')) + "\n                        ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e()])], 1)
    })], 2)
  }), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'STEPS') ? _c('div', [_c('mu-timeline', [(_vm.data.data.length === 0 && !_vm.isReadingsLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "24px"
    }
  }, [_c('h3', [_vm._v("You don't have any steps data yet")]), _vm._v(" "), _c('p', [_vm._v("To get started connect your favorite health app below")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Add an activity integration"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getStartedIntegrations.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedStepDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_c('img', {
        staticStyle: {
          "position": "relative",
          "top": "8px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "24",
          "src": "static/ic_watch_activity.svg"
        }
      }), _vm._v(_vm._s(item.device))]), _vm._v(" "), _c('span', [_c('img', {
        staticStyle: {
          "position": "relative",
          "top": "8px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "24",
          "src": "static/ic_hk_activity.svg"
        }
      }), _vm._v(_vm._s(_vm.$t('message.labelCaloriesBurnt')) + ": " + _vm._s(_vm.numberFormat(item.calories)) + " kcal")]), _vm._v(" "), _c('div', [_c('img', {
        staticStyle: {
          "position": "relative",
          "top": "8px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "24",
          "src": "static/ic_floors_climbed.svg"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('message.labelFloorsClimbed')) + ":\n                          " + _vm._s(item.floors) + "\n                        ")])]), _vm._v(" "), _c('mu-col', [_c('div', {
        staticClass: "reading"
      }, [_vm._v(_vm._s(_vm.numberFormat(item.steps)) + " " + _vm._s(_vm.$t('message.labelSteps')))])])], 1)], 1) : _vm._e()])], 1)
    })], 2)
  }), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 2)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight"
  }, [_vm._m(0), _vm._v(" "), (_vm.showFlashMessage) ? _c('mu-flexbox', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('MessageBox', {
    attrs: {
      "message-type": _vm.flashMessageType,
      "message": _vm.flashMessageBody,
      "title": _vm.flashMessageTitle
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-flexbox', {
    class: {
      'fullHeight': !_vm.showFlashMessage
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "reset-block"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Reset your password",
      "subTitle": "Use the form below to reset your password",
      "titleClass": "blueTitle largeTitle regTitle resetTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "password",
    attrs: {
      "name": "password",
      "data-vv-name": "password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Password",
      "errorText": _vm.errors.first('password'),
      "label": "New password",
      "type": "password",
      "hintText": "Enter desired password",
      "fullWidth": ""
    },
    on: {
      "change": _vm.triggerValidate
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.$set(_vm.model, "password", $$v)
      },
      expression: "model.password"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('password-strength-validation', {
    attrs: {
      "password": _vm.model.password
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "name": "password_confirmation",
      "data-vv-name": "password_confirmation",
      "data-vv-value-path": "inputValue",
      "data-vv-as": " ",
      "errorText": _vm.confirmPassErr,
      "label": "Confirm password",
      "type": "password",
      "hintText": "Confirm password",
      "fullWidth": ""
    },
    on: {
      "change": _vm.triggerValidate
    },
    model: {
      value: (_vm.model.password_confirm),
      callback: function($$v) {
        _vm.$set(_vm.model, "password_confirm", $$v)
      },
      expression: "model.password_confirm"
    }
  })], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSending,
      "type": "button",
      "label": "Reset Password",
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(657),
      "width": "312",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 3713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "weight-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "14px",
      "viewBox": "0 3 16 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.0274359,4.84740771 C14.8735715,3.69796239 14.1860505,3 13.1481453,3 L7.99995032,3 L2.85178845,3 C1.81394954,3 1.12642845,3.69796239 0.972531032,4.84740771 C0.81863361,5.99685303 0,14.2824828 0,14.2824828 C0,15.3027795 0.841418509,16.1298905 1.87929054,16.1298905 L7.99998344,16.1298905 L14.1207095,16.1298905 C15.1585484,16.1298905 16,15.3027795 16,14.2824828 C15.9999338,14.2824828 15.1813002,5.99682048 15.0274359,4.84740771 L15.0274359,4.84740771 Z M8.04591753,7.64554054 C8.06671538,7.61930062 8.0855924,7.59156313 8.1017869,7.56210019 C8.4607153,7.11289617 9.37125021,5.94541497 9.23897857,5.81603848 C9.13482376,5.71449715 8.33910752,6.12020671 7.76869022,6.43176509 C7.55504867,6.54844484 7.3728026,6.65200463 7.27066796,6.71070262 C7.24397519,6.72362725 7.21910388,6.73863544 7.19456375,6.7548482 C7.18946364,6.75777821 7.18174724,6.76230346 7.18174724,6.76230346 L7.18221089,6.7627918 C7.00413763,6.8859827 6.89405477,7.09443707 6.91432274,7.32330388 C6.92501972,7.44499722 6.97121875,7.55506815 7.0413618,7.64554054 L4.14473213,7.64554054 C4.07713914,7.64554054 4.02236265,7.59169336 4.02236265,7.5252471 C4.02236265,5.52499022 5.67774519,3.89765927 7.71252279,3.89765927 C7.81707501,3.89765927 7.92474029,3.90231474 8.03253803,3.91139779 C8.94949775,3.98884788 9.7994606,4.3991478 10.4257141,5.06663803 C11.05571,5.7380675 11.4026829,6.6112123 11.4026829,7.5252471 C11.4026829,7.59169336 11.3479065,7.64554054 11.2803135,7.64554054 L8.04591753,7.64554054 L8.04591753,7.64554054 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#69A7D9",
      "fill-rule": "evenodd",
      "transform": "translate(8.000000, 9.564945) scale(-1, 1) translate(-8.000000, -9.564945) "
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    staticStyle: {
      "color": "#69A7D9"
    },
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "iconClass": "blueIcon",
      "icon": 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "iconClass": "blueIcon",
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', [_c('mu-card-text', {
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [(_vm.$store.state.user.settings.weight.measure === 'kg') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "635",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:635',
      "data-vv-name": "kg",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('kg'),
      "type": "number",
      "label": "KG",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.kg),
      callback: function($$v) {
        _vm.$set(_vm.model, "kg", _vm._n($$v))
      },
      expression: "model.kg"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'lbs') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "1400",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:1400',
      "data-vv-name": "lbs",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('lbs'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.lbs),
      callback: function($$v) {
        _vm.$set(_vm.model, "lbs", _vm._n($$v))
      },
      expression: "model.lbs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "100",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:100',
      "data-vv-name": "stones",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('stones'),
      "type": "number",
      "label": "ST",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.stones),
      callback: function($$v) {
        _vm.$set(_vm.model, "stones", _vm._n($$v))
      },
      expression: "model.stones"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "13",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('pounds'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.pounds),
      callback: function($$v) {
        _vm.$set(_vm.model, "pounds", _vm._n($$v))
      },
      expression: "model.pounds"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userQuestions"
    }
  }, [(_vm.showPrivacyQuestions || _vm.isAdmin) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('message.discussionTabMyQuestions')))]), _vm._v(" "), _c('user-profile-questions', {
    attrs: {
      "userId": _vm.userId,
      "type": "MY_QUESTIONS"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('message.discussionTabMyAnswers')))]), _vm._v(" "), _c('user-profile-questions', {
    attrs: {
      "userId": _vm.userId,
      "type": "MY_ANSWERS"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showPrivacyQuestions && !_vm.isAdmin) ? _c('p', [_vm._v(_vm._s(_vm.$t('message.labelDiscussionPrivate')))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight"
  }, [(_vm.showFlashMessage) ? _c('mu-flexbox', {
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('MessageBox', {
    attrs: {
      "message-type": _vm.flashMessageType,
      "message": _vm.flashMessageBody,
      "title": _vm.flashMessageTitle
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1), _vm._v(" "), _c('mu-row')], 1)], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('mu-flexbox', {
    class: {
      'fullHeight': !_vm.showFlashMessage
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "formWrap"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "titleClass": "blueTitle largeTitle formTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('form', {
    attrs: {
      "name": "login"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "emailTxt",
      "name": "email",
      "data-vv-name": "email",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('email'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.accountPreferencesEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "passwordTxt",
      "type": _vm.passwordVisible === true ? 'text' : 'password',
      "data-vv-rules": 'required',
      "data-vv-name": "password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesPassword'),
      "label": _vm.$t('message.accountPreferencesPassword'),
      "errorText": _vm.errors.first('password'),
      "hintText": _vm.$t('message.accountPreferencesPassword'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.passwordVisible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.passwordVisible = !_vm.passwordVisible
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('VueRecaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.captchaSiteKey,
      "loadRecaptchaScript": false
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', [_c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.loginRememberMe')
    },
    model: {
      value: (_vm.remember_me),
      callback: function($$v) {
        _vm.remember_me = $$v
      },
      expression: "remember_me"
    }
  })], 1), _vm._v(" "), _c('mu-col', [_c('router-link', {
    attrs: {
      "to": "/forgot-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loginForgotPassword')))])], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "buttonPrimary",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoggingIn || !_vm.captchaFilled,
      "label": _vm.isLoggingIn ? _vm.$t('message.loggingInText') : _vm.$t('message.logInText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flexbox', [_c('div', {
    staticClass: "optionSpacer"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])]), _vm._v(" "), _c('mu-flexbox', {
    attrs: {
      "orient": "vertical"
    }
  }, _vm._l((_vm.providers), function(provider, index) {
    return _c('mu-flexbox-item', {
      key: ("provider-" + index)
    }, [_c('mu-raised-button', {
      staticClass: "loginButton",
      class: {
        darkTextButton: provider.brandColour === '#ffffff',
        buttonImageOnly: !provider.buttonText || !provider.buttonText.length
      },
      style: ({
        backgroundColor: provider.brandColour,
        backgroundImage: provider.buttonText ? '' : ("url(" + (provider.image) + ")")
      }),
      attrs: {
        "type": "button",
        "full-width": "",
        "label": provider.buttonText && provider.buttonText.length ? provider.title.toString().replace(/^/, 'Sign in with ') : '',
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.connectAccount(provider.connectUrl)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": provider.image
      }
    })])], 1)
  }), 1), _vm._v(" "), _c('mu-row', {
    staticClass: "noAccount"
  }, [_c('mu-col', [_vm._v("\n                    " + _vm._s(_vm.$t('message.loginNoAccountYet')) + "\n                  ")]), _vm._v(" "), _c('mu-col', [(_vm.offerCode) ? _c('div', [_c('router-link', {
    attrs: {
      "to": ("/register?oc=" + _vm.offerCode)
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loginSignUp')))])], 1) : _c('div', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loginSignUp')))])], 1)])], 1), _vm._v(" "), (_vm.hasError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.errorMessage || _vm.$t('message.loginErrorIncorrectCredentials')) + "\n                  ")])]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(657),
      "width": "312",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 3716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-card-actions"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 3718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "integrations"
    }
  }, [_c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "integration-panel"
  }, _vm._l((_vm.integrations), function(integration, index) {
    return _c('mu-row', {
      key: 'integration-' + index,
      staticClass: "integration-item",
      class: {
        bottom: _vm.bottom
      },
      attrs: {
        "gutter": ""
      }
    }, [_c('mu-col', {
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "width": "100",
        "desktop": "10",
        "tablet": "10"
      }
    }, [_c('img', {
      attrs: {
        "src": integration.image,
        "width": "100%"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "check",
      staticStyle: {
        "position": "absolute"
      }
    }, [_c('mu-icon', {
      attrs: {
        "color": "white",
        "value": "check"
      }
    })], 1)]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "100",
        "desktop": "90",
        "tablet": "90"
      }
    }, [_c('div', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(integration.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "afterText",
      domProps: {
        "textContent": _vm._s(integration.description)
      }
    }), _vm._v(" "), (!_vm.subscribedTo(integration.key)) ? _c('div', [_c('mu-raised-button', {
      attrs: {
        "label": _vm.$t('message.connectText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.windowOpen(integration.url, integration.key, integration.cookie, integration.handshake)
        }
      }
    })], 1) : _c('div', [_c('mu-raised-button', {
      attrs: {
        "background-color": "red",
        "color": "white",
        "label": _vm.$t('message.disconnectText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.disconnectIntegration(integration.key)
        }
      }
    }), _vm._v(" "), (integration.syncsHeartRate) ? _c('mu-raised-button', {
      attrs: {
        "disabled": _vm.hasStriivSyncStarted || _vm.isStriivPending || _vm.isStriivPending,
        "label": _vm.isStriivPending === true ? 'Sync is already processing' : 'Sync readings'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.syncStriivHeartRate.apply(null, arguments)
        }
      }
    }) : _vm._e()], 1)])], 1)
  }), 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 3719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasReports),
      expression: "hasReports"
    }],
    attrs: {
      "id": "listReports"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Reports",
      "subTitle": "A list of reported items"
    }
  }), _vm._v(" "), _c('mu-list', {
    attrs: {
      "id": "listReportsScroll"
    }
  }, [_vm._l((_vm.reports), function(report, index) {
    return _c('mu-list-item', {
      key: ("report-" + index),
      staticClass: "report",
      attrs: {
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToReport(report)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(report.comment !== null) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(("Comment: " + (report.comment.substr(0, 100)))))
      }
    }) : _vm._e(), _vm._v(" "), (report.comment === null) ? _c('div', [_vm._v("Comment: No comment")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info",
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }, [_c('p', [_vm._v("Reported user: " + _vm._s(report.reported_user))]), _vm._v(" "), _c('p', [_vm._v("Reported by: " + _vm._s(report.reported_by))]), _vm._v(" "), _c('p', [_vm._v("Reason: " + _vm._s(report.reason))]), _vm._v(" "), _c('p', [_vm._v("Date: " + _vm._s(_vm.formatDate(report.date)))]), _vm._v(" "), _c('p', [_vm._v("Time(s) reported: " + _vm._s(report.amount))])]), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "rate_review"
      },
      slot: "right"
    })], 1)
  }), _vm._v(" "), (_vm.isAppending && !_vm.isFinished) ? _c('mu-content-block', {
    staticClass: "loader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scrollDetector"
    }
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "40"
    }
  }, [_c('mu-card', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleFilterShowing.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_vm._v("\n          Refine filters\n          "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('mu-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.refiningFilters === true),
      expression: "refiningFilters === true"
    }],
    attrs: {
      "value": "keyboard_arrow_up"
    }
  }), _vm._v(" "), _c('mu-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.refiningFilters === false),
      expression: "refiningFilters === false"
    }],
    attrs: {
      "value": "keyboard_arrow_down"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.refiningFilters === true) ? _c('div', [_c('recipe-search', {
    attrs: {
      "is-results-page": true,
      "fullWidth": true,
      "filterData": _vm.filterData,
      "categories": _vm.$store.state.recipes.categories
    },
    on: {
      "filterModel": _vm.onFilterModelChange,
      "recipeData": _vm.onRecipeSearchLoaded,
      "isSearching": _vm.onSearchInitiated
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "60"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "height": "500px",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('message.loadingText')) + "\n        ")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.recipeData) ? _c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.recipeData.recipes), function(item, recipeI) {
    return _c('mu-col', {
      key: 'recipe-' + recipeI,
      staticClass: "bottom",
      attrs: {
        "width": "100",
        "desktop": "33",
        "tablet": "50"
      }
    }, [(item) ? _c('div', [_c('recipe-card', {
      attrs: {
        "recipe": item
      }
    })], 1) : _vm._e()])
  }), 1), _vm._v(" "), (_vm.recipeData) ? _c('mu-pagination', {
    attrs: {
      "total": _vm.recipeData.paginationInfo.totalItems,
      "current": _vm.recipeData.paginationInfo.actualPage + 1,
      "defaultPageSize": 15,
      "pageSize": 15
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "my-questions"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "My questions",
      "subTitle": "Your recent questions"
    }
  }), _vm._v(" "), _c('mu-list', [(_vm.isLoading) ? _c('div', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dl-' + index,
      attrs: {
        "title": item.display_name
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "width": "16%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', [_c('mu-content-block', [_vm._v("\n          No questions added yet\n        ")])], 1), _vm._v(" "), _vm._m(0)], 2) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.data.length > 0) ? _c('mu-raised-button', {
    attrs: {
      "label": "See all",
      "fullWidth": ""
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.data), function(item, index) {
    return _c('mu-list-item', {
      key: 'q-' + index,
      attrs: {
        "title": item.question
      }
    }, [_vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 0, 'q-' + index)], 1)
  })
}]}

/***/ }),
/* 3722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mu-checkbox",
    class: {
      'label-left': _vm.labelLeft,
      'disabled': _vm.disabled,
      'no-label': !_vm.label
    },
    on: {
      "mousedown": _vm.handleMouseDown,
      "mouseup": _vm.handleMouseUp,
      "mouseleave": _vm.handleMouseLeave,
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchEnd,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.nativeValue,
      "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, _vm.nativeValue) > -1 : (_vm.inputValue)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.inputValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.nativeValue,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputValue = $$c
        }
      }, _vm.handleChange]
    }
  }), _vm._v(" "), (!_vm.disabled) ? _c('touch-ripple', {
    staticClass: "mu-checkbox-wrapper",
    attrs: {
      "rippleWrapperClass": "mu-checkbox-ripple-wrapper"
    }
  }, [(_vm.label && _vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-checkbox-icon"
  }, [(!_vm.checkedIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-uncheck mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.uncheckIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-checked mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.uncheckIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-uncheck",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.uncheckIcon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkedIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-checked",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.checkedIcon
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.label && !_vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "mu-checkbox-wrapper"
  }, [(_vm.label && _vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-checkbox-icon"
  }, [(!_vm.checkedIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-uncheck mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.uncheckIcon) ? _c('svg', {
    staticClass: "mu-checkbox-icon-checked mu-checkbox-svg-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.uncheckIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-uncheck",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.uncheckIcon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkedIcon) ? _c('icon', {
    staticClass: "mu-checkbox-icon-checked",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.checkedIcon
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.label && !_vm.labelLeft) ? _c('div', {
    staticClass: "mu-checkbox-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "activity-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-paper', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-content-block', [_c('service-tracking-types', {
    staticStyle: {
      "float": "right",
      "display": "inline-block",
      "margin-top": "4px",
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "activity"
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#183C45"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.graphEmpty')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.graphEmptyExplain')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "activeStepsType": _vm.activeType,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  })], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-select-field', {
    model: {
      value: (_vm.activeType),
      callback: function($$v) {
        _vm.activeType = $$v
      },
      expression: "activeType"
    }
  }, _vm._l((_vm.activeTypes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'types-selector-' + index,
      attrs: {
        "value": item.value,
        "title": item.name
      }
    })
  }), 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(0)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(7)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(30)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(360)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('div', [(_vm.$store.state.user.scope) ? _c('medication-line-graph', {
    staticClass: "insetGraph"
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('medication-input', {
    staticStyle: {
      "margin-top": "24px"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.treatment_name))])]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                        " + _vm._s(item.dosage + ' ' + _vm.localizeRegime(item.unit_label)) + "\n                      ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('medication-edit', {
        attrs: {
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()])], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.$store.state.user.scope.has_email_sent === false && !_vm.hasSent) ? _c('alert', {
    attrs: {
      "type": "warning",
      "icon": "warning",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Please confirm your account by email!\n        "), _c('br'), _vm._v(" "), (!_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.has_email_sent ? 'Resend email' : 'Send email')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e(), _vm._v(" "), (_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#",
      "disabled": _vm.isSending
    },
    domProps: {
      "textContent": _vm._s(_vm.isSending ? 'Sending...' : 'Done!')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope.has_email_sent && !_vm.hasSent) ? _c('alert', {
    attrs: {
      "type": "success",
      "icon": "check",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n        You have already been sent an account activation email. Please check your email inbox to find it (have a look in\n        the spam folder too, just in case it was sorted into there by mistake!)\n        "), _c('br'), _vm._v(" "), (!_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.has_email_sent ? 'Resend email' : 'Send email')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e(), _vm._v(" "), (_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#",
      "disabled": _vm.isSending
    },
    domProps: {
      "textContent": _vm._s(_vm.isSending ? 'Sending...' : 'Done!')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.hasSent) ? _c('alert', {
    attrs: {
      "type": "success",
      "icon": "check",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n        Please check your email inbox for an account activation email. If you cannot find it, please check your spam\n        folder in case it was sorted into there by mistake!\n        "), _c('br'), _vm._v(" "), (!_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.has_email_sent ? 'Resend email' : 'Send email')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e(), _vm._v(" "), (_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#",
      "disabled": _vm.isSending
    },
    domProps: {
      "textContent": _vm._s(_vm.isSending ? 'Sending...' : 'Done!')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e()])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('mu-card', {
    attrs: {
      "id": "lifeRecommendations"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.lifeCategoryListsHeaderText'),
      "subTitle": _vm.$t('message.lifeCategoryListsSubHeaderText')
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('mu-list', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dummy-loader-' + index
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9 "
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "width": "16%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9 "
      },
      slot: "describe"
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('mu-list', _vm._l((_vm.data), function(item, index) {
    return (!_vm.isLoading && !item.post_private) ? _c('mu-list-item', {
      key: 'life-category-post-' + index
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(item.post_slug)
        }
      },
      slot: "title"
    }, [_vm._v(" ' →')\">")]), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "size": 50,
        "src": item.post_image || '',
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(item.post_slug)
        }
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-flat-button', {
      staticClass: "btn-outline",
      attrs: {
        "rippleColor": "#E74C3C",
        "disabled": !_vm.userId
      },
      nativeOn: {
        "click": function($event) {
          return _vm.favouritePost(item.post_id, index)
        }
      }
    }, [_c('span', {
      staticClass: "mu-icon material-icons",
      domProps: {
        "textContent": _vm._s(item.post_favourited ? 'favorite' : 'favorite_border')
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.post_favourites)
      }
    })])], 1)], 1) : _vm._e()
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.provider.showLogo === true) ? _c('div', {
    staticClass: "provider-accreditation"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('message.labelProviderInAssociationWith')) + "\n  "), _vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$store.state.provider.logo
    }
  })]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nhs-logo"
  }, [_c('img', {
    attrs: {
      "src": "static/nhs-logo.svg",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 3728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fitbit-sleep-stages"
    }
  }, [(_vm.fitbitData.sleep.length > 0) ? _c('mu-card', [_c('mu-divider'), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Time asleep",
      "subTitleClass": "timeAsleep",
      "subTitle": _vm.normalizeDuration(_vm.sleepBreakdown.total)
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Time in bed",
      "subTitleClass": "timeAsleep",
      "subTitle": _vm.normalizeDuration(_vm.sleepBreakdown.totalInBed)
    }
  })], 1)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Stages of sleep",
      "subTitle": _vm.date
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.sleepBreakdown && _vm.sleepBreakdown.type === 'classic') ? _c('div', [_c('mu-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Awake")])]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.awake)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.awake) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Asleep")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.asleep)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.asleep) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Restless")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.restless)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.restless) + "%")])])], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "accreditation"
  }, [_c('img', {
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "src": "static/integrations/fitbit.svg"
    }
  }), _vm._v("\n        Data from FitBit\n      ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.sleepBreakdown && _vm.sleepBreakdown.type === 'stages') ? _c('mu-card-text', [_c('div', [_c('div', {
    staticClass: "rail"
  }, [_c('div', {
    staticClass: "percentage-bar awake",
    style: ({
      'width': _vm.sleepBreakdown.formatted.wake + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.wake) + "% awake")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.wake)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rail"
  }, [_c('div', {
    staticClass: "percentage-bar rem",
    style: ({
      'width': _vm.sleepBreakdown.formatted.rem + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.rem) + "% REM")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.rem)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rail"
  }, [_c('div', {
    staticClass: "percentage-bar light",
    style: ({
      'width': _vm.sleepBreakdown.formatted.light + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.light) + "% light")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.light)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "percentage-bar deep",
    style: ({
      'width': _vm.sleepBreakdown.formatted.deep + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.deep) + "% deep")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.deep)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "accreditation"
  }, [_c('img', {
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "src": "static/integrations/fitbit.svg"
    }
  }), _vm._v("\n        Data from FitBit\n      ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.fitbitData.sleep.length === 0) ? _c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "No data",
      "subTitle": _vm.date
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight register"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInUp",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(657),
      "width": "312",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.showFlashMessage) ? _c('MessageBox', {
    staticStyle: {
      "padding": "0 15px"
    },
    attrs: {
      "message-type": _vm.flashMessageType,
      "message": _vm.flashMessageBody,
      "title": _vm.flashMessageTitle
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-card-text', [_c('InitialRegistration')], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "testimonial"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3345),
      "alt": "Liz Before and After"
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "testimonial-block"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3344),
      "width": "28",
      "alt": "Quote Icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-text"
  }, [_c('p', [_vm._v("“I’m a vegetarian and lost 13kg (2st) and am in Type 2 Diabetes Remission”")])]), _vm._v(" "), _c('div', {
    staticClass: "testimonial-from"
  }, [_c('p', [_vm._v("Liz")]), _vm._v(" "), _c('p', {
    staticClass: "member"
  }, [_vm._v("Member since 2019")])])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "FoodDiaryList"
    }
  }, [(_vm.hasFoods) ? _c('mu-list', {
    staticClass: "foods"
  }, _vm._l((_vm.foods), function(food, foodIndex) {
    return _c('mu-list-item', {
      key: ("food-item-" + foodIndex),
      staticClass: "food",
      attrs: {
        "disableRipple": ""
      }
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n        " + _vm._s('x' + food.servings + ' ' + (food.brand_name ? food.brand_name + ' - ' : '') + food.food_name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "serving",
      attrs: {
        "slot": "describe"
      },
      domProps: {
        "textContent": _vm._s(food.serving_description)
      },
      slot: "describe"
    }), _vm._v(" "), (_vm.userId === _vm.$store.state.user.scope.user_id) ? _c('mu-float-button', {
      staticClass: "trash",
      attrs: {
        "slot": "right",
        "icon": "delete",
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteFood(food, foodIndex)
        }
      },
      slot: "right"
    }) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.hasRecipes) ? _c('mu-list', {
    staticClass: "foods"
  }, _vm._l((_vm.recipes), function(recipe, recipeIndex) {
    return _c('mu-list-item', {
      key: ("food-item-" + recipeIndex),
      staticClass: "food",
      attrs: {
        "disableRipple": ""
      }
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n        " + _vm._s('x' + recipe.servings + ' ' + recipe.name) + _vm._s(recipe.length) + "\n      ")]), _vm._v(" "), (_vm.userId === _vm.$store.state.user.scope.user_id) ? _c('mu-float-button', {
      staticClass: "trash",
      attrs: {
        "slot": "right",
        "icon": "delete",
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteRecipe(recipe, recipeIndex)
        }
      },
      slot: "right"
    }) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.hasFoods && !_vm.hasRecipes) ? _c('div', {
    staticClass: "noFoods"
  }, [(_vm.tab !== 'All') ? _c('p', [_vm._v("You added no foods for "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.tab)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-row', {
    staticClass: "totals"
  }, _vm._l((_vm.nutritionalKeys), function(nutrition, nutritionIndex) {
    return _c('mu-col', {
      key: ("nutrition-" + nutritionIndex),
      staticClass: "nutrition",
      attrs: {
        "tablet": "20",
        "desktop": "20",
        "width": "20"
      }
    }, [_c('div', {
      staticClass: "value",
      domProps: {
        "textContent": _vm._s(("" + (_vm.getValueByNutritionKey(nutrition.key).toFixed(1)) + (nutrition.unit)))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "label",
      domProps: {
        "textContent": _vm._s(nutrition.label)
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "pulse-ranges"
  }, [_c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v("Your heart rate statistics for " + _vm._s(_vm.moment(_vm.data.date).format('Do MMM YY')))]), _vm._v(" "), (_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v(_vm._s(_vm.$t('message.loadingText')))]) : _vm._e(), _vm._v(" "), _c('mu-card-text', [(!_vm.isLoading) ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('radial-progress', {
    attrs: {
      "data-id": "radial-min",
      "value": _vm.data.min,
      "color": "#9781F0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          MIN\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('radial-progress', {
    attrs: {
      "data-id": "radial-max",
      "value": _vm.data.max,
      "color": "#F1696B"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          MAX\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('radial-progress', {
    attrs: {
      "data-id": "radial-avg",
      "value": _vm.data.avg,
      "color": "#6EDEEA"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          AVG\n        ")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "subHeader",
    staticStyle: {
      "padding": "8px 8px 4px 8px"
    }
  }, [_c('div', [_vm._v("Select one of your pre-saved meals from the list")])]), _vm._v(" "), _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.meals), function(meal, index) {
    return _c('mu-list-item', {
      key: 'meal-' + index,
      attrs: {
        "disableRipple": ""
      },
      on: {
        "click": _vm.loadFoods
      }
    }, [_vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(meal.meal_name))]), 0, 'meal-' + index), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "describe"
    }, [_vm._v("\n        Contains " + _vm._s(meal.count) + " foods\n      ")]), _vm._v(" "), _c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteMeal(meal.meal_id)
        }
      }
    })], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope && !_vm.$route.meta.hideLoader),
      expression: "!$route.meta.isAuthView && !$store.state.user.scope && !$route.meta.hideLoader"
    }],
    staticClass: "medLoader",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "bootLoader",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "static/loader-gif.gif",
      "alt": _vm.$t('message.loadingText')
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.loadingMessage)
    }
  })])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "postInfo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: ("/life/" + _vm.slug)
      }
    },
    on: {
      "click": function($event) {
        return _vm.goToArticle(_vm.slug)
      }
    }
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url('" + _vm.image + "')")
    })
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "date"
  }, [_c('mu-icon', {
    attrs: {
      "value": "watch_later",
      "color": "#5b617c"
    }
  }), _vm._v(" "), _c('time', {
    attrs: {
      "datetime": _vm.time
    },
    domProps: {
      "textContent": _vm._s(_vm.moment(_vm.time).fromNow())
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "favourites"
  }, [_c('mu-icon', {
    attrs: {
      "value": "favorite",
      "color": "#d83e38"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.favourites)
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 3735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bioField"
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": "Describe yourself",
      "errorText": _vm.error,
      "errorColor": "red",
      "multiLine": "",
      "fullWidth": "",
      "rows": 3,
      "rowsMax": 6,
      "maxLength": _vm.max
    },
    on: {
      "textOverflow": _vm.handleOverflow
    },
    model: {
      value: (_vm.bio),
      callback: function($$v) {
        _vm.bio = $$v
      },
      expression: "bio"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-buttons"
  }, [_c('mu-flat-button', {
    attrs: {
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeBio.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "Save",
      "primary": "",
      "disabled": _vm.isBioError
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveBio.apply(null, arguments)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-select-field', {
    attrs: {
      "maxHeight": 246,
      "label": "Ethnicity",
      "separator": ", ",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.ethnicity_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "ethnicity_id", $$v)
      },
      expression: "model.ethnicity_id"
    }
  }, _vm._l((_vm.lists.ethnicities), function(item, index) {
    return _c('mu-menu-item', {
      key: "'allergy-' + index",
      attrs: {
        "value": item.ethnicity_id,
        "title": item.name
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "maxHeight": 246,
      "label": "Occupation",
      "separator": ", ",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.occupation_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "occupation_id", $$v)
      },
      expression: "model.occupation_id"
    }
  }, _vm._l((_vm.lists.occupations), function(item, index) {
    return _c('mu-menu-item', {
      key: "'occupation-' + index",
      attrs: {
        "value": item.occupation_id,
        "title": item.occupation_name
      }
    })
  }), 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "fullWidth": "",
      "maxHeight": 246,
      "label": "Your allergys",
      "multiple": "",
      "separator": ", "
    },
    model: {
      value: (_vm.model.allergies),
      callback: function($$v) {
        _vm.$set(_vm.model, "allergies", $$v)
      },
      expression: "model.allergies"
    }
  }, _vm._l((_vm.lists.allergies), function(item, index) {
    return _c('mu-menu-item', {
      key: "'allergy-' + index",
      attrs: {
        "value": item.allergy_id,
        "title": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "fullWidth": "",
      "maxHeight": 246,
      "label": "Dietary preference",
      "separator": ", "
    },
    model: {
      value: (_vm.model.dietry_preference_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "dietry_preference_id", $$v)
      },
      expression: "model.dietry_preference_id"
    }
  }, _vm._l((_vm.lists.dietry_preferences), function(item, index) {
    return _c('mu-menu-item', {
      key: "'dpref-' + index",
      attrs: {
        "value": item.dietry_preference_id,
        "title": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "secondary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? 'Updating...' : 'Update'
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "ketones-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "17px",
      "height": "15px",
      "viewBox": "20 193 17 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.596657,204.024078 L27.4483433,202.008701 C27.4466257,202.00863 27.4449084,202.008558 27.4431913,202.008486 C27.1065685,201.994308 26.7913774,201.899106 26.5165508,201.742332 C26.5127922,201.740187 26.5090412,201.738031 26.5052978,201.735864 L22.9607307,205.098641 C22.9022004,205.00058 22.8320228,204.910144 22.7520541,204.829189 C22.8320477,204.91017 22.9022218,205.000584 22.9607307,205.098603 C23.0858378,205.308123 23.1578576,205.552244 23.1578576,205.813086 C23.1578576,206.591273 22.5192209,207.222113 21.7315461,207.222113 C20.9438714,207.222113 20.3052347,206.591273 20.3052347,205.813086 C20.3052347,205.034899 20.9438714,204.404059 21.7315461,204.404059 C22.0081146,204.404059 22.266129,204.482054 22.4847255,204.616683 C22.5823877,204.676827 22.6721283,204.748294 22.7520786,204.829222 C22.6721112,204.74826 22.5823835,204.676806 22.4847255,204.616683 L25.9804623,201.300249 C25.979853,201.299539 25.9792442,201.298829 25.9786358,201.298118 C25.8510297,201.149012 25.7450446,200.981427 25.6654138,200.799813 C25.6638728,200.796296 25.6623417,200.792774 25.6608205,200.789247 L23.7310234,201.083431 C23.731024,201.083445 23.7310246,201.08346 23.7310252,201.083474 C23.7316689,201.099335 23.7322369,201.115233 23.7322369,201.131281 C23.7322369,201.754564 23.2207519,202.259789 22.5899154,202.259789 C21.9590789,202.259789 21.447594,201.754564 21.447594,201.131281 C21.447594,200.508035 21.9590789,200.002773 22.5899154,200.002773 C23.0588019,200.002773 23.4615755,200.282057 23.6375736,200.681344 C23.6649255,200.743352 23.6867798,200.808249 23.70255,200.875451 C23.686733,200.808242 23.6648749,200.743329 23.6375357,200.681307 L25.5370166,200.391763 C25.5120013,200.265875 25.498617,200.135916 25.498617,200.002773 C25.498617,199.791682 25.531787,199.588223 25.5929395,199.397109 C25.594108,199.393456 25.5952868,199.389807 25.5964758,199.386163 L22.2313526,197.296404 C22.0022118,197.451577 21.7251049,197.542657 21.4263115,197.542657 C20.6386368,197.542657 20,196.911817 20,196.13363 C20,195.355443 20.6386368,194.724603 21.4263115,194.724603 C22.2139862,194.724603 22.852623,195.355443 22.852623,196.13363 C22.852623,196.360693 22.7979454,196.575001 22.701351,196.764993 C22.6977556,196.772067 22.6941018,196.779107 22.6903901,196.786113 L25.9134096,198.787653 C25.9142237,198.786597 25.9150389,198.785541 25.9158551,198.784487 C26.1606166,198.468319 26.498224,198.226405 26.8885399,198.097948 C26.8904269,198.097326 26.8923151,198.096707 26.8942045,198.096091 L26.5419267,196.272088 C26.5275843,196.272616 26.5131743,196.272881 26.4987015,196.272881 C26.0241731,196.272881 25.6173101,195.986976 25.4447199,195.580058 C25.3919735,195.455716 25.3614161,195.320001 25.3572131,195.177778 C25.3569102,195.166631 25.35638,195.155558 25.35638,195.144373 C25.35638,194.521128 25.867865,194.015865 26.4987015,194.015865 C27.129538,194.015865 27.641023,194.521128 27.641023,195.144373 C27.641023,195.609839 27.3557657,196.009462 26.9485713,196.181993 L27.3011865,198.00799 C27.302338,198.007862 27.3034899,198.007735 27.3046421,198.007609 C27.3790096,197.999454 27.4544752,197.99489 27.5310768,197.99489 C27.8205573,197.99489 28.0956868,198.055079 28.3449164,198.162849 C28.3489893,198.16461 28.3530551,198.166383 28.3571139,198.168169 L31.3242218,194.710288 C31.295779,194.66368 31.2706485,194.614875 31.2491522,194.564193 C31.1964058,194.43985 31.1658485,194.304136 31.1616454,194.161913 C31.1613425,194.150766 31.1608124,194.139693 31.1608124,194.128508 C31.1608124,193.505263 31.6722974,193 32.3031339,193 C32.9339704,193 33.4454553,193.505263 33.4454553,194.128508 C33.4454553,194.751791 32.9339704,195.257016 32.3031339,195.257016 C32.1358821,195.257016 31.9770362,195.221499 31.8338911,195.157684 L28.927578,198.544676 C28.9281876,198.545247 28.9287969,198.545817 28.9294058,198.546388 C29.2396504,198.837192 29.4568592,199.223451 29.533072,199.657709 L31.5322182,199.230597 C31.5317163,199.221318 31.5313269,199.21201 31.5310509,199.202673 C31.530748,199.191526 31.5302179,199.180453 31.5302179,199.169268 C31.5302179,198.546023 32.0417029,198.04076 32.6725394,198.04076 C33.3033759,198.04076 33.8148608,198.546023 33.8148608,199.169268 C33.8148608,199.792551 33.3033759,200.297776 32.6725394,200.297776 C32.2080875,200.297776 31.8084578,200.023885 31.6298678,199.63071 L29.5619371,200.072526 C29.5617913,200.076347 29.5616419,200.080166 29.5614918,200.083984 C29.5475952,200.428133 29.4461919,200.749912 29.2784484,201.028261 C29.2780899,201.028856 29.277731,201.02945 29.2773718,201.030045 L33.6347039,203.867711 C33.4627953,204.016368 33.3274646,204.205164 33.2434793,204.419359 L28.8313211,201.546008 C28.8277765,201.548928 28.8242216,201.551836 28.8206565,201.554733 C28.5521534,201.772744 28.2259435,201.923646 27.8681919,201.982675 C27.8668152,201.982902 27.865438,201.983128 27.8640604,201.983353 L28.0113579,203.984385 C28.5960015,204.0338 29.0550808,204.51804 29.0550808,205.108442 C29.0550808,205.731725 28.5435959,206.23695 27.9127594,206.23695 C27.2819229,206.23695 26.7704379,205.731725 26.7704379,205.108442 C26.7704379,204.593604 27.1195928,204.159566 27.5966568,204.024075 Z M27.9622524,203.981169 C27.9787073,203.981941 27.995072,203.983055 28.0113607,203.984422 Z M34.5736885,203.518774 C34.2140057,203.518774 33.8856375,203.650598 33.6347039,203.867711 C33.4627953,204.016443 33.3274646,204.205164 33.2434793,204.419396 C33.1816452,204.577181 33.147377,204.748507 33.147377,204.927838 C33.147377,205.706026 33.7860138,206.336865 34.5736885,206.336865 C35.3613632,206.336865 36,205.706026 36,204.927838 C36,204.149651 35.3613632,203.518774 34.5736885,203.518774 Z",
      "id": "Combined-Shape",
      "stroke": "none",
      "fill": "#2761ff",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.isOpenInput === false) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput === true) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.$store.state.user.settings.blood_glucose.measure === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "63",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:63',
      "data-vv-name": "ketones_mgdl",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('ketones_mgdl'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "mgdl", _vm._n($$v))
      },
      expression: "model.mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0.1",
      "max": "3.5",
      "type": "number",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:3.5',
      "data-vv-name": "ketones_mmoll",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('ketones_mmoll'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "mmoll", _vm._n($$v))
      },
      expression: "model.mmoll"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "updateEmail"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "email",
      "data-vv-rules": 'required|email',
      "data-vv-name": "new_email",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.securityPreferencesChangeEmail'),
      "errorText": _vm.errors.first('new_email'),
      "label": _vm.$t('message.securityPreferencesChangeEmail'),
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.new_email),
      callback: function($$v) {
        _vm.$set(_vm.model, "new_email", $$v)
      },
      expression: "model.new_email"
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.securityPreferencesSendVerificationEmail'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-result edit-dialog"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('md-icon', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticStyle: {
      "position": "relative",
      "z-index": "99"
    }
  }, [_c('mu-list', [_c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "describeText": _vm.food.brand_name
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : _vm.food.food_name)
    }
  })])])], 1), _vm._v(" "), (_vm.food.food_name) ? _c('div', [(!_vm.isLoading) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "width": "100",
      "desktop": _vm.leftPaneWidth.desktop,
      "tablet": _vm.leftPaneWidth.tablet
    }
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:99'),
      expression: "'required|min_value:0|max_value:99'"
    }],
    attrs: {
      "data-vv-name": "serving_size",
      "data-vv-as": "serving size",
      "errorText": _vm.errors.first('serving_size'),
      "min": 0,
      "type": "number",
      "hintText": "Multiplier",
      "label": _vm.$t('message.labelServingSize'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.servings),
      callback: function($$v) {
        _vm.$set(_vm.model, "servings", _vm._n($$v))
      },
      expression: "model.servings"
    }
  }), _vm._v(" "), _c('span', [_c('mu-flexbox', {
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryQuickPortionLabel'))
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "maxHeight": 248,
      "label": " ",
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.serving_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "serving_id", _vm._n($$v))
      },
      expression: "model.serving_id"
    }
  }, _vm._l((_vm.food.servings), function(serving, index) {
    return _c('mu-menu-item', {
      key: 'serving-' + index,
      attrs: {
        "value": serving.serving_id,
        "title": serving.serving_description
      }
    })
  }), 1), _vm._v(" "), _c('span', [_c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.25')
      }
    }
  }, [_vm._v("1/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.5')
      }
    }
  }, [_vm._v("1/2")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.75')
      }
    }
  }, [_vm._v("3/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('1')
      }
    }
  }, [_vm._v("1")])], 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "landscape",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "bottom"
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCalories'))
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.rounded(_vm.activeServingObject.nutrients.calories * _vm.model.servings))
    }
  }), _vm._v(" "), _c('span', [_vm._v("kcal")])]), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat') + ': ')
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.rounded(_vm.activeServingObject.nutrients.fat * _vm.model.servings))
    }
  }), _vm._v(" "), _c('span', [_vm._v("g")])]), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrate') + ': ')
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.rounded(_vm.activeServingObject.nutrients.carbohydrate * _vm.model.servings))
    }
  }), _vm._v(" "), _c('span', [_vm._v("g")])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein') + ': ')
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.rounded(_vm.activeServingObject.nutrients.protein * _vm.model.servings))
    }
  }), _vm._v(" "), _c('span', [_vm._v("g")])]), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientSugar'))
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.rounded(_vm.activeServingObject.nutrients.sugar * _vm.model.servings))
    }
  }), _vm._v(" "), _c('span', [_vm._v("g")])])])], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Full nutrition",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNutritionPane()
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.isNutritionPaneVisible) ? _c('mu-col', {
    staticClass: "rightPane",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    staticClass: "removePadding",
    attrs: {
      "subTitle": _vm.model.servings + ' x ' + _vm.activeServingObject.serving_description
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeServingObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrient-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.rounded(value * _vm.model.servings) + _vm.getUnit(key)
      }
    })
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "card-actions",
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateFood()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcpDashboard"
    }
  }, [(_vm.isHcpVerified) ? _c('hcp-getting-started-modal') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Low Carb Program: Healthcare Professional Platform")]), _vm._v(" "), _c('mu-card', {
    staticClass: "downloads"
  }, [_c('div', {
    staticClass: "mu-card-title-container"
  }, [_c('div', {
    staticClass: "mu-card-title"
  }, [_vm._v("\n          Core Resources\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mu-card-sub-title"
  }, [_vm._v("\n          Key information and guidance to support your patients\n        ")])]), _vm._v(" "), _c('mu-card-text', [_c('ul', [_vm._l((_vm.downloads.modules), function(download, downloadIndex) {
    return (!_vm.downloads.isLoading) ? _c('li', {
      key: ("download-" + downloadIndex)
    }, [_c('a', {
      attrs: {
        "href": download.link,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("\n              " + _vm._s(download.title) + "\n              "), _c('mu-icon', {
      attrs: {
        "value": "open_in_new",
        "size": 16,
        "color": "#A8A8A8"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((5), function(download, downloadIndex) {
    return (_vm.downloads.isLoading) ? _c('li', {
      key: ("download-" + downloadIndex),
      staticStyle: {
        "margin": "15px 0 0"
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "20px",
        "width": "10%",
        "background": "#f1f1f1"
      },
      style: ({
        width: _vm.getRandomArbitrary(15, 25)
      }),
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  })], 2)])], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "commission"
  }, [_c('mu-card-title', {
    attrs: {
      "title": "Learn more about commissioning the program"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-flat-button', {
    attrs: {
      "label": "Contact Us",
      "backgroundColor": "#FFF",
      "color": "#0179d5"
    },
    on: {
      "click": _vm.goToFeedbackCommission
    }
  })], 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "modules"
  }, [_c('mu-card-title', {
    attrs: {
      "title": "Professional Development"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "60",
      "tablet": "6",
      "width": "100"
    }
  }, [_c('mu-list', {
    staticClass: "links"
  }, _vm._l((_vm.quickLinks), function(link, index) {
    return _c('div', {
      key: ("link-" + index),
      staticClass: "linkWrap"
    }, [_c('mu-list-item', {
      attrs: {
        "title": link.label
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(link.to, link.type)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_c('mu-icon', {
      attrs: {
        "value": link.icon,
        "color": "#0179d5"
      }
    })], 1)]), _vm._v(" "), _c('mu-divider')], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "recent"
  }, [_c('h3', {
    staticClass: "largeTitle blueTitle"
  }, [_vm._v("Recently added")]), _vm._v(" "), _c('mu-list', [_vm._l((_vm.recent.modules), function(post, index) {
    return (!_vm.recent.isLoading) ? _c('mu-list-item', {
      key: ("post-" + index),
      staticClass: "item",
      attrs: {
        "title": post.post_title,
        "describeText": post.post_excerpt,
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToModule(post.post_slug)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "src": post.post_video_thumb
      }
    })], 1), _vm._v(" "), _c('mu-divider')], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((3), function(post, index) {
    return (_vm.recent.isLoading) ? _c('mu-list-item', {
      key: ("post-" + index)
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "size": 40,
        "backgroundColor": "#F1F1F1"
      }
    })], 1), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "height": "13px",
        "width": "10%",
        "background": "#f1f1f1",
        "position": "relative",
        "top": "-5px"
      },
      style: ({
        width: _vm.getRandomArbitrary(40, 60)
      }),
      attrs: {
        "slot": "title",
        "color": "#d9d9d9"
      },
      slot: "title"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "height": "13px",
        "width": "10%",
        "background": "#f1f1f1"
      },
      style: ({
        width: _vm.getRandomArbitrary(80, 100)
      }),
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "block-rcgp",
    staticStyle: {
      "background-image": "url('static/hcp/rcgp-module.jpg')"
    },
    attrs: {
      "desktop": "40",
      "tablet": "40",
      "width": "100"
    }
  }, [_c('img', {
    staticClass: "rcgp-bg",
    attrs: {
      "src": "static/hcp/rcgp-module.jpg",
      "alt": "RCGP"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rcgp-module"
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('img', {
    staticClass: "rcgp-logo",
    attrs: {
      "src": "static/hcp/rcgp.png",
      "alt": "RCGP logo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.quickLinks[1].label))]), _vm._v(" "), _c('p', [_vm._v("Written by Dr David Unwin, this module describes the use of a low GI diet as an adjunct treatment for diabetes, using a case study of a real patient registered at the author's practice. The physiology and evidence behind a low glycaemic-index diet are described, as well as how to implement it in real life.")]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "view",
    attrs: {
      "label": "View Module",
      "icon": "play_circle_filled",
      "color": "#FFF",
      "href": _vm.quickLinks[1].to,
      "target": "_blank"
    }
  })], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "information",
    attrs: {
      "align": "stretch"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-card', [_c('mu-card-title', {
    attrs: {
      "title": "Resources"
    }
  }), _vm._v(" "), _c('mu-card-text', [_vm._l((_vm.cats.data), function(cat, index) {
    return (!_vm.cats.isLoading) ? _c('md-chip', {
      key: ("cat-" + index),
      staticClass: "cat",
      domProps: {
        "textContent": _vm._s(cat.name)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToResourceCat(cat.slug)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((5), function(cat, index) {
    return (_vm.cats.isLoading) ? _c('mu-linear-progress', {
      key: ("cat-" + index),
      staticClass: "cat",
      staticStyle: {
        "display": "inline-block",
        "height": "32px",
        "width": "10%",
        "background": "#f1f1f1"
      },
      style: ({
        width: _vm.getRandomArbitrary(10, 20)
      }),
      attrs: {
        "color": "#d9d9d9"
      }
    }) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "feedback",
    staticStyle: {
      "background-image": "url('static/hcp/hcp-feedback.jpg')"
    },
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Contact us")]), _vm._v(" "), _c('p', [_vm._v("Contact us to discuss your needs, queries and suggestions for development of the platform")]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action",
    attrs: {
      "label": "Contact us",
      "icon": "play_circle_filled",
      "color": "#FFF"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToFeedback()
      }
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "forum"
  }, [_c('mu-card-title', {
    attrs: {
      "title": "Latest from the forum"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('hcp-forum', {
    attrs: {
      "amount": 5
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_vm._l((_vm.params.per_page), function(item, index) {
    return (_vm.isLoading === true) ? _c('mu-list-item', {
      key: 'params-' + index
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "14px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.avatar,
        "color": "white",
        "backgroundColor": "white"
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "12px",
        "width": "15%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.isLoading === false && _vm.hasItems) ? _c('mu-list', _vm._l((_vm.items), function(item, itemIndex) {
    return _c('mu-list-item', {
      key: 'question-item-' + itemIndex,
      staticClass: "userQuestion",
      attrs: {
        "to": {
          path: ("/questions/thread/" + (item.question_id))
        }
      }
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('p', {
      staticClass: "question-title",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(item.question))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "question-by"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('message.discussionAskedBySuffix')) + "\n          "), _c('router-link', {
      attrs: {
        "to": {
          path: ("/profile/" + (item.url))
        }
      },
      domProps: {
        "textContent": _vm._s(item.display_name)
      }
    })], 1)]), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": item.profile_large
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(_vm.fromNow(item.timestamp))
      }
    })])], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasItems) ? _c('mu-card-text', [_vm._v(_vm._s(_vm.$t('message.labelNo')) + " " + _vm._s(_vm.type === 'MY_QUESTIONS' ? _vm.$t('message.labelQuestionsAsked').toLowerCase() : _vm.$t('message.labelQuestionsAnswered').toLowerCase()))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipeData.recipes.length == 1000),
      expression: "recipeData.recipes.length == 1000"
    }],
    staticClass: "noFavourites"
  }, [_c('p', [_vm._v("You haven't added any recipes to your favourites yet, have a browse!")])]), _vm._v(" "), _vm._l((_vm.recipeData.recipes), function(item, recipeI) {
    return (_vm.recipeData.recipes.length < 1000) ? _c('mu-col', {
      key: 'recipe-' + recipeI,
      staticClass: "bottom",
      attrs: {
        "width": "100",
        "desktop": "33",
        "tablet": "33"
      }
    }, [_c('recipe-card', {
      attrs: {
        "recipe": item
      }
    })], 1) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      userAvatar: _vm.$store.state.user.cover_photo
    },
    style: ({
      'background': 'url(' + _vm.$store.state.user.cover_photo + ') center center no-repeat no-repeat',
      'background-size': 'cover',
      'position': 'relative'
    })
  }, [(_vm.$store.state.user.cover_photo) ? _c('div', {
    staticClass: "blackGradient"
  }) : _vm._e(), (_vm.$store.state.user.scope) ? _c('mu-list', [_c('mu-list-item', {
    attrs: {
      "title": _vm.upperFirstChar,
      "describeText": _vm.$store.state.user.scope.diabetes_type.diabetes_type ? _vm.$store.state.user.scope.diabetes_type.diabetes_type : null,
      "disabled": "disabled"
    }
  }, [(!_vm.$store.state.user.scope.profile_large) ? _c('mu-avatar', {
    staticClass: "blue",
    attrs: {
      "slot": "left",
      "src": _vm.$store.state.user.scope.profile_large,
      "color": "white",
      "backgroundColor": "grey"
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.upperTwoInitials))]) : _c('mu-avatar', {
    attrs: {
      "slot": "left",
      "src": _vm.$store.state.user.scope.profile_large,
      "color": "white",
      "backgroundColor": "grey"
    },
    slot: "left"
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 3745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "medication-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.hasMedications) ? _c('div', [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.data.message)
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.hasMedications) ? _c('div', [_c('div', {
    staticClass: "card-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('message.cardEmptyMedication')))]), _vm._v("\n            " + _vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings_cog"
    },
    slot: "left"
  }), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1) : _vm._e()])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardMedicationLastDose')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_vm._v("\n                " + _vm._s(_vm.data.dosage) + " " + _vm._s(_vm.localizeRegime(_vm.data.unit_label)) + "\n              ")])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardMedicationLastMedication')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.data.treatment_name) + "\n            ")])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "21 193 15 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M1.00081633,9.15102041 C-0.331428571,10.4832653 -0.331428571,12.6546939 1.00081633,13.9869388 C2.33306122,15.3191837 4.5044898,15.3191837 5.83673469,13.9869388 L9.9477551,9.87591837 L5.11183673,5.03673469 L1.00081633,9.15102041 L1.00081633,9.15102041 Z",
      "id": "path-1"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "mask-2",
      "maskContentUnits": "userSpaceOnUse",
      "maskUnits": "objectBoundingBox",
      "x": "0",
      "y": "0",
      "width": "9.94612245",
      "height": "9.94938776",
      "fill": "white"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-5",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(21.000000, 193.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.15020408,1.00163265 L4.56897959,5.56979592 L9.40489796,10.4057143 L13.9828571,5.83428571 C15.3183673,4.50204082 15.3183673,2.33387755 13.9828571,1.00163265 C12.6506122,-0.333877551 10.482449,-0.333877551 9.15020408,1.00163265 Z",
      "id": "Shape",
      "fill": "#AD3463"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "id": "Shape",
      "stroke": "#AD3463",
      "mask": "url(#mask-2)",
      "stroke-width": "2",
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.loading) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": "settings_cog",
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToSettings()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasMedications && !_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'add',
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasMedications && _vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'remove',
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [(_vm.hasMedications) ? _c('mu-card-text', [(!_vm.alreadyCopied) ? _c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "disabled": !_vm.hasMedsToCopy,
      "label": _vm.$t('message.cardMedicationRepeatYesterday') + ' (' + _vm.yesterdayDosageCount + ')',
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyYesterdaysMedication.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-name": "medication",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('medication'),
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('cardMedication'),
      "scroller": _vm.scroller,
      "label": _vm.$t('message.cardMedicationSelect'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.tracking_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "tracking_id", $$v)
      },
      expression: "model.tracking_id"
    }
  }, _vm._l((_vm.activeMedications), function(item, index) {
    return _c('mu-menu-item', {
      key: 'medication-' + index,
      attrs: {
        "title": item.treatment_name,
        "value": item.tracking_id
      }
    })
  }), 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2500'),
      expression: "'required|min_value:1|max_value:2500'"
    }],
    staticClass: "bottom",
    attrs: {
      "min": "1",
      "max": "2500",
      "data-vv-name": "dosage",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.cardMedicationDose'),
      "errorText": _vm.errors.first('dosage'),
      "data-vv-validate-on": "none",
      "label": _vm.$t('message.cardMedicationDose'),
      "type": "number",
      "hintText": _vm.$t('message.cardMedicationDosage'),
      "helpText": _vm.localizeRegime(_vm.activeLabel),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.dosage),
      callback: function($$v) {
        _vm.$set(_vm.model, "dosage", _vm._n($$v))
      },
      expression: "model.dosage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(!_vm.isLoading && _vm.data.status.locked) ? _c('div', {
    attrs: {
      "id": "lessonLockScreen"
    }
  }, [_c('h1', {
    staticClass: "largeTitle blueTitle"
  }, [_vm._v("We're sorry, this content is not available to you yet")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "value": "lock"
    }
  }), _vm._v(" "), _c('p', [_vm._v("This lesson is not available to you for another " + _vm._s(_vm.data.status.remaining) + " day(s)")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btnRedirect",
    attrs: {
      "label": "Go to Dashboard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDashboard.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.data.status.locked === false) ? _c('div', [(!_vm.data.taken.start_questions) ? _c('lesson-rating-panel', {
    staticClass: "marginBottom",
    attrs: {
      "mode": "start",
      "course": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.data.title)
    }
  })])]), _vm._v(" "), _c('lesson-personalised-panel', {
    attrs: {
      "course": _vm.data,
      "courseId": _vm.data.course_id
    },
    on: {
      "isMainVideoVisible": _vm.toggleMainVideo
    }
  }), _vm._v(" "), (_vm.isMainVideoVisible) ? _c('mu-card', [_c('iframe-video-player', {
    attrs: {
      "src": _vm.data.videos.vimeo.web
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-text', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.data.content))
    }
  }), _vm._v(" "), (_vm.data.audio_url) ? _c('audio-player', {
    staticClass: "bottom",
    attrs: {
      "url": _vm.data.audio_url
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "icon": _vm.isTranscriptOpen ? 'expand_less' : 'expand_more',
      "label": _vm.isTranscriptOpen ? _vm.$t('message.lessonHideTranscript') : _vm.$t('message.lessonViewTranscript'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleTranscript.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.isTranscriptOpen) ? _c('mu-card', {
    staticClass: "marginBottom removeBrs"
  }, [_c('mu-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.data.transcript))
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    nativeOn: {
      "click": function($event) {
        _vm.isTranscriptOpen = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.closeText')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "action_points"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.lessonActionPoints'),
      "subTitle": _vm.$t('message.lessonActionPointsSubTitle')
    }
  }), _vm._v(" "), _c('iframe-video-player', {
    attrs: {
      "src": _vm.data.videos.vimeo_ap.web
    }
  }), _vm._v(" "), _c('mu-card-text', {
    attrs: {
      "id": "actionList"
    }
  }, _vm._l((_vm.data.action_points), function(action, index) {
    return _c('div', {
      key: 'action-' + index,
      staticClass: "action"
    }, [_c('div', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(action.title)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(action.action))
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('lesson-rating-panel', {
    staticClass: "bottom",
    attrs: {
      "mode": "end",
      "course": _vm.data
    }
  }), _vm._v(" "), (_vm.data.quiz.length > 0) ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('lesson-quiz-panel', {
    attrs: {
      "quiz": _vm.data.quiz,
      "course_id": _vm.data.course_id,
      "quiz_id": _vm.data.quiz_id
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('lesson-downloads-panel', {
    staticClass: "bottom",
    attrs: {
      "downloads": _vm.data.downloads
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('lesson-questions-panel', {
    attrs: {
      "course-id": _vm.data.course_id
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-chip",
    class: _vm.classNames,
    style: (_vm.style),
    on: {
      "mouseenter": _vm.onMouseenter,
      "mouseup": _vm.onMouseup,
      "mousedown": _vm.onMousedown,
      "mouseleave": _vm.onMouseleave,
      "touchstart": _vm.onTouchstart,
      "click": _vm.handleClick,
      "touchend": _vm.onTouchend,
      "touchcancel": _vm.onTouchend
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.showDelete && !_vm.disabled) ? _c('svg', {
    staticClass: "mu-chip-delete-icon",
    class: _vm.deleteIconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelete.apply(null, arguments)
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipeSearchHeader"
  }, [_c('div', {
    staticClass: "content headerHeight"
  }, [_c('div', {
    staticClass: "alignBottomOfSearch"
  }, [_c('div', {
    staticClass: "recipeWelcome centerAlign"
  }, [(_vm.isBreakfast) ? _c('h1', [_vm._v("Good morning " + _vm._s(_vm.$store.state.user.scope.firstname) + "!")]) : _vm._e(), _vm._v(" "), (_vm.isLunch) ? _c('h1', [_vm._v("Good afternoon " + _vm._s(_vm.$store.state.user.scope.firstname) + "!")]) : _vm._e(), _vm._v(" "), (_vm.isDinner) ? _c('h1', [_vm._v("Good evening " + _vm._s(_vm.$store.state.user.scope.firstname) + "!")]) : _vm._e(), _vm._v(" "), (_vm.isNight) ? _c('h1', [_vm._v("Good night, " + _vm._s(_vm.$store.state.user.scope.firstname))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Lets get started with some healthy recipe ideas")]), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "38px"
    }
  }, [_c('mu-col', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-raised-button', {
    staticClass: "recipeHvrBtn mobileSpacing",
    attrs: {
      "label": "Advanced search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goSearch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "recipeHvrBtn",
    attrs: {
      "label": "My favourites"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goFavorites.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onBlur),
      expression: "onBlur"
    }],
    staticStyle: {
      "position": "relative"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitSearch.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.q),
      expression: "params.q"
    }],
    staticClass: "recipeSearch",
    attrs: {
      "autocomplete": "off",
      "id": "txtAutoSearch",
      "type": "text",
      "placeholder": "Search by; ingredient, title or category"
    },
    domProps: {
      "value": (_vm.params.q)
    },
    on: {
      "focus": _vm.onFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "q", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.isSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "width": "24px",
      "height": "24px",
      "position": "absolute",
      "right": "18px",
      "top": "27px"
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-up-down",
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAutoCompleteOpen && _vm.suggestions.length > 0),
      expression: "isAutoCompleteOpen && suggestions.length > 0"
    }],
    staticClass: "suggestion-wrapper",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "suggestions",
    staticStyle: {
      "position": "absolute"
    }
  }, _vm._l((_vm.suggestions), function(item, index) {
    return _c('div', {
      staticClass: "item",
      class: {
        'active': index === _vm.suggestionIndex
      },
      on: {
        "click": _vm.submitSearch,
        "mouseover": function($event) {
          return _vm.onItemMouseover(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "searchArea"
  }), _vm._v(" "), _c('div', {
    staticClass: "recipeGradient"
  })])
},staticRenderFns: []}

/***/ }),
/* 3749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-text-field",
    class: _vm.textFieldClass,
    style: (_vm.isFocused ? _vm.errorStyle : {})
  }, [(_vm.icon) ? _c('icon', {
    staticClass: "mu-text-field-icon",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "mu-text-field-content",
    on: {
      "click": _vm.handleLabelClick
    }
  }, [(_vm.label) ? _c('text-field-label', {
    attrs: {
      "float": _vm.float,
      "focus": _vm.isFocused,
      "normalClass": _vm.labelClass,
      "focusClass": _vm.labelFocusClass
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.hintText) ? _c('text-field-hint', {
    class: _vm.hintTextClass,
    attrs: {
      "text": _vm.hintText,
      "show": _vm.showHint
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", function() {
    return [(!_vm.multiLine) ? _c('input', {
      ref: "input",
      staticClass: "mu-text-field-input",
      class: _vm.inputClass,
      attrs: {
        "name": _vm.name,
        "type": _vm.type,
        "disabled": _vm.disabled,
        "max": _vm.max,
        "min": _vm.min,
        "required": _vm.required
      },
      domProps: {
        "value": _vm.inputValue
      },
      on: {
        "change": _vm.handleChange,
        "focus": _vm.handleFocus,
        "input": _vm.handleInput,
        "blur": _vm.handleBlur
      }
    }) : _vm._e(), _vm._v(" "), (_vm.multiLine) ? _c('enhanced-textarea', {
      ref: "textarea",
      attrs: {
        "name": _vm.name,
        "normalClass": _vm.inputClass,
        "value": _vm.inputValue,
        "disabled": _vm.disabled,
        "rows": _vm.rows,
        "rowsMax": _vm.rowsMax
      },
      on: {
        "change": _vm.handleChange,
        "input": _vm.handleInput,
        "focus": _vm.handleFocus,
        "blur": _vm.handleBlur
      }
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.underlineShow) ? _c('underline', {
    attrs: {
      "error": !!_vm.errorText,
      "disabled": _vm.disabled,
      "errorColor": _vm.errorColor,
      "focus": _vm.isFocused,
      "normalClass": _vm.underlineClass,
      "focusClass": _vm.underlineFocusClass
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errorText || _vm.helpText || _vm.maxLength > 0) ? _c('div', {
    staticClass: "mu-text-field-help",
    class: _vm.helpTextClass,
    style: (_vm.errorStyle)
  }, [_c('div', [_vm._v("\n            " + _vm._s(_vm.errorText || _vm.helpText) + "\n        ")]), _vm._v(" "), (_vm.maxLength > 0) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.charLength) + "/" + _vm._s(_vm.maxLength) + "\n        ")]) : _vm._e()]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "lessonQuiz"
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "lightbulb-icon quizBg",
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "244px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "width": "116px",
      "height": "100%",
      "src": "static/lesson/lightbulb.svg"
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', [(!_vm.isQuizComplete) ? _c('mu-card-text', _vm._l((_vm.quiz), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.questionNumberIndex === index),
        expression: "questionNumberIndex === index"
      }],
      key: 'quiz-' + index,
      staticClass: "question"
    }, [_c('div', {
      staticClass: "blueTitle largeTitle"
    }, [_vm._v(_vm._s(_vm.$t('message.quizTestKnowledge')))]), _vm._v(" "), _c('div', {
      staticClass: "bottom",
      domProps: {
        "textContent": _vm._s(_vm.$t('message.questionText') + ' ' + (index + 1) + ': ' + item.question)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "textContent": _vm._s((item.correct === 1) ? _vm.$t('message.selectText') + ' ' + item.correct + ' ' + _vm.$t('message.answerText') : 'Please select ' + item.correct + ' ' + _vm.$t('message.answersText'))
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "answers"
    }, _vm._l((item.answers), function(answer, answerIndex) {
      return _c('div', {
        key: 'quiz-answer-' + answerIndex,
        staticClass: "answer"
      }, [_c('mu-checkbox', {
        attrs: {
          "slot": "left",
          "label": answer.answer,
          "nativeValue": '' + answer.answer_id + '',
          "disabled": _vm.activeAnswerStore.length >= _vm.activeQuestion.correct && _vm.activeAnswerStore.indexOf('' + '' + answer.answer_id + '' + '') === -1
        },
        slot: "left",
        model: {
          value: (_vm.activeAnswerStore),
          callback: function($$v) {
            _vm.activeAnswerStore = $$v
          },
          expression: "activeAnswerStore"
        }
      })], 1)
    }), 0)])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isQuizComplete) ? _c('mu-card-text', [_c('div', {
    staticClass: "blueTitle largeTitle"
  }, [_vm._v(_vm._s(_vm.$t('message.quizComplete')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.percentage) + "%.")])]) : _vm._e()], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-divider'), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.isQuizComplete === false) ? _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "disabled": (_vm.questions !== _vm.questionNumberIndex) && _vm.activeAnswerStore.length !== _vm.activeQuestion.correct,
      "secondary": "",
      "label": _vm.markable.length === _vm.totalCorrectAnswers ? _vm.$t('message.finishText') : _vm.$t('message.nextText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextQuestion()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isQuizComplete === true) ? _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "secondary": "",
      "label": _vm.$t('message.labelTryAgain')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startAgain()
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.preference === 'mmoll') ? _c('mu-text-field', {
    attrs: {
      "label": _vm.$t('message.cardBloodGlucose'),
      "type": "number",
      "step": "any",
      "helpText": "mmol/L",
      "underlineShow": "",
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.blood_glucose_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.reading, "blood_glucose_mmoll", _vm._n($$v))
      },
      expression: "reading.blood_glucose_mmoll"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.preference === 'mgdl') ? _c('mu-text-field', {
    attrs: {
      "label": _vm.$t('message.cardBloodGlucose'),
      "type": "number",
      "step": "any",
      "helpText": "mg/dL",
      "underlineShow": "",
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.blood_glucose_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.reading, "blood_glucose_mgdl", _vm._n($$v))
      },
      expression: "reading.blood_glucose_mgdl"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.tags) ? _c('mu-select-field', {
    attrs: {
      "hintText": _vm.$t('message.selectText'),
      "multiple": "",
      "label": _vm.$t('message.labelTagYourReading'),
      "fullWidth": true,
      "maxHeight": 300,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.readingTags),
      callback: function($$v) {
        _vm.readingTags = $$v
      },
      expression: "readingTags"
    }
  }, _vm._l((_vm.listTags), function(tag, index) {
    return _c('mu-menu-item', {
      key: 'reading-tag-' + index,
      attrs: {
        "value": tag.tag_id,
        "title": _vm.$t(_vm.localizeTag(tag.tag))
      }
    })
  }), 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrivacyProgress || _vm.isAdmin),
      expression: "showPrivacyProgress || isAdmin"
    }]
  }, [_c('div', {
    staticClass: "graphWrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.labelBloodGlucoseProgress')))]), _vm._v(" "), _c('bg-line-graph', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "userId": _vm.$store.state.activeProfile
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "graphWrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.labelWeightProgress')))]), _vm._v(" "), _c('weight-line-graph', {
    attrs: {
      "userId": _vm.$store.state.activeProfile
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPrivacyProgress && !_vm.isAdmin),
      expression: "!showPrivacyProgress && !isAdmin"
    }]
  }, [_vm._v(_vm._s(_vm.$t('message.labelGraphsPrivate')))])])
},staticRenderFns: []}

/***/ }),
/* 3753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.welcome_accept) ? _c('mu-dialog', {
    attrs: {
      "width": "760",
      "open": _vm.dialog,
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "id": "hcpGettingStartedModal"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/hcp/hcp_showcase.png"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Welcome to the Healthcare Professional Platform")]), _vm._v(" "), _c('p', [_vm._v("Created for clinicians by clinicians to assist you in achieving safe, effective and efficient care for your patients.")]), _vm._v(" "), _c('p', [_vm._v("The Low Carb Program provides education and support for people with conditions that can benefit from lifestyle interventions. Condition specific programs are currently available for people with type 2 diabetes, prediabetes or obesity. (Further evidence-based programs are in development)")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btn",
    attrs: {
      "primary": "",
      "label": "Get Started",
      "fullWidth": ""
    },
    on: {
      "click": function($event) {
        return _vm.acceptWelcome()
      }
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), (_vm.preference == 'mmoll') ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'required|min_value:0|max_value:18.1',
      "data-vv-name": "total_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "total",
      "errorText": _vm.errors.first('total_mmoll'),
      "label": _vm.$t('message.labelCholesterolTotal'),
      "helpText": "mmol/L",
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.total_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.reading, "total_mmoll", _vm._n($$v))
      },
      expression: "reading.total_mmoll"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'min_value:0|max_value: 18.1',
      "data-vv-name": "hdl_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('hdl_mmoll'),
      "label": _vm.$t('message.labelCholesterolHDL'),
      "helpText": "mmol/L",
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.hdl_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.reading, "hdl_mmoll", _vm._n($$v))
      },
      expression: "reading.hdl_mmoll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preference == 'mgdl') ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter mg/dL",
      "data-vv-rules": 'required|min_value:0|max_value:700',
      "data-vv-name": "total_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "total",
      "errorText": _vm.errors.first('total_mgdl'),
      "label": _vm.$t('message.labelCholesterolTotal'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.reading.total_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.reading, "total_mgdl", _vm._n($$v))
      },
      expression: "reading.total_mgdl"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter mg/dL",
      "data-vv-rules": 'min_value:0|max_value:700',
      "data-vv-name": "hdl_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('hdl_mgdl'),
      "label": _vm.$t('message.labelCholesterolHDL'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.reading.hdl_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.reading, "hdl_mgdl", _vm._n($$v))
      },
      expression: "reading.hdl_mgdl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preference == 'mmoll') ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'min_value:0|max_value:18.1',
      "data-vv-name": "triglycerides_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "triglycerides",
      "errorText": _vm.errors.first('triglycerides_mmoll'),
      "label": _vm.$t('message.labelCholesterolTriglycerides'),
      "fullWidth": true,
      "helpText": "mmol/L"
    },
    model: {
      value: (_vm.reading.triglycerides_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.reading, "triglycerides_mmoll", _vm._n($$v))
      },
      expression: "reading.triglycerides_mmoll"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter mmol/L",
      "data-vv-rules": 'min_value:0|max_value: 18.1',
      "data-vv-name": "ldl_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('ldl_mmoll'),
      "label": _vm.$t('message.labelCholesterolLDL'),
      "fullWidth": true,
      "helpText": "mmol/L"
    },
    model: {
      value: (_vm.reading.ldl_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.reading, "ldl_mmoll", _vm._n($$v))
      },
      expression: "reading.ldl_mmoll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preference == 'mgdl') ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter md/dL",
      "data-vv-rules": 'min_value:0|max_value:700',
      "data-vv-name": "triglycerides_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "triglycerides",
      "errorText": _vm.errors.first('triglycerides_mgdl'),
      "label": _vm.$t('message.labelCholesterolTriglycerides'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.reading.triglycerides_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.reading, "triglycerides_mgdl", _vm._n($$v))
      },
      expression: "reading.triglycerides_mgdl"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "Enter md/dL",
      "data-vv-rules": 'min_value:0|max_value:700',
      "data-vv-name": "ldl_mgdl",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hdl",
      "errorText": _vm.errors.first('ldl_mgdl'),
      "label": _vm.$t('message.labelCholesterolLDL'),
      "fullWidth": true,
      "helpText": "mg/dL"
    },
    model: {
      value: (_vm.reading.ldl_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.reading, "ldl_mgdl", _vm._n($$v))
      },
      expression: "reading.ldl_mgdl"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "medication-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "21 193 15 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M1.00081633,9.15102041 C-0.331428571,10.4832653 -0.331428571,12.6546939 1.00081633,13.9869388 C2.33306122,15.3191837 4.5044898,15.3191837 5.83673469,13.9869388 L9.9477551,9.87591837 L5.11183673,5.03673469 L1.00081633,9.15102041 L1.00081633,9.15102041 Z",
      "id": "path-1"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "mask-2",
      "maskContentUnits": "userSpaceOnUse",
      "maskUnits": "objectBoundingBox",
      "x": "0",
      "y": "0",
      "width": "9.94612245",
      "height": "9.94938776",
      "fill": "white"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-5",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(21.000000, 193.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.15020408,1.00163265 L4.56897959,5.56979592 L9.40489796,10.4057143 L13.9828571,5.83428571 C15.3183673,4.50204082 15.3183673,2.33387755 13.9828571,1.00163265 C12.6506122,-0.333877551 10.482449,-0.333877551 9.15020408,1.00163265 Z",
      "id": "Shape",
      "fill": "#AD3463"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "id": "Shape",
      "stroke": "#AD3463",
      "mask": "url(#mask-2)",
      "stroke-width": "2",
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Configure medications'),
      expression: "'Configure medications'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": "settings_cog"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToSettings()
      }
    }
  }), _vm._v(" "), (_vm.hasMedications && !_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasMedications && _vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [(_vm.hasMedications) ? _c('mu-card-text', [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-name": "medication",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('medication'),
      "data-vv-validate-on": "none",
      "scroller": _vm.scroller,
      "label": _vm.$t('message.cardMedicationSelect'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.tracking_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "tracking_id", $$v)
      },
      expression: "model.tracking_id"
    }
  }, _vm._l((_vm.medications), function(item, index) {
    return _c('mu-menu-item', {
      key: 'treatment-' + index,
      attrs: {
        "title": item.treatment_name,
        "value": item.tracking_id
      }
    })
  }), 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:1000'),
      expression: "'required|min_value:1|max_value:1000'"
    }],
    staticClass: "bottom",
    attrs: {
      "min": "1",
      "max": "1000",
      "data-vv-name": "dosage",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('dosage'),
      "data-vv-validate-on": "none",
      "label": _vm.$t('message.cardMedicationDose'),
      "type": "number",
      "hintText": _vm.$t('message.cardMedicationDosage'),
      "helpText": _vm.localizeRegime(_vm.activeLabel),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.dosage),
      callback: function($$v) {
        _vm.$set(_vm.model, "dosage", _vm._n($$v))
      },
      expression: "model.dosage"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight",
    attrs: {
      "id": "login"
    }
  }, [_c('mu-flexbox', {
    staticClass: "fullHeight",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "33",
      "tablet": "50"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.forgotPasswordTitle'),
      "subTitle": _vm.$t('message.forgotPasswordSubTitle'),
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('form', {
    attrs: {
      "name": "login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "name": "email",
      "data-vv-name": "email",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('email'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSending,
      "type": "button",
      "label": _vm.$t('message.resetText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-row', {
    staticClass: "noAccount"
  }, [_c('mu-col', [_vm._v("\n                    " + _vm._s(_vm.$t('message.loginNoAccountYet')) + "\n                  ")]), _vm._v(" "), _c('mu-col', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loginSignUp')))])], 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "noAccount last"
  }, [_c('mu-col', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.forgotPasswordSignIn')))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "25"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-text-field-hint",
    class: {
      'show': _vm.show
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 3758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [(_vm.$store.state.user.settings.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": "%",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": "%"
    },
    model: {
      value: (_vm.reading.percent),
      callback: function($$v) {
        _vm.$set(_vm.reading, "percent", _vm._n($$v))
      },
      expression: "reading.percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": "mmol/mmol",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": "mmol/mol"
    },
    model: {
      value: (_vm.reading.mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.reading, "mmol_mol", _vm._n($$v))
      },
      expression: "reading.mmol_mol"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcp-categories"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticClass: "contentLoader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "content",
    attrs: {
      "id": "categories"
    }
  }, _vm._l((_vm.chunkedItems), function(chunks, index) {
    return (!_vm.isLoading) ? _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      attrs: {
        "gutter": 16
      }
    }, _vm._l((chunks), function(cat, index) {
      return _c('mu-flexbox-item', {
        key: 'cat-' + index,
        staticClass: "cat",
        style: ('background-image: url(' + cat.image + ');')
      }, [_c('mu-flexbox', {
        staticClass: "cat",
        attrs: {
          "justify": "flex-start",
          "align": "center"
        }
      }, [_c('mu-card', {
        nativeOn: {
          "click": function($event) {
            return _vm.goTo(cat.slug)
          }
        }
      }, [_c('mu-card-text', [_c('div', {
        staticClass: "cat-desc"
      }, [_c('h3', {
        staticClass: "largeTitle"
      }, [_vm._o(_c('span', [_vm._v(_vm._s(cat.name))]), 0, 'cat-' + index)]), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "extract"
      }, [_c('div', [_vm._v(_vm._s(cat.description))])]), _vm._v(" "), _c('span', {
        staticClass: "view-all"
      }, [_vm._v("View All")])])])])], 1)], 1)], 1)
    }), 1) : _vm._e()
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mu-ripple"
    }
  }, [_c('div', {
    staticClass: "mu-circle-ripple",
    style: (_vm.styles)
  })])
},staticRenderFns: []}

/***/ }),
/* 3761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "hba1c-input"
    }
  }, [_c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 24 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Icons/Light/Cards/ic_hba1c")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "x1": "0%",
      "y1": "100%",
      "x2": "98.4753667%",
      "y2": "1.52463329%",
      "id": "linearGradient-1"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF7950",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#F42C2A",
      "offset": "100%"
    }
  })], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icons/Light/Cards/ic_hba1c"
    }
  }, [_c('g', {
    attrs: {
      "id": "ic_bloodglucose"
    }
  }, [_c('rect', {
    attrs: {
      "id": "bounds",
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.7141425,15.4206675 C16.7141425,14.3305871 16.3089743,12.0255408 14.6252466,9.85941762 C13.1714601,7.98914179 10.8003551,3 10.8003551,3 C10.8003551,3 8.54268237,7.98914179 7.08889592,9.85938459 C5.40516818,12.0255078 5,14.330554 5,15.4206675 C5,18.2970952 7.58662631,20.6348409 10.8003551,20.6887454 L10.8003551,20.6900005 C10.8192976,20.6900005 10.8381659,20.6895051 10.8570712,20.689373 C10.8760137,20.6895381 10.894882,20.6900005 10.9138244,20.6900005 L10.9138244,20.6887454 C14.1275162,20.6348409 16.7141425,18.2970952 16.7141425,15.4206675 L16.7141425,15.4206675 Z",
      "id": "Shape",
      "fill": "url(#linearGradient-1)"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.3372489,11.445418 L10.3372489,11.445418 L10.3372489,11.445418 C10.0734114,11.7092555 10.0728335,12.1368422 10.3359569,12.4013919 L13.3932177,15.4752261 L13.3932177,15.4752261 C13.7826849,15.8668046 14.4158475,15.8685161 14.8074261,15.4790489 C14.808048,15.4784303 14.8086692,15.4778109 14.8092895,15.4771906 L16.136795,14.1498748 L18.6001799,16.6132598 L18.6001799,16.6132598 C18.8637287,16.8768085 19.2910256,16.8768085 19.5545743,16.6132598 L19.5545743,16.6132598 L19.5545743,16.6132598 C19.815976,16.351858 19.815976,15.9280421 19.5545743,15.6666403 C19.5532838,15.6653498 19.551988,15.6640646 19.550687,15.6627847 L16.8119508,12.96849 L16.8119508,12.96849 C16.4204799,12.5833715 15.7916925,12.5859891 15.4034415,12.9743535 L14.1121987,14.2659734 L11.2919132,11.4454391 L11.2919132,11.4454391 C11.0283074,11.18181 10.6008991,11.1817911 10.33727,11.4453969 C10.337263,11.445404 10.3372559,11.445411 10.3372489,11.445418 Z",
      "id": "Page-1",
      "fill": "#B8E986",
      "transform": "translate(14.944809, 14.029313) rotate(3.000000) translate(-14.944809, -14.029313) "
    }
  })])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": _vm.isOpenInput ? 'remove_circle_outline' : 'add_circle'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": _vm.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.hba1c.unit,
      "fullWidth": true,
      "helpText": _vm.hba1c.unit
    },
    model: {
      value: (_vm.model.percent),
      callback: function($$v) {
        _vm.$set(_vm.model, "percent", _vm._n($$v))
      },
      expression: "model.percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.hba1c.unit,
      "fullWidth": true,
      "helpText": _vm.hba1c.unit
    },
    model: {
      value: (_vm.model.mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.model, "mmol_mol", _vm._n($$v))
      },
      expression: "model.mmol_mol"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": "Discard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input"
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 24 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "x1": "0%",
      "y1": "100%",
      "x2": "98.4753667%",
      "y2": "1.52463329%",
      "id": "linearGradient-1"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF7950",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#F42C2A",
      "offset": "100%"
    }
  })], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icons/Light/Cards/ic_hba1c"
    }
  }, [_c('g', {
    attrs: {
      "id": "ic_bloodglucose"
    }
  }, [_c('rect', {
    attrs: {
      "id": "bounds",
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.7141425,15.4206675 C16.7141425,14.3305871 16.3089743,12.0255408 14.6252466,9.85941762 C13.1714601,7.98914179 10.8003551,3 10.8003551,3 C10.8003551,3 8.54268237,7.98914179 7.08889592,9.85938459 C5.40516818,12.0255078 5,14.330554 5,15.4206675 C5,18.2970952 7.58662631,20.6348409 10.8003551,20.6887454 L10.8003551,20.6900005 C10.8192976,20.6900005 10.8381659,20.6895051 10.8570712,20.689373 C10.8760137,20.6895381 10.894882,20.6900005 10.9138244,20.6900005 L10.9138244,20.6887454 C14.1275162,20.6348409 16.7141425,18.2970952 16.7141425,15.4206675 L16.7141425,15.4206675 Z",
      "id": "Shape",
      "fill": "url(#linearGradient-1)"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.3372489,11.445418 L10.3372489,11.445418 L10.3372489,11.445418 C10.0734114,11.7092555 10.0728335,12.1368422 10.3359569,12.4013919 L13.3932177,15.4752261 L13.3932177,15.4752261 C13.7826849,15.8668046 14.4158475,15.8685161 14.8074261,15.4790489 C14.808048,15.4784303 14.8086692,15.4778109 14.8092895,15.4771906 L16.136795,14.1498748 L18.6001799,16.6132598 L18.6001799,16.6132598 C18.8637287,16.8768085 19.2910256,16.8768085 19.5545743,16.6132598 L19.5545743,16.6132598 L19.5545743,16.6132598 C19.815976,16.351858 19.815976,15.9280421 19.5545743,15.6666403 C19.5532838,15.6653498 19.551988,15.6640646 19.550687,15.6627847 L16.8119508,12.96849 L16.8119508,12.96849 C16.4204799,12.5833715 15.7916925,12.5859891 15.4034415,12.9743535 L14.1121987,14.2659734 L11.2919132,11.4454391 L11.2919132,11.4454391 C11.0283074,11.18181 10.6008991,11.1817911 10.33727,11.4453969 C10.337263,11.445404 10.3372559,11.445411 10.3372489,11.445418 Z",
      "id": "Page-1",
      "fill": "#B8E986",
      "transform": "translate(14.944809, 14.029313) rotate(3.000000) translate(-14.944809, -14.029313) "
    }
  })])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    staticStyle: {
      "color": "#FB5940"
    },
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": _vm.isOpenInput ? 'remove_circle_outline' : 'add_circle'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "novalidate": ""
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.$store.state.user.settings.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.percent),
      callback: function($$v) {
        _vm.$set(_vm.model, "percent", _vm._n($$v))
      },
      expression: "model.percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.model, "mmol_mol", _vm._n($$v))
      },
      expression: "model.mmol_mol"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('mu-card', {
    attrs: {
      "id": "similarPosts"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "readNext",
      "title": _vm.$t('message.lifeCategoryListsHeaderText')
    }
  }), _vm._v(" "), _c('mu-card-text', _vm._l((_vm.posts), function(post, index) {
    return _c('div', {
      key: ("sidepost-" + index),
      staticClass: "sidePost"
    }, [_c('life-post-info', {
      attrs: {
        "slug": post.post_slug,
        "image": post.post_image,
        "title": post.post_title,
        "time": post.post_date,
        "favourites": post.post_favourites
      }
    })], 1)
  }), 0)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-text-field-label",
    class: _vm.labelClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "patientDownloads"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "weekTags"
    }
  }, [_c('span', {
    staticClass: "tag",
    class: {
      'active': _vm.selectedFilter === 'resources'
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelResources'))
    },
    on: {
      "click": function($event) {
        return _vm.updateFilter('resources')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag",
    class: {
      'active': _vm.selectedFilter === 'mealplans'
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelMealPlans'))
    },
    on: {
      "click": function($event) {
        return _vm.updateFilter('mealplans')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag",
    class: {
      'active': _vm.selectedFilter === 'seasonal'
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelSeasonalDownloads'))
    },
    on: {
      "click": function($event) {
        return _vm.updateFilter('seasonal')
      }
    }
  }), _vm._v(" "), _vm._l((_vm.lessons), function(item, index) {
    return _c('span', {
      key: 'week-list-' + index,
      staticClass: "tag",
      class: {
        'disabled': item.status.locked,
        'active': _vm.selectedFilter === item.course_id
      },
      domProps: {
        "textContent": _vm._s(item.week_name.replace('Week', _vm.$t('message.labelWeek')))
      },
      on: {
        "click": function($event) {
          return _vm.updateFilter(item.course_id, item.status.locked)
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-row', {
    attrs: {
      "id": "weekLists"
    }
  }, [_c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "hintText": "Resources"
    },
    on: {
      "change": _vm.updateFilter
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelResources'),
      "value": "resources"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelMealPlans'),
      "value": "mealplans"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelSeasonalDownloads'),
      "value": "seasonal"
    }
  }), _vm._v(" "), _vm._l((_vm.lessons), function(item, index) {
    return _c('mu-menu-item', {
      key: 'week-list-' + index,
      attrs: {
        "value": item.course_id,
        "title": _vm.$t('message.labelDownloadsFrom') + ' ' + item.week_name.replace('Week', _vm.$t('message.labelWeek')),
        "disabled": item.status.locked
      }
    })
  })], 2)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "downloadTabs"
    }
  }, [_c('mu-row', _vm._l((_vm.tabs), function(tab, tabIndex) {
    return _c('mu-col', {
      key: 'download-tab-' + tabIndex,
      attrs: {
        "tablet": "50",
        "desktop": "50",
        "width": "50"
      }
    }, [_c('a', {
      staticClass: "tab",
      class: {
        'active': _vm.activeTab === tab.key
      },
      domProps: {
        "textContent": _vm._s(tab.label)
      },
      on: {
        "click": function($event) {
          return _vm.setTab(tab.key)
        }
      }
    })])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading || _vm.showFilterLoader) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading || !_vm.showFilterLoader) ? _c('div', {
    staticClass: "container"
  }, [(_vm.activeTab === 'grid') ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.items), function(res, index) {
    return _c('mu-col', {
      key: 'download-item-' + index,
      staticClass: "download-item",
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "33"
      }
    }, [_c('mu-card', {
      staticClass: "grid-item card-background-cover bottom",
      attrs: {
        "align": "center"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(res)
        }
      }
    }, [_vm._o(_c('img', {
      attrs: {
        "src": res.image_url,
        "width": "100%"
      }
    }), 0, 'download-item-' + index), _vm._v(" "), _vm._o(_c('mu-card-header', {
      attrs: {
        "title": res.title,
        "subTitle": res.description
      }
    }), 1, 'download-item-' + index), _vm._v(" "), _c('mu-card-actions', {
      staticClass: "actions"
    }, [_c('mu-flat-button', {
      attrs: {
        "primary": "",
        "icon": "file_download",
        "disabled": !_vm.$store.state.status.payment.paid,
        "label": res.button_text
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'list') ? _c('mu-card', {
    staticClass: "listViewSpacer"
  }, [_c('mu-list', _vm._l((_vm.items), function(res, index) {
    return _c('div', {
      key: 'download-item-' + index,
      staticClass: "download-item"
    }, [_c('mu-list-item', {
      attrs: {
        "disableRipple": "",
        "title": res.title,
        "describeText": res.description
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(res)
        }
      }
    }, [_c('mu-flat-button', {
      attrs: {
        "slot": "right",
        "primary": "",
        "icon": "file_download",
        "disabled": !_vm.$store.state.status.payment.paid,
        "label": res.button_text
      },
      slot: "right"
    })], 1), _vm._v(" "), (_vm.items.length !== index + 1) ? _c('mu-divider') : _vm._e()], 1)
  }), 0)], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.mode === 'image') ? _c('mu-avatar', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.badge.label),
      expression: "badge.label",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "imageBadge",
    attrs: {
      "size": 34,
      "src": _vm.badge.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode === 'text') ? _c('mu-badge', {
    staticClass: "userBadge",
    class: _vm.badge.key,
    attrs: {
      "content": _vm.badge.label
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    staticClass: "bottom"
  }, [(_vm.content && _vm.isDefaultView === true) ? _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "personalizedPanel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showVideo()
      }
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "image",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      backgroundImage: ("url('" + (_vm.content.thumbImage) + "')"),
      height: _vm.imageHeight + 'px'
    }),
    attrs: {
      "width": "30",
      "desktop": "15",
      "tablet": "30"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "calcHeight",
    attrs: {
      "width": "70",
      "desktop": "85",
      "tablet": "70"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "wrap": "allow",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Personalised for you")]), _vm._v(" "), _c('div', {
    staticClass: "summaryTitle"
  }, [_vm._v(_vm._s(_vm.content.summaryTitle))]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v(_vm._s(_vm.content.subTitle))])])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.content && _vm.isVideoVisible === true) ? _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "continueWatchingPanel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showVideo()
      }
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "image",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      backgroundImage: ("url('" + (_vm.course.image_url) + "')"),
      height: _vm.imageHeight + 'px'
    }),
    attrs: {
      "width": "30",
      "desktop": "15",
      "tablet": "30"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "calcHeight",
    attrs: {
      "width": "70",
      "desktop": "85",
      "tablet": "70"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "wrap": "allow",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Continue learning")]), _vm._v(" "), _c('div', {
    staticClass: "summaryTitle"
  }, [_vm._v("Click here once you have finished watching this video")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("Continue to this weeks's module")])])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isVideoVisible && (_vm.content.intl_language_video !== '' && _vm.content.intl_language_video !== null)) ? _c('div', [(_vm.activeTab === 'local') ? _c('iframe-video-player', {
    attrs: {
      "src": _vm.content.local_language_video
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'intl') ? _c('iframe-video-player', {
    attrs: {
      "src": _vm.content.intl_language_video
    }
  }) : _vm._e()], 1) : _c('div', [(_vm.isVideoVisible && _vm.content) ? _c('iframe-video-player', {
    attrs: {
      "src": _vm.content.local_language_video
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.content.language_id !== null && _vm.content.intl_language_video !== '' && _vm.isVideoVisible) ? _c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "intl",
      "title": _vm.content.language
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "local",
      "title": _vm.content.local_language
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-search-dialog"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('mu-paper', {
    staticClass: "search-area"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "grow": "7",
      "shrink": "7"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "icon": "search",
      "hintText": _vm.$t('message.searchText'),
      "underlineShow": false,
      "hintTextClass": "hidden",
      "fullWidth": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), (_vm.voiceSupported) ? _c('mu-flexbox-item', {
    attrs: {
      "shrink": "1",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "keyboard_voice"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startVoiceRecognition.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isSearching) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isListening) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('div', {
    staticClass: "load-wrapp"
  }, [_c('div', {
    staticClass: "load-3 bottom"
  }, [_c('div', {
    staticClass: "line loaderRed"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderGreen"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderBlue"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.labelVoiceRecognition')) + "\n          ")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Stop"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.stopVoiceRecognition()
      }
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), (!_vm.isListening) ? _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('mu-list-item', {
      key: 'suggestion-' + index,
      attrs: {
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelection(suggestion)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "slot": "left",
        "value": "search"
      },
      slot: "left"
    }), _vm._v(" "), _vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.highlight(suggestion)))
      },
      slot: "title"
    }), 0, 'suggestion-' + index)], 1)
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": _vm.activeStep
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && _vm.$store.state.list.diabetes_types),
      expression: "!isLoading && $store.state.list.diabetes_types"
    }]
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "70"
    }
  }, [(_vm.isDiabetic) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "diagnosisYearTxt",
      "data-vv-rules": 'required',
      "data-vv-name": "diagnosis_year",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDiagnosisYear'),
      "errorText": _vm.errors.first('diagnosis_year'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesDiagnosisYear')
    },
    model: {
      value: (_vm.model.diagnosis_year),
      callback: function($$v) {
        _vm.$set(_vm.model, "diagnosis_year", $$v)
      },
      expression: "model.diagnosis_year"
    }
  }, _vm._l((_vm.yearList()), function(item, index) {
    return (_vm.moment(_vm.model.dob).format('Y') <= item) ? _c('mu-menu-item', {
      key: 'diagnosis-year-' + index,
      attrs: {
        "value": item,
        "title": item
      }
    }) : _vm._e()
  }), 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h2', {
    staticStyle: {
      "padding-top": "0",
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.gettingStartedHealthCheckRelevantBoxes')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c('mu-checkbox', {
    attrs: {
      "id": "healthConditionChk",
      "label": _vm.isDiabetic ? _vm.$t('message.gettingStartedHealthDoYouHaveAnyOtherConditions') : _vm.$t('message.gettingStartedHealthDoYouHaveAnyConditions')
    },
    model: {
      value: (_vm.model.has_other_conditions),
      callback: function($$v) {
        _vm.$set(_vm.model, "has_other_conditions", $$v)
      },
      expression: "model.has_other_conditions"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.has_other_conditions),
      expression: "model.has_other_conditions"
    }]
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "conditions"
    }
  }, [_c('mu-auto-complete', {
    attrs: {
      "id": "conditionSearchingTxt",
      "scroller": _vm.scroller,
      "inputClass": "conSearchInput",
      "openOnFocus": !_vm.conditionSearching,
      "fullWidth": true,
      "hintText": _vm.conditionHelpText,
      "maxSearchResults": 10,
      "dataSource": _vm.conditionDataSource,
      "dataSourceConfig": _vm.conditionDataSourceConfig,
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleConditionSelected
    },
    model: {
      value: (_vm.conditionSearchValue),
      callback: function($$v) {
        _vm.conditionSearchValue = $$v
      },
      expression: "conditionSearchValue"
    }
  }), _vm._v(" "), (_vm.conditionSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "size": 16
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _vm._l((_vm.model.user_conditions), function(item, index) {
    return _c('mu-chip', {
      key: 'condition-' + index
    }, [_c('mu-icon', {
      attrs: {
        "value": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleConditionRemoval(item)
        }
      }
    }), _vm._v("\n            " + _vm._s(item.condition_label) + "\n          ")], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 2), _vm._v(" "), _c('div', [_c('mu-checkbox', {
    attrs: {
      "id": "takesMedicationChk",
      "label": _vm.$t('message.accountPreferencesTakeMedication')
    },
    model: {
      value: (_vm.model.takes_medication),
      callback: function($$v) {
        _vm.$set(_vm.model, "takes_medication", $$v)
      },
      expression: "model.takes_medication"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.takes_medication),
      expression: "model.takes_medication"
    }]
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    ref: "medications",
    staticClass: "mediSearch",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "medications"
    }
  }, [_c('mu-auto-complete', {
    attrs: {
      "id": "medicationSearchTxt",
      "scroller": _vm.scroller,
      "inputClass": "mediSearchInput",
      "openOnFocus": !_vm.medicationSearching,
      "dataSource": _vm.medicationDataSource,
      "dataSourceConfig": _vm.medicationDataSourceConfig,
      "fullWidth": true,
      "maxSearchResults": 10,
      "hintText": _vm.$t('message.gettingStartedHealthTypeMedication'),
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleMedicationSelected
    },
    model: {
      value: (_vm.medicationSearchValue),
      callback: function($$v) {
        _vm.medicationSearchValue = $$v
      },
      expression: "medicationSearchValue"
    }
  }), _vm._v(" "), (_vm.medicationSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "size": 16
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.model.user_medications.length > 0) ? _c('mu-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.takes_medication),
      expression: "model.takes_medication"
    }],
    staticStyle: {
      "padding-bottom": "0",
      "padding-left": "0",
      "padding-right": "0"
    },
    attrs: {
      "id": "medication-list"
    }
  }, [_vm._l((_vm.model.user_medications), function(treatment, index) {
    return _c('mu-list-item', {
      key: 'treatment-' + index,
      staticStyle: {
        "padding-bottom": "0",
        "padding-left": "0",
        "padding-right": "0"
      },
      attrs: {
        "disableRipple": "",
        "title": treatment.treatment_name
      }
    }, [_c('mu-row', {
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "slot": "default",
        "gutter": ""
      },
      slot: "default"
    }, [_c('mu-col', {
      attrs: {
        "width": "50",
        "desktop": "70",
        "tablet": "50"
      }
    }, [_c('mu-select-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "id": "treatmentSelectTxt",
        "hintText": _vm.$t('message.selectText'),
        "data-vv-name": treatment.treatment_name + '_unit_' + index,
        "data-vv-rules": "required",
        "data-vv-value-as": "inputValue",
        "data-vv-validate-on": "none",
        "errorText": _vm.errors.first(treatment.treatment_name + '_unit_' + index),
        "maxHeight": 250,
        "fullWidth": "",
        "label": _vm.$t('message.labelUnits'),
        "autoWidth": ""
      },
      on: {
        "change": _vm.reformatMedications
      },
      model: {
        value: (treatment.unit_id),
        callback: function($$v) {
          _vm.$set(treatment, "unit_id", $$v)
        },
        expression: "treatment.unit_id"
      }
    }, _vm._l((_vm.medicationUnitRegimes), function(item, index) {
      return _c('mu-menu-item', {
        key: 'unit-regime-' + index,
        attrs: {
          "title": _vm.localizeRegime(item.unit_label),
          "value": item.unit_id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "50",
        "desktop": "30",
        "tablet": "50"
      }
    }, [_c('mu-select-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "id": "treatmentFrequencyTxt",
        "hintText": _vm.$t('message.selectText'),
        "data-vv-name": treatment.treatment_name + '_freq_' + index,
        "data-vv-rules": "required",
        "data-vv-value-as": "inputValue",
        "data-vv-validate-on": "none",
        "errorText": _vm.errors.first(treatment.treatment_name + '_freq_' + index),
        "maxHeight": 250,
        "fullWidth": "",
        "label": _vm.$t('message.labelHowOften'),
        "autoWidth": ""
      },
      on: {
        "change": _vm.reformatMedications
      },
      model: {
        value: (treatment.frequency_id),
        callback: function($$v) {
          _vm.$set(treatment, "frequency_id", $$v)
        },
        expression: "treatment.frequency_id"
      }
    }, _vm._l((_vm.medicationFrequencyRegimes), function(item, index) {
      return _c('mu-menu-item', {
        key: 'regime-frequency-' + index,
        attrs: {
          "title": _vm.$t(_vm.localizeFrequency(item.frequency_label)),
          "value": item.frequency_id
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleMedicationDeleted(treatment)
        }
      },
      slot: "right"
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder",
    staticStyle: {
      "margin-top": "8px"
    }
  })], 2) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isDiabetic) ? _c('div', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('mu-checkbox', {
    attrs: {
      "id": "testBloodChk",
      "label": _vm.$t('message.accountPreferencesTestBlood')
    },
    model: {
      value: (_vm.model.tests_blood),
      callback: function($$v) {
        _vm.$set(_vm.model, "tests_blood", $$v)
      },
      expression: "model.tests_blood"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('mu-checkbox', {
    attrs: {
      "id": "smokesCigarettesChk",
      "label": _vm.$t('message.accountSmokesCigarettes')
    },
    model: {
      value: (_vm.model.smokes_cigarettes),
      callback: function($$v) {
        _vm.$set(_vm.model, "smokes_cigarettes", $$v)
      },
      expression: "model.smokes_cigarettes"
    }
  }), _vm._v(" "), (_vm.model.smokes_cigarettes) ? _c('div', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "label": _vm.$t('message.accountCigarettesPerDay'),
      "type": "number",
      "data-vv-rules": 'required',
      "data-vv-name": "cigarettes_per_day",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountCigarettesPerDay'),
      "errorText": _vm.errors.first('cigarettes_per_day'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.placeholderText')
    },
    model: {
      value: (_vm.model.cigarettes_per_day),
      callback: function($$v) {
        _vm.$set(_vm.model, "cigarettes_per_day", $$v)
      },
      expression: "model.cigarettes_per_day"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "fullWidth": true,
      "secondary": "",
      "backgroundColor": "#9ACA3F",
      "color": "white",
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText'),
      "disabled": _vm.isSaving
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcpDownloads"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('p', [_vm._v("Browse and download resources to support your patients")]), _vm._v(" "), _vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      attrs: {
        "gutter": 16
      }
    }, _vm._l((chunks), function(cat, index) {
      return _c('mu-flexbox-item', {
        key: 'cat-' + index,
        staticClass: "cat",
        style: ('background-image: url(' + cat.image + ');')
      }, [_c('mu-flexbox', {
        staticClass: "item",
        attrs: {
          "justify": "flex-start",
          "align": "center"
        }
      }, [_c('mu-card', {
        nativeOn: {
          "click": function($event) {
            return _vm.goTo(cat.slug)
          }
        }
      }, [_c('mu-card-text', [_c('div', {
        staticClass: "cat-desc"
      }, [_c('h3', {
        staticClass: "largeTitle"
      }, [_vm._o(_c('span', [_vm._v(_vm._s(cat.name))]), 0, 'cat-' + index)]), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "extract"
      }, [_c('div', [_vm._v(_vm._s(cat.desc))])]), _vm._v(" "), _c('span', {
        staticClass: "view-all"
      }, [_vm._v("View All")])])])])], 1)], 1)], 1)
    }), 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-list"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('form', {
    attrs: {
      "id": "hcpSearchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [_c('mu-paper', {
    staticClass: "searchBar"
  }, [_c('mu-icon', {
    attrs: {
      "value": "search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.searchText')
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "blood-glucose-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [(_vm.visualDate.dateStep !== 0) ? _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  }) : _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "red"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.graphEmpty')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.graphEmptyExplain')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "dateStep": _vm.visualDate.dateStep,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(0)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(7)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(30)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(360)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "weight-line-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#1E89E1"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.graphEmpty')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.graphEmptyExplain')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "dateStep": _vm.visualDate.dateStep,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(0)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(7)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(30)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(360)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mousedown": _vm.handleMouseDown,
      "mouseup": function($event) {
        return _vm.end()
      },
      "mouseleave": function($event) {
        return _vm.end()
      },
      "touchstart": _vm.handleTouchStart,
      "touchend": function($event) {
        return _vm.end()
      },
      "touchcancel": function($event) {
        return _vm.end()
      }
    }
  }, [_c('div', {
    ref: "holder",
    staticClass: "mu-ripple-wrapper",
    class: _vm.rippleWrapperClass
  }, _vm._l((_vm.ripples), function(ripple) {
    return _c('circle-ripple', {
      key: ripple.key,
      attrs: {
        "color": ripple.color,
        "opacity": ripple.opacity,
        "merge-style": ripple.style
      }
    })
  }), 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ketones-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [(_vm.visualDate.dateStep !== 0) ? _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  }) : _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "white"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.graphEmpty')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.graphEmptyExplain')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(0)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(7)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(30)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(360)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "striiv-sleep-stages"
    }
  }, [(!_vm.striivData.error) ? _c('mu-card', [_c('mu-divider'), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Time asleep",
      "subTitleClass": "timeAsleep",
      "subTitle": _vm.normalizeDuration(_vm.sleepBreakdown.total)
    }
  })], 1)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Stages of sleep",
      "subTitle": _vm.date
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', [_c('mu-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Deep")])]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.deep)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.deep) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Light")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.light)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.light) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Awake")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.awake) + "x")])])], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "accreditation"
  }, [_c('img', {
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "src": "static/integrations/striiv.png"
    }
  }), _vm._v("\n          Data from Striiv\n        ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.striivData.error) ? _c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "No data",
      "subTitle": _vm.date
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkIn weight"
  }, [_c('mu-row', {
    staticClass: "content",
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticStyle: {
      "padding-right": "24px"
    },
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "bigTxt first"
  }, [_vm._v("HbA1c readings are a great way to mark your progress.")]), _vm._v(" "), _c('div', {
    staticClass: "bigTxt"
  }, [_vm._v("What was your last HbA1c result?")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', {
    staticStyle: {
      "width": "280px",
      "margin": "0 auto"
    }
  }, [_c('mu-card-text', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "lgTxt"
  }, [_vm._v("My HbA1c is...")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.$store.state.user.settings.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.percent),
      expression: "model.percent",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "min": "0",
      "type": "number",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit
    },
    domProps: {
      "value": (_vm.model.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "percent", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  Percent (%)\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.mmol_mol),
      expression: "model.mmol_mol",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "min": "0",
      "type": "number",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit
    },
    domProps: {
      "value": (_vm.model.mmol_mol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "mmol_mol", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  mmol/mol\n                ")])]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "disabled": _vm.isProcessing,
      "type": "button",
      "label": !_vm.isProcessing ? _vm.$t('message.nextText') : _vm.$t('message.savingText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgView"
  }, [_c('mu-paper', {
    staticClass: "insetGraph"
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "bloodGlucose"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.cardBloodGlucose')) + "\n      ")]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "hba1c"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('HbA1cProgress')
      }
    }
  }, [_vm._v("\n       " + _vm._s(_vm.$t('message.cardHbA1c')) + "\n      ")])], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('bg-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('blood-glucose-range', {
    staticStyle: {
      "margin-top": "24px"
    }
  }), _vm._v(" "), (_vm.$store.state.user.settings) ? _c('blood-glucose-input', {
    staticClass: "card-spacing bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c,
      "bloodGlucose": _vm.$store.state.user.settings.blood_glucose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings) ? _c('hba1c-input', {
    staticClass: "bottom",
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c
    }
  }) : _vm._e(), _vm._v(" "), _c('blood-glucose-targets', {
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c,
      "bloodGlucose": _vm.$store.state.user.settings.blood_glucose
    }
  }), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "blood-glucose"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), (_vm.readingTags.length > 0) ? _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.determineColor(item),
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [(item.userDevice && item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: (_vm.$t('message.cardFromDevice') + item.userDevice.nickname),
          expression: "$t('message.cardFromDevice') +   item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "6px"
        },
        attrs: {
          "width": "22",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.blood_glucose_mmoll + ' mmol/L' : item.blood_glucose_mgdl + ' mg/dL')
        }
      })]) : _vm._e()])], 1), _vm._v(" "), (item.tags.length > 0 && !item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, _vm._l((item.tags), function(tag, tagIndex) {
        return (tag.tag_id !== null) ? _c('span', {
          key: tagIndex
        }, [(tagIndex === 0 && item.tags.length === 1) ? _c('span', [(tagIndex <= 1) ? _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.$t(_vm.localizeTag(tag.tag)))
          }
        }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.tags.length > 1) ? _c('span', [(tagIndex <= 1) ? _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.$t(_vm.localizeTag(tag.tag)) + (tagIndex === 1 && !item.showAllTags ? '' : ', '))
          }
        }) : _vm._e(), _vm._v(" "), (tagIndex > 1 && item.showAllTags) ? _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.$t(_vm.localizeTag(tag.tag)) + (tagIndex === item.tags.length - 1 ? '' : ', '))
          }
        }) : _vm._e(), _vm._v(" "), (tagIndex == item.tags.length - 1 && item.tags.length > 2) ? _c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!item.showAllTags),
            expression: "!item.showAllTags"
          }],
          on: {
            "click": function($event) {
              return _vm.showAllTags(item)
            }
          }
        }, [_c('span', [_vm._v("+")]), _c('span', {
          domProps: {
            "textContent": _vm._s(item.tags.length - 2 + ' ' + String(_vm.$t('message.moreText')).toLowerCase())
          }
        })]) : _vm._e(), _vm._v(" "), (tagIndex == item.tags.length - 1 && item.tags.length > 2) ? _c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.showAllTags),
            expression: "item.showAllTags"
          }],
          on: {
            "click": function($event) {
              return _vm.showAllTags(item)
            }
          }
        }, [_c('span', {
          domProps: {
            "textContent": _vm._s(String(_vm.$t('message.hideText')).toLowerCase())
          }
        })]) : _vm._e()]) : _vm._e()]) : _vm._e()
      }), 0) : _vm._e(), _vm._v(" "), (!item.isEditMode && item.tags.length === 0) ? _c('div', {
        staticClass: "no_tags"
      }, [_vm._v("\n                 " + _vm._s(_vm.$t('message.labelNoTags')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.isControlsVisible && !item.isEditMode) ? _c('div', {
        attrs: {
          "align": "right"
        }
      }, [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('bg-edit', {
        attrs: {
          "tags": _vm.readingTags,
          "preference": _vm.data.preference,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-text', [_c('div', {
    staticClass: "v-header"
  }, [_vm._v(_vm._s(_vm.$t('message.labelTodaysPrediction')) + " "), _c('mu-icon', {
    attrs: {
      "value": "help"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTodaysPredictionExplain')))])]), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "center-text",
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('radial-progress', {
    attrs: {
      "mode": "duration",
      "data-id": "radial-loading-1",
      "value": _vm.$store.state.cards.sleep.wearable.minutesAwake,
      "outOfValue": _vm.$store.state.cards.sleep.wearable.predictions.minutesAwake,
      "suffix": "min",
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTimeAwake')[0].toUpperCase() + _vm.$t('message.labelTimeAwake').substr(1)))])], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "center-text",
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('radial-progress', {
    attrs: {
      "mode": "duration",
      "data-id": "radial-loading-3",
      "value": _vm.$store.state.cards.sleep.wearable.minutesAsleep,
      "outOfValue": _vm.$store.state.cards.sleep.wearable.predictions.minutesAsleep,
      "suffix": "min",
      "color": "#89C93B"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTimeAsleep')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aio-media"
    }
  }, [_c('mu-card', {
    staticClass: "aio-input"
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('mu-icon', {
    staticClass: "card-left-icon blueIcon",
    attrs: {
      "value": "photo_camera",
      "size": 20
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardPhotos'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": _vm.isOpenInput ? 'remove_circle_outline' : 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpenInput),
      expression: "isOpenInput"
    }]
  }, [_c('div', {
    class: {
      bottom: _vm.images.length > 0 || _vm.isUploadingImage
    },
    attrs: {
      "id": "uploadImage"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "labelClass": "large",
      "id": "uploadBtn",
      "label": _vm.$t('message.cardPhotosChoosePicture'),
      "disabled": _vm.isUploadingImage,
      "primary": ""
    },
    on: {
      "click": _vm.bindUploadEvent
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.chooseImage
    }
  })], 1), _vm._v(" "), (_vm.images.length > 0 || _vm.isUploadingImage) ? _c('div', {
    staticClass: "label bottom"
  }, [_c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardPhotosAddingPhotos'))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isUploadingImage) ? _c('div', {
    staticClass: "loader"
  }, [_c('mu-circular-progress', {
    staticClass: "uploadProgress",
    staticStyle: {
      "position": "relative",
      "left": "2px"
    },
    attrs: {
      "mode": "determinate",
      "size": 20,
      "value": _vm.uploadProgress
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.images), function(image, index) {
    return _c('mu-avatar', {
      key: 'image-' + index,
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "src": image.image_url,
        "imgClass": "progPic"
      }
    })
  }), _vm._v(" "), (_vm.profileImage) ? _c('avatar-uploader', {
    attrs: {
      "hideAvatar": true,
      "imageUrl": _vm.profileImage
    }
  }) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "blood-pressure-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "10px",
      "viewBox": "20 195 16 10",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M32.000831,196.05636 C32.0007895,196.056319 32.0007064,196.056319 32.0006648,196.056278 C29.5330536,194.647969 26.4672788,194.647887 23.999626,196.056155 C23.9995014,196.056237 23.9993352,196.056278 23.9992105,196.05636 C21.6008227,197.424633 20,199.980785 20,202.890183 C20,203.059962 20.1395272,203.197531 20.31163,203.197531 L26.1818257,203.197531 C26.3304109,204.054991 27.0889184,204.709847 28,204.709847 C28.9149458,204.709847 29.6534259,204.084537 29.8156812,203.197531 L35.68837,203.197531 C35.8604728,203.197531 36,203.059962 36,202.890183 C36.0000416,199.979638 34.3982216,197.424059 32.000831,196.05636 L32.000831,196.05636 Z M28.0000416,204.095151 C27.326339,204.095151 26.7782441,203.554628 26.7782441,202.890183 C26.7782441,202.22668 27.3266298,201.685091 28.0001247,201.685091 C28.6587859,201.685091 29.2129056,202.206559 29.2215482,202.874118 C29.2187643,203.485085 28.7620809,204.095151 28.0000416,204.095151 L28.0000416,204.095151 Z M29.710558,202.195043 C29.655171,202.06272 29.583413,201.936707 29.4958242,201.819587 L30.3388873,201.602599 L29.710558,202.195043 L29.710558,202.195043 Z M30.2012715,202.582794 L31.6378444,201.228167 C31.8691985,201.00995 31.6538829,200.628962 31.3437903,200.708626 L29.334192,201.225872 L31.9554577,196.748098 C33.9382142,197.992776 35.2657581,200.135606 35.370258,202.582794 L30.2012715,202.582794 L30.2012715,202.582794 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#FA6956",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "30",
      "max": "300",
      "data-vv-rules": "required|min_value:30|max_value:300",
      "data-vv-name": "systolic",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('systolic'),
      "label": _vm.$t('message.labelSystolic'),
      "hintText": _vm.$t('message.cardBloodPressuremmHGPlaceholder'),
      "fullWidth": true,
      "helpText": 'mmHG'
    },
    model: {
      value: (_vm.model.systolic),
      callback: function($$v) {
        _vm.$set(_vm.model, "systolic", _vm._n($$v))
      },
      expression: "model.systolic"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "30",
      "max": "300",
      "data-vv-rules": "required|min_value:30|max_value:300",
      "data-vv-name": "diastolic",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('diastolic'),
      "label": _vm.$t('message.labelDiastolic'),
      "hintText": _vm.$t('message.cardBloodPressuremmHGPlaceholder'),
      "helpText": 'mmHG'
    },
    model: {
      value: (_vm.model.diastolic),
      callback: function($$v) {
        _vm.$set(_vm.model, "diastolic", _vm._n($$v))
      },
      expression: "model.diastolic"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "100",
      "tablet": "20"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "40",
      "width": "100",
      "tablet": "60"
    }
  }, [_c('create-question', {
    staticClass: "animated fadeInUp"
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "100",
      "tablet": "20"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "searchBar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.searchText') + '...'
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "Search"
    },
    on: {
      "click": _vm.onSearch
    }
  })], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-item",
    class: {
      last: _vm.isLast
    }
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.chartLabel)
    }
  }), _vm._v(":\n    "), _c('span', [_vm._v("\n              " + _vm._s(_vm.decimalize(_vm.value)) + "  / " + _vm._s(_vm.total) + _vm._s(_vm.unit) + "\n              ")])]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? ("rgba(" + _vm.color + ", 0.24)") : _vm.color,
      "mode": _vm.barMode,
      "size": 16,
      "value": (_vm.value) ? ((_vm.value / _vm.total) > 100 ? 100 : (_vm.value / _vm.total) * 100) : 0
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "blood-glucose-ranges"
  }, [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v(_vm._s(_vm.ranges.total) + " " + _vm._s(_vm.$t('message.visualizationBloodGlucoseHeader')))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v(_vm._s(_vm.$t('message.loadingText')))]) : _vm._e(), _vm._v(" "), _c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('radial-progress', {
    attrs: {
      "data-id": "radial-loading-1",
      "value": 0,
      "suffix": "%",
      "color": "#0179d5"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('radial-progress', {
    attrs: {
      "data-id": "radial-1",
      "value": _vm.lower,
      "suffix": "%",
      "color": "#0179d5"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelBelowRange')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.ranges.lower) + "\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('radial-progress', {
    attrs: {
      "data-id": "radial-loading-2",
      "value": 0,
      "suffix": "%",
      "color": "#89C93B"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('radial-progress', {
    attrs: {
      "data-id": "radial-2",
      "value": _vm.inRange,
      "suffix": "%",
      "color": "#89C93B"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelInRange')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.ranges.in_range) + "\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('radial-progress', {
    attrs: {
      "data-id": "radial-loading-3",
      "value": 0,
      "suffix": "%",
      "color": "#89C93B"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('radial-progress', {
    attrs: {
      "data-id": "radial-3",
      "value": _vm.upper,
      "suffix": "%",
      "color": "#E74C3C"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelAboveRange')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.ranges.upper) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "downloadsCat"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "cat-view"
  }, [_c('div', {
    staticClass: "cat-bg",
    style: ('background-image: url(' + _vm.data.cat.image + ');')
  }, [_c('div', {
    staticClass: "cat"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.data.cat.name,
      "subTitle": _vm.data.cat.desc,
      "titleClass": "largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.data.downloads), function(download, index) {
    return _c('mu-list-item', {
      key: ("download-" + index),
      staticClass: "item",
      attrs: {
        "title": download.title,
        "describeText": download.desc
      },
      on: {
        "click": function($event) {
          return _vm.openLink(download)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "src": download.image_url
      }
    })], 1), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('mu-icon', {
      attrs: {
        "value": "file_downloads",
        "color": "#0179d5"
      }
    })], 1), _vm._v(" "), _c('mu-divider')], 1)
  }), 1)], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.data.cat.name)
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc",
    domProps: {
      "textContent": _vm._s(_vm.data.cat.desc)
    }
  })
}]}

/***/ }),
/* 3789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mode === 'start' && (!_vm.course.taken.start_questions && !_vm.ratingStart.saved)) ? _c('mu-card', {
    attrs: {
      "id": "lessonRatingStart"
    }
  }, _vm._l((_vm.course.start_questions), function(q, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ratingStart.activeIndex === index),
        expression: "ratingStart.activeIndex === index"
      }],
      key: 'start-rating-' + index,
      staticClass: "start-q"
    }, [_c('mu-card-title', {
      attrs: {
        "title": q.question,
        "subTitle": index + 1 + '/' + _vm.course.start_questions.length,
        "titleClass": "largeTitle"
      }
    }), _vm._v(" "), _c('mu-card-text', [_c('mu-flexbox', {
      staticClass: "ratings",
      attrs: {
        "align": "flex-start"
      }
    }, _vm._l((_vm.ratingStart.ratings), function(rating, ratingIndex) {
      return _c('mu-flexbox-item', {
        key: 'start-rating-label-' + ratingIndex,
        staticClass: "rating",
        nativeOn: {
          "click": function($event) {
            return _vm.addScoreToMarkers(q.question_id, ratingIndex + 1)
          }
        }
      }, [_c('span', {
        staticClass: "amount",
        domProps: {
          "textContent": _vm._s(ratingIndex + 1)
        }
      }), _vm._v(" "), (q.type === 'motivation-text') ? _c('span', {
        staticClass: "label",
        domProps: {
          "textContent": _vm._s(rating.label)
        }
      }) : _vm._e()])
    }), 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.mode === 'end' && (!_vm.course.taken.end_questions && !_vm.ratingEnd.saved)) ? _c('mu-card', {
    attrs: {
      "id": "lessonRatingEnd"
    }
  }, [_vm._m(0), _vm._v(" "), _c('mu-card-text', [_c('mu-flexbox', {
    staticClass: "stars",
    attrs: {
      "align": "flex-start"
    }
  }, _vm._l((_vm.ratingEnd.ratings), function(rating, index) {
    return _c('mu-flexbox-item', {
      key: 'end-rating-' + index,
      staticClass: "star",
      nativeOn: {
        "click": function($event) {
          return _vm.saveRatingEnd(index + 1)
        }
      }
    }, [_c('mu-icon', {
      staticClass: "icon",
      attrs: {
        "value": "star"
      }
    }), _vm._v(" "), (index == 0) ? _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('message.lessonRatingVery')))]) : _vm._e(), _vm._v(" "), (index == (_vm.ratingEnd.ratings - 1)) ? _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('message.lessonRatingNotVery')))]) : _vm._e()], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.course.end_question
    }
  })
}]}

/***/ }),
/* 3790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Add a review of this recipe",
      "subTitle": "Take a picture of the prepared recipe to share with the community"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('recipe-rating', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "read-only": false,
      "count": _vm.recipe.rating.ratingCount,
      "rating": _vm.recipe.rating.userRating,
      "recipe": _vm.recipe
    },
    on: {
      "ratingPicked": _vm.onRatingPicked
    }
  }), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.review),
      expression: "model.review"
    }],
    staticClass: "textAreaReview",
    staticStyle: {
      "min-width": "100%",
      "min-height": "100px",
      "max-width": "100%",
      "margin-bottom": "14px"
    },
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.model.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "review", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isImagesUploading) ? _c('div', [_vm._v("\n        Uploading images...\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.model.images), function(image, index) {
    return _c('img', {
      staticStyle: {
        "height": "50px",
        "border": "1px solid white",
        "margin-bottom": "8px"
      },
      attrs: {
        "index": 'images-' + index,
        "src": image
      }
    })
  }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": 50,
      "tablet": 50,
      "desktop": "50",
      "align": "left"
    }
  }, [_c('multiple-image-uploader', {
    on: {
      "uploading": _vm.onUploading
    },
    model: {
      value: (_vm.model.images),
      callback: function($$v) {
        _vm.$set(_vm.model, "images", $$v)
      },
      expression: "model.images"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": 50,
      "tablet": 50,
      "desktop": 50,
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "primary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving === false ? _vm.$t('message.submitText') : _vm.$t('message.savingText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 2)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-list', {
    staticClass: "reviewList"
  }, _vm._l((_vm.reviews.data), function(item, rindex) {
    return _c('mu-list-item', {
      key: item.user_id,
      attrs: {
        "disableRipple": true
      }
    }, [(!item.user.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n        " + _vm._s(_vm.upperTwoInitials(item.user.display_name)) + "\n      ")]) : _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.user.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(_vm.question.url)
        }
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.user.display_name))]), _vm._v(" "), (!item.isUpdateReviewOpen) ? _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "8px"
      }
    }, [_vm._v(_vm._s(_vm.fromNow(item.createdAt)))]), _vm._v(" "), _vm._l((5), function(ratingI, rindex) {
      return _c('span', {
        key: 'rating-' + rindex,
        class: {
          'activeStar': item.rating.rating >= ratingI
        },
        staticStyle: {
          "color": "rgb(204, 204, 204)"
        }
      }, [_c('mu-icon', {
        attrs: {
          "value": "star"
        }
      })], 1)
    }), _vm._v(" "), (item) ? _c('div', {
      staticStyle: {
        "margin-bottom": "14px",
        "margin-top": "14px",
        "word-break": "normal"
      }
    }, [_c('vue-markdown', {
      attrs: {
        "source": item.review
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((item.images), function(image, iindex) {
      return _c('img', {
        key: 'image-' + iindex,
        staticStyle: {
          "height": "90px"
        },
        attrs: {
          "src": image
        },
        on: {
          "click": function($event) {
            return _vm.openImg(image)
          }
        }
      })
    }), _vm._v(" "), _c('mu-dialog', {
      attrs: {
        "open": _vm.imgModal
      },
      on: {
        "close": _vm.closeImg
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.imgModalSrc
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "slot": "actions",
        "label": "Close"
      },
      on: {
        "click": _vm.closeImg
      },
      slot: "actions"
    })], 1)], 2), _vm._v(" "), _c('mu-list', _vm._l((item.comments), function(comments, cindex) {
      return _c('mu-list-item', {
        key: 'comment-' + cindex
      }, [(!comments.user.profile_large) ? _c('mu-avatar', {
        attrs: {
          "slot": "left",
          "color": "#0179d5",
          "backgroundColor": "#E9E9E8"
        },
        slot: "left"
      }, [_vm._v("\n              " + _vm._s(_vm.upperTwoInitials(comments.user.display_name)) + "\n            ")]) : _c('mu-avatar', {
        attrs: {
          "slot": "left",
          "src": comments.user.profile_large,
          "color": "white",
          "backgroundColor": "#E9E9E8"
        },
        on: {
          "click": function($event) {
            return _vm.goToProfile(_vm.question.url)
          }
        },
        slot: "left"
      }), _vm._v(" "), _c('div', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(comments.user.display_name))]), _vm._v(" "), _c('div', {
        attrs: {
          "slot": "describe"
        },
        slot: "describe"
      }, [_c('div', {
        staticStyle: {
          "margin-bottom": "8px"
        }
      }, [_vm._v(_vm._s(_vm.fromNow(comments.createdAt)))]), _vm._v(" "), _c('span', [_c('vue-markdown', {
        staticStyle: {
          "white-space": "pre-wrap",
          "word-break": "normal"
        },
        attrs: {
          "source": comments.body
        }
      })], 1), _vm._v(" "), (comments.isUpdateCommentOpen) ? _c('span', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editableCommentModel[comments.id]),
          expression: "editableCommentModel[comments.id]"
        }],
        staticClass: "textAreaReview",
        staticStyle: {
          "min-width": "100%",
          "min-height": "100px",
          "max-width": "100%",
          "margin-bottom": "14px"
        },
        attrs: {
          "rows": "4"
        },
        domProps: {
          "value": (_vm.editableCommentModel[comments.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.editableCommentModel, comments.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "reply-block"
      }, [_c('mu-raised-button', {
        attrs: {
          "label": "Cancel"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showUpdateCommentBlock(comments)
          }
        }
      }), _vm._v(" "), _c('mu-raised-button', {
        attrs: {
          "label": "Update",
          "primary": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.updateComment(comments)
          }
        }
      })], 1)]) : _vm._e()]), _vm._v(" "), (comments.userId === _vm.$store.state.user.scope.user_id) ? _c('mu-icon-menu', {
        directives: [{
          name: "tooltop",
          rawName: "v-tooltop.left",
          value: ('Options'),
          expression: "'Options'",
          modifiers: {
            "left": true
          }
        }],
        attrs: {
          "slot": "right",
          "icon": "more_vert"
        },
        slot: "right"
      }, [_c('mu-menu-item', {
        attrs: {
          "title": "Edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editComment(comments)
          }
        }
      }), _vm._v(" "), _c('mu-menu-item', {
        attrs: {
          "title": "Delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteComment(comments.id, item)
          }
        }
      })], 1) : _vm._e()], 1)
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "reply-block"
    }, [_c('mu-raised-button', {
      attrs: {
        "label": !item.isReplyOpen ? _vm.showReply : _vm.hideReply,
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.showReplyBlock(item)
        }
      }
    })], 1), _vm._v(" "), (item.isReplyOpen) ? _c('div', {
      staticClass: "reviewCommentWrap"
    }, [_c('form', [_c('div', {
      staticClass: "reviewComment"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commentModel.body),
        expression: "commentModel.body"
      }],
      staticClass: "textAreaReview",
      staticStyle: {
        "min-width": "100%",
        "min-height": "100px",
        "max-width": "100%",
        "margin-bottom": "14px"
      },
      attrs: {
        "rows": "4"
      },
      domProps: {
        "value": (_vm.commentModel.body)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.commentModel, "body", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('mu-col', {
      attrs: {
        "width": 100,
        "tablet": 100,
        "desktop": 100,
        "align": "right"
      }
    }, [_c('mu-raised-button', {
      attrs: {
        "label": "Submit",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addComment(item)
        }
      }
    })], 1)], 1)])]) : _vm._e()], 2) : _c('div', [_c('div', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editableReviewModel[item.id].review),
        expression: "editableReviewModel[item.id].review"
      }],
      staticClass: "textAreaReview",
      staticStyle: {
        "min-width": "100%",
        "min-height": "100px",
        "max-width": "100%",
        "margin-bottom": "14px"
      },
      attrs: {
        "rows": "4"
      },
      domProps: {
        "value": (_vm.editableReviewModel[item.id].review)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.editableReviewModel[item.id], "review", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.isImagesUploadingForUpdate) ? _c('div', [_vm._v("\n        Uploading images...\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, _vm._l((_vm.model.updateImages), function(image, index) {
      return _c('div', [_c('img', {
        staticStyle: {
          "height": "50px",
          "border": "1px solid white",
          "margin-bottom": "8px"
        },
        attrs: {
          "index": 'images-' + index,
          "src": image
        }
      }), _vm._v(" "), _c('mu-icon', {
        staticStyle: {
          "verticalAlign": "top",
          "cursor": "pointer"
        },
        attrs: {
          "size": "16",
          "value": "close"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.removeImage(item, index)
          }
        }
      })], 1)
    }), 0), _vm._v(" "), _c('mu-row', [_c('mu-col', {
      attrs: {
        "width": 50,
        "tablet": 50,
        "desktop": "50",
        "align": "left"
      }
    }, [_c('multiple-image-uploader', {
      attrs: {
        "existing-images": item.images
      },
      on: {
        "uploading": _vm.onUploadingForUpdate
      },
      model: {
        value: (_vm.model.updateImages),
        callback: function($$v) {
          _vm.$set(_vm.model, "updateImages", $$v)
        },
        expression: "model.updateImages"
      }
    })], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": 50,
        "tablet": 50,
        "desktop": 50,
        "align": "right"
      }
    }, [_c('div', {
      staticClass: "reply-block"
    }, [_c('mu-raised-button', {
      attrs: {
        "label": "Cancel"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.showUpdateReviewBlock(item)
        }
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      attrs: {
        "label": "Update",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.updateReview(item)
        }
      }
    })], 1)])], 1)], 1), _vm._v(" "), (item.user_id === _vm.$store.state.user.scope.user_id) ? _c('mu-icon-menu', {
      directives: [{
        name: "tooltop",
        rawName: "v-tooltop.left",
        value: ('Options'),
        expression: "'Options'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "slot": "right",
        "icon": "more_vert"
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": "Edit"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editReview(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": "Delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.removeReview(item)
        }
      }
    })], 1) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.reviews.paginationInfo.actualPage < _vm.reviews.paginationInfo.totalPages && _vm.reviews.data.length !== 0) ? _c('mu-card-actions', {
    attrs: {
      "align": "center"
    }
  }, [(!_vm.isAppending) ? _c('div', [_c('mu-raised-button', {
    attrs: {
      "label": "Load more reviews"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getReviews.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAppending) ? _c('div', [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-content-block"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 3793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-card-header"
  }, [_vm._t("avatar"), _vm._v(" "), (_vm.title || _vm.subTitle) ? _c('div', {
    staticClass: "mu-card-header-title"
  }, [_c('div', {
    staticClass: "mu-card-title",
    class: _vm.titleClass
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mu-card-sub-title",
    class: _vm.subTitleClass
  }, [_vm._v("\n      " + _vm._s(_vm.subTitle) + "\n    ")])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "weight-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.data.no_height_setting ? _vm.$t('message.cardWeightEmptyHeight') : _vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.$t('message.cardTapSuffix')) + "\n\n          ")], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardLatestReading'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.latest)
    }
  }), _vm._v(" "), (_vm.data.userDevice && _vm.data.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.t('message.cardFromDevice') + ' ' + _vm.data.userDevice.nickname),
      expression: "t('message.cardFromDevice') + ' ' +  data.userDevice.nickname",
      modifiers: {
        "left": true
      }
    }],
    staticStyle: {
      "position": "relative",
      "top": "6px",
      "margin-left": "4px"
    },
    attrs: {
      "width": "22",
      "src": _vm.data.userDevice.device.iconWhite
    }
  })]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.data.lost_weight ? _vm.$t('message.cardWeightTotalLoss') : _vm.$t('message.cardWeightTotalGain'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.difference)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.data.week_weight.lost_weight ? _vm.$t('message.cardWeightLostThisWeek') : _vm.$t('message.cardWeightGainedThisWeek'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.week_weight.difference)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardWeightWaistHipRatio'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.waist_hip_ratio)
    }
  })])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "14px",
      "viewBox": "0 3 16 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.0274359,4.84740771 C14.8735715,3.69796239 14.1860505,3 13.1481453,3 L7.99995032,3 L2.85178845,3 C1.81394954,3 1.12642845,3.69796239 0.972531032,4.84740771 C0.81863361,5.99685303 0,14.2824828 0,14.2824828 C0,15.3027795 0.841418509,16.1298905 1.87929054,16.1298905 L7.99998344,16.1298905 L14.1207095,16.1298905 C15.1585484,16.1298905 16,15.3027795 16,14.2824828 C15.9999338,14.2824828 15.1813002,5.99682048 15.0274359,4.84740771 L15.0274359,4.84740771 Z M8.04591753,7.64554054 C8.06671538,7.61930062 8.0855924,7.59156313 8.1017869,7.56210019 C8.4607153,7.11289617 9.37125021,5.94541497 9.23897857,5.81603848 C9.13482376,5.71449715 8.33910752,6.12020671 7.76869022,6.43176509 C7.55504867,6.54844484 7.3728026,6.65200463 7.27066796,6.71070262 C7.24397519,6.72362725 7.21910388,6.73863544 7.19456375,6.7548482 C7.18946364,6.75777821 7.18174724,6.76230346 7.18174724,6.76230346 L7.18221089,6.7627918 C7.00413763,6.8859827 6.89405477,7.09443707 6.91432274,7.32330388 C6.92501972,7.44499722 6.97121875,7.55506815 7.0413618,7.64554054 L4.14473213,7.64554054 C4.07713914,7.64554054 4.02236265,7.59169336 4.02236265,7.5252471 C4.02236265,5.52499022 5.67774519,3.89765927 7.71252279,3.89765927 C7.81707501,3.89765927 7.92474029,3.90231474 8.03253803,3.91139779 C8.94949775,3.98884788 9.7994606,4.3991478 10.4257141,5.06663803 C11.05571,5.7380675 11.4026829,6.6112123 11.4026829,7.5252471 C11.4026829,7.59169336 11.3479065,7.64554054 11.2803135,7.64554054 L8.04591753,7.64554054 L8.04591753,7.64554054 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#69A7D9",
      "fill-rule": "evenodd",
      "transform": "translate(8.000000, 9.564945) scale(-1, 1) translate(-8.000000, -9.564945) "
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), (_vm.data.no_setting) ? _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpenSetting || _vm.loading
    },
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": "settings"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSettings.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.data.no_setting) ? _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpenSetting
    },
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isOpenSetting) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [(_vm.data.missing_settings.weight) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": "required",
      "data-vv-name": "weight_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Weight setting",
      "errorText": _vm.errors.first('weight_setting'),
      "label": _vm.$t('message.unitsPreferencesMeasureWeight'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.settings.weight),
      callback: function($$v) {
        _vm.$set(_vm.settings, "weight", $$v)
      },
      expression: "settings.weight"
    }
  }, _vm._l((_vm.data.missing_settings.weight), function(item, index) {
    return _c('mu-menu-item', {
      key: 'weight-setting-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.height) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": "required",
      "data-vv-name": "height_setting",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('height_setting'),
      "label": _vm.$t('message.unitsPreferencesMeasureHeight'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.settings.height),
      callback: function($$v) {
        _vm.$set(_vm.settings, "height", $$v)
      },
      expression: "settings.height"
    }
  }, _vm._l((_vm.data.missing_settings.height), function(item, index) {
    return _c('mu-menu-item', {
      key: 'height-setting-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.waist) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": "required",
      "data-vv-name": "waist_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Waist setting",
      "errorText": _vm.errors.first('waist_setting'),
      "label": _vm.$t('message.unitsPreferencesMeasureWaist'),
      "fullWidth": true,
      "hintText": _vm.$t('message.selectText')
    },
    model: {
      value: (_vm.settings.waist),
      callback: function($$v) {
        _vm.$set(_vm.settings, "waist", $$v)
      },
      expression: "settings.waist"
    }
  }, _vm._l((_vm.data.missing_settings.waist), function(item, index) {
    return _c('mu-menu-item', {
      key: 'waist-setting-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.isOpenSetting) ? _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSettings.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? 'Saving' : 'Save'
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isOpenHeightSetting) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveHeightSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.height.measure === 'cm') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "272",
      "data-vv-rules": 'required|min_value:0|max_value:272',
      "data-vv-name": "height_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "errorText": _vm.errors.first('height_cm'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "cm"
    },
    model: {
      value: (_vm.heightSettings.cm),
      callback: function($$v) {
        _vm.$set(_vm.heightSettings, "cm", _vm._n($$v))
      },
      expression: "heightSettings.cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.height.measure === 'ft-in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "9",
      "data-vv-rules": 'required|min_value:0|max_value:9',
      "data-vv-name": "height_ft",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "ft",
      "errorText": _vm.errors.first('height_ft'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "ft",
      "fullWidth": true
    },
    model: {
      value: (_vm.heightSettings.ft),
      callback: function($$v) {
        _vm.$set(_vm.heightSettings, "ft", _vm._n($$v))
      },
      expression: "heightSettings.ft"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.height.measure === 'ft-in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "11",
      "data-vv-rules": 'required|min_value:0|max_value:11',
      "data-vv-name": "height_in",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('height_in'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "in",
      "fullWidth": true
    },
    model: {
      value: (_vm.heightSettings.in),
      callback: function($$v) {
        _vm.$set(_vm.heightSettings, "in", _vm._n($$v))
      },
      expression: "heightSettings.in"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isOpenHeightSetting) ? _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": "Discard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeHeightSettings.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? 'Saving' : 'Save'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveHeightSettings.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.weight.measure === 'kg') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "635",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:635',
      "data-vv-name": "kg",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "kg",
      "errorText": _vm.errors.first('kg'),
      "type": "number",
      "label": "KG",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.kg),
      callback: function($$v) {
        _vm.$set(_vm.model, "kg", _vm._n($$v))
      },
      expression: "model.kg"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.weight.measure === 'lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "1400",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:1400',
      "data-vv-name": "lbs",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "lbs",
      "errorText": _vm.errors.first('lbs'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.lbs),
      callback: function($$v) {
        _vm.$set(_vm.model, "lbs", _vm._n($$v))
      },
      expression: "model.lbs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "min": "0",
      "max": "100",
      "data-vv-rules": 'required|min_value:0|max_value:100',
      "data-vv-name": "stones",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "st",
      "errorText": _vm.errors.first('stones'),
      "type": "number",
      "label": "ST",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.stones),
      callback: function($$v) {
        _vm.$set(_vm.model, "stones", _vm._n($$v))
      },
      expression: "model.stones"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "min": "0",
      "max": "13",
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "lbs",
      "errorText": _vm.errors.first('pounds'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.pounds),
      callback: function($$v) {
        _vm.$set(_vm.model, "pounds", _vm._n($$v))
      },
      expression: "model.pounds"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', [(!_vm.model.image) ? _c('image-uploader', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "title": _vm.$t('message.labelAddPhoto')
    },
    model: {
      value: (_vm.model.image),
      callback: function($$v) {
        _vm.$set(_vm.model, "image", $$v)
      },
      expression: "model.image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.image) ? _c('mu-card', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('mu-card-text', [_c('mu-flat-button', {
    attrs: {
      "icon": "close",
      "label": "Clear image"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeImage.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.model.image) ? _c('img', {
    staticStyle: {
      "margin-bottom": "-6px"
    },
    attrs: {
      "src": _vm.model.image,
      "width": "100%"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [(!_vm.isInputExpanded) ? _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.labelAdditionalInformation'),
      "icon": "expand_more"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleExpandedInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInputExpanded) ? _c('mu-raised-button', {
    attrs: {
      "label": "Close",
      "icon": "expand_less"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleExpandedInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isInputExpanded) ? _c('mu-row', [_c('mu-col', {
    staticClass: "card-sub-header",
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.cardWeightWaistHipRatio')) + "\n          ")]), _vm._v(" "), (_vm.waist.measure == 'cm') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "305",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:305',
      "data-vv-name": "waist_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "errorText": _vm.errors.first('waist_cm'),
      "hintText": _vm.$t('message.labelCMPlaceholder'),
      "label": _vm.$t('message.labelWaist'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.waist_cm),
      callback: function($$v) {
        _vm.$set(_vm.model, "waist_cm", _vm._n($$v))
      },
      expression: "model.waist_cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.waist.measure == 'cm') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "305",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:305',
      "data-vv-name": "hip_cm",
      "data-vv-as": "cm",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hip_cm'),
      "hintText": _vm.$t('message.labelCMPlaceholder'),
      "label": _vm.$t('message.labelHip'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hip_cm),
      callback: function($$v) {
        _vm.$set(_vm.model, "hip_cm", _vm._n($$v))
      },
      expression: "model.hip_cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.waist.measure == 'in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "120",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:120',
      "data-vv-name": "waist_in",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('waist_in'),
      "hintText": _vm.$t('message.labelInchesPlaceholder'),
      "label": _vm.$t('message.labelWaist'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.waist_in),
      callback: function($$v) {
        _vm.$set(_vm.model, "waist_in", _vm._n($$v))
      },
      expression: "model.waist_in"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.waist.measure == 'in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "120",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:120',
      "data-vv-name": "hip_in",
      "data-vv-as": "in",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hip_in'),
      "hintText": _vm.$t('message.labelInchesPlaceholder'),
      "label": _vm.$t('message.labelHip'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hip_in),
      callback: function($$v) {
        _vm.$set(_vm.model, "hip_in", _vm._n($$v))
      },
      expression: "model.hip_in"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ketones-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [(_vm.visualDate.dateStep !== 0) ? _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  }) : _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#34A1C9"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmpty'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmptyExplain'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "dateStep": _vm.visualDate.dateStep,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(0)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(7)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(30)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(360)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "profile-header innerProfile",
    class: {
      'has-coverphoto': _vm.profile.cover_photo !== ''
    },
    style: ({
      'background-image': 'url(' + _vm.profile.cover_photo + ')'
    }),
    attrs: {
      "id": "profileHeader"
    }
  }, [_c('mu-card-text', {
    staticClass: "profile-header-content"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "bottom",
      "justify": "bottom"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "bottom"
    }
  }, [_c('mu-row', {
    staticClass: "padRow",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "25",
      "tablet": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "profile-text desktop",
    attrs: {
      "width": "100",
      "desktop": "75",
      "tablet": "100",
      "align": "left"
    }
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.profile.display_name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [(_vm.profile.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.progress.percentage === 100 && !_vm.isHcpView) ? _c('user-badge', {
    attrs: {
      "type": "finished-program"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.champion) ? _c('user-badge', {
    attrs: {
      "type": "champion"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHcpView && _vm.isHcpVerified) ? _c('user-badge', {
    attrs: {
      "type": "hcp-verified"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showPrivacyInfo || _vm.profile.country !== null) ? _c('p', {
    staticClass: "country"
  }, [_c('country-badge', {
    attrs: {
      "alpha2": _vm.profile.location.alpha2,
      "tooltip": _vm.profile.country
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.profile.country)
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('mu-col', {
    staticClass: "profile-text mobile",
    attrs: {
      "width": "100",
      "desktop": "75",
      "tablet": "70",
      "align": "center"
    }
  }, [_c('mu-avatar', {
    staticClass: "relativeAvatar",
    attrs: {
      "size": 120,
      "src": _vm.profile.profile_image
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.profile.display_name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [(_vm.profile.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.progress.percentage === 100 && !_vm.isHcpView) ? _c('user-badge', {
    attrs: {
      "type": "finished-program"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.champion) ? _c('user-badge', {
    attrs: {
      "type": "champion"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHcpView && _vm.isHcpVerified) ? _c('user-badge', {
    attrs: {
      "type": "hcp-verified"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dashboard-settings"
    }
  }, [(!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    staticClass: "dashedItem",
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list', [_c('draggable', {
    attrs: {
      "options": {
        draggable: '.item',
        handle: '.handle'
      }
    },
    model: {
      value: (_vm.order),
      callback: function($$v) {
        _vm.order = $$v
      },
      expression: "order"
    }
  }, _vm._l((_vm.order), function(item, index) {
    return _c('mu-list-item', {
      key: 'card-order-' + index,
      staticClass: "item dashboardItem dashedItem",
      class: {
        'odd': index % 2 === 0
      },
      attrs: {
        "title": _vm.$t(_vm.getNameByKey(item.name)),
        "disableRipple": ""
      }
    }, [_c('mu-checkbox', {
      staticClass: "greenIcon",
      attrs: {
        "slot": "left",
        "uncheckIcon": "radio_button_checked",
        "checkedIcon": "radio_button_unchecked"
      },
      slot: "left",
      model: {
        value: (item.hidden),
        callback: function($$v) {
          _vm.$set(item, "hidden", $$v)
        },
        expression: "item.hidden"
      }
    }), _vm._v(" "), _c('mu-icon', {
      staticClass: "handle",
      attrs: {
        "slot": "after",
        "value": "menu"
      },
      slot: "after"
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-card-text', [(_vm.order.length > 0) ? _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isUpdating,
      "label": !_vm.isUpdating ? _vm.$t('message.updateText') : _vm.$t('message.updatingText'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "downloadsPanel"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.downloadsAppBarText'),
      "subTitle": _vm.$t('message.lessonDownloadsThisWeek')
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.downloads), function(download, index) {
    return _c('mu-list-item', {
      key: 'download-' + index,
      attrs: {
        "disableRipple": "",
        "title": download.title
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(download)
        }
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": download.image_url
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      staticStyle: {
        "color": "rgba(0, 0, 0, .87)"
      },
      domProps: {
        "textContent": _vm._s(download.description)
      }
    })]), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "file_download"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveTrackingCount(download)
        }
      },
      slot: "right"
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sleep-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#183C45"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmpty'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.graphEmptyExplain'))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  })], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(0)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(7)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(30)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(360)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-flat-button",
    class: _vm.buttonClass,
    style: (_vm.buttonStyle),
    attrs: {
      "disabled": _vm.disabled,
      "keyboardFocused": _vm.keyboardFocused,
      "wrapperClass": "mu-flat-button-wrapper",
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "rippleColor": _vm.rippleColor,
      "rippleOpacity": _vm.rippleOpacity,
      "centerRipple": false
    },
    on: {
      "click": _vm.handleClick,
      "keyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [(_vm.label && _vm.labelPosition === 'before') ? _c('span', {
    staticClass: "mu-flat-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('icon', {
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.label && _vm.labelPosition === 'after') ? _c('span', {
    staticClass: "mu-flat-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "mood-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "19 193 17 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "moodIcon",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(20.000000, 193.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.728,2.30929587 C15.6869333,2.24827023 15.6218667,2.20673177 15.5477333,2.19391126 L15.5424,2.19339844 C14.8528,2.41134716 13.3312,2.39083433 11.6,2.10109075 C9.8688,1.81134716 8.432,1.33596254 7.85813333,0.906731771 L7.85386667,0.90621895 C7.77973333,0.893911258 7.70346667,0.911859976 7.64373333,0.95596254 C7.584,1.0000651 7.54613333,1.06621895 7.53973333,1.137501 L7.32053333,3.53442408 C7.384,3.52519331 7.44693333,3.51442408 7.51093333,3.51442408 C7.78453333,3.51442408 8.04693333,3.59391126 8.27093333,3.74570613 C8.4992,3.89955228 8.66826667,4.11852664 8.75946667,4.36724459 C8.92,4.25391126 9.16213333,4.17544972 9.43893333,4.16468049 C9.93386667,4.14673177 10.344,4.34980869 10.3546667,4.61801382 C10.3658667,4.88570613 9.97173333,5.11801382 9.4768,5.13544972 C9.24853333,5.14365485 9.04106667,5.10314203 8.87946667,5.03288562 L9.2112,7.45185998 C9.59733333,7.0949369 10.1445333,6.90980869 10.7125333,7.00468049 C11.5706667,7.14827023 12.1706667,7.8749369 12.1525333,8.68775741 C12.1525333,8.6949369 12.1493333,8.7000651 12.1434667,8.70519331 C12.1381333,8.70929587 12.1317333,8.71134716 12.1248,8.70980869 L9.3184,8.2400651 L9.52853333,9.76775741 C9.54613333,9.91083433 9.55573333,10.0539113 9.55946667,10.1949369 C9.73706667,10.2528856 9.92,10.3016036 10.1093333,10.3339113 C11.9872,10.6482702 13.8090667,9.54365485 14.3205333,7.77903946 L15.7594667,2.51442408 C15.7813333,2.44519331 15.7685333,2.37032151 15.728,2.30929587 L15.728,2.30929587 Z M13.5541333,5.5200651 C13.4506667,5.76878305 12.9936,5.82673177 12.5328,5.64827023 C12.0736,5.47032151 11.7856,5.12468049 11.8885333,4.87596254 C11.9925333,4.62775741 12.4501333,4.56980869 12.9098667,4.74775741 C13.3696,4.92570613 13.6581333,5.27134716 13.5541333,5.5200651 L13.5541333,5.5200651 Z",
      "id": "Shape",
      "fill": "#8150E4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.76586667,4.75544972 C7.75626667,4.68724459 7.71786667,4.62621895 7.6592,4.58621895 C7.61546667,4.55647536 7.56426667,4.54160357 7.512,4.54160357 C7.49386667,4.54160357 7.47573333,4.54365485 7.45706667,4.54724459 L7.4528,4.54827023 C6.92693333,4.97852664 5.5808,5.48775741 3.94773333,5.83185998 C2.8784,6.05698818 1.89013333,6.16929587 1.14826667,6.16929587 C0.757333333,6.16929587 0.4352,6.137501 0.205333333,6.07596254 L0.201066667,6.07698818 C0.1312,6.09134716 0.0709333333,6.13339844 0.0346666667,6.19339844 C-0.0016,6.25288562 -0.0096,6.32416767 0.0112,6.38980869 L1.60533333,11.3364754 C2.0896,12.7569882 3.46346667,13.6764754 4.96106667,13.6764754 C5.21173333,13.6764754 5.4656,13.6508343 5.71946667,13.597501 C7.49066667,13.2236548 8.68,11.6210907 8.47093333,9.88980869 L7.76586667,4.75544972 L7.76586667,4.75544972 Z M2.1568,8.79647536 C2.1552,8.54211639 2.536,8.33339844 3.00746667,8.33032151 C3.47893333,8.32673177 3.8624,8.53288562 3.864,8.78724459 C3.8656,9.04211639 3.4848,9.25134716 3.01333333,9.25391126 C2.5424,9.25647536 2.15893333,9.05185998 2.1568,8.79647536 L2.1568,8.79647536 Z M5.37333333,12.0785266 C4.59306667,12.2426292 3.82293333,11.8492959 3.5088,11.1744241 C3.4976,11.1492959 3.4976,11.1210907 3.5104,11.0964754 C3.5232,11.0713472 3.54666667,11.0544241 3.57493333,11.0482702 L6.5584,10.4185266 C6.58613333,10.4128856 6.61493333,10.4190395 6.63733333,10.4364754 C6.65973333,10.4533984 6.67253333,10.4795523 6.67306667,10.5067318 C6.6816,11.246219 6.15306667,11.9144241 5.37333333,12.0785266 L5.37333333,12.0785266 Z M6.2864,8.56365485 C5.85653333,8.75032151 5.41973333,8.71442408 5.3104,8.48211639 C5.20053333,8.24929587 5.45973333,7.90980869 5.88906667,7.72314203 C6.31893333,7.53647536 6.75573333,7.5723728 6.86506667,7.80416767 C6.97493333,8.03647536 6.71626667,8.37647536 6.2864,8.56365485 L6.2864,8.56365485 Z",
      "id": "Shape",
      "fill": "#8150E4"
    }
  })])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": _vm.isOpenInput ? 'remove_circle_outline' : 'add_circle'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', [_c('mu-card-text', [_c('div', {
    staticClass: "upper-label"
  }, [_c('mu-icon', {
    attrs: {
      "size": 12,
      "value": "flash_on"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.labelEnergy')) + "\n      ")], 1), _vm._v(" "), _vm._l((_vm.moods.energy), function(group, groupIndex) {
    return _c('mu-row', {
      key: 'mood-group-1' + groupIndex,
      staticClass: "bottom"
    }, _vm._l((group), function(item, index) {
      return _c('mu-col', {
        key: 'group-inner-1-' + index,
        attrs: {
          "width": "20",
          "tablet": "20",
          "desktop": "20",
          "align": "center"
        }
      }, [_c('div', {
        staticClass: "hvr-grow pointer",
        class: {
          isActiveMood: item.isActive
        },
        on: {
          "click": function($event) {
            return _vm.toggleMood(item)
          }
        }
      }, [_c('div', {
        staticClass: "moodButton"
      }, [_c('div', {
        staticClass: "moodToggle"
      }), _vm._v(" "), _c('img', {
        attrs: {
          "width": "48",
          "src": item.icon
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.$t(_vm.localizeMood(item.mood))))])])])
    }), 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "upper-label"
  }, [_c('mu-icon', {
    attrs: {
      "size": 12,
      "value": "thumb_up"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.labelMood')) + "\n      ")], 1), _vm._v(" "), _vm._l((_vm.moods.mood), function(group, groupIndex) {
    return _c('mu-row', {
      key: 'mood-group-2' + groupIndex,
      staticClass: "bottom"
    }, _vm._l((group), function(item, index) {
      return _c('mu-col', {
        key: 'group-inner-2' + index,
        attrs: {
          "width": "20",
          "tablet": "20",
          "desktop": "20",
          "align": "center"
        }
      }, [_c('div', {
        staticClass: "hvr-grow pointer",
        class: {
          isActiveMood: item.isActive
        },
        on: {
          "click": function($event) {
            return _vm.toggleMood(item)
          }
        }
      }, [_c('div', {
        staticClass: "moodButton"
      }, [_c('div', {
        staticClass: "moodToggle"
      }), _vm._v(" "), _c('img', {
        attrs: {
          "width": "48",
          "src": item.icon
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.$t(_vm.localizeMood(item.mood))))])])])
    }), 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "upper-label"
  }, [_c('mu-icon', {
    attrs: {
      "size": 12,
      "value": "favorite"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.labelHealth')) + "\n      ")], 1), _vm._v(" "), _vm._l((_vm.moods.health), function(group, groupIndex) {
    return _c('mu-row', {
      key: 'mood-group-3' + groupIndex,
      staticClass: "bottom"
    }, _vm._l((group), function(item, index) {
      return _c('mu-col', {
        key: 'group-inner-3' + index,
        attrs: {
          "width": "20",
          "tablet": "20",
          "desktop": "20",
          "align": "center"
        }
      }, [_c('div', {
        staticClass: "hvr-grow pointer",
        class: {
          isActiveMood: item.isActive
        },
        on: {
          "click": function($event) {
            return _vm.toggleMood(item)
          }
        }
      }, [_c('div', {
        staticClass: "moodButton"
      }, [_c('div', {
        staticClass: "moodToggle"
      }), _vm._v(" "), _c('img', {
        attrs: {
          "width": "48",
          "src": item.icon
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.$t(_vm.localizeMood(item.mood))))])])])
    }), 1)
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "insetGraph",
    attrs: {
      "id": "activity-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-paper', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-content-block', [_c('service-tracking-types', {
    staticStyle: {
      "float": "right",
      "display": "inline-block",
      "margin-top": "4px",
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "activity",
      "current-service": "FITBIT"
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [_c('activity-input', {
    staticClass: "card-spacing",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "bmr": _vm.$store.state.user.stats.bmr
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px",
      "padding-top": "8px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.startTime))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing"
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        }
      }, [_c('div', [_c('mu-row', [_c('mu-col', [_c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.startTime, item.duration))
        }
      })]), _vm._v(" "), _c('mu-col', {
        staticClass: "reading"
      }, [_vm._v("\n                      " + _vm._s(item.activityName) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
        staticClass: "reading",
        staticStyle: {
          "margin-bottom": "12px"
        }
      }, [_vm._v(_vm._s(_vm.duration(item.duration)))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline-block",
          "margin-right": "8px"
        }
      }, [_c('mu-icon', {
        staticStyle: {
          "position": "relative",
          "top": "2px"
        },
        attrs: {
          "size": "16",
          "color": "#3d8517",
          "value": "directions_walk"
        }
      }), _vm._v("\n                    " + _vm._s(_vm.numberFormat(item.calories)) + " "), _c('span', {
        staticClass: "lite"
      }, [_vm._v("kcal")])], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline-block"
        }
      }, [_c('mu-icon', {
        staticStyle: {
          "position": "relative",
          "top": "2px"
        },
        attrs: {
          "size": "16",
          "color": "red",
          "value": "favorite"
        }
      }), _vm._v("\n                    " + _vm._s(item.averageHeartRate) + " "), _c('span', {
        staticClass: "lite"
      }, [_vm._v("avg bpm")])], 1), _vm._v(" "), (item.heartRateZones && item.calories > 0) ? _c('div', {
        staticStyle: {
          "margin-top": "8px"
        }
      }, [_c('mu-icon', {
        staticStyle: {
          "position": "relative",
          "top": "2px"
        },
        attrs: {
          "size": "16",
          "value": "access_time"
        }
      }), _vm._v(" " + _vm._s(_vm.fatBurnPercentageMins(item.heartRateZones)) + " of fat burn\n                    "), _c('div', {
        staticClass: "heartRateZone",
        staticStyle: {
          "width": "250px"
        }
      }, [_c('div', {
        staticClass: "fillBar",
        style: ({
          width: _vm.fatBurnPercentage(item.heartRateZones)
        })
      })])], 1) : _vm._e()], 1)])], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading === true) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadingsLoading === false) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkIn weight"
  }, [_c('mu-row', {
    staticClass: "content",
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "paddingRight",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "bigTxt first"
  }, [_vm._v("By this point in the program, many people have reported weight loss.")]), _vm._v(" "), _c('div', {
    staticClass: "bigTxt"
  }, [_vm._v("Fill us in on how you're getting along!")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', {
    staticStyle: {
      "width": "280px",
      "margin": "0 auto"
    }
  }, [_c('mu-card-text', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "lgTxt"
  }, [_vm._v(" Right now, I weigh...")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": "",
      "align": "center"
    }
  }, [(_vm.$store.state.user.settings.weight.measure === 'kg') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.kg),
      expression: "model.kg",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('kg')
    },
    attrs: {
      "type": "number",
      "data-vv-rules": 'required|min_value:0|max_value:635',
      "data-vv-name": "kg",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('kg'),
      "label": "KG",
      "hintText": "Weight in kg"
    },
    domProps: {
      "value": (_vm.model.kg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "kg", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Kilograms (kg)")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.lbs),
      expression: "model.lbs",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('lbs')
    },
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:750',
      "data-vv-name": "lbs",
      "errorText": _vm.errors.first('lbs'),
      "type": "number",
      "label": "POUNDS"
    },
    domProps: {
      "value": (_vm.model.lbs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "lbs", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Pounds (lbs)")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.stones),
      expression: "model.stones",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('stones')
    },
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:100',
      "data-vv-name": "stones",
      "type": "number"
    },
    domProps: {
      "value": (_vm.model.stones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "stones", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  Stones (st)\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "align": "center",
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.pounds),
      expression: "model.pounds",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    class: {
      'hasError': _vm.errors.has('pounds')
    },
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "errorText": _vm.errors.first('pounds'),
      "type": "number"
    },
    domProps: {
      "value": (_vm.model.pounds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "pounds", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  Pounds (lbs)\n                ")])]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "disabled": _vm.isProcessing,
      "type": "button",
      "label": _vm.isProcessing ? _vm.$t('message.savingText') : _vm.$t('message.nextText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imageUploader"
  }, [_c('vue-base64-file-upload', {
    staticClass: "v1",
    attrs: {
      "id": 'uploader-' + _vm._uid,
      "accept": "image/png,image/jpeg",
      "image-class": "v1-image",
      "input-class": "imageInput",
      "max-size": _vm.maxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  }), _vm._v(" "), (!_vm.isUploading) ? _c('mu-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: (_vm.label),
      expression: "label",
      modifiers: {
        "bottom": true
      }
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": _vm.size,
      "color": "#0179d5",
      "value": _vm.icon
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectFile.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('mu-circular-progress', {
    attrs: {
      "size": _vm.size,
      "mode": "determinate",
      "value": _vm.progress
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "hcpRegister"
    }
  }, [(!_vm.isFinished) ? _c('div', {
    attrs: {
      "id": "hcpModal"
    }
  }, [_c('mu-stepper', {
    attrs: {
      "activeStep": _vm.activeStep
    }
  }, _vm._l((_vm.steps), function(step, stepIndex) {
    return _c('mu-step', {
      key: ("step-" + stepIndex)
    }, [_c('mu-step-label', [_vm._v("\n          " + _vm._s(step.label) + "\n        ")])], 1)
  }), 1), _vm._v(" "), _vm._l((_vm.steps), function(step, stepIndex) {
    return _c('mu-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (stepIndex === _vm.activeStep),
        expression: "stepIndex === activeStep"
      }],
      key: ("card-step-" + stepIndex)
    }, [_c('mu-card-header', [_c('div', {
      staticClass: "mu-card-title-container"
    }, [_c('div', {
      staticClass: "mu-card-title"
    }, [_vm._v("\n            " + _vm._s(step.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "mu-card-sub-title",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(step.subTitle))
      }
    })])]), _vm._v(" "), _c('mu-card-text', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (step.key === 'step1'),
        expression: "step.key === 'step1'"
      }]
    }, [_c('mu-row', [_c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "50"
      }
    }, [_c('mu-text-field', {
      attrs: {
        "hintText": "example@nhs.net",
        "label": "Your work email address",
        "type": "email",
        "fullWidth": ""
      },
      model: {
        value: (_vm.model.step1.work_email),
        callback: function($$v) {
          _vm.$set(_vm.model.step1, "work_email", $$v)
        },
        expression: "model.step1.work_email"
      }
    }), _vm._v(" "), (_vm.list.jobs.length) ? _c('mu-select-field', {
      attrs: {
        "label": "Your job title",
        "fullWidth": ""
      },
      model: {
        value: (_vm.model.step1.job_id),
        callback: function($$v) {
          _vm.$set(_vm.model.step1, "job_id", $$v)
        },
        expression: "model.step1.job_id"
      }
    }, _vm._l((_vm.list.jobs), function(job, jobIndex) {
      return _c('mu-menu-item', {
        key: ("job-" + jobIndex),
        attrs: {
          "value": job.job_id,
          "title": job.job_title
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), _c('mu-auto-complete', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.listManualSurgery),
        expression: "!listManualSurgery"
      }],
      attrs: {
        "inputClass": "surgerySearchTxt",
        "maxHeight": 250,
        "scroller": _vm.scroller,
        "openOnFocus": true,
        "label": "Your surgery name",
        "fullWidth": "",
        "hintText": "Start typing to see results",
        "filter": "noFilter",
        "dataSource": _vm.list.surgeries,
        "dataSourceConfig": _vm.dataSourceConfig
      },
      on: {
        "change": _vm.handleSurgerySelected
      },
      model: {
        value: (_vm.surgerySearchValue),
        callback: function($$v) {
          _vm.surgerySearchValue = $$v
        },
        expression: "surgerySearchValue"
      }
    }), _vm._v(" "), _c('mu-checkbox', {
      staticClass: "listManualSurgery",
      attrs: {
        "label": 'My surgery isn\'t listed'
      },
      on: {
        "change": _vm.onListManualSurgery
      },
      model: {
        value: (_vm.listManualSurgery),
        callback: function($$v) {
          _vm.listManualSurgery = $$v
        },
        expression: "listManualSurgery"
      }
    }), _vm._v(" "), (_vm.listManualSurgery) ? _c('mu-row', [_c('mu-col', {
      attrs: {
        "desktop": "100",
        "tablet": "100",
        "width": "100"
      }
    }, [_c('h2', [_vm._v("Manually enter surgery address")])]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "desktop": "50",
        "tablet": "50",
        "width": "100"
      }
    }, [_c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "surgery",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "surgery",
        "errorText": _vm.errors.first('surgery'),
        "hintText": "Surgery name",
        "label": "Surgery name"
      },
      model: {
        value: (_vm.model.step1.surgery.surgery_name),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "surgery_name", $$v)
        },
        expression: "model.step1.surgery.surgery_name"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "address_line_1",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "Address line 1",
        "errorText": _vm.errors.first('address_line_1'),
        "hintText": "Address line 1",
        "label": "Address line 1"
      },
      model: {
        value: (_vm.model.step1.surgery.address_line_1),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "address_line_1", $$v)
        },
        expression: "model.step1.surgery.address_line_1"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
      attrs: {
        "hintText": "Address line 2",
        "label": "Address line 2"
      },
      model: {
        value: (_vm.model.step1.surgery.address_line_2),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "address_line_2", $$v)
        },
        expression: "model.step1.surgery.address_line_2"
      }
    }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "desktop": "50",
        "tablet": "50",
        "width": "100"
      }
    }, [_c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "surgery_postcode",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "surgery postcode",
        "errorText": _vm.errors.first('surgery_postcode'),
        "hintText": "Postcode/Zip",
        "label": "Postcode/Zip"
      },
      model: {
        value: (_vm.model.step1.surgery.postcode),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "postcode", $$v)
        },
        expression: "model.step1.surgery.postcode"
      }
    }), _vm._v(" "), _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-rules": 'required',
        "data-vv-name": "surgery_city",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "surgery city",
        "errorText": _vm.errors.first('surgery_city'),
        "hintText": "City",
        "label": "City"
      },
      model: {
        value: (_vm.model.step1.surgery.city),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "city", $$v)
        },
        expression: "model.step1.surgery.city"
      }
    }), _vm._v(" "), _c('mu-text-field', {
      attrs: {
        "hintText": "County",
        "label": "County"
      },
      model: {
        value: (_vm.model.step1.surgery.county),
        callback: function($$v) {
          _vm.$set(_vm.model.step1.surgery, "county", $$v)
        },
        expression: "model.step1.surgery.county"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-col', {
      attrs: {
        "desktop": "100",
        "tablet": "100",
        "width": "100"
      }
    }, [(_vm.list.state.countries) ? _c('mu-select-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "scroller": _vm.scroller,
        "data-vv-rules": 'required',
        "data-vv-name": "country",
        "data-vv-value-path": "inputValue",
        "data-vv-as": "country",
        "errorText": _vm.errors.first('relationship'),
        "underlineShow": _vm.underlineShow,
        "fullWidth": "",
        "maxHeight": 300,
        "hintText": "Select country",
        "label": 'I live in'
      },
      model: {
        value: (_vm.model.step1.country_id),
        callback: function($$v) {
          _vm.$set(_vm.model.step1, "country_id", $$v)
        },
        expression: "model.step1.country_id"
      }
    }, _vm._l((_vm.list.state.countries), function(item, index) {
      return _c('mu-menu-item', {
        key: 'country-' + index,
        attrs: {
          "value": item.country_id,
          "title": item.country_name
        }
      })
    }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "100",
        "desktop": "100"
      }
    }, [_c('div', {
      staticClass: "goals"
    }, [_c('h2', [_vm._v("What goals are you hoping to achieve by joining the Low Carb Program?")]), _vm._v(" "), _vm._l((_vm.list.goals), function(goal, goalIndex) {
      return _c('div', {
        key: ("goal-" + goalIndex),
        staticClass: "goal"
      }, [_c('mu-checkbox', {
        attrs: {
          "name": "goal",
          "nativeValue": '' + goal.goal_id + '',
          "label": goal.goal
        },
        model: {
          value: (_vm.model.step1.goals),
          callback: function($$v) {
            _vm.$set(_vm.model.step1, "goals", $$v)
          },
          expression: "model.step1.goals"
        }
      })], 1)
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "agreement"
    }, [_c('p', [_vm._v("By continuing, you agree to our "), _c('a', {
      attrs: {
        "href": (_vm.siteUrl + "terms")
      }
    }, [_vm._v("Terms & Conditions")]), _vm._v(" and that you have read our "), _c('a', {
      attrs: {
        "href": (_vm.siteUrl + "privacy")
      }
    }, [_vm._v("Privacy Policy")]), _vm._v(", including our cookie policy")])])])], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (step.key === 'step2'),
        expression: "step.key === 'step2'"
      }]
    }, [_c('p', [_vm._v("We accept the following file types: PDF, GIF, JPG and PNG")]), _vm._v(" "), _c('p', [_vm._v("The following types of documentation are accepted:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Passport")]), _vm._v(" "), _c('li', [_vm._v("Driving licence")]), _vm._v(" "), _c('li', [_vm._v("State-issued licence or ID card")]), _vm._v(" "), _c('li', [_vm._v("Medical ID")]), _vm._v(" "), _c('li', [_vm._v("Professional certification")])]), _vm._v(" "), _c('mu-flexbox', {
      attrs: {
        "id": "dropzone",
        "justify": "space-between",
        "align": "center"
      }
    }, [_c('mu-flexbox-item', {
      staticClass: "area"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": "myFile",
        "multiple": "",
        "size": "1"
      },
      on: {
        "change": _vm.onFileChange
      }
    }), _vm._v(" "), (!_vm.hasSelectedFiles) ? _c('p', [_vm._v("Drag and drop a file here "), _c('br'), _vm._v(" or click to browse")]) : _vm._e(), _vm._v(" "), (_vm.hasSelectedFiles) ? _c('mu-row', _vm._l((_vm.model.step2.files), function(f, fileIndex) {
      return _c('mu-col', {
        key: ("file-" + fileIndex),
        attrs: {
          "width": "100",
          "tablet": "100",
          "desktop": "100"
        }
      }, [_c('mu-row', {
        staticClass: "file-row"
      }, [_c('mu-col', {
        attrs: {
          "width": "33",
          "tablet": "33",
          "desktop": "33"
        }
      }, [_c('span', {
        domProps: {
          "textContent": _vm._s(f.name)
        }
      })]), _vm._v(" "), _c('mu-col', {
        attrs: {
          "width": "33",
          "tablet": "33",
          "desktop": "33"
        }
      }, [_c('span', {
        domProps: {
          "textContent": _vm._s(_vm.convertSize(f.size))
        }
      })]), _vm._v(" "), _c('mu-col', {
        attrs: {
          "width": "33",
          "tablet": "33",
          "desktop": "33"
        }
      }, [_c('mu-icon-button', {
        staticClass: "removeFile",
        attrs: {
          "icon": "close"
        },
        on: {
          "click": function($event) {
            return _vm.removeFile(f)
          }
        }
      })], 1)], 1)], 1)
    }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "agreement"
    }, [_c('mu-checkbox', {
      attrs: {
        "label": "I confirm that I am the person represented in the submitted documents"
      },
      model: {
        value: (_vm.model.step2.agree),
        callback: function($$v) {
          _vm.$set(_vm.model.step2, "agree", $$v)
        },
        expression: "model.step2.agree"
      }
    })], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
      staticClass: "button",
      attrs: {
        "fullWidth": "",
        "label": _vm.isSaving ? 'Saving...' : 'Continue',
        "disabled": _vm.isSaving
      },
      on: {
        "click": _vm.nextStep
      }
    })], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isFinished) ? _c('div', {
    attrs: {
      "id": "hcpFinished"
    }
  }, [_c('mu-card', [_c('mu-card-header', [_c('mu-card-title', {
    attrs: {
      "title": "Thank you for verifying",
      "subTitle": 'Your ID documentation will be reviewed in the next 24 hours. You will recieve an email once your account is approved.'
    }
  })], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": "mu-popover"
    },
    on: {
      "after-enter": function($event) {
        return _vm.show()
      },
      "after-leave": function($event) {
        return _vm.hide()
      }
    }
  }, [(_vm.open) ? _c('div', {
    ref: "popup",
    staticClass: "mu-popover",
    class: _vm.popoverClass,
    style: ({
      'z-index': _vm.zIndex
    })
  }, [_vm._t("default")], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isHcpView) ? _c('div', {
    attrs: {
      "id": "lesson-scroller"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ls-header"
  }, [(_vm.$store.state.status.payment.paid) ? _c('div', {
    staticClass: "ls-header-text ellipsis"
  }, [(!_vm.isLoading && _vm.currentLessonObject) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.lessonScrollerWeekPrefix')))]) : _vm._e(), _vm._v(" "), _c('strong', [(_vm.currentLessonObject) ? _c('router-link', {
    attrs: {
      "to": 'lesson/' + _vm.currentLessonObject.permalink
    }
  }, [_c('span', {
    staticClass: "bold",
    domProps: {
      "textContent": _vm._s(!_vm.isLoading ? ' ' + _vm.currentLessonObject.week_name + ': ' + _vm.currentLessonObject.title : '')
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : '')
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ls-header-nav"
  }, [_c('button', {
    staticClass: "ls-nav-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isLeftLocked || _vm.isLoading
    },
    on: {
      "click": _vm.goLeft
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")])]), _vm._v(" "), _c('button', {
    staticClass: "ls-nav-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isRightLocked || _vm.isLoading
    },
    on: {
      "click": _vm.goRight
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    ref: "rail",
    staticClass: "ls-rail"
  }, [_vm._l((_vm.tiles), function(tile) {
    return [(tile.kind === 'loader') ? _c('div', {
      key: 'loader-' + tile.key,
      staticClass: "ls-tile dummyTile"
    }, [_vm._m(0, true)]) : (tile.kind === 'lesson') ? _c('div', {
      key: 'lesson-' + tile.key,
      staticClass: "ls-tile outerItem",
      class: {
        locked: tile.locked
      },
      attrs: {
        "data-lesson": tile.lessonNumber
      },
      on: {
        "click": function($event) {
          return _vm.goToPermalink(tile.data)
        }
      }
    }, [(tile.data.hasPersonalization) ? _c('span', {
      staticClass: "ls-chip ls-chip--personalized"
    }, [_vm._v(_vm._s(_vm.$t('message.labelPersonalized')))]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": tile.data.image_url,
        "alt": tile.data.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-titlebar"
    }, [_c('div', {
      staticClass: "ls-titles"
    }, [_c('div', {
      staticClass: "ls-title",
      domProps: {
        "textContent": _vm._s(tile.data.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-subtitle",
      domProps: {
        "textContent": _vm._s(tile.data.week_name.replace('Week', _vm.$t('message.labelWeek')))
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "ls-action",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(tile.locked ? 'lock' : 'play_arrow'))])])])]) : _c('div', {
      key: 'bonus-' + tile.key,
      staticClass: "ls-tile innerItem",
      class: {
        locked: tile.locked
      },
      on: {
        "click": function($event) {
          return _vm.goToBonus(tile.data, tile.parent)
        }
      }
    }, [_c('span', {
      staticClass: "ls-chip ls-chip--bonus"
    }, [_vm._v(_vm._s(_vm.$t('message.labelBonus')))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": tile.data.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-titlebar"
    }, [_c('div', {
      staticClass: "ls-titles"
    }, [_c('div', {
      staticClass: "ls-title",
      domProps: {
        "textContent": _vm._s(tile.data.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-subtitle",
      domProps: {
        "textContent": _vm._s(tile.data.subTitle.replace('Week', _vm.$t('message.labelWeek')))
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "ls-action",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(tile.locked ? 'lock' : 'play_arrow'))])])])])]
  })], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-titlebar"
  }, [_c('div', {
    staticClass: "ls-titles"
  }, [_c('div', {
    staticClass: "ls-loader-bar wide"
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-loader-bar"
  })])])
}]}

/***/ }),
/* 3808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "coaching"
    }
  }, [_c('h1', [_vm._v("Keep connected with virtual meet-ups and one-to-one coaching")]), _vm._v(" "), _c('p', [_vm._v("Join weekly virtual meetups and stay connected with coaches and friends from around the globe.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "coachingCards"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('coaching-card', {
    staticStyle: {
      "min-height": "540px"
    },
    attrs: {
      "image": "https://res.cloudinary.com/grohealth/image/upload/v1610543180/Low%20Carb%20Program/UI-Assets/5fd1e9e75ac081c56b819597_evening-meetups-p-500.webp",
      "title": "Monday night meet up",
      "text": "Join our original Monday night meet up, hosted by our very own Health coaches. This meet up has been long-standing and is ideal for those who have been attending the meet ups for some time. It’s a great way to kickstart your week on a positive note and keep you feeling motivated. The Health coaches will be speaking to you about a different topic each week, followed by a good old catch up with your fellow members.",
      "list": ['Get support from your mentors', 'Meet others on the same journey'],
      "buttonText": "More about Monday meet ups",
      "buttonLink": "life/low-carb-programs-virtual-meet-up-monday-6pm"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('coaching-card', {
    attrs: {
      "image": "static/weighin.png",
      "title": "Wednesday Meet ups",
      "text": "If you are new to the Low Carb Program, then this is a must do meet up for you! On this meet up you can expect to hear your mentor cover topics for beginners, who are new to the program and low carb approach. It is also a great way to ask questions and meet with other members at a similar point of their journey to you.",
      "list": ['Get support from your mentors', 'Something else'],
      "buttonText": "More about Wednesday meet ups",
      "buttonLink": "life/low-carb-newbie-meet-up-wednesday-6pm"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('coaching-card', {
    attrs: {
      "image": "https://res.cloudinary.com/grohealth/image/upload/v1612266366/Low%20Carb%20Program/UI-Assets/601907ca6ba8ee0341514d3a_antonia-remote-p-500.webp",
      "title": "Low Carb Program daily drop in sessions",
      "text": "You can drop in and visit us at 11am any day of the working week. This is a great session to use if you are new to the Low Carb Program, unsure of where to get started or looking for some help on how to use the various features available.",
      "list": ['A chance to ask questions', 'Find support and motivation every day'],
      "buttonText": "More about Daily Drop-in Sessions",
      "buttonLink": "life/january-bootcamp-drop-in-sessions"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "supportCard"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "supportInfo"
  }, [_c('h2', [_vm._v("Need some one-to-one support?")]), _vm._v(" "), _c('p', [_vm._v("If you feel like you could do with some more personal support, or just prefer some privacy, then one-to-one coaching is for you.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Meet your personal health coach and mentor.")]), _vm._v(" "), _c('li', [_vm._v("Get help on how to make the most out of the Program.")]), _vm._v(" "), _c('li', [_vm._v("Create short and long-term goals to better your health.")]), _vm._v(" "), _c('li', [_vm._v("Receive support on how to tailor the low carb lifestyle for you.")])]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "label": "Purchase one-to-one coaching",
      "href": "https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "stepsCard"
  }, [_c('h2', [_vm._v("How it works")]), _vm._v(" "), _c('p', [_vm._v("Follow these three simple steps to book in with your health coach and start your journey to better health today.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "label": "Purchase one-to-one coaching",
      "href": "https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "marginBottom"
  }, [_vm._v("We currently host 2 meet-ups each week, with one-to-one time "), _c('a', {
    attrs: {
      "href": "https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
    }
  }, [_vm._v("available for purchase from our shop")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepList"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "stepNumber"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "stepText"
  }, [_c('p', [_vm._v("Purchase your Health Coaching session from the Low Carb Program Shop.")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "stepNumber"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "stepText"
  }, [_c('p', [_vm._v("Use the link in the receipt email to book a coaching session with a coach of your choice. Choose the date and time to suit you.")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "stepNumber"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "stepText"
  }, [_c('p', [_vm._v("Join the 30-minute session using your phone or computer using Zoom.")])])])])
}]}

/***/ }),
/* 3809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-paper', {
    staticClass: "insetGraph"
  }, [_c('mu-row', {
    staticClass: "headingRow"
  }, [_c('mu-col', {
    staticClass: "deviceHeading",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "75"
    }
  }, [(_vm.service != 'LCP') ? _c('mu-row', [(_vm.service != 'LCP') ? _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subtractDay.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "70",
      "tablet": "70",
      "desktop": "70"
    }
  }, [_c('span', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.humanizeDate)
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right",
      "disabled": _vm.isToday
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDay.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "25"
    }
  }, [_c('service-tracking-types', {
    attrs: {
      "type": "sleep"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$store.state.user.scope && _vm.service === 'LCP') ? _c('sleep-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'FITBIT') ? _c('fitbit-sleep-graph', {
    attrs: {
      "fitbitData": _vm.fitbitData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'STRIIV') ? _c('striiv-sleep-graph', {
    attrs: {
      "striivData": _vm.striivData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading && _vm.service != 'LCP') ? _c('mu-card', {
    staticClass: "card-spacing",
    staticStyle: {
      "min-height": "430px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_vm._v("\n\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n\n        "), _c('mu-circular-progress')], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticStyle: {
      "padding-top": "24px"
    },
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [(_vm.isLoading && _vm.service != 'LCP') ? _c('mu-card', {
    staticClass: "card-spacing",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_c('mu-circular-progress')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'STRIIV') ? _c('striiv-sleep-stages', {
    staticClass: "card-spacing",
    attrs: {
      "striivData": _vm.striivData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'FITBIT') ? _c('fitbit-sleep-stages', {
    staticClass: "card-spacing",
    attrs: {
      "fitbitData": _vm.fitbitData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e(), _vm._v(" "), _c('sleep-input', {
    staticClass: "card-spacing"
  }), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "sleep"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "DEVICE"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'DEVICE'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelFromDevice').charAt(0).toUpperCase() + _vm.$t('message.labelFromDevice').substr(1)))]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "SELF_REPORTED"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'SELF_REPORTED'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelManualEntry')))])], 1), _vm._v(" "), _c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardSleepQuality')) + ": " + _vm._s(item.quality) + "/10")])]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                        " + _vm._s(_vm.humanizedHours(item.hours)) + "\n                      ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('sleep-edit', {
        attrs: {
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()])], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "reg-form"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelLetsGetStarted'),
      "titleClass": "regTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.$route.query.hcp) ? _c('p', [_vm._v("Enter the basics to begin personalising your Low Carb Program experience. If\n      you already have an account, "), (_vm.model.offerCode) ? _c('span', [_c('router-link', {
    attrs: {
      "to": ("/login?oc=" + (_vm.model.offerCode))
    }
  }, [_vm._v("click here to log in")])], 1) : _c('span', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("click here to log in")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttonWrap"
  }, [_c('mu-flexbox', {
    attrs: {
      "orient": "vertical"
    }
  }, _vm._l((_vm.providers), function(provider, index) {
    return _c('mu-flexbox-item', {
      key: ("provider-" + index)
    }, [_c('mu-raised-button', {
      staticClass: "loginButton",
      class: {
        darkTextButton: provider.brandColour === '#ffffff',
        buttonImageOnly: !provider.buttonText || !provider.buttonText.length
      },
      style: ({
        backgroundColor: provider.brandColour,
        backgroundImage: provider.buttonText ? '' : ("url(" + (provider.image) + ")")
      }),
      attrs: {
        "type": "button",
        "full-width": "",
        "label": provider.buttonText && provider.buttonText.length ? provider.title.toString().replace(/^/, 'Register using ') : '',
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.connectAccount(provider.connectUrl)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": provider.image
      }
    })])], 1)
  }), 1)], 1), _vm._v(" "), (_vm.$route.query.hcp) ? _c('p', [_vm._v("Join the free Healthcare Professional Platform")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "align": "baseline"
    }
  }, [_c('mu-flexbox-item', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "id": "firstnameTxt",
      "data-vv-name": "first_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesFirstName'),
      "errorText": _vm.errors.first('first_name'),
      "label": _vm.$t('message.labelYourName'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesFirstName'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.firstname),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstname", $$v)
      },
      expression: "model.firstname"
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "id": "surnameTxt",
      "label": "",
      "data-vv-name": "last_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesSurname'),
      "errorText": _vm.errors.first('last_name'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesSurname'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.surname),
      callback: function($$v) {
        _vm.$set(_vm.model, "surname", $$v)
      },
      expression: "model.surname"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "emailTxt",
      "data-vv-name": "email",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "errorText": _vm.errors.first('email'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "emailTxtV",
      "data-vv-name": "emailVerify",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesEmailVerify'),
      "errorText": _vm.errors.first('emailVerify'),
      "label": _vm.$t('message.accountPreferencesEmailVerify'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.emailVerify),
      callback: function($$v) {
        _vm.$set(_vm.model, "emailVerify", $$v)
      },
      expression: "model.emailVerify"
    }
  }), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    ref: "password",
    staticClass: "pw-field",
    attrs: {
      "id": "passwordTxt",
      "type": _vm.model.visible === true ? 'text' : 'password',
      "data-vv-rules": 'required',
      "data-vv-name": "password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesPassword'),
      "label": _vm.$t('message.accountPreferencesPassword'),
      "hintText": _vm.$t('message.accountPreferencesPassword'),
      "errorText": _vm.errors.first('password'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.$set(_vm.model, "password", $$v)
      },
      expression: "model.password"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.model.visible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.model.visible = !_vm.model.visible
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('password-limit-validation', {
    attrs: {
      "password": _vm.model.password
    }
  }), _vm._v(" "), _c('password-strength-validation', {
    attrs: {
      "password": _vm.model.password
    }
  }), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "passwordTxtV",
      "type": _vm.model.verifyVisible === true ? 'text' : 'password',
      "data-vv-rules": 'required|confirmed:password',
      "data-vv-name": "passwordVerify",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesPasswordVerify'),
      "label": _vm.$t('message.accountPreferencesPasswordVerify'),
      "hintText": _vm.$t('message.accountPreferencesPasswordVerify'),
      "errorText": _vm.confirmPassErr,
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.passwordVerify),
      callback: function($$v) {
        _vm.$set(_vm.model, "passwordVerify", $$v)
      },
      expression: "model.passwordVerify"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.model.verifyVisible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.model.verifyVisible = !_vm.model.verifyVisible
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n        Date of birth\n      ")]), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.day),
      expression: "dob.day"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_day')
    },
    attrs: {
      "name": "birth_day",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-as": "day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Day")]), _vm._v(" "), _vm._l((_vm.dobItems.days), function(day, index) {
    return _c('option', {
      key: 'day-' + index,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.month),
      expression: "dob.month"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_month')
    },
    attrs: {
      "name": "birth_month",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-as": "month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._m(0)], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.year),
      expression: "dob.year"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_year')
    },
    attrs: {
      "name": "birth_year",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-as": "year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._m(1)], 2)])], 1), _vm._v(" "), _c('p', {
    staticClass: "privacyDisclaimer",
    on: {
      "click": _vm.setTerms
    }
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.model.terms),
      callback: function($$v) {
        _vm.$set(_vm.model, "terms", $$v)
      },
      expression: "model.terms"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.registerTermsByContinuing')) + "\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "terms"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerTermsAndCondtions')))])], 1), _vm._v(" "), _c('p', {
    staticClass: "privacyDisclaimer",
    on: {
      "click": _vm.setPrivacyPolicy
    }
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.model.privacyPolicy),
      callback: function($$v) {
        _vm.$set(_vm.model, "privacyPolicy", $$v)
      },
      expression: "model.privacyPolicy"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.registerTermsByContinuing')) + "\n\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "privacy"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerPrivacyPolicy')))]), _vm._v("\n        including\n        "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "cookies"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerIncludingCookie')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('VueRecaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.captchaSiteKey,
      "loadRecaptchaScript": false
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": _vm.isSaving ? _vm.$t('message.labelProcessing') : _vm.$t('message.registerAppBarText'),
      "disabled": _vm.isSaving,
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1), _vm._v(" "), (_vm.isServerValidationError) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.serverValidationErrorText) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.registerErrorUserExists')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isTermsError) ? _c('alert', {
    staticStyle: {
      "margin-top": "24px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Please agree to our terms and conditions\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isPrivacyPolicyError) ? _c('alert', {
    staticStyle: {
      "margin-top": "24px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Please agree to our privacy policy\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isServerValidationError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          " + _vm._s(_vm.serverValidationErrorText) + "\n        ")])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('option', {
      key: 'month-' + index,
      domProps: {
        "value": month
      }
    }, [_vm._v(_vm._s(_vm.localizeMonth(month.name)) + "\n            ")])
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('option', {
      key: 'year-' + index,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year.value) + "\n            ")])
  })
}]}

/***/ }),
/* 3811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "90",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": "TIME",
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": "DATE",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": "required|min_value:30|max_value:300",
      "data-vv-name": "systolic",
      "data-vv-as": "Systolic",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('systolic'),
      "type": "number",
      "label": _vm.$t('message.labelSystolic'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.systolic),
      callback: function($$v) {
        _vm.$set(_vm.reading, "systolic", _vm._n($$v))
      },
      expression: "reading.systolic"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": "required|min_value:30|max_value:300",
      "data-vv-name": "diastolic",
      "data-vv-as": "Diastolic",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('diastolic'),
      "type": "number",
      "label": _vm.$t('message.labelDiastolic'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.diastolic),
      callback: function($$v) {
        _vm.$set(_vm.reading, "diastolic", _vm._n($$v))
      },
      expression: "reading.diastolic"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": 4
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n       " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "noPaddingBottom"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "ethnicityTxt",
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "ethnicity",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "ethnicity",
      "errorText": _vm.errors.first('ethnicity'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.accountPreferencesEthnicity'),
      "label": _vm.$t('message.accountPreferencesEthnicity')
    },
    model: {
      value: (_vm.model.ethnicity_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "ethnicity_id", $$v)
      },
      expression: "model.ethnicity_id"
    }
  }, _vm._l((_vm.lists.ethnicities), function(item, index) {
    return _c('mu-menu-item', {
      key: 'ethnicity-' + index,
      attrs: {
        "title": _vm.$t(_vm.localizeEthnicity(item.ethnicity_id)),
        "value": item.ethnicity_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "languageTxt",
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "language",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "language",
      "errorText": _vm.errors.first('language'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesLanguage')
    },
    model: {
      value: (_vm.model.language_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "language_id", $$v)
      },
      expression: "model.language_id"
    }
  }, _vm._l((_vm.lists.languages), function(item, index) {
    return _c('mu-menu-item', {
      key: 'language-' + index,
      attrs: {
        "value": item.id,
        "title": _vm.getNativeName(item.iso)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "occupationTxt",
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "occupation",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesOccupation'),
      "errorText": _vm.errors.first('occupation'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": "Select",
      "label": _vm.$t('message.accountPreferencesOccupation')
    },
    model: {
      value: (_vm.model.occupation_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "occupation_id", $$v)
      },
      expression: "model.occupation_id"
    }
  }, _vm._l((_vm.lists.occupations), function(item, index) {
    return _c('mu-menu-item', {
      key: 'occupatation-' + index,
      attrs: {
        "value": item.occupation_id,
        "title": _vm.localizeOccupation(item.occupation_name)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1), _vm._v(" "), _c('mu-card-header', {
    staticClass: "noPaddingTop",
    attrs: {
      "title": _vm.$t('message.gettingStartedPersonalizeFoodsTitle'),
      "subTitle": _vm.$t('message.gettingStartedPersonalizeFoodsSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "favouriteSearch"
    }
  }, [_c('mu-auto-complete', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "id": "searchFoodTxt",
      "scroller": _vm.scroller,
      "fullWidth": _vm.fullWidth,
      "filter": "noFilter",
      "hintText": _vm.$t('message.labelStartTyping'),
      "maxHeight": 250,
      "openOnFocus": true,
      "dataSource": _vm.favouriteDataSource,
      "dataSourceConfig": _vm.foodDataSourceConfig,
      "icon": "search"
    },
    on: {
      "change": _vm.handleFavouriteSelected
    },
    model: {
      value: (_vm.favouriteSearch),
      callback: function($$v) {
        _vm.favouriteSearch = $$v
      },
      expression: "favouriteSearch"
    }
  }), _vm._v(" "), (_vm.foodSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "size": 16
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.favouriteModel), function(item, index) {
    return _c('mu-chip', {
      key: 'favorite-' + index
    }, [_c('mu-icon', {
      attrs: {
        "value": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.favouriteModel.splice(index, 1)
        }
      }
    }), _vm._v("\n                " + _vm._s(item.food_name) + "\n              ")], 1)
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1), _vm._v(" "), _c('mu-card-header', {
    staticClass: "noPaddingTop",
    attrs: {
      "title": _vm.$t('message.gettingStartedPersonalizeDietaryPreferencesTitle'),
      "subTitle": _vm.$t('message.gettingStartedPersonalizeDietaryPreferencesSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "noPaddingBottom"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "100"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "dietaryPreferenceTxt",
      "scroller": _vm.scroller,
      "autoWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "dietry_preference",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDietaryPreference'),
      "errorText": _vm.errors.first('dietry_preference'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesDietaryPreference')
    },
    model: {
      value: (_vm.model.dietry_preference_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "dietry_preference_id", $$v)
      },
      expression: "model.dietry_preference_id"
    }
  }, _vm._l((_vm.lists.dietry_preferences), function(item, index) {
    return _c('mu-menu-item', {
      key: 'dietary-preference-' + index,
      attrs: {
        "value": item.dietry_preference_id,
        "title": _vm.localizeDietPreference(item.name)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "id": "allergiesTxt",
      "scroller": _vm.scroller,
      "multiple": "",
      "separator": ", ",
      "autoWidth": "",
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesAllergies')
    },
    model: {
      value: (_vm.model.allergies),
      callback: function($$v) {
        _vm.$set(_vm.model, "allergies", $$v)
      },
      expression: "model.allergies"
    }
  }, _vm._l((_vm.lists.allergies), function(item, index) {
    return _c('mu-menu-item', {
      key: 'allergy-' + index,
      attrs: {
        "value": item.allergy_id,
        "title": _vm.localizeAllergy(item.name)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.currency.currency) ? _c('currency-input', {
    attrs: {
      "label": _vm.$t('message.accountPreferencesShopCost'),
      "currency": _vm.currency.currency
    },
    model: {
      value: (_vm.model.weekly_shop_cost),
      callback: function($$v) {
        _vm.$set(_vm.model, "weekly_shop_cost", _vm._n($$v))
      },
      expression: "model.weekly_shop_cost"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-row'), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1), _vm._v(" "), _c('mu-card-header', {
    staticClass: "noPaddingTop",
    attrs: {
      "title": _vm.$t('message.gettingStartedPersonalizeHealthTitle'),
      "subTitle": _vm.$t('message.gettingStartedPersonalizeHealthSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  }, [(_vm.settings.hba1c && _vm.isDiabetic) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.activeHba1cType.measure === 'percentage'),
      expression: "activeHba1cType.measure === 'percentage'"
    }],
    attrs: {
      "id": "hba1cPercentTxt",
      "data-vv-name": "hba1c_percent",
      "data-vv-rules": 'min_value:3|max_value:25',
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c",
      "errorText": _vm.errors.first('hba1c_percent'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth,
      "label": "HbA1c"
    },
    model: {
      value: (_vm.hba1cModel.percent),
      callback: function($$v) {
        _vm.$set(_vm.hba1cModel, "percent", _vm._n($$v))
      },
      expression: "hba1cModel.percent"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.activeHba1cType.measure === 'mmol-mol'),
      expression: "activeHba1cType.measure === 'mmol-mol'"
    }],
    attrs: {
      "id": "hba1cMmolmolTxt",
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-rules": 'min_value:8|max_value:300',
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth,
      "label": "HbA1c"
    },
    model: {
      value: (_vm.hba1cModel.mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.hba1cModel, "mmol_mol", _vm._n($$v))
      },
      expression: "hba1cModel.mmol_mol"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "hba1cSettingTxt",
      "autoWidth": "",
      "data-vv-name": "hba1c",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c",
      "errorText": _vm.errors.first('hba1c'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "hintText": "Select",
      "label": ' '
    },
    model: {
      value: (_vm.settingsModel.hba1c),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "hba1c", $$v)
      },
      expression: "settingsModel.hba1c"
    }
  }, _vm._l((_vm.settings.hba1c.dropdown), function(item, index) {
    return _c('mu-menu-item', {
      key: 'hba1c-dropdown-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isDiabetic) ? _c('mu-row', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "hba1cEvaluationTxt",
      "autoWidth": "",
      "data-vv-name": "hba1c_month_id",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c evaluation",
      "autoWidth": "",
      "errorText": _vm.errors.first('hba1c_month_id'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "label": _vm.$t('message.labelLastHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.hba1c_month_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_month_id", $$v)
      },
      expression: "model.hba1c_month_id"
    }
  }, _vm._l((_vm.lists.hba1c_months), function(item, index) {
    return _c('mu-menu-item', {
      key: 'hba1c-month-' + index,
      attrs: {
        "value": item.id,
        "title": item.name
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settings.height) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingsModel.height === 1),
      expression: "settingsModel.height === 1"
    }]
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.settingsModel.height === 1) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:8'),
      expression: "'required|min_value:0|max_value:8'"
    }],
    attrs: {
      "id": "heightFtTxt",
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_ft",
      "data-vv-as": "ft",
      "errorText": _vm.errors.first('height_ft'),
      "min": 0,
      "max": 8,
      "hintText": _vm.$t('message.placeholderText'),
      "helpText": "FT",
      "label": _vm.$t('message.labelHeight'),
      "type": "number",
      "fullWidth": ""
    },
    model: {
      value: (_vm.heightModel.ft),
      callback: function($$v) {
        _vm.$set(_vm.heightModel, "ft", _vm._n($$v))
      },
      expression: "heightModel.ft"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.settingsModel.height === 1) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:11'),
      expression: "'required|min_value:0|max_value:11'"
    }],
    attrs: {
      "id": "heightInTxt",
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_in",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('height_in'),
      "min": 0,
      "max": 11,
      "hintText": _vm.$t('message.placeholderText'),
      "helpText": "IN",
      "label": " ",
      "type": "number",
      "fullWidth": ""
    },
    model: {
      value: (_vm.heightModel.in),
      callback: function($$v) {
        _vm.$set(_vm.heightModel, "in", _vm._n($$v))
      },
      expression: "heightModel.in"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingsModel.height === 2),
      expression: "settingsModel.height === 2"
    }]
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [(_vm.settingsModel.height === 2) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:50|max_value:251'),
      expression: "'required|min_value:50|max_value:251'"
    }],
    attrs: {
      "id": "heightCmTxt",
      "data-vv-name": "height_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "errorText": _vm.errors.first('height_cm'),
      "label": "Height",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth,
      "type": "number"
    },
    model: {
      value: (_vm.heightModel.cm),
      callback: function($$v) {
        _vm.$set(_vm.heightModel, "cm", _vm._n($$v))
      },
      expression: "heightModel.cm"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "heightSettingsTxt",
      "autoWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "height",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "height",
      "errorText": _vm.errors.first('height'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": "Select",
      "label": ' '
    },
    model: {
      value: (_vm.settingsModel.height),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "height", $$v)
      },
      expression: "settingsModel.height"
    }
  }, _vm._l((_vm.settings.height.dropdown), function(item, index) {
    return _c('mu-menu-item', {
      key: 'height-dropdown-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settings.weight) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [(_vm.settingsModel.weight === 1) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightKgTxt",
      "min": 20,
      "max": 750,
      "data-vv-rules": 'required|min_value:20|max_value:635',
      "data-vv-name": "weight_kg",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "kg",
      "errorText": _vm.errors.first('weight_kg'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.cardWeight'),
      "type": "number"
    },
    model: {
      value: (_vm.weightModel.kg),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "kg", _vm._n($$v))
      },
      expression: "weightModel.kg"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingsModel.weight === 2) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightLbsTxt",
      "min": 0,
      "max": 1102,
      "data-vv-rules": 'required|min_value:20|max_value:1400',
      "data-vv-name": "weight_lbs",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "lbs",
      "errorText": _vm.errors.first('weight_lbs'),
      "label": _vm.$t('message.cardWeight'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.weightModel.lbs),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "lbs", _vm._n($$v))
      },
      expression: "weightModel.lbs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingsModel.weight === 3) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "width": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightStonesTxt",
      "min": 0,
      "max": 92,
      "data-vv-rules": 'required|min_value:0|max_value:92',
      "data-vv-name": "stones",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "stones",
      "errorText": _vm.errors.first('stones'),
      "label": _vm.$t('message.cardWeight'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "helpText": "ST",
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.weightModel.stones),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "stones", _vm._n($$v))
      },
      expression: "weightModel.stones"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "width": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightPoundsTxt",
      "min": 0,
      "max": 13,
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "pounds",
      "errorText": _vm.errors.first('pounds'),
      "label": " ",
      "helpText": "LBS",
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.weightModel.pounds),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "pounds", _vm._n($$v))
      },
      expression: "weightModel.pounds"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightSettingsTxt",
      "autoWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "weight",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "weight",
      "errorText": _vm.errors.first('weight'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": ' '
    },
    model: {
      value: (_vm.settingsModel.weight),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "weight", $$v)
      },
      expression: "settingsModel.weight"
    }
  }, _vm._l((_vm.settings.weight.dropdown), function(item, index) {
    return _c('mu-menu-item', {
      key: 'weight-dropdown-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "fullWidth": true,
      "secondary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [(_vm.preference === 'cm') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:1000',
      "data-vv-name": "waist_cm",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('waist_cm'),
      "type": "number",
      "label": "waist cm",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.waist_cm),
      callback: function($$v) {
        _vm.$set(_vm.reading, "waist_cm", _vm._n($$v))
      },
      expression: "reading.waist_cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'cm') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:1000',
      "data-vv-name": "hip_cm",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hip_cm'),
      "type": "number",
      "label": "hip cm",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.hip_cm),
      callback: function($$v) {
        _vm.$set(_vm.reading, "hip_cm", _vm._n($$v))
      },
      expression: "reading.hip_cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:1000',
      "data-vv-name": "waist_in",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('waist_in'),
      "type": "number",
      "label": "waist in",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.waist_in),
      callback: function($$v) {
        _vm.$set(_vm.reading, "waist_in", _vm._n($$v))
      },
      expression: "reading.waist_in"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:1000',
      "data-vv-name": "hip_in",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hip_in'),
      "type": "number",
      "label": "hip in",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.hip_in),
      callback: function($$v) {
        _vm.$set(_vm.reading, "hip_in", _vm._n($$v))
      },
      expression: "reading.hip_in"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SubscriptionWrap"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "paymentModal loading"
  }, [_c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal"
  }, [(!_vm.isPaymentCancelled && !_vm.hasPaymentProcessed) ? _c('div', {
    staticClass: "block payment"
  }, [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "55",
      "tablet": "55",
      "width": "100"
    }
  }, [_c('div', {
    staticClass: "choose-plan"
  }, [_c('h2', [_vm._v("Choose your plan")]), _vm._v(" "), _c('p', [_vm._v("Get access to the world's largest low carb community, multi-award winning education, daily meal plans,\n              recipes and more!")]), _vm._v(" "), _c('div', {
    staticClass: "discount-code"
  }, [_c('h3', [_vm._v("Got a discount code?")]), _vm._v(" "), _c('p', [_vm._v("Choose your plan, then enter your code at checkout.")])]), _vm._v(" "), (_vm.discountData) ? _c('div', {
    staticClass: "payment-plans"
  }, [_vm._l((_vm.prices), function(price, index) {
    return _c('div', [_c('div', {
      key: ("price-" + index),
      staticClass: "subscription",
      class: {
        'yearly': price.description === 'Yearly',
        'monthly': price.description !== 'Yearly'
      },
      on: {
        "click": function($event) {
          return _vm.createStripeSession(price)
        }
      }
    }, [_c('div', {
      staticClass: "overlay",
      nativeOn: {
        "click": function($event) {
          return _vm.createStripeSession(price)
        }
      }
    }, [_c('mu-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!price.selected),
        expression: "!price.selected"
      }],
      staticClass: "radio unchecked",
      attrs: {
        "value": "radio_button_unchecked"
      }
    }), _vm._v(" "), _c('mu-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (price.selected),
        expression: "price.selected"
      }],
      staticClass: "radio checked",
      attrs: {
        "value": "radio_button_checked"
      }
    }), _vm._v(" "), _c('strong', {
      staticClass: "itemName",
      domProps: {
        "textContent": _vm._s(price.description)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "itemPrice"
    }, [_vm._v("\n                " + _vm._s(price.amount) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "itemDesc",
      domProps: {
        "innerHTML": _vm._s(price.extra ? price.extra : price.extra_description)
      }
    }), _vm._v(" "), (price.percentageOffForCurrentUser > 0) ? _c('div', {
      staticClass: "discount"
    }, [_c('span', [_vm._v("Save " + _vm._s(price.percentageOffForCurrentUser) + "%")])]) : _vm._e()], 1)])])
  }), _vm._v(" "), _c('stripe-checkout', {
    ref: "sessionCheckoutRef",
    attrs: {
      "pk": _vm.publishableKey,
      "session-id": _vm.sessionId
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('p', [_vm._v("Recurring billing, cancel anytime.")]), _vm._v(" "), _c('p', [_vm._v("By continuing, you accept our "), _c('a', {
    attrs: {
      "href": _vm.Config('siteUrl') + 'terms',
      "target": "_blank"
    }
  }, [_vm._v("Terms and\n                Conditions")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": _vm.Config('siteUrl') + 'privacy',
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.Config('siteUrl') + 'billing-terms',
      "target": "_blank"
    }
  }, [_vm._v("Billing Terms")])]), _vm._v(" "), (_vm.selectedPackage) ? _c('div', {
    staticClass: "processing"
  }, [_c('p', [_vm._v("Processing...")])]) : _vm._e()])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "45",
      "tablet": "45",
      "width": "100"
    }
  }, [_c('h2', {
    staticClass: "whySub"
  }, [_vm._v("Why subscribe?")]), _vm._v(" "), _c('div', {
    staticClass: "benefits"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Award-winning, proven education on how to embrace a low carb lifestyle")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Practical Action Points to achieve your health goals")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Daily meal plans for 12 weeks to start and sustain your journey")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Over 1,800 searchable recipes and meal plans tailored to your preferences")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Group and one-to-one virtual meetups with expert coaches")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Peer support from " + _vm._s(_vm.numeral(_vm.stats.count).format('0,0')) + " members")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Integrated food diary with food search and barcode scanner")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Integrated health tracking and data exporting")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Daily updated news, research and guidance")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Access on the web, iOS, Android and Alexa")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Sync your data with Apple Health, Google Fit and FitBit")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Regularly updated features and enhancements")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Access on Apple Watch and Android Watch")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Friendly technical support")])])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentCancelled) ? _c('div', {
    staticClass: "block cancelled"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailed')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailedExplain')))]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "label": "Try again"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Subscription')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPaymentProcessed) ? _c('div', {
    staticClass: "block success"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Package")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.getParam('item_name')) + "\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Subscription ID")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.getParam('subscr_id')) + "\n          ")])]), _vm._v(" "), (_vm.getParam('trialbillingperiod')) ? _c('tr', [_c('td', [_vm._v("\n            Trial period\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('trialbillingperiod')))])]) : _vm._e(), _vm._v(" "), (_vm.getParam('trialamt')) ? _c('tr', [_c('td', [_vm._v("Trial price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('trialamt')) + " " + _vm._s(_vm.getParam('cc')))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('amt')) + " " + _vm._s(_vm.getParam('cc')))])])])]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "label": "Get started",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.continueProgram()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titleLink"
  }, [_c('router-link', {
    attrs: {
      "to": '/register/amend'
    }
  }, [_vm._v("Need to update your details?\n      ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal"
  }, [_c('h2', [_vm._v("Been referred by your healthcare team?")]), _vm._v(" "), _c('p', [_vm._v("Enter your referral code below to access the Low Carb Program.")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "voucherForm",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "voucher"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "tablet": "70",
      "desktop": "70",
      "width": "70"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "id": "voucherTxt",
      "hintText": "Referral code (this is different from a discount code)",
      "fullWidth": "",
      "min": 20
    },
    model: {
      value: (_vm.voucher.code),
      callback: function($$v) {
        _vm.$set(_vm.voucher, "code", $$v)
      },
      expression: "voucher.code"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30",
      "width": "30"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "apply",
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": "Check code",
      "disabled": (_vm.voucher.code.length <= 3) || _vm.voucher.isSending,
      "color": "#FFF",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "message",
    class: {
      error: _vm.voucher.error === true,
      success: _vm.voucher.error === false
    },
    domProps: {
      "textContent": _vm._s(_vm.voucher.isSending ? 'Processing...' : _vm.voucher.message)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "discount-text"
  }, [_vm._v("Got a discount code? Select a plan above and enter it at checkout")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesQuestions')
    },
    on: {
      "click": function($event) {
        _vm.model.questions = !_vm.model.questions
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesQuestionsExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.questions),
      callback: function($$v) {
        _vm.$set(_vm.model, "questions", $$v)
      },
      expression: "model.questions"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesFood')
    },
    on: {
      "click": function($event) {
        _vm.model.food = !_vm.model.food
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesFoodExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.food),
      callback: function($$v) {
        _vm.$set(_vm.model, "food", $$v)
      },
      expression: "model.food"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesProgress')
    },
    on: {
      "click": function($event) {
        _vm.model.progress = !_vm.model.progress
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesProgressExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.progress),
      callback: function($$v) {
        _vm.$set(_vm.model, "progress", $$v)
      },
      expression: "model.progress"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.privacyPreferencesAbout')
    },
    on: {
      "click": function($event) {
        _vm.model.information = !_vm.model.information
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.privacyPreferencesAboutExplain')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.information),
      callback: function($$v) {
        _vm.$set(_vm.model, "information", $$v)
      },
      expression: "model.information"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('abstract-button', {
    ref: "button",
    staticClass: "mu-menu-item-wrapper",
    class: {
      'active': _vm.active
    },
    attrs: {
      "href": _vm.href,
      "target": _vm.target,
      "centerRipple": false,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "disableFocusRipple": _vm.disableFocusRipple,
      "disabled": _vm.disabled,
      "containerElement": "div"
    },
    on: {
      "click": _vm.handleClick,
      "keyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [_c('div', {
    staticClass: "mu-menu-item",
    class: {
      'have-left-icon': _vm.leftIcon || _vm.inset
    }
  }, [_c('icon', {
    staticClass: "mu-menu-item-left-icon",
    class: _vm.leftIconClass,
    style: ({
      'color': _vm.filterColor(_vm.leftIconColor)
    }),
    attrs: {
      "value": _vm.leftIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-menu-item-title",
    class: _vm.titleClass
  }, [_vm._t("title", function() {
    return [_vm._v("\n           " + _vm._s(_vm.title) + "\n         ")]
  })], 2), _vm._v(" "), (!_vm.rightIcon) ? _c('div', [(_vm.showAfterText) ? _c('span', {
    class: _vm.afterTextClass
  }, [_vm._v(_vm._s(_vm.afterText))]) : _vm._e(), _vm._v(" "), _vm._t("after")], 2) : _vm._e(), _vm._v(" "), _c('icon', {
    staticClass: "mu-menu-item-right-icon",
    class: _vm.rightIconClass,
    style: ({
      'color': _vm.filterColor(_vm.rightIconColor)
    }),
    attrs: {
      "value": _vm.rightIcon
    }
  })], 1)]), _vm._v(" "), (_vm.$slots && _vm.$slots.default && _vm.$slots.default.length > 0) ? _c('popover', {
    attrs: {
      "open": _vm.openMenu,
      "anchorOrigin": {
        vertical: 'top',
        horizontal: 'right'
      },
      "trigger": _vm.trigger
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.openMenu) ? _c('mu-menu', {
    class: _vm.nestedMenuClass,
    attrs: {
      "desktop": _vm.$parent.desktop,
      "popover": "",
      "listClass": _vm.nestedMenuListClass,
      "maxHeight": _vm.$parent.maxHeight,
      "value": _vm.nestedMenuValue
    }
  }, [_vm._t("default")], 2) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "lesson-bonus"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('mu-content-block', {
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.data.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.data.summary) + "\n      ")])]), _vm._v(" "), _c('iframe-video-player', {
    attrs: {
      "src": _vm.data.video_player_url
    }
  }), _vm._v(" "), _c('questions-panel', {
    attrs: {
      "courseId": _vm.data.course_id
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-search-dialog"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "subHeader",
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('div', [_vm._v("Select one of your pre-saved meals from the list")])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.savingText'))
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading) ? _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.meals), function(meal, index) {
    return _c('mu-list-item', {
      key: meal.meal_id,
      attrs: {
        "disableRipple": ""
      },
      on: {
        "click": _vm.loadFoods
      }
    }, [_vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(meal.meal_name))]), 0, meal.meal_id), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "describe"
    }, [_vm._v("\n          Contains " + _vm._s(meal.count) + " foods\n        ")]), _vm._v(" "), _c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteMeal(meal.meal_id)
        }
      }
    })], 1)], 1)
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-raised-button', {
    attrs: {
      "label": "Filters",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.isModalShown = !_vm.isModalShown
      }
    }
  }), _vm._v(" "), _c('mu-dialog', {
    staticClass: "scrollBox",
    attrs: {
      "open": _vm.isModalShown,
      "title": "Refine your search",
      "scrollable": ""
    },
    on: {
      "close": function($event) {
        _vm.isModalShown = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "34px"
    }
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Carbohydrate "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.carbs[0] + ' - ' + _vm.model.carbs[1]) + "g")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.carbs),
      callback: function($$v) {
        _vm.$set(_vm.model, "carbs", $$v)
      },
      expression: "model.carbs"
    }
  }, 'vue-slider', _vm.carbSlider, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Fat "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.fat[0] + ' - ' + _vm.model.fat[1]) + "g")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.fat),
      callback: function($$v) {
        _vm.$set(_vm.model, "fat", $$v)
      },
      expression: "model.fat"
    }
  }, 'vue-slider', _vm.fatSlider, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Calories "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.calories[0] + ' - ' + _vm.model.calories[1]) + "kcal")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.calories),
      callback: function($$v) {
        _vm.$set(_vm.model, "calories", $$v)
      },
      expression: "model.calories"
    }
  }, 'vue-slider', _vm.calorieSlider, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Protein "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.protein[0] + ' - ' + _vm.model.protein[1]) + "g")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.protein),
      callback: function($$v) {
        _vm.$set(_vm.model, "protein", $$v)
      },
      expression: "model.protein"
    }
  }, 'vue-slider', _vm.proteinSlider, false))], 1)]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.okText')
    },
    nativeOn: {
      "click": function($event) {
        _vm.isModalShown = false
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "upload-avatar"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hideAvatar && _vm.$store.state.user.scope.profile_large) ? _c('mu-col', {
    attrs: {
      "desktop": "10",
      "tablet": "15",
      "width": "20"
    }
  }, [_c('mu-avatar', {
    staticStyle: {
      "height": "50px",
      "width": "50px"
    },
    attrs: {
      "src": _vm.$store.state.user.scope.profile_large ? _vm.$store.state.user.scope.profile_large : 'static/avatar.png'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.hideAvatar) ? _c('mu-col', {
    attrs: {
      "desktop": "90",
      "tablet": "85",
      "width": "80",
      "align": "left"
    }
  }, [(!_vm.isSaving) ? _c('mu-flat-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "add_a_photo",
      "label": _vm.$store.state.user.scope.profile_large === null ? 'Upload avatar' : _vm.$t('message.accountPreferencesChangeAvatar')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('mu-col', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-circular-progress', {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      "size": 16
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-flex",
      "margin-left": "8px"
    }
  }, [_vm._v("\n             Uploading picture\n        ")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-base64-file-upload', {
    attrs: {
      "disable-preview": "",
      "placeholder": "Click to change profile pic",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.customImageMaxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isImagePresent),
      expression: "isImagePresent"
    }]
  }, [_c('div', {
    ref: "imageCropper"
  }), _vm._v(" "), (_vm.isSaving) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("Uploading...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isImagePresent),
      expression: "isImagePresent"
    }],
    attrs: {
      "align": "center"
    }
  }, [(!_vm.isSaving) ? _c('mu-icon-button', {
    attrs: {
      "tooltip": "Cancel",
      "icon": "close",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doCancel()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate left",
      "icon": "rotate_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('left')
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate right",
      "icon": "rotate_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('right')
      }
    }
  }), _vm._v(" "), _c('mu-circular-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSaving),
      expression: "isSaving"
    }],
    attrs: {
      "size": 16
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "icon": "crop",
      "label": _vm.isSaving ? 'Uploading...' : 'Save profile picture'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doCrop()
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('mu-paper', {
    staticClass: "searchReminder",
    staticStyle: {
      "position": "relative",
      "z-index": "99"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c('mu-list-item', {
    attrs: {
      "disableRipple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.searchTerm)
    }
  })]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    attrs: {
      "slot": "after"
    },
    slot: "after"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.results.length)
    }
  }), _vm._v(" of "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.options.total_results + ' ' + _vm.$t('message.labelFoods'))
    }
  })]) : _vm._e(), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack.apply(null, arguments)
      }
    },
    slot: "left"
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "resultScroller"
    }
  }, [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.results.length === 0) ? _c('mu-list', {
    staticClass: "oddEven"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.labelFoodSearchResultsEmpty')
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "warning"
    },
    slot: "left"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.results.length >= 1) ? _c('mu-list', {
    staticClass: "oddEven"
  }, [_vm._l((_vm.results), function(result, index) {
    return _c('mu-list-item', {
      key: 'result-' + index,
      attrs: {
        "describeText": result.food_description,
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectFood(result)
        }
      }
    }, [_vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "textContent": _vm._s(result.food_name)
      },
      slot: "title"
    }), 0, 'result-' + index), _vm._v(" "), _vm._o(_c('div', {
      attrs: {
        "slot": "describe"
      },
      domProps: {
        "textContent": _vm._s(result.food_description)
      },
      slot: "describe"
    }), 1, 'result-' + index), _vm._v(" "), _vm._o(_c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "add_circle"
      },
      slot: "right"
    }), 2, 'result-' + index)], 1)
  }), _vm._v(" "), (!_vm.isAppending && _vm.options.total_results > _vm.results.length) ? _c('div', {
    attrs: {
      "id": "infinite-scroll-detector"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isAppending) ? _c('div', {
    staticStyle: {
      "padding": "24px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "activity-settings"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [(_vm.isLoading) ? _c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [(!_vm.isLoading) ? _c('mu-table', {
    attrs: {
      "showCheckbox": false
    }
  }, [_c('mu-thead', [_c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingDevice'))
    }
  }), _vm._v(" "), _c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingOS'))
    }
  }), _vm._v(" "), _c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingIp'))
    }
  }), _vm._v(" "), _c('mu-th', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.settingsActivityHeadingDate'))
    }
  })], 1), _vm._v(" "), _c('mu-tbody', _vm._l((_vm.logins), function(login, index) {
    return _c('mu-tr', {
      key: ("login-" + index)
    }, [_c('mu-td', {
      domProps: {
        "textContent": _vm._s(login.device || '-')
      }
    }), _vm._v(" "), _c('mu-td', {
      domProps: {
        "textContent": _vm._s(login.os)
      }
    }), _vm._v(" "), _c('mu-td', [_vm._v(_vm._s(login.ip_address.replace(', 35.244.130.1', ' ')))]), _vm._v(" "), _c('mu-td', {
      domProps: {
        "textContent": _vm._s(_vm.formatDate(login.date_created))
      }
    })], 1)
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "suspicious"
  }, [_c('p', [_vm._v("Notice anything suspicious? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(".")], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cholesterolView"
  }, [(_vm.$store.state.user.scope) ? _c('cholesterol-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [(_vm.$store.state.user.settings) ? _c('cholesterol-input', {
    staticClass: "card-spacing bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "blood_glucose": _vm.$store.state.user.settings.blood_glucose
    }
  }, [_vm._v("\n        >\n      ")]) : _vm._e(), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "cholesterol"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  }), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "icon": "filter_list",
      "autoWidth": ""
    },
    model: {
      value: (_vm.activeFilter),
      callback: function($$v) {
        _vm.activeFilter = $$v
      },
      expression: "activeFilter"
    }
  }, _vm._l((_vm.filters), function(filter, index) {
    return _c('mu-menu-item', {
      key: 'tracking-filter-' + index,
      attrs: {
        "value": filter.key,
        "title": filter.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.determineColor(item),
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [(_vm.activeFilter === 'TOTAL_CHOLESTEROL') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.total_mmoll + ' mmol/L' : item.total_mgdl + ' mg/dL')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'LDL_CHOLESTEROL') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.ldl_mmoll + ' mmol/L' : item.ldl_mgdl + ' mg/dL')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'HDL_CHOLESTEROL') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.hdl_mmoll + ' mmol/L' : item.hdl_mgdl + ' mg/dL')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'TRIGLYCERIDES') ? _c('div', [_c('div', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.triglycerides_mmoll + ' mmol/L' : item.triglycerides_mgdl + ' mg/dL')
        }
      })]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (item.isControlsVisible && !item.isEditMode) ? _c('div', {
        attrs: {
          "align": "right"
        }
      }, [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('cholesterol-edit', {
        attrs: {
          "preference": _vm.data.preference,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-content-block', {
    attrs: {
      "id": "initialLoader"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('mu-content-block', {
    attrs: {
      "id": "initialLoader"
    }
  }, [_c('span', [_vm._v("Unauthorized to view article")])]) : _vm._e(), _vm._v(" "), ((!_vm.isLoading && !_vm.isError)) ? _c('article', {
    attrs: {
      "id": "LifeStyleArticle"
    }
  }, [((!_vm.isLoading && !_vm.isError)) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.post.post_video && _vm.post.post_format === 'video') ? _c('mu-card', {
    staticStyle: {
      "background": "none",
      "box-shadow": "none"
    }
  }, [_c('div', {
    attrs: {
      "id": "embed-video"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.post.post_video_iframe, {
        allowedAttributes: {
          'iframe': ['width', 'height', 'allow', 'frameborder', 'src', 'webkitallowfullscreen', 'mozallowfullscreen', 'allowfullscreen']
        }
      }))
    }
  })]) : _vm._e(), _vm._v(" "), _c('mu-card', {
    attrs: {
      "id": "articleContent"
    }
  }, [(_vm.post.post_image) ? _c('img', {
    staticClass: "postImg",
    attrs: {
      "src": _vm.post.post_image,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "byAuthor"
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('mu-avatar', {
    attrs: {
      "size": 32,
      "src": _vm.post.post_author_image
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.post.post_author)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('mu-icon', {
    attrs: {
      "value": "watch_later",
      "color": "#5b617c"
    }
  }), _vm._v(" "), _c('time', {
    attrs: {
      "datetime": _vm.post.post_date
    },
    domProps: {
      "textContent": _vm._s(_vm.moment(_vm.post.post_date).fromNow())
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "favourites"
  }, [_c('mu-icon', {
    attrs: {
      "value": "favorite",
      "color": "#d83e38"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.post.post_favourites)
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "favouriteBtn"
  }, [_c('mu-flat-button', {
    attrs: {
      "icon": _vm.post.post_favourited ? 'favorite' : 'favorite_border',
      "label": _vm.post.post_favourited ? 'Favourited' : 'Favourite'
    },
    on: {
      "click": function($event) {
        return _vm.favouritePost()
      }
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "postTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.post.post_title)
    }
  }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-content-block', [(_vm.userId) ? _c('vue-markdown', {
    staticClass: "markdownContent",
    attrs: {
      "source": _vm.post.post_content
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.userId) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.post.post_excerpt))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.userId) ? _c('div', {
    staticClass: "loggedOutActions"
  }, [_c('mu-raised-button', {
    attrs: {
      "primary": "",
      "label": "Log in"
    },
    on: {
      "click": _vm.goToLogin
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "Register"
    },
    on: {
      "click": function($event) {
        return _vm.goToRoute('Register')
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    attrs: {
      "id": "lifeSidebar"
    }
  }, [(_vm.isLoading === false && !_vm.isHcpView) ? _c('life-similar-posts', {
    attrs: {
      "post_id": _vm.post.post_id,
      "size": "medium-400"
    }
  }) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.userId) ? _c('life-comments', {
    attrs: {
      "postId": _vm.post.post_id,
      "userId": _vm.userId
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isLoggedOut && !_vm.userId && _vm.attempts.read >= _vm.attempts.amount) ? _c('div', {
    attrs: {
      "id": "lockScreen"
    }
  }, [_c('div', {
    attrs: {
      "id": "lockModal"
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "desc",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "gutter": 0
    }
  }, [_c('mu-flexbox-item', [_c('h2', [_vm._v("Sorry to interrupt your reading, but...")]), _vm._v(" "), _c('p', [_vm._v("\n                  We noticed that you’ve read " + _vm._s(_vm.attempts.read) + " articles on the Low Carb Lifestyle blog this week.")]), _vm._v(" "), _c('p', [_vm._v("Sign up for unlimited access to all this and loads more.")])])], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "noAccount",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "gutter": 0,
      "align": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-raised-button', {
    staticClass: "signUpBtn",
    attrs: {
      "label": "Sign up",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToRoute('Register')
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.registerHaveAccount')) + "\n                  "), _c('a', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.registerSignIn'))
    },
    on: {
      "click": _vm.goToLogin
    }
  }, [_vm._v("Sign in now")])])], 1)], 1)], 1)], 1)], 1)]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-avatar",
    style: (_vm.avatarStyle),
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "mu-avatar-inner"
  }, [(_vm.icon) ? _c('icon', {
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon,
      "size": _vm.iconSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.src) ? _c('img', {
    class: _vm.imgClass,
    attrs: {
      "src": _vm.src
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 3826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": "required|min_value:1|max_value:24",
      "data-vv-name": "hours",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hours'),
      "label": _vm.$t('message.labelHours'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.hours),
      callback: function($$v) {
        _vm.$set(_vm.reading, "hours", _vm._n($$v))
      },
      expression: "reading.hours"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": "required|min_value:1|max_value:10",
      "data-vv-name": "quality",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('quality'),
      "type": "number",
      "label": _vm.$t('message.cardSleepQuality'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.quality),
      callback: function($$v) {
        _vm.$set(_vm.reading, "quality", _vm._n($$v))
      },
      expression: "reading.quality"
    }
  })], 1)], 1), _vm._v(" "), _c('vue-slider', _vm._b({
    staticClass: "bottom",
    staticStyle: {
      "padding-left": "0"
    },
    model: {
      value: (_vm.reading.quality),
      callback: function($$v) {
        _vm.$set(_vm.reading, "quality", $$v)
      },
      expression: "reading.quality"
    }
  }, 'vue-slider', _vm.sliderSettings, false))], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  })], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "recipe-item",
    attrs: {
      "to": {
        name: 'RecipeDetail',
        params: {
          id: _vm.recipe.id
        }
      }
    }
  }, [_c('mu-card', [_c('div', {
    class: 'imgLoadContainer' + '_' + _vm.uid,
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageLoaded),
      expression: "!imageLoaded"
    }],
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAD6CAQAAAAlrtnPAAAB2UlEQVR42u3TMQEAAAgDINc/9Lw9bAAdSDvAI4KAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAggCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAgIIggIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAggCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCAgiCAgCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAlwLZBnzFqLt6FUAAAAASUVORK5CYII="
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoSmallUri != null && _vm.imageLoaded),
      expression: "recipe.photoSmallUri != null && imageLoaded"
    }],
    attrs: {
      "alt": _vm.recipe.title + ' image',
      "src": _vm.recipe.photoSmallUri,
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoSmallUri == null && _vm.imageLoaded),
      expression: "recipe.photoSmallUri == null && imageLoaded"
    }],
    attrs: {
      "alt": 'Empty image',
      "src": "static/emptyImgPlaceholder.png",
      "width": "100%"
    }
  }), _vm._v(" "), (!_vm.imageLoaded) ? _c('img', {
    staticStyle: {
      "margin": "0px auto",
      "position": "absolute",
      "height": "32px",
      "width": "32px",
      "vertical-align": "middle",
      "align-items": "center",
      "display": "flex",
      "text-align": "center",
      "align-content": "center",
      "top": "50%",
      "left": "calc(50% - 16px)"
    },
    attrs: {
      "src": "static/rollingSpinner.gif"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipe.video_url !== null) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "8px",
      "right": "8px"
    }
  }, [_c('mu-chip', [_c('mu-icon', {
    staticStyle: {
      "padding-top": "4px",
      "padding-bottom": "4px"
    },
    attrs: {
      "value": "ondemand_video"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "margin-top": "-6px"
    }
  }, [_c('div', {
    staticClass: "overflowText recipeCardTitle",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v(_vm._s(_vm.recipe.title))]), _vm._v(" "), (_vm.recipe.categories.length > 0) ? _c('div', {
    staticClass: "overflowText",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, _vm._l((_vm.recipe.categories), function(tag, i) {
    return _c('span', {
      key: 'recipe-' + i,
      attrs: {
        "title": tag
      }
    }, [_vm._v(_vm._s(tag)), (_vm.recipe.categories.length - 1 !== i) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.recipe.categories.length === 0) ? _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_vm._v("No categories")]) : _vm._e(), _vm._v(" "), _c('mu-chip', {
    staticClass: "carbTag",
    attrs: {
      "color": "#4479C9",
      "background-color": "white"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.oneCarbPortion.toFixed(0) + 'g') + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "timeTag",
    attrs: {
      "background-color": "white"
    }
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.recipe.totalTime * 60000)))]), _vm._v(" "), _c('recipe-rating', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "read-only": true,
      "rating": _vm.recipe.rating.ratingScore,
      "count": _vm.recipe.rating.ratingCount,
      "recipe": _vm.recipe
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profileView"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isChild && !_vm.isLoading) ? _c('div', [(_vm.profile.user_id) ? _c('profile-header', {
    staticClass: "insetGraph",
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scroll-detector"
    }
  }), _vm._v(" "), _c('mu-paper', {
    staticClass: "insetTabBar innerProfile",
    class: {
      isDocked: _vm.avatarDocked
    },
    attrs: {
      "id": "profileTabs"
    }
  }, [_c('mu-row', {
    staticClass: "padRow",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "desktop": "25",
      "tablet": "30",
      "align": "center"
    }
  }, [_c('mu-avatar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.avatarDocked === false),
      expression: "avatarDocked === false"
    }],
    staticClass: "relativeAvatar desktop",
    attrs: {
      "size": 190,
      "src": _vm.profile.profile_image
    }
  }), _vm._v(" "), _c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.avatarDocked === true),
      expression: "avatarDocked === true"
    }],
    staticStyle: {
      "height": "52px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "shrink": "9",
      "grow": "1",
      "align": "center"
    }
  }, [_c('mu-avatar', {
    staticClass: "desktop",
    staticStyle: {
      "position": "relative",
      "top": "4px"
    },
    attrs: {
      "size": 34,
      "src": _vm.profile.profile_image
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "grow": "3"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.profile.display_name))])])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "75",
      "tablet": "70"
    }
  }, [_c('ul', _vm._l((_vm.routes), function(route) {
    return (_vm.hideTabItems(route.name)) ? _c('li', {
      class: {
        active: route.name === _vm.$route.name
      }
    }, [_c('a', {
      domProps: {
        "textContent": _vm._s(route.label)
      },
      on: {
        "click": function($event) {
          return _vm.goTo(route.name)
        }
      }
    })]) : _vm._e()
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "innerProfile",
    class: {
      isDocked: _vm.avatarDocked
    }
  }, [(!_vm.$route.meta.isChild && _vm.profile) ? _c('router-view', {
    staticClass: "routerView mobile",
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticClass: "padRow",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "profileAvatar",
    attrs: {
      "width": "100",
      "desktop": "25",
      "tablet": "30"
    }
  }, [(!_vm.isLoading) ? _c('profile-avatar', {
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.profile) ? _c('mu-col', {
    staticClass: "routerView desktop",
    attrs: {
      "width": "100",
      "desktop": "75",
      "tablet": "70"
    }
  }, [(!_vm.$route.meta.isChild) ? _c('router-view', {
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "activity-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style"
  }, [(_vm.loading === true) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n          "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.data.error) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), (_vm.hasStepsAndNoSelfReportedReadings || _vm.isStepsMoreRecent) ? _c('div', [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelTotalSteps')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.formatNumber(_vm.data.steps.steps))
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Todays estimated steps'),
      expression: "'Todays estimated steps'",
      modifiers: {
        "top": true
      }
    }],
    staticStyle: {
      "margin-left": "-3px"
    },
    domProps: {
      "textContent": _vm._s('/' + _vm.formatNumber(_vm.data.steps.predictions.steps))
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelFromDevice')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.deviceName)
    }
  })])])], 1)], 1), _vm._v(" "), (_vm.data.steps.distance_mi !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelDistance')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.steps.distance_mi.toFixed(2) + ' mi')
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelFloorsClimbed')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.steps.floors)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelCaloriesBurnt')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.formatNumber(_vm.data.steps.calories) + ' kcal')
    }
  })])])], 1)], 1)], 1) : _c('div', [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelActivity')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.getLocaleLabel(_vm.data.type))
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelDuration')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.minutes + ' mins')
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "orient": "horizontal",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelCaloriesBurnt')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.calories_burnt + ' kcal')
    }
  })])])], 1)], 1)], 1)])]) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('mu-icon', {
    staticClass: "card-left-icon",
    attrs: {
      "value": "directions_walk"
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": _vm.isOpenInput ? 'remove' : 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "activityType",
      "data-vv-as": _vm.$t('message.labelActivityType'),
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('activityType'),
      "label": _vm.$t('message.labelActivityType'),
      "hint-text": _vm.$t('message.selectText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }, _vm._l((_vm.activityTypes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'activity-' + index,
      attrs: {
        "title": _vm.getLocaleLabel(item.value),
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "duration",
      "data-vv-as": _vm.$t('message.labelDurationMinutes'),
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('duration'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": _vm.$t('message.labelDurationMinutes'),
      "type": "number",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.minutes),
      callback: function($$v) {
        _vm.$set(_vm.model, "minutes", $$v)
      },
      expression: "model.minutes"
    }
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "info",
      "icon": "directions_walk"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.labelCalorieBurn')) + " " + _vm._s(_vm.calorieBurn) + "kcal\n          ")])])], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "food-settings"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    staticClass: "gutter",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "likes",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "100"
    }
  }, [_c('mu-card', [_c('mu-paper', {
    attrs: {
      "id": "favorite-food-autocomplete"
    }
  }, [_c('mu-auto-complete', {
    staticClass: "inputInPaper",
    attrs: {
      "icon": "search",
      "underlineShow": false,
      "scroller": _vm.scroller,
      "inputClass": "favoriteAutocomplete",
      "openOnFocus": !_vm.favoriteSearching,
      "fullWidth": true,
      "hintText": _vm.$t('message.searchText'),
      "maxSearchResults": 10,
      "dataSource": _vm.favoriteDataSource,
      "dataSourceConfig": _vm.foodDataSourceConfig,
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleFavoriteSelected
    },
    model: {
      value: (_vm.favoriteSearchValue),
      callback: function($$v) {
        _vm.favoriteSearchValue = $$v
      },
      expression: "favoriteSearchValue"
    }
  })], 1), _vm._v(" "), _c('mu-list', [_c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.foodPreferencesLove')) + "\n            ")]), _vm._v(" "), (_vm.favorites.length === 0) ? _c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.emptyText')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _vm._l((_vm.favorites), function(item, index) {
    return _c('mu-list-item', {
      key: 'fav-food-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "title": item.food_name
      }
    }, [_c('mu-icon-button', {
      attrs: {
        "slot": "right",
        "icon": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteFavorite(item)
        }
      },
      slot: "right"
    })], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "dislikes",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "100"
    }
  }, [_c('mu-card', [_c('mu-paper', {
    attrs: {
      "id": "disliked-food-autocomplete"
    }
  }, [_c('mu-auto-complete', {
    staticClass: "inputInPaper",
    attrs: {
      "icon": "search",
      "underlineShow": false,
      "scroller": _vm.scroller,
      "inputClass": "dislikeAutocomplete",
      "openOnFocus": !_vm.favoriteSearching,
      "fullWidth": true,
      "hintText": _vm.$t('message.searchText'),
      "maxSearchResults": 10,
      "dataSource": _vm.dislikeDataSource,
      "dataSourceConfig": _vm.foodDataSourceConfig,
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleDislikeSelected
    },
    model: {
      value: (_vm.dislikeSearchValue),
      callback: function($$v) {
        _vm.dislikeSearchValue = $$v
      },
      expression: "dislikeSearchValue"
    }
  })], 1), _vm._v(" "), _c('mu-list', [_c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.foodPreferencesHate')) + "\n            ")]), _vm._v(" "), (_vm.dislikes.length === 0) ? _c('mu-sub-header', [_vm._v("\n              " + _vm._s(_vm.$t('message.emptyText')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _vm._l((_vm.dislikes), function(item, index) {
    return _c('mu-list-item', {
      key: 'disliked-food-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "title": item.food_name
      }
    }, [_c('mu-icon-button', {
      attrs: {
        "slot": "right",
        "icon": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteDislike(item)
        }
      },
      slot: "right"
    })], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isUpdating,
      "label": !_vm.isUpdating ? _vm.$t('message.updateText') : _vm.$t('message.updatingText'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.iconMode) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.type === 'datetime' ? '50' : '100',
      "tablet": _vm.type === 'datetime' ? '50' : '100',
      "width": "100"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "iconClass": "blueIcon",
      "icon": "date_range",
      "hintText": _vm.$t('message.labelDate'),
      "inputClass": "datePickerDateEl",
      "format": "DD-MM-YYYY",
      "dateTimeFormat": _vm.dateFormat,
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), (_vm.type !== 'date') ? _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": _vm.type === 'datetime' ? '50' : '100',
      "width": "100"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "iconClass": "blueIcon",
      "icon": "access_time",
      "hintText": _vm.$t('message.labelTime'),
      "inputClass": "datePickerTimeEl",
      "mode": "portrait",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "fullWidth": ""
    },
    on: {
      "change": _vm.timeChanged
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1) : _vm._e()], 1) : _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": _vm.type === 'datetime' ? '50' : '100',
      "tablet": _vm.type === 'datetime' ? '50' : '100',
      "width": "100"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "iconClass": "blueIcon",
      "hintText": _vm.$t('message.labelDate'),
      "inputClass": "datePickerDateEl",
      "format": "DD-MM-YYYY",
      "dateTimeFormat": _vm.dateFormat,
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [(_vm.type !== 'date') ? _c('mu-time-picker', {
    attrs: {
      "iconClass": "blueIcon",
      "hintText": _vm.$t('message.labelTime'),
      "inputClass": "datePickerTimeEl",
      "mode": "portrait",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "fullWidth": ""
    },
    on: {
      "change": _vm.timeChanged
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [(_vm.data !== false) ? _c('mu-card-text', {
    staticStyle: {
      "padding": "8px"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "40",
      "desktop": "40",
      "tablet": "40"
    }
  }, [_c('div', {
    staticClass: "blueText cardTitle"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiary' + _vm.type.charAt(0).toUpperCase() + _vm.type.slice(1))) + "\n          ")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "60",
      "desktop": "60",
      "tablet": "60",
      "align": "right"
    }
  }, [(_vm.data) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Favourite'),
      expression: "'Favourite'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "iconClass": "redIcon",
      "icon": _vm.data.userFavorites ? 'favorite' : 'favorite_outline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favorite(_vm.data.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('View breakdown'),
      expression: "'View breakdown'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "icon": "bar_chart"
    },
    nativeOn: {
      "click": function($event) {
        _vm.isGraphShown = !_vm.isGraphShown
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Refresh'),
      expression: "'Refresh'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "icon": "refresh"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.refresh.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('View recipe'),
      expression: "'View recipe'",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo(_vm.data.id)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [(_vm.data) ? _c('mu-col', {
    staticClass: "recipeBg",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    style: ({
      'background': 'url(' + _vm.data.photoSmallUri + ')'
    }),
    attrs: {
      "width": "30",
      "tablet": "25",
      "desktop": "25"
    }
  }, [(_vm.isLoading) ? _c('mu-circular-progress', {
    staticStyle: {
      "display": "flex",
      "align-self": "center"
    },
    attrs: {
      "color": "white"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('mu-col', {
    attrs: {
      "width": "70",
      "tablet": "75",
      "desktop": "75"
    }
  }, [_c('div', {
    staticClass: "blueText",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.data.title) + "\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.servings) + " serving(s) · Carbs " + _vm._s(_vm.oneCarbPortion.toFixed(0)) + "g (1 serving)\n          ")])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading && _vm.data === false) ? _c('mu-card-text', {
    staticStyle: {
      "padding": "8px"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "blueText cardTitle"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiary' + _vm.type.charAt(0).toUpperCase() + _vm.type.slice(1))) + "\n          ")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": true,
      "iconClass": "redIcon",
      "icon": 'favorite_outline'
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "disabled": true,
      "icon": "bar_chart"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "disabled": true,
      "icon": "refresh"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "recipeBg",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    style: ({
      'background': 'url(static/recipe-placeholder.png)'
    }),
    attrs: {
      "width": "30",
      "tablet": "25",
      "desktop": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "70",
      "tablet": "75",
      "desktop": "75"
    }
  }, [_c('div', {
    staticClass: "blueText",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('mu-linear-progress', {
    staticStyle: {
      "width": "50%",
      "height": "14px",
      "background": "rgb(214, 214, 214)",
      "margin-bottom": "8px"
    },
    style: ({
      width: _vm.getRandomArbitrary(40, 90)
    }),
    attrs: {
      "slot": "describe",
      "color": "#d9d9d9"
    },
    slot: "describe"
  })], 1), _vm._v(" "), _c('div', [_c('mu-linear-progress', {
    staticStyle: {
      "width": "50%",
      "height": "14px",
      "background": "rgb(214, 214, 214)",
      "margin-bottom": "8px"
    },
    style: ({
      width: _vm.getRandomArbitrary(40, 50)
    }),
    attrs: {
      "slot": "describe",
      "color": "#d9d9d9"
    },
    slot: "describe"
  })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data && _vm.isGraphShown) ? _c('mu-card-text', {
    staticClass: "bubble-progress"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden",
      "white-space": "nowrap",
      "font-size": "0",
      "-webkit-border-radius": "8px",
      "-moz-border-radius": "8px",
      "border-radius": "8px",
      "margin-bottom": "16px"
    }
  }, [_c('span', {
    staticClass: "inline-block-bar",
    style: ({
      'width': _vm.nutrientPercentage.fat + '%',
      'background': 'rgb(192, 77, 216)'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "inline-block-bar",
    style: ({
      'width': _vm.nutrientPercentage.carbs + '%',
      'background': 'rgb(78, 216, 218)'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "inline-block-bar",
    style: ({
      'width': _vm.nutrientPercentage.protein + '%',
      'background': 'rgb(224, 105, 80)'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "outer-bubble"
  }, [_c('span', {
    staticClass: "bubble",
    staticStyle: {
      "background-color": "rgb(192, 77, 216)"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.nutrientFat')) + ": " + _vm._s(_vm.oneFatPortion.toFixed(0) + 'g') + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "outer-bubble"
  }, [_c('span', {
    staticClass: "bubble",
    staticStyle: {
      "background-color": "rgb(78, 216, 218)"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.nutrientCarbohydrateShort')) + ": " + _vm._s(_vm.oneCarbPortion.toFixed(0) + 'g'))]), _vm._v(" "), _c('span', {
    staticClass: "outer-bubble"
  }, [_c('span', {
    staticClass: "bubble",
    staticStyle: {
      "background-color": "rgb(224, 105, 80)"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.nutrientProtein')) + ": " + _vm._s(_vm.oneProteinPortion.toFixed(0) + 'g'))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "wrap",
    class: ['vue-slider-component', _vm.flowDirection, _vm.disabledClass, {
      'vue-slider-has-label': _vm.piecewiseLabel
    }],
    style: (_vm.wrapStyles),
    on: {
      "click": _vm.wrapClick
    }
  }, [_c('div', {
    ref: "elem",
    staticClass: "vue-slider",
    style: ([_vm.elemStyles, _vm.bgStyle]),
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.isRange) ? [_c('div', {
    ref: "dot0",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.dotStyles, _vm.sliderStyles[0]]),
    on: {
      "mousedown": function($event) {
        return _vm.moveStart($event, 0)
      },
      "touchstart": function($event) {
        return _vm.moveStart($event, 0)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[0], 'vue-slider-tooltip-wrap']
  }, [_vm._t("tooltip", function() {
    return [_c('span', {
      staticClass: "vue-slider-tooltip",
      style: (_vm.tooltipStyles[0])
    }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[0]) : _vm.val[0]))])]
  }, {
    "value": _vm.val[0],
    "index": 0
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "dot1",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.dotStyles, _vm.sliderStyles[1]]),
    on: {
      "mousedown": function($event) {
        return _vm.moveStart($event, 1)
      },
      "touchstart": function($event) {
        return _vm.moveStart($event, 1)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[1], 'vue-slider-tooltip-wrap']
  }, [_vm._t("tooltip", function() {
    return [_c('span', {
      staticClass: "vue-slider-tooltip",
      style: (_vm.tooltipStyles[1])
    }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[1]) : _vm.val[1]))])]
  }, {
    "value": _vm.val[1],
    "index": 1
  })], 2)])] : [_c('div', {
    ref: "dot",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.dotStyles, _vm.sliderStyles]),
    on: {
      "mousedown": _vm.moveStart,
      "touchstart": _vm.moveStart
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection, 'vue-slider-tooltip-wrap']
  }, [_vm._t("tooltip", function() {
    return [_c('span', {
      staticClass: "vue-slider-tooltip",
      style: (_vm.tooltipStyles)
    }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val) : _vm.val))])]
  }, {
    "value": _vm.val
  })], 2)])], _vm._v(" "), _c('ul', {
    staticClass: "vue-slider-piecewise"
  }, _vm._l((_vm.piecewiseDotWrap), function(piecewiseObj, index) {
    return _c('li', {
      key: index,
      staticClass: "vue-slider-piecewise-item",
      style: ([_vm.piecewiseDotStyle, piecewiseObj.style])
    }, [_vm._t("piecewise", function() {
      return [(_vm.piecewise) ? _c('span', {
        staticClass: "vue-slider-piecewise-dot",
        style: ([_vm.piecewiseStyle, piecewiseObj.inRange ? _vm.piecewiseActiveStyle : null])
      }) : _vm._e()]
    }, {
      "label": piecewiseObj.label,
      "index": index,
      "first": index === 0,
      "last": index === _vm.piecewiseDotWrap.length - 1,
      "active": piecewiseObj.inRange
    }), _vm._v(" "), _vm._t("label", function() {
      return [(_vm.piecewiseLabel) ? _c('span', {
        staticClass: "vue-slider-piecewise-label",
        style: ([_vm.labelStyle, piecewiseObj.inRange ? _vm.labelActiveStyle : null])
      }, [_vm._v("\n            " + _vm._s(piecewiseObj.label) + "\n          ")]) : _vm._e()]
    }, {
      "label": piecewiseObj.label,
      "index": index,
      "first": index === 0,
      "last": index === _vm.piecewiseDotWrap.length - 1,
      "active": piecewiseObj.inRange
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    ref: "process",
    staticClass: "vue-slider-process",
    style: (_vm.processStyle)
  })], 2), _vm._v(" "), (!_vm.isRange && !_vm.data) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    staticClass: "vue-slider-sr-only",
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "__r": function($event) {
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      blueBg: _vm.$route.meta.isBlueBg,
      transHeader: _vm.hasTransHeader,
      isAuthView: _vm.$route.meta.isAuthView,
      isLoggedOut: !_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope
    },
    attrs: {
      "id": "app"
    }
  }, [_c('boot-loader', {
    attrs: {
      "loadingMessage": _vm.loadingMessage
    }
  }), _vm._v(" "), (_vm.loggedIn && !_vm.docked && _vm.isOpen) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.isAuthView),
      expression: "!$route.meta.isAuthView"
    }],
    staticClass: "app-drawer-overlay",
    on: {
      "click": function($event) {
        return _vm.toggle(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.isAuthView),
      expression: "!$route.meta.isAuthView"
    }],
    staticClass: "app-drawer",
    class: {
      open: _vm.isOpen,
      docked: _vm.docked,
      isMobile: !_vm.docked
    }
  }, [_c('div', {
    staticClass: "nav-head"
  }, [_c('div', {
    staticClass: "avatar",
    on: {
      "click": _vm.goToProfile
    }
  }, [(_vm.$store.state.user.scope.profile_thumb !== null) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.user.scope.profile_thumb,
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.upperTwoInitials))])]), _vm._v(" "), _c('div', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.display_name && _vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : _vm.$store.state.user.scope.firstname)
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('div', {
    ref: "settingsMenu",
    staticClass: "settings-menu"
  }, [_c('button', {
    ref: "settingsTrigger",
    staticClass: "settings-trigger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSettingsMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuOpen),
      expression: "menuOpen"
    }],
    ref: "settingsDropdown",
    staticClass: "settings-dropdown"
  }, [_c('div', {
    staticClass: "menu-user",
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goToProfile()
      }
    }
  }, [_c('div', {
    staticClass: "avatar avatar--lg"
  }, [(_vm.$store.state.user.scope.profile_large) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.user.scope.profile_large,
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.upperTwoInitials))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-user-info"
  }, [_c('div', {
    staticClass: "menu-user-name",
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.display_name && _vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : (_vm.$store.state.user.scope.firstname + ' ' + _vm.$store.state.user.scope.surname))
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope.diabetes_type && _vm.$store.state.user.scope.diabetes_type.diabetes_type) ? _c('div', {
    staticClass: "menu-user-type",
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.diabetes_type.diabetes_type)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "menu-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/dashboard')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dashboard")]), _vm._v(_vm._s(_vm.$t('message.dashboardAppBarText')) + "\n            ")]), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/questions?type=MY_QUESTIONS')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chat")]), _vm._v(_vm._s(_vm.$t('message.discussionTabMyQuestions')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/profile/' + _vm.$store.state.user.profile.profile_url)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(_vm._s(_vm.$t('message.labelMyProfile')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/settings')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")]), _vm._v(_vm._s(_vm.$t('message.settingsMenuTitleText')) + "\n            ")]), _vm._v(" "), (!_vm.isHcpView) ? _c('hr', {
    staticClass: "menu-divider"
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/add-progress')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(_vm._s(_vm.$t('message.addProgressAppBarText')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/food-diary/')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(_vm._s(_vm.$t('message.foodDiaryAddFoodAppBarText')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('hr', {
    staticClass: "menu-divider"
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    class: {
      disabled: _vm.showTestimonial
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/testimonials')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v(_vm._s(_vm.$t('message.addTestimonialText')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goToContact()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")]), _vm._v(_vm._s(_vm.$t('message.labelHelp')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("exit_to_app")]), _vm._v(_vm._s(_vm.$t('message.logOutText')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/dashboard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'home' : 'dashboard'))]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.dashboardMenuTitleText')))])]), _vm._v(" "), (_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/hcp"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("school")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Education")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": _vm.isHcpView && _vm.isHcpUser ? '/life/category/evidence-and-papers' : '/life'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("local_florist")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'Evidence and Papers' : _vm.$t('message.lifestyleMenuTitleText')))])]), _vm._v(" "), (_vm.isHcpUser && _vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/downloads"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Resources")])]) : _vm._e(), _vm._v(" "), (!_vm.questionsDisabled) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/questions"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v(_vm._s(_vm.isHcpView || _vm.isHcpUser ? 'textsms' : 'live_help'))]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'Forum' : _vm.$t('message.questionsMenuTitleText')))])]) : _c('div', {
    staticClass: "nav-item disabled"
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v(_vm._s(_vm.isHcpView || _vm.isHcpUser ? 'textsms' : 'live_help'))]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'Forum' : _vm.$t('message.questionsMenuTitleText')))])]), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/food-diary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("book")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiaryMenuTitleText')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nav-group"
  }, [_c('button', {
    staticClass: "nav-item nav-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.recipesOpen = !_vm.recipesOpen
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("restaurant")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.recipeMenuTitleText')))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons nav-caret"
  }, [_vm._v(_vm._s(_vm.recipesOpen ? 'expand_less' : 'expand_more'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipesOpen),
      expression: "recipesOpen"
    }],
    staticClass: "nav-nested"
  }, [_c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("view_carousel")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("All Recipes")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/favorites/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("grade")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Favourites")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("search")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Search")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/generator/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Meal Plan Generator")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/mealplans/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("view_list")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("My Meal Plans")])])], 1)]), _vm._v(" "), (!_vm.isHcpView) ? _c('div', {
    staticClass: "nav-group"
  }, [_c('button', {
    staticClass: "nav-item nav-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.shopOpen = !_vm.shopOpen
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("shopping_cart")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.shopMenuTitleText')))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons nav-caret"
  }, [_vm._v(_vm._s(_vm.shopOpen ? 'expand_less' : 'expand_more'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopOpen),
      expression: "shopOpen"
    }],
    staticClass: "nav-nested"
  }, [_c('a', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "href": "https://shop.lowcarbprogram.com/collections/books",
      "target": "_blank"
    },
    on: {
      "click": _vm.closeIfMobile
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("book")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Books")])])])]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/add-progress"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.addProgressMenuTitleText')))])]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView && _vm.$store.state.user.scope.country.country_id === 41) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/coaching"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("school")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.coachingMenuTitleText')))])]) : _vm._e(), _vm._v(" "), (!_vm.isHcpUser || !_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/downloads"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.downloadsMenuTitleText')))])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/coaching"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("sports")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Coaching")])]), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": '/profile/' + _vm.$store.state.user.profile.profile_url
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("person")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.profileMenuTitleText')))])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/contact"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("feedback")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.feedbackMenuTitleText')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/settings"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("settings")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.settingsMenuTitleText')))])]), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/faq"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("help")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.faqMenuTitleText')))])]) : _vm._e(), _vm._v(" "), (_vm.isHcpView || _vm.isHcpUser) ? _c('button', {
    staticClass: "nav-item hcpSwitch",
    class: {
      disabled: !_vm.isHcpVerified && _vm.isHcpView
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleHcpSwitchModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("swap_horizontal_circle")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView ? _vm.$t('message.labelSwitchPatient') : _vm.$t('message.labelSwitchHcp')))])]) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.status.payment.paid === false) ? _c('payment-call-to-action') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "page-content",
    class: {
      sidebarOpen: _vm.isOpen,
      isMobile: !_vm.docked
    }
  }, [((_vm.$route.meta.isAuthView && !_vm.$route.meta.hideRegisterAppBar)) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen,
      noShadow: _vm.$route.meta.hideShadow
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.applicationContext === 'grohealth') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "width": "26",
      "src": __webpack_require__(3342)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.applicationContext === 'lowcarbprogram') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "width": "200",
      "src": "static/logos/lcp-logo.svg"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showLogOut) ? _c('div', {
    staticClass: "logout-button",
    on: {
      "click": _vm.logOut
    }
  }, [_c('span', [_c('mu-icon', {
    attrs: {
      "value": "exit_to_app"
    }
  }), _vm._v("\n              Log out\n            ")], 1)]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isAuthView && _vm.$store.state.user.scope) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen,
      transparent: _vm.$route.meta.isBlueBg
    },
    attrs: {
      "title": _vm.replaceTitle ? _vm.replaceTitle : _vm.$route.meta.title + (_vm.$route.meta.hasCustomTitle ? ': ' + _vm.externalTitle : '')
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left",
      "iconClass": "menu-icon material-icons-round",
      "icon": "menu"
    },
    on: {
      "click": function($event) {
        return _vm.toggle(false)
      }
    },
    slot: "left"
  }), _vm._v(" "), (_vm.$route.meta.isChild) ? _c('mu-icon-button', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "left",
      "icon": "chevron_left"
    },
    on: {
      "click": function($event) {
        return _vm.goBack(_vm.$route)
      }
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), ((_vm.isHcpView || _vm.isHcpUser) && _vm.isHcpVerified) ? _c('mu-icon', {
    staticClass: "mobileHcpSwitch",
    attrs: {
      "slot": "right",
      "value": "swap_horizontal_circle",
      "color": "#FFF"
    },
    on: {
      "click": function($event) {
        _vm.toggleHcpSwitchModal = true
      }
    },
    slot: "right"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "20px",
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('span', {
    staticClass: "user-block pointer",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile()
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : _vm.$store.state.user.scope.firstname))]), _vm._v(" "), (_vm.$store.state.user.scope.profile_thumb !== null) ? _c('mu-avatar', {
    staticStyle: {
      "margin-left": "12px",
      "border": "2px solid #fff"
    },
    attrs: {
      "size": 32,
      "src": _vm.$store.state.user.scope.profile_thumb,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }) : _c('mu-avatar', {
    staticClass: "blue",
    staticStyle: {
      "margin-left": "12px",
      "border": "2px solid #fff"
    },
    attrs: {
      "size": 32,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upperTwoInitials) + "\n          ")])], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('notifications-panel', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "right",
      "visible": _vm.isNotificationsPanelVisible
    },
    on: {
      "panelHidden": _vm.hidePanelFn
    },
    slot: "right"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen
    },
    attrs: {
      "title": _vm.$route.meta.title + (_vm.$route.meta.hasCustomTitle ? ': ' + _vm.externalTitle : '')
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-content-block', {
    staticClass: "main-content",
    attrs: {
      "id": _vm.$route.meta.id
    },
    nativeOn: {
      "scroll": function($event) {
        return _vm.handleScroll.apply(null, arguments)
      }
    }
  }, [(_vm.isHcpView && _vm.isHcpUser) ? _c('hcp-search') : _vm._e(), _vm._v(" "), (_vm.$store.state.list.diabetes_types) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "siteFooter content",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50",
      "align": "center"
    }
  }, [_c('div', [_vm._v("\n\n                " + _vm._s(_vm.$t('message.labelMadeWith')) + "\n\n                "), _c('mu-icon', {
    attrs: {
      "color": "#D83E38",
      "size": 12,
      "value": "favorite"
    }
  }), _vm._v(" "), (_vm.applicationContext === 'grohealth') ? _c('span', [_vm._v("grohealth.com")]) : _vm._e(), _vm._v(" "), (_vm.applicationContext === 'lowcarbprogram') ? _c('span', [_vm._v("lowcarbprogram.com")]) : _vm._e(), _vm._v(" © " + _vm._s(_vm.currentYear) + "\n              ")], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$route.meta.paymentWall && _vm.$store.state.status.payment.paid === false) ? _c('paywall', {
    attrs: {
      "show": _vm.showPaywall
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHcpUser) ? _c('hcp-switch-modal', {
    attrs: {
      "open": _vm.toggleHcpSwitchModal
    },
    on: {
      "close": function($event) {
        return _vm.closeHcpSwitchModal()
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:250',
      "data-vv-name": "units",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('units'),
      "type": "number",
      "label": _vm.$t('message.labelUnits'),
      "hintText": ((_vm.$t('message.cardInsulin')) + " " + _vm.lowerCaseUnitsLabel),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.units),
      callback: function($$v) {
        _vm.$set(_vm.reading, "units", _vm._n($$v))
      },
      expression: "reading.units"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": "$t('message.selectText')",
      "data-vv-rules": 'required',
      "data-vv-name": "insulin_type",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('insulin_type'),
      "label": _vm.$t('message.labelInsulinType'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.type),
      callback: function($$v) {
        _vm.$set(_vm.reading, "type", $$v)
      },
      expression: "reading.type"
    }
  }, _vm._l((_vm.insulinTypes), function(type, index) {
    return _c('mu-menu-item', {
      key: 'insulin-type-' + index,
      attrs: {
        "value": type.insulin_type_id,
        "title": _vm.mapInsulinTypes(type.type)
      }
    })
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fitbit-sleep-graph"
    }
  }, [_c('mu-paper', [(!_vm.isLoading && _vm.fitbitData.sleep.length > 0) ? _c('fitbit-sleep-chart', {
    attrs: {
      "chart-data": _vm.data,
      "options": _vm.options
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.fitbitData.sleep.length === 0) ? _c('mu-card-text', [_c('alert', {
    attrs: {
      "type": "info",
      "icon": "info"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Not enough data to create a chart\n        ")])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mouseleave": _vm.onMouseLeave
    }
  }, _vm._l((_vm.maxRating), function(item, ratingIndex) {
    return _c('span', {
      key: 'rating-' + ratingIndex,
      class: {
        'starActive': _vm.hoverRating >= ratingIndex
      },
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "disabled": _vm.readOnly === true
      },
      on: {
        "mouseover": function($event) {
          return _vm.onMouseOver(ratingIndex)
        },
        "click": function($event) {
          return _vm.onClick(ratingIndex)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "size": 24,
        "value": "star",
        "color": _vm.calcStars(ratingIndex)
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 3838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope.has_engaged_preference === false) ? _c('alert', {
    attrs: {
      "type": "alert-color",
      "icon": "warning",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('message.labelHi')) + " " + _vm._s(_vm.$store.state.user.scope.firstname) + ", " + _vm._s(_vm.$t('message.labelUpdateCommPreferences')) + "\n    "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "to": {
        name: 'SettingsPreferences'
      }
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.updateText'))
    },
    slot: "action"
  })], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-badge-container"
  }, [_vm._t("default"), _vm._v(" "), _c('em', {
    staticClass: "mu-badge",
    class: _vm.badgeInternalClass,
    style: (_vm.badgeStyle)
  }, [_vm._t("content", function() {
    return [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")]
  })], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 3840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-flex",
      "position": "absolute",
      "right": "34px",
      "top": "0px",
      "z-index": "10"
    }
  }, [_c('mu-raised-button', {
    ref: "button",
    staticClass: "opaque",
    attrs: {
      "label-position": "before",
      "label": _vm.$t('message.graphPointsToggleTitle'),
      "icon": "arrow_drop_down",
      "disabled": _vm.isDisabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-popover', {
    attrs: {
      "scroller": _vm.scroller,
      "trigger": _vm.trigger,
      "open": _vm.open,
      "anchorOrigin": _vm.anchorOrigin,
      "targetOrigin": _vm.targetOrigin
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('mu-list', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_c('mu-sub-header', [_vm._v(_vm._s(_vm.$t('message.graphPointsToggleTitle')) + "\n        "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "arrow_drop_up"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.graphPointToggleShowPoints')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggle('showPoints')
      }
    }
  }, [_c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.showPoints),
      callback: function($$v) {
        _vm.showPoints = $$v
      },
      expression: "showPoints"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.graphToggleSmoothLine')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggle('smoothLine')
      }
    }
  }, [_c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.smoothLine),
      callback: function($$v) {
        _vm.smoothLine = $$v
      },
      expression: "smoothLine"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.graphToggleShowArea')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggle('showArea')
      }
    }
  }, [_c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-paper', {
    staticClass: "insetGraph"
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "sleepDiary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('SleepProgress')
      }
    }
  }, [_vm._v("\n        Sleep diary\n      ")]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "deviceHistory"
    }
  }, [_vm._v("\n        Device history\n      ")])], 1)], 1), _vm._v(" "), (_vm.$store.state.user.scope && _vm.integrationsLoaded) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "60",
      "tablet": "60",
      "width": "100"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "align-items": "center",
      "padding-top": "8px",
      "padding-bottom": "8px"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "25",
      "desktop": "25",
      "tablet": "25"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subtractDay.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50",
      "align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDate) + "\n        ")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "desktop": "25",
      "tablet": "25",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right",
      "disabled": _vm.isSameDay
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDay.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), (!_vm.isLoading && _vm.integration === 'FITBIT') ? _c('fitbit-sleep-graph', {
    attrs: {
      "fitbitData": _vm.fitbitData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.integration === 'STRIIV') ? _c('striiv-sleep-graph', {
    attrs: {
      "striivData": _vm.striivData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_c('mu-circular-progress')], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "40",
      "tablet": "40",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "icon": "filter_list",
      "fullWidth": ""
    },
    model: {
      value: (_vm.integration),
      callback: function($$v) {
        _vm.integration = $$v
      },
      expression: "integration"
    }
  }, _vm._l((_vm.integrations), function(item, index) {
    return _c('mu-menu-item', {
      key: 'integrations-' + index,
      attrs: {
        "title": _vm.formatIntegrationLabel(item),
        "value": item.service
      }
    })
  }), 1), _vm._v(" "), (_vm.isLoading) ? _c('mu-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_c('mu-circular-progress')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.integration === 'FITBIT') ? _c('fitbit-sleep-stages', {
    attrs: {
      "fitbitData": _vm.fitbitData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.integration === 'STRIIV') ? _c('striiv-sleep-stages', {
    attrs: {
      "striivData": _vm.striivData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }, [_c('mu-icon-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "slot": "avatar",
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-card-text', [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "80",
      "tablet": "80"
    }
  }, [(_vm.user.diabetes_type.is_diabetic) ? _c('div', [_c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v(_vm._s(_vm.$t('message.labelITakeThisForMy')) + " " + _vm._s(_vm.user.diabetes_type.diabetes_type))]), _vm._v(" "), _c('mu-radio', {
    staticClass: "demo-radio",
    attrs: {
      "label": _vm.$t('message.labelYes'),
      "name": "group",
      "nativeValue": 1
    },
    model: {
      value: (_vm.model.forDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.model, "forDiabetes", $$v)
      },
      expression: "model.forDiabetes"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-radio', {
    staticClass: "demo-radio",
    attrs: {
      "label": _vm.$t('message.labelNo'),
      "name": "group",
      "nativeValue": 0
    },
    model: {
      value: (_vm.model.forDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.model, "forDiabetes", $$v)
      },
      expression: "model.forDiabetes"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.model.forDiabetes === 0) ? _c('mu-row', [(_vm.conditions.length > 0) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.model.treatment_id,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "condition",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('condition'),
      "hintText": "Select from my condititons",
      "label": "What do you take it for?",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.condition_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "condition_id", $$v)
      },
      expression: "model.condition_id"
    }
  }, _vm._l((_vm.conditions), function(item) {
    return _c('mu-menu-item', {
      key: 'condition-' + item.condition_id,
      attrs: {
        "title": item.condition_label,
        "value": item.condition_id
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.model.treatment_id,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "dosage",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('dosage'),
      "min": "0",
      "type": "number",
      "label": _vm.$t('message.labelDosage'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.defaultDosage),
      callback: function($$v) {
        _vm.$set(_vm.model, "defaultDosage", _vm._n($$v))
      },
      expression: "model.defaultDosage"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.model.treatment_id,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "unit_regime",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('unit_regime'),
      "maxHeight": 250,
      "scroller": _vm.scroller,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.labelUnits'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.unit_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "unit_id", $$v)
      },
      expression: "model.unit_id"
    }
  }, _vm._l((_vm.regimes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'regime-' + index,
      attrs: {
        "value": item.ID,
        "title": _vm.localizeRegime(item.regimeUnitLabel)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.model.treatment_id) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.model.treatment_id,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "frequency",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('frequency'),
      "maxHeight": 250,
      "scroller": _vm.scroller,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.labelHowOften'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.frequency_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "frequency_id", $$v)
      },
      expression: "model.frequency_id"
    }
  }, _vm._l((_vm.frequencies), function(item, index) {
    return _c('mu-menu-item', {
      key: 'frequency-' + index,
      attrs: {
        "value": item.ID,
        "title": _vm.$t(_vm.localizeFrequency(item.frequency))
      }
    })
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "type": "submit",
      "fullWidth": "",
      "label": !_vm.isSaving ? _vm.$t('message.saveText') : _vm.$t('message.savingText'),
      "secondary": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('div', {
    staticClass: "isError",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.medicationAlreadyTrackingError')))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-flexbox-item",
    style: (_vm.itemStyle)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "blood-glucose-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [(_vm.visualDate.dateStep !== 0) ? _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  }) : _c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "red"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v("Nothing to see here yet")]), _vm._v(" "), _c('p', [_vm._v("Not enough data to create graph")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "dateStep": _vm.visualDate.dateStep,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(0)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(7)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(30)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.humanizeDays(360)) + "\n      ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "ketones-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('message.cardEmpty')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.latestReadingTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.latest_value + ' ' + _vm.bloodGlucose.unit)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [(_vm.data.last_occurrence) ? _c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lastOccurrenceTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.data.last_occurrence))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.totalOccurrenceTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_occurrence)
    }
  })])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "17px",
      "height": "15px",
      "viewBox": "20 193 17 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.596657,204.024078 L27.4483433,202.008701 C27.4466257,202.00863 27.4449084,202.008558 27.4431913,202.008486 C27.1065685,201.994308 26.7913774,201.899106 26.5165508,201.742332 C26.5127922,201.740187 26.5090412,201.738031 26.5052978,201.735864 L22.9607307,205.098641 C22.9022004,205.00058 22.8320228,204.910144 22.7520541,204.829189 C22.8320477,204.91017 22.9022218,205.000584 22.9607307,205.098603 C23.0858378,205.308123 23.1578576,205.552244 23.1578576,205.813086 C23.1578576,206.591273 22.5192209,207.222113 21.7315461,207.222113 C20.9438714,207.222113 20.3052347,206.591273 20.3052347,205.813086 C20.3052347,205.034899 20.9438714,204.404059 21.7315461,204.404059 C22.0081146,204.404059 22.266129,204.482054 22.4847255,204.616683 C22.5823877,204.676827 22.6721283,204.748294 22.7520786,204.829222 C22.6721112,204.74826 22.5823835,204.676806 22.4847255,204.616683 L25.9804623,201.300249 C25.979853,201.299539 25.9792442,201.298829 25.9786358,201.298118 C25.8510297,201.149012 25.7450446,200.981427 25.6654138,200.799813 C25.6638728,200.796296 25.6623417,200.792774 25.6608205,200.789247 L23.7310234,201.083431 C23.731024,201.083445 23.7310246,201.08346 23.7310252,201.083474 C23.7316689,201.099335 23.7322369,201.115233 23.7322369,201.131281 C23.7322369,201.754564 23.2207519,202.259789 22.5899154,202.259789 C21.9590789,202.259789 21.447594,201.754564 21.447594,201.131281 C21.447594,200.508035 21.9590789,200.002773 22.5899154,200.002773 C23.0588019,200.002773 23.4615755,200.282057 23.6375736,200.681344 C23.6649255,200.743352 23.6867798,200.808249 23.70255,200.875451 C23.686733,200.808242 23.6648749,200.743329 23.6375357,200.681307 L25.5370166,200.391763 C25.5120013,200.265875 25.498617,200.135916 25.498617,200.002773 C25.498617,199.791682 25.531787,199.588223 25.5929395,199.397109 C25.594108,199.393456 25.5952868,199.389807 25.5964758,199.386163 L22.2313526,197.296404 C22.0022118,197.451577 21.7251049,197.542657 21.4263115,197.542657 C20.6386368,197.542657 20,196.911817 20,196.13363 C20,195.355443 20.6386368,194.724603 21.4263115,194.724603 C22.2139862,194.724603 22.852623,195.355443 22.852623,196.13363 C22.852623,196.360693 22.7979454,196.575001 22.701351,196.764993 C22.6977556,196.772067 22.6941018,196.779107 22.6903901,196.786113 L25.9134096,198.787653 C25.9142237,198.786597 25.9150389,198.785541 25.9158551,198.784487 C26.1606166,198.468319 26.498224,198.226405 26.8885399,198.097948 C26.8904269,198.097326 26.8923151,198.096707 26.8942045,198.096091 L26.5419267,196.272088 C26.5275843,196.272616 26.5131743,196.272881 26.4987015,196.272881 C26.0241731,196.272881 25.6173101,195.986976 25.4447199,195.580058 C25.3919735,195.455716 25.3614161,195.320001 25.3572131,195.177778 C25.3569102,195.166631 25.35638,195.155558 25.35638,195.144373 C25.35638,194.521128 25.867865,194.015865 26.4987015,194.015865 C27.129538,194.015865 27.641023,194.521128 27.641023,195.144373 C27.641023,195.609839 27.3557657,196.009462 26.9485713,196.181993 L27.3011865,198.00799 C27.302338,198.007862 27.3034899,198.007735 27.3046421,198.007609 C27.3790096,197.999454 27.4544752,197.99489 27.5310768,197.99489 C27.8205573,197.99489 28.0956868,198.055079 28.3449164,198.162849 C28.3489893,198.16461 28.3530551,198.166383 28.3571139,198.168169 L31.3242218,194.710288 C31.295779,194.66368 31.2706485,194.614875 31.2491522,194.564193 C31.1964058,194.43985 31.1658485,194.304136 31.1616454,194.161913 C31.1613425,194.150766 31.1608124,194.139693 31.1608124,194.128508 C31.1608124,193.505263 31.6722974,193 32.3031339,193 C32.9339704,193 33.4454553,193.505263 33.4454553,194.128508 C33.4454553,194.751791 32.9339704,195.257016 32.3031339,195.257016 C32.1358821,195.257016 31.9770362,195.221499 31.8338911,195.157684 L28.927578,198.544676 C28.9281876,198.545247 28.9287969,198.545817 28.9294058,198.546388 C29.2396504,198.837192 29.4568592,199.223451 29.533072,199.657709 L31.5322182,199.230597 C31.5317163,199.221318 31.5313269,199.21201 31.5310509,199.202673 C31.530748,199.191526 31.5302179,199.180453 31.5302179,199.169268 C31.5302179,198.546023 32.0417029,198.04076 32.6725394,198.04076 C33.3033759,198.04076 33.8148608,198.546023 33.8148608,199.169268 C33.8148608,199.792551 33.3033759,200.297776 32.6725394,200.297776 C32.2080875,200.297776 31.8084578,200.023885 31.6298678,199.63071 L29.5619371,200.072526 C29.5617913,200.076347 29.5616419,200.080166 29.5614918,200.083984 C29.5475952,200.428133 29.4461919,200.749912 29.2784484,201.028261 C29.2780899,201.028856 29.277731,201.02945 29.2773718,201.030045 L33.6347039,203.867711 C33.4627953,204.016368 33.3274646,204.205164 33.2434793,204.419359 L28.8313211,201.546008 C28.8277765,201.548928 28.8242216,201.551836 28.8206565,201.554733 C28.5521534,201.772744 28.2259435,201.923646 27.8681919,201.982675 C27.8668152,201.982902 27.865438,201.983128 27.8640604,201.983353 L28.0113579,203.984385 C28.5960015,204.0338 29.0550808,204.51804 29.0550808,205.108442 C29.0550808,205.731725 28.5435959,206.23695 27.9127594,206.23695 C27.2819229,206.23695 26.7704379,205.731725 26.7704379,205.108442 C26.7704379,204.593604 27.1195928,204.159566 27.5966568,204.024075 Z M27.9622524,203.981169 C27.9787073,203.981941 27.995072,203.983055 28.0113607,203.984422 Z M34.5736885,203.518774 C34.2140057,203.518774 33.8856375,203.650598 33.6347039,203.867711 C33.4627953,204.016443 33.3274646,204.205164 33.2434793,204.419396 C33.1816452,204.577181 33.147377,204.748507 33.147377,204.927838 C33.147377,205.706026 33.7860138,206.336865 34.5736885,206.336865 C35.3613632,206.336865 36,205.706026 36,204.927838 C36,204.149651 35.3613632,203.518774 34.5736885,203.518774 Z",
      "id": "Combined-Shape",
      "stroke": "none",
      "fill": "#2761ff",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.bloodGlucose !== false && _vm.isOpenInput === false) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose !== false && _vm.isOpenInput === true) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose === false) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": "settings_cog"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToSettings()
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.bloodGlucose.measure === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "63",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:63',
      "data-vv-name": "ketones_mgdl",
      "data-vv-value-path": _vm.inputValue,
      "data-vv-as": _vm.bloodGlucose.unit,
      "errorText": _vm.errors.first('ketones_mgdl'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "mgdl", _vm._n($$v))
      },
      expression: "model.mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose.measure === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0.1",
      "max": "3.5",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:3.5',
      "data-vv-name": "ketones_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.bloodGlucose.unit,
      "errorText": _vm.errors.first('ketones_mmoll'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "mmoll", $$v)
      },
      expression: "model.mmoll"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 3846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "dialog",
    on: {
      "close": _vm.close
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Show Macronutrients percentage:")]), _vm._v(" "), _c('mu-col', [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('mu-col', [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Based on food weight consumed")]), _vm._v(" "), _c('p', [_vm._v("Recommended if you’re basing your daily intake\n            on numbers you see on food labelling.")])]), _vm._v(" "), _c('mu-col', [_c('mu-radio', {
    attrs: {
      "value": "g",
      "native-value": "g"
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = $$v
      },
      expression: "unit"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Based on the nutrient’s density")]), _vm._v(" "), _c('p', [_vm._v("Recommended for advanced members who prefer\n            to see calorie breakdown by nutritional density.")])]), _vm._v(" "), _c('mu-col', [_c('mu-radio', {
    attrs: {
      "value": "kcal",
      "native-value": "kcal"
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = $$v
      },
      expression: "unit"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hide.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.updateText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.update.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locale-picker",
    class: _vm.position
  }, [_c('div', {
    staticClass: "locale selected",
    on: {
      "click": function($event) {
        return _vm.toggleMenu()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": 'static/flags/' + _vm.localeSelected.flag + '.svg'
    }
  }), _vm._v(" "), _c('mu-icon', {
    staticClass: "close",
    class: {
      'active': _vm.toggleLocales === true
    },
    attrs: {
      "value": _vm.isMenuTop ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "selectedLang",
    domProps: {
      "textContent": _vm._s(_vm.getLangLabel(_vm.locales[_vm.selected].cl) + ' (' + _vm.locales[_vm.selected].cc + ')')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "menu",
    class: {
      'visible': _vm.toggleLocales
    }
  }, _vm._l((_vm.locales), function(locale, i) {
    return _c('div', {
      key: ("locale-" + i),
      staticClass: "locale clearfix",
      on: {
        "click": function($event) {
          return _vm.onSelect(i)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": 'static/flags/' + locale.flag + '.svg'
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getLangLabel(locale.cl) + ' (' + locale.cc + ')')
      }
    })])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 3848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "id": "paymentForm",
      "action": _vm.paypal.action,
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "business"
    },
    domProps: {
      "value": _vm.paypal.business
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name"
    },
    domProps: {
      "value": _vm.paypal.item_name
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code"
    },
    domProps: {
      "value": _vm.paypal.currency_code
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "amount"
    },
    domProps: {
      "value": _vm.paypal.amount
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cancel_return"
    },
    domProps: {
      "value": (_vm.app_url + "#/payment?cancelled=true")
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "return"
    },
    domProps: {
      "value": (_vm.app_url + "#/payment?success=true")
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "notify_url"
    },
    domProps: {
      "value": (_vm.api_url + "paypal-ipn/")
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "custom"
    },
    domProps: {
      "value": _vm.paypal.custom
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_shipping",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "1"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button paypalBtn",
    attrs: {
      "type": "button",
      "label": "Pay via PayPal",
      "disabled": _vm.paypal.hasSubmitted === true
    },
    on: {
      "click": _vm.submitPayment
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcp-article"
    }
  }, [(_vm.initialLoad) ? _c('mu-content-block', {
    staticClass: "contentLoader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.initialLoad) ? _c('article', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "blueTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.article.post_title))
    }
  }), _vm._v(" "), (_vm.article.post_format === 'video') ? _c('figure', {
    staticClass: "media"
  }, [_c('mu-circular-progress', {
    staticClass: "loader",
    attrs: {
      "size": 36
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.article.post_video_iframe, {
        allowedAttributes: {
          'iframe': ['width', 'height', 'allow', 'frameborder', 'src', 'webkitallowfullscreen', 'mozallowfullscreen', 'allowfullscreen']
        }
      }))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "75",
      "desktop": "75"
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.article.post_content))
    }
  }), _vm._v(" "), (_vm.hasReferences) ? _c('mu-raised-button', {
    staticClass: "smoothBtn primary",
    attrs: {
      "id": "viewReferencesBtn",
      "label": _vm.toggle.references ? 'Hide References' : 'View References',
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.toggleReferences()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasReferences && _vm.toggle.references),
      expression: "hasReferences && toggle.references"
    }],
    staticClass: "references"
  }, [_c('ol', _vm._l((_vm.article.post_references), function(reference, refIndex) {
    return _c('li', {
      key: ("reference-" + refIndex),
      class: {
        'active': _vm.activeReference === refIndex + 1
      },
      attrs: {
        "id": ("reference-" + (refIndex + 1))
      }
    }, [_c('a', {
      attrs: {
        "href": reference.reference_url,
        "target": "_blank"
      },
      domProps: {
        "textContent": _vm._s(reference.reference_title)
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.hasFurtherReading) ? _c('div', {
    staticClass: "further-reading"
  }, [_c('h3', [_vm._v("Further Reading")]), _vm._v(" "), _c('ol', _vm._l((_vm.article.post_further_reading), function(further, furtherIndex) {
    return _c('li', {
      key: ("further-" + furtherIndex)
    }, [_c('a', {
      attrs: {
        "href": further.further_reading_url,
        "target": "_blank"
      },
      domProps: {
        "textContent": _vm._s(further.further_reading_title)
      }
    })])
  }), 0)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('mu-card', {
    staticStyle: {
      "padding": "0 20px"
    },
    attrs: {
      "id": "similar"
    }
  }, [_c('h4', [_vm._v("Similar articles")]), _vm._v(" "), _vm._l((_vm.similar.per_page), function(dummy, dummyIndex) {
    return (_vm.similar.isLoading) ? _c('div', {
      key: ("dummy-" + dummyIndex),
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img",
      attrs: {
        "size": 15,
        "color": "#d9d9d9"
      }
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title",
      attrs: {
        "size": 10,
        "color": "#d9d9d9"
      }
    }), _vm._v(" "), _c('mu-linear-progress', {
      attrs: {
        "size": 10,
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.similar.articles), function(article, articleIndex) {
    return (!_vm.similar.isLoading) ? _c('article', {
      key: ("article-" + articleIndex)
    }, [(article.post_format === 'video') ? _c('figure', {
      staticClass: "media"
    }, [_c('mu-circular-progress', {
      staticClass: "loader",
      attrs: {
        "size": 36
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/hcp/article/' + article.post_slug
      }
    }, [_c('img', {
      attrs: {
        "src": article.post_video_thumb
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('h3', {
      staticClass: "title"
    }, [_c('router-link', {
      attrs: {
        "to": '/hcp/article/' + article.post_slug
      },
      domProps: {
        "textContent": _vm._s(article.post_title)
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "textContent": _vm._s(article.post_video_desc)
      }
    })]) : _vm._e()
  })], 2)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "testimonialsView"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-card', {
    attrs: {
      "id": "addTestimonials"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blueTitle",
      "title": _vm.cardTitle,
      "subTitle": _vm.cardSubTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50"
    }
  }, [_c('form', {
    attrs: {
      "name": "submitTestimonialForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitTestimonial.apply(null, arguments)
      }
    }
  }, [_c('mu-row', {
    staticClass: "progressImages"
  }, [_c('mu-col', {
    attrs: {
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "beforeImage"
    },
    on: {
      "click": function($event) {
        return _vm.openImage('beforeImage')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.progressImage.before),
      expression: "!progressImage.before"
    }],
    staticClass: "instructions"
  }, [_c('mu-icon', {
    attrs: {
      "value": "cloud_upload",
      "size": 40
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelBeforePhoto'))
    }
  }), _vm._v(" "), _c('vue-base64-file-upload', {
    ref: "beforeImage",
    staticClass: "base64Upload",
    attrs: {
      "disable-preview": "",
      "placeholder": "Before image",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.maxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoadBefore
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progressImage.before),
      expression: "progressImage.before"
    }],
    staticClass: "imagePreview",
    style: ('background-image: url(' + _vm.progressImage.before + ')')
  })])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "afterImage"
    },
    on: {
      "click": function($event) {
        return _vm.openImage('afterImage')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.progressImage.after),
      expression: "!progressImage.after"
    }],
    staticClass: "instructions"
  }, [_c('mu-icon', {
    attrs: {
      "value": "cloud_upload",
      "size": 40
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelAfterPhoto'))
    }
  }), _vm._v(" "), _c('vue-base64-file-upload', {
    ref: "afterImage",
    staticClass: "base64Upload",
    attrs: {
      "disable-preview": "",
      "placeholder": "After image",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.maxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoadAfter
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progressImage.after),
      expression: "progressImage.after"
    }],
    staticClass: "imagePreview",
    style: ('background-image: url(' + _vm.progressImage.after + ')')
  })])])], 1), _vm._v(" "), _vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      key: 'question-' + index,
      staticClass: "question"
    }, [(question.type == 'textarea') ? _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "label": question.question,
        "rows": 3,
        "hintText": question.question_hint,
        "multiLine": "",
        "fullWidth": "",
        "data-vv-rules": 'required'
      },
      model: {
        value: (question.answer),
        callback: function($$v) {
          _vm.$set(question, "answer", $$v)
        },
        expression: "question.answer"
      }
    }) : _vm._e(), _vm._v(" "), (question.type == 'tel') ? _c('mu-text-field', {
      attrs: {
        "type": "tel",
        "label": question.question,
        "hintText": question.question_hint,
        "fullWidth": ""
      },
      model: {
        value: (question.answer),
        callback: function($$v) {
          _vm.$set(question, "answer", $$v)
        },
        expression: "question.answer"
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.terms.agreed),
      callback: function($$v) {
        _vm.$set(_vm.terms, "agreed", $$v)
      },
      expression: "terms.agreed"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.terms.agreed = !_vm.terms.agreed
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerTestimonialConcent')) + " "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "terms")
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.registerTermsAndCondtions'))
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.registerTestimonialExplain')))])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "button",
      "label": _vm.isSubmitting ? _vm.$t('message.savingText') : _vm.$t('message.submitText'),
      "secondary": "",
      "disabled": _vm.isSubmitting
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitTestimonial.apply(null, arguments)
      }
    }
  })], 2)])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.isHcpUser || !_vm.isHcpView) ? _c('reset-account') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('avatar-uploader') : _vm._e(), _vm._v(" "), _c('update-height'), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(!_vm.hideNameInputs) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "data-vv-name": "firstname",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesFirstName'),
      "errorText": _vm.errors.first('firstname'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesFirstName')
    },
    model: {
      value: (_vm.model.firstname),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstname", $$v)
      },
      expression: "model.firstname"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(!_vm.hideNameInputs) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "data-vv-name": "surname",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesSurname'),
      "errorText": _vm.errors.first('surname'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesSurname')
    },
    model: {
      value: (_vm.model.surname),
      callback: function($$v) {
        _vm.$set(_vm.model, "surname", $$v)
      },
      expression: "model.surname"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [(_vm.hideNameInputs) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required|display_name_regex|min:2|max:30',
      "data-vv-name": "display_name",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDisplayName'),
      "errorText": _vm.errors.first('display_name'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesDisplayName')
    },
    model: {
      value: (_vm.model.display_name),
      callback: function($$v) {
        _vm.$set(_vm.model, "display_name", $$v)
      },
      expression: "model.display_name"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-row', [_c('p', [_vm._v(_vm._s(_vm.$t('Show username instead of first and last name')))]), _vm._v(" "), _c('mu-switch', {
    on: {
      "change": _vm.switchInputs
    },
    model: {
      value: (_vm.model.use_display_name),
      callback: function($$v) {
        _vm.$set(_vm.model, "use_display_name", $$v)
      },
      expression: "model.use_display_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-card-text'), _vm._v(" "), _c('mu-divider')], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelDay'),
      "errorText": _vm.errors.first('birth_day'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesBirthday')
    },
    model: {
      value: (_vm.dob.day),
      callback: function($$v) {
        _vm.$set(_vm.dob, "day", $$v)
      },
      expression: "dob.day"
    }
  }, _vm._l((_vm.dobItems.days), function(item, index) {
    return _c('mu-menu-item', {
      key: 'dob-day-' + index,
      attrs: {
        "value": item,
        "title": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelMonth'),
      "errorText": _vm.errors.first('birth_month'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "autoWidth": "",
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": " "
    },
    model: {
      value: (_vm.dob.month),
      callback: function($$v) {
        _vm.$set(_vm.dob, "month", $$v)
      },
      expression: "dob.month"
    }
  }, _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('mu-menu-item', {
      key: 'month-' + index,
      attrs: {
        "value": month,
        "title": _vm.localizeMonth(month.name)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": true,
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelYear'),
      "errorText": _vm.errors.first('birth_year'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": " "
    },
    model: {
      value: (_vm.dob.year),
      callback: function($$v) {
        _vm.$set(_vm.dob, "year", $$v)
      },
      expression: "dob.year"
    }
  }, _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('mu-menu-item', {
      key: 'year-' + index,
      attrs: {
        "value": year,
        "title": '' + year.value + ''
      }
    })
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col')], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "diabetes_type",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesWhatBringsYouHere'),
      "errorText": _vm.errors.first('diabetes_type'),
      "maxHeight": 216,
      "label": _vm.$t('message.accountPreferencesWhatBringsYouHere'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.model.diabetes_type_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "diabetes_type_id", $$v)
      },
      expression: "model.diabetes_type_id"
    }
  }, _vm._l((_vm.lists.diabetes_types), function(item, index) {
    return (item.hide === 0) ? _c('mu-menu-item', {
      key: 'diabetes-type-' + index,
      attrs: {
        "title": _vm.localizeRegistrationReason(item.diabetes_type),
        "value": item.diabetes_type_id
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "diagnosis_year",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDiagnosisYear'),
      "errorText": _vm.errors.first('diagnosis_year'),
      "maxHeight": 216,
      "label": _vm.$t('message.accountPreferencesDiagnosisYear'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.model.diagnosis_year),
      callback: function($$v) {
        _vm.$set(_vm.model, "diagnosis_year", _vm._n($$v))
      },
      expression: "model.diagnosis_year"
    }
  }, _vm._l((_vm.yearList()), function(item, index) {
    return _c('mu-menu-item', {
      key: 'diagnosis-year+' + index,
      attrs: {
        "title": '' + item + '',
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "gender",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesSex'),
      "errorText": _vm.errors.first('gender'),
      "maxHeight": 216,
      "label": _vm.$t('message.accountPreferencesSex'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.model.gender_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "gender_id", $$v)
      },
      expression: "model.gender_id"
    }
  }, _vm._l((_vm.lists.genders), function(item, index) {
    return _c('mu-menu-item', {
      key: 'gender-' + index,
      attrs: {
        "title": _vm.localizeSex(item.gender),
        "value": item.gender_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.accountPreferencesTestBlood')
    },
    model: {
      value: (_vm.model.tests_blood),
      callback: function($$v) {
        _vm.$set(_vm.model, "tests_blood", $$v)
      },
      expression: "model.tests_blood"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.accountPreferencesTakeMedication')
    },
    model: {
      value: (_vm.model.takes_medication),
      callback: function($$v) {
        _vm.$set(_vm.model, "takes_medication", $$v)
      },
      expression: "model.takes_medication"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "ethnicity",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "day",
      "errorText": _vm.errors.first('ethnicity'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesEthnicity')
    },
    model: {
      value: (_vm.personalizationModel.ethnicity_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "ethnicity_id", $$v)
      },
      expression: "personalizationModel.ethnicity_id"
    }
  }, _vm._l((_vm.lists.ethnicities), function(item, index) {
    return _c('mu-menu-item', {
      key: 'ethnicity-' + index,
      attrs: {
        "value": item.ethnicity_id,
        "title": _vm.$t(_vm.localizeEthnicity(item.ethnicity_id))
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "language",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesLanguage'),
      "errorText": _vm.errors.first('language'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": "Select",
      "label": _vm.$t('message.accountPreferencesLanguage')
    },
    model: {
      value: (_vm.personalizationModel.language_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "language_id", $$v)
      },
      expression: "personalizationModel.language_id"
    }
  }, _vm._l((_vm.lists.languages), function(item, index) {
    return _c('mu-menu-item', {
      key: 'language-' + index,
      attrs: {
        "value": item.id,
        "title": _vm.getNativeName(item.iso)
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "occupation",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesOccupation'),
      "errorText": _vm.errors.first('occupation'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesOccupation')
    },
    model: {
      value: (_vm.personalizationModel.occupation_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "occupation_id", $$v)
      },
      expression: "personalizationModel.occupation_id"
    }
  }, _vm._l((_vm.lists.occupations), function(item, index) {
    return _c('mu-menu-item', {
      key: 'occupation-' + index,
      attrs: {
        "value": item.occupation_id,
        "title": _vm.localizeOccupation(item.occupation_name)
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "dietary_preference",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDietaryPreference'),
      "errorText": _vm.errors.first('dietary_preference'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesDietaryPreference')
    },
    model: {
      value: (_vm.personalizationModel.dietry_preference_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "dietry_preference_id", $$v)
      },
      expression: "personalizationModel.dietry_preference_id"
    }
  }, _vm._l((_vm.lists.dietry_preferences), function(item, index) {
    return _c('mu-menu-item', {
      key: 'diet-pref-' + index,
      attrs: {
        "value": item.dietry_preference_id,
        "title": _vm.localizeDietPreference(item.name)
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "multiple": "",
      "separator": ", ",
      "autoWidth": "",
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesAllergies')
    },
    model: {
      value: (_vm.personalizationModel.allergies),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "allergies", $$v)
      },
      expression: "personalizationModel.allergies"
    }
  }, _vm._l((_vm.lists.allergies), function(item, index) {
    return _c('mu-menu-item', {
      key: 'allergy-' + index,
      attrs: {
        "value": item.allergy_id,
        "title": _vm.localizeAllergy(item.name)
      }
    })
  }), 1), _vm._v(" "), (_vm.personalizationModel.currency_code) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.personalizationModel.currency_code),
      expression: "personalizationModel.currency_code"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.personalizationModel.currency_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.personalizationModel, "currency_code", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('currency-input', {
    attrs: {
      "currency": _vm.currencyCode,
      "label": _vm.$t('message.accountPreferencesShopCost')
    },
    model: {
      value: (_vm.personalizationModel.weekly_shop_cost),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "weekly_shop_cost", _vm._n($$v))
      },
      expression: "personalizationModel.weekly_shop_cost"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "secondary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordCheck"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "baseline"
    }
  }, [_c('mu-flexbox-item', [(_vm.isPasswordLengthValid !== false) ? _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.isPasswordLengthValid === true) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPasswordLengthValid === 'error') ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.isPasswordLengthValid === true,
      error: _vm.isPasswordLengthValid === 'error'
    }
  }, [_vm._v("Password must not be more than "), _c('strong', [_vm._v(" " + _vm._s(_vm.maxCharacter) + " characters")])])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-result"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticStyle: {
      "position": "relative",
      "z-index": "99"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "describeText": _vm.food.brand_name
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : _vm.food.food_name)
    }
  })]), _vm._v(" "), (_vm.mode === '') ? _c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('goBack', 's')
      }
    },
    slot: "left"
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [(!_vm.isLoading) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": _vm.leftPaneWidth.desktop,
      "tablet": _vm.leftPaneWidth.tablet
    }
  }, [_c('mu-content-block', {
    staticStyle: {
      "padding": "16px 24px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:99'),
      expression: "'required|min_value:0|max_value:99'"
    }],
    attrs: {
      "data-vv-name": "serving_size",
      "data-vv-as": _vm.$t('message.labelServingSize'),
      "errorText": _vm.errors.first('serving_size'),
      "min": 0,
      "type": "number",
      "hintText": _vm.$t('message.labelMultiplier'),
      "label": _vm.$t('message.labelServingSize'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.servings),
      callback: function($$v) {
        _vm.$set(_vm.model, "servings", _vm._n($$v))
      },
      expression: "model.servings"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "maxHeight": 248,
      "label": " ",
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.serving_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "serving_id", _vm._n($$v))
      },
      expression: "model.serving_id"
    }
  }, _vm._l((_vm.food.servings), function(serving, index) {
    return _c('mu-menu-item', {
      key: 'serving-' + index,
      attrs: {
        "value": serving.serving_id,
        "title": serving.serving_description
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('span', [_c('mu-flexbox', {
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.foodDiaryQuickPortionLabel'))
    }
  })], 1)], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('span', [_c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.25')
      }
    }
  }, [_vm._v("1/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.5')
      }
    }
  }, [_vm._v("1/2")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('0.75')
      }
    }
  }, [_vm._v("3/4")]), _vm._v(" "), _c('mu-chip', {
    nativeOn: {
      "click": function($event) {
        return _vm.setServingSize('1')
      }
    }
  }, [_vm._v("1")])], 1)])], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingInput.desktop,
      "tablet": _vm.servingPickerWidth.servingInput.tablet
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "container": "inline",
      "label": _vm.$t('message.labelTime'),
      "mode": "landscape",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": _vm.servingPickerWidth.servingSelector.desktop,
      "tablet": _vm.servingPickerWidth.servingSelector.tablet
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "container": "inline",
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isNutritionPaneVisible) ? _c('mu-col', {
    staticClass: "rightPane",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    staticClass: "removePadding",
    attrs: {
      "subTitle": _vm.model.servings + ' x ' + _vm.activeServingObject.serving_description
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.activeServingObject.nutrients), function(value, key) {
    return _c('mu-list-item', {
      key: 'nutrient-' + key,
      attrs: {
        "disableRipple": "",
        "title": _vm.$t(_vm.localizeNutrient(key)),
        "afterText": '' + _vm.rounded(value * _vm.model.servings) + _vm.getUnit(key)
      }
    })
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading) ? _c('mu-card-actions', {
    staticClass: "card-actions",
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText'),
      "disabled": _vm.isSaving,
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveFood()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": 2
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        Loading...\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "60"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "country",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "country",
      "errorText": _vm.errors.first('relationship'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": "Select",
      "label": _vm.$t('message.addressCountry')
    },
    model: {
      value: (_vm.model.country_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "country_id", $$v)
      },
      expression: "model.country_id"
    }
  }, _vm._l((_vm.lists.countries), function(item, index) {
    return _c('mu-menu-item', {
      key: 'country-' + index,
      attrs: {
        "value": item.country_id,
        "title": _vm.localizeCountry(item.alpha3_code)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "40"
    }
  }, [(_vm.model.country_id === 235 || _vm.model.country_id === 237) ? _c('mu-text-field', {
    attrs: {
      "id": "postcodeTxt",
      "fullWidth": _vm.fullWidth,
      "label": _vm.$t('message.addressPostcode'),
      "hintText": "Post code"
    },
    model: {
      value: (_vm.model.postcode),
      callback: function($$v) {
        _vm.$set(_vm.model, "postcode", $$v)
      },
      expression: "model.postcode"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.country_id === 235),
      expression: "model.country_id === 235"
    }],
    attrs: {
      "id": "surgery"
    }
  }, [_c('mu-auto-complete', {
    attrs: {
      "scroller": _vm.scroller,
      "inputClass": "surgerySearchTxt",
      "maxHeight": 250,
      "openOnFocus": true,
      "label": _vm.$t('message.gettingStartedLocationGpSurgery'),
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.searchText'),
      "filter": "noFilter",
      "dataSource": _vm.surgeries,
      "dataSourceConfig": _vm.dataSourceConfig
    },
    on: {
      "change": _vm.handleSurgerySelected
    },
    model: {
      value: (_vm.surgerySearchValue),
      callback: function($$v) {
        _vm.surgerySearchValue = $$v
      },
      expression: "surgerySearchValue"
    }
  })], 1), _vm._v(" "), (_vm.activeSurgery.surgery_name) ? _c('div', [_c('mu-raised-button', {
    attrs: {
      "backgroundColor": "#D5D5D5",
      "color": "#444",
      "label": "Clear",
      "icon": "clear"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearSurgery.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.activeSurgery.surgery_name) ? _c('mu-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.country_id === 235),
      expression: "model.country_id === 235"
    }],
    attrs: {
      "label": _vm.$t('message.gettingStartedLocationSurgeryNotInList')
    },
    model: {
      value: (_vm.unableToFindSurgery),
      callback: function($$v) {
        _vm.unableToFindSurgery = $$v
      },
      expression: "unableToFindSurgery"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.unableToFindSurgery) ? _c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "surgery",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "surgery",
      "errorText": _vm.errors.first('surgery'),
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.addressSurgeryName')
    },
    model: {
      value: (_vm.model.surgery.surgery_name),
      callback: function($$v) {
        _vm.$set(_vm.model.surgery, "surgery_name", $$v)
      },
      expression: "model.surgery.surgery_name"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "address_line_1",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.addressLine1'),
      "errorText": _vm.errors.first('address_line_1'),
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.addressLine1')
    },
    model: {
      value: (_vm.model.surgery.address_line_1),
      callback: function($$v) {
        _vm.$set(_vm.model.surgery, "address_line_1", $$v)
      },
      expression: "model.surgery.address_line_1"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.addressLine2')
    },
    model: {
      value: (_vm.model.surgery.address_line_2),
      callback: function($$v) {
        _vm.$set(_vm.model.surgery, "address_line_2", $$v)
      },
      expression: "model.surgery.address_line_2"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "surgery_postcode",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.addressPostcode'),
      "errorText": _vm.errors.first('surgery_postcode'),
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.addressPostcode')
    },
    model: {
      value: (_vm.model.surgery.postcode),
      callback: function($$v) {
        _vm.$set(_vm.model.surgery, "postcode", $$v)
      },
      expression: "model.surgery.postcode"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required',
      "data-vv-name": "surgery_city",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.addressCity'),
      "errorText": _vm.errors.first('surgery_city'),
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.addressCity')
    },
    model: {
      value: (_vm.model.surgery.city),
      callback: function($$v) {
        _vm.$set(_vm.model.surgery, "city", $$v)
      },
      expression: "model.surgery.city"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.addressCounty')
    },
    model: {
      value: (_vm.model.surgery.county),
      callback: function($$v) {
        _vm.$set(_vm.model.surgery, "county", $$v)
      },
      expression: "model.surgery.county"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "fullWidth": true,
      "secondary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(!_vm.isLoading && _vm.$route.name === 'SettingsMedication') ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "to": {
        'name': 'SettingsAddMedications'
      },
      "rippleColor": "#F6F6F6",
      "fullWidth": "",
      "label": _vm.$t('message.medicationPreferencesAdd'),
      "secondary": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.medications.length > 0) ? _c('div', [_vm._l((_vm.activeMedications), function(item, index) {
    return _c('mu-list-item', {
      key: 'medication-active-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "disableRipple": "",
        "title": item.treatment_name,
        "describeText": item.defaultDosage + ' ' + item.unit_label + ' ' + item.frequency_label.toLowerCase()
      }
    }, [_c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "anchorOrigin": _vm.rightTop,
        "targetOrigin": _vm.rightTop,
        "scroller": _vm.scroller,
        "icon": "more_vert",
        "desktop": ""
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "leftIcon": "edit",
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editMedication(item)
        }
      }
    }), _vm._v(" "), (item.active === true) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "visibility_off",
        "title": _vm.$t('message.disableText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.disableMedication(item)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.editMode) ? _c('div', {
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.inActiveMedications.length > 0) ? _c('mu-content-block', {
    staticStyle: {
      "border-left": "4px solid #3d8517"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.medicationsPreferencesNotTaking')) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.inActiveMedications), function(item, index) {
    return _c('mu-list-item', {
      key: 'medication-inactive-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "disableRipple": "",
        "title": item.treatment_name,
        "describeText": item.defaultDosage + ' ' + item.unit_label + ' ' + item.frequency_label.toLowerCase()
      }
    }, [_c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "anchorOrigin": _vm.rightTop,
        "targetOrigin": _vm.rightTop,
        "scroller": _vm.scroller,
        "icon": "more_vert",
        "desktop": ""
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "leftIcon": "edit",
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editMedication(item)
        }
      }
    }), _vm._v(" "), (item.active === false) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "visibility",
        "title": _vm.$t('message.enableText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.enableMedication(item)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.editMode) ? _c('div', {
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }) : _vm._e()], 1)
  })], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 3856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-flexbox",
    class: {
      'mu-flex-col': _vm.orient === 'vertical',
      'mu-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model) ? _c('div', {
    attrs: {
      "id": "updateHeight"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateHeightSettings.apply(null, arguments)
      }
    }
  }, [(!_vm.model.cm) ? _c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:8'),
      expression: "'required|min_value:0|max_value:8'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_ft",
      "data-vv-as": "ft",
      "errorText": _vm.errors.first('height_ft'),
      "min": 0,
      "max": 8,
      "hintText": _vm.$t('message.placeholderText'),
      "label": "ft",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.ft),
      callback: function($$v) {
        _vm.$set(_vm.model, "ft", _vm._n($$v))
      },
      expression: "model.ft"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:11'),
      expression: "'required|min_value:0|max_value:11'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_in",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('height_in'),
      "min": 0,
      "max": 11,
      "hintText": _vm.$t('message.placeholderText'),
      "label": "in",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.in),
      callback: function($$v) {
        _vm.$set(_vm.model, "in", _vm._n($$v))
      },
      expression: "model.in"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.model.cm) ? _c('div', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:50|max_value:251'),
      expression: "'required|min_value:50|max_value:251'"
    }],
    attrs: {
      "data-vv-name": "height_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "min": 0,
      "max": 251,
      "errorText": _vm.errors.first('height_cm'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "cm"
    },
    model: {
      value: (_vm.model.cm),
      callback: function($$v) {
        _vm.$set(_vm.model, "cm", _vm._n($$v))
      },
      expression: "model.cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.updateText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateHeightSettings.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report",
    attrs: {
      "id": "question-thread"
    }
  }, [(!_vm.isLoading) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "color": "#0179d5",
      "backgroundColor": "#E9E9E8",
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "src": _vm.question.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', {
    staticClass: "badges"
  }, [(_vm.question.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.question.user.profile.url
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.encodeText(_vm.question.user.display_name)) + " "), _c('country-badge', {
    attrs: {
      "alpha2": _vm.question.user.country.alpha2,
      "tooltip": _vm.question.user.country.country_name
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }, [_vm._v(_vm._s(_vm.question.user.diabetes_type))]), _vm._v(" "), _c('div', [_vm._v("Posts: " + _vm._s(_vm.question.posts))])])], 1) : _vm._e(), _vm._v(" "), (_vm.question.content) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.question.content)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', [_c('mu-flat-button', {
    attrs: {
      "icon": "history",
      "label": "Go to question"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToThread()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('report', {
    attrs: {
      "typeId": parseInt(_vm.$route.params.id),
      "type": "THREAD_QUESTION"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Handle report"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._v("\n            What do you want to do this with answer?\n          ")]), _vm._v(" "), _c('mu-card-text', [_c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "KEEP",
      "label": "Keep it (removes reports)"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1), _vm._v(" "), _c('div', [_c('mu-radio', {
    attrs: {
      "nativeValue": "REMOVE",
      "label": "Remove it"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "type": "button",
      "label": "Ammend",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_c('mu-icon-button', {
    staticClass: "notificationBtn",
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "icon": _vm.icon
    },
    nativeOn: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }), _vm._v(" "), (_vm.showIndicator && _vm.newNotifications) ? _c('img', {
    staticClass: "newIndicator",
    attrs: {
      "src": __webpack_require__(3343)
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.visible) ? _c('mu-card', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    attrs: {
      "id": "notifications"
    }
  }, [_c('mu-card-header', {
    class: {
      'newNotifs': _vm.newNotifications
    },
    staticStyle: {
      "padding": "10px 0 0 0"
    },
    attrs: {
      "titleClass": "blueTitle notificationTitle",
      "title": _vm.$t('message.notificationHeaderText')
    }
  }, [(_vm.newNotifications) ? _c('div', {
    staticClass: "readAll",
    on: {
      "click": function($event) {
        return _vm.markAllRead()
      }
    }
  }, [_c('span', [_vm._v("Mark all read")])]) : _vm._e()]), _vm._v(" "), (!_vm.newNotifications) ? _c('div', {
    staticClass: "notificationsEmpty"
  }, [_c('mu-icon', {
    attrs: {
      "value": "notifications_none",
      "size": "80",
      "color": "#a8abb9"
    }
  }), _vm._v(" "), _c('p', [_vm._v("You haven't received any new notifications yet")])], 1) : _vm._e(), _vm._v(" "), (_vm.newNotifications) ? _c('div', {
    staticClass: "scrollable",
    staticStyle: {
      "overflow": "auto",
      "-webkit-overflow-scrolling": "touch"
    },
    attrs: {
      "id": "notificationScroller"
    }
  }, [_c('mu-list', _vm._l((_vm.notifications), function(item, index) {
    return _c('mu-list-item', {
      key: 'n-' + index,
      class: {
        notificationTextNewBg: item.isViewed === null
      },
      attrs: {
        "title": _vm.generateText(item),
        "titleClass": {
          notificationText: item.isViewed === true,
          notificationTextNew: item.isViewed === false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.markReadAndGo(item)
        }
      }
    }, [(item.user) ? _c('div', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [(item.user.profile_thumb) ? _c('mu-avatar', {
      staticClass: "notificationAvatar",
      attrs: {
        "src": item.user.profile_thumb,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      }
    }) : _c('mu-avatar', {
      staticClass: "notificationAvatar",
      attrs: {
        "color": "black",
        "backgroundColor": "#E9E9E8"
      }
    }, [_vm._v(_vm._s(item.user.firstname.substring(0, 1)))])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      class: {
        'notificationTextNew': !item.isViewed
      },
      staticStyle: {
        "font-family": "'Poppins',sans-serif",
        "font-size": "16px",
        "line-height": "1.4",
        "font-weight": "400"
      },
      domProps: {
        "textContent": _vm._s(_vm.formatDate(item.date_created))
      }
    })])])
  }), 1), _vm._v(" "), (_vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.notificationEndedFromServer) ? _c('div', {
    staticClass: "wrapBtn"
  }, [_c('mu-flat-button', {
    staticClass: "showMore",
    attrs: {
      "label": "Show more"
    },
    on: {
      "click": function($event) {
        return _vm.showMore()
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(!_vm.isLoading) ? _c('mu-content-block', [_c('mu-breadcrumb', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('mu-breadcrumb-item', {
    attrs: {
      "href": "#/faq"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToFAQ.apply(null, arguments)
      }
    }
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('mu-breadcrumb-item', [_vm._v(_vm._s(_vm.content.question))])], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-card', {
    staticClass: "top"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.content.question,
      "titleClass": "largeTitle blueTitle"
    }
  }), _vm._v(" "), (_vm.content.video_url !== null) ? _c('video', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "100%"
    },
    attrs: {
      "controlsList": "nodownload",
      "controls": "",
      "src": _vm.content.video_url
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.answer)
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    staticClass: "grey",
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "relative",
      "top": "-6px",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelRateThisAnswer')))]), _vm._v(" "), _c('mu-icon-button', {
    class: {
      'active': _vm.content.rating === 'UP'
    },
    attrs: {
      "color": "#767676",
      "icon": "thumb_up"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.upVote.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    class: {
      'inactive': _vm.content.rating === 'DOWN'
    },
    attrs: {
      "color": "#767676",
      "icon": "thumb_down"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downVote.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": "28"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkIn goals"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    attrs: {
      "id": "initialLoader"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_vm._l((_vm.goals), function(goal, index) {
    return _c('div', {
      key: ("goal-" + index)
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.activeStep),
        expression: "index === activeStep"
      }],
      staticClass: "step-content"
    }, [_c('p', {
      staticClass: "bigTxt"
    }, [_vm._v("Goal " + _vm._s(index + 1) + "/" + _vm._s(_vm.goals.length))]), _vm._v(" "), _c('p', {
      staticClass: "bigTxt"
    }, [_vm._v("\n            When you first began the program, you told us you wanted to "), _c('strong', {
      domProps: {
        "textContent": _vm._s(goal.goal)
      }
    }), _vm._v(" and rated yourself a "), _c('strong', {
      domProps: {
        "textContent": _vm._s(_vm.evaluation.old)
      }
    }), _vm._v(" out of 10 in regards to reaching this goal.\n          ")]), _vm._v(" "), _c('p', {
      staticClass: "bigTxt"
    }, [_vm._v("How do you feel like you’re doing now?")]), _vm._v(" "), _c('div', {
      staticClass: "sliderWrap"
    }, [_c('mu-slider', {
      staticClass: "slider",
      attrs: {
        "min": _vm.slider.min,
        "step": _vm.slider.step,
        "max": _vm.slider.max
      },
      model: {
        value: (_vm.evaluation.now),
        callback: function($$v) {
          _vm.$set(_vm.evaluation, "now", $$v)
        },
        expression: "evaluation.now"
      }
    }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
      staticClass: "sliderLabel amount",
      attrs: {
        "width": "33",
        "desktop": "33",
        "tablet": "33"
      },
      domProps: {
        "textContent": _vm._s(_vm.slider.min)
      }
    }), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "33",
        "desktop": "33",
        "tablet": "33"
      }
    }), _vm._v(" "), _c('mu-col', {
      staticClass: "sliderLabel amount",
      attrs: {
        "width": "33",
        "desktop": "33",
        "tablet": "33"
      },
      domProps: {
        "textContent": _vm._s(_vm.slider.max)
      }
    })], 1)], 1)])])
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isProcessing || _vm.isFinished,
      "type": "button",
      "label": _vm.isProcessing ? _vm.$t('message.savingText') : (_vm.isLastPanel ? _vm.$t('message.saveText') : _vm.$t('message.nextText')),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleNext.apply(null, arguments)
      }
    }
  })], 2)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-row', {
    staticClass: "reportCard top"
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "60",
      "tablet": "60"
    }
  }, [_c('div', {
    staticClass: "topArrow"
  }), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom errorBox"
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "upperReport",
      "title": _vm.message
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.splicedReports), function(item, index) {
    return _c('mu-list-item', {
      key: 'sr-' + index,
      attrs: {
        "title": item.firstname + ' ' + item.surname,
        "describeText": item.reason
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": (item.profile_thumb !== null) ? item.profile_thumb : 'static/avatar.png'
      },
      slot: "leftAvatar"
    })], 1)
  }), 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.report.reasons.length > 1 && _vm.limitSize !== Infinity) ? _c('mu-flat-button', {
    attrs: {
      "label": "View all reasons"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showAllReasons()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.limitSize === Infinity) ? _c('mu-flat-button', {
    attrs: {
      "label": "Hide reasons"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideReasons()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notReportingPage) ? _c('mu-flat-button', {
    attrs: {
      "label": "Handle report"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo(_vm.type)
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-edit"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode),
      expression: "!isEditMode"
    }],
    ref: "text",
    staticClass: "title",
    attrs: {
      "id": "q-readonly"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.title))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditMode),
      expression: "isEditMode"
    }],
    ref: "editor",
    staticClass: "title",
    attrs: {
      "id": "q-editor"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.isEditMode) ? _c('mu-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Edit'),
      expression: "'Edit'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "editIcon",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": 22,
      "value": "edit",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMode.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
    staticClass: "bottom"
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "label": _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateQuestion.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": _vm.activeStep
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.$store.state.list.diabetes_types) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n          Date of birth\n        ")]), _vm._v(" "), (_vm.dobItems) ? _c('mu-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.day),
      expression: "dob.day"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_day')
    },
    attrs: {
      "name": "birth_day",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-as": "day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Day")]), _vm._v(" "), _vm._l((_vm.dobItems.days), function(day, index) {
    return _c('option', {
      key: 'day-' + index,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.month),
      expression: "dob.month"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_month')
    },
    attrs: {
      "name": "birth_month",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-as": "month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._m(0)], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.year),
      expression: "dob.year"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_year')
    },
    attrs: {
      "name": "birth_year",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-as": "year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._m(1)], 2)])], 1) : _vm._e(), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "diabetesTxt",
      "data-vv-rules": 'required',
      "data-vv-name": "diabetes_type",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "diabetes type",
      "errorText": _vm.errors.first('diabetes_type'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": "Select",
      "label": _vm.$t('message.accountPreferencesWhatBringsYouHere')
    },
    model: {
      value: (_vm.model.diabetes_type_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "diabetes_type_id", $$v)
      },
      expression: "model.diabetes_type_id"
    }
  }, _vm._l((_vm.lists.diabetes_types), function(item, index) {
    return (item.hide === 0) ? _c('mu-menu-item', {
      key: 'diabetes-type-' + index,
      attrs: {
        "value": item.diabetes_type_id,
        "title": _vm.localizeRegistrationReason(item.diabetes_type)
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "sexTxt",
      "data-vv-rules": 'required',
      "data-vv-name": "sex",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesSex'),
      "errorText": _vm.errors.first('sex'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesSex')
    },
    model: {
      value: (_vm.model.gender_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "gender_id", $$v)
      },
      expression: "model.gender_id"
    }
  }, _vm._l((_vm.$store.state.list.genders), function(item, index) {
    return _c('mu-menu-item', {
      key: 'gender-' + index,
      attrs: {
        "value": item.gender_id,
        "title": _vm.localizeSex(item.gender)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    class: {
      bottomSpacingOther: !_vm.model.behalf_of_other
    }
  }, [_c('mu-checkbox', {
    attrs: {
      "id": "behalfOfOtherCheckBox",
      "label": _vm.$t('message.labelBehalfSomeoneElse')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.forceUpdate.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.model.behalf_of_other),
      callback: function($$v) {
        _vm.$set(_vm.model, "behalf_of_other", $$v)
      },
      expression: "model.behalf_of_other"
    }
  })], 1), _vm._v(" "), (_vm.model.behalf_of_other) ? _c('div', [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "relationshipTxt",
      "data-vv-rules": 'required',
      "data-vv-name": "relationship",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "relationship",
      "errorText": _vm.errors.first('relationship'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": 'Please select',
      "label": _vm.$t('message.labelRelationship')
    },
    model: {
      value: (_vm.model.relationship_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "relationship_id", $$v)
      },
      expression: "model.relationship_id"
    }
  }, _vm._l((_vm.lists.relationships), function(item, index) {
    return _c('mu-menu-item', {
      key: 'relationship-' + index,
      attrs: {
        "value": item.relationship_id,
        "title": _vm.localizeRelationship(item.title)
      }
    })
  }), 1), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "id": "relationshipNameTxt",
      "label": _vm.$t('message.nameText'),
      "fullWidth": true,
      "hintText": _vm.$t('message.placeholderText'),
      "rows": 3,
      "rowsMax": 6,
      "icon": "person",
      "type": "text"
    },
    model: {
      value: (_vm.model.behalf_of_name),
      callback: function($$v) {
        _vm.$set(_vm.model, "behalf_of_name", $$v)
      },
      expression: "model.behalf_of_name"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "isDesktop",
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "width": "80%",
      "src": "static/step-1-about.svg"
    }
  })])], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "fullWidth": true,
      "secondary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('option', {
      key: 'month-' + index,
      domProps: {
        "value": month.value
      }
    }, [_vm._v(_vm._s(_vm.localizeMonth(month.name)) + "\n              ")])
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('option', {
      key: 'year-' + index,
      domProps: {
        "value": year.value
      }
    }, [_vm._v(_vm._s(year.value) + "\n              ")])
  })
}]}

/***/ }),
/* 3865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-circular-progress",
    style: ({
      'width': _vm.size + 'px',
      'height': _vm.size + 'px'
    })
  }, [(_vm.mode === 'indeterminate') ? _c('circular', {
    attrs: {
      "size": _vm.size,
      "color": _vm.color,
      "borderWidth": _vm.strokeWidth
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode === 'determinate') ? _c('svg', {
    staticClass: "mu-circular-progress-determinate",
    style: (_vm.circularSvgStyle),
    attrs: {
      "viewBox": '0 0 ' + _vm.size + ' ' + _vm.size
    }
  }, [_c('circle', {
    staticClass: "mu-circular-progress-determinate-path",
    style: (_vm.circularPathStyle),
    attrs: {
      "r": _vm.radius,
      "cx": _vm.size / 2,
      "cy": _vm.size / 2,
      "fill": "none",
      "stroke-miterlimit": "20",
      "stroke-width": _vm.strokeWidth
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hba1cView"
  }, [_c('mu-paper', {
    staticClass: "insetGraph"
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "bloodGlucose"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('BloodGlucoseProgress')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.cardBloodGlucose')) + "\n      ")]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "hba1c"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.cardHbA1c')) + "\n      ")])], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('hba1c-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [(_vm.$store.state.user.settings) ? _c('hba1c-input', {
    staticClass: "bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings) ? _c('blood-glucose-input', {
    staticClass: "card-spacing bottom",
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c,
      "bloodGlucose": _vm.$store.state.user.settings.blood_glucose
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        key: 'tl-' + index,
        attrs: {
          "iconLine": "8",
          "iconType": "solid",
          "iconColor": _vm.btnColor
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        class: {
          spacingBottom: item.isControlsVisible
        },
        domProps: {
          "textContent": _vm._s(_vm.hba1cSetting.measure === 'mmol-mol' ? '' + item.mmol_mol + ' mmol/mol' : item.percent + ' %')
        }
      }) : _vm._e()])], 1), _vm._v(" "), (item.isControlsVisible && !item.isEditMode) ? _c('div', {
        attrs: {
          "align": "right"
        }
      }, [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('hba1c-edit', {
        attrs: {
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "cardDetails"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url('" + _vm.image + "')")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "cardText"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "label": _vm.buttonText
    },
    on: {
      "click": function($event) {
        return _vm.goToArticle(_vm.buttonLink)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "info-circle"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 3868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "waist-hip-line-graph"
    }
  }, [_c('mu-card', {
    staticClass: "line-graph",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-card-text', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "graph-nav"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading,
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateBackward.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "center",
      "grow": "5"
    }
  }, [_c('div', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.visualDate.fromDate + ' - ' + _vm.visualDate.toDate)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "3"
    }
  }, [_c('div', {
    staticClass: "graph-nav",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('mu-icon-button', {
    attrs: {
      "disabled": _vm.graphIsLoading || _vm.visualDate.toDateIsToday,
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dateForward.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.graphIsLoading),
      expression: "graphIsLoading"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "align": "center",
      "color": "#1E89E1"
    }
  })], 1)], 1), _vm._v(" "), (_vm.graphError && !_vm.graphIsLoading) ? _c('mu-flexbox', {
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/moods/content.svg",
      "width": "168"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "line-height": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.graphEmpty')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.graphEmptyExplain')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.graphIsLoading && !_vm.graphError) ? _c('graph-point-toggle', {
    attrs: {
      "is-disabled": _vm.graphIsLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.graphReady) ? _c('line-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphIsLoading && !_vm.graphError),
      expression: "!graphIsLoading && !graphError"
    }],
    style: ({
      height: _vm.height,
      minHeight: _vm.height,
      maxHeight: _vm.height
    }),
    attrs: {
      "type": _vm.graph.type,
      "userId": _vm.graph.userId,
      "from-date": _vm.graph.fromDate,
      "to-date": _vm.graph.toDate,
      "dateStep": _vm.visualDate.dateStep,
      "showPoints": _vm.showPoints
    },
    on: {
      "graphLoading": _vm.graphLoading,
      "graphLoaded": _vm.graphDidLoad,
      "graphFailed": _vm.graphDidFail
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-paper', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: (_vm.visualDate.dateStep === 0 || _vm.visualDate.dateStep === 1) && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(0)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(0)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 7 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(7)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(7)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 30 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(30)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(30)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.visualDate.dateStep === 360 && !_vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDateStep(360)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.humanizeDays(360)) + "\n        ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "border",
    class: {
      isSelected: _vm.isCustomDateMode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showCustomDate()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelCustomDate')) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.isCustomDateMode) ? _c('mu-paper', [_c('mu-card-text', [_c('mu-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "icon": "date_range",
      "hintText": _vm.$t('message.labelFromDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "fromDate", $$v)
      },
      expression: "customDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": _vm.$t('message.labelToDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.customDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.customDate, "toDate", $$v)
      },
      expression: "customDate.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100",
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideCustomDate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.applyText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.applyCustomDate()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('text-field', {
    ref: "textField",
    staticClass: "mu-select-field",
    attrs: {
      "label": _vm.label,
      "labelFloat": _vm.labelFloat,
      "underlineShow": _vm.underlineShow,
      "labelClass": _vm.labelClass,
      "labelFocusClass": _vm.labelFocusClass,
      "underlineClass": _vm.underlineClass,
      "underlineFocusClass": _vm.underlineFocusClass,
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.hintText,
      "hintTextClass": _vm.hintTextClass,
      "helpText": _vm.helpText,
      "helpTextClass": _vm.helpTextClass,
      "icon": _vm.icon,
      "iconClass": _vm.iconClass,
      "value": _vm.inputValue instanceof Array ? _vm.inputValue.join('') : _vm.inputValue,
      "disabled": _vm.disabled,
      "errorText": _vm.errorText,
      "errorColor": _vm.errorColor
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.inputValue instanceof Array ? _vm.inputValue.join('') : _vm.inputValue
    }
  }), _vm._v(" "), _c('dropDown-menu', {
    attrs: {
      "anchorEl": _vm.anchorEl,
      "scroller": _vm.scroller,
      "value": _vm.inputValue,
      "disabled": _vm.disabled,
      "maxHeight": _vm.maxHeight,
      "autoWidth": _vm.autoWidth,
      "iconClass": _vm.dropDownIconClass,
      "multiple": _vm.multiple,
      "anchorOrigin": {
        vertical: 'bottom',
        horizontal: 'left'
      },
      "separator": _vm.separator
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose,
      "change": _vm.handlehange
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "16px"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.data.recipes) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.data.recipes), function(recipe, index) {
    return _c('mu-col', {
      key: 'r' + index,
      staticClass: "bottom",
      attrs: {
        "width": "100",
        "desktop": "33",
        "tablet": "33"
      }
    }, [_c('recipe-card', {
      attrs: {
        "recipe": recipe
      }
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "detector"
  }), _vm._v(" "), (_vm.isAppending) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n      "), _c('div', {
    staticStyle: {
      "height": "16px"
    }
  }), _vm._v(" "), _c('mu-circular-progress')], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-col', [_c('mu-card', {
    staticClass: "messageContainer",
    class: _vm.messageClass
  }, [_c('div', {
    staticClass: "titleWrap"
  }, [_c('img', {
    staticClass: "titleIcon",
    attrs: {
      "src": _vm.messageIcon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "titleText"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "bodyWrap"
  }, [_c('span', {
    staticClass: "bodyText"
  }, [_vm._v(_vm._s(_vm.message))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 3872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-dialog', {
    staticStyle: {
      "width": "1024px"
    },
    attrs: {
      "open": _vm.dialog,
      "dialogClass": "coverPhotoDialog"
    },
    on: {
      "close": _vm.close
    }
  }, [(!_vm.isCropperVisible) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isUploading) ? _c('div', [_c('h2', [_vm._v("Just a moment")])]) : _vm._e(), _vm._v(" "), (!_vm.isUploading) ? _c('mu-raised-button', {
    attrs: {
      "icon": "photo",
      "label": "Select image"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('vue-base64-file-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disable-preview": "",
      "placeholder": "Tap to change cover photo",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.customImageMaxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCropperVisible && _vm.isCropperVisible),
      expression: "isCropperVisible && isCropperVisible"
    }],
    ref: "imageCropper"
  }), _vm._v(" "), _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUploading && _vm.isCropperVisible),
      expression: "!isUploading && isCropperVisible"
    }],
    attrs: {
      "align": "center"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "tooltip": "Cancel",
      "icon": "close",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate left",
      "icon": "rotate_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('left')
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "tooltip": "Rotate right",
      "icon": "rotate_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rotate('right')
      }
    }
  }), _vm._v(" "), _c('mu-circular-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploading),
      expression: "isUploading"
    }],
    attrs: {
      "size": 16
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "icon": "crop",
      "label": _vm.isUploading ? 'Uploading...' : 'Crop & Upload'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doCrop()
      }
    }
  })], 1), _vm._v(" "), (_vm.isUploading) ? _c('div', [_vm._v("Uploading...")]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('mu-linear-progress', {
    attrs: {
      "mode": "determinate",
      "value": _vm.completionPercentage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list', [_c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.notificationPreferencesQuestionReplies')
    },
    on: {
      "click": function($event) {
        _vm.model.answer = !_vm.model.answer
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#767676"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.notificationPreferencesQuestionRepliesSubLine')) + "\n        ")]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.answer),
      callback: function($$v) {
        _vm.$set(_vm.model, "answer", $$v)
      },
      expression: "model.answer"
    }
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.notificationPreferencesNewFollower')
    },
    on: {
      "click": function($event) {
        _vm.model.follow = !_vm.model.follow
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#767676"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.$t('message.notificationPreferencesNewFollowerSubLine')))]), _vm._v(" "), _c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.model.follow),
      callback: function($$v) {
        _vm.$set(_vm.model, "follow", $$v)
      },
      expression: "model.follow"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-card-text', [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "secondary": "",
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.snackbar) ? _c('mu-snackbar', {
    attrs: {
      "message": "Updated notification preferences",
      "action": "Ok"
    },
    on: {
      "actionClick": _vm.hideSnackbar,
      "close": _vm.hideSnackbar
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "password",
      "data-vv-rules": 'required',
      "data-vv-name": "old_password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.securityPreferencesOldPassword'),
      "errorText": _vm.errors.first('old_password'),
      "label": _vm.$t('message.securityPreferencesOldPassword'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.old_password),
      callback: function($$v) {
        _vm.$set(_vm.model, "old_password", $$v)
      },
      expression: "model.old_password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": _vm.model.visible ? 'text' : 'password',
      "data-vv-rules": 'required|min: 10|strong_password_regex',
      "data-vv-name": "new_password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.securityPreferencesDesiredPassword'),
      "errorText": _vm.errors.first('new_password'),
      "label": _vm.$t('message.securityPreferencesDesiredPassword'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.new_password),
      callback: function($$v) {
        _vm.$set(_vm.model, "new_password", $$v)
      },
      expression: "model.new_password"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.model.visible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.model.visible = !_vm.model.visible
      }
    }
  })], 1), _vm._v(" "), _c('password-strength-validation', {
    attrs: {
      "password": _vm.model.new_password
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') + '...' : _vm.$t('message.updateText'),
      "fullWidth": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('email-update')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle  largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-paper', [_c('mu-auto-complete', {
    staticClass: "inputInPaper",
    attrs: {
      "icon": "search",
      "underlineShow": false,
      "scroller": _vm.scroller,
      "inputClass": _vm.conditionSearchClass,
      "openOnFocus": !_vm.conditionSearching,
      "fullWidth": true,
      "hintText": _vm.$t('message.searchText'),
      "maxSearchResults": 10,
      "dataSource": _vm.conditionDataSource,
      "dataSourceConfig": _vm.conditionDataSourceConfig,
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleConditionSelected
    },
    model: {
      value: (_vm.conditionSearchValue),
      callback: function($$v) {
        _vm.conditionSearchValue = $$v
      },
      expression: "conditionSearchValue"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "136px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.conditions.length === 0 && !_vm.isLoading) ? _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "dashedBorder"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80",
      "src": "static/moods/content.svg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.conditionsPreferencesEmpty')))]), _vm._v("\n    " + _vm._s(_vm.$t('message.conditionsPreferencesHelpText')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('mu-list', _vm._l((_vm.conditions), function(item, index) {
    return _c('mu-list-item', {
      key: 'cd-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "disableRipple": "",
        "title": item.condition_label
      }
    }, [_c('mu-icon-button', {
      attrs: {
        "slot": "right",
        "icon": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteCondition(item)
        }
      },
      slot: "right"
    })], 1)
  }), 1), _vm._v(" "), _c('mu-card-text', [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.conditions.length === 0 || _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "followerTabs"
    }
  }, [_c('mu-row', _vm._l((_vm.tabs), function(tab, tabIndex) {
    return _c('mu-col', {
      key: 'follower-tab-' + tabIndex,
      attrs: {
        "tablet": "50",
        "desktop": "50",
        "width": "50"
      }
    }, [_c('router-link', {
      staticClass: "tab",
      attrs: {
        "to": tab.route
      },
      domProps: {
        "textContent": _vm._s(tab.label)
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-card', [_c('mu-list', _vm._l((_vm.items), function(item, index) {
    return _c('mu-list-item', {
      key: 'item-' + index,
      staticClass: "item",
      attrs: {
        "disableRipple": ""
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(item.profile_id)
        }
      },
      slot: "title"
    }, [_vm._v("\n          " + _vm._s(item.display_name) + "\n        ")]), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": item.profile_large
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(item.profile_id)
        }
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.diabetes_type)
      }
    })]), _vm._v(" "), (!item.is_own_profile) ? _c('mu-flat-button', {
      staticClass: "followBtn",
      class: {
        'following': item.is_following
      },
      attrs: {
        "slot": "right",
        "disabled": item.is_sending === true,
        "icon": item.is_following ? 'person' : 'person_add',
        "label": item.is_following ? 'Unfollow' : 'Follow',
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.followUser(item)
        }
      },
      slot: "right"
    }) : _vm._e()], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3877 */,
/* 3878 */,
/* 3879 */,
/* 3880 */,
/* 3881 */,
/* 3882 */,
/* 3883 */,
/* 3884 */,
/* 3885 */,
/* 3886 */,
/* 3887 */,
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */,
/* 3892 */,
/* 3893 */,
/* 3894 */,
/* 3895 */,
/* 3896 */,
/* 3897 */,
/* 3898 */,
/* 3899 */,
/* 3900 */,
/* 3901 */,
/* 3902 */,
/* 3903 */,
/* 3904 */,
/* 3905 */,
/* 3906 */,
/* 3907 */,
/* 3908 */,
/* 3909 */,
/* 3910 */,
/* 3911 */,
/* 3912 */,
/* 3913 */,
/* 3914 */,
/* 3915 */,
/* 3916 */,
/* 3917 */,
/* 3918 */,
/* 3919 */,
/* 3920 */,
/* 3921 */
/***/ (function(module, exports) {

module.exports = {"reportText":"Report","reportedText":"Reported","nameText":"Name","resetText":"Reset","labelContinueText":"Continue","logOutText":"Log out","logInText":"Log in","loggingInText":"Logging in...","sendingText":"Sending...","loadingText":"Loading...","searchText":"Search","searchingText":"Searching...","closeText":"Close","submitText":"Submit","saveText":"Save","savingText":"Saving...","readMoreText":"Read More","watchVideoText":"Watch Video","deleteText":"Delete","hideText":"Hide","moreText":"More","hiddenText":"Hidden","restoreText":"Restore","editText":"Edit","okText":"Ok","cancelText":"Cancel","addCommentText":"Add comment","addToFavouritesText":"Add to favourites","addTestimonialText":"Add testimonial","unfavouriteText":"Unfavourite","loadCommentsText":"Load comments","applyText":"Apply","discardText":"Discard","updateText":"Update","updatingText":"Updating","updatedText":"Updated","addEntryText":"Add entry","nextText":"Next","backText":"Back","skipText":"Skip","replyText":"reply","repliesText":"replies","replyToText":"Reply to","likeText":"like","likesText":"likes","listViewText":"List view","gridViewText":"Grid view","emptyText":"Nothing added yet","selectText":"Select","enableText":"Enable","disableText":"Disable","connectText":"Connect","andText":"and","youText":"You","exportText":"Export","exportTextData":"Export data","exportingText":"Exporting...","justAMomentText":"Just a moment...","trackingHelpText":"Tap any entry to edit or delete a reading","badgeChampion":"Champion","badgeSupport":"Support Team","badgeCompleted":"Completed the program","mealPlanGeneratorAppBarText":"Meal plan generator","fourZeroFourAppBarText":"Page not found","registerAppBarText":"Register","amendAppBarText":"Update","loginAppBarText":"Login","forgotPasswordAppBarText":"Forgot password","verifyAccountAppBarText":"Email confirmed","resetPasswordAppBarText":"Change your password","contactTitle":"Contact","contactSubTitle":"I have a question about:","contactAdded":"Your question has been submitted. Thanks","contactBodyLabel":"Anything else we should know?","contactReasonApp":"App","contactReasonWebsite":"Website","contactReasonTechnical":"Technical query","contactReasonFeatureRequest":"Feature request","contactReasonOther":"Other","contactReasonHcpCommission":"Commissioning the program","contactReasonHcpTraining":"Healthcare Professional Training","contactReasonHcpLeaflets":"Program leaflets and flyers","bootloaderConnecting":"Connecting...","bootloaderDownloadingAssets":"Downloading assets...","bootloaderInitializing":"Initializing...","bootloaderProfile":"Loading your profile...","dashboardAppBarText":"Dashboard","foodDiaryAppBarText":"Food Diary","foodDiaryAddFoodAppBarText":"Add Food","questionsAppBarText":"Discussion","profileAppBarText":"Profile","lifestyleAppBarText":"Lifestyle","downloadsAppBarText":"Downloads","coachingAppBarText":"Coaching","contactAppBarText":"Contact us","testimonialAppBarText":"Add a testimonial","hcpAppBarText":"Healthcare Professionals","questionReportAppBarText":"Question report","answerReportAppBarText":"Answer report","lifeReportAppBarText":"Life report","checkInAppBarText":"Check In","addProgressAppBarText":"Add progress","bloodGlucoseAppBarText":"My blood glucose readings","hbA1cAppBarText":"My HbA1c readings","weightAppBarText":"My weight progress","sleepAppBarText":"My sleep progress","bloodPressureAppBarText":"My blood pressure readings","ketonesAppBarText":"My ketone readings","medicationAppBarText":"My medication progress","moodAppBarText":"My emotional progress","cholesterolAppBarText":"My cholesterol readings","insulinAppBarText":"My insulin readings","activityAppBarText":"My activity progress","obAboutAppBarText":"About you - Getting started","obHealthAppBarText":"Your health - Getting started","obLocationAppBarText":"Your location - Getting started","obGoalsAppBarText":"Your Goals - Getting started","obPersonalizeAppBarText":"Personalize your program - Getting started","faqAppBarText":"Frequently Asked Questions","dashboardMenuTitleText":"Dashboard","foodDiaryMenuTitleText":"Food Diary","questionsMenuTitleText":"Discussion","profileMenuTitleText":"Profile","lifestyleMenuTitleText":"Lifestyle","downloadsMenuTitleText":"Downloads","coachingMenuTitleText":"Coaching","settingsMenuTitleText":"Settings","addProgressMenuTitleText":"Add Progress","faqMenuTitleText":"FAQs","feedbackMenuTitleText":"Feedback","lessonTitleText":"Lesson","lessonBonusTitleText":"Bonus lesson","threadTitleText":"Thread","settingsGeneralTitleText":"General","settingsSecurityTitleText":"Security","settingsSubscriptionTitleText":"Subscription","settingsPrivacyTitleText":"Privacy","settingsNotificationsTitleText":"Notifications","settingsUnitsTitleText":"Units","settingsPersonalizeTitleText":"Personalise","settingsConditionsTitleText":"Conditions","settingsMedicationTitleText":"Medications","settingsFoodTitleText":"Food Preferences","settingsDashboardTitleText":"Dashboard","settingsIntegrationTitleText":"Health App Integration","settingsPreferencesTitleText":"Marketing preferences","integrationCompleteAppBarText":"Integration was successful","loginForgotPassword":"Forgot password?","loginNoAccountYet":"Don't have an account yet?","loginSignUp":"Sign up","loginErrorIncorrectCredentials":"Incorrect credentials","loginRememberMe":"Remember me?","forgotPasswordTitle":"Forgotten your password?","forgotPasswordSubTitle":"Use the form below to send a password reset email","forgotPasswordSignIn":"I just want to sign in","forgotPasswordEmailNotFound":"We could not find an account with this email address","forgotPasswordEmailSentMessageTitle":"Password reset email was sent!","forgotPasswordEmailSendMessageSubTitle":"Please check your email inbox at","registerSignIn":"Sign in","registerHaveAccount":"Already have an account?","registerErrorUserExists":"An account using this email already exists","registerTestimonialConcent":"I consent to the","registerTestimonialExplain":"and that my testimonial can be used by the Program to inspire and motivate others","registerTermsByContinuing":"By continuing, you agree to our ","registerTermsAndCondtions":"Terms and conditions","registerTermsJoin":"and that you have read our","registerPrivacyPolicy":"Privacy policy","registerIncludingCookie":"including our Cookie Policy.","lessonActionPoints":"Action points","lessonActionPointsSubTitle":"Things to do this week","lessonViewTranscript":"View transcript","lessonHideTranscript":"Hide transcript","lessonDownloadsThisWeek":"Downloads this week","lessonQuestionsTitle":"Recently asked questions","lessonQuestionsSubTitle":"Questions asked this week","lessonQuestionsEmpty":"No one has asked questions about this lesson yet - why not be first?","lessonRatingVery":"Very","lessonRatingNotVery":"Not very","foodDiaryTodayYouveHad":"Today you've had...","foodDiaryLandingExplain":"You can add a food to your food diary by searching for what you ate.","foodDiaryRecentsEmpty":"Tap on the search button to start adding some food!","foodDiaryHasRecents":"Click an item in the recent list on the right of this panel to add it again.","foodDiaryRepeatYesterdayMeal":"Repeat yesterdays meal","foodDiaryIntakeBar":"Today you've had","foodDiaryIntakeBarNotToday":"On this date you had","foodDiaryModifyTargets":"Edit targets","foodDiaryNutritionPanelHeaderText":"Your nutrition targets","foodDiaryNutritionPanelSubHeaderText":"Configure your nutrition targets","foodDiaryBreakfast":"Breakfast","foodDiaryAddBreakfast":"Add breakfast","foodDiaryAddingBreakfast":"Adding breakfast","foodDiaryNoBreakfastLabel":"No breakfast added yet","foodDiaryLunch":"Lunch","foodDiaryAddLunch":"Add lunch","foodDiaryAddingLunch":"Adding lunch","foodDiaryNoLunchLabel":"No lunch added yet","foodDiaryDinner":"Dinner","foodDiaryAddDinner":"Add dinner","foodDiaryAddingDinner":"Adding dinner","foodDiaryNoDinnerLabel":"No dinner added yet","foodDiarySnack":"Snack","foodDiaryAddSnack":"Add snack","foodDiaryAddingSnack":"Adding snack","foodDiaryNoSnackLabel":"No snack added yet","foodDiaryQuickPortionLabel":"Quick portions","foodDiaryExportDataTitle":"Export nutrition data","foodDiaryExportDataSubTitle":"Export your Food Diary data","foodDiaryMealPlateNameTitle":"Give your meal a name","foodDiaryLoadFromMyMeals":"My saved meals","foodDiaryMealPlateRemoved":"Meal plate removed","dietPlanLowCarb":"Low Carb","dietPlanKeto":"Keto","nutrientCalories":"Calories","nutrientCaloriesShort":"Cals","nutrientProtein":"Protein","nutrientCarbohydrate":"Carbohydrate","nutrientCarbohydrateShort":"Carbs","nutrientSugar":"Sugar","nutrientFat":"Fat","nutrientTotalFat":"Total fat","nutrientTotalFatShort":"Tot fat","nutrientSaturatedFat":"Saturated Fat","nutrientSaturatedFatShort":"Sat fat","nutrientMonounsaturatedFat":"Monounsaturated Fat","nutrientPolyunsaturatedFat":"Polyunsaturated Fat","nutrientCholesterol":"Cholesterol","nutrientFibre":"Fibre","nutrientSodium":"Sodium","nutrientPotassium":"Potassium","visualizationBloodGlucoseHeader":"blood glucose reading(s) logged this month","confirmRemoveTitle":"Are you sure?","confirmResetAccount":"You are restarting your education to week 1","confirmedResetAccount":"Page will refresh in 1 second to update the changes. please wait...","confirmRemoveBloodGlucoseItem":"You are removing a blood glucose entry","confirmedRemoveBloodGlucoseItem":"Blood glucose entry was removed","confirmRemoveWeightItem":"You are removing a weight entry","confirmedRemoveWeightItem":"Weight entry was removed","confirmRemoveBloodPressureItem":"You are removing an blood pressure entry","confirmedRemoveBloodPressureItem":"Blood pressure entry was removed","confirmRemoveActivityItem":"You are removing a activity entry","confirmedRemoveActivityItem":"Activity entry was removed","confirmRemoveCholesterolItem":"You are removing a cholesterol entry","confirmedRemoveCholesterolItem":"Cholesterol entry was removed","confirmRemoveHbA1cItem":"You are removing a HbA1c entry","confirmedRemoveHbA1cItem":"HbA1c entry was removed","confirmRemoveInsulinItem":"You are removing a insulin entry","confirmedRemoveInsulinItem":"Insulin entry was removed","confirmRemoveKetoneItem":"You are removing a ketone entry","confirmedRemoveKetoneItem":"Ketone entry was removed","confirmRemoveMedicationItem":"You are removing a medication dosage","confirmedRemoveMedicationItem":"Medication dosage was removed","confirmRemoveMoodItem":"You are removing a mood entry","confirmedRemoveMoodItem":"Mood entry was removed","confirmRemoveSleepItem":"You are removing a sleep entry","confirmedRemoveSleepItem":"Sleep entry was removed","confirmRemoveFoodItem":"You are removing ","confirmedRemoveFoodItem":"was removed from your food diary","confirmRemoveAnswerItem":"You are removing an answer","confirmedRemoveAnswerItem":"Answer was removed","confirmRemoveQuestionItem":"You are removing a question","confirmedRemoveQuestionItem":"Question was removed","placeholderText":"Please enter","placeholderEmail":"email@email.com","lessonScrollerWeekPrefix":"Currently on","graphEmpty":"Nothing to see here yet","graphEmptyExplain":"Not enough data to create graph","graphPointToggleShowPoints":"Show points","graphToggleSmoothLine":"Curved line","graphToggleShowArea":"Area fill","graphPointsToggleTitle":"Options","labelIHave":"I have","labelFollowers":"Followers","labelFollowing":"Following","labelUpdateBio":"Update bio","labelEnterBio":"Enter bio","labelChangeProfilePicture":"Change profile picture","labelRemoveProfilePicture":"Remove profile picture","labelAddCoverPhoto":"Add cover photo","labelRemoveCoverPhoto":"Remove cover photo","labelUpdateCoverPhoto":"Update cover photo","labelQuestionsAnswered":"Questions answered","labelQuestionsAsked":"Questions asked","labelProgress":"Progress","labelProgramProgress":"Program progress","labelPostsAndReplies":"Posts & Replies","labelGallery":"Gallery","labelFood":"Food","labelDiscussionPrivate":"User has chosen to keep their questions/answers private","labelBloodGlucoseProgress":"Blood glucose progress","labelWeightProgress":"Weight progress","labelGraphsPrivate":"User has kept their progress graphs private","labelUploadPhoto":"Upload photo","labelMyGoals":"My goals","labelNew":"BETA","labelTestimonialSubTitle":"Share your thoughts and tell us how the program has helped you","labelAddTestimonial":"Add testimonial","labelBeforePhoto":"Add before photo","labelAfterPhoto":"Add after photo","labelDescription":"Description","labelBody":"Body","labelProviderInAssociationWith":"In association with","labelBonus":"Bonus","labelPersonalized":"Personalised","labelVerifyingAccount":"Verifying account...","labelAccountActivated":"Your account was activated, you may now continue with the program","labelRateThisAnswer":"Rate this answer","labelFindExactlyWhatYouAreLookingFor":"Find exactly what you're looking for...","labelRelatedQuestions":"Related questions","labelHi":"Hi","labelMostUseful":"Most useful","labelUpdateCommPreferences":"please update your communication preferences","labelRecents":"Recents","labelVoiceRecognition":"Go ahead and say something...","labelFoodSearchResultsEmpty":"No foods found for your search term","labelFoods":"foods","labelCustom":"Custom","labelProceed":"Proceed","labelProcessing":"Processing...","labelViewHistory":"View history","labelViewNutrition":"View nutrition","labelNutrientTargetHelpText":"Not too sure? Pick a preset","labelMultiplier":"Multiplier","labelServingSize":"Serving size","labelSwitchHcp":"Switch to HCP view","labelSwitchPatient":"Switch to Patient view","labelHelp":"Help","labelAddFoods":"Add some foods to your diary","labelAddHealthSnapshot":"Add a snapshot of your health","labelMyProfile":"My profile","labelStartProgramOver":"Want to start the program again from week 1?","labelClickHere":"Click here","labelError":"Something went wrong, please try again later","labelProgressDatePickerExplain":"This is the time and date that will be tied to any readings you save from this page","labelLetsGetStarted":"Lets get started","labelModifyDetails":"Modify your details","labelYourName":"Your name","labelBaseLine":"Base line","labelUpperRange":"Upper range","labelLowerRange":"Lower range","labelMinute":"min","labelFromDate":"From date","labelToDate":"To date","labelToday":"Today","labelDay":"Day","labelMonth":"Month","labelYear":"Year","labelNoTags":"No tags","labelSuccess":"Success","labelUpdateRange":"Update range","labelRangeUpdated":"Updated glucose range","labelResources":"Resources","labelMealPlans":"Meal plans","labelEnergy":"Energy","labelMood":"Mood","labelHealth":"Health","labelWeek":"Week","labelDownloadsFrom":"Downloads from: ","labelWaist":"Waist","labelHip":"Hip","labelBolus":"Bolus","labelCorrection":"Correction","labelBasal":"Basal","labelInsulinType":"Insulin type","labelBloodSugar":"Blood sugar","labelHba1cOptional":"HBA1C [OPTIONAL]","labelAboveRange":"Above range","labelBelowRange":"Below range","labelInRange":"In range","labelAdditionalInformation":"Additional information","labelAddPhoto":"Add photo","labelMedicationName":"Medication name","labelYes":"Yes","labelNo":"No","labelITakeThisForMy":"I take this for my","labelWhatDoYouTakeItFor":"What do you take it for?","labelUnits":"Units","labelHowOften":"How often?","labelDuration":"Duration","labelDurationMinutes":"Duration (minutes)","labelActivity":"Activity","labelActivityType":"Activity type","labelCaloriesBurnt":"Calories burned","labelCalorieBurn":"Calorie burn: ","labelDosage":"Dosage","labelCustomDate":"Custom date","labelRangeDay":"Day","labelRangeWeek":"Week","labelRangeMonth":"Month","labelRangeYear":"Year","labelSelectMedication":"Select medication","labelSystolic":"Systolic","labelDiastolic":"Diastolic","labelCholesterolTotal":"Total","labelCholesterolHDL":"HDL","labelCholesterolLDL":"LDL","labelCholesterolTriglycerides":"Triglycerides","labelHours":"Hours","labelQuality":"Quality","labelDate":"Date","labelTime":"Time","labelTagYourReading":"Tag your reading [OPTIONAL]","labelInchesPlaceholder":"Enter in inches","labelCMPlaceholder":"Enter in cm","labelBehalfSomeoneElse":"I'm joining on behalf of someone else","labelRelationship":"What is your relationship?","relationshipMother":"My mother","relationshipFather":"My father","relationshipWife":"My wife","relationshipHusband":"My husband","relationshipSister":"My sister","relationshipBrother":"My brother","relationshipSon":"My son","relationshipDaughter":"My daughter","relationshipPatient":"My patient","gettingStartedAboutTitle":"About you","gettingStartedAboutSubTitle":"Tailor your Program","errorExportEmpty":"Nothing to export","unitsPreferencesTitle":"Units","unitsPreferencesSubTitle":"Choose your preferred units of measurement","unitsPreferencesMeasureWeight":"I measure my weight in:","unitsPreferencesMeasureHeight":"I measure my height in:","unitsPreferencesMeasureWaist":"I measure my waist in:","unitsPreferencesMeasureHba1c":"I measure my HbA1c in:","unitsPreferencesMeasureBloodGlucose":"I measure my blood glucose in:","conditionsPreferencesTitle":"My conditions","conditionsPreferencesSubTitle":"Use the search below to update your conditions","conditionsPreferencesEmpty":"No conditions added yet","conditionsPreferencesHelpText":"Search to add a condition","accountPreferencesTitle":"General account details","accountPreferencesSubTitle":"Use the form below to update your general details","accountPreferencesChangeAvatar":"Change avatar","accountPreferencesFirstName":"First name","accountPreferencesSurname":"Surname","accountPreferencesEmail":"Email","accountPreferencesEmailVerify":"Verify Email","accountPreferencesPassword":"Password","accountPreferencesDisplayName":"Username","accountPreferencesPasswordVerify":"Verify Password","accountPreferencesBirthday":"Birthday","accountPreferencesWhatBringsYouHere":"What brings you here?","accountPreferencesDiagnosisYear":"Diagnosis year","accountPreferencesSex":"Sex","accountPreferencesTestBlood":"Do you test your blood?","accountPreferencesTakeMedication":"Do you take medication?","accountPreferencesEthnicity":"Ethnicity","accountPreferencesLanguage":"Language","accountPreferencesOccupation":"Occupation","accountPreferencesDietaryPreference":"Dietary preference","accountPreferencesAllergies":"Allergies","accountPreferencesShopCost":"Weekly grocery cost","integrationPreferencesTitle":"Integrations","integrationPreferencesSubTitle":"Integrate into other health apps","integrationFitBitExplain":"Connect your FitBit to your health tracking profile","integrationStriivExplain":"Connect your Stiiv to your health tracking profile","integrationStriivImportStarted":"Striiv import started, this can take a few minutes - you will be notified upon completion","integrationStriivImportEmpty":"No data to retrieve, if you know you have readings - sync your Striiv device by opening the Striiv App and swiping down to refresh on the dashboard, come back here then click the sync button.","privacyPreferencesTitle":"Privacy","privacyPreferencesSubTitle":"I am happy for others to see the following area(s) of my profile:","privacyPreferencesQuestions":"Questions","privacyPreferencesQuestionsExplain":"Things you've asked or replied to","privacyPreferencesFood":"Food & nutrition","privacyPreferencesFoodExplain":"Food diary entries, nutritional goals","privacyPreferencesProgress":"Progress","privacyPreferencesProgressExplain":"Weight loss, blood glucose stats, photos etc.","privacyPreferencesMedication":"Medication","privacyPreferencesMedicationExplain":"Anything you've recorded relating to your medication regime","privacyPreferencesAbout":"About me","privacyPreferencesAboutExplain":"About, likes and dislikes","paywallPaymentFailed":"Payment failed","paywallPaywallFailedExplain":"We're sorry, your payment failed or was cancelled. Please try again.","paywallStatusComplete":"Your payment has been completed and a receipt will be emailed to you","paywallStatusPending":"Practical Action Points to achieve your health goal","paywallStatusFailed":"No money has been deducted from your account","paywallJoinIncentiveReason1":"Award-winning education on therapeutic carbohydrate restriction","paywallJoinIncentiveReason2":"Practical Action Points to achieve your health goal","paywallJoinIncentiveReason3":"Tailored messages from your mentor to keep you on track","paywallJoinIncentiveReason4":"Support from behavioural health coaches","paywallJoinIncentiveReason5":"Support from the largest low carb community available 24/7","paywallJoinIncentiveReason6":"Integrated health tracking and data exporting","paywallJoinIncentiveReason7":"Over 40 meal plans customised to your dietary preferences","paywallJoinIncentiveReason8":"Over 1,000 recipe ideas","paywallJoinIncentiveReason9":"Daily news, research and expert opinions","paywallJoinIncentiveReason10":"Over 120 low carb resources","paywallJoinIncentiveReason11":"Access on any device on web, iOS, Android and Kindle","paywallJoinIncentiveReason12":"Constantly updated features and enhancements","paywallJoinIncentiveReason13":"Sync with Striiv, FitBit and Nokia Withings launching Summer 2018 ","paywallJoinIncentiveReason14":"Friendly technical support","paymentModalFeatureNotAvailable":"This feature is only available on the Premium tier of the Program","paymentModalUpgrade":"Upgrade now for a one-off payment of","paymentModalProceedPayment":"Proceed to Payment","notificationHeaderText":"Notifications","notificationEmptyText":"Nothing to see here yet","notificationPreferencesTitle":"Notification","notificationPreferencesSubTitle":"Use the toggles below to choose which type of notifications you wish to receive","notificationPreferencesHeaderText":"Notifications","notificationPreferencesEmptyText":"No new notifications","notificationPreferencesQuestionReplies":"Question replies","notificationPreferencesQuestionRepliesSubLine":"When someone answers my question","notificationPreferencesNewFollower":"New follower","notificationPreferencesNewFollowerSubLine":"When someone follows me","securityPreferencesTitle":"Security","securityPreferencesSubTitle":"Use the form below to update your password","subscriptionPreferencesTitle":"Subscription","subscriptionPreferencesSubTitle":"Manage your current subscription below","securityPreferencesOldPassword":"Old password","securityPreferencesDesiredPassword":"Desired password","securityPreferencesChangeEmail":"Change email address","securityPreferencesSendVerificationEmail":"Send verification email","securityPreferencesCheckEmailAt":"Please check verification email at","medicationPreferencesTitle":"My medications","medicationPreferencesSubTitle":"The dosages here will be taken into account when using the Medication card on the Dashboard","medicationPreferencesAdd":"Add a medication","medicationsPreferencesNotTaking":"Medications i'm no longer taking","medicationPreferencesAddSubTitle":"Use the form below add a new medication","medicationPreferenceUpdateSubTitle":"Use the form below to update medication information","medicationAlreadyTrackingError":"Already tracking this medication","medicationConfirmAlertTitle":"Marking medication as inactive","medicationConfirmAlertText":"You are no longer taking this medication","medicationConfirmAlertSuccessTitle":"Success!","medicationConfirmAlertSuccessText":"Marked as inactive","foodPreferencesTitle":"Foods","foodPreferencesSubTitle":"Adds foods to your love and hate lists","foodPreferencesLove":"Foods I love","foodsPreferencesLoveAdd":"Add favourite food","foodPreferencesHate":"Foods I dislike","foodPreferencesHateAdd":"Add disliked food","marketingPreferencesTitle":"Email Settings","marketingPreferencesSubTitle":"Choose the email communications that you'd like to receive from us.","marketingPreferenceCommunicationType":"Communication type","marketingPreferenceImIn":"I'm in","marketingPreferenceImOut":"I'm out","marketingPreferencePromotion":"Beta tester panel","marketingPreferencePromotionExplain":"Test cutting-edge new features first.","marketingPreferenceSurveys":"Research","marketingPreferenceSurveysExplain":"Get involved in academic research that match your profile.","marketingPreferenceNewsletters":"Low carb lifestyle","marketingPreferenceNewslettersExplain":"A monthly roundup of the latest recipes, meal plans, research, exclusive interviews, lifestyle tips, community updates and not-to-be-missed events, live Q&As, podcasts, conferences and more.","marketingPreferenceAlerts":"Program Alerts","marketingPreferenceAlertsExplain":"Milestones, replies, and notifications inside the app can all be emailed to you so that you can stay up to date with any developments of your account or the  Program.","marketingPreferenceUpdates":"Personalised support","marketingPreferenceUpdatesExplain":"Tips, insights and feedback on your progress to support your journey.","communityEmailPreferences":"Community","communityEmailPreferencesExplain":"Get notified of responses to your questions.","dashboardPreferencesTitle":"Dashboard","dashboardPreferencesSubTitle":"Drag list items to re-order, or hide the ones that aren't relevant to you","questionCreateTitle":"Ask your question","questionCreateSubTitle":"Our community is on hand 24 hours a day","questionCreateLabelTitle":"Question title","questionCreateLabelText":"Question text","questionCreateTitlePlaceholder":"i.e 'Should i stop metaformin?'","questionCreateTextPlaceholder":"Full body of your question","questionCreateTitleHelpText":"This is what others will see in the question list","discussionButtonAsk":"Ask a Question","discussionTabRecent":"Recent","discussionTabTrending":"Trending","discussionTabUseful":"Useful","discussionTabMyQuestions":"My questions","discussionTabMyAnswers":"My answers","discussionTabUnanswered":"Unanswered","discussionReportsTitle":"Reports","discussionReportsSubTitle":"A list of reported items","discussionTopContributorsTitle":"Top contributors","discussionTopContributorsSubTitle":"Users who contribute the most","discussionFaqTitle":"FAQs","discussionFaqSubTitle":"Questions often asked by the community","discussionAskedBySuffix":"asked by ","discussionAskedAtSuffix":" on ","discussionMyAnswersEmpty":"You have answered no questions","discussionMyQuestionsEmpty":"You have asked no questions","discussionHcpEmpty":"Be the first to ask a question","discussionSearchHintText":"Search for something","discussionYouAndOthersFoundUseful":"other(s) found this useful","threadTypeReply":"Type your reply...","threadAskedBy":"Question asked by ","threadPostsCount":"Posts:","threadSingleUseful":"found this useful","threadUseful":"person found this useful","threadUsefulPlural":"people found this useful","threadUserSaid":"said","threadPreviousQuestion":"Previous question","threadNextQuestion":"Next question","threadInputPlaceholder":"Type your reply...","threadSubmitReplyText":"Submit reply","threadChronological":"Chronological","threadMostRecent":"Most recent","threadAnswersEmpty":"No answers to this question yet, be the first.","threadPaging10":"10 per page","threadPaging20":"20 per page","threadPaging40":"40 per page","cardEmpty":"Nothing to see here yet","cardEmptySubLine":"Tap the + to add a reading","cardLatestReading":"Latest reading","cardLatestReadingAt":"Latest reading at","cardPreviousReading":"Previous reading","cardWeight":"Weight","cardWeightEmptyHeight":"Add your height to get started","cardWeightAdded":"Weight entry added","cardWeightTotalGain":"Total gain","cardWeightTotalLoss":"Total loss","cardWeightGainedThisWeek":"Gained this week","cardWeightLostThisWeek":"Lost this week","cardWeightWaistHipRatio":"Waist-hip ratio","cardActivity":"Activity","cardKetones":"Ketones","cardKetonesAdded":"Ketones entry added","cardBloodGlucoseAdded":"Blood glucose entry added","cardFromDevice":"From device: ","cardKetonesLastOccurrence":"Last occurrence","cardKetonesTotalOccurrences":"Total occurrences","cardSleep":"Sleep","cardSleepLastNight":"Last night","cardSleepAverage":"Average","cardSleepQuality":"Quality","cardSleepEntryAdded":"Sleep entry added","cardBloodGlucose":"Blood Glucose","cardBloodGlucose30DayAverage":"30 day average","cardBloodGlucoseInRange":"In range today","cardHbA1c":"HbA1c","cardHbA1cAdded":"HbA1c entry added","cardNutrition":"Nutrition","cardNutritionEmpty":"You've had nothing to eat today","cardNutritionSubLine":"to add a food","cardPhotos":"Progress photos","cardPhotosChoosePicture":"Choose picture","cardPhotosAddingPhotos":"Adding photos","cardInsulin":"Insulin","cardInsulinLatestBasal":"Latest basal","cardInsulinLatestBolus":"Latest bolus","cardInsulinLatestCorrection":"Latest correction","cardBloodPressure":"Blood pressure","cardBloodPressuremmHGPlaceholder":"Enter mmHG","cardBloodPressureAdded":"Blood pressure entry added","cardCholesterol":"Cholesterol","cardCholesterolLatestHDL":"Latest HDL","cardCholesterolLatestLDL":"Latest LDL","cardCholesterolLatestTriglycerides":"Latest triglycerides","cardCholesterolLatestTotal":"Latest total","cardMood":"Mood","cardMoodLatest":"Latest mood","cardMoodMostCommon":"Most common","cardMoodOftenTogether":"Often together","cardMoodAdded":"Mood entry added","cardMedication":"Medication","cardEmptyMedication":"Which medications do you take?","cardMedicationDose":"Dose","cardMedicationDosage":"Enter dosage","cardMedicationLastDose":"Last dose","cardMedicationLastMedication":"Last medication","cardMedicationAdded":"Medication entry added","cardMedicationRepeatYesterday":"Repeat yesterdays medication","cardMedicationSelect":"Select medication","cardTapPrefix":"Tap the","cardTapSuffix":"to get started","lifeCategoryListsHeaderText":"More in this category","lifeCategoryListsSubHeaderText":"You may also like...","lifeCommentsHeaderText":"Add a comment","lifeEmbedScrollingText":"Scroll to continue reading","lifeEmbedScrollingVideoText":"Scroll to watch video","lifeUnauthorizedArticle":"Unauthorized to view article","activityCycling":"Cycling","activitySwimming":"Swimming","activityGymRowing":"Rowing Machine","activityGymTreadmill":"Running - Treadmill","activityGymCycling":"Cycling - Gym","activityRunning":"Running","activityStairWalking":"Stair climbing","activityWalking":"Walking","activityGymWeights":"Weight Lifting","activityYoga":"Yoga","activitySports":"Sports","activityAerobics":"Aerobics","activitySex":"Sex","activityDancing":"Dancing","activitySalsaDancing":"Salsa Dancing","moodRefreshed":"Refreshed","moodEnergetic":"Energetic","moodFocused":"Focused","moodRestless":"Restless","moodCalm":"Calm","moodDistracted":"Distracted","moodFatigued":"Fatigued","moodSleepy":"Sleepy","moodWeak":"Weak","moodAnxious":"Anxious","moodChilled":"Chilled","moodRelieved":"Relieved","moodHappy":"Happy","moodContent":"Content","moodExcited":"Excited","moodStressed":"Stressed","moodIrritable":"Irritable","moodHopeless":"Hopeless","moodAngry":"Angry","moodWorried":"Worried","moodUnwell":"Unwell","moodDizzy":"Dizzy","moodHeadache":"Headache","moodHypo":"Hypo","moodPain":"Pain","medicationRegimeMilligrams":"milligram(s)","medicationRegimeGrams":"gram(s)","medicationRegimeDrops":"drop(s)","medicationRegimeTablespoons":"tablespoon(s)","medicationRegimeMicrograms":"microgram(s)","medicationRegimeTablets":"tablet(s)","medicationRegimeCapsules":"capsule(s)","medicationRegimeMilliliters":"milliliter(s)","medicationRegimeTeaspoons":"teaspoon(s)","medicationRegimeMinutes":"minute(s)","medicationRegimeHours":"hour(s)","medicationRegimeUnits":"units(s)","tagActivity":"Activity","tagAfterBreakfast":"After Breakfast","tagAfterDinnerMeal":"After Dinner/meal","tagAfterLunch":"After Lunch","tagBeforeBreakfast":"Before Breakfast","tagBeforeDinnerMeal":"Before Dinner/meal","tagBeforeLunch":"Before lunch","tagCorrection":"Correction","tagDrink":"Drink","tagDriving":"Driving","tagFasting":"Fasting","tagMenstruation":"Menstruation","tagParty":"Party","tagShop":"Shop","tagSnack":"Snack","tagWork":"Work","frequencyOnceDaily":"Daily","frequencyTwiceDaily":"Twice daily","frequencyThreeDaily":"Three times daily","frequencyWeekly":"Weekly","frequencyEverySixWeeks":"Every 6 weeks","frequencyFourTimesDaily":"Four times daily","frequencyEveryThreeMonths":"Every 3 months","frequencyFiveTimesDaily":"Five times daily","frequencyEveryOtherWeek":"Every other week","frequencyEveryThreeWeeks":"Every 3 weeks","frequencyMonthly":"Monthly","frequencyEveryEightWeeks":"Every 8 weeks","frequencyEveryTwelveWeeks":"Every 12 weeks","frequencyEverySixMonths":"Every 6 months","frequencyEveryEightMonths":"Every 8 months","frequencyYearly":"Yearly","frequencyOneTime":"One time","frequencyAsNeeded":"As needed","monthJanuary":"January","monthFebruary":"February","monthMarch":"March","monthApril":"April","monthMay":"May","monthJune":"June","monthJuly":"July","monthAugust":"August","monthSeptember":"September","monthOctober":"October","monthNovember":"November","monthDecember":"December","registerReasonPrediabetes":"Prediabetes","registerReasonType2Diabetes":"Type 2 diabetes","registerReasonType1Diabetes":"Type 1 diabetes","registerReasonGestationalDiabetes":"Gestational diabetes","registerReasonLADA":"LADA","registerReasonMODY":"MODY","registerReasonDiabetesInsipidus":"Diabetes insipidus","registerReasonStudentOrResearcher":"Student or researcher","registerReasonCarer":"Carer","registerReasonDSN":"DSN","registerReasonDoctor":"Doctor","registerReasonHCP":"HCP","registerReasonOther":"Other","registerReasonParentOfType1":"Parent of child with Type 1 diabetes","registerReasonParentOfType2":"Parent of child with Type 2 diabetes","registerReasonProfessionalCarer":"Professional carer","registerReasonDiagnosedObesity":"Obesity","registerReasonOverweight":"Overweight","registerReasonAnotherHealthCondition":"I have another health condition","sexMale":"Male","sexFemale":"Female","foodDiarySelectMyMeal":"Select one of your pre-saved meals from the list","gettingStartedTabYou":"You","gettingStartedTabHealth":"Health","gettingStartedTabLocation":"Location","gettingStartedTabGoals":"Goals","gettingStartedTabPersonalise":"Personalise","gettingStartedGoalsTitle":"Your goals","gettingStartedGoalsSubTitle":"Identifying your goals is important to establish how you will measure your success","gettingStartedGoalsSubHeader":"My goal is to…","goalReduceMedication":"Reduce medication dependency","goalLoseWeight":"Lose weight","goalReduceBloodGlucose":"Reduce blood glucose/HbA1c","goalSenseOfWellbeing":"Sense of wellbeing","goalHealthyLifestyle":"Healthy lifestyle for me and my family","goalSomethingElse":"Something else","gettingStartedHealthTitle":"Tell us about your health","gettingStartedHealthSubTitle":"Personalise your Program","gettingStartedHealthCheckRelevantBoxes":"Tick the relevant boxes below","gettingStartedHealthTypeCondition":"Type a condition","gettingStartedHealthDoYouHaveAnyOtherConditions":"Do you have any other health conditions?","gettingStartedDoYouHaveAnyConditions":"Do you have any health conditions","gettingStartedHealthDoYouHaveAnyConditions":"Do you have any other health conditions","gettingStartedHealthTypeMedication":"Type a medication","addressSurgeryName":"Surgery name","addressLine1":"Address line 1","addressLine2":"Address line 2","addressPostcode":"Post code","addressCity":"City","addressCounty":"County","addressCountry":"Country","gettingStartedLocationTitle":"Your location","gettingStartedLocationSubTitle":"Tell us where in the world you are","gettingStartedLocationGpSurgery":"My local gp surgery is...","gettingStartedLocationSurgeryNotInList":"I couldn't find my surgery in the list","goalReasonRelaxed":"Feel more relaxed","goalReasonRelaxedShort":"more relaxed","goalReasonControl":"Feel more in control","goalReasonControlShort":"more in control","goalReasonConfidence":"More confidence","goalReasonConfidenceShort":"more confident","goalReasonMoreActive":"More active","goalReasonMoreActiveShort":"more active","goalReasonHealthier":"Feel healthier","goalReasonHealthierShort":"healthier","goalReasonHappier":"Feel happier","goalReasonHappierShort":"happier","gettingStartedGoalsEmptyError":"Please select one or more goal(s)","gettingStartedGoalsWhatDifference":"What difference will it make to you?","gettingStartedGoalsRatingScale":"On a scale of 1 to 10, where would you say you are currently with these goals?","gettingStartedGoalsWhenYouAreFeeling":"When you are feeling","gettingStartedGoalsWhatWillYouNoticeIsDifferent":"what will you notice that is different? Who else will notice things are better and how?","labelStartTyping":"Start typing","gettingStartedGoalsWhenYouHave":"When you have","registerSubTitle":"Create your account to choose your plan or redeem your referral code.","modifySubTitle":"Update your account details to choose your plan or redeem your referral code.","goalImprovedSenseOfWellbeing":"achieved a greater sense of wellbeing","goalLostWeight":"lost weight","goalReducedMedication":"reduced your medication","goalReducedBloodGlucose":"improved blood glucose control","goalImprovedHealth":"improved the health of your family","goalImprovedSomethingElse":"accomplished your other goal","gettingStartedPersonalizeTitle":"Complete your personalisation","gettingStartedPersonalizeSubTitle":"Finally, set your personal preferences","gettingStartedPersonalizeFoodsTitle":"Favourite foods","gettingStartedPersonalizeFoodsSubTitle":"Which foods do you enjoy the most?","gettingStartedPersonalizeDietaryPreferencesTitle":"Dietary preferences and allergies","gettingStartedPersonalizeDietaryPreferencesSubTitle":"Get recipes and food ideas tailored to you","gettingStartedPersonalizeHealthTitle":"Your health data","gettingStartedPersonalizeHealthSubTitle":"Start your program with a few measurements","labelLastHbA1c":"When was your last hba1c?","allergyDairy":"Dairy","allergyGluten":"Gluten","allergyCelery":"Celery","allergyYeast":"Yeast","allergyShellfish":"Shellfish","allergyAlcohol":"Alcohol","allergyPeanuts":"Peanuts","allergyLupin":"Lupin","allergySoybeans":"Soybeans","allergyFish":"Fish","allergyEggs":"Eggs","allergyMustard":"Mustard","allergySulphites":"Sulphites","occupationFullTime":"Full time employment","occupationPartTime":"Part time employment","occupationRetired":"Retired","occupationSelfEmployed":"Self employed","occupationStudent":"Student","occupationUnemployed":"Unemployed","dietPreferenceNone":"No dietary preference","dietPreferencePescetarian":"Pescetarian","dietPreferenceVegetarian":"Vegetarian","dietPreferenceVegan":"Vegan","labelHeight":"Height","labelPerWeek":"per week","lifeCatBehaviourChange":"Behaviour change","lifeCatCarbsVsFat":"Carbs vs Fat","lifeCatChildren":"Children","lifeCatConditions":"Conditions","lifeCatDairyFree":"Dairy Free","lifeCatEducation":"Education","lifeCatExercise":"Exercise","lifeCatFoodAndRecipes":"Food and Recipes","lifeCatFoodSwaps":"Food Swaps","lifeCatHCP":"Healthcare Professionals","lifeCatIntermittentFasting":"Intermittent Fasting","lifeCatMotivation":"Motivation","lifeCatMythBusting":"Myth Busting","lifeCatPHC":"Conferences","lifeCatRecipesOfTheWeek":"Recipes of the week","lifeCatResearch":"Research","lifeCatSeasonalVeg":"Seasonal Veg","lifeCatSuccessStories":"Success Stories","lifeCatSugar":"Sugar","lifeCatWereListeningTo":"We're listening to","lifeCatWereWatching":"We're watching","lifeBrowseCategory":"Browse categories","lifeMyFavourites":"My Favourites","labelArticle":"article","labelArticles":"articles","emailResetPassSubject":"Reset your password","emailResetPassDescription":"You recently requested to reset your password for your Low Carb Program account. Use the button below to reset it. This password reset is only valid for the next 3 hours.","emailResetPassBtnLabel":"RESET PASSWORD","emailResetPassIgnore":"If you did not request a password reset, please ignore this email or contact support if you have questions.","emailFooterAllRightsReserved":"All rights reserved","emailTrouble":"If you're having trouble with the button above, copy and paste the URL below into your web browser.","labelTeam":"team","emailConfirmSubject":"Confirm your email","emailConfirmDescription":"You requested to update your email address. Please use the button below to confirm.","emailConfirmButton":"CONFIRM EMAIL","emailVerifySubject":"Verify your account.","emailVerifyDescription":"Welcome to the program. Please use the button below to confirm your account.","paywallPaywallFailed":"Payment Failed","labelProgressAddSnapshot":"Add a snapshot of your progress","labelAddToFoodDiary":"Add some foods to your diary","labelMadeWith":"Made with","foodDiarySaveMealForNextTime":"Save this meal for quick entry next time?","activityTaiChi":"Tai Chi","activityPilates":"Pilates","heightUpdateFormTitle":"Update your height","heightUpdateFormSubTitle":"Use the form below to update","occupationPreferNotToSay":"I prefer not to say","disconnectText":"Disconnect","labelHeartRateAverage":"Average heart rate","labelHeartRateOutOfRange":"Out of range","labelHeartRateFatBurn":"Fat burn","labelHeartRateCardio":"Cardio","labelHeartRatePeak":"Peak","marketingPreferenceMealplans":"Daily meal plans","marketingPreferenceMealplansExplain":"Get a new and unique meal plan every day of the year.  Starts November 1, 2018.","labelFloorsClimbed":"Floors climbed","labelDistance":"Distance","labelTotalSteps":"Total steps","labelFromDevice":"From device","labelSteps":"steps","labelManualEntry":"Self reported","activityStepsEmptyTitle":"You don't have any steps data yet","activityStepsEmptySubTitle":"To get started connect your favorite health app below","activityStepsEmptyButton":"Add an activity integration","quizTestKnowledge":"Test your knowledge","questionText":"Question","answerText":"answer","answersText":"answers","finishText":"Finish","quizComplete":"You completed the quiz!","labelTryAgain":"Try again","labelSeasonalDownloads":"Seasonal","labelTimeInBed":"Time in bed","labelTimeAsleep":"Time asleep","labelEfficiency":"Efficiency","labelTimeAwake":"Time awake","minutesAsleep":"Time asleep","minutesAwake":"Time awake","stageRemMinutes":"REM\n","stageLightMinutes":"Light","stageDeepMinutes":"Deep","labelTodaysPrediction":"Today's prediction","labelTodaysPredictionExplain":"See how close you are to today's predicted readings based on your profile history","labelTonightsPrediction":"Tonight's prediction","accountCigarettesPerDay":"How many cigarettes do you smoke a day?","accountSmokesCigarettes":"Are you a smoker?","ethnicityWhite":"White","ethnicityArab":"Arab","ethnicityIndian":"Indian","ethnicityPakistani":"Pakistani","ethnicityBangladeshi":"Bangladeshi","ethnicityChinese":"Chinese","ethnicityOtherAsian":"Other Asian","ethnicityBlack":"Black/African/Caribbean","ethnicityOther":"Other","registerReasonWellbeing":"General wellbeing","registerReasonNAFLD":"NAFLD","paymentCtaUpgrade":"Upgrade to Premium","paymentCtaCommunitySupport":"24/7 community support","paymentCtaResources":"Library of resources","paymentCtaMealPlans":"Weekly meal plans","paymentCtaUpdatesInformation":"Daily updated guides and information","paymentCtaFriendlySupport":"Friendly support","labelUpgrade":"Upgrade","paymentCtaEducation":"Award winning education","recipesAppBarText":"Recipes","recipeMenuTitleText":"Recipes","settingsActivityTitleText":"Activity","activitySettingsTitle":"Activity on your account","activitySettingsSubTitle":"See all login activities on your account from the last 7 days","settingsActivityHeadingDevice":"Device","settingsActivityHeadingEngine":"Engine","settingsActivityHeadingOS":"Operating System","settingsActivityHeadingIp":"IP Address","settingsActivityHeadingDate":"Date/Time","settingsExternalLoginTitle":"External Logins","recipeAppBarText":"Recipe","recipesFavoritesAppBarText":"My favourites","recipesAdvancedSearchAppBarText":"Advanced search","recipesSearchResultsAppBarText":"Search results","labelCookingTime":"Cooking time","labelPrepTime":"Preparation time","recipeAddedToDiary":"Recipe added to your food diary","passwordValidationError":"Password validation error","idleLogoutTitle":"Session expired","idleLogoutBody":"For security reasons, you’ve been logged out of the Low Carb Program due to inactivity. Please log in again.","savePasswordText":"Save password","usernameInitialModalTitle":"Would you like to set a username?","usernameInitialModalBody":"If you don’t want other members of the Low Carb Program to see your real name, you can now set a username for an extra level of privacy.","usernameInitialModalTip":"Tip: For added privacy, steer clear of using anything that resembles your email address or any personal information that could be used to identify you.","usernameInitialModalReject":"No, continue with first & last name","usernameInitialModalSave":"Set Username","usernameInitialModalConfirmTitle":"Username set","usernameInitialModalConfirmBody":"You can toggle whether to use your first and last name or your username throughout the Low Carb Program by visiting Settings. For now, people will only see your username.","usernameInitialModalRejectTitle":"No username set","usernameInitialModalRejectBody":"You can set a username in Settings -> General later if you change your mind."}

/***/ }),
/* 3922 */
/***/ (function(module, exports) {

module.exports = {"reportText":"Report","reportedText":"Reported","nameText":"Name","resetText":"Reset","labelContinueText":"Continue","logOutText":"Log out","logInText":"Log in","loggingInText":"Logging in...","sendingText":"Sending...","loadingText":"Loading...","searchText":"Search","searchingText":"Searching...","closeText":"Close","submitText":"Submit","saveText":"Save","savingText":"Saving...","readMoreText":"Read More","watchVideoText":"Watch Video","deleteText":"Delete","hideText":"Hide","moreText":"More","hiddenText":"Hidden","restoreText":"Restore","editText":"Edit","okText":"Ok","cancelText":"Cancel","addCommentText":"Add comment","printPageText":"Print page","addToFavouritesText":"Add to favourites","addTestimonialText":"Add testimonial","unfavouriteText":"Unfavourite","loadCommentsText":"Load comments","applyText":"Apply","discardText":"Discard","updateText":"Update","updatingText":"Updating","updatedText":"Updated","addEntryText":"Add entry","nextText":"Next","backText":"Back","skipText":"Skip","replyText":"reply","repliesText":"replies","replyToText":"Reply to","likeText":"like","likesText":"likes","listViewText":"List view","gridViewText":"Grid view","emptyText":"Nothing added yet","selectText":"Select","enableText":"Enable","disableText":"Disable","connectText":"Connect","andText":"and","youText":"You","exportText":"Export","exportTextData":"Export data","exportingText":"Exporting...","justAMomentText":"Just a moment...","trackingHelpText":"Tap any entry to edit or delete a reading","badgeChampion":"Champion","badgeSupport":"Support Team","badgeCompleted":"Completed the program","mealPlanGeneratorAppBarText":"Meal plan generator","fourZeroFourAppBarText":"Page not found","registerAppBarText":"Register","amendAppBarText":"Update","loginAppBarText":"Login","forgotPasswordAppBarText":"Forgot password","verifyAccountAppBarText":"Email confirmed","resetPasswordAppBarText":"Change your password","contactTitle":"Contact","contactSubTitle":"I have a question about:","contactAdded":"Your question has been submitted. Thanks","contactBodyLabel":"Anything else we should know?","contactReasonApp":"App","contactReasonWebsite":"Website","contactReasonTechnical":"Technical query","contactReasonFeatureRequest":"Feature request","contactReasonOther":"Other","contactReasonHcpCommission":"Commissioning the program","contactReasonHcpTraining":"Healthcare Professional Training","contactReasonHcpLeaflets":"Program leaflets and flyers","bootloaderConnecting":"Connecting...","bootloaderDownloadingAssets":"Downloading assets...","bootloaderInitializing":"Initializing...","bootloaderProfile":"Loading your profile...","dashboardAppBarText":"Dashboard","foodDiaryAppBarText":"Food Diary","foodDiaryAddFoodAppBarText":"Add Food","questionsAppBarText":"Discussion","profileAppBarText":"Profile","lifestyleAppBarText":"Lifestyle","downloadsAppBarText":"Downloads","coachingAppBarText":"Coaching","contactAppBarText":"Contact us","testimonialAppBarText":"Add a testimonial","hcpAppBarText":"Healthcare Professionals","questionReportAppBarText":"Question report","answerReportAppBarText":"Answer report","lifeReportAppBarText":"Life report","checkInAppBarText":"Check In","addProgressAppBarText":"Add progress","bloodGlucoseAppBarText":"My blood glucose readings","hbA1cAppBarText":"My HbA1c readings","weightAppBarText":"My weight progress","sleepAppBarText":"My sleep progress","bloodPressureAppBarText":"My blood pressure readings","ketonesAppBarText":"My ketone readings","medicationAppBarText":"My medication progress","moodAppBarText":"My emotional progress","cholesterolAppBarText":"My cholesterol readings","insulinAppBarText":"My insulin readings","activityAppBarText":"My activity progress","obAboutAppBarText":"About you - Getting started","obHealthAppBarText":"Your health - Getting started","obLocationAppBarText":"Your location - Getting started","obGoalsAppBarText":"Your Goals - Getting started","obPersonalizeAppBarText":"Personalize your program - Getting started","faqAppBarText":"Frequently Asked Questions","dashboardMenuTitleText":"Dashboard","foodDiaryMenuTitleText":"Food Diary","questionsMenuTitleText":"Discussion","profileMenuTitleText":"Profile","lifestyleMenuTitleText":"Lifestyle","downloadsMenuTitleText":"Downloads","coachingMenuTitleText":"Coaching","settingsMenuTitleText":"Settings","shopMenuTitleText":"Shop","addProgressMenuTitleText":"Add Progress","faqMenuTitleText":"FAQs","feedbackMenuTitleText":"Feedback","lessonTitleText":"Lesson","lessonBonusTitleText":"Bonus lesson","threadTitleText":"Thread","settingsGeneralTitleText":"General","settingsSecurityTitleText":"Security","settingsSubscriptionTitleText":"Subscription","settingsPrivacyTitleText":"Privacy","settingsNotificationsTitleText":"Notifications","settingsUnitsTitleText":"Units","settingsPersonalizeTitleText":"Personalise","settingsConditionsTitleText":"Conditions","settingsMedicationTitleText":"Medications","settingsFoodTitleText":"Food Preferences","settingsDashboardTitleText":"Dashboard","settingsIntegrationTitleText":"Health App Integration","settingsPreferencesTitleText":"Marketing preferences","integrationCompleteAppBarText":"Integration was successful","loginForgotPassword":"Forgot password?","loginNoAccountYet":"Don't have an account yet?","loginSignUp":"Sign up","loginErrorIncorrectCredentials":"Incorrect credentials","loginRememberMe":"Remember me?","forgotPasswordTitle":"Forgotten your password?","forgotPasswordSubTitle":"Use the form below to send a password reset email","forgotPasswordSignIn":"I just want to sign in","forgotPasswordEmailNotFound":"We could not find an account with this email address","forgotPasswordEmailSentMessageTitle":"Password reset email was sent!","forgotPasswordEmailSendMessageSubTitle":"Please check your email inbox at","registerSignIn":"Sign in","registerHaveAccount":"Already have an account?","registerErrorUserExists":"An account using this email already exists","registerTestimonialConcent":"I consent to the","registerTestimonialExplain":"and that my testimonial can be used by the Program to inspire and motivate others","registerTermsByContinuing":"I agree to ","registerTermsAndCondtions":"Terms and conditions","registerTermsJoin":"and that you have read our","registerPrivacyPolicy":"Privacy policy","registerIncluding":"including our","registerIncludingCookie":"Cookie Policy.","lessonActionPoints":"Action points","lessonActionPointsSubTitle":"Things to do this week","lessonViewTranscript":"View transcript","lessonHideTranscript":"Hide transcript","lessonDownloadsThisWeek":"Downloads this week","lessonQuestionsTitle":"Recently asked questions","lessonQuestionsSubTitle":"Questions asked this week","lessonQuestionsEmpty":"No one has asked questions about this lesson yet - why not be first?","lessonRatingVery":"Very","lessonRatingNotVery":"Not very","foodDiaryTodayYouveHad":"Today you've had...","foodDiaryLandingExplain":"You can add a food to your food diary by searching for what you ate.","foodDiaryRecentsEmpty":"Tap on the search button to start adding some food!","foodDiaryHasRecents":"Click an item in the recent list on the right of this panel to add it again.","foodDiaryRepeatYesterdayMeal":"Repeat yesterdays meal","foodDiaryIntakeBar":"Today you've had","foodDiaryIntakeBarNotToday":"On this date you had","foodDiaryModifyTargets":"Edit targets","foodDiaryNutritionPanelHeaderText":"Your nutrition targets","foodDiaryNutritionPanelSubHeaderText":"Configure your nutrition targets","foodDiaryBreakfast":"Breakfast","foodDiaryAddBreakfast":"Add breakfast","foodDiaryAddingBreakfast":"Adding breakfast","foodDiaryNoBreakfastLabel":"No breakfast added yet","foodDiaryLunch":"Lunch","foodDiaryAddLunch":"Add lunch","foodDiaryAddingLunch":"Adding lunch","foodDiaryNoLunchLabel":"No lunch added yet","foodDiaryDinner":"Dinner","foodDiaryAddDinner":"Add dinner","foodDiaryAddingDinner":"Adding dinner","foodDiaryNoDinnerLabel":"No dinner added yet","foodDiarySnack":"Snack","foodDiaryAddSnack":"Add snack","foodDiaryAddingSnack":"Adding snack","foodDiaryNoSnackLabel":"No snack added yet","foodDiaryQuickPortionLabel":"Quick portions","foodDiaryExportDataTitle":"Export nutrition data","foodDiaryExportDataSubTitle":"Export your Food Diary data","foodDiaryMealPlateNameTitle":"Give your meal a name","foodDiaryLoadFromMyMeals":"My saved meals","foodDiaryMealPlateRemoved":"Meal plate removed","dietPlanLowCarb":"Low Carb","dietPlanKeto":"Keto","nutrientCalories":"Calories","nutrientCaloriesShort":"Cals","nutrientProtein":"Protein","nutrientCarbohydrate":"Carbohydrate","nutrientCarbohydrateShort":"Carbs","nutrientSugar":"Sugar","nutrientFat":"Fat","nutrientTotalFat":"Total fat","nutrientTotalFatShort":"Tot fat","nutrientSaturatedFat":"Saturated Fat","nutrientSaturatedFatShort":"Sat fat","nutrientMonounsaturatedFat":"Monounsaturated Fat","nutrientPolyunsaturatedFat":"Polyunsaturated Fat","nutrientCholesterol":"Cholesterol","nutrientFibre":"Fibre","nutrientSodium":"Sodium","nutrientPotassium":"Potassium","visualizationBloodGlucoseHeader":"blood glucose reading(s) logged this month","confirmRemoveTitle":"Are you sure?","confirmResetAccount":"You are restarting your education to week 1","confirmedResetAccount":"Page will refresh in 1 second to update the changes. please wait...","confirmRemoveBloodGlucoseItem":"You are removing a blood glucose entry","confirmedRemoveBloodGlucoseItem":"Blood glucose entry was removed","confirmRemoveWeightItem":"You are removing a weight entry","confirmedRemoveWeightItem":"Weight entry was removed","confirmRemoveBloodPressureItem":"You are removing an blood pressure entry","confirmedRemoveBloodPressureItem":"Blood pressure entry was removed","confirmRemoveActivityItem":"You are removing a activity entry","confirmedRemoveActivityItem":"Activity entry was removed","confirmRemoveCholesterolItem":"You are removing a cholesterol entry","confirmedRemoveCholesterolItem":"Cholesterol entry was removed","confirmRemoveHbA1cItem":"You are removing a HbA1c entry","confirmedRemoveHbA1cItem":"HbA1c entry was removed","confirmRemoveInsulinItem":"You are removing a insulin entry","confirmedRemoveInsulinItem":"Insulin entry was removed","confirmRemoveKetoneItem":"You are removing a ketone entry","confirmedRemoveKetoneItem":"Ketone entry was removed","confirmRemoveMedicationItem":"You are removing a medication dosage","confirmedRemoveMedicationItem":"Medication dosage was removed","confirmRemoveMoodItem":"You are removing a mood entry","confirmedRemoveMoodItem":"Mood entry was removed","confirmRemoveSleepItem":"You are removing a sleep entry","confirmedRemoveSleepItem":"Sleep entry was removed","confirmRemoveFoodItem":"You are removing ","confirmedRemoveFoodItem":"was removed from your food diary","confirmRemoveAnswerItem":"You are removing an answer","confirmedRemoveAnswerItem":"Answer was removed","confirmRemoveQuestionItem":"You are removing a question","confirmedRemoveQuestionItem":"Question was removed","placeholderText":"Please enter","placeholderEmail":"email@email.com","lessonScrollerWeekPrefix":"Currently on","graphEmpty":"Nothing to see here yet","graphEmptyExplain":"Not enough data to create graph","graphPointToggleShowPoints":"Show points","graphToggleSmoothLine":"Curved line","graphToggleShowArea":"Area fill","graphPointsToggleTitle":"Options","labelIHave":"I have","labelFollowers":"Followers","labelFollowing":"Following","labelUpdateBio":"Update bio","labelEnterBio":"Enter bio","labelChangeProfilePicture":"Change profile picture","labelRemoveProfilePicture":"Remove profile picture","labelAddCoverPhoto":"Add cover photo","labelRemoveCoverPhoto":"Remove cover photo","labelUpdateCoverPhoto":"Update cover photo","labelQuestionsAnswered":"Questions answered","labelQuestionsAsked":"Questions asked","labelProgress":"Progress","labelProgramProgress":"Program progress","labelPostsAndReplies":"Posts & Replies","labelGallery":"Gallery","labelFood":"Food","labelDiscussionPrivate":"User has chosen to keep their questions/answers private","labelBloodGlucoseProgress":"Blood glucose progress","labelWeightProgress":"Weight progress","labelGraphsPrivate":"User has kept their progress graphs private","labelUploadPhoto":"Upload photo","labelMyGoals":"My goals","labelNew":"BETA","labelTestimonialSubTitle":"Share your thoughts and tell us how the program has helped you","labelAddTestimonial":"Add testimonial","labelBeforePhoto":"Add before photo","labelAfterPhoto":"Add after photo","labelDescription":"Description","labelBody":"Body","labelProviderInAssociationWith":"In association with","labelBonus":"Bonus","labelPersonalized":"Personalised","labelVerifyingAccount":"Verifying account...","labelAccountActivated":"Your account was activated, you may now continue with the program","labelRateThisAnswer":"Rate this answer","labelFindExactlyWhatYouAreLookingFor":"Find exactly what you're looking for...","labelRelatedQuestions":"Related questions","labelHi":"Hi","labelMostUseful":"Most useful","labelUpdateCommPreferences":"please update your communication preferences","labelRecents":"Recents","labelVoiceRecognition":"Go ahead and say something...","labelFoodSearchResultsEmpty":"No foods found for your search term","labelFoods":"foods","labelCustom":"Custom","labelProceed":"Proceed","labelProcessing":"Processing...","labelViewHistory":"View history","labelViewNutrition":"View nutrition","labelNutrientTargetHelpText":"Not too sure? Pick a preset","labelMultiplier":"Multiplier","labelServingSize":"Serving size","labelSwitchHcp":"Switch to HCP view","labelSwitchPatient":"Switch to Patient view","labelHelp":"Help","labelAddFoods":"Add some foods to your diary","labelAddHealthSnapshot":"Add a snapshot of your health","labelMyProfile":"My profile","labelStartProgramOver":"Want to start the program again from week 1?","labelClickHere":"Click here","labelError":"Something went wrong, please try again later","labelProgressDatePickerExplain":"This is the time and date that will be tied to any readings you save from this page","labelLetsGetStarted":"Let's get started","labelModifyDetails":"Modify your details","labelYourName":"Your name","labelBaseLine":"Base line","labelUpperRange":"Upper range","labelLowerRange":"Lower range","labelMinute":"min","labelFromDate":"From date","labelToDate":"To date","labelToday":"Today","labelDay":"Day","labelMonth":"Month","labelYear":"Year","labelNoTags":"No tags","labelSuccess":"Success","labelUpdateRange":"Update range","labelRangeUpdated":"Updated glucose range","labelResources":"Resources","labelMealPlans":"Meal plans","labelEnergy":"Energy","labelMood":"Mood","labelHealth":"Health","labelWeek":"Week","labelDownloadsFrom":"Downloads from: ","labelWaist":"Waist","labelHip":"Hip","labelBolus":"Bolus","labelCorrection":"Correction","labelBasal":"Basal","labelInsulinType":"Insulin type","labelBloodSugar":"Blood sugar","labelHba1cOptional":"HBA1C [OPTIONAL]","labelAboveRange":"Above range","labelBelowRange":"Below range","labelInRange":"In range","labelAdditionalInformation":"Additional information","labelAddPhoto":"Add photo","labelMedicationName":"Medication name","labelYes":"Yes","labelNo":"No","labelITakeThisForMy":"I take this for my","labelWhatDoYouTakeItFor":"What do you take it for?","labelUnits":"Units","labelHowOften":"How often?","labelDuration":"Duration","labelDurationMinutes":"Duration (minutes)","labelActivity":"Activity","labelActivityType":"Activity type","labelCaloriesBurnt":"Calories burned","labelCalorieBurn":"Calorie burn: ","labelDosage":"Dosage","labelCustomDate":"Custom date","labelRangeDay":"Day","labelRangeWeek":"Week","labelRangeMonth":"Month","labelRangeYear":"Year","labelSelectMedication":"Select medication","labelSystolic":"Systolic","labelDiastolic":"Diastolic","labelCholesterolTotal":"Total","labelCholesterolHDL":"HDL","labelCholesterolLDL":"LDL","labelCholesterolTriglycerides":"Triglycerides","labelHours":"Hours","labelQuality":"Quality","labelDate":"Date","labelTime":"Time","labelTagYourReading":"Tag your reading [OPTIONAL]","labelInchesPlaceholder":"Enter in inches","labelCMPlaceholder":"Enter in cm","labelBehalfSomeoneElse":"I'm joining on behalf of someone else","labelRelationship":"What is your relationship?","relationshipMother":"My mother","relationshipFather":"My father","relationshipWife":"My wife","relationshipHusband":"My husband","relationshipSister":"My sister","relationshipBrother":"My brother","relationshipSon":"My son","relationshipDaughter":"My daughter","relationshipPatient":"My patient","gettingStartedAboutTitle":"About you","gettingStartedAboutSubTitle":"Tailor your Program","errorExportEmpty":"Nothing to export","unitsPreferencesTitle":"Units","unitsPreferencesSubTitle":"Choose your preferred units of measurement","unitsPreferencesMeasureWeight":"I measure my weight in:","unitsPreferencesMeasureHeight":"I measure my height in:","unitsPreferencesMeasureWaist":"I measure my waist in:","unitsPreferencesMeasureHba1c":"I measure my HbA1c in:","unitsPreferencesMeasureBloodGlucose":"I measure my blood glucose in:","conditionsPreferencesTitle":"My conditions","conditionsPreferencesSubTitle":"Use the search below to update your conditions","conditionsPreferencesEmpty":"No conditions added yet","conditionsPreferencesHelpText":"Search to add a condition","accountPreferencesTitle":"General account details","accountPreferencesSubTitle":"Use the form below to update your general details","accountPreferencesChangeAvatar":"Change avatar","accountPreferencesFirstName":"First name","accountPreferencesSurname":"Last name","accountPreferencesDisplayName":"Username","accountPreferencesEmail":"Email address","accountPreferencesEmailVerify":"Verify Email","accountPreferencesPassword":"Password","accountPreferencesPasswordVerify":"Confirm Password","accountPreferencesBirthday":"Birthday","accountPreferencesWhatBringsYouHere":"What brings you here?","accountPreferencesDiagnosisYear":"Diagnosis year","accountPreferencesSex":"Sex","accountPreferencesTestBlood":"Do you test your blood?","accountPreferencesTakeMedication":"Do you take medication?","accountPreferencesEthnicity":"Ethnicity","accountPreferencesLanguage":"Language","accountPreferencesOccupation":"Occupation","accountPreferencesDietaryPreference":"Dietary preference","accountPreferencesAllergies":"Allergies","accountPreferencesShopCost":"Weekly grocery cost","integrationPreferencesTitle":"Integrations","integrationPreferencesSubTitle":"Integrate into other health apps","integrationFitBitExplain":"Connect your FitBit to your health tracking profile","integrationStriivExplain":"Connect your Stiiv to your health tracking profile","integrationStriivImportStarted":"Striiv import started, this can take a few minutes - you will be notified upon completion","integrationStriivImportEmpty":"No data to retrieve, if you know you have readings - sync your Striiv device by opening the Striiv App and swiping down to refresh on the dashboard, come back here then click the sync button.","privacyPreferencesTitle":"Privacy","privacyPreferencesSubTitle":"I am happy for others to see the following area(s) of my profile:","privacyPreferencesQuestions":"Questions","privacyPreferencesQuestionsExplain":"Things you've asked or replied to","privacyPreferencesFood":"Food & nutrition","privacyPreferencesFoodExplain":"Food diary entries, nutritional goals","privacyPreferencesProgress":"Progress","privacyPreferencesProgressExplain":"Weight loss, blood glucose stats, photos etc.","privacyPreferencesMedication":"Medication","privacyPreferencesMedicationExplain":"Anything you've recorded relating to your medication regime","privacyPreferencesAbout":"About me","privacyPreferencesAboutExplain":"About, likes and dislikes","paywallPaymentFailed":"Payment failed","paywallPaywallFailedExplain":"We're sorry, your payment failed or was cancelled. Please try again.","paywallStatusComplete":"Your payment has been completed and a receipt will be emailed to you","paywallStatusPending":"Practical Action Points to achieve your health goal","paywallStatusFailed":"No money has been deducted from your account","paywallJoinIncentiveReason1":"Award-winning education on therapeutic carbohydrate restriction","paywallJoinIncentiveReason2":"Practical Action Points to achieve your health goal","paywallJoinIncentiveReason3":"Tailored messages from your mentor to keep you on track","paywallJoinIncentiveReason4":"Support from behavioural health coaches","paywallJoinIncentiveReason5":"Support from the largest low carb community available 24/7","paywallJoinIncentiveReason6":"Integrated health tracking and data exporting","paywallJoinIncentiveReason7":"Over 40 meal plans customised to your dietary preferences","paywallJoinIncentiveReason8":"Over 1,000 recipe ideas","paywallJoinIncentiveReason9":"Daily news, research and expert opinions","paywallJoinIncentiveReason10":"Over 120 low carb resources","paywallJoinIncentiveReason11":"Access on any device on web, iOS, Android and Kindle","paywallJoinIncentiveReason12":"Constantly updated features and enhancements","paywallJoinIncentiveReason13":"Sync with Striiv, FitBit and Nokia Withings launching Summer 2018 ","paywallJoinIncentiveReason14":"Friendly technical support","paymentModalFeatureNotAvailable":"This feature is only available on the Premium tier of the Program","paymentModalUpgrade":"Upgrade now for a one-off payment of","paymentModalProceedPayment":"Proceed to Payment","notificationHeaderText":"Notifications","notificationEmptyText":"Nothing to see here yet","notificationPreferencesTitle":"Notification","notificationPreferencesSubTitle":"Use the toggles below to choose which type of notifications you wish to receive","notificationPreferencesHeaderText":"Notifications","notificationPreferencesEmptyText":"No new notifications","notificationPreferencesQuestionReplies":"Question replies","notificationPreferencesQuestionRepliesSubLine":"When someone answers my question","notificationPreferencesNewFollower":"New follower","notificationPreferencesNewFollowerSubLine":"When someone follows me","securityPreferencesTitle":"Security","securityPreferencesSubTitle":"Use the form below to update your password","subscriptionPreferencesTitle":"Subscription","subscriptionPreferencesSubTitle":"Manage your current subscription below","securityPreferencesOldPassword":"old password","securityPreferencesDesiredPassword":"desired password","securityPreferencesChangeEmail":"change email address","securityPreferencesSendVerificationEmail":"Send verification email","securityPreferencesCheckEmailAt":"Please check verification email at","medicationPreferencesTitle":"My medications","medicationPreferencesSubTitle":"The dosages here will be taken into account when using the Medication card on the Dashboard","medicationPreferencesAdd":"Add a medication","medicationsPreferencesNotTaking":"Medications i'm no longer taking","medicationPreferencesAddSubTitle":"Use the form below add a new medication","medicationPreferenceUpdateSubTitle":"Use the form below to update medication information","medicationAlreadyTrackingError":"Already tracking this medication","medicationConfirmAlertTitle":"Marking medication as inactive","medicationConfirmAlertText":"You are no longer taking this medication","medicationConfirmAlertSuccessTitle":"Success!","medicationConfirmAlertSuccessText":"Marked as inactive","foodPreferencesTitle":"Foods","foodPreferencesSubTitle":"Adds foods to your love and hate lists","foodPreferencesLove":"Foods I love","foodsPreferencesLoveAdd":"Add favourite food","foodPreferencesHate":"Foods I dislike","foodPreferencesHateAdd":"Add disliked food","marketingPreferencesTitle":"Email Settings","marketingPreferencesSubTitle":"Choose the email communications that you'd like to receive from us.","marketingPreferenceCommunicationType":"Communication type","marketingPreferenceImIn":"I'm in","marketingPreferenceImOut":"I'm out","marketingPreferencePromotion":"Beta tester panel","marketingPreferencePromotionExplain":"Test cutting-edge new features first.","marketingPreferenceSurveys":"Research","marketingPreferenceSurveysExplain":"Get involved in academic research that match your profile.","marketingPreferenceNewsletters":"Low carb lifestyle","marketingPreferenceNewslettersExplain":"A monthly roundup of the latest recipes, meal plans, research, exclusive interviews, lifestyle tips, community updates and not-to-be-missed events, live Q&As, podcasts, conferences and more.","marketingPreferenceAlerts":"Program Alerts","marketingPreferenceAlertsExplain":"Milestones, replies, and notifications inside the app can all be emailed to you so that you can stay up to date with any developments of your account or the  Program.","marketingPreferenceUpdates":"Personalised support","marketingPreferenceUpdatesExplain":"Tips, insights and feedback on your progress to support your journey.","communityEmailPreferences":"Community","communityEmailPreferencesExplain":"Get notified of responses to your questions.","dashboardPreferencesTitle":"Dashboard","dashboardPreferencesSubTitle":"Drag list items to re-order, or hide the ones that aren't relevant to you","questionCreateTitle":"Ask your question","questionCreateSubTitle":"Our community is on hand 24 hours a day","questionCreateLabelTitle":"Question title","questionCreateLabelText":"Question text","questionCreateTitlePlaceholder":"i.e 'Should i stop metaformin?'","questionCreateTextPlaceholder":"Full body of your question","questionCreateTitleHelpText":"This is what others will see in the question list","discussionButtonAsk":"Ask a Question","discussionTabRecent":"Recent","discussionTabTrending":"Trending","discussionTabUseful":"Useful","discussionTabMyQuestions":"My questions","discussionTabMyAnswers":"My answers","discussionTabUnanswered":"Unanswered","discussionReportsTitle":"Reports","discussionReportsSubTitle":"A list of reported items","discussionTopContributorsTitle":"Top contributors","discussionTopContributorsSubTitle":"Users who contribute the most","discussionFaqTitle":"FAQs","discussionFaqSubTitle":"Questions often asked by the community","discussionAskedBySuffix":"asked by ","discussionAskedAtSuffix":" on ","discussionMyAnswersEmpty":"You have answered no questions","discussionMyQuestionsEmpty":"You have asked no questions","discussionHcpEmpty":"Be the first to ask a question","discussionSearchHintText":"Search for something","discussionYouAndOthersFoundUseful":"other(s) found this useful","threadTypeReply":"Type your reply...","threadAskedBy":"Question asked by ","threadPostsCount":"Posts:","threadSingleUseful":"found this useful","threadUseful":"person found this useful","threadUsefulPlural":"people found this useful","threadUserSaid":"said","threadPreviousQuestion":"Previous question","threadNextQuestion":"Next question","threadInputPlaceholder":"Type your reply...","threadSubmitReplyText":"Submit reply","threadChronological":"Chronological","threadMostRecent":"Most recent","threadAnswersEmpty":"No answers to this question yet, be the first.","threadPaging10":"10 per page","threadPaging20":"20 per page","threadPaging40":"40 per page","cardEmpty":"Nothing to see here yet","cardEmptySubLine":"Tap the + to add a reading","cardLatestReading":"Latest reading","cardLatestReadingAt":"Latest reading at","cardPreviousReading":"Previous reading","cardWeight":"Weight","cardWeightEmptyHeight":"Add your height to get started","cardWeightAdded":"Weight entry added","cardWeightTotalGain":"Total gain","cardWeightTotalLoss":"Total loss","cardWeightGainedThisWeek":"Gained this week","cardWeightLostThisWeek":"Lost this week","cardWeightWaistHipRatio":"Waist-hip ratio","cardActivity":"Activity","cardKetones":"Ketones","cardKetonesAdded":"Ketones entry added","cardBloodGlucoseAdded":"Blood glucose entry added","cardFromDevice":"From device: ","cardKetonesLastOccurrence":"Last occurrence","cardKetonesTotalOccurrences":"Total occurrences","cardSleep":"Sleep","cardSleepLastNight":"Last night","cardSleepAverage":"Average","cardSleepQuality":"Quality","cardSleepEntryAdded":"Sleep entry added","cardBloodGlucose":"Blood Glucose","cardBloodGlucose30DayAverage":"30 day average","cardBloodGlucoseInRange":"In range today","cardHbA1c":"HbA1c","cardHbA1cAdded":"HbA1c entry added","cardNutrition":"Nutrition","cardNutritionEmpty":"You've had nothing to eat today","cardNutritionSubLine":"to add a food","cardPhotos":"Progress photos","cardPhotosChoosePicture":"Choose picture","cardPhotosAddingPhotos":"Adding photos","cardInsulin":"Insulin","cardInsulinLatestBasal":"Latest basal","cardInsulinLatestBolus":"Latest bolus","cardInsulinLatestCorrection":"Latest correction","cardBloodPressure":"Blood pressure","cardBloodPressuremmHGPlaceholder":"Enter mmHG","cardBloodPressureAdded":"Blood pressure entry added","cardCholesterol":"Cholesterol","cardCholesterolLatestHDL":"Latest HDL","cardCholesterolLatestLDL":"Latest LDL","cardCholesterolLatestTriglycerides":"Latest triglycerides","cardCholesterolLatestTotal":"Latest total","cardMood":"Mood","cardMoodLatest":"Latest mood","cardMoodMostCommon":"Most common","cardMoodOftenTogether":"Often together","cardMoodAdded":"Mood entry added","cardMedication":"Medication","cardEmptyMedication":"Which medications do you take?","cardMedicationDose":"Dose","cardMedicationDosage":"Enter dosage","cardMedicationLastDose":"Last dose","cardMedicationLastMedication":"Last medication","cardMedicationAdded":"Medication entry added","cardMedicationRepeatYesterday":"Repeat yesterdays medication","cardMedicationSelect":"Select medication","cardTapPrefix":"Tap the","cardTapSuffix":"to get started","lifeCategoryListsHeaderText":"Read next...","lifeCategoryListsSubHeaderText":"You may also like...","lifeCommentsHeaderText":"Add a comment","lifeEmbedScrollingText":"Scroll to continue reading","lifeEmbedScrollingVideoText":"Scroll to watch video","lifeUnauthorizedArticle":"Unauthorized to view article","activityCycling":"Cycling","activitySwimming":"Swimming","activityGymRowing":"Rowing Machine","activityGymTreadmill":"Running - Treadmill","activityGymCycling":"Cycling - Gym","activityRunning":"Running","activityStairWalking":"Stair climbing","activityWalking":"Walking","activityGymWeights":"Weight Lifting","activityYoga":"Yoga","activitySports":"Sports","activityAerobics":"Aerobics","activitySex":"Sex","activityDancing":"Dancing","activitySalsaDancing":"Salsa Dancing","moodRefreshed":"Refreshed","moodEnergetic":"Energetic","moodFocused":"Focused","moodRestless":"Restless","moodCalm":"Calm","moodDistracted":"Distracted","moodFatigued":"Fatigued","moodSleepy":"Sleepy","moodWeak":"Weak","moodAnxious":"Anxious","moodChilled":"Chilled","moodRelieved":"Relieved","moodHappy":"Happy","moodContent":"Content","moodExcited":"Excited","moodStressed":"Stressed","moodIrritable":"Irritable","moodHopeless":"Hopeless","moodAngry":"Angry","moodWorried":"Worried","moodUnwell":"Unwell","moodDizzy":"Dizzy","moodHeadache":"Headache","moodHypo":"Hypo","moodPain":"Pain","medicationRegimeMilligrams":"milligram(s)","medicationRegimeGrams":"gram(s)","medicationRegimeDrops":"drop(s)","medicationRegimeTablespoons":"tablespoon(s)","medicationRegimeMicrograms":"microgram(s)","medicationRegimeTablets":"tablet(s)","medicationRegimeCapsules":"capsule(s)","medicationRegimeMilliliters":"milliliter(s)","medicationRegimeTeaspoons":"teaspoon(s)","medicationRegimeMinutes":"minute(s)","medicationRegimeHours":"hour(s)","medicationRegimeUnits":"units(s)","tagActivity":"Activity","tagAfterBreakfast":"After Breakfast","tagAfterDinnerMeal":"After Dinner/meal","tagAfterLunch":"After Lunch","tagBeforeBreakfast":"Before Breakfast","tagBeforeDinnerMeal":"Before Dinner/meal","tagBeforeLunch":"Before lunch","tagCorrection":"Correction","tagDrink":"Drink","tagDriving":"Driving","tagFasting":"Fasting","tagMenstruation":"Menstruation","tagParty":"Party","tagShop":"Shop","tagSnack":"Snack","tagWork":"Work","frequencyOnceDaily":"Daily","frequencyTwiceDaily":"Twice daily","frequencyThreeDaily":"Three times daily","frequencyWeekly":"Weekly","frequencyEverySixWeeks":"Every 6 weeks","frequencyFourTimesDaily":"Four times daily","frequencyEveryThreeMonths":"Every 3 months","frequencyFiveTimesDaily":"Five times daily","frequencyEveryOtherWeek":"Every other week","frequencyEveryThreeWeeks":"Every 3 weeks","frequencyMonthly":"Monthly","frequencyEveryEightWeeks":"Every 8 weeks","frequencyEveryTwelveWeeks":"Every 12 weeks","frequencyEverySixMonths":"Every 6 months","frequencyEveryEightMonths":"Every 8 months","frequencyYearly":"Yearly","frequencyOneTime":"One time","frequencyAsNeeded":"As needed","monthJanuary":"January","monthFebruary":"February","monthMarch":"March","monthApril":"April","monthMay":"May","monthJune":"June","monthJuly":"July","monthAugust":"August","monthSeptember":"September","monthOctober":"October","monthNovember":"November","monthDecember":"December","registerReasonPrediabetes":"Prediabetes","registerReasonType2Diabetes":"Type 2 diabetes","registerReasonType1Diabetes":"Type 1 diabetes","registerReasonGestationalDiabetes":"Gestational diabetes","registerReasonLADA":"LADA","registerReasonMODY":"MODY","registerReasonDiabetesInsipidus":"Diabetes insipidus","registerReasonStudentOrResearcher":"Student or researcher","registerReasonCarer":"Carer","registerReasonDSN":"DSN","registerReasonDoctor":"Doctor","registerReasonHCP":"HCP","registerReasonOther":"Other","registerReasonParentOfType1":"Parent of child with Type 1 diabetes","registerReasonParentOfType2":"Parent of child with Type 2 diabetes","registerReasonProfessionalCarer":"Professional carer","registerReasonDiagnosedObesity":"Obesity","registerReasonOverweight":"Overweight","registerReasonAnotherHealthCondition":"I have another health condition","registerReasonNAFLD":"NAFLD","sexMale":"Male","sexFemale":"Female","foodDiarySelectMyMeal":"Select one of your pre-saved meals from the list","gettingStartedTabYou":"You","gettingStartedTabHealth":"Health","gettingStartedTabLocation":"Location","gettingStartedTabGoals":"Goals","gettingStartedTabPersonalise":"Personalise","gettingStartedGoalsTitle":"Your goals","gettingStartedGoalsSubTitle":"Identifying your goals is important to establish how you will measure your success","gettingStartedGoalsSubHeader":"My goal is to…","goalReduceMedication":"Reduce medication dependency","goalLoseWeight":"Lose weight","goalReduceBloodGlucose":"Reduce blood glucose/HbA1c","goalSenseOfWellbeing":"Sense of wellbeing","goalHealthyLifestyle":"Healthy lifestyle for me and my family","goalSomethingElse":"Something else","gettingStartedHealthTitle":"Tell us about your health","gettingStartedHealthSubTitle":"Personalise your Program","gettingStartedHealthCheckRelevantBoxes":"Tick the relevant boxes below","gettingStartedHealthTypeCondition":"Type a condition","gettingStartedHealthDoYouHaveAnyOtherConditions":"Do you have any other health conditions?","gettingStartedDoYouHaveAnyConditions":"Do you have any health conditions","gettingStartedHealthDoYouHaveAnyConditions":"Do you have any other health conditions","gettingStartedHealthTypeMedication":"Type a medication","addressSurgeryName":"Surgery name","addressLine1":"Address line 1","addressLine2":"Address line 2","addressPostcode":"Post code","addressCity":"City","addressCounty":"County","addressCountry":"Country","gettingStartedLocationTitle":"Your location","gettingStartedLocationSubTitle":"Tell us where in the world you are","gettingStartedLocationGpSurgery":"My local gp surgery is...","gettingStartedLocationSurgeryNotInList":"I couldn't find my surgery in the list","goalReasonRelaxed":"Feel more relaxed","goalReasonRelaxedShort":"more relaxed","goalReasonControl":"Feel more in control","goalReasonControlShort":"more in control","goalReasonConfidence":"More confidence","goalReasonConfidenceShort":"more confident","goalReasonMoreActive":"More active","goalReasonMoreActiveShort":"more active","goalReasonHealthier":"Feel healthier","goalReasonHealthierShort":"healthier","goalReasonHappier":"Feel happier","goalReasonHappierShort":"happier","gettingStartedGoalsEmptyError":"Please select one or more goal(s)","gettingStartedGoalsWhatDifference":"What difference will it make to you?","gettingStartedGoalsRatingScale":"On a scale of 1 to 10, where would you say you are currently with these goals?","gettingStartedGoalsWhenYouAreFeeling":"When you are feeling","gettingStartedGoalsWhatWillYouNoticeIsDifferent":"what will you notice that is different? Who else will notice things are better and how?","labelStartTyping":"Start typing","gettingStartedGoalsWhenYouHave":"When you have","registerSubTitle":"Create your account to choose your plan or redeem your referral code.","modifySubTitle":"Update your account details to choose your plan or redeem your referral code.","goalImprovedSenseOfWellbeing":"achieved a greater sense of wellbeing","goalLostWeight":"lost weight","goalReducedMedication":"reduced your medication","goalReducedBloodGlucose":"improved blood glucose control","goalImprovedHealth":"improved the health of your family","goalImprovedSomethingElse":"accomplished your other goal","gettingStartedPersonalizeTitle":"Complete your personalisation","gettingStartedPersonalizeSubTitle":"Finally, set your personal preferences","gettingStartedPersonalizeFoodsTitle":"Favourite foods","gettingStartedPersonalizeFoodsSubTitle":"Which foods do you enjoy the most?","gettingStartedPersonalizeDietaryPreferencesTitle":"Dietary preferences and allergies","gettingStartedPersonalizeDietaryPreferencesSubTitle":"Get recipes and food ideas tailored to you","gettingStartedPersonalizeHealthTitle":"Your health data","gettingStartedPersonalizeHealthSubTitle":"Start your program with a few measurements","labelLastHbA1c":"When was your last hba1c?","allergyDairy":"Dairy","allergyGluten":"Gluten","allergyCelery":"Celery","allergyYeast":"Yeast","allergyShellfish":"Shellfish","allergyAlcohol":"Alcohol","allergyPeanuts":"Peanuts","allergyLupin":"Lupin","allergySoybeans":"Soybeans","allergyFish":"Fish","allergyEggs":"Eggs","allergyMustard":"Mustard","allergySulphites":"Sulphites","occupationFullTime":"Full time employment","occupationPartTime":"Part time employment","occupationRetired":"Retired","occupationSelfEmployed":"Self employed","occupationStudent":"Student","occupationUnemployed":"Unemployed","dietPreferenceNone":"No dietary preference","dietPreferencePescetarian":"Pescetarian","dietPreferenceVegetarian":"Vegetarian","dietPreferenceVegan":"Vegan","labelHeight":"Height","labelPerWeek":"per week","lifeCatBehaviourChange":"Behaviour change","lifeCatCarbsVsFat":"Carbs vs Fat","lifeCatChildren":"Family","lifeCatConditions":"Conditions","lifeCatDairyFree":"Dairy Free","lifeCatEducation":"Education","lifeCatExercise":"Exercise","lifeCatFoodAndRecipes":"Food and Recipes","lifeCatFoodSwaps":"Food Swaps","lifeCatHCP":"Healthcare Professionals","lifeCatIntermittentFasting":"Intermittent Fasting","lifeCatMotivation":"Motivation","lifeCatMythBusting":"Myth Busting","lifeCatPHC":"Conferences","lifeCatRecipesOfTheWeek":"Recipes of the week","lifeCatResearch":"Research","lifeCatSeasonalVeg":"Seasonal Veg","lifeCatSuccessStories":"Success Stories","lifeCatSugar":"Sugar","lifeCatWereListeningTo":"We're listening to","lifeCatWereWatching":"We're watching","lifeBrowseCategory":"Browse categories","lifeMyFavourites":"My Favourites","labelArticle":"article","labelArticles":"articles","emailResetPassSubject":"Reset your password","emailResetPassDescription":"You recently requested to reset your password for your Low Carb Program account. Use the button below to reset it. This password reset is only valid for the next 3 hours.","emailResetPassBtnLabel":"RESET PASSWORD","emailResetPassIgnore":"If you did not request a password reset, please ignore this email or contact support if you have questions.","emailFooterAllRightsReserved":"All rights reserved","emailTrouble":"If you're having trouble with the button above, copy and paste the URL below into your web browser.","labelTeam":"team","emailConfirmSubject":"Confirm your email","emailConfirmDescription":"You requested to update your email address. Please use the button below to confirm.","emailConfirmButton":"CONFIRM EMAIL","emailVerifySubject":"Verify your account.","emailVerifyDescription":"Welcome to the program. Please use the button below to confirm your account.","paywallPaywallFailed":"Payment Failed","labelProgressAddSnapshot":"Add a snapshot of your progress","labelAddToFoodDiary":"Add some foods to your diary","labelMadeWith":"Made with","foodDiarySaveMealForNextTime":"Save this meal for quick entry next time?","activityTaiChi":"Tai Chi","activityPilates":"Pilates","heightUpdateFormTitle":"Update your height","heightUpdateFormSubTitle":"Use the form below to update","occupationPreferNotToSay":"I prefer not to say","disconnectText":"Disconnect","labelHeartRateAverage":"Average heart rate","labelHeartRateOutOfRange":"Out of range","labelHeartRateFatBurn":"Fat burn","labelHeartRateCardio":"Cardio","labelHeartRatePeak":"Peak","marketingPreferenceMealplans":"Daily meal plans","marketingPreferenceMealplansExplain":"Get a new and unique meal plan every day of the year.  Starts November 1, 2018.","labelFloorsClimbed":"Floors climbed","labelDistance":"Distance","labelTotalSteps":"Total steps","labelFromDevice":"From device","labelSteps":"steps","labelManualEntry":"Self reported","activityStepsEmptyTitle":"You don't have any steps data yet","activityStepsEmptySubTitle":"To get started connect your favorite health app below","activityStepsEmptyButton":"Add an activity integration","quizTestKnowledge":"Test your knowledge","questionText":"Question","answerText":"answer","answersText":"answers","finishText":"Finish","quizComplete":"You completed the quiz!","labelTryAgain":"Try again","labelSeasonalDownloads":"Seasonal","labelTimeInBed":"Time in bed","labelTimeAsleep":"Time asleep","labelEfficiency":"Efficiency","labelTimeAwake":"Time awake","minutesAsleep":"Time asleep","minutesAwake":"Time awake","stageRemMinutes":"REM\n","stageLightMinutes":"Light","stageDeepMinutes":"Deep","labelTodaysPrediction":"Today's prediction","labelTodaysPredictionExplain":"See how close you are to today's predicted readings based on your profile history","labelTonightsPrediction":"Tonight's prediction","accountCigarettesPerDay":"How many cigarettes do you smoke a day?","accountSmokesCigarettes":"Are you a smoker?","ethnicityWhite":"White","ethnicityArab":"Arab","ethnicityIndian":"Indian","ethnicityPakistani":"Pakistani","ethnicityBangladeshi":"Bangladeshi","ethnicityChinese":"Chinese","ethnicityOtherAsian":"Other Asian","ethnicityBlack":"Black/African/Caribbean","ethnicityOther":"Other","ethnicityRatherNotSay":"I'd rather not say","registerReasonWellbeing":"General wellbeing","paymentCtaUpgrade":"Upgrade to Premium","paymentCtaCommunitySupport":"24/7 community support","paymentCtaResources":"Library of resources","paymentCtaMealPlans":"Weekly meal plans","paymentCtaUpdatesInformation":"Daily updated guides and information","paymentCtaFriendlySupport":"Friendly support","labelUpgrade":"Upgrade","paymentCtaEducation":"Award winning education","recipesAppBarText":"Recipes","recipeMenuTitleText":"Recipes","settingsActivityTitleText":"Activity","activitySettingsTitle":"Activity on your account","activitySettingsSubTitle":"See all login activities on your account from the last 7 days","settingsActivityHeadingDevice":"Device","settingsActivityHeadingEngine":"Engine","settingsActivityHeadingOS":"Operating System","settingsActivityHeadingIp":"IP Address","settingsActivityHeadingDate":"Date/Time","settingsExternalLoginTitle":"External Logins","settingExternalLoginDisconnectBody":"In order to continue using the Low Carb Program after you disconnect your __title__, you’ll need to set a password","settingExternalLoginSavedTitle":"Password saved","settingsUsernameHelpText":"Show username instead of first and last name","recipeAppBarText":"Recipe","recipesFavoritesAppBarText":"My favourites","recipesAdvancedSearchAppBarText":"Advanced search","recipesSearchResultsAppBarText":"Search results","labelCookingTime":"Cooking time","labelPrepTime":"Preparation time","recipeAddedToDiary":"Recipe added to your food diary","passwordValidationError":"Password validation error","idleLogoutTitle":"Session expired","idleLogoutBody":"For security reasons, you’ve been logged out of the Low Carb Program due to inactivity. Please log in again.","savePasswordText":"Save password","usernameInitialModalTitle":"Would you like to set a username?","usernameInitialModalBody":"If you don’t want other members of the Low Carb Program to see your real name, you can now set a username for an extra level of privacy.","usernameInitialModalTip":"Tip: For added privacy, steer clear of using anything that resembles your email address or any personal information that could be used to identify you.","usernameInitialModalReject":"No, continue with first & last name","usernameInitialModalSave":"Set Username","usernameInitialModalConfirmTitle":"Username set","usernameInitialModalConfirmBody":"You can toggle whether to use your first and last name or your username throughout the Low Carb Program by visiting Settings. For now, people will only see your username.","usernameInitialModalRejectTitle":"No username set","usernameInitialModalRejectBody":"You can set a username in Settings -> General later if you change your mind."}

/***/ }),
/* 3923 */
/***/ (function(module, exports) {

module.exports = {"reportText":"Report","reportedText":"Reported","nameText":"Name","resetText":"Reset","labelContinueText":"Continue","logOutText":"Log out","logInText":"Log in","loggingInText":"Logging in...","sendingText":"Sending...","loadingText":"Loading...","searchText":"Search","searchingText":"Searching...","closeText":"Close","submitText":"Submit","saveText":"Save","savingText":"Saving...","readMoreText":"Read More","watchVideoText":"Watch Video","deleteText":"Delete","hideText":"Hide","moreText":"More","hiddenText":"Hidden","restoreText":"Restore","editText":"Edit","okText":"Ok","cancelText":"Cancel","addCommentText":"Add comment","addToFavouritesText":"Add to favourites","addTestimonialText":"Add testimonial","unfavouriteText":"Unfavourite","loadCommentsText":"Load comments","applyText":"Apply","discardText":"Discard","updateText":"Update","updatingText":"Updating...","updatedText":"Updated","addEntryText":"Add entry","nextText":"Next","backText":"Back","skipText":"Skip","replyText":"reply","repliesText":"replies","replyToText":"Reply to","likeText":"like","likesText":"likes","listViewText":"List view","gridViewText":"Grid view","emptyText":"Nothing added yet","selectText":"Select","enableText":"Enable","disableText":"Disable","connectText":"Connect","andText":"and","youText":"You","exportText":"Export","exportTextData":"Export data","exportingText":"Exporting...","justAMomentText":"Just a moment...","trackingHelpText":"Tap any entry to edit or delete a reading","badgeChampion":"Champion","badgeSupport":"Support Team","badgeCompleted":"Completed the program","mealPlanGeneratorAppBarText":"Meal plan generator","fourZeroFourAppBarText":"Page not found","registerAppBarText":"Register","amendAppBarText":"Update","loginAppBarText":"Login","forgotPasswordAppBarText":"Forgot password","verifyAccountAppBarText":"Email confirmed","resetPasswordAppBarText":"Change your password","contactTitle":"Contact","contactSubTitle":"I have a question about:","contactAdded":"Your question has been submitted. Thanks","contactBodyLabel":"Anything else we should know?","contactReasonApp":"App","contactReasonWebsite":"Website","contactReasonTechnical":"Technical query","contactReasonFeatureRequest":"Feature request","contactReasonOther":"Other","contactReasonHcpCommission":"Commissioning the program","contactReasonHcpTraining":"Healthcare Professional Training","contactReasonHcpLeaflets":"Program leaflets and flyers","bootloaderConnecting":"Connecting...","bootloaderDownloadingAssets":"Downloading assets...","bootloaderInitializing":"Initializing...","bootloaderProfile":"Loading your profile...","dashboardAppBarText":"Dashboard","foodDiaryAppBarText":"Food Diary","foodDiaryAddFoodAppBarText":"Add Food","questionsAppBarText":"Discussion","profileAppBarText":"Profile","lifestyleAppBarText":"Lifestyle","downloadsAppBarText":"Downloads","coachingAppBarText":"Coaching","contactAppBarText":"Contact us","testimonialAppBarText":"Add a testimonial","hcpAppBarText":"Healthcare Professionals","questionReportAppBarText":"Question report","answerReportAppBarText":"Answer report","lifeReportAppBarText":"Life report","checkInAppBarText":"Check In","addProgressAppBarText":"Add progress","bloodGlucoseAppBarText":"My blood glucose readings","hbA1cAppBarText":"My HbA1c readings","weightAppBarText":"My weight progress","sleepAppBarText":"My sleep progress","bloodPressureAppBarText":"My blood pressure readings","ketonesAppBarText":"My ketone readings","medicationAppBarText":"My medication progress","moodAppBarText":"My emotional progress","cholesterolAppBarText":"My cholesterol readings","insulinAppBarText":"My insulin readings","activityAppBarText":"My activity progress","obAboutAppBarText":"About you - Getting started","obHealthAppBarText":"Your health - Getting started","obLocationAppBarText":"Your location - Getting started","obGoalsAppBarText":"Your Goals - Getting started","obPersonalizeAppBarText":"Personalize your program - Getting started","faqAppBarText":"Frequently Asked Questions","dashboardMenuTitleText":"Dashboard","foodDiaryMenuTitleText":"Food Diary","questionsMenuTitleText":"Discussion","profileMenuTitleText":"Profile","lifestyleMenuTitleText":"Lifestyle","downloadsMenuTitleText":"Downloads","coachingMenuTitleText":"Coaching","settingsMenuTitleText":"Settings","addProgressMenuTitleText":"Add Progress","faqMenuTitleText":"FAQs","feedbackMenuTitleText":"Feedback","lessonTitleText":"Lesson","lessonBonusTitleText":"Bonus lesson","threadTitleText":"Thread","settingsGeneralTitleText":"General","settingsSecurityTitleText":"Security","settingsSubscriptionTitleText":"Subscription","settingsPrivacyTitleText":"Privacy","settingsNotificationsTitleText":"Notifications","settingsUnitsTitleText":"Units","settingsPersonalizeTitleText":"Personalize","settingsConditionsTitleText":"Conditions","settingsMedicationTitleText":"Medications","settingsFoodTitleText":"Food Preferences","settingsDashboardTitleText":"Dashboard","settingsIntegrationTitleText":"Health App Integration","settingsPreferencesTitleText":"Marketing preferences","integrationCompleteAppBarText":"Integration was successful","loginForgotPassword":"Forgot password?","loginNoAccountYet":"Don't have an account yet?","loginSignUp":"Sign up","loginErrorIncorrectCredentials":"Incorrect credentials","loginRememberMe":"Remember me?","forgotPasswordTitle":"Forgotten your password?","forgotPasswordSubTitle":"Use the form below to send a password reset email","forgotPasswordSignIn":"I just want to sign in","forgotPasswordEmailNotFound":"We could not find an account with this email address","forgotPasswordEmailSentMessageTitle":"Password reset email was sent!","forgotPasswordEmailSendMessageSubTitle":"Please check your email inbox at","registerSignIn":"Sign in","registerHaveAccount":"Already have an account?","registerErrorUserExists":"An account using this email already exists","registerTestimonialConcent":"I consent to the","registerTestimonialExplain":"and that my testimonial can be used by the Program to inspire and motivate others","registerTermsByContinuing":"By continuing, you agree to our ","registerTermsAndCondtions":"Terms and conditions","registerTermsJoin":"and that you have read our","registerPrivacyPolicy":"Privacy policy","registerIncludingCookie":"including our Cookie Policy.","lessonActionPoints":"Action points","lessonActionPointsSubTitle":"Things to do this week","lessonViewTranscript":"View transcript","lessonHideTranscript":"Hide transcript","lessonDownloadsThisWeek":"Downloads this week","lessonQuestionsTitle":"Recently asked questions","lessonQuestionsSubTitle":"Questions asked this week","lessonQuestionsEmpty":"No one has asked questions about this lesson yet - why not be first?","lessonRatingVery":"Very","lessonRatingNotVery":"Not very","foodDiaryTodayYouveHad":"Today you've had...","foodDiaryLandingExplain":"You can add a food to your food diary by searching for what you ate.","foodDiaryRecentsEmpty":"Tap on the search button to start adding some food!","foodDiaryHasRecents":"Click an item in the recent list on the right of this panel to add it again.","foodDiaryRepeatYesterdayMeal":"Repeat yesterdays meal","foodDiaryIntakeBar":"Today you've had","foodDiaryIntakeBarNotToday":"On this date you had","foodDiaryModifyTargets":"Edit targets","foodDiaryNutritionPanelHeaderText":"Your nutrition targets","foodDiaryNutritionPanelSubHeaderText":"Configure your nutrition targets","foodDiaryBreakfast":"Breakfast","foodDiaryAddBreakfast":"Add breakfast","foodDiaryAddingBreakfast":"Adding breakfast","foodDiaryNoBreakfastLabel":"No breakfast added yet","foodDiaryLunch":"Lunch","foodDiaryAddLunch":"Add lunch","foodDiaryAddingLunch":"Adding lunch","foodDiaryNoLunchLabel":"No lunch added yet","foodDiaryDinner":"Dinner","foodDiaryAddDinner":"Add dinner","foodDiaryAddingDinner":"Adding dinner","foodDiaryNoDinnerLabel":"No dinner added yet","foodDiarySnack":"Snack","foodDiaryAddSnack":"Add snack","foodDiaryAddingSnack":"Adding snack","foodDiaryNoSnackLabel":"No snack added yet","foodDiaryQuickPortionLabel":"Quick portions","foodDiaryExportDataTitle":"Export nutrition data","foodDiaryExportDataSubTitle":"Export your Food Diary data","foodDiaryMealPlateNameTitle":"Give your meal a name","foodDiaryLoadFromMyMeals":"My saved meals","foodDiaryMealPlateRemoved":"Meal plate removed","dietPlanLowCarb":"Low Carb","dietPlanKeto":"Keto","nutrientCalories":"Calories","nutrientCaloriesShort":"Cals","nutrientProtein":"Protein","nutrientCarbohydrate":"Carbohydrate","nutrientCarbohydrateShort":"Carbs","nutrientSugar":"Sugar","nutrientFat":"Fat","nutrientTotalFat":"Total fat","nutrientTotalFatShort":"Tot fat","nutrientSaturatedFat":"Saturated Fat","nutrientSaturatedFatShort":"Sat fat","nutrientMonounsaturatedFat":"Monounsaturated Fat","nutrientPolyunsaturatedFat":"Polyunsaturated Fat","nutrientCholesterol":"Cholesterol","nutrientFibre":"Fibre","nutrientSodium":"Sodium","nutrientPotassium":"Potassium","visualizationBloodGlucoseHeader":"blood glucose reading(s) logged this month","confirmRemoveTitle":"Are you sure?","confirmResetAccount":"You are restarting your education to week 1","confirmedResetAccount":"Page will refresh in 1 second to update the changes. please wait...","confirmRemoveBloodGlucoseItem":"You are removing a blood glucose entry","confirmedRemoveBloodGlucoseItem":"Blood glucose entry was removed","confirmRemoveWeightItem":"You are removing a weight entry","confirmedRemoveWeightItem":"Weight entry was removed","confirmRemoveBloodPressureItem":"You are removing an blood pressure entry","confirmedRemoveBloodPressureItem":"Blood pressure entry was removed","confirmRemoveActivityItem":"You are removing a activity entry","confirmedRemoveActivityItem":"Activity entry was removed","confirmRemoveCholesterolItem":"You are removing a cholesterol entry","confirmedRemoveCholesterolItem":"Cholesterol entry was removed","confirmRemoveHbA1cItem":"You are removing a HbA1c entry","confirmedRemoveHbA1cItem":"HbA1c entry was removed","confirmRemoveInsulinItem":"You are removing a insulin entry","confirmedRemoveInsulinItem":"HbA1c entry was removed","confirmRemoveKetoneItem":"You are removing a ketone entry","confirmedRemoveKetoneItem":"Ketone entry was removed","confirmRemoveMedicationItem":"You are removing a medication dosage","confirmedRemoveMedicationItem":"Medication dosage was removed","confirmRemoveMoodItem":"You are removing a mood entry","confirmedRemoveMoodItem":"Mood entry was removed","confirmRemoveSleepItem":"You are removing a sleep entry","confirmedRemoveSleepItem":"Sleep entry was removed","confirmRemoveFoodItem":"You are removing ","confirmedRemoveFoodItem":"was removed from your food diary","confirmRemoveAnswerItem":"You are removing an answer","confirmedRemoveAnswerItem":"Answer was removed","confirmRemoveQuestionItem":"You are removing a question","confirmedRemoveQuestionItem":"Question was removed","placeholderText":"Please enter","placeholderEmail":"email@email.com","lessonScrollerWeekPrefix":"Currently on","graphEmpty":"Nothing to see here yet","graphEmptyExplain":"Not enough data to create graph","graphPointToggleShowPoints":"Show points","graphToggleSmoothLine":"Curved line","graphToggleShowArea":"Area fill","graphPointsToggleTitle":"Options","labelIHave":"I have","labelFollowers":"Followers","labelFollowing":"Following","labelUpdateBio":"Update bio","labelEnterBio":"Enter bio","labelChangeProfilePicture":"Change profile picture","labelRemoveProfilePicture":"Remove profile picture","labelAddCoverPhoto":"Add cover photo","labelRemoveCoverPhoto":"Remove cover photo","labelUpdateCoverPhoto":"Update cover photo","labelQuestionsAnswered":"Questions answered","labelQuestionsAsked":"Questions asked","labelProgress":"Progress","labelProgramProgress":"Program progress","labelPostsAndReplies":"Posts & Replies","labelGallery":"Gallery","labelFood":"Food","labelDiscussionPrivate":"User has chosen to keep their questions/answers private","labelBloodGlucoseProgress":"Blood glucose progress","labelWeightProgress":"Weight progress","labelGraphsPrivate":"User has kept their progress graphs private","labelUploadPhoto":"Upload photo","labelMyGoals":"My goals","labelNew":"BETA","labelTestimonialSubTitle":"Share your thoughts and tell us how the program has helped you","labelAddTestimonial":"Add testimonial","labelBeforePhoto":"Add before photo","labelAfterPhoto":"Add after photo","labelDescription":"Description","labelBody":"Body","labelProviderInAssociationWith":"In association with","labelBonus":"Bonus","labelPersonalized":"Personalized","labelVerifyingAccount":"Verifying account..","labelAccountActivated":"Your account was activated, you may now continue with the program","labelRateThisAnswer":"Rate this answer","labelFindExactlyWhatYouAreLookingFor":"Find exactly what you're looking for...","labelRelatedQuestions":"Related questions","labelHi":"Hi","labelMostUseful":"Most useful","labelUpdateCommPreferences":"please update your communication preferences","labelRecents":"Recents","labelVoiceRecognition":"Go ahead and say something...","labelFoodSearchResultsEmpty":"No foods found for your search term","labelFoods":"foods","labelCustom":"Custom","labelProceed":"Proceed","labelProcessing":"Processing...","labelViewHistory":"View history","labelViewNutrition":"View nutrition","labelNutrientTargetHelpText":"Not too sure? Pick a preset","labelMultiplier":"Multiplier","labelServingSize":"Serving size","labelSwitchHcp":"Switch to HCP view","labelSwitchPatient":"Switch to Patient view","labelHelp":"Help","labelAddFoods":"Add some foods to your diary","labelAddHealthSnapshot":"Add a snapshot of your health","labelMyProfile":"My profile","labelStartProgramOver":"Want to start the program again from week 1?","labelClickHere":"Click here","labelError":"Something went wrong, please try again later","labelProgressDatePickerExplain":"This is the time and date that will be tied to any readings you save from this page","labelLetsGetStarted":"Lets get started","labelModifyDetails":"Modify your details","labelYourName":"Your name","labelBaseLine":"Base line","labelUpperRange":"Upper range","labelLowerRange":"Lower range","labelMinute":"min","labelFromDate":"From date","labelToDate":"To date","labelToday":"Today","labelDay":"Day","labelMonth":"Month","labelYear":"Year","labelNoTags":"No tags","labelSuccess":"Success","labelUpdateRange":"Update range","labelRangeUpdated":"Updated glucose range","labelResources":"Resources","labelMealPlans":"Meal plans","labelEnergy":"Energy","labelMood":"Mood","labelHealth":"Health","labelWeek":"Week","labelDownloadsFrom":"Downloads from: ","labelWaist":"Waist","labelHip":"Hip","labelBolus":"Bolus","labelCorrection":"Correction","labelBasal":"Basal","labelInsulinType":"Insulin type","labelBloodSugar":"Blood sugar","labelHba1cOptional":"HBA1C [OPTIONAL]","labelAboveRange":"Above range","labelBelowRange":"Below range","labelInRange":"In range","labelAdditionalInformation":"Additional information","labelAddPhoto":"Add photo","labelMedicationName":"Medication name","labelYes":"Yes","labelNo":"No","labelITakeThisForMy":"I take this for my","labelWhatDoYouTakeItFor":"What do you do take it for?","labelUnits":"Units","labelHowOften":"How often","labelDuration":"Duration","labelDurationMinutes":"Duration (minutes)","labelActivity":"Activity","labelActivityType":"Activity type","labelCaloriesBurnt":"Calories burned","labelCalorieBurn":"Calorie burn: ","labelDosage":"Dosage","labelCustomDate":"Custom date","labelRangeDay":"Day","labelRangeWeek":"Week","labelRangeMonth":"Month","labelRangeYear":"Year","labelSelectMedication":"Select medication","labelSystolic":"Systolic","labelDiastolic":"Diastolic","labelCholesterolTotal":"Total","labelCholesterolHDL":"HDL","labelCholesterolLDL":"LDL","labelCholesterolTriglycerides":"Triglycerides","labelHours":"Hours","labelQuality":"Quality","labelDate":"Date","labelTime":"Time","labelTagYourReading":"Tag your reading [OPTIONAL]","labelInchesPlaceholder":"Enter in inches","labelCMPlaceholder":"Enter in cm","labelBehalfSomeoneElse":"I'm joining on behalf of someone else","labelRelationship":"What is your relationship?","relationshipMother":"My mother","relationshipFather":"My father","relationshipWife":"My wife","relationshipHusband":"My husband","relationshipSister":"My sister","relationshipBrother":"My brother","relationshipSon":"My son","relationshipDaughter":"My daughter","relationshipPatient":"My patient","gettingStartedAboutTitle":"About you","gettingStartedAboutSubTitle":"Tailor your Program","errorExportEmpty":"Nothing to export","unitsPreferencesTitle":"Units","unitsPreferencesSubTitle":"Choose your preferred units of measurement","unitsPreferencesMeasureWeight":"I measure my weight in:","unitsPreferencesMeasureHeight":"I measure my height in:","unitsPreferencesMeasureWaist":"I measure my waist in:","unitsPreferencesMeasureHba1c":"I measure my HbA1c in:","unitsPreferencesMeasureBloodGlucose":"I measure my blood glucose in:","conditionsPreferencesTitle":"My conditions","conditionsPreferencesSubTitle":"Use the search below to update your conditions","conditionsPreferencesEmpty":"No conditions added yet","conditionsPreferencesHelpText":"Search to add a condition","accountPreferencesTitle":"General account details","accountPreferencesSubTitle":"Use the form below to update your general details","accountPreferencesChangeAvatar":"Change avatar","accountPreferencesFirstName":"First name","accountPreferencesSurname":"Surname","accountPreferencesEmail":"Email","accountPreferencesEmailVerify":"Verify Email","accountPreferencesPassword":"Password","accountPreferencesDisplayName":"Username","accountPreferencesPasswordVerify":"Verify Password","accountPreferencesBirthday":"Birthday","accountPreferencesWhatBringsYouHere":"What brings you here?","accountPreferencesDiagnosisYear":"Diagnosis year","accountPreferencesSex":"Sex","accountPreferencesTestBlood":"Do you test your blood?","accountPreferencesTakeMedication":"Do you take medication?","accountPreferencesEthnicity":"Ethnicity","accountPreferencesLanguage":"Language","accountPreferencesOccupation":"Occupation","accountPreferencesDietaryPreference":"Dietary preference","accountPreferencesAllergies":"Allergies","accountPreferencesShopCost":"Weekly grocery cost","integrationPreferencesTitle":"Integrations","integrationPreferencesSubTitle":"Integrate into other health apps","integrationFitBitExplain":"Connect your FitBit to your health tracking profile","integrationStriivExplain":"Connect your Stiiv to your health tracking profile","integrationStriivImportStarted":"Striiv import started, this can take a few minutes - you will be notified upon completion","integrationStriivImportEmpty":"No data to retrieve, if you know you have readings - sync your Striiv device by opening the Striiv App and swiping down to refresh on the dashboard, come back here then click the sync button.","privacyPreferencesTitle":"Privacy","privacyPreferencesSubTitle":"I am happy for others to see the following area(s) of my profile:","privacyPreferencesQuestions":"Questions","privacyPreferencesQuestionsExplain":"Things you've asked or replied to","privacyPreferencesFood":"Food & nutrition","privacyPreferencesFoodExplain":"Food diary entries, nutritional goals","privacyPreferencesProgress":"Progress","privacyPreferencesProgressExplain":"Weight loss, blood glucose stats, photos etc.","privacyPreferencesMedication":"Medication","privacyPreferencesMedicationExplain":"Anything you've recorded relating to your medication regime","privacyPreferencesAbout":"About me","privacyPreferencesAboutExplain":"About, likes and dislikes","paywallPaymentFailed":"Payment failed","paywallPaywallFailedExplain":"We're sorry, your payment failed or was cancelled. Please try again.","paywallStatusComplete":"Your payment has been completed and a receipt will be emailed to you","paywallStatusPending":"Practical Action Points to achieve your health goal","paywallStatusFailed":"No money has been deducted from your account","paywallJoinIncentiveReason1":"Award-winning education on therapeutic carbohydrate restriction","paywallJoinIncentiveReason2":"Practical Action Points to achieve your health goal","paywallJoinIncentiveReason3":"Tailored messages from your mentor to keep you on track","paywallJoinIncentiveReason4":"Support from behavioural health coaches","paywallJoinIncentiveReason5":"Support from the largest low carb community available 24/7","paywallJoinIncentiveReason6":"Integrated health tracking and data exporting","paywallJoinIncentiveReason7":"Over 40 meal plans customised to your dietary preferences","paywallJoinIncentiveReason8":"Over 1,000 recipe ideas","paywallJoinIncentiveReason9":"Daily news, research and expert opinions","paywallJoinIncentiveReason10":"Over 120 low carb resources","paywallJoinIncentiveReason11":"Access on any device on web, iOS, Android and Kindle","paywallJoinIncentiveReason12":"Constantly updated features and enhancements","paywallJoinIncentiveReason13":"Sync with Striiv, FitBit and Nokia Withings launching Summer 2018 ","paywallJoinIncentiveReason14":"Friendly technical support","paymentModalFeatureNotAvailable":"This feature is only available on the Premium tier of the Program","paymentModalUpgrade":"Upgrade now for a one-off payment of","paymentModalProceedPayment":"Proceed to Payment","notificationHeaderText":"Notifications","notificationEmptyText":"Nothing to see here yet","notificationPreferencesTitle":"Notification","notificationPreferencesSubTitle":"Use the toggles below to choose which type of notifications you wish to receive","notificationPreferencesHeaderText":"Notifications","notificationPreferencesEmptyText":"No new notifications","notificationPreferencesQuestionReplies":"Question replies","notificationPreferencesQuestionRepliesSubLine":"When someone answers my question","notificationPreferencesNewFollower":"New follower","notificationPreferencesNewFollowerSubLine":"When someone follows me","securityPreferencesTitle":"Security","securityPreferencesSubTitle":"Use the form below to update your password","subscriptionPreferencesTitle":"Subscription","subscriptionPreferencesSubTitle":"Manage your current subscription below","securityPreferencesOldPassword":"Old password","securityPreferencesDesiredPassword":"Desired password","securityPreferencesChangeEmail":"Change email address","securityPreferencesSendVerificationEmail":"Send verification email","securityPreferencesCheckEmailAt":"Please check verification email at","medicationPreferencesTitle":"My medications","medicationPreferencesSubTitle":"The dosages here will be taken into account when using the Medication card on the Dashboard","medicationPreferencesAdd":"Add a medication","medicationsPreferencesNotTaking":"Medications i'm no longer taking","medicationPreferencesAddSubTitle":"Use the form below add a new medication","medicationPreferenceUpdateSubTitle":"Use the form below to update medication information","medicationAlreadyTrackingError":"Already tracking this medication","medicationConfirmAlertTitle":"Marking medication as inactive","medicationConfirmAlertText":"You are no longer taking this medication","medicationConfirmAlertSuccessTitle":"Success!","medicationConfirmAlertSuccessText":"Marked as inactive","foodPreferencesTitle":"Foods","foodPreferencesSubTitle":"Adds foods to your love and hate lists","foodPreferencesLove":"Foods I love","foodsPreferencesLoveAdd":"Add favourite food","foodPreferencesHate":"Foods I dislike","foodPreferencesHateAdd":"Add disliked food","marketingPreferencesTitle":"Email Settings","marketingPreferencesSubTitle":"Choose the email communications that you'd like to receive from us.","marketingPreferenceCommunicationType":"Communication type","marketingPreferenceImIn":"I'm in","marketingPreferenceImOut":"I'm out","marketingPreferencePromotion":"Beta tester panel","marketingPreferencePromotionExplain":"Test cutting-edge new features first.","marketingPreferenceSurveys":"Research","marketingPreferenceSurveysExplain":"Get involved in academic research that match your profile.","marketingPreferenceNewsletters":"Low carb lifestyle","marketingPreferenceNewslettersExplain":"A monthly roundup of the latest recipes, meal plans, research, exclusive interviews, lifestyle tips, community updates and not-to-be-missed events, live Q&As, podcasts, conferences and more.","marketingPreferenceAlerts":"Program Alerts","marketingPreferenceAlertsExplain":"Milestones, replies, and notifications inside the app can all be emailed to you so that you can stay up to date with any developments of your account or the  Program.","marketingPreferenceUpdates":"Personalised support","marketingPreferenceUpdatesExplain":"Tips, insights and feedback on your progress to support your journey.","communityEmailPreferences":"Community","communityEmailPreferencesExplain":"Get notified of responses to your questions.","dashboardPreferencesTitle":"Dashboard","dashboardPreferencesSubTitle":"Drag list items to re-order, or hide the ones that aren't relevant to you","questionCreateTitle":"Ask your question","questionCreateSubTitle":"Our community is on hand 24 hours a day","questionCreateLabelTitle":"Question title","questionCreateLabelText":"Question text","questionCreateTitlePlaceholder":"i.e 'Should i stop metaformin?'","questionCreateTextPlaceholder":"Full body of your question","questionCreateTitleHelpText":"This is what others will see in the question list","discussionButtonAsk":"Ask a Question","discussionTabRecent":"Recent","discussionTabTrending":"Trending","discussionTabUseful":"Useful","discussionTabMyQuestions":"My questions","discussionTabMyAnswers":"My answers","discussionTabUnanswered":"Unanswered","discussionReportsTitle":"Reports","discussionReportsSubTitle":"A list of reported items","discussionTopContributorsTitle":"Top contributors","discussionTopContributorsSubTitle":"Users who contribute the most","discussionFaqTitle":"FAQs","discussionFaqSubTitle":"Questions often asked by the community","discussionAskedBySuffix":"asked by ","discussionAskedAtSuffix":" on ","discussionMyAnswersEmpty":"You have answered no questions","discussionMyQuestionsEmpty":"You have asked no questions","discussionHcpEmpty":"Be the first to ask a question","discussionSearchHintText":"Search for something","discussionYouAndOthersFoundUseful":"other(s) found this useful","threadTypeReply":"Type your reply...","threadAskedBy":"Question asked by ","threadPostsCount":"Posts:","threadSingleUseful":"found this useful","threadUseful":"person found this useful","threadUsefulPlural":"people found this useful","threadUserSaid":"said","threadPreviousQuestion":"Previous question","threadNextQuestion":"Next question","threadInputPlaceholder":"Type your reply...","threadSubmitReplyText":"Submit reply","threadChronological":"Chronological","threadMostRecent":"Most recent","threadAnswersEmpty":"No answers to this question yet, be the first.","threadPaging10":"10 per page","threadPaging20":"20 per page","threadPaging40":"40 per page","cardEmpty":"Nothing to see here yet","cardEmptySubLine":"Tap the + to add a reading","cardLatestReading":"Latest reading","cardLatestReadingAt":"Latest reading at","cardPreviousReading":"Previous reading","cardWeight":"Weight","cardWeightEmptyHeight":"Add your height to get started","cardWeightAdded":"Weight entry added","cardWeightTotalGain":"Total gain","cardWeightTotalLoss":"Total loss","cardWeightGainedThisWeek":"Gained this week","cardWeightLostThisWeek":"Lost this week","cardWeightWaistHipRatio":"Waist-hip ratio","cardActivity":"Activity","cardKetones":"Ketones","cardKetonesAdded":"Ketones entry added","cardBloodGlucoseAdded":"Blood glucose entry added","cardFromDevice":"From device: ","cardKetonesLastOccurrence":"Last occurrence","cardKetonesTotalOccurrences":"Total occurrences","cardSleep":"Sleep","cardSleepLastNight":"Last night","cardSleepAverage":"Average","cardSleepQuality":"Quality","cardSleepEntryAdded":"Sleep entry added","cardBloodGlucose":"Blood Glucose","cardBloodGlucose30DayAverage":"30 day average","cardBloodGlucoseInRange":"In range today","cardHbA1c":"HbA1c","cardHbA1cAdded":"HbA1c entry added","cardNutrition":"Nutrition","cardNutritionEmpty":"You've had nothing to eat today","cardNutritionSubLine":"to add a food","cardPhotos":"Progress photos","cardPhotosChoosePicture":"Choose picture","cardPhotosAddingPhotos":"Adding photos","cardInsulin":"Insulin","cardInsulinLatestBasal":"Latest basal","cardInsulinLatestBolus":"Latest bolus","cardInsulinLatestCorrection":"Latest correction","cardBloodPressure":"Blood pressure","cardBloodPressuremmHGPlaceholder":"Enter mmHG","cardBloodPressureAdded":"Blood pressure entry added","cardCholesterol":"Cholesterol","cardCholesterolLatestHDL":"Latest HDL","cardCholesterolLatestLDL":"Latest LDL","cardCholesterolLatestTriglycerides":"Latest triglycerides","cardCholesterolLatestTotal":"Latest total","cardMood":"Mood","cardMoodLatest":"Latest mood","cardMoodMostCommon":"Most common","cardMoodOftenTogether":"Often together","cardMoodAdded":"Mood entry added","cardMedication":"Medication","cardEmptyMedication":"Which medications do you take?","cardMedicationDose":"Dose","cardMedicationDosage":"Enter dosage","cardMedicationLastDose":"Last dose","cardMedicationLastMedication":"Last medication","cardMedicationAdded":"Medication entry added","cardMedicationRepeatYesterday":"Repeat yesterdays medication","cardMedicationSelect":"Select medication","cardTapPrefix":"Tap the","cardTapSuffix":"to get started","lifeCategoryListsHeaderText":"More in this category","lifeCategoryListsSubHeaderText":"You may also like...","lifeCommentsHeaderText":"Add a comment","lifeEmbedScrollingText":"Scroll to continue reading","lifeEmbedScrollingVideoText":"Scroll to watch video","lifeUnauthorizedArticle":"Unauthorized to view article","activityCycling":"Cycling","activitySwimming":"Swimming","activityGymRowing":"Rowing Machine","activityGymTreadmill":"Running - Treadmill","activityGymCycling":"Cycling - Gym","activityRunning":"Running","activityStairWalking":"Stair climbing","activityWalking":"Walking","activityGymWeights":"Weight Lifting","activityYoga":"Yoga","activitySports":"Sports","activityAerobics":"Aerobics","activitySex":"Sex","activityDancing":"Dancing","activitySalsaDancing":"Salsa Dancing","moodRefreshed":"Refreshed","moodEnergetic":"Energetic","moodFocused":"Focused","moodRestless":"Restless","moodCalm":"Calm","moodDistracted":"Distracted","moodFatigued":"Fatigued","moodSleepy":"Sleepy","moodWeak":"Weak","moodAnxious":"Anxious","moodChilled":"Chilled","moodRelieved":"Relieved","moodHappy":"Happy","moodContent":"Content","moodExcited":"Excited","moodStressed":"Stressed","moodIrritable":"Irritable","moodHopeless":"Hopeless","moodAngry":"Angry","moodWorried":"Worried","moodUnwell":"Unwell","moodDizzy":"Dizzy","moodHeadache":"Headache","moodHypo":"Hypo","moodPain":"Pain","medicationRegimeMilligrams":"milligram(s)","medicationRegimeGrams":"gram(s)","medicationRegimeDrops":"drop(s)","medicationRegimeTablespoons":"tablespoon(s)","medicationRegimeMicrograms":"microgram(s)","medicationRegimeTablets":"tablet(s)","medicationRegimeCapsules":"capsule(s)","medicationRegimeMilliliters":"milliliter(s)","medicationRegimeTeaspoons":"teaspoon(s)","medicationRegimeMinutes":"minute(s)","medicationRegimeHours":"hour(s)","medicationRegimeUnits":"units(s)","tagActivity":"Activity","tagAfterBreakfast":"After Breakfast","tagAfterDinnerMeal":"After Dinner/meal","tagAfterLunch":"After Lunch","tagBeforeBreakfast":"Before Breakfast","tagBeforeDinnerMeal":"Before Dinner/meal","tagBeforeLunch":"Before lunch","tagCorrection":"Correction","tagDrink":"Drink","tagDriving":"Driving","tagFasting":"Fasting","tagMenstruation":"Menstruation","tagParty":"Party","tagShop":"Shop","tagSnack":"Snack","tagWork":"Work","frequencyOnceDaily":"Daily","frequencyTwiceDaily":"Twice daily","frequencyThreeDaily":"Three times daily","frequencyWeekly":"Weekly","frequencyEverySixWeeks":"Every 6 weeks","frequencyFourTimesDaily":"Four times daily","frequencyEveryThreeMonths":"Every 3 months","frequencyFiveTimesDaily":"Five times daily","frequencyEveryOtherWeek":"Every other week","frequencyEveryThreeWeeks":"Every 3 weeks","frequencyMonthly":"Monthly","frequencyEveryEightWeeks":"Every 8 weeks","frequencyEveryTwelveWeeks":"Every 12 weeks","frequencyEverySixMonths":"Every 6 months","frequencyEveryEightMonths":"Every 8 months","frequencyYearly":"Yearly","frequencyOneTime":"One time","frequencyAsNeeded":"As needed","monthJanuary":"January","monthFebruary":"February","monthMarch":"March","monthApril":"April","monthMay":"May","monthJune":"June","monthJuly":"July","monthAugust":"August","monthSeptember":"September","monthOctober":"October","monthNovember":"November","monthDecember":"December","registerReasonPrediabetes":"Prediabetes","registerReasonType2Diabetes":"Type 2 diabetes","registerReasonType1Diabetes":"Type 1 diabetes","registerReasonGestationalDiabetes":"Gestational diabetes","registerReasonLADA":"LADA","registerReasonMODY":"MODY","registerReasonDiabetesInsipidus":"Diabetes insipidus","registerReasonStudentOrResearcher":"Student or researcher","registerReasonCarer":"Carer","registerReasonDSN":"DSN","registerReasonDoctor":"Doctor","registerReasonHCP":"HCP","registerReasonOther":"Other","registerReasonParentOfType1":"Parent of child with Type 1 diabetes","registerReasonParentOfType2":"Parent of child with Type 2 diabetes","registerReasonProfessionalCarer":"Professional carer","registerReasonDiagnosedObesity":"Diagnosed obesity","registerReasonOverweight":"Overweight","registerReasonAnotherHealthCondition":"I have another health condition","registerReasonNAFLD":"NAFLD","sexMale":"Male","sexFemale":"Female","foodDiarySelectMyMeal":"Select one of your pre-saved meals from the list","gettingStartedTabYou":"You","gettingStartedTabHealth":"Health","gettingStartedTabLocation":"Location","gettingStartedTabGoals":"Goals","gettingStartedTabPersonalise":"Personalize","gettingStartedGoalsTitle":"Your goals","gettingStartedGoalsSubTitle":"Identifying your goals is important to establish how you will measure your success","gettingStartedGoalsSubHeader":"My goal is to…","goalReduceMedication":"Reduce medication dependency","goalLoseWeight":"Lose weight","goalReduceBloodGlucose":"Reduce blood glucose/HbA1c","goalSenseOfWellbeing":"Sense of wellbeing","goalHealthyLifestyle":"Healthy lifestyle for me and my family","goalSomethingElse":"Something else","gettingStartedHealthTitle":"Tell us about your health","gettingStartedHealthSubTitle":"Personalise your Program","gettingStartedHealthCheckRelevantBoxes":"Tick the relevant boxes below","gettingStartedHealthTypeCondition":"Type a condition here","gettingStartedHealthDoYouHaveAnyOtherConditions":"Do you have any other health conditions?","gettingStartedDoYouHaveAnyConditions":"Do you have any health conditions","gettingStartedHealthDoYouHaveAnyConditions":"Do you have any conditions","gettingStartedHealthTypeMedication":"Type a medication here","addressSurgeryName":"Surgery name","addressLine1":"Address line 1","addressLine2":"Address line 2","addressPostcode":"Zip code","addressCity":"City","addressCounty":"County","addressCountry":"Country","gettingStartedLocationTitle":"My location","gettingStartedLocationSubTitle":"Where in the world are you","gettingStartedLocationGpSurgery":"My local gp surgery is...","gettingStartedLocationSurgeryNotInList":"I couldn't find my local surgery from the list","goalReasonRelaxed":"Feel more relaxed","goalReasonRelaxedShort":"more relaxed","goalReasonControl":"Feel more in control","goalReasonControlShort":"more in control","goalReasonConfidence":"More confidence","goalReasonConfidenceShort":"more confident","goalReasonMoreActive":"More active","goalReasonMoreActiveShort":"more active","goalReasonHealthier":"Feel healthier","goalReasonHealthierShort":"healthier","goalReasonHappier":"Feel happier","goalReasonHappierShort":"happier","gettingStartedGoalsEmptyError":"Please select one or more goal(s)","gettingStartedGoalsWhatDifference":"What difference will it make to you?","gettingStartedGoalsRatingScale":"On a scale of 1 to 10, where would you say you are currently with these goals?","gettingStartedGoalsWhenYouAreFeeling":"When you are feeling","gettingStartedGoalsWhatWillYouNoticeIsDifferent":"what will you notice that is different? Who else will notice things are better and how?","labelStartTyping":"Start typing","gettingStartedGoalsWhenYouHave":"When you have","registerSubTitle":"Create your account to choose your plan or redeem your referral code.","modifySubTitle":"Update your account details to choose your plan or redeem your referral code.","goalImprovedSenseOfWellbeing":"achieved a greater sense of wellbeing","goalLostWeight":"lost weight","goalReducedMedication":"reduced your medication","goalReducedBloodGlucose":"improved blood glucose control","goalImprovedHealth":"improved the health of your family","goalImprovedSomethingElse":"accomplished your other goal","gettingStartedPersonalizeTitle":"Complete your personalization","gettingStartedPersonalizeSubTitle":"Finally, set your personal preferences","gettingStartedPersonalizeFoodsTitle":"Favourite foods","gettingStartedPersonalizeFoodsSubTitle":"Which foods do you enjoy the most?","gettingStartedPersonalizeDietaryPreferencesTitle":"Dietary preferences and allergies","gettingStartedPersonalizeDietaryPreferencesSubTitle":"Get recipes and food ideas tailored to you","gettingStartedPersonalizeHealthTitle":"Your health data","gettingStartedPersonalizeHealthSubTitle":"Start your program with a few measurements","labelLastHbA1c":"When was your last hba1c?","allergyDairy":"Dairy","allergyGluten":"Gluten","allergyCelery":"Celery","allergyYeast":"Yeast","allergyShellfish":"Shellfish","allergyAlcohol":"Alcohol","allergyPeanuts":"Peanuts","allergyLupin":"Lupin","allergySoybeans":"Soybeans","allergyFish":"Fish","allergyEggs":"Eggs","allergyMustard":"Mustard","allergySulphites":"Sulphites","occupationFullTime":"Full time employment","occupationPartTime":"Part time employment","occupationRetired":"Retired","occupationSelfEmployed":"Self employed","occupationStudent":"Student","occupationUnemployed":"Unemployed","dietPreferenceNone":"No dietary preference","dietPreferencePescetarian":"Pescetarian","dietPreferenceVegetarian":"Vegetarian","dietPreferenceVegan":"Vegan","labelHeight":"Height","labelPerWeek":"per week","lifeCatBehaviourChange":"Behaviour change","lifeCatCarbsVsFat":"Carbs vs Fat","lifeCatChildren":"Children","lifeCatConditions":"Conditions","lifeCatDairyFree":"Dairy Free","lifeCatEducation":"Education","lifeCatExercise":"Exercise","lifeCatFoodAndRecipes":"Food and Recipes","lifeCatFoodSwaps":"Food Swaps","lifeCatHCP":"Healthcare Professionals","lifeCatIntermittentFasting":"Intermittent Fasting","lifeCatMotivation":"Motivation","lifeCatMythBusting":"Myth Busting","lifeCatPHC":"Conferences","lifeCatRecipesOfTheWeek":"Recipes of the week","lifeCatResearch":"Research","lifeCatSeasonalVeg":"Seasonal Veg","lifeCatSuccessStories":"Success Stories","lifeCatSugar":"Sugar","lifeCatWereListeningTo":"We're listening to","lifeCatWereWatching":"We're watching","lifeBrowseCategory":"Browse categories","lifeMyFavourites":"My Favorites","labelArticle":"article","labelArticles":"articles","emailResetPassSubject":"Reset your password","emailResetPassDescription":"You recently requested to reset your password for your Low Carb Program account. Use the button below to reset it. This password reset is only valid for the next 3 hours.","emailResetPassBtnLabel":"RESET PASSWORD","emailResetPassIgnore":"If you did not request a password reset, please ignore this email or contact support if you have questions.","emailFooterAllRightsReserved":"All rights reserved","emailTrouble":"If you're having trouble with the button above, copy and paste the URL below into your web browser.","labelTeam":"team","emailConfirmSubject":"Confirm your email","emailConfirmDescription":"If you did not request a password reset, please ignore this email or contact support if you have questions.","emailConfirmButton":"CONFIRM EMAIL","emailVerifySubject":"Verify your account.","emailVerifyDescription":"Welcome to the program. Please use the button below to confirm your account.","paywallPaywallFailed":"Payment Failed","labelProgressAddSnapshot":"Add a snapshot of your progress","labelAddToFoodDiary":"Add some food to your diary","labelMadeWith":"Made with","foodDiarySaveMealForNextTime":"Save this meal for quick entry next time?","activityTaiChi":"Tai Chi","activityPilates":"Pilates","heightUpdateFormTitle":"Update your height","heightUpdateFormSubTitle":"Use the form below to update","occupationPreferNotToSay":"I prefer not to say","disconnectText":"Disconnect","labelHeartRateAverage":"Average heart rate","labelHeartRateOutOfRange":"Out of range","labelHeartRateFatBurn":"Fat burn","labelHeartRateCardio":"Cardio","labelHeartRatePeak":"Peak","marketingPreferenceMealplans":"Daily meal plans","marketingPreferenceMealplansExplain":"Get a new and unique meal plan every day of the year.","labelFloorsClimbed":"Floors climbed","labelDistance":"Distance","labelTotalSteps":"Total steps","labelFromDevice":"From device","labelSteps":"steps","labelManualEntry":"Self reported","activityStepsEmptyTitle":"You don't have any steps data yet","activityStepsEmptySubTitle":"To get started connect your favorite health app below","activityStepsEmptyButton":"Add an activity integration","quizTestKnowledge":"Test your knowledge","questionText":"Question","answerText":"answer","answersText":"answers","finishText":"Finish","quizComplete":"You completed the quiz","labelTryAgain":"Try again","labelSeasonalDownloads":"Seasonal","labelTimeInBed":"Time in bed","labelTimeAsleep":"Time asleep","labelEfficiency":"Efficiency","labelTimeAwake":"Time awake","minutesAsleep":"Time asleep","minutesAwake":"Time awake","stageRemMinutes":"REM","stageLightMinutes":"Light","stageDeepMinutes":"Deep","labelTodaysPrediction":"Today's prediction","labelTodaysPredictionExplain":"See how close you are to today's predicted readings based on your profile history","labelTonightsPrediction":"Tonight's prediction","accountCigarettesPerDay":"How many cigarettes do you smoke a day?","accountSmokesCigarettes":"Are you a smoker?","ethnicityWhite":"White","ethnicityArab":"Arab","ethnicityIndian":"Indian","ethnicityPakistani":"Pakistani","ethnicityBangladeshi":"Bangladeshi","ethnicityChinese":"Chinese","ethnicityOtherAsian":"Other Asian","ethnicityBlack":"Black","ethnicityOther":"Other","registerReasonWellbeing":"General wellbeing","paymentCtaUpgrade":"Upgrade to Premium","paymentCtaCommunitySupport":"24/7 community support","paymentCtaResources":"Library of resources","paymentCtaMealPlans":"Weekly meal plans","paymentCtaUpdatesInformation":"Daily updated guides and information","paymentCtaFriendlySupport":"Friendly support","labelUpgrade":"Upgrade","paymentCtaEducation":"Award winning education","recipesAppBarText":"Recipes","recipeMenuTitleText":"Recipes","settingsActivityTitleText":"Activity","activitySettingsTitle":"Activity on your account","activitySettingsSubTitle":"See all login activities on your account from the last 7 days","settingsActivityHeadingDevice":"Device","settingsActivityHeadingEngine":"Engine","settingsActivityHeadingOS":"Operating System","settingsActivityHeadingIp":"IP Address","settingsActivityHeadingDate":"Date/Time","settingsExternalLoginTitle":"External Logins","recipeAppBarText":"Recipe","recipesFavoritesAppBarText":"My favorites","recipesAdvancedSearchAppBarText":"Advanced search","recipesSearchResultsAppBarText":"Search results","labelCookingTime":"Cooking time","labelPrepTime":"Preparation time","recipeAddedToDiary":"Recipe added to your food diary","passwordValidationError":"Password validation error","idleLogoutTitle":"Session expired","idleLogoutBody":"For security reasons, you’ve been logged out of the Low Carb Program due to inactivity. Please log in again.","savePasswordText":"Save password","usernameInitialModalTitle":"Would you like to set a username?","usernameInitialModalBody":"If you don’t want other members of the Low Carb Program to see your real name, you can now set a username for an extra level of privacy.","usernameInitialModalTip":"Tip: For added privacy, steer clear of using anything that resembles your email address or any personal information that could be used to identify you.","usernameInitialModalReject":"No, continue with first & last name","usernameInitialModalSave":"Set Username","usernameInitialModalConfirmTitle":"Username set","usernameInitialModalConfirmBody":"You can toggle whether to use your first and last name or your username throughout the Low Carb Program by visiting Settings. For now, people will only see your username.","usernameInitialModalRejectTitle":"No username set","usernameInitialModalRejectBody":"You can set a username in Settings -> General later if you change your mind."}

/***/ }),
/* 3924 */
/***/ (function(module, exports) {

module.exports = {"reportText":"Report","reportedText":"Signalé","nameText":"Prénom","resetText":"Réinitialiser","labelContinueText":"Continuer","logOutText":"Fermer la session...","logInText":"S'identifier","loggingInText":"Se connecter...","sendingText":"Envoi...","loadingText":"Chargement...","searchText":"Chercher","searchingText":"Recherche...","closeText":"Fermer","submitText":"Soumettre","saveText":"Sauvegarder","savingText":"Économie...","readMoreText":"Lire la suite\n","watchVideoText":"Regarder la vidéo","deleteText":"Effacer","hideText":"Cacher","moreText":"Plus","hiddenText":"Caché","restoreText":"Restaurer","editText":"modifier","okText":"D'accord","cancelText":"Annuler","addCommentText":"Ajouter un commentaire","addToFavouritesText":"Ajouter aux Favoris","addTestimonialText":"Ajouter un témoignage","unfavouriteText":"Unfavourite","loadCommentsText":"Charger les commentaires","applyText":"Appliquer","discardText":"Jeter","updateText":"Mettre à jour","updatingText":"Mise à jour","updatedText":"Actualisé","addEntryText":"Ajouter une entrée\n","nextText":"Prochain","backText":"Arrière","skipText":"Sauter","replyText":"réponse","repliesText":"réponses","replyToText":"Répondre à","likeText":"J’aime","likesText":"mentions J'aime","listViewText":"Vue de la liste","gridViewText":"Vue de la grille","emptyText":"Rien n'a encore été ajouté","selectText":"Sélectionner","enableText":"Activer","disableText":"Désactiver","connectText":"Relier","andText":"et","youText":"Toi","exportText":"Exporter","exportTextData":"exportation de données","exportingText":"S'il vous plaît, attendez...","justAMomentText":"Juste un moment...","trackingHelpText":"Appuyez sur n'importe quelle entrée pour modifier ou supprimer une lecture","badgeChampion":"Champion","badgeSupport":"Équipe de soutien","badgeCompleted":"Terminé le programme","mealPlanGeneratorAppBarText":"Planificateur de repas","fourZeroFourAppBarText":"Page non trouvée","registerAppBarText":"Registre","amendAppBarText":"Modifier","loginAppBarText":"S'identifier","forgotPasswordAppBarText":"Mot de passe oublié","verifyAccountAppBarText":"Email confirmé","resetPasswordAppBarText":"changez votre mot de passe","contactTitle":"Contact","contactSubTitle":"J'ai une question à propos de:","contactAdded":"Votre question a été soumise. Merci","contactBodyLabel":"Autre chose que nous devrions savoir?","contactReasonApp":"L'application","contactReasonWebsite":"Le site Web","contactReasonTechnical":"Requête technique","contactReasonFeatureRequest":"Demande de fonctionnalité","contactReasonOther":"Autre","contactReasonHcpCommission":"Mise en service du programme","contactReasonHcpTraining":"Formation professionnelle en soins de santé","contactReasonHcpLeaflets":"Brochures et dépliants","bootloaderConnecting":"De liaison...","bootloaderDownloadingAssets":"Téléchargement d'actifs ...","bootloaderInitializing":"Initialisation ...","bootloaderProfile":"Chargement de votre profil ...","dashboardAppBarText":"Tableau de bord","foodDiaryAppBarText":"Journal alimentaire","foodDiaryAddFoodAppBarText":"Ajouter de la nourriture","questionsAppBarText":"Discussion","profileAppBarText":"Profil","lifestyleAppBarText":"Mode de vie","downloadsAppBarText":"Téléchargements","coachingAppBarText":"encadrement","contactAppBarText":"Contactez nous","testimonialAppBarText":"Ajouter un témoignage","hcpAppBarText":"Professionnels de la santé","questionReportAppBarText":"Rapport de question","answerReportAppBarText":"Répondre au rapport","lifeReportAppBarText":"Rapport de vie","checkInAppBarText":"Enregistrement","addProgressAppBarText":"Ajouter des progrès","bloodGlucoseAppBarText":"Mes lectures de glycémie","hbA1cAppBarText":"Mes progrès HbA1c","weightAppBarText":"Mon poids progresse","sleepAppBarText":"Mes progrès de sommeil","bloodPressureAppBarText":"Mes lectures de tension artérielle","ketonesAppBarText":"Mes lectures de cétones","medicationAppBarText":"Mes progrès en matière de médicaments","moodAppBarText":"Mes progrès émotionnels","cholesterolAppBarText":"Mes progrès émotionnels","insulinAppBarText":"Mes progrès en insuline","activityAppBarText":"Mon activité progresse","obAboutAppBarText":"À propos de vous - Mise en route","obHealthAppBarText":"Votre santé - Premiers pas","obLocationAppBarText":"Votre position - Commencer","obGoalsAppBarText":"Vos objectifs - Commencer","obPersonalizeAppBarText":"Personnalisez votre programme - Pour commencer","faqAppBarText":"Questions fréquemment posées","dashboardMenuTitleText":"Tableau de bord","foodDiaryMenuTitleText":"Journal alimentaire","questionsMenuTitleText":"Discussion","profileMenuTitleText":"Profil","lifestyleMenuTitleText":"Mode de vie","downloadsMenuTitleText":"Téléchargements","coachingMenuTitleText":"Encadrement","settingsMenuTitleText":"Paramètres","addProgressMenuTitleText":"Ajouter des progrès","faqMenuTitleText":"FAQ","feedbackMenuTitleText":"Retour d'information","lessonTitleText":"Leçon","lessonBonusTitleText":"Leçon bonus","threadTitleText":"Fil","settingsGeneralTitleText":"Général","settingsSecurityTitleText":"Sécurité","settingsSubscriptionTitleText":"Abonnement","settingsPrivacyTitleText":"Intimité","settingsNotificationsTitleText":"Notifications","settingsUnitsTitleText":"Unités","settingsPersonalizeTitleText":"Personnaliser","settingsConditionsTitleText":"Conditions","settingsMedicationTitleText":"Médicaments","settingsFoodTitleText":"Préférences alimentaires","settingsDashboardTitleText":"Tableau de bord","settingsIntegrationTitleText":"Intégration d'applications de santé","settingsPreferencesTitleText":"Préférences email","integrationCompleteAppBarText":"L'intégration a été réussie\n","loginForgotPassword":"mot de passe oublié?","loginNoAccountYet":"Vous n'avez pas encore de compte?","loginSignUp":"S'inscrire","loginErrorIncorrectCredentials":"Informations d'identification incorrectes","loginRememberMe":"Souviens-toi de moi?","forgotPasswordTitle":"Mot de passe oublié?","forgotPasswordSubTitle":"Utilisez le formulaire ci-dessous pour envoyer un e-mail de réinitialisation du mot de passe","forgotPasswordSignIn":"Je veux juste me connecter","forgotPasswordEmailNotFound":"Nous n'avons pas pu trouver de compte avec cette adresse e-mail","forgotPasswordEmailSentMessageTitle":"La réinitialisation du mot de passe a été envoyée!","forgotPasswordEmailSendMessageSubTitle":"S'il vous plaît vérifier votre boîte e-mail à","registerSignIn":"Se connecter","registerHaveAccount":"Vous avez déjà un compte?","registerErrorUserExists":"Un compte utilisant cet email existe déjà","registerTestimonialConcent":"I consent to the","registerTestimonialExplain":"and that my testimonial can be used by the Program to inspire and motivate others","registerTermsByContinuing":"En continuant, vous acceptez notre ","registerTermsAndCondtions":"Modalités et Conditions","registerTermsJoin":"et que vous avez lu notre","registerPrivacyPolicy":"Politique de confidentialité","registerIncludingCookie":"y compris notre politique de cookie.","lessonActionPoints":"Points d'action","lessonActionPointsSubTitle":"Choses à faire cette semaine","lessonViewTranscript":"Voir la transcription","lessonHideTranscript":"Masquer transcription","lessonDownloadsThisWeek":"Téléchargements cette semaine","lessonQuestionsTitle":"Questions récemment posées","lessonQuestionsSubTitle":"Questions posées cette semaine","lessonQuestionsEmpty":"Personne n'a encore posé de questions sur cette leçon - pourquoi ne pas être le premier?","lessonRatingVery":"Très","lessonRatingNotVery":"Pas très","foodDiaryTodayYouveHad":"Aujourd'hui, vous avez eu ...","foodDiaryLandingExplain":"Vous pouvez ajouter un aliment à votre journal alimentaire en recherchant ce que vous avez mangé.","foodDiaryRecentsEmpty":"Appuyez sur le bouton de recherche pour commencer à ajouter de la nourriture!","foodDiaryHasRecents":"Cliquez sur un élément dans la liste récente à droite de ce panneau pour l'ajouter à nouveau.","foodDiaryRepeatYesterdayMeal":"Répétez le repas d'hier","foodDiaryIntakeBar":"Aujourd'hui, vous avez eu","foodDiaryIntakeBarNotToday":"À cette date, vous avez eu","foodDiaryModifyTargets":"Modifier les cibles","foodDiaryNutritionPanelHeaderText":"Vos objectifs nutritionnels","foodDiaryNutritionPanelSubHeaderText":"Configurez vos objectifs nutritionnels","foodDiaryBreakfast":"Déjeuner","foodDiaryAddBreakfast":"Ajouter le petit déjeuner","foodDiaryAddingBreakfast":"Ajouter le petit-déjeuner","foodDiaryNoBreakfastLabel":"Aucun petit-déjeuner ajouté pour le moment","foodDiaryLunch":"Le déjeuner","foodDiaryAddLunch":"Ajouter le déjeuner","foodDiaryAddingLunch":"Ajouter le déjeuner","foodDiaryNoLunchLabel":"Aucun déjeuner ajouté pour le moment","foodDiaryDinner":"Dîner","foodDiaryAddDinner":"Ajouter le dîner","foodDiaryAddingDinner":"Ajouter un dîner","foodDiaryNoDinnerLabel":"Aucun dîner ajouté pour le moment","foodDiarySnack":"Casse-croûte","foodDiaryAddSnack":"Ajouter une collation","foodDiaryAddingSnack":"Ajouter une collation","foodDiaryNoSnackLabel":"Aucune collation ajoutée pour le moment","foodDiaryQuickPortionLabel":"Portions rapides","foodDiaryExportDataTitle":"Exporter les données nutritionnelles","foodDiaryExportDataSubTitle":"Exporter les données de votre journal alimentaire","foodDiaryMealPlateNameTitle":"Donnez un nom à votre repas","foodDiaryLoadFromMyMeals":"Mes repas sauvegardés","foodDiaryMealPlateRemoved":"Meal plate removed","dietPlanLowCarb":"Faible Carb","dietPlanKeto":"Keto","nutrientCalories":"Calories","nutrientCaloriesShort":"Cals","nutrientProtein":"Protéine","nutrientCarbohydrate":"Glucides","nutrientCarbohydrateShort":"Glucides","nutrientSugar":"Sucre","nutrientFat":"Graisse","nutrientTotalFat":"Graisse totale","nutrientTotalFatShort":"Pour gros","nutrientSaturatedFat":"Gras saturé","nutrientSaturatedFatShort":"Graisse sat","nutrientMonounsaturatedFat":"Graisse monoinsaturée","nutrientPolyunsaturatedFat":"Graisse polyinsaturée","nutrientCholesterol":"Cholestérol","nutrientFibre":"Fibre","nutrientSodium":"Sodium","nutrientPotassium":"Potassium","visualizationBloodGlucoseHeader":"lectures de glycémie enregistrées ce mois-ci","confirmRemoveTitle":"Êtes-vous sûr?","confirmResetAccount":"Vous recommencez votre éducation à la semaine 1","confirmedResetAccount":"La page sera actualisée en 1 seconde pour mettre à jour les modifications. S'il vous plaît, attendez..","confirmRemoveBloodGlucoseItem":"Vous supprimez une entrée de glycémie","confirmedRemoveBloodGlucoseItem":"L'entrée de la glycémie a été supprimée","confirmRemoveWeightItem":"Vous supprimez une entrée de poids","confirmedRemoveWeightItem":"L'entrée de poids a été supprimée","confirmRemoveBloodPressureItem":"You are removing an blood pressure entry","confirmedRemoveBloodPressureItem":"Vous supprimez une entrée de tension artérielle","confirmRemoveActivityItem":"Vous supprimez une entrée d'activité","confirmedRemoveActivityItem":"L'entrée d'activité a été supprimée","confirmRemoveCholesterolItem":"Vous supprimez une entrée de cholestérol","confirmedRemoveCholesterolItem":"L'entrée de cholestérol a été enlevée","confirmRemoveHbA1cItem":"Vous supprimez une entrée HbA1c","confirmedRemoveHbA1cItem":"L'entrée HbA1c a été retirée","confirmRemoveInsulinItem":"Vous supprimez une entrée d'insuline","confirmedRemoveInsulinItem":"L'entrée d'insuline a été supprimée","confirmRemoveKetoneItem":"Vous supprimez une entrée de cétone","confirmedRemoveKetoneItem":"L'entrée de cétone a été supprimée","confirmRemoveMedicationItem":"Vous supprimez un dosage de médicament","confirmedRemoveMedicationItem":"Le dosage de médicament a été enlevé","confirmRemoveMoodItem":"Vous supprimez une entrée d'humeur","confirmedRemoveMoodItem":"L'entrée d'humeur a été supprimée","confirmRemoveSleepItem":"Vous supprimez une entrée de sommeil","confirmedRemoveSleepItem":"L'entrée du sommeil a été supprimée","confirmRemoveFoodItem":"Vous supprimez ","confirmedRemoveFoodItem":"a été retiré de votre journal alimentaire","confirmRemoveAnswerItem":"Vous supprimez une réponse","confirmedRemoveAnswerItem":"La réponse a été supprimée","confirmRemoveQuestionItem":"Vous supprimez une question","confirmedRemoveQuestionItem":"La question a été supprimée","placeholderText":"Entrez s'il vous plait","placeholderEmail":"email@email.com","lessonScrollerWeekPrefix":"Actuellement","graphEmpty":"Rien à voir ici encore","graphEmptyExplain":"Pas assez de données pour créer un graphique","graphPointToggleShowPoints":"Afficher les points","graphToggleSmoothLine":"Ligne courbe","graphToggleShowArea":"Remplissage","graphPointsToggleTitle":"Options","labelIHave":"j'ai le","labelFollowers":"Suiveurs","labelFollowing":"Suivant","labelUpdateBio":"Mise à jour bio","labelEnterBio":"Entrez bio","labelChangeProfilePicture":"Modifier la photo de profil","labelRemoveProfilePicture":"Supprimer la photo de profil","labelAddCoverPhoto":"Ajouter une photo de couverture","labelRemoveCoverPhoto":"Supprimer la photo de couverture","labelUpdateCoverPhoto":"Mettre la photo de couverture","labelQuestionsAnswered":"Questions répondues","labelQuestionsAsked":"Questions posées","labelProgress":"Progrès","labelProgramProgress":"Progrès du programme","labelPostsAndReplies":"Messages & Réponses","labelGallery":"Galerie","labelFood":"Aliments","labelDiscussionPrivate":"L'utilisateur a choisi de garder ses questions / réponses privées","labelBloodGlucoseProgress":"Progrès de la glycémie","labelWeightProgress":"Progression du poids","labelGraphsPrivate":"L'utilisateur a gardé ses graphiques de progression privés","labelUploadPhoto":"Envoyer la photo","labelMyGoals":"Mes objectifs","labelNew":"BETA","labelTestimonialSubTitle":"Partagez vos pensées et dites-nous comment le programme vous a aidé","labelAddTestimonial":"Ajouter un témoignage","labelBeforePhoto":"Ajouter avant la photo","labelAfterPhoto":"Ajouter après photo","labelDescription":"La description","labelBody":"Message","labelProviderInAssociationWith":"En association avec","labelBonus":"Prime","labelPersonalized":"Personnalisé","labelVerifyingAccount":"Vérification du compte ...","labelAccountActivated":"Votre compte a été activé, vous pouvez maintenant continuer avec le programme","labelRateThisAnswer":"Notez cette réponse","labelFindExactlyWhatYouAreLookingFor":"Trouvez exactement ce que vous cherchez ...","labelRelatedQuestions":"Questions connexes","labelHi":"salut","labelMostUseful":"Le plus utile","labelUpdateCommPreferences":"Veuillez mettre à jour vos préférences de communication","labelRecents":"Récent","labelVoiceRecognition":"Allez-y et dites quelque chose ...","labelFoodSearchResultsEmpty":"Aucun aliment trouvé pour votre terme de recherche","labelFoods":"nourriture","labelCustom":"Douane","labelProceed":"Procéder","labelProcessing":"En traitement...","labelViewHistory":"Voir l'historique","labelViewNutrition":"Voir la nutrition","labelNutrientTargetHelpText":"Pas trop sûr? Choisissez un preset","labelMultiplier":"Multiplicateur","labelServingSize":"Portion","labelSwitchHcp":"Passer à l'affichage HCP","labelSwitchPatient":"Passer à la vue Patient","labelHelp":"Aidez-moi","labelAddFoods":"Ajoutez des aliments à votre journal","labelAddHealthSnapshot":"Ajoutez un instantané de votre santé","labelMyProfile":"Mon profil","labelStartProgramOver":"Voulez-vous recommencer le programme à partir de la semaine 1?","labelClickHere":"Cliquez ici","labelError":"Quelque chose c'est mal passé. Merci d'essayer plus tard","labelProgressDatePickerExplain":"C'est l'heure et la date qui seront liées à toutes les lectures que vous sauvegarderez à partir de cette page","labelLetsGetStarted":"Commençons","labelModifyDetails":"Modifiez vos coordonnées","labelYourName":"Votre nom","labelBaseLine":"Ligne de base","labelUpperRange":"Plage supérieure","labelLowerRange":"Plage inférieure","labelMinute":"moi","labelFromDate":"Partir de la date","labelToDate":"À ce jour","labelToday":"Aujourd'hui","labelDay":"journée","labelMonth":"Mois","labelYear":"An","labelNoTags":"Aucun","labelSuccess":"Succès","labelUpdateRange":"Mise à jour","labelRangeUpdated":"Gamme de glucose mise à jour","labelResources":"Ressources","labelMealPlans":"Plans de repas","labelEnergy":"Énergie","labelMood":"Ambiance","labelHealth":"Santé","labelWeek":"la semaine","labelDownloadsFrom":"Téléchargements de: ","labelWaist":"Taille","labelHip":"Hanche","labelBolus":"Bol","labelCorrection":"Correction","labelBasal":"Basal","labelInsulinType":"Type d'insuline","labelBloodSugar":"Sucre dans le sang","labelHba1cOptional":"HBA1C [FACULTATIF]","labelAboveRange":"Au-dessus de la plage","labelBelowRange":"Au-dessous","labelInRange":"Dans la gamme","labelAdditionalInformation":"Information additionnelle","labelAddPhoto":"Ajouter une photo","labelMedicationName":"Nom du médicament","labelYes":"Oui","labelNo":"Non","labelITakeThisForMy":"Je prends ça pour mon","labelWhatDoYouTakeItFor":"Que prenez-vous pour?","labelUnits":"Unités","labelHowOften":"À quelle fréquence?","labelDuration":"Durée","labelDurationMinutes":"Durée (minutes)","labelActivity":"Activité","labelActivityType":"Type d'activité","labelCaloriesBurnt":"Calories brûlées","labelCalorieBurn":"Calorie brûler: ","labelDosage":"Dosage","labelCustomDate":"Date personnalisée","labelRangeDay":"Jour","labelRangeWeek":"Semaine","labelRangeMonth":"Mois","labelRangeYear":"Année","labelSelectMedication":"Choisissez un médicament","labelSystolic":"Systolique","labelDiastolic":"Diastolique","labelCholesterolTotal":"Total","labelCholesterolHDL":"HDL","labelCholesterolLDL":"LDL","labelCholesterolTriglycerides":"Triglycérides","labelHours":"Heures","labelQuality":"Qualité","labelDate":"Date","labelTime":"Temps","labelTagYourReading":"Marquer votre lecture [FACULTATIF]","labelInchesPlaceholder":"Entrer en in","labelCMPlaceholder":"Entrer in cm","labelBehalfSomeoneElse":"Je rejoins sur behalf de quelqu'un d'autre","labelRelationship":"Quelle est votre relation?","relationshipMother":"Ma mère","relationshipFather":"Mon père","relationshipWife":"Ma femme","relationshipHusband":"Mon mari","relationshipSister":"Ma sœur","relationshipBrother":"Mon frère","relationshipSon":"Mon fils","relationshipDaughter":"Ma fille","relationshipPatient":"Mon patient","gettingStartedAboutTitle":"Au propos de vous","gettingStartedAboutSubTitle":"Personnalisez votre programme","errorExportEmpty":"Rien à exporter","unitsPreferencesTitle":"Unités","unitsPreferencesSubTitle":"Choisissez vos unités de mesure préférées","unitsPreferencesMeasureWeight":"Je mesure mon poids en:","unitsPreferencesMeasureHeight":"Je mesure ma taille en:","unitsPreferencesMeasureWaist":"Je mesure ma taille en:","unitsPreferencesMeasureHba1c":"Je mesure mon HbA1c en:","unitsPreferencesMeasureBloodGlucose":"Je mesure ma glycémie:","conditionsPreferencesTitle":"Mes conditions","conditionsPreferencesSubTitle":"Utilisez le chercher ci-dessous pour mettre à jour vos conditions","conditionsPreferencesEmpty":"Aucune condition ajoutée pour le moment","conditionsPreferencesHelpText":"Rechercher pour ajouter une condition","accountPreferencesTitle":"Détails du compte général","accountPreferencesSubTitle":"Utilisez le formulaire ci-dessous pour mettre à jour vos informations générales","accountPreferencesChangeAvatar":"Changer d'avatar","accountPreferencesFirstName":"Prénom","accountPreferencesSurname":"Nom de famille","accountPreferencesDisplayName":"Display name","accountPreferencesEmail":"Email","accountPreferencesEmailVerify":"Vérifier Email","accountPreferencesPassword":"Mot de passe","accountPreferencesPasswordVerify":"Vérifier le mot de passe","accountPreferencesBirthday":"Anniversaire","accountPreferencesWhatBringsYouHere":"Qu'est-ce qui t'amène?","accountPreferencesDiagnosisYear":"Année de diagnostic","accountPreferencesSex":"Sexe","accountPreferencesTestBlood":"Testez-vous votre sang?","accountPreferencesTakeMedication":"Prenez-vous des médicaments?","accountPreferencesEthnicity":"Ethnicité","accountPreferencesLanguage":"Langue","accountPreferencesOccupation":"Occupation","accountPreferencesDietaryPreference":"Préférence diététique","accountPreferencesAllergies":"Allergies","accountPreferencesShopCost":"Coût hebdomadaire de l'épicerie","integrationPreferencesTitle":"Intégrations","integrationPreferencesSubTitle":"Intégrer dans d'autres applications de santé","integrationFitBitExplain":"Connectez votre FitBit à votre profil de suivi de santé","integrationStriivExplain":"Connectez votre Stiiv à votre profil de suivi de santé","integrationStriivImportStarted":"L'importation de Striiv a commencé, cela peut prendre quelques minutes - vous serez notifié à la fin","integrationStriivImportEmpty":"Aucune donnée à récupérer, si vous savez que vous avez des lectures - synchronisez votre appareil Striiv en ouvrant l'application Striiv et en glissant vers le bas pour rafraîchir sur le tableau de bord, revenez ici puis cliquez sur le bouton de synchronisation.","privacyPreferencesTitle":"Intimité","privacyPreferencesSubTitle":"Je suis heureux que les autres voient le (s) domaine (s) suivant (s) de mon profil:","privacyPreferencesQuestions":"Des questions","privacyPreferencesQuestionsExplain":"Les choses que vous avez posées ou auxquelles vous avez répondu","privacyPreferencesFood":"Alimentation et nutrition","privacyPreferencesFoodExplain":"Entrées de journal alimentaire, objectifs nutritionnels","privacyPreferencesProgress":"Le progrès","privacyPreferencesProgressExplain":"Perte de poids, statistiques de glycémie, photos etc.","privacyPreferencesMedication":"Des médicaments","privacyPreferencesMedicationExplain":"Tout ce que vous avez enregistré concernant votre régime de médicaments","privacyPreferencesAbout":"À propos de moi","privacyPreferencesAboutExplain":"A propos, aime et n'aime pas","paywallPaymentFailed":"Paiement échoué","paywallPaywallFailedExplain":"Nous sommes désolés, votre paiement a échoué ou a été annulé. Veuillez réessayer.","paywallStatusComplete":"Votre paiement a été complété et un reçu vous sera envoyé par courriel","paywallStatusPending":"Points d'action pratique pour atteindre votre objectif en matière de santé","paywallStatusFailed":"Aucun montant n'a été déduit de votre compte","paywallJoinIncentiveReason1":"Éducation primée sur la restriction thérapeutique des glucides\n","paywallJoinIncentiveReason2":"Points d'action pratique pour atteindre votre objectif en matière de santé","paywallJoinIncentiveReason3":"Des messages personnalisés de votre mentor pour vous garder sur la bonne voie","paywallJoinIncentiveReason4":"Soutien des entraîneurs en santé comportementale","paywallJoinIncentiveReason5":"Soutien de la plus grande communauté à faible teneur en glucides disponible 24/7","paywallJoinIncentiveReason6":"Suivi intégré de la santé et exportation de données","paywallJoinIncentiveReason7":"Plus de 40 plans de repas adaptés à vos préférences alimentaires","paywallJoinIncentiveReason8":"Plus de 1000 idées de recettes","paywallJoinIncentiveReason9":"Actualités quotidiennes, recherches et avis d'experts","paywallJoinIncentiveReason10":"Plus de 120 ressources faibles en glucides","paywallJoinIncentiveReason11":"Accès sur n'importe quel appareil sur le Web, iOS, Android et Kindle","paywallJoinIncentiveReason12":"Fonctions et améliorations constamment mises à jour","paywallJoinIncentiveReason13":"Synchronisez avec Striiv, FitBit et Nokia Withings en lançant Summer 2018 ","paywallJoinIncentiveReason14":"Support technique amical","paymentModalFeatureNotAvailable":"Cette fonctionnalité est uniquement disponible sur le niveau Premium du programme","paymentModalUpgrade":"Mettez à niveau maintenant pour un paiement unique de","paymentModalProceedPayment":"Procéder au paiement","notificationHeaderText":"Notifications","notificationEmptyText":"Rien à voir ici encore","notificationPreferencesTitle":"Notification","notificationPreferencesSubTitle":"Utilisez les boutons ci-dessous pour choisir le type de notifications que vous souhaitez recevoir","notificationPreferencesHeaderText":"Notifications","notificationPreferencesEmptyText":"pas de nouvelles notifications","notificationPreferencesQuestionReplies":"Réponses aux questions","notificationPreferencesQuestionRepliesSubLine":"Quand quelqu'un répond à ma question","notificationPreferencesNewFollower":"Nouveau suiveur","notificationPreferencesNewFollowerSubLine":"Quand quelqu'un me suit","securityPreferencesTitle":"Sécurité","securityPreferencesSubTitle":"Utilisez le formulaire ci-dessous pour mettre à jour votre mot de passe","subscriptionPreferencesTitle":"Abonnement","subscriptionPreferencesSubTitle":"Gérez votre abonnement actuel ci-dessous","securityPreferencesOldPassword":"Ancien mot de passe","securityPreferencesDesiredPassword":"Mot de passe désiré","securityPreferencesChangeEmail":"Changer l'adresse email","securityPreferencesSendVerificationEmail":"Envoyer email de vérification","securityPreferencesCheckEmailAt":"S'il vous plaît vérifier l'email de vérification à","medicationPreferencesTitle":"Mes médicaments","medicationPreferencesSubTitle":"Les dosages ici seront pris en compte lors de l'utilisation de la carte de médicament sur le tableau de bord","medicationPreferencesAdd":"Ajouter un médicament","medicationsPreferencesNotTaking":"Les médicaments que je ne prends plus","medicationPreferencesAddSubTitle":"Utilisez le formulaire ci-dessous pour ajouter un nouveau médicament","medicationPreferenceUpdateSubTitle":"Utilisez le formulaire ci-dessous pour mettre à jour les informations sur les médicaments","medicationAlreadyTrackingError":"Déjà suivi ce médicament","medicationConfirmAlertTitle":"Marquage des médicaments comme inactifs","medicationConfirmAlertText":"Vous ne prenez plus ce médicament","medicationConfirmAlertSuccessTitle":"Succès!","medicationConfirmAlertSuccessText":"Marqué comme inactif","foodPreferencesTitle":"nourriture","foodPreferencesSubTitle":"Ajoute des aliments à vos listes d'amour et de haine","foodPreferencesLove":"Les aliments que j'aime","foodsPreferencesLoveAdd":"Ajouter la nourriture préférée","foodPreferencesHate":"Les aliments que je n'aime pas","foodPreferencesHateAdd":"Ajouter de la nourriture détestée","marketingPreferencesTitle":"Paramètres de messagerie","marketingPreferencesSubTitle":"Choisissez les communications par e-mail que vous souhaitez recevoir de notre part.","marketingPreferenceCommunicationType":"Type de communication","marketingPreferenceImIn":"j'en suis","marketingPreferenceImOut":"je suis dehors","marketingPreferencePromotion":"Panneau de test Beta","marketingPreferencePromotionExplain":"Testez d'abord les nouvelles fonctionnalités avant-gardistes.","marketingPreferenceSurveys":"Recherche","marketingPreferenceSurveysExplain":"Participez à des recherches universitaires correspondant à votre profil.","marketingPreferenceNewsletters":"Faible taux de glucides","marketingPreferenceNewslettersExplain":"Un résumé mensuel des dernières recettes, plans de repas, recherches, entrevues exclusives, conseils sur le mode de vie, mises à jour communautaires et événements à ne pas manquer, questions-réponses en direct, balados, conférences et plus encore.","marketingPreferenceAlerts":"Alertes de programme","marketingPreferenceAlertsExplain":"Les jalons, les réponses et les notifications à l'intérieur de l'application peuvent tous vous être envoyés par e-mail afin que vous puissiez rester informé des développements de votre compte ou du programme.","marketingPreferenceUpdates":"Support personnalisé","marketingPreferenceUpdatesExplain":"Conseils, idées et commentaires sur vos progrès pour soutenir votre voyage.","communityEmailPreferences":"Communauté","communityEmailPreferencesExplain":"Soyez notifié des réponses à vos questions.","dashboardPreferencesTitle":"Tableau de bord","dashboardPreferencesSubTitle":"Faites glisser les éléments de la liste pour les réordonner ou masquer ceux qui ne vous concernent pas","questionCreateTitle":"Pose une question","questionCreateSubTitle":"Notre communauté est sur place 24 heures sur 24","questionCreateLabelTitle":"Titre de question","questionCreateLabelText":"Texte de la question","questionCreateTitlePlaceholder":"Dois-je arrêter la métaformine?","questionCreateTextPlaceholder":"Corps complet de votre question","questionCreateTitleHelpText":"C'est ce que les autres verront dans la liste des questions","discussionButtonAsk":"Pose une question","discussionTabRecent":"Récent","discussionTabTrending":"Trending","discussionTabUseful":"Tendance","discussionTabMyQuestions":"Mes questions","discussionTabMyAnswers":"Mes réponses","discussionTabUnanswered":"Sans réponse","discussionReportsTitle":"Rapports","discussionReportsSubTitle":"Une liste d'éléments rapportés","discussionTopContributorsTitle":"Meilleurs contributeurs","discussionTopContributorsSubTitle":"Les utilisateurs qui contribuent le plus","discussionFaqTitle":"FAQ","discussionFaqSubTitle":"Questions souvent posées par la communauté","discussionAskedBySuffix":"demandé par ","discussionMyAnswersEmpty":"Vous avez répondu à aucune question","discussionMyQuestionsEmpty":"Vous n'avez posé aucune question","discussionHcpEmpty":"Soyez le premier à poser une question","discussionSearchHintText":"Chercher quelque chose","discussionYouAndOthersFoundUseful":"autre (s) ont trouvé cela utile","threadTypeReply":"Tapez votre réponse...","threadAskedBy":"Question posée par ","threadPostsCount":"Des postes:","threadSingleUseful":"trouvé cela utile","threadUseful":"personne a trouvé cela utile","threadUsefulPlural":"les gens ont trouvé cela utile","threadUserSaid":"m'a dit","threadPreviousQuestion":"Question précédente","threadNextQuestion":"Question suivante","threadInputPlaceholder":"Tapez votre réponse...","threadSubmitReplyText":"Soumettre une réponse","threadChronological":"Chronologique","threadMostRecent":"Le plus récent","threadAnswersEmpty":"Aucune réponse à cette question, soyez le premier.","threadPaging10":"10 par page","threadPaging20":"20 par page","threadPaging40":"40 par page","cardEmpty":"Rien à voir ici encore","cardEmptySubLine":"Appuyez sur le + pour ajouter une entrée","cardLatestReading":"Dernière lecture","cardLatestReadingAt":"Dernière lecture à","cardPreviousReading":"Lecture précédente","cardWeight":"Poids","cardWeightEmptyHeight":"Ajoutez votre taille pour commencer","cardWeightAdded":"Entrée de poids ajoutée","cardWeightTotalGain":"Gain total","cardWeightTotalLoss":"Perte totale","cardWeightGainedThisWeek":"Gagné cette semaine","cardWeightLostThisWeek":"Perdu cette semaine","cardWeightWaistHipRatio":"Rapport taille-hanches","cardActivity":"Activité","cardKetones":"Cétones","cardKetonesAdded":"Entrée de cétones ajoutée","cardBloodGlucoseAdded":"Entrée de glycémie ajoutée","cardFromDevice":"De l'appareil: ","cardKetonesLastOccurrence":"Dernière occurrence","cardKetonesTotalOccurrences":"Nombre total d'occurrences","cardSleep":"Dormir","cardSleepLastNight":"Hier soir","cardSleepAverage":"Moyenne","cardSleepQuality":"Qualité","cardSleepEntryAdded":"Entrée de sommeil ajoutée","cardBloodGlucose":"Glucose sanguin","cardBloodGlucose30DayAverage":"Moyenne de 30 jours","cardBloodGlucoseInRange":"Dans la gamme aujourd'hui","cardHbA1c":"HbA1c","cardHbA1cAdded":"Ajout de l'HbA1c","cardNutrition":"Nutrition","cardNutritionEmpty":"Tu n'as rien mangé aujourd'hui","cardNutritionSubLine":"ajouter de la nourriture","cardPhotos":"Photos de progrès","cardPhotosChoosePicture":"Choisir l'image","cardPhotosAddingPhotos":"Ajouter des photos","cardInsulin":"Insuline","cardInsulinLatestBasal":"Dernier basal","cardInsulinLatestBolus":"Dernier bolus","cardInsulinLatestCorrection":"Dernière correction","cardBloodPressure":"Tension artérielle","cardBloodPressuremmHGPlaceholder":"Entrez mmHG","cardBloodPressureAdded":"Pression artérielle ajoutée","cardCholesterol":"Cholestérol","cardCholesterolLatestHDL":"Dernières HDL","cardCholesterolLatestLDL":"Dernières LDL","cardCholesterolLatestTriglycerides":"Derniers triglycérides","cardCholesterolLatestTotal":"Dernier total","cardMood":"Ambiance","cardMoodLatest":"Dernière humeur","cardMoodMostCommon":"Le plus commun","cardMoodOftenTogether":"Souvent ensemble","cardMoodAdded":"Entrée d'humeur ajoutée","cardMedication":"Des médicaments","cardEmptyMedication":"Quels médicaments prenez-vous?","cardMedicationDose":"Dose","cardMedicationDosage":"Entrez le dosage","cardMedicationLastDose":"Dernière dose","cardMedicationLastMedication":"Dernier médicament","cardMedicationAdded":"Entrée de médicament ajoutée","cardMedicationRepeatYesterday":"Répétez les médicaments d'hier","cardMedicationSelect":"Choisissez un médicament","cardTapPrefix":"appuie sur le","cardTapSuffix":"pour commencer","lifeCategoryListsHeaderText":"Plus dans cette catégorie","lifeCategoryListsSubHeaderText":"Tu pourrais aussi aimer...","lifeCommentsHeaderText":"Ajouter un commentaire","lifeEmbedScrollingText":"faites défiler pour continuer à lire","lifeEmbedScrollingVideoText":"Faites défiler pour regarder la vidéo","lifeUnauthorizedArticle":"Non autorisé à voir l'article","activityCycling":"Cyclisme","activitySwimming":"La natation","activityGymRowing":"Rameur","activityGymTreadmill":"Course à pied - Tapis de course","activityGymCycling":"Cyclisme - Gym","activityRunning":"Fonctionnement","activityStairWalking":"Monter les escaliers","activityWalking":"En marchant","activityGymWeights":"Musculation","activityYoga":"Yoga","activitySports":"Sport","activityAerobics":"Aérobie","activitySex":"Sexe","activityDancing":"La danse","activitySalsaDancing":"La danse salsa","moodRefreshed":"Rafraîchi","moodEnergetic":"Énergique","moodFocused":"Focalisé","moodRestless":"Agité","moodCalm":"Calmestless","moodDistracted":"Distraits","moodFatigued":"Fatigué","moodSleepy":"Somnolent","moodWeak":"Faible","moodAnxious":"Anxieux","moodChilled":"Glacé","moodRelieved":"Soulagé","moodHappy":"Content","moodContent":"Contenu","moodExcited":"Excité","moodStressed":"Stressé","moodIrritable":"Irritable","moodHopeless":"Désespéré","moodAngry":"En colère","moodWorried":"Inquiet","moodUnwell":"Indisposé","moodDizzy":"Étourdi","moodHeadache":"Mal de tête","moodHypo":"Hypo","moodPain":"Douleur","medicationRegimeMilligrams":"milligramme(s)","medicationRegimeGrams":"gramme(s)","medicationRegimeDrops":"gouttes","medicationRegimeTablespoons":"cuillère à soupe(s)","medicationRegimeMicrograms":"microgramme(s)","medicationRegimeTablets":"tablette(s)","medicationRegimeCapsules":"capsule(s)","medicationRegimeMilliliters":"millilitre(s)","medicationRegimeTeaspoons":"cuillère à café(s)","medicationRegimeMinutes":"minute(s)","medicationRegimeHours":"heure(s)","medicationRegimeUnits":"unités(s)","tagActivity":"Activité","tagAfterBreakfast":"Après le petit déjeuner","tagAfterDinnerMeal":"Après le dîner / repas","tagAfterLunch":"Après le déjeuner","tagBeforeBreakfast":"Avant le petit déjeuner","tagBeforeDinnerMeal":"Avant le dîner / repas","tagBeforeLunch":"Avant le déjeuner","tagCorrection":"Correction","tagDrink":"Boisson","tagDriving":"Conduite","tagFasting":"Jeûne","tagMenstruation":"Menstruation","tagParty":"Fête","tagShop":"Boutique","tagSnack":"Casse-croûte","tagWork":"Travail","frequencyOnceDaily":"Du quotidien","frequencyTwiceDaily":"Deux fois par jour","frequencyThreeDaily":"Trois fois par jour","frequencyWeekly":"Hebdomadaire","frequencyEverySixWeeks":"Toutes les 6 semaines","frequencyFourTimesDaily":"Quatre fois par jour","frequencyEveryThreeMonths":"Tous les 3 mois","frequencyFiveTimesDaily":"Cinq fois par jour","frequencyEveryOtherWeek":"Toutes les autres semaines","frequencyEveryThreeWeeks":"Toutes les 3 semaines","frequencyMonthly":"Mensuel","frequencyEveryEightWeeks":"Toutes les 8 semaines","frequencyEveryTwelveWeeks":"Toutes les 12 semaines","frequencyEverySixMonths":"Tous les 6 mois","frequencyEveryEightMonths":"Tous les 8 mois","frequencyYearly":"Annuel","frequencyOneTime":"Une fois","frequencyAsNeeded":"Comme requis","monthJanuary":"janvier","monthFebruary":"février","monthMarch":"mars","monthApril":"avril","monthMay":"mai","monthJune":"juin","monthJuly":"juillet","monthAugust":"août","monthSeptember":"septembre","monthOctober":"octobre","monthNovember":"novembre","monthDecember":"décembre","registerReasonPrediabetes":"Prédiabète","registerReasonType2Diabetes":"Diabète de type 2","registerReasonType1Diabetes":"Diabète de type 1","registerReasonGestationalDiabetes":"Diabète gestationnel","registerReasonLADA":"LADA","registerReasonMODY":"MODY","registerReasonDiabetesInsipidus":"Diabète insipide","registerReasonStudentOrResearcher":"Étudiant ou chercheur","registerReasonCarer":"Soignant","registerReasonDSN":"Infirmière de soutien au diabète","registerReasonDoctor":"Docteur","registerReasonHCP":"Professionnel de la Santé","registerReasonOther":"Autre","registerReasonParentOfType1":"Parent de l'enfant atteint de diabète de type 1","registerReasonParentOfType2":"Parent d'un enfant atteint de diabète de type 2","registerReasonProfessionalCarer":"Soignant professionnel","registerReasonDiagnosedObesity":"Obésité","registerReasonOverweight":"Surpoids","registerReasonAnotherHealthCondition":"J'ai un autre problème de santé","registerReasonNAFLD":"NAFLD","sexMale":"Homme","sexFemale":"Femme","foodDiarySelectMyMeal":"Sélectionnez l'un de vos plats préenregistrés dans la liste","gettingStartedTabYou":"Toi","gettingStartedTabHealth":"Santé","gettingStartedTabLocation":"Emplacement","gettingStartedTabGoals":"Buts","gettingStartedTabPersonalise":"Personnaliser","gettingStartedGoalsTitle":"Tes objectifs\n","gettingStartedGoalsSubTitle":"Identifier vos objectifs est important pour établir comment vous allez mesurer votre succès","gettingStartedGoalsSubHeader":"Mon but est de ...","goalReduceMedication":"Réduire la dépendance aux médicaments","goalLoseWeight":"Perdre du poids","goalReduceBloodGlucose":"Réduire la glycémie / HbA1c","goalSenseOfWellbeing":"Sentiment de bien-être","goalHealthyLifestyle":"Mode de vie sain pour moi et ma famille","goalSomethingElse":"Autre chose","gettingStartedHealthTitle":"Parlez-nous de votre santé","gettingStartedHealthSubTitle":"Personnalisez votre programme","gettingStartedHealthCheckRelevantBoxes":"Cochez les cases pertinentes ci-dessous","gettingStartedHealthTypeCondition":"Entrez une condition","gettingStartedHealthDoYouHaveAnyOtherConditions":"Avez-vous d'autres problèmes de santé?","gettingStartedDoYouHaveAnyConditions":"Avez-vous des problèmes de santé?","gettingStartedHealthDoYouHaveAnyConditions":"Avez-vous des problèmes de sante","gettingStartedHealthTypeMedication":"Tapez un médicament","addressSurgeryName":"Nom de la chirurgie","addressLine1":"Adresse 1","addressLine2":"Adresse ligne 2","addressPostcode":"Code postal","addressCity":"Ville","addressCounty":"Comté","addressCountry":"Pays","gettingStartedLocationTitle":"Ton emplacement","gettingStartedLocationSubTitle":"Dites-nous où dans le monde vous êtes","gettingStartedLocationGpSurgery":"Ma chirurgie gp locale est...","gettingStartedLocationSurgeryNotInList":"Je n'ai pas pu trouver ma chirurgie dans la liste","goalReasonRelaxed":"Se sentir plus détendu","goalReasonRelaxedShort":"plus détendu","goalReasonControl":"Se sentir plus en contrôle","goalReasonControlShort":"plus en contrôle","goalReasonConfidence":"Plus de confiance","goalReasonConfidenceShort":"plus confiant","goalReasonMoreActive":"Plus actif","goalReasonMoreActiveShort":"plus actif","goalReasonHealthier":"Sentez-vous en meilleure santé","goalReasonHealthierShort":"plus sain","goalReasonHappier":"Je me sens heureux","goalReasonHappierShort":"plus heureux","gettingStartedGoalsEmptyError":"Veuillez sélectionner un ou plusieurs objectifs","gettingStartedGoalsWhatDifference":"Quelle différence cela vous fera-t-il?","gettingStartedGoalsRatingScale":"Sur une échelle de 1 à 10, où diriez-vous que vous êtes actuellement avec ces objectifs?","gettingStartedGoalsWhenYouAreFeeling":"quand tu te sens","gettingStartedGoalsWhatWillYouNoticeIsDifferent":"que remarquerez-vous qui est différent? Qui d'autre remarquera que les choses vont mieux et comment?","labelStartTyping":"commencer à taper","gettingStartedGoalsWhenYouHave":"Lorsque vous avez","registerSubTitle":"Inscrivez-vous gratuitement pour les installations de suivi de santé complet ou payez pour mettre à niveau à tout moment. Les utilisateurs Premium bénéficient d'un accès illimité à vie à l'éducation, au support, aux ressources personnalisées, aux plans de repas et aux améliorations.","modifySubTitle":"Mettez à jour les détails de votre compte pour choisir votre plan ou utiliser votre code de parrainage.","goalImprovedSenseOfWellbeing":"sens amélioré du bien-être","goalLostWeight":"perdre du poids","goalReducedMedication":"réduit vos médicaments","goalReducedBloodGlucose":"meilleur contrôle de la glycémie","goalImprovedHealth":"amélioré la santé de votre famille","goalImprovedSomethingElse":"accompli votre autre objectif","gettingStartedPersonalizeTitle":"Complétez votre personnalisation","gettingStartedPersonalizeSubTitle":"Enfin, définissez vos préférences personnelles\n","gettingStartedPersonalizeFoodsTitle":"Aliments préférés","gettingStartedPersonalizeFoodsSubTitle":"Quels aliments aimez-vous le plus?","gettingStartedPersonalizeDietaryPreferencesTitle":"Préférences alimentaires et allergies","gettingStartedPersonalizeDietaryPreferencesSubTitle":"Obtenez des recettes et des idées de nourriture adaptées à vos besoins","gettingStartedPersonalizeHealthTitle":"Vos données de santé","gettingStartedPersonalizeHealthSubTitle":"Commencez votre programme avec quelques mesures","labelLastHbA1c":"Quand était votre dernier hba1c?","allergyDairy":"Laitier","allergyGluten":"Gluten","allergyCelery":"Céleri","allergyYeast":"Levure","allergyShellfish":"Fruits de mer","allergyAlcohol":"De l'alcool","allergyPeanuts":"Cacahuètes","allergyLupin":"Lupin","allergySoybeans":"Soja","allergyFish":"Poisson","allergyEggs":"Des œufs","allergyMustard":"Moutarde","allergySulphites":"Sulfites","occupationFullTime":"Emploi à temps plein","occupationPartTime":"Emploi à temps partiel","occupationRetired":"Retraité","occupationSelfEmployed":"Travailleur indépendant","occupationStudent":"Étudiant","occupationUnemployed":"Sans emploi","dietPreferenceNone":"Pas de préférence alimentaire","dietPreferencePescetarian":"Pescatarian","dietPreferenceVegetarian":"Végétarien","dietPreferenceVegan":"Vegan","labelHeight":"la taille","labelPerWeek":"par semaine","lifeCatBehaviourChange":"Changement de comportement","lifeCatCarbsVsFat":"Glucides vs graisse","lifeCatChildren":"Enfants","lifeCatConditions":"Conditions","lifeCatDairyFree":"Sans produits laitiers","lifeCatEducation":"Éducation","lifeCatExercise":"Exercice","lifeCatFoodAndRecipes":"Nourriture et Recettes","lifeCatFoodSwaps":"Échanges alimentaires","lifeCatHCP":"Professionnels de la santé","lifeCatIntermittentFasting":"Jeûne intermittent","lifeCatMotivation":"Motivation","lifeCatMythBusting":"Myth Busting","lifeCatPHC":"Conférences","lifeCatRecipesOfTheWeek":"Recettes de la semaine","lifeCatResearch":"Recherche","lifeCatSeasonalVeg":"Végétale saisonnière","lifeCatSuccessStories":"Réussites","lifeCatSugar":"Sucre","lifeCatWereListeningTo":"Nous écoutons","lifeCatWereWatching":"Nous regardons","lifeBrowseCategory":"Parcourir les catégories","lifeMyFavourites":"Mes Favoris","labelArticle":"article","labelArticles":"des articles","emailResetPassSubject":"Vous avez demandé à réinitialiser votre mot de passe.","emailResetPassDescription":"Veuillez utiliser le lien ci-dessous pour réinitialiser votre mot de passe.","emailResetPassBtnLabel":"RÉINITIALISER LE MOT DE PASSE","emailResetPassIgnore":"Si vous n'avez pas demandé la réinitialisation du mot de passe, ignorez cet e-mail ou contactez l'assistance si vous avez des questions.","emailFooterAllRightsReserved":"tous les droits sont réservés","emailTrouble":"Si vous rencontrez des problèmes avec le bouton ci-dessus, copiez et collez l'URL ci-dessous dans votre navigateur Web.","labelTeam":"équipe","emailConfirmSubject":"Confirme ton email","emailConfirmDescription":"Vous avez demandé à mettre à jour votre adresse e-mail. Veuillez utiliser le bouton ci-dessous pour confirmer.","emailConfirmButton":"CONFIRMEZ VOTRE E-MAIL","emailVerifySubject":"Merci de confirmer votre adresse e-mail","emailVerifyDescription":"Bienvenue au programme Low Carb. Veuillez utiliser le bouton ci-dessous pour confirmer votre compte.","paywallPaywallFailed":"Paiement échoué","labelProgressAddSnapshot":"Ajoutez un instantané de vos progrès","labelAddToFoodDiary":"Ajoutez de la nourriture à votre journal","labelMadeWith":"Fabriqué avec","foodDiarySaveMealForNextTime":"Enregistrer ce repas pour une entrée rapide la prochaine fois?","activityTaiChi":"Taï chi","activityPilates":"Pilates","heightUpdateFormTitle":"Mettez à jour votre taille","heightUpdateFormSubTitle":"Utilisez le formulaire ci-dessous pour mettre à jour votre taille","occupationPreferNotToSay":"Je préfère ne pas dire","disconnectText":"Déconnecter","labelHeartRateAverage":"Fréquence cardiaque moyenne","labelHeartRateOutOfRange":"Hors de portée","labelHeartRateFatBurn":"Bruler les graisses","labelHeartRateCardio":"Cardio","labelHeartRatePeak":"De pointe","marketingPreferenceMealplans":"Plans de repas quotidiens","marketingPreferenceMealplansExplain":"Obtenez un nouveau et unique plan de repas tous les jours de l'année. Commence le 1er Novembre, 2018.","labelFloorsClimbed":"Les étages ont grimpé","labelDistance":"Distance","labelTotalSteps":"Total des étapes","labelFromDevice":"De l'appareil","labelSteps":"étapes","labelManualEntry":"Saisie manuelle","activityStepsEmptyTitle":"","activityStepsEmptySubTitle":"","activityStepsEmptyButton":"","quizTestKnowledge":"Testez vos connaissances","questionText":"Question","answerText":"répondre","answersText":"réponses","finishText":"Terminer","quizComplete":"Vous avez terminé le quiz","labelTryAgain":"réessayer","labelSeasonalDownloads":"Saisonnier","labelTimeInBed":"Temps au lit","labelTimeAsleep":"Le sommeil de temps","labelEfficiency":"Efficacité","labelTimeAwake":"Temps éveillé","minutesAsleep":"Temps endormi","minutesAwake":"Le temps se réveille","stageRemMinutes":"Mouvement rapide des yeux","stageLightMinutes":"Lumière","stageDeepMinutes":"Profond","labelTodaysPrediction":"La prédiction d'aujourd'hui","labelTodaysPredictionExplain":"Voyez à quel point vous êtes proche des lectures prédites d'aujourd'hui en fonction de votre historique de profil","labelTonightsPrediction":"Prédiction des soirées","accountCigarettesPerDay":"Cigarettes par jour","accountSmokesCigarettes":"Est-ce que tu fumes?","ethnicityWhite":"Blanc (caucasien)","ethnicityArab":"Arabe","ethnicityIndian":"Indien","ethnicityPakistani":"Pakistanais","ethnicityBangladeshi":"Bangladais","ethnicityChinese":"Chinois","ethnicityOtherAsian":"Autre asiatique","ethnicityBlack":"Noir / Africain / Caraïbes","ethnicityOther":"Autre","registerReasonWellbeing":"Bien-être","paymentCtaUpgrade":"Passer à la version premium","paymentCtaCommunitySupport":"Assistance 24/7","paymentCtaResources":"Bibliothèque de ressources","paymentCtaMealPlans":"Plans de repas hebdomadaires","paymentCtaUpdatesInformation":"Guides et informations mis à jour quotidiennement","paymentCtaFriendlySupport":"Soutien amical","labelUpgrade":"Améliorer","paymentCtaEducation":"Éducation primée","recipesAppBarText":"Recettes","recipeMenuTitleText":"Recettes","settingsActivityTitleText":"Activité","activitySettingsTitle":"Activité sur votre compte","activitySettingsSubTitle":"Voir toutes les activités de connexion sur votre compte des 7 derniers jours","settingsActivityHeadingDevice":"Dispositif","settingsActivityHeadingEngine":"Moteur","settingsActivityHeadingOS":"Système opérateur","settingsActivityHeadingIp":"Adresse IP","settingsActivityHeadingDate":"Date / heure","recipeAppBarText":"Recette","recipesFavoritesAppBarText":"Mes favoris","recipesAdvancedSearchAppBarText":"Recherche Avancée","recipesSearchResultsAppBarText":"Résultats de la recherche","labelCookingTime":"Temps de cuisson","labelPrepTime":"Temps de préparation","recipeAddedToDiary":"Recette ajoutée au journal alimentaire","passwordValidationError":"Password validation error","idleLogoutTitle":"Session expirée","idleLogoutBody":"Pour des raisons de sécurité, vous avez été déconnecté(e) du Programme Low Carb du fait de votre inactivité. Veuillez vous reconnecter."}

/***/ }),
/* 3925 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(684);
module.exports = __webpack_require__(1302);


/***/ })
],[3925]);


// WEBPACK FOOTER //
// static/js/app.2a71fe6d008078685564.js